(function () {
"use strict";
const RADICE = document.getElementById("ga-strumenti");
if (RADICE) try { if ("scrollRestoration" in history) history.scrollRestoration = "manual"; } catch (e) {   }
const LINGUA = (() => {
  const l = (RADICE && RADICE.dataset.lingua) || document.documentElement.lang || "it";
  const c = l.slice(0, 2).toLowerCase();
  return ["it", "de", "es", "en"].includes(c) ? c : "it";
})();
const LOCALE = { it: "it-IT", de: "de-DE", es: "es-ES", en: "en-GB" }[LINGUA];
const RADICE_URL = (RADICE && RADICE.dataset.root) || "/";
const FOTO_DSS = !!(RADICE && RADICE.dataset.foto === "dss");
const DEBUG =/[?&]gasdebug\b/.test(location.search);
const NAV_VOCI = true;
const NAV4 = NAV_VOCI ? !/[?&]nav=vecchia\b/.test(location.search) : /[?&]nav=nuova\b/.test(location.search);
function $(sel, root) { return (root || document).querySelector(sel); }
function $$(sel, root) { return Array.from((root || document).querySelectorAll(sel)); }
function el(tag, attr, ...figli) {
  const n = document.createElement(tag);
  if (attr) {
    for (const [k, v] of Object.entries(attr)) {
      if (v == null || v === false) continue;
      if (k === "class") n.className = v;
      else if (k === "text") n.textContent = v;
      else if (k === "dataset") Object.assign(n.dataset, v);
      else if (k === "style" && typeof v === "object") Object.assign(n.style, v);
      else if (k.startsWith("on") && typeof v === "function") n.addEventListener(k.slice(2), v);
      else if (v === true) n.setAttribute(k, "");
      else n.setAttribute(k, v);
    }
  }
  aggiungi(n, figli);
  return n;
}
function aggiungi(n, figli) {
  for (const f of figli) {
    if (f == null || f === false) continue;
    if (Array.isArray(f)) aggiungi(n, f);
    else n.appendChild(typeof f === "object" ? f : document.createTextNode(String(f)));
  }
  return n;
}
function svuota(n) { while (n.firstChild) n.removeChild(n.firstChild); return n; }
const SVGNS = "http://www.w3.org/2000/svg";
function sv(tag, attr, ...figli) {
  const n = document.createElementNS(SVGNS, tag);
  if (attr) for (const [k, v] of Object.entries(attr)) {
    if (v == null) continue;
    if (k === "text") n.textContent = v;
    else if (k.startsWith("on") && typeof v === "function") n.addEventListener(k.slice(2), v);
    else n.setAttribute(k, v);
  }
  for (const f of figli.flat()) if (f) n.appendChild(f);
  return n;
}
const _nf = {};
function num(x, dec) {
  if (x == null || !isFinite(x)) return "–";
  const d = dec == null ? 0 : dec;
  const k = d;
  if (!_nf[k]) _nf[k] = new Intl.NumberFormat(LOCALE, { minimumFractionDigits: d, maximumFractionDigits: d });
  return _nf[k].format(x);
}
function numAuto(x) {
  if (x == null || !isFinite(x)) return "–";
  const a = Math.abs(x);
  return num(x, a >= 100 ? 0 : a >= 10 ? 1 : a >= 1 ? 2 : 3);
}
function clamp(x, a, b) { return Math.max(a, Math.min(b, x)); }
function debounce(fn, ms) {
  let t = null;
  return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); };
}
function norm(s) {
  return String(s || "").toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "").replace(/[\s\-_.'’/()]+/g, "");
}
function normParole(s) {
  return String(s || "").toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "");
}
const MEMORIA = "ga-strumenti:";
function salva(k, v) { try { localStorage.setItem(MEMORIA + k, JSON.stringify(v)); } catch (e) {   } }
function ricorda(k, def) {
  try { const v = localStorage.getItem(MEMORIA + k); return v == null ? def : JSON.parse(v); } catch (e) { return def; }
}
function ora(d) {
  if (!d || isNaN(d)) return "–";
  return d.toLocaleTimeString(LOCALE, { hour: "2-digit", minute: "2-digit" });
}
function giorno(d, lungo) {
  if (!d || isNaN(d)) return "–";
  return d.toLocaleDateString(LOCALE, lungo ? { weekday: "long", day: "numeric", month: "long", year: "numeric" }
    : { weekday: "short", day: "numeric", month: "short" });
}
function durata(ore) {
  if (ore == null || !isFinite(ore)) return "–";
  if (ore > 0 && ore * 3600 < 59.5) return `${Math.max(1, Math.round(ore * 3600))} s`;
  const h = Math.floor(ore + 1e-9), m = Math.round((ore - h) * 60);
  return m === 60 ? `${h + 1} h` : (h ? `${h} h ${String(m).padStart(2, "0")}′` : `${m}′`);
}
function raHms(gradi) {
  let s = Math.round(((gradi / 15) % 24 + 24) % 24 * 3600);
  const h = Math.floor(s / 3600); s -= h * 3600;
  const m = Math.floor(s / 60); s -= m * 60;
  return `${String(h).padStart(2, "0")}h ${String(m).padStart(2, "0")}m ${String(s).padStart(2, "0")}s`;
}
function decDms(gradi) {
  const seg = gradi < 0 ? "−" : "+";
  let s = Math.round(Math.abs(gradi) * 3600);
  const d = Math.floor(s / 3600); s -= d * 3600;
  const m = Math.floor(s / 60); s -= m * 60;
  return `${seg}${d}° ${String(m).padStart(2, "0")}′ ${String(s).padStart(2, "0")}″`;
}
function angolo(gradi) {
  if (gradi == null || !isFinite(gradi)) return "–";
  if (gradi >= 1) return num(gradi, gradi >= 10 ? 1 : 2) + "°";
  const m = gradi * 60;
  if (m >= 1) return num(m, m >= 10 ? 1 : 2) + "′";
  return num(m * 60, 1) + "″";
}
function angoli(a, b) { return `${angolo(a)} × ${angolo(b)}`; }
const TESTI = {
  it: {
    tab_campo: "Campo inquadrato", tab_stanotte: "Stanotte", tab_camere: "Camere", tab_calcolatori: "Calcolatori", tab_software: "Software",
    caricamento: "Caricamento degli strumenti…", errore_dati: "Non riesco a caricare i dati degli strumenti. Ricarica la pagina tra qualche secondo.",
    cerca: "Cerca…", nessun_risultato: "Nessun risultato", nel_negozio: "Su Giordano Astronomia", vedi_prodotto: "Vedi", da: "da",
    non_disponibile: "non disponibile", copiato: "Link copiato!",
    modo_foto: "Astrofotografia", modo_visuale: "Osservazione visuale",
    telescopio: "Telescopio", cerca_telescopio: "Cerca: Esprit 100, RCN8, Samyang…",
    diametro: "Diametro", focale: "Focale", personalizzato: "Personalizzato", personalizzata: "Personalizzata",
    riduttore: "Riduttore / Barlow", nessuno: "Nessuno (1×)", riduttore_b: "riduttore", barlow_b: "Barlow",
    riduttori_negozio: "Riduttori con questo fattore nel negozio:", barlow_negozio: "Barlow con questo fattore nel negozio:",
    camera: "Camera", cerca_camera: "Cerca: ASI2600, EOS R6, Seestar…",
    larghezza_px: "Larghezza", altezza_px: "Altezza", pixel: "Pixel", binning: "Binning (pixel uniti)", seeing: "Seeing (tremolio dell'aria)",
    seeing_1: "Eccellente (1″)", seeing_1_5: "Ottimo (1,5″)", seeing_2: "Buono (2″)", seeing_2_5: "Medio (2,5″)", seeing_3: "Mediocre (3″)",
    seeing_4: "Scarso (4″)", seeing_5: "Pessimo (5″)", in_vendita: "in vendita",
    oculare: "Oculare", cerca_oculare: "Cerca: 25 mm, 82°, Plössl…", focale_oculare: "Focale dell'oculare", campo_apparente: "Campo apparente",
    oggetto: "Oggetto", cerca_oggetto: "Cerca: M31, NGC 7000, Pipistrello…",
    inquadratura: "Inquadratura", rotazione: "Rotazione della camera", rotazione_n: "0° = lato lungo orizzontale (est-ovest) con il nord in alto; l'angolo cresce in senso antiorario.", mosaico_x: "Pannelli in orizzontale", mosaico_y: "Pannelli in verticale",
    sovrapposizione: "Sovrapposizione", mosaico: "Mosaico", rosso: "Visione notturna", rosso_n: "Pagina in rosso per non perdere l'adattamento al buio quando sei all'aperto", chip_luna: "Luna", chip_buio: "Buio", chip_oggetti: "oggetti", chip_camere: "camere", chip_telescopi: "telescopi", rotazione_b: "Rotazione", ruota_90: "Ruota di 90°",
    carico_cielo: "Disegno la mappa del cielo…", cielo_errore: "La mappa del cielo non si carica in questo momento: i calcoli restano validi.",
    allarga: "Allarga la vista", stringi: "Stringi la vista", centra_qui: "Centra qui", reimposta: "Ricomincia", copia_link: "Copia link",
    credito_cielo: "Mappa del cielo disegnata da Giordano Astronomia: stelle dai cataloghi Hipparcos e Tycho-2 dell'ESA fino alla magnitudine 10,5, con i loro colori veri; Via Lattea ricavata dalla densità delle stelle; galassie e nebulose dal nostro catalogo con misure e orientamento reali.",
    trascina: "Trascina il cielo per spostarti (il riquadro resta al centro); doppio tocco (o doppio clic) per centrare; due dita o Ctrl + rotella per ingrandire.",
    centri_pannelli: "Coordinate dei pannelli del mosaico", centro_inquadratura: "Coordinate del centro dell'inquadratura",
    scegli_telescopio: "Scegli un telescopio o inserisci diametro e focale.", scegli_camera: "Scegli una camera o inserisci risoluzione e dimensione dei pixel.",
    scegli_oculare: "Scegli un oculare o inserisci focale e campo apparente.", mancano_dati: "Scegli telescopio e camera (o oculare) per vedere il campo.",
    campo_inquadrato: "Campo inquadrato", diagonale: "diagonale", scala: "Scala dell'immagine", focale_effettiva: "Focale effettiva", immagine: "Immagine",
    campionamento: "Campionamento",
    camp_sovra: "sovracampionato", camp_sovra_n: "Ogni stella occupa troppi pixel: usa il binning {b}×{b} o un riduttore.",
    camp_poco_sovra: "leggermente sovracampionato", camp_poco_sovra_n: "Va bene con un seeing migliore; con il seeing scelto il binning 2×2 non perde dettaglio.",
    camp_ok: "ideale", camp_ok_n: "Le stelle restano rotonde e si sfrutta tutta la risoluzione.",
    camp_poco_sotto: "leggermente sottocampionato", camp_poco_sotto_n: "Normale per il grande campo: stelle un po' più squadrate, dettaglio vicino al massimo.",
    camp_sotto: "sottocampionato", camp_sotto_n: "Le stelle diventano piccoli quadrati: va bene per i campi larghissimi, per il dettaglio serve più focale.",
    camp_dettaglio: "Con seeing di {s}″ l'ideale è tra {a} e {b}″/px (2–3 pixel per stella).",
    risoluzione_dawes: "Potere risolutivo (Dawes)", risoluzione_nota: "limite teorico dell'ottica: in pratica il limite è quasi sempre il seeing",
    mosaico_totale: "Mosaico, area totale", pannelli: "pannelli",
    riempimento: "L'oggetto occupa", non_entra: "non entra intero: prova un riduttore o un mosaico", molto_piccolo: "molto piccolo nel campo: serve più focale",
    ingrandimento: "Ingrandimento", max_utile: "massimo utile", campo_reale: "Campo reale", pupilla: "Pupilla d'uscita",
    pupilla_piccola: "molto piccola: immagine buia", pupilla_grande: "Pupilla d'uscita oltre 7 mm: parte della luce non entra nell'occhio.",
    troppo_ingrandimento: "Oltre l'ingrandimento massimo utile ({m}×): l'immagine si impasta.",
    ingr_minimo: "Ingrandimento minimo", ingr_minimo_n: "sotto questo valore la pupilla d'uscita supera i 7 mm",
    il_telescopio: "Il telescopio su Giordano Astronomia", la_camera: "La camera su Giordano Astronomia", l_oculare: "L'oculare su Giordano Astronomia",
    parte_di: "parte di",
    migliori_stanotte: "I migliori oggetti della notte", latitudine: "Latitudine", longitudine: "Longitudine", posizione_mano: "Posizione inserita a mano",
    cerca_citta: "Cerca una città…", cerco_posizione: "Cerco la posizione…", mia_posizione: "La mia posizione", usa_posizione: "Usa la mia posizione",
    posizione_negata: "Posizione non disponibile: cerca una città o scrivi le coordinate.", stanotte: "Stanotte", luogo: "Luogo", data_notte: "Notte del",
    nota_orari: "Gli orari sono nel fuso orario del tuo dispositivo.",
    altezza_minima: "Altezza minima", tipo: "Tipo", tutti: "Tutti", tutte: "Tutte", costellazione: "Costellazione", qualsiasi: "Qualsiasi",
    magnitudine_max: "Luminosità (magnitudine)", ordina: "Ordina per",
    ord_migliori: "I migliori stanotte", ord_ore: "Più ore utili", ord_altezza: "Più alti in cielo", ord_grandezza: "Più grandi", ord_luminosi: "Più luminosi",
    ord_nome: "Nome", ord_mp: "Più megapixel", ord_pixel: "Pixel più grandi", ord_formato: "Sensore più grande", ord_recenti: "Più recenti",
    solo_famosi: "Solo oggetti famosi (Messier, Caldwell o con un nome)", solo_campo: "Mostra solo gli oggetti adatti al mio campo", mio_setup: "La mia attrezzatura", mio_setup_n: "Scegli telescopio e camera: la scelta vale anche nel Campo inquadrato.", campo_tuo: "Il tuo campo:", nessun_setup: "Scegli telescopio e camera per vedere quali oggetti entrano nel tuo campo.", modifica_campo: "Vedi e modifica nel Campo inquadrato →", occupa: "{p} % del campo", fit_ok: "entra bene", fit_grande: "più grande del campo", fit_piccolo: "piccolo nel campo",
    prima_campo: "prima scegli telescopio e camera",
    calcolo: "Calcolo la notte…", tramonto: "Tramonto", buio_da: "Inizio buio", buio_a: "Fine buio", crep_astronomico: "crepuscolo astronomico", alba: "Alba",
    ore_buio: "Ore di buio", solo_nautico: "il cielo non diventa del tutto buio", luna: "Luna", crescente: "crescente", calante: "calante",
    luna_nuova: "Prossima Luna nuova", luna_piena: "Prossima Luna piena",
    avviso_nautico: "In questa data il cielo non diventa del tutto buio: i calcoli usano la parte più buia disponibile (crepuscolo nautico).",
    avviso_nessuno: "In questa data il Sole non scende abbastanza sotto l'orizzonte: niente notte vera.",
    giorno: "Giorno", crepuscolo: "Crepuscolo", notte_astro: "Notte astronomica", luna_sopra: "Luna sopra l'orizzonte",
    pianeti_stanotte: "Pianeti stanotte", pianeta: "Pianeta", alt_max: "Altezza max", quando: "Ora", mag: "Magnitudine", diametro_app: "Diametro",
    fase: "Illuminato", sotto_orizzonte: "sotto l'orizzonte",
    pianeta_mercurio: "Mercurio", pianeta_venere: "Venere", pianeta_marte: "Marte", pianeta_giove: "Giove", pianeta_saturno: "Saturno",
    pianeta_urano: "Urano", pianeta_nettuno: "Nettuno",
    nessun_oggetto: "Nessun oggetto con queste scelte: abbassa l'altezza minima o togli qualche limite in «Oggetti».", trovati: "{n} oggetti visibili",
    mostra_altri: "Mostra altri", ore_utili: "Ore utili", dist_luna: "Distanza dalla Luna", sempre_sopra: "Sempre sopra l'orizzonte", sorge: "Sorge",
    culmina: "più alto", tramonta: "tramonta", inquadra: "Inquadralo nel campo", grafico_altezza: "Altezza sull'orizzonte durante la notte",
    altezza_oggetto: "Oggetto", altezza_luna: "Luna",
    gruppo_galassie: "Galassie", gruppo_emissione: "Nebulose a emissione", gruppo_riflessione: "Nebulose a riflessione", gruppo_oscure: "Nebulose oscure",
    gruppo_planetarie: "Nebulose planetarie", gruppo_supernova: "Resti di supernova", gruppo_aperti: "Ammassi aperti", gruppo_globulari: "Ammassi globulari",
    gruppo_altre: "Altri oggetti",
    tipo_gx: "Galassia", tipo_gxg: "Gruppo di galassie", tipo_gxcl: "Ammasso di galassie", tipo_gxp: "Regione di una galassia", tipo_oc: "Ammasso aperto",
    tipo_sc: "Nube stellare", tipo_gc: "Ammasso globulare", tipo_pn: "Nebulosa planetaria", tipo_en: "Nebulosa a emissione", tipo_rn: "Nebulosa a riflessione",
    tipo_dn: "Nebulosa oscura", tipo_cn: "Ammasso con nebulosa", tipo_snr: "Resto di supernova", tipo_neb: "Nebulosa", tipo_reg: "Regione", tipo_ds: "Stella doppia",
    marca: "Marca", colore_mono: "A colori o monocromatica", colore: "Colore", mono: "Mono", sensore: "Sensore",
    pix_p1: "fino a 2,4 µm", pix_p2: "2,4 – 3,8 µm", pix_p3: "3,8 – 5 µm", pix_p4: "oltre 5 µm",
    solo_negozio: "Solo quelle che vendiamo", solo_produzione: "Solo in produzione", camere_trovate: "{n} camere su {tot}",
    risoluzione: "Risoluzione", formato: "Dimensioni", campo_col: "Campo col tuo telescopio", confronta: "Confronta", usa: "Usa", acquista: "Acquista",
    raffreddata_s: "raffreddata", fuori_produzione: "fuori produzione", mostra_altre: "Mostra altre ({n})",
    da_confrontare: "{n} camere da confrontare (fino a 4)", svuota: "Svuota", confronto: "Confronto", megapixel: "Megapixel", bit: "ADC",
    raffreddata: "Raffreddata", si: "Sì", no: "No",
    nota_camere: "Dati tecnici dalle schede ufficiali dei produttori. Il campo è calcolato col telescopio scelto nel Campo inquadrato.",
    cat_raffreddata: "Raffreddate", cat_non_raffreddata: "Non raffreddate", cat_planetaria_guida: "Planetarie e guida", cat_smart: "Smart telescope",
    cat_mirrorless: "Mirrorless", cat_reflex: "Reflex", cat_medio_formato: "Medio formato", cat_swir: "Infrarosso (SWIR)",
    c_tel: "Telescopio", c_tel_i: "Cosa può fare un telescopio in base a diametro e focale.", rapporto_focale: "Rapporto focale",
    luce_raccolta: "Luce raccolta", luce_raccolta_n: "rispetto all'occhio (pupilla di 7 mm)", risoluzione_rayleigh: "Potere risolutivo (Rayleigh)",
    mag_limite: "Magnitudine limite visuale", mag_limite_n: "le stelle più deboli visibili sotto un cielo buio", ingr_max: "Ingrandimento massimo utile",
    c_oc: "Oculare", c_oc_i: "Ingrandimento, campo reale e pupilla d'uscita con un oculare.", focale_telescopio: "Focale del telescopio",
    c_camp: "Focale ideale per la tua camera", c_camp_i: "Quale focale sfrutta al meglio i pixel della camera col seeing del tuo cielo.",
    focale_ideale: "Focale ideale", focale_ideale_n: "con seeing di {s}″ (2–3 pixel per stella)", consiglio: "Consiglio",
    consiglio_rid: "un riduttore di circa {k}×", consiglio_barlow: "una Barlow di circa {k}×", consiglio_barlow_n: "solo se cerchi il massimo dettaglio (in alternativa, un telescopio con focale più lunga): per il grande campo va bene così",
    c_plan: "Riprese planetarie", c_plan_i: "Per Luna, Sole e pianeti con il lucky imaging: si riprende un video e si tengono solo i fotogrammi più nitidi.", f_ideale: "Rapporto focale ideale",
    f_ideale_n: "regola pratica: 5 volte la dimensione del pixel in µm per le camere a colori, 4 volte per le mono", focale_planetaria: "Focale da usare",
    barlow_serve: "serve una Barlow di circa {k}×", barlow_non_serve: "va bene già così",
    c_npf: "Paesaggi notturni senza inseguimento", c_npf_i: "La posa più lunga prima che le stelle diventino strisce, con la fotocamera sul treppiede.",
    focale_obiettivo: "Focale dell'obiettivo", diaframma: "Diaframma", full_frame: "Full frame", declinazione: "Declinazione dell'inquadratura",
    regola_npf: "Regola NPF", regola_npf_n: "stelle puntiformi anche ingrandendo", regola_500: "Regola del 500", regola_500_n: "più tollerante, per la visione a schermo intero",
    c_bf: "Backfocus e distanziali", c_bf_i: "Quanti millimetri di distanziali servono tra correttore e sensore.", bf_richiesto: "Backfocus richiesto",
    bf_camera: "Backfocus della camera", bf_ruota: "Ruota portafiltri o cassetto", bf_filtro: "Spessore del filtro", bf_altro: "Altri adattatori",
    bf_distanziali: "Distanziali da aggiungere", bf_troppo: "i pezzi montati sono già troppo lunghi: togline uno o scegline di più corti", bf_correzione: "Correzione per il filtro",
    bf_correzione_n: "un filtro di vetro allunga il fuoco di circa 1/3 del suo spessore",
    c_pol: "Polare nel cannocchiale polare", c_pol_i: "Dove mettere la Stella Polare nel reticolo per allineare la montatura, adesso, nel luogo scelto in «Stanotte».",
    pol_cannocchiale: "Nel cannocchiale polare", pol_occhio: "A occhio nudo", pol_ore: "Polare a ore {o}", pol_angolo: "Angolo orario della Polare",
    pol_distanza: "Distanza della Polare dal polo", pol_nota: "Calcolato alle {ora} per: {luogo}. Il cannocchiale polare capovolge l'immagine: segui il disegno «Nel cannocchiale polare».",
    pol_sud: "Nell'emisfero sud la Polare non si vede: si usa Sigma Octantis.",
    c_rug: "Rischio condensa", c_rug_i: "Il punto di rugiada dice quando l'ottica si appanna.", temperatura: "Temperatura", umidita: "Umidità",
    punto_rugiada: "Punto di rugiada", rischio: "Rischio condensa", rischio_alto: "alto: accendi le fasce anticondensa", rischio_medio: "medio: tieni pronte le fasce",
    rischio_basso: "basso", rischio_n: "{m} °C sopra il punto di rugiada",
    c_int: "Tempo di integrazione e spazio su disco", c_int_i: "Quante ore di dati raccogli e quanto spazio occupano.", numero_pose: "Numero di pose",
    posa_s: "Durata di una posa", integrazione: "Integrazione totale", spazio_disco: "Spazio su disco", spazio_disco_n: "{mb} MB a posa (file a 16 bit, {c})",
    cerca_software: "Cerca un programma…", categoria: "Categoria", sistema: "Sistema", solo_gratis: "Solo gratuiti",
    nota_software: "Link ai siti ufficiali dei programmi. Giordano Astronomia non è responsabile dei contenuti dei siti esterni.",
    prezzo_gratuito: "Gratuito", prezzo_open_source: "Open source", prezzo_freemium: "Gratis + Pro", prezzo_a_pagamento: "A pagamento",
    sw_acquisizione: "Acquisizione e controllo", sw_guida: "Autoguida", sw_plate_solving: "Plate solving (riconosce il cielo dalla foto)", sw_driver: "Driver e collegamento",
    sw_stacking: "Calibrazione e stacking (somma delle pose)", sw_elaborazione: "Elaborazione", sw_planetario_solare: "Elaborazione di pianeti, Luna e Sole",
    sw_planetari: "Planetari e pianificazione", sw_app_strumenti: "App di smart telescope e montature", sw_meteo_cielo: "Meteo e cielo",
    carico_foto: "Carico la foto del cielo…", foto_errore: "La foto del cielo non è disponibile in questo momento: i calcoli restano validi.",
    credito_foto: "Foto: Digitized Sky Survey (DSS2, STScI/NASA), colori CDS, tramite hips2fits del CDS di Strasburgo.",
    firma_mappa: "Mappa Giordano · ESA Hipparcos/Tycho-2", mappa_cielo: "Mappa del cielo attorno all'oggetto, col riquadro del campo",
    vista_mappa: "Mappa", vista_foto: "Foto", vista_confronto: "Confronto", legenda_mappa: "Sulla mappa:", barlow_vicine: "Barlow nel negozio:",
    cerca_fotocamera: "Cerca: EOS R6, Z6 II, A7 IV…",
    nomi: "Nomi", nomi_n: "Mostra o nascondi nomi e contorni degli oggetti", foto_errore_mappa: "La foto del cielo non è disponibile in questo momento: ti mostro la nostra mappa.",
    miei_setup: "I miei setup", setup: "Setup", salva_setup: "Salva setup", nome_setup: "Nome del setup", salva: "Salva", annulla: "Annulla", togli_setup: "Togli questo setup", conferma_togli: "Togliere il setup «{n}»?", nessun_setup_salvato: "Nessun setup salvato: scegli telescopio e camera, poi premi «Salva setup».", setup_gia_salvato: "Questa attrezzatura è già tra i tuoi setup.", usa_setup_calc: "Riempi con un mio setup:", ferma: "Ferma", ascolta_spiegazione: "Ascolta la spiegazione", guida_voce: "Guida",
    torna_oggetto: "Torna sull'oggetto", ctrl_rotella: "Per ingrandire: Ctrl + rotella (o due dita)",
    richiama_setup: "Tocca un setup per richiamarlo:", setup_salvato_come: "Questa attrezzatura è salvata come «{n}».", passo_1: "Scegli qui sotto il telescopio e la camera (o l'oculare).", passo_1_notte: "Scegli qui sotto il telescopio e la camera.", passo_2: "Poi dai un nome al setup e premi «Salva setup»: la prossima volta lo richiami con un tocco.", setup_pieni: "Hai già {n} setup: togline uno per salvarne un altro.", setup_scelto: "Attrezzatura scelta:", salva_come_setup: "Salva questa attrezzatura nei miei setup",
    obiettivo: "Obiettivo fotografico", diaframma_f: "Diaframma", miei_filtri: "I miei filtri",
    miei_filtri_n: "Cerca i tuoi filtri per nome (o tocca il tipo): per ogni oggetto ti diciamo quale montare.", filtro_dual: "Dual band", filtro_sho: "Set Hα/OIII/SII",
    filtro_ha: "Hα", filtro_oiii: "OIII", filtro_sii: "SII", filtro_hbeta: "Hβ", filtro_uhc: "UHC", filtro_lp: "Anti-inquinamento",
    filtro_lrgb: "Set LRGB", filtro_uvir: "UV/IR cut", filtro_irpass: "IR pass", filtro_luna: "Lunare", filtro_nessuno: "Nessun filtro",
    filtro_rimanda: "Meglio un'altra sera", filtro_dual_n: "Hα + OIII in un solo filtro, per camere a colori (es. L-eXtreme, L-Ultimate, ALP-T)",
    filtro_sho_n: "Filtri a banda stretta per camere mono", filtro_ha_n: "Banda stretta all'idrogeno alfa", filtro_oiii_n: "Banda stretta all'ossigeno",
    filtro_sii_n: "Banda stretta allo zolfo", filtro_hbeta_n: "Da usare all'oculare, per le nebulose Testa di Cavallo e California", filtro_uhc_n: "Per nebulose, soprattutto da guardare all'oculare",
    filtro_lp_n: "Banda larga contro l'inquinamento luminoso (es. L-Pro, CLS)", filtro_lrgb_n: "Luminanza e colori per camere mono",
    filtro_uvir_n: "Taglia ultravioletto e infrarosso", filtro_irpass_n: "Per pianeti e Luna con seeing difficile",
    filtro_luna_n: "Riduce la luce della Luna all'oculare", filtro_consigliato: "Filtro consigliato",
    filtro_alternativa: "Con il tuo filtro {f} va meglio che senza, ma un dual band è tutta un'altra cosa.", filtro_non_usare: "Non usare: {f}.",
    filtri_negozio: "Nel negozio:", filtro_per_notte: "Vale per stanotte, osservando {l_da} (cielo Bortle {b}).", cambia_in_stanotte: "Cambia in «Stanotte» →",
    cielo_luogo: "Cielo del luogo", cielo_luogo_n: "Serve a consigliare il filtro: più il cielo è chiaro, più conta la banda stretta.",
    bortle_1: "1 · Cielo eccellente", bortle_2: "2 · Cielo veramente buio", bortle_3: "3 · Cielo rurale", bortle_4: "4 · Tra campagna e periferia",
    bortle_5: "5 · Cielo di periferia", bortle_6: "6 · Periferia luminosa", bortle_7: "7 · Tra periferia e città", bortle_8: "8 · Cielo di città", bortle_9: "9 · Centro città",
    ff_mono_em: "nebulosa a emissione: Hα, poi OIII e SII per la palette SHO. Funziona anche con la Luna e in città.",
    ff_mono_pn: "nebulosa planetaria: OIII e Hα, anche con la Luna.",
    ff_colore_em_buio: "con un cielo buio e senza Luna puoi anche riprendere senza filtro, per i colori naturali delle stelle, ma il dual band dà più contrasto.",
    ff_colore_em_luna: "con questa Luna il dual band è quasi indispensabile: taglia la luce lunare e lascia passare solo Hα e OIII.",
    ff_colore_em_citta: "con il cielo chiaro del tuo luogo il dual band taglia l'inquinamento luminoso e lascia passare solo Hα e OIII.",
    ff_colore_bl_buio: "per galassie, ammassi e nebulose a riflessione non serve un filtro (basta l'UV/IR cut se la camera non ce l'ha).",
    ff_colore_bl_luce: "un anti-inquinamento a banda larga aiuta un po' in periferia, poco con la Luna o con i lampioni a LED. Niente dual band: toglierebbe la luce dell'oggetto.",
    ff_mono_bl_buio: "LRGB: la luminanza per il dettaglio, RGB per i colori.",
    ff_mono_bl_luce: "più tempo in RGB che in luminanza, perché la luminanza risente di più della luce di cielo e Luna. Niente banda stretta su questi oggetti.",
    ff_rimanda_luna: "con questa Luna galassie e nebulose a riflessione perdono quasi tutto il contrasto: meglio un'altra sera, o una nebulosa a emissione col dual band.",
    ff_rimanda_citta: "con questo cielo le galassie si vedono poco anche con i filtri: meglio un cielo più buio, o una nebulosa a emissione col dual band.",
    fv_uhc: "a occhio un UHC scurisce il fondo cielo e fa risaltare la nebulosa.",
    fv_oiii: "a occhio per resti di supernova e nebulose planetarie il migliore è l'OIII (va bene anche un UHC).", fv_hbeta: "a occhio l'Hβ è quasi l'unico modo per vederla.",
    fv_nessuno: "a occhio un filtro toglierebbe solo luce.",
    fv_nessuno_luce: "a occhio nessun filtro aiuta davvero con questa luce: meglio un cielo più buio.",
    scrivi_altre: "Scrivi qualche lettera in più…",
    sqm_misurato: "SQM misurato (se hai lo strumento)",
    coordinate_sqm: "Coordinate a mano e SQM misurato",
    sqm_vuoto: "Lascia vuoto se non l'hai misurato",
    configurazione: "Configurazione",
    come_stimiamo: "Come stimiamo il buio del cielo?",
    cielo_satellite: "Dall'atlante dell'inquinamento luminoso di David Lorenz (2025), in questo punto: SQM circa {s} · LPI {l} (Bortle {b}). Se osservi lontano dal centro abitato, metti le coordinate del posto o usa la tua posizione.",
    vedi_atlante: "Il punto su lightpollutionmap.info ↗", vedi_lorenz: "La mappa di David Lorenz ↗",
    come_stimiamo_testo: "In Italia e dintorni (dalla Provenza all'Albania, fino a Malta e Lampedusa) usiamo l'atlante dell'inquinamento luminoso di David Lorenz, aggiornato al 2025 con le luci viste dai satelliti (VIIRS): un valore ogni 900 metri circa. Per ogni punto dà due numeri. L'SQM è la luminosità del cielo allo zenit in magnitudini per secondo d'arco quadrato: più è alto, più il cielo è buio (22 è il cielo naturale, senza luci). L'LPI, l'indice di inquinamento luminoso, dice quante volte la luce artificiale supera quella naturale del cielo: 0,1 vuol dire un decimo, 1 la stessa quantità, 50 cinquanta volte tanto. La classe di Bortle è una nostra conversione dall'SQM. Fuori da quest'area stimiamo il buio dalle città vicine (errore tipico ±0,4–0,5 magnitudini). La mappa non tiene conto dell'altitudine né della foschia della serata: se misuri il cielo con un SQM, scrivi il tuo valore qui sopra, in «Coordinate a mano e SQM misurato».",
    cielo_stimato: "Stimato dalle città vicine: SQM circa {s} · LPI {l} (Bortle {b}). Se sei lontano dal centro abitato, in campagna o in montagna, scegli il tuo cielo qui sopra.",
    cielo_misurato: "Dal tuo SQM: {s} mag/arcsec².",
    cielo_scelto: "Scelto da te.",
    usa_stima: "Usa la stima",
    stima_in_corso: "Stimo il buio del cielo…",
    cerca_filtro: "Cerca: L-eXtreme, ALP-T, Hα…", togli_filtro: "Togli questo filtro", oppure_tipo: "…oppure tocca il tipo di filtro che hai:", usa_il_tuo: "✓ Usa il tuo {f}.",
    luna_nuova_ok: "Luna quasi nuova: non disturba.", luna_non_in_cielo: "Luna {k} %, ma non è in cielo mentre l'oggetto è alto: non disturba.", luna_info: "Luna {k} %, a {sep}° dall'oggetto; ore utili con la Luna in cielo: {su} %.", luna_lontana_ok: "È abbastanza lontana: puoi fotografare anche senza filtri a banda stretta.", luna_con_cautela: "Senza filtri a banda stretta si può, ma lo sfondo del cielo sarà più chiaro: meglio le ore senza Luna.", luna_vicina_no: "Troppo vicina e luminosa: senza un filtro a banda stretta non conviene fotografare.",
    corpo_sole: "Sole", tipo_pianeta: "Pianeta", tipo_sole: "Stella (il Sole)", tipo_luna: "Satellite", alle: "alle", illuminato: "illuminato", inquadra_breve: "Inquadra", filtro_solare: "Filtro solare", filtro_solare_n: "Filtro solare certificato che copre tutta l'apertura, montato davanti al telescopio", ff_sole: "è obbligatorio: certificato, deve coprire tutta l'apertura ed essere montato DAVANTI al telescopio (e al cercatore). Mai guardare o riprendere il Sole senza: danni immediati a occhi e camera.", ff_luna: "di solito non serve; con seeing difficile un IR pass dà immagini più ferme.", fv_luna: "a occhio un filtro lunare o un polarizzatore toglie l'abbagliamento.", ff_pianeta: "camera a colori: UV/IR cut; camera mono o seeing difficile: IR pass per la luminanza. Il rapporto focale ideale lo trovi nel calcolatore «Riprese planetarie».", fv_pianeta: "a occhio non serve per forza un filtro; quelli colorati aiutano a vedere bande e macchie.",
  },
  de: {
    tab_campo: "Bildfeld", tab_stanotte: "Heute Nacht", tab_camere: "Kameras", tab_calcolatori: "Rechner", tab_software: "Software",
    caricamento: "Werkzeuge werden geladen…", errore_dati: "Die Daten konnten nicht geladen werden. Bitte laden Sie die Seite in ein paar Sekunden neu.",
    cerca: "Suchen…", nessun_risultato: "Keine Ergebnisse", nel_negozio: "Bei Giordano Astronomia", vedi_prodotto: "Ansehen", da: "ab",
    non_disponibile: "nicht verfügbar", copiato: "Link kopiert!",
    modo_foto: "Astrofotografie", modo_visuale: "Visuelle Beobachtung",
    telescopio: "Teleskop", cerca_telescopio: "Suche: Esprit 100, RCN8, Samyang…",
    diametro: "Öffnung", focale: "Brennweite", personalizzato: "Eigene Werte", personalizzata: "Eigene Werte",
    riduttore: "Reducer / Barlow", nessuno: "Keiner (1×)", riduttore_b: "Reducer", barlow_b: "Barlow",
    riduttori_negozio: "Reducer mit diesem Faktor im Shop:", barlow_negozio: "Barlowlinsen mit diesem Faktor im Shop:",
    camera: "Kamera", cerca_camera: "Suche: ASI2600, EOS R6, Seestar…",
    larghezza_px: "Breite", altezza_px: "Höhe", pixel: "Pixel", binning: "Binning", seeing: "Seeing",
    seeing_1: "Hervorragend (1″)", seeing_1_5: "Sehr gut (1,5″)", seeing_2: "Gut (2″)", seeing_2_5: "Mittel (2,5″)", seeing_3: "Mäßig (3″)",
    seeing_4: "Schlecht (4″)", seeing_5: "Sehr schlecht (5″)", in_vendita: "im Shop",
    oculare: "Okular", cerca_oculare: "Suche: 25 mm, 82°, Plössl…", focale_oculare: "Brennweite des Okulars", campo_apparente: "Scheinbares Gesichtsfeld",
    oggetto: "Objekt", cerca_oggetto: "Suche: M31, NGC 7000, Fledermaus…",
    inquadratura: "Bildausschnitt", rotazione: "Kameradrehung", rotazione_n: "0° = lange Seite waagerecht (Ost-West), Norden oben; der Winkel wächst gegen den Uhrzeigersinn.", mosaico_x: "Felder waagerecht", mosaico_y: "Felder senkrecht", sovrapposizione: "Überlappung", mosaico: "Mosaik", rosso: "Nachtsicht", rosso_n: "Seite in Rot, damit die Dunkeladaption draußen erhalten bleibt", chip_luna: "Mond", chip_buio: "Dunkel", chip_oggetti: "Objekte", chip_camere: "Kameras", chip_telescopi: "Teleskope", rotazione_b: "Drehung", ruota_90: "Um 90° drehen",
    carico_cielo: "Himmelskarte wird gezeichnet…", cielo_errore: "Die Himmelskarte lässt sich gerade nicht laden – die Berechnungen bleiben gültig.",
    allarga: "Herauszoomen", stringi: "Hineinzoomen", centra_qui: "Hier zentrieren", reimposta: "Zurücksetzen", copia_link: "Link kopieren",
    credito_cielo: "Himmelskarte von Giordano Astronomia: Sterne aus den ESA-Katalogen Hipparcos und Tycho-2 bis zur Größe 10,5 in ihren echten Farben, Milchstraße aus der Sterndichte berechnet, Galaxien und Nebel aus unserem Katalog mit echten Maßen und echter Ausrichtung.",
    trascina: "Ziehen Sie den Himmel, um sich zu bewegen (der Rahmen bleibt in der Mitte); Doppeltippen (oder Doppelklick) zum Zentrieren; zwei Finger oder Strg + Mausrad zum Zoomen.",
    centri_pannelli: "Koordinaten der Mosaikfelder", centro_inquadratura: "Koordinaten der Bildmitte",
    scegli_telescopio: "Wählen Sie ein Teleskop oder geben Sie Öffnung und Brennweite ein.", scegli_camera: "Wählen Sie eine Kamera oder geben Sie Auflösung und Pixelgröße ein.",
    scegli_oculare: "Wählen Sie ein Okular oder geben Sie Brennweite und scheinbares Gesichtsfeld ein.", mancano_dati: "Wählen Sie Teleskop und Kamera (oder Okular), um das Bildfeld zu sehen.",
    campo_inquadrato: "Bildfeld", diagonale: "Diagonale", scala: "Abbildungsmaßstab", focale_effettiva: "Effektive Brennweite", immagine: "Bild",
    campionamento: "Sampling",
    camp_sovra: "Oversampling", camp_sovra_n: "Jeder Stern belegt zu viele Pixel: Nutzen Sie Binning {b}×{b} oder einen Reducer.",
    camp_poco_sovra: "leichtes Oversampling", camp_poco_sovra_n: "Passt bei besserem Seeing; beim gewählten Seeing verliert Binning 2×2 kein Detail.",
    camp_ok: "ideal", camp_ok_n: "Die Sterne bleiben rund und die volle Auflösung wird genutzt.",
    camp_poco_sotto: "leichtes Undersampling", camp_poco_sotto_n: "Normal für Weitfeld: Sterne etwas eckiger, Detail nahe am Maximum.",
    camp_sotto: "Undersampling", camp_sotto_n: "Die Sterne werden zu kleinen Quadraten: gut für sehr weite Felder, für Details braucht es mehr Brennweite.",
    camp_dettaglio: "Bei {s}″ Seeing liegt das Ideal zwischen {a} und {b}″/px (2–3 Pixel pro Stern).",
    risoluzione_dawes: "Auflösungsvermögen (Dawes)", risoluzione_nota: "theoretische Grenze der Optik: In der Praxis begrenzt fast immer das Seeing",
    mosaico_totale: "Mosaik, Gesamtfläche", pannelli: "Felder",
    riempimento: "Das Objekt füllt", non_entra: "passt nicht ganz hinein: Versuchen Sie einen Reducer oder ein Mosaik", molto_piccolo: "sehr klein im Bild: mehr Brennweite nötig",
    ingrandimento: "Vergrößerung", max_utile: "maximal sinnvoll", campo_reale: "Wahres Gesichtsfeld", pupilla: "Austrittspupille",
    pupilla_piccola: "sehr klein: dunkles Bild", pupilla_grande: "Austrittspupille über 7 mm: Ein Teil des Lichts gelangt nicht ins Auge.",
    troppo_ingrandimento: "Über der maximal sinnvollen Vergrößerung ({m}×): Das Bild wird verschwommen.",
    ingr_minimo: "Minimale Vergrößerung", ingr_minimo_n: "darunter ist die Austrittspupille größer als 7 mm",
    il_telescopio: "Das Teleskop bei Giordano Astronomia", la_camera: "Die Kamera bei Giordano Astronomia", l_oculare: "Das Okular bei Giordano Astronomia",
    parte_di: "Teil von",
    migliori_stanotte: "Die besten Objekte der Nacht", latitudine: "Breitengrad", longitudine: "Längengrad", posizione_mano: "Manuell eingegebener Ort",
    cerca_citta: "Stadt suchen…", cerco_posizione: "Standort wird ermittelt…", mia_posizione: "Mein Standort", usa_posizione: "Meinen Standort verwenden",
    posizione_negata: "Standort nicht verfügbar: Suchen Sie eine Stadt oder geben Sie die Koordinaten ein.", stanotte: "Heute Nacht", luogo: "Ort", data_notte: "Nacht vom",
    nota_orari: "Alle Uhrzeiten in der Zeitzone Ihres Geräts.",
    altezza_minima: "Mindesthöhe", tipo: "Typ", tutti: "Alle", tutte: "Alle", costellazione: "Sternbild", qualsiasi: "Beliebig",
    magnitudine_max: "Helligkeit", ordina: "Sortieren nach",
    ord_migliori: "Die besten heute Nacht", ord_ore: "Meiste nutzbare Stunden", ord_altezza: "Am höchsten", ord_grandezza: "Am größten", ord_luminosi: "Am hellsten",
    ord_nome: "Name", ord_mp: "Meiste Megapixel", ord_pixel: "Größte Pixel", ord_formato: "Größter Sensor", ord_recenti: "Neueste",
    solo_famosi: "Nur Messier, Caldwell und Objekte mit Namen", solo_campo: "Nur Objekte zeigen, die zu meinem Bildfeld passen", mio_setup: "Meine Ausrüstung", mio_setup_n: "Wählen Sie Teleskop und Kamera – die Auswahl gilt auch für „Bildfeld“.", campo_tuo: "Ihr Bildfeld:", nessun_setup: "Wählen Sie Teleskop und Kamera, um zu sehen, welche Objekte in Ihr Bildfeld passen.", modifica_campo: "Im Bildfeld ansehen und ändern →", occupa: "{p} % des Bildfelds", fit_ok: "passt gut", fit_grande: "größer als das Bildfeld", fit_piccolo: "klein im Bildfeld",
    prima_campo: "wählen Sie zuerst Teleskop und Kamera",
    calcolo: "Nacht wird berechnet…", tramonto: "Sonnenuntergang", buio_da: "Dunkel ab", buio_a: "Dunkel bis", crep_astronomico: "astronomische Dämmerung", alba: "Sonnenaufgang",
    ore_buio: "Dunkle Stunden", solo_nautico: "es wird nicht ganz dunkel", luna: "Mond", crescente: "zunehmend", calante: "abnehmend",
    luna_nuova: "Nächster Neumond", luna_piena: "Nächster Vollmond",
    avviso_nautico: "An diesem Datum wird es nicht ganz dunkel: Die Berechnung nutzt den dunkelsten verfügbaren Teil (nautische Dämmerung).",
    avviso_nessuno: "An diesem Datum sinkt die Sonne nicht tief genug: keine echte Nacht.",
    giorno: "Tag", crepuscolo: "Dämmerung", notte_astro: "Astronomische Nacht", luna_sopra: "Mond über dem Horizont",
    pianeti_stanotte: "Planeten heute Nacht", pianeta: "Planet", alt_max: "Max. Höhe", quando: "Uhrzeit", mag: "Helligkeit", diametro_app: "Durchmesser",
    fase: "Beleuchtet", sotto_orizzonte: "unter dem Horizont",
    pianeta_mercurio: "Merkur", pianeta_venere: "Venus", pianeta_marte: "Mars", pianeta_giove: "Jupiter", pianeta_saturno: "Saturn",
    pianeta_urano: "Uranus", pianeta_nettuno: "Neptun",
    nessun_oggetto: "Keine Objekte mit dieser Auswahl: Senken Sie die Mindesthöhe oder lockern Sie einige Einschränkungen unter „Objekte“.", trovati: "{n} sichtbare Objekte",
    mostra_altri: "Mehr anzeigen", ore_utili: "Nutzbare Std.", dist_luna: "Abstand zum Mond", sempre_sopra: "Immer über dem Horizont", sorge: "Aufgang",
    culmina: "am höchsten", tramonta: "Untergang", inquadra: "Im Bildfeld zeigen", grafico_altezza: "Höhe über dem Horizont während der Nacht",
    altezza_oggetto: "Objekt", altezza_luna: "Mond",
    gruppo_galassie: "Galaxien", gruppo_emissione: "Emissionsnebel", gruppo_riflessione: "Reflexionsnebel", gruppo_oscure: "Dunkelnebel",
    gruppo_planetarie: "Planetarische Nebel", gruppo_supernova: "Supernova-Überreste", gruppo_aperti: "Offene Sternhaufen", gruppo_globulari: "Kugelsternhaufen",
    gruppo_altre: "Weitere Objekte",
    tipo_gx: "Galaxie", tipo_gxg: "Galaxiengruppe", tipo_gxcl: "Galaxienhaufen", tipo_gxp: "Region einer Galaxie", tipo_oc: "Offener Sternhaufen",
    tipo_sc: "Sternwolke", tipo_gc: "Kugelsternhaufen", tipo_pn: "Planetarischer Nebel", tipo_en: "Emissionsnebel", tipo_rn: "Reflexionsnebel",
    tipo_dn: "Dunkelnebel", tipo_cn: "Sternhaufen mit Nebel", tipo_snr: "Supernova-Überrest", tipo_neb: "Nebel", tipo_reg: "Region", tipo_ds: "Doppelstern",
    marca: "Marke", colore_mono: "Farbe oder Mono", colore: "Farbe", mono: "Mono", sensore: "Sensor",
    pix_p1: "bis 2,4 µm", pix_p2: "2,4 – 3,8 µm", pix_p3: "3,8 – 5 µm", pix_p4: "über 5 µm",
    solo_negozio: "Nur Kameras aus unserem Shop", solo_produzione: "Nur aktuelle Modelle", camere_trovate: "{n} von {tot} Kameras",
    risoluzione: "Auflösung", formato: "Größe", campo_col: "Bildfeld mit Ihrem Teleskop", confronta: "Vergleichen", usa: "Verwenden", acquista: "Kaufen",
    raffreddata_s: "gekühlt", fuori_produzione: "nicht mehr hergestellt", mostra_altre: "Mehr anzeigen ({n})",
    da_confrontare: "{n} Kameras zum Vergleich (bis zu 4)", svuota: "Leeren", confronto: "Vergleich", megapixel: "Megapixel", bit: "ADC",
    raffreddata: "Gekühlt", si: "Ja", no: "Nein",
    nota_camere: "Technische Daten aus den offiziellen Datenblättern der Hersteller. Das Bildfeld wird mit dem unter „Bildfeld“ gewählten Teleskop berechnet.",
    cat_raffreddata: "Gekühlt", cat_non_raffreddata: "Ungekühlt", cat_planetaria_guida: "Planeten und Guiding", cat_smart: "Smart-Teleskope",
    cat_mirrorless: "Spiegellos", cat_reflex: "Spiegelreflex", cat_medio_formato: "Mittelformat", cat_swir: "Infrarot (SWIR)",
    c_tel: "Teleskop", c_tel_i: "Was ein Teleskop je nach Öffnung und Brennweite leisten kann.", rapporto_focale: "Öffnungsverhältnis",
    luce_raccolta: "Lichtsammelvermögen", luce_raccolta_n: "im Vergleich zum Auge (Pupille 7 mm)", risoluzione_rayleigh: "Auflösungsvermögen (Rayleigh)",
    mag_limite: "Visuelle Grenzgröße", mag_limite_n: "die schwächsten Sterne unter dunklem Himmel", ingr_max: "Maximal sinnvolle Vergrößerung",
    c_oc: "Okular", c_oc_i: "Vergrößerung, wahres Gesichtsfeld und Austrittspupille mit einem Okular.", focale_telescopio: "Brennweite des Teleskops",
    c_camp: "Ideale Brennweite für Ihre Kamera", c_camp_i: "Welche Brennweite die Pixel Ihrer Kamera beim Seeing Ihres Himmels am besten nutzt.",
    focale_ideale: "Ideale Brennweite", focale_ideale_n: "bei {s}″ Seeing (2–3 Pixel pro Stern)", consiglio: "Empfehlung",
    consiglio_rid: "ein Reducer von etwa {k}×", consiglio_barlow: "eine Barlowlinse von etwa {k}×", consiglio_barlow_n: "nur für maximale Details (oder ein Teleskop mit längerer Brennweite) – für weite Felder passt es so",
    c_plan: "Planetenfotografie", c_plan_i: "Für Mond, Sonne und Planeten mit Lucky Imaging.", f_ideale: "Ideales Öffnungsverhältnis",
    f_ideale_n: "Faustregel: das 5-Fache der Pixelgröße in µm bei Farbkameras, das 4-Fache bei Monokameras", focale_planetaria: "Zu verwendende Brennweite",
    barlow_serve: "eine Barlowlinse von etwa {k}× ist nötig", barlow_non_serve: "passt bereits",
    c_npf: "Nachtlandschaften ohne Nachführung", c_npf_i: "Die längste Belichtung, bevor die Sterne zu Strichen werden, mit der Kamera auf dem Stativ.",
    focale_obiettivo: "Brennweite des Objektivs", diaframma: "Blende", full_frame: "Vollformat", declinazione: "Deklination des Bildausschnitts",
    regola_npf: "NPF-Regel", regola_npf_n: "punktförmige Sterne auch in der Vergrößerung", regola_500: "500er-Regel", regola_500_n: "großzügiger, für die Ansicht im Vollbild",
    c_bf: "Backfokus und Distanzringe", c_bf_i: "Wie viele Millimeter Distanzringe zwischen Korrektor und Sensor nötig sind.", bf_richiesto: "Benötigter Backfokus",
    bf_camera: "Backfokus der Kamera", bf_ruota: "Filterrad oder Filterschublade", bf_filtro: "Filterdicke", bf_altro: "Weitere Adapter",
    bf_distanziali: "Benötigte Distanzringe", bf_troppo: "der Aufbau ist bereits zu lang", bf_correzione: "Korrektur für den Filter",
    bf_correzione_n: "ein Glasfilter verlängert den Fokus um etwa 1/3 seiner Dicke",
    c_pol: "Polarstern im Polsucher", c_pol_i: "Wo der Polarstern auf der Strichplatte stehen muss, um die Montierung einzunorden – jetzt, am unter „Heute Nacht“ gewählten Ort.",
    pol_cannocchiale: "Im Polsucher", pol_occhio: "Mit bloßem Auge", pol_ore: "Polarstern auf {o} Uhr", pol_angolo: "Stundenwinkel des Polarsterns",
    pol_distanza: "Abstand des Polarsterns vom Pol", pol_nota: "Berechnet um {ora} für: {luogo}. Der Polsucher zeigt das Bild umgekehrt: Folgen Sie der Zeichnung «Im Polsucher».",
    pol_sud: "Auf der Südhalbkugel ist der Polarstern nicht sichtbar: Dort nutzt man Sigma Octantis.",
    c_rug: "Taurisiko", c_rug_i: "Der Taupunkt zeigt, wann die Optik beschlägt.", temperatura: "Temperatur", umidita: "Luftfeuchtigkeit",
    punto_rugiada: "Taupunkt", rischio: "Taurisiko", rischio_alto: "hoch: Heizmanschetten einschalten", rischio_medio: "mittel: Heizmanschetten bereithalten",
    rischio_basso: "gering", rischio_n: "{m} °C über dem Taupunkt",
    c_int: "Integrationszeit und Speicherplatz", c_int_i: "Wie viele Stunden Daten Sie sammeln und wie viel Platz sie belegen.", numero_pose: "Anzahl der Aufnahmen",
    posa_s: "Belichtungszeit", integrazione: "Gesamtbelichtung", spazio_disco: "Speicherplatz", spazio_disco_n: "{mb} MB pro Aufnahme (16-Bit-Dateien, {c})",
    cerca_software: "Programm suchen…", categoria: "Kategorie", sistema: "System", solo_gratis: "Nur kostenlose",
    nota_software: "Links zu den offiziellen Seiten der Programme. Giordano Astronomia ist für die Inhalte externer Seiten nicht verantwortlich.",
    prezzo_gratuito: "Kostenlos", prezzo_open_source: "Open Source", prezzo_freemium: "Gratis + Pro", prezzo_a_pagamento: "Kostenpflichtig",
    sw_acquisizione: "Aufnahme und Steuerung", sw_guida: "Autoguiding", sw_plate_solving: "Plate Solving", sw_driver: "Treiber und Anbindung",
    sw_stacking: "Kalibrierung und Stacking", sw_elaborazione: "Bildbearbeitung", sw_planetario_solare: "Bearbeitung von Planeten, Mond und Sonne",
    sw_planetari: "Planetariumsprogramme und Planung", sw_app_strumenti: "Apps für Smart-Teleskope und Montierungen", sw_meteo_cielo: "Wetter und Himmel",
    carico_foto: "Himmelsaufnahme wird geladen…", foto_errore: "Die Himmelsaufnahme ist gerade nicht verfügbar – die Berechnungen bleiben gültig.",
    credito_foto: "Foto: Digitized Sky Survey (DSS2, STScI/NASA), Farben CDS, über hips2fits des CDS Straßburg.",
    firma_mappa: "Karte Giordano · ESA Hipparcos/Tycho-2", mappa_cielo: "Himmelskarte um das Objekt mit dem Bildfeld", vista_mappa: "Karte",
    vista_foto: "Foto", vista_confronto: "Vergleich", legenda_mappa: "Auf der Karte:", barlow_vicine: "Barlowlinsen im Shop:",
    cerca_fotocamera: "Suche: EOS R6, Z6 II, A7 IV…",
    nomi: "Namen", nomi_n: "Namen und Umrisse der Objekte ein- oder ausblenden", foto_errore_mappa: "Die Himmelsaufnahme ist gerade nicht verfügbar – hier unsere Himmelskarte.",
    miei_setup: "Meine Setups", setup: "Setup", salva_setup: "Setup speichern", nome_setup: "Name des Setups", salva: "Speichern", annulla: "Abbrechen", togli_setup: "Dieses Setup entfernen", conferma_togli: "Setup „{n}“ entfernen?", nessun_setup_salvato: "Noch kein Setup gespeichert: Teleskop und Kamera wählen, dann auf „Setup speichern“ tippen.", setup_gia_salvato: "Diese Ausrüstung ist bereits gespeichert.", usa_setup_calc: "Mit einem meiner Setups ausfüllen:", ferma: "Stopp", ascolta_spiegazione: "Erklärung anhören", guida_voce: "Anleitung",
    torna_oggetto: "Zurück zum Objekt", ctrl_rotella: "Zum Zoomen: Strg + Mausrad (oder zwei Finger)",
    richiama_setup: "Tippen Sie auf ein Setup, um es aufzurufen:", setup_salvato_come: "Diese Ausrüstung ist als „{n}“ gespeichert.", passo_1: "Wählen Sie unten Teleskop und Kamera (oder Okular).", passo_1_notte: "Wählen Sie unten Teleskop und Kamera.", passo_2: "Geben Sie ihm dann einen Namen und tippen Sie auf „Setup speichern“: Beim nächsten Mal genügt ein Tippen.", setup_pieni: "Sie haben bereits {n} Setups: Entfernen Sie eines, um ein neues zu speichern.", setup_scelto: "Gewählte Ausrüstung:", salva_come_setup: "Diese Ausrüstung in meinen Setups speichern",
    obiettivo: "Fotoobjektiv", diaframma_f: "Blende", miei_filtri: "Meine Filter",
    miei_filtri_n: "Suchen Sie Ihre Filter nach Namen (oder tippen Sie den Typ an): Für jedes Objekt sagen wir Ihnen, welchen Sie verwenden sollten.", filtro_dual: "Dualband",
    filtro_sho: "Hα/OIII/SII-Satz", filtro_ha: "Hα", filtro_oiii: "OIII", filtro_sii: "SII", filtro_hbeta: "Hβ", filtro_uhc: "UHC",
    filtro_lp: "LP-Filter", filtro_lrgb: "LRGB-Satz", filtro_uvir: "UV/IR-Sperre", filtro_irpass: "IR-Pass", filtro_luna: "Mondfilter",
    filtro_nessuno: "Kein Filter", filtro_rimanda: "Besser eine andere Nacht",
    filtro_dual_n: "Hα + OIII in einem Filter, für Farbkameras (z. B. L-eXtreme, L-Ultimate, ALP-T)", filtro_sho_n: "Schmalbandfilter für Monokameras",
    filtro_ha_n: "Schmalband Wasserstoff-Alpha", filtro_oiii_n: "Schmalband Sauerstoff", filtro_sii_n: "Schmalband Schwefel",
    filtro_hbeta_n: "Visuell: Pferdekopf- und Kaliforniennebel", filtro_uhc_n: "Nebelfilter, vor allem visuell",
    filtro_lp_n: "Breitband gegen Lichtverschmutzung (z. B. L-Pro, CLS)", filtro_lrgb_n: "Luminanz und Farben für Monokameras",
    filtro_uvir_n: "Sperrt UV und Infrarot", filtro_irpass_n: "Für Planeten und Mond bei schwierigem Seeing",
    filtro_luna_n: "Dämpft das Mondlicht visuell", filtro_consigliato: "Empfohlener Filter",
    filtro_alternativa: "Mit Ihrem {f} geht es besser als ohne Filter, aber ein Dualband spielt in einer ganz anderen Liga.",
    filtro_non_usare: "Nicht verwenden: {f}.", filtri_negozio: "Im Shop:", filtro_per_notte: "Gilt für heute Nacht {l_a} (Himmel Bortle {b}).",
    cambia_in_stanotte: "In „Heute Nacht“ ändern →", cielo_luogo: "Himmel am Ort",
    cielo_luogo_n: "Für die Filterempfehlung: Je heller der Himmel, desto wichtiger das Schmalband.", bortle_1: "1 · Exzellenter Himmel",
    bortle_2: "2 · Wirklich dunkler Himmel", bortle_3: "3 · Ländlicher Himmel", bortle_4: "4 · Zwischen Land und Vorort", bortle_5: "5 · Vorstadthimmel", bortle_6: "6 · Heller Vorort",
    bortle_7: "7 · Zwischen Vorort und Stadt", bortle_8: "8 · Stadthimmel", bortle_9: "9 · Stadtzentrum",
    ff_mono_em: "Emissionsnebel: Hα, dann OIII und SII für die SHO-Palette. Funktioniert auch bei Mond und in der Stadt.",
    ff_mono_pn: "Planetarischer Nebel: OIII und Hα, auch bei Mond.",
    ff_colore_em_buio: "Unter dunklem Himmel ohne Mond geht es auch ohne Filter, für natürliche Sternfarben, aber ein Dualband bringt mehr Kontrast.",
    ff_colore_em_luna: "Bei diesem Mond ist ein Dualband fast unverzichtbar: Es blockt das Mondlicht und lässt nur Hα und OIII durch.",
    ff_colore_em_citta: "Bei Ihrem hellen Himmel blockt ein Dualband die Lichtverschmutzung und lässt nur Hα und OIII durch.",
    ff_colore_bl_buio: "für Galaxien, Sternhaufen und Reflexionsnebel ist kein Filter nötig (eine UV/IR-Sperre genügt, wenn die Kamera keine hat).",
    ff_colore_bl_luce: "Ein Breitband-LP-Filter hilft im Vorort etwas, wenig bei Mond oder LED-Straßenlicht. Kein Dualband: Es würde das Licht des Objekts wegnehmen.",
    ff_mono_bl_buio: "LRGB: Luminanz für die Details, RGB für die Farben.",
    ff_mono_bl_luce: "mehr Zeit in RGB als in Luminanz, weil die Luminanz stärker unter dem Licht von Himmel und Mond leidet. Kein Schmalband für diese Objekte.",
    ff_rimanda_luna: "Bei diesem Mond verlieren Galaxien und Reflexionsnebel fast allen Kontrast: lieber eine andere Nacht, oder ein Emissionsnebel mit Dualband.",
    ff_rimanda_citta: "Unter diesem Himmel sind Galaxien auch mit Filtern schwach: lieber dunkler Himmel, oder ein Emissionsnebel mit Dualband.",
    fv_uhc: "Visuell dunkelt ein UHC den Himmelshintergrund ab und hebt den Nebel hervor.",
    fv_oiii: "visuell ist für Supernova-Überreste und planetarische Nebel OIII der beste (ein UHC geht auch).",
    fv_hbeta: "Visuell ist Hβ fast die einzige Möglichkeit, ihn zu sehen.", fv_nessuno: "visuell würde ein Filter nur Licht wegnehmen.",
    fv_nessuno_luce: "Visuell hilft bei diesem Licht kein Filter wirklich: besser ein dunklerer Himmel.",
    scrivi_altre: "Bitte noch ein paar Buchstaben eingeben…",
    sqm_misurato: "Gemessener SQM-Wert (falls vorhanden)",
    coordinate_sqm: "Koordinaten von Hand und gemessener SQM",
    sqm_vuoto: "Leer lassen, falls nicht gemessen",
    configurazione: "Konfiguration",
    come_stimiamo: "Wie schätzen wir die Himmelsdunkelheit?",
    cielo_satellite: "Aus dem Lichtverschmutzungsatlas von David Lorenz (2025), an diesem Punkt: SQM etwa {s} · LPI {l} (Bortle {b}). Wenn Sie außerhalb des Ortes beobachten, geben Sie die Koordinaten Ihres Beobachtungsplatzes ein oder nutzen Sie Ihren Standort.",
    vedi_atlante: "Der Punkt auf lightpollutionmap.info ↗", vedi_lorenz: "Die Karte von David Lorenz ↗",
    come_stimiamo_testo: "In Italien und Umgebung (von der Provence bis Albanien, im Süden bis Malta und Lampedusa) verwenden wir den Lichtverschmutzungsatlas von David Lorenz, Stand 2025, auf Basis der von Satelliten erfassten Lichter (VIIRS): ein Wert etwa alle 900 Meter. Für jeden Punkt liefert er zwei Zahlen. Der SQM ist die Himmelshelligkeit im Zenit in Magnituden pro Quadratbogensekunde: je höher, desto dunkler (22 ist der natürliche Himmel ohne Lichter). Der LPI, der Lichtverschmutzungsindex, gibt an, wie stark das künstliche Licht im Verhältnis zum natürlichen Himmelslicht ist: 0,1 heißt ein Zehntel, 1 gleich viel, 50 fünfzigmal so viel. Die Bortle-Klasse ist unsere Umrechnung aus dem SQM. Außerhalb dieses Gebiets schätzen wir die Dunkelheit anhand der Orte in der Nähe (typischer Fehler ±0,4–0,5 Magnituden). Die Karte berücksichtigt weder die Höhenlage noch den Dunst des Abends: Wenn Sie den Himmel mit einem SQM messen, tragen Sie Ihren Wert oben unter „Koordinaten von Hand und gemessener SQM“ ein.",
    cielo_stimato: "Aus den Orten in der Nähe geschätzt: SQM etwa {s} · LPI {l} (Bortle {b}). Wenn Sie außerhalb des Ortes, auf dem Land oder in den Bergen sind, wählen Sie Ihren Himmel oben selbst.",
    cielo_misurato: "Aus Ihrem SQM: {s} mag/arcsec².",
    cielo_scelto: "Von Ihnen gewählt.",
    usa_stima: "Schätzung verwenden",
    stima_in_corso: "Himmelsdunkelheit wird geschätzt…",
    cerca_filtro: "Suche: L-eXtreme, ALP-T, Hα…", togli_filtro: "Diesen Filter entfernen", oppure_tipo: "…oder tippen Sie den Filtertyp an:", usa_il_tuo: "✓ Nehmen Sie Ihren {f}.",
    luna_nuova_ok: "Fast Neumond: stört nicht.", luna_non_in_cielo: "Mond zu {k} % beleuchtet, aber nicht am Himmel, während das Objekt hoch steht: stört nicht.", luna_info: "Mond {k} %, {sep}° vom Objekt entfernt; nutzbare Stunden mit Mond am Himmel: {su} %.", luna_lontana_ok: "Er ist weit genug weg: Es geht auch ohne Schmalbandfilter.", luna_con_cautela: "Ohne Schmalbandfilter geht es, aber der Hintergrund wird heller: besser die Stunden ohne Mond.", luna_vicina_no: "Zu nah und zu hell: Ohne Schmalbandfilter lohnt sich das Fotografieren nicht.",
    corpo_sole: "Sonne", tipo_pianeta: "Planet", tipo_sole: "Stern (die Sonne)", tipo_luna: "Mond", alle: "um", illuminato: "beleuchtet", inquadra_breve: "Anzeigen", filtro_solare: "Sonnenfilter", filtro_solare_n: "Zertifizierter Objektiv-Sonnenfilter vor dem Teleskop", ff_sole: "ist Pflicht: zertifiziert, für die volle Öffnung und VOR dem Teleskop (und dem Sucher) montiert. Die Sonne nie ohne Filter beobachten oder fotografieren: sofortige Schäden an Augen und Kamera.", ff_luna: "meist nicht nötig; bei schwierigem Seeing gibt ein IR-Pass ruhigere Bilder.", fv_luna: "visuell nimmt ein Mondfilter oder Polfilter die Blendung.", ff_pianeta: "Farbkamera: UV/IR-Sperre; Monokamera oder schwieriges Seeing: IR-Pass für die Luminanz. Das ideale Öffnungsverhältnis finden Sie im Rechner „Planetenfotografie“.", fv_pianeta: "visuell nicht unbedingt nötig; Farbfilter helfen, Bänder und Flecken zu sehen.",
  },
  es: {
    tab_campo: "Campo de visión", tab_stanotte: "Esta noche", tab_camere: "Cámaras", tab_calcolatori: "Calculadoras", tab_software: "Software",
    caricamento: "Cargando las herramientas…", errore_dati: "No se pudieron cargar los datos. Recarga la página dentro de unos segundos.",
    cerca: "Buscar…", nessun_risultato: "Sin resultados", nel_negozio: "En Giordano Astronomia", vedi_prodotto: "Ver", da: "desde",
    non_disponibile: "no disponible", copiato: "¡Enlace copiado!",
    modo_foto: "Astrofotografía", modo_visuale: "Observación visual",
    telescopio: "Telescopio", cerca_telescopio: "Busca: Esprit 100, RCN8, Samyang…",
    diametro: "Diámetro", focale: "Focal", personalizzato: "Personalizado", personalizzata: "Personalizada",
    riduttore: "Reductor / Barlow", nessuno: "Ninguno (1×)", riduttore_b: "reductor", barlow_b: "Barlow",
    riduttori_negozio: "Reductores con este factor en la tienda:", barlow_negozio: "Barlow con este factor en la tienda:",
    camera: "Cámara", cerca_camera: "Busca: ASI2600, EOS R6, Seestar…",
    larghezza_px: "Ancho", altezza_px: "Alto", pixel: "Píxel", binning: "Binning", seeing: "Seeing",
    seeing_1: "Excelente (1″)", seeing_1_5: "Muy bueno (1,5″)", seeing_2: "Bueno (2″)", seeing_2_5: "Medio (2,5″)", seeing_3: "Regular (3″)",
    seeing_4: "Malo (4″)", seeing_5: "Muy malo (5″)", in_vendita: "a la venta",
    oculare: "Ocular", cerca_oculare: "Busca: 25 mm, 82°, Plössl…", focale_oculare: "Focal del ocular", campo_apparente: "Campo aparente",
    oggetto: "Objeto", cerca_oggetto: "Busca: M31, NGC 7000, Murciélago…",
    inquadratura: "Encuadre", rotazione: "Rotación de la cámara", rotazione_n: "0° = lado largo horizontal (este-oeste) con el norte arriba; el ángulo crece en sentido antihorario.", mosaico_x: "Paneles en horizontal", mosaico_y: "Paneles en vertical", sovrapposizione: "Solapamiento", mosaico: "Mosaico", rosso: "Visión nocturna", rosso_n: "Página en rojo para no perder la adaptación a la oscuridad al aire libre", chip_luna: "Luna", chip_buio: "Oscuridad", chip_oggetti: "objetos", chip_camere: "cámaras", chip_telescopi: "telescopios", rotazione_b: "Rotación", ruota_90: "Girar 90°",
    carico_cielo: "Dibujando el mapa del cielo…", cielo_errore: "El mapa del cielo no se puede cargar ahora mismo: los cálculos siguen siendo válidos.",
    allarga: "Alejar la vista", stringi: "Acercar la vista", centra_qui: "Centrar aquí", reimposta: "Empezar de nuevo", copia_link: "Copiar enlace",
    credito_cielo: "Mapa del cielo dibujado por Giordano Astronomia: estrellas de los catálogos Hipparcos y Tycho-2 de la ESA hasta la magnitud 10,5, con sus colores reales; Vía Láctea calculada a partir de la densidad de estrellas; galaxias y nebulosas de nuestro catálogo con tamaño y orientación reales.",
    trascina: "Arrastra el cielo para moverte (el recuadro se queda en el centro); doble toque (o doble clic) para centrar; dos dedos o Ctrl + rueda para ampliar.",
    centri_pannelli: "Coordenadas de los paneles del mosaico", centro_inquadratura: "Coordenadas del centro del encuadre",
    scegli_telescopio: "Elige un telescopio o introduce diámetro y focal.", scegli_camera: "Elige una cámara o introduce resolución y tamaño de píxel.",
    scegli_oculare: "Elige un ocular o introduce focal y campo aparente.", mancano_dati: "Elige telescopio y cámara (u ocular) para ver el campo.",
    campo_inquadrato: "Campo de visión", diagonale: "diagonal", scala: "Escala de imagen", focale_effettiva: "Focal efectiva", immagine: "Imagen",
    campionamento: "Muestreo",
    camp_sovra: "sobremuestreado", camp_sovra_n: "Cada estrella ocupa demasiados píxeles: usa binning {b}×{b} o un reductor.",
    camp_poco_sovra: "ligeramente sobremuestreado", camp_poco_sovra_n: "Va bien con mejor seeing; con el seeing elegido el binning 2×2 no pierde detalle.",
    camp_ok: "ideal", camp_ok_n: "Las estrellas quedan redondas y se aprovecha toda la resolución.",
    camp_poco_sotto: "ligeramente submuestreado", camp_poco_sotto_n: "Normal en gran campo: estrellas algo más cuadradas, detalle cerca del máximo.",
    camp_sotto: "submuestreado", camp_sotto_n: "Las estrellas se vuelven pequeños cuadrados: bien para campos muy amplios; para el detalle hace falta más focal.",
    camp_dettaglio: "Con un seeing de {s}″ lo ideal está entre {a} y {b}″/px (2-3 píxeles por estrella).",
    risoluzione_dawes: "Poder resolutivo (Dawes)", risoluzione_nota: "límite teórico de la óptica: en la práctica el límite es casi siempre el seeing",
    mosaico_totale: "Mosaico, área total", pannelli: "paneles",
    riempimento: "El objeto ocupa", non_entra: "no cabe entero: prueba un reductor o un mosaico", molto_piccolo: "muy pequeño en el campo: hace falta más focal",
    ingrandimento: "Aumentos", max_utile: "máximo útil", campo_reale: "Campo real", pupilla: "Pupila de salida",
    pupilla_piccola: "muy pequeña: imagen oscura", pupilla_grande: "Pupila de salida de más de 7 mm: parte de la luz no entra en el ojo.",
    troppo_ingrandimento: "Por encima de los aumentos máximos útiles ({m}×): la imagen pierde nitidez.",
    ingr_minimo: "Aumentos mínimos", ingr_minimo_n: "por debajo, la pupila de salida supera los 7 mm",
    il_telescopio: "El telescopio en Giordano Astronomia", la_camera: "La cámara en Giordano Astronomia", l_oculare: "El ocular en Giordano Astronomia",
    parte_di: "parte de",
    migliori_stanotte: "Los mejores objetos de la noche", latitudine: "Latitud", longitudine: "Longitud", posizione_mano: "Posición introducida a mano",
    cerca_citta: "Busca una ciudad…", cerco_posizione: "Buscando la posición…", mia_posizione: "Mi posición", usa_posizione: "Usar mi posición",
    posizione_negata: "Posición no disponible: busca una ciudad o escribe las coordenadas.", stanotte: "Esta noche", luogo: "Lugar", data_notte: "Noche del",
    nota_orari: "Las horas están en la zona horaria de tu dispositivo.",
    altezza_minima: "Altura mínima", tipo: "Tipo", tutti: "Todos", tutte: "Todas", costellazione: "Constelación", qualsiasi: "Cualquiera",
    magnitudine_max: "Magnitud", ordina: "Ordenar por",
    ord_migliori: "Los mejores esta noche", ord_ore: "Más horas útiles", ord_altezza: "Más altos en el cielo", ord_grandezza: "Más grandes", ord_luminosi: "Más brillantes",
    ord_nome: "Nombre", ord_mp: "Más megapíxeles", ord_pixel: "Píxeles más grandes", ord_formato: "Sensor más grande", ord_recenti: "Más recientes",
    solo_famosi: "Solo Messier, Caldwell y objetos con nombre", solo_campo: "Mostrar solo los objetos adecuados para mi campo", mio_setup: "Mi equipo", mio_setup_n: "Elige telescopio y cámara: la elección vale también en el Campo de visión.", campo_tuo: "Tu campo:", nessun_setup: "Elige telescopio y cámara para ver qué objetos caben en tu campo.", modifica_campo: "Ver y cambiar en Campo de visión →", occupa: "{p} % del campo", fit_ok: "cabe bien", fit_grande: "más grande que el campo", fit_piccolo: "pequeño en el campo",
    prima_campo: "primero elige telescopio y cámara",
    calcolo: "Calculando la noche…", tramonto: "Puesta de Sol", buio_da: "Inicio de la oscuridad", buio_a: "Fin de la oscuridad", crep_astronomico: "crepúsculo astronómico", alba: "Salida del Sol",
    ore_buio: "Horas de oscuridad", solo_nautico: "el cielo no oscurece del todo", luna: "Luna", crescente: "creciente", calante: "menguante",
    luna_nuova: "Próxima Luna nueva", luna_piena: "Próxima Luna llena",
    avviso_nautico: "En esta fecha el cielo no llega a oscurecer del todo: los cálculos usan la parte más oscura disponible (crepúsculo náutico).",
    avviso_nessuno: "En esta fecha el Sol no baja lo suficiente bajo el horizonte: no hay noche de verdad.",
    giorno: "Día", crepuscolo: "Crepúsculo", notte_astro: "Noche astronómica", luna_sopra: "Luna sobre el horizonte",
    pianeti_stanotte: "Planetas esta noche", pianeta: "Planeta", alt_max: "Altura máx.", quando: "Hora", mag: "Magnitud", diametro_app: "Diámetro",
    fase: "Iluminado", sotto_orizzonte: "bajo el horizonte",
    pianeta_mercurio: "Mercurio", pianeta_venere: "Venus", pianeta_marte: "Marte", pianeta_giove: "Júpiter", pianeta_saturno: "Saturno",
    pianeta_urano: "Urano", pianeta_nettuno: "Neptuno",
    nessun_oggetto: "No hay objetos con estas opciones: baja la altura mínima o quita algún límite en «Objetos».", trovati: "{n} objetos visibles",
    mostra_altri: "Mostrar más", ore_utili: "Horas útiles", dist_luna: "Distancia a la Luna", sempre_sopra: "Siempre sobre el horizonte", sorge: "Sale",
    culmina: "más alto", tramonta: "se pone", inquadra: "Encuádralo en el campo", grafico_altezza: "Altura sobre el horizonte durante la noche",
    altezza_oggetto: "Objeto", altezza_luna: "Luna",
    gruppo_galassie: "Galaxias", gruppo_emissione: "Nebulosas de emisión", gruppo_riflessione: "Nebulosas de reflexión", gruppo_oscure: "Nebulosas oscuras",
    gruppo_planetarie: "Nebulosas planetarias", gruppo_supernova: "Restos de supernova", gruppo_aperti: "Cúmulos abiertos", gruppo_globulari: "Cúmulos globulares",
    gruppo_altre: "Otros objetos",
    tipo_gx: "Galaxia", tipo_gxg: "Grupo de galaxias", tipo_gxcl: "Cúmulo de galaxias", tipo_gxp: "Región de una galaxia", tipo_oc: "Cúmulo abierto",
    tipo_sc: "Nube estelar", tipo_gc: "Cúmulo globular", tipo_pn: "Nebulosa planetaria", tipo_en: "Nebulosa de emisión", tipo_rn: "Nebulosa de reflexión",
    tipo_dn: "Nebulosa oscura", tipo_cn: "Cúmulo con nebulosa", tipo_snr: "Resto de supernova", tipo_neb: "Nebulosa", tipo_reg: "Región", tipo_ds: "Estrella doble",
    marca: "Marca", colore_mono: "Color o mono", colore: "Color", mono: "Mono", sensore: "Sensor",
    pix_p1: "hasta 2,4 µm", pix_p2: "2,4 – 3,8 µm", pix_p3: "3,8 – 5 µm", pix_p4: "más de 5 µm",
    solo_negozio: "Solo las que vendemos", solo_produzione: "Solo en producción", camere_trovate: "{n} cámaras de {tot}",
    risoluzione: "Resolución", formato: "Tamaño", campo_col: "Campo con tu telescopio", confronta: "Comparar", usa: "Usar", acquista: "Comprar",
    raffreddata_s: "refrigerada", fuori_produzione: "descatalogada", mostra_altre: "Mostrar más ({n})",
    da_confrontare: "{n} cámaras para comparar (hasta 4)", svuota: "Vaciar", confronto: "Comparación", megapixel: "Megapíxeles", bit: "ADC",
    raffreddata: "Refrigerada", si: "Sí", no: "No",
    nota_camere: "Datos técnicos de las fichas oficiales de los fabricantes. El campo se calcula con el telescopio elegido en el Campo de visión.",
    cat_raffreddata: "Refrigeradas", cat_non_raffreddata: "No refrigeradas", cat_planetaria_guida: "Planetarias y de guiado", cat_smart: "Telescopios inteligentes",
    cat_mirrorless: "Sin espejo", cat_reflex: "Réflex", cat_medio_formato: "Formato medio", cat_swir: "Infrarrojo (SWIR)",
    c_tel: "Telescopio", c_tel_i: "Lo que puede hacer un telescopio según su diámetro y su focal.", rapporto_focale: "Relación focal",
    luce_raccolta: "Luz captada", luce_raccolta_n: "respecto al ojo (pupila de 7 mm)", risoluzione_rayleigh: "Poder resolutivo (Rayleigh)",
    mag_limite: "Magnitud límite visual", mag_limite_n: "las estrellas más débiles visibles bajo un cielo oscuro", ingr_max: "Aumentos máximos útiles",
    c_oc: "Ocular", c_oc_i: "Aumentos, campo real y pupila de salida con un ocular.", focale_telescopio: "Focal del telescopio",
    c_camp: "Focal ideal para tu cámara", c_camp_i: "Qué focal aprovecha mejor los píxeles de tu cámara con el seeing de tu cielo.",
    focale_ideale: "Focal ideal", focale_ideale_n: "con seeing de {s}″ (2-3 píxeles por estrella)", consiglio: "Consejo",
    consiglio_rid: "un reductor de unos {k}×", consiglio_barlow: "una Barlow de unos {k}×", consiglio_barlow_n: "solo si buscas el máximo detalle (o un telescopio de focal más larga): para gran campo, así está bien",
    c_plan: "Fotografía planetaria", c_plan_i: "Para Luna, Sol y planetas con la técnica del lucky imaging.", f_ideale: "Relación focal ideal",
    f_ideale_n: "regla práctica: 5 veces el tamaño del píxel en µm para las cámaras en color, 4 veces para las mono", focale_planetaria: "Focal que usar",
    barlow_serve: "hace falta una Barlow de unos {k}×", barlow_non_serve: "ya está bien así",
    c_npf: "Paisajes nocturnos sin seguimiento", c_npf_i: "La exposición más larga antes de que las estrellas se conviertan en trazos, con la cámara en el trípode.",
    focale_obiettivo: "Focal del objetivo", diaframma: "Diafragma", full_frame: "Full frame", declinazione: "Declinación del encuadre",
    regola_npf: "Regla NPF", regola_npf_n: "estrellas puntuales incluso ampliando", regola_500: "Regla del 500", regola_500_n: "más tolerante, para ver a pantalla completa",
    c_bf: "Backfocus y separadores", c_bf_i: "Cuántos milímetros de separadores hacen falta entre corrector y sensor.", bf_richiesto: "Backfocus necesario",
    bf_camera: "Backfocus de la cámara", bf_ruota: "Rueda o cajón", bf_filtro: "Grosor del filtro", bf_altro: "Otros adaptadores",
    bf_distanziali: "Separadores que añadir", bf_troppo: "el tren óptico ya es demasiado largo", bf_correzione: "Corrección por el filtro",
    bf_correzione_n: "un filtro de vidrio alarga el foco aproximadamente 1/3 de su grosor",
    c_pol: "Polar en el buscador polar", c_pol_i: "Dónde colocar la Estrella Polar en la retícula para alinear la montura, ahora, en el lugar elegido en «Esta noche».",
    pol_cannocchiale: "En el buscador polar", pol_occhio: "A simple vista", pol_ore: "Polar a las {o}", pol_angolo: "Ángulo horario de la Polar",
    pol_distanza: "Distancia de la Polar al polo", pol_nota: "Calculado a las {ora} para: {luogo}. El buscador invierte la imagen: sigue el dibujo «En el buscador polar».",
    pol_sud: "En el hemisferio sur la Polar no se ve: se usa Sigma Octantis.",
    c_rug: "Riesgo de condensación", c_rug_i: "El punto de rocío indica cuándo se empaña la óptica.", temperatura: "Temperatura", umidita: "Humedad",
    punto_rugiada: "Punto de rocío", rischio: "Riesgo de condensación", rischio_alto: "alto: enciende las bandas calefactoras", rischio_medio: "medio: ten preparadas las bandas",
    rischio_basso: "bajo", rischio_n: "{m} °C por encima del punto de rocío",
    c_int: "Tiempo de integración y espacio en disco", c_int_i: "Cuántas horas de datos reúnes y cuánto espacio ocupan.", numero_pose: "Número de tomas",
    posa_s: "Duración de una toma", integrazione: "Integración total", spazio_disco: "Espacio en disco", spazio_disco_n: "{mb} MB por toma (archivos de 16 bits, {c})",
    cerca_software: "Busca un programa…", categoria: "Categoría", sistema: "Sistema", solo_gratis: "Solo gratuitos",
    nota_software: "Enlaces a las webs oficiales de los programas. Giordano Astronomia no es responsable del contenido de sitios externos.",
    prezzo_gratuito: "Gratis", prezzo_open_source: "Código abierto", prezzo_freemium: "Gratis + Pro", prezzo_a_pagamento: "De pago",
    sw_acquisizione: "Captura y control", sw_guida: "Autoguiado", sw_plate_solving: "Plate solving", sw_driver: "Drivers y conexión",
    sw_stacking: "Calibración y apilado", sw_elaborazione: "Procesado", sw_planetario_solare: "Procesado de planetas, Luna y Sol",
    sw_planetari: "Planetarios y planificación", sw_app_strumenti: "Apps de telescopios inteligentes y monturas", sw_meteo_cielo: "Meteorología y cielo",
    carico_foto: "Cargando la foto del cielo…", foto_errore: "La foto del cielo no está disponible ahora mismo: los cálculos siguen siendo válidos.",
    credito_foto: "Foto: Digitized Sky Survey (DSS2, STScI/NASA), colores CDS, mediante hips2fits del CDS de Estrasburgo.",
    firma_mappa: "Mapa Giordano · ESA Hipparcos/Tycho-2", mappa_cielo: "Mapa del cielo alrededor del objeto, con el recuadro del campo",
    vista_mappa: "Mapa", vista_foto: "Foto", vista_confronto: "Comparar", legenda_mappa: "En el mapa:", barlow_vicine: "Barlow en la tienda:",
    cerca_fotocamera: "Busca: EOS R6, Z6 II, A7 IV…",
    nomi: "Nombres", nomi_n: "Mostrar u ocultar nombres y contornos de los objetos", foto_errore_mappa: "La foto del cielo no está disponible ahora mismo: te muestro nuestro mapa.",
    miei_setup: "Mis configuraciones", setup: "Configuración", salva_setup: "Guardar configuración", nome_setup: "Nombre de la configuración", salva: "Guardar", annulla: "Cancelar", togli_setup: "Quitar esta configuración", conferma_togli: "¿Quitar la configuración «{n}»?", nessun_setup_salvato: "Ningún equipo guardado: elige telescopio y cámara y pulsa «Guardar equipo».", setup_gia_salvato: "Este equipo ya está entre tus configuraciones.", usa_setup_calc: "Rellenar con una de mis configuraciones:", ferma: "Parar", ascolta_spiegazione: "Escuchar la explicación", guida_voce: "Guía",
    torna_oggetto: "Volver al objeto", ctrl_rotella: "Para ampliar: Ctrl + rueda (o dos dedos)",
    richiama_setup: "Toca una configuración para recuperarla:", setup_salvato_come: "Este equipo está guardado como «{n}».", passo_1: "Elige abajo el telescopio y la cámara (o el ocular).", passo_1_notte: "Elige abajo el telescopio y la cámara.", passo_2: "Luego ponle un nombre y pulsa «Guardar configuración»: la próxima vez la recuperas con un toque.", setup_pieni: "Ya tienes {n} configuraciones: quita una para guardar otra.", setup_scelto: "Equipo elegido:", salva_come_setup: "Guardar este equipo en mis configuraciones",
    obiettivo: "Objetivo fotográfico", diaframma_f: "Diafragma", miei_filtri: "Mis filtros",
    miei_filtri_n: "Busca tus filtros por nombre (o toca el tipo): para cada objeto te decimos cuál montar.", filtro_dual: "Dual band", filtro_sho: "Set Hα/OIII/SII",
    filtro_ha: "Hα", filtro_oiii: "OIII", filtro_sii: "SII", filtro_hbeta: "Hβ", filtro_uhc: "UHC", filtro_lp: "Antipolución", filtro_lrgb: "Set LRGB",
    filtro_uvir: "UV/IR cut", filtro_irpass: "IR pass", filtro_luna: "Lunar", filtro_nessuno: "Sin filtro", filtro_rimanda: "Mejor otra noche",
    filtro_dual_n: "Hα + OIII en un solo filtro, para cámaras en color (p. ej. L-eXtreme, L-Ultimate, ALP-T)",
    filtro_sho_n: "Filtros de banda estrecha para cámaras mono", filtro_ha_n: "Banda estrecha de hidrógeno alfa",
    filtro_oiii_n: "Banda estrecha de oxígeno", filtro_sii_n: "Banda estrecha de azufre", filtro_hbeta_n: "Visual: Cabeza de Caballo y California",
    filtro_uhc_n: "Nebular, sobre todo visual", filtro_lp_n: "Banda ancha contra la contaminación lumínica (p. ej. L-Pro, CLS)",
    filtro_lrgb_n: "Luminancia y colores para cámaras mono", filtro_uvir_n: "Corta ultravioleta e infrarrojo",
    filtro_irpass_n: "Para planetas y Luna con seeing difícil", filtro_luna_n: "Reduce la luz de la Luna en el ocular",
    filtro_consigliato: "Filtro recomendado", filtro_alternativa: "Con tu filtro {f} va mejor que sin él, pero un dual band es otra cosa.",
    filtro_non_usare: "No uses: {f}.", filtri_negozio: "En la tienda:", filtro_per_notte: "Vale para esta noche, observando {l_da} (cielo Bortle {b}).",
    cambia_in_stanotte: "Cambiar en «Esta noche» →", cielo_luogo: "Cielo del lugar",
    cielo_luogo_n: "Sirve para recomendar el filtro: cuanto más claro el cielo, más cuenta la banda estrecha.", bortle_1: "1 · Cielo excelente",
    bortle_2: "2 · Cielo realmente oscuro", bortle_3: "3 · Cielo rural", bortle_4: "4 · Entre campo y periferia", bortle_5: "5 · Cielo de periferia",
    bortle_6: "6 · Afueras luminosas", bortle_7: "7 · Entre afueras y ciudad", bortle_8: "8 · Cielo de ciudad", bortle_9: "9 · Centro de la ciudad",
    ff_mono_em: "nebulosa de emisión: Hα, luego OIII y SII para la paleta SHO. Funciona también con Luna y en la ciudad.",
    ff_mono_pn: "nebulosa planetaria: OIII y Hα, también con Luna.",
    ff_colore_em_buio: "con un cielo oscuro y sin Luna también puedes fotografiar sin filtro, para los colores naturales de las estrellas, pero el dual band da más contraste.",
    ff_colore_em_luna: "con esta Luna el dual band es casi imprescindible: corta la luz lunar y deja pasar solo Hα y OIII.",
    ff_colore_em_citta: "con el cielo claro de tu lugar el dual band corta la contaminación lumínica y deja pasar solo Hα y OIII.",
    ff_colore_bl_buio: "para galaxias, cúmulos y nebulosas de reflexión no hace falta filtro (basta el UV/IR cut si la cámara no lo tiene).",
    ff_colore_bl_luce: "un filtro antipolución de banda ancha ayuda algo en las afueras, poco con Luna o farolas LED. Nada de dual band: quitaría la luz del objeto.",
    ff_mono_bl_buio: "LRGB: la luminancia para el detalle, RGB para los colores.",
    ff_mono_bl_luce: "más tiempo en RGB que en luminancia, porque la luminancia sufre más la luz del cielo y de la Luna. Nada de banda estrecha en estos objetos.",
    ff_rimanda_luna: "con esta Luna las galaxias y las nebulosas de reflexión pierden casi todo el contraste: mejor otra noche, o una nebulosa de emisión con dual band.",
    ff_rimanda_citta: "con este cielo las galaxias se ven poco incluso con filtros: mejor un cielo más oscuro, o una nebulosa de emisión con dual band.",
    fv_uhc: "en visual, un UHC oscurece el fondo del cielo y hace resaltar la nebulosa.",
    fv_oiii: "en visual, para restos de supernova y nebulosas planetarias el mejor es el OIII (también sirve un UHC).",
    fv_hbeta: "en visual, el Hβ es casi la única forma de verla.", fv_nessuno: "en visual, un filtro solo quitaría luz.",
    fv_nessuno_luce: "en visual, ningún filtro ayuda de verdad con esta luz: mejor un cielo más oscuro.",
    scrivi_altre: "Escribe alguna letra más…",
    sqm_misurato: "SQM medido (si tienes el medidor)",
    coordinate_sqm: "Coordenadas a mano y SQM medido",
    sqm_vuoto: "Déjalo vacío si no lo has medido",
    configurazione: "Configuración óptica",
    come_stimiamo: "¿Cómo estimamos la oscuridad del cielo?",
    cielo_satellite: "Según el atlas de contaminación lumínica de David Lorenz (2025), en este punto: SQM aprox. {s} · LPI {l} (Bortle {b}). Si observas lejos del núcleo urbano, pon las coordenadas del lugar o usa tu posición.",
    vedi_atlante: "El punto en lightpollutionmap.info ↗", vedi_lorenz: "El mapa de David Lorenz ↗",
    come_stimiamo_testo: "En Italia y alrededores (de la Provenza a Albania, hasta Malta y Lampedusa) usamos el atlas de contaminación lumínica de David Lorenz, actualizado a 2025 con las luces vistas por los satélites (VIIRS): un valor cada 900 metros aproximadamente. Para cada punto da dos números. El SQM es el brillo del cielo en el cenit en magnitudes por segundo de arco cuadrado: cuanto más alto, más oscuro (22 es el cielo natural, sin luces). El LPI, el índice de contaminación lumínica, dice cuántas veces la luz artificial supera la natural del cielo: 0,1 es una décima parte, 1 la misma cantidad, 50 cincuenta veces más. La clase de Bortle es una conversión nuestra desde el SQM. Fuera de esta zona estimamos la oscuridad a partir de las poblaciones cercanas (error típico ±0,4–0,5 magnitudes). El mapa no tiene en cuenta la altitud ni la bruma de la noche: si mides el cielo con un SQM, escribe tu valor aquí arriba, en «Coordenadas a mano y SQM medido».",
    cielo_stimato: "Estimado a partir de las poblaciones cercanas: SQM aprox. {s} · LPI {l} (Bortle {b}). Si estás lejos del núcleo urbano, en el campo o en la montaña, elige tu cielo arriba.",
    cielo_misurato: "Según tu SQM: {s} mag/arcsec².",
    cielo_scelto: "Elegido por ti.",
    usa_stima: "Usar la estimación",
    stima_in_corso: "Estimando la oscuridad del cielo…",
    cerca_filtro: "Busca: L-eXtreme, ALP-T, Hα…", togli_filtro: "Quitar este filtro", oppure_tipo: "…o toca el tipo de filtro que tienes:", usa_il_tuo: "✓ Usa tu {f}.",
    luna_nuova_ok: "Luna casi nueva: no molesta.", luna_non_in_cielo: "Luna al {k} %, pero no está en el cielo mientras el objeto está alto: no molesta.", luna_info: "Luna al {k} %, a {sep}° del objeto; horas útiles con la Luna en el cielo: {su} %.", luna_lontana_ok: "Está bastante lejos: puedes fotografiar también sin filtros de banda estrecha.", luna_con_cautela: "Sin filtros de banda estrecha se puede, pero el fondo será más claro: mejor las horas sin Luna.", luna_vicina_no: "Demasiado cerca y brillante: sin un filtro de banda estrecha no conviene fotografiar.",
    corpo_sole: "Sol", tipo_pianeta: "Planeta", tipo_sole: "Estrella (el Sol)", tipo_luna: "Satélite", alle: "a las", illuminato: "iluminado", inquadra_breve: "Encuadrar", filtro_solare: "Filtro solar", filtro_solare_n: "Filtro solar certificado de apertura completa, delante del telescopio", ff_sole: "es obligatorio: certificado, de apertura completa, montado DELANTE del telescopio (y del buscador). Nunca mires ni fotografíes el Sol sin él: daños inmediatos en ojos y cámara.", ff_luna: "normalmente no hace falta; con seeing difícil un IR pass da imágenes más estables.", fv_luna: "en visual, un filtro lunar o un polarizador quita el deslumbramiento.", ff_pianeta: "cámara en color: UV/IR cut; cámara mono o seeing difícil: IR pass para la luminancia. La relación focal ideal la encuentras en la calculadora «Fotografía planetaria».", fv_pianeta: "en visual no es imprescindible un filtro; los de color ayudan a ver bandas y manchas.",
  },
  en: {},
};
Object.assign(TESTI.it, { me_ore_buone_1: "{n} ora buona", home_vivo_meteo_1: "Stanotte {n} ora buona · nuvole {p} %",
  da_confrontare_1: "{n} camera da confrontare (fino a 4)", pn_tot_1: "{n} oggetto · {t} di buio", camere_trovate_1: "{n} camera su {tot}",
  trovati_1: "{n} oggetto visibile", kit_pezzi_1: "{n} prodotto", att_recuperati_1: "Abbiamo ritrovato {n} filtro che era rimasto dentro i tuoi setup." });
Object.assign(TESTI.en, { me_ore_buone_1: "{n} good hour", home_vivo_meteo_1: "{n} good hour tonight · clouds {p}%",
  da_confrontare_1: "{n} camera to compare (up to 4)", pn_tot_1: "{n} object · {t} of darkness", camere_trovate_1: "{n} of {tot} cameras",
  trovati_1: "{n} visible object", kit_pezzi_1: "{n} product", att_recuperati_1: "We found {n} filter that had been left inside your setups." });
Object.assign(TESTI.de, { me_ore_buone_1: "{n} gute Stunde", home_vivo_meteo_1: "Heute Nacht {n} gute Stunde · Wolken {p} %",
  da_confrontare_1: "{n} Kamera zum Vergleich (bis zu 4)", pn_tot_1: "{n} Objekt · {t} Dunkelheit", camere_trovate_1: "{n} von {tot} Kameras",
  trovati_1: "{n} sichtbares Objekt", kit_pezzi_1: "{n} Produkt", att_recuperati_1: "Wir haben {n} Filter wiedergefunden, der in Ihren Setups gespeichert war." });
Object.assign(TESTI.es, { me_ore_buone_1: "{n} hora buena", home_vivo_meteo_1: "Esta noche {n} hora buena · nubes {p} %",
  da_confrontare_1: "{n} cámara para comparar (hasta 4)", pn_tot_1: "{n} objeto · {t} de oscuridad", camere_trovate_1: "{n} cámara de {tot}",
  trovati_1: "{n} objeto visible", kit_pezzi_1: "{n} producto", att_recuperati_1: "Hemos recuperado {n} filtro que se había quedado dentro de tus configuraciones." });
function t(k, v) {
  if (v && (v.n === 1 || v.n === "1") && TESTI[LINGUA] && TESTI[LINGUA][k + "_1"] != null) k = k + "_1";
  let s = (TESTI[LINGUA] && TESTI[LINGUA][k]) != null ? TESTI[LINGUA][k] : (TESTI.it[k] != null ? TESTI.it[k] : k);
  if (v) s = s.replace(/\{(\w+)\}/g, (m, x) => (v[x] != null ? v[x] : m));
  return s;
}
function tNodi(k, v) {
  return t(k).split(/(\{\w+\})/).filter(Boolean).map(p => {
    const m = /^\{(\w+)\}$/.exec(p);
    return m && v[m[1]] != null ? el("b", null, String(v[m[1]])) : p;
  });
}
const NOMI_COSTELLAZIONI = {
  And: ["Andromeda", "Andromeda", "Andrómeda"], Ant: ["Macchina Pneumatica", "Luftpumpe", "Máquina Neumática"], Aps: ["Uccello del Paradiso", "Paradiesvogel", "Ave del Paraíso"],
  Aqr: ["Acquario", "Wassermann", "Acuario"], Aql: ["Aquila", "Adler", "Águila"], Ara: ["Altare", "Altar", "Altar"], Ari: ["Ariete", "Widder", "Aries"],
  Aur: ["Auriga", "Fuhrmann", "Auriga"], Boo: ["Boote", "Bärenhüter", "Boyero"], Cae: ["Bulino", "Grabstichel", "Cincel"], Cam: ["Giraffa", "Giraffe", "Jirafa"],
  Cnc: ["Cancro", "Krebs", "Cáncer"], CVn: ["Cani da Caccia", "Jagdhunde", "Perros de Caza"], CMa: ["Cane Maggiore", "Großer Hund", "Can Mayor"],
  CMi: ["Cane Minore", "Kleiner Hund", "Can Menor"], Cap: ["Capricorno", "Steinbock", "Capricornio"], Car: ["Carena", "Kiel des Schiffs", "Quilla"],
  Cas: ["Cassiopea", "Kassiopeia", "Casiopea"], Cen: ["Centauro", "Zentaur", "Centauro"], Cep: ["Cefeo", "Kepheus", "Cefeo"], Cet: ["Balena", "Walfisch", "Ballena"],
  Cha: ["Camaleonte", "Chamäleon", "Camaleón"], Cir: ["Compasso", "Zirkel", "Compás"], Col: ["Colomba", "Taube", "Paloma"],
  Com: ["Chioma di Berenice", "Haar der Berenike", "Cabellera de Berenice"], CrA: ["Corona Australe", "Südliche Krone", "Corona Austral"],
  CrB: ["Corona Boreale", "Nördliche Krone", "Corona Boreal"], Crv: ["Corvo", "Rabe", "Cuervo"], Crt: ["Cratere", "Becher", "Copa"],
  Cru: ["Croce del Sud", "Kreuz des Südens", "Cruz del Sur"], Cyg: ["Cigno", "Schwan", "Cisne"], Del: ["Delfino", "Delphin", "Delfín"],
  Dor: ["Dorado", "Schwertfisch", "Dorado"], Dra: ["Drago", "Drache", "Dragón"], Equ: ["Cavallino", "Füllen", "Caballito"], Eri: ["Eridano", "Eridanus", "Erídano"],
  For: ["Fornace", "Chemischer Ofen", "Horno"], Gem: ["Gemelli", "Zwillinge", "Géminis"], Gru: ["Gru", "Kranich", "Grulla"], Her: ["Ercole", "Herkules", "Hércules"],
  Hor: ["Orologio", "Pendeluhr", "Reloj"], Hya: ["Idra", "Wasserschlange", "Hidra"], Hyi: ["Idra Maschio", "Kleine Wasserschlange", "Hidra Macho"],
  Ind: ["Indiano", "Inder", "Indio"], Lac: ["Lucertola", "Eidechse", "Lagarto"], Leo: ["Leone", "Löwe", "Leo"], LMi: ["Leone Minore", "Kleiner Löwe", "León Menor"],
  Lep: ["Lepre", "Hase", "Liebre"], Lib: ["Bilancia", "Waage", "Libra"], Lup: ["Lupo", "Wolf", "Lobo"], Lyn: ["Lince", "Luchs", "Lince"], Lyr: ["Lira", "Leier", "Lira"],
  Men: ["Mensa", "Tafelberg", "Mesa"], Mic: ["Microscopio", "Mikroskop", "Microscopio"], Mon: ["Unicorno", "Einhorn", "Unicornio"], Mus: ["Mosca", "Fliege", "Mosca"],
  Nor: ["Regolo", "Winkelmaß", "Escuadra"], Oct: ["Ottante", "Oktant", "Octante"], Oph: ["Ofiuco", "Schlangenträger", "Ofiuco"], Ori: ["Orione", "Orion", "Orión"],
  Pav: ["Pavone", "Pfau", "Pavo"], Peg: ["Pegaso", "Pegasus", "Pegaso"], Per: ["Perseo", "Perseus", "Perseo"], Phe: ["Fenice", "Phönix", "Fénix"],
  Pic: ["Pittore", "Maler", "Pintor"], Psc: ["Pesci", "Fische", "Piscis"], PsA: ["Pesce Australe", "Südlicher Fisch", "Pez Austral"],
  Pup: ["Poppa", "Achterdeck des Schiffs", "Popa"], Pyx: ["Bussola", "Schiffskompass", "Brújula"], Ret: ["Reticolo", "Netz", "Retículo"], Sge: ["Freccia", "Pfeil", "Flecha"],
  Sgr: ["Sagittario", "Schütze", "Sagitario"], Sco: ["Scorpione", "Skorpion", "Escorpio"], Scl: ["Scultore", "Bildhauer", "Escultor"], Sct: ["Scudo", "Schild", "Escudo"],
  Ser: ["Serpente", "Schlange", "Serpiente"], Sex: ["Sestante", "Sextant", "Sextante"], Tau: ["Toro", "Stier", "Tauro"], Tel: ["Telescopio", "Teleskop", "Telescopio"],
  Tri: ["Triangolo", "Dreieck", "Triángulo"], TrA: ["Triangolo Australe", "Südliches Dreieck", "Triángulo Austral"], Tuc: ["Tucano", "Tukan", "Tucán"],
  UMa: ["Orsa Maggiore", "Großer Bär", "Osa Mayor"], UMi: ["Orsa Minore", "Kleiner Bär", "Osa Menor"], Vel: ["Vele", "Segel des Schiffs", "Vela"],
  Vir: ["Vergine", "Jungfrau", "Virgo"], Vol: ["Pesce Volante", "Fliegender Fisch", "Pez Volador"], Vul: ["Volpetta", "Fuchs", "Zorra"],
};
const COSTELLAZIONI = Object.keys(NOMI_COSTELLAZIONI);
const COSTELLAZIONI_LATINO = {
  And: "Andromeda", Ant: "Antlia", Aps: "Apus", Aqr: "Aquarius", Aql: "Aquila", Ara: "Ara", Ari: "Aries", Aur: "Auriga", Boo: "Boötes", Cae: "Caelum",
  Cam: "Camelopardalis", Cnc: "Cancer", CVn: "Canes Venatici", CMa: "Canis Major", CMi: "Canis Minor", Cap: "Capricornus", Car: "Carina", Cas: "Cassiopeia",
  Cen: "Centaurus", Cep: "Cepheus", Cet: "Cetus", Cha: "Chamaeleon", Cir: "Circinus", Col: "Columba", Com: "Coma Berenices", CrA: "Corona Australis",
  CrB: "Corona Borealis", Crv: "Corvus", Crt: "Crater", Cru: "Crux", Cyg: "Cygnus", Del: "Delphinus", Dor: "Dorado", Dra: "Draco", Equ: "Equuleus",
  Eri: "Eridanus", For: "Fornax", Gem: "Gemini", Gru: "Grus", Her: "Hercules", Hor: "Horologium", Hya: "Hydra", Hyi: "Hydrus", Ind: "Indus", Lac: "Lacerta",
  Leo: "Leo", LMi: "Leo Minor", Lep: "Lepus", Lib: "Libra", Lup: "Lupus", Lyn: "Lynx", Lyr: "Lyra", Men: "Mensa", Mic: "Microscopium", Mon: "Monoceros",
  Mus: "Musca", Nor: "Norma", Oct: "Octans", Oph: "Ophiuchus", Ori: "Orion", Pav: "Pavo", Peg: "Pegasus", Per: "Perseus", Phe: "Phoenix", Pic: "Pictor",
  Psc: "Pisces", PsA: "Piscis Austrinus", Pup: "Puppis", Pyx: "Pyxis", Ret: "Reticulum", Sge: "Sagitta", Sgr: "Sagittarius", Sco: "Scorpius", Scl: "Sculptor",
  Sct: "Scutum", Ser: "Serpens", Sex: "Sextans", Tau: "Taurus", Tel: "Telescopium", Tri: "Triangulum", TrA: "Triangulum Australe", Tuc: "Tucana",
  UMa: "Ursa Major", UMi: "Ursa Minor", Vel: "Vela", Vir: "Virgo", Vol: "Volans", Vul: "Vulpecula",
};
function nomeCostellazione(c) {
  if (LINGUA === "en") return COSTELLAZIONI_LATINO[c] || c || "";
  const n = NOMI_COSTELLAZIONI[c];
  return n ? n[{ it: 0, de: 1, es: 2 }[LINGUA]] : c || "";
}
const RAD = Math.PI / 180, DEG = 180 / Math.PI;
const Astro = (() => {
  const n360 = x => ((x % 360) + 360) % 360;
  const sin = x => Math.sin(x * RAD), cos = x => Math.cos(x * RAD);
  const jd = d => d.getTime() / 86400000 + 2440587.5;
  const data = j => new Date(Math.round((j - 2440587.5) * 86400000));
  const secoli = j => (j - 2451545.0) / 36525;
  function gmst(j) {
    const T = secoli(j);
    return n360(280.46061837 + 360.98564736629 * (j - 2451545.0) + 0.000387933 * T * T - T * T * T / 38710000);
  }
  function obliquita(j) {
    const T = secoli(j);
    return 23.4392911 - (46.8150 * T + 0.00059 * T * T - 0.001813 * T * T * T) / 3600;
  }
  function precessa(ra, dec, j) {
    const T = secoli(j);
    const z = (2306.2181 * T + 1.09468 * T * T + 0.018203 * T * T * T) / 3600;
    const ze = (2306.2181 * T + 0.30188 * T * T + 0.017998 * T * T * T) / 3600;
    const th = (2004.3109 * T - 0.42665 * T * T - 0.041833 * T * T * T) / 3600;
    const A = cos(dec) * sin(ra + ze);
    const B = cos(th) * cos(dec) * cos(ra + ze) - sin(th) * sin(dec);
    const C = sin(th) * cos(dec) * cos(ra + ze) + cos(th) * sin(dec);
    let d = Math.asin(clamp(C, -1, 1)) * DEG;
    if (Math.abs(C) > 0.999) d = Math.sign(C) * Math.acos(Math.hypot(A, B)) * DEG;
    return [n360(Math.atan2(A, B) * DEG + z), d];
  }
  function altAz(ra, dec, lat, lst) {
    const H = lst - ra;
    const sa = sin(lat) * sin(dec) + cos(lat) * cos(dec) * cos(H);
    const alt = Math.asin(clamp(sa, -1, 1)) * DEG;
    const az = Math.atan2(-cos(dec) * sin(H), sin(dec) * cos(lat) - cos(dec) * sin(lat) * cos(H)) * DEG;
    return [alt, n360(az)];
  }
  function altezza(ra, dec, lat, lst) {
    return Math.asin(clamp(sin(lat) * sin(dec) + cos(lat) * cos(dec) * cos(lst - ra), -1, 1)) * DEG;
  }
  function rifrazione(h) {
    if (h < -1.5) return 0;
    return 1.02 / Math.tan((h + 10.3 / (h + 5.11)) * RAD) / 60;
  }
  function eclEq(lon, lat, eps) {
    const ra = Math.atan2(sin(lon) * cos(eps) - Math.tan(lat * RAD) * sin(eps), cos(lon)) * DEG;
    const dec = Math.asin(clamp(sin(lat) * cos(eps) + cos(lat) * sin(eps) * sin(lon), -1, 1)) * DEG;
    return [n360(ra), dec];
  }
  function separazione(ra1, d1, ra2, d2) {
    const c = sin(d1) * sin(d2) + cos(d1) * cos(d2) * cos(ra1 - ra2);
    return Math.acos(clamp(c, -1, 1)) * DEG;
  }
  function sole(j) {
    const T = secoli(j);
    const L0 = n360(280.46646 + 36000.76983 * T + 0.0003032 * T * T);
    const M = n360(357.52911 + 35999.05029 * T - 0.0001537 * T * T);
    const e = 0.016708634 - 0.000042037 * T;
    const C = (1.914602 - 0.004817 * T - 0.000014 * T * T) * sin(M) + (0.019993 - 0.000101 * T) * sin(2 * M) + 0.000289 * sin(3 * M);
    const v = M + C;
    const R = 1.000001018 * (1 - e * e) / (1 + e * cos(v));
    const om = 125.04 - 1934.136 * T;
    const lam = L0 + C - 0.00569 - 0.00478 * sin(om);
    const eps = obliquita(j) + 0.00256 * cos(om);
    const [ra, dec] = eclEq(lam, 0, eps);
    return { ra, dec, lon: n360(lam), dist: R };
  }
  const LUNA_LR = [
    [0, 0, 1, 0, 6288774, -20905355], [2, 0, -1, 0, 1274027, -3699111], [2, 0, 0, 0, 658314, -2955968],
    [0, 0, 2, 0, 213618, -569925], [0, 1, 0, 0, -185116, 48888], [0, 0, 0, 2, -114332, -3149],
    [2, 0, -2, 0, 58793, 246158], [2, -1, -1, 0, 57066, -152138], [2, 0, 1, 0, 53322, -170733],
    [2, -1, 0, 0, 45758, -204586], [0, 1, -1, 0, -40923, -129620], [1, 0, 0, 0, -34720, 108743],
    [0, 1, 1, 0, -30383, 104755], [2, 0, 0, -2, 15327, 10321], [0, 0, 1, 2, -12528, 0],
    [0, 0, 1, -2, 10980, 79661], [4, 0, -1, 0, 10675, -34782], [0, 0, 3, 0, 10034, -23210],
    [4, 0, -2, 0, 8548, -21636], [2, 1, -1, 0, -7888, 24208], [2, 1, 0, 0, -6766, 30824],
    [1, 0, -1, 0, -5163, -8379], [1, 1, 0, 0, 4987, -16675], [2, -1, 1, 0, 4036, -12831],
    [2, 0, 2, 0, 3994, -10445], [4, 0, 0, 0, 3861, -11650], [2, 0, -3, 0, 3665, 14403],
    [0, 1, -2, 0, -2689, -7003], [2, 0, -1, 2, -2602, 0], [2, -1, -2, 0, 2390, 10056],
    [1, 0, 1, 0, -2348, 6322], [2, -2, 0, 0, 2236, -9884], [0, 1, 2, 0, -2120, 5751],
    [0, 2, 0, 0, -2069, 0], [2, -2, -1, 0, 2048, -4950], [2, 0, 1, -2, -1773, 4130],
    [2, 0, 0, 2, -1595, 0], [4, -1, -1, 0, 1215, -3958], [0, 0, 2, 2, -1110, 0],
    [3, 0, -1, 0, -892, 3258], [2, 1, 1, 0, -810, 2616], [4, -1, -2, 0, 759, -1897],
    [0, 2, -1, 0, -713, -2117], [2, 2, -1, 0, -700, 2354], [2, 1, -2, 0, 691, 0],
    [2, -1, 0, -2, 596, 0], [4, 0, 1, 0, 549, -1423], [0, 0, 4, 0, 537, -1117],
    [4, -1, 0, 0, 520, -1571], [1, 0, -2, 0, -487, -1739], [2, 1, 0, -2, -399, 0],
    [0, 0, 2, -2, -381, -4421], [1, 1, 1, 0, 351, 0], [3, 0, -2, 0, -340, 0],
    [4, 0, -3, 0, 330, 0], [2, -1, 2, 0, 327, 0], [0, 2, 1, 0, -323, 1165],
    [1, 1, -1, 0, 299, 0], [2, 0, 3, 0, 294, 0], [2, 0, -1, -2, 0, 8752],
  ];
  const LUNA_B = [
    [0, 0, 0, 1, 5128122], [0, 0, 1, 1, 280602], [0, 0, 1, -1, 277693], [2, 0, 0, -1, 173237],
    [2, 0, -1, 1, 55413], [2, 0, -1, -1, 46271], [2, 0, 0, 1, 32573], [0, 0, 2, 1, 17198],
    [2, 0, 1, -1, 9266], [0, 0, 2, -1, 8822], [2, -1, 0, -1, 8216], [2, 0, -2, -1, 4324],
    [2, 0, 1, 1, 4200], [2, 1, 0, -1, -3359], [2, -1, -1, 1, 2463], [2, -1, 0, 1, 2211],
    [2, -1, -1, -1, 2065], [0, 1, -1, -1, -1870], [4, 0, -1, -1, 1828], [0, 1, 0, 1, -1794],
    [0, 0, 0, 3, -1749], [0, 1, -1, 1, -1565], [1, 0, 0, 1, -1491], [0, 1, 1, 1, -1475],
    [0, 1, 1, -1, -1410], [0, 1, 0, -1, -1344], [1, 0, 0, -1, -1335], [0, 0, 3, 1, 1107],
    [4, 0, 0, -1, 1021], [4, 0, -1, 1, 833], [0, 0, 1, -3, 777], [4, 0, -2, 1, 671],
    [2, 0, 0, -3, 607], [2, 0, 2, -1, 596], [2, -1, 1, -1, 491], [2, 0, -2, 1, -451],
    [0, 0, 3, -1, 439], [2, 0, 2, 1, 422], [2, 0, -3, -1, 421], [2, 1, -1, 1, -366],
    [2, 1, 0, 1, -351], [4, 0, 0, 1, 331], [2, -1, 1, 1, 315], [2, -2, 0, -1, 302],
    [0, 0, 1, 3, -283], [2, 1, 1, -1, -229], [1, 1, 0, -1, 223], [1, 1, 0, 1, 223],
  ];
  function luna(j) {
    const T = secoli(j);
    const Lp = n360(218.3164477 + 481267.88123421 * T - 0.0015786 * T * T + T * T * T / 538841 - T ** 4 / 65194000);
    const D = n360(297.8501921 + 445267.1114034 * T - 0.0018819 * T * T + T * T * T / 545868 - T ** 4 / 113065000);
    const M = n360(357.5291092 + 35999.0502909 * T - 0.0001536 * T * T + T * T * T / 24490000);
    const Mp = n360(134.9633964 + 477198.8675055 * T + 0.0087414 * T * T + T * T * T / 69699 - T ** 4 / 14712000);
    const F = n360(93.2720950 + 483202.0175233 * T - 0.0036539 * T * T - T * T * T / 3526000 + T ** 4 / 863310000);
    const A1 = n360(119.75 + 131.849 * T), A2 = n360(53.09 + 479264.290 * T), A3 = n360(313.45 + 481266.484 * T);
    const E = 1 - 0.002516 * T - 0.0000074 * T * T;
    let sl = 0, sr = 0, sb = 0;
    for (const [d, m, mp, f, cl, cr] of LUNA_LR) {
      const arg = d * D + m * M + mp * Mp + f * F;
      const fe = Math.abs(m) === 1 ? E : Math.abs(m) === 2 ? E * E : 1;
      sl += cl * fe * sin(arg);
      sr += cr * fe * cos(arg);
    }
    for (const [d, m, mp, f, cb] of LUNA_B) {
      const fe = Math.abs(m) === 1 ? E : Math.abs(m) === 2 ? E * E : 1;
      sb += cb * fe * sin(d * D + m * M + mp * Mp + f * F);
    }
    sl += 3958 * sin(A1) + 1962 * sin(Lp - F) + 318 * sin(A2);
    sb += -2235 * sin(Lp) + 382 * sin(A3) + 175 * sin(A1 - F) + 175 * sin(A1 + F) + 127 * sin(Lp - Mp) - 115 * sin(Lp + Mp);
    const om = 125.04452 - 1934.136261 * T;
    const dpsi = (-17.20 * sin(om) - 1.32 * sin(2 * (280.4665 + 36000.7698 * T)) - 0.23 * sin(2 * Lp) + 0.21 * sin(2 * om)) / 3600;
    const lon = n360(Lp + sl / 1e6 + dpsi), lat = sb / 1e6;
    const dist = 385000.56 + sr / 1000;
    const eps = obliquita(j) + 0.00256 * cos(om);
    const [ra, dec] = eclEq(lon, lat, eps);
    return { ra, dec, dist, par: Math.asin(6378.14 / dist) * DEG, lon, lat };
  }
  function faseLuna(j) {
    const s = sole(j), l = luna(j);
    const el = Math.acos(clamp(cos(l.lat) * cos(l.lon - s.lon), -1, 1)) * DEG;
    const R = s.dist * 149597870.7;
    const i = Math.atan2(R * sin(el), l.dist - R * cos(el)) * DEG;
    const diff = n360(l.lon - s.lon);
    return { k: (1 + cos(i)) / 2, crescente: diff < 180, eta: diff / 360 * 29.530589, diff };
  }
  function prossimaFase(j, obiettivo) {
    let t = j, d0 = n360(faseLuna(t).diff - obiettivo);
    for (let k = 0; k < 40; k++) {
      const t1 = t + 1, d1 = n360(faseLuna(t1).diff - obiettivo);
      if (d1 < d0) {
        let a = t, b = t1;
        for (let i = 0; i < 30; i++) {
          const c = (a + b) / 2, dc = n360(faseLuna(c).diff - obiettivo);
          if (dc > 180) a = c; else b = c;
        }
        return (a + b) / 2;
      }
      t = t1; d0 = d1;
    }
    return null;
  }
  const ELEM = {
    mercurio: [0.38709927, 0.20563593, 7.00497902, 252.25032350, 77.45779628, 48.33076593,
      0.00000037, 0.00001906, -0.00594749, 149472.67411175, 0.16047689, -0.12534081],
    venere: [0.72333566, 0.00677672, 3.39467605, 181.97909950, 131.60246718, 76.67984255,
      0.00000390, -0.00004107, -0.00078890, 58517.81538729, 0.00268329, -0.27769418],
    terra: [1.00000261, 0.01671123, -0.00001531, 100.46457166, 102.93768193, 0.0,
      0.00000562, -0.00004392, -0.01294668, 35999.37244981, 0.32327364, 0.0],
    marte: [1.52371034, 0.09339410, 1.84969142, -4.55343205, -23.94362959, 49.55953891,
      0.00001847, 0.00007882, -0.00813131, 19140.30268499, 0.44441088, -0.29257343],
    giove: [5.20288700, 0.04838624, 1.30439695, 34.39644051, 14.72847983, 100.47390909,
      -0.00011607, -0.00013253, -0.00183714, 3034.74612775, 0.21252668, 0.20469106],
    saturno: [9.53667594, 0.05386179, 2.48599187, 49.95424423, 92.59887831, 113.66242448,
      -0.00125060, -0.00050991, 0.00193609, 1222.49362201, -0.41897216, -0.28867794],
    urano: [19.18916464, 0.04725744, 0.77263783, 313.23810451, 170.95427630, 74.01692503,
      -0.00196176, -0.00004397, -0.00242939, 428.48202785, 0.40805281, 0.04240589],
    nettuno: [30.06992276, 0.00859048, 1.77004347, -55.12002969, 44.96476227, 131.78422574,
      0.00026291, 0.00005105, 0.00035372, 218.45945325, -0.32241464, -0.00508664],
  };
  const FISICA = {
    mercurio: [6.72, -0.42, 0.0380, -0.000273, 0.000002], venere: [16.82, -4.40, 0.0009, 0.000239, -0.00000065],
    marte: [9.36, -1.52, 0.016, 0, 0], giove: [196.88, -9.40, 0.005, 0, 0], saturno: [165.46, -8.88, 0.044, 0, 0],
    urano: [70.04, -7.19, 0, 0, 0], nettuno: [67.0, -6.87, 0, 0, 0],
  };
  function eliocentrico(nome, T) {
    const e0 = ELEM[nome];
    const a = e0[0] + e0[6] * T, e = e0[1] + e0[7] * T, I = e0[2] + e0[8] * T;
    const L = e0[3] + e0[9] * T, w = e0[4] + e0[10] * T, O = e0[5] + e0[11] * T;
    const om = w - O;
    let M = n360(L - w); if (M > 180) M -= 360;
    const ed = e * DEG;
    let E = M + ed * sin(M);
    for (let k = 0; k < 12; k++) {
      const dM = M - (E - ed * sin(E)), dE = dM / (1 - e * cos(E));
      E += dE;
      if (Math.abs(dE) < 1e-7) break;
    }
    const xp = a * (cos(E) - e), yp = a * Math.sqrt(1 - e * e) * sin(E);
    const x = (cos(om) * cos(O) - sin(om) * sin(O) * cos(I)) * xp + (-sin(om) * cos(O) - cos(om) * sin(O) * cos(I)) * yp;
    const y = (cos(om) * sin(O) + sin(om) * cos(O) * cos(I)) * xp + (-sin(om) * sin(O) + cos(om) * cos(O) * cos(I)) * yp;
    const z = (sin(om) * sin(I)) * xp + (cos(om) * sin(I)) * yp;
    return [x, y, z];
  }
  function pianeta(nome, j) {
    let T = secoli(j);
    const terra = eliocentrico("terra", T);
    let p = eliocentrico(nome, T), g, delta;
    for (let k = 0; k < 2; k++) {
      g = [p[0] - terra[0], p[1] - terra[1], p[2] - terra[2]];
      delta = Math.hypot(...g);
      p = eliocentrico(nome, T - delta * 0.0057755183 / 36525);
    }
    g = [p[0] - terra[0], p[1] - terra[1], p[2] - terra[2]];
    delta = Math.hypot(...g);
    const r = Math.hypot(...p), R = Math.hypot(...terra);
    const eps = 23.43928;
    const X = g[0], Y = g[1] * cos(eps) - g[2] * sin(eps), Z = g[1] * sin(eps) + g[2] * cos(eps);
    const ra0 = n360(Math.atan2(Y, X) * DEG), dec0 = Math.asin(Z / delta) * DEG;
    const [ra, dec] = precessa(ra0, dec0, j);
    const i = Math.acos(clamp((r * r + delta * delta - R * R) / (2 * r * delta), -1, 1)) * DEG;
    const f = FISICA[nome];
    let mag = f[1] + 5 * Math.log10(r * delta) + f[2] * i + f[3] * i * i + f[4] * i * i * i;
    if (nome === "saturno") {
      const sB = clamp(-sin(83.537) * sin(dec0) - cos(83.537) * cos(dec0) * cos(40.589 - ra0), -1, 1);
      mag += -2.60 * Math.abs(sB) + 1.25 * sB * sB;
    }
    return { ra, dec, r, delta, mag, diam: f[0] / delta, k: (1 + cos(i)) / 2 };
  }
  function altezzaLuna(l, lat, lst) {
    const h = altezza(l.ra, l.dec, lat, lst);
    return h - l.par * Math.cos(h * RAD);
  }
  function notte(giornoLocale, lat, lon, passo) {
    const p = passo || 5;
    const inizio = new Date(giornoLocale.getFullYear(), giornoLocale.getMonth(), giornoLocale.getDate(), 12, 0, 0);
    const j0 = jd(inizio), n = Math.round(24 * 60 / p) + 1;
    const tempi = new Float64Array(n), lst = new Float64Array(n), hSole = new Float64Array(n), hLuna = new Float64Array(n);
    const lune = [];
    for (let i = 0; i < n; i++) {
      const j = j0 + i * p / 1440;
      tempi[i] = j;
      lst[i] = n360(gmst(j) + lon);
      const s = sole(j);
      hSole[i] = altezza(s.ra, s.dec, lat, lst[i]);
      const l = luna(j);
      lune.push(l);
      hLuna[i] = altezzaLuna(l, lat, lst[i]);
    }
    const attraversa = (h, soglia, su) => {
      for (let i = 1; i < n; i++) {
        const a = h[i - 1] - soglia, b = h[i] - soglia;
        if (su ? (a < 0 && b >= 0) : (a >= 0 && b < 0)) {
          const f = a / (a - b);
          return data(tempi[i - 1] + f * (tempi[i] - tempi[i - 1]));
        }
      }
      return null;
    };
    const ev = {
      tramonto: attraversa(hSole, -0.833, false), alba: attraversa(hSole, -0.833, true),
      civileFine: attraversa(hSole, -6, false), civileInizio: attraversa(hSole, -6, true),
      nauticoFine: attraversa(hSole, -12, false), nauticoInizio: attraversa(hSole, -12, true),
      astroFine: attraversa(hSole, -18, false), astroInizio: attraversa(hSole, -18, true),
      lunaSorge: attraversa(hLuna, -0.833, true), lunaTramonta: attraversa(hLuna, -0.833, false),
    };
    let buio = [], tipoBuio = "astro";
    for (let i = 0; i < n; i++) if (hSole[i] <= -18) buio.push(i);
    if (!buio.length) { tipoBuio = "nautico"; for (let i = 0; i < n; i++) if (hSole[i] <= -12) buio.push(i); }
    if (!buio.length) { tipoBuio = "nessuno"; for (let i = 0; i < n; i++) if (hSole[i] <= -0.833) buio.push(i); }
    const mezzanotte = jd(new Date(inizio.getTime() + 12 * 3600e3));
    const fase = faseLuna(mezzanotte);
    const lm = luna(mezzanotte);
    return { j0, passo: p, n, tempi, lst, hSole, hLuna, lune, ev, buio, tipoBuio, fase, lunaMezzanotte: lm, lat, lon };
  }
  function curvaOggetto(nt, ra2000, dec2000) {
    const [ra, dec] = precessa(ra2000, dec2000, nt.tempi[Math.floor(nt.n / 2)]);
    const h = new Float32Array(nt.n);
    const sl = sin(nt.lat), cl = cos(nt.lat), sd = sin(dec), cd = cos(dec);
    for (let i = 0; i < nt.n; i++) h[i] = Math.asin(clamp(sl * sd + cl * cd * cos(nt.lst[i] - ra), -1, 1)) * DEG;
    return { h, ra, dec };
  }
  function eventiOggetto(nt, h, ra) {
    let sorge = null, tramonta = null, culm = null, hMax = -90;
    for (let i = 1; i < nt.n; i++) {
      if (h[i - 1] < 0 && h[i] >= 0 && !sorge) sorge = interp(nt, i, h, 0);
      if (h[i - 1] >= 0 && h[i] < 0 && !tramonta) tramonta = interp(nt, i, h, 0);
    }
    const lst0 = nt.lst[0];
    const dt = n360(ra - lst0) / 360.98564736629;
    const jc = nt.tempi[0] + dt;
    if (jc <= nt.tempi[nt.n - 1]) culm = data(jc);
    for (let i = 0; i < nt.n; i++) hMax = Math.max(hMax, h[i]);
    return { sorge, tramonta, culm, hMax };
  }
  function interp(nt, i, h, soglia) {
    const a = h[i - 1] - soglia, b = h[i] - soglia, f = a / (a - b);
    return data(nt.tempi[i - 1] + f * (nt.tempi[i] - nt.tempi[i - 1]));
  }
  return { jd, data, gmst, precessa, altAz, altezza, rifrazione, separazione, sole, luna, faseLuna, prossimaFase,
    pianeta, notte, curvaOggetto, eventiOggetto, altezzaLuna, n360, obliquita };
})();
const DATI = { oggetti: [], perId: new Map(), camere: [], perCamera: new Map(), telescopi: [], oculari: [], ottiche: [],
  software: [], pronto: false };
const TIPI_OGGETTO = ["gx", "gxg", "gxcl", "gxp", "oc", "sc", "gc", "pn", "en", "rn", "dn", "cn", "snr", "neb", "reg", "ds"];
function nomeOggetto(o) {
  return (o.nomi && (o.nomi[LINGUA] || o.nomi.en)) || "";
}
function titoloOggetto(o) {
  if (o.corpo) return nomeCorpo(o.corpo);
  const n = nomeOggetto(o);
  return n ? `${o.id} – ${n}` : o.id;
}
function gruppoOggetto(o) {
  return o.nomi && o.nomi.g ? (o.nomi.g[LINGUA] || o.nomi.g.en) : "";
}
function misuraOggetto(o) {
  if (o.a) return o.a;
  return { gx: 3, gc: 5, oc: 10, pn: 1, en: 15, rn: 10, dn: 20, snr: 20, ds: 1 }[o.t] || 10;
}
function caricaOggetti(j) {
  const nomi = j.n;
  DATI.oggetti = j.o.map(r => {
    const o = { id: r[0], alias: r[1] ? r[1].split("|") : [], ra: r[2], dec: r[3], t: j.tipi[r[4]], mag: r[5], a: r[6], b: r[7],
      pa: r[8], c: r[9], nomi: r[10] >= 0 ? nomi[r[10]] : null, top: !!r[11], zona: r[11] === 2, op: r[12] || null, soloCerca: r[13] === 1 };
    const estesa = s => SIGLE_ESTESE.flatMap(([re, estese]) => { const m = re.exec(s); return m ? estese.map(e => e + " " + m[1]) : []; });
    const sigle = [o.id, ...o.alias].flatMap(estesa);
    o.sigleId = estesa(o.id).map(norm);
    const n = o.nomi || {};
    const principali = [n[LINGUA], n.en, ...(LINGUA === "it" ? n.ait || [] : []), ...(LINGUA === "en" ? n.alt || [] : [])].filter(Boolean);
    const secondari = [...["it", "de", "es"].filter(k => k !== LINGUA).map(k => n[k]), ...(LINGUA === "en" ? [] : n.alt || []),
      ...(LINGUA === "it" ? [] : n.ait || []), n.g && (n.g[LINGUA] || n.g.en)].filter(Boolean);
    o.cerca = [o.id, ...o.alias].map(norm);
    o.cercaSigle = sigle.map(norm);
    o.cercaNomi = [...principali, ...secondari].map(norm);
    o.inizi1 = [...o.cerca, ...principali.flatMap(inizi)];
    o.inizi2 = secondari.flatMap(inizi);
    o.cercaParole = normParole([o.id, ...o.alias, ...sigle, ...principali, ...secondari].join(" "));
    o.messier = /^M\d+$/.test(o.id);
    o.caldwell = o.alias.some(a => /^C\d+$/.test(a)) || /^C\d+$/.test(o.id);
    return o;
  });
  for (const o of DATI.oggetti) {
    DATI.perId.set(norm(o.id), o);
    for (const a of o.alias) if (!DATI.perId.has(norm(a))) DATI.perId.set(norm(a), o);
  }
}
function trovaOggetto(id) {
  if (typeof id === "string" && id[0] === "@" && CORPI.includes(id.slice(1))) return corpoOggetto(id.slice(1));
  if (typeof id === "string" && id.startsWith("@cometa:")) return oggettoCometa(id.slice(8));
  return DATI.perId.get(norm(id)) || null;
}
const SIGLE_ESTESE = [[/^M(\d+)$/, ["Messier"]], [/^C(\d+)$/, ["Caldwell"]], [/^Sh2-(\d+)$/, ["Sharpless", "Sh"]],
  [/^B(\d+)$/, ["Barnard"]], [/^Cr (\d+)$/, ["Collinder"]], [/^Mel (\d+)$/, ["Melotte"]], [/^Tr (\d+)$/, ["Trumpler"]],
  [/^LDN (\d+)$/, ["Lynds", "L"]]];
function inizi(s) {
  const w = normParole(s).split(/[\s\-_.'’/()]+/).filter(Boolean);
  return w.map((_, i) => norm(w.slice(i).join("")));
}
function cercaOggetti(q, max) {
  const k = norm(q), p = normParole(q).trim();
  if (!k) return [];
  const livelli = [[], [], [], [], [], [], []];
  for (const o of DATI.oggetti) {
    const l = o.cerca[0] === k ? 0
      : o.sigleId.includes(k) ? 1
      : o.cerca.includes(k) || o.cercaSigle.includes(k) ? 2
      : o.cercaNomi.includes(k) ? 3
      : o.inizi1.some(c => c.startsWith(k)) || o.cercaSigle.some(c => c.startsWith(k)) ? 4
      : o.inizi2.some(c => c.startsWith(k)) ? 5
      : p.length >= 3 && o.cercaParole.includes(p) ? 6 : -1;
    if (l >= 0) livelli[l].push(o);
  }
  const peso = o => (o.top ? 0 : 2) + (o.messier ? 0 : 1) + (o.nomi ? 0 : 1);
  for (const l of livelli.slice(2)) l.sort((a, b) => peso(a) - peso(b) || (a.mag ?? 99) - (b.mag ?? 99));
  return [...cercaCorpi(q), ...livelli.flat()].slice(0, max || 30);
}
function siglaCercata(o, q) {
  const k = norm(q);
  if (!k || !o || !o.alias || !o.alias.length || !/\d/.test(k) || norm(o.id).startsWith(k)) return "";
  const estesa = a => SIGLE_ESTESE.flatMap(([re, estese]) => { const m = re.exec(a); return m ? estese.map(e => norm(e + " " + m[1])) : []; });
  return o.alias.find(a => norm(a) === k || estesa(a).includes(k)) || o.alias.find(a => norm(a).startsWith(k)) || "";
}
function titoloCercato(o, q) {
  const s = siglaCercata(o, q);
  if (!s) return titoloOggetto(o);
  const n = nomeOggetto(o);
  return `${o.id} · ${s}` + (n ? ` – ${n}` : "");
}
function caricaCamere(lista) {
  DATI.camere = lista.map(c => {
    c.nome = `${c.marca} ${c.modello}`;
    const alfa = c.marca === "Sony" && /^Alpha (.+)$/.exec(c.modello || ""), extra = alfa ? ` a${alfa[1]} α${alfa[1]}` : "";
    c.cerca = norm(c.nome + " " + (c.sensore || "") + " " + (c.alias || "") + extra);
    c.cercaParole = normParole(`${c.nome} ${c.sensore || ""} ${c.alias || ""}${extra}`);
    if (!c.mm && c.w && c.h && c.px) c.mm = [c.w * c.px / 1000, c.h * c.px / 1000];
    c.mp = c.w && c.h ? c.w * c.h / 1e6 : null;
    return c;
  });
  for (const c of DATI.camere) DATI.perCamera.set(c.id, c);
  const riallinea = cam => {
    const c = cam && cam.id && DATI.perCamera.get(cam.id);
    if (!c) return;
    if (c.h_negozio) cam.h_negozio = c.h_negozio; else delete cam.h_negozio;
  };
  if (typeof CAMPO !== "undefined") riallinea(CAMPO.cam);
  if (typeof SETUP_ELENCO !== "undefined") SETUP_ELENCO.forEach(s => riallinea(s.cam));
}
function cercaCamere(q, max) {
  const k = norm(q), p = normParole(q).trim().split(/\s+/).filter(Boolean);
  if (!k) return [];
  const ha = (c, w) => { const rc = reCifra(w); return rc ? rc.test(c.cercaParole) : c.cercaParole.includes(w) || (attaccato(w).length > 1 && (c._cercaA || (c._cercaA = attaccato(c.cercaParole))).includes(attaccato(w))); };
  let out = DATI.camere.filter(c => c.cerca.includes(k) || (p.length > 1 && p.every(w => ha(c, w))));
  if (!out.length && !RICERCA_ESATTA) out = cercaTollerante(DATI.camere, p, ha, 400);
  const reIntero = new Map(), intero = w => reIntero.get(w) || reIntero.set(w, new RegExp(reCifra(w).source + "(?!\\d)")).get(w);
  const intere = c => p.filter(w => /^\d+$/.test(w) ? intero(w).test(c.cercaParole) : parolaIntera(c.cercaParole, w)).length;
  const inPiu = c => c._parole || (c._parole = normParole(c.nome).split(/\s+/)), extra = c => inPiu(c).filter(w => !p.some(x => w.includes(x) || x.includes(w))).length;
  const negozio = (a, b) => (b.h_negozio ? 1 : 0) - (a.h_negozio ? 1 : 0) || (b.prod ? 1 : 0) - (a.prod ? 1 : 0) || a.nome.localeCompare(b.nome);
  out.sort(RICERCA_ESATTA ? negozio : (a, b) => intere(b) - intere(a) || extra(a) - extra(b) || negozio(a, b));
  return out.slice(0, max || 30);
}
let RICERCA_ESATTA = false;
const attaccato = s => s.replace(/(\d)[.,](?=\d)/g, "$1d").replace(/[^\p{L}\p{N}]+/gu, "");
const _reCifra = new Map();
const reCifra = w => {
  if (!_reCifra.has(w)) _reCifra.set(w, /^\d/.test(w) ? new RegExp("(^|[^\\d.,])" + w.split(/[.,]/).map(x => x.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
    .replace(/(\d)(?=[a-z])/g, "$1[\\s-]?")).join("[.,]").replace(/"$/, "(?:\"|''|”|″)")) : null);
  return _reCifra.get(w);
};
const _reSigla = new Map();
const reSigla = w => {
  if (!_reSigla.has(w)) _reSigla.set(w, /^[a-z][a-z0-9]{1,3}$/.test(w) && /\d/.test(w)
    ? new RegExp("(^|[^a-z0-9])" + w.split("").join("[\\s\\-_.]*")) : null);
  return _reSigla.get(w);
};
const parolaIntera = (s, w) => new RegExp("(^|[^\\p{L}\\p{N}])" + w.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") + "($|[^\\p{L}\\p{N}.,]|[.,][^\\p{N}]|[.,]$)", "u").test(s);
const PAROLE_CONTORNO = new Set(["pollici", "pollice", "inch", "inches", "zoll", "pulgadas", "mm", "cm", "con", "e", "il", "la", "lo", "le", "di", "da", "del",
  "un", "una", "the", "with", "and", "mit", "und", "y", "de", "el", "astro", "astronomica", "astronomico", "astronomia", "modificata", "modificato", "modded",
  "mod", "raffreddata", "raffreddato", "cooled", "camera", "fotocamera", "reflex", "mirrorless", "telescopio", "telescope", "teleskop", "tubo", "ota", "ottico",
  "obiettivo", "oculare", "eyepiece", "filtro", "filter", "riduttore", "spianatore", "nuovo", "nuova", "usato", "usata",
  "montatura", "montature", "mount", "montierung", "montura",
  "per", "for", "fur", "fuer", "para", "pour", "al", "alla", "allo", "della", "dello", "dei", "delle", "degli"]);
const eMisura = w => /^\d+([.,]\d+)?("|''|”|″|mm|cm|nm|°|x|×)$/.test(w) || /^f\/?\d+([.,]\d+)?$/.test(w) || /^\d+([.,]\d+)?\/\d+$/.test(w) ||
  /^\d+([.,]\d+)?[-–]\d+([.,]\d+)?(mm|cm|nm)$/.test(w);
function riattacca(p) {
  const parole = [];
  for (let i = 0; i < p.length; i++) {
    const w = p[i], u = p[i + 1] || "";
    if (/^\d+([.,]\d+)?$/.test(w) && /^(mm|cm|nm|°|gradi|grad|grados|degrees|pollici|pollice|inch|inches|zoll|pulgadas|")$/.test(u)) {
      parole.push(w + (/^(pollic|inch|zoll|pulgad|")/.test(u) ? "\"" : /^(°|grad|degree)/.test(u) ? "°" : u)); i++;
    } else parole.push(w);
  }
  return parole;
}
function cercaTollerante(elenco, p, ha, max) {
  if (p.length < 2) return [];
  const parole = riattacca(p);
  const forti = [], deboli = [];
  parole.forEach(w => (eMisura(w) || PAROLE_CONTORNO.has(w) || w.length < 2 ? deboli : forti).push(w));
  parole.forEach(w => { const m = /^(\d+(?:[.,]\d+)?)("|''|”|″)$/.exec(w); if (m) deboli.push(String(Math.round(parseFloat(m[1].replace(",", ".")) * 25.4))); });
  let obbligo = forti.filter(w => elenco.some(x => ha(x, w)));
  if (!obbligo.length) obbligo = parole.filter(w => eMisura(w) && elenco.some(x => ha(x, w)));
  if (!obbligo.length || obbligo.length === parole.length) return [];
  if (forti.some(w => !obbligo.includes(w) && (w.match(/\d/g) || []).length >= 2 && !/(mm|cm|nm|°|x|×|"|''|”|″|gradi|grad|grados|degrees)$/.test(w))) return [];
  const testo = x => x._cerca || x.cercaParole || "";
  const punti = x => deboli.filter(w => {
    const fr = /^f\/?(\d+(?:[.,]\d+)?)$/.exec(w);
    if (fr && x.D > 0 && x.F > 0) return Math.abs(x.F / x.D - parseFloat(fr[1].replace(",", "."))) < 0.35;
    const mi = /^(\d+(?:[.,]\d+)?)(mm|cm)$/.exec(w);
    if (mi && x.D > 0 && x.tipo !== "obiettivo") {
      const v = parseFloat(mi[1].replace(",", ".")) * (mi[2] === "cm" ? 10 : 1);
      if (Math.abs(x.D - v) <= Math.max(2, v * 0.02)) return true;
    }
    return parolaIntera(testo(x), w);
  }).length;
  return elenco.filter(x => obbligo.every(w => ha(x, w))).map((x, i) => [x, punti(x), i])
    .sort((a, b) => b[1] - a[1] || a[2] - b[2]).slice(0, max || 30).map(a => a[0]);
}
function cercaInElenco(elenco, q, max, testo) {
  const p0 = normParole(q).trim().split(/\s+/).filter(Boolean);
  if (!p0.length) return [];
  const p = riattacca(p0);
  const pa = p.map(attaccato), pc = p.map(reCifra), ps = p.map(reSigla), tutto = attaccato(p0.join(""));
  const out = [];
  for (const x of elenco) {
    const s = x._cerca || (x._cerca = normParole(testo(x))), sa = x._cercaA || (x._cercaA = attaccato(s));
    if (p.every((w, i) => pc[i] ? pc[i].test(s) : ps[i] ? ps[i].test(s) : s.includes(w) || (pa[i] && sa.includes(pa[i]))) || (/^\p{L}/u.test(tutto) && tutto.length >= 5 && sa.includes(tutto))) out.push(x);
    if (out.length >= (max || 30)) break;
  }
  return out;
}
function cercaInElencoTollerante(elenco, q, max, testo) {
  if (RICERCA_ESATTA) return [];
  const p = normParole(q).trim().split(/\s+/).filter(Boolean);
  const ha = (x, w) => {
    const s = x._cerca || (x._cerca = normParole(testo(x))), sa = x._cercaA || (x._cercaA = attaccato(s)), a = attaccato(w);
    const rc = reCifra(w), rs = reSigla(w);
    return rc ? rc.test(s) : rs ? rs.test(s) : s.includes(w) || (!!a && sa.includes(a));
  };
  return cercaTollerante(elenco, p, ha, max);
}
async function caricaDati() {
  const url = k => RADICE.dataset[k];
  const prendi = async k => {
    const r = await fetch(url(k), { credentials: "omit" });
    if (!r.ok) throw new Error(k + " " + r.status);
    return r.json();
  };
  const [ogg, cam, neg, sw] = await Promise.all([prendi("oggetti"), prendi("camere"), prendi("negozio"), prendi("software")]);
  caricaOggetti(ogg);
  caricaCamere(cam.camere || cam);
  DATI.telescopi = neg.telescopi || [];
  DATI.oculari = neg.oculari || [];
  DATI.ottiche = neg.ottiche || [];
  DATI.filtri = neg.filtri || [];
  DATI.montature = neg.montature || [];
  DATI.camerePrezzi = neg.camere_prezzi || {};
  DATI.fotoObiettivi = neg.foto_obiettivi || {};
  DATI.noti = Object.assign({ oculari: [], telescopi: [], obiettivi: [], ottiche: [], filtri: [], montature: [] }, neg.noti || {});
  DATI.software = sw.software || sw;
  DATI.pronto = true;
}
const _prezzi = new Map();
function prodotto(handle) {
  if (!handle) return Promise.resolve(null);
  if (!_prezzi.has(handle)) {
    _prezzi.set(handle, fetch(`${RADICE_URL.replace(/\/?$/, "/")}products/${handle}.js`)
      .then(r => r.ok ? r.json() : r.status === 404 ? false : null).catch(() => null)
      .then(p => { if (p === null) _prezzi.delete(handle); return p; }));
  }
  return _prezzi.get(handle);
}
function inNegozio(handle) {
  if (!handle) return false;
  return [DATI.telescopi, DATI.oculari, DATI.ottiche, DATI.filtri, DATI.montature].some(l => (l || []).some(x => x.h === handle)) ||
    (DATI.camere || []).some(c => c.h_negozio === handle);
}
function urlProdotto(handle) { return `${RADICE_URL.replace(/\/?$/, "/")}products/${handle}`; }
function euro(cent) {
  const valuta = (window.Shopify && Shopify.currency && Shopify.currency.active) || "EUR";
  return new Intl.NumberFormat(LOCALE, { style: "currency", currency: valuta }).format(cent / 100);
}
const CITTA = [
  ["Bitonto", 41.11, 16.69], ["Bari", 41.12, 16.87], ["Molfetta", 41.20, 16.60], ["Altamura", 40.83, 16.55], ["Andria", 41.23, 16.29],
  ["Barletta", 41.32, 16.28], ["Trani", 41.28, 16.42], ["Monopoli", 40.95, 17.30], ["Brindisi", 40.63, 17.94], ["Lecce", 40.35, 18.17],
  ["Taranto", 40.47, 17.24], ["Foggia", 41.46, 15.55], ["Matera", 40.67, 16.60], ["Potenza", 40.64, 15.80], ["Roma", 41.90, 12.50],
  ["Noci", 40.79, 17.13], ["Putignano", 40.85, 17.12], ["Alberobello", 40.78, 17.24], ["Castellana Grotte", 40.89, 17.17],
  ["Gioia del Colle", 40.80, 16.92], ["Conversano", 40.97, 17.12], ["Turi", 40.92, 17.02], ["Locorotondo", 40.76, 17.33],
  ["Martina Franca", 40.71, 17.34], ["Polignano a Mare", 41.00, 17.22], ["Mola di Bari", 41.06, 17.09], ["Fasano", 40.84, 17.36],
  ["Ostuni", 40.73, 17.58], ["Cisternino", 40.74, 17.42], ["Ceglie Messapica", 40.65, 17.52], ["Gravina in Puglia", 40.82, 16.42],
  ["Santeramo in Colle", 40.79, 16.76], ["Acquaviva delle Fonti", 40.90, 16.84], ["Casamassima", 40.95, 16.92], ["Sammichele di Bari", 40.89, 16.95],
  ["Rutigliano", 41.01, 17.01], ["Noicattaro", 41.03, 16.99], ["Triggiano", 41.07, 16.92], ["Capurso", 41.05, 16.92], ["Valenzano", 41.04, 16.89],
  ["Adelfia", 41.00, 16.87], ["Cassano delle Murge", 40.89, 16.77], ["Grumo Appula", 41.01, 16.71], ["Toritto", 41.00, 16.68],
  ["Palo del Colle", 41.06, 16.70], ["Bitetto", 41.04, 16.75], ["Modugno", 41.08, 16.78], ["Giovinazzo", 41.19, 16.67], ["Terlizzi", 41.13, 16.54],
  ["Ruvo di Puglia", 41.12, 16.49], ["Corato", 41.15, 16.41], ["Bisceglie", 41.24, 16.50], ["Canosa di Puglia", 41.22, 16.07],
  ["Minervino Murge", 41.09, 16.08], ["Spinazzola", 40.97, 16.09], ["Margherita di Savoia", 41.37, 16.15], ["Cerignola", 41.27, 15.89],
  ["San Severo", 41.69, 15.38], ["Lucera", 41.51, 15.34], ["Manfredonia", 41.63, 15.91], ["San Giovanni Rotondo", 41.71, 15.73],
  ["Monte Sant'Angelo", 41.71, 15.96], ["Vieste", 41.88, 16.18], ["Peschici", 41.95, 16.02], ["Grottaglie", 40.54, 17.44],
  ["Massafra", 40.59, 17.11], ["Castellaneta", 40.63, 16.94], ["Mottola", 40.64, 17.04], ["Laterza", 40.63, 16.80], ["Ginosa", 40.58, 16.76],
  ["Manduria", 40.40, 17.63], ["Francavilla Fontana", 40.53, 17.59], ["Mesagne", 40.56, 17.81], ["San Vito dei Normanni", 40.66, 17.71],
  ["Carovigno", 40.71, 17.66], ["Gallipoli", 40.06, 17.99], ["Otranto", 40.14, 18.49], ["Nardò", 40.18, 18.03], ["Galatina", 40.17, 18.17],
  ["Maglie", 40.12, 18.30], ["Tricase", 39.93, 18.36], ["Santa Maria di Leuca", 39.80, 18.36], ["Pisticci", 40.39, 16.56], ["Policoro", 40.21, 16.68],
  ["Metaponto", 40.37, 16.82], ["Montescaglioso", 40.55, 16.67], ["Irsina", 40.75, 16.24],
  ["Milano", 45.46, 9.19], ["Napoli", 40.85, 14.27], ["Torino", 45.07, 7.69], ["Palermo", 38.12, 13.36], ["Genova", 44.41, 8.93],
  ["Bologna", 44.49, 11.34], ["Firenze", 43.77, 11.25], ["Catania", 37.50, 15.09], ["Venezia", 45.44, 12.33], ["Verona", 45.44, 10.99],
  ["Messina", 38.19, 15.55], ["Padova", 45.41, 11.88], ["Trieste", 45.65, 13.78], ["Brescia", 45.54, 10.22], ["Parma", 44.80, 10.33],
  ["Prato", 43.88, 11.10], ["Modena", 44.65, 10.93], ["Reggio Calabria", 38.11, 15.65], ["Reggio Emilia", 44.70, 10.63],
  ["Perugia", 43.11, 12.39], ["Ravenna", 44.42, 12.20], ["Livorno", 43.55, 10.31], ["Cagliari", 39.22, 9.11], ["Rimini", 44.06, 12.57],
  ["Salerno", 40.68, 14.77], ["Ferrara", 44.84, 11.62], ["Sassari", 40.73, 8.56], ["Latina", 41.47, 12.90], ["Monza", 45.58, 9.27],
  ["Siracusa", 37.08, 15.29], ["Pescara", 42.46, 14.21], ["Bergamo", 45.70, 9.67], ["Forlì", 44.22, 12.04], ["Trento", 46.07, 11.12],
  ["Vicenza", 45.55, 11.55], ["Terni", 42.56, 12.65], ["Bolzano", 46.50, 11.35], ["Novara", 45.45, 8.62], ["Piacenza", 45.05, 9.69],
  ["Ancona", 43.62, 13.52], ["Arezzo", 43.46, 11.88], ["Udine", 46.06, 13.24], ["Cesena", 44.14, 12.24], ["Pesaro", 43.91, 12.91],
  ["La Spezia", 44.10, 9.82], ["Alessandria", 44.91, 8.61], ["Pisa", 43.72, 10.40], ["Pistoia", 43.93, 10.91], ["Lucca", 43.84, 10.50],
  ["Como", 45.81, 9.08], ["Treviso", 45.67, 12.24], ["Catanzaro", 38.91, 16.59], ["Varese", 45.82, 8.83], ["Cosenza", 39.30, 16.25],
  ["Campobasso", 41.56, 14.66], ["L'Aquila", 42.35, 13.40], ["Aosta", 45.74, 7.32], ["Avellino", 40.91, 14.79], ["Benevento", 41.13, 14.78],
  ["Caserta", 41.07, 14.33], ["Frosinone", 41.64, 13.35], ["Viterbo", 42.42, 12.11], ["Rieti", 42.40, 12.86], ["Teramo", 42.66, 13.70],
  ["Chieti", 42.35, 14.17], ["Isernia", 41.59, 14.23], ["Crotone", 39.08, 17.13], ["Vibo Valentia", 38.68, 16.10], ["Trapani", 38.02, 12.51],
  ["Agrigento", 37.31, 13.58], ["Caltanissetta", 37.49, 14.06], ["Enna", 37.57, 14.28], ["Ragusa", 36.93, 14.73], ["Nuoro", 40.32, 9.33],
  ["Oristano", 39.90, 8.59], ["Olbia", 40.92, 9.50], ["Grosseto", 42.76, 11.11], ["Siena", 43.32, 11.33], ["Macerata", 43.30, 13.45],
  ["Ascoli Piceno", 42.85, 13.58], ["Belluno", 46.14, 12.22], ["Rovigo", 45.07, 11.79], ["Pordenone", 45.96, 12.66], ["Gorizia", 45.94, 13.62],
  ["Sondrio", 46.17, 9.87], ["Lecco", 45.86, 9.40], ["Cremona", 45.13, 10.02], ["Mantova", 45.16, 10.79], ["Pavia", 45.19, 9.16],
  ["Cuneo", 44.39, 7.55], ["Asti", 44.90, 8.21], ["Savona", 44.31, 8.48], ["Imperia", 43.89, 8.03], ["Massa", 44.04, 10.14],
  ["Asiago", 45.88, 11.51], ["Campo Imperatore", 42.44, 13.56], ["Saint-Barthélemy", 45.86, 7.47],
  ["Berlin", 52.52, 13.40], ["Hamburg", 53.55, 9.99], ["München", 48.14, 11.58], ["Köln", 50.94, 6.96], ["Frankfurt am Main", 50.11, 8.68],
  ["Stuttgart", 48.78, 9.18], ["Düsseldorf", 51.23, 6.78], ["Leipzig", 51.34, 12.37], ["Dortmund", 51.51, 7.47], ["Essen", 51.46, 7.01],
  ["Bremen", 53.08, 8.80], ["Dresden", 51.05, 13.74], ["Hannover", 52.38, 9.73], ["Nürnberg", 49.45, 11.08], ["Bonn", 50.74, 7.10],
  ["Münster", 51.96, 7.63], ["Mannheim", 49.49, 8.47], ["Karlsruhe", 49.01, 8.40], ["Augsburg", 48.37, 10.90], ["Wiesbaden", 50.08, 8.24],
  ["Freiburg im Breisgau", 47.99, 7.85], ["Kiel", 54.32, 10.12], ["Rostock", 54.09, 12.10], ["Erfurt", 50.98, 11.03], ["Mainz", 50.00, 8.27],
  ["Saarbrücken", 49.24, 6.99], ["Magdeburg", 52.13, 11.63], ["Potsdam", 52.39, 13.06], ["Regensburg", 49.01, 12.10], ["Würzburg", 49.79, 9.95],
  ["Wien", 48.21, 16.37], ["Graz", 47.07, 15.44], ["Linz", 48.31, 14.29], ["Salzburg", 47.81, 13.06], ["Innsbruck", 47.27, 11.39],
  ["Zürich", 47.38, 8.54], ["Bern", 46.95, 7.45], ["Basel", 47.56, 7.59], ["Genève", 46.20, 6.14], ["Lugano", 46.00, 8.95],
  ["Madrid", 40.42, -3.70], ["Barcelona", 41.39, 2.17], ["Valencia", 39.47, -0.38], ["Sevilla", 37.39, -5.99], ["Zaragoza", 41.65, -0.89],
  ["Málaga", 36.72, -4.42], ["Murcia", 37.99, -1.13], ["Palma", 39.57, 2.65], ["Las Palmas de Gran Canaria", 28.12, -15.43],
  ["Bilbao", 43.26, -2.93], ["Alicante", 38.35, -0.48], ["Córdoba", 37.89, -4.78], ["Valladolid", 41.65, -4.72], ["Vigo", 42.24, -8.72],
  ["Gijón", 43.53, -5.66], ["A Coruña", 43.36, -8.41], ["Granada", 37.18, -3.60], ["Vitoria-Gasteiz", 42.85, -2.67], ["Oviedo", 43.36, -5.85],
  ["Santa Cruz de Tenerife", 28.46, -16.25], ["Pamplona", 42.81, -1.64], ["Almería", 36.84, -2.46], ["San Sebastián", 43.32, -1.98],
  ["Santander", 43.46, -3.81], ["Burgos", 42.34, -3.70], ["Salamanca", 40.97, -5.66], ["Logroño", 42.47, -2.45], ["Badajoz", 38.88, -6.97],
  ["Huelva", 37.26, -6.95], ["Cádiz", 36.53, -6.29], ["León", 42.60, -5.57], ["Tarragona", 41.12, 1.25], ["Lleida", 41.62, 0.63],
  ["Girona", 41.98, 2.82], ["Toledo", 39.86, -4.03], ["Cáceres", 39.48, -6.37], ["Albacete", 38.99, -1.86], ["Castellón", 39.99, -0.05],
  ["Jaén", 37.78, -3.79], ["Teruel", 40.34, -1.11], ["Cuenca", 40.07, -2.13], ["Calar Alto", 37.22, -2.55], ["Roque de los Muchachos", 28.76, -17.89],
  ["Teide", 28.30, -16.51],
];
const LUOGO_PREDEFINITO = { it: ["Bitonto", 41.12, 16.68], de: ["Frankfurt am Main", 50.11, 8.68], es: ["Madrid", 40.42, -3.70], en: ["London", 51.51, -0.13] }[LINGUA];
Object.assign(TESTI.it, { att_non_qui: "Non è tra questi? Inseriscilo a mano ↓" });
Object.assign(TESTI.de, { att_non_qui: "Nicht dabei? Von Hand eingeben ↓" });
Object.assign(TESTI.es, { att_non_qui: "¿No está entre estos? Introdúcelo a mano ↓" });
Object.assign(TESTI.en, { att_non_qui: "Not among these? Enter it manually ↓" });
function creaCerca(opts) {
  const input = el("input", { type: "search", class: "gas-input", placeholder: opts.segnaposto || t("cerca"),
    autocomplete: "off", spellcheck: "false", "aria-autocomplete": "list", "aria-expanded": "false" });
  const lista = el("ul", { class: "gas-sugg", role: "listbox", hidden: true });
  const box = el("div", { class: "gas-cerca" }, input, lista);
  let voci = [], attiva = -1;
  const chiudi = () => { lista.hidden = true; input.setAttribute("aria-expanded", "false"); attiva = -1; };
  const evidenzia = i => {
    attiva = i;
    $$("li", lista).forEach((li, k) => li.classList.toggle("on", k === i));
    const li = lista.children[i];
    if (li && li.scrollIntoView) li.scrollIntoView({ block: "nearest" });
  };
  const scegli = x => { chiudi(); opts.scegli(x); };
  const mostra = () => {
    const q = input.value.trim();
    const r = q ? opts.cerca(q) : (opts.iniziali ? opts.iniziali() : []);
    if (r && typeof r.then === "function") {
      r.then(v => { if (input.value.trim() === q) disegnaVoci(q, v); }).catch(() => { if (input.value.trim() === q) disegnaVoci(q, []); });
      return;
    }
    disegnaVoci(q, r);
  };
  const disegnaVoci = (q, risultato) => {
    const poche = risultato && risultato.poche;
    voci = Array.isArray(risultato) ? risultato : (risultato && risultato.voci) || [];
    svuota(lista);
    if (!voci.length) {
      if (q && !poche && opts.senza) {
        opts.senza.apri(q);
        lista.appendChild(el("li", { class: "gas-sugg-vuoto gas-sugg-mano", onmousedown: e => { e.preventDefault(); chiudi(); opts.senza.tocca(q); } },
          opts.senza.testo));
      } else if (q) lista.appendChild(el("li", { class: "gas-sugg-vuoto" }, poche ? t("scrivi_altre") : (opts.vuoto || t("nessun_risultato"))));
      else { chiudi(); return; }
    }
    voci.forEach((x, i) => {
      const r = opts.riga(x, q);
      lista.appendChild(el("li", { role: "option", onmousedown: e => { e.preventDefault(); scegli(x); },
        onmousemove: () => attiva !== i && evidenzia(i) },
      r.foto ? el("img", { src: r.foto, alt: "", loading: "lazy", width: 36, height: 36 }) : null,
      el("span", { class: "gas-sugg-testo" }, el("b", null, r.titolo), r.sotto ? el("small", null, r.sotto) : null),
      r.extra ? el("em", null, r.extra) : null));
    });
    if (q && voci.length && opts.senza) lista.appendChild(el("li", { class: "gas-sugg-vuoto gas-sugg-mano",
      onmousedown: e => { e.preventDefault(); chiudi(); opts.senza.apri(q); opts.senza.tocca(q); } }, opts.senza.altro || t("att_non_qui")));
    lista.hidden = false;
    input.setAttribute("aria-expanded", "true");
    attiva = -1;
  };
  input.addEventListener("input", debounce(mostra, 80));
  input.addEventListener("focus", () => { if (input.value.trim() || opts.iniziali) mostra(); });
  input.addEventListener("blur", () => setTimeout(chiudi, 150));
  input.addEventListener("keydown", e => {
    if (lista.hidden && (e.key === "ArrowDown")) { mostra(); return; }
    if (e.key === "ArrowDown") { e.preventDefault(); evidenzia(Math.min(voci.length - 1, attiva + 1)); }
    else if (e.key === "ArrowUp") { e.preventDefault(); evidenzia(Math.max(0, attiva - 1)); }
    else if (e.key === "Enter") { if (voci.length) { e.preventDefault(); scegli(voci[attiva >= 0 ? attiva : 0]); } }
    else if (e.key === "Escape") chiudi();
  });
  return { box, input, imposta: s => { input.value = s || ""; }, chiudi };
}
function selezione(voci, valore, cambia, attr) {
  const s = el("select", Object.assign({ class: "gas-input" }, attr || {}),
    voci.map(([v, e]) => el("option", { value: String(v), selected: String(v) === String(valore) }, e)));
  s.addEventListener("change", () => cambia(s.value));
  return s;
}
function campoNumero(etichetta, valore, cambia, o) {
  o = o || {};
  const inp = el("input", { type: "number", class: "gas-input", inputmode: "decimal", step: o.passo || "any",
    min: o.min, max: o.max, value: valore == null ? "" : valore, placeholder: o.segnaposto || "" });
  inp.addEventListener("input", () => {
    const v = parseFloat(String(inp.value).replace(",", "."));
    cambia(isFinite(v) ? v : null);
  });
  return el("label", { class: "gas-campo" + (o.class ? " " + o.class : "") }, el("span", null, etichetta),
    o.unita ? el("span", { class: "gas-unita" }, inp, el("i", null, o.unita)) : inp);
}
function etichetta(testo, ...figli) {
  return el("label", { class: "gas-campo" }, el("span", null, testo), ...figli);
}
function scheda(titolo, ...figli) {
  return el("section", { class: "gas-card" }, titolo ? el("h3", null, titolo) : null, ...figli);
}
function riga(etichettaTesto, valore, nota, classe) {
  return el("div", { class: "gas-riga" + (classe ? " " + classe : "") },
    el("span", { class: "gas-riga-e" }, etichettaTesto),
    el("span", { class: "gas-riga-v" }, valore),
    nota ? el("small", { class: "gas-riga-n" }, nota) : null);
}
function badge(testo, tipo) { return el("span", { class: "gas-badge" + (tipo ? " gas-badge--" + tipo : "") }, testo); }
function boxProdotto(handle, titolo, foto, nota) {
  const prezzo = el("span", { class: "gas-prod-prezzo" }, "");
  const nome = el("b", null, titolo);
  const box = el("a", { class: "gas-prod", href: urlProdotto(handle), target: "_blank", rel: "noopener" },
    foto ? el("img", { src: foto, alt: "", loading: "lazy", width: 56, height: 56 }) : null,
    el("span", { class: "gas-prod-testo" }, el("small", null, nota || t("nel_negozio")), nome, prezzo),
    el("span", { class: "gas-prod-vai" }, t("vedi_prodotto"), " →"));
  prodotto(handle).then(p => {
    if (p === false) { box.style.display = "none"; return; }
    if (!p) return;
    if (p.title) nome.textContent = p.title;
    if (!foto && p.featured_image) box.prepend(el("img", { src: p.featured_image + (p.featured_image.includes("?") ? "&" : "?") + "width=120", alt: "", loading: "lazy", width: 56, height: 56 }));
    const prezzi = (p.variants || []).map(v => v.price).filter(x => x != null);
    const min = prezzi.length ? Math.min(...prezzi) : p.price;
    prezzo.textContent = (prezzi.length > 1 && Math.max(...prezzi) > min ? t("da") + " " : "") + euro(min) +
      (p.available ? "" : " · " + t("non_disponibile"));
  });
  return box;
}
Object.assign(TESTI.it, { copiato_testo: "Copiato!", copia_mano: "Tieni premuto sul testo qui sotto e scegli «Copia»." });
Object.assign(TESTI.de, { copiato_testo: "Kopiert!", copia_mano: "Halten Sie den Text unten gedrückt und wählen Sie „Kopieren“." });
Object.assign(TESTI.es, { copiato_testo: "¡Copiado!", copia_mano: "Mantén pulsado el texto de abajo y elige «Copiar»." });
Object.assign(TESTI.en, { copiato_testo: "Copied!", copia_mano: "Press and hold the text below, then choose “Copy”." });
function copia(testo, bottone) {
  const fatto = () => {
    if (!bottone) return;
    if (bottone._copiato) clearTimeout(bottone._copiato);
    else bottone._prima = [...bottone.childNodes];
    const soloIcona = !bottone.textContent.trim();
    svuota(bottone).append(soloIcona ? "✓" : t(/^https?:\/\//.test(testo) ? "copiato" : "copiato_testo"));
    bottone.classList.add("gas-copiato");
    bottone._copiato = setTimeout(() => { svuota(bottone).append(...bottone._prima); bottone.classList.remove("gas-copiato"); bottone._copiato = null; }, 1600);
  };
  const ripiego = () => { if (copiaVecchia(testo)) fatto(); else daCopiareAMano(testo, bottone); };
  if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(testo).then(fatto, ripiego);
  else ripiego();
}
function copiaVecchia(testo) {
  const ta = el("textarea", { readonly: true, "aria-hidden": "true", style: { position: "fixed", top: "0", left: "-9999px", fontSize: "12pt" } });
  const prima = document.activeElement;
  ta.value = testo;
  document.body.appendChild(ta);
  let ok = false;
  try { ta.select(); ta.setSelectionRange(0, testo.length); ok = document.execCommand("copy"); } catch (e) { ok = false; }
  ta.remove();
  if (prima && prima.focus) try { prima.focus({ preventScroll: true }); } catch (e) {   }
  return ok;
}
function daCopiareAMano(testo, bottone) {
  if (!bottone || !bottone.isConnected) return;
  const dopo = bottone.closest(".gas-riga-bottoni, .gas-cielo-barra") || bottone;
  const vecchia = dopo.nextElementSibling;
  if (vecchia && vecchia.classList.contains("gas-copia-mano")) vecchia.remove();
  const casella = el("textarea", { class: "gas-input", readonly: true, rows: Math.min(6, testo.split("\n").length + 1), "aria-label": t("copia_mano") });
  casella.value = testo;
  dopo.after(el("div", { class: "gas-copia-mano" }, el("p", { class: "gas-nota" }, t("copia_mano")), casella));
  try { casella.focus({ preventScroll: true }); casella.select(); casella.setSelectionRange(0, testo.length); } catch (e) {   }
}
let CDS_GIU = +ricorda("cds_giu", 0) || 0;
const cdsGiu = () => Date.now() - CDS_GIU < 1800000;
function segnaCdsGiu() { CDS_GIU = Date.now(); salva("cds_giu", CDS_GIU); }
function urlCielo(ra, dec, fov, w, h, riserva) {
  const base = riserva ? "https://alaskybis.cds.unistra.fr" : "https://alasky.cds.unistra.fr";
  return `${base}/hips-image-services/hips2fits?hips=${encodeURIComponent("CDS/P/DSS2/color")}&width=${Math.round(w)}&height=${Math.round(h)}` +
    `&fov=${fov.toFixed(4)}&projection=TAN&coordsys=icrs&ra=${ra.toFixed(5)}&dec=${dec.toFixed(5)}&format=jpg`;
}
const TELE_TASSELLI = [];
function telaTasselli(classe, g, pronto, errore) {
  for (let i = TELE_TASSELLI.length - 1; i >= 0; i--) {
    if (TELE_TASSELLI[i].isConnected || performance.now() - TELE_TASSELLI[i]._nata < 3000) continue;
    try { const gl = TELE_TASSELLI[i].getContext("webgl"), x = gl && gl.getExtension("WEBGL_lose_context"); if (x) x.loseContext(); } catch (e) {   }
    TELE_TASSELLI.splice(i, 1);
  }
  if (typeof Hips === "undefined") return null;
  const tela = el("canvas", { class: classe, "aria-hidden": "true" });
  tela._nata = performance.now();
  let primo = true;
  const v = Hips.crea(tela, { pronto: () => { if (primo && pronto) { primo = false; pronto(); } }, errore: () => { if (errore) errore(tela); } });
  if (!v) return null;
  TELE_TASSELLI.push(tela);
  v.disegna(Object.assign({ cdelt: g.fov / g.W }, g), ["dss"]);
  return tela;
}
function fotoDaTasselli(img, g, pronto, altrimenti) {
  if (!img || !img.parentNode) return false;
  const tela = telaTasselli(img.className, g, pronto, altrimenti && (t => { t.hidden = true; altrimenti(); }));
  if (!tela) return false;
  if (img.style.cssText) tela.style.cssText = img.style.cssText;
  img.replaceWith(tela);
  return true;
}
function fotoCielo(img, g, pronto, altrimenti) {
  let finito = false, attesa = 0;
  const tasselli = () => { if (!fotoDaTasselli(img, g, pronto, altrimenti) && altrimenti) altrimenti(); };
  if (cdsGiu()) { finito = true; tasselli(); return; }
  const passa = () => {
    if (finito) return;
    finito = true; clearTimeout(attesa); segnaCdsGiu();
    img.onload = img.onerror = null; img.removeAttribute("src");
    tasselli();
  };
  img.onload = () => { if (finito) return; finito = true; clearTimeout(attesa); if (pronto) pronto(); };
  img.onerror = () => {
    if (finito) return;
    if (!img.dataset.riserva) { img.dataset.riserva = "1"; img.src = urlCielo(g.ra, g.dec, g.fov, g.W, g.H, true); } else passa();
  };
  attesa = setTimeout(passa, 6000);
  img.src = urlCielo(g.ra, g.dec, g.fov, g.W, g.H);
}
function daGnomonica(ra0, dec0, x, y) {
  const xi = x * RAD, eta = y * RAD;
  const rho = Math.hypot(xi, eta);
  if (rho < 1e-12) return [ra0, dec0];
  const c = Math.atan(rho), d0 = dec0 * RAD;
  const dec = Math.asin(Math.cos(c) * Math.sin(d0) + eta * Math.sin(c) * Math.cos(d0) / rho);
  const ra = ra0 * RAD + Math.atan2(xi * Math.sin(c), rho * Math.cos(d0) * Math.cos(c) - eta * Math.sin(d0) * Math.sin(c));
  return [Astro.n360(ra * DEG), dec * DEG];
}
function aGnomonica(ra0, dec0, ra, dec) {
  const a = (ra - ra0) * RAD, d = dec * RAD, d0 = dec0 * RAD;
  const cosc = Math.sin(d0) * Math.sin(d) + Math.cos(d0) * Math.cos(d) * Math.cos(a);
  const x = Math.cos(d) * Math.sin(a) / cosc;
  const y = (Math.cos(d0) * Math.sin(d) - Math.sin(d0) * Math.cos(d) * Math.cos(a)) / cosc;
  return [x * DEG, y * DEG];
}
const OBL_J2000 = 23.4392911 * RAD;
function eclitticaInEq(l) {
  const r = l * RAD;
  return [Astro.n360(Math.atan2(Math.sin(r) * Math.cos(OBL_J2000), Math.cos(r)) * DEG), Math.asin(Math.sin(OBL_J2000) * Math.sin(r)) * DEG];
}
function eqInEclittica(ra, dec) {
  const a = ra * RAD, d = dec * RAD, e = OBL_J2000;
  const b = Math.asin(clamp(Math.sin(d) * Math.cos(e) - Math.cos(d) * Math.sin(e) * Math.sin(a), -1, 1));
  return [Astro.n360(Math.atan2(Math.sin(a) * Math.cos(e) + Math.tan(d) * Math.sin(e), Math.cos(a)) * DEG), b * DEG];
}
Object.assign(TESTI.it, { mp_equatore: "Equatore celeste", mp_eclittica: "Eclittica" });
Object.assign(TESTI.de, { mp_equatore: "Himmelsäquator", mp_eclittica: "Ekliptik" });
Object.assign(TESTI.es, { mp_equatore: "Ecuador celeste", mp_eclittica: "Eclíptica" });
Object.assign(TESTI.en, { mp_equatore: "Celestial equator", mp_eclittica: "Ecliptic" });
const Mappa = (() => {
  let base = null;
  const tasselli = new Map();
  const urlFile = nome => ((RADICE && RADICE.dataset.stelle) || "").replace("ga-stelle-0.json", nome);
  let FONT = "";
  const font = (px, peso) => {
    if (!FONT) FONT = getComputedStyle(RADICE || document.body).fontFamily || "sans-serif";
    return `${peso || 400} ${px.toFixed(1)}px ${FONT}`;
  };
  function decodifica(b64) {
    const s = atob(b64), u = new Uint8Array(s.length);
    for (let i = 0; i < s.length; i++) u[i] = s.charCodeAt(i);
    return u;
  }
  function contenitore(n) {
    return { n, ra: new Float32Array(n), sd: new Float32Array(n), cd: new Float32Array(n), m: new Float32Array(n), c: new Uint8Array(n) };
  }
  function metti(st, i, ra, dec, mag, col) {
    st.ra[i] = ra * RAD; st.sd[i] = Math.sin(dec * RAD); st.cd[i] = Math.cos(dec * RAD); st.m[i] = mag; st.c[i] = col;
  }
  function caricaBase() {
    if (!base) {
      base = fetch(urlFile("ga-stelle-0.json"), { credentials: "omit" }).then(r => {
        if (!r.ok) throw new Error("stelle " + r.status);
        return r.json();
      }).then(j => {
        const u = decodifica(j.d), st = contenitore(j.n);
        for (let i = 0, p = 0; i < j.n; i++, p += 8) {
          const a = u[p] | (u[p + 1] << 8) | (u[p + 2] << 16), d = u[p + 3] | (u[p + 4] << 8) | (u[p + 5] << 16);
          metti(st, i, a / 16777216 * 360, d / 16777216 * 180 - 90, u[p + 6] / 20 - 2, u[p + 7]);
        }
        j.stelle = st;
        j.viaDati = j.via ? decodifica(j.via.d) : null;
        delete j.d;
        return j;
      });
      base.catch(() => { base = null; });
    }
    return base;
  }
  const fasce = new Map();
  function caricaFascia(j, b) {
    if (!fasce.has(b)) {
      const p = fetch(urlFile(`ga-stelle-m${b}.json`), { credentials: "omit" }).then(r => r.ok ? r.json() : null).then(f => {
        if (!f) return null;
        const d0 = -90 + f.b * j.fascia, u = decodifica(f.d), st = contenitore(f.n);
        for (let i = 0, q = 0; i < f.n; i++, q += 7) {
          metti(st, i, (u[q] | (u[q + 1] << 8) | (u[q + 2] << 16)) / 16777216 * 360, d0 + (u[q + 3] | (u[q + 4] << 8)) / 65535 * j.fascia,
            u[q + 5] / 20 - 2, u[q + 6]);
        }
        return st;
      }).catch(() => null);
      fasce.set(b, p);
      p.then(st => { if (!st) fasce.delete(b); });
    }
    return fasce.get(b);
  }
  function fascePer(j, dec, r) {
    const out = [];
    for (let b = Math.max(0, Math.floor((dec - r + 90) / j.fascia)); b <= Math.min(j.settori.length - 1, Math.floor((dec + r + 90) / j.fascia)); b++)
      if (j.medie && j.medie[b]) out.push(b);
    return out;
  }
  function caricaTassello(j, chiave) {
    if (!tasselli.has(chiave)) {
      const p = fetch(urlFile(`ga-stelle-t${chiave}.json`), { credentials: "omit" }).then(r => r.ok ? r.json() : null).then(t => {
        if (!t) return null;
        const n = j.settori[t.b], ra0 = t.s * 360 / n, larg = 360 / n, d0 = -90 + t.b * j.fascia;
        const u = decodifica(t.d), st = contenitore(t.n);
        for (let i = 0, q = 0; i < t.n; i++, q += 6) {
          metti(st, i, ra0 + (u[q] | (u[q + 1] << 8)) / 65535 * larg, d0 + (u[q + 2] | (u[q + 3] << 8)) / 65535 * j.fascia,
            u[q + 4] / 20 - 2, u[q + 5]);
        }
        return st;
      }).catch(() => null);
      tasselli.set(chiave, p);
      p.then(st => { if (!st) tasselli.delete(chiave); });
    }
    return tasselli.get(chiave);
  }
  function tasselliPer(j, ra, dec, r) {
    const out = [], nb = j.settori.length;
    const b0 = Math.max(0, Math.floor((dec - r + 90) / j.fascia)), b1 = Math.min(nb - 1, Math.floor((dec + r + 90) / j.fascia));
    const larg = Math.abs(dec) + r >= 89.5 ? 180 : Math.asin(Math.min(1, Math.sin(r * RAD) / Math.cos(dec * RAD))) * DEG;
    for (let b = b0; b <= b1; b++) {
      const n = j.settori[b], w = 360 / n;
      const s0 = larg >= 180 ? 0 : Math.floor((ra - larg) / w), s1 = larg >= 180 ? n - 1 : Math.floor((ra + larg) / w);
      for (let s = s0; s <= s1 && s - s0 < n; s++) {
        const chiave = `${b}-${((s % n) + n) % n}`;
        if (j.tasselli[chiave]) out.push(chiave);
      }
    }
    return out;
  }
  function magLimite(fov) {
    return clamp(9.5 - 3.54 * Math.log10(Math.max(fov, 0.3) / 10), 5.8, 10.5);
  }
  function proiettore(g) {
    const a0 = g.ra * RAD, s0 = Math.sin(g.dec * RAD), c0 = Math.cos(g.dec * RAD), k = DEG / g.cdelt, cx = g.W / 2, cy = g.H / 2;
    const p = (ra, sd, cd, out) => {
      const da = ra - a0, cda = Math.cos(da);
      const cosc = s0 * sd + c0 * cd * cda;
      if (cosc < 0.2) return false;
      out[0] = cx - (cd * Math.sin(da) / cosc) * k;
      out[1] = cy - ((c0 * sd - s0 * cd * cda) / cosc) * k;
      return true;
    };
    p.gradi = (raG, decG, out) => p(raG * RAD, Math.sin(decG * RAD), Math.cos(decG * RAD), out);
    return p;
  }
  const raggioVista = g => Math.atan(Math.hypot(g.W, g.H) * g.cdelt / 2 * RAD) * DEG;
  const SCALA_BV = [[-0.4, [155, 178, 255]], [-0.2, [172, 196, 255]], [0, [206, 220, 255]], [0.3, [242, 244, 255]], [0.6, [255, 246, 232]],
    [0.9, [255, 232, 200]], [1.2, [255, 214, 165]], [1.5, [255, 192, 125]], [2.0, [255, 165, 95]]];
  const TAVOLOZZA = [];
  for (let q = 0; q < 128; q++) {
    const bv = q * 4 / 127 - 0.5;
    let i = 0;
    while (i < SCALA_BV.length - 2 && bv > SCALA_BV[i + 1][0]) i++;
    const [b0, c0] = SCALA_BV[i], [b1, c1] = SCALA_BV[i + 1], f = clamp((bv - b0) / (b1 - b0), 0, 1);
    TAVOLOZZA[q] = c0.map((v, z) => Math.round(v + (c1[z] - v) * f));
  }
  const TIPI = {
    gx: { c: [255, 222, 160], f: 0.34, d: 0, s: "gx" }, gxp: { c: [255, 222, 160], f: 0.3, d: 0, s: "gx" },
    gxg: { c: [255, 222, 160], f: 0, d: 1 }, gxcl: { c: [255, 222, 160], f: 0, d: 1 },
    en: { c: [255, 92, 128], f: 0.26, d: 0 }, cn: { c: [255, 116, 140], f: 0.24, d: 0 }, neb: { c: [255, 120, 150], f: 0.18, d: 1 },
    reg: { c: [255, 120, 150], f: 0.12, d: 1 }, snr: { c: [255, 160, 90], f: 0.18, d: 1 }, rn: { c: [120, 170, 255], f: 0.28, d: 0 },
    dn: { c: [170, 180, 200], f: -1, d: 1 }, pn: { c: [100, 245, 205], f: 0.3, d: 0, s: "pn" },
    oc: { c: [255, 214, 130], f: 0, d: 2 }, sc: { c: [255, 214, 130], f: 0, d: 2 }, gc: { c: [255, 226, 170], f: 0.3, d: 0, s: "gc" },
    ds: { c: [235, 240, 255], f: 0, d: 0 },
  };
  const rgba = (c, a) => `rgba(${c[0]},${c[1]},${c[2]},${a})`;
  async function disegna(tela, g, opz) {
    opz = opz || {};
    const foto = !!opz.sopraFoto;
    const mio = tela._giro = (tela._giro || 0) + 1;
    const j = await caricaBase();
    if (tela._giro !== mio) return null;
    const mlim = magLimite(g.fov), r = raggioVista(g) * 1.02 + 0.05;
    const pronti = foto ? [] : [...(mlim > j.mag_luminose ? fascePer(j, g.dec, r).map(b => caricaFascia(j, b)) : []),
      ...(mlim > j.mag_medie ? tasselliPer(j, g.ra, g.dec, r).map(k => caricaTassello(j, k)) : [])];
    const firma = opz.firma ? (typeof opz.firma === "string" ? opz.firma : t("firma_mappa")) : "";
    const dipingi = deboli => {
      tela.width = g.W; tela.height = g.H;
      const c = tela.getContext("2d"), pr = proiettore(g);
      const occupati = (opz.riservati || []).slice();
      if (firma) {
        c.font = font(9 * g.k);
        const w = c.measureText(firma).width;
        occupati.push([g.W - w - 10 * g.k, g.H - 18 * g.k, w + 10 * g.k, 18 * g.k]);
      }
      if (!foto) disegnaFondo(c, g, j);
      const griglia = opz.griglia === undefined ? (!foto || !opz.senzaNomi ? 1 : 0) : opz.griglia ? 2 : foto ? 0 : 1;
      const scritteGriglia = griglia ? disegnaGriglia(c, g, pr, occupati, foto, griglia === 2) : null;
      if (g.fov >= 4 && (!foto || !opz.senzaNomi)) disegnaCostellazioni(c, g, pr, j, foto);
      const vis = oggettiInVista(g, pr, opz.oggetto);
      if (!foto || !opz.senzaNomi) for (const v of vis) disegnaOggetto(c, g, v, opz.oggetto, foto);
      if (!foto) disegnaStelle(c, g, pr, [j.stelle, ...deboli], mlim);
      if (opz.oggetto && opz.oggetto.corpo) {
        const o = opz.oggetto, p = [0, 0];
        if (pr.gradi(o.ra, o.dec, p)) disegnaCorpo(c, o, p[0], p[1], o.diam / 7200 / g.cdelt, g.k);
      }
      if (scritteGriglia) scritteGriglia();
      if (opz.cornice) disegnaCornice(c, g, opz.cornice, occupati);
      if (!opz.senzaNomi) {
        etichetteOggetti(c, g, vis, opz.oggetto, opz, occupati);
        nomiStelle(c, g, pr, j, occupati);
        if (g.fov >= 15) nomiCostellazioni(c, g, pr, j, occupati);
      }
      if (firma) {
        c.font = font(9 * g.k); c.textAlign = "right"; c.fillStyle = foto ? "rgba(255,255,255,0.6)" : "rgba(255,255,255,0.42)";
        if (foto) { c.lineWidth = 2.5 * g.k; c.strokeStyle = "rgba(0,0,0,0.6)"; c.strokeText(firma, g.W - 6 * g.k, g.H - 6 * g.k); }
        c.fillText(firma, g.W - 6 * g.k, g.H - 6 * g.k); c.textAlign = "left";
      }
    };
    let pronte = null;
    if (pronti.length) {
      const tutti = Promise.all(pronti);
      pronte = await Promise.race([tutti, new Promise(r => setTimeout(() => r(null), 60))]);
      if (!pronte) { if (tela._giro !== mio) return null; dipingi([]); pronte = await tutti; }
      if (tela._giro !== mio) return null;
    }
    dipingi(pronte || []);
    return { mlim };
  }
  function disegnaFondo(c, g, j) {
    const r = c.createRadialGradient(g.W * 0.5, g.H * 0.42, 0, g.W * 0.5, g.H * 0.5, Math.hypot(g.W, g.H) * 0.62);
    r.addColorStop(0, "#0c1629"); r.addColorStop(1, "#03060d");
    c.fillStyle = r; c.fillRect(0, 0, g.W, g.H);
    if (g.fov >= 8 && j.viaDati) viaLattea(c, g, j);
  }
  function viaLattea(c, g, j) {
    const V = j.viaDati, nx = j.via.w, ny = j.via.h;
    const passo = Math.max(6, Math.round(g.W / 90));
    const w = Math.ceil(g.W / passo), h = Math.ceil(g.H / passo);
    const off = document.createElement("canvas");
    off.width = w; off.height = h;
    const oc = off.getContext("2d"), im = oc.createImageData(w, h);
    const forza = clamp((g.fov - 8) / 12, 0, 1);
    for (let y = 0; y < h; y++) for (let x = 0; x < w; x++) {
      const [ra, dec] = daGnomonica(g.ra, g.dec, (g.W / 2 - (x + 0.5) * passo) * g.cdelt, (g.H / 2 - (y + 0.5) * passo) * g.cdelt);
      const fx = ra / 360 * nx - 0.5, fy = clamp((dec + 90) / 180 * ny - 0.5, 0, ny - 1);
      const x0 = Math.floor(fx), y0 = Math.floor(fy), y1 = Math.min(ny - 1, y0 + 1), tx = fx - x0, ty = fy - y0;
      const a = ((x0 % nx) + nx) % nx, b = (a + 1) % nx;
      const v = ((V[y0 * nx + a] * (1 - tx) + V[y0 * nx + b] * tx) * (1 - ty) + (V[y1 * nx + a] * (1 - tx) + V[y1 * nx + b] * tx) * ty) / 255;
      const f = clamp((v - 0.42) / 0.58, 0, 1);
      const q = (y * w + x) * 4;
      im.data[q] = 170; im.data[q + 1] = 188; im.data[q + 2] = 236; im.data[q + 3] = Math.round(Math.pow(f, 1.5) * 0.26 * forza * 255);
    }
    oc.putImageData(im, 0, 0);
    c.imageSmoothingEnabled = true;
    c.imageSmoothingQuality = "high";
    c.drawImage(off, 0, 0, w * passo, h * passo);
  }
  function disegnaStelle(c, g, pr, elenchi, mlim) {
    const k = g.k, out = [0, 0], margine = 12 * k;
    const lotti = new Map();
    const brillanti = [];
    for (const st of elenchi) {
      if (!st) continue;
      for (let i = 0; i < st.n; i++) {
        const m = st.m[i];
        if (m > mlim) break;
        if (!pr(st.ra[i], st.sd[i], st.cd[i], out)) continue;
        const x = out[0], y = out[1];
        if (x < -margine || y < -margine || x > g.W + margine || y > g.H + margine) continue;
        const d = mlim - m;
        const r = Math.min(5.4, 0.62 + 0.12 * d + 0.026 * d * d) * k;
        if (d >= 5) { brillanti.push([x, y, r, d, st.c[i]]); continue; }
        const al = Math.min(4, Math.floor(d / 0.6));
        const chiave = (st.c[i] >> 3) * 8 + al;
        let p = lotti.get(chiave);
        if (!p) { p = new Path2D(); lotti.set(chiave, p); }
        p.moveTo(x + r, y); p.arc(x, y, r, 0, 2 * Math.PI);
      }
    }
    for (const [chiave, p] of lotti) {
      const col = TAVOLOZZA[(chiave >> 3) * 8 + 4] || [255, 255, 255], al = chiave & 7;
      c.fillStyle = rgba(col, [0.5, 0.66, 0.8, 0.92, 1][al]);
      c.fill(p);
    }
    for (const [x, y, r, d, ci] of brillanti) {
      const col = TAVOLOZZA[ci] || [255, 255, 255], f = clamp((d - 5) / 5, 0, 1);
      const h = c.createRadialGradient(x, y, 0, x, y, r * 4.2);
      h.addColorStop(0, rgba(col, 0.42 + 0.25 * f)); h.addColorStop(0.3, rgba(col, 0.16 + 0.1 * f)); h.addColorStop(1, rgba(col, 0));
      c.fillStyle = h; c.beginPath(); c.arc(x, y, r * 4.2, 0, 2 * Math.PI); c.fill();
      if (d >= 7.5) {
        const L = r * (3.2 + 2.5 * f);
        c.strokeStyle = rgba(col, 0.28 + 0.2 * f); c.lineWidth = Math.max(1, 0.8 * k);
        c.beginPath(); c.moveTo(x - L, y); c.lineTo(x + L, y); c.moveTo(x, y - L); c.lineTo(x, y + L); c.stroke();
      }
      c.fillStyle = rgba(col.map(v => Math.round(v + (255 - v) * 0.45)), 1);
      c.beginPath(); c.arc(x, y, r, 0, 2 * Math.PI); c.fill();
    }
  }
  const PASSI_DEC = [1, 2, 5, 10, 15, 20, 30, 60, 120, 300, 600, 900, 1200, 1800];
  const PASSI_RA = [4, 5, 10, 15, 20, 30, 60, 120, 300, 600, 900, 1200, 1800, 3600, 7200, 10800];
  function testoDec(d, passo) {
    const q = Math.round(d * 60), s = q < 0 ? "−" : "+", a = Math.abs(q), gr = Math.floor(a / 60), mi = a % 60;
    return passo >= 60 || !mi ? `${s}${gr}°` : `${s}${gr}°${String(mi).padStart(2, "0")}′`;
  }
  function testoRa(ra, passo) {
    const s = Math.round(Astro.n360(ra) * 240) % 86400, h = Math.floor(s / 3600), m = Math.floor(s % 3600 / 60), ss = s % 60;
    if (passo >= 3600) return `${h}h`;
    if (passo >= 60) return `${h}h ${String(m).padStart(2, "0")}m`;
    return `${h}h ${String(m).padStart(2, "0")}m ${String(ss).padStart(2, "0")}s`;
  }
  function disegnaGriglia(c, g, pr, occupati, foto, forte) {
    const k = g.k, out = [0, 0], r = raggioVista(g) + 0.5;
    const vorrei = g.fov / 4.5 * 60;
    const pd = PASSI_DEC.find(p => p >= vorrei) || 1800, pdG = pd / 60;
    const polo = Math.abs(g.dec) + r >= 89.5;
    const vorreiRa = pdG / Math.max(1e-6, Math.cos(g.dec * RAD)) * 240;
    const pa = PASSI_RA.find(p => p >= vorreiRa) || 10800, paG = pa / 240;
    const larg = polo ? 180 : Math.asin(Math.min(1, Math.sin(r * RAD) / Math.cos(g.dec * RAD))) * DEG;
    const d0 = Math.max(-90, g.dec - r), d1 = Math.min(90, g.dec + r);
    c.strokeStyle = forte ? "rgba(160,215,255,0.5)" : foto ? "rgba(143,208,255,0.2)" : "rgba(143,208,255,0.13)";
    c.lineWidth = Math.max(1, (forte ? 1.15 : 0.9) * k);
    const etichette = [];
    const linea = punti => {
      c.beginPath();
      let prima = null;
      for (const p of punti) {
        if (!p) { prima = null; continue; }
        if (prima) c.lineTo(p[0], p[1]); else c.moveTo(p[0], p[1]);
        prima = p;
      }
      c.stroke();
    };
    const incrocio = (punti, asse, v) => {
      let prima = null;
      for (const p of punti) {
        if (p && prima && (prima[asse] - v) * (p[asse] - v) <= 0 && prima[asse] !== p[asse]) {
          const f = (v - prima[asse]) / (p[asse] - prima[asse]), q = [prima[0] + f * (p[0] - prima[0]), prima[1] + f * (p[1] - prima[1])];
          if (q[1 - asse] > 0 && q[1 - asse] < (asse ? g.W : g.H)) return q;
        }
        prima = p;
      }
      return null;
    };
    const N = 90;
    for (let d = Math.ceil(d0 / pdG) * pdG; d <= d1 + 1e-9; d += pdG) {
      if (Math.abs(d) > 89.99) continue;
      const punti = [];
      for (let i = 0; i <= N; i++) {
        const a = g.ra - larg + 2 * larg * i / N;
        punti.push(pr.gradi(a, d, out) ? [out[0], out[1]] : null);
      }
      linea(punti);
      const posti = [], sx = incrocio(punti, 0, 0), dx = forte ? incrocio(punti, 0, g.W) : null;
      if (sx) posti.push([4 * k, sx[1] - 4 * k]);
      if (dx) posti.push([g.W - 4 * k, dx[1] - 4 * k, true]);
      if (polo) for (const da of [180, 90, -90]) if (pr.gradi(g.ra + da, d, out)) posti.push([out[0] + 4 * k, out[1] - 4 * k]);
      if (posti.length) etichette.push([testoDec(d, pd), posti]);
    }
    const a0 = polo ? 0 : Math.ceil((g.ra - larg) / paG) * paG, a1 = polo ? 360 - 1e-9 : g.ra + larg;
    for (let a = a0; a <= a1; a += paG) {
      const punti = [];
      for (let i = 0; i <= N; i++) {
        const d = d0 + (d1 - d0) * i / N;
        punti.push(pr.gradi(a, d, out) ? [out[0], out[1]] : null);
      }
      linea(punti);
      const posti = [], giu = incrocio(punti, 1, g.H);
      if (giu) posti.push([giu[0] + 4 * k, g.H - 5 * k]);
      if (forte) {
        const sopraScala = incrocio(punti, 1, g.H - 58 * k), su = incrocio(punti, 1, 0);
        if (sopraScala) posti.push([sopraScala[0] + 4 * k, g.H - 62 * k]);
        if (su) posti.push([su[0] + 4 * k, 15 * k]);
        const st = incrocio(punti, 1, 56 * k), sb = incrocio(punti, 1, g.H - 100 * k);
        if (st) posti.push([st[0] + 4 * k, 52 * k], [st[0] - 4 * k, 52 * k, true]);
        if (sb) posti.push([sb[0] + 4 * k, g.H - 96 * k]);
      }
      if (posti.length) etichette.push([testoRa(a, pa), posti]);
    }
    const cerchi = [];
    if (forte) {
      const lungo = Math.min(180, r * 1.6 + 1), M = 120;
      if (Math.abs(g.dec) <= r) {
        const punti = [];
        for (let i = 0; i <= M; i++) punti.push(pr.gradi(g.ra - lungo + 2 * lungo * i / M, 0, out) ? [out[0], out[1]] : null);
        cerchi.push([punti, "rgba(255,140,150,0.95)", t("mp_equatore")]);
      }
      const [lc, bc] = eqInEclittica(g.ra, g.dec);
      if (Math.abs(bc) <= r) {
        const punti = [];
        for (let i = 0; i <= M; i++) {
          const [ra, dec] = eclitticaInEq(lc - lungo + 2 * lungo * i / M);
          punti.push(pr.gradi(ra, dec, out) ? [out[0], out[1]] : null);
        }
        cerchi.push([punti, "rgba(160,232,120,0.95)", t("mp_eclittica")]);
      }
      c.lineWidth = Math.max(1.5, 1.8 * k);
      for (const [punti, col] of cerchi) { c.strokeStyle = col; linea(punti); }
    }
    return () => {
      c.textAlign = "left";
      c.font = font(11.5 * k, 700);
      for (const [punti, col, nome] of cerchi) nomeSullaLinea(c, g, punti, nome, col, occupati);
      const fs = (forte ? 11 : 10.5) * k;
      c.font = font(fs, 600);
      for (const [testo, posti] of etichette) {
        const w = c.measureText(testo).width;
        for (const [x0, y, destra] of posti) {
          const x = destra ? x0 - w : x0, box = [x - 2 * k, y - fs, w + 4 * k, fs + 3 * k];
          if (x < 2 * k || x + w > g.W - 4 * k || y - fs < 0 || y > g.H || urta(box, occupati)) continue;
          occupati.push(box);
          if (foto || forte) alone(c, testo, x, y, forte ? "rgba(200,232,255,0.98)" : "rgba(170,220,255,0.85)", k);
          else { c.fillStyle = "rgba(143,208,255,0.62)"; c.fillText(testo, x, y); }
          break;
        }
      }
    };
  }
  function nomeSullaLinea(c, g, punti, nome, col, occupati) {
    const k = g.k, m = 2 * k, fs = 11.5 * k, w = c.measureText(nome).width;
    const pp = punti.filter(Boolean);
    if (pp.length < 2) return;
    const [ax, ay] = pp[0], [bx, by] = pp[pp.length - 1], L = Math.hypot(bx - ax, by - ay) * (bx < ax ? -1 : 1);
    if (!L) return;
    const cs = (bx - ax) / L, sn = (by - ay) / L, ang = Math.atan2(sn, cs);
    let t0 = -Infinity, t1 = Infinity;
    for (const [d, q] of [[-cs, ax - m], [cs, g.W - m - ax], [-sn, ay - m], [sn, g.H - m - ay]]) {
      if (Math.abs(d) < 1e-9) { if (q < 0) return; } else if (d < 0) t0 = Math.max(t0, q / d); else t1 = Math.min(t1, q / d);
    }
    if (!(t1 - t0 >= w)) return;
    for (const f of [0.15, 0.5, 0.85, 0.3, 0.7, ...Array.from({ length: 33 }, (_, i) => i / 32)]) {
      const t = t0 + f * (t1 - t0 - w), ox = ax + cs * t + sn * 5 * k, oy = ay + sn * t - cs * 5 * k;
      const xs = [], ys = [];
      for (const [lx, ly] of [[0, -fs], [w, -fs], [0, 3 * k], [w, 3 * k]]) { xs.push(ox + lx * cs - ly * sn); ys.push(oy + lx * sn + ly * cs); }
      const box = [Math.min(...xs), Math.min(...ys), Math.max(...xs) - Math.min(...xs), Math.max(...ys) - Math.min(...ys)];
      if (box[0] < 2 * k || box[1] < 2 * k || box[0] + box[2] > g.W - 2 * k || box[1] + box[3] > g.H - 2 * k || urta(box, occupati)) continue;
      c.save(); c.translate(ox, oy); c.rotate(ang); c.textAlign = "left";
      alone(c, nome, 0, 0, col, k);
      c.restore();
      occupati.push(box);
      return;
    }
  }
  function disegnaCostellazioni(c, g, pr, j, foto) {
    const a = [0, 0], b = [0, 0], k = g.k;
    c.strokeStyle = foto ? "rgba(143,208,255,0.42)" : "rgba(143,208,255,0.3)"; c.lineWidth = Math.max(1, 1.1 * k);
    c.beginPath();
    for (const [r1, d1, r2, d2] of j.linee) {
      if (!pr.gradi(r1, d1, a) || !pr.gradi(r2, d2, b)) continue;
      const dx = b[0] - a[0], dy = b[1] - a[1], L = Math.hypot(dx, dy), stacco = 7 * k;
      if (L < 3 * stacco) continue;
      const t1 = stacco / L;
      c.moveTo(a[0] + dx * t1, a[1] + dy * t1); c.lineTo(b[0] - dx * t1, b[1] - dy * t1);
    }
    c.stroke();
  }
  function nomiCostellazioni(c, g, pr, j, occupati) {
    const a = [0, 0], fs = (g.fov >= 40 ? 12 : 11) * g.k;
    c.font = font(fs, 600); c.fillStyle = "rgba(143,208,255,0.42)"; c.textAlign = "center";
    for (const [sigla, [ra, dec]] of Object.entries(j.etichette)) {
      if (!pr.gradi(ra, dec, a) || a[0] < 0 || a[0] > g.W || a[1] < fs || a[1] > g.H) continue;
      const testo = nomeCostellazione(sigla).toUpperCase(), w = c.measureText(testo).width;
      if (w > g.W - 8 * g.k) continue;
      const x = clamp(a[0], w / 2 + 4 * g.k, g.W - w / 2 - 4 * g.k), box = [x - w / 2, a[1] - fs, w, fs + 2 * g.k];
      if (urta(box, occupati)) continue;
      occupati.push(box);
      c.fillText(testo, x, a[1]);
    }
    c.textAlign = "left";
  }
  function nomiStelle(c, g, pr, j, occupati) {
    const out = [0, 0], k = g.k, limite = g.fov > 60 ? 1.6 : g.fov > 25 ? 2.6 : 3.6, fs = 10.5 * k;
    c.font = font(fs, 500);
    for (const s of j.nomi) {
      if (s.m > limite) continue;
      if (!pr.gradi(s.ra, s.dec, out) || out[0] < 0 || out[1] < 0 || out[0] > g.W || out[1] > g.H) continue;
      const testo = s[LINGUA] || s.en, w = c.measureText(testo).width;
      for (const [x, y] of [[out[0] + 7 * k, out[1] - 5 * k], [out[0] - 7 * k - w, out[1] - 5 * k], [out[0] + 7 * k, out[1] + 5 * k + fs]]) {
        const box = [x, y - fs, w, fs + 2 * k];
        if (x < 2 || x + w > g.W - 2 || y - fs < 2 || y > g.H - 2 || urta(box, occupati)) continue;
        occupati.push(box);
        alone(c, testo, x, y, "rgba(226,234,248,0.82)", k);
        break;
      }
    }
  }
  function oggettiInVista(g, pr, principale) {
    const out = [0, 0], r = raggioVista(g), lista = [];
    const poco = g.fov >= 10;
    for (const o of DATI.oggetti) {
      if ((o.zona || o.soloCerca) && o !== principale) continue;
      const mis = misuraOggetto(o) / 60;
      if (Math.abs(o.dec - g.dec) > r + mis) continue;
      if (Astro.separazione(o.ra, o.dec, g.ra, g.dec) > r + mis / 2) continue;
      if (poco && o !== principale && !(o.top || o.messier || o.caldwell || o.nomi) && (o.a || 0) / 60 / g.cdelt < 6 * g.k) continue;
      if (!pr.gradi(o.ra, o.dec, out)) continue;
      lista.push({ o, x: out[0], y: out[1], r: 0 });
    }
    return lista.sort((a, b) => misuraOggetto(b.o) - misuraOggetto(a.o));
  }
  function disegnaOggetto(c, g, v, principale, foto) {
    const o = v.o, st = TIPI[o.t] || TIPI.neb, k = g.k, io = o === principale;
    const A = o.a ? Math.max(o.a / 120 / g.cdelt, 2.6 * k) : 4 * k;
    const B = o.a ? Math.max((o.b || o.a) / 120 / g.cdelt, 2.6 * k) : 4 * k;
    const rot = o.pa == null ? 0 : Math.atan2(-Math.cos(o.pa * RAD), -Math.sin(o.pa * RAD));
    v.r = Math.max(A, B);
    if (o.zona) {
      c.strokeStyle = "rgba(244,213,139,0.55)"; c.lineWidth = 1.2 * k; c.setLineDash([6 * k, 5 * k]);
      c.beginPath(); c.ellipse(v.x, v.y, A, B, rot, 0, 2 * Math.PI); c.stroke(); c.setLineDash([]);
      return;
    }
    const anonima = anonimo(o) && !io;
    const f = st.f * (anonima ? 0.45 : 1) * clamp(0.9 * Math.min(g.W, g.H) / (2 * A), 0.35, 1);
    if (foto) {
      c.lineWidth = 1.1 * k; c.strokeStyle = rgba(st.c, anonima ? 0.35 : 0.6);
      c.setLineDash(st.d === 2 || anonima ? [2 * k, 4 * k] : [6 * k, 5 * k]);
      c.beginPath(); c.ellipse(v.x, v.y, A, B, rot, 0, 2 * Math.PI); c.stroke(); c.setLineDash([]);
      return;
    }
    if (st.f > 0 && A > 3 * k) {
      c.save(); c.translate(v.x, v.y); c.rotate(rot); c.scale(1, B / A);
      const gr = c.createRadialGradient(0, 0, 0, 0, 0, A), nucleo = st.s === "gx" || st.s === "gc" ? 1.7 : 1.15;
      gr.addColorStop(0, rgba(st.c, Math.min(0.75, f * nucleo)));
      gr.addColorStop(0.3, rgba(st.c, f * 0.75));
      gr.addColorStop(0.75, rgba(st.c, f * 0.32));
      gr.addColorStop(1, rgba(st.c, 0));
      c.fillStyle = gr; c.beginPath(); c.arc(0, 0, A, 0, 2 * Math.PI); c.fill();
      c.restore();
    } else if (st.f < 0) {
      c.fillStyle = `rgba(0,0,0,${anonima ? 0.3 : 0.42})`; c.beginPath(); c.ellipse(v.x, v.y, A, B, rot, 0, 2 * Math.PI); c.fill();
    }
    c.lineWidth = (io ? 1.4 : 1.1) * k;
    c.strokeStyle = rgba(st.c, io ? 0.85 : anonima ? 0.4 : o.a ? 0.66 : 0.5);
    const d = anonima && st.d === 0 ? 1 : st.d;
    c.setLineDash(d === 1 ? [5 * k, 4 * k] : d === 2 ? [1.3 * k, 3.2 * k] : []);
    c.beginPath(); c.ellipse(v.x, v.y, A, B, rot, 0, 2 * Math.PI); c.stroke();
    c.setLineDash([]);
    if (st.s === "gc" && A > 4 * k) {
      c.strokeStyle = rgba(st.c, 0.55); c.lineWidth = k;
      c.beginPath(); c.moveTo(v.x - A, v.y); c.lineTo(v.x + A, v.y); c.moveTo(v.x, v.y - A); c.lineTo(v.x, v.y + A); c.stroke();
    } else if (st.s === "pn") {
      const r1 = Math.max(A, B), r2 = r1 + Math.max(3 * k, r1 * 0.45);
      c.strokeStyle = rgba(st.c, 0.75); c.lineWidth = k;
      c.beginPath();
      for (const [dx, dy] of [[1, 0], [-1, 0], [0, 1], [0, -1]]) { c.moveTo(v.x + dx * r1, v.y + dy * r1); c.lineTo(v.x + dx * r2, v.y + dy * r2); }
      c.stroke();
    }
  }
  function etichetteOggetti(c, g, vis, principale, opz, occupati) {
    const k = g.k, fs = 11.5 * k, nomePrincipale = opz.nomePrincipale;
    const peso = v => (v.o === principale ? 1e7 : 0) + (v.o.top ? 1e5 : 0) + (v.o.messier ? 5e4 : 0) + (v.o.caldwell ? 2e4 : 0) +
      (v.o.nomi ? 1e4 : 0) + (anonimo(v.o) ? v.r * 0.2 : v.r);
    const ordinati = vis.filter(v => !v.o.zona && !(opz.senzaPrincipale && v.o === principale)).sort((a, b) => peso(b) - peso(a));
    const max = g.fov > 10 ? 16 : 26;
    let n = 0, anonimi = 0;
    for (const v of ordinati) {
      if (n >= max) break;
      const o = v.o, io = o === principale;
      if (!io && v.r < 3 * k && !o.top && !o.messier && !o.caldwell) continue;
      if (!io && anonimo(o) && ++anonimi > 4) continue;
      const nome = nomeOggetto(o);
      const testo = nome && (io ? nomePrincipale : (v.r > 28 * k || (o.top && n < 6))) ? `${o.id} · ${nome}` : o.id;
      c.font = font(fs, io ? 800 : 650);
      const w = c.measureText(testo).width, s = Math.min(v.r * 0.72, Math.min(g.W, g.H) * 0.3), m = 4 * k;
      const posti = [[v.x + s + m, v.y - s - m], [v.x + s + m, v.y + s + m + fs], [v.x - s - m - w, v.y - s - m], [v.x - s - m - w, v.y + s + m + fs]];
      if (v.r > 40 * k) posti.push([v.x + 10 * k, v.y - 10 * k], [v.x - w - 10 * k, v.y + fs + 10 * k]);
      for (const [x, y] of posti) {
        const box = [x - 2 * k, y - fs, w + 4 * k, fs + 4 * k];
        if (x < 2 || x + w > g.W - 2 || y - fs < 2 || y > g.H - 2 || urta(box, occupati)) continue;
        occupati.push(box);
        const st = TIPI[o.t] || TIPI.neb;
        alone(c, testo, x, y, io ? "#f4d58b" : rgba(st.c.map(z => Math.round(z + (255 - z) * 0.25)), 0.95), k);
        n++;
        break;
      }
    }
  }
  function disegnaCornice(c, g, cr, occupati) {
    const k = g.k, pw = cr.w / g.cdelt, ph = cr.h / g.cdelt;
    c.save(); c.translate(g.W / 2, g.H / 2);
    c.fillStyle = "rgba(216,174,67,0.07)"; c.strokeStyle = "#e2b84f"; c.lineWidth = 1.8 * k;
    if (cr.cerchio) { c.beginPath(); c.arc(0, 0, pw / 2, 0, 2 * Math.PI); c.fill(); c.stroke(); }
    else { c.rotate(-(cr.rot || 0) * RAD); c.fillRect(-pw / 2, -ph / 2, pw, ph); c.strokeRect(-pw / 2, -ph / 2, pw, ph); }
    c.restore();
    if (cr.nome && !cr.rot) {
      const fs = 11 * k, x = g.W / 2 - pw / 2 + 4 * k, y = g.H / 2 - ph / 2 - 5 * k;
      c.font = font(fs, 750);
      const w = c.measureText(cr.nome).width;
      if (y - fs > 2 && x > 2 && x + w < g.W) { alone(c, cr.nome, x, y, "#f4d58b", k); occupati.push([x, y - fs, w, fs + 3 * k]); }
    }
  }
  function anonimo(o) {
    return !o.top && !o.messier && !o.caldwell && !o.nomi && o.mag == null && o.t !== "gx" && o.t !== "pn";
  }
  function alone(c, testo, x, y, colore, k) {
    c.lineJoin = "round"; c.lineWidth = 3.2 * k; c.strokeStyle = "rgba(3,6,13,0.88)";
    c.strokeText(testo, x, y);
    c.fillStyle = colore; c.fillText(testo, x, y);
  }
  function urta(b, lista) {
    for (const q of lista) if (b[0] < q[0] + q[2] && b[0] + b[2] > q[0] && b[1] < q[1] + q[3] && b[1] + b[3] > q[1]) return true;
    return false;
  }
  function anteprima(tela, o, campo, img) {
    const box = tela.getBoundingClientRect(), dpr = Math.min(window.devicePixelRatio || 1, 2);
    const cssW = box.width || 480, W = Math.round(clamp(cssW * dpr, 360, 1200)), H = Math.round(W * 2 / 3);
    let fov = misuraOggetto(o) / 60 * 1.8;
    if (campo) fov = Math.max(fov, Math.max(campo.w, campo.h) * 1.3, campo.h * 1.1 * W / H);
    fov = clamp(fov, 0.12, 60);
    const g = { ra: o.ra, dec: o.dec, fov, W, H, cdelt: fov / W, k: W / cssW };
    const opz = { oggetto: o, nomePrincipale: true, firma: true,
      cornice: campo ? { w: campo.w, h: campo.h, rot: CAMPO.rot, cerchio: (CAMPO.modo || "foto") !== "foto",
        nome: (CAMPO.modo === "foto" && CAMPO.cam && CAMPO.cam.nome) || "" } : null };
    if (img) {
      let mappa = false;
      fotoCielo(img, g, null, () => { mappa = true; img.hidden = true; disegna(tela, g, opz).catch(() => {}); });
      return mappa ? Promise.resolve() : disegna(tela, g, Object.assign({}, opz, { sopraFoto: true, firma: "DSS2 · STScI/NASA · CDS" }));
    }
    return disegna(tela, g, opz);
  }
  return { disegna, anteprima, caricaBase, magLimite, colore: q => TAVOLOZZA[q] || TAVOLOZZA[40] };
})();
const Hips = (() => {
  const JRLL = [2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4], JPLL = [1, 3, 5, 7, 0, 2, 4, 6, 1, 3, 5, 7];
  function sparpaglia(v) { let r = 0; for (let b = 0; v; b++, v >>= 1) r |= (v & 1) << (2 * b); return r; }
  function compatta(v) { let r = 0; for (let b = 0; v; b++, v >>= 2) r |= (v & 1) << b; return r; }
  const xyf2nest = (ix, iy, f, o) => (f << (2 * o)) + sparpaglia(ix) + (sparpaglia(iy) << 1);
  function nest2xyf(p, o) { const l = p & ((1 << (2 * o)) - 1); return [compatta(l), compatta(l >> 1), p >> (2 * o)]; }
  function ang2nest(o, z, phi) {
    const ns = 1 << o, za = Math.abs(z);
    let tt = (phi / (Math.PI / 2)) % 4;
    if (tt < 0) tt += 4;
    if (za <= 2 / 3) {
      const t1 = ns * (0.5 + tt), t2 = ns * z * 0.75;
      const jp = Math.floor(t1 - t2), jm = Math.floor(t1 + t2), ifp = jp >> o, ifm = jm >> o;
      const f = ifp === ifm ? (ifp | 4) : (ifp < ifm ? ifp : ifm + 8);
      return xyf2nest(jm & (ns - 1), ns - (jp & (ns - 1)) - 1, f, o);
    }
    const ntt = Math.min(3, Math.floor(tt)), tp = tt - ntt, tmp = ns * Math.sqrt(3 * (1 - za));
    const jp = Math.min(ns - 1, Math.floor(tp * tmp)), jm = Math.min(ns - 1, Math.floor((1 - tp) * tmp));
    return z >= 0 ? xyf2nest(ns - jm - 1, ns - jp - 1, ntt, o) : xyf2nest(jp, jm, ntt + 8, o);
  }
  function xyf2vec(x, y, f, out, k) {
    const jr = JRLL[f] - x - y;
    let nr, z, st;
    if (jr < 1) { nr = jr; const t2 = nr * nr / 3; z = 1 - t2; st = Math.sqrt(t2 * (2 - t2)); }
    else if (jr > 3) { nr = 4 - jr; const t2 = nr * nr / 3; z = t2 - 1; st = Math.sqrt(t2 * (2 - t2)); }
    else { nr = 1; z = (2 - jr) * 2 / 3; st = Math.sqrt(1 - z * z); }
    let tmp = JPLL[f] * nr + x - y;
    if (tmp < 0) tmp += 8;
    if (tmp >= 8) tmp -= 8;
    const phi = nr < 1e-15 ? 0 : (Math.PI / 4) * tmp / nr;
    out[k] = st * Math.cos(phi); out[k + 1] = st * Math.sin(phi); out[k + 2] = z;
  }
  const RASSEGNE = {
    dss: { basi: ["https://skies.esac.esa.int/DSSColor/", "https://alasky.cds.unistra.fr/DSS/DSSColor/", "https://alaskybis.cds.unistra.fr/DSS/DSSColor/"], max: 9, ext: "jpg",
      allsky: true, firma: "DSS2 · STScI/NASA · CDS" },
    legacy: { basi: ["https://alasky.cds.unistra.fr/DESI-legacy-surveys/DR10/CDS_P_DESI-Legacy-Surveys_DR10_color/"], max: 11, ext: "png",
      allsky: false, firma: "Legacy Surveys / D. Lang (Perimeter Institute)" },
  };
  const urlTassello = (r, i, o, n) => `${r.basi[i]}Norder${o}/Dir${Math.floor(n / 10000) * 10000}/Npix${n}.${r.ext}`;
  let VERSO = 4;
  let uvCache = {};
  function uvDa(a, b) {
    let p = a, q = b;
    if (VERSO & 4) { const s = p; p = q; q = s; }
    if (VERSO & 1) p = 1 - p;
    if (VERSO & 2) q = 1 - q;
    return [p, q];
  }
  const VS = `attribute vec3 a_v; attribute vec2 a_uv; uniform mat3 u_rot; uniform vec2 u_s; uniform float u_k; varying vec2 v_uv;
    void main() { vec3 p = u_rot * a_v; gl_Position = vec4(-p.x * u_s.x, p.y * u_s.y, 0.0, mix(p.z, (1.0 + p.z) * 0.5, u_k)); v_uv = a_uv; }`;
  const FS = `precision mediump float; uniform sampler2D u_t; uniform float u_a; uniform vec2 u_lv; varying vec2 v_uv;
    void main() { vec4 c = texture2D(u_t, v_uv); gl_FragColor = vec4(clamp((c.rgb - u_lv.x) * u_lv.y, 0.0, 1.0), c.a * u_a); }`;
  function crea(tela, quando) {
    let gl = null;
    try { gl = tela.getContext("webgl", { alpha: true, premultipliedAlpha: false, antialias: false, preserveDrawingBuffer: true })
      || tela.getContext("experimental-webgl"); } catch (e) { gl = null; }
    if (!gl) return null;
    let aV, aUV, uRot, uS, uA, uK, uLv, bufV, bufUV, indici = {};
    function prepara() {
      const shader = (tipo, testo) => { const s = gl.createShader(tipo); gl.shaderSource(s, testo); gl.compileShader(s); return s; };
      const prog = gl.createProgram();
      gl.attachShader(prog, shader(gl.VERTEX_SHADER, VS)); gl.attachShader(prog, shader(gl.FRAGMENT_SHADER, FS)); gl.linkProgram(prog);
      if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) return false;
      gl.useProgram(prog);
      aV = gl.getAttribLocation(prog, "a_v"); aUV = gl.getAttribLocation(prog, "a_uv");
      uRot = gl.getUniformLocation(prog, "u_rot"); uS = gl.getUniformLocation(prog, "u_s"); uA = gl.getUniformLocation(prog, "u_a");
      uK = gl.getUniformLocation(prog, "u_k"); uLv = gl.getUniformLocation(prog, "u_lv");
      gl.enable(gl.BLEND); gl.blendFuncSeparate(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
      bufV = gl.createBuffer(); bufUV = gl.createBuffer(); indici = {};
      return true;
    }
    if (!prepara()) return null;
    const maglia = n => {
      if (indici[n]) return indici[n];
      const idx = new Uint16Array(n * n * 6);
      let q = 0;
      for (let j = 0; j < n; j++) for (let i = 0; i < n; i++) {
        const a = j * (n + 1) + i, b = a + 1, c = a + n + 1, d = c + 1;
        idx[q++] = a; idx[q++] = b; idx[q++] = d; idx[q++] = a; idx[q++] = d; idx[q++] = c;
      }
      const buf = gl.createBuffer();
      gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, buf); gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, idx, gl.STATIC_DRAW);
      return (indici[n] = { buf, n: idx.length });
    };
    const forme = new Map();
    const forma = (o, n, m) => {
      const chiave = o + "/" + n;
      let v = forme.get(chiave);
      if (!v) {
        const [ix, iy, f] = nest2xyf(n, o), ns = 1 << o;
        v = new Float32Array((m + 1) * (m + 1) * 3);
        for (let j = 0, k = 0; j <= m; j++) for (let i = 0; i <= m; i++, k += 3) xyf2vec((ix + i / m) / ns, (iy + j / m) / ns, f, v, k);
        forme.set(chiave, v);
        if (forme.size > 1500) forme.delete(forme.keys().next().value);
      }
      return v;
    };
    const cache = new Map();
    let inCorso = 0, coda = [], richiesta = 0, ultimaG = null, attivi = [];
    let vista = [], avvisato = false;
    const allsky = {};
    tela.addEventListener("webglcontextlost", e => e.preventDefault());
    tela.addEventListener("webglcontextrestored", () => {
      cache.clear(); coda = [];
      for (const nr of Object.keys(allsky)) delete allsky[nr];
      if (prepara()) rinfresca();
    });
    function texture(img) {
      const tex = gl.createTexture();
      gl.bindTexture(gl.TEXTURE_2D, tex);
      gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, false);
      gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, img);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
      return tex;
    }
    function carica(nr, r, o, n) {
      const chiave = `${nr}|${o}|${n}`;
      if (cache.has(chiave)) return null;
      const voce = { stato: 0, tex: null, t0: 0, usato: performance.now() };
      cache.set(chiave, voce);
      coda.push({ chiave, nr, r, o, n, voce, priorita: 1e9 });
      return coda[coda.length - 1];
    }
    function scarica() {
      coda = coda.filter(x => {
        const resta = x.voce.usato >= richiesta - 1;
        if (!resta) cache.delete(x.chiave);
        return resta;
      });
      coda.sort((a, b) => a.priorita - b.priorita);
      while (inCorso < 10 && coda.length) {
        const x = coda.shift(), len = x.r.basi.length, da = x.r.buona || 0;
        inCorso++;
        const img = new Image();
        img.crossOrigin = "anonymous";
        let prova = 0;
        const chiedi = () => { img.src = urlTassello(x.r, (da + prova) % len, x.o, x.n); };
        img.onload = () => {
          inCorso--;
          if (prova) x.r.buona = (da + prova) % len;
          if (cache.get(x.chiave) !== x.voce) { scarica(); return; }
          x.voce.tex = texture(img); x.voce.stato = 1; x.voce.t0 = performance.now();
          if (quando && quando.pronto) quando.pronto();
          rinfresca(); scarica();
        };
        img.onerror = () => {
          if (++prova < len) { chiedi(); return; }
          inCorso--; x.voce.stato = 2; x.voce.t0 = performance.now(); scarica();
          controlla(x.nr);
        };
        chiedi();
      }
    }
    function controlla(nr) {
      let ok = 0, ko = 0;
      for (const v of vista) { if (v.stato === 1) ok++; else if (v.stato === 2) ko++; }
      if (vista.length && !ok && ko >= Math.min(12, vista.length)) segnala(nr);
    }
    function segnala(nr) { if (!avvisato && quando && quando.errore) { avvisato = true; quando.errore(nr); } }
    function riprova() {
      for (const [k, v] of cache) if (v.stato === 2) cache.delete(k);
      for (const nr of Object.keys(allsky)) if (allsky[nr].fallito) delete allsky[nr];
    }
    let soloAllsky = new Set();
    function caricaAllsky(nr, r) {
      const vecchia = allsky[nr];
      if (vecchia && !(vecchia.fallito && performance.now() - vecchia.t0 > 15000)) return;
      const a = allsky[nr] = { tex: null }, len = r.basi.length, da = r.buona || 0;
      const img = new Image();
      img.crossOrigin = "anonymous";
      let prova = 0;
      const chiedi = () => { img.src = `${r.basi[(da + prova) % len]}Norder3/Allsky.${r.ext}`; };
      img.onerror = () => {
        if (++prova < len) { chiedi(); return; }
        if (allsky[nr] !== a) return;
        a.fallito = true; a.t0 = performance.now();
        if (soloAllsky.has(nr)) segnala(nr);
      };
      img.onload = () => {
        if (prova) r.buona = (da + prova) % len;
        if (allsky[nr] !== a) return;
        const colonne = 27, lato = img.width / colonne;
        Object.assign(a, { tex: texture(img), w: img.width, h: img.height, lato, colonne, t0: performance.now() });
        if (quando && quando.pronto) quando.pronto();
        rinfresca();
      };
      chiedi();
    }
    function pulisci() {
      if (cache.size < 450) return;
      const vecchi = [...cache.entries()].filter(([, v]) => v.stato !== 0).sort((a, b) => a[1].usato - b[1].usato).slice(0, cache.size - 380);
      for (const [k, v] of vecchi) { if (v.tex) gl.deleteTexture(v.tex); cache.delete(k); }
    }
    let fotogramma = 0, riserva = 0;
    function rinfresca() {
      if (fotogramma || !ultimaG) return;
      const vai = () => { cancelAnimationFrame(fotogramma); clearTimeout(riserva); fotogramma = 0; disegnaOra(ultimaG); };
      fotogramma = requestAnimationFrame(vai);
      riserva = setTimeout(vai, 150);
    }
    function disegna(g, strati) {
      ultimaG = g; attivi = strati || attivi; avvisato = false;
      rinfresca();
    }
    function disegnaOra(g) {
      if (gl.isContextLost()) { segnala(attivi[0]); return; }
      if (tela.width !== g.W || tela.height !== g.H) { tela.width = g.W; tela.height = g.H; }
      gl.viewport(0, 0, g.W, g.H);
      gl.clearColor(0, 0, 0, 0); gl.clear(gl.COLOR_BUFFER_BIT);
      let c, e, nn;
      if (g.assi) [e, nn, c] = g.assi;
      else {
        const a0 = g.ra * RAD, d0 = g.dec * RAD, ca = Math.cos(a0), sa = Math.sin(a0), cd = Math.cos(d0), sd = Math.sin(d0);
        c = [cd * ca, cd * sa, sd]; e = [-sa, ca, 0]; nn = [-sd * ca, -sd * sa, cd];
      }
      gl.uniform1f(uK, g.stereo ? 1 : 0);
      gl.uniform2f(uLv, g.livelli ? g.livelli[0] : 0, g.livelli ? g.livelli[1] : 1);
      gl.uniformMatrix3fv(uRot, false, new Float32Array([e[0], nn[0], c[0], e[1], nn[1], c[1], e[2], nn[2], c[2]]));
      const cdr = g.cdelt * RAD;
      gl.uniform2f(uS, 2 / (g.W * cdr), 2 / (g.H * cdr));
      richiesta++;
      const ora = performance.now(), voci = [];
      let anima = false;
      soloAllsky = new Set();
      const passo = Math.max(24, Math.min(g.W, g.H) / 14);
      const punti = [];
      for (let y = 0; y <= g.H + 0.1; y += Math.min(passo, g.H / Math.ceil(g.H / passo))) for (let x = 0; x <= g.W + 0.1; x += Math.min(passo, g.W / Math.ceil(g.W / passo))) {
        let X = -(x - g.W / 2) * cdr, Y = -(y - g.H / 2) * cdr, Z = 1;
        if (g.stereo) {
          const rr = Math.hypot(X, Y), th = 2 * Math.atan(rr / 2), f = rr > 1e-9 ? Math.sin(th) / rr : 1;
          X *= f; Y *= f; Z = Math.cos(th);
        }
        const v = [Z * c[0] + X * e[0] + Y * nn[0], Z * c[1] + X * e[1] + Y * nn[1], Z * c[2] + X * e[2] + Y * nn[2]];
        const l = Math.hypot(v[0], v[1], v[2]);
        punti.push([v[2] / l, Math.atan2(v[1], v[0]), Math.hypot(x - g.W / 2, y - g.H / 2)]);
      }
      for (const nr of attivi) {
        const r = RASSEGNE[nr];
        if (!r) continue;
        if (r.allsky) caricaAllsky(nr, r);
        const o = clamp(Math.ceil(Math.log2(1.0233 / (512 * cdr * 1.15))), 3, r.max);
        const grezzo = !!(g.grezzo && r.allsky && Math.log2(1.0233 / (512 * cdr * 1.15)) < 0.6);
        if (grezzo) {
          soloAllsky.add(nr);
          if (allsky[nr] && allsky[nr].fallito) segnala(nr);
        }
        const vis = new Map();
        for (const [z, phi, dist] of punti) {
          const n = ang2nest(o, z, phi);
          if (!vis.has(n) || vis.get(n) > dist) vis.set(n, dist);
        }
        const m = o <= 4 ? 16 : o <= 6 ? 10 : 6, ib = maglia(m);
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, ib.buf);
        for (const [n, dist] of vis) {
          const chiave = `${nr}|${o}|${n}`;
          if (grezzo) { sostituto(nr, r, o, n, m, ib); continue; }
          let voce = cache.get(chiave);
          if (voce && voce.stato === 2 && ora - voce.t0 > 15000) { cache.delete(chiave); voce = null; }
          if (!voce) { carica(nr, r, o, n).priorita = dist; voce = cache.get(chiave); }
          voce.usato = richiesta;
          voci.push(voce);
          const pronta = voce.stato === 1, alfa = pronta ? Math.min(1, (ora - voce.t0) / 220) : 0;
          if (alfa < 1) {
            if (!sostituto(nr, r, o, n, m, ib)) {   }
            if (pronta) anima = true;
          }
          if (pronta) disegnaMaglia(forma(o, n, m), uvPropri(m), voce.tex, alfa, ib);
        }
      }
      vista = voci;
      scarica(); pulisci();
      controlla(attivi[0]);
      if (anima) rinfresca();
    }
    function uvPropri(m) {
      if (uvCache[m]) return uvCache[m];
      const uv = new Float32Array((m + 1) * (m + 1) * 2);
      const mezzo = 0.5 / 512;
      for (let j = 0, k = 0; j <= m; j++) for (let i = 0; i <= m; i++, k += 2) {
        const [u, v] = uvDa(i / m, j / m);
        uv[k] = mezzo + u * (1 - 2 * mezzo); uv[k + 1] = mezzo + v * (1 - 2 * mezzo);
      }
      return (uvCache[m] = uv);
    }
    function sostituto(nr, r, o, n, m, ib) {
      const [ix, iy] = nest2xyf(n, o);
      for (let d = 1; o - d >= 3; d++) {
        const p = n >> (2 * d), v = cache.get(`${nr}|${o - d}|${p}`);
        if (v && v.stato === 1) {
          const lato = 1 << d, ox = ix & (lato - 1), oy = iy & (lato - 1);
          const uv = new Float32Array((m + 1) * (m + 1) * 2);
          for (let j = 0, k = 0; j <= m; j++) for (let i = 0; i <= m; i++, k += 2) {
            const [u, w] = uvDa((ox + i / m) / lato, (oy + j / m) / lato);
            uv[k] = u; uv[k + 1] = w;
          }
          v.usato = richiesta;
          disegnaMaglia(forma(o, n, m), uv, v.tex, 1, ib);
          return true;
        }
      }
      const a = allsky[nr];
      if (a && a.tex) {
        const d = o - 3, p = n >> (2 * d), lato = 1 << d, ox = ix & (lato - 1), oy = iy & (lato - 1);
        const col = p % a.colonne, riga = Math.floor(p / a.colonne);
        const uv = new Float32Array((m + 1) * (m + 1) * 2);
        for (let j = 0, k = 0; j <= m; j++) for (let i = 0; i <= m; i++, k += 2) {
          const [u, w] = uvDa((ox + i / m) / lato, (oy + j / m) / lato);
          uv[k] = (col + 0.004 + u * 0.992) * a.lato / a.w; uv[k + 1] = (riga + 0.004 + w * 0.992) * a.lato / a.h;
        }
        disegnaMaglia(forma(o, n, m), uv, a.tex, 1, ib);
        return true;
      }
      return false;
    }
    function disegnaMaglia(vert, uv, tex, alfa, ib) {
      gl.bindBuffer(gl.ARRAY_BUFFER, bufV); gl.bufferData(gl.ARRAY_BUFFER, vert, gl.DYNAMIC_DRAW);
      gl.enableVertexAttribArray(aV); gl.vertexAttribPointer(aV, 3, gl.FLOAT, false, 0, 0);
      gl.bindBuffer(gl.ARRAY_BUFFER, bufUV); gl.bufferData(gl.ARRAY_BUFFER, uv, gl.DYNAMIC_DRAW);
      gl.enableVertexAttribArray(aUV); gl.vertexAttribPointer(aUV, 2, gl.FLOAT, false, 0, 0);
      gl.activeTexture(gl.TEXTURE0); gl.bindTexture(gl.TEXTURE_2D, tex);
      gl.uniform1f(uA, alfa);
      gl.drawElements(gl.TRIANGLES, ib.n, gl.UNSIGNED_SHORT, 0);
    }
    return { disegna, rinfresca, riprova, firma: nr => (RASSEGNE[nr] || {}).firma || "" };
  }
  return { crea, RASSEGNE, ang2nest, nest2xyf, xyf2vec, verso: v => { if (v != null) { VERSO = v; uvCache = {}; } return VERSO; } };
})();
const OBIETTIVI = [
  ["Samyang 135mm f/2 ED UMC", 135, 2, "Rokinon"], ["Samyang 85mm f/1.4", 85, 1.4, "Rokinon"], ["Samyang 50mm f/1.4", 50, 1.4, "Rokinon"],
  ["Samyang 35mm f/1.4", 35, 1.4, "Rokinon"], ["Samyang 24mm f/1.4", 24, 1.4, "Rokinon"], ["Samyang 20mm f/1.8", 20, 1.8, "Rokinon"],
  ["Samyang 14mm f/2.8", 14, 2.8, "Rokinon"], ["Samyang 12mm f/2 (APS-C)", 12, 2, "Rokinon"], ["Samyang AF 135mm f/1.8", 135, 1.8, "Rokinon"],
  ["Samyang AF 75mm f/1.8", 75, 1.8, "Rokinon"],
  ["Sigma 135mm f/1.8 DG HSM Art", 135, 1.8, ""], ["Sigma 105mm f/1.4 DG HSM Art", 105, 1.4, "Bokeh Master"],
  ["Sigma 85mm f/1.4 DG DN Art", 85, 1.4, ""], ["Sigma 50mm f/1.4 DG DN Art", 50, 1.4, ""], ["Sigma 40mm f/1.4 DG HSM Art", 40, 1.4, ""],
  ["Sigma 35mm f/1.4 DG DN Art", 35, 1.4, ""], ["Sigma 24mm f/1.4 DG DN Art", 24, 1.4, ""], ["Sigma 20mm f/1.4 DG DN Art", 20, 1.4, ""],
  ["Sigma 14mm f/1.4 DG DN Art", 14, 1.4, ""], ["Sigma 14mm f/1.8 DG HSM Art", 14, 1.8, ""], ["Sigma 150-600mm (a 600 mm f/6.3)", 600, 6.3, "Sports Contemporary"],
  ["Sigma 60-600mm (a 600 mm f/6.3)", 600, 6.3, "Sports"],
  ["Canon EF 135mm f/2L USM", 135, 2, ""], ["Canon EF 200mm f/2.8L II USM", 200, 2.8, ""], ["Canon EF 300mm f/4L IS USM", 300, 4, ""],
  ["Canon EF 400mm f/5.6L USM", 400, 5.6, ""], ["Canon RF 135mm f/1.8L IS USM", 135, 1.8, ""], ["Canon RF 100-500mm (a 500 mm f/7.1)", 500, 7.1, ""],
  ["Canon RF 600mm f/11", 600, 11, ""], ["Canon RF 800mm f/11", 800, 11, ""], ["Canon RF 200-800mm (a 800 mm f/9)", 800, 9, ""],
  ["Nikon Z 135mm f/1.8 S Plena", 135, 1.8, ""], ["Nikon Z 180-600mm (a 600 mm f/6.3)", 600, 6.3, ""], ["Nikon AF-S 200-500mm (a 500 mm f/5.6)", 500, 5.6, ""],
  ["Nikon AF-S 105mm f/1.4E", 105, 1.4, ""], ["Nikon Z 20mm f/1.8 S", 20, 1.8, ""], ["Nikon Z 14-24mm f/2.8 S", 14, 2.8, ""],
  ["Sony FE 135mm f/1.8 GM", 135, 1.8, ""], ["Sony FE 200-600mm (a 600 mm f/6.3)", 600, 6.3, ""], ["Sony FE 24mm f/1.4 GM", 24, 1.4, ""],
  ["Sony FE 20mm f/1.8 G", 20, 1.8, ""], ["Sony FE 14mm f/1.8 GM", 14, 1.8, ""],
  ["Tamron 150-600mm G2 (a 600 mm f/6.3)", 600, 6.3, ""], ["Laowa 15mm f/2 Zero-D", 15, 2, "Venus Optics"],
  ["Viltrox 135mm f/1.8 LAB", 135, 1.8, ""], ["Viltrox 85mm f/1.8", 85, 1.8, ""],
];
function obiettiviPerRicerca() {
  if (!obiettiviPerRicerca._l) {
    const visti = new Set(OBIETTIVI.map(([t0]) => attaccato(normParole(t0))));
    const altri = ((DATI.noti && DATI.noti.obiettivi) || []).filter(x => !visti.has(attaccato(normParole(x.t)))).map(x => [x.t, x.F, x.N, ""]);
    obiettiviPerRicerca._l = [...OBIETTIVI, ...altri].map(([t0, F, N, alias]) => ({ t: t0, v: alias, D: Math.round(F / N * 10) / 10, F,
      tipo: "obiettivo", h: null, foto: (DATI.fotoObiettivi || {})[t0] || null }));
  }
  return obiettiviPerRicerca._l;
}
const eBundle = x => /^bundle\b/i.test((x && x.t) || "");
const PAROLE_TEL = /^(telescopio|telescopi|doppietto|tripletto|rifrattore|apocromatico|acromatico|solare|tubo|ottico|ota)$/i;
const marcaTel = x => (String((x && x.t) || "").split(/\s+/).find(p => p && !PAROLE_TEL.test(p)) || "").toLowerCase();
function telescopiSenzaPacchetti() {
  if (telescopiSenzaPacchetti._l) return telescopiSenzaPacchetti._l;
  const l = DATI.telescopi || [], kit = x => /\s\+\s/.test(x.t || "") && !/2-in-1/i.test(x.t || ""), expo = x => /\bexpo\b|ex esposizione/i.test(x.t || "");
  const stesso = (x, y) => y !== x && !expo(y) && !eBundle(y) && y.D === x.D && y.F === x.F && marcaTel(y) === marcaTel(x);
  const tenuti = l.filter(x => !eBundle(x) && !(expo(x) && l.some(y => stesso(x, y))) && !(kit(x) && l.some(y => stesso(x, y) && !kit(y))));
  if (l.length) telescopiSenzaPacchetti._l = tenuti;
  return tenuti;
}
function cercaTelescopi(q, max) {
  const testo = x => `${x.t} ${x.v || ""} ${x.D}/${x.F} ${Math.round(x.D)} ${x.tipo === "obiettivo" ? t("obiettivo") + " " + x.F + "mm" : Math.round(x.D) + "mm"}`;
  const elenco = [...telescopiSenzaPacchetti(), ...telescopiNoti(), ...obiettiviPerRicerca()], r = cercaInElenco(elenco, q, max || 40, testo);
  return r.length ? r : cercaInElencoTollerante(elenco, q, max || 40, testo);
}
function rigaTelescopio(x) {
  return x.tipo === "obiettivo" ? `${t("obiettivo")} · ${num(x.F)} mm f/${num(x.F / x.D, 1)}` : `${num(x.D)}/${num(x.F)} mm · f/${num(x.F / x.D, 1)}`;
}
Object.assign(TESTI.it, { df_aperto: "aperto", df_altro: "Altro…", df_scelto: "scelto da te", df_scrivi: "Scrivi il diaframma, da f/{a} a f/32", df_ok: "Usa", df_fuori: "Deve stare fra f/{a} (tutto aperto) e f/32.", rq_obiettivo: "Obiettivo",
  df_n: "Chiudere di uno stop (es. f/2 → f/2,8) dà stelle più puntiformi fino ai bordi e meno aloni colorati, ma servono pose lunghe il doppio. Il campo inquadrato non cambia." });
Object.assign(TESTI.de, { df_aperto: "offen", df_altro: "Andere…", df_scelto: "Ihre Wahl", df_scrivi: "Blende eingeben, von f/{a} bis f/32", df_ok: "Übernehmen", df_fuori: "Muss zwischen f/{a} (offen) und f/32 liegen.", rq_obiettivo: "Objektiv",
  df_n: "Abblenden um eine Stufe (z. B. f/2 → f/2,8) sorgt für punktförmigere Sterne bis zum Rand und weniger Farbsäume, erfordert aber doppelt so lange Belichtungen. Das Bildfeld ändert sich nicht." });
Object.assign(TESTI.es, { df_aperto: "abierto", df_altro: "Otro…", df_scelto: "elegido por ti", df_scrivi: "Escribe el diafragma, de f/{a} a f/32", df_ok: "Usar", df_fuori: "Debe estar entre f/{a} (abierto) y f/32.", rq_obiettivo: "Objetivo",
  df_n: "Cerrar un paso (p. ej. f/2 → f/2,8) da estrellas más puntuales hasta los bordes y menos halos de color, pero hacen falta exposiciones el doble de largas. El campo encuadrado no cambia." });
Object.assign(TESTI.en, { df_aperto: "wide open", df_altro: "Other…", df_scelto: "your choice", df_scrivi: "Type the f-number, from f/{a} to f/32", df_ok: "Use", df_fuori: "It must be between f/{a} (wide open) and f/32.", rq_obiettivo: "Lens",
  df_n: "Stopping down one stop (e.g. f/2 → f/2.8) gives more pinpoint stars right to the edges and less colour fringing, but you need exposures twice as long. The field of view doesn't change." });
const STOP_DIAFRAMMA = [1.4, 2, 2.8, 4, 5.6, 8, 11, 16];
const eObiettivo = tel => !!(tel && (tel.obiettivo || tel.lente));
function bottoniDiaframma(tel, cambia) {
  if (!eObiettivo(tel) || !(tel.F > 0) || !(tel.D > 0)) return null;
  const ora = Math.round(tel.F / tel.D * 10) / 10, aperto = tel.Nmax || ora;
  const scelte = [aperto, ...STOP_DIAFRAMMA.filter(n => n > aperto + 0.05)].slice(0, 5);
  if (scelte.length < 2) return null;
  const usa = n => { tel.Nmax = aperto; tel.D = tel.F / n; cambia(); };
  const fNum = n => `f/${num(n, n % 1 ? 1 : 0)}`, a = num(aperto, aperto % 1 ? 1 : 0);
  const mio = !scelte.some(n => Math.abs(n - ora) < 0.05);
  const campo = el("input", { type: "text", inputmode: "decimal", class: "gas-input", value: mio ? num(ora, 1) : "", placeholder: num(aperto * 1.2, 1) });
  const avviso = el("p", { class: "gas-nota gas-diaframma-errore", hidden: true });
  const conferma = () => {
    const n = parseFloat(String(campo.value).replace(",", "."));
    if (!(n >= aperto - 0.01 && n <= 32)) { avviso.textContent = t("df_fuori", { a }); avviso.hidden = false; return; }
    usa(Math.round(n * 10) / 10);
  };
  campo.addEventListener("keydown", e => { if (e.key === "Enter") { e.preventDefault(); conferma(); } });
  const riga = el("div", { class: "gas-diaframma-altro", hidden: !mio },
    el("label", null, el("span", null, t("df_scrivi", { a })), el("span", { class: "gas-df-campo" }, "f/", campo)),
    el("button", { type: "button", class: "gas-btn gas-btn--mini", onclick: conferma }, t("df_ok")), avviso);
  const altro = el("button", { type: "button", class: mio ? "on" : "", "aria-pressed": String(mio), "aria-expanded": String(mio),
    onclick: () => { riga.hidden = !riga.hidden; altro.setAttribute("aria-expanded", String(!riga.hidden)); if (!riga.hidden) campo.focus(); } },
    el("b", null, mio ? fNum(ora) : t("df_altro")), el("small", null, mio ? t("df_scelto") : "f/…"));
  return el("div", { class: "gas-config gas-diaframma" }, el("small", null, t("diaframma")),
    el("div", { class: "gas-seg gas-seg--config", role: "group", "aria-label": t("diaframma") }, scelte.map(n => {
      const on = Math.abs(n - ora) < 0.05;
      return el("button", { type: "button", class: on ? "on" : "", "aria-pressed": String(on), onclick: () => { if (!on) usa(n); } },
        el("b", null, fNum(n)), el("small", null, n === aperto ? t("df_aperto") : `⌀ ${num(tel.F / n)} mm`));
    }), altro), riga, el("p", { class: "gas-nota gas-diaframma-n" }, t("df_n")));
}
function configurazioni(h) {
  if (!h) return [];
  const l = DATI.telescopi.filter(y => y.h === h);
  return l.length > 1 ? l : [];
}
function nomeConfigurazione(x) { const p = String(x.t).split(" – "); return p.length > 2 ? p[p.length - 1] : ""; }
function titoloTelescopio(x) {
  const c = configurazioni(x.h).length ? nomeConfigurazione(x) : "";
  return c ? `${nomeCorto(x.t)} · ${c}` : x.t;
}
function nomeTel(tel) { return tel && tel.h ? titoloTelescopio({ t: tel.nome, h: tel.h }) : tel ? tel.nome : ""; }
function telDaVoce(x) {
  const tel = { nome: titoloTelescopio(x), D: x.D, F: x.F, h: x.h, foto: x.foto, smart: x.tipo === "smart" };
  if (x.tipo === "obiettivo") tel.obiettivo = true;
  return tel;
}
function bottoniConfigurazione(dopo) {
  const conf = CAMPO.tel ? configurazioni(CAMPO.tel.h) : [];
  if (!conf.length) return null;
  return el("div", { class: "gas-config" }, el("small", null, t("configurazione")),
    el("div", { class: "gas-seg gas-seg--config", role: "group", "aria-label": t("configurazione") }, conf.map(x => {
      const on = x.D === CAMPO.tel.D && x.F === CAMPO.tel.F;
      return el("button", { type: "button", class: on ? "on" : "", "aria-pressed": String(on),
        onclick: () => { if (!on) { scegliTelescopio(x); dopo(); } } },
        el("b", null, nomeConfigurazione(x)), el("small", null, `${num(x.D)}/${num(x.F)} mm · f/${num(x.F / x.D, 1)}`));
    })));
}
const giaInNegozio = (negozio, x, campo, tolleranza, chiave) => (negozio || []).some(n => Math.abs((n[campo] || 0) - x[campo]) <= tolleranza &&
  (!chiave || attaccato(normParole(n.t)).includes(attaccato(normParole(chiave)))));
const parolaChiave = (t, marca) => (normParole(t).replace(normParole(marca || ""), "").match(/[a-z0-9][a-z0-9\-]+/g) || [""])
  .sort((a, b) => b.length - a.length)[0];
function cercaOculari(q, max) {
  const testo = x => `${x.t} ${x.v || ""} ${x.f}mm ${x.afov}°`;
  const doppione = (x, fra) => fra.some(n => Math.abs(n.f - x.f) < 0.05 && Math.abs((n.afov || 0) - x.afov) <= 3 &&
    attaccato(normParole(n.t)).includes(attaccato(normParole(x.chiave || ""))) &&
    attaccato(normParole(`${n.t} ${n.v || ""}`)).includes(attaccato(normParole(x.t).split(/\s+/)[0] || "")));
  const negozio = cercaInElenco(DATI.oculari || [], q, max || 40, testo);
  const noti = cercaInElenco((DATI.noti && DATI.noti.oculari) || [], q, 80, testo).filter(x => !doppione(x, negozio));
  const r = [...negozio, ...noti].slice(0, max || 40);
  if (r.length) return r;
  const neg = DATI.oculari || [], tt = cercaInElencoTollerante([...neg, ...((DATI.noti && DATI.noti.oculari) || [])], q, max || 40, testo);
  const tn = tt.filter(x => neg.includes(x));
  return tt.filter(x => neg.includes(x) || !doppione(x, tn));
}
function cercaOttiche(q, max) {
  const testo = x => `${x.t} ${x.v || ""} ${x.k}x ${String(x.k).replace(".", ",")}x ${x.per || ""}`;
  const negozio = cercaInElenco(DATI.ottiche || [], q, 400, testo);
  const stessaMarca = (n, x) => { const m = attaccato(normParole(x.v || "")); return !m || attaccato(normParole(`${n.t} ${n.v || ""}`)).includes(m); };
  const noti = cercaInElenco((DATI.noti && DATI.noti.ottiche) || [], q, 400, testo)
    .filter(x => !giaInNegozio((DATI.ottiche || []).filter(n => stessaMarca(n, x)), x, "k", 0.005, parolaChiave(x.t, x.v)));
  const cifre = normParole(q).trim().split(/\s+/).filter(w => reCifra(w)).map(w => new RegExp(reCifra(w).source + "(?![\\d]|[.,]\\d)"));
  const intere = x => cifre.filter(re => re.test(x._cerca || normParole(testo(x)))).length;
  const r = [...negozio, ...noti];
  if (cifre.length) r.sort((a, b) => intere(b) - intere(a));
  if (r.length) return r.slice(0, max || 30);
  const neg = DATI.ottiche || [], tutti = [...neg, ...((DATI.noti && DATI.noti.ottiche) || [])];
  const pieni = cercaInElenco(tutti, q, max || 30, testo), tt = pieni.length ? pieni : cercaInElencoTollerante(tutti, q, max || 30, testo);
  const tn = tt.filter(x => neg.includes(x));
  return tt.filter(x => neg.includes(x) || !tn.some(n => Math.abs((n.k || 0) - x.k) <= 0.005 &&
    [x.v, parolaChiave(x.t, x.v)].every(w => !w || attaccato(normParole(n.t)).includes(attaccato(normParole(w))))));
}
function telescopiNoti() {
  if (!telescopiNoti._l) {
    const neg = DATI.telescopi || [];
    telescopiNoti._l = ((DATI.noti && DATI.noti.telescopi) || []).filter(x => !neg.some(n => Math.abs(n.D - x.D) <= 1 && Math.abs(n.F - x.F) <= 5 &&
      attaccato(normParole(n.t)).includes(attaccato(parolaChiave(x.t, x.v)))));
  }
  return telescopiNoti._l;
}
const montatureNote = () => (DATI.noti && DATI.noti.montature) || [];
function filtroNoto(nome) {
  if (!filtroNoto._m) filtroNoto._m = new Map(((DATI.noti && DATI.noti.filtri) || []).map(f => [attaccato(normParole(f.nome)), f]));
  return filtroNoto._m.get(attaccato(normParole(nome))) || null;
}
const ICONE_SVG = {
  home: '<rect x="4" y="4" width="6.6" height="6.6" rx="1.6"/><rect x="13.4" y="4" width="6.6" height="6.6" rx="1.6"/><rect x="4" y="13.4" width="6.6" height="6.6" rx="1.6"/><rect x="13.4" y="13.4" width="6.6" height="6.6" rx="1.6"/>',
  campo: '<path d="M4 8.5V5.6A1.6 1.6 0 0 1 5.6 4h2.9M15.5 4h2.9A1.6 1.6 0 0 1 20 5.6v2.9M20 15.5v2.9a1.6 1.6 0 0 1-1.6 1.6h-2.9M8.5 20H5.6A1.6 1.6 0 0 1 4 18.4v-2.9"/><path class="pieno" d="M12 8.2l1.1 2.2 2.4.35-1.75 1.7.42 2.4L12 13.7l-2.17 1.15.42-2.4-1.75-1.7 2.4-.35z"/>',
  stanotte: '<path d="M19.6 13.6A7.8 7.8 0 1 1 10.4 4.4a6.1 6.1 0 0 0 9.2 9.2z"/><path class="pieno" d="M17.2 3.2l.55 1.25 1.25.55-1.25.55-.55 1.25-.55-1.25L15.4 5l1.25-.55z"/><circle class="pieno" cx="20.6" cy="9.3" r=".95"/>',
  meteo: '<path d="M15.2 3.9a3.7 3.7 0 0 0 4.6 4.6 4.1 4.1 0 1 1-4.6-4.6z"/><path d="M7.3 19.5h9.2a3.7 3.7 0 0 0 .4-7.4 5.3 5.3 0 0 0-10.1 1.4 3 3 0 0 0 .5 6z"/>',
  planetario: '<circle cx="12" cy="12" r="8.8"/><path d="M3.6 14.2c2.6 1.3 5.4 1.9 8.4 1.9s5.8-.6 8.4-1.9"/><path class="pieno" d="M9.2 6.6l.5 1.1 1.1.5-1.1.5-.5 1.1-.5-1.1-1.1-.5 1.1-.5z"/><circle class="pieno" cx="15.4" cy="8.2" r="1"/><circle class="pieno" cx="13.2" cy="11.4" r=".8"/><circle class="pieno" cx="7.2" cy="11.2" r=".7"/><circle class="pieno" cx="17.4" cy="11.6" r=".7"/>',
  lunasole: '<circle cx="12" cy="12" r="8.4"/><path class="pieno" d="M12 3.6a8.4 8.4 0 0 1 0 16.8z"/>',
  camere: '<circle cx="12" cy="12" r="8.6"/><rect x="8.5" y="8.5" width="7" height="7" rx="1.2"/><path d="M12 3.4v1.8M12 18.8v1.8"/>',
  calcolatori: '<rect x="5.2" y="3" width="13.6" height="18" rx="2.2"/><rect x="8" y="5.8" width="8" height="3.4" rx=".8"/><circle class="pieno" cx="9" cy="13" r=".95"/><circle class="pieno" cx="12" cy="13" r=".95"/><circle class="pieno" cx="15" cy="13" r=".95"/><circle class="pieno" cx="9" cy="16.6" r=".95"/><circle class="pieno" cx="12" cy="16.6" r=".95"/><circle class="pieno" cx="15" cy="16.6" r=".95"/>',
  software: '<rect x="3" y="4.4" width="18" height="12.2" rx="1.8"/><path d="M9 20.2h6M12 16.6v3.6M10.2 8.4l-2.1 2.1 2.1 2.1M13.8 8.4l2.1 2.1-2.1 2.1"/>',
  guida: '<path d="M4 9.6v4.8h3.4l4.6 4V5.6L7.4 9.6z"/><path d="M15.4 9.1a4.1 4.1 0 0 1 0 5.8M17.9 6.6a7.6 7.6 0 0 1 0 10.8"/>',
  rosso: '<path d="M2.6 12S6.1 5.6 12 5.6 21.4 12 21.4 12 17.9 18.4 12 18.4 2.6 12 2.6 12z"/><circle cx="12" cy="12" r="2.9"/>',
  meno: '<path d="M5.5 12h13"/>',
  piu: '<path d="M12 5.5v13M5.5 12h13"/>',
  centro: '<circle cx="12" cy="12" r="5.6"/><path d="M12 2.8v4M12 17.2v4M2.8 12h4M17.2 12h4"/>',
  reimposta: '<path d="M4.6 12.2a7.4 7.4 0 1 0 2.3-5.4"/><path d="M4.6 4.4v4.1h4.1"/>',
  link: '<path d="M10.2 13.8a3.9 3.9 0 0 0 5.5 0l2.8-2.8a3.9 3.9 0 0 0-5.5-5.5l-1.2 1.2"/><path d="M13.8 10.2a3.9 3.9 0 0 0-5.5 0L5.5 13a3.9 3.9 0 0 0 5.5 5.5l1.2-1.2"/>',
  condividi: '<path d="M12 14.6V3.6M7.8 7.8 12 3.6l4.2 4.2"/><path d="M5.2 12.4v6.2a1.6 1.6 0 0 0 1.6 1.6h10.4a1.6 1.6 0 0 0 1.6-1.6v-6.2"/>',
  nomi: '<path d="M3.8 7.2A1.6 1.6 0 0 1 5.4 5.6h9.2l5.6 6.4-5.6 6.4H5.4a1.6 1.6 0 0 1-1.6-1.6z"/><circle class="pieno" cx="8.4" cy="12" r="1.2"/>',
  griglia: '<circle cx="12" cy="12" r="8.6"/><path d="M3.4 12h17.2M4.9 7.4h14.2M4.9 16.6h14.2M12 3.4c-2.9 2.4-4.3 5.3-4.3 8.6s1.4 6.2 4.3 8.6M12 3.4c2.9 2.4 4.3 5.3 4.3 8.6s-1.4 6.2-4.3 8.6"/>',
  confronta: '<rect x="3" y="5.6" width="11.4" height="9" rx="1.2"/><rect x="9.6" y="9.4" width="11.4" height="9" rx="1.2" stroke-dasharray="2.4 2"/>',
  esporta: '<path d="M12 3.6v11M7.8 10.4 12 14.6l4.2-4.2"/><path d="M5 19.6h14"/>',
  indietro: '<path d="M14.6 5.4 8 12l6.6 6.6"/>',
  chiudi: '<path d="M6.4 6.4l11.2 11.2M17.6 6.4 6.4 17.6"/>',
  stella: '<path class="pieno" d="M12 3.4l2.5 5.2 5.7.8-4.1 4 1 5.6L12 16.3 6.9 19l1-5.6-4.1-4 5.7-.8z"/>',
  attrezzatura: '<path d="M3.8 12.2 15.6 6.6l1.6 3.3-11.8 5.6z"/><path d="M15.6 6.6l3-1.4 1.6 3.3-3 1.4"/><path d="M10.6 12.9 7.4 20.4M10.6 12.9l3.6 7.5M10.6 12.9v7.7"/>',
  assistente: '<path d="M4.6 5.2h14.8a1.6 1.6 0 0 1 1.6 1.6v8.6a1.6 1.6 0 0 1-1.6 1.6H10.2L5.8 20.4V17H4.6A1.6 1.6 0 0 1 3 15.4V6.8a1.6 1.6 0 0 1 1.6-1.6z"/><path class="pieno" d="M12 7.6l.85 1.85 1.85.85-1.85.85L12 13l-.85-1.85-1.85-.85 1.85-.85z"/>',
  microfono: '<rect x="9" y="3.4" width="6" height="11.2" rx="3"/><path d="M5.8 11.4a6.2 6.2 0 0 0 12.4 0M12 17.6v3M8.8 20.6h6.4"/>',
  invia: '<path d="M3.8 11.6 20.2 4.2l-4.4 15.6-3.6-6.4z"/><path d="m12.2 13.4 8-9.2"/>',
  meteora: '<path d="M10.6 13.4 19.6 4.4M13.4 15.6l6.2-6.2M8.4 10.6l6.2-6.2"/><path class="pieno" d="M7.2 12.8l1.05 2.15 2.35.35-1.7 1.65.4 2.35-2.1-1.1-2.1 1.1.4-2.35-1.7-1.65 2.35-.35z"/>',
  sole: '<circle cx="12" cy="12" r="4.2"/><path d="M12 2.8v2.4M12 18.8v2.4M2.8 12h2.4M18.8 12h2.4M5.5 5.5l1.7 1.7M16.8 16.8l1.7 1.7M5.5 18.5l1.7-1.7M16.8 7.2l1.7-1.7"/>',
  pianeta: '<circle cx="12" cy="12" r="5.4"/><path d="M6.9 14.2c-2.6 1.9-3.9 3.7-3.3 4.5 1 1.3 6.3-1.2 10.8-5.6s7-9.3 5.7-10.4c-.7-.6-2.6.4-4.6 2.3"/>',
  eclissi: '<circle cx="12" cy="12" r="8.6"/><circle class="pieno" cx="13.6" cy="10.6" r="6.4"/>',
  carrello: '<path d="M3.4 4.6h2.3l2.2 10.2a1.6 1.6 0 0 0 1.6 1.3h7.6a1.6 1.6 0 0 0 1.6-1.2l1.6-6.6H6.6"/><circle class="pieno" cx="10" cy="19.6" r="1.3"/><circle class="pieno" cx="17" cy="19.6" r="1.3"/>',
  scegli: '<path d="M3.8 12.6 14.6 7.4l1.6 3.3L5.4 15.9z"/><path d="M10 13.6 7.2 20.4M10 13.6l3.2 6.8"/><path class="pieno" d="M18.6 2.8l.8 1.8 1.8.8-1.8.8-.8 1.8-.8-1.8-1.8-.8 1.8-.8z"/><circle class="pieno" cx="20.2" cy="10.6" r="1"/>',
  cometa: '<circle class="pieno" cx="16.6" cy="7.4" r="2.6"/><circle cx="16.6" cy="7.4" r="4.4"/><path d="M13.2 10.4 3.6 20M14.8 11.8 8.4 19.4M11.8 9.2 4.2 15.6"/>',
  diario: '<path d="M6 3.6h10.8a1.6 1.6 0 0 1 1.6 1.6v15.2H7.6A1.6 1.6 0 0 1 6 18.8z"/><path d="M6 17.4a1.6 1.6 0 0 1 1.6-1.6h10.8"/><path d="M9.4 9.2l1.8 1.8 3.6-3.8"/>',
  calendario: '<rect x="3.6" y="5" width="16.8" height="15.4" rx="2"/><path d="M3.6 9.6h16.8M8.2 3.2v3.6M15.8 3.2v3.6"/><rect class="pieno" x="7" y="12.4" width="3" height="3" rx=".6"/>',
  cx_vista: '<circle cx="12" cy="12" r="8.8"/><ellipse cx="12" cy="12" rx="5.4" ry="1.9" transform="rotate(-18 12 12)"/><circle class="pieno" cx="12" cy="12" r="2.3"/>',
  cx_tc: '<rect x="2.6" y="5.4" width="7.8" height="13.2" rx="1.6"/><rect x="13.6" y="5.4" width="7.8" height="13.2" rx="1.6"/><path d="M5 9.4h3M5 12h3M16 9.4h3M16 12h3"/>',
  cx_tel: '<path d="M3.8 12.2 15.6 6.6l1.6 3.3-11.8 5.6z"/><path d="M15.6 6.6l3-1.4 1.6 3.3-3 1.4"/><path d="M10.6 12.9 7.4 20.4M10.6 12.9l3.6 7.5M10.6 12.9v7.7"/>',
  cx_oc: '<path d="M8.4 3.4h7.2l-.9 3.6H9.3z"/><rect x="8.6" y="7" width="6.8" height="9" rx="1.2"/><path d="M10 16h4v4.6h-4zM8.6 10.4h6.8"/>',
  cx_ocset: '<rect x="3" y="9" width="4.6" height="11" rx="1"/><rect x="9.7" y="5.5" width="4.6" height="14.5" rx="1"/><rect x="16.4" y="11.5" width="4.6" height="8.5" rx="1"/><path d="M3 12h4.6M9.7 9h4.6M16.4 14.5h4.6"/>',
  cx_bino: '<circle cx="6.8" cy="15.6" r="3.8"/><circle cx="17.2" cy="15.6" r="3.8"/><path d="M5 11.9 6.6 5.2h3.2l.6 7M19 11.9l-1.6-6.7h-3.2l-.6 7M10.4 13.4h3.2"/>',
  cx_camp: '<rect x="3.6" y="3.6" width="16.8" height="16.8" rx="1.8"/><path d="M3.6 9.2h16.8M3.6 14.8h16.8M9.2 3.6v16.8M14.8 3.6v16.8"/><rect class="pieno" x="9.2" y="9.2" width="5.6" height="5.6"/>',
  cx_posa: '<circle cx="12" cy="13.6" r="7.2"/><path d="M12 13.6V9.6M9.6 2.8h4.8M12 2.8v3.6M18.4 6.8l1.4-1.4"/>',
  cx_int: '<ellipse cx="12" cy="5.8" rx="7.4" ry="2.6"/><path d="M4.6 5.8v12.4c0 1.4 3.3 2.6 7.4 2.6s7.4-1.2 7.4-2.6V5.8M4.6 12c0 1.4 3.3 2.6 7.4 2.6s7.4-1.2 7.4-2.6"/>',
  cx_npf: '<path d="M2.6 19.8 9.2 9.6l3.8 5.6 2.6-3.4 5.8 8z"/><path class="pieno" d="M17.4 3.4l.6 1.3 1.3.6-1.3.6-.6 1.3-.6-1.3-1.3-.6 1.3-.6z"/><circle class="pieno" cx="12.6" cy="5.4" r=".8"/>',
  cx_rot: '<path d="M19.2 12a7.2 7.2 0 0 1-12.3 5.1M4.8 12a7.2 7.2 0 0 1 12.3-5.1"/><path d="M17.1 3.4v3.6h-3.6M6.9 20.6V17h3.6"/><circle class="pieno" cx="12" cy="12" r="1.7"/>',
  cx_cfz: '<path d="M2.8 5.6 12 12 2.8 18.4M21.2 5.6 12 12l9.2 6.4"/><path d="M10 3.6v16.8M14 3.6v16.8" stroke-dasharray="1.6 1.8"/>',
  cx_fil: '<circle cx="12" cy="12" r="8.6"/><circle cx="12" cy="12" r="5.4"/><path d="M8.6 15.4l6.8-6.8"/>',
  cx_pol: '<rect x="3" y="5" width="18" height="14" rx="1.8"/><circle cx="9.6" cy="11" r="3"/><circle cx="9.6" cy="11" r="1.1"/><circle cx="16.2" cy="14.6" r="1.6"/>',
  cx_car: '<path d="M12 4v15.6M7.6 19.6h8.8M4.4 7.2h15.2"/><path d="M4.4 7.2 2.2 12.6a2.3 2.3 0 0 0 4.4 0zM19.6 7.2l-2.2 5.4a2.3 2.3 0 0 0 4.4 0z"/>',
  cx_gui: '<circle cx="12" cy="12" r="7.4"/><path d="M12 2.6v4.2M12 17.2v4.2M2.6 12h4.2M17.2 12h4.2"/><circle class="pieno" cx="13.6" cy="10.4" r="1.5"/>',
  cx_bf: '<rect x="2.6" y="7.2" width="5.4" height="9.6" rx="1"/><rect x="9.4" y="8.6" width="4.6" height="6.8" rx=".8"/><rect x="15.4" y="7.2" width="6" height="9.6" rx="1"/><path d="M8 12h1.4M14 12h1.4"/>',
  cx_rug: '<path d="M12 3.2c3.8 4.6 5.8 7.8 5.8 10.6a5.8 5.8 0 0 1-11.6 0c0-2.8 2-6 5.8-10.6z"/><path d="M9.4 14.2a2.6 2.6 0 0 0 2.6 2.6"/>',
  cx_sqm: '<path d="M3.6 16.8a8.4 8.4 0 1 1 16.8 0"/><path d="M12 16.8l4.4-5M6.2 12.2l1.2.8M12 8v1.4M17.8 12.2l-1.2.8"/><circle class="pieno" cx="12" cy="16.8" r="1.4"/>',
};
function icona(nome, cl) {
  const s = document.createElementNS(SVGNS, "svg");
  s.setAttribute("viewBox", "0 0 24 24");
  s.setAttribute("class", "gas-ico" + (cl ? " " + cl : ""));
  s.setAttribute("aria-hidden", "true");
  s.setAttribute("focusable", "false");
  s.innerHTML = ICONE_SVG[nome] || "";
  return s;
}
const FATTORI = [0.33, 0.4, 0.5, 0.6, 0.63, 0.65, 0.67, 0.7, 0.72, 0.73, 0.75, 0.77, 0.79, 0.8, 0.85, 0.9, 0.92, 0.95, 1, 1.15, 1.25, 1.3, 1.4, 1.5, 1.6, 1.7, 1.8, 2, 2.25, 2.5, 2.7, 3, 3.5, 4, 5, 6];
const fattoreVicino = v => FATTORI.reduce((a, b) => Math.abs(b - v) < Math.abs(a - v) ? b : a);
const SEEING = [1, 1.5, 2, 2.5, 3, 4, 5];
const CAMPO = Object.assign({
  modo: "foto", tel: null, k: 1, cam: null, bin: 1, seeing: 2.5, oc: null, ogg: "M31", rot: 0, nx: 1, ny: 1, sov: 15, filtri: [],
}, ricorda("campo", {}));
let CENTRO = null, SPOSTA = [0, 0], ZOOM = 1;
let CENTRO_RIQ = [0, 0];
let VISORE_FOTO = null;
function visoreFoto() {
  if (VISORE_FOTO === false) return null;
  if (!VISORE_FOTO) {
    const tela = el("canvas", { class: "gas-cielo-gl", "aria-hidden": "true" });
    const quando = {};
    const hips = Hips.crea(tela, { errore: n => quando.errore && quando.errore(n), pronto: () => quando.pronto && quando.pronto() });
    VISORE_FOTO = hips ? { tela, hips, quando } : false;
  }
  return VISORE_FOTO || null;
}
let VISTA_CIELO = ricorda("vista", "foto");
let NOMI_CIELO = ricorda("nomi", true);
let GRIGLIA_CIELO = ricorda("griglia", false);
Object.assign(TESTI.it, { griglia: "Griglia", griglia_n: "Rende ben visibile la griglia delle coordinate (AR e Dec) e aggiunge l'equatore celeste e l'eclittica. Spenta, sulla mappa resta una griglia leggera" });
Object.assign(TESTI.de, { griglia: "Gitter", griglia_n: "Macht das Koordinatengitter (RA und Dek) gut sichtbar und zeigt Himmelsäquator und Ekliptik. Ausgeschaltet bleibt auf der Karte ein leichtes Gitter" });
Object.assign(TESTI.es, { griglia: "Cuadrícula", griglia_n: "Hace bien visible la cuadrícula de coordenadas (AR y Dec) y añade el ecuador celeste y la eclíptica. Apagada, en el mapa queda una cuadrícula suave" });
Object.assign(TESTI.en, { griglia: "Grid", griglia_n: "Makes the coordinate grid (RA and Dec) clearly visible and adds the celestial equator and the ecliptic. When it's off, the map keeps a faint grid" });
let RISULTATO_CIELO = false;
ICONE_SVG.risultato = '<rect x="3.4" y="5.6" width="17.2" height="12.8" rx="1.6"/><path d="M6.6 16l3.8-4.4 2.8 2.8 1.9-1.9 2.6 3.5"/><circle class="pieno" cx="15.4" cy="9.2" r="1.3"/>';
Object.assign(TESTI.it, { campo_tenue: "Nebulosa molto tenue: in foto si nota appena. Il cerchio tratteggiato ne segna la zona." });
Object.assign(TESTI.de, { campo_tenue: "Sehr schwacher Nebel: Auf dem Foto ist er kaum zu erkennen. Der gestrichelte Kreis markiert seinen Bereich." });
Object.assign(TESTI.es, { campo_tenue: "Nebulosa muy tenue: en la foto apenas se nota. El círculo discontinuo marca su zona." });
Object.assign(TESTI.en, { campo_tenue: "Very faint nebula: it barely shows in the photo. The dashed circle marks its area." });
Object.assign(TESTI.it, { ris: "Risultato", ris_n: "Come uscirà la foto: solo quello che entra nel sensore, raddrizzato come nella foto finita. Ruota la camera e guarda come cambia l'inquadratura", ris_titolo: "Come uscirà la foto", ris_camera: "camera a {g}°", ris_consiglio: "Vuoi vedere come uscirà la foto con la camera girata così? Tocca «Risultato»" });
Object.assign(TESTI.de, { ris: "Ergebnis", ris_n: "So wird das Foto: nur was auf den Sensor fällt, gerade ausgerichtet wie im fertigen Bild. Drehe die Kamera und sieh, wie sich der Bildausschnitt ändert", ris_titolo: "So wird das Foto", ris_camera: "Kamera bei {g}°", ris_consiglio: "Wie wird das Foto mit so gedrehter Kamera? Tippe auf «Ergebnis»" });
Object.assign(TESTI.es, { ris: "Resultado", ris_n: "Cómo saldrá la foto: solo lo que entra en el sensor, enderezado como en la foto terminada. Gira la cámara y mira cómo cambia el encuadre", ris_titolo: "Cómo saldrá la foto", ris_camera: "cámara a {g}°", ris_consiglio: "¿Quieres ver cómo saldrá la foto con la cámara girada así? Toca «Resultado»" });
Object.assign(TESTI.en, { ris: "Result", ris_n: "How the photo will come out: only what lands on the sensor, straightened as in the finished image. Rotate the camera and see how the framing changes", ris_titolo: "How the photo will look", ris_camera: "camera at {g}°", ris_consiglio: "Want to see how the photo will come out with the camera rotated like this? Tap «Result»" });
const LEGENDA_MAPPA = [["galassie", "#ffdea0"], ["emissione", "#ff5c80"], ["riflessione", "#78aaff"], ["planetarie", "#64f5cd"],
  ["supernova", "#ffa05a"], ["aperti", "#ffd682"], ["globulari", "#ffe2aa"], ["oscure", "#59627a"]];
function salvaCampo() {
  const { modo, tel, k, cam, bin, seeing, oc, ogg, rot, nx, ny, sov, filtri, filtriNomi } = CAMPO;
  salva("campo", { modo, tel, k, cam, bin, seeing, oc, ogg, rot, nx, ny, sov, filtri, filtriNomi });
}
function calcoloCampo(s) {
  const C = s || CAMPO, tel = C.tel;
  if (!tel || !tel.D || !tel.F) return null;
  const bin = C.bin || 1;
  const F = tel.F * (tel.smart ? 1 : C.k || 1);
  const out = { F, D: tel.D, N: F / tel.D, dawes: 116 / tel.D, rayleigh: 138 / tel.D };
  if ((C.modo || "foto") === "foto") {
    const c = C.cam;
    if (!c || !c.w || !c.h || !c.px) return out;
    const wmm = c.w * c.px / 1000, hmm = c.h * c.px / 1000;
    Object.assign(out, {
      wmm, hmm,
      fovW: 2 * Math.atan(wmm / 2 / F) * DEG, fovH: 2 * Math.atan(hmm / 2 / F) * DEG,
      projW: wmm / F * DEG, projH: hmm / F * DEG,
      scala: 206.265 * c.px * bin / F,
      imgW: Math.floor(c.w / bin), imgH: Math.floor(c.h / bin),
    });
    out.fovD = 2 * Math.atan(Math.hypot(wmm, hmm) / 2 / F) * DEG;
    const sov = 1 - (C.sov == null ? 15 : C.sov) / 100;
    out.mosW = out.fovW * (1 + ((C.nx || 1) - 1) * sov);
    out.mosH = out.fovH * (1 + ((C.ny || 1) - 1) * sov);
  } else {
    const o = C.oc;
    if (!o || !o.f || !o.afov) return out;
    const M = F / o.f;
    Object.assign(out, { M, campo: o.afov / M, pupilla: tel.D / M, Mmax: 2 * tel.D, Mmin: tel.D / 7 });
    out.projR = Math.tan(out.campo / 2 * RAD) * DEG;
  }
  return out;
}
function campoAttuale() {
  const r = calcoloCampo();
  if (!r) return null;
  if (r.fovW) return { w: r.mosW || r.fovW, h: r.mosH || r.fovH };
  if (r.campo) return { w: r.campo, h: r.campo };
  return null;
}
function giudizioCampionamento(scala, seeing) {
  const ppf = seeing / scala;
  if (ppf > 4) return ["sovra", t("camp_sovra"), t("camp_sovra_n", { b: Math.max(2, Math.round(ppf / 2.5)) })];
  if (ppf > 3.2) return ["poco_sovra", t("camp_poco_sovra"), t("camp_poco_sovra_n")];
  if (ppf >= 1.9) return ["ok", t("camp_ok"), t("camp_ok_n")];
  if (ppf >= 1.3) return ["poco_sotto", t("camp_poco_sotto"), t("camp_poco_sotto_n")];
  return ["sotto", t("camp_sotto"), t("camp_sotto_n")];
}
function boxConfronto(r, rc, nome) {
  const col = x => x.fovW ? [angoli(x.fovW, x.fovH), `${num(x.scala, 2)}″/px`, `${num(x.F)} mm · f/${num(x.N, 1)}`]
    : [angolo(x.campo), `${num(x.M)}×`, `${num(x.F)} mm · f/${num(x.N, 1)}`];
  const a = col(r), b = col(rc);
  const dA = r.fovW ? Math.hypot(r.fovW, r.fovH) : r.campo, dB = rc.fovW ? Math.hypot(rc.fovW, rc.fovH) : rc.campo, q = dB / dA;
  const nota = q > 1.05 ? t("cf_piu_grande", { n: nome, x: num(q, q < 10 ? 1 : 0) })
    : q < 0.95 ? t("cf_piu_piccolo", { n: nome, x: num(1 / q, 1 / q < 10 ? 1 : 0) }) : t("cf_uguale", { n: nome });
  const seconda = r.fovW && rc.fovW ? t("cd_scala") : !r.fovW && !rc.fovW ? t("ingrandimento") : `${t("cd_scala")} · ${t("ingrandimento")}`;
  return el("div", { class: "gas-cf" },
    el("table", { class: "gas-tab gas-cf-tab" },
      el("thead", null, el("tr", null, el("th", null, icona("confronta")), el("th", { class: "gas-cf-ora" }, t("cf_attuale")), el("th", { class: "gas-cf-altro" }, nome))),
      el("tbody", null, [t("cd_campo"), seconda, t("focale_effettiva")].map((e, i) => el("tr", null, el("th", null, e), el("td", null, a[i]), el("td", null, b[i]))))),
    el("p", { class: "gas-nota" }, nota));
}
let _fermaCol = null, _fermaOss = null;
function fermaInFondo(col) {
  _fermaCol = col;
  if (_fermaOss) _fermaOss.disconnect();
  _fermaOss = typeof ResizeObserver === "function" ? new ResizeObserver(() => aggiornaFermaInFondo()) : null;
  if (_fermaOss) _fermaOss.observe(col);
  if (!fermaInFondo.ascolta) { fermaInFondo.ascolta = true; window.addEventListener("resize", () => aggiornaFermaInFondo()); }
  aggiornaFermaInFondo();
}
function aggiornaFermaInFondo() {
  const col = _fermaCol;
  if (!col || !col.isConnected) return;
  if (window.innerWidth < 990) { col.style.position = ""; col.style.top = ""; return; }
  const testa = document.querySelector(".gas-testa-app"), sopra = testa ? testa.offsetHeight : 0;
  col.style.position = "sticky";
  col.style.top = Math.round(Math.min(sopra + 16, window.innerHeight - col.offsetHeight - 16)) + "px";
}
Object.assign(TESTI.it, { cs_aria: "Vai a una sezione", cs_setup: "Setup", cs_risultati: "Risultati", acc_setup_n: "{n} salvati", acc_setup_n_1: "1 salvato",
  acc_filtri_n: "{n} filtri", acc_filtri_n_1: "1 filtro", acc_nessuno: "Nessuno" });
Object.assign(TESTI.de, { cs_aria: "Zu einem Abschnitt springen", cs_setup: "Setups", cs_risultati: "Ergebnisse", acc_setup_n: "{n} gespeichert", acc_setup_n_1: "1 gespeichert",
  acc_filtri_n: "{n} Filter", acc_filtri_n_1: "1 Filter", acc_nessuno: "Keiner" });
Object.assign(TESTI.es, { cs_aria: "Ir a una sección", cs_setup: "Configuraciones", cs_risultati: "Resultados", acc_setup_n: "{n} guardados", acc_setup_n_1: "1 guardado",
  acc_filtri_n: "{n} filtros", acc_filtri_n_1: "1 filtro", acc_nessuno: "Ninguno" });
Object.assign(TESTI.en, { cs_aria: "Go to a section", cs_setup: "Setups", cs_risultati: "Results", acc_setup_n: "{n} saved", acc_setup_n_1: "1 saved",
  acc_filtri_n: "{n} filters", acc_filtri_n_1: "1 filter", acc_nessuno: "None" });
Object.assign(TESTI.it, { sv_scegli: "Scegli un setup…" });
Object.assign(TESTI.de, { sv_scegli: "Setup wählen…" });
Object.assign(TESTI.es, { sv_scegli: "Elige una configuración…" });
Object.assign(TESTI.en, { sv_scegli: "Choose a setup…" });
Object.assign(TESTI.it, { rp_centro: "Centro", rp_pannelli: "Pannelli", rp_luogo: "Luogo", rp_stanotte: "Stanotte", rp_finestra: "dalle {a} alle {b}, più alto alle {m} ({h}°)", rp_mai: "stanotte non sale sopra {h}°" });
Object.assign(TESTI.de, { rp_centro: "Zentrum", rp_pannelli: "Felder", rp_luogo: "Ort", rp_stanotte: "Heute Nacht", rp_finestra: "von {a} bis {b}, am höchsten um {m} ({h}°)", rp_mai: "steigt heute Nacht nicht über {h}°" });
Object.assign(TESTI.es, { rp_centro: "Centro", rp_pannelli: "Paneles", rp_luogo: "Lugar", rp_stanotte: "Esta noche", rp_finestra: "de las {a} a las {b}, más alto a las {m} ({h}°)", rp_mai: "esta noche no sube por encima de {h}°" });
Object.assign(TESTI.en, { rp_centro: "Centre", rp_pannelli: "Panels", rp_luogo: "Location", rp_stanotte: "Tonight", rp_finestra: "from {a} to {b}, highest at {m} ({h}°)", rp_mai: "does not rise above {h}° tonight" });
Object.assign(TESTI.it, { cp_ra: "AR (J2000)", cp_dec: "Dec (J2000)" });
Object.assign(TESTI.de, { cp_ra: "RA (J2000)", cp_dec: "Dek (J2000)" });
Object.assign(TESTI.es, { cp_ra: "AR (J2000)", cp_dec: "Dec (J2000)" });
Object.assign(TESTI.en, { cp_ra: "RA (J2000)", cp_dec: "Dec (J2000)" });
let ACC_APERTA = null;
let RIAPRI_RQ = null;
function vistaCampo(pannello) {
  const ridisegno = pannello.childElementCount > 0 && schedaAttiva === "campo", yPrima = window.scrollY;
  chiudiFoglioCampo(true);
  if (ridisegno) pannello.style.minHeight = pannello.offsetHeight + "px";
  svuota(pannello);
  const comandi = el("div", { class: "gas-comandi" });
  const cieloBox = el("div", { class: "gas-cielo-box" });
  const uscite = el("div", { class: "gas-uscite" });
  const sottoBox = el("div", { class: "gas-cielo-sotto", hidden: true });
  pannello.appendChild(el("div", { class: "gas-campo-griglia" }, comandi, cieloBox, sottoBox, uscite));
  fermaInFondo(comandi);
  function comandoSetup(cl) {
    const box = el("label", { class: "gas-confronta gas-setup-veloce " + cl, hidden: true });
    const disegna = () => {
      if (!box.isConnected && box._mostrato) { SETUP_UI.delete(disegna); return; }
      box._mostrato = true;
      svuota(box).hidden = !SETUP_ELENCO.length;
      if (!SETUP_ELENCO.length) return;
      const ora = setupAttuale(), qui = SETUP_ELENCO.find(s => stessoSetup(s, ora));
      box.append(icona("attrezzatura"), el("span", null, t("cs_setup")),
        selezione([["", t("sv_scegli")], ...SETUP_ELENCO.map((s, i) => [String(i), s.nome])], qui ? String(SETUP_ELENCO.indexOf(qui)) : "",
          v => { const s = SETUP_ELENCO[+v]; if (s) { usaSetup(s); vistaCampo(pannello); } }, { "aria-label": t("cs_setup") }));
    };
    SETUP_UI.add(disegna);
    return box;
  }
  function comandoConfronto(cl) {
    const box = el("label", { class: "gas-confronta " + cl, hidden: true });
    const disegna = () => {
      if (!box.isConnected && box._mostrato) { SETUP_UI.delete(disegna); return; }
      box._mostrato = true;
      const ora = setupAttuale(), altri = SETUP_ELENCO.filter(s => !stessoSetup(s, ora));
      svuota(box).hidden = !altri.length;
      if (!altri.length) return;
      const sc = setupConfronto();
      box.classList.toggle("on", !!sc);
      box.append(icona("confronta"), el("span", null, t("cf_confronta")),
        selezione([["", t("cf_nessuno")], ...altri.map(s => [s.nome, s.nome])], sc ? sc.nome : "",
          v => { CONFRONTO = v; salva("confronto", v); aggiorna(); }, { "aria-label": t("cf_confronta") }));
    };
    SETUP_UI.add(disegna);
    return box;
  }
  const setupBox = boxSetup(() => vistaCampo(pannello));
  comandi.appendChild(scheda(titoloVoce(t("miei_setup"), "g_setup"), setupBox, comandoConfronto("gas-confronta--setup"), bottoneAssistente()));
  const modo = el("div", { class: "gas-seg", role: "group" },
    ["foto", "visuale"].map(m => el("button", { type: "button", class: CAMPO.modo === m ? "on" : "", "aria-pressed": String(CAMPO.modo === m), onclick: () => {
      if (CAMPO.modo === m) return;
      if (FOGLIO_CAMPO) RIAPRI_RQ = "cam";
      CAMPO.modo = m; salvaCampo(); vistaCampo(pannello); } }, t("modo_" + m))));
  comandi.appendChild(modo);
  const telInfo = el("div", { class: "gas-scelto" });
  const telD = campoNumero(t("diametro"), CAMPO.tel && CAMPO.tel.D && Math.round(CAMPO.tel.D * 100) / 100, v => { manuale({ D: v }); }, { unita: "mm", min: 10 });
  const telF = campoNumero(t("focale"), CAMPO.tel && CAMPO.tel.F, v => { manuale({ F: v }); }, { unita: "mm", min: 5 });
  const telN = campoNumero(t("diaframma_f"), CAMPO.tel && CAMPO.tel.D ? Math.round(CAMPO.tel.F / CAMPO.tel.D * 100) / 100 : null,
    v => {
      if (!(v && v >= 0.7 && CAMPO.tel && CAMPO.tel.F)) return;
      if (eObiettivo(CAMPO.tel) && v >= (CAMPO.tel.Nmax || CAMPO.tel.F / CAMPO.tel.D) - 0.05) {
        CAMPO.tel.Nmax = CAMPO.tel.Nmax || Math.round(CAMPO.tel.F / CAMPO.tel.D * 10) / 10; CAMPO.tel.D = CAMPO.tel.F / v; aggiorna();
      } else manuale({ D: CAMPO.tel.F / v });
    }, { unita: "f/", passo: "0.1" });
  const manuale = ch => {
    const tel = Object.assign({ nome: t("personalizzato") }, CAMPO.tel && !CAMPO.tel.h && !CAMPO.tel.smart ? CAMPO.tel : {}, ch);
    tel.nome = t("personalizzato"); delete tel.h; delete tel.smart;
    if (!tel.D) tel.D = CAMPO.tel && CAMPO.tel.D; if (!tel.F) tel.F = CAMPO.tel && CAMPO.tel.F;
    CAMPO.tel = tel; cercaTel.imposta(""); aggiorna();
  };
  const cercaTel = creaCerca({
    segnaposto: t("cerca_telescopio"),
    cerca: q => {
      return cercaTelescopi(q, 40);
    },
    riga: x => ({ titolo: titoloTelescopio(x), sotto: rigaTelescopio(x), foto: x.foto }),
    scegli: x => { scegliTelescopio(x); cercaTel.imposta(""); vistaCampo(pannello); },
  });
  comandi.appendChild(scheda(titoloVoce(t("telescopio"), "g_telescopio"), sceltaRapida("tel", () => vistaCampo(pannello)), cercaTel.box, telInfo, el("div", { class: "gas-tre" }, telD, telF, telN)));
  const rid = selezione(FATTORI.map(f => [f, f === 1 ? t("nessuno") : `${num(f, f % 1 ? 2 : 0)}×` + (f < 1 ? " " + t("riduttore_b") : " " + t("barlow_b"))]),
    CAMPO.k, v => { CAMPO.k = parseFloat(v); aggiorna(); });
  const ridNeg = el("div", { class: "gas-mini-elenco" });
  comandi.appendChild(scheda(titoloVoce(t("riduttore"), "g_riduttore"), sceltaRapida("k", () => vistaCampo(pannello)), rid, ridNeg));
  const camInfo = el("div", { class: "gas-scelto" });
  let camW, camH, camPx;
  if (CAMPO.modo === "foto") {
    const manCam = ch => {
      const c = Object.assign({}, CAMPO.cam && !CAMPO.cam.id ? CAMPO.cam : (CAMPO.cam ? { w: CAMPO.cam.w, h: CAMPO.cam.h, px: CAMPO.cam.px } : {}), ch);
      c.nome = t("personalizzata"); delete c.id; delete c.h_negozio;
      CAMPO.cam = c; cercaCam.imposta(""); aggiorna();
    };
    camW = campoNumero(t("larghezza_px"), CAMPO.cam && CAMPO.cam.w, v => manCam({ w: v }), { unita: "px", min: 100 });
    camH = campoNumero(t("altezza_px"), CAMPO.cam && CAMPO.cam.h, v => manCam({ h: v }), { unita: "px", min: 100 });
    camPx = campoNumero(t("pixel"), CAMPO.cam && CAMPO.cam.px, v => manCam({ px: v }), { unita: "µm", min: 0.5, passo: "0.01" });
    const cercaCam = creaCerca({
      segnaposto: t("cerca_camera"),
      cerca: q => cercaCamere(q, 40),
      riga: c => ({ titolo: c.nome, sotto: rigaCamera(c), extra: c.h_negozio ? t("in_vendita") : "", foto: c.foto }),
      scegli: c => { scegliCamera(c); cercaCam.imposta(""); vistaCampo(pannello); },
    });
    const bin = selezione([[1, "1×1"], [2, "2×2"], [3, "3×3"], [4, "4×4"]], CAMPO.bin, v => { CAMPO.bin = +v; aggiorna(); });
    const see = selezione(SEEING.map(s => [s, t("seeing_" + String(s).replace(".", "_"))]), CAMPO.seeing, v => { CAMPO.seeing = +v; aggiorna(); });
    comandi.appendChild(scheda(titoloVoce(t("camera"), "g_camera"), sceltaRapida("cam", () => vistaCampo(pannello)), cercaCam.box, camInfo, el("div", { class: "gas-tre" }, camW, camH, camPx),
      el("div", { class: "gas-due" }, etichetta(t("binning"), bin), etichetta(t("seeing"), see))));
    comandi.appendChild(scheda(titoloVoce(t("miei_filtri"), "g_filtri"), el("p", { class: "gas-nota" }, t("miei_filtri_n")), boxFiltri(() => aggiorna())));
    comandi.appendChild(invitoSalvaSetup());
  } else {
    const manOc = ch => {
      const o = Object.assign({ f: CAMPO.oc && CAMPO.oc.f, afov: CAMPO.oc && CAMPO.oc.afov }, ch);
      o.nome = t("personalizzato"); CAMPO.oc = o; cercaOc.imposta(""); aggiorna();
    };
    const cercaOc = creaCerca({
      segnaposto: t("cerca_oculare"),
      cerca: q => cercaOculari(q, 40),
      riga: x => ({ titolo: x.t, sotto: `${num(x.f, x.f % 1 ? 1 : 0)} mm · ${num(x.afov)}°${x.bar ? " · " + x.bar + "″" : ""}`, foto: x.foto }),
      scegli: x => { CAMPO.oc = { nome: x.t, f: x.f, afov: x.afov, h: x.h, foto: x.foto }; cercaOc.imposta(""); vistaCampo(pannello); },
    });
    const ocF = campoNumero(t("focale_oculare"), CAMPO.oc && CAMPO.oc.f, v => manOc({ f: v }), { unita: "mm", min: 1 });
    const ocA = campoNumero(t("campo_apparente"), CAMPO.oc && CAMPO.oc.afov, v => manOc({ afov: v }), { unita: "°", min: 20, max: 120 });
    comandi.appendChild(scheda(titoloVoce(t("oculare"), "g_oculare"), sceltaRapida("oc", () => vistaCampo(pannello)), cercaOc.box, camInfo, el("div", { class: "gas-due" }, ocF, ocA)));
    comandi.appendChild(scheda(titoloVoce(t("miei_filtri"), "g_filtri"), el("p", { class: "gas-nota" }, t("miei_filtri_n")), boxFiltri(() => aggiorna())));
    comandi.appendChild(invitoSalvaSetup());
  }
  const oggInfo = el("div", { class: "gas-scelto" });
  const cercaOgg = creaCerca({
    segnaposto: t("cerca_oggetto"),
    cerca: q => cercaOggetti(q, 30),
    riga: (o, q) => ({ titolo: titoloCercato(o, q), sotto: rigaOggetto(o) }),
    scegli: o => { CAMPO.ogg = o.id; CENTRO = null; SPOSTA = [0, 0]; ZOOM = 1; cercaOgg.imposta(""); OGG_CAMPO_VISTO = o.id; provaFatta(1); chiudiFoglioCampo(); aggiorna(); },
  });
  comandi.appendChild(scheda(titoloVoce(t("oggetto"), "g_oggetto"), cercaOgg.box, oggInfo));
  if (CAMPO.modo === "foto") {
    const nx = selezione([1, 2, 3, 4, 5].map(n => [n, n]), CAMPO.nx, v => { CAMPO.nx = +v; aggiorna(); });
    const ny = selezione([1, 2, 3, 4, 5].map(n => [n, n]), CAMPO.ny, v => { CAMPO.ny = +v; aggiorna(); });
    const sov = selezione([5, 10, 15, 20, 25, 30].map(n => [n, n + " %"]), CAMPO.sov, v => { CAMPO.sov = +v; aggiorna(); });
    comandi.appendChild(scheda(titoloVoce(t("mosaico"), "g_mosaico"),
      el("div", { class: "gas-tre" }, etichetta(t("mosaico_x"), nx), etichetta(t("mosaico_y"), ny), etichetta(t("sovrapposizione"), sov))));
  }
  const fotoOk = FOTO_DSS || DEBUG;
  if (!fotoOk) VISTA_CIELO = "mappa";
  else if (VISTA_CIELO !== "mappa") VISTA_CIELO = "foto";
  const telaMappa = el("canvas", { class: "gas-cielo-mappa", role: "img", "aria-label": t("mappa_cielo") });
  const telaNomi = el("canvas", { class: "gas-cielo-mappa gas-cielo-nomi", "aria-hidden": "true", hidden: true });
  const gl = fotoOk ? visoreFoto() : null;
  const img = fotoOk && !gl ? el("img", { class: "gas-cielo-img", alt: "", decoding: "async", hidden: true }) : null;
  const svg = sv("svg", { class: "gas-cielo-svg" });
  const stato = el("div", { class: "gas-cielo-stato", hidden: true }, t("carico_cielo"));
  const firma = el("span", { class: "gas-cielo-firma" });
  const firmaVista = (testo, extra) => {
    const [nome, ...resto] = testo.split(" · ");
    svuota(firma).append(el("b", null, nome), el("span", { class: "gas-cielo-firma-extra" }, [...resto, ...(extra ? [extra] : [])].map(x => " · " + x).join("")));
  };
  firmaVista(t("firma_mappa"));
  const telaRis = el("canvas", { class: "gas-cielo-ris", "aria-hidden": "true", hidden: true });
  const cielo = el("div", { class: "gas-cielo" }, telaMappa, gl && gl.tela, img, telaNomi, svg, telaRis, stato, firma);
  const bott = (testo, titolo, fn, cls) => el("button", { type: "button", class: cls || "", title: titolo, "aria-label": titolo, onclick: fn }, testo);
  const scegliVista = fotoOk ? el("div", { class: "gas-seg gas-seg--mini", role: "group" },
    ["foto", "mappa"].map(v => el("button", { type: "button", class: VISTA_CIELO === v ? "on" : "", "aria-pressed": String(VISTA_CIELO === v),
      onclick: e => {
        VISTA_CIELO = v; salva("vista", v);
        if (v === "foto") { fotoFallita = false; if (gl) gl.hips.riprova(); }
        $$("button", e.currentTarget.parentNode).forEach(b => { b.classList.toggle("on", b === e.currentTarget); b.setAttribute("aria-pressed", String(b === e.currentTarget)); });
        caricaCielo();
      } }, t("vista_" + v)))) : null;
  const bottoneNomi = el("button", { type: "button", class: "gas-nomi-btn", "aria-pressed": String(NOMI_CIELO), title: t("nomi_n"),
    onclick: () => { NOMI_CIELO = !NOMI_CIELO; salva("nomi", NOMI_CIELO); bottoneNomi.setAttribute("aria-pressed", String(NOMI_CIELO)); caricaCielo(); } },
  icona("nomi"), el("span", null, t("nomi")));
  const bottoneGriglia = el("button", { type: "button", class: "gas-nomi-btn gas-griglia-btn", "aria-pressed": String(GRIGLIA_CIELO), title: t("griglia_n"),
    onclick: () => { GRIGLIA_CIELO = !GRIGLIA_CIELO; salva("griglia", GRIGLIA_CIELO); bottoneGriglia.setAttribute("aria-pressed", String(GRIGLIA_CIELO)); caricaCielo(); } },
  icona("griglia"), el("span", null, t("griglia")));
  const bottoneRis = CAMPO.modo === "foto" ? el("button", { type: "button", class: "gas-nomi-btn gas-ris-btn", "aria-pressed": String(RISULTATO_CIELO), title: t("ris_n"),
    onclick: () => { RISULTATO_CIELO = !RISULTATO_CIELO; salva("ris_visto", true); bottoneRis.classList.remove("gas-ris-btn--nota");
      bottoneRis.setAttribute("aria-pressed", String(RISULTATO_CIELO)); disegnaRis(); } },
  icona("risultato"), el("span", null, t("ris"))) : null;
  const barra = el("div", { class: "gas-cielo-barra" },
    bott(icona("meno"), t("allarga"), () => { ZOOM = clamp(ZOOM * 1.6, 0.02, 60); caricaCielo(); }),
    bott(icona("piu"), t("stringi"), () => { ZOOM = clamp(ZOOM / 1.6, 0.02, 60); caricaCielo(); }),
    bott(icona("centro"), t("torna_oggetto"), () => { CENTRO = null; caricaCielo(); mostraMosaico(); }),
    bott(icona("reimposta"), t("reimposta"), () => { CENTRO = null; SPOSTA = [0, 0]; ZOOM = 1; aggiorna(); }),
    bott(icona("link"), t("copia_link"), e => copia(linkCampo(), e.currentTarget)),
    bott(icona("condividi"), t("cd_titolo"), e => condividi(e.currentTarget)), scegliVista, bottoneNomi, bottoneGriglia, bottoneRis,
    bottoneVistaLuogo(() => CAMPO.ogg, "gas-vl-apri--campo"), Voce.bottone("g_cielo"));
  let ultimiCentri = [];
  async function righeReport(o, righe) {
    if (ultimiCentri.length === 1) righe.push([t("rp_centro"), `${raHms(ultimiCentri[0][1])} · ${decDms(ultimiCentri[0][2])}`]);
    else if (ultimiCentri.length > 1) righe.push([t("rp_pannelli"), ultimiCentri.map(([k, ra, dec]) => `${k}: ${raHms(ra)} ${decDms(dec)}`.replace(/ /g, "\u00a0")).join(" · ")]);
    if (CAMPO.rot && CAMPO.modo === "foto") righe.push([t("rotazione_b"), `${num(CAMPO.rot)}°`]);
    if (NOTTE.luogo) righe.push([t("rp_luogo"), `${NOTTE.luogo.nome || ""} · ${num(NOTTE.luogo.lat, 2)}°, ${num(NOTTE.luogo.lon, 2)}°${NOTTE.sqmStima ? ` · SQM ${num(NOTTE.sqmStima, 1)}` : ""}`]);
    if (o.corpo) return null;
    try {
      const c = calcolaNotte(), rr = rigaDi(c, o) || c.righe.find(x => x.o.id === o.id);
      if (!rr) return null;
      const pc = c.nt.buio.length ? percorso(rr, c.nt, NOTTE.hmin, vistaAttiva() ? NOTTE.vista : null) : null;
      const alle = i => ora(Astro.data(c.nt.tempi[i]));
      righe.push([t("rp_stanotte"), pc ? t("rp_finestra", { a: alle(pc.i0), b: alle(pc.i1), m: alle(pc.iM), h: num(rr.h[pc.iM]) }) : t("rp_mai", { h: NOTTE.hmin })]);
      const box = panoramaCielo(rr, c.nt), fuori = el("div", { style: { position: "absolute", left: "-10000px", top: "0", width: "720px" } }, box);
      RADICE.appendChild(fuori);
      try { return await svgInImmagine(box.querySelector("svg")); } finally { fuori.remove(); }
    } catch (e) { console.error("strumenti, report:", e); return null; }
  }
  if (DEBUG) window.gasReport = async () => { const o = oggetto(), righe = []; const pano = await righeReport(o, righe);
    const blob = await immagineInquadratura([telaMappa], svg, { titolo: titoloOggetto(o), righe, link: "x", credito: "x", pano, panoTitolo: t("pano_titolo") });
    return { righe, pano: !!pano, kb: Math.round(blob.size / 1024), url: URL.createObjectURL(blob) }; };
  async function condividi(b) {
    if (!geometria) return;
    b.disabled = true;
    stato.textContent = t("cd_preparo"); stato.hidden = false;
    const o = oggetto(), r = calcoloCampo(), righe = [];
    if (CAMPO.tel) righe.push([t("telescopio"), nomeTel(CAMPO.tel) + (CAMPO.k !== 1 && !CAMPO.tel.smart ? ` + ${num(CAMPO.k, 2)}×` : "")]);
    if (CAMPO.modo === "foto" && CAMPO.cam) righe.push([t("camera"), CAMPO.cam.nome]);
    if (CAMPO.modo === "visuale" && CAMPO.oc) righe.push([t("oculare"), CAMPO.oc.nome]);
    if (r && r.fovW) righe.push([t("cd_campo"), `${angoli(r.fovW, r.fovH)} · ${num(r.scala, 2)}″/px · f/${num(r.N, 1)}`]);
    else if (r && r.M) righe.push([t("cd_campo"), `${num(r.M)}× · ${angolo(r.campo)}`]);
    const sc = setupConfronto(), rc = sc && calcoloCampo(sc);
    if (rc && (rc.fovW || rc.M)) righe.push([t("cf_riga"), `${sc.nome} · ${rc.fovW ? angoli(rc.fovW, rc.fovH) : `${num(rc.M)}× · ${angolo(rc.campo)}`}`]);
    const pano = await righeReport(o, righe);
    const foto = telaMappa.hidden;
    const testi = { titolo: titoloOggetto(o), righe, link: location.host + urlScheda("campo"), pano, panoTitolo: t("pano_titolo"),
      credito: foto ? t("cd_foto") + ": DSS2 · STScI/NASA · CDS — " + t("cd_fatto") : t("cd_fatto") };
    const strati = foto ? [gl && gl.tela, img && !img.hidden ? img : null, telaNomi.hidden ? null : telaNomi] : [telaMappa];
    let blob = null;
    try { blob = await immagineInquadratura(strati, svg, testi); } catch (err) {
      try {
        stato.textContent = t("cd_errore");
        const tmp = el("canvas", { width: geometria.W, height: geometria.H });
        await Mappa.disegna(tmp, geometria, { oggetto: o, riservati: riservatiVista(geometria, o), senzaPrincipale: !CENTRO, senzaNomi: !NOMI_CIELO, griglia: GRIGLIA_CIELO });
        blob = await immagineInquadratura([tmp], svg, Object.assign({}, testi, { credito: t("cd_fatto") }));
      } catch (e2) { console.error("strumenti, condividi:", e2); }
    }
    b.disabled = false;
    stato.hidden = true;
    if (blob) await condividiBlob(blob, `giordano-${String(o.id).replace(/[^a-z0-9]+/gi, "-").toLowerCase()}.png`, testi.titolo, linkCampo());
  }
  let rotVal = null, rot = null;
  let rotAdatta = CAMPO.rot || 0, attesaGiro = null, attesaMos = null;
  const consiglioRis = () => {
    if (!bottoneRis || RISULTATO_CIELO || ricorda("ris_visto", false)) return;
    salva("ris_visto", true);
    bottoneRis.classList.add("gas-ris-btn--nota");
    stato.textContent = t("ris_consiglio"); stato.hidden = false; stato.classList.add("gas-cielo-stato--nota");
    setTimeout(() => {
      bottoneRis.classList.remove("gas-ris-btn--nota"); stato.classList.remove("gas-cielo-stato--nota");
      if (stato.textContent === t("ris_consiglio")) stato.hidden = true;
    }, 6000);
  };
  const giraA = v => {
    CAMPO.rot = ((Math.round(v) % 360) + 360) % 360;
    consiglioRis();
    if (rot) rot.value = CAMPO.rot;
    if (rotVal) rotVal.textContent = `${CAMPO.rot}°`;
    disegna(); salvaCampo(); disegnaRq();
    clearTimeout(attesaMos);
    attesaMos = setTimeout(() => { if (cieloBox.isConnected) mostraMosaico(); }, 150);
    clearTimeout(attesaGiro);
    attesaGiro = setTimeout(() => {
      if (!geometria || !cieloBox.isConnected || Math.abs(ZOOM - 1) > 0.05 || CAMPO.rot === rotAdatta) return;
      const [bw, bh] = ingombroVista(CAMPO.rot), pieno = Math.max(bw / geometria.fov, bh / (geometria.fov * geometria.H / geometria.W));
      if (pieno > 0.97 || pieno < 0.6) { rotAdatta = CAMPO.rot; caricaCielo(); }
    }, 650);
  };
  let rotBar = null;
  if (CAMPO.modo === "foto") {
    rotVal = el("output", { class: "gas-rot-val" }, `${CAMPO.rot}°`);
    rot = el("input", { type: "range", min: 0, max: 359, step: 1, value: CAMPO.rot, class: "gas-range", "aria-label": t("rotazione") });
    rot.addEventListener("input", () => giraA(+rot.value));
    rotBar = el("div", { class: "gas-rot", title: t("rotazione_n") },
      el("span", { class: "gas-rot-et" }, t("rotazione_b")),
      bott("−5°", "−5°", () => giraA(CAMPO.rot + 355), "gas-rot-btn"), rot, bott("+5°", "+5°", () => giraA(CAMPO.rot + 5), "gas-rot-btn"),
      bott("90°", t("ruota_90"), () => giraA(CAMPO.rot + 90), "gas-rot-btn"), rotVal);
  }
  const sintesi = el("div", { class: "gas-sintesi" });
  const notaTenue = el("p", { class: "gas-cielo-tenue", hidden: true }, t("campo_tenue"));
  const legendaRiq = el("div", { class: "gas-cielo-legenda", hidden: true });
  const rotApri = rotBar ? el("button", { type: "button", class: "gas-rot-apri", "aria-expanded": "false", onclick: () => {
    const aperta = cieloBox.classList.toggle("gas-rot-aperta");
    sottoBox.classList.toggle("gas-rot-aperta", aperta);
    rotApri.setAttribute("aria-expanded", String(aperta));
  } }, "↻ ", t("rotazione_b")) : null;
  const salti = el("div", { class: "gas-cielo-salti", role: "group", "aria-label": t("cs_aria") });
  const comandiCielo = el("div", { class: "gas-cielo-comandi" }, notaTenue, barra, rotBar, comandoSetup("gas-confronta--cielo"), comandoConfronto("gas-confronta--cielo"));
  const piedeCielo = el("div", { class: "gas-cielo-piede" }, legendaRiq, sintesi,
    el("div", { class: "gas-cielo-piede-btn" }, rotApri, bottoneVistaLuogo(() => CAMPO.ogg, "gas-vl-apri--piede")));
  const carta = k => [...comandi.children].find(c => { const h = c.querySelector(":scope > h3"); return h && h.textContent.trim().startsWith(t(k)); });
  const camCorta = n => { const s = nomeCorto(n), p = s.split(" "); return p.length > 1 && s.length > 10 ? p.slice(1).join(" ") : s; };
  const rqBox = el("div", { class: "gas-cielo-rq", role: "group", "aria-label": t("rq_aria") });
  rqBox.addEventListener("scroll", () => rqBox.classList.toggle("gas-fine", rqBox.scrollLeft + rqBox.clientWidth >= rqBox.scrollWidth - 4), { passive: true });
  let rqAperto = null;
  const fogliettoConfronto = altri => {
    const ora = setupConfronto() ? setupConfronto().nome : "";
    return el("div", { class: "gas-cielo-foglio-scelte" }, el("p", { class: "gas-nota" }, t("rq_conf_n")),
      [["", t("rq_conf_no")], ...altri.map(s => [s.nome, s.nome])].map(([v, n]) => el("button", { type: "button", class: "gas-cielo-foglio-scelta" + (ora === v ? " on" : ""),
        onclick: () => { CONFRONTO = v; salva("confronto", v); chiudiFoglioCampo(); aggiorna(); } }, n)));
  };
  const vociRq = () => {
    const foto = CAMPO.modo === "foto", r = calcoloCampo(), ora = setupAttuale();
    const qui = SETUP_ELENCO.find(s => stessoSetup(s, ora)), altri = SETUP_ELENCO.filter(s => !stessoSetup(s, ora)), sc = setupConfronto(), nf = contaFiltri();
    const id = String(CAMPO.ogg || ""), o = id.startsWith("@") ? null : trovaOggetto(id);
    const invito = () => comandi.querySelector(":scope > .gas-setup-invito");
    const nf0 = CAMPO.tel && CAMPO.tel.D ? Math.round(CAMPO.tel.F / CAMPO.tel.D * 10) / 10 : 0;
    return [
      ["setup", "strati", t("rq_setup"), qui ? qui.nome : setupCompleto() ? t("rq_da_salvare") : "–", () => [carta("miei_setup")]],
      ["tel", "cx_tel", eObiettivo(CAMPO.tel) ? `${t("rq_obiettivo")} f/${num(nf0, nf0 % 1 ? 1 : 0)}` : t("rq_tel"),
        CAMPO.tel ? `${num(r && r.F ? r.F : CAMPO.tel.F * (CAMPO.k || 1))} mm` : t("rq_scegli"), () => [carta("telescopio"), carta("riduttore")],
        eObiettivo(CAMPO.tel) ? t("rq_obiettivo") : t("rq_tel")],
      foto ? ["cam", "camere", t("rq_cam"), CAMPO.cam ? camCorta(CAMPO.cam.nome) : t("rq_scegli"), () => [modo, carta("camera"), invito()]]
        : ["cam", "cx_oc", t("rq_oc"), CAMPO.oc ? `${num(CAMPO.oc.f, CAMPO.oc.f % 1 ? 1 : 0)} mm` : t("rq_scegli"), () => [modo, carta("oculare"), invito()]],
      ["ogg", "centro", t("rq_ogg"), id.startsWith("@cometa:") ? id.slice(8) : id.startsWith("@") ? nomeCorpo(id.slice(1)) : o ? o.id : "–", () => [carta("oggetto")]],
      foto ? ["mos", "cx_camp", t("rq_mos"), `${CAMPO.nx || 1} × ${CAMPO.ny || 1}`, () => [carta("mosaico")]] : null,
      foto && rotBar ? ["rot", "cx_rot", t("rq_rot"), `${CAMPO.rot || 0}°`, () => [rotBar]] : null,
      altri.length ? ["conf", "confronta", t("rq_conf"), sc ? sc.nome : t("rq_nessuno"), () => [fogliettoConfronto(altri)]] : null,
      ["filtri", "cx_fil", t("rq_filtri"), nf ? String(nf) : t("rq_nessuno"), () => [carta("miei_filtri")]],
      ["posto", "orizzonte", t("vl_apri"), t("rq_posto_v"), null],
    ].filter(Boolean);
  };
  const fuocoRq = k => { const b = k && rqBox.querySelector(`[data-k="${k}"]`); if (b) try { b.focus({ preventScroll: true }); } catch (e) {   } };
  function disegnaRq() {
    if (!rqBox.isConnected && rqBox._mostrato) { SETUP_UI.delete(disegnaRq); return; }
    rqBox._mostrato = rqBox.isConnected;
    const x = rqBox.scrollLeft, fuoco = rqBox.contains(document.activeElement) ? document.activeElement.getAttribute("data-k") : null;
    svuota(rqBox).append(...vociRq().map(([k, ico, nome, scelta, pezzi, titolo]) => el("button", { type: "button", class: "gas-cielo-rq-v" + (rqAperto === k ? " on" : ""),
      "data-k": k, "aria-haspopup": pezzi ? "dialog" : null, "aria-label": `${nome}: ${scelta}`,
      onclick: () => {
        chiudiFoglioCampo();
        if (!pezzi) { apriVistaLuogo(CAMPO.ogg); return; }
        rqAperto = k; disegnaRq();
        apriFoglioCampo(titolo || nome, pezzi(), { leggero: ["mos", "rot", "conf"].includes(k), dopo: () => { rqAperto = null; disegnaRq(); fuocoRq(k); } });
      } }, icona(ico), el("b", null, scelta), el("small", null, nome))));
    rqBox.scrollLeft = x;
    fuocoRq(fuoco);
    setTimeout(() => rqBox.classList.toggle("gas-fine", rqBox.scrollLeft + rqBox.clientWidth >= rqBox.scrollWidth - 4));
  }
  SETUP_UI.add(disegnaRq);
  let confrontoVisto = "";
  const nomeConfronto = () => { const s = setupConfronto(); return s ? s.nome : ""; };
  const controllaConfronto = () => {
    if (!cieloBox.isConnected) { SETUP_UI.delete(controllaConfronto); return; }
    if (schedaAttiva === "campo" && nomeConfronto() !== confrontoVisto) aggiorna();
  };
  SETUP_UI.add(controllaConfronto);
  aggiungi(cieloBox, [rqBox, cielo, comandiCielo, piedeCielo, salti]);
  const stretto = window.matchMedia ? matchMedia("(max-width: 989px)") : null;
  const sistemaSotto = () => {
    if (!cieloBox.isConnected && sistemaSotto._fatto) { if (stretto && stretto.removeEventListener) stretto.removeEventListener("change", sistemaSotto); return; }
    sistemaSotto._fatto = true;
    if (stretto && stretto.matches) { sottoBox.append(comandiCielo, piedeCielo, salti); sottoBox.hidden = false; }
    else { cieloBox.append(comandiCielo, piedeCielo, salti); sottoBox.hidden = true; }
  };
  sistemaSotto();
  if (stretto && stretto.addEventListener) stretto.addEventListener("change", sistemaSotto);
  let compatto = false, dH = -1, hMisurata = -1;
  const misuraDH = () => {
    const h0 = hMisurata = cieloBox.offsetHeight;
    cieloBox.classList.add("gas-cielo-compatto");
    dH = Math.max(0, h0 - cieloBox.offsetHeight);
    cieloBox.classList.remove("gas-cielo-compatto");
  };
  const controllaCompatto = e => {
    if (!cieloBox.isConnected) { window.removeEventListener("scroll", controllaCompatto); window.removeEventListener("resize", controllaCompatto); return; }
    const cs = getComputedStyle(cieloBox);
    if (cs.position !== "sticky") { if (compatto) { compatto = false; cieloBox.classList.remove("gas-cielo-compatto"); cieloBox.style.marginBottom = ""; } return; }
    if (!compatto && (dH < 0 || cieloBox.offsetHeight !== hMisurata || (e && e.type === "resize"))) misuraDH();
    const su = cieloBox.parentNode.getBoundingClientRect().top, fermo = parseFloat(cs.top) || 0;
    const vuole = compatto ? su < fermo - dH + 20 : su < fermo - dH - 20;
    if (vuole === compatto || dH < 40) return;
    compatto = vuole;
    cieloBox.classList.toggle("gas-cielo-compatto", vuole);
    cieloBox.style.marginBottom = vuole ? dH + "px" : "";
  };
  window.addEventListener("scroll", controllaCompatto, { passive: true });
  window.addEventListener("resize", controllaCompatto);
  const riempiSalti = () => {
    const titolo = x => ((x.querySelector("h3") || {}).textContent || "").trim();
    const carte = [...comandi.children], trova = k => carte.find(c => titolo(c).startsWith(t(k)));
    const cam = CAMPO.modo === "foto" ? "camera" : "oculare";
    const voci = [["telescopio", trova("telescopio")], [cam, trova(cam)], ["oggetto", trova("oggetto")], ["cs_risultati", uscite]];
    svuota(salti).append(...voci.filter(([, n]) => n).map(([k, n]) => el("button", { type: "button", class: "gas-cielo-salto", onclick: () => {
      const f = fisarmonica.find(x => x.card === n);
      if (f) apriSezione(f.k);
      const nav = parseFloat(getComputedStyle(RADICE).getPropertyValue("--gas-nav-h")) || 0;
      const sopra = getComputedStyle(cieloBox).position === "sticky" ? cieloBox.getBoundingClientRect().height + nav + 24 : 90;
      window.scrollTo({ top: Math.max(0, n.getBoundingClientRect().top + window.scrollY - sopra), behavior: "smooth" });
    } }, t(k))));
  };
  const risultati = el("div", { class: "gas-risultati" });
  const prodotti = el("div", { class: "gas-prodotti" });
  const consigli = el("div", { class: "gas-consigli" });
  let chiaveConsigli = "";
  const pannelliMos = el("div", { class: "gas-mos-elenco" });
  const legenda = el("div", { class: "gas-legenda gas-legenda--mappa" }, el("span", { class: "gas-legenda-tit" }, t("legenda_mappa")),
    LEGENDA_MAPPA.map(([k, c]) => el("span", null, el("i", { style: { background: c } }), t("gruppo_" + k))));
  const SEZIONI = [["setup", "miei_setup"], ["tel", "telescopio"], ["k", "riduttore"], ["cam", "camera"], ["oc", "oculare"], ["filtri", "miei_filtri"],
    ["ogg", "oggetto"], ["mos", "mosaico"]];
  const riassunto = k => {
    try {
      if (k === "setup") return SETUP_ELENCO.length ? t("acc_setup_n", { n: SETUP_ELENCO.length }) : "";
      if (k === "tel") return CAMPO.tel ? nomeTel(CAMPO.tel) : "–";
      if (k === "k") return !CAMPO.k || CAMPO.k === 1 ? t("acc_nessuno") : `${num(CAMPO.k, CAMPO.k % 1 ? 2 : 0)}×`;
      if (k === "cam") return CAMPO.cam ? CAMPO.cam.nome : "–";
      if (k === "oc") return CAMPO.oc ? CAMPO.oc.nome : "–";
      if (k === "filtri") { const n = contaFiltri();   return n ? t("acc_filtri_n", { n }) : t("acc_nessuno"); }
      if (k === "ogg") {
        const id = String(CAMPO.ogg || "");
        if (id.startsWith("@cometa:")) return id.slice(8);
        if (id.startsWith("@")) return nomeCorpo(id.slice(1));
        const o = trovaOggetto(id);
        return o ? [o.id, nomeOggetto(o)].filter(Boolean).join(" · ") : id;
      }
      if (k === "mos") return `${CAMPO.nx || 1} × ${CAMPO.ny || 1}`;
    } catch (e) {   }
    return "";
  };
  const fisarmonica = [];
  const aggiornaRiassunti = () => { for (const f of fisarmonica) f.val.textContent = riassunto(f.k); };
  const apriSezione = k => {
    ACC_APERTA = k;
    for (const f of fisarmonica) { const on = f.k === k; f.card.classList.toggle("aperta", on); f.testa.setAttribute("aria-expanded", String(on)); }
  };
  const preparaSezioni = () => {
    for (const card of [...comandi.children]) {
      const h = card.querySelector(":scope > h3");
      if (!h) continue;
      const tit = (h.textContent || "").trim(), voce = SEZIONI.find(([, chiave]) => tit.startsWith(t(chiave)));
      if (!voce) continue;
      const k = voce[0], val = el("span", { class: "gas-acc-val" });
      const testa = el("button", { type: "button", class: "gas-acc-testa", "aria-expanded": "false",
        onclick: () => apriSezione(card.classList.contains("aperta") ? null : k) },
        el("span", { class: "gas-acc-tit" }, t(voce[1])), val, el("span", { class: "gas-acc-freccia", "aria-hidden": "true" }, "▾"));
      card.classList.add("gas-acc");
      card.prepend(testa);
      fisarmonica.push({ k, card, testa, val });
    }
    aggiornaRiassunti();
    apriSezione(ACC_APERTA);
    comandi.addEventListener("change", () => setTimeout(aggiornaRiassunti, 30));
    comandi.addEventListener("click", () => setTimeout(aggiornaRiassunti, 80));
  };
  setTimeout(() => {
    preparaSezioni(); riempiSalti();
    if (ridisegno) { pannello.style.minHeight = ""; window.scrollTo(0, yPrima); }
    if (RIAPRI_RQ && rqBox.isConnected) { const b = rqBox.querySelector(`[data-k="${RIAPRI_RQ}"]`); RIAPRI_RQ = null; if (b) b.click(); }
  }, 0);
  aggiungi(uscite, [risultati, pannelliMos, prodotti, consigli, legenda,
    el("p", { class: "gas-credito" }, t("credito_cielo"), fotoOk ? " " + t("credito_foto") : "", " ",
      el("span", { class: "gas-suggerimento" }, t("trascina")))]);
  let presa = null, pizzico = null, fotogrammaCielo = 0, giro = null;
  const tocchi = new Map();
  const angoloTocchi = () => { const [a, b] = [...tocchi.values()]; return Math.atan2(b.y - a.y, b.x - a.x) * DEG; };
  const distanzaTocchi = () => { const [a, b] = [...tocchi.values()]; return Math.hypot(b.x - a.x, b.y - a.y); };
  const centroVista = () => CENTRO || [oggetto().ra, oggetto().dec];
  const gradiPerPunto = () => geometria.cdelt * geometria.W / Math.max(1, svg.getBoundingClientRect().width);
  const ridisegnaPresto = () => { if (!fotogrammaCielo) fotogrammaCielo = requestAnimationFrame(() => { fotogrammaCielo = 0; caricaCielo(); }); };
  svg.addEventListener("pointerdown", e => {
    if (!geometria) return;
    if (e.target.closest && e.target.closest(".gas-rot-maniglia")) {
      const rc = svg.getBoundingClientRect(), sc = rc.width / geometria.W, x0 = rc.left + CENTRO_RIQ[0] * sc, y0 = rc.top + CENTRO_RIQ[1] * sc;
      giro = { x0, y0, a0: Math.atan2(e.clientY - y0, e.clientX - x0) * DEG, rot0: CAMPO.rot };
      svg.setPointerCapture(e.pointerId);
      e.preventDefault();
      return;
    }
    tocchi.set(e.pointerId, { x: e.clientX, y: e.clientY });
    svg.setPointerCapture(e.pointerId);
    if (tocchi.size === 1) { presa = { x: e.clientX, y: e.clientY, c: centroVista(), s: gradiPerPunto() }; svg.classList.add("presa"); }
    else if (tocchi.size === 2) { presa = null; pizzico = { d: distanzaTocchi(), a: angoloTocchi(), rot: CAMPO.rot, zoom: ZOOM }; }
  });
  svg.addEventListener("pointermove", e => {
    if (giro) { giraA(giro.rot0 - (Math.atan2(e.clientY - giro.y0, e.clientX - giro.x0) * DEG - giro.a0)); return; }
    if (!tocchi.has(e.pointerId) || !geometria) return;
    tocchi.set(e.pointerId, { x: e.clientX, y: e.clientY });
    if (pizzico && tocchi.size === 2) {
      ZOOM = clamp(pizzico.zoom * pizzico.d / Math.max(20, distanzaTocchi()), 0.02, 60);
      const d = ((angoloTocchi() - pizzico.a) % 360 + 540) % 360 - 180, dd = Math.abs(d) > 10 ? d - Math.sign(d) * 10 : 0;
      if (CAMPO.modo === "foto" && (dd || CAMPO.rot !== pizzico.rot)) giraA(pizzico.rot - dd);
      ridisegnaPresto();
      return;
    }
    if (!presa) return;
    CENTRO = daGnomonica(presa.c[0], presa.c[1], (e.clientX - presa.x) * presa.s, (e.clientY - presa.y) * presa.s);
    ridisegnaPresto();
  });
  const lascia = e => {
    if (giro) { giro = null; mostraMosaico(); return; }
    tocchi.delete(e.pointerId);
    if (tocchi.size < 2) pizzico = null;
    if (tocchi.size === 1) { const [p] = [...tocchi.values()]; presa = { x: p.x, y: p.y, c: centroVista(), s: gradiPerPunto() }; }
    if (!tocchi.size) { presa = null; svg.classList.remove("presa"); mostraMosaico(); caricaCielo(); }
  };
  svg.addEventListener("pointerup", lascia);
  svg.addEventListener("pointercancel", lascia);
  svg.addEventListener("dblclick", e => {
    if (!geometria) return;
    const r = svg.getBoundingClientRect(), s = gradiPerPunto(), c = centroVista();
    CENTRO = daGnomonica(c[0], c[1], -(e.clientX - r.left - r.width / 2) * s, -(e.clientY - r.top - r.height / 2) * s);
    caricaCielo(); mostraMosaico();
  });
  let avvisoRotella = null;
  svg.addEventListener("wheel", e => {
    if (!e.ctrlKey && !e.metaKey) {
      stato.textContent = t("ctrl_rotella"); stato.hidden = false;
      clearTimeout(avvisoRotella); avvisoRotella = setTimeout(() => { if (stato.textContent === t("ctrl_rotella")) stato.hidden = true; }, 1400);
      return;
    }
    e.preventDefault();
    ZOOM = clamp(ZOOM * Math.exp(clamp(e.deltaY, -60, 60) * 0.012), 0.02, 60);
    ridisegnaPresto();
  }, { passive: false });
  let geometria = null, ultimoUrl = "", attesaMappa = null, fotoFallita = false;
  function oggetto() { return trovaOggetto(CAMPO.ogg) || trovaOggetto("M31"); }
  function ingombroVista(giro) {
    const a = (CAMPO.modo === "foto" ? giro || 0 : 0) * RAD, c = Math.abs(Math.cos(a)), s = Math.abs(Math.sin(a));
    const ret = (w, h) => [w * c + h * s, w * s + h * c];
    const r = calcoloCampo(), rc = setupConfronto() && calcoloCampo(setupConfronto());
    let [bw, bh] = r && r.mosW ? ret(r.mosW, r.mosH) : r && r.campo ? [r.campo * 1.2, r.campo * 1.2] : [1.5, 1.5];
    const [cw, ch] = rc && rc.fovW ? ret(rc.fovW, rc.fovH) : rc && rc.campo ? [rc.campo * 1.2, rc.campo * 1.2] : [0, 0];
    return [Math.max(bw, cw), Math.max(bh, ch)];
  }
  function caricaCielo() {
    const o = oggetto();
    const [ra, dec] = CENTRO || [o.ra, o.dec];
    const box = cielo.getBoundingClientRect();
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    const prop = box.width && box.height ? box.height / box.width : 2 / 3;
    const [bw, bh] = ingombroVista(rotAdatta);
    let fov = Math.max(bw * 1.32, bh * 1.32 / Math.max(prop, 0.2), misuraOggetto(o) / 60 * 1.5, 0.08) * ZOOM;
    fov = clamp(fov, 0.03, 120);
    const cssW = box.width || 800;
    const W = Math.round(clamp(cssW * dpr, 400, 1600)), H = Math.round(W * prop);
    geometria = { ra, dec, fov, W, H, cdelt: fov / W, k: W / cssW };
    svg.setAttribute("viewBox", `0 0 ${W} ${H}`);
    svg.style.setProperty("--k", geometria.k.toFixed(3));
    disegna();
    const foto = fotoOk && VISTA_CIELO === "foto" && !fotoFallita;
    if (gl) gl.tela.hidden = !foto;
    if (img) img.hidden = !foto;
    telaMappa.hidden = foto;
    telaNomi.hidden = !foto || (!NOMI_CIELO && !GRIGLIA_CIELO && !o.corpo);
    if (foto) {
      firmaVista("DSS2 · STScI/NASA · CDS");
      if (gl) {
        gl.quando.errore = () => {
          fotoFallita = true; stato.textContent = t("foto_errore_mappa"); stato.hidden = false;
          setTimeout(() => { stato.hidden = true; }, 4000);
          caricaCielo();
        };
        gl.quando.pronto = () => { if (stato.textContent === t("carico_foto")) stato.hidden = true; };
        gl.hips.disegna(Object.assign({ grezzo: true }, geometria), ["dss"]);
      } else if (!presa && !pizzico) caricaFoto(ra, dec, fov, W, H);
    }
    if (!telaMappa.hidden) disegnaMappa(telaMappa, o, false);
    if (!telaNomi.hidden) disegnaMappa(telaNomi, o, true);
    disegnaRis();
  }
  let attesaRis = null;
  function disegnaRis(giro) {
    clearTimeout(attesaRis);
    const r = geometria && CAMPO.modo === "foto" ? calcoloCampo() : null;
    if (!RISULTATO_CIELO || !r || !r.projW) { telaRis.hidden = true; return; }
    const { W, H, cdelt, k } = geometria, sov = 1 - CAMPO.sov / 100;
    const mw = r.projW / cdelt * (1 + (CAMPO.nx - 1) * sov), mh = r.projH / cdelt * (1 + (CAMPO.ny - 1) * sov);
    const cx = W / 2 - SPOSTA[0] / cdelt, cy = H / 2 - SPOSTA[1] / cdelt, a = CAMPO.rot * RAD;
    const fonte = gl && !gl.tela.hidden ? gl.tela : img && !img.hidden && img.complete && img.naturalWidth ? img : telaMappa;
    if (telaRis.width !== W || telaRis.height !== H) { telaRis.width = W; telaRis.height = H; }
    const g = telaRis.getContext("2d");
    g.setTransform(1, 0, 0, 1, 0, 0);
    g.fillStyle = "#03060c"; g.fillRect(0, 0, W, H);
    const s = Math.min(W * 0.9 / mw, (H - 96 * k) / mh), dw = mw * s, dh = mh * s, x0 = (W - dw) / 2, y0 = 44 * k + (H - 96 * k - dh) / 2;
    g.save();
    g.beginPath(); g.rect(x0, y0, dw, dh); g.clip();
    g.translate(x0 + dw / 2, y0 + dh / 2); g.scale(s, s); g.rotate(a); g.translate(-cx, -cy);
    try { g.drawImage(fonte, 0, 0, W, H); } catch (e) {   }
    g.restore();
    g.strokeStyle = "#e2b84f"; g.lineWidth = 2 * k; g.strokeRect(x0, y0, dw, dh);
    g.fillStyle = "#f4d58b"; g.font = `700 ${14 * k}px ${getComputedStyle(RADICE).fontFamily}`; g.textBaseline = "alphabetic";
    g.fillText(`${t("ris_titolo")} · ${angoli(r.mosW || r.fovW, r.mosH || r.fovH)} · ${t("ris_camera", { g: CAMPO.rot || 0 })}`, x0, y0 - 12 * k, W - x0 - 12 * k);
    const R = 22 * k, bx = x0 + dw - R - 8 * k, by = y0 + R + 8 * k, nx = Math.sin(a), ny = -Math.cos(a);
    g.fillStyle = "rgba(3, 6, 12, .62)"; g.beginPath(); g.arc(bx, by, R, 0, 2 * Math.PI); g.fill();
    g.strokeStyle = g.fillStyle = "#e2b84f"; g.lineWidth = 2 * k;
    g.beginPath(); g.moveTo(bx - nx * R * 0.55, by - ny * R * 0.55); g.lineTo(bx + nx * R * 0.2, by + ny * R * 0.2); g.stroke();
    g.font = `800 ${12 * k}px ${getComputedStyle(RADICE).fontFamily}`; g.textAlign = "center"; g.textBaseline = "middle";
    g.fillText((t("vs_card").split(",")[0] || "N"), bx + nx * R * 0.58, by + ny * R * 0.58);
    g.textAlign = "start";
    telaRis.hidden = false;
    if ((giro || 0) < 2) attesaRis = setTimeout(() => { if (cieloBox.isConnected && RISULTATO_CIELO) disegnaRis((giro || 0) + 1); }, giro ? 1300 : 700);
  }
  function disegnaMappa(tela, o, foto) {
    const g = geometria, k = g.k;
    const chiave = [g.ra.toFixed(6), g.dec.toFixed(6), g.fov.toFixed(6), g.W, g.H, o.id, foto ? 1 : 0, NOMI_CIELO ? 1 : 0, GRIGLIA_CIELO ? 1 : 0, CENTRO ? 1 : 0].join("|");
    if (chiave === tela._chiave) return;
    tela._chiave = chiave;
    const riservati = riservatiVista(g, o);
    clearTimeout(attesaMappa);
    if (!foto) attesaMappa = setTimeout(() => { stato.textContent = t("carico_cielo"); stato.hidden = false; }, 250);
    Mappa.disegna(tela, g, { oggetto: o, riservati, senzaPrincipale: !CENTRO, sopraFoto: foto, senzaNomi: !NOMI_CIELO, griglia: GRIGLIA_CIELO }).then(f => {
      if (!f) return;
      clearTimeout(attesaMappa);
      if (!foto) { if (stato.textContent === t("carico_cielo")) stato.hidden = true; firmaVista(t("firma_mappa"), `mag ${num(f.mlim, 1)}`); }
    }).catch(e => {
      clearTimeout(attesaMappa); tela._chiave = "";
      if (!foto) { stato.textContent = t("cielo_errore"); stato.hidden = false; }
      console.error("strumenti, mappa:", e);
    });
  }
  function riservatiVista(g, o) {
    const k = g.k;
    const fr = firma.getBoundingClientRect(), cr = cielo.getBoundingClientRect();
    const fw = fr.width && cr.width ? Math.max(240, cr.right - fr.left + 8 + (telaMappa.hidden || /mag/.test(firma.textContent) ? 0 : 80)) : 240;
    const fh = fr.height && cr.height ? Math.max(24, fr.bottom - cr.top + 4) : 24;
    return [[g.W - 92 * k, g.H - 92 * k, 92 * k, 92 * k], [0, g.H - 52 * k, Math.min(g.W * 0.4, 230 * k), 52 * k],
      [g.W - fw * k, 0, fw * k, fh * k], [0, 0, Math.min(g.W * 0.75, (titoloVista(o).length * 9.5 + 30) * k), 38 * k]];
  }
  function titoloVista(o) {
    if (!CENTRO) return titoloOggetto(o);
    return `${raHms(CENTRO[0]).replace(/\s\d+s$/, "")} · ${decDms(CENTRO[1]).replace(/\s\d+″$/, "")}`;
  }
  function caricaFoto(ra, dec, fov, W, H) {
    const url = urlCielo(ra, dec, fov, W, H);
    if (url === ultimoUrl) return;
    ultimoUrl = url;
    stato.textContent = t("carico_foto"); stato.hidden = false;
    img.onerror = () => {
      if (!img.dataset.riserva) { img.dataset.riserva = "1"; img.src = urlCielo(ra, dec, fov, W, H, true); return; }
      fotoFallita = true; ultimoUrl = ""; telaMappa._chiave = telaNomi._chiave = "";
      stato.textContent = t("foto_errore_mappa"); stato.hidden = false;
      setTimeout(() => { stato.hidden = true; }, 4000);
      caricaCielo();
    };
    img.onload = () => { stato.hidden = true; delete img.dataset.riserva; };
    img.src = url;
  }
  function disegna() {
    svuota(svg);
    if (!geometria) return;
    const { W, H, cdelt, k } = geometria;
    const r = calcoloCampo();
    const cx = W / 2 - SPOSTA[0] / cdelt, cy = H / 2 - SPOSTA[1] / cdelt;
    const oro = "#e2b84f";
    const o = oggetto();
    let mx = W / 2, my = H / 2;
    if (CENTRO) {
      const [ox, oy] = aGnomonica(geometria.ra, geometria.dec, o.ra, o.dec);
      mx = W / 2 - ox / cdelt; my = H / 2 - oy / cdelt;
    }
    const g0 = Math.max(5 * k, o && o.corpo ? o.diam / 7200 / cdelt * (o.corpo === "saturno" ? 2.3 : 1) + 4 * k : 0), g1 = g0 + 9 * k;
    if (mx > -20 && my > -20 && mx < W + 20 && my < H + 20 && g0 < Math.min(W, H) / 3) svg.appendChild(sv("g", { class: "gas-mira" },
      sv("line", { x1: mx - g1, y1: my, x2: mx - g0, y2: my }), sv("line", { x1: mx + g0, y1: my, x2: mx + g1, y2: my }),
      sv("line", { x1: mx, y1: my - g1, x2: mx, y2: my - g0 }), sv("line", { x1: mx, y1: my + g0, x2: mx, y2: my + g1 })));
    const mioSetup = SETUP_ELENCO.find(s => stessoSetup(s, setupAttuale())), nomeMio = etichettaSetup(mioSetup);
    const piccola = (svg.getBoundingClientRect().width || 800) < 600, nomeOro = nomeMio || (CAMPO.cam && CAMPO.cam.nome) || "";
    const intero = s => s ? (etichettaSetup(s) || nomeSetupAuto(s)) : "";
    const adatta = (tx, lungo, corto, maxPx) => {
      if (!tx || !lungo || lungo === corto) return;
      try { tx.textContent = lungo; if (!(tx.getBoundingClientRect().width <= maxPx)) tx.textContent = corto; } catch (e) { tx.textContent = corto; }
    };
    const scalaPx = (svg.getBoundingClientRect().width || W) / W;
    const rotV = CAMPO.modo === "foto" ? CAMPO.rot : 0;
    const capovolto = Math.cos(rotV * RAD) < 0;
    const dritta = (x, y, resto) => Object.assign({ x, y }, capovolto ? { transform: `rotate(180 ${x} ${y})` } : {}, resto);
    const spostaScritta = (tx, d) => {
      const x = +tx.getAttribute("x") + d * Math.cos(rotV * RAD), y = +tx.getAttribute("y") + d * Math.sin(rotV * RAD);
      tx.setAttribute("x", String(x)); tx.setAttribute("y", String(y));
      if (capovolto) tx.setAttribute("transform", `rotate(180 ${x} ${y})`);
    };
    if (r && r.projW) {
      const pw = r.projW / cdelt, ph = r.projH / cdelt, sov = 1 - CAMPO.sov / 100;
      const g = sv("g", { transform: `translate(${cx} ${cy}) rotate(${-CAMPO.rot})` });
      let n = 0;
      for (let j = 0; j < CAMPO.ny; j++) for (let i = 0; i < CAMPO.nx; i++) {
        n++;
        const x = (i - (CAMPO.nx - 1) / 2) * pw * sov, y = (j - (CAMPO.ny - 1) / 2) * ph * sov;
        g.appendChild(sv("rect", { x: x - pw / 2, y: y - ph / 2, width: pw, height: ph, fill: "rgba(216,174,67,0.07)", stroke: oro,
          "stroke-width": 1.8, "vector-effect": "non-scaling-stroke" }));
        if (CAMPO.nx * CAMPO.ny > 1) g.appendChild(sv("text", { x, y: y + 6 * k, "text-anchor": "middle", class: "gas-svg-num", text: String(n),
          transform: `rotate(${CAMPO.rot} ${x} ${y})` }));
      }
      const lx = -pw * (1 + (CAMPO.nx - 1) * sov) / 2 + 6 * k, alto = -ph * (1 + (CAMPO.ny - 1) * sov) / 2;
      const qx = capovolto ? -lx : lx, qy = capovolto ? 8 * k - alto : alto - 8 * k;
      const a = -CAMPO.rot * RAD, ax = cx + qx * Math.cos(a) - qy * Math.sin(a), ay = cy + qx * Math.sin(a) + qy * Math.cos(a);
      const larghTitolo = Math.min(W * 0.75, (titoloVista(o).length * 9.5 + 30) * k);
      const sottoTitolo = ay < 46 * k && ax < larghTitolo;
      const scrittaOro = piccola ? null : sv("text", sottoTitolo
        ? dritta(capovolto ? lx : -lx, capovolto ? alto + 8 * k : -alto - 8 * k, { "text-anchor": "end", class: "gas-svg-etich", text: nomeOro })
        : dritta(qx, qy, { class: "gas-svg-etich", text: nomeOro }));
      if (scrittaOro) g.appendChild(scrittaOro);
      if (CAMPO.modo === "foto") {
        const mx0 = -lx + 6 * k - 12 * k, my0 = alto;
        g.appendChild(sv("g", { class: "gas-rot-maniglia", transform: `translate(${mx0 + 12 * k} ${my0})` },
          sv("circle", { class: "gas-rot-presa", r: 22 * k }), sv("circle", { r: 13 * k }), sv("text", { "text-anchor": "middle", "dominant-baseline": "central", text: "↻", style: `font-size:${16 * k}px` })));
      }
      CENTRO_RIQ = [cx, cy];
      svg.appendChild(g);
      adatta(scrittaOro, intero(mioSetup) || nomeSetupAuto(setupAttuale()), nomeOro, pw * (1 + (CAMPO.nx - 1) * sov) * scalaPx - 12);
    } else if (r && r.projR) {
      const rr = r.projR / cdelt;
      svg.appendChild(sv("circle", { cx, cy, r: rr, fill: "rgba(216,174,67,0.06)", stroke: oro, "stroke-width": 1.8, "vector-effect": "non-scaling-stroke" }));
      svg.appendChild(sv("text", { x: cx, y: cy - rr - 8 * k, "text-anchor": "middle", class: "gas-svg-etich", text: `${nomeMio ? nomeMio + " · " : ""}${num(r.M)}× · ${angolo(r.campo)}` }));
    }
    const sc = setupConfronto(), rc = sc && calcoloCampo(sc);
    const nomeCf = sc ? etichettaSetup(sc) || nomeCorto(sc.cam && sc.cam.nome && !(CAMPO.cam && CAMPO.cam.nome === sc.cam.nome) ? sc.cam.nome : sc.tel ? nomeTel(sc.tel) : sc.nome) : "";
    if (rc && (rc.projW || rc.projR)) {
      const tratto = { fill: "none", class: "gas-confronto-linea", "stroke-width": 1.8 * k, "stroke-dasharray": `${8 * k} ${6 * k}` };
      let scritta;
      if (rc.projW) {
        const pw = rc.projW / cdelt, ph = rc.projH / cdelt;
        scritta = sv("text", dritta(capovolto ? 4 * k - pw / 2 : pw / 2 - 4 * k, capovolto ? -ph / 2 - 17 * k : ph / 2 + 17 * k,
          { "text-anchor": "end", class: "gas-svg-etich gas-svg-etich--confronto", text: nomeCf }));
        svg.appendChild(sv("g", { transform: `translate(${cx} ${cy}) rotate(${-rotV})` },
          sv("rect", Object.assign({ x: -pw / 2, y: -ph / 2, width: pw, height: ph }, tratto)), piccola ? null : scritta));
      } else {
        const rr = rc.projR / cdelt;
        scritta = sv("text", { x: cx, y: cy + rr + 19 * k, "text-anchor": "middle", class: "gas-svg-etich gas-svg-etich--confronto", text: nomeCf });
        svg.appendChild(sv("g", null, sv("circle", Object.assign({ cx, cy, r: rr }, tratto)), piccola ? null : scritta));
      }
      if (!piccola) adatta(scritta, intero(sc), nomeCf, (svg.getBoundingClientRect().width || W) - 12);
      if (!piccola) try {
        const s = svg.getBoundingClientRect(), u = W / (s.width || W);
        let b = scritta.getBoundingClientRect(), testo = scritta.textContent;
        while (b.width && b.width > s.width - 12 && testo.length > 8) { testo = testo.slice(0, -2).trimEnd(); scritta.textContent = testo + "…"; b = scritta.getBoundingClientRect(); }
        const dx = b.left < s.left + 6 ? s.left + 6 - b.left : b.right > s.right - 6 ? s.right - 6 - b.right : 0;
        if (b.width && dx) {
          if (rc.projW) spostaScritta(scritta, dx * u);
          else scritta.setAttribute("x", String(+scritta.getAttribute("x") + dx * u));
        }
      } catch (e) {   }
    }
    const voci = piccola && r && (r.projW || r.projR) ? [["oro", intero(mioSetup) || nomeSetupAuto(setupAttuale()) || nomeOro], rc && (rc.projW || rc.projR) ? ["az", intero(sc) || nomeCf] : null].filter(x => x && x[1]) : [];
    svuota(legendaRiq).hidden = !voci.length;
    for (const [c, n] of voci) legendaRiq.appendChild(el("span", { class: "gas-lg-voce gas-lg-voce--" + c }, el("i", { "aria-hidden": "true" }), el("span", { class: "gas-lg-nome" }, n),
      c === "az" ? el("button", { type: "button", class: "gas-lg-togli", title: t("cf_togli"), "aria-label": t("cf_togli"),
        onclick: () => { CONFRONTO = ""; salva("confronto", ""); aggiorna(); } }, "✕") : null));
    if (o && o.corpo === "giove" && o.quando) {
      const lune = luneGiove(Astro.jd(o.quando), o.polo || 0, o.diam).filter(m => !m.sulDisco)
        .map(m => ({ m, x: mx - m.est / cdelt, y: my - m.nord / cdelt })).filter(p => p.x > -9 && p.y > -9 && p.x < W + 9 && p.y < H + 9);
      lune.sort((a, b) => a.x - b.x).forEach((p, i) => {
        const vicina = lune[i - 1] && Math.abs(lune[i - 1].x - p.x) < 46 * k;
        p.sotto = vicina ? !lune[i - 1].sotto : false;
        svg.appendChild(sv("g", { class: "gas-lune" }, sv("circle", { cx: p.x, cy: p.y, r: 2.4 * k }),
          sv("text", { x: p.x, y: p.sotto ? p.y + 15 * k : p.y - 7 * k, "text-anchor": "middle", text: nomeLunaGiove(p.m.nome) })));
      });
    }
    const scale = [1 / 60, 2 / 60, 5 / 60, 10 / 60, 15 / 60, 0.5, 1, 2, 5, 10, 20, 30];
    const vorrei = geometria.fov * 0.18;
    const s = scale.reduce((a, b) => Math.abs(b - vorrei) < Math.abs(a - vorrei) ? b : a);
    const sl = s / cdelt;
    svg.appendChild(sv("g", { class: "gas-svg-scala" },
      sv("line", { x1: 16 * k, y1: H - 18 * k, x2: 16 * k + sl, y2: H - 18 * k }),
      sv("text", { x: 16 * k + sl / 2, y: H - 26 * k, "text-anchor": "middle", text: s < 1 ? num(s * 60) + "′" : num(s) + "°" })));
    const bx = W - 28 * k, by = H - 28 * k, L = 28 * k, card = t("vs_card").split(",");
    svg.appendChild(sv("g", { class: "gas-svg-bussola" },
      sv("line", { x1: bx, y1: by, x2: bx, y2: by - L }), sv("line", { x1: bx, y1: by, x2: bx - L, y2: by }),
      sv("text", { x: bx, y: by - L - 5 * k, "text-anchor": "middle", text: card[0] || "N" }),
      sv("text", { x: bx - L - 6 * k, y: by + 4 * k, "text-anchor": "end", text: card[1] || "E" })));
    if (o) svg.appendChild(sv("text", { x: 14 * k, y: 27 * k, class: "gas-svg-ogg", text: titoloVista(o) }));
    disegnaRis();
  }
  function mostraMosaico() {
    const aperto = !!(pannelliMos.querySelector("details") || {}).open;
    svuota(pannelliMos);
    ultimiCentri = [];
    const r = calcoloCampo();
    if (!r || !r.projW || !geometria) return;
    const sov = 1 - CAMPO.sov / 100, a = CAMPO.rot * RAD;
    const centri = [];
    let n = 0;
    for (let j = 0; j < CAMPO.ny; j++) for (let i = 0; i < CAMPO.nx; i++) {
      n++;
      const x = (i - (CAMPO.nx - 1) / 2) * r.projW * sov, y = (j - (CAMPO.ny - 1) / 2) * r.projH * sov;
      const xr = x * Math.cos(a) + y * Math.sin(a), yr = -x * Math.sin(a) + y * Math.cos(a);
      const est = SPOSTA[0] - xr, nord = SPOSTA[1] - yr;
      centri.push([n, ...daGnomonica(geometria.ra, geometria.dec, est, nord), j + 1, i + 1]);
    }
    ultimiCentri = centri;
    const titolo = centri.length > 1 ? t("centri_pannelli") : t("centro_inquadratura");
    pannelliMos.appendChild(el("details", { class: "gas-dettagli", open: aperto }, el("summary", null, titolo),
      el("table", { class: "gas-tab" }, el("thead", null, el("tr", null, centri.length > 1 ? el("th", null, "#") : null, el("th", null, t("cp_ra")), el("th", null, t("cp_dec")))),
        el("tbody", null, centri.map(([k, ra, dec]) => el("tr", null, centri.length > 1 ? el("td", null, k) : null, el("td", null, raHms(ra)), el("td", null, decDms(dec))))))));
    const o = oggetto();
    if (o.corpo) return;
    const nome = String(o.id || "").replace(/[,"]/g, " ").trim() || "Target";
    const csv = csvMosaico(nome, daGnomonica(geometria.ra, geometria.dec, SPOSTA[0], SPOSTA[1]), centri, r);
    const file = `giordano-${nome.replace(/[^a-z0-9]+/gi, "-").toLowerCase()}${centri.length > 1 ? "-mosaico" : ""}.csv`;
    pannelliMos.appendChild(el("div", { class: "gas-esporta" },
      el("b", null, icona("esporta"), " ", t("esp_titolo")),
      el("div", { class: "gas-riga-bottoni" },
        el("button", { type: "button", class: "gas-btn gas-btn--mini", onclick: () => scaricaTesto(csv, file, "text/csv;charset=utf-8") }, t("esp_scarica")),
        el("button", { type: "button", class: "gas-btn gas-btn--chiaro gas-btn--mini", onclick: e => copia(csv, e.currentTarget) }, t("esp_copia"))),
      el("small", null, t("esp_n"))));
  }
  function aggiorna() {
    salvaCampo();
    confrontoVisto = nomeConfronto();
    aggiornaSetupUI();
    const r = calcoloCampo();
    svuota(telInfo);
    if (CAMPO.tel) telInfo.append(el("div", null, el("b", null, nomeTel(CAMPO.tel)), " · ",
      `${num(CAMPO.tel.D)}/${num(CAMPO.tel.F)} mm · f/${num(CAMPO.tel.F / CAMPO.tel.D, 1)}`),
      bottoniConfigurazione(() => vistaCampo(pannello)) || "", bottoniDiaframma(CAMPO.tel, () => aggiorna()) || "", bottoneAttrezzo("tel", CAMPO.tel) || "");
    else telInfo.appendChild(el("div", { class: "gas-muto" }, t("scegli_telescopio")));
    $$("input", telD).forEach(i => { if (document.activeElement !== i) i.value = CAMPO.tel ? Math.round(CAMPO.tel.D * 100) / 100 : ""; });
    $$("input", telF).forEach(i => { if (document.activeElement !== i) i.value = CAMPO.tel ? CAMPO.tel.F : ""; });
    $$("input", telN).forEach(i => { if (document.activeElement !== i) i.value = CAMPO.tel && CAMPO.tel.D ? Math.round(CAMPO.tel.F / CAMPO.tel.D * 100) / 100 : ""; });
    telN.style.display = eObiettivo(CAMPO.tel) ? "none" : "";
    rid.disabled = !!(CAMPO.tel && CAMPO.tel.smart);
    svuota(ridNeg);
    if (CAMPO.k !== 1 && !rid.disabled) {
      ridNeg.appendChild(bottoneAttrezzo("k", { k: CAMPO.k }));
      const tipo = CAMPO.k < 1 ? ["riduttore"] : ["barlow"];
      const lista = DATI.ottiche.filter(x => Math.abs(x.k - CAMPO.k) < 0.006 && (CAMPO.k < 1 ? x.tipo !== "barlow" : x.tipo === "barlow")).slice(0, 4);
      if (lista.length) ridNeg.appendChild(el("small", null, t(tipo[0] === "barlow" ? "barlow_negozio" : "riduttori_negozio"), " ",
        lista.map((x, i) => [i ? " · " : "", el("a", { href: urlProdotto(x.h), target: "_blank", rel: "noopener" }, x.t)])));
    }
    svuota(camInfo);
    if (CAMPO.modo === "foto") {
      if (CAMPO.cam && CAMPO.cam.w) camInfo.append(el("div", null, el("b", null, CAMPO.cam.nome), " · ", rigaCamera(CAMPO.cam)),
        CAMPO.tel && CAMPO.tel.smart ? "" : bottoneAttrezzo("cam", CAMPO.cam));
      else camInfo.appendChild(el("div", { class: "gas-muto" }, t("scegli_camera")));
      [[camW, "w"], [camH, "h"], [camPx, "px"]].forEach(([c, k]) => $$("input", c).forEach(i => {
        if (document.activeElement !== i) i.value = CAMPO.cam && CAMPO.cam[k] != null ? CAMPO.cam[k] : "";
      }));
    } else if (CAMPO.oc) camInfo.append(el("div", null, el("b", null, CAMPO.oc.nome), " · ", `${num(CAMPO.oc.f, 1)} mm · ${num(CAMPO.oc.afov)}°`),
      bottoneAttrezzo("oc", CAMPO.oc));
    const o = oggetto();
    svuota(oggInfo).appendChild(el("div", null, el("b", null, titoloOggetto(o)), el("br"), rigaOggetto(o, true)));
    if (r && r.fovW) sintesi.textContent = `${angoli(r.fovW, r.fovH)} · ${num(r.scala, 2)}″/px · f/${num(r.N, 1)}` +
      (CAMPO.nx * CAMPO.ny > 1 ? ` · ${t("mosaico")} ${CAMPO.nx}×${CAMPO.ny}` : "");
    else if (r && r.M) sintesi.textContent = `${num(r.M)}× · ${angolo(r.campo)} · ${t("pupilla")} ${num(r.pupilla, 1)} mm`;
    else sintesi.textContent = t("mancano_dati");
    notaTenue.hidden = !(o.op && o.op <= 3 && !o.nomi && !o.top);
    svuota(risultati);
    if (!r) { risultati.appendChild(el("p", { class: "gas-muto" }, t("mancano_dati"))); }
    else if (CAMPO.modo === "foto" && r.fovW) {
      const [classe, giudizio, spiega] = giudizioCampionamento(r.scala, CAMPO.seeing);
      const occ = riempimento(o, { w: r.mosW, h: r.mosH });
      risultati.appendChild(el("div", { class: "gas-numeri" },
        cifra(t("campo_inquadrato"), angoli(r.fovW, r.fovH), t("diagonale") + " " + angolo(r.fovD), "fov"),
        cifra(t("scala"), `${num(r.scala, 2)}″/px`, CAMPO.bin > 1 ? `bin ${CAMPO.bin}×${CAMPO.bin}` : "", "scala"),
        cifra(t("focale_effettiva"), `${num(r.F)} mm`, `f/${num(r.N, 1)}`, "fnum"),
        cifra(t("immagine"), `${num(r.imgW)} × ${num(r.imgH)} px`, `${num(r.imgW * r.imgH / 1e6, 1)} MP · ${num(r.wmm, 1)} × ${num(r.hmm, 1)} mm`)));
      if (o.corpo) risultati.appendChild(boxPlanetario(o, r));
      else risultati.appendChild(el("div", { class: "gas-giudizio gas-giudizio--" + classe },
        el("b", null, t("campionamento"), " ", infoBtn("campionamento"), ": ", giudizio),
        el("span", null, t("camp_dettaglio", { s: num(CAMPO.seeing, 1), a: num(CAMPO.seeing / 3, 2), b: num(CAMPO.seeing / 2, 2) }), " ", spiega)));
      const righe = [
        riga(t("risoluzione_dawes"), `${num(r.dawes, 2)}″`, t("risoluzione_nota")),
        CAMPO.nx * CAMPO.ny > 1 ? riga(t("mosaico_totale"), angoli(r.mosW, r.mosH), `${CAMPO.nx * CAMPO.ny} ${t("pannelli")}`) : null,
        o.corpo ? null : riga(t("riempimento"), `${num(occ, occ < 10 ? 1 : 0)} %`, occ > 100 ? t("non_entra") : occ < 8 ? t("molto_piccolo") : ""),
      ];
      risultati.appendChild(el("div", { class: "gas-righe" }, righe));
      const dob = boxInseguimento(o, r);
      if (dob) risultati.appendChild(dob);
      risultati.appendChild(boxConsiglioFiltro(o));
      if (!o.corpo) { const tp = boxTempoPosa(o); if (tp) risultati.appendChild(tp); }
    } else if (CAMPO.modo === "visuale" && r.M) {
      const avvisi = [];
      if (r.M > r.Mmax) avvisi.push(t("troppo_ingrandimento", { m: num(r.Mmax) }));
      if (r.pupilla > 7) avvisi.push(t("pupilla_grande"));
      risultati.appendChild(el("div", { class: "gas-numeri" },
        cifra(t("ingrandimento"), `${num(r.M)}×`, t("max_utile") + " " + num(r.Mmax) + "×"),
        cifra(t("campo_reale"), angolo(r.campo), ""),
        cifra(t("pupilla"), `${num(r.pupilla, 1)} mm`, r.pupilla < 0.5 ? t("pupilla_piccola") : "", "pupilla"),
        cifra(t("focale_effettiva"), `${num(r.F)} mm`, `f/${num(r.N, 1)}`, "fnum")));
      if (avvisi.length) risultati.appendChild(el("div", { class: "gas-giudizio gas-giudizio--poco_sotto" }, avvisi.join(" ")));
      risultati.appendChild(el("div", { class: "gas-righe" }, riga(t("risoluzione_dawes"), `${num(r.dawes, 2)}″`, t("risoluzione_nota")),
        riga(t("ingr_minimo"), `${num(r.Mmin)}×`, t("ingr_minimo_n"))));
      risultati.appendChild(boxConsiglioFiltro(o));
    } else risultati.appendChild(el("p", { class: "gas-muto" }, CAMPO.modo === "foto" ? t("scegli_camera") : t("scegli_oculare")));
    const sc = setupConfronto(), rc = sc && calcoloCampo(sc);
    if (r && (r.fovW || r.M) && rc && (rc.fovW || rc.M)) risultati.insertBefore(boxConfronto(r, rc, sc.nome), risultati.children[1] || null);
    svuota(prodotti);
    if (CAMPO.tel && CAMPO.tel.h) prodotti.appendChild(boxProdotto(CAMPO.tel.h, nomeTel(CAMPO.tel), CAMPO.tel.foto, t("il_telescopio")));
    if (CAMPO.modo === "foto" && CAMPO.cam && CAMPO.cam.h_negozio && !(CAMPO.tel && CAMPO.tel.smart && CAMPO.tel.h === CAMPO.cam.h_negozio))
      prodotti.appendChild(boxProdotto(CAMPO.cam.h_negozio, CAMPO.cam.nome, null, t("la_camera")));
    if (CAMPO.modo === "visuale" && CAMPO.oc && CAMPO.oc.h) prodotti.appendChild(boxProdotto(CAMPO.oc.h, CAMPO.oc.nome, CAMPO.oc.foto, t("l_oculare")));
    const kc = CAMPO.modo === "foto" && !o.corpo ? [o.id, CAMPO.tel && CAMPO.tel.F, CAMPO.k, CAMPO.cam && (CAMPO.cam.id || CAMPO.cam.w + "x" + CAMPO.cam.px)].join("|") : "";
    if (kc !== chiaveConsigli) {
      chiaveConsigli = kc;
      svuota(consigli);
      if (kc) consigli.appendChild(boxConsigliProdotti(o, () => vistaCampo(pannello)));
    }
    rotAdatta = CAMPO.rot || 0;
    caricaCielo();
    mostraMosaico();
    aggiornaHash("campo");
  }
  if (window.ResizeObserver) {
    let ultima = 0;
    new ResizeObserver(debounce(() => {
      const w = Math.round(cielo.getBoundingClientRect().width);
      if (Math.abs(w - ultima) > 40) { ultima = w; ultimoUrl = ""; telaMappa._chiave = telaNomi._chiave = ""; caricaCielo(); }
    }, 300)).observe(cielo);
  }
  aggiorna();
}
const camEIntegrata = c => !!(c && c.id && (DATI.perCamera.get(c.id) || {}).cat === "smart");
function scegliTelescopio(x) {
  const eraSmart = !!(CAMPO.tel && CAMPO.tel.smart);
  CAMPO.tel = telDaVoce(x);
  if (!CAMPO.tel.smart && (eraSmart || camEIntegrata(CAMPO.cam))) {
    CAMPO.cam = copiaProfonda(((ATTREZZI && ATTREZZI.cam) || []).find(c => !camEIntegrata(c))) || null;
  }
  if (CAMPO.tel.smart) {
    const c = camSmartPer(x.t, x.h);
    if (c) { CAMPO.cam = camScelta(c); CAMPO.modo = "foto"; if (c.D && c.F) { CAMPO.tel.D = c.D; CAMPO.tel.F = c.F; } }
    else CAMPO.cam = null;
  }
  salvaCampo();
}
function scegliCamera(c) {
  CAMPO.modo = "foto";
  CAMPO.cam = camScelta(c);
  if (c.cat === "smart" && c.D && c.F) CAMPO.tel = { nome: c.nome, D: c.D, F: c.F, smart: true, h: c.h_negozio };
  else if (c.cat !== "smart" && CAMPO.tel && CAMPO.tel.smart)
    CAMPO.tel = copiaProfonda(((ATTREZZI && ATTREZZI.tel) || []).find(x => !x.smart && x.F && x.D)) || null;
  salvaCampo();
}
function cifra(titolo, valore, nota, info) {
  return el("div", { class: "gas-cifra" }, el("small", null, titolo, info ? [" ", infoBtn(info)] : null), el("b", null, valore), nota ? el("span", null, nota) : null);
}
function rigaCamera(c) {
  const p = [];
  if (c.sensore) p.push(c.sensore);
  if (c.w && c.h) p.push(`${num(c.w)}×${num(c.h)}`);
  if (c.px) p.push(`${num(c.px, c.px < 3 ? 2 : 2)} µm`);
  if (c.mm) p.push(`${num(c.mm[0], 1)}×${num(c.mm[1], 1)} mm`);
  return p.join(" · ");
}
function rigaOggetto(o, lungo) {
  if (o.corpo) {
    const q = [t("tipo_" + o.t), `⌀ ${o.diam >= 120 ? angolo(o.diam / 3600) : num(o.diam, 1) + "″"}`, `mag ${num(o.mag, 1)}`];
    if (o.k != null && o.k < 0.995 && o.corpo !== "sole") q.push(`${num(o.k * 100)} % ${t("illuminato")}`);
    q.push(o.corpo === "sole" ? giorno(o.quando) : `${t("alle")} ${ora(o.quando)}`);
    return q.join(" · ");
  }
  const p = [t("tipo_" + o.t)];
  if (o.c) p.push(nomeCostellazione(o.c));
  if (o.a) p.push(o.b ? `${numAuto(o.a)}′ × ${numAuto(o.b)}′` : `${numAuto(o.a)}′`);
  if (o.mag != null) p.push(`mag ${num(o.mag, 1)}`);
  if (lungo) {
    const g = gruppoOggetto(o);
    if (g) p.push(t("parte_di") + " " + g);
    if (o.alias.length) p.push(o.alias.slice(0, 3).join(", "));
  }
  return p.join(" · ");
}
function camScelta(c) {
  return { id: c.id, nome: c.nome, w: c.w, h: c.h, px: c.px, sensore: c.sensore, mm: c.mm, h_negozio: c.h_negozio };
}
function camSmartPer(titolo, h) {
  const delNegozio = h && DATI.camere.find(c => c.cat === "smart" && c.h_negozio === h && !/grandangolo|wide/i.test(c.modello));
  if (delNegozio) return delNegozio;
  const tt = normParole(titolo), ta = norm(titolo), parole = new Set(tt.split(/[^a-z0-9]+/));
  let migliore = null;
  for (const c of DATI.camere) {
    if (c.cat !== "smart") continue;
    const m = normParole(c.modello).replace(/\(.*\)/, "").trim(), pm = m.split(/[^a-z0-9]+/).filter(Boolean);
    if (!m || !(tt.includes(m) || ta.includes(norm(m)) || (pm.length && pm.every(p => parole.has(p))))) continue;
    const lm = migliore ? normParole(migliore.modello).replace(/\(.*\)/, "").trim().length : -1;
    const grand = /grandangolo|wide/i.test(c.modello);
    if (!migliore || m.length > lm || (m.length === lm && !grand && /grandangolo|wide/i.test(migliore.modello))) migliore = c;
  }
  return migliore;
}
function linkCampo() {
  const p = new URLSearchParams();
  p.set("m", CAMPO.modo);
  if (CAMPO.tel) p.set("t", CAMPO.tel.h ? "h:" + CAMPO.tel.h + (configurazioni(CAMPO.tel.h).length ? "@" + CAMPO.tel.F : "") : `${+CAMPO.tel.D.toFixed(3)},${CAMPO.tel.F}`);
  if (CAMPO.tel && CAMPO.tel.h) p.set("td", `${CAMPO.tel.D},${CAMPO.tel.F}`);
  else if (CAMPO.tel && !CAMPO.tel.smart && CAMPO.tel.nome && [...telescopiNoti(), ...obiettiviPerRicerca()].some(z => z.t === CAMPO.tel.nome)) p.set("tn", CAMPO.tel.nome);
  if (CAMPO.k !== 1) p.set("k", CAMPO.k);
  if (CAMPO.modo === "foto" && CAMPO.cam) p.set("c", CAMPO.cam.id ? "id:" + CAMPO.cam.id : `${CAMPO.cam.w},${CAMPO.cam.h},${CAMPO.cam.px}`);
  if (CAMPO.modo === "visuale" && CAMPO.oc) p.set("e", CAMPO.oc.h ? "h:" + CAMPO.oc.h : `${CAMPO.oc.f},${CAMPO.oc.afov}`);
  if (CAMPO.modo === "visuale" && CAMPO.oc && !CAMPO.oc.h && CAMPO.oc.nome && ((DATI.noti && DATI.noti.oculari) || []).some(z => z.t === CAMPO.oc.nome)) p.set("en", CAMPO.oc.nome);
  if (CAMPO.bin > 1) p.set("b", CAMPO.bin);
  if (CAMPO.ogg) p.set("o", CAMPO.ogg);
  if (CAMPO.rot) p.set("r", CAMPO.rot);
  if (CAMPO.nx * CAMPO.ny > 1) p.set("mos", `${CAMPO.nx},${CAMPO.ny},${CAMPO.sov}`);
  if (CENTRO) p.set("pos", `${CENTRO[0].toFixed(4)},${CENTRO[1].toFixed(4)}`);
  return (SR_IN_CAMPO ? location.origin + srBase() + "pages/" + srHandle() + location.search : location.href.split("#")[0]) + "#campo?" + p.toString();
}
function leggiLinkCampo(q) {
  const p = new URLSearchParams(q);
  if (p.get("m")) { CAMPO.k = 1; CAMPO.bin = 1; CAMPO.rot = 0; CAMPO.nx = 1; CAMPO.ny = 1; }
  if (p.get("m")) CAMPO.modo = p.get("m") === "visuale" ? "visuale" : "foto";
  const tt = p.get("t");
  if (tt) {
    if (tt.startsWith("h:")) {
      const [h, F] = tt.slice(2).split("@"), l = DATI.telescopi.filter(z => z.h === h);
      const x = (F && l.find(z => String(z.F) === F)) || l[0];
      if (x) scegliTelescopio(x);
      else {
        const [D0, F0] = (p.get("td") || "").split(",").map(Number);
        if (D0 && F0) CAMPO.tel = { nome: t("personalizzato"), D: D0, F: F0 };
      }
    } else {
      const [D, F] = tt.split(",").map(Number);
      if (D && F) {
        const n = p.get("tn"), x = n && [...telescopiNoti(), ...obiettiviPerRicerca()].find(z => z.t === n && Math.abs(z.F - F) < 0.5);
        CAMPO.tel = x ? Object.assign(telDaVoce(x), { D }) : { nome: t("personalizzato"), D, F };
        if (x && eObiettivo(CAMPO.tel) && Math.abs(x.D - D) > 0.05) CAMPO.tel.Nmax = Math.round(x.F / x.D * 10) / 10;
      }
    }
  }
  if (p.get("k")) CAMPO.k = +p.get("k") || 1;
  const c = p.get("c");
  if (c) {
    if (c.startsWith("id:")) {
      const x = DATI.perCamera.get(c.slice(3)), tel = CAMPO.tel;
      if (x && x.cat === "smart" && x.D && x.F && (!tel || (tel.smart ? (tel.D !== x.D || tel.F !== x.F) : (tel.D === x.D && tel.F === x.F)))) scegliCamera(x);
      else if (x) CAMPO.cam = camScelta(x);
    } else if (c.startsWith("h:")) {
      const x = DATI.camere.find(z => z.h_negozio === c.slice(2));
      if (x) scegliCamera(x);
    } else { const [w, h, px] = c.split(",").map(Number); if (w && h && px) CAMPO.cam = { nome: t("personalizzata"), w, h, px }; }
  }
  const e = p.get("e");
  if (e) {
    if (e.startsWith("h:")) { const x = DATI.oculari.find(z => z.h === e.slice(2)); if (x) CAMPO.oc = { nome: x.t, f: x.f, afov: x.afov, h: x.h, foto: x.foto }; }
    else {
      const [f, afov] = e.split(",").map(Number), n = p.get("en");
      const x = f && afov && n && ((DATI.noti && DATI.noti.oculari) || []).find(z => z.t === n && Math.abs(z.f - f) < 0.05);
      if (x) CAMPO.oc = { nome: x.t, f: x.f, afov: x.afov, h: x.h, foto: x.foto };
      else if (f && afov) CAMPO.oc = { nome: t("personalizzato"), f, afov };
    }
  }
  if (p.get("b")) CAMPO.bin = clamp(+p.get("b") || 1, 1, 4);
  const og = p.get("o"), cometa = og && og.startsWith("@cometa:") ? og.slice(8) : null, esiste = () => (COMETE || []).some(x => x[0] === cometa);
  if (cometa && COMETE) { if (esiste()) CAMPO.ogg = og; }
  else if (cometa) {
    const prima = CAMPO.ogg;
    caricaComete().then(() => {
      if (CAMPO.ogg !== prima || !esiste()) return;
      CAMPO.ogg = og; salvaCampo();
      if (schedaAttiva === "campo") vai("campo", true);
    }).catch(() => {});
  } else if (og && trovaOggetto(og)) CAMPO.ogg = trovaOggetto(og).id;
  if (p.get("r")) CAMPO.rot = (+p.get("r") || 0) % 360;
  if (p.get("mos")) { const [nx, ny, sov] = p.get("mos").split(",").map(Number); CAMPO.nx = clamp(nx || 1, 1, 5); CAMPO.ny = clamp(ny || 1, 1, 5); CAMPO.sov = sov || 15; }
  CENTRO = null; SPOSTA = [0, 0]; ZOOM = 1;
  if (p.get("pos")) { const [ra, dec] = p.get("pos").split(",").map(Number); if (isFinite(ra) && Math.abs(dec) <= 90) CENTRO = [Astro.n360(ra), dec]; }
}
Object.assign(TESTI.it, {
  rq_aria: "Le scelte del campo", rq_setup: "Setup", rq_tel: "Telescopio", rq_cam: "Camera", rq_oc: "Oculare", rq_ogg: "Oggetto", rq_mos: "Mosaico",
  rq_rot: "Rotazione", rq_conf: "Confronta", rq_filtri: "Filtri", rq_posto_v: "Orizzonte", rq_scegli: "Scegli", rq_nessuno: "Nessuno", rq_da_salvare: "Da salvare",
  rq_chiudi: "Chiudi", rq_fatto: "Fatto", rq_conf_no: "Nessun confronto", rq_conf_n: "Sulla foto compare anche il riquadro tratteggiato azzurro di un altro tuo setup: vedi subito quale inquadra meglio.",
});
Object.assign(TESTI.de, {
  rq_aria: "Auswahl im Bildfeld", rq_setup: "Setup", rq_tel: "Teleskop", rq_cam: "Kamera", rq_oc: "Okular", rq_ogg: "Objekt", rq_mos: "Mosaik",
  rq_rot: "Drehung", rq_conf: "Vergleich", rq_filtri: "Filter", rq_posto_v: "Horizont", rq_scegli: "Wählen", rq_nessuno: "Keins", rq_da_salvare: "Nicht gespeichert",
  rq_chiudi: "Schließen", rq_fatto: "Fertig", rq_conf_no: "Kein Vergleich", rq_conf_n: "Auf dem Foto erscheint auch der blau gestrichelte Rahmen eines anderen Setups: Sie sehen sofort, welches besser passt.",
});
Object.assign(TESTI.es, {
  rq_aria: "Opciones del campo", rq_setup: "Configuración", rq_tel: "Telescopio", rq_cam: "Cámara", rq_oc: "Ocular", rq_ogg: "Objeto", rq_mos: "Mosaico",
  rq_rot: "Rotación", rq_conf: "Comparar", rq_filtri: "Filtros", rq_posto_v: "Horizonte", rq_scegli: "Elegir", rq_nessuno: "Ninguno", rq_da_salvare: "Sin guardar",
  rq_chiudi: "Cerrar", rq_fatto: "Hecho", rq_conf_no: "Sin comparar", rq_conf_n: "En la foto aparece también el recuadro azul discontinuo de otra de tus configuraciones: ves enseguida cuál encuadra mejor.",
});
Object.assign(TESTI.en, {
  rq_aria: "Field choices", rq_setup: "Setup", rq_tel: "Telescope", rq_cam: "Camera", rq_oc: "Eyepiece", rq_ogg: "Object", rq_mos: "Mosaic",
  rq_rot: "Rotation", rq_conf: "Compare", rq_filtri: "Filters", rq_posto_v: "Horizon", rq_scegli: "Choose", rq_nessuno: "None", rq_da_salvare: "Unsaved",
  rq_chiudi: "Close", rq_fatto: "Done", rq_conf_no: "No comparison", rq_conf_n: "The dashed blue frame of another of your setups also appears on the photo: you see right away which one frames it better.",
});
ICONE_SVG.strati = '<path d="M12 3.6 3.6 8l8.4 4.4L20.4 8z"/><path d="M3.6 12l8.4 4.4 8.4-4.4"/><path d="M3.6 16l8.4 4.4 8.4-4.4"/>';
let FOGLIO_CAMPO = null;
function apriFoglioCampo(titolo, pezzi, opz) {
  chiudiFoglioCampo();
  opz = opz || {};
  const corpo = el("div", { class: "gas-cielo-foglio-corpo" }), posti = [];
  for (const p of pezzi) {
    if (!p) continue;
    if (p.parentNode) { const segno = document.createComment("foglio"); p.parentNode.insertBefore(segno, p); posti.push([p, segno]); }
    corpo.appendChild(p);
  }
  const ok = el("button", { type: "button", class: "gas-btn gas-cielo-foglio-ok", onclick: () => chiudiFoglioCampo() });
  const scriviOk = () => { ok.textContent = (typeof opz.conferma === "function" ? opz.conferma() : opz.conferma) || t("rq_fatto"); };
  scriviOk();
  const box = el("div", { class: "gas gas-cielo-foglio-box", tabindex: "-1" },
    el("div", { class: "gas-cielo-foglio-testa" }, el("b", null, titolo),
      el("button", { type: "button", class: "gas-cielo-foglio-chiudi", "aria-label": t("rq_chiudi"), title: t("rq_chiudi"), onclick: () => chiudiFoglioCampo() }, icona("chiudi"))),
    corpo, el("div", { class: "gas-cielo-foglio-piede" }, ok));
  const fondo = el("div", { class: "gas-cielo-foglio" + (opz.leggero ? " gas-cielo-foglio--leggero" : ""), role: "dialog", "aria-modal": "true", "aria-label": titolo,
    onclick: e => { if (e.target === fondo) chiudiFoglioCampo(); } }, box);
  const sf = document.getElementById("gas-sfondo");
  if (sf && sf.classList.contains("gas-rosso")) fondo.classList.add("gas-cielo-foglio--rosso");
  if (sf && sf.classList.contains("gas-grande")) box.classList.add("gas-grande");
  document.body.appendChild(fondo);
  document.documentElement.classList.add("gas-menu-su");
  const vv = window.visualViewport;
  const sopraTastiera = () => { fondo.style.top = vv.offsetTop + "px"; fondo.style.height = vv.height + "px"; fondo.style.bottom = "auto"; };
  if (vv) { vv.addEventListener("resize", sopraTastiera); vv.addEventListener("scroll", sopraTastiera); }
  let guardia = null;
  if (typeof CloseWatcher === "function") try { guardia = new CloseWatcher(); guardia.onclose = () => { if (FOGLIO_CAMPO && FOGLIO_CAMPO.guardia === guardia) chiudiFoglioCampo(); }; } catch (e) { guardia = null; }
  const da = document.activeElement && document.activeElement !== document.body ? document.activeElement : null;
  const daPadre = da && da.parentNode, daPosto = daPadre ? [...daPadre.children].indexOf(da) : -1;
  FOGLIO_CAMPO = { fondo, posti, dopo: opz.dopo, aggiorna: scriviOk, guardia, da, daPadre, daPosto, via: () => {
    if (vv) { vv.removeEventListener("resize", sopraTastiera); vv.removeEventListener("scroll", sopraTastiera); }
    if (guardia) try { guardia.destroy(); } catch (e) {   }
  } };
  try { box.focus({ preventScroll: true }); } catch (e) {   }
}
function chiudiFoglioCampo(scarta) {
  if (!FOGLIO_CAMPO) return;
  const f = FOGLIO_CAMPO;
  FOGLIO_CAMPO = null;
  if (!scarta) for (const [p, segno] of f.posti) if (segno.parentNode) { segno.parentNode.insertBefore(p, segno); segno.remove(); }
  f.via();
  f.fondo.remove();
  document.documentElement.classList.remove("gas-menu-su");
  if (!scarta && f.dopo) f.dopo();
  const attivo = document.activeElement;
  if (!scarta && (!attivo || attivo === document.body)) {
    const x = f.da && f.da.isConnected ? f.da : f.daPadre && f.daPadre.isConnected ? f.daPadre.children[f.daPosto] : null;
    if (x && !/^(INPUT|TEXTAREA|SELECT)$/.test(x.tagName)) try { x.focus({ preventScroll: true }); } catch (e) {   }
  }
}
document.addEventListener("keydown", e => {
  const x = e.target;
  if (e.key === "Escape" && FOGLIO_CAMPO && x && x.matches && x.matches('[aria-autocomplete][aria-expanded="true"]')) e.preventDefault();
}, true);
document.addEventListener("keydown", e => { if (e.key === "Escape" && FOGLIO_CAMPO && !e.defaultPrevented) chiudiFoglioCampo(); });
const SETUP_MAX = 24;
let SETUP_ELENCO = ricorda("setup", []);
if (!Array.isArray(SETUP_ELENCO)) SETUP_ELENCO = [];
function copiaProfonda(x) { return x == null ? x : JSON.parse(JSON.stringify(x)); }
function setupAttuale() {
  const { modo, tel, k, cam, bin, oc } = CAMPO;
  return copiaProfonda({ modo, tel, k, cam, bin, oc });
}
function nomeCorto(n) {
  let s = String(n || "").split(/\s[–—-]\s|,(?!\d)|\s\(/)[0].trim();
  const max = s.includes(" · ") ? 44 : 34;
  if (s.length > max) s = (/\s/.test(s[max]) ? s.slice(0, max) : s.slice(0, max).replace(/\s+\S*$/, "")).replace(/[\s+·–-]+$/, "") + "…";
  return s;
}
function nomeTelCorto(n) {
  const s = String(n || "");
  const pulito = (/2-in-1/i.test(s) ? s : s.replace(/\s\+\s.*$/, ""))
    .replace(/(^|\s)(telescopio|rifrattore|apocromatico|acromatico|doppietto|tripletto|quadrupletto|tubo ottico|ota|schmidt-cassegrain)(?=\s|$)/gi, " ").replace(/\s{2,}/g, " ").trim();
  return nomeCorto(pulito) || nomeCorto(s);
}
function nomeSetupAuto(s) {
  const p = [];
  if (s.tel) p.push(s.tel.nome === t("personalizzato") ? `${num(s.tel.D)}/${num(s.tel.F)}` : nomeTelCorto(s.tel.nome));
  if (s.k && s.k !== 1 && !(s.tel && s.tel.smart)) p.push(`${num(s.k, 2)}×`);
  const fine = s.modo === "visuale" ? s.oc : s.cam;
  if (fine && !(s.tel && s.tel.smart && s.modo === "foto")) p.push(fine.nome === t("personalizzata") || fine.nome === t("personalizzato") ?
    (s.modo === "visuale" ? `${num(fine.f, 1)} mm` : `${num(fine.w)}×${num(fine.h)} ${num(fine.px, 2)} µm`) : nomeCorto(fine.nome));
  return p.join(" + ") || t("setup");
}
Object.assign(TESTI.it, { rinomina_setup: "Rinomina", rinomina_n: "Nome del setup: meglio corto (es. RC8-705), compare sul riquadro della foto nel Campo inquadrato",
  nome_foto_n: "Il nome compare sul riquadro della foto: meglio corto, es. «RC8-705»." });
Object.assign(TESTI.de, { rinomina_setup: "Umbenennen", rinomina_n: "Name des Setups: lieber kurz (z. B. RC8-705), er steht am Rahmen im Bildfeld",
  nome_foto_n: "Der Name steht am Rahmen auf dem Foto: lieber kurz, z. B. „RC8-705“." });
Object.assign(TESTI.es, { rinomina_setup: "Cambiar nombre", rinomina_n: "Nombre de la configuración: mejor corto (p. ej. RC8-705), aparece en el recuadro de la foto en Campo de visión",
  nome_foto_n: "El nombre aparece en el recuadro de la foto: mejor corto, p. ej. «RC8-705»." });
Object.assign(TESTI.en, { rinomina_setup: "Rename", rinomina_n: "Setup name: short is best (e.g. RC8-705), it appears on the frame in Field of view",
  nome_foto_n: "The name appears on the frame in the photo: short is best, e.g. “RC8-705”." });
Object.assign(TESTI.it, { setup_togli_si: "Togli" });
Object.assign(TESTI.it, { modifica_setup: "Modifica pezzi e nome", comp_modifica: "Modifica «{n}»: cambia i pezzi o il nome e salva.",
  salva_modifiche: "Salva modifiche", setup_uguale_a: "Così è uguale al setup «{n}»: cambia almeno un pezzo.", setup_aggiornato: "«{n}» aggiornato." });
Object.assign(TESTI.de, { modifica_setup: "Teile und Namen ändern", comp_modifica: "„{n}“ bearbeiten: Teile oder Namen ändern und speichern.",
  salva_modifiche: "Änderungen speichern", setup_uguale_a: "So ist es identisch mit dem Setup „{n}“: Ändern Sie mindestens ein Teil.", setup_aggiornato: "„{n}“ aktualisiert." });
Object.assign(TESTI.es, { modifica_setup: "Cambiar piezas y nombre", comp_modifica: "Editar «{n}»: cambia las piezas o el nombre y guarda.",
  salva_modifiche: "Guardar cambios", setup_uguale_a: "Así es igual que «{n}»: cambia al menos una pieza.", setup_aggiornato: "«{n}» actualizado." });
Object.assign(TESTI.en, { modifica_setup: "Edit parts and name", comp_modifica: "Edit “{n}”: change the parts or the name and save.",
  salva_modifiche: "Save changes", setup_uguale_a: "That's the same as “{n}”: change at least one part.", setup_aggiornato: "“{n}” updated." });
Object.assign(TESTI.de, { setup_togli_si: "Entfernen" });
Object.assign(TESTI.es, { setup_togli_si: "Quitar" });
Object.assign(TESTI.en, { setup_togli_si: "Remove" });
function rinominaSetup(s, dopo, pillola, ridisegna) {
  if (!puoSalvare()) return invitoAccount();
  if (!pillola) return;
  const campo = el("input", { type: "text", class: "gas-input gas-setup-rin-campo", maxlength: 60, value: s.nome, "aria-label": t("rinomina_n"), title: t("rinomina_n") });
  const fine = ok => {
    const n = campo.value.trim().slice(0, 60);
    if (ok && n && n !== s.nome) {
      if (CONFRONTO === s.nome) { CONFRONTO = n; salva("confronto", n); }
      s.nome = n;
      salva("setup", SETUP_ELENCO);
    }
    aggiornaSetupUI();
    if (ridisegna && pillola.isConnected) ridisegna();
    if (ok && dopo) dopo();
  };
  campo.addEventListener("keydown", e => { if (e.key === "Enter") { e.preventDefault(); fine(true); } else if (e.key === "Escape") { e.preventDefault(); e.stopPropagation(); fine(false); } });
  pillola.classList.add("gas-setup-chip--apri");
  svuota(pillola).append(campo,
    el("button", { type: "button", class: "gas-btn gas-btn--mini", onclick: () => fine(true) }, t("salva")),
    el("button", { type: "button", class: "gas-btn gas-btn--chiaro gas-btn--mini", onclick: () => fine(false) }, t("annulla")));
  campo.focus(); campo.select();
}
function chiediTogliSetup(s, pillola, ridisegna) {
  const torna = () => { aggiornaSetupUI(); if (ridisegna && pillola.isConnected) ridisegna(); };
  pillola.classList.add("gas-setup-chip--apri");
  svuota(pillola).append(el("span", { class: "gas-setup-chiedi" }, t("conferma_togli", { n: s.nome })),
    el("button", { type: "button", class: "gas-btn gas-btn--mini gas-setup-si", onclick: () => {
      const i = SETUP_ELENCO.indexOf(s);
      if (i >= 0) { SETUP_ELENCO.splice(i, 1); salva("setup", SETUP_ELENCO); }
      torna();
    } }, t("setup_togli_si")),
    el("button", { type: "button", class: "gas-btn gas-btn--chiaro gas-btn--mini", onclick: torna }, t("annulla")));
}
function etichettaSetup(s) {
  if (!s || !s.nome || s.nome === nomeSetupAuto(s)) return "";
  return s.nome.length > 28 ? s.nome.slice(0, 27).trim() + "…" : s.nome;
}
function stessoSetup(a, b) {
  const tt = x => x ? [x.h || "", x.D, x.F].join("|") : "";
  const cc = x => x ? [x.id || "", x.w, x.h, x.px].join("|") : "";
  const oo = x => x ? [x.h || "", x.f, x.afov].join("|") : "";
  return a.modo === b.modo && tt(a.tel) === tt(b.tel) && (a.k || 1) === (b.k || 1) &&
    (a.modo === "visuale" ? oo(a.oc) === oo(b.oc) : cc(a.cam) === cc(b.cam) && (a.bin || 1) === (b.bin || 1));
}
function usaSetup(s) {
  const c = copiaProfonda(s);
  Object.assign(CAMPO, { modo: c.modo || "foto", tel: c.tel || null, k: c.k || 1, cam: c.cam || null, bin: c.bin || 1, oc: c.oc || null });
  salvaCampo();
}
let CONFRONTO = ricorda("confronto", "");
function setupConfronto() {
  const s = CONFRONTO && SETUP_ELENCO.find(x => x.nome === CONFRONTO);
  return s && !stessoSetup(s, setupAttuale()) ? s : null;
}
const SETUP_UI = new Set();
function aggiornaSetupUI() { for (const f of [...SETUP_UI]) f(); }
const setupPieno = x => !!x && !!x.tel && (x.modo === "visuale" ? !!x.oc : !!x.cam);
const setupCompleto = () => setupPieno(CAMPO);
function salvaSetup(nome, pronto) {
  if (!puoSalvare()) return invitoAccount();
  const ora = pronto ? copiaProfonda(pronto) : setupAttuale();
  if (!setupPieno(ora) || SETUP_ELENCO.some(s => stessoSetup(s, ora)) || SETUP_ELENCO.length >= SETUP_MAX) return false;
  SETUP_ELENCO.push(Object.assign({ nome: (nome || "").trim() || nomeSetupAuto(ora) }, ora));
  salva("setup", SETUP_ELENCO);
  aggiornaSetupUI();
  return true;
}
function boxSetup(dopo, compatto, daAttrezzi) {
  const box = el("div", { class: "gas-setup-box" + (compatto ? " gas-setup-box--compatto" : "") });
  const scelta = { tel: null, k: "", fine: null, nome: null };
  let modifica = null, aggiornato = "";
  const apriModifica = s => {
    modifica = s; aggiornato = "";
    scelta.tel = TIPI_ATT.tel.chiave(s.tel);
    const f = s.modo === "visuale" ? ["oc", s.oc] : ["cam", s.cam];
    scelta.fine = f[1] ? f[0] + ":" + TIPI_ATT[f[0]].chiave(f[1]) : null;
    const kk = s.k && s.k !== 1 ? ATTREZZI.k.find(x => x.k === s.k) || { k: s.k } : null;
    scelta.k = kk ? TIPI_ATT.k.chiave(kk) : "";
    scelta.nome = s.nome === nomeSetupAuto(s) ? null : s.nome;
    disegna();
    const r = box.querySelector(".gas-setup-nuovo");
    if (r) r.scrollIntoView({ block: "start", behavior: "smooth" });
    const p = r && $(".gas-setup-scelta", r);
    if (p) p.focus({ preventScroll: true });
  };
  const chiudiModifica = () => { modifica = null; scelta.nome = null; disegna(); };
  const componi = () => {
    const tels = [...ATTREZZI.tel], ks = [...ATTREZZI.k], fini = [...ATTREZZI.cam.map(x => ["cam", x]), ...ATTREZZI.oc.map(x => ["oc", x])];
    const chT = TIPI_ATT.tel.chiave, chK = TIPI_ATT.k.chiave, chF = ([tp, x]) => tp + ":" + TIPI_ATT[tp].chiave(x);
    if (modifica) {
      if (modifica.tel) { const i = tels.findIndex(x => chT(x) === chT(modifica.tel)); if (i < 0) tels.unshift(modifica.tel); else tels[i] = modifica.tel; }
      const f = modifica.modo === "visuale" ? ["oc", modifica.oc] : ["cam", modifica.cam];
      if (f[1] && !fini.some(x => chF(x) === chF(f))) fini.unshift(f);
      if (modifica.k && modifica.k !== 1 && !ks.some(x => x.k === modifica.k)) ks.unshift({ k: modifica.k });
    }
    if (!tels.length || !fini.length) return [el("p", { class: "gas-nota" }, t("comp_manca"))];
    if (!tels.some(x => chT(x) === scelta.tel)) scelta.tel = chT(CAMPO.tel && ho("tel", CAMPO.tel) ? CAMPO.tel : tels[0]);
    if (scelta.k && !ks.some(x => chK(x) === scelta.k)) scelta.k = "";
    if (!fini.some(f => chF(f) === scelta.fine)) {
      const daCampo = CAMPO.modo === "visuale" ? (CAMPO.oc && ho("oc", CAMPO.oc) ? ["oc", CAMPO.oc] : null) : (CAMPO.cam && ho("cam", CAMPO.cam) ? ["cam", CAMPO.cam] : null);
      scelta.fine = chF(daCampo || fini[0]);
    }
    const pronto = () => {
      const tel = tels.find(x => chT(x) === scelta.tel), kk = ks.find(x => chK(x) === scelta.k), f = fini.find(x => chF(x) === scelta.fine);
      const bin = modifica && modifica.cam && f[0] === "cam" && chF(f) === chF(["cam", modifica.cam]) ? modifica.bin || 1 : 1;
      return copiaProfonda({ modo: f[0] === "oc" ? "visuale" : "foto", tel, k: tel.smart || !kk ? 1 : kk.k, cam: f[0] === "cam" ? f[1] : null,
        bin, oc: f[0] === "oc" ? f[1] : null });
    };
    const ora = pronto(), gia = SETUP_ELENCO.find(s => s !== modifica && stessoSetup(s, ora));
    const cambiaScelta = k => v => {
      scelta[k] = v; disegna();
      const m = window.matchMedia && matchMedia("(pointer: fine)").matches ? box.querySelector(`[data-scelta="${k}"]`) : null;
      if (m) m.focus();
    };
    const righe = [aggiornato ? el("p", { class: "gas-setup-ok", role: "status" }, "✓ ", t("setup_aggiornato", { n: aggiornato })) : null,
      el("p", { class: "gas-setup-scelta", tabindex: "-1" }, modifica ? t("comp_modifica", { n: modifica.nome }) : t("comp_titolo")),
      el("div", { class: "gas-due gas-setup-componi" },
        etichetta(t("telescopio"), selezione(tels.map(x => [chT(x), nomeCorto(nomeTel(x))]), scelta.tel, cambiaScelta("tel"), { dataset: { scelta: "tel" } })),
        etichetta(t("comp_fine"), selezione(fini.map(f => [chF(f), nomeCorto(f[1].nome)]), scelta.fine, cambiaScelta("fine"), { dataset: { scelta: "fine" } })),
        ks.length && !(ora.tel && ora.tel.smart) ? etichetta(t("riduttore"), selezione([["", t("nessuno")],
          ...ks.map(x => [chK(x), x.nome ? nomeCorto(x.nome) : nomeFattore(x.k)])], scelta.k, cambiaScelta("k"), { dataset: { scelta: "k" } })) : null)];
    aggiornato = "";
    if (gia && modifica) righe.push(el("p", { class: "gas-att-manca", role: "alert" }, t("setup_uguale_a", { n: gia.nome })),
      el("button", { type: "button", class: "gas-btn gas-btn--chiaro", onclick: chiudiModifica }, t("annulla")));
    else if (gia) righe.push(el("p", { class: "gas-setup-ok" }, "✓ ", t("setup_salvato_come", { n: gia.nome })));
    else if (!modifica && SETUP_ELENCO.length >= SETUP_MAX) righe.push(el("p", { class: "gas-muto" }, t("setup_pieni", { n: SETUP_MAX })));
    else if (modifica) {
      const nome = el("input", { type: "text", class: "gas-input gas-setup-nome", maxlength: 60, value: scelta.nome != null ? scelta.nome : nomeSetupAuto(ora),
        "aria-label": t("nome_setup"), onfocus: e => e.target.select(), oninput: e => { scelta.nome = e.target.value; } });
      const salvaModifica = () => {
        if (!puoSalvare()) return invitoAccount();
        const i = SETUP_ELENCO.indexOf(modifica);
        if (i < 0) return chiudiModifica();
        const nuovo = pronto(), n = nome.value.trim().slice(0, 60) || nomeSetupAuto(nuovo), inUso = stessoSetup(modifica, setupAttuale());
        if (CONFRONTO === modifica.nome && n !== modifica.nome) { CONFRONTO = n; salva("confronto", n); }
        SETUP_ELENCO[i] = Object.assign({ nome: n }, nuovo);
        salva("setup", SETUP_ELENCO);
        if (inUso) usaSetup(SETUP_ELENCO[i]);
        modifica = null; scelta.nome = null; aggiornato = n;
        aggiornaSetupUI();
        dopo();
      };
      nome.addEventListener("keydown", e => { if (e.key === "Enter") { e.preventDefault(); salvaModifica(); } });
      righe.push(el("label", { class: "gas-campo" }, el("span", null, t("nome_setup")), nome),
        el("div", { class: "gas-riga-bottoni gas-setup-mod-bott" },
          el("button", { type: "button", class: "gas-btn", onclick: salvaModifica }, "💾 ", t("salva_modifiche")),
          el("button", { type: "button", class: "gas-btn gas-btn--chiaro", onclick: chiudiModifica }, t("annulla"))),
        el("small", { class: "gas-muto gas-setup-nome-n" }, t("nome_foto_n")));
    } else {
      const nome = el("input", { type: "text", class: "gas-input gas-setup-nome", maxlength: 60, value: nomeSetupAuto(ora),
        "aria-label": t("nome_setup"), onfocus: e => e.target.select() });
      const salvaOra = () => {
        if (!puoSalvare()) return invitoAccount();
        const s = pronto();
        usaSetup(s);
        salvaSetup(nome.value, s);
        dopo();
      };
      nome.addEventListener("keydown", e => { if (e.key === "Enter") { e.preventDefault(); salvaOra(); } });
      righe.push(el("label", { class: "gas-campo" }, el("span", null, t("nome_setup")),
        el("div", { class: "gas-setup-salva" }, nome, el("button", { type: "button", class: "gas-btn", onclick: salvaOra }, "💾 ", t("salva_setup")))),
        el("small", { class: "gas-muto gas-setup-nome-n" }, t("nome_foto_n")));
    }
    return righe.filter(Boolean);
  };
  const disegna = () => {
    if (!box.isConnected && box._mostrato) { SETUP_UI.delete(disegna); return; }
    box._mostrato = true;
    svuota(box);
    if (modifica && !SETUP_ELENCO.includes(modifica)) { modifica = null; scelta.nome = null; }
    const ora = setupAttuale(), salvato = SETUP_ELENCO.find(s => stessoSetup(s, ora));
    if (SETUP_ELENCO.length) {
      const chip = el("div", { class: "gas-setup-chip-riga" });
      SETUP_ELENCO.forEach(s => {
        const attivo = s === salvato, pillola = el("span", { class: "gas-setup-chip" + (attivo ? " on" : "") + (s === modifica ? " gas-setup-chip--modifica" : "") });
        pillola.append(
          el("button", { type: "button", class: "gas-setup-usa", title: nomeSetupAuto(s), "aria-pressed": String(attivo),
            onclick: () => { usaSetup(s); if (daAttrezzi) disegna(); dopo(); } }, s.nome),
          el("button", { type: "button", class: "gas-setup-rinomina", title: t(daAttrezzi ? "modifica_setup" : "rinomina_setup"),
            "aria-label": `${t(daAttrezzi ? "modifica_setup" : "rinomina_setup")}: ${s.nome}`,
            onclick: () => (daAttrezzi && ATTREZZI ? apriModifica(s) : rinominaSetup(s, dopo, pillola, disegna)) }, "✎"),
          el("button", { type: "button", class: "gas-setup-togli", title: t("togli_setup"), "aria-label": `${t("togli_setup")}: ${s.nome}`,
            onclick: () => chiediTogliSetup(s, pillola, disegna) }, "×"));
        chip.appendChild(pillola);
      });
      box.append(el("small", { class: "gas-setup-etich" }, t("richiama_setup")), chip);
    }
    const salvaRiq = el("div", { class: "gas-setup-nuovo" });
    if (daAttrezzi && ATTREZZI) {
      if (modifica) salvaRiq.append(...componi());
      else if (aggiornato) { salvaRiq.appendChild(el("p", { class: "gas-setup-ok", role: "status" }, "✓ ", t("setup_aggiornato", { n: aggiornato }))); aggiornato = ""; }
    } else if (salvato) {
      salvaRiq.appendChild(el("p", { class: "gas-setup-ok" }, "✓ ", t("setup_salvato_come", { n: salvato.nome })));
    } else if (!setupCompleto()) {
      salvaRiq.append(el("ol", { class: "gas-setup-passi" },
        el("li", { class: CAMPO.tel ? "fatto" : "" }, t(compatto ? "passo_1_notte" : "passo_1")),
        el("li", null, t("passo_2"))));
    } else if (SETUP_ELENCO.length >= SETUP_MAX) {
      salvaRiq.appendChild(el("p", { class: "gas-muto" }, t("setup_pieni", { n: SETUP_MAX })));
    } else {
      const nome = el("input", { type: "text", class: "gas-input gas-setup-nome", maxlength: 60, value: nomeSetupAuto(ora),
        "aria-label": t("nome_setup"), onfocus: e => e.target.select() });
      const salvaOra = () => salvaSetup(nome.value);
      nome.addEventListener("keydown", e => { if (e.key === "Enter") { e.preventDefault(); salvaOra(); } });
      salvaRiq.append(el("p", { class: "gas-setup-scelta" }, t("setup_scelto"), " ", el("b", null, nomeSetupAuto(ora))),
        el("label", { class: "gas-campo" }, el("span", null, t("nome_setup")),
          el("div", { class: "gas-setup-salva" }, nome, el("button", { type: "button", class: "gas-btn", onclick: salvaOra }, "💾 ", t("salva_setup")))),
        el("small", { class: "gas-muto gas-setup-nome-n" }, t("nome_foto_n")));
    }
    if (salvaRiq.firstChild) box.appendChild(salvaRiq);
    if (!daAttrezzi) box.appendChild(bottoneNuovoSetup());
  };
  SETUP_UI.add(disegna);
  box.aggiorna = disegna;
  disegna();
  return box;
}
function invitoSalvaSetup() {
  const box = el("div", { class: "gas-setup-invito" });
  const disegna = () => {
    if (!box.isConnected && box._mostrato) { SETUP_UI.delete(disegna); return; }
    box._mostrato = true;
    svuota(box);
    const ora = setupAttuale(), salvato = SETUP_ELENCO.find(s => stessoSetup(s, ora));
    if (salvato) box.appendChild(el("span", { class: "gas-setup-ok" }, "✓ ", t("setup_salvato_come", { n: salvato.nome })));
    else if (setupCompleto() && SETUP_ELENCO.length < SETUP_MAX)
      box.appendChild(el("button", { type: "button", class: "gas-btn gas-btn--chiaro gas-btn--largo", onclick: () => salvaSetup() },
        "💾 ", t("salva_come_setup")));
    box.hidden = !box.firstChild;
  };
  SETUP_UI.add(disegna);
  box.aggiorna = disegna;
  disegna();
  return box;
}
const GUIDA = {
  it: {
    g_campo: "Questa è la scheda Campo inquadrato. Scegli il tuo telescopio e la tua camera, oppure un oculare per l'osservazione visuale, e poi l'oggetto da riprendere. Sul cielo compare il riquadro del sensore: puoi spostarti trascinando, ingrandire, ruotare la camera e progettare un mosaico, cioè più foto affiancate. Sotto trovi quanto cielo entra nella foto, la scala dell'immagine, cioè quanto cielo finisce in ogni pixel, e se i pixel sono della misura giusta per il tuo cielo.",
    g_stanotte: "Questa è la scheda Stanotte. Scegli il luogo e la data: la pagina calcola il tramonto, il buio astronomico e la Luna, poi mette in classifica gli oggetti migliori della notte, in base alle ore sopra l'orizzonte, all'altezza e alla distanza dalla Luna. Se imposti la tua attrezzatura puoi vedere solo gli oggetti che entrano bene nel tuo campo. Tocca un oggetto per vedere il grafico dell'altezza e l'anteprima, e premi Inquadralo per aprirlo nel campo inquadrato.",
    g_camere: "Qui c'è il database delle camere: camere astronomiche, reflex, mirrorless e smart telescope, con i dati delle schede ufficiali dei produttori. Puoi filtrare per marca, sensore e dimensione dei pixel, confrontare fino a quattro camere e, con il pulsante Usa, provarle subito nel Campo inquadrato.",
    g_calcolatori: "Questi sono i calcolatori, divisi in quattro gruppi: osservare, fotografare, montatura e guida, cielo e meteo. Scegline uno dall'elenco oppure cercalo per nome. In ogni calcolatore puoi cercare il tuo telescopio, la camera o l'oculare, e i campi si riempiono da soli. Trovi per esempio l'ingrandimento e la pupilla d'uscita, la focale ideale per i tuoi pixel, le riprese planetarie, i paesaggi notturni, la catena del backfocus, la Polare nel cannocchiale polare e il rischio di condensa.",
    g_software: "Qui trovi i programmi e le app più usati dagli astrofili, divisi per categoria: acquisizione, cioè scattare le foto, autoguida, stacking, cioè sommare gli scatti, elaborazione, planetari e meteo. Ogni riquadro porta al sito ufficiale del programma.",
    g_setup: "Nella sezione I miei setup salvi le tue attrezzature con un nome. La prossima volta basta un tocco per richiamarle, senza cercare di nuovo telescopio, riduttore e camera. Restano nel tuo account: le ritrovi su tutti i tuoi dispositivi.",
    g_telescopio: "Cerca il tuo telescopio tra quelli del nostro negozio, oppure scrivi a mano diametro e focale. Se scegli uno smart telescope, la camera si imposta da sola.",
    g_riduttore: "Se usi un riduttore di focale o una lente di Barlow, scegli il fattore: la focale effettiva e il campo inquadrato si aggiornano subito.",
    g_camera: "Cerca la tua camera nell'elenco, oppure inserisci risoluzione e dimensione dei pixel. Indica anche il binning, cioè se unisci i pixel a gruppi, e il seeing, cioè quanto trema l'aria nel tuo cielo: così vedi se i pixel sono della misura giusta.",
    g_oculare: "Cerca il tuo oculare tra quelli del nostro negozio, oppure inserisci focale e campo apparente: vedi ingrandimento, campo reale e pupilla d'uscita.",
    g_oggetto: "Cerca l'oggetto che vuoi riprendere per sigla o per nome, per esempio M31 oppure Andromeda. La vista del cielo si centra sull'oggetto.",
    g_mosaico: "Se l'oggetto non entra in un solo scatto, progetta un mosaico: scegli quanti pannelli in orizzontale e in verticale e quanta sovrapposizione. Sotto trovi le coordinate del centro di ogni pannello.",
    g_cielo: "Questa è la vista del cielo. Trascina il cielo per spostarti: il riquadro della camera resta al centro. Per ingrandire usa i pulsanti più e meno, allarga due dita sullo schermo, oppure tieni premuto il tasto Control e gira la rotella del mouse. Con un doppio clic centri la vista in quel punto. La camera si ruota con la barra della rotazione oppure ruotando due dita sullo schermo. Il pulsante Nomi mostra o nasconde i nomi degli oggetti; il pulsante Griglia rende ben visibili le coordinate e aggiunge l'equatore celeste e l'eclittica. Il pulsante Risultato mostra come uscirà la foto: solo quello che entra nel sensore, raddrizzato, con la camera girata come l'hai messa. Con il link puoi condividere la tua inquadratura.",
    g_luogo: "Scegli la città oppure usa la tua posizione: gli orari della notte, la Luna e la classifica degli oggetti si calcolano per quel punto.",
    g_data: "Scegli la notte che ti interessa. Gli orari sono nel fuso orario del tuo dispositivo.",
    g_attrezzatura: "Imposta qui telescopio e camera, oppure richiama un tuo setup. Poi accendi l'interruttore per vedere solo gli oggetti che entrano bene nel tuo campo.",
    g_filtri: "Qui indichi i filtri che possiedi: li cerchi per nome oppure tocchi il loro tipo. Per ogni oggetto, in Cosa vedere e nei risultati qui sotto, ti diciamo quale montare: dipende dal tipo di oggetto, dalla Luna, dal cielo del tuo luogo e dalla tua camera, a colori o monocromatica.",
  },
  de: {
    g_campo: "Das ist der Bereich Bildfeld. Wählen Sie Ihr Teleskop und Ihre Kamera, oder ein Okular für die visuelle Beobachtung, und dann das Objekt. Am Himmel erscheint der Rahmen des Sensors: Sie können den Himmel verschieben, vergrößern, die Kamera drehen und ein Mosaik planen. Darunter sehen Sie das Bildfeld, den Abbildungsmaßstab und ob die Abtastung zu Ihrem Himmel passt.",
    g_stanotte: "Das ist der Bereich Heute Nacht. Wählen Sie Ort und Datum: Die Seite berechnet Sonnenuntergang, astronomische Dunkelheit und Mond und ordnet die besten Objekte der Nacht nach den Stunden über dem Horizont, der Höhe und dem Abstand zum Mond. Mit Ihrer Ausrüstung können Sie nur die Objekte anzeigen, die gut in Ihr Bildfeld passen. Tippen Sie auf ein Objekt für das Höhendiagramm und die Vorschau.",
    g_camere: "Hier ist die Kameradatenbank: Astrokameras, Spiegelreflex-, spiegellose Kameras und Smart-Teleskope, mit den Daten aus den offiziellen Datenblättern. Sie können nach Marke, Sensor und Pixelgröße filtern, bis zu vier Kameras vergleichen und sie mit Verwenden direkt im Bildfeld ausprobieren.",
    g_calcolatori: "Das sind die Rechner, in vier Gruppen: Beobachten, Fotografieren, Montierung und Guiding, Himmel und Wetter. Wählen Sie einen aus der Liste oder suchen Sie ihn nach Namen. In jedem Rechner können Sie Ihr Teleskop, Ihre Kamera oder Ihr Okular suchen, und die Felder füllen sich von selbst. Es gibt zum Beispiel Vergrößerung und Austrittspupille, die ideale Brennweite für Ihre Pixel, Planetenaufnahmen, Nachtlandschaften, die Backfokus-Kette, Polaris im Polsucher und das Taurisiko.",
    g_software: "Hier finden Sie die Programme und Apps, die Hobbyastronomen am meisten nutzen, nach Kategorien: Aufnahme, Autoguiding, Stacking, Bearbeitung, Planetarien und Wetter. Jeder Kasten führt zur offiziellen Seite des Programms.",
    g_setup: "Unter Meine Setups speichern Sie Ihre Ausrüstungen mit einem Namen. Beim nächsten Mal genügt ein Tippen, ohne Teleskop, Reducer und Kamera neu zu suchen. Sie bleiben in Ihrem Konto: Sie haben sie auf allen Ihren Geräten.",
    g_telescopio: "Suchen Sie Ihr Teleskop in unserem Sortiment oder geben Sie Öffnung und Brennweite von Hand ein. Bei einem Smart-Teleskop wird die Kamera automatisch eingestellt.",
    g_riduttore: "Wenn Sie einen Reducer oder eine Barlowlinse verwenden, wählen Sie den Faktor: Effektive Brennweite und Bildfeld werden sofort aktualisiert.",
    g_camera: "Suchen Sie Ihre Kamera in der Datenbank oder geben Sie Auflösung und Pixelgröße ein. Mit dem Binning und dem Seeing Ihres Himmels sehen Sie, ob die Abtastung stimmt.",
    g_oculare: "Suchen Sie Ihr Okular in unserem Sortiment oder geben Sie Brennweite und scheinbares Gesichtsfeld ein: Sie sehen Vergrößerung, wahres Gesichtsfeld und Austrittspupille.",
    g_oggetto: "Suchen Sie das Objekt nach Katalognummer oder Namen, zum Beispiel M31 oder Andromeda. Die Himmelsansicht zentriert sich auf das Objekt.",
    g_mosaico: "Wenn das Objekt nicht in ein Bild passt, planen Sie ein Mosaik: Wählen Sie die Anzahl der Felder waagerecht und senkrecht und die Überlappung. Darunter stehen die Koordinaten der Feldmitten.",
    g_cielo: "Das ist die Himmelsansicht. Ziehen Sie den Himmel, um sich zu bewegen: Der Rahmen der Kamera bleibt in der Mitte. Zum Vergrößern nehmen Sie Plus und Minus, zwei Finger oder Strg und das Mausrad, ein Doppelklick zentriert die Ansicht. Die Kamera drehen Sie mit dem Schieberegler oder mit zwei Fingern. Die Taste Namen blendet die Objektnamen ein oder aus; die Taste Gitter macht die Koordinaten gut sichtbar und zeigt Himmelsäquator und Ekliptik. Die Taste Ergebnis zeigt, wie das Foto wird: nur was auf den Sensor fällt, gerade ausgerichtet, mit der Kamera so gedreht, wie Sie sie eingestellt haben. Mit dem Link teilen Sie Ihren Bildausschnitt.",
    g_luogo: "Wählen Sie die Stadt oder verwenden Sie Ihren Standort: Die Zeiten der Nacht, der Mond und die Objektliste werden für diesen Ort berechnet.",
    g_data: "Wählen Sie die gewünschte Nacht. Die Zeiten sind in der Zeitzone Ihres Geräts.",
    g_attrezzatura: "Stellen Sie hier Teleskop und Kamera ein oder rufen Sie ein eigenes Setup auf. Schalten Sie dann den Schalter ein, um nur die Objekte zu sehen, die gut in Ihr Bildfeld passen.",
    g_filtri: "Unter Meine Filter tippen Sie die Filter an, die Sie besitzen. Für jedes Objekt sagen wir Ihnen in Was sehen und hier unter den Ergebnissen, welchen Sie verwenden: Das hängt vom Objekttyp, vom Mond, vom Himmel an Ihrem Ort und von Ihrer Kamera ab, Farbe oder Mono.",
  },
  es: {
    g_campo: "Esta es la sección Campo de visión. Elige tu telescopio y tu cámara, o un ocular para la observación visual, y luego el objeto. Sobre el cielo aparece el recuadro del sensor: puedes moverte arrastrando, ampliar, girar la cámara y planificar un mosaico. Debajo verás el campo, la escala de imagen y si el muestreo es el adecuado para tu cielo.",
    g_stanotte: "Esta es la sección Esta noche. Elige el lugar y la fecha: la página calcula la puesta de sol, la oscuridad astronómica y la Luna, y ordena los mejores objetos de la noche según las horas sobre el horizonte, la altura y la distancia a la Luna. Si configuras tu equipo puedes ver solo los objetos que caben bien en tu campo. Toca un objeto para ver el gráfico de altura y la vista previa.",
    g_camere: "Aquí está la base de datos de cámaras: astronómicas, réflex, sin espejo y telescopios inteligentes, con los datos de las fichas oficiales. Puedes filtrar por marca, sensor y tamaño de píxel, comparar hasta cuatro cámaras y probarlas al instante en el Campo de visión con el botón Usar.",
    g_calcolatori: "Estas son las calculadoras, divididas en cuatro grupos: observar, fotografiar, montura y guiado, cielo y tiempo. Elige una de la lista o búscala por su nombre. En cada calculadora puedes buscar tu telescopio, tu cámara o tu ocular, y los campos se rellenan solos. Encontrarás, por ejemplo, el aumento y la pupila de salida, la focal ideal para tus píxeles, la fotografía planetaria, los paisajes nocturnos, la cadena del backfocus, la Polar en el buscador polar y el riesgo de rocío.",
    g_software: "Aquí tienes los programas y las apps más usados por los astrónomos aficionados, por categorías: captura, autoguiado, apilado, procesado, planetarios y meteorología. Cada recuadro lleva a la web oficial del programa.",
    g_setup: "En Mis equipos guardas tus equipos con un nombre. La próxima vez basta un toque para recuperarlos, sin volver a buscar telescopio, reductor y cámara. Se quedan en tu cuenta: los tienes en todos tus dispositivos.",
    g_telescopio: "Busca tu telescopio en nuestro catálogo o escribe a mano el diámetro y la focal. Si eliges un telescopio inteligente, la cámara se configura sola.",
    g_riduttore: "Si usas un reductor de focal o una lente Barlow, elige el factor: la focal efectiva y el campo se actualizan al instante.",
    g_camera: "Busca tu cámara en la base de datos o introduce la resolución y el tamaño de píxel. Con el binning y el seeing de tu cielo verás si el muestreo es correcto.",
    g_oculare: "Busca tu ocular en nuestro catálogo o introduce la focal y el campo aparente: verás los aumentos, el campo real y la pupila de salida.",
    g_oggetto: "Busca el objeto por su sigla o por su nombre, por ejemplo M31 o Andrómeda. La vista del cielo se centra en el objeto.",
    g_mosaico: "Si el objeto no cabe en una sola toma, planifica un mosaico: elige cuántos paneles en horizontal y en vertical y cuánto solapamiento. Debajo verás las coordenadas del centro de cada panel.",
    g_cielo: "Esta es la vista del cielo. Arrastra el cielo para moverte: el recuadro de la cámara se queda en el centro. Para ampliar usa más y menos, dos dedos o Ctrl y la rueda, y con un doble clic centras la vista en ese punto. La cámara se gira con la barra de rotación o con dos dedos. El botón Nombres muestra u oculta los nombres de los objetos; el botón Cuadrícula hace bien visibles las coordenadas y añade el ecuador celeste y la eclíptica. El botón Resultado muestra cómo saldrá la foto: solo lo que entra en el sensor, enderezado, con la cámara girada como la has puesto. Con el enlace puedes compartir tu encuadre.",
    g_luogo: "Elige la ciudad o usa tu posición: los horarios de la noche, la Luna y la clasificación de objetos se calculan para ese lugar.",
    g_data: "Elige la noche que te interesa. Los horarios están en la zona horaria de tu dispositivo.",
    g_attrezzatura: "Configura aquí el telescopio y la cámara, o recupera uno de tus equipos. Luego activa el interruptor para ver solo los objetos que caben bien en tu campo.",
    g_filtri: "En Mis filtros indicas los filtros que tienes: los buscas por su nombre o tocas su tipo. Para cada objeto, en Qué ver y aquí debajo de los resultados, te decimos cuál montar: depende del tipo de objeto, de la Luna, del cielo de tu lugar y de tu cámara, en color o monocromática.",
  },
  en: {},
};
const Voce = (() => {
  const ok = typeof window !== "undefined" && "speechSynthesis" in window && "SpeechSynthesisUtterance" in window;
  let voce = null, bottoneAttivo = null, coda = [], parlando = false;
  let giro = 0, attesa = null;
  const testo = el("span", { class: "gas-voce-testo" });
  const ferma = el("button", { type: "button", class: "gas-voce-ferma", onclick: () => smetti() }, "■ ", t("ferma"));
  const barra = el("div", { class: "gas-voce-barra", hidden: true, role: "status", "aria-live": "polite" },
    el("span", { class: "gas-voce-onda", "aria-hidden": "true" }, el("i"), el("i"), el("i")), testo, ferma);
  const cornice = el("div", { class: "gas-voce-cornice" }, barra);
  function comeLaPagina() {
    const sf = document.getElementById("gas-sfondo"), c = k => !!sf && sf.classList.contains(k);
    cornice.classList.toggle("gas-chiaro", c("gas-chiaro"));
    cornice.classList.toggle("gas-grande", c("gas-grande"));
    cornice.classList.toggle("gas-voce--rosso", c("gas-rosso"));
  }
  function scegliVoce() {
    if (!ok) return null;
    const tutte = speechSynthesis.getVoices();
    const mie = tutte.filter(v => (v.lang || "").toLowerCase().replace("_", "-").startsWith(LINGUA));
    const punti = v => (/natural|neural|premium|enhanced|siri/i.test(v.name) ? 6 : 0) + (/online/i.test(v.name) ? 3 : 0) +
      (/google/i.test(v.name) ? 4 : 0) + ((v.lang || "").toLowerCase().replace("_", "-") === LOCALE.toLowerCase() ? 1 : 0);
    mie.sort((a, b) => punti(b) - punti(a));
    return mie[0] || null;
  }
  if (ok) {
    voce = scegliVoce();
    speechSynthesis.addEventListener && speechSynthesis.addEventListener("voiceschanged", () => { voce = scegliVoce(); });
  }
  const frasi = s => String(s).replace(/([.!?]+)\s+/g, "$1\n").split("\n").map(x => x.trim()).filter(Boolean);
  function prossima(g) {
    if (!parlando || g !== giro) return;
    const f = coda.shift();
    if (!f) { smetti(true); return; }
    testo.textContent = f;
    if (!ok || !voce && !speechSynthesis.getVoices().length) {
      attesa = setTimeout(() => prossima(g), Math.max(2500, f.length * 65));
      return;
    }
    const u = new SpeechSynthesisUtterance(f);
    if (voce) u.voice = voce;
    u.lang = (voce && voce.lang) || LOCALE;
    u.rate = 1; u.pitch = 1;
    u.onend = () => prossima(g);
    u.onerror = () => prossima(g);
    speechSynthesis.speak(u);
  }
  function smetti(fine) {
    parlando = false; coda = []; giro++;
    clearTimeout(attesa); attesa = null;
    if (ok) speechSynthesis.cancel();
    if (bottoneAttivo) { bottoneAttivo.classList.remove("on"); bottoneAttivo.setAttribute("aria-pressed", "false"); bottoneAttivo = null; }
    barra.hidden = true;
    if (!fine) testo.textContent = "";
  }
  function parla(chiave, bottone) {
    const s = (GUIDA[LINGUA] || GUIDA.it)[chiave] || GUIDA.it[chiave];
    if (!s) return;
    const stesso = bottoneAttivo === bottone;
    smetti();
    if (stesso) return;
    comeLaPagina();
    if (!cornice.isConnected) document.body.appendChild(cornice);
    bottoneAttivo = bottone;
    provaFatta(4);
    if (bottone) { bottone.classList.add("on"); bottone.setAttribute("aria-pressed", "true"); }
    barra.hidden = false; parlando = true; coda = frasi(s);
    prossima(giro);
  }
  function bottone(chiave, conTesto) {
    const b = el("button", { type: "button", class: "gas-voce-btn" + (conTesto ? " gas-voce-btn--testo" : ""), "aria-pressed": "false",
      title: t("ascolta_spiegazione"), "aria-label": t("ascolta_spiegazione"),
      onclick: e => { e.stopPropagation(); e.preventDefault(); parla(chiave, b); } },
    icona("guida"), conTesto ? el("span", null, t("guida_voce")) : null);
    return b;
  }
  return { bottone, parla, smetti, disponibile: ok };
})();
function titoloVoce(testo, chiave) { return [testo, " ", Voce.bottone(chiave)]; }
const FILTRI_TIPI = [
  { id: "dual", foto: true }, { id: "sho", foto: true }, { id: "ha", foto: true }, { id: "oiii", foto: true, vis: true },
  { id: "sii", foto: true }, { id: "hbeta", vis: true }, { id: "uhc", foto: true, vis: true }, { id: "lp", foto: true, vis: true },
  { id: "lrgb", foto: true }, { id: "uvir", foto: true }, { id: "irpass", foto: true }, { id: "luna", vis: true },
  { id: "solare", foto: true, vis: true },
];
const EMISSIONE = new Set(["en", "cn", "snr", "neb"]);
const HBETA = new Set(["IC 434", "IC 434/NGC 2024", "B33", "NGC 1499", "IC 5146"]);
const conHbeta = o => HBETA.has(o.id) || (o.alias || []).some(a => HBETA.has(a));
const nebEmissione = o => EMISSIONE.has(o.t) || conHbeta(o);
function solareNonBasta(nome, modo) {
  const n = String(nome || "");
  if (/occhial|glasses|viewer|brille|gafas/i.test(n) && !/film|folie|pellicola/i.test(n)) return "occhiali";
  if (/herschel|wedge/i.test(n)) return "herschel";
  if (/continuum|contrast|g-?band|photosphere|polari[sz]|calcium|ca-?k\b|blocking|bloccaggio|\berf\b|quark|sundancer|etalon|double.?stack|doppio strato|h-?alpha|hα|\bha\b|triband/i.test(n)) return "insieme";
  return modo === "visuale" && /od\s?3[.,]8|photo film|digital sol/i.test(n) ? "foto" : "";
}
Object.assign(TESTI.it, { fm_sole_occhiali: "si usano solo a occhio nudo, mai dietro al telescopio, al binocolo o al cercatore.",
  fm_sole_herschel: "si usa solo su un rifrattore, col suo filtro ND montato; mai su Newton, Maksutov o Schmidt-Cassegrain.",
  fm_sole_insieme: "da solo non protegge: si usa insieme al filtro davanti al telescopio o al prisma di Herschel, come spiega il produttore.",
  fm_sole_foto: "è solo per le foto, non per gli occhi: per guardare il Sole serve un filtro solare visuale (OD 5)." });
Object.assign(TESTI.de, { fm_sole_occhiali: "nur mit bloßem Auge verwenden, nie hinter Teleskop, Fernglas oder Sucher.",
  fm_sole_herschel: "nur an einem Refraktor und mit eingesetztem ND-Filter verwenden; nie an Newton, Maksutov oder Schmidt-Cassegrain.",
  fm_sole_insieme: "schützt allein nicht: nur zusammen mit dem Filter vor dem Teleskop oder dem Herschelkeil verwenden, wie es der Hersteller beschreibt.",
  fm_sole_foto: "ist nur für Fotos, nicht für die Augen: Zum Beobachten der Sonne brauchen Sie einen visuellen Sonnenfilter (OD 5)." });
Object.assign(TESTI.es, { fm_sole_occhiali: "se usan solo a simple vista, nunca detrás del telescopio, los prismáticos o el buscador.",
  fm_sole_herschel: "se usa solo en un refractor, con su filtro ND puesto; nunca en Newton, Maksutov o Schmidt-Cassegrain.",
  fm_sole_insieme: "no protege por sí solo: se usa junto al filtro delante del telescopio o a la cuña de Herschel, como explica el fabricante.",
  fm_sole_foto: "es solo para fotos, no para los ojos: para mirar el Sol necesitas un filtro solar visual (OD 5)." });
Object.assign(TESTI.en, { fm_sole_occhiali: "use them with the naked eye only, never behind a telescope, binoculars or finder.",
  fm_sole_herschel: "use it only on a refractor, with its ND filter fitted; never on a Newtonian, Maksutov or Schmidt-Cassegrain.",
  fm_sole_insieme: "doesn't protect on its own: use it together with the filter in front of the telescope or with a Herschel wedge, as the maker explains.",
  fm_sole_foto: "is for photos only, not for your eyes: to look at the Sun you need a visual solar filter (OD 5)." });
if (!Array.isArray(CAMPO.filtri)) CAMPO.filtri = [];
if (!Array.isArray(CAMPO.filtriNomi)) CAMPO.filtriNomi = [];
let _notteBase = null;
function notteBase() {
  const d = dataNotte(), { lat, lon } = NOTTE.luogo, chiave = `${isoData(d)}|${lat}|${lon}`;
  if (!_notteBase || _notteBase.chiave !== chiave) {
    const nt = Astro.notte(d, lat, lon, 10);
    const meta = nt.buio.length ? nt.buio[Math.floor(nt.buio.length / 2)] : Math.floor(nt.n / 2);
    const su = nt.buio.length ? nt.buio.filter(i => nt.hLuna[i] > 0).length / nt.buio.length : 0;
    _notteBase = { chiave, nt, meta, lunaSu: su };
  }
  return _notteBase;
}
function lunaOggetto(nt, h, sep) {
  let ore = 0, conLuna = 0;
  const hmin = NOTTE.hmin || 30;
  for (const i of nt.buio) if (h[i] >= hmin) { ore++; if (nt.hLuna[i] > 0) conLuna++; }
  return { k: nt.fase.k, sep, su: ore ? conLuna / ore : 0, ore: ore * nt.passo / 60 };
}
function lunaPer(o) {
  const b = notteBase(), L = b.nt.lune[b.meta];
  return lunaOggetto(b.nt, Astro.curvaOggetto(b.nt, o.ra, o.dec).h, Astro.separazione(L.ra, L.dec, o.ra, o.dec));
}
function pesoLuna(L) {
  const vic = L.sep < 30 ? 1.3 : L.sep < 60 ? 1 : L.sep < 90 ? 0.6 : L.sep < 120 ? 0.35 : 0.2;
  return L.k * L.su * vic;
}
function consiglioFiltro(o, ctx) {
  const miei = ctx.miei || new Set(), b = clamp(ctx.bortle || 5, 1, 9), L = ctx.luna || { k: 0, su: 0, sep: 180 };
  const luna = pesoLuna(L);
  const disturbo = clamp(0.2 * (b - 3), 0, 1.2) + luna;
  const tipo = o.t;
  const r = { tipo: "nessuno", testo: "", classe: "ok", hai: false, no: [], luna: L, pesoLuna: luna, bandaLarga: false, o, ctx, disturbo };
  const ho = id => miei.has(id);
  if (o.corpo) {
    if (o.corpo === "sole") Object.assign(r, { tipo: "solare", testo: t("ff_sole"), classe: "male", luna: null });
    else if (o.corpo === "luna") Object.assign(r, { tipo: ctx.modo === "visuale" ? "luna" : "nessuno", testo: t(ctx.modo === "visuale" ? "fv_luna" : "ff_luna"),
      luna: null });
    else Object.assign(r, { tipo: ctx.modo === "visuale" ? "nessuno" : ctx.mono ? "irpass" : "uvir", testo: t(ctx.modo === "visuale" ? "fv_pianeta" : "ff_pianeta"),
      luna: null });
    const sole = o.corpo === "sole" ? (CAMPO.filtriNomi || []).filter(f => f.tipo === "solare") : [];
    r.hai = r.tipo === "nessuno" || (ho(r.tipo) && !(sole.length && sole.every(f => solareNonBasta(f.nome, ctx.modo))));
    if (o.corpo === "sole") r.classe = r.hai ? "medio" : "male";
    return r;
  }
  if (ctx.modo === "visuale") {
    if (conHbeta(o)) Object.assign(r, { tipo: "hbeta", testo: t("fv_hbeta") });
    else if (tipo === "snr" || tipo === "pn") Object.assign(r, { tipo: ho("uhc") && !ho("oiii") ? "uhc" : "oiii", testo: t("fv_oiii") });
    else if (EMISSIONE.has(tipo)) Object.assign(r, { tipo: "uhc", testo: t("fv_uhc") });
    else Object.assign(r, { tipo: "nessuno", testo: t(disturbo > 0.8 ? "fv_nessuno_luce" : "fv_nessuno"), classe: disturbo > 0.8 ? "medio" : "ok", no: ["uhc", "oiii", "hbeta"] });
  } else if (nebEmissione(o) || tipo === "pn") {
    if (ctx.mono) Object.assign(r, { tipo: "sho", testo: t(tipo === "pn" ? "ff_mono_pn" : "ff_mono_em") });
    else if (disturbo < 0.25) Object.assign(r, { tipo: "dual", testo: t("ff_colore_em_buio") });
    else Object.assign(r, { tipo: "dual", testo: t(luna > 0.35 ? "ff_colore_em_luna" : "ff_colore_em_citta") });
    if (!ctx.mono && !ho("dual") && (ho("uhc") || ho("lp"))) r.alternativa = ho("uhc") ? "uhc" : "lp";
    if (ctx.mono && !ho("sho") && (ho("ha") || ho("oiii"))) { r.tipo = ho("ha") ? "ha" : "oiii"; r.hai = true; }
  } else {
    r.no = ["dual", "sho", "ha", "oiii", "sii", "uhc"];
    r.bandaLarga = true;
    const stelle = ["oc", "sc", "gc", "ds"].includes(tipo), brillante = o.mag != null && o.mag <= 6.5;
    if (stelle) Object.assign(r, { tipo: ctx.mono ? "lrgb" : disturbo >= 0.45 ? "lp" : "nessuno", testo: t(disturbo >= 0.45 ? "ff_stelle_luce" : "ff_stelle_buio") });
    else if (disturbo >= 1 && brillante && luna < 0.5)
      Object.assign(r, { tipo: ctx.mono ? "lrgb" : "lp", testo: t("ff_brillante_citta"), classe: "medio" });
    else if (disturbo >= 1) Object.assign(r, { tipo: "rimanda", testo: t(luna > 0.5 ? "ff_rimanda_luna" : "ff_rimanda_citta"), classe: "male" });
    else if (disturbo >= 0.45) Object.assign(r, { tipo: ctx.mono ? "lrgb" : "lp", testo: t(ctx.mono ? "ff_mono_bl_luce" : "ff_colore_bl_luce"), classe: "medio" });
    else Object.assign(r, { tipo: ctx.mono ? "lrgb" : "nessuno", testo: t(ctx.mono ? "ff_mono_bl_buio" : "ff_colore_bl_buio") });
  }
  if (!r.hai) r.hai = r.tipo === "nessuno" || r.tipo === "rimanda" || ho(r.tipo) ||
    (r.tipo === "sho" && ho("ha")) || (r.tipo === "lp" && ho("uvir") && disturbo < 0.6);
  return r;
}
function contestoFiltro(o, luna) {
  const cam = CAMPO.cam && CAMPO.cam.id && DATI.perCamera.get(CAMPO.cam.id), r = calcoloCampo();
  const mm = cam && cam.mm ? cam.mm : CAMPO.cam && CAMPO.cam.w && CAMPO.cam.px ? [CAMPO.cam.w * CAMPO.cam.px / 1000, CAMPO.cam.h * CAMPO.cam.px / 1000] : null;
  return { luna: luna || lunaPer(o), bortle: NOTTE.bortle || 5, mono: !!(cam && cam.col === "mono"), modo: CAMPO.modo, miei: new Set(CAMPO.filtri || []),
    N: r && r.N, marca: cam ? cam.marca : "", cat: cam ? cam.cat : "", diag: mm ? Math.hypot(mm[0], mm[1]) : null };
}
function nomeFiltro(id) { return id === "nessuno" ? t("filtro_nessuno") : id === "rimanda" ? t("filtro_rimanda") : t("filtro_" + id); }
function badgeFiltro(c) {
  const sc = c.tipo !== "rimanda" && c.tipo !== "nessuno" ? sceltaMieiFiltri(c) : null, mio = sc ? sc.migliore && sc.migliore.f : mioFiltroDiTipo(c.tipo);
  const hai = sc ? !!sc.migliore : c.hai, segno = c.tipo === "rimanda" ? "☾" : hai ? "✓" : "＋";
  return el("span", { class: `gas-filtro gas-filtro--${c.classe}${hai ? " gas-filtro--hai" : ""}`, title: c.testo },
    `${segno} ${mio ? nomeCorto(mio.nome) : nomeFiltro(c.tipo)}`);
}
function spiegaFiltro(c) {
  const righe = [el("p", { class: "gas-filtro-testo" }, el("b", null, t("filtro_consigliato"), ": ", nomeFiltro(c.tipo)), " — ", c.testo)];
  const sc = sceltaMieiFiltri(c), rimanda = c.tipo === "rimanda";
  const conPerche = v => [nomeCorto(v.f.nome), " (", [descriviFiltro(v.p), v.perche, ...(v.note || [])].filter(Boolean).join(" · "), ")"].join("");
  if (sc) {
    if (sc.migliore && !rimanda) righe.push(el("p", { class: "gas-filtro-tuo" }, t("fm_usa", { f: nomeCorto(sc.migliore.f.nome) }), ": ",
      el("span", { class: "gas-filtro-perche" }, [descriviFiltro(sc.migliore.p), sc.migliore.perche, ...(sc.migliore.note || [])].filter(Boolean).join(" · ")), "."));
    if (sc.alternative.length && !rimanda) righe.push(el("p", { class: "gas-nota" }, t("fm_anche", { f: sc.alternative.map(conPerche).join("; ") })));
    if (sc.sho && !rimanda) righe.push(el("p", { class: "gas-nota" }, t("fm_sho", { s: nomeCorto(sc.sho.s.nome), h: nomeCorto(sc.sho.h.nome), bs: sc.sho.bs, bh: sc.sho.bh })));
    const perMotivo = new Map();
    for (const v of sc.no) { if (!perMotivo.has(v.no)) perMotivo.set(v.no, []); perMotivo.get(v.no).push(nomeCorto(v.f.nome)); }
    if (perMotivo.size) righe.push(el("p", { class: "gas-nota gas-filtro-no" }, t("fm_no", { f: [...perMotivo].map(([m, n]) => `${n.join(", ")} (${m})`).join("; ") })));
  }
  const sole = c.o && c.o.corpo === "sole", modo = c.ctx && c.ctx.modo;
  const mio = sc ? null : sole ? (CAMPO.filtriNomi || []).find(f => f.tipo === "solare" && !solareNonBasta(f.nome, modo)) : mioFiltroDiTipo(c.tipo);
  if (mio) righe.push(el("p", { class: "gas-filtro-tuo" }, t("usa_il_tuo", { f: mio.nome })));
  if (sole) for (const f of CAMPO.filtriNomi || []) {
    const k = f.tipo === "solare" && solareNonBasta(f.nome, modo);
    if (k) righe.push(el("p", { class: "gas-nota gas-filtro-no gas-filtro-sole-no" }, "⚠ ", el("b", null, f.nome), ": ", t("fm_sole_" + k)));
  }
  const L = c.luna;
  if (L) {
    const pct = Math.round(L.k * 100);
    let frase;
    if (L.k < 0.12) frase = t("luna_nuova_ok");
    else if (L.su < 0.12) frase = t("luna_non_in_cielo", { k: pct });
    else frase = t("luna_info", { k: pct, sep: num(L.sep), su: Math.round(L.su * 100) });
    if (c.bandaLarga && L.k >= 0.12 && L.su >= 0.12) frase += " " + t(c.pesoLuna < 0.3 ? (c.tipo === "rimanda" ? "luna_lontana_cielo" : "luna_lontana_ok")
      : c.pesoLuna < 0.55 ? "luna_con_cautela" : "luna_vicina_no");
    righe.push(el("p", { class: "gas-nota gas-filtro-luna" }, "☾ ", frase));
  }
  if (!sc && c.alternativa) righe.push(el("p", { class: "gas-nota" }, t("filtro_alternativa", { f: nomeFiltro(c.alternativa) })));
  if (!sc && c.no.length && (CAMPO.filtri || []).some(f => c.no.includes(f))) righe.push(el("p", { class: "gas-nota" }, t("filtro_non_usare",
    { f: (CAMPO.filtri || []).filter(f => c.no.includes(f)).map(nomeFiltro).join(", ") })));
  if ((sc ? !sc.migliore : !c.hai) && DATI.filtri && c.tipo !== "nessuno" && c.tipo !== "rimanda") {
    const lista = filtriNegozioPer(c).slice(0, 3);
    if (lista.length) righe.push(el("p", { class: "gas-nota gas-calc-negozio" }, t("filtri_negozio"), " ",
      lista.map((x, i) => [i ? " · " : "", el("a", { href: urlProdotto(x.h), target: "_blank", rel: "noopener" }, x.t)])));
  }
  return el("div", { class: "gas-filtro-box" }, righe);
}
function filtriNegozioPer(c) {
  const x = c.ctx || {}, vis = x.modo === "visuale", D = CAMPO.tel && CAMPO.tel.D > 0 ? Math.round(CAMPO.tel.D) : 0;
  const va = f => {
    const p = profiloFiltro({ nome: f.t, tipo: f.tipo, h: f.h });
    if (p.clip && (vis || !(new RegExp(p.clip, "i").test(x.marca || "") && /reflex|mirrorless|dslr/i.test(x.cat || "")))) return false;
    if (c.tipo === "solare") return !solareNonBasta(f.t, x.modo);
    if (/clear\s?glass|mc-?clear|\b\d{2,3}\s?x\s?\d{2,3}\s?(x\s?\d+\s?)?mm/i.test(f.t)) return false;
    return c.tipo !== "dual" || p.bande.has("ha");
  };
  const l = DATI.filtri.filter(f => f.tipo === c.tipo && va(f)), misura = f => new RegExp(`\\b${D}\\s?mm`, "i").test(f.t) ? 0 : 1;
  return c.tipo === "solare" && D ? l.sort((a, b) => misura(a) - misura(b)) : l;
}
function boxConsiglioFiltro(o) {
  return el("div", { class: "gas-filtro-campo" }, spiegaFiltro(consiglioFiltro(o, contestoFiltro(o))),
    el("p", { class: "gas-nota" }, t("filtro_per_notte", Object.assign(luogoFrasi(), { b: NOTTE.bortle || 5 })), " ",
      el("a", { href: "#stanotte", onclick: e => { e.preventDefault(); vai("stanotte"); } }, t("cambia_in_stanotte"))));
}
const FILTRI_NOTI = [
  ["Optolong L-eXtreme", "dual"], ["Optolong L-Ultimate", "dual"], ["Optolong L-eNhance", "dual"], ["Optolong L-Quad Enhance", "dual"],
  ["Optolong L-Synergy", "dual"], ["Optolong L-Pro", "lp"], ["Optolong L-Para", "dual"], ["Optolong UV/IR Cut", "uvir"],
  ["Optolong H-alpha 7nm", "ha"], ["Optolong H-alpha 3nm", "ha"], ["Optolong OIII 6.5nm", "oiii"], ["Optolong SII 6.5nm", "sii"],
  ["Optolong SHO 7nm", "sho"], ["Optolong LRGB", "lrgb"], ["Optolong UHC", "uhc"], ["Optolong CLS", "lp"],
  ["Antlia ALP-T Dual Band", "dual"], ["Antlia Triband RGB Ultra", "dual"], ["Antlia Quad Band", "dual"], ["Antlia SHO 3nm", "sho"],
  ["Antlia LRGB-V", "lrgb"], ["Antlia ALP-T 5nm", "dual"],
  ["IDAS NBZ", "dual"], ["IDAS NB1", "dual"], ["IDAS NB3", "dual"], ["IDAS LPS-D1", "lp"], ["IDAS LPS-D2", "lp"], ["IDAS LPS-D3", "lp"], ["IDAS LPS-P2", "lp"],
  ["ZWO Duo-Band", "dual"], ["ZWO LRGB", "lrgb"], ["ZWO Hα/OIII/SII 7nm", "sho"], ["ZWO IR Cut", "uvir"], ["ZWO IR850", "irpass"],
  ["Askar ColorMagic D1", "dual"], ["Askar ColorMagic D2", "dual"], ["STC Astro Duo-NB", "dual"], ["Radian Triad Ultra", "dual"],
  ["SVBONY SV220 Hα/OIII 7nm", "dual"], ["SVBONY SV220 Hα/OIII 3nm", "dual"], ["SVBONY SV220 SII/OIII 7nm", "dual"],
  ["SVBONY SV240 multibanda Hβ/OIII/Hα", "dual"], ["SVBONY SV260 5 bande", "lp"], ["SVBONY SV220 set SHO 7nm", "sho"],
  ["SVBONY SV227 H-alpha 5nm", "ha"], ["SVBONY SV227 OIII 5nm", "oiii"], ["SVBONY SV227 SII 5nm", "sii"], ["SVBONY SV227 set SHO 5nm", "sho"],
  ["SVBONY H-alpha 7nm", "ha"], ["SVBONY OIII 7nm", "oiii"], ["SVBONY SII 7nm", "sii"], ["SVBONY SV115 OIII", "oiii"],
  ["SVBONY SV183 IR-pass 685nm", "irpass"], ["SVBONY LRGB", "lrgb"], ["SVBONY SV139 filtro lunare ND", "luna"], ["SVBONY filtro lunare", "luna"],
  ["SVBONY UHC clip Canon EOS-C", "uhc"], ["SVBONY CLS clip Canon EOS-C", "lp"], ["SVBONY H-alpha 7nm clip Canon EOS-C", "ha"], ["SVBONY UHC", "uhc"], ["SVBONY CLS", "lp"], ["SVBONY UV/IR Cut", "uvir"],
  ["Baader UHC-S", "uhc"], ["Baader Moon & Skyglow", "lp"], ["Baader Neodymium", "lp"], ["Baader H-alpha 7nm", "ha"], ["Baader OIII 8.5nm", "oiii"],
  ["Baader SII 8nm", "sii"], ["Baader LRGB CMOS", "lrgb"], ["Baader UV/IR Cut", "uvir"], ["Baader IR-Pass 685nm", "irpass"], ["Baader H-beta", "hbeta"],
  ["Astronomik CLS", "lp"], ["Astronomik CLS-CCD", "lp"], ["Astronomik UHC", "uhc"], ["Astronomik OIII", "oiii"], ["Astronomik H-alpha 6nm", "ha"],
  ["Astronomik H-alpha 12nm", "ha"], ["Astronomik SII 6nm", "sii"], ["Astronomik L-2 UV-IR Block", "uvir"], ["Astronomik L-3 UV-IR Block", "uvir"],
  ["Astronomik Deep-Sky RGB", "lrgb"], ["Astronomik ProPlanet 742", "irpass"], ["Astronomik H-beta", "hbeta"],
  ["Celestron UHC/LPR", "uhc"], ["Celestron Smart Filter (Origin)", "dual"], ["Lumicon UHC", "uhc"], ["Lumicon OIII", "oiii"], ["Lumicon H-beta", "hbeta"],
  ["Player One UV/IR Cut", "uvir"], ["Player One IR685", "irpass"], ["DWARFLAB Duo-Band (Dwarf)", "dual"], ["ZWO Seestar filtro duo-band integrato", "dual"],
];
function cercaFiltri(q) {
  const p = normParole(q).trim().split(/\s+/).filter(Boolean);
  if (!p.length) return [];
  const pa = p.map(attaccato);
  const pc = p.map(reCifra);
  const prova = s => { const n = normParole(s), na = attaccato(n); return p.every((w, i) => pc[i] ? pc[i].test(n) : n.includes(w) || (pa[i] && na.includes(pa[i]))); };
  const negozio = (DATI.filtri || []).filter(x => prova(`${x.t} ${x.v || ""} ${t("filtro_" + x.tipo)}`)).slice(0, 12)
    .map(x => ({ nome: x.t, tipo: tipoGiusto(x.t, x.tipo), h: x.h, foto: x.foto }));
  const noti = FILTRI_NOTI.filter(([n, tp]) => prova(`${n} ${t("filtro_" + tp)}`)).slice(0, 30).map(([n, tp]) => ({ nome: n, tipo: tipoGiusto(n, tp) }));
  const visti = new Set([...negozio, ...noti].map(f => attaccato(normParole(f.nome))));
  const db = ((DATI.noti && DATI.noti.filtri) || []).filter(f => !visti.has(attaccato(normParole(f.nome))) && prova(`${f.nome} ${t("filtro_" + f.tipo)}`)).slice(0, 40)
    .map(f => Object.assign({}, f, { tipo: tipoGiusto(f.nome, f.tipo) }));
  const tutti = [...negozio, ...noti, ...db];
  if (tutti.length || p.length < 2 || RICERCA_ESATTA) return tutti;
  const ridotte = p.filter(w => !eMisura(w) && !PAROLE_CONTORNO.has(w) && w.length > 1);
  const r = ridotte.length && ridotte.length < p.length ? cercaFiltri(ridotte.join(" ")) : [];
  if (r.length) return r;
  const senza = riattacca(p).filter(w => !eMisura(w) && !PAROLE_CONTORNO.has(w) && w.length > 1);
  if (senza.length) return senza.length < ridotte.length ? cercaFiltri(senza.join(" ")) : [];
  const misure = riattacca(p).filter(eMisura);
  return misure.length && misure.length < p.length ? cercaFiltri(misure.join(" ")) : [];
}
function mioFiltroDiTipo(tipo) {
  return (CAMPO.filtriNomi || []).find(f => f.tipo === tipo || (tipo === "sho" && f.tipo === "ha"));
}
Object.assign(TESTI.it, { fm_nome: "Nome del filtro", fm_tipo: "Tipo", fm_tipo_scegli: "Scegli il tipo…", fm_banda: "Larghezza di banda",
  fm_banda_n: "La trovi sulla scatola o sul sito del produttore (es. 7 nm): serve per consigliarti il filtro giusto per il cielo e per il tuo telescopio." });
Object.assign(TESTI.de, { fm_nome: "Name des Filters", fm_tipo: "Typ", fm_tipo_scegli: "Typ wählen…", fm_banda: "Bandbreite",
  fm_banda_n: "Steht auf der Verpackung oder auf der Website des Herstellers (z. B. 7 nm): Damit können wir Ihnen den passenden Filter für Ihren Himmel und Ihr Teleskop empfehlen." });
Object.assign(TESTI.es, { fm_nome: "Nombre del filtro", fm_tipo: "Tipo", fm_tipo_scegli: "Elige el tipo…", fm_banda: "Ancho de banda",
  fm_banda_n: "Lo encuentras en la caja o en la web del fabricante (p. ej. 7 nm): sirve para aconsejarte el filtro adecuado para el cielo y tu telescopio." });
Object.assign(TESTI.en, { fm_nome: "Filter name", fm_tipo: "Type", fm_tipo_scegli: "Choose the type…", fm_banda: "Bandwidth",
  fm_banda_n: "It's on the box or the maker's website (e.g. 7 nm): we use it to suggest the right filter for your sky and telescope." });
function indovinaTipoFiltro(nome) {
  const s = String(nome || "").toLowerCase();
  if (!s.trim()) return null;
  const regole = [
    [/skyglow|neodym|\bcls\b|\blps|pollution|inquinament|\blpr\b|l-?pro\b|\blp\b/, "lp"],
    [/solar|\bsun\b|herschel/, "solare"],
    [/\bmoon\b|\bluna\b|lunare/, "luna"],
    [/h.?beta|h\u03b2/, "hbeta"],
    [/\bsho\b|h(a|\u03b1).?oiii.?sii/, "sho"],
    [/dual|\bduo|tri.?band|triad|quad|alp-?t|\bnbz\b|\bnb\d|l-?extreme|l-?ultimate|l-?enhance|l-?synergy|l-?para|colormagic|h(a|\u03b1)\W{0,3}o\s?iii|o\s?iii\W{0,3}h(a|\u03b1)/, "dual"],
    [/\buhc/, "uhc"],
    [/o\s?iii|\bo3\b/, "oiii"],
    [/\bs\s?ii\b|\bs2\b/, "sii"],
    [/h.?alpha|h\u03b1|\bha\b/, "ha"],
    [/rgb/, "lrgb"],
    [/uv.?ir|ir.?cut|\bl-?[23]\b/, "uvir"],
    [/ir.?pass|\bir\s?\d{3}|\b(685|742|807|850)\b/, "irpass"],
  ];
  const r = regole.find(([re]) => re.test(s));
  return r ? tipoGiusto(nome, r[1]) : tipoGiusto(nome, null);
}
Object.assign(TESTI.it, { fm_manca_tipo: "Scegli il tipo di filtro (dual band, Hα, UHC…): serve per consigliarti quando usarlo.", fm_manca_nome: "Scrivi il nome del filtro." });
Object.assign(TESTI.de, { fm_manca_tipo: "Wählen Sie den Filtertyp (Dualband, Hα, UHC…): Damit können wir Ihnen sagen, wann Sie ihn verwenden sollten.", fm_manca_nome: "Geben Sie den Namen des Filters ein." });
Object.assign(TESTI.es, { fm_manca_tipo: "Elige el tipo de filtro (dual band, Hα, UHC…): sirve para aconsejarte cuándo usarlo.", fm_manca_nome: "Escribe el nombre del filtro." });
Object.assign(TESTI.en, { fm_manca_tipo: "Choose the filter type (dual-band, Hα, UHC…): we need it to tell you when to use the filter.", fm_manca_nome: "Type the filter's name." });
Object.assign(TESTI.it, { fm_togli_tipo: "Tocca di nuovo per togliere anche {f}" });
Object.assign(TESTI.de, { fm_togli_tipo: "Tippen Sie erneut, um auch {f} zu entfernen" });
Object.assign(TESTI.es, { fm_togli_tipo: "Toca otra vez para quitar también {f}" });
Object.assign(TESTI.en, { fm_togli_tipo: "Tap again to remove {f} too" });
function boxFiltri(dopo, opz) {
  const box = el("div", { class: "gas-filtri-miei" });
  const cambiato = () => { salvaCampo(); disegna(); if (dopo) dopo(); };
  const aggiungiFiltro = f => {
    if (!puoSalvare()) return invitoAccount();
    const nomi = (CAMPO.filtriNomi || []).filter(x => x.nome !== f.nome);
    nomi.push(Object.assign({ nome: f.nome, tipo: f.tipo, h: f.h || null }, f.nm > 0 ? { nm: f.nm } : {}));
    CAMPO.filtriNomi = nomi;
    const s = new Set(CAMPO.filtri || []); s.add(f.tipo);
    CAMPO.filtri = FILTRI_TIPI.map(x => x.id).filter(id => s.has(id));
    cambiato();
  };
  const manoNome = el("input", { type: "text", class: "gas-input", maxlength: 60, placeholder: t("fm_nome") });
  const manoTipo = selezione([["", t("fm_tipo_scegli")], ...FILTRI_TIPI.map(f => [f.id, t("filtro_" + f.id)])], "", () => {});
  let tipoDaNome = true, nomeDaRicerca = false, nmDaNome = true, manoNm = null;
  const banda = campoNumero(t("fm_banda"), null, v => { manoNm = v; nmDaNome = false; }, { unita: "nm", min: 0, passo: "0.5", segnaposto: "7" });
  const bandaNota = el("small", { class: "gas-muto gas-filtri-banda-n" }, t("fm_banda_n"));
  const bandaInp = $("input", banda);
  const mostraBanda = () => { const si = TIPI_STRETTI.has(manoTipo.value); banda.hidden = !si; bandaNota.hidden = !si; };
  manoTipo.addEventListener("change", () => { tipoDaNome = false; mostraBanda(); });
  const indovina = () => {
    if (tipoDaNome) { manoTipo.value = indovinaTipoFiltro(manoNome.value) || ""; if (manoTipo.value && manoTipo.hasAttribute("aria-invalid")) { manoTipo.removeAttribute("aria-invalid"); manca.hidden = true; } }
    if (nmDaNome) { manoNm = nmDalNome(manoNome.value); bandaInp.value = manoNm ? String(manoNm) : ""; }
    mostraBanda();
  };
  manoNome.addEventListener("input", () => { nomeDaRicerca = false; indovina(); });
  const manca = el("p", { class: "gas-nota gas-att-manca", role: "alert", hidden: true });
  const mano = el("details", { class: "gas-dettagli gas-att-mano gas-filtri-mano" }, el("summary", null, t("att_a_mano")),
    el("div", { class: "gas-due" }, etichetta(t("fm_nome"), manoNome), etichetta(t("fm_tipo"), manoTipo), banda), bandaNota,
    el("div", { class: "gas-riga-bottoni" }, el("button", { type: "button", class: "gas-btn gas-btn--mini", onclick: () => {
      const nome = manoNome.value.trim(), tipo = manoTipo.value;
      if (!nome || !tipo) {
        const c = nome ? manoTipo : manoNome;
        c.setAttribute("aria-invalid", "true");
        c.addEventListener(nome ? "change" : "input", () => { c.removeAttribute("aria-invalid"); manca.hidden = true; }, { once: true });
        manca.textContent = t(nome ? "fm_manca_tipo" : "fm_manca_nome"); manca.hidden = false;
        c.focus(); return;
      }
      manca.hidden = true; [manoNome, manoTipo].forEach(c => c.removeAttribute("aria-invalid"));
      aggiungiFiltro({ nome, tipo, nm: TIPI_STRETTI.has(tipo) && manoNm > 0 ? manoNm : null });
      manoNome.value = ""; manoTipo.value = ""; bandaInp.value = "";
      tipoDaNome = true; nomeDaRicerca = false; nmDaNome = true; manoNm = null; mostraBanda();
      cerca.imposta(""); cerca.chiudi();
    } }, t("att_aggiungi_btn"))), manca);
  mostraBanda();
  const cerca = creaCerca({
    segnaposto: t("cerca_filtro"),
    cerca: q => cercaFiltri(q),
    riga: f => ({ titolo: f.nome, sotto: t("filtro_" + f.tipo), extra: f.h ? t("in_vendita") : "", foto: f.foto }),
    scegli: f => { cerca.imposta(""); aggiungiFiltro(f); },
    senza: { testo: t("att_non_trovato"),
      apri: q => {
        mano.open = true;
        if (!manoNome.value.trim() || nomeDaRicerca) { manoNome.value = q.slice(0, 60); nomeDaRicerca = true; if (manoNome.hasAttribute("aria-invalid")) { manoNome.removeAttribute("aria-invalid"); manca.hidden = true; } indovina(); }
      },
      tocca: () => {
        mano.open = true;
        mano.scrollIntoView({ block: "center", behavior: "smooth" });
        setTimeout(() => (manoTipo.value ? manoNome : manoTipo).focus({ preventScroll: true }), 350);
      } },
  });
  const disegna = () => {
    const tutti = !!(opz && opz.tutti), visuale = !tutti && CAMPO.modo === "visuale", miei = new Set(CAMPO.filtri || []), nomi = CAMPO.filtriNomi || [];
    svuota(box);
    box.append(cerca.box, mano);
    if (nomi.length) box.appendChild(el("div", { class: "gas-setup-chip-riga gas-filtri-nomi" }, nomi.map(f => el("span", { class: "gas-setup-chip on" },
      f.h && inNegozio(f.h) ? el("a", { class: "gas-setup-usa", href: urlProdotto(f.h), target: "_blank", rel: "noopener", title: t("filtro_" + f.tipo) }, f.nome)
        : el("span", { class: "gas-setup-usa", title: t("filtro_" + f.tipo) }, f.nome),
      el("button", { type: "button", class: "gas-setup-togli", title: t("togli_filtro"), "aria-label": `${t("togli_filtro")}: ${f.nome}`, onclick: () => {
        if (!puoSalvare()) return invitoAccount();
        CAMPO.filtriNomi = nomi.filter(x => x !== f);
        if (!CAMPO.filtriNomi.some(x => x.tipo === f.tipo)) CAMPO.filtri = (CAMPO.filtri || []).filter(x => x !== f.tipo);
        cambiato();
      } }, "×")))));
    if (nomi.length && !visuale) box.appendChild(el("details", { class: "gas-dettagli gas-filtri-guida" }, el("summary", null, t("fm_guida")),
      el("ul", null, nomi.map(f => { const p = profiloFiltro(f), d = descriviFiltro(p);
        return el("li", null, el("b", null, nomeCorto(f.nome)), d ? ` · ${d}` : "", ": ", guidaFiltro(p), p.clip ? ` (${t("fm_clip", { m: p.clip })})` : ""); }))));
    box.appendChild(el("small", { class: "gas-setup-etich" }, t("oppure_tipo")));
    box.appendChild(el("div", { class: "gas-setup-chip-riga" }, FILTRI_TIPI.filter(f => tutti || miei.has(f.id) || (visuale ? f.vis : f.foto)).map(f => {
      const on = miei.has(f.id), conNome = nomi.filter(x => x.tipo === f.id);
      let attesa = null;
      const b = el("button", { type: "button", class: "gas-filtro-scelta" + (on ? " on" : ""), "aria-pressed": String(on), title: t("filtro_" + f.id + "_n"),
        onclick: () => {
          if (!puoSalvare()) return invitoAccount();
          if (on && conNome.length && !attesa) {
            b.classList.add("pronto"); b.textContent = t("fm_togli_tipo", { f: conNome.map(x => nomeCorto(x.nome)).join(", ") });
            attesa = setTimeout(() => { attesa = null; b.classList.remove("pronto"); b.textContent = "✓ " + t("filtro_" + f.id); }, 5000);
            return;
          }
          clearTimeout(attesa);
          const s = new Set(CAMPO.filtri || []);
          if (s.has(f.id)) { s.delete(f.id); CAMPO.filtriNomi = (CAMPO.filtriNomi || []).filter(x => x.tipo !== f.id); } else s.add(f.id);
          CAMPO.filtri = FILTRI_TIPI.map(x => x.id).filter(id => s.has(id));
          cambiato();
        } }, (on ? "✓ " : "") + t("filtro_" + f.id));
      return b;
    })));
  };
  box.aggiorna = disegna;
  disegna();
  return box;
}
Object.assign(TESTI.it, {
  ff_stelle_luce: "ammassi e stelle doppie sono luminosi: si riprendono bene anche col cielo chiaro, con pose brevi (con la camera a colori un anti-inquinamento a banda larga aiuta un po'). Niente banda stretta: toglierebbe i colori delle stelle.",
  ff_stelle_buio: "col cielo buio non serve un filtro: i colori delle stelle restano naturali (con la camera a colori basta l'UV/IR cut, se non ce l'ha già).",
  ff_brillante_citta: "con questo cielo si riprende lo stesso, perché l'oggetto è luminoso, ma servono molte ore di posa; da un cielo più buio rende molto di più.",
  ff_rimanda_citta: "con questo cielo galassie e nebulose deboli si vedono poco anche con i filtri: meglio un cielo più buio, o una nebulosa a emissione col dual band.",
  luna_lontana_cielo: "È abbastanza lontana: qui a disturbare è il cielo del luogo, non la Luna.",
  fm_clip: "a clip: solo per le {m}", fm_usa: "✓ Usa il tuo {f}", fm_anche: "Va bene anche: {f}.", fm_no: "Non usare: {f}.",
  fm_sho: "Palette Hubble (SHO): una serie con {s} ({bs}) più una con {h} ({bh}), poi le unisci.",
  fm_p_debole: "il più selettivo che hai; con questa luce un Hα+OIII da 7 nm o meno darebbe più contrasto",
  fm_a_largo: "più largo: stelle più naturali, un po' meno contrasto", fm_a_stretto: "più stretto: più contrasto, stelle meno colorate",
  fm_p5: "il più selettivo che hai: con questa luce (cielo e Luna) serve", fm_p4: "taglia bene la Luna e l'inquinamento luminoso",
  fm_p3: "buon compromesso fra contrasto e colori delle stelle", fm_p2: "col cielo buio basta questo e le stelle restano più naturali",
  fm_pl: "toglie un po' di inquinamento luminoso senza togliere la luce dell'oggetto", fm_pl_buio: "col cielo buio puoi anche farne a meno",
  fm_pm: "una banda alla volta: per la SHO o la HOO", fm_plrgb: "per i colori veri con la camera mono", fm_puv: "taglia solo UV e infrarosso",
  fm_n_larga: "banda stretta: toglierebbe proprio la luce di questo oggetto", fm_n_ha: "senza Hα", fm_n_debole: "banda troppo larga per questa luce",
  fm_n_clip: "a clip per {m}: non si monta sulla tua camera", fm_n_solo_ha: "solo Hα",
  fm_veloce: "a f/{n} la banda si sposta e perde segnale (è fatto per f/{m} o più lento)", fm_lento: "è la versione per ottiche veloci: a f/{n} rende un po' meno",
  fm_vignetta: "da 1,25″ è piccolo per il sensore grande della tua camera: gli angoli della foto vengono scuri",
  fm_b_dual: "Hα+OIII {nm} nm", fm_b_dual0: "Hα+OIII", fm_b_sii: "SII+OIII {nm} nm", fm_b_quad: "4 righe: Hβ, OIII, Hα, SII", fm_b_tri: "Hα, Hβ e OIII",
  fm_b_uhc: "UHC: Hβ, OIII e Hα larghi", fm_b_larga: "banda larga contro l'inquinamento luminoso", fm_b_f2: "per ottiche veloci (f/{a}–f/{b})",
  fm_b_ha: "Hα {nm} nm", fm_b_oiii: "OIII {nm} nm", fm_b_sii1: "SII {nm} nm", fm_b_lrgb: "L, R, G, B", fm_b_uvir: "taglia UV e IR", fm_b_irpass: "lascia passare solo l'infrarosso",
  fm_guida: "Quando usare i tuoi filtri",
  fm_g_dual: "nebulose a emissione e resti di supernova, anche con la Luna e in città; non per galassie e ammassi.",
  fm_g_sii: "insieme a un Hα+OIII per la palette Hubble (SHO); da solo va bene soltanto per nebulose ricche di OIII.",
  fm_g_quad: "nebulose a emissione con un cielo medio: stelle più colorate che con un dual band; non per galassie.",
  fm_g_uhc: "nebulose a emissione e planetarie, anche a occhio; meno selettivo di un dual band.",
  fm_g_larga: "galassie, nebulose a riflessione e ammassi con un cielo un po' inquinato; col cielo buio non serve.",
  fm_g_mono: "camera monocromatica: una banda alla volta (SHO, HOO); su una camera a colori lavora solo il canale rosso o verde-blu.",
  fm_g_lrgb: "camera monocromatica: i colori veri di galassie, ammassi e nebulose a riflessione.",
  fm_g_uvir: "stelle più fini con rifrattori e obiettivi, quando la camera non ha già il filtro.", fm_g_irpass: "pianeti e Luna quando il seeing è mediocre.",
  fm_g_solare: "obbligatorio per il Sole.", fm_g_luna: "attenua la luce della Luna all'oculare.", fm_g_hbeta: "a occhio, per la Testa di Cavallo e la California.",
});
Object.assign(TESTI.de, {
  ff_stelle_luce: "Sternhaufen und Doppelsterne sind hell und lassen sich auch bei hellem Himmel mit kurzen Belichtungen gut fotografieren (bei einer Farbkamera hilft ein Breitband-LP-Filter etwas). Kein Schmalband: Es nähme die Sternfarben weg.",
  ff_stelle_buio: "bei dunklem Himmel braucht es nichts weiter: Die Sternfarben bleiben natürlich (bei einer Farbkamera genügt eine UV/IR-Sperre, falls sie nicht schon eine hat).",
  ff_brillante_citta: "unter diesem Himmel geht es trotzdem, weil das Objekt hell ist, aber es braucht viele Stunden Belichtung; unter dunklerem Himmel wird es viel besser.",
  ff_rimanda_citta: "unter diesem Himmel sind Galaxien und schwache Nebel auch mit Filtern kaum zu sehen: lieber ein dunklerer Himmel oder ein Emissionsnebel mit Dualband.",
  luna_lontana_cielo: "Er ist weit genug weg: Hier stört der Himmel des Ortes, nicht der Mond.",
  fm_clip: "Clip-Filter: nur für {m}-Kameras", fm_usa: "✓ Nehmen Sie Ihren {f}", fm_anche: "Geht auch: {f}.", fm_no: "Nicht verwenden: {f}.",
  fm_sho: "Hubble-Palette (SHO): eine Serie mit {s} ({bs}) plus eine mit {h} ({bh}), dann kombinieren.",
  fm_p_debole: "der selektivste, den Sie haben; bei diesem Licht brächte ein Hα+OIII mit 7 nm oder weniger mehr Kontrast",
  fm_a_largo: "breiter: natürlichere Sterne, etwas weniger Kontrast", fm_a_stretto: "schmaler: mehr Kontrast, weniger farbige Sterne",
  fm_p5: "der selektivste, den Sie haben: bei diesem Licht (Himmel und Mond) nötig", fm_p4: "blockt Mond und Lichtverschmutzung gut",
  fm_p3: "guter Kompromiss zwischen Kontrast und Sternfarben", fm_p2: "bei dunklem Himmel reicht das, die Sterne bleiben natürlicher",
  fm_pl: "filtert etwas Lichtverschmutzung heraus, ohne dem Objekt Licht zu nehmen", fm_pl_buio: "bei dunklem Himmel geht es auch ohne",
  fm_pm: "ein Band nach dem anderen: für SHO oder HOO", fm_plrgb: "für echte Farben mit der Monokamera", fm_puv: "blockt nur UV und Infrarot",
  fm_n_larga: "schmalbandig: würde genau das Licht dieses Objekts wegfiltern", fm_n_ha: "ohne Hα", fm_n_debole: "Band zu breit für dieses Licht",
  fm_n_clip: "Clip-Filter für {m}: passt nicht auf Ihre Kamera", fm_n_solo_ha: "nur Hα",
  fm_veloce: "bei f/{n} verschiebt sich das Band und verliert Signal (gebaut für f/{m} oder langsamer)", fm_lento: "ist die Version für schnelle Optiken: bei f/{n} etwas schwächer",
  fm_vignetta: "in 1,25″ vignettiert er am großen Sensor Ihrer Kamera",
  fm_b_dual: "Hα+OIII {nm} nm", fm_b_dual0: "Hα+OIII", fm_b_sii: "SII+OIII {nm} nm", fm_b_quad: "4 Linien: Hβ, OIII, Hα, SII", fm_b_tri: "Hα, Hβ und OIII",
  fm_b_uhc: "UHC: breite Durchlässe für Hβ, OIII und Hα", fm_b_larga: "Breitband gegen Lichtverschmutzung", fm_b_f2: "für schnelle Optiken (f/{a}–f/{b})",
  fm_b_ha: "Hα {nm} nm", fm_b_oiii: "OIII {nm} nm", fm_b_sii1: "SII {nm} nm", fm_b_lrgb: "L, R, G, B", fm_b_uvir: "blockt UV und IR", fm_b_irpass: "lässt nur Infrarot durch",
  fm_guida: "Wann Sie Ihre Filter verwenden",
  fm_g_dual: "Emissionsnebel und Supernova-Überreste, auch bei Mond und in der Stadt; nicht für Galaxien und Sternhaufen.",
  fm_g_sii: "zusammen mit einem Hα+OIII für die Hubble-Palette (SHO); allein nur für OIII-reiche Nebel.",
  fm_g_quad: "Emissionsnebel bei mittlerem Himmel: farbigere Sterne als mit einem Dualband; nicht für Galaxien.",
  fm_g_uhc: "Emissions- und planetarische Nebel, auch visuell; weniger selektiv als ein Dualband.",
  fm_g_larga: "Galaxien, Reflexionsnebel und Sternhaufen bei leicht lichtverschmutztem Himmel; bei dunklem Himmel nicht nötig.",
  fm_g_mono: "Monokamera: ein Band nach dem anderen (SHO, HOO); an einer Farbkamera arbeitet nur der rote bzw. grün-blaue Kanal.",
  fm_g_lrgb: "Monokamera: echte Farben von Galaxien, Sternhaufen und Reflexionsnebeln.",
  fm_g_uvir: "feinere Sterne mit Refraktoren und Objektiven, wenn die Kamera keinen eingebauten UV/IR-Filter hat.", fm_g_irpass: "Planeten und Mond bei mäßigem Seeing.",
  fm_g_solare: "Pflicht für die Sonne.", fm_g_luna: "dämpft das Mondlicht visuell.", fm_g_hbeta: "visuell, für Pferdekopf- und Kaliforniennebel.",
});
Object.assign(TESTI.es, {
  ff_stelle_luce: "los cúmulos y las estrellas dobles son brillantes: se fotografían bien también con cielo claro, con exposiciones cortas (con cámara en color, un filtro antipolución de banda ancha ayuda algo). Nada de banda estrecha: quitaría los colores de las estrellas.",
  ff_stelle_buio: "con cielo oscuro no hace falta nada más: los colores de las estrellas quedan naturales (con cámara en color basta el UV/IR cut, si no lo lleva ya).",
  ff_brillante_citta: "con este cielo se puede fotografiar igualmente porque el objeto es brillante, pero hacen falta muchas horas de exposición; desde un cielo más oscuro rinde mucho más.",
  ff_rimanda_citta: "con este cielo las galaxias y las nebulosas débiles se ven poco incluso con filtros: mejor un cielo más oscuro, o una nebulosa de emisión con dual band.",
  luna_lontana_cielo: "Está bastante lejos: aquí lo que molesta es el cielo del lugar, no la Luna.",
  fm_clip: "de clip: solo para cámaras {m}", fm_usa: "✓ Usa tu {f}", fm_anche: "También vale: {f}.", fm_no: "No uses: {f}.",
  fm_sho: "Paleta Hubble (SHO): una serie con {s} ({bs}) y otra con {h} ({bh}), y luego las unes.",
  fm_p_debole: "el más selectivo que tienes; con esta luz un Hα+OIII de 7 nm o menos daría más contraste",
  fm_a_largo: "más ancho: estrellas más naturales, algo menos de contraste", fm_a_stretto: "más estrecho: más contraste, estrellas menos coloridas",
  fm_p5: "el más selectivo que tienes: con esta luz (cielo y Luna) hace falta", fm_p4: "corta bien la Luna y la contaminación lumínica",
  fm_p3: "buen compromiso entre contraste y colores de las estrellas", fm_p2: "con cielo oscuro basta con este y las estrellas quedan más naturales",
  fm_pl: "quita algo de contaminación lumínica sin quitar la luz del objeto", fm_pl_buio: "con cielo oscuro puedes prescindir de él",
  fm_pm: "una banda cada vez: para SHO o HOO", fm_plrgb: "para los colores reales con la cámara mono", fm_puv: "solo corta UV e infrarrojo",
  fm_n_larga: "banda estrecha: quitaría justo la luz de este objeto", fm_n_ha: "sin Hα", fm_n_debole: "banda demasiado ancha para esta luz",
  fm_n_clip: "de clip para {m}: no se monta en tu cámara", fm_n_solo_ha: "solo Hα",
  fm_veloce: "a f/{n} la banda se desplaza y pierde señal (está hecho para f/{m} o más lento)", fm_lento: "es la versión para ópticas rápidas: a f/{n} rinde algo menos",
  fm_vignetta: "de 1,25″ viñetea en el sensor grande de tu cámara",
  fm_b_dual: "Hα+OIII {nm} nm", fm_b_dual0: "Hα+OIII", fm_b_sii: "SII+OIII {nm} nm", fm_b_quad: "4 líneas: Hβ, OIII, Hα, SII", fm_b_tri: "Hα, Hβ y OIII",
  fm_b_uhc: "UHC: Hβ, OIII y Hα anchos", fm_b_larga: "banda ancha contra la contaminación lumínica", fm_b_f2: "para ópticas rápidas (f/{a}–f/{b})",
  fm_b_ha: "Hα {nm} nm", fm_b_oiii: "OIII {nm} nm", fm_b_sii1: "SII {nm} nm", fm_b_lrgb: "L, R, G, B", fm_b_uvir: "corta UV e IR", fm_b_irpass: "solo deja pasar el infrarrojo",
  fm_guida: "Cuándo usar tus filtros",
  fm_g_dual: "nebulosas de emisión y restos de supernova, también con Luna y en ciudad; no para galaxias ni cúmulos.",
  fm_g_sii: "junto a un Hα+OIII para la paleta Hubble (SHO); por sí solo, únicamente para nebulosas ricas en OIII.",
  fm_g_quad: "nebulosas de emisión con un cielo medio: más color en las estrellas que con un dual band; no para galaxias.",
  fm_g_uhc: "nebulosas de emisión y planetarias, también en visual; menos selectivo que un dual band.",
  fm_g_larga: "galaxias, nebulosas de reflexión y cúmulos con un cielo algo contaminado; con cielo oscuro no hace falta.",
  fm_g_mono: "cámara monocromática: una banda cada vez (SHO, HOO); en una cámara en color solo trabaja el canal rojo o verde-azul.",
  fm_g_lrgb: "cámara monocromática: los colores reales de galaxias, cúmulos y nebulosas de reflexión.",
  fm_g_uvir: "estrellas más finas con refractores y objetivos, si la cámara no tiene ya el filtro.", fm_g_irpass: "planetas y Luna con seeing mediocre.",
  fm_g_solare: "obligatorio para el Sol.", fm_g_luna: "atenúa la luz de la Luna en el ocular.", fm_g_hbeta: "en visual, para la Cabeza de Caballo y la California.",
});
const PROFILI_FILTRO = [
  [/l-?ultimate.*\bf2\b|\bf2\b.*l-?ultimate/i, { b: "ha oiii", nm: 3, fmin: 2, fmax: 3.5 }],
  [/l-?ultimate/i, { b: "ha oiii", nm: 3, fmin: 4 }],
  [/l-?extreme.*\bf2\b|\bf2\b.*l-?extreme/i, { b: "ha oiii", nm: 7, fmin: 2, fmax: 3.5 }],
  [/l-?extreme/i, { b: "ha oiii", nm: 7, fmin: 3 }],
  [/l-?synergy/i, { b: "sii oiii", nm: 7, fmin: 3.3 }],
  [/l-?para\b/i, { b: "ha oiii", nm: 10, fmin: 2 }],
  [/l-?qef|quad.?enhance/i, { b: "ha hb oiii sii", nm: 20, quad: true }],
  [/l-?enhance/i, { b: "ha hb oiii", nm: 10, tri: true }],
  [/alp-?t(?!.*\bs\s?ii\b).*\b3\s?nm/i, { b: "ha oiii", nm: 3 }], [/alp-?t(?!.*\bs\s?ii\b)/i, { b: "ha oiii", nm: 5 }],
  [/alp-?t(?=.*\bs\s?ii\b)(?=.*\bh(b|β|-?beta))/i, { b: "sii hb" }], [/alp-?t.*\bs\s?ii\b/i, { b: "sii oiii" }],
  [/zwo.*(db2|duo.?band)|(db2|duo.?band).*zwo/i, { b: "ha oiii", nm: 15, nmTot: 50 }],
  [/sv\s?220.*\b(set|sho)\b/i, { b: "ha oiii sii", nm: 7 }],
  [/sv\s?220.*\b3\s?nm/i, { b: "ha oiii", nm: 3 }],
  [/sv\s?220.*\bs\s?ii\b|\bs\s?ii\b.*sv\s?220/i, { b: "sii oiii", nm: 7 }],
  [/sv\s?220/i, { b: "ha oiii", nm: 7 }],
  [/sv\s?240/i, { b: "ha hb oiii", nm: 20, tri: true }],
  [/sv\s?260/i, { b: "larga" }],
  [/\buhc\b/i, { b: "ha hb oiii", nm: 30, uhc: true }],
  [/l-?pro\b|\bcls\b|lps-?d\d|lps-?p\d|sky.?glow|neodym/i, { b: "larga" }],
];
const BANDE_DA_TIPO = { dual: "ha oiii", sho: "ha oiii sii", ha: "ha", oiii: "oiii", sii: "sii", hbeta: "hb", uhc: "ha hb oiii", lp: "larga", lrgb: "lrgb",
  uvir: "uvir", irpass: "irpass", luna: "luna", solare: "solare" };
const _profili = new Map();
function nmDalNome(nome) {
  const m = /(\d{1,2}(?:[.,]\d)?)\s*nm\b/i.exec(String(nome || ""));
  const v = m ? parseFloat(m[1].replace(",", ".")) : NaN;
  return v > 0 && v <= 60 ? v : null;
}
const TIPI_STRETTI = new Set(["dual", "sho", "ha", "oiii", "sii", "hbeta"]);
function profiloFiltro(f) {
  const nome = String(f.nome || ""), k = nome + "|" + f.tipo + "|" + (f.nm || "");
  if (_profili.has(k)) return _profili.get(k);
  const voce = PROFILI_FILTRO.find(([re]) => re.test(nome));
  const p = Object.assign({ nm: null }, voce ? voce[1] : { b: BANDE_DA_TIPO[f.tipo] || "larga", uhc: f.tipo === "uhc" });
  p.bande = new Set(p.b.split(" "));
  const noto = typeof filtroNoto === "function" ? filtroNoto(nome) : null;
  const db = !voce && f.tipo !== "solare" && f.tipo !== "luna" ? noto : null;
  if (db && db.bande) {
    p.b = db.bande; p.bande = new Set(db.bande.split(" "));
    if (db.nm) p.nm = db.nm;
    if (db.fmin) p.fmin = db.fmin;
    if (db.fmax) p.fmax = db.fmax;
    p.uhc = f.tipo === "uhc";
    if (!p.uhc && p.bande.has("hb") && p.bande.has("oiii") && p.bande.has("ha")) { if (p.bande.has("sii")) p.quad = true; else p.tri = true; }
  }
  if (!voce && !(db && db.bande) && TIPI_STRETTI.has(f.tipo)) {
    p.nm = f.nm > 0 ? f.nm : nmDalNome(nome);
    if (/\bf\/?2\b|\bfast\b|hyper.?star|\brasa\b/i.test(nome)) { p.fmin = 2; p.fmax = 3.5; }
  }
  if (voce && !p.nm && TIPI_STRETTI.has(f.tipo)) p.nm = f.nm > 0 ? f.nm : nmDalNome(nome);
  const neg = f.h && (DATI.filtri || []).find(x => x.h === f.h);
  const testo = nome + " " + ((neg && neg.misura) || "");
  p.piccolo = /1[.,]25|31[.,]8/.test(testo) && !/\b2\s*(″|"|''|”|pol)/.test(testo);
  const clip = /\bclip\b/i.test(nome) && /(sony|canon|nikon|fuji)/i.exec(nome);
  p.clip = clip ? clip[1] : (noto && noto.clip) || (/\bclip\b/i.test(nome) ? (/\beos\b/i.test(nome) ? "Canon" : /\bnk\b/i.test(nome) ? "Nikon" : null) : null);
  if (f.tipo === "solare") p.sole = solareNonBasta(nome);
  _profili.set(k, p);
  return p;
}
function tipoGiusto(nome, tipo) {
  const voce = PROFILI_FILTRO.find(([re]) => re.test(String(nome || "")));
  if (!voce) return tipo;
  const b = voce[1].b;
  return b === "larga" ? "lp" : voce[1].uhc ? "uhc" : !voce[1].quad && /\bha\b/.test(b) && b.includes("oiii") && b.includes("sii") ? "sho"
    : b.includes("oiii") ? "dual" : tipo;
}
const numFiltro = x => num(x, Math.abs(x - Math.round(x)) < 0.05 ? 0 : 1);
function descriviFiltro(p) {
  const nm = p.nm ? numFiltro(p.nm) : null, f2 = !p.fmax ? "" : " · " + (p.fmin ? t("fm_b_f2", { a: numFiltro(p.fmin), b: numFiltro(p.fmax) })
    : t("fm_b_f2_max", { b: numFiltro(p.fmax) }));
  if (p.bande.has("larga")) return t("fm_b_larga");
  if (p.quad) return t("fm_b_quad");
  if (p.tri) return t("fm_b_tri");
  if (p.uhc) return t("fm_b_uhc");
  if (p.bande.has("lrgb")) return t("fm_b_lrgb");
  if (p.bande.has("uvir")) return t("fm_b_uvir");
  if (p.bande.has("irpass")) return t("fm_b_irpass");
  if (p.bande.has("sii") && p.bande.has("oiii") && !p.bande.has("ha")) return t("fm_b_sii", { nm: nm || "–" }) + f2;
  if (p.bande.has("sii") && p.bande.has("hb") && !p.bande.has("ha")) return (nm ? t("fm_b_siihb", { nm }) : "SII+Hβ") + f2;
  if (p.bande.has("sii") && p.bande.has("ha") && p.bande.has("oiii")) return (nm ? t("fm_b_sho", { nm }) : t("filtro_sho")) + f2;
  if (p.bande.has("ha") && p.bande.has("oiii")) return (nm ? t("fm_b_dual", { nm }) : t("fm_b_dual0")) + f2;
  for (const b of ["ha", "oiii"]) if (p.bande.size === 1 && p.bande.has(b)) return nm ? t("fm_b_" + b, { nm }) : t("filtro_" + b);
  if (p.bande.size === 1 && p.bande.has("sii")) return nm ? t("fm_b_sii1", { nm }) : t("filtro_sii");
  return "";
}
function guidaFiltro(p) {
  if (p.sole) return t("fm_sole_" + p.sole);
  if (p.bande.has("larga")) return t("fm_g_larga");
  if (p.quad || p.tri) return t("fm_g_quad");
  if (p.uhc) return t("fm_g_uhc");
  for (const k of ["lrgb", "uvir", "irpass", "solare", "luna"]) if (p.bande.has(k)) return t("fm_g_" + k);
  if (p.bande.has("hb") && p.bande.size === 1) return t("fm_g_hbeta");
  if (p.bande.has("sii") && p.bande.has("oiii") && !p.bande.has("ha")) return t("fm_g_sii");
  if (p.bande.has("sii") && p.bande.has("hb") && !p.bande.has("ha")) return t("fm_g_siihb");
  if (p.bande.size === 1 || (p.bande.has("sii") && p.bande.has("ha") && p.bande.has("oiii"))) return t("fm_g_mono");
  return t("fm_g_dual");
}
Object.assign(TESTI.it, { fm_b_sho: "Hα, OIII e SII {nm} nm", fm_b_siihb: "SII+Hβ {nm} nm", fm_b_f2_max: "per ottiche veloci (fino a f/{b})",
  fm_g_siihb: "si usa insieme a un Hα+OIII, per aggiungere SII e Hβ alle nebulose a emissione; da solo non basta." });
Object.assign(TESTI.de, { fm_b_sho: "Hα, OIII und SII {nm} nm", fm_b_siihb: "SII+Hβ {nm} nm", fm_b_f2_max: "für schnelle Optiken (bis f/{b})",
  fm_g_siihb: "zusammen mit einem Hα+OIII, um bei Emissionsnebeln SII und Hβ hinzuzufügen; allein reicht er nicht." });
Object.assign(TESTI.es, { fm_b_sho: "Hα, OIII y SII {nm} nm", fm_b_siihb: "SII+Hβ {nm} nm", fm_b_f2_max: "para ópticas rápidas (hasta f/{b})",
  fm_g_siihb: "se usa junto a un Hα+OIII, para añadir SII y Hβ en las nebulosas de emisión; solo no basta." });
Object.assign(TESTI.en, { fm_b_sho: "Hα, OIII and SII {nm} nm", fm_b_siihb: "SII+Hβ {nm} nm", fm_b_f2_max: "for fast optics (up to f/{b})",
  fm_g_siihb: "use it together with an Hα+OIII filter, to add SII and Hβ on emission nebulae; on its own it isn't enough." });
function votoMioFiltro(f, c) {
  const p = profiloFiltro(f), x = c.ctx || {}, d = c.disturbo || 0, o = c.o, note = [];
  const cls = o.t === "pn" ? "pn" : nebEmissione(o) ? "em" : "larga";
  if (p.clip && !(new RegExp(p.clip, "i").test(x.marca || "") && /reflex|mirrorless|dslr/i.test(x.cat || ""))) return { f, p, s: -9, no: t("fm_n_clip", { m: p.clip }) };
  const stretto = !p.bande.has("larga") && !p.bande.has("lrgb") && !p.bande.has("uvir") && !p.bande.has("irpass") && !p.bande.has("luna") && !p.bande.has("solare");
  let s, perche = "", no = "", forza = null;
  if (cls === "larga") {
    if (stretto) return { f, p, s: 0, no: t("fm_n_larga") };
    if (p.bande.has("larga")) { s = x.mono ? 4 : d >= 0.45 ? 8 : 5; perche = t(d >= 0.45 ? "fm_pl" : "fm_pl_buio"); }
    else if (p.bande.has("lrgb")) { s = x.mono ? 8.5 : 1; perche = t("fm_plrgb"); }
    else if (p.bande.has("uvir")) { s = x.mono ? 3 : d >= 0.45 ? 4 : 6; perche = t("fm_puv"); }
    else s = 1;
  } else {
    const riga = cls === "pn" ? "oiii" : "ha";
    if (!stretto && !p.bande.has("larga")) return { f, p, s: 1, no: "" };
    if (!p.bande.has("larga") && !p.bande.has(riga) && !(cls === "pn" && p.bande.has("ha"))) return { f, p, s: 2.5, no: t("fm_n_ha"), sho: p.bande.has("sii") };
    forza = p.bande.has("larga") ? 1.2 : p.uhc ? 2.2 : p.quad ? 2.8 : p.tri ? 3.2 : !p.nm ? 4 : p.nm <= 4 ? 5 : p.nm <= 7 ? 4.3 : p.nm <= 10 ? 3.8 : 3.3;
    const serve = d >= 1 ? 5 : d >= 0.6 ? 4.3 : d >= 0.3 ? 3.8 : 3.2;
    s = 10 - (forza < serve ? (serve - forza) * 2.2 : (forza - serve) * 1.2);
    if (x.mono) {
      if (p.bande.size === 1 && stretto) { s = Math.max(s, 8.5); perche = t("fm_pm"); }
      else if (p.bande.size > 1) s -= 1;
    } else if (p.bande.size === 1 && stretto) { s -= 3; note.push(t("fm_n_solo_ha")); }
    if (cls === "pn" && !p.bande.has("ha") && !p.bande.has("larga")) s -= 1.5;
    if (!perche && forza >= serve - 0.4) perche = t(serve >= 5 ? "fm_p5" : serve >= 4.3 ? "fm_p4" : serve >= 3.8 ? "fm_p3" : "fm_p2");
    if (p.bande.has("larga") && serve >= 4.3) no = t("fm_n_debole");
  }
  const N = x.N, penaVeloce = !p.nm ? 1.5 : p.nm <= 4 ? 4 : p.nm <= 7 ? 3 : 1.5, penaLento = !p.nm ? 0.6 : p.nm <= 4 ? 3 : p.nm <= 7 ? 1.5 : 0.6;
  if (N && p.fmin && N < p.fmin - 0.15) { s -= penaVeloce; note.push(t("fm_veloce", { n: numFiltro(N), m: numFiltro(p.fmin) })); }
  if (N && p.fmax && p.fmax <= 6 && N > p.fmax + 0.5) { s -= penaLento; note.push(t("fm_lento", { n: numFiltro(N) })); }
  if (p.piccolo && x.diag && x.diag > 22) { s -= 2; note.push(t("fm_vignetta")); }
  return { f, p, s, perche, note, no, forza };
}
function sceltaMieiFiltri(c) {
  if (!c.o || c.o.corpo || (c.ctx && c.ctx.modo === "visuale")) return null;
  const nomi = (CAMPO.filtriNomi || []).slice();
  for (const tp of CAMPO.filtri || []) if (!nomi.some(f => f.tipo === tp)) nomi.push({ nome: t("filtro_" + tp), tipo: tp, generico: true });
  if (!nomi.length) return null;
  const voti = nomi.map(f => votoMioFiltro(f, c)).sort((a, b) => b.s - a.s);
  const migliore = voti[0] && voti[0].s >= 4.5 && !voti[0].no ? voti[0] : null;
  const alternative = migliore ? voti.slice(1).filter(v => v.s >= 6 && v.s >= migliore.s - 2.5 && !v.no).slice(0, 2) : [];
  if (migliore && !migliore.perche) migliore.perche = t("fm_p_debole");
  for (const v of alternative) if (v.forza != null && migliore.forza != null && v.forza !== migliore.forza) v.perche = t(v.forza < migliore.forza ? "fm_a_largo" : "fm_a_stretto");
  const conHa = voti.find(v => v.p.bande.has("ha") && v.p.bande.has("oiii") && v.s >= 4.5);
  const sho = c.o.t !== "pn" && nebEmissione(c.o) && conHa && !conHa.p.bande.has("sii") && voti.find(v => v.sho);
  const no = voti.filter(v => v !== migliore && !alternative.includes(v) && v.no && !(sho && v === sho));
  const bande = b => ["ha", "hb", "oiii", "sii"].filter(x => b.has(x)).map(x => ({ ha: "Hα", hb: "Hβ", oiii: "OIII", sii: "SII" })[x]).join("+");
  return { migliore, alternative, no, sho: sho ? { s: sho.f, h: conHa.f, bs: bande(sho.p.bande), bh: bande(conHa.p.bande) } : null };
}
(function () {
  let cambiato = false;
  const tipi = new Set(CAMPO.filtri || []);
  for (const f of CAMPO.filtriNomi || []) {
    const giusto = tipoGiusto(f.nome, f.tipo);
    if (giusto === f.tipo) continue;
    const vecchio = f.tipo;
    f.tipo = giusto; tipi.add(giusto); cambiato = true;
    if (!CAMPO.filtriNomi.some(x => x.tipo === vecchio)) tipi.delete(vecchio);
  }
  if (cambiato) { CAMPO.filtri = FILTRI_TIPI.map(x => x.id).filter(id => tipi.has(id)); salvaCampo(); }
})();
const Luoghi = (() => {
  const url = nome => ((RADICE && RADICE.dataset.citta) || "").replace("ga-citta-0.json", nome);
  let indice = null, luci = null;
  const file = new Map();
  const VUOTE = new Set(("san santa santo sant santi monte villa borgo marina lido porto torre case casale ponte castel castello rocca bad " +
    "sankt st saint sainte puerto la le il lo el los las de di del della").split(" "));
  const piatto = s => normParole(s).replace(/[^a-z0-9 ]+/g, " ").trim();
  function chiaviRiga(r, zona) {
    if (r._k) return r._k;
    const k = [];
    const loc = LOCALI.has(r[0]) ? luogoLeggibile(r[0], r[1], r[2], zona || "").nome : r[0];
    for (const testo of [r[0], ...(loc !== r[0] ? [loc] : []), ...(r[4] ? r[4].split("|") : [])]) {
      const parole = piatto(testo).split(/\s+/).filter(Boolean);
      if (!parole.length) continue;
      k.push(parole.join(""));
      let i = 0;
      while (i < parole.length - 1 && (VUOTE.has(parole[i]) || parole[i].length <= 2)) i++;
      if (i) k.push(parole.slice(i).join(""));
    }
    return (r._k = k);
  }
  const prendi = nome => fetch(url(nome), { credentials: "omit" }).then(r => { if (!r.ok) throw new Error(nome + " " + r.status); return r.json(); });
  function caricaIndice() {
    if (!indice) { indice = prendi("ga-citta-0.json"); indice.catch(() => { indice = null; }); }
    return indice;
  }
  async function cerca(q, max) {
    const k = piatto(q).replace(/\s+/g, "");
    if (k.length < 2) return { voci: [], poche: k.length > 0 };
    const ind = await caricaIndice();
    if (!ind.padri) {
      ind.padri = new Set();
      for (const x of Object.keys(ind.f)) for (let n = 2; n < x.length; n++) ind.padri.add(x.slice(0, n));
    }
    if (ind.padri.has(k)) return { voci: [], poche: true };
    let pref = null;
    for (let n = Math.min(5, k.length); n >= 2; n--) if (ind.f[k.slice(0, n)] != null) { pref = k.slice(0, n); break; }
    if (!pref) return { voci: [], poche: k.length < 4 };
    const nf = ind.f[pref];
    if (!file.has(nf)) { const p = prendi(`ga-citta-${nf}.json`).then(j => j.c); file.set(nf, p); p.catch(() => file.delete(nf)); }
    const righe = await file.get(nf);
    const n = max || 20, gruppi = [[], [], []], leggibile = r => luogoLeggibile(r[0], r[1], r[2], ind.z[r[3]] || "");
    for (const r of righe) {
      const ks = chiaviRiga(r, ind.z[r[3]]);
      let g = ks[0] === k ? 0 : ks.includes(k) ? 1 : ks.some(x => x.startsWith(k)) ? 2 : -1, v = null;
      if (g === 1) { v = leggibile(r); if (piatto(v.nome).replace(/\s+/g, "") === k) g = 0; }
      if (g >= 0 && gruppi[g].length < n) gruppi[g].push(v || leggibile(r));
      if (gruppi[0].length >= n) break;
    }
    return { voci: gruppi.flat().slice(0, n) };
  }
  const NOMI_LOCALI = {
    IT: { Rome: "Roma", Milan: "Milano", Naples: "Napoli", Turin: "Torino", Florence: "Firenze", Venice: "Venezia", Genoa: "Genova",
      Padua: "Padova", Syracuse: "Siracusa", Mantua: "Mantova", Leghorn: "Livorno" },
    DE: { Munich: "München", Cologne: "Köln", Nuremberg: "Nürnberg", Hanover: "Hannover", Brunswick: "Braunschweig" },
    AT: { Vienna: "Wien" }, CH: { Zurich: "Zürich", Geneva: "Genève", Lucerne: "Luzern", Basle: "Basel" },
    ES: { Seville: "Sevilla", Saragossa: "Zaragoza", Corunna: "A Coruña" },
  };
  const LOCALI = new Set(Object.values(NOMI_LOCALI).flatMap(o => Object.keys(o)));
  let nomiPaesi = null;
  function nomePaese(cc) {
    try { if (!nomiPaesi) nomiPaesi = new Intl.DisplayNames([LOCALE], { type: "region" }); return nomiPaesi.of(cc) || cc; } catch (e) { return cc; }
  }
  function luogoLeggibile(nome, lat, lon, zona) {
    const m = /^(.+),\s*([A-Z]{2})$/.exec(zona), sigla = /^[A-Z]{2}$/.test(zona);
    const italia = !m && (zona === "IT" || (sigla && zona !== "SM" && lat > 35 && lat < 47.2 && lon > 6.4 && lon < 18.7));
    const zonaLunga = m ? `${m[1]}, ${nomePaese(m[2])}` : italia ? (zona === "IT" ? nomePaese("IT") : `${zona}, ${nomePaese("IT")}`)
      : sigla ? nomePaese(zona) : zona;
    const locali = NOMI_LOCALI[italia ? "IT" : m ? m[2] : zona] || {};
    return { nome: locali[nome] || nome, lat, lon, zona: zonaLunga };
  }
  const MOD = { a: 0.1778, b: 0.4, c: 0.04, g: 0.25, p: 1.6, raggio: 200, nazioni: { DE: 0.6, ES: 0.6 } };
  function caricaLuci() {
    if (!luci) {
      luci = prendi("ga-luci.json").then(j => {
        const n = j.l.length / 4, lat = new Float32Array(n), lon = new Float32Array(n), pop = new Float32Array(n), f = new Float32Array(n);
        for (let i = 0; i < n; i++) {
          lat[i] = j.l[4 * i] / 100; lon[i] = j.l[4 * i + 1] / 100; pop[i] = j.l[4 * i + 2] * 100;
          f[i] = MOD.nazioni[j.p[j.l[4 * i + 3]]] || 1;
        }
        return { n, lat, lon, pop, f };
      });
      luci.catch(() => { luci = null; });
    }
    return luci;
  }
  const urlBuio = nome => { const b = RADICE && RADICE.dataset.buio; return b ? b.replace("ga-buio.json", nome) : url(nome); };
  const prendiBuio = nome => fetch(urlBuio(nome), { credentials: "omit" }).then(r => { if (!r.ok) throw new Error(nome + " " + r.status); return r.json(); });
  let buioIdx = null;
  const buioTass = new Map();
  function caricaBuio() {
    if (!buioIdx) { buioIdx = prendiBuio("ga-buio.json"); buioIdx.catch(() => { buioIdx = null; }); }
    return buioIdx;
  }
  function tasselloBuio(nome) {
    if (!buioTass.has(nome)) {
      const p = prendiBuio(`ga-buio-${nome}.json`).then(t => {
        const bin = atob(t.d), n = t.n;
        if (t.c === "lorenz") {
          const q = new Uint16Array(n * n);
          for (let i = 0, k = 0; i < n; i++) {
            let v = (bin.charCodeAt(k) << 8) | bin.charCodeAt(k + 1);
            k += 2; q[i * n] = v;
            for (let j = 1; j < n; j++) { const b = bin.charCodeAt(k++); v += b > 127 ? b - 256 : b; q[i * n + j] = v; }
          }
          return { lat: t.lat, lon: t.lon, n, q, lorenz: true };
        }
        const q = new Uint8Array(n * n);
        for (let i = 0; i < n; i++) {
          let v = 0;
          for (let j = 0; j < n; j++) { v = (v + bin.charCodeAt(i * n + j)) & 255; q[i * n + j] = v; }
        }
        return { lat: t.lat, lon: t.lon, n, q, lorenz: false };
      });
      p.catch(() => buioTass.delete(nome));
      buioTass.set(nome, p);
    }
    return buioTass.get(nome);
  }
  async function sqmSatellite(la, lo) {
    const ix = await caricaBuio();
    const [la0, lo0, la1, lo1] = ix.area;
    if (la < la0 || la >= la1 || lo < lo0 || lo >= lo1) return null;
    const nome = `${Math.floor(la / ix.lato) * ix.lato}-${Math.floor(lo / ix.lato) * ix.lato}`;
    if (!ix.tasselli.includes(nome)) return null;
    if (ix.codifica === "lorenz") {
      const [R, C] = cellaLorenz(la, lo);
      const lat0 = Math.floor(((R + 0.5) / 120 - 65) / ix.lato) * ix.lato, lon0 = Math.floor(((C + 0.5) / 120 - 180) / ix.lato) * ix.lato;
      if (!ix.tasselli.includes(`${lat0}-${lon0}`)) return null;
      const t = await tasselloBuio(`${lat0}-${lon0}`);
      const i = clamp(R - Math.round((lat0 + 65) * 120), 0, t.n - 1), j = clamp(C - Math.round((lon0 + 180) * 120), 0, t.n - 1);
      return t.lorenz ? sqmDaLpi(lpiLorenz(t.q[i * t.n + j])) : null;
    }
    const t = await tasselloBuio(nome), n = t.n;
    const fy = (la - t.lat) / ix.passo - 0.5, fx = (lo - t.lon) / ix.passo - 0.5;
    const y0 = clamp(Math.floor(fy), 0, n - 2), x0 = clamp(Math.floor(fx), 0, n - 2);
    const ty = clamp(fy - y0, 0, 1), tx = clamp(fx - x0, 0, 1), q = t.q, i = y0 * n + x0;
    const v = q[i] * (1 - tx) * (1 - ty) + q[i + 1] * tx * (1 - ty) + q[i + n] * (1 - tx) * ty + q[i + n + 1] * tx * ty;
    return (ix.min ?? 16) + v / (ix.scala ?? 40);
  }
  async function stimaCielo(la, lo) {
    const sat = await sqmSatellite(la, lo).catch(() => null);
    if (sat != null) return { sqm: sat, lpi: lpiDaSqm(sat), bortle: bortleDaSqm(sat), fonte: "satellite" };
    return Object.assign(await stimaCitta(la, lo), { fonte: "citta" });
  }
  async function stimaCitta(la, lo) {
    const L = await caricaLuci();
    const cl = Math.cos(la * RAD), R = MOD.raggio, dLat = R / 111.2, dLon = R / (111.2 * Math.max(0.1, cl));
    let s = 0;
    for (let i = 0; i < L.n; i++) {
      const dy = L.lat[i] - la;
      if (dy > dLat || dy < -dLat) continue;
      let dx = L.lon[i] - lo;
      if (dx > 180) dx -= 360; else if (dx < -180) dx += 360;
      if (dx > dLon || dx < -dLon) continue;
      const d = Math.hypot(dx * 111.2 * cl, dy * 111.2);
      if (d > R) continue;
      const r0 = MOD.c * Math.pow(L.pop[i], MOD.g);
      s += L.f[i] * MOD.a * Math.pow(L.pop[i], MOD.b) * (d <= r0 ? 1 : Math.pow(r0 / d, MOD.p));
    }
    const sqm = 22 - 2.5 * Math.log10(1 + s);
    return { sqm, lpi: s, bortle: bortleDaSqm(sqm) };
  }
  let terraP = null, viciniP = null;
  const decodifica = s => Uint8Array.from(atob(s), c => c.charCodeAt(0));
  function caricaTerra() {
    if (!terraP) { terraP = prendiBuio("ga-buio-terra.json").then(d => Object.assign(d, { bit: decodifica(d.d) })); terraP.catch(() => { terraP = null; }); }
    return terraP;
  }
  function caricaVicini() {
    if (!viciniP) { viciniP = prendiBuio("ga-buio-vicini.json").then(d => Object.assign(d, { celle: decodifica(d.d) })); viciniP.catch(() => { viciniP = null; }); }
    return viciniP;
  }
  const eTerra = (T, la, lo) => {
    const i = Math.floor((la - T.lat0) / T.passo), j = Math.floor((lo - T.lon0) / T.passo);
    if (i < 0 || j < 0 || i >= T.nlat || j >= T.nlon) return false;
    const k = i * T.nlon + j;
    return !!((T.bit[k >> 3] >> (k & 7)) & 1);
  };
  function vicinoA(V, la, lo) {
    const i0 = Math.floor((la - V.lat0) / V.passo), j0 = Math.floor((lo - V.lon0) / V.passo);
    for (let r = 0; r <= 2; r++) for (let di = -r; di <= r; di++) for (let dj = -r; dj <= r; dj++) {
      if (Math.max(Math.abs(di), Math.abs(dj)) !== r) continue;
      const i = i0 + di, j = j0 + dj;
      if (i < 0 || j < 0 || i >= V.nlat || j >= V.nlon) continue;
      const k = (i * V.nlon + j) * 2, v = V.celle[k] | (V.celle[k + 1] << 8);
      if (v) return V.nomi[v - 1];
    }
    return "";
  }
  const kmTra = (a, b, c, d) => { const x = (d - b) * Math.cos((a + c) / 2 * RAD), y = c - a; return Math.hypot(x, y) * 111.2; };
  async function cieliBui(la, lo, R) {
    const ix = await caricaBuio(), T = await caricaTerra(), V = await caricaVicini().catch(() => null);
    const dLat = R / 111.2, dLon = R / (111.2 * Math.cos(la * RAD));
    const nomi = new Set();
    for (let a = Math.floor((la - dLat) / ix.lato) * ix.lato; a <= la + dLat; a += ix.lato)
      for (let o = Math.floor((lo - dLon) / ix.lato) * ix.lato; o <= lo + dLon; o += ix.lato) if (ix.tasselli.includes(`${a}-${o}`)) nomi.add(`${a}-${o}`);
    const tass = new Map(await Promise.all([...nomi].map(async n => [n, await tasselloBuio(n)])));
    const sqmDi = (y, x) => {
      const t0 = tass.get(`${Math.floor(y / ix.lato) * ix.lato}-${Math.floor(x / ix.lato) * ix.lato}`);
      if (!t0) return null;
      const i = clamp(Math.floor((y - t0.lat) / ix.passo), 0, t0.n - 1), j = clamp(Math.floor((x - t0.lon) / ix.passo), 0, t0.n - 1);
      const q = t0.q[i * t0.n + j];
      return t0.lorenz ? sqmDaLpi(lpiLorenz(q)) : (ix.min ?? 16) + q / (ix.scala ?? 40);
    };
    const passoKm = R <= 40 ? 1.5 : R <= 80 ? 2.5 : 4, py = passoKm / 111.2, px = passoKm / (111.2 * Math.cos(la * RAD));
    const punti = [];
    for (let y = la - dLat; y <= la + dLat; y += py) for (let x = lo - dLon; x <= lo + dLon; x += px) {
      const km = kmTra(la, lo, y, x);
      if (km > R) continue;
      const terra = eTerra(T, y, x), s = terra ? sqmDi(y, x) : null;
      punti.push({ lat: y, lon: x, sqm: s, terra, km });
    }
    const qui = await sqmSatellite(la, lo).catch(() => null);
    const cand = punti.filter(p => p.sqm != null && (qui == null || p.sqm > qui + 0.15)).sort((a, b) => (b.sqm - 0.004 * b.km) - (a.sqm - 0.004 * a.km));
    const migliori = [], sep = Math.max(6, R / 6);
    for (const p of cand) {
      if (migliori.some(m => kmTra(m.lat, m.lon, p.lat, p.lon) < sep)) continue;
      const az = Astro.n360(Math.atan2((p.lon - lo) * Math.cos(la * RAD), p.lat - la) * DEG);
      migliori.push(Object.assign({}, p, { az, vicino: V ? vicinoA(V, p.lat, p.lon) : "" }));
      if (migliori.length >= 5) break;
    }
    return { punti, migliori, qui, passoKm };
  }
  async function terraferma(punti) {
    const T = await caricaTerra(), V = await caricaVicini().catch(() => null);
    return punti.map(([la, lo]) => {
      const i = Math.floor((la - T.lat0) / T.passo), j = Math.floor((lo - T.lon0) / T.passo);
      return { terra: i >= 0 && j >= 0 && i < T.nlat && j < T.nlon ? eTerra(T, la, lo) : null, vicino: V ? vicinoA(V, la, lo) : "" };
    });
  }
  return { cerca, stimaCielo, caricaIndice, cieliBui, terraferma };
})();
function luogoFrasi(l) {
  l = l || NOTTE.luogo;
  const n = l.nome, gps = l.gps || ["La mia posizione", "Mein Standort", "Mi posición", "My location", t("mia_posizione")].includes(n);
  const punto = !gps && (l.punto || ["it", "de", "es", "en"].some(g => {
    const T = TESTI[g] || {};
    return n === T.posizione_mano || [T.cb_nome, T.cb_nome_senza].some(s => s && String(n || "").startsWith(s.split("{")[0]));
  }));
  const F = {
    it: gps ? ["dalla tua posizione", "della tua posizione", "nella tua posizione", "sopra di te"]
      : punto ? ["dal luogo scelto", "del luogo scelto", "nel luogo scelto", "sopra il luogo scelto"] : [`da ${n}`, `di ${n}`, `a ${n}`, `sopra ${n}`],
    de: gps ? ["von Ihrem Standort", "Ihres Standorts", "an Ihrem Standort", "über Ihnen"]
      : punto ? ["vom gewählten Ort", "des gewählten Orts", "am gewählten Ort", "über dem gewählten Ort"] : [`von ${n}`, `von ${n}`, `in ${n}`, `über ${n}`],
    es: gps ? ["desde tu posición", "de tu posición", "en tu posición", "sobre ti"]
      : punto ? ["desde el lugar elegido", "del lugar elegido", "en el lugar elegido", "sobre el lugar elegido"] : [`desde ${n}`, `de ${n}`, `en ${n}`, `sobre ${n}`],
    en: gps ? ["from your location", "of your location", "at your location", "above you"]
      : punto ? ["from the chosen spot", "of the chosen spot", "at the chosen spot", "above the chosen spot"] : [`from ${n}`, `of ${n}`, `in ${n}`, `above ${n}`],
  }[LINGUA] || [n, n, n, n];
  return { l: n, l_da: F[0], l_di: F[1], l_a: F[2], l_sopra: F[3] };
}
function bortleDaSqm(q) {
  return q >= 21.99 ? 1 : q >= 21.89 ? 2 : q >= 21.69 ? 3 : q >= 20.49 ? 4 : q >= 19.5 ? 5 : q >= 18.94 ? 6 : q >= 18.38 ? 7 : q >= 17.8 ? 8 : 9;
}
const MAPPA_BUIO = "2025-lorenz-2";
const lpiLorenz = c => (5 / 195) * (Math.exp(0.0195 * c) - 1);
function cellaLorenz(la, lo) {
  const ld = ((lo + 180) % 360 + 360) % 360, lf = la + 65, tx = Math.floor(ld / 5) + 1, ty = Math.floor(lf / 5) + 1;
  return [600 * (ty - 1) + Math.round(120 * (lf - 5 * (ty - 1) + 1 / 240)) - 1, 600 * (tx - 1) + Math.round(120 * (ld - 5 * (tx - 1) + 1 / 240)) - 1];
}
const sqmDaLpi = r => 22 - 2.5 * Math.log10(1 + Math.max(0, r));
const lpiDaSqm = s => Math.max(0, Math.pow(10, (22 - s) / 2.5) - 1);
const numLpi = r => r == null || !isFinite(r) ? "–" : num(r, r < 0.1 ? 3 : r < 3 ? 2 : 1);
const CORPI = ["sole", "luna", "mercurio", "venere", "marte", "giove", "saturno", "urano", "nettuno"];
const NOMI_CORPI_EN = { sole: "Sun", luna: "Moon", mercurio: "Mercury", venere: "Venus", marte: "Mars", giove: "Jupiter", saturno: "Saturn",
  urano: "Uranus", nettuno: "Neptune" };
const POLI = { giove: [268.057, 64.495], saturno: [40.589, 83.537] };
function nomeCorpo(c) { return c === "sole" ? t("corpo_sole") : c === "luna" ? t("luna") : t("pianeta_" + c); }
function aJ2000(ra, dec, j) {
  let a = ra, d = dec;
  for (let k = 0; k < 3; k++) {
    const [pa, pd] = Astro.precessa(a, d, j);
    let da = pa - ra;
    if (da > 180) da -= 360; else if (da < -180) da += 360;
    a = Astro.n360(a - da); d -= pd - dec;
  }
  return [a, d];
}
function angoloPosizione(ra1, d1, ra2, d2) {
  const da = (ra2 - ra1) * RAD;
  return Astro.n360(Math.atan2(Math.sin(da) * Math.cos(d2 * RAD),
    Math.cos(d1 * RAD) * Math.sin(d2 * RAD) - Math.sin(d1 * RAD) * Math.cos(d2 * RAD) * Math.cos(da)) * DEG);
}
function posizioneCorpo(c, j) {
  if (c === "sole") { const s = Astro.sole(j); return { ra: s.ra, dec: s.dec, diam: 1919.26 / s.dist, mag: -26.7, k: 1 }; }
  if (c === "luna") {
    const l = Astro.luna(j), f = Astro.faseLuna(j);
    return { ra: l.ra, dec: l.dec, diam: 2 * Math.asin(1737.4 / l.dist) * DEG * 3600, mag: -12.7 + 3.6 * (1 - f.k), k: f.k };
  }
  return Astro.pianeta(c, j);
}
const _corpi = new Map();
function corpoOggetto(c) {
  const b = notteBase(), nt = b.nt, chiave = `${c}|${b.chiave}`;
  if (_corpi.has(chiave)) return _corpi.get(chiave);
  let jBest, hBest = -90;
  if (c === "sole") jBest = Astro.jd(dataNotte());
  else {
    for (let i = 0; i < nt.n; i += 3) {
      if (nt.hSole[i] > -6) continue;
      const p = posizioneCorpo(c, nt.tempi[i]);
      const h = Astro.altezza(p.ra, p.dec, nt.lat, nt.lst[i]);
      if (h > hBest) { hBest = h; jBest = nt.tempi[i]; }
    }
    if (jBest == null) jBest = nt.tempi[Math.floor(nt.n / 2)];
  }
  const p = posizioneCorpo(c, jBest), [ra, dec] = aJ2000(p.ra, p.dec, jBest);
  const s = Astro.sole(jBest), [sra, sdec] = aJ2000(s.ra, s.dec, jBest);
  const o = { id: "@" + c, corpo: c, t: c === "sole" ? "sole" : c === "luna" ? "luna" : "pianeta", ra, dec, alias: [NOMI_CORPI_EN[c]],
    a: p.diam / 60, b: p.diam / 60, pa: null, mag: p.mag, k: p.k, diam: p.diam, quando: Astro.data(jBest), hMax: hBest, nomi: null, top: true,
    chi: angoloPosizione(ra, dec, sra, sdec), c: "" };
  if (POLI[c]) {
    const [pa, pd] = POLI[c];
    o.polo = angoloPosizione(ra, dec, pa, pd);
    o.inclinazione = Math.asin(clamp(-Math.sin(pd * RAD) * Math.sin(dec * RAD) - Math.cos(pd * RAD) * Math.cos(dec * RAD) * Math.cos((pa - ra) * RAD), -1, 1)) * DEG;
  }
  _corpi.set(chiave, o);
  return o;
}
function cercaCorpi(q) {
  const k = norm(q);
  if (!k) return [];
  return CORPI.filter(c => [nomeCorpo(c), NOMI_CORPI_EN[c], c].some(n => norm(n).startsWith(k))).map(corpoOggetto);
}
const COLORI_CORPI = { sole: [255, 236, 190], luna: [222, 222, 214], mercurio: [190, 180, 168], venere: [246, 236, 205], marte: [222, 120, 78],
  giove: [222, 200, 165], saturno: [232, 212, 158], urano: [170, 228, 232], nettuno: [118, 146, 232] };
function disegnaCorpo(c, o, x, y, r, k) {
  const col = COLORI_CORPI[o.corpo] || [230, 230, 230], R = Math.max(r, 2.5 * k);
  const ang = th => Math.atan2(-Math.cos(th * RAD), -Math.sin(th * RAD));
  c.save();
  if (o.corpo === "sole") {
    const g = c.createRadialGradient(x, y, 0, x, y, R * 1.6);
    g.addColorStop(0, "rgba(255,250,235,1)"); g.addColorStop(0.62, "rgba(255,236,190,1)"); g.addColorStop(0.64, "rgba(255,210,140,0.5)");
    g.addColorStop(1, "rgba(255,190,110,0)");
    c.fillStyle = g; c.beginPath(); c.arc(x, y, R * 1.6, 0, 2 * Math.PI); c.fill();
  }
  const anelli = (davanti) => {
    const s = Math.max(0.035, Math.abs(Math.sin(o.inclinazione * RAD))), sud = o.inclinazione > 0;
    const da = davanti === sud ? 0 : Math.PI;
    c.translate(x, y); c.rotate(ang(o.polo) + Math.PI / 2);
    for (const [r1, r2, al] of [[1.53, 1.95, davanti ? 0.95 : 0.8], [2.03, 2.27, davanti ? 0.75 : 0.6]]) {
      c.fillStyle = `rgba(${col.join(",")},${al})`;
      c.beginPath();
      c.ellipse(0, 0, R * r2, Math.max(R * r2 * s, 0.5 * k), 0, da, da + Math.PI);
      c.ellipse(0, 0, R * r1, R * r1 * s, 0, da + Math.PI, da, true);
      c.closePath(); c.fill();
    }
    c.setTransform(1, 0, 0, 1, 0, 0);
  };
  if (o.corpo === "saturno" && o.inclinazione != null) anelli(false);
  c.translate(x, y);
  const schiaccia = { giove: 0.935, saturno: 0.902 }[o.corpo];
  if (schiaccia && o.polo != null) { const a = ang(o.polo) + Math.PI / 2; c.rotate(a); c.scale(1, schiaccia); c.rotate(-a); }
  c.rotate(ang(o.chi));
  c.fillStyle = o.corpo === "luna" ? "rgba(48,52,62,0.95)" : `rgba(${col.map(v => Math.round(v * 0.25)).join(",")},0.9)`;
  c.beginPath(); c.arc(0, 0, R, 0, 2 * Math.PI); c.fill();
  const fase = clamp(o.k == null ? 1 : o.k, 0, 1), e = R * (1 - 2 * fase);
  const g2 = c.createRadialGradient(-R * 0.3, -R * 0.3, 0, 0, 0, R);
  g2.addColorStop(0, `rgb(${col.map(v => Math.min(255, v + 25)).join(",")})`); g2.addColorStop(1, `rgb(${col.map(v => Math.round(v * 0.82)).join(",")})`);
  c.fillStyle = g2;
  c.beginPath(); c.arc(0, 0, R, -Math.PI / 2, Math.PI / 2, false); c.ellipse(0, 0, Math.abs(e), R, 0, Math.PI / 2, -Math.PI / 2, e > 0); c.fill();
  c.setTransform(1, 0, 0, 1, 0, 0);
  if (o.corpo === "giove" && o.polo != null && R > 6 * k) {
    c.save(); c.beginPath(); c.arc(x, y, R, 0, 2 * Math.PI); c.clip();
    c.translate(x, y); c.rotate(ang(o.polo) + Math.PI / 2);
    c.fillStyle = "rgba(150,100,70,0.45)";
    c.fillRect(-R, -R * 0.32, 2 * R, R * 0.16); c.fillRect(-R, R * 0.12, 2 * R, R * 0.16);
    c.restore();
  }
  if (o.corpo === "saturno" && o.inclinazione != null) anelli(true);
  c.restore();
}
Object.assign(TESTI.it, {
  pp_titolo: "Ripresa planetaria", pp_disco: "{n}: {p} px sul sensore", pp_disco_n: "disco {d}", pp_anelli: "anelli {p} px", pp_non_entra: "non entra nel sensore: mosaico di {x} × {y} riprese",
  pp_f_ideale: "Rapporto focale ideale con pixel di {px} µm", pp_f_range: "f/{a} con seeing mediocre · f/{b} con seeing ottimo", pp_ora_f: "ora sei a f/{n}",
  pp_ok: "va bene così", pp_barlow: "con una Barlow di circa {k}× arrivi a f/{n}", pp_troppo: "sei oltre il rapporto focale ideale: togli la Barlow o usane una con fattore più basso",
  pp_roi: "ROI consigliata (ritaglio del sensore)", pp_roi_n: "basta una finestra di {w} × {h} px: la camera va molto più veloce", pp_alto: "Più alto stanotte", pp_opposizione: "Prossima opposizione",
  pp_opposizione_n: "diametro {s}: il più grande dell'anno",
});
Object.assign(TESTI.de, {
  pp_titolo: "Planetenfotografie", pp_disco: "{n}: {p} px auf dem Sensor", pp_disco_n: "Scheibe {d}", pp_anelli: "Ringe {p} px", pp_non_entra: "passt nicht auf den Sensor: Mosaik aus {x} × {y} Aufnahmen",
  pp_f_ideale: "Ideales Öffnungsverhältnis bei {px} µm Pixelgröße", pp_f_range: "f/{a} bei mäßigem Seeing · f/{b} bei sehr gutem Seeing", pp_ora_f: "jetzt f/{n}",
  pp_ok: "passt so", pp_barlow: "mit einer Barlow von etwa {k}× kommen Sie auf f/{n}", pp_troppo: "zu viel: Barlow weglassen oder eine mit kleinerem Faktor nehmen",
  pp_roi: "Empfohlene ROI", pp_roi_n: "ein Fenster von {w} × {h} px reicht: Die Kamera arbeitet dann viel schneller", pp_alto: "Am höchsten heute Nacht", pp_opposizione: "Nächste Opposition",
  pp_opposizione_n: "Durchmesser {s}: der größte des Jahres",
});
Object.assign(TESTI.es, {
  pp_titolo: "Fotografía planetaria", pp_disco: "{n}: {p} px en el sensor", pp_disco_n: "disco {d}", pp_anelli: "anillos {p} px", pp_non_entra: "no cabe en el sensor: mosaico de {x} × {y} tomas",
  pp_f_ideale: "Relación focal ideal con píxeles de {px} µm", pp_f_range: "f/{a} con seeing regular · f/{b} con seeing excelente", pp_ora_f: "ahora estás a f/{n}",
  pp_ok: "así va bien", pp_barlow: "con una Barlow de unos {k}× llegas a f/{n}", pp_troppo: "te pasas: quita la Barlow o usa una de factor más bajo",
  pp_roi: "ROI recomendada", pp_roi_n: "basta una ventana de {w} × {h} px: la cámara va mucho más rápido", pp_alto: "Más alto esta noche", pp_opposizione: "Próxima oposición",
  pp_opposizione_n: "diámetro {s}: el mayor del año",
});
Object.assign(TESTI.it, { pp_smart: "su uno smart telescope la Barlow non si monta: va bene così, i pianeti vengono piccoli",
  pp_lento: "sei oltre anche senza Barlow: va bene lo stesso, l'immagine è solo un po' più buia" });
Object.assign(TESTI.de, { pp_smart: "an einem Smart-Teleskop lässt sich keine Barlow anbringen: so passt es, die Planeten werden klein",
  pp_lento: "auch ohne Barlow zu viel: es geht trotzdem, das Bild ist nur etwas dunkler" });
Object.assign(TESTI.es, { pp_smart: "en un smart telescope no se puede poner una Barlow: así va bien, los planetas salen pequeños",
  pp_lento: "te pasas incluso sin Barlow: vale igual, la imagen solo sale algo más oscura" });
Object.assign(TESTI.en, { pp_smart: "you can't fit a Barlow to a smart telescope: it's fine as it is, the planets come out small",
  pp_lento: "too high even without a Barlow: it still works, the image is just a little dimmer" });
function lonEclittica(ra, dec, j) {
  const e = Astro.obliquita(j) * RAD, a = ra * RAD, d = dec * RAD;
  return Astro.n360(Math.atan2(Math.sin(a) * Math.cos(e) + Math.tan(d) * Math.sin(e), Math.cos(a)) * DEG);
}
Object.assign(TESTI.it, { luna_io: "Io", luna_europa: "Europa", luna_ganimede: "Ganimede", luna_callisto: "Callisto",
  pp_lune: "Lune di Giove", pp_lune_campo: "{n} su 4 nel campo", pp_lune_ora: "alle {o}", pp_est: "E", pp_ovest: "O", pp_davanti: "davanti al disco", pp_dietro: "dietro il disco" });
Object.assign(TESTI.de, { luna_io: "Io", luna_europa: "Europa", luna_ganimede: "Ganymed", luna_callisto: "Kallisto",
  pp_lune: "Jupitermonde", pp_lune_campo: "{n} von 4 im Bildfeld", pp_lune_ora: "um {o} Uhr", pp_est: "O", pp_ovest: "W", pp_davanti: "vor der Scheibe", pp_dietro: "hinter der Scheibe" });
Object.assign(TESTI.es, { luna_io: "Ío", luna_europa: "Europa", luna_ganimede: "Ganímedes", luna_callisto: "Calisto",
  pp_lune: "Lunas de Júpiter", pp_lune_campo: "{n} de 4 en el campo", pp_lune_ora: "a las {o}", pp_est: "E", pp_ovest: "O", pp_davanti: "delante del disco", pp_dietro: "detrás del disco" });
const LUNE_GIOVE = ["io", "europa", "ganimede", "callisto"];
const nomeLunaGiove = n => t("luna_" + n);
function luneGiove(j, polo, diam) {
  const d = j - 2451545.0, s = x => Math.sin(x * RAD), c = x => Math.cos(x * RAD);
  const V = 172.74 + 0.00111588 * d, M = 357.529 + 0.9856003 * d;
  const N = 20.020 + 0.0830853 * d + 0.329 * s(V), J = 66.115 + 0.9025179 * d - 0.329 * s(V);
  const A = 1.915 * s(M) + 0.020 * s(2 * M), B = 5.555 * s(N) + 0.168 * s(2 * N), K = J + A - B;
  const R = 1.00014 - 0.01671 * c(M) - 0.00014 * c(2 * M), r = 5.20872 - 0.25208 * c(N) - 0.00611 * c(2 * N);
  const D = Math.sqrt(r * r + R * R - 2 * r * R * c(K)), psi = Math.asin(R / D * s(K)) * DEG;
  const lam = 34.35 + 0.083091 * d + 0.329 * s(V) + B;
  const De = 3.12 * s(lam + 42.8) - 2.22 * s(psi) * c(lam + 22) - 1.30 * (r - D) / D * s(lam - 100.5);
  const t0 = d - D / 173;
  const u = [163.8069 + 203.4058646 * t0, 358.4140 + 101.2916335 * t0, 5.7176 + 50.2345180 * t0, 224.8092 + 21.4879800 * t0].map(x => x + psi - B);
  const G = 331.18 + 50.310482 * t0, H = 87.45 + 21.569231 * t0;
  const du = [0.473 * s(2 * (u[0] - u[1])), 1.065 * s(2 * (u[1] - u[2])), 0.165 * s(G), 0.843 * s(H)];
  const rr = [5.9057 - 0.0244 * c(2 * (u[0] - u[1])), 9.3966 - 0.0882 * c(2 * (u[1] - u[2])), 14.9883 - 0.0216 * c(G), 26.3627 - 0.1939 * c(H)];
  const raggio = diam / 7200, P = polo * RAD;
  return LUNE_GIOVE.map((nome, i) => {
    const ui = u[i] + du[i], X = rr[i] * s(ui), Y = -rr[i] * c(ui) * s(De);
    const ovest = X * Math.cos(P) - Y * Math.sin(P), nord = X * Math.sin(P) + Y * Math.cos(P);
    return { nome, est: -ovest * raggio, nord: nord * raggio, davanti: c(ui) > 0, sulDisco: X * X + Y * Y / 0.874 < 1 };
  });
}
function rigaLuneGiove(o, r) {
  const lune = luneGiove(Astro.jd(o.quando), o.polo || 0, o.diam), a = -CAMPO.rot * RAD;
  const nelCampo = m => {
    const sx = -m.est, sy = -m.nord, u = sx * Math.cos(a) + sy * Math.sin(a), v = -sx * Math.sin(a) + sy * Math.cos(a);
    return Math.abs(u) <= r.mosW / 2 && Math.abs(v) <= r.mosH / 2;
  };
  const elenco = lune.map(m => `${nomeLunaGiove(m.nome)} ${m.sulDisco ? t(m.davanti ? "pp_davanti" : "pp_dietro")
    : angolo(Math.hypot(m.est, m.nord)) + " " + t(m.est > 0 ? "pp_est" : "pp_ovest")}`);
  return riga(t("pp_lune"), t("pp_lune_campo", { n: lune.filter(nelCampo).length }), `${t("pp_lune_ora", { o: ora(o.quando) })}: ${elenco.join(" · ")}`);
}
const _opposizioni = new Map();
function prossimaOpposizione(c, j) {
  if (!["marte", "giove", "saturno", "urano", "nettuno"].includes(c)) return null;
  const chiave = `${c}|${Math.floor(j)}`;
  if (_opposizioni.has(chiave)) return _opposizioni.get(chiave);
  const elong = x => { const p = Astro.pianeta(c, x); return Astro.n360(lonEclittica(p.ra, p.dec, x) - Astro.sole(x).lon); };
  let risultato = null, prima = elong(j);
  for (let x = j + 2; x < j + 920; x += 2) {
    const adesso = elong(x);
    if (prima > 180 && adesso <= 180 && prima - adesso < 90) {
      let a = x - 2, b = x;
      for (let i = 0; i < 25; i++) { const m = (a + b) / 2; if (elong(m) > 180) a = m; else b = m; }
      const jo = (a + b) / 2;
      risultato = { j: jo, diam: Astro.pianeta(c, jo).diam };
      break;
    }
    prima = adesso;
  }
  _opposizioni.set(chiave, risultato);
  return risultato;
}
function boxPlanetario(o, r) {
  const c = CAMPO.cam, sc = r.scala, diamS = o.diam;
  const dPx = diamS / sc, anelli = o.corpo === "saturno" ? diamS * 2.27 / sc : null;
  const lungo = anelli || dPx;
  const corto = anelli ? Math.max(dPx * 0.9, anelli * Math.abs(Math.sin((o.inclinazione || 0) * RAD))) : dPx;
  const righe = [];
  const nota = [t("pp_disco_n", { d: diamS >= 120 ? angolo(diamS / 3600) : num(diamS, 1) + "″" })];
  if (anelli) nota.push(t("pp_anelli", { p: num(anelli) }));
  if (lungo * 1.05 > Math.max(r.imgW, r.imgH) || corto * 1.05 > Math.min(r.imgW, r.imgH))
    nota.push(t("pp_non_entra", { x: Math.ceil(lungo * 1.1 / Math.max(r.imgW, r.imgH)), y: Math.ceil(corto * 1.1 / Math.min(r.imgW, r.imgH)) }));
  righe.push(riga(t("immagine"), t("pp_disco", { n: nomeCorpo(o.corpo), p: num(dPx) }), nota.join(" · ")));
  const px = c.px * CAMPO.bin, ideale = 5 * px, nTel = CAMPO.tel.F / CAMPO.tel.D, nOra = r.N;
  let consiglio, kServe = null;
  if (nOra >= 3.5 * px && nOra <= 7 * px) consiglio = t("pp_ok");
  else if (nOra < 3.5 * px && CAMPO.tel.smart) consiglio = t("pp_smart");
  else if (nOra < 3.5 * px) {
    kServe = Math.max(1.5, Math.round(ideale / nTel * 2) / 2);
    consiglio = t("pp_barlow", { k: num(kServe, kServe % 1 ? 1 : 0), n: num(nTel * kServe, 1) });
  } else consiglio = t(CAMPO.k > 1 && !CAMPO.tel.smart ? "pp_troppo" : "pp_lento");
  righe.push(riga(t("pp_f_ideale", { px: num(px, 2) }), `f/${num(ideale, 1)}`,
    `${t("pp_f_range", { a: num(3.5 * px, 1), b: num(7 * px, 1) })} · ${t("pp_ora_f", { n: num(nOra, 1) })}: ${consiglio}`));
  const ROI = [[320, 240], [640, 480], [800, 600], [1024, 768], [1280, 960], [1920, 1080]];
  const roi = ROI.find(([w, h]) => w >= lungo * 1.5 && h >= corto * 1.5 && w <= Math.max(r.imgW, r.imgH) && h <= Math.min(r.imgW, r.imgH));
  if (roi && roi[0] * roi[1] < r.imgW * r.imgH * 0.6) righe.push(riga(t("pp_roi"), `${roi[0]} × ${roi[1]} px`, t("pp_roi_n", { w: roi[0], h: roi[1] })));
  if (o.corpo === "giove" && o.quando) righe.push(rigaLuneGiove(o, r));
  if (o.corpo !== "sole" && o.hMax > -90) righe.push(riga(t("pp_alto"), `${ora(o.quando)} · ${num(o.hMax)}°`, giorno(o.quando)));
  const opp = prossimaOpposizione(o.corpo, Astro.jd(new Date()));
  if (opp) righe.push(riga(t("pp_opposizione"), giorno(Astro.data(opp.j), true), t("pp_opposizione_n", { s: num(opp.diam, 1) + "″" })));
  const box = el("div", { class: "gas-pp" }, el("h4", null, "🪐 ", t("pp_titolo")), el("div", { class: "gas-righe" }, righe));
  if (kServe) { const neg = barlowNegozio(kServe); if (neg) box.appendChild(neg); }
  return box;
}
Object.assign(TESTI.it, {
  cm_titolo: "Cosa ti serve per fotografare {o}", cm_tel: "Telescopi del negozio adatti alla tua camera", cm_tel_aps: "Telescopi del negozio adatti a una camera APS-C",
  cm_cam: "Camere del negozio adatte al tuo telescopio", cm_riempie: "{o}: {p} % del campo", cm_prova: "Prova", cm_vedi: "Vedi",
  cm_nessuno: "Nessun prodotto adatto disponibile adesso.", cm_nota: "In verde: l'oggetto riempie tra il 30 e l'80 % del campo, quindi entra intero con un po' di cielo intorno.",
  cm_carico: "Cerco nel negozio…", cm_aps: "APS-C (23,5 × 15,6 mm)", cm_cosa_serve: "Cosa mi serve?",
});
Object.assign(TESTI.de, {
  cm_titolo: "Was Sie brauchen, um {o} zu fotografieren", cm_tel: "Teleskope aus dem Shop für Ihre Kamera", cm_tel_aps: "Teleskope aus dem Shop für eine APS-C-Kamera",
  cm_cam: "Kameras aus dem Shop für Ihr Teleskop", cm_riempie: "{o}: {p} % des Bildfelds", cm_prova: "Ausprobieren", cm_vedi: "Ansehen",
  cm_nessuno: "Gerade kein passendes Produkt verfügbar.", cm_nota: "In Grün: Das Objekt füllt 30 bis 80 % des Bildfelds, passt also ganz hinein, mit etwas Himmel rundherum.",
  cm_carico: "Shop wird durchsucht…", cm_aps: "APS-C (23,5 × 15,6 mm)", cm_cosa_serve: "Was brauche ich?",
});
Object.assign(TESTI.es, {
  cm_titolo: "Qué necesitas para fotografiar {o}", cm_tel: "Telescopios de la tienda adecuados a tu cámara", cm_tel_aps: "Telescopios de la tienda adecuados a una cámara APS-C",
  cm_cam: "Cámaras de la tienda adecuadas a tu telescopio", cm_riempie: "{o}: {p} % del campo", cm_prova: "Probar", cm_vedi: "Ver",
  cm_nessuno: "Ahora no hay un producto adecuado disponible.", cm_nota: "En verde: el objeto llena entre el 30 y el 80 % del campo, así que entra entero con algo de cielo alrededor.",
  cm_carico: "Buscando en la tienda…", cm_aps: "APS-C (23,5 × 15,6 mm)", cm_cosa_serve: "¿Qué necesito?",
});
function riempieCon(o, Lmm, Smm, F) {
  const a = misuraOggetto(o), b = o.b || a;
  const L = 2 * Math.atan(Lmm / 2 / F) * DEG * 60, S = 2 * Math.atan(Smm / 2 / F) * DEG * 60;
  return Math.max(a / L, b / S);
}
const distanzaRiempimento = f => (f >= 0.3 && f <= 0.8 ? Math.abs(Math.log(f / 0.55)) : f < 0.3 ? 1 + Math.log(0.3 / f) : 1 + Math.log(f / 0.8));
function boxConsigliProdotti(o, dopo) {
  const box = el("div", { class: "gas-cm" });
  const cam = CAMPO.cam && CAMPO.cam.w && CAMPO.cam.px ? CAMPO.cam : null;
  const Lc = cam ? Math.max(cam.w, cam.h) * cam.px / 1000 : 23.5, Sc = cam ? Math.min(cam.w, cam.h) * cam.px / 1000 : 15.6;
  const NO_FOTO = /\bAZ|Startravel|AstroMaster|PowerSeeker|FirstScope|Firstlight|StarSense|Heritage|Virtuoso|NexStar|Evolution|\bEQ-?[12]\b/i;
  const tel = DATI.telescopi.filter(x => x.h && x.F && x.D && !/^(smart|solare|dobson|guida)$/.test(x.tipo || "") && !NO_FOTO.test(x.t))
    .map(x => ({ x, f: riempieCon(o, Lc, Sc, x.F) })).sort((p, q) => distanzaRiempimento(p.f) - distanzaRiempimento(q.f));
  const r = calcoloCampo(), cams = [];
  if (r && r.F && !(CAMPO.tel && CAMPO.tel.smart)) {
    const viste = new Set();
    for (const c of DATI.camere) {
      if (!c.h_negozio || c.cat === "smart" || !c.w || !c.px || viste.has(c.h_negozio)) continue;
      viste.add(c.h_negozio);
      cams.push({ c, f: riempieCon(o, Math.max(c.w, c.h) * c.px / 1000, Math.min(c.w, c.h) * c.px / 1000, r.F) });
    }
    cams.sort((p, q) => distanzaRiempimento(p.f) - distanzaRiempimento(q.f));
  }
  const nome = titoloOggetto(o).split(" – ")[0];
  box.append(el("h4", null, icona("carrello"), " ", t("cm_titolo", { o: nome })));
  const colonna = (titolo, voci, crea) => {
    const lista = el("div", { class: "gas-cm-lista" }, el("p", { class: "gas-muto gas-cm-carico" }, t("cm_carico")));
    box.append(el("div", { class: "gas-cm-gruppo" }, el("h5", null, titolo), lista));
    Promise.all(voci.slice(0, 10).map(v => prodotto(v.h).then(p => ({ v, p })))).then(ris => {
      if (!lista.isConnected) return;
      const buoni = [], visti = new Set();
      for (const { v, p } of ris) {
        if (!p || !p.available || visti.has(v.h)) continue;
        visti.add(v.h); buoni.push({ v, p });
        if (buoni.length === 3) break;
      }
      svuota(lista).append(...(buoni.length ? buoni.map(({ v, p }) => crea(v, p)) : [el("p", { class: "gas-muto" }, t("cm_nessuno"))]));
    });
  };
  const foto = (v, p) => {
    const src = p.featured_image ? p.featured_image + (p.featured_image.includes("?") ? "&" : "?") + "width=160" : v.foto;
    return src ? el("img", { src, alt: "", width: 64, height: 64, loading: "lazy" })
      : el("span", { class: "gas-cm-senza" }, icona(v.c ? "camere" : "campo"));
  };
  const carta = (v, p, prova) => el("div", { class: "gas-cm-carta" },
    foto(v, p),
    el("div", { class: "gas-cm-testo" },
      el("b", null, p.title),
      el("span", { class: "gas-cm-riempie" + (v.f >= 0.3 && v.f <= 0.8 ? " ok" : "") }, t("cm_riempie", { o: nome, p: num(Math.min(v.f, 9.99) * 100) })),
      el("span", { class: "gas-cm-prezzo" }, euro(p.price))),
    el("div", { class: "gas-cm-bottoni" },
      el("button", { type: "button", class: "gas-btn gas-btn--mini", onclick: prova }, t("cm_prova")),
      el("a", { class: "gas-btn gas-btn--chiaro gas-btn--mini", href: urlProdotto(v.h), target: "_blank", rel: "noopener" }, t("cm_vedi"))));
  colonna(cam ? t("cm_tel") : t("cm_tel_aps"), tel.map(({ x, f }) => ({ h: x.h, foto: x.foto, f, x })),
    (v, p) => carta(v, p, () => { scegliTelescopio(v.x); dopo(); }));
  if (cams.length) colonna(t("cm_cam"), cams.map(({ c, f }) => ({ h: c.h_negozio, foto: c.foto, f, c })),
    (v, p) => carta(v, p, () => { scegliCamera(v.c); dopo(); }));
  box.append(el("p", { class: "gas-nota" }, t("cm_nota")));
  return box;
}
Object.assign(TESTI.it, {
  tp_titolo: "Quanto tempo di posa serve", tp_buona: "Foto buona", tp_ottima: "Foto ottima", tp_sub: "Posa singola",
  tp_npose: "circa {n} pose per la foto buona", tp_con: "col tuo {f}", tp_con_tipo: "con un {f}", tp_senza: "Senza filtro", tp_buio: "Da un cielo buio (SQM {s})",
  tp_oltre: "oltre 100 h", tp_n: "Stima per la luminosità media di {o} col tuo setup, il cielo {l_di} (SQM {s}) e la Luna di stanotte: per il nucleo basta meno tempo, per le parti deboli ne serve di più. Margine di errore ±50 %: contano anche seeing, trasparenza ed elaborazione.",
  tp_stelle: "Ammassi e stelle doppie: bastano pose brevi (10–60 s) per non saturare le stelle; dopo 30–60 minuti il fondo è già pulito.",
  tp_manca: "Scegli telescopio e camera per la stima del tempo di posa.", tp_scuro: "Nebulosa oscura: si vede solo come ombra sul fondo stellato e servono un cielo molto buio e molte ore.",
});
Object.assign(TESTI.de, {
  tp_titolo: "Wie viel Belichtungszeit nötig ist", tp_buona: "Gutes Foto", tp_ottima: "Sehr gutes Foto", tp_sub: "Einzelbelichtung",
  tp_npose: "etwa {n} Aufnahmen für das gute Foto", tp_con: "mit Ihrem {f}", tp_con_tipo: "mit einem {f}", tp_senza: "Ohne Filter", tp_buio: "Unter dunklem Himmel (SQM {s})",
  tp_oltre: "über 100 h", tp_n: "Schätzung für die mittlere Helligkeit von {o} mit Ihrem Setup, dem Himmel {l_di} (SQM {s}) und dem Mond heute Nacht: Für den Kern genügt weniger Zeit, für die schwachen Bereiche ist mehr nötig. Fehlerspanne ±50 %: Auch Seeing, Transparenz und Bearbeitung spielen eine Rolle.",
  tp_stelle: "Sternhaufen und Doppelsterne: Kurze Belichtungen (10–60 s) genügen, damit die Sterne nicht sättigen; nach 30–60 Minuten ist der Hintergrund schon sauber.",
  tp_manca: "Wählen Sie Teleskop und Kamera für die Schätzung der Belichtungszeit.", tp_scuro: "Dunkelnebel: nur als Schatten vor dem Sternhintergrund sichtbar, braucht sehr dunklen Himmel und viele Stunden.",
});
Object.assign(TESTI.es, {
  tp_titolo: "Cuánto tiempo de exposición hace falta", tp_buona: "Foto buena", tp_ottima: "Foto excelente", tp_sub: "Toma individual",
  tp_npose: "unas {n} tomas para la foto buena", tp_con: "con tu {f}", tp_con_tipo: "con un {f}", tp_senza: "Sin filtro", tp_buio: "Desde un cielo oscuro (SQM {s})",
  tp_oltre: "más de 100 h", tp_n: "Estimación para el brillo medio de {o} con tu equipo, el cielo {l_di} (SQM {s}) y la Luna de esta noche: para el núcleo basta menos tiempo; para las partes débiles hace falta más. Margen de error ±50 %: también cuentan el seeing, la transparencia y el procesado.",
  tp_stelle: "Cúmulos y estrellas dobles: bastan tomas cortas (10–60 s) para no saturar las estrellas; tras 30–60 minutos el fondo ya está limpio.",
  tp_manca: "Elige telescopio y cámara para estimar el tiempo de exposición.", tp_scuro: "Nebulosa oscura: solo se ve como una sombra sobre el fondo estelar y necesita un cielo muy oscuro y muchas horas.",
});
Object.assign(TESTI.it, { tp_tua: "La tua posa singola", tp_consigliata: "Consigliata ({s})",
  tp_lunghe: "Dal tuo cielo bastano pose da {s}: più lunghe vanno bene, conta il tempo totale. Con pose lunghe le stelle più brillanti si saturano prima.",
  tp_corte: "Con pose più corte di {s} il rumore della camera pesa: serve più tempo in totale." });
Object.assign(TESTI.de, { tp_tua: "Ihre Einzelbelichtung", tp_consigliata: "Empfohlen ({s})",
  tp_lunghe: "Unter Ihrem Himmel genügen Einzelbelichtungen von {s}: Längere sind in Ordnung, es zählt die Gesamtzeit. Bei langen Belichtungen sättigen die hellsten Sterne früher.",
  tp_corte: "Mit Einzelbelichtungen unter {s} fällt das Kamerarauschen ins Gewicht: Dann ist mehr Gesamtzeit nötig." });
Object.assign(TESTI.es, { tp_tua: "Tu toma individual", tp_consigliata: "Recomendada ({s})",
  tp_lunghe: "Desde tu cielo bastan tomas de {s}: más largas están bien, cuenta el tiempo total. Con tomas largas las estrellas más brillantes se saturan antes.",
  tp_corte: "Con tomas más cortas de {s} el ruido de la cámara pesa: hace falta más tiempo total." });
Object.assign(TESTI.en, { tp_tua: "Your single exposure", tp_consigliata: "Recommended ({s})",
  tp_lunghe: "From your sky, {s} exposures are enough: longer ones are fine, as the total time is what counts. With long exposures the brightest stars saturate sooner.",
  tp_corte: "With exposures shorter than {s} the camera noise matters: you need more total time." });
Object.assign(TESTI.it, { tp_npose_1: "basta {n} posa per la foto buona" });
Object.assign(TESTI.de, { tp_npose_1: "{n} Aufnahme reicht für das gute Foto" });
Object.assign(TESTI.es, { tp_npose_1: "basta {n} toma para la foto buena" });
Object.assign(TESTI.en, { tp_npose_1: "{n} sub-exposure is enough for a good image" });
const TP_POSE = [30, 60, 120, 180, 300, 600, 900, 1200];
const posaLeggibile = s => (s < 60 ? `${s} s` : `${num(s / 60, s % 60 ? 1 : 0)} min`);
const FOTONI_0 = 3.0e10;
const SENSORI = { IMX571: [0.8, 1.5], IMX455: [0.8, 1.5], IMX533: [0.8, 1.5], IMX294: [0.75, 1.8], IMX585: [0.9, 1.0], IMX462: [0.8, 1.0],
  IMX662: [0.9, 0.8], IMX678: [0.83, 1.0], IMX290: [0.8, 1.0], IMX183: [0.84, 2.0], IMX178: [0.8, 1.4], IMX174: [0.77, 3.5], IMX224: [0.75, 1.5],
  IMX492: [0.75, 1.8], IMX410: [0.8, 1.5], IMX432: [0.79, 2.4], IMX428: [0.75, 2.0], IMX461: [0.8, 1.5], IMX411: [0.8, 1.5], IMX715: [0.8, 1.0],
  IMX664: [0.83, 1.0], IMX676: [0.8, 1.0], IMX482: [0.85, 1.0], IMX485: [0.85, 1.0], IMX464: [0.85, 1.0], IMX253: [0.7, 2.5], IMX304: [0.7, 2.5],
  MN34230: [0.6, 1.5], "KAF-8300": [0.55, 7], "KAF-16200": [0.6, 9], "KAI-11002": [0.5, 11], AR0130: [0.6, 3.5] };
const MU_TIPICA = { en: 23.5, cn: 23.5, snr: 24.5, pn: 20, rn: 23, gx: 22.5, gxg: 23, gxcl: 23, neb: 24, reg: 24.5 };
const SQM_DA_BORTLE = [null, 22.0, 21.94, 21.79, 21.1, 20.0, 19.2, 18.66, 18.1, 17.5];
function datiCameraPosa(cam) {
  const c = cam && cam.id ? DATI.perCamera.get(cam.id) : null, s = String((c && c.sensore) || (cam && cam.sensore) || "");
  const m = /(IMX\d{3}|MN34230|KAF-\d+|KAI-\d+|AR0130)/i.exec(s), sens = m ? SENSORI[m[1].toUpperCase()] : null;
  const cat = (c && c.cat) || "", foto = /reflex|mirrorless|medio_formato/.test(cat), smart = cat === "smart";
  const qe = sens ? sens[0] : foto ? 0.5 : 0.7, rn = sens ? sens[1] : foto ? 2.5 : 2;
  const colore = !(c && c.col === "mono");
  return { qe, rn, colore, eff: qe * (colore ? 0.33 : 0.85), buio: c && c.raff ? 0.003 : foto ? 0.1 : 0.04, posaMax: smart ? 10 : foto ? 180 : 300, smart };
}
function tipoTelescopio(tel) {
  if (!tel || !tel.h) return null;
  const l = (DATI.telescopi || []).filter(z => z.h === tel.h), x = l.find(z => z.F === tel.F) || l[0];
  return x ? x.tipo : null;
}
const tipoOttica = tel => { const x = tipoTelescopio(tel); return x && x !== "smart" && x !== "altro" ? x : null; };
const TIPI_SPECCHIO = ["newton", "dobson", "sc", "mak", "rc", "coassiale", "dk"];
function areaUtile(tel, D) {
  const n = String((tel && tel.nome) || ""), tipo = tipoOttica(tel);
  const rifl = tipo ? TIPI_SPECCHIO.includes(tipo) : /newton|riflettore|dobson|\brc\b|ritchey|schmidt|cassegrain|maksutov|\bmak\b|rasa|dall|\bsc\b|rcn8/i.test(n);
  const ost = rifl ? ((tipo ? tipo === "rc" : /\brc\b|ritchey/i.test(n)) ? 0.42 : 0.33) : 0, tr = rifl ? 0.8 : 0.9;
  return Math.PI / 4 * Math.pow(D / 1000, 2) * (1 - ost * ost) * tr;
}
function muOggetto(o) {
  const a = (o.a || misuraOggetto(o)) * 60, b = (o.b || o.a || misuraOggetto(o)) * 60;
  const mu = o.mag != null && o.a ? o.mag + 2.5 * Math.log10(Math.PI / 4 * a * b) : null;
  const tipica = MU_TIPICA[o.t];
  if (mu == null || ((o.t === "en" || o.t === "cn") && (mu < 19 || mu > 25))) return tipica || 23.5;
  return mu;
}
function passaFiltro(p, o) {
  const righe = nebEmissione(o) || o.t === "pn", kRiga = o.t === "pn" ? 1.2 : 1.5;
  if (!p) return { ro: 1, rs: 1, rm: 1 };
  if (p.bande.has("larga")) return { ro: 0.85, rs: 0.6, rm: 0.85 };
  if (p.bande.has("lrgb") || p.bande.has("uvir")) return { ro: 0.95, rs: 0.95, rm: 0.95 };
  const largo = p.uhc ? 90 : p.quad ? 80 : p.tri ? 34 : p.nmTot || (p.nm || 7) * (p.bande.has("ha") && p.bande.has("oiii") ? 2 : 1);
  const fondo = Math.min(1, largo / 300);
  let ro;
  if (!righe) ro = fondo * 0.9;
  else if (p.bande.has("ha") && p.bande.has("oiii")) ro = kRiga * (p.quad || p.tri || p.uhc ? 0.95 : 0.9);
  else if (p.bande.has("sii") && p.bande.has("oiii")) ro = kRiga * 0.35;
  else if (p.bande.has("ha")) ro = kRiga * 0.6;
  else if (p.bande.has("oiii")) ro = kRiga * (o.t === "pn" ? 0.6 : 0.3);
  else ro = kRiga * 0.2;
  return { ro, rs: fondo, rm: fondo };
}
function stimaPosa(x) {
  const c = datiCameraPosa(x.cam), A = areaUtile(x.tel, x.D), px2 = x.scala * x.scala, f = passaFiltro(x.filtro, x.o);
  const fotoni = mu => FOTONI_0 * Math.pow(10, -0.4 * mu) * A * px2;
  const L = x.luna || { k: 0, su: 0, sep: 180 };
  const vic = L.sep < 30 ? 3 : L.sep < 60 ? 1.6 : L.sep < 90 ? 1 : L.sep < 120 ? 0.7 : 0.5;
  const S = fotoni(muOggetto(x.o)) * c.eff * f.ro;
  const B = (fotoni(x.sqm) * f.rs + fotoni(19.1) * Math.pow(L.k, 3) * vic * L.su * f.rm) * c.eff;
  const tSubConsigliata = Math.round(clamp(10 * c.rn * c.rn / Math.max(B, 1e-6), c.smart ? 10 : 30, c.posaMax) / 5) * 5 || 10;
  const tSub = x.tSub > 0 && !c.smart ? x.tSub : tSubConsigliata;
  const n = Math.max(1, Math.pow(2 / x.scala, 2));
  const ore = Q => Q * Q * (S + B + c.buio + c.rn * c.rn / tSub) / (n * S * S) / 3600;
  return { tBuona: ore(10), tOttima: ore(20), tSub, tSubConsigliata, S, B };
}
const oreLeggibili = h => (h > 100 ? t("tp_oltre") : durata(Math.max(h, 1 / 60)));
function boxTempoPosa(o, luna) {
  const r = calcoloCampo();
  if (o.corpo || CAMPO.modo !== "foto") return null;
  const box = el("div", { class: "gas-tp" }, el("h4", null, "⏱ ", t("tp_titolo")));
  if (senzaInseguimento(CAMPO.tel)) box.appendChild(el("p", { class: "gas-giudizio gas-giudizio--poco_sotto" }, t("dob_tp")));
  if (!r || !r.scala || !CAMPO.cam) { box.appendChild(el("p", { class: "gas-muto" }, t("tp_manca"))); return box; }
  if (["oc", "gc", "sc", "ds"].includes(o.t)) { box.appendChild(el("p", { class: "gas-nota" }, t("tp_stelle"))); return box; }
  if (o.t === "dn") box.appendChild(el("p", { class: "gas-nota" }, t("tp_scuro")));
  const sqm = sqmLuogo(), smart = datiCameraPosa(CAMPO.cam).smart;
  const mia = smart ? 0 : ricorda("tp_sub", 0), L = luna || lunaPer(o), base = { o, tel: CAMPO.tel, D: r.D, scala: r.scala, cam: CAMPO.cam, sqm, luna: L, tSub: mia };
  const cf = consiglioFiltro(o, contestoFiltro(o, L)), sc = sceltaMieiFiltri(cf);
  const mio = sc && sc.migliore && cf.tipo !== "rimanda" && cf.tipo !== "nessuno" ? sc.migliore : null;
  const tipoConsigliato = !mio && !["nessuno", "rimanda"].includes(cf.tipo) ? { nome: nomeFiltro(cf.tipo), tipo: cf.tipo } : null;
  const filtro = mio ? mio.p : tipoConsigliato ? profiloFiltro(tipoConsigliato) : null;
  const stima = stimaPosa(Object.assign({ filtro }, base));
  const etichetta = mio ? t("tp_con", { f: nomeCorto(mio.f.nome) }) : tipoConsigliato ? t("tp_con_tipo", { f: tipoConsigliato.nome }) : t("tp_senza");
  box.append(el("p", { class: "gas-tp-filtro" }, etichetta),
    el("div", { class: "gas-numeri gas-numeri--tre" },
      cifra(t("tp_buona"), oreLeggibili(stima.tBuona), "SNR 10"),
      cifra(t("tp_ottima"), oreLeggibili(stima.tOttima), "SNR 20"),
      cifra(t("tp_sub"), posaLeggibile(stima.tSub), t("tp_npose", { n: num(Math.ceil(stima.tBuona * 3600 / stima.tSub)) }))));
  const scelta = selezione([[0, t("tp_consigliata", { s: posaLeggibile(stima.tSubConsigliata) })], ...TP_POSE.map(v => [v, posaLeggibile(v)])], mia,
    v => { salva("tp_sub", +v); box.replaceWith(boxTempoPosa(o, luna)); });
  aggiungi(box, [smart ? null : el("div", { class: "gas-tp-mia" }, el("label", { class: "gas-campo" }, el("span", null, t("tp_tua")), scelta)),
    mia && mia !== stima.tSubConsigliata ? el("p", { class: "gas-nota" }, t(mia > stima.tSubConsigliata ? "tp_lunghe" : "tp_corte", { s: posaLeggibile(stima.tSubConsigliata) })) : null]);
  const righe = [];
  if (filtro) righe.push(riga(t("tp_senza"), oreLeggibili(stimaPosa(Object.assign({ filtro: null }, base)).tBuona), t("tp_buona")));
  if (sqm < 21.3) righe.push(riga(t("tp_buio", { s: num(21.5, 1) }), oreLeggibili(stimaPosa(Object.assign({}, base, { filtro, sqm: 21.5 })).tBuona), `${etichetta} · ${t("tp_buona")}`));
  if (righe.length) box.appendChild(el("div", { class: "gas-righe" }, righe));
  box.appendChild(el("p", { class: "gas-nota" }, t("tp_n", Object.assign(luogoFrasi(), { o: titoloOggetto(o).split(" – ")[0], s: num(sqm, 1) }))));
  return box;
}
Object.assign(TESTI.it, {
  dob_n: "Il tuo Dobson non è motorizzato e non segue il cielo. Per nebulose e galassie servono pose lunghe, quindi una montatura che insegue: sul Dobson, con questa focale e questa camera, le stelle restano puntiformi solo per circa {s} secondi.",
  dob_corpo: "Il tuo Dobson non segue il cielo, ma per la Luna e i pianeti va bene: si riprendono in video, con pose brevissime, rimettendo l'oggetto al centro ogni tanto.",
  dob_stanotte: "Il tuo Dobson non segue il cielo: per fotografare stanotte scegli la Luna e i pianeti, oppure guarda tutto il resto all'oculare (Osservazione visuale).",
  dob_montatura: "Montature che inseguono →", dob_titolo: "Senza inseguimento",
  dob_tp: "Con il tuo Dobson senza motori queste pose non si possono fare: i numeri valgono con una montatura che insegue." });
Object.assign(TESTI.de, {
  dob_n: "Ihr Dobson ist nicht motorisiert und folgt dem Himmel nicht. Für Nebel und Galaxien braucht es lange Belichtungen, also eine nachführende Montierung. Auf dem Dobson bleiben die Sterne mit dieser Brennweite und dieser Kamera nur etwa {s} Sekunden punktförmig.",
  dob_corpo: "Ihr Dobson folgt dem Himmel nicht, für Mond und Planeten reicht er aber: Man filmt sie mit sehr kurzen Belichtungen und rückt das Objekt ab und zu wieder in die Mitte.",
  dob_stanotte: "Ihr Dobson folgt dem Himmel nicht: zum Fotografieren heute Nacht Mond und Planeten wählen, alles andere am Okular beobachten (Visuelle Beobachtung).",
  dob_montatura: "Nachführende Montierungen →", dob_titolo: "Ohne Nachführung",
  dob_tp: "Mit Ihrem Dobson ohne Motor sind diese Belichtungen nicht möglich: Die Zahlen gelten für eine nachführende Montierung." });
Object.assign(TESTI.es, {
  dob_n: "Tu Dobson no está motorizado y no sigue el cielo. Para nebulosas y galaxias hacen falta exposiciones largas y, por tanto, una montura con seguimiento: en el Dobson, con esta focal y esta cámara, las estrellas quedan puntuales solo unos {s} segundos.",
  dob_corpo: "Tu Dobson no sigue el cielo, pero para la Luna y los planetas va bien: se graban en vídeo, con exposiciones brevísimas, volviendo a centrar el objeto de vez en cuando.",
  dob_stanotte: "Tu Dobson no sigue el cielo: para fotografiar esta noche elige la Luna y los planetas, o mira todo lo demás con el ocular (Observación visual).",
  dob_montatura: "Monturas con seguimiento →", dob_titolo: "Sin seguimiento",
  dob_tp: "Con tu Dobson sin motores estas exposiciones no se pueden hacer: los números valen con una montura con seguimiento." });
Object.assign(TESTI.en, {
  dob_n: "Your Dobsonian isn't motorised and doesn't track the sky. Nebulae and galaxies need long exposures, and therefore a tracking mount: on the Dobsonian, with this focal length and this camera, stars stay pinpoint for only about {s} seconds.",
  dob_corpo: "Your Dobsonian doesn't track the sky, but it's fine for the Moon and planets: you record them as video with very short exposures, re-centring the object now and then.",
  dob_stanotte: "Your Dobsonian doesn't track the sky: to take photos tonight pick the Moon and planets, or look at everything else through the eyepiece (Visual observing).",
  dob_montatura: "Tracking mounts →", dob_titolo: "No tracking",
  dob_tp: "These exposures aren't possible with your unmotorised Dobsonian: the numbers assume a tracking mount." });
function senzaInseguimento(tel) {
  if (!tel || tel.smart || !tel.h) return false;
  const x = (DATI.telescopi || []).find(d => d.h === tel.h);
  return !!x && x.tipo === "dobson" && !/go ?to|synscan|auto ?track|wi-?fi|motoriz/i.test(`${x.t} ${tel.nome || ""}`);
}
function bottoneMontature() {
  return el("a", { class: "gas-btn gas-btn--chiaro gas-btn--mini", href: urlScheda("scegli") + "#scegli?montatura",
    onclick: e => {
      e.preventDefault();
      try { history.pushState(null, "", "#scegli?montatura"); } catch (er) {   }
      vai("scegli", true);
      const top = RADICE.getBoundingClientRect().top + window.scrollY - 90;
      if (Math.abs(window.scrollY - top) > 40) window.scrollTo({ top, behavior: "smooth" });
    } }, t("dob_montatura"));
}
function boxInseguimento(o, r) {
  if (CAMPO.modo !== "foto" || !senzaInseguimento(CAMPO.tel)) return null;
  if (o && o.corpo) return el("div", { class: "gas-giudizio gas-giudizio--poco_sotto" }, el("b", null, t("dob_titolo"), ": "), t("dob_corpo"));
  const px = CAMPO.cam && CAMPO.cam.px, F = r && r.F, N = r && r.N;
  const s = px && F && N ? (35 * N + 30 * px) / F : null;
  return el("div", { class: "gas-giudizio gas-giudizio--poco_sotto" }, el("b", null, t("dob_titolo"), ": "),
    t("dob_n", { s: s ? num(s, s < 1 ? 1 : 0) : "1" }), " ", bottoneMontature());
}
function avvisoInseguimentoNotte() {
  if (CAMPO.modo !== "foto" || !senzaInseguimento(CAMPO.tel)) return null;
  return el("div", { class: "gas-giudizio gas-giudizio--poco_sotto gas-dob-notte" }, el("b", null, t("dob_titolo"), ": "), t("dob_stanotte"), " ", bottoneMontature());
}
Object.assign(TESTI.it, { cd_condividi: "Condividi", cd_titolo: "Condividi l'inquadratura", cd_preparo: "Preparo l'immagine…", cd_errore: "Non riesco a preparare l'immagine con la foto: la faccio con la mappa.",
  cd_campo: "Campo", cd_scala: "Scala", cd_fatto: "Fatto con gli strumenti gratuiti di Giordano Astronomia" });
Object.assign(TESTI.de, { cd_condividi: "Teilen", cd_titolo: "Bildfeld teilen", cd_preparo: "Bild wird vorbereitet…", cd_errore: "Mit dem Foto lässt sich das Bild nicht erstellen – wir verwenden stattdessen die Karte.",
  cd_campo: "Bildfeld", cd_scala: "Maßstab", cd_fatto: "Erstellt mit den kostenlosen Werkzeugen von Giordano Astronomia" });
Object.assign(TESTI.es, { cd_condividi: "Compartir", cd_titolo: "Compartir el encuadre", cd_preparo: "Preparando la imagen…", cd_errore: "No puedo preparar la imagen con la foto: la hago con el mapa.",
  cd_campo: "Campo", cd_scala: "Escala", cd_fatto: "Hecho con las herramientas gratuitas de Giordano Astronomia" });
Object.assign(TESTI.it, { cd_foto: "Foto" });
Object.assign(TESTI.de, { cd_foto: "Foto" });
Object.assign(TESTI.es, { cd_foto: "Foto" });
Object.assign(TESTI.en, { cd_foto: "Photo" });
function svgInImmagine(svg) {
  const copia = svg.cloneNode(true);
  const originali = [svg, ...svg.querySelectorAll("*")], copie = [copia, ...copia.querySelectorAll("*")];
  const PROP = ["fill", "fill-opacity", "stroke", "stroke-width", "stroke-opacity", "stroke-dasharray", "opacity", "font-family", "font-size", "font-weight", "letter-spacing",
    "paint-order", "text-anchor", "dominant-baseline"];
  originali.forEach((n, i) => {
    const cs = getComputedStyle(n);
    copie[i].setAttribute("style", PROP.map(p => `${p}:${cs.getPropertyValue(p)}`).join(";"));
  });
  copia.querySelectorAll(".gas-rot-maniglia").forEach(n => n.remove());
  copia.setAttribute("xmlns", SVGNS);
  const vb = svg.viewBox.baseVal;
  copia.setAttribute("width", vb.width); copia.setAttribute("height", vb.height);
  const url = URL.createObjectURL(new Blob([new XMLSerializer().serializeToString(copia)], { type: "image/svg+xml" }));
  return new Promise((ok, ko) => { const im = new Image(); im.onload = () => { URL.revokeObjectURL(url); ok(im); }; im.onerror = ko; im.src = url; });
}
async function immagineInquadratura(strati, svg, testi) {
  const prima = strati.find(Boolean) || svg;
  const sw = prima.width || prima.viewBox.baseVal.width, sh = prima.height || prima.viewBox.baseVal.height;
  const conPano = !!testi.pano, W = 1080, Hc = Math.round(clamp(W * sh / sw, 540, 1080));
  const c = document.createElement("canvas"), g = c.getContext("2d");
  const font = (px, peso) => `${peso || 600} ${px}px ${getComputedStyle(RADICE).fontFamily}`;
  const testo = disegna => {
    g.fillStyle = "#ffffff"; g.font = font(58, 800);
    let y = scriviA(g, testi.titolo, 64, Hc + 92, W - 128, 66, !disegna) - 6;
    for (const [e, v] of testi.righe) {
      g.font = font(30, 600); g.fillStyle = "#9fb0c6"; if (disegna) g.fillText(e, 64, y);
      g.font = font(34, 700); g.fillStyle = "#eef3f9";
      y = scriviA(g, v, 300, y, W - 364, 42, !disegna) + 10;
    }
    return y;
  };
  const ph = conPano ? (W - 128) * testi.pano.height / testi.pano.width : 0;
  const H = Math.round(testo(false) + (conPano ? ph + 193 : 145));
  c.width = W; c.height = H;
  const fondo = g.createLinearGradient(0, 0, 0, H);
  fondo.addColorStop(0, "#050b17"); fondo.addColorStop(1, "#0c1a30");
  g.fillStyle = fondo; g.fillRect(0, 0, W, H);
  const s = Math.min(W / sw, Hc / sh), dx = (W - sw * s) / 2, dy = (Hc - sh * s) / 2;
  g.save(); g.beginPath(); g.rect(0, 0, W, Hc); g.clip();
  g.fillStyle = "#000"; g.fillRect(0, 0, W, Hc);
  for (const t0 of strati) if (t0) g.drawImage(t0, dx, dy, sw * s, sh * s);
  if (svg) g.drawImage(await svgInImmagine(svg), dx, dy, sw * s, sh * s);
  g.restore();
  g.fillStyle = "#e2b84f"; g.fillRect(0, Hc, W, 4);
  testo(true);
  if (conPano) {
    const pw = W - 128, py = H - 168 - ph;
    g.fillStyle = "#e2b84f"; g.font = font(30, 800); g.fillText(testi.panoTitolo || "", 64, py - 16);
    g.fillStyle = "#0a1628"; g.fillRect(64, py, pw, ph);
    g.drawImage(testi.pano, 64, py, pw, ph);
  }
  g.fillStyle = "#f4d58b"; g.font = font(40, 800); g.fillText("GIORDANO ASTRONOMIA", 64, H - 118);
  g.fillStyle = "#cfd8e6"; g.font = font(27, 500); g.fillText(testi.link, 64, H - 76);
  g.fillStyle = "#7d8da3"; g.font = font(22, 500); g.fillText(testi.credito, 64, H - 40);
  return new Promise((ok, ko) => c.toBlob(b => (b ? ok(b) : ko(new Error("toBlob"))), "image/png"));
}
function scriviA(g, testo, x, y, larg, passo, finto) {
  const parole = String(testo).split(/[ \t\r\n]+/);
  let riga = "";
  for (const p of parole) {
    const prova = riga ? riga + " " + p : p;
    if (g.measureText(prova).width > larg && riga) { if (!finto) g.fillText(riga, x, y); y += passo; riga = p; } else riga = prova;
  }
  if (riga && !finto) g.fillText(riga, x, y);
  return y + passo;
}
async function condividiBlob(blob, nome, titolo, url) {
  const file = new File([blob], nome, { type: "image/png" });
  if (navigator.canShare && navigator.canShare({ files: [file] })) {
    try { await navigator.share({ files: [file], title: titolo, text: `${titolo} · ${url}` }); return; } catch (e) { if (e && e.name === "AbortError") return; }
  }
  const a = el("a", { href: URL.createObjectURL(blob), download: nome });
  document.body.appendChild(a); a.click(); setTimeout(() => { URL.revokeObjectURL(a.href); a.remove(); }, 2000);
}
function scaricaTesto(testo, nome, tipo) {
  const a = el("a", { href: URL.createObjectURL(new Blob([testo], { type: tipo || "text/plain;charset=utf-8" })), download: nome });
  document.body.appendChild(a); a.click(); setTimeout(() => { URL.revokeObjectURL(a.href); a.remove(); }, 2000);
}
Object.assign(TESTI.it, { cf_confronta: "Confronta con", cf_nessuno: "nessun setup", cf_togli: "Togli il confronto", cf_attuale: "Attuale", cf_riga: "Confronto",
  cf_piu_grande: "Il campo di {n} è {x} volte più largo.", cf_piu_piccolo: "Il campo di {n} è {x} volte più stretto.", cf_uguale: "{n} ha quasi lo stesso campo.",
  esp_titolo: "Per N.I.N.A. e ASIAIR", esp_scarica: "Scarica CSV", esp_copia: "Copia",
  esp_n: "Formato CSV di Telescopius: coordinate J2000 e angolo di posizione (da nord verso est). In N.I.N.A. si apre con «Importa» nel sequenziatore semplice, in ASIAIR dal Piano." });
Object.assign(TESTI.de, { cf_confronta: "Vergleichen mit", cf_nessuno: "kein Setup", cf_togli: "Vergleich entfernen", cf_attuale: "Aktuell", cf_riga: "Vergleich",
  cf_piu_grande: "Das Bildfeld von {n} ist {x}-mal so breit.", cf_piu_piccolo: "Das Bildfeld von {n} ist {x}-mal schmaler.", cf_uguale: "{n} hat fast dasselbe Bildfeld.",
  esp_titolo: "Für N.I.N.A. und ASIAIR", esp_scarica: "CSV herunterladen", esp_copia: "Kopieren",
  esp_n: "CSV-Format von Telescopius: J2000-Koordinaten und Positionswinkel (von Nord nach Ost). Die Datei öffnen Sie in N.I.N.A. über „Importieren“ im einfachen Sequenzer, in ASIAIR über den Plan." });
Object.assign(TESTI.es, { cf_confronta: "Comparar con", cf_nessuno: "ninguna configuración", cf_togli: "Quitar la comparación", cf_attuale: "Actual", cf_riga: "Comparación",
  cf_piu_grande: "El campo de {n} es {x} veces más ancho.", cf_piu_piccolo: "El campo de {n} es {x} veces más estrecho.", cf_uguale: "{n} tiene casi el mismo campo.",
  esp_titolo: "Para N.I.N.A. y ASIAIR", esp_scarica: "Descargar CSV", esp_copia: "Copiar",
  esp_n: "Formato CSV de Telescopius: coordenadas J2000 y ángulo de posición (de norte hacia este). En N.I.N.A. se abre con «Importar» en el secuenciador simple, en ASIAIR desde el Plan." });
function raTelescopius(g) {
  let s = Math.round(((g / 15) % 24 + 24) % 24 * 3600) % 86400;
  const h = Math.floor(s / 3600), m = Math.floor(s / 60) % 60;
  s %= 60;
  return `${String(h).padStart(2, "0")}hr ${String(m).padStart(2, "0")}’ ${String(s).padStart(2, "0")}"`;
}
function decTelescopius(g) {
  let s = Math.round(Math.abs(g) * 3600);
  const d = Math.floor(s / 3600), m = Math.floor(s / 60) % 60;
  s %= 60;
  return `${g < 0 && (d || m || s) ? "-" : ""}${String(d).padStart(2, "0")}º ${String(m).padStart(2, "0")}’ ${String(s).padStart(2, "0")}"`;
}
function csvMosaico(nome, centro, pannelli, r) {
  const pa = (ra, dec) => {
    let da = ra - centro[0];
    if (da > 180) da -= 360; else if (da < -180) da += 360;
    return ((CAMPO.rot + da * Math.sin((dec + centro[1]) / 2 * RAD)) % 360 + 360) % 360;
  };
  const fisse = `${(r.fovW * 60).toFixed(2)}, ${(r.fovH * 60).toFixed(2)}, ${CAMPO.sov}%`;
  const righe = ["Pane, RA, DEC, Position Angle (East), Pane width (arcmins), Pane height (arcmins), Overlap, Row, Column",
    `${pannelli.length > 1 ? "Center" : nome}, ${raTelescopius(centro[0])}, ${decTelescopius(centro[1])}, ${pa(centro[0], centro[1]).toFixed(2)}, ${fisse}, -, -`];
  if (pannelli.length > 1) for (const [n, ra, dec, riga, col] of pannelli)
    righe.push(`${nome} Pane ${n}, ${raTelescopius(ra)}, ${decTelescopius(dec)}, ${pa(ra, dec).toFixed(2)}, ${fisse}, ${riga}, ${col}`);
  return righe.join("\r\n") + "\r\n";
}
Object.assign(TESTI.it, {
  tab_attrezzatura: "Attrezzatura", home_attrezzatura: "Telescopi, camere, oculari, riduttori, filtri e montature che hai: li inserisci una volta e li ritrovi in tutti gli strumenti.",
  att_titolo: "La mia attrezzatura", att_intro: "Inserisci una volta quello che hai. Nel Campo inquadrato e in Stanotte i tuoi pezzi compaiono per primi: un tocco e sono scelti. I filtri servono per i consigli su cosa montare.",
  att_tel: "Telescopi e obiettivi", att_cam: "Camere", att_oc: "Oculari", att_k: "Riduttori e Barlow", att_filtri: "Filtri",
  att_vuoto_tel: "Nessun telescopio: cercalo qui sotto o inseriscilo a mano.", att_vuoto_cam: "Nessuna camera: cercala qui sotto o inseriscila a mano.",
  att_vuoto_oc: "Nessun oculare.", att_vuoto_k: "Nessun riduttore o Barlow.", att_nessuno: "Ancora vuota: comincia dal telescopio.",
  att_a_mano: "Non lo trovi? Inseriscilo a mano", att_nome: "Nome (facoltativo)", att_aggiungi_btn: "Aggiungi", att_fattore: "Oppure scegli solo il numero (es. 0,8× o 2×)",
  att_aggiungi: "Aggiungi alla mia attrezzatura", att_aggiunto: "Nella tua attrezzatura", att_tua: "Dalla tua attrezzatura:", att_togli: "Togli",
  att_cerca_k: "Cerca: 0,8×, Askar, Barlow 2×…", att_setup_n: "Un setup è una combinazione pronta di telescopio, riduttore e camera (o oculare): componila qui sotto con i pezzi della tua attrezzatura e salvala con un nome. Poi la richiami con un tocco nel Campo inquadrato, in Stanotte e nei calcolatori. Con la matita ✎ cambi i pezzi o il nome.",
  att_prova: "Apri il Campo inquadrato", att_link: "Portala su un altro dispositivo",
  att_link_n: "Senza account resta salvata solo in questo browser: per averla anche sul telefono (o sul computer) copia il link e aprilo lì.", att_copia_link: "Copia il link",
  att_import: "Questo link contiene un'attrezzatura: {r}.", att_import_si: "Aggiungila alla mia", att_import_no: "No, grazie",
  att_importata: "Fatto: ora è nella tua attrezzatura.", att_recuperati: "Abbiamo ritrovato {n} filtri che erano rimasti dentro i tuoi setup.",
  att_modifica: "Modifica la tua attrezzatura", mio_setup: "Telescopio e camera di stanotte",
});
Object.assign(TESTI.de, {
  tab_attrezzatura: "Ausrüstung", home_attrezzatura: "Teleskope, Kameras, Okulare, Reducer, Filter und Montierungen, die Sie besitzen: einmal eingeben und in allen Werkzeugen wiederfinden.",
  att_titolo: "Meine Ausrüstung", att_intro: "Geben Sie einmal ein, was Sie besitzen. Unter „Bildfeld“ und „Heute Nacht“ erscheinen Ihre Teile zuerst: Ein Tippen genügt. Anhand Ihrer Filter empfehlen wir, welchen Sie verwenden sollten.",
  att_tel: "Teleskope und Objektive", att_cam: "Kameras", att_oc: "Okulare", att_k: "Reducer und Barlow", att_filtri: "Filter",
  att_vuoto_tel: "Kein Teleskop: unten suchen oder von Hand eingeben.", att_vuoto_cam: "Keine Kamera: unten suchen oder von Hand eingeben.",
  att_vuoto_oc: "Kein Okular.", att_vuoto_k: "Kein Reducer und keine Barlow.", att_nessuno: "Noch leer: Beginnen Sie mit dem Teleskop.",
  att_a_mano: "Nicht gefunden? Von Hand eingeben", att_nome: "Name (optional)", att_aggiungi_btn: "Hinzufügen", att_fattore: "Oder nur den Wert wählen (z. B. 0,8× oder 2×)",
  att_aggiungi: "Zu meiner Ausrüstung hinzufügen", att_aggiunto: "In Ihrer Ausrüstung", att_tua: "Aus Ihrer Ausrüstung:", att_togli: "Entfernen",
  att_cerca_k: "Suche: 0,8×, Askar, Barlow 2×…", att_setup_n: "Ein Setup ist eine fertige Kombination aus Teleskop, Reducer und Kamera (oder Okular): Stellen Sie es unten aus Ihrer Ausrüstung zusammen und speichern Sie es mit einem Namen. Danach rufen Sie es mit einem Tippen im Bildfeld, unter „Was sehen“ und in den Rechnern auf. Mit dem Stift ✎ ändern Sie Teile oder Namen.",
  att_prova: "Bildfeld öffnen", att_link: "Auf ein anderes Gerät übertragen",
  att_link_n: "Ohne Konto bleibt sie nur in diesem Browser gespeichert: Um sie auch auf dem Handy (oder dem Computer) zu haben, kopieren Sie den Link und öffnen Sie ihn dort.", att_copia_link: "Link kopieren",
  att_import: "Dieser Link enthält eine Ausrüstung: {r}.", att_import_si: "Zu meiner hinzufügen", att_import_no: "Nein, danke",
  att_importata: "Erledigt: Sie ist jetzt in Ihrer Ausrüstung.", att_recuperati: "Wir haben {n} Filter wiedergefunden, die in Ihren Setups gespeichert waren.",
  att_modifica: "Ausrüstung bearbeiten", mio_setup: "Teleskop und Kamera für heute Nacht",
});
Object.assign(TESTI.es, {
  tab_attrezzatura: "Equipo", home_attrezzatura: "Telescopios, cámaras, oculares, reductores, filtros y monturas que tienes: los introduces una vez y los encuentras en todas las herramientas.",
  att_titolo: "Mi equipo", att_intro: "Introduce una vez lo que tienes. En Campo de visión y en Esta noche tus piezas aparecen primero: basta un toque. Los filtros sirven para los consejos sobre cuál montar.",
  att_tel: "Telescopios y objetivos", att_cam: "Cámaras", att_oc: "Oculares", att_k: "Reductores y Barlow", att_filtri: "Filtros",
  att_vuoto_tel: "Ningún telescopio: búscalo abajo o introdúcelo a mano.", att_vuoto_cam: "Ninguna cámara: búscala abajo o introdúcela a mano.",
  att_vuoto_oc: "Ningún ocular.", att_vuoto_k: "Ningún reductor ni Barlow.", att_nessuno: "Todavía vacío: empieza por el telescopio.",
  att_a_mano: "¿No lo encuentras? Introdúcelo a mano", att_nome: "Nombre (opcional)", att_aggiungi_btn: "Añadir", att_fattore: "O elige solo el número (p. ej. 0,8× o 2×)",
  att_aggiungi: "Añadir a mi equipo", att_aggiunto: "En tu equipo", att_tua: "De tu equipo:", att_togli: "Quitar",
  att_cerca_k: "Busca: 0,8×, Askar, Barlow 2×…", att_setup_n: "Una configuración es una combinación lista de telescopio, reductor y cámara (u ocular): ármala aquí abajo con las piezas de tu equipo y guárdala con un nombre. Luego la recuperas con un toque en Campo de visión, en Esta noche y en las calculadoras. Con el lápiz ✎ cambias las piezas o el nombre.",
  att_prova: "Abrir Campo de visión", att_link: "Llévalo a otro dispositivo",
  att_link_n: "Sin cuenta se queda guardado solo en este navegador: para tenerlo también en el móvil (o en el ordenador) copia el enlace y ábrelo allí.", att_copia_link: "Copiar el enlace",
  att_import: "Este enlace contiene un equipo: {r}.", att_import_si: "Añadirlo al mío", att_import_no: "No, gracias",
  att_importata: "Hecho: ya está en tu equipo.", att_recuperati: "Hemos recuperado {n} filtros que se habían quedado dentro de tus configuraciones.",
  att_modifica: "Editar tu equipo", mio_setup: "Telescopio y cámara de esta noche",
});
Object.assign(GUIDA.it, {
  g_attrezzatura: "Questa è la tua attrezzatura. In alto ci sono i riquadri con i numeri: toccane uno e si apre quella parte. Subito sotto trovi i tuoi setup, cioè telescopio, riduttore e camera salvati insieme: tocca un setup per usarlo nel Campo inquadrato e in Stanotte; con la matita ne cambi i pezzi o il nome, con Crea un setup ne fai uno nuovo in quattro passi. Poi c'è una riga per ogni tipo: telescopi, camere, oculari, riduttori, montature e filtri. Ogni riga dice cosa contiene: toccala per aprirla, cercare un pezzo per nome o scriverlo a mano. All'assistente scrivi o dici cosa hai, e compila tutto lui. In fondo, in Account e link, ci sono il tuo account, il link per mandare la tua attrezzatura a un amico e Svuota tutto.",
  g_mio_setup: "Imposta qui telescopio e camera, oppure tocca un pezzo della tua attrezzatura o un tuo setup. Per vedere solo gli oggetti che entrano bene nel tuo campo, nel riquadro Oggetti accendi Mostra solo gli oggetti adatti al mio campo.",
});
Object.assign(GUIDA.de, {
  g_attrezzatura: "Das ist Ihre Ausrüstung. Oben stehen die Kästchen mit den Zahlen: Tippen Sie auf eines, und dieser Teil öffnet sich. Gleich darunter finden Sie Ihre Setups, also Teleskop, Reducer und Kamera zusammen gespeichert: Tippen Sie auf ein Setup, um es im Bildfeld und bei Heute Nacht zu verwenden; mit dem Stift ändern Sie Teile oder Namen, mit Setup erstellen legen Sie in vier Schritten ein neues an. Danach kommt eine Zeile für jede Art: Teleskope, Kameras, Okulare, Reducer, Montierungen und Filter. Jede Zeile zeigt, was darin ist: Tippen Sie darauf, um sie zu öffnen, ein Teil nach Namen zu suchen oder von Hand einzugeben. Dem Assistenten schreiben oder sagen Sie, was Sie haben, und er trägt alles ein. Ganz unten, unter Konto und Link, finden Sie Ihr Konto, den Link, um Ihre Ausrüstung einem Freund zu senden, und Alles löschen.",
  g_mio_setup: "Stellen Sie hier Teleskop und Kamera ein, oder tippen Sie auf ein Teil Ihrer Ausrüstung oder ein Setup. Um nur die Objekte zu sehen, die gut in Ihr Bildfeld passen, schalten Sie im Kasten Objekte die Option Nur Objekte zeigen, die zu meinem Bildfeld passen ein.",
});
Object.assign(GUIDA.es, {
  g_attrezzatura: "Este es tu equipo. Arriba están los recuadros con los números: toca uno y se abre esa parte. Justo debajo tienes tus configuraciones guardadas, es decir, telescopio, reductor y cámara juntos: toca una para usarla en Campo de visión y en Esta noche; con el lápiz cambias sus piezas o el nombre, y con Crear una configuración haces una nueva en cuatro pasos. Luego hay una fila para cada tipo: telescopios, cámaras, oculares, reductores, monturas y filtros. Cada fila dice lo que contiene: tócala para abrirla, buscar una pieza por su nombre o escribirla a mano. Al asistente le escribes o le dices lo que tienes, y lo rellena todo él. Al final, en Cuenta y enlace, están tu cuenta, el enlace para mandar tu equipo a un amigo y Borrar todo.",
  g_mio_setup: "Configura aquí el telescopio y la cámara, o toca una pieza de tu equipo o una configuración. Para ver solo los objetos que caben bien en tu campo, en el recuadro Objetos activa Mostrar solo los objetos adecuados para mi campo.",
});
Object.assign(GUIDA.it, { g_attrezzatura_vuota: "Questa è la tua attrezzatura, per ora vuota. In alto c'è Nuovo setup in 4 passi: scegli il telescopio, il riduttore e la camera, un passo alla volta, e lo vedi subito sul cielo. Subito sotto c'è l'assistente: scrivi o di' cosa hai, e compila tutto lui. Poi c'è una riga per ogni tipo: telescopi, camere, oculari, riduttori, montature e filtri. Toccala per aprirla, cercare un pezzo per nome o scriverlo a mano. Quando avrai aggiunto qualcosa, in alto compariranno i riquadri con i numeri e i tuoi setup." });
Object.assign(GUIDA.de, { g_attrezzatura_vuota: "Das ist Ihre Ausrüstung, noch leer. Oben steht Neues Setup in 4 Schritten: Wählen Sie Teleskop, Reducer und Kamera, einen Schritt nach dem anderen, und Sie sehen es sofort am Himmel. Gleich darunter ist der Assistent: Schreiben oder sagen Sie, was Sie haben, und er trägt alles ein. Danach kommt eine Zeile für jede Art: Teleskope, Kameras, Okulare, Reducer, Montierungen und Filter. Tippen Sie darauf, um sie zu öffnen, ein Teil nach Namen zu suchen oder von Hand einzugeben. Sobald Sie etwas hinzugefügt haben, erscheinen oben die Kästchen mit den Zahlen und Ihre Setups." });
Object.assign(GUIDA.es, { g_attrezzatura_vuota: "Este es tu equipo, por ahora vacío. Arriba está Nueva configuración en 4 pasos: elige el telescopio, el reductor y la cámara, un paso cada vez, y lo ves enseguida en el cielo. Justo debajo está el asistente: escribe o di lo que tienes, y lo rellena todo él. Luego hay una fila para cada tipo: telescopios, cámaras, oculares, reductores, monturas y filtros. Tócala para abrirla, buscar una pieza por su nombre o escribirla a mano. Cuando hayas añadido algo, arriba aparecerán los recuadros con los números y tus configuraciones." });
Object.assign(GUIDA.en, { g_attrezzatura_vuota: "This is your equipment, empty for now. At the top is New setup in 4 steps: pick the telescope, the reducer and the camera, one step at a time, and you see it on the sky right away. Just below is the assistant: type or say what you own, and it fills everything in. Then there's a row for each type: telescopes, cameras, eyepieces, reducers, mounts and filters. Tap it to open it, search for a piece by name or type it in. Once you've added something, the boxes with the numbers and your setups appear at the top." });
Object.assign(TESTI.it, { comp_titolo: "Componi un setup con i pezzi della tua attrezzatura:", comp_fine: "Camera o oculare",
  comp_manca: "Per comporre un setup aggiungi in questa pagina almeno un telescopio e una camera (o un oculare)." });
Object.assign(TESTI.de, { comp_titolo: "Stellen Sie ein Setup aus Ihrer Ausrüstung zusammen:", comp_fine: "Kamera oder Okular",
  comp_manca: "Um ein Setup zusammenzustellen, fügen Sie auf dieser Seite mindestens ein Teleskop und eine Kamera (oder ein Okular) hinzu." });
Object.assign(TESTI.es, { comp_titolo: "Arma una configuración con las piezas de tu equipo:", comp_fine: "Cámara u ocular",
  comp_manca: "Para armar una configuración, añade en esta página al menos un telescopio y una cámara (o un ocular)." });
Object.assign(TESTI.en, { comp_titolo: "Put together a setup from your gear:", comp_fine: "Camera or eyepiece",
  comp_manca: "To put together a setup, add at least one telescope and one camera (or eyepiece) on this page." });
Object.assign(TESTI.it, { att_calcolato: "calcolato", att_fn: "Rapporto focale f/", att_fn_n: "Bastano due valori. Obiettivo fotografico: focale e f/ (es. 105 mm f/1,4), il diametro lo calcoliamo noi. Telescopio: diametro e focale." });
Object.assign(TESTI.de, { att_calcolato: "berechnet", att_fn: "Öffnungsverhältnis f/", att_fn_n: "Zwei Werte genügen. Fotoobjektiv: Brennweite und f/ (z. B. 105 mm f/1,4), die Öffnung rechnen wir aus. Teleskop: Öffnung und Brennweite." });
Object.assign(TESTI.es, { att_calcolato: "calculado", att_fn: "Relación focal f/", att_fn_n: "Bastan dos valores. Objetivo fotográfico: focal y f/ (p. ej. 105 mm f/1,4), el diámetro lo calculamos nosotros. Telescopio: diámetro y focal." });
Object.assign(TESTI.en, { att_calcolato: "calculated", att_fn: "Focal ratio f/", att_fn_n: "Two values are enough. Camera lens: focal length and f-number (e.g. 105 mm f/1.4); we work out the aperture. Telescope: aperture and focal length." });
Object.assign(TESTI.it, { att_non_trovato: "Non è nel nostro elenco: tocca qui e inseriscilo a mano ↓" });
Object.assign(TESTI.de, { att_non_trovato: "Nicht in unserer Liste: hier tippen und von Hand eingeben ↓" });
Object.assign(TESTI.es, { att_non_trovato: "No está en nuestra lista: toca aquí e introdúcelo a mano ↓" });
Object.assign(TESTI.en, { att_non_trovato: "Not in our list: tap here and enter it manually ↓" });
Object.assign(TESTI.it, { att_mancano: "Manca qualche numero: riempi le caselle segnate in rosso." });
Object.assign(TESTI.it, { att_k_non_trovato: "Non lo troviamo: scegli qui sotto il numero scritto sul pezzo ↓", att_k_non_qui: "Non è tra questi? Scegli il numero ↓" });
Object.assign(TESTI.de, { att_k_non_trovato: "Nicht gefunden: unten die auf dem Teil aufgedruckte Zahl wählen ↓", att_k_non_qui: "Nicht dabei? Die Zahl wählen ↓" });
Object.assign(TESTI.es, { att_k_non_trovato: "No lo encontramos: elige abajo el número que lleva impreso ↓", att_k_non_qui: "¿No está entre estos? Elige el número ↓" });
Object.assign(TESTI.en, { att_k_non_trovato: "We can't find it: below, pick the number printed on the part ↓", att_k_non_qui: "Not among these? Pick the number ↓" });
Object.assign(TESTI.de, { att_mancano: "Es fehlen Zahlen: Füllen Sie die rot markierten Felder aus." });
Object.assign(TESTI.es, { att_mancano: "Faltan números: rellena las casillas marcadas en rojo." });
Object.assign(TESTI.en, { att_mancano: "Some numbers are missing: fill in the boxes marked in red." });
function avvisaMancanti(box) {
  const vuote = $$("input[type=number]", box).filter(i => !i.value);
  let riga = $(".gas-att-manca", box);
  vuote.forEach(i => { i.setAttribute("aria-invalid", "true"); i.addEventListener("input", () => { i.removeAttribute("aria-invalid"); if (riga && !$("[aria-invalid]", box)) riga.hidden = true; }, { once: true }); });
  if (!riga) { riga = el("p", { class: "gas-nota gas-att-manca", role: "alert" }); box.appendChild(riga); }
  riga.textContent = t("att_mancano"); riga.hidden = false;
  const prima = vuote[0] || $("input", box);
  if (prima) prima.focus({ preventScroll: false });
}
const togliMancanti = box => { const r = $(".gas-att-manca", box); if (r) r.hidden = true; $$("[aria-invalid]", box).forEach(i => i.removeAttribute("aria-invalid")); };
Object.assign(TESTI.it, { att_link_amico: "Mandala a un amico", att_link_amico_n: "Per il tuo telefono e il computer il link non serve: entra con la stessa email e la ritrovi già lì. Questo link serve per mandare la tua attrezzatura a un'altra persona.",
  att_svuota_n_conto: "Cancella dal tuo account telescopi, camere, oculari, riduttori, montature, filtri e setup: spariscono da tutti i tuoi dispositivi" });
Object.assign(TESTI.de, { att_link_amico: "An einen Freund senden", att_link_amico_n: "Für Ihr Handy und Ihren Computer ist dieser Link nicht nötig: Melden Sie sich mit derselben E-Mail an, und alles ist schon da. Mit dem Link senden Sie Ihre Ausrüstung an eine andere Person.",
  att_svuota_n_conto: "Löscht Teleskope, Kameras, Okulare, Reducer, Montierungen, Filter und Setups aus Ihrem Konto: Sie verschwinden von allen Ihren Geräten" });
Object.assign(TESTI.es, { att_link_amico: "Mándalo a un amigo", att_link_amico_n: "Para tu móvil y tu ordenador el enlace no hace falta: entra con el mismo correo y ya lo encuentras todo ahí. Este enlace sirve para mandar tu equipo a otra persona.",
  att_svuota_n_conto: "Borra de tu cuenta telescopios, cámaras, oculares, reductores, monturas, filtros y configuraciones: desaparecen de todos tus dispositivos" });
Object.assign(TESTI.en, { att_link_amico: "Send it to a friend", att_link_amico_n: "You don't need the link for your own phone and computer: sign in with the same email and it's already there. This link is for sending your equipment to someone else.",
  att_svuota_n_conto: "Deletes telescopes, cameras, eyepieces, reducers, mounts, filters and setups from your account: they disappear from all your devices" });
Object.assign(TESTI.it, { att_m: "Montature", att_vuoto_m: "Nessuna montatura: cercala qui sotto o scrivi la portata a mano.", att_cerca_m: "Cerca: EQ6-R, AM5, Star Adventurer…",
  att_m_kg: "portata {n} kg", att_m_eq: "equatoriale", att_m_arm: "armonica", att_m_altaz: "altazimutale", att_m_mano: "Montatura da {n} kg" });
Object.assign(TESTI.de, { att_m: "Montierungen", att_vuoto_m: "Keine Montierung: unten suchen oder die Tragkraft von Hand eingeben.", att_cerca_m: "Suche: EQ6-R, AM5, Star Adventurer…",
  att_m_kg: "Tragkraft {n} kg", att_m_eq: "äquatorial", att_m_arm: "Harmonic", att_m_altaz: "azimutal", att_m_mano: "Montierung für {n} kg" });
Object.assign(TESTI.es, { att_m: "Monturas", att_vuoto_m: "Ninguna montura: búscala abajo o escribe la capacidad a mano.", att_cerca_m: "Busca: EQ6-R, AM5, Star Adventurer…",
  att_m_kg: "capacidad {n} kg", att_m_eq: "ecuatorial", att_m_arm: "armónica", att_m_altaz: "altacimutal", att_m_mano: "Montura de {n} kg" });
Object.assign(TESTI.en, { att_m: "Mounts", att_vuoto_m: "No mounts yet: search for one below or enter the payload manually.", att_cerca_m: "Search: EQ6-R, AM5, Star Adventurer…",
  att_m_kg: "payload {n} kg", att_m_eq: "equatorial", att_m_arm: "harmonic", att_m_altaz: "alt-azimuth", att_m_mano: "{n} kg mount" });
const sigleMont = x => normParole(x.t).split(/\s+/).filter(w => /\d/.test(w));
function montatureNoteNuove() {
  const neg = montatureSenzaPacchetti();
  return montatureNote().filter(x => {
    const s = sigleMont(x)[0], marca = attaccato(normParole(String(x.t).split(/\s+/)[0]));
    return !s || !neg.some(b => sigleMont(b).includes(s) && Math.abs((b.kg_portata || 0) - (x.kg_portata || 0)) <= 2 && attaccato(normParole(b.t)).includes(marca));
  });
}
function montatureSenzaPacchetti() {
  if (montatureSenzaPacchetti._l) return montatureSenzaPacchetti._l;
  const l = DATI.montature || [], pacchetto = x => /^bundle\b|\s\+\s|\bcompleta\b/i.test(x.t || "");
  const singole = l.filter(x => !pacchetto(x));
  const tenute = l.filter(x => !pacchetto(x) || !singole.some(b => b.kg_portata === x.kg_portata && b.tipo === x.tipo && sigleMont(b)[0] && sigleMont(x).includes(sigleMont(b)[0])));
  if (l.length) montatureSenzaPacchetti._l = tenute;
  return tenute;
}
function cercaMontature(q, max) {
  const testo = x => `${x.t} ${x.v || ""} ${x.kg_portata}kg ${x.tipo === "altaz" ? "altazimutale altaz" : x.tipo === "armonica" ? "armonica harmonic equatoriale" : "equatoriale eq"}`;
  const elenco = [...montatureSenzaPacchetti(), ...montatureNoteNuove()], r = cercaInElenco(elenco, q, max || 30, testo);
  return r.length ? r : cercaInElencoTollerante(elenco, q, max || 30, testo);
}
const GOTO_IN_PIU = /\baz-?gti|\bfusion\s*\d+i\b|\bsh20\b/i;
const montDaVoce = x => ({ nome: x.t, kg: x.kg_portata, cp: x.kg_portata_cp || null, tipo: x.tipo || null, goto: x.goto != null ? !!x.goto : motorizzata(x) || GOTO_IN_PIU.test(x.t), h: x.h });
function rigaMontatura(x) {
  const tipo = { eq: "att_m_eq", armonica: "att_m_arm", altaz: "att_m_altaz" }[x.tipo];
  const cp = x.cp || (x.h && ((DATI.montature || []).find(y => y.h === x.h) || montatureNote().find(y => y.h === x.h) || {}).kg_portata_cp);
  return [x.kg > 0 ? t("att_m_kg", { n: num(x.kg, x.kg % 1 ? 1 : 0) }) + (cp > x.kg ? t("qm_r_cp", { p: num(cp) }) : "") : "", tipo ? t(tipo) : "", x.goto || GOTO_IN_PIU.test(x.nome || "") ? "GoTo" : ""].filter(Boolean).join(" · ");
}
function indovinaTelescopio(q) {
  const s = String(q).toLowerCase().replace(",", ".");
  let m = s.match(/(\d{2,4}(?:\.\d)?)\s*(?:mm)?\s*\/\s*(\d{3,5})/);
  if (m && +m[2] > +m[1]) return { D: +m[1], F: +m[2] };
  m = s.match(/(?:^|\s)(\d{2,3})\s+(\d{3,4})(?=\s|$)/);
  if (m && +m[2] > 2 * +m[1]) return { D: +m[1], F: +m[2] };
  const pollici = s.match(/(\d{1,2}(?:\.\d)?)\s*(?:"|''|”|pollici|zoll|pulgadas|inch(?:es)?)/);
  const mm = s.match(/(\d{2,4})\s*mm/) || s.match(/(?:^|\s)(\d{2,3})(?=\s|$)/);
  const D = pollici ? Math.round(+pollici[1] * 25.4) : mm ? +mm[1] : null;
  const f = s.match(/f\s*\/?\s*(\d{1,2}(?:\.\d+)?)(?!\d)/);
  if (mm && !pollici && f && +f[1] > 0.9 && +f[1] <= 2.8) return { F: +mm[1], N: +f[1] };
  if (D && f && +f[1] > 1) return { D, F: Math.round(D * +f[1]) };
  return D ? { D } : null;
}
function indovinaOculare(q) {
  const s = String(q).toLowerCase().replace(",", ".");
  const f = s.match(/(\d{1,2}(?:\.\d)?)\s*mm/), a = s.match(/(\d{2,3})\s*°/);
  return f || a ? { f: f ? +f[1] : null, afov: a ? +a[1] : null } : null;
}
const PLURALI_ATT = {
  it: { tel: ["telescopio", "telescopi"], cam: ["camera", "camere"], oc: ["oculare", "oculari"], k: ["riduttore/Barlow", "riduttori/Barlow"], m: ["montatura", "montature"], f: ["filtro", "filtri"] },
  de: { tel: ["Teleskop", "Teleskope"], cam: ["Kamera", "Kameras"], oc: ["Okular", "Okulare"], k: ["Reducer/Barlow", "Reducer/Barlows"], m: ["Montierung", "Montierungen"], f: ["Filter", "Filter"] },
  es: { tel: ["telescopio", "telescopios"], cam: ["cámara", "cámaras"], oc: ["ocular", "oculares"], k: ["reductor/Barlow", "reductores/Barlow"], m: ["montura", "monturas"], f: ["filtro", "filtros"] },
  en: { tel: ["telescope", "telescopes"], cam: ["camera", "cameras"], oc: ["eyepiece", "eyepieces"], k: ["reducer/Barlow", "reducers/Barlows"], m: ["mount", "mounts"], f: ["filter", "filters"] },
}[LINGUA];
const nomeFattore = k => Math.abs(k - 1) < 0.05 ? `${num(k, k % 1 ? 2 : 0)}×` : `${num(k, k % 1 ? 2 : 0)}× ${k < 1 ? t("riduttore_b") : t("barlow_b")}`;
const TIPI_ATT = {
  tel: { chiave: x => (eObiettivo(x) ? [x.h || "", x.F, "f" + (x.Nmax || Math.round(x.F / x.D * 10) / 10)] : [x.h || "", x.D, x.F]).join("|"), nome: x => nomeTel(x),
    sotto: x => eObiettivo(x) ? `${num(x.F)} mm · f/${num(Math.round(x.F / x.D * 10) / 10, Math.round(x.F / x.D * 10) % 10 ? 1 : 0)}` : `${num(x.D)}/${num(x.F)} mm · f/${num(x.F / x.D, 1)}`, ico: "attrezzatura" },
  cam: { chiave: x => [x.id || "", x.w, x.h, x.px].join("|"), nome: x => x.nome, sotto: x => rigaCamera(x), ico: "camere" },
  oc: { chiave: x => [x.h || "", x.f, x.afov].join("|"), nome: x => x.nome, sotto: x => `${num(x.f, x.f % 1 ? 1 : 0)} mm · ${num(x.afov)}°`, ico: "centro" },
  k: { chiave: x => [x.h || "", x.k].join("|"), nome: x => x.nome || nomeFattore(x.k), sotto: x => (x.nome ? nomeFattore(x.k) : ""), ico: "piu" },
  m: { chiave: x => [x.h || "", x.kg, x.h ? "" : String(x.nome || "").replace(/,/g, " ").slice(0, 40)].join("|"),
    nome: x => x.nome || t("att_m_mano", { n: num(x.kg, x.kg % 1 ? 1 : 0) }), sotto: x => rigaMontatura(x), ico: "cx_car" },
};
let ATTREZZI = ricorda("attrezzatura", null), FILTRI_RECUPERATI = 0, ATT_DA_LINK = null;
function salvaAttrezzi() { salva("attrezzatura", ATTREZZI); }
function ho(tipo, x) { const k = x && TIPI_ATT[tipo].chiave(x); return !!x && ATTREZZI[tipo].some(y => TIPI_ATT[tipo].chiave(y) === k); }
function metti(tipo, x) {
  if (!x || ho(tipo, x)) return false;
  ATTREZZI[tipo].push(copiaProfonda(x));
  return true;
}
function aggiungiAttrezzo(tipo, x) {
  if (!puoSalvare()) return invitoAccount();
  if (!metti(tipo, x)) return false;
  salvaAttrezzi(); aggiornaSetupUI();
  return true;
}
function togliAttrezzo(tipo, x) {
  const k = TIPI_ATT[tipo].chiave(x);
  ATTREZZI[tipo] = ATTREZZI[tipo].filter(y => TIPI_ATT[tipo].chiave(y) !== k);
  salvaAttrezzi(); aggiornaSetupUI();
}
function uniscFiltri(nomi, tipi) {
  const miei = CAMPO.filtriNomi = (CAMPO.filtriNomi || []).slice(), s = new Set(CAMPO.filtri || []);
  let nuovi = 0;
  for (const f of nomi || []) if (f && f.nome && f.tipo && !miei.some(x => x.nome === f.nome)) { miei.push(Object.assign({ nome: f.nome, tipo: f.tipo, h: f.h || null }, f.nm > 0 ? { nm: f.nm } : {})); s.add(f.tipo); nuovi++; }
  for (const tp of tipi || []) if (!s.has(tp) && FILTRI_TIPI.some(x => x.id === tp)) { s.add(tp); if (!miei.some(x => x.tipo === tp)) nuovi++; }
  CAMPO.filtri = FILTRI_TIPI.map(x => x.id).filter(id => s.has(id));
  return nuovi;
}
(function () {
  const nuova = !ATTREZZI || typeof ATTREZZI !== "object";
  if (nuova) ATTREZZI = {};
  for (const k of Object.keys(TIPI_ATT)) if (!Array.isArray(ATTREZZI[k])) ATTREZZI[k] = [];
  if (!nuova) return;
  for (const s of SETUP_ELENCO) {
    if (s.tel) metti("tel", s.tel);
    if (s.modo !== "visuale" && s.cam && !(s.tel && s.tel.smart)) metti("cam", s.cam);
    if (s.modo === "visuale" && s.oc) metti("oc", s.oc);
    if (s.k && s.k !== 1 && !(s.tel && s.tel.smart)) metti("k", { k: s.k });
  }
  FILTRI_RECUPERATI = uniscFiltri(SETUP_ELENCO.flatMap(s => s.filtriNomi || []), SETUP_ELENCO.flatMap(s => s.filtri || []));
  salvaAttrezzi();
  if (SETUP_ELENCO.length) salvaCampo();
})();
function contaFiltri() {
  const nomi = CAMPO.filtriNomi || [];
  return nomi.length + (CAMPO.filtri || []).filter(tp => !nomi.some(f => f.tipo === tp)).length;
}
function riepilogoAttrezzi() {
  const n = { tel: ATTREZZI.tel.length, cam: ATTREZZI.cam.length, oc: ATTREZZI.oc.length, k: ATTREZZI.k.length, m: ATTREZZI.m.length, f: contaFiltri() };
  const p = Object.entries(n).filter(([, v]) => v).map(([k, v]) => `${v} ${PLURALI_ATT[k][v === 1 ? 0 : 1]}`);
  return p.length ? p.join(" · ") : t("att_nessuno");
}
function usaAttrezzo(tipo, x) {
  if (tipo === "tel") {
    const v = x.h && (DATI.telescopi.find(z => z.h === x.h && z.D === x.D && z.F === x.F) || DATI.telescopi.find(z => z.h === x.h));
    if (v) scegliTelescopio(v); else { CAMPO.tel = copiaProfonda(x); salvaCampo(); }
  } else if (tipo === "cam") {
    const c = x.id && DATI.camere.find(z => z.id === x.id);
    if (c) scegliCamera(c); else { CAMPO.modo = "foto"; CAMPO.cam = copiaProfonda(x); salvaCampo(); }
  } else if (tipo === "oc") { CAMPO.modo = "visuale"; CAMPO.oc = copiaProfonda(x); salvaCampo(); }
  else if (tipo === "k") { CAMPO.k = x.k; salvaCampo(); }
}
const attualeDi = tipo => tipo === "tel" ? CAMPO.tel : tipo === "cam" ? CAMPO.cam : tipo === "oc" ? CAMPO.oc : CAMPO.k !== 1 ? { k: CAMPO.k } : null;
function sceltaRapida(tipo, dopo) {
  const box = el("div", { class: "gas-rapida", hidden: true });
  const disegna = () => {
    if (!box.isConnected && box._mostrato) { SETUP_UI.delete(disegna); return; }
    box._mostrato = true;
    const voci = ATTREZZI[tipo];
    svuota(box).hidden = !voci.length;
    if (!voci.length) return;
    const ora = attualeDi(tipo), ka = ora && TIPI_ATT[tipo].chiave(ora);
    const scelto = x => (tipo === "k" ? ora && x.k === ora.k : TIPI_ATT[tipo].chiave(x) === ka);
    box.append(el("small", { class: "gas-setup-etich" }, t("att_tua")), el("div", { class: "gas-rapida-riga" }, voci.map(x => {
      const on = scelto(x);
      return el("button", { type: "button", class: "gas-rapida-btn" + (on ? " on" : ""), "aria-pressed": String(on), title: TIPI_ATT[tipo].sotto(x) || null,
        onclick: () => { if (tipo === "k" && on) { CAMPO.k = 1; salvaCampo(); } else usaAttrezzo(tipo, x); dopo(); } },
      on ? "✓ " : "", tipo === "k" ? nomeFattore(x.k) + (x.nome ? " · " + x.nome.replace(/\s*\d+([.,]\d+)?\s*[x×](\s.*)?$/i, "").split(/\s[–—-]\s/)[0].trim().slice(0, 24) : "") : nomeCorto(TIPI_ATT[tipo].nome(x)));
    })));
  };
  SETUP_UI.add(disegna);
  disegna();
  return box;
}
function bottoneAttrezzo(tipo, x) {
  if (!x) return null;
  if (ho(tipo, x) || (tipo === "k" && ATTREZZI.k.some(y => y.k === x.k))) return el("span", { class: "gas-att-gia" }, "✓ ", t("att_aggiunto"));
  return el("button", { type: "button", class: "gas-btn gas-btn--chiaro gas-btn--mini gas-att-piu", onclick: e => {
    const b = e.currentTarget;
    if (!aggiungiAttrezzo(tipo, x) && !ho(tipo, x)) return;
    b.replaceWith(el("span", { class: "gas-att-gia" }, "✓ ", t("att_aggiunto")));
  } }, "+ ", t("att_aggiungi"));
}
function fotoAttrezzo(tipo, x) {
  const c = tipo === "cam" && x.id ? DATI.camere.find(z => z.id === x.id) : null;
  const src = x.foto || (c && c.foto);
  return src ? el("img", { src: src + (src.includes("?") ? "&" : "?") + "width=120", alt: "", width: 48, height: 48, loading: "lazy" })
    : el("span", { class: "gas-att-ico" }, icona(tipo === "k" ? (x.k < 1 ? "meno" : "piu") : TIPI_ATT[tipo].ico));
}
function riquadroAttrezzi(tipo, titolo, conf, conta) {
  const lista = el("div", { class: "gas-att-lista" });
  let giaN = null;
  const disegna = () => {
    if (giaN) { giaN.remove(); giaN = null; }
    svuota(lista);
    if (!ATTREZZI[tipo].length) { lista.appendChild(el("p", { class: "gas-muto gas-att-vuoto" }, t("att_vuoto_" + tipo))); return; }
    for (const x of ATTREZZI[tipo]) lista.appendChild(el("div", { class: "gas-att-voce" }, fotoAttrezzo(tipo, x),
      el("div", { class: "gas-att-testo" }, el("b", null, TIPI_ATT[tipo].nome(x)), TIPI_ATT[tipo].sotto(x) ? el("small", null, TIPI_ATT[tipo].sotto(x)) : null),
      el("button", { type: "button", class: "gas-att-togli", title: t("att_togli"), "aria-label": `${t("att_togli")}: ${TIPI_ATT[tipo].nome(x)}`,
        onclick: () => { togliAttrezzo(tipo, x); disegna(); conta(); } }, icona("chiudi"))));
  };
  const aggiunto = x => {
    if (aggiungiAttrezzo(tipo, x)) { disegna(); conta(); return; }
    const k = x && puoSalvare() && TIPI_ATT[tipo].chiave(x), gia = k && ATTREZZI[tipo].find(y => TIPI_ATT[tipo].chiave(y) === k);
    if (!gia) return;
    if (giaN) giaN.remove();
    giaN = el("div", { class: "gas-att-gia", role: "status" }, "✓ ", t("att_aggiunto"), ": ", TIPI_ATT[tipo].nome(gia));
    cerca.box.after(giaN);
  };
  let mano = null, riempiMano = null, vaiAMano = null;
  if (conf.campi) {
    const valori = {};
    const campi = conf.campi.map(([k, e, u, passo]) => campoNumero(e, null, v => { valori[k] = v; }, { unita: u, min: 0, passo }));
    const suggerisci = () => {
      if (!conf.calcola) return;
      const c = conf.calcola(valori) || {};
      conf.campi.forEach(([k], i) => {
        const inp = $("input", campi[i]);
        if (inp) inp.placeholder = c[k] > 0 && !inp.value ? `${num(c[k], c[k] % 1 ? 1 : 0)} (${t("att_calcolato")})` : "";
      });
    };
    campi.forEach(c => $$("input", c).forEach(i => i.addEventListener("input", () => setTimeout(suggerisci, 0))));
    const nome = el("input", { type: "text", class: "gas-input", maxlength: 60, placeholder: t("att_nome"), "aria-label": t("att_nome") });
    const daRicerca = new Set();
    nome.addEventListener("input", () => daRicerca.delete(nome));
    campi.forEach(c => $$("input", c).forEach(i => i.addEventListener("input", () => daRicerca.delete(i))));
    riempiMano = q => {
      mano.open = true;
      if (!nome.value.trim() || daRicerca.has(nome)) { nome.value = q.slice(0, 60); daRicerca.add(nome); }
      const v = conf.indovina ? conf.indovina(q) : null;
      conf.campi.forEach(([k], i) => {
        const inp = $("input", campi[i]);
        if (!inp || (inp.value && !daRicerca.has(inp))) return;
        if (v && v[k] != null) { inp.value = String(v[k]); valori[k] = v[k]; daRicerca.add(inp); }
        else if (daRicerca.has(inp)) { inp.value = ""; delete valori[k]; daRicerca.delete(inp); }
      });
    };
    const riempi0 = riempiMano;
    riempiMano = q => { riempi0(q); suggerisci(); };
    vaiAMano = () => {
      mano.open = true;
      mano.scrollIntoView({ block: "center", behavior: "smooth" });
      const vuoto = campi.map(c => $("input", c)).find(i => i && !i.value);
      setTimeout(() => (vuoto || nome).focus({ preventScroll: true }), 350);
    };
    mano = el("details", { class: "gas-dettagli gas-att-mano" }, el("summary", null, t("att_a_mano")),
      el("div", { class: conf.campi.length > 2 ? "gas-tre" : "gas-due" }, campi),
      conf.notaMano ? el("small", { class: "gas-muto gas-att-mano-n" }, conf.notaMano) : null,
      el("div", { class: "gas-riga-bottoni" }, nome, el("button", { type: "button", class: "gas-btn gas-btn--mini", onclick: () => {
        const x = conf.daMano(valori, nome.value.trim());
        if (!x) return avvisaMancanti(mano);
        togliMancanti(mano);
        aggiunto(x);
        campi.forEach(c => $$("input", c).forEach(i => { i.value = ""; }));
        nome.value = ""; Object.keys(valori).forEach(k => delete valori[k]); daRicerca.clear(); suggerisci();
        cerca.imposta(""); cerca.chiudi();
      } }, t("att_aggiungi_btn"))));
  }
  const cerca = creaCerca({ segnaposto: conf.segnaposto, cerca: conf.cerca, riga: conf.riga, scegli: x => { cerca.imposta(""); if (mano) togliMancanti(mano); aggiunto(conf.prendi(x)); },
    senza: conf.senza || (riempiMano ? { testo: t("att_non_trovato"), apri: riempiMano, tocca: vaiAMano } : null) });
  const box = scheda(titolo, lista, cerca.box, conf.extra ? conf.extra(aggiunto) : null, mano);
  box.classList.add("gas-att-sez", "gas-att-sez--" + tipo);
  box.ridisegna = disegna;
  disegna();
  return box;
}
Object.assign(TESTI.it, { att_svuota: "Svuota tutto", att_svuota_n: "Cancella da questo dispositivo telescopi, camere, oculari, riduttori, montature, filtri e setup",
  att_svuota_sicuro: "Sicuro? Tocca di nuovo per cancellare tutto", att_svuotata: "Fatto: attrezzatura, filtri e setup cancellati. Riparti da zero." });
Object.assign(TESTI.de, { att_svuota: "Alles löschen", att_svuota_n: "Löscht Teleskope, Kameras, Okulare, Reducer, Montierungen, Filter und Setups von diesem Gerät",
  att_svuota_sicuro: "Sicher? Zum Löschen noch einmal tippen", att_svuotata: "Erledigt: Ausrüstung, Filter und Setups gelöscht. Sie können von vorn beginnen." });
Object.assign(TESTI.es, { att_svuota: "Borrar todo", att_svuota_n: "Borra de este dispositivo telescopios, cámaras, oculares, reductores, monturas, filtros y configuraciones",
  att_svuota_sicuro: "¿Seguro? Toca otra vez para borrarlo todo", att_svuotata: "Hecho: equipo, filtros y configuraciones borrados. Empiezas de cero." });
const attrezzaturaVuota = () => !ATTREZZI.tel.length && !ATTREZZI.cam.length && !ATTREZZI.oc.length && !ATTREZZI.k.length && !ATTREZZI.m.length && !contaFiltri() && !SETUP_ELENCO.length;
function svuotaAttrezzi() {
  for (const k of Object.keys(TIPI_ATT)) ATTREZZI[k] = [];
  CAMPO.filtri = []; CAMPO.filtriNomi = [];
  SETUP_ELENCO.length = 0; CONFRONTO = ""; FILTRI_RECUPERATI = 0;
  salvaAttrezzi(); salva("setup", SETUP_ELENCO); salva("confronto", ""); salvaCampo(); aggiornaSetupUI();
  salva("ns_bozza", null); BV_PASSO = 0; salva("bv_passo", 0);
}
function bottoneSvuotaAttrezzi(dopo) {
  let attesa = null;
  const b = el("button", { type: "button", class: "gas-btn gas-btn--chiaro gas-btn--mini gas-att-svuota", title: t(SYNC.stato === "account" ? "att_svuota_n_conto" : "att_svuota_n") });
  const normale = () => { attesa = null; b.classList.remove("pronto"); svuota(b).append(icona("reimposta"), " ", t("att_svuota")); };
  b.addEventListener("click", () => {
    if (!attesa) { b.classList.add("pronto"); svuota(b).append(t("att_svuota_sicuro")); attesa = setTimeout(normale, 5000); return; }
    clearTimeout(attesa); attesa = null;
    svuotaAttrezzi(); dopo();
  });
  normale();
  return b;
}
let ATT_SVUOTATA = false, ATT_IMPORTATA = false;
Object.assign(TESTI.it, { att_i_setup: "Setup", att_i_tel: "Telescopi", att_i_cam: "Camere", att_i_oc: "Oculari", att_i_k: "Riduttori",
  att_i_m: "Montature", att_i_f: "Filtri", att_i_conto: "Account", att_i_aria: "Le parti della tua attrezzatura", att_conto_t: "Account e link",
  att_r_vuoto: "Ancora niente: tocca per aggiungere", att_as_r: "Scrivi o di' cosa hai: l'assistente compila tutto",
  att_setup_corto: "✎ cambia pezzi o nome · × toglie il setup" });
Object.assign(TESTI.de, { att_i_setup: "Setups", att_i_tel: "Teleskope", att_i_cam: "Kameras", att_i_oc: "Okulare", att_i_k: "Reducer",
  att_i_m: "Montierungen", att_i_f: "Filter", att_i_conto: "Konto", att_i_aria: "Die Teile Ihrer Ausrüstung", att_conto_t: "Konto und Link",
  att_r_vuoto: "Noch nichts: zum Hinzufügen tippen", att_as_r: "Schreiben oder sagen Sie, was Sie haben: Der Assistent trägt alles ein",
  att_setup_corto: "✎ ändert Teile oder Namen · × entfernt das Setup" });
Object.assign(TESTI.es, { att_i_setup: "Configuraciones", att_i_tel: "Telescopios", att_i_cam: "Cámaras", att_i_oc: "Oculares", att_i_k: "Reductores",
  att_i_m: "Monturas", att_i_f: "Filtros", att_i_conto: "Cuenta", att_i_aria: "Las partes de tu equipo", att_conto_t: "Cuenta y enlace",
  att_r_vuoto: "Nada todavía: toca para añadir", att_as_r: "Escribe o di lo que tienes: el asistente lo rellena todo",
  att_setup_corto: "✎ cambia piezas o nombre · × quita la configuración" });
Object.assign(TESTI.en, { att_i_setup: "Setups", att_i_tel: "Telescopes", att_i_cam: "Cameras", att_i_oc: "Eyepieces", att_i_k: "Reducers",
  att_i_m: "Mounts", att_i_f: "Filters", att_i_conto: "Account", att_i_aria: "The parts of your equipment", att_conto_t: "Account and link",
  att_r_vuoto: "Nothing yet: tap to add", att_as_r: "Type or say what you have: the assistant fills it all in",
  att_setup_corto: "✎ changes parts or name · × removes the setup" });
let ATT_APERTA;
try { const v = sessionStorage.getItem(MEMORIA + "att_aperta"); if (v != null) ATT_APERTA = v; } catch (e) {   }
let ATT_APRI = null;
function segnaAperta(k) {
  ATT_APERTA = k;
  try { if (k === undefined) sessionStorage.removeItem(MEMORIA + "att_aperta"); else sessionStorage.setItem(MEMORIA + "att_aperta", k); } catch (e) {   }
}
function apriSezioneAtt(k) {
  const p = PANNELLI.attrezzatura && PANNELLI.attrezzatura.pannello;
  if (schedaAttiva === "attrezzatura" && p && p._apri) p._apri(k); else ATT_APRI = k;
}
const breveAtt = (s, tel) => {
  const c = (tel ? nomeTelCorto(s) : nomeCorto(s)).split(" · ")[0].replace(/…$/, "");
  return c.length > 30 ? (/\s/.test(c[30]) ? c.slice(0, 30) : c.slice(0, 30).replace(/\s+\S*$/, "")).replace(/[\s+·–-]+$/, "") + "…" : c;
};
function riassuntoAtt(k) {
  if (k === "f") {
    const nomi = CAMPO.filtriNomi || [], tipi = (CAMPO.filtri || []).filter(tp => !nomi.some(f => f.tipo === tp));
    return { n: contaFiltri(), testo: [...nomi.map(f => breveAtt(f.nome)), ...tipi.map(tp => t("filtro_" + tp))].join(" · ") };
  }
  const l = ATTREZZI[k] || [];
  return { n: l.length, testo: l.map(x => k === "k" ? `${num(x.k, x.k % 1 ? 2 : 0)}×` : k === "oc" ? `${num(x.f, x.f % 1 ? 1 : 0)} mm`
    : breveAtt(TIPI_ATT[k].nome(x), k === "tel")).join(" · ") };
}
function vistaAttrezzatura(pannello) {
  svuota(pannello);
  pannello._apri = null;
  if (schedaSoloAccount(pannello, "attrezzatura")) { aggiornaHash("attrezzatura"); return; }
  const daFuori = NS_APRI, primo = !SETUP_ELENCO.length, conto = SYNC.stato === "account";
  const righe = [];
  const conta = () => {
    if (!indice.isConnected) { if (indice._mostrato) SETUP_UI.delete(conta); return; }
    indice._mostrato = true;
    const vuota = attrezzaturaVuota();
    for (const b of indice.children) {
      const kk = b.dataset.k, n = kk === "setup" ? SETUP_ELENCO.length : kk === "conto" ? -1 : riassuntoAtt(kk).n;
      b.classList.toggle("gas-att-pil--vuota", n === 0);
      b.firstChild.textContent = n < 0 ? "☁" : n ? String(n) : "–";
    }
    for (const r of righe) {
      let testo, n = 0;
      if (r.k === "as") testo = t("att_as_r");
      else if (r.k === "conto") testo = [t(conto ? "att_link_amico" : "att_link"), conto ? t("ab_account") : "", vuota ? "" : t("att_svuota")].filter(Boolean).join(" · ");
      else { const x = riassuntoAtt(r.k); n = x.n; testo = n ? x.testo : t("att_r_vuoto"); }
      r.card.classList.toggle("gas-att-acc--vuota", !n && r.k !== "as" && r.k !== "conto");
      r.val.textContent = testo;
      r.n.textContent = n ? String(n) : "";
    }
    svuotaRiga.hidden = vuota;
    setupSch.hidden = !SETUP_ELENCO.length;
    nuovo.classList.toggle("gas-ns--in-setup", SETUP_ELENCO.length > 0);
    if (fatto && !vuota) fatto.remove();
  };
  const fatto = ATT_SVUOTATA ? el("p", { class: "gas-setup-ok gas-att-svuotata", role: "status" }, "✓ ", t("att_svuotata")) : null;
  const importata = ATT_IMPORTATA ? el("p", { class: "gas-setup-ok gas-att-svuotata", role: "status" }, "✓ ", t("att_importata")) : null;
  ATT_SVUOTATA = false; ATT_IMPORTATA = false;
  const svuotaBtn = bottoneSvuotaAttrezzi(() => { ATT_SVUOTATA = true; segnaAperta(undefined); vistaAttrezzatura(pannello); tornaAllaNav(); });
  const fat = selezione(FATTORI.filter(f => f !== 1).map(f => [f, nomeFattore(f)]), 0.8, () => {}, { "aria-label": t("att_fattore") });
  const filtriBox = boxFiltri(conta, { tutti: true });
  const sezioni = [
    riquadroAttrezzi("tel", t("att_tel"), {
      segnaposto: t("cerca_telescopio"), cerca: q => cercaTelescopi(q, 40), prendi: telDaVoce,
      riga: x => ({ titolo: titoloTelescopio(x), sotto: rigaTelescopio(x), foto: x.foto }),
      campi: [["D", t("diametro"), "mm", "1"], ["F", t("focale"), "mm", "1"], ["N", t("att_fn"), "", "0.1"]],
      notaMano: t("att_fn_n"),
      calcola: v => ({ D: !(v.D > 0) && v.F > 0 && v.N > 0 ? v.F / v.N : null, F: !(v.F > 0) && v.D > 0 && v.N > 0 ? v.D * v.N : null,
        N: !(v.N > 0) && v.D > 0 && v.F > 0 ? v.F / v.D : null }),
      daMano: (v, n) => {
        const D = v.D > 0 ? v.D : v.F > 0 && v.N > 0 ? Math.round(v.F / v.N * 10) / 10 : null, F = v.F > 0 ? v.F : v.D > 0 && v.N > 0 ? Math.round(v.D * v.N) : null;
        if (!(D > 0 && F > 0)) return null;
        const lente = !(v.D > 0) && v.N > 0;
        return Object.assign({ nome: n || (lente ? `${num(F)} mm f/${num(v.N, 1)}` : `${num(D)}/${num(F)} mm`), D, F }, lente ? { lente: true } : {});
      },
      indovina: indovinaTelescopio,
    }, conta),
    riquadroAttrezzi("cam", t("att_cam"), {
      segnaposto: t("cerca_camera"), cerca: q => cercaCamere(q, 40), prendi: camScelta,
      riga: c => ({ titolo: c.nome, sotto: rigaCamera(c), extra: c.h_negozio ? t("in_vendita") : "", foto: c.foto }),
      campi: [["w", t("larghezza_px"), "px", "1"], ["h", t("altezza_px"), "px", "1"], ["px", t("pixel"), "µm", "0.01"]],
      daMano: (v, n) => v.w > 0 && v.h > 0 && v.px > 0 ? { nome: n || `${num(v.w)}×${num(v.h)} · ${num(v.px, 2)} µm`, w: v.w, h: v.h, px: v.px } : null,
    }, conta),
    riquadroAttrezzi("oc", t("att_oc"), {
      segnaposto: t("cerca_oculare"), cerca: q => cercaOculari(q, 40),
      prendi: x => ({ nome: x.t, f: x.f, afov: x.afov, h: x.h, foto: x.foto }),
      riga: x => ({ titolo: x.t, sotto: `${num(x.f, x.f % 1 ? 1 : 0)} mm · ${num(x.afov)}°`, foto: x.foto }),
      campi: [["f", t("focale_oculare"), "mm", "0.1"], ["afov", t("campo_apparente"), "°", "1"]],
      daMano: (v, n) => v.f > 0 && v.afov > 0 ? { nome: n || `${num(v.f, v.f % 1 ? 1 : 0)} mm ${num(v.afov)}°`, f: v.f, afov: v.afov } : null,
      indovina: indovinaOculare,
    }, conta),
    riquadroAttrezzi("k", t("att_k"), {
      segnaposto: t("att_cerca_k"), cerca: q => cercaOttiche(q, 30),
      senza: { testo: t("att_k_non_trovato"), altro: t("att_k_non_qui"), apri: () => {},
        tocca: () => { fat.scrollIntoView({ block: "center", behavior: "smooth" }); setTimeout(() => fat.focus({ preventScroll: true }), 300); } },
      prendi: x => ({ nome: x.t, k: FATTORI.reduce((a, b) => Math.abs(b - x.k) < Math.abs(a - x.k) ? b : a), h: x.h }),
      riga: x => ({ titolo: x.t, sotto: nomeFattore(x.k) + (x.per ? " · " + x.per : ""), foto: x.foto }),
      extra: aggiunto => el("div", { class: "gas-riga-bottoni gas-att-fattore" }, etichetta(t("att_fattore"), fat),
        el("button", { type: "button", class: "gas-btn gas-btn--mini", onclick: () => aggiunto({ k: parseFloat(fat.value) }) }, t("att_aggiungi_btn"))),
    }, conta),
    riquadroAttrezzi("m", t("att_m"), {
      segnaposto: t("att_cerca_m"), cerca: q => cercaMontature(q, 30), prendi: montDaVoce,
      riga: x => ({ titolo: x.t, sotto: rigaMontatura(montDaVoce(x)), extra: x.h && !x.noto ? t("in_vendita") : "" }),
      campi: [["kg", t("mc_portata"), "kg", "0.5"]],
      daMano: (v, n) => v.kg > 0 ? Object.assign({ kg: v.kg }, n ? { nome: n } : {}) : null,
    }, conta)];
  const ridisegnaPezzi = () => { sezioni.forEach(s => s.ridisegna()); conta(); };
  const nuovo = percorsoSetup(ridisegnaPezzi, daFuori);
  const setupSch = scheda(titoloVoce(t("miei_setup"), "g_setup"), boxSetup(conta, false, true),
    el("p", { class: "gas-nota gas-att-setup-n" }, t("att_setup_corto")),
    el("div", { class: "gas-riga-bottoni gas-att-setup-azioni" },
      el("button", { type: "button", class: "gas-btn", onclick: () => nuovo.apri() }, "+ ", t("ns_apri")),
      el("a", { class: "gas-btn gas-btn--chiaro", href: urlScheda("campo"), onclick: e => { e.preventDefault(); vai("campo"); } }, icona("campo"), " ", t("att_prova"))));
  setupSch.classList.add("gas-att-setup-cima");
  const asBox = boxAssistente(() => { sezioni.forEach(s => s.ridisegna()); filtriBox.aggiorna(); conta(); });
  const filtriSch = scheda(t("att_filtri"),
    FILTRI_RECUPERATI ? el("p", { class: "gas-setup-ok" }, "✓ ", t("att_recuperati", { n: FILTRI_RECUPERATI })) : null,
    el("p", { class: "gas-nota" }, t("miei_filtri_n"), " ", Voce.bottone("g_filtri")), filtriBox);
  const svuotaRiga = el("div", { class: "gas-att-blocco" }, svuotaBtn, el("small", { class: "gas-muto" }, t(conto ? "att_svuota_n_conto" : "att_svuota_n")));
  const contoSch = scheda(t("att_conto_t"), boxAccount("attrezzatura"),
    el("div", { class: "gas-att-blocco" }, el("b", null, t(conto ? "att_link_amico" : "att_link")),
      el("p", { class: "gas-nota" }, t(conto ? "att_link_amico_n" : "att_link_n")),
      el("div", { class: "gas-riga-bottoni" },
        el("button", { type: "button", class: "gas-btn gas-btn--chiaro", onclick: e => copia(linkAttrezzatura(), e.currentTarget) }, t("att_copia_link")),
        navigator.share ? el("button", { type: "button", class: "gas-btn gas-btn--chiaro", onclick: () => {
          navigator.share({ title: t("att_titolo"), url: linkAttrezzatura() }).catch(() => {});
        } }, icona("condividi"), " ", t("cd_condividi")) : null)),
    svuotaRiga);
  contoSch.classList.add("gas-att-conto");
  const tocca = kk => {
    if (kk !== "setup") { apri(kk, "vai"); return; }
    if (SETUP_ELENCO.length) setupSch.scrollIntoView({ block: "start", behavior: "smooth" }); else nuovo.apri();
  };
  const indice = el("nav", { class: "gas-att-indice", "aria-label": t("att_i_aria"), hidden: attrezzaturaVuota() },
    [["setup", "att_i_setup"], ["tel", "att_i_tel"], ["cam", "att_i_cam"], ["oc", "att_i_oc"], ["k", "att_i_k"], ["m", "att_i_m"], ["f", "att_i_f"], ["conto", "att_i_conto"]]
      .map(([kk, chiave]) => el("button", { type: "button", class: "gas-att-pil", dataset: { k: kk }, onclick: () => tocca(kk) }, el("b"), el("span", null, t(chiave)))));
  const erroreSync = el("p", { class: "gas-sy-ok gas-sy-ko gas-att-sync-ko", role: "status", hidden: true }, t("sy_errore"));
  const segnaErrore = () => {
    if (!erroreSync.isConnected) { if (erroreSync._mostrato) SYNC.ui.delete(segnaErrore); return; }
    erroreSync._mostrato = true;
    erroreSync.hidden = !(SYNC.stato === "account" && SYNC.errore);
  };
  SYNC.ui.add(segnaErrore);
  const apri = (kk, come) => {
    const r = righe.find(x => x.k === kk) || null, y0 = r ? r.testa.getBoundingClientRect().top : 0, ka = r ? kk : null;
    for (const x of righe) { x.card.classList.toggle("aperta", x === r); x.testa.setAttribute("aria-expanded", String(x === r)); }
    for (const b of indice.children) b.classList.toggle("on", b.dataset.k === ka);
    if (come) segnaAperta(ka || "");
    if (!r) return;
    const msgs = r.k === "as" ? $(".gas-as-msgs", r.card) : null;
    if (msgs) msgs.scrollTop = msgs.scrollHeight;
    if (come === "vai") { r.card.scrollIntoView({ block: "start", behavior: "smooth" }); r.testa.focus({ preventScroll: true }); return; }
    if (come !== "dito") return;
    const dy = r.testa.getBoundingClientRect().top - y0;
    if (Math.abs(dy) > 1) window.scrollTo(0, window.scrollY + dy);
    if (r.testa.getBoundingClientRect().top > window.innerHeight * 0.6) r.card.scrollIntoView({ block: "start", behavior: "smooth" });
  };
  const rigaAcc = (kk, card, ico, titolo) => {
    const val = el("span", { class: "gas-acc-val" }), n = el("span", { class: "gas-att-acc-n" });
    const testa = el("button", { type: "button", class: "gas-acc-testa gas-att-acc-testa", "aria-expanded": "false",
      onclick: () => apri(card.classList.contains("aperta") ? null : kk, "dito") },
      el("span", { class: "gas-att-acc-ico" }, icona(ico)),
      el("span", { class: "gas-att-acc-testo" }, el("b", { class: "gas-acc-tit" }, titolo), val), n,
      el("span", { class: "gas-acc-freccia", "aria-hidden": "true" }, "▾"));
    card.classList.add("gas-acc", "gas-att-acc", "gas-att-acc--" + kk);
    card.prepend(testa);
    righe.push({ k: kk, card, testa, val, n });
  };
  const [tel, cam, oc, k, mo] = sezioni;
  rigaAcc("as", asBox, "assistente", t("as_titolo"));
  rigaAcc("tel", tel, "cx_tel", t("att_tel"));
  rigaAcc("cam", cam, "camere", t("att_cam"));
  rigaAcc("oc", oc, "cx_oc", t("att_oc"));
  rigaAcc("k", k, "piu", t("att_k"));
  rigaAcc("m", mo, "cx_car", t("att_m"));
  rigaAcc("f", filtriSch, "cx_fil", t("att_filtri"));
  rigaAcc("conto", contoSch, "utente", t("att_conto_t"));
  const colA = el("div", { class: "gas-att-col" }, tel, oc, mo, filtriSch), colB = el("div", { class: "gas-att-col" });
  const griglia = el("div", { class: "gas-att" }, colA, colB);
  const largo = window.matchMedia ? matchMedia("(min-width: 990px)") : null;
  const disponi = () => {
    if (!griglia.isConnected && disponi._fatto) { if (largo && largo.removeEventListener) largo.removeEventListener("change", disponi); return; }
    disponi._fatto = true;
    if (largo && largo.matches) colB.append(cam, k, contoSch);
    else { tel.after(cam); oc.after(k); filtriSch.after(contoSch); }
  };
  disponi();
  if (largo && largo.addEventListener) largo.addEventListener("change", disponi);
  aggiungi(pannello, [fatto, importata, erroreSync, ATT_DA_LINK ? boxImporta(() => vistaAttrezzatura(pannello)) : null, indice,
    primo ? [nuovo, setupSch] : [setupSch, nuovo], asBox, griglia]);
  segnaErrore();
  const inizio = ATT_APRI != null ? ATT_APRI : (daFuori || nuovo.classList.contains("gas-ns--aperto")) ? null
    : attrezzaturaVuota() && ATT_APERTA === undefined ? "as" : ATT_APERTA || null;
  ATT_APRI = null;
  apri(inizio, inizio && inizio !== ATT_APERTA ? "fuori" : null);
  conta();
  SETUP_UI.add(conta);
  pannello._apri = kk => apri(kk, "fuori");
  if (daFuori) setTimeout(() => nuovo.scrollIntoView({ block: "start", behavior: "smooth" }), 80);
  NS_APRI = false;
  aggiornaHash("attrezzatura");
}
const da64 = s => new TextDecoder().decode(Uint8Array.from(atob(s.replace(/-/g, "+").replace(/_/g, "/")), c => c.charCodeAt(0)));
function codiceBreve(s) {
  let h = 0x811c9dc5;
  for (let i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 0x01000193); }
  return (h >>> 0).toString(36);
}
const nomeLink = n => {
  const s = String(n || "").replace(/,/g, "‚");
  return s ? "_" + encodeURIComponent(s.length > 60 ? s.slice(0, 60).replace(/\s+\S*$/, "") : s) : "";
};
const filtriNotiLink = () => [...FILTRI_NOTI.map(([nome, tipo]) => ({ nome, tipo })), ...((DATI.noti && DATI.noti.filtri) || [])];
function linkAttrezzatura() {
  const p = [], nomi = CAMPO.filtriNomi || [];
  const neiDati = (l, h) => !!h && (l || []).some(z => z.h === h);
  for (const x of ATTREZZI.tel) {
    if (neiDati(DATI.telescopi, x.h)) p.push("t" + codiceBreve(x.h) + (configurazioni(x.h).length ? "@" + x.F : ""));
    else if (x.obiettivo && obiettiviPerRicerca().some(z => z.t === x.nome)) p.push("l" + codiceBreve(x.nome));
    else p.push(`${eObiettivo(x) ? "L" : "T"}${eObiettivo(x) && x.Nmax ? Math.round(x.F / x.Nmax * 10) / 10 : x.D}x${x.F}${nomeLink(x.nome)}`);
  }
  for (const x of ATTREZZI.cam) p.push(x.id && DATI.camere.some(z => z.id === x.id) ? "c" + codiceBreve(x.id) : `C${x.w}x${x.h}x${x.px}${nomeLink(x.nome)}`);
  for (const x of ATTREZZI.oc) p.push(neiDati(DATI.oculari, x.h) ? "o" + codiceBreve(x.h) : `O${x.f}x${x.afov}${nomeLink(x.nome)}`);
  for (const x of ATTREZZI.k) p.push(neiDati(DATI.ottiche, x.h) ? "r" + codiceBreve(x.h) : "R" + x.k + nomeLink(x.nome));
  for (const x of ATTREZZI.m) p.push(neiDati([...(DATI.montature || []), ...montatureNote()], x.h) ? "m" + codiceBreve(x.h) : `M${x.kg}${nomeLink(x.nome)}`);
  const noti = filtriNotiLink();
  for (const f of nomi) {
    const z = noti.find(y => y.nome === f.nome);
    p.push(neiDati(DATI.filtri, f.h) ? "f" + codiceBreve(f.h) : z && z.tipo === f.tipo ? "n" + codiceBreve(f.nome) : `N${f.tipo}${f.nm > 0 ? "x" + f.nm : ""}${nomeLink(f.nome)}`);
  }
  for (const tp of CAMPO.filtri || []) if (!nomi.some(f => f.tipo === tp)) p.push("y" + tp);
  return (SR_IN_CAMPO ? location.origin + srBase() + "pages/" + srHandle() : location.origin + location.pathname) + "#attrezzatura?k=" + p.join(",");
}
function leggiCodici(s) {
  const mappa = (lista, chiave) => {
    const m = new Map();
    for (const x of lista) { const k = chiave(x); if (k) { const c = codiceBreve(k); if (!m.has(c)) m.set(c, []); m.get(c).push(x); } }
    return m;
  };
  const tel = mappa(DATI.telescopi, x => x.h), lenti = mappa(obiettiviPerRicerca(), x => x.t), cam = mappa(DATI.camere, x => x.id),
    oc = mappa(DATI.oculari, x => x.h), ot = mappa(DATI.ottiche, x => x.h), fi = mappa(DATI.filtri || [], x => x.h),
    noti = mappa(filtriNotiLink(), x => x.nome), mo = mappa([...(DATI.montature || []), ...montatureNote()], x => x.h);
  const d = { tel: [], cam: [], oc: [], k: [], m: [], f: [], ft: [] }, primo = (m, c) => (m.get(c) || [])[0];
  for (const pz of String(s).split(",")) {
    const tipo = pz[0], i = pz.indexOf("_"), corpo = i < 0 ? pz.slice(1) : pz.slice(1, i);
    const nome = i < 0 ? "" : pz.slice(i + 1).replace(/‚/g, ","), n = corpo.split("x").map(parseFloat);
    let x;
    if (tipo === "t") {
      const [c, F] = corpo.split("@"), l = tel.get(c) || [];
      x = (F && l.find(z => String(z.F) === F)) || l[0];
      if (x) d.tel.push(telDaVoce(x));
    } else if (tipo === "l") { if ((x = primo(lenti, corpo))) d.tel.push(telDaVoce(x)); }
    else if (tipo === "T" || tipo === "L") {
      if (n[0] > 0 && n[1] > 0) d.tel.push(Object.assign({ nome: nome || (tipo === "L" ? `${num(n[1])} mm f/${num(n[1] / n[0], 1)}` : `${num(n[0])}/${num(n[1])} mm`), D: n[0], F: n[1] },
        tipo === "L" ? { lente: true } : {}));
    }
    else if (tipo === "c") { if ((x = primo(cam, corpo))) d.cam.push(camScelta(x)); }
    else if (tipo === "C") { if (n[0] > 0 && n[1] > 0 && n[2] > 0) d.cam.push({ nome: nome || `${num(n[0])}×${num(n[1])} · ${num(n[2], 2)} µm`, w: n[0], h: n[1], px: n[2] }); }
    else if (tipo === "o") { if ((x = primo(oc, corpo))) d.oc.push({ nome: x.t, f: x.f, afov: x.afov, h: x.h, foto: x.foto }); }
    else if (tipo === "O") { if (n[0] > 0 && n[1] > 0) d.oc.push({ nome: nome || `${num(n[0], n[0] % 1 ? 1 : 0)} mm ${num(n[1])}°`, f: n[0], afov: n[1] }); }
    else if (tipo === "r") { if ((x = primo(ot, corpo))) d.k.push({ nome: x.t, k: FATTORI.reduce((a, b) => Math.abs(b - x.k) < Math.abs(a - x.k) ? b : a), h: x.h }); }
    else if (tipo === "R") { if (n[0] > 0.2 && n[0] <= 6 && n[0] !== 1) d.k.push(Object.assign({ k: n[0] }, nome ? { nome } : {})); }
    else if (tipo === "m") { if ((x = primo(mo, corpo))) d.m.push(montDaVoce(x)); }
    else if (tipo === "M") { if (n[0] > 0 && n[0] < 500) d.m.push(Object.assign({ kg: n[0] }, nome ? { nome } : {})); }
    else if (tipo === "f") { if ((x = primo(fi, corpo))) d.f.push({ nome: x.t, tipo: x.tipo, h: x.h }); }
    else if (tipo === "n") { if ((x = primo(noti, corpo))) d.f.push(Object.assign({ nome: x.nome, tipo: x.tipo }, x.nm > 0 ? { nm: x.nm } : {})); }
    else if (tipo === "N") {
      const [tp, nm] = corpo.split("x");
      if (nome && FILTRI_TIPI.some(z => z.id === tp)) d.f.push(Object.assign({ nome, tipo: tp }, +nm > 0 ? { nm: +nm } : {}));
    }
    else if (tipo === "y" && FILTRI_TIPI.some(z => z.id === corpo)) d.ft.push(corpo);
  }
  return d;
}
function leggiLinkAttrezzatura(q) {
  try {
    const par = new URLSearchParams(q);
    if (par.get("k")) { ATT_DA_LINK = leggiCodici(par.get("k")); salva("att_link", q); return; }
    const d = JSON.parse(da64(par.get("a") || ""));
    if (!d || d.v !== 1) { salva("att_link", null); return; }
    ATT_DA_LINK = { f: Array.isArray(d.f) ? d.f : [], ft: Array.isArray(d.ft) ? d.ft : [] };
    for (const k of Object.keys(TIPI_ATT)) ATT_DA_LINK[k] = (Array.isArray(d[k]) ? d[k] : []).filter(x => x && typeof x === "object");
    salva("att_link", q);
  } catch (e) { ATT_DA_LINK = null; salva("att_link", null); }
}
function boxImporta(dopo) {
  const d = ATT_DA_LINK;
  for (const k of Object.keys(TIPI_ATT)) if (!Array.isArray(d[k])) d[k] = [];
  const n = { tel: d.tel.length, cam: d.cam.length, oc: d.oc.length, k: d.k.length, m: d.m.length, f: d.f.length + d.ft.filter(tp => !d.f.some(x => x && x.tipo === tp)).length };
  if (!Object.values(n).some(Boolean)) { ATT_DA_LINK = null; salva("att_link", null); return null; }
  const r = Object.entries(n).filter(([, v]) => v).map(([k, v]) => `${v} ${PLURALI_ATT[k][v === 1 ? 0 : 1]}`).join(", ");
  const fine = () => { ATT_DA_LINK = null; salva("att_link", null); aggiornaHash("attrezzatura"); dopo(); };
  return el("div", { class: "gas-att-importa" }, el("p", null, t("att_import", { r })),
    el("div", { class: "gas-riga-bottoni" },
      el("button", { type: "button", class: "gas-btn", onclick: () => {
        for (const k of Object.keys(TIPI_ATT)) for (const x of d[k]) {
          if (k === "tel" && x.h && !x.foto) { const v = DATI.telescopi.find(z => z.h === x.h); if (v) x.foto = v.foto; }
          if (k === "oc" && x.h && !x.foto) { const v = DATI.oculari.find(z => z.h === x.h); if (v) x.foto = v.foto; }
          metti(k, x);
        }
        uniscFiltri(d.f, d.ft);
        salvaAttrezzi(); salvaCampo(); aggiornaSetupUI();
        ATT_IMPORTATA = true;
        fine();
      } }, t("att_import_si")),
      el("button", { type: "button", class: "gas-btn gas-btn--chiaro", onclick: fine }, t("att_import_no"))));
}
Object.assign(TESTI.it, {
  as_titolo: "Compila con l'assistente", as_apri: "Compila con l'assistente",
  as_ciao: "Ciao! Dimmi cosa hai: telescopi, riduttori, camere, oculari e filtri. Puoi scrivere tutto insieme, oppure toccare il microfono e dirlo a voce.",
  as_hai_gia: "Hai già: {r}. Dimmi cosa vuoi aggiungere.", as_esempio: "Per esempio: «Askar 71F con riduttore 0,8, ZWO ASI2600MC Pro, filtri L-eXtreme e UHC»",
  as_segnaposto: "Scrivi qui cosa hai…", as_invia: "Invia", as_voce: "Parla", as_ascolto: "Ti ascolto…",
  as_capito: "Ecco cosa ho capito. Togli la spunta se qualcosa non va, o scegli il modello giusto:",
  as_non_capito: "Non ho riconosciuto: «{s}». Prova con marca e modello.",
  as_niente: "Non ho riconosciuto niente. Scrivi marca e modello, per esempio «Sky-Watcher Evostar 80ED» o «Canon EOS 6D».",
  as_aggiungi: "Aggiungi alla mia attrezzatura", as_fatto: "✓ Fatto! Ora hai: {r}.", as_va_bene: "Va bene.",
  as_chiedi_tel: "Che telescopio (o obiettivo fotografico) usi?", as_chiedi_cam: "Con che camera riprendi? Se fai solo osservazione visuale, dimmi quali oculari hai.",
  as_chiedi_filtri: "Hai dei filtri? Scrivi i nomi (anche solo il tipo, come «UHC» o «dual band»), oppure «no».",
  as_finito: "Perfetto, la tua attrezzatura è pronta: nel Campo inquadrato e in «Cosa vedere» trovi i tuoi pezzi sopra le caselle di ricerca.",
  as_salva_setup: "Salva anche il setup «{n}»", as_setup_ok: "Setup «{n}» salvato ✓", as_apri_campo: "Apri il Campo inquadrato",
  as_tipo_tel: "Telescopio", as_tipo_cam: "Camera", as_tipo_oc: "Oculare", as_tipo_k: "Riduttore/Barlow", as_tipo_f: "Filtro",
  as_altri_modelli: "Altri {n} modelli…", as_altri_modelli_1: "Un altro modello…", as_cambia_modello: "Cambia modello", as_gia: "già nella tua attrezzatura", as_a_mano: "inserito a mano", as_solo_tipo: "solo il tipo",
});
Object.assign(TESTI.it, { as_tipo_m: "Montatura" });
Object.assign(TESTI.de, { as_tipo_m: "Montierung" });
Object.assign(TESTI.es, { as_tipo_m: "Montura" });
Object.assign(TESTI.en, { as_tipo_m: "Mount" });
Object.assign(TESTI.de, {
  as_titolo: "Mit dem Assistenten ausfüllen", as_apri: "Mit dem Assistenten ausfüllen",
  as_ciao: "Hallo! Sagen Sie mir, was Sie haben: Teleskope, Reducer, Kameras, Okulare und Filter. Sie können alles zusammen schreiben oder auf das Mikrofon tippen und es sagen.",
  as_hai_gia: "Sie haben schon: {r}. Sagen Sie mir, was Sie hinzufügen möchten.", as_esempio: "Zum Beispiel: „Askar 71F mit Reducer 0,8, ZWO ASI2600MC Pro, Filter L-eXtreme und UHC“",
  as_segnaposto: "Schreiben Sie hier, was Sie haben…", as_invia: "Senden", as_voce: "Sprechen", as_ascolto: "Ich höre zu…",
  as_capito: "Das habe ich verstanden. Entfernen Sie das Häkchen, wenn etwas nicht stimmt, oder wählen Sie das richtige Modell:",
  as_non_capito: "Das habe ich nicht erkannt: „{s}“. Versuchen Sie es mit Marke und Modell.",
  as_niente: "Ich habe nichts erkannt. Schreiben Sie Marke und Modell, zum Beispiel „Sky-Watcher Evostar 80ED“ oder „Canon EOS 6D“.",
  as_aggiungi: "Zu meiner Ausrüstung hinzufügen", as_fatto: "✓ Erledigt! Jetzt haben Sie: {r}.", as_va_bene: "In Ordnung.",
  as_chiedi_tel: "Welches Teleskop (oder Fotoobjektiv) verwenden Sie?", as_chiedi_cam: "Mit welcher Kamera fotografieren Sie? Wenn Sie nur visuell beobachten, sagen Sie mir, welche Okulare Sie haben.",
  as_chiedi_filtri: "Haben Sie Filter? Schreiben Sie die Namen (oder nur den Typ, wie „UHC“ oder „Dualband“), oder „nein“.",
  as_finito: "Perfekt, Ihre Ausrüstung ist fertig: Im Bildfeld und unter „Was sehen“ finden Sie Ihre Teile über den Suchfeldern.",
  as_salva_setup: "Auch das Setup „{n}“ speichern", as_setup_ok: "Setup „{n}“ gespeichert ✓", as_apri_campo: "Bildfeld öffnen",
  as_tipo_tel: "Teleskop", as_tipo_cam: "Kamera", as_tipo_oc: "Okular", as_tipo_k: "Reducer/Barlow", as_tipo_f: "Filter",
  as_altri_modelli: "{n} weitere Modelle…", as_altri_modelli_1: "Ein weiteres Modell…", as_cambia_modello: "Modell ändern", as_gia: "schon in Ihrer Ausrüstung", as_a_mano: "von Hand eingegeben", as_solo_tipo: "nur der Typ",
});
Object.assign(TESTI.es, {
  as_titolo: "Rellenar con el asistente", as_apri: "Rellenar con el asistente",
  as_ciao: "¡Hola! Dime qué tienes: telescopios, reductores, cámaras, oculares y filtros. Puedes escribirlo todo junto o tocar el micrófono y decirlo en voz alta.",
  as_hai_gia: "Ya tienes: {r}. Dime qué quieres añadir.", as_esempio: "Por ejemplo: «Askar 71F con reductor 0,8, ZWO ASI2600MC Pro, filtros L-eXtreme y UHC»",
  as_segnaposto: "Escribe aquí lo que tienes…", as_invia: "Enviar", as_voce: "Hablar", as_ascolto: "Te escucho…",
  as_capito: "Esto es lo que he entendido. Quita la marca si algo no está bien, o elige el modelo correcto:",
  as_non_capito: "No he reconocido: «{s}». Prueba con marca y modelo.",
  as_niente: "No he reconocido nada. Escribe marca y modelo, por ejemplo «Sky-Watcher Evostar 80ED» o «Canon EOS 6D».",
  as_aggiungi: "Añadir a mi equipo", as_fatto: "✓ ¡Hecho! Ahora tienes: {r}.", as_va_bene: "De acuerdo.",
  as_chiedi_tel: "¿Qué telescopio (u objetivo fotográfico) usas?", as_chiedi_cam: "¿Con qué cámara fotografías? Si solo haces observación visual, dime qué oculares tienes.",
  as_chiedi_filtri: "¿Tienes filtros? Escribe los nombres (o solo el tipo, como «UHC» o «dual band»), o «no».",
  as_finito: "Perfecto, tu equipo está listo: en el Campo de visión y en «Qué ver» encontrarás tus piezas encima de las casillas de búsqueda.",
  as_salva_setup: "Guardar también la configuración «{n}»", as_setup_ok: "Configuración «{n}» guardada ✓", as_apri_campo: "Abrir Campo de visión",
  as_tipo_tel: "Telescopio", as_tipo_cam: "Cámara", as_tipo_oc: "Ocular", as_tipo_k: "Reductor/Barlow", as_tipo_f: "Filtro",
  as_altri_modelli: "Otros {n} modelos…", as_altri_modelli_1: "Otro modelo…", as_cambia_modello: "Cambiar modelo", as_gia: "ya en tu equipo", as_a_mano: "introducido a mano", as_solo_tipo: "solo el tipo",
});
const AS_VUOTE = new Set(("ho hai abbiamo un uno una il lo la i gli le l mio mia miei mie mi con e ed poi anche piu più di del della dei degli delle da per " +
  "uso usato usata uso: ce c'e c'è e' è sono tengo possiedo pure ancora vecchio nuovo ich habe hab ein eine einen einem einer mein meine meinen meiner mit und " +
  "auch dazu noch tengo tiene tengo mis con y tambien también el los las unos unas uso have has a an my with and also the i've i got " +
  "own owns use using used plus our we some i'm im it's its " +
  "sia che entrambi entrambe tutte tutti configurazione configurazioni sowohl als beide tanto como ambos ambas both " +
  "su sul sulla sullo sui sulle sugli nel nella nello auf am on sobre en is are " +
  "no non nessun nessuno nessuna niente nulla ancora purtroppo solo ce l'ho lho io nein kein keine keinen keiner nichts nicht leider nur " +
  "ninguno ninguna ningun nada todavia aun none nothing nope not yet only dont don't haven't havent grazie danke gracias thanks " +
  "visuale visuali visual visuell visuelle osservazione observation beobachtung observacion " +
  "due tre zwei drei dos tres two three treppiede treppiedi tripod tripode stativ").split(" "));
const AS_SEGNALI = {
  tel: ["telescopio", "telescopi", "rifrattore", "rifrattori", "riflettore", "newton", "tubo", "obiettivo", "obiettivi", "teleskop", "teleskope", "refraktor",
    "reflektor", "objektiv", "objetivo", "objetivos", "telescopios", "refractor", "reflector", "scope", "telescope", "lens",
    "telescopes", "scopes", "refractors", "reflectors", "lenses"],
  k: ["riduttore", "riduttori", "spianatore", "spianatori", "correttore", "barlow", "reducer", "flattener", "reductor", "reductores", "aplanador", "telecompressor",
    "reducers", "flatteners", "corrector", "barlows"],
  cam: ["camera", "camere", "fotocamera", "fotocamere", "reflex", "mirrorless", "kamera", "kameras", "camara", "camaras", "dslr", "cameras"],
  oc: ["oculare", "oculari", "okular", "okulare", "ocular", "oculares", "eyepiece", "eyepieces"],
  f: ["filtro", "filtri", "filter", "filtros", "filters"],
  m: ["montatura", "montature", "mount", "mounts", "montierung", "montierungen", "montura", "monturas"],
};
const AS_MONT = /^(?:n?eq|heq|eqm|cem|gem|sh|am)-?\d[a-z0-9-]*$|^az-?gti[a-z]*$/;
const AS_MONT_DOPO = /^(pro|goto|synscan|r|ii|gen|ec)$/;
const AS_NEGATIVE = /^(no|non|nessun[oa]?|niente|nulla|nein|kein\w*|nichts|nicht|ninguno|ninguna|ningun|nada|none|nothing|nope|not|don'?t|haven'?t|havent)$/;
const AS_VISUALE = /^(visuale|visuali|visual|visuell\w*|osservazione|observation|beobachtung|observacion)$/;
const AS_TIPI_FILTRO = { dual: ["dual", "dualband", "dual-band", "duoband", "bibanda"], sho: ["sho"], oiii: ["oiii", "o3", "o-iii"], sii: ["sii", "s2", "s-ii"],
  hbeta: ["hbeta", "h-beta", "hβ"], uhc: ["uhc", "uhc-s"], lrgb: ["lrgb"], uvir: ["uv/ir", "uvir", "uv-ir", "ir-cut", "ircut"], irpass: ["ir-pass", "irpass"],
  ha: ["ha", "h-alpha", "halpha", "h-a", "hα"], lp: ["lp", "cls", "lps", "antinquinamento", "anti-inquinamento", "antiinquinamento", "antipolucion"],
  luna: ["lunare", "moon", "mond", "lunar"], solare: ["solare", "solar", "sonnenfilter", "astrosolar"] };
const AS_FILTRO_SICURI = new Set(["dual", "sho", "oiii", "sii", "hbeta", "uhc", "lrgb", "uvir", "irpass"]);
const AS_NO = /^(no|nessun[oa]?|niente|nulla|non (ne )?ho|nein|kein[en]?|nichts|ninguno|ninguna|nada|none|nothing|nope|not yet|(i )?don'?t (have|own))\b/i;
function asCerca(tipo, parole) {
  const q = parole.join(" ");
  let r, nome;
  RICERCA_ESATTA = true;
  try {
    if (tipo === "tel") { r = cercaTelescopi(q, 30); nome = x => x.t; }
    else if (tipo === "cam") { r = cercaCamere(q, 30); nome = x => x.nome; }
    else if (tipo === "oc") { r = cercaOculari(q, 30); nome = x => x.t; }
    else if (tipo === "k") { r = cercaOttiche(q, 30); nome = x => x.t; }
    else if (tipo === "m") { r = cercaMontature(q, 30); nome = x => x.t; }
    else { r = cercaFiltri(q); nome = x => x.nome; }
  } finally { RICERCA_ESATTA = false; }
  const intere = s => { const w = normParole(s).split(/[^a-z0-9α-ω/.+-]+/); return parole.filter(p => w.includes(p)).length; };
  const generico = tipo === "oc" && !parole.some(p => /^[a-z]{3,}$/.test(p) && !AS_OCULARE_GENERICO.test(p));
  const comune = x => generico && /plossl/.test(normParole(nome(x))) ? 6 : 0;
  const extra = x => normParole(nome(x)).split(/[^a-z0-9]+/).filter(w => AS_MODELLO.has(w) && !parole.includes(w)).length;
  const out = r.map(x => ({ x, p: intere(nome(x)) * 10 + (x.h || x.h_negozio ? 3 : 0) + comune(x) - extra(x) * 4 - nome(x).length / 40 })).sort((a, b) => b.p - a.p).map(v => v.x).slice(0, 6);
  out.n = r.length;
  return out;
}
const AS_MODELLO = new Set(["pro", "plus", "max", "mini", "air", "ii", "iii", "mark", "duo", "ultra", "lite"]);
const AS_OCULARE_GENERICO = /^(oculare|oculari|okular|okulare|ocular|oculares|eyepiece|eyepieces|uno|una|con|del|della|the|ein|eine|einen|mit|und|los|las|and|dal|mio|mia)$/;
const asNomeDi = (tipo, x) => tipo === "cam" ? x.nome : tipo === "f" || tipo === "filtri" ? x.nome : x.t;
let _asMarche = null, _asTesto = null, _asChiave = "";
function asDati() {
  const chiave = [DATI.telescopi, DATI.camere, DATI.oculari, DATI.ottiche, DATI.filtri].map(l => (l || []).length).join("|");
  if (chiave === _asChiave && _asTesto) return;
  _asChiave = chiave;
  const primo = s => normParole(String(s || "")).replace(/[®™]/g, "").split(/[^a-z0-9-]+/).filter(Boolean)[0];
  const m = new Set(["zwo", "qhy", "qhyccd", "samyang", "rokinon", "sigma", "canon", "nikon", "sony", "fujifilm", "panasonic", "olympus", "pentax", "tamron",
    "viltrox", "skywatcher", "celestron", "askar", "sharpstar", "optolong", "antlia", "baader", "astronomik", "svbony", "touptek", "player", "william",
    "explore", "meade", "takahashi", "vixen", "tecnosky", "omegon", "bresser", "dwarflab", "dwarf", "seestar", "vaonis", "unistellar", "idas", "chroma",
    "altair", "geoptik", "pegasus", "giordano", "lunt", "coronado", "daystar", "televue", "stellarvue", "lacerta", "artesky", "orion", "gso"]);
  const testi = [];
  const usa = (marca, ...t) => { const p = primo(marca); if (p) m.add(p); testi.push(...t); };
  for (const x of DATI.telescopi || []) usa(x.t, x.t, x.v || "");
  for (const x of DATI.camere || []) usa(x.marca, x.nome, x.sensore || "", x.alias || "");
  for (const l of [DATI.oculari, DATI.ottiche, DATI.filtri]) for (const x of l || []) usa(x.t, x.t, x.v || "");
  for (const [n] of typeof FILTRI_NOTI !== "undefined" ? FILTRI_NOTI : []) usa(n, n);
  for (const x of typeof obiettiviPerRicerca === "function" ? obiettiviPerRicerca() : []) usa(x.t, x.t);
  for (const w of ["filtro", "filtri", "telescopio", "rifrattore", "riflettore", "oculare", "riduttore", "spianatore", "correttore", "camera", "obiettivo",
    "kit", "set", "new", "nuovo", "adattatore", "anello", "ruota", "tubo", "the"]) m.delete(w);
  _asMarche = new Set([...m].filter(w => w.length >= 3 && /^[a-z]/.test(w)));
  _asTesto = normParole(testi.join(" "));
}
function asMarca(w) { asDati(); return _asMarche.has(w); }
function asDistanza(a, b) {
  const d = Array.from({ length: a.length + 1 }, (_, i) => Array.from({ length: b.length + 1 }, (_, j) => (i ? (j ? 0 : i) : j)));
  for (let i = 1; i <= a.length; i++) for (let j = 1; j <= b.length; j++) {
    d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
    if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + 1);
  }
  return d[a.length][b.length];
}
function asCorreggi(w) {
  if (w.length < 3 || !/^[a-z]+$/.test(w)) return w;
  asDati();
  if (_asMarche.has(w) || _asTesto.includes(w)) return w;
  const max = w.length >= 7 ? 2 : 1;
  let meglio = null, dm = max + 1, pari = false;
  for (const m of _asMarche) {
    if (m[0] !== w[0] || Math.abs(m.length - w.length) > max) continue;
    const d = asDistanza(w, m);
    if (d < dm) { dm = d; meglio = m; pari = false; } else if (d === dm) pari = true;
  }
  return meglio && !pari ? meglio : w;
}
const AS_TUTTE = /^(entramb[ei]|tutte|tutti|both|beide|ambos|ambas)$/;
function asParoleConfig(c) {
  const w = normParole(nomeConfigurazione(c)).split(/[\s·]+/).filter(Boolean);
  return [...w, ...w.filter(x => /^f\/\d/.test(x)).map(x => x.replace("/", ""))];
}
function asVociDi(tipo, r, parole) {
  const voce = l => ({ tipo, scelte: l.map(x => asPezzo(tipo, x)) });
  const conf = tipo === "tel" && r[0] && r[0].h ? configurazioni(r[0].h) : [];
  if (!conf.length) return [voce(r)];
  const citate = conf.filter(c => asParoleConfig(c).some(w => parole.includes(w)));
  const prima = c => [c, ...conf.filter(y => y !== c), ...r.filter(y => !conf.includes(y))];
  if (citate.length >= 2 || parole.some(w => AS_TUTTE.test(w))) return (citate.length >= 2 ? citate : conf).map(c => voce(prima(c)));
  return [voce(citate.length ? prima(citate[0]) : r)];
}
function asPezzo(tipo, x) {
  if (tipo === "tel") return telDaVoce(x);
  if (tipo === "cam") return camScelta(x);
  if (tipo === "oc") return { nome: x.t, f: x.f, afov: x.afov, h: x.h, foto: x.foto };
  if (tipo === "k") return { nome: x.t, k: FATTORI.reduce((a, b) => Math.abs(b - x.k) < Math.abs(a - x.k) ? b : a), h: x.h };
  if (tipo === "m") return montDaVoce(x);
  return { nome: x.nome, tipo: x.tipo, h: x.h || null };
}
const asFattore = v => FATTORI.reduce((a, b) => Math.abs(b - v) < Math.abs(a - v) ? b : a);
const maiuscola = s => s.replace(/(^|\s)(\S)/g, (m, a, b) => a + b.toUpperCase());
const AS_GENERICHE = new Set(["pro", "plus", "max", "ultra", "lite", "mini", "kit", "set", "new", "nuovo", "nuova", "edition", "version", "versione", "gen", "v2", "ii", "iii"]);
const asSigla = w => /[a-z]/.test(w) && /\d/.test(w) && !/^x?\d+(\.\d+)?x?$/.test(w) && !/^\d+\/\d+$/.test(w) && !/^\d+(\.\d+)?(nm|mm|cm|m|kg|g|mp|in)$/.test(w);
const asApertura = w => /^f\/?\d/.test(w);
const asForte = w => (asSigla(w) && !asApertura(w)) || /^l-[a-z]/.test(w) || (/^[a-z][a-z-]{2,}$/.test(w) && !asMarca(w) && !AS_GENERICHE.has(w));
const asSegnaleDi = w => Object.keys(AS_SEGNALI).find(k => AS_SEGNALI[k].includes(w)) || null;
function asUnisci(lista) {
  const fuori = { segnale: null, parole: [], voci: [], ignoti: [] };
  for (const r of lista) {
    fuori.segnale = r.segnale || fuori.segnale;
    fuori.parole.push(...r.parole);
    fuori.voci.push(...r.voci);
    if (!r.voci.length && r.parole.length) fuori.ignoti.push(r.parole.join(" ")); else fuori.ignoti.push(...r.ignoti);
  }
  return fuori;
}
function asCapisciPezzo(pezzo, esterno) {
  const parole = normParole(pezzo).replace(/[«»"“”„()!?:]/g, " ").replace(/(\d)\s+mm\b/g, "$1mm").split(/\s+/).filter(Boolean);
  for (let i = 1; i < parole.length; i++) {
    const sg = asSegnaleDi(parole[i]);
    if (!sg || sg === "tel") continue;
    const prima = parole.slice(0, i), dopo = parole.slice(i + 1);
    if (prima.some(w => !AS_VUOTE.has(w) && !asSegnaleDi(w) && asForte(asCorreggi(w))) && dopo.some(w => !AS_VUOTE.has(w) && !asSegnaleDi(w)))
      return asUnisci([asCapisciPezzo(prima.join(" "), esterno), asCapisciPezzo(parole.slice(i).join(" "), esterno)]);
  }
  let segnale = null;
  const resto = [];
  for (const w of parole) {
    const s = asSegnaleDi(w);
    if (s) { segnale = segnale || s; continue; }
    if (!AS_VUOTE.has(w)) resto.push(asCorreggi(w));
  }
  const pref = segnale || esterno;
  const fuori = { segnale, parole: resto, voci: [], ignoti: [] };
  const una = voce => Object.assign(fuori, { voci: [voce] });
  if (!resto.length) return fuori;
  const altrove = ws => asCapisciPezzo(ws.join(" "), esterno && esterno !== segnale ? esterno : null);
  const misure = resto.filter(w => /^\d+(\.\d+)?mm$/.test(w));
  if (pref === "oc" && misure.length > 1) {
    const altre = resto.filter(w => !misure.includes(w));
    return Object.assign(asUnisci(misure.map(m => asCapisciPezzo([...altre, m].join(" "), "oc"))), { segnale });
  }
  const iM = resto.map((w, i) => AS_MONT.test(w) ? i : -1).filter(i => i >= 0);
  if (segnale !== "m" && iM.length) {
    const usate = new Set();
    for (const i of iM) {
      usate.add(i);
      for (let j = i - 1; j >= 0 && asMarca(resto[j]); j--) usate.add(j);
      for (let j = i + 1; j < resto.length && AS_MONT_DOPO.test(resto[j]); j++) usate.add(j);
    }
    const mw = resto.filter((w, i) => usate.has(i)), altre = resto.filter((w, i) => !usate.has(i));
    let r = asCerca("m", mw);
    if (!r.length && mw.length > 1) r = asCerca("m", mw.filter(w => AS_MONT.test(w)));
    const m = { segnale, parole: mw, voci: r.length ? [{ tipo: "m", scelte: r.map(x => asPezzo("m", x)) }] : [], ignoti: [] };
    if (!altre.length) return m;
    const a = asCapisciPezzo(altre.join(" "), segnale || esterno);
    return Object.assign(asUnisci(usate.has(0) ? [m, a] : [a, m]), { segnale: segnale || a.segnale });
  }
  const haK = parole.some(w => AS_SEGNALI.k.includes(w));
  const iF = resto.findIndex(w => /^x?\d+(\.\d+)?x?$/.test(w) && (/x/.test(w) || pref === "k" || haK) && (v => v >= 0.3 && v <= 5)(parseFloat(w.replace(/x/g, ""))));
  if (iF >= 0) {
    const v = parseFloat(resto[iF].replace(/x/g, "")), prima = resto.slice(0, iF), dopo = resto.slice(iF + 1);
    const marcaPrima = prima.some(asForte) ? [] : prima.filter(w => !/^\d+(\.\d+)?$/.test(w));
    const marcaDopo = dopo.length && dopo.every(asMarca) ? dopo : [];
    const marca = [...marcaPrima, ...marcaDopo];
    const negozio = marca.length ? asCerca("k", marca).filter(x => Math.abs(x.k - v) < 0.03).map(x => asPezzo("k", x)) : [];
    const k = { segnale, parole: [resto[iF], ...marca], voci: [{ tipo: "k", scelte: negozio.length ? negozio : [{ k: asFattore(v) }] }], ignoti: [] };
    const pa = marcaPrima.length ? [] : prima.filter(w => !/^\d+(\.\d+)?$/.test(w)), pd = marcaDopo.length ? [] : dopo;
    return Object.assign(asUnisci([pa.length ? altrove(pa) : null, k, pd.length ? altrove(pd) : null].filter(Boolean)), { segnale: segnale || "k" });
  }
  const df = resto.map(w => /^(\d{2,4})\/(\d{2,5})$/.exec(w)).find(Boolean);
  if (df && resto.length === 1) {
    const D = +df[1], F = +df[2];
    if (F > D) return una({ tipo: "tel", scelte: [{ nome: maiuscola(pezzo.trim()).replace(/\s+/g, " ").slice(0, 60), D, F }], mano: true });
  }
  const tipoF = Object.keys(AS_TIPI_FILTRO).find(k => resto.some(w => AS_TIPI_FILTRO[k].includes(w)) && (pref === "f" || AS_FILTRO_SICURI.has(k)));
  const soloTipi = ws => ws.every(w => Object.values(AS_TIPI_FILTRO).some(l => l.includes(w)) || /^\d+(\.\d+)?(nm)?$/.test(w) || w === "nm" || w === "band");
  if (tipoF && soloTipi(resto)) {
    const r = asCerca("filtri", resto.filter(w => !/^\d/.test(w) && w !== "nm")).filter(x => x.tipo === tipoF);
    return una({ tipo: "f", scelte: [{ soloTipo: tipoF }, ...r.map(x => asPezzo("f", x))] });
  }
  const sigleCam = ws => ws.some(w => /^(asi|qhy|poa|atr|imx)\d/.test(w));
  const famigliaL = ws => ws.some(w => /^l-[a-z]/.test(w));
  const ordineDi = ws => segnale === "m" ? ["m"] : [...new Set([pref === "f" ? "filtri" : pref, ...(famigliaL(ws) ? ["filtri"] : []), ...(sigleCam(ws) ? ["cam", "tel"] : ["tel", "cam"]), "oc", "filtri", "k"].filter(Boolean))];
  const ordine = ordineDi(resto);
  const prove = [resto];
  if (resto.length > 1) resto.forEach((_, i) => prove.push(resto.filter((w, j) => j !== i)));
  if (resto.length > 2) for (let i = 0; i < resto.length; i++) for (let j = i + 1; j < resto.length; j++) prove.push(resto.filter((w, k) => k !== i && k !== j));
  const sigla = asSigla;
  const spezza = ws => ws.flatMap(w => sigla(w) ? w.replace(/([a-z])(\d)/g, "$1 $2").replace(/(\d)([a-z])/g, "$1 $2").split(" ").filter(Boolean) : [w]);
  const tiene = p => resto.filter(sigla).every(w => p.includes(w));
  const pesanti = resto.filter(w => sigla(w) && (w.match(/\d/g) || []).length >= 3);
  const GENERICHE = AS_GENERICHE;
  const peso = w => /^\d+(\.\d+)?(nm|mm|cm|m|kg|g|mp|in)?$/.test(w) || ["pollici", "pollice", "zoll", "pulgadas", "inch", "inches"].includes(w) ? 0
    : GENERICHE.has(w) ? 1 : sigla(w) ? 3 : 2;
  const lasciate = p => resto.filter(w => !p.includes(w)).reduce((s, w) => s + peso(w), 0);
  prove.sort((a, b) => lasciate(a) - lasciate(b));
  const tentativi = [...prove.filter(tiene), ...prove.filter(p => !tiene(p) && pesanti.every(w => p.includes(w)))]
    .flatMap(p => tiene(p) && p.some(sigla) ? [[p, p], [spezza(p), p]] : [[p, p]]);
  const corta = resto.map(w => /^\d{2,4}[a-z]$/.test(w) ? w.slice(0, -1) : w);
  if (corta.some((w, i) => w !== resto[i])) tentativi.splice(1, 0, [corta, resto]);
  const apertura = asApertura, forte = asForte;
  const perAltro = (tipo, x, p) => {
    const n = normParole(asNomeDi(tipo, x)), m = /[\s(](per|for|fur|fuer|para|pour)\s/.exec(n);
    if (!m) return false;
    const prima = n.slice(0, m.index), mod = p.filter(w => !asMarca(w) && !GENERICHE.has(w) && !/^\d+(\.\d+)?$/.test(w));
    return mod.length > 0 && mod.every(w => !prima.includes(w));
  };
  const cerca = (tp, p, primo) => { const r = asCerca(tp, p); if (tp === primo) return r; const f = r.filter(x => !perAltro(tp === "filtri" ? "f" : tp, x, p)); f.n = f.length; return f; };
  const cercaTratto = run => {
    const tipoRun = Object.keys(AS_TIPI_FILTRO).find(k => run.some(w => AS_TIPI_FILTRO[k].includes(w)) && (pref === "f" || AS_FILTRO_SICURI.has(k)));
    if (tipoRun && soloTipi(run)) return [{ tipo: "f", scelte: [{ soloTipo: tipoRun }] }];
    const dice = run.length === 1 ? (sigla(run[0]) && !apertura(run[0])) || /^l-[a-z]/.test(run[0])
      : run.some(forte) || (run.some(asMarca) && run.some(w => /\d/.test(w)));
    if (!dice) return null;
    const ord = ordineDi(run);
    for (const tp of ord) {
      const r = cerca(tp, run, ord[0]);
      if (!r.length) continue;
      return r.n <= 6 || tp === "filtri" ? asVociDi(tp === "filtri" ? "f" : tp, r, run) : null;
    }
    return null;
  };
  const spezzaInPezzi = ws => {
    const voci = [], ignote = [];
    let i = 0, ok = true;
    while (i < ws.length) {
      let preso = 0;
      for (let j = Math.min(ws.length, i + 6); j > i && !preso; j--) {
        const v = cercaTratto(ws.slice(i, j));
        if (v) { voci.push(...v); preso = j - i; }
      }
      if (preso) { i += preso; continue; }
      if (pesanti.includes(ws[i])) ok = false;
      if (forte(ws[i])) ignote.push(ws[i]);
      i++;
    }
    return { voci, ignote, ok };
  };
  for (const [p, usate] of tentativi) {
    if (!p.some(w => w.length > 1 && !/^\d+$/.test(w))) continue;
    if (p.every(w => asMarca(w) || GENERICHE.has(w) || /^\d+(\.\d+)?$/.test(w)) && resto.some(w => !p.includes(w) && forte(w))) continue;
    for (const tp of ordine) {
      const r = cerca(tp, p, ordine[0]);
      if (r.length) {
        const tipo = tp === "filtri" ? "f" : tp;
        if (tipo === "f" && tipoF && !r.some(x => x.tipo === tipoF)) break;
        fuori.voci = asVociDi(tipo, r, parole);
        const nome = normParole(asNomeDi(tipo, r[0])), dentro = w => nome.includes(w) || spezza([w]).every(x => nome.includes(x));
        const fuoriNome = resto.filter(w => !usate.includes(w) && !dentro(w));
        if (fuoriNome.some(forte)) {
          const s = spezzaInPezzi(fuoriNome);
          if (resto.indexOf(fuoriNome[0]) < resto.findIndex(w => usate.includes(w))) fuori.voci.unshift(...s.voci); else fuori.voci.push(...s.voci);
          fuori.ignoti.push(...s.ignote);
        }
        return fuori;
      }
    }
  }
  if (resto.length > 1) {
    const s = spezzaInPezzi(resto);
    if (s.ok && s.voci.length) return Object.assign(fuori, { voci: s.voci, ignoti: s.ignote });
  }
  if (tipoF) return una({ tipo: "f", scelte: [{ soloTipo: tipoF }] });
  if (df) return una({ tipo: "tel", scelte: [{ nome: maiuscola(pezzo.trim()).slice(0, 60), D: +df[1], F: +df[2] }], mano: true });
  return fuori;
}
function asCapisci(testo, preferito) {
  const trovati = [], ignoti = [], visti = new Set();
  const pulito = String(testo).replace(/(\d),(\d)/g, "$1.$2")
    .replace(/\bl[\s-]?(pro|para|extreme|enhance|ultimate|synergy|qef|quad)\b/gi, "l-$1");
  const soloMisure = frase => {
    const w = normParole(frase).replace(/[«»"“”„()!?:]/g, " ").split(/\s+/).filter(x => x && !AS_VUOTE.has(x));
    return w.length > 0 && w.every(x => /^\d+(\.\d+)?(mm|nm|x|°)?$/.test(x) || x === "mm" || x === "nm" || x === "band" || Object.values(AS_TIPI_FILTRO).some(l => l.includes(x)));
  };
  let ultimo = null;
  for (const frase of pulito.split(/[,;\n]+|\.\s+/)) {
    let segnale = soloMisure(frase) ? ultimo : null;
    for (const pezzo of frase.split(/\s+(?:e|ed|y|und|and|con|mit|with|più|piu|poi|oltre a|\+|&)\s+/i)) {
      if (!pezzo.trim()) continue;
      const r = asCapisciPezzo(pezzo, segnale || preferito);
      if (r.segnale) segnale = r.segnale;
      for (const v of r.voci) {
        const s0 = v.scelte[0], k = v.tipo + ":" + (s0.soloTipo || (v.tipo === "f" ? s0.nome : TIPI_ATT[v.tipo].chiave(s0)));
        if (!visti.has(k)) { visti.add(k); trovati.push(v); }
      }
      if (!r.voci.length) { if (r.parole.length) ignoti.push(pezzo.trim()); }
      else if (r.ignoti.length) ignoti.push(r.ignoti.join(" "));
    }
    ultimo = segnale;
  }
  return { trovati, ignoti };
}
Object.assign(TESTI.it, { as_ricomincia: "Ricomincia", as_ricomincia_n: "Cancella la conversazione e riparti da capo (la tua attrezzatura resta)" });
Object.assign(TESTI.de, { as_ricomincia: "Neu beginnen", as_ricomincia_n: "Unterhaltung löschen und neu beginnen (Ihre Ausrüstung bleibt)" });
Object.assign(TESTI.es, { as_ricomincia: "Empezar de nuevo", as_ricomincia_n: "Borra la conversación y empieza de cero (tu equipo se queda)" });
function boxAssistente(dopo) {
  const msgs = el("div", { class: "gas-as-msgs", role: "log", "aria-live": "polite" });
  const area = el("textarea", { class: "gas-input gas-as-testo", rows: 2, placeholder: t("as_segnaposto"), "aria-label": t("as_segnaposto") });
  const sessione = { tel: [], cam: [], oc: [], k: [], m: [] }, rifiutati = new Set();
  let chiede = null;
  const scorri = () => { msgs.scrollTop = msgs.scrollHeight; };
  const bot = (...figli) => {
    msgs.appendChild(el("div", { class: "gas-as-msg gas-as-msg--bot" }, el("span", { class: "gas-as-av" }, icona("assistente")), el("div", { class: "gas-as-bolla" }, ...figli)));
    scorri();
  };
  const io = s => { msgs.appendChild(el("div", { class: "gas-as-msg gas-as-msg--io" }, el("div", { class: "gas-as-bolla" }, s))); scorri(); };
  const chiedi = c => { chiede = c; bot(el("p", null, t("as_chiedi_" + c))); };
  const haCamera = () => ATTREZZI.cam.length || ATTREZZI.oc.length || ATTREZZI.tel.some(x => x.smart);
  const prossima = () => {
    if (!ATTREZZI.tel.length && !rifiutati.has("tel")) return chiedi("tel");
    if (!haCamera() && !rifiutati.has("cam")) return chiedi("cam");
    if (!contaFiltri() && !rifiutati.has("filtri")) return chiedi("filtri");
    chiede = null;
    fine();
  };
  const fine = () => {
    const tel = sessione.tel[0] || ATTREZZI.tel[0], cam = tel && !tel.smart ? sessione.cam[0] || ATTREZZI.cam[0] : null;
    const oc = tel && !tel.smart && !cam ? sessione.oc[0] || ATTREZZI.oc[0] : null, k = sessione.k[0] || null;
    const bottoni = el("div", { class: "gas-riga-bottoni" },
      el("a", { class: "gas-btn", href: urlScheda("campo"), onclick: e => { e.preventDefault(); vai("campo"); } }, icona("campo"), " ", t("as_apri_campo")));
    if (tel && (tel.smart || cam || oc)) {
      const prova = () => { usaAttrezzo("tel", tel); CAMPO.k = 1; if (k && !tel.smart) usaAttrezzo("k", k); if (cam) usaAttrezzo("cam", cam); else if (oc) usaAttrezzo("oc", oc); };
      const vecchio = setupAttuale();
      prova();
      const nome = nomeSetupAuto(setupAttuale()), gia = SETUP_ELENCO.some(s => stessoSetup(s, setupAttuale()));
      usaSetup(vecchio);
      if (!gia) bottoni.prepend(el("button", { type: "button", class: "gas-btn gas-btn--chiaro", onclick: e => {
        prova(); salvaSetup(); aggiornaSetupUI(); dopo();
        e.currentTarget.replaceWith(el("span", { class: "gas-setup-ok" }, t("as_setup_ok", { n: nome })));
      } }, t("as_salva_setup", { n: nome })));
    }
    bot(el("p", null, t("as_finito")), bottoni);
  };
  const mostraCapito = r => {
    if (!r.trovati.length) { bot(el("p", null, r.ignoti.length ? t("as_non_capito", { s: r.ignoti.join(", ") }) : t("as_niente"))); return; }
    const righe = r.trovati.map(v => {
      const gia = x => (v.tipo === "f" ? (x.soloTipo ? (CAMPO.filtri || []).includes(x.soloTipo) : (CAMPO.filtriNomi || []).some(f => f.nome === x.nome)) : ho(v.tipo, x));
      const nomeDi = x => v.tipo === "f" ? (x.soloTipo ? `${t("filtro_" + x.soloTipo)} (${t("as_solo_tipo")})` : x.nome) : TIPI_ATT[v.tipo].nome(x);
      const sottoDi = x => v.tipo === "f" ? (x.soloTipo ? "" : t("filtro_" + x.tipo)) : [TIPI_ATT[v.tipo].sotto(x), v.mano ? t("as_a_mano") : ""].filter(Boolean).join(" · ");
      let scelta = v.scelte[0];
      const spunta = el("input", { type: "checkbox", checked: !gia(scelta), "aria-label": nomeDi(scelta) });
      const sotto = el("small", null), nome = el("b", { class: "gas-as-nome" });
      const nota = () => {
        nome.textContent = nomeDi(scelta); spunta.setAttribute("aria-label", nomeDi(scelta));
        svuota(sotto).append([sottoDi(scelta), gia(scelta) ? t("as_gia") : ""].filter(Boolean).join(" · "));
      };
      const sel = v.scelte.length > 1 ? selezione([["", t("as_altri_modelli", { n: v.scelte.length - 1 })], ...v.scelte.map((x, i) => [i, nomeDi(x)])], "", i => {
        if (i === "") return;
        scelta = v.scelte[+i]; spunta.checked = !gia(scelta); nota(); sel.value = "";
      }, { class: "gas-input gas-as-cambia", "aria-label": t("as_cambia_modello") }) : null;
      nota();
      return { v, spunta, prendi: () => scelta, el: el("div", { class: "gas-as-riga" },
        el("label", { class: "gas-as-etichetta", style: { display: "contents" } }, spunta, el("span", { class: "gas-as-tipo" }, t("as_tipo_" + v.tipo)), nome, sotto), sel) };
    });
    const aggiungi = el("button", { type: "button", class: "gas-btn", onclick: () => {
      for (const r0 of righe) {
        if (!r0.spunta.checked) continue;
        const x = r0.prendi();
        if (r0.v.tipo === "f") { if (x.soloTipo) uniscFiltri([], [x.soloTipo]); else uniscFiltri([x], []); continue; }
        if (aggiungiAttrezzo(r0.v.tipo, x)) sessione[r0.v.tipo].push(x);
      }
      salvaCampo(); aggiornaSetupUI();
      aggiungi.disabled = true; righe.forEach(r0 => { r0.spunta.disabled = true; });
      dopo();
      bot(el("p", null, t("as_fatto", { r: riepilogoAttrezzi() })));
      prossima();
    } }, t("as_aggiungi"));
    bot(el("p", null, t("as_capito")), el("div", { class: "gas-as-righe" }, righe.map(r0 => r0.el)),
      r.ignoti.length ? el("p", { class: "gas-as-ignoti" }, t("as_non_capito", { s: r.ignoti.join(", ") })) : null, aggiungi);
  };
  const invia = () => {
    const s = area.value.trim();
    if (!s) return;
    area.value = "";
    io(s);
    const capito = asCapisci(s, chiede === "filtri" ? "f" : chiede === "cam" ? null : chiede);
    const parole = normParole(s).replace(/[«»"“”„()!?.,;:]/g, " ").split(/\s+/).filter(Boolean);
    const diceNo = AS_NO.test(s) || parole.some(w => AS_NEGATIVE.test(w)) || (chiede === "cam" && parole.some(w => AS_VISUALE.test(w)));
    if (chiede && diceNo && !capito.trovati.length) { rifiutati.add(chiede); bot(el("p", null, t("as_va_bene"))); prossima(); return; }
    mostraCapito(capito);
  };
  area.addEventListener("keydown", e => { if (e.key === "Enter" && !e.shiftKey && !e.isComposing) { e.preventDefault(); invia(); } });
  const SR = window.SpeechRecognition || window.webkitSpeechRecognition;
  let ascolto = null;
  const mic = SR ? el("button", { type: "button", class: "gas-as-mic", title: t("as_voce"), "aria-label": t("as_voce"), "aria-pressed": "false", onclick: () => {
    if (ascolto) { ascolto.stop(); return; }
    const r = new SR(), prima = area.value.trim();
    r.lang = LOCALE; r.interimResults = true; r.maxAlternatives = 1;
    r.onresult = e => { let s = ""; for (const x of e.results) s += x[0].transcript; area.value = (prima ? prima + " " : "") + s; };
    r.onend = () => { ascolto = null; mic.classList.remove("on"); mic.setAttribute("aria-pressed", "false"); area.placeholder = t("as_segnaposto");
      if (area.value.trim() && area.value.trim() !== prima) invia(); };
    r.onerror = () => {};
    try { r.start(); ascolto = r; mic.classList.add("on"); mic.setAttribute("aria-pressed", "true"); area.placeholder = t("as_ascolto"); } catch (e) { ascolto = null; }
  } }, icona("microfono")) : null;
  const saluta = () => bot(el("p", null, riepilogoAttrezzi() !== t("att_nessuno") ? t("as_hai_gia", { r: riepilogoAttrezzi() }) : t("as_ciao")), el("small", null, t("as_esempio")));
  const ricomincia = () => {
    if (ascolto) ascolto.stop();
    svuota(msgs); area.value = "";
    for (const k of Object.keys(sessione)) sessione[k] = [];
    rifiutati.clear(); chiede = null;
    saluta();
    area.focus({ preventScroll: true });
  };
  saluta();
  const box = scheda(null, el("div", { class: "gas-as-testa" }, el("h3", { class: "gas-as-titolo" }, icona("assistente"), " ", t("as_titolo")),
    el("button", { type: "button", class: "gas-btn gas-btn--chiaro gas-btn--mini gas-as-ricomincia", title: t("as_ricomincia_n"), onclick: ricomincia },
      icona("reimposta"), " ", t("as_ricomincia"))), msgs,
    el("div", { class: "gas-as-scrivi" }, area, mic,
      el("button", { type: "button", class: "gas-as-invia", title: t("as_invia"), "aria-label": t("as_invia"), onclick: invia }, icona("invia"))));
  box.classList.add("gas-as");
  box.scrivi = () => area.focus();
  return box;
}
function bottoneAssistente() {
  return el("a", { class: "gas-btn gas-btn--chiaro gas-btn--mini gas-as-lancia", href: urlScheda("attrezzatura") + "#attrezzatura", onclick: e => {
    e.preventDefault(); ATT_APRI = "as"; vai("attrezzatura");
    setTimeout(() => { const a = $(".gas-as-testo"); if (a) { a.scrollIntoView({ behavior: "smooth", block: "center" }); a.focus({ preventScroll: true }); } }, 350);
  } }, icona("assistente"), " ", t("as_apri"));
}
Object.assign(TESTI.it, {
  sy_account: "☁ Collegata al tuo account: la ritrovi uguale sul telefono e sul computer.", sy_errore: "☁ Non riesco a salvare nel tuo account adesso: riprovo da solo.",
  sy_ospite_t: "Ritrovala su tutti i tuoi dispositivi", sy_accedi: "Accedi o registrati gratis",
  sy_ospite_n: "Con l'account del negozio salviamo attrezzatura, setup, filtri e diario: li hai uguali sul telefono e sul computer. Senza account restano solo su questo dispositivo.",
  sy_diario_ok: "☁ Il diario è collegato al tuo account.", sy_diario_n: "Accedi o registrati per ritrovare il diario su tutti i tuoi dispositivi →",
});
Object.assign(TESTI.de, {
  sy_account: "☁ Mit Ihrem Konto verbunden: auf Handy und Computer immer auf dem gleichen Stand.", sy_errore: "☁ Speichern im Konto gerade nicht möglich: Ich versuche es gleich wieder.",
  sy_ospite_t: "Auf allen Ihren Geräten verfügbar", sy_accedi: "Anmelden oder kostenlos registrieren",
  sy_ospite_n: "Mit dem Kundenkonto speichern wir Ausrüstung, Setups, Filter und Tagebuch: auf Handy und Computer immer auf dem gleichen Stand. Ohne Konto bleiben sie nur auf diesem Gerät.",
  sy_diario_ok: "☁ Das Tagebuch ist mit Ihrem Konto verbunden.", sy_diario_n: "Anmelden oder registrieren, um das Tagebuch auf allen Geräten zu haben →",
});
Object.assign(TESTI.es, {
  sy_account: "☁ Conectado a tu cuenta: lo tienes igual en el móvil y en el ordenador.", sy_errore: "☁ Ahora no puedo guardar en tu cuenta: lo vuelvo a intentar solo.",
  sy_ospite_t: "Tenlo en todos tus dispositivos", sy_accedi: "Entra o regístrate gratis",
  sy_ospite_n: "Con la cuenta de la tienda guardamos equipo, configuraciones, filtros y diario: los tienes igual en el móvil y en el ordenador. Sin cuenta se quedan solo en este dispositivo.",
  sy_diario_ok: "☁ El diario está conectado a tu cuenta.", sy_diario_n: "Entra o regístrate para tener el diario en todos tus dispositivos →",
});
Object.assign(TESTI.en, {
  sy_account: "☁ Linked to your account: the same on your phone and your computer.", sy_errore: "☁ I can't save to your account right now: I'll keep trying automatically.",
  sy_ospite_t: "Have it on all your devices", sy_accedi: "Sign in or register for free",
  sy_ospite_n: "With a shop account we save your equipment, setups, filters and log: the same on your phone and your computer. Without an account they stay on this device only.",
  sy_diario_ok: "☁ Your log is linked to your account.", sy_diario_n: "Sign in or register to have your log on all your devices →",
});
Object.assign(TESTI.it, { sy_chi: "Sei dentro come {e}: sugli altri dispositivi entra con questa stessa email.", sy_esci: "Esci" });
Object.assign(TESTI.de, { sy_chi: "Angemeldet als {e}: Melden Sie sich auf den anderen Geräten mit derselben E-Mail an.", sy_esci: "Abmelden" });
Object.assign(TESTI.es, { sy_chi: "Has entrado como {e}: en los demás dispositivos entra con este mismo correo.", sy_esci: "Salir" });
Object.assign(TESTI.en, { sy_chi: "Signed in as {e}: on your other devices, sign in with this same email.", sy_esci: "Sign out" });
Object.assign(TESTI.it, { sy_locale: "☁ Adesso il tuo account non risponde: le modifiche restano su questo dispositivo e le porto nell'account appena torna la rete." });
Object.assign(TESTI.de, { sy_locale: "☁ Ihr Konto antwortet gerade nicht: Änderungen bleiben auf diesem Gerät, ich übertrage sie ins Konto, sobald das Netz wieder da ist." });
Object.assign(TESTI.es, { sy_locale: "☁ Ahora tu cuenta no responde: los cambios se quedan en este dispositivo y los llevo a tu cuenta en cuanto vuelva la conexión." });
Object.assign(TESTI.en, { sy_locale: "☁ Your account isn't answering right now: changes stay on this device and I'll copy them to your account as soon as you're back online." });
const ACCOUNT_OBBLIGATORIO = true;
Object.assign(TESTI.it, {
  ac_t_att: "La tua attrezzatura, su tutti i tuoi dispositivi", ac_t_dr: "Il tuo diario del cielo, su tutti i tuoi dispositivi",
  ac_n: "Per salvare attrezzatura, setup, filtri e diario serve l'account del negozio: è gratis e si entra con l'email, senza password.",
  ac_p1: "Telescopi, camere, oculari, riduttori, montature e filtri: li inserisci una volta sola", ac_p2: "Li ritrovi uguali sul telefono e sul computer, pronti in tutti gli strumenti",
  ac_p3: "Il diario degli oggetti visti e fotografati, con la sfida dei 110 di Messier", ac_ritrovi: "Quello che avevi già inserito su questo dispositivo lo ritrovi appena entri.",
  ac_libero: "Tutti gli altri strumenti restano liberi, anche senza account.", ac_toast_t: "Serve l'account (gratis)",
  ac_toast: "Per salvare attrezzatura, setup, filtri e diario entra con l'account del negozio: basta l'email, senza password.", ac_non_ora: "Non ora",
});
Object.assign(TESTI.de, {
  ac_t_att: "Ihre Ausrüstung auf allen Ihren Geräten", ac_t_dr: "Ihr Himmelstagebuch auf allen Ihren Geräten",
  ac_n: "Zum Speichern von Ausrüstung, Setups, Filtern und Tagebuch brauchen Sie ein Kundenkonto des Shops: kostenlos, Anmeldung mit E-Mail, ohne Passwort.",
  ac_p1: "Teleskope, Kameras, Okulare, Reducer, Montierungen und Filter nur einmal eingeben", ac_p2: "Auf Handy und Computer immer auf dem gleichen Stand, in allen Werkzeugen sofort bereit",
  ac_p3: "Das Tagebuch der gesehenen und fotografierten Objekte, mit der Challenge der 110 Messier-Objekte", ac_ritrovi: "Was Sie auf diesem Gerät schon eingegeben haben, finden Sie nach der Anmeldung wieder.",
  ac_libero: "Alle anderen Werkzeuge bleiben frei nutzbar, auch ohne Konto.", ac_toast_t: "Kundenkonto nötig (kostenlos)",
  ac_toast: "Zum Speichern von Ausrüstung, Setups, Filtern und Tagebuch mit dem Kundenkonto anmelden: nur mit E-Mail, ohne Passwort.", ac_non_ora: "Nicht jetzt",
});
Object.assign(TESTI.es, {
  ac_t_att: "Tu equipo, en todos tus dispositivos", ac_t_dr: "Tu diario del cielo, en todos tus dispositivos",
  ac_n: "Para guardar equipo, configuraciones, filtros y diario hace falta la cuenta de la tienda: es gratis y se entra con el correo, sin contraseña.",
  ac_p1: "Telescopios, cámaras, oculares, reductores, monturas y filtros: los introduces una sola vez", ac_p2: "Los tienes igual en el móvil y en el ordenador, listos en todas las herramientas",
  ac_p3: "El diario de los objetos vistos y fotografiados, con el reto de los 110 de Messier", ac_ritrovi: "Lo que ya habías introducido en este dispositivo lo recuperas en cuanto entres.",
  ac_libero: "Todas las demás herramientas siguen siendo de uso libre, incluso sin cuenta.", ac_toast_t: "Hace falta la cuenta (gratis)",
  ac_toast: "Para guardar equipo, configuraciones, filtros y diario entra con la cuenta de la tienda: basta el correo, sin contraseña.", ac_non_ora: "Ahora no",
});
Object.assign(TESTI.en, {
  ac_t_att: "Your equipment, on all your devices", ac_t_dr: "Your observing log, on all your devices",
  ac_n: "To save equipment, setups, filters and log you need a shop account: it's free and you sign in with your email, no password.",
  ac_p1: "Telescopes, cameras, eyepieces, reducers, mounts and filters: enter them once", ac_p2: "The same on your phone and your computer, ready in every tool",
  ac_p3: "A log of the objects you've observed and imaged, with the 110-object Messier challenge", ac_ritrovi: "Anything you've already entered on this device will be there as soon as you sign in.",
  ac_libero: "All the other tools stay free, even without an account.", ac_toast_t: "Account needed (free)",
  ac_toast: "To save equipment, setups, filters and log, sign in with your shop account: just your email, no password.", ac_non_ora: "Not now",
});
const SYNC_URL = "/apps/strumenti/attrezzatura";
const SYNC = { stato: "?", inviato: "", timer: null, applico: false, errore: false, ui: new Set(), visto: null,
  base: null, invio: null, avvio: null, rileggo: false, caricato: null };
const pacchettoSync = () => ({ v: 1, attrezzatura: ATTREZZI, setup: SETUP_ELENCO, filtri: CAMPO.filtri || [], filtriNomi: CAMPO.filtriNomi || [],
  confronto: CONFRONTO || "", diario: DIARIO });
const pacchettoVuoto = p => !p || (Object.keys(TIPI_ATT).every(k => !((p.attrezzatura || {})[k] || []).length) && !(p.setup || []).length &&
  !(p.filtri || []).length && !(p.filtriNomi || []).length && !Object.keys(p.diario || {}).length);
function avvisaSync() { for (const f of [...SYNC.ui]) f(); }
function chiamaSync(corpo) {
  const ferma = typeof AbortController === "function" ? new AbortController() : null, tempo = ferma ? setTimeout(() => ferma.abort(), 8000) : null;
  const opz = corpo === undefined ? { credentials: "same-origin", cache: "no-store" }
    : { method: "POST", credentials: "same-origin", keepalive: true, headers: { "Content-Type": "application/json" }, body: JSON.stringify(corpo) };
  if (ferma && corpo === undefined) opz.signal = ferma.signal;
  return fetch(SYNC_URL + (corpo === undefined ? "?t=" + Date.now() : ""), opz)
    .then(r => { if (!r.ok) throw new Error("sync " + r.status); return r.json(); })
    .finally(() => { if (tempo) clearTimeout(tempo); });
}
function puoSalvare() { return !ACCOUNT_OBBLIGATORIO || SYNC.stato !== "ospite"; }
let _invitoAccount = null;
function invitoAccount() {
  if (_invitoAccount) _invitoAccount.remove();
  const chiudi = () => { if (_invitoAccount) { _invitoAccount.remove(); _invitoAccount = null; } };
  _invitoAccount = el("div", { class: "gas-sy-foglio", role: "dialog", "aria-label": t("ac_toast_t") },
    el("span", { class: "gas-sy-ico", "aria-hidden": "true" }, "☁"),
    el("div", null, el("b", null, t("ac_toast_t")), el("p", null, t("ac_toast")),
      el("div", { class: "gas-riga-bottoni" }, el("a", { class: "gas-btn gas-btn--mini", href: urlAccesso(schedaAttiva) }, t("sy_accedi"), " →"),
        el("button", { type: "button", class: "gas-btn gas-btn--chiaro gas-btn--mini", onclick: chiudi }, t("ac_non_ora")))));
  (typeof PAGINA_OGG !== "undefined" && PAGINA_OGG ? PAGINA_OGG : document.getElementById("gas-sfondo") || document.body).appendChild(_invitoAccount);
  return false;
}
function cancelloAccount(tipo) {
  const qui = !pacchettoVuoto(JSON.parse(JSON.stringify(pacchettoSync()))) && !ricorda("sync_chi", "") && !ricorda("sync_visto", null);
  return el("section", { class: "gas-card gas-ac" },
    el("span", { class: "gas-ac-ico", "aria-hidden": "true" }, icona(tipo === "diario" ? "diario" : "attrezzatura")),
    el("h2", null, t(tipo === "diario" ? "ac_t_dr" : "ac_t_att")),
    el("p", { class: "gas-ac-n" }, t("ac_n")),
    el("ul", { class: "gas-qz-punti" }, ["ac_p1", "ac_p2", "ac_p3"].map(k => el("li", null, el("i", null, "✓"), " ", t(k)))),
    qui ? el("p", { class: "gas-setup-ok" }, "✓ ", t("ac_ritrovi")) : null,
    el("a", { class: "gas-btn gas-ac-btn", href: urlAccesso(tipo) }, t("sy_accedi"), " →"),
    el("p", { class: "gas-nota" }, t("ac_libero")));
}
function schedaSoloAccount(pannello, tipo) {
  if (!ACCOUNT_OBBLIGATORIO || SYNC.stato === "account" || SYNC.stato === "locale") return false;
  pannello.append(SYNC.stato === "ospite" ? cancelloAccount(tipo) : el("p", { class: "gas-carico" }, t("caricamento")));
  return true;
}
function applicaSync(d) {
  SYNC.applico = true;
  try {
    const a = d.attrezzatura || {};
    for (const k of Object.keys(TIPI_ATT)) ATTREZZI[k] = Array.isArray(a[k]) ? a[k] : [];
    SETUP_ELENCO.length = 0;
    if (Array.isArray(d.setup)) SETUP_ELENCO.push(...d.setup);
    CAMPO.filtri = Array.isArray(d.filtri) ? d.filtri : [];
    CAMPO.filtriNomi = Array.isArray(d.filtriNomi) ? d.filtriNomi : [];
    CONFRONTO = typeof d.confronto === "string" ? d.confronto : "";
    for (const k of Object.keys(DIARIO)) delete DIARIO[k];
    if (d.diario && typeof d.diario === "object") Object.assign(DIARIO, d.diario);
    salvaAttrezzi(); salva("setup", SETUP_ELENCO); salva("confronto", CONFRONTO); salvaCampo(); salva("diario", DIARIO);
  } finally { SYNC.applico = false; }
  aggiornaSetupUI();
  for (const f of [...DIARIO_UI]) f();
}
function unisciSync(conto, qui) {
  const a = {}, ca = conto.attrezzatura || {}, qa = qui.attrezzatura || {};
  for (const k of Object.keys(TIPI_ATT)) {
    const visti = new Set(), lista = [];
    for (const x of [...(ca[k] || []), ...(qa[k] || [])]) { const c = TIPI_ATT[k].chiave(x); if (!visti.has(c)) { visti.add(c); lista.push(x); } }
    a[k] = lista;
  }
  const setup = [...(conto.setup || [])];
  for (const s of qui.setup || []) if (!setup.some(x => stessoSetup(x, s))) setup.push(s);
  const nomi = [...(conto.filtriNomi || [])];
  for (const f of qui.filtriNomi || []) if (!nomi.some(x => x.nome === f.nome)) nomi.push(f);
  const diario = Object.assign({}, qui.diario || {});
  for (const [k, r] of Object.entries(conto.diario || {})) {
    const m = diario[k] || {};
    diario[k] = { v: [m.v, r.v].filter(Boolean).sort()[0], f: [m.f, r.f].filter(Boolean).sort()[0] };
    if (!diario[k].f) delete diario[k].f;
  }
  return { v: 1, attrezzatura: a, setup, filtri: [...new Set([...(conto.filtri || []), ...(qui.filtri || [])])], filtriNomi: nomi,
    confronto: conto.confronto || qui.confronto || "", diario };
}
const _ogg = x => x && typeof x === "object" && !Array.isArray(x) ? x : {};
function testoFisso(x) {
  if (Array.isArray(x)) return "[" + x.map(testoFisso).join(",") + "]";
  if (x && typeof x === "object") return "{" + Object.keys(x).filter(k => x[k] !== undefined).sort().map(k => JSON.stringify(k) + ":" + testoFisso(x[k])).join(",") + "}";
  return JSON.stringify(x === undefined ? null : x);
}
const chiaveSetup = s => {
  if (!s || typeof s !== "object") return null;
  const tt = x => x ? [x.h || "", x.D, x.F].join("|") : "", cc = x => x ? [x.id || "", x.w, x.h, x.px].join("|") : "", oo = x => x ? [x.h || "", x.f, x.afov].join("|") : "";
  return [s.modo || "", tt(s.tel), s.k || 1, s.modo === "visuale" ? oo(s.oc) : cc(s.cam) + "|" + (s.bin || 1)].join("#");
};
const CHIAVI_SYNC = { setup: chiaveSetup, filtri: x => typeof x === "string" ? x : null, filtriNomi: x => x && typeof x === "object" && x.nome ? String(x.nome) : null };
const chiaveSicura = (f, x) => { try { return x && (typeof x === "object" || typeof x === "string") ? f(x) : null; } catch (e) { return null; } };
function diffLista(base, qui, chiave) {
  const mappa = l => { const m = new Map(); for (const x of Array.isArray(l) ? l : []) { const k = chiaveSicura(chiave, x); if (k != null && !m.has(k)) m.set(k, x); } return m; };
  const b = mappa(base), q = mappa(qui);
  return { piu: [...q].filter(([k, x]) => !b.has(k) || testoFisso(b.get(k)) !== testoFisso(x)).map(([, x]) => x), meno: [...b.keys()].filter(k => !q.has(k)) };
}
function applicaLista(conto, d, chiave) {
  const meno = new Set((d && d.meno) || []), fuori = [], dove = new Map();
  for (const x of Array.isArray(conto) ? conto : []) {
    const k = chiaveSicura(chiave, x);
    if (k == null) { fuori.push(x); continue; }
    if (meno.has(k) || dove.has(k)) continue;
    dove.set(k, fuori.length); fuori.push(x);
  }
  for (const x of (d && d.piu) || []) {
    const k = chiaveSicura(chiave, x);
    if (k == null) continue;
    if (dove.has(k)) fuori[dove.get(k)] = x; else { dove.set(k, fuori.length); fuori.push(x); }
  }
  return fuori;
}
function differenzeSync(base, qui) {
  base = _ogg(base); qui = _ogg(qui);
  const ba = _ogg(base.attrezzatura), qa = _ogg(qui.attrezzatura), d = { att: {}, diario: {} };
  for (const k of Object.keys(TIPI_ATT)) d.att[k] = diffLista(ba[k], qa[k], TIPI_ATT[k].chiave);
  for (const k of Object.keys(CHIAVI_SYNC)) d[k] = diffLista(base[k], qui[k], CHIAVI_SYNC[k]);
  if ((qui.confronto || "") !== (base.confronto || "")) d.confronto = qui.confronto || "";
  const bd = _ogg(base.diario), qd = _ogg(qui.diario);
  for (const id of new Set([...Object.keys(bd), ...Object.keys(qd)])) {
    const b = _ogg(bd[id]), q = _ogg(qd[id]), campi = {};
    for (const c of new Set([...Object.keys(b), ...Object.keys(q)])) if (testoFisso(b[c]) !== testoFisso(q[c])) campi[c] = q[c] === undefined ? null : q[c];
    if (Object.keys(campi).length) d.diario[id] = campi;
  }
  return d;
}
const diffVuota = d => !d || (Object.values(_ogg(d.att)).every(l => !l.piu.length && !l.meno.length) &&
  Object.keys(CHIAVI_SYNC).every(k => !d[k] || (!d[k].piu.length && !d[k].meno.length)) && !("confronto" in d) && !Object.keys(_ogg(d.diario)).length);
function applicaDifferenze(conto, d) {
  const c = JSON.parse(JSON.stringify(_ogg(conto))), a = _ogg(c.attrezzatura), diario = _ogg(c.diario);
  for (const k of Object.keys(TIPI_ATT)) a[k] = applicaLista(a[k], d.att && d.att[k], TIPI_ATT[k].chiave);
  for (const [id, campi] of Object.entries(_ogg(d.diario))) {
    const r = Object.assign({}, _ogg(diario[id]));
    for (const [k, v] of Object.entries(_ogg(campi))) if (v == null) delete r[k]; else r[k] = v;
    if (r.f && !r.v) r.v = r.f;
    if (Object.keys(r).length) diario[id] = r; else delete diario[id];
  }
  return { v: c.v || 1, attrezzatura: a, setup: applicaLista(c.setup, d.setup, chiaveSetup), filtri: applicaLista(c.filtri, d.filtri, CHIAVI_SYNC.filtri),
    filtriNomi: applicaLista(c.filtriNomi, d.filtriNomi, CHIAVI_SYNC.filtriNomi),
    confronto: "confronto" in d ? d.confronto : typeof c.confronto === "string" ? c.confronto : "", diario };
}
const pacchettoVuotoSync = () => ({ v: 1, attrezzatura: Object.fromEntries(Object.keys(TIPI_ATT).map(k => [k, []])), setup: [], filtri: [], filtriNomi: [], confronto: "", diario: {} });
function ricordaConto(j) {
  SYNC.base = j.dati || null; SYNC.visto = j.aggiornato || null; SYNC.inviato = j.dati ? JSON.stringify(j.dati) : "";
  salva("sync_base", SYNC.base); salva("sync_visto", SYNC.visto);
}
const emailConto = () => (typeof SR_IN_CAMPO !== "undefined" && SR_IN_CAMPO) || !RADICE ? "" : String(RADICE.dataset.email || "").trim().toLowerCase();
function ricordaChi() { const e = emailConto(); if (e) salva("sync_chi", e); }
function recepisciSync(j) {
  const prima = JSON.stringify(pacchettoSync()), nuovo = applicaDifferenze(j.dati, differenzeSync(SYNC.base, JSON.parse(prima)));
  if (JSON.stringify(nuovo) !== prima) applicaSync(nuovo);
  ricordaConto(j);
  return JSON.stringify(pacchettoSync()) !== prima;
}
function inviaSync() {
  clearTimeout(SYNC.timer); SYNC.timer = null;
  if (SYNC.stato !== "account") return Promise.resolve();
  if (SYNC.invio) return SYNC.invio.then(inviaSync);
  if (JSON.stringify(pacchettoSync()) === SYNC.inviato) return Promise.resolve();
  SYNC.invio = (async () => {
    const j = await chiamaSync();
    if (!j || !j.accesso) { SYNC.stato = "ospite"; return; }
    if (j.aggiornato && j.aggiornato > (SYNC.visto || "") && recepisciSync(j) && schedaAttiva && PANNELLI[schedaAttiva]) vai(schedaAttiva, true);
    const testo = JSON.stringify(pacchettoSync());
    if (testo !== SYNC.inviato) {
      const r = await chiamaSync({ dati: JSON.parse(testo) });
      if (!r || !r.accesso) { SYNC.stato = "ospite"; return; }
      ricordaConto({ dati: JSON.parse(testo), aggiornato: r.aggiornato || SYNC.visto });
      ricordaChi();
    }
    SYNC.errore = false;
  })().catch(e => {
    if (!/^sync \d|abort|fetch|network|load/i.test(String((e && (e.message || e.name)) || ""))) console.error("strumenti, account:", e);
    SYNC.errore = true; SYNC.timer = setTimeout(inviaSync, 20000);
  }).finally(() => { SYNC.invio = null; avvisaSync(); });
  return SYNC.invio;
}
function syncDopo() {
  if (SYNC.stato !== "account" || SYNC.applico) return;
  clearTimeout(SYNC.timer);
  SYNC.timer = setTimeout(inviaSync, 1500);
}
const SYNC_CHIAVI = new Set(["attrezzatura", "setup", "confronto", "campo", "diario"]);
const _salvaSoloQui = salva;
salva = function (k, v) { _salvaSoloQui(k, v); if (SYNC_CHIAVI.has(k)) syncDopo(); };
function rileggiSync() {
  if (SYNC.stato === "locale") { avviaSync(); return; }
  if (SYNC.stato !== "account" || SYNC.rileggo || SYNC.invio) return;
  if (SYNC.timer) { inviaSync(); return; }
  SYNC.rileggo = true;
  chiamaSync().then(j => {
    if (!j || !j.accesso || !j.dati || !j.aggiornato || SYNC.invio || j.aggiornato <= (SYNC.visto || "")) return;
    const cambiata = recepisciSync(j);
    if (JSON.stringify(pacchettoSync()) !== SYNC.inviato) syncDopo();
    if (cambiata && schedaAttiva && PANNELLI[schedaAttiva]) vai(schedaAttiva, true);
  }).catch(() => {}).finally(() => { SYNC.rileggo = false; });
}
document.addEventListener("visibilitychange", () => { if (document.visibilityState === "hidden") { if (SYNC.timer) inviaSync(); } else rileggiSync(); });
function ascoltaSync() {
  if (ascoltaSync.fatto || typeof window.addEventListener !== "function") return;
  ascoltaSync.fatto = true;
  window.addEventListener("pageshow", e => { if (e.persisted) rileggiSync(); });
  window.addEventListener("focus", () => rileggiSync());
  window.addEventListener("online", () => { if (SYNC.stato === "locale") avviaSync(); else if (SYNC.stato === "account" && SYNC.errore) inviaSync(); });
}
function avviaSync() {
  if (SYNC.avvio) return SYNC.avvio;
  ascoltaSync();
  const primo = SYNC.stato === "?";
  if (!SYNC.caricato) {
    SYNC.caricato = JSON.parse(JSON.stringify(pacchettoSync()));
    if (ricorda("sync_visto", null) && !ricorda("sync_base", null)) salva("sync_base", SYNC.caricato);
  }
  SYNC.avvio = (async () => {
    let qui = null;
    try {
      const j = await chiamaSync();
      if (!j || !j.accesso) {
        SYNC.stato = "ospite"; avvisaSync();
        if (ACCOUNT_OBBLIGATORIO && ["attrezzatura", "diario"].includes(schedaAttiva)) vai(schedaAttiva, true);
        return;
      }
      SYNC.stato = "account"; SYNC.errore = false;
      const email = emailConto(), chi = String(ricorda("sync_chi", "") || ""), visto = ricorda("sync_visto", null);
      const base = ricorda("sync_base", null) || SYNC.caricato, sospese = Object.assign({}, _ogg(ricorda("sync_sospese", null)));
      qui = JSON.parse(JSON.stringify(pacchettoSync()));
      let nuovo;
      if (chi && email && chi !== email) {
        const d = differenzeSync(visto ? base : null, qui);
        if (d && !diffVuota(d)) sospese[chi] = [...(Array.isArray(sospese[chi]) ? sospese[chi] : []), d];
        nuovo = j.dati || pacchettoVuotoSync();
      } else if (!visto) nuovo = j.dati ? unisciSync(j.dati, qui) : qui;
      else nuovo = j.dati ? applicaDifferenze(j.dati, differenzeSync(base, qui)) : qui;
      for (const d of email && Array.isArray(sospese[email]) ? sospese[email] : []) nuovo = applicaDifferenze(nuovo, d);
      if (email) delete sospese[email];
      salva("sync_sospese", Object.keys(sospese).length ? sospese : null);
      if (JSON.stringify(nuovo) !== JSON.stringify(qui)) applicaSync(nuovo);
      ricordaConto(j);
      if (!j.dati && pacchettoVuoto(pacchettoSync())) SYNC.inviato = JSON.stringify(pacchettoSync());
      ricordaChi();
      if (JSON.stringify(pacchettoSync()) !== SYNC.inviato) inviaSync();
      if (JSON.stringify(qui) !== JSON.stringify(pacchettoSync()) && schedaAttiva && PANNELLI[schedaAttiva]) vai(schedaAttiva, true);
    } catch (e) {
      if (SYNC.stato === "account" && qui) console.error("strumenti, account:", e);
      SYNC.stato = "locale";
    }
    avvisaSync();
    if (primo && ACCOUNT_OBBLIGATORIO && ["attrezzatura", "diario"].includes(schedaAttiva)) vai(schedaAttiva, true);
  })().finally(() => { SYNC.avvio = null; });
  return SYNC.avvio;
}
const urlAccesso = dove => "/customer_authentication/login?return_to=" + encodeURIComponent(location.pathname + (dove ? "#" + dove : ""));
async function esciAccount() {
  if (SYNC.stato === "account") {
    await inviaSync();
    if (!SYNC.errore && SYNC.stato === "account" && JSON.stringify(pacchettoSync()) === SYNC.inviato)
      for (const k of [...SYNC_CHIAVI, "sync_visto", "sync_base", "sync_chi", "ns_bozza", "bv_passo", "att_link"]) try { localStorage.removeItem(MEMORIA + k); } catch (e) {   }
  }
  try {
    if (navigator.onLine !== false && "caches" in window && typeof SR_PAGINE !== "undefined" && await caches.delete(SR_PAGINE)) salva("senza_rete", null);
  } catch (e) {   }
  const u = RADICE.dataset.esci || "/account/logout";
  location.href = u + (u.includes("?") ? "&" : "?") + "return_url=" + encodeURIComponent(location.pathname);
}
function boxAccount(dove, piccolo) {
  const box = el("div", { class: "gas-sy" + (piccolo ? " gas-sy--piccolo" : "") });
  const disegna = () => {
    if (!box.isConnected && box._mostrato) { SYNC.ui.delete(disegna); return; }
    box._mostrato = true;
    svuota(box);
    if (SYNC.stato === "account") box.append(el("p", { class: "gas-sy-ok" + (SYNC.errore ? " gas-sy-ko" : "") },
      t(SYNC.errore ? "sy_errore" : piccolo ? "sy_diario_ok" : "sy_account")),
      !piccolo && RADICE.dataset.email ? el("p", { class: "gas-sy-chi" }, t("sy_chi", { e: RADICE.dataset.email }), " ",
        el("button", { type: "button", class: "gas-sy-esci", onclick: () => esciAccount() }, t("sy_esci"))) : "");
    else if (SYNC.stato === "locale") box.append(el("p", { class: "gas-sy-ok gas-sy-ko" }, t("sy_locale")));
    else if (SYNC.stato === "ospite") {
      if (piccolo) box.append(el("a", { class: "gas-sy-link", href: urlAccesso(dove) }, t("sy_diario_n")));
      else box.append(el("div", { class: "gas-sy-invito" }, el("span", { class: "gas-sy-ico", "aria-hidden": "true" }, "☁"),
        el("div", null, el("b", null, t("sy_ospite_t")), el("p", null, t("sy_ospite_n")),
          el("a", { class: "gas-btn gas-btn--mini", href: urlAccesso(dove) }, t("sy_accedi"), " →"))));
    }
  };
  SYNC.ui.add(disegna);
  disegna();
  return box;
}
Object.assign(TESTI.it, {
  ns_titolo: "Nuovo setup in 4 passi", ns_apri: "Crea un setup", ns_apri_n: "Un setup è la tua combinazione di telescopio, riduttore e camera: la crei un passo alla volta e vedi subito cosa inquadri nel cielo.",
  ns_p_tel: "Telescopio", ns_p_k: "Riduttore", ns_p_cam: "Camera", ns_p_oc: "Oculare", ns_p_fine: "Salva",
  ns_q_tel: "Che telescopio o obiettivo usi?", ns_q_k: "Usi un riduttore o una Barlow (lenti che accorciano o allungano la focale)?", ns_q_cam: "Con che camera fotografi?", ns_q_oc: "Con che oculare osservi?",
  ns_q_fine: "Ecco il tuo setup", ns_foto: "Fotografo", ns_visuale: "Osservo all'oculare",
  ns_cambia: "Cambia", ns_avanti: "Avanti", ns_indietro: "Indietro", ns_salta: "Nessuno, avanti",
  ns_mano: "Non lo trovi? Scrivilo a mano", ns_usa: "Usa questo", ns_tuoi: "Dalla tua attrezzatura:", ns_comuni: "I più comuni:",
  ns_k_nome: "Cercalo per nome", ns_k_numero: "Non lo trovi? Scrivi il numero stampato sul pezzo (es. 0,72 o 2,5)", ns_k_usa: "Usa",
  ns_k_fuori: "Scrivi un numero fra 0,3 e 6: per esempio 0,72 per un riduttore, 2,5 per una Barlow.",
  ns_k_uno: "Così vicino a 1 la focale non cambia: tocca «Nessuno». Un riduttore è sotto 1 (0,8), una Barlow sopra (2).",
  ns_k_uguale: "la focale non cambia (spianatore o correttore)", ns_k_non_qui: "Non è tra questi? Scrivi il numero ↓",
  ns_k_non_trovato: "Non lo troviamo: scrivi qui sotto il numero stampato sul pezzo ↓",
  ns_nessun_k: "Nessuno", ns_altro_k: "Altro riduttore o Barlow…", ns_smart: "Smart telescope: la camera è già dentro, il riduttore non serve.",
  ns_anteprima: "Così inquadri {o}", ns_nome: "Nome del setup", ns_salva: "Salva il setup", ns_salvato: "Salvato: «{n}». I pezzi sono anche nella tua attrezzatura.",
  ns_gia: "Hai già questo setup: «{n}».", ns_pieni: "Hai già {n} setup: togline uno per salvarne un altro.",
  ns_campo: "Apri nel Campo inquadrato", ns_stanotte: "Cosa fotografare stanotte", ns_altro: "Crea un altro setup", ns_chiudi: "Chiudi",
  ns_focale: "Focale effettiva", ns_scala: "Scala dell'immagine", ns_campo_t: "Campo", ns_ingr: "Ingrandimento", ns_pupilla: "Pupilla d'uscita",
  ns_giudizio_ok: "Pixel della misura giusta per questo telescopio, con una turbolenza dell'aria (seeing) di {s}″", ns_giudizio_fine: "Pixel piccoli per questo telescopio: con una turbolenza dell'aria (seeing) di {s}″ conviene il binning {b}×{b}, cioè unire i pixel a gruppi",
  ns_giudizio_grosso: "Pixel grandi per questo telescopio: le stelle possono venire squadrate",
});
Object.assign(TESTI.de, {
  ns_titolo: "Neues Setup in 4 Schritten", ns_apri: "Setup erstellen", ns_apri_n: "Teleskop, Reducer und Kamera: ein Schritt nach dem anderen, und Sie sehen sofort, was Sie am Himmel erfassen.",
  ns_p_tel: "Teleskop", ns_p_k: "Reducer", ns_p_cam: "Kamera", ns_p_oc: "Okular", ns_p_fine: "Speichern",
  ns_q_tel: "Welches Teleskop oder Objektiv benutzen Sie?", ns_q_k: "Benutzen Sie einen Reducer oder eine Barlow?", ns_q_cam: "Mit welcher Kamera fotografieren Sie?", ns_q_oc: "Mit welchem Okular beobachten Sie?",
  ns_q_fine: "Ihr Setup", ns_foto: "Ich fotografiere", ns_visuale: "Ich beobachte mit Okular",
  ns_cambia: "Ändern", ns_avanti: "Weiter", ns_indietro: "Zurück", ns_salta: "Keiner, weiter",
  ns_mano: "Nicht gefunden? Von Hand eingeben", ns_usa: "Übernehmen", ns_tuoi: "Aus Ihrer Ausrüstung:", ns_comuni: "Die häufigsten:",
  ns_k_nome: "Nach Namen suchen", ns_k_numero: "Nicht gefunden? Die auf dem Teil aufgedruckte Zahl eingeben (z. B. 0,72 oder 2,5)", ns_k_usa: "Übernehmen",
  ns_k_fuori: "Eine Zahl zwischen 0,3 und 6 eingeben: zum Beispiel 0,72 für einen Reducer, 2,5 für eine Barlow.",
  ns_k_uno: "So nah an 1 ändert sich die Brennweite nicht: „Keiner“ antippen. Ein Reducer liegt unter 1 (0,8), eine Barlow darüber (2).",
  ns_k_uguale: "die Brennweite bleibt gleich (Flattener oder Korrektor)", ns_k_non_qui: "Nicht dabei? Die Zahl eingeben ↓",
  ns_k_non_trovato: "Nicht gefunden: unten die auf dem Teil aufgedruckte Zahl eingeben ↓",
  ns_nessun_k: "Keiner", ns_altro_k: "Anderer Reducer oder Barlow…", ns_smart: "Smart-Teleskop: Die Kamera ist eingebaut, ein Reducer ist nicht nötig.",
  ns_anteprima: "So sieht {o} in Ihrem Bildfeld aus", ns_nome: "Name des Setups", ns_salva: "Setup speichern", ns_salvato: "Gespeichert: „{n}“. Die Teile sind auch in Ihrer Ausrüstung.",
  ns_gia: "Dieses Setup haben Sie schon: „{n}“.", ns_pieni: "Sie haben bereits {n} Setups: Entfernen Sie eines, um ein neues zu speichern.",
  ns_campo: "Im Bildfeld öffnen", ns_stanotte: "Was Sie heute Nacht fotografieren können", ns_altro: "Noch ein Setup erstellen", ns_chiudi: "Schließen",
  ns_focale: "Effektive Brennweite", ns_scala: "Abbildungsmaßstab", ns_campo_t: "Bildfeld", ns_ingr: "Vergrößerung", ns_pupilla: "Austrittspupille",
  ns_giudizio_ok: "Passendes Sampling für {s}″ Seeing", ns_giudizio_fine: "Kleine Pixel für dieses Teleskop: bei {s}″ Seeing lohnt sich {b}×{b}-Binning",
  ns_giudizio_grosso: "Große Pixel für dieses Teleskop: Sterne können eckig wirken",
});
Object.assign(TESTI.es, {
  ns_titolo: "Nueva configuración en 4 pasos", ns_apri: "Crear una configuración", ns_apri_n: "Telescopio, reductor y cámara: un paso cada vez, y ves enseguida qué encuadras en el cielo.",
  ns_p_tel: "Telescopio", ns_p_k: "Reductor", ns_p_cam: "Cámara", ns_p_oc: "Ocular", ns_p_fine: "Guardar",
  ns_q_tel: "¿Qué telescopio u objetivo usas?", ns_q_k: "¿Usas un reductor o una Barlow?", ns_q_cam: "¿Con qué cámara fotografías?", ns_q_oc: "¿Con qué ocular observas?",
  ns_q_fine: "Esta es tu configuración", ns_foto: "Fotografío", ns_visuale: "Observo con ocular",
  ns_cambia: "Cambiar", ns_avanti: "Siguiente", ns_indietro: "Atrás", ns_salta: "Ninguno, siguiente",
  ns_mano: "¿No lo encuentras? Escríbelo a mano", ns_usa: "Usar este", ns_tuoi: "De tu equipo:", ns_comuni: "Los más comunes:",
  ns_k_nome: "Búscalo por nombre", ns_k_numero: "¿No lo encuentras? Escribe el número que lleva impreso (p. ej. 0,72 o 2,5)", ns_k_usa: "Usar",
  ns_k_fuori: "Escribe un número entre 0,3 y 6: por ejemplo 0,72 para un reductor, 2,5 para una Barlow.",
  ns_k_uno: "Tan cerca de 1 la focal no cambia: toca «Ninguno». Un reductor está por debajo de 1 (0,8), una Barlow por encima (2).",
  ns_k_uguale: "la focal no cambia (aplanador o corrector)", ns_k_non_qui: "¿No está entre estos? Escribe el número ↓",
  ns_k_non_trovato: "No lo encontramos: escribe abajo el número que lleva impreso ↓",
  ns_nessun_k: "Ninguno", ns_altro_k: "Otro reductor o Barlow…", ns_smart: "Smart telescope: la cámara ya está dentro, el reductor no hace falta.",
  ns_anteprima: "Así encuadras {o}", ns_nome: "Nombre de la configuración", ns_salva: "Guardar la configuración", ns_salvato: "Guardada: «{n}». Las piezas también están en tu equipo.",
  ns_gia: "Ya tienes esta configuración: «{n}».", ns_pieni: "Ya tienes {n} configuraciones: quita una para guardar otra.",
  ns_campo: "Abrir en Campo de visión", ns_stanotte: "Qué fotografiar esta noche", ns_altro: "Crear otra configuración", ns_chiudi: "Cerrar",
  ns_focale: "Focal efectiva", ns_scala: "Escala", ns_campo_t: "Campo", ns_ingr: "Aumentos", ns_pupilla: "Pupila de salida",
  ns_giudizio_ok: "Muestreo adecuado para un seeing de {s}″", ns_giudizio_fine: "Píxeles pequeños para este telescopio: con {s}″ de seeing conviene el binning {b}×{b}",
  ns_giudizio_grosso: "Píxeles grandes para este telescopio: las estrellas pueden salir cuadradas",
});
Object.assign(TESTI.en, {
  ns_titolo: "New setup in 4 steps", ns_apri: "Create a setup", ns_apri_n: "Telescope, reducer and camera: one step at a time, and you see right away what you frame in the sky.",
  ns_p_tel: "Telescope", ns_p_k: "Reducer", ns_p_cam: "Camera", ns_p_oc: "Eyepiece", ns_p_fine: "Save",
  ns_q_tel: "Which telescope or lens do you use?", ns_q_k: "Do you use a reducer or a Barlow?", ns_q_cam: "Which camera do you shoot with?", ns_q_oc: "Which eyepiece do you observe with?",
  ns_q_fine: "Here's your setup", ns_foto: "I take photos", ns_visuale: "I use an eyepiece",
  ns_cambia: "Change", ns_avanti: "Next", ns_indietro: "Back", ns_salta: "None, next",
  ns_mano: "Can't find it? Type it in", ns_usa: "Use this", ns_tuoi: "From your equipment:", ns_comuni: "Most common:",
  ns_k_nome: "Search by name", ns_k_numero: "Can't find it? Type the number printed on the part (e.g. 0.72 or 2.5)", ns_k_usa: "Use",
  ns_k_fuori: "Type a number between 0.3 and 6: for example 0.72 for a reducer, 2.5 for a Barlow.",
  ns_k_uno: "That close to 1, the focal length doesn't change: tap “None”. A reducer is below 1 (0.8), a Barlow above (2).",
  ns_k_uguale: "the focal length stays the same (flattener or corrector)", ns_k_non_qui: "Not among these? Type the number ↓",
  ns_k_non_trovato: "We can't find it: type the number printed on the part in the box below ↓",
  ns_nessun_k: "None", ns_altro_k: "Another reducer or Barlow…", ns_smart: "Smart telescope: the camera is built in, no reducer needed.",
  ns_anteprima: "This is how you frame {o}", ns_nome: "Setup name", ns_salva: "Save the setup", ns_salvato: "Saved: “{n}”. Its items are now in your equipment too.",
  ns_gia: "You already have this setup: “{n}”.", ns_pieni: "You already have {n} setups: remove one to save another.",
  ns_campo: "Open in Field of view", ns_stanotte: "What to shoot tonight", ns_altro: "Create another setup", ns_chiudi: "Close",
  ns_focale: "Effective focal length", ns_scala: "Image scale", ns_campo_t: "Field", ns_ingr: "Magnification", ns_pupilla: "Exit pupil",
  ns_giudizio_ok: "Good sampling for {s}″ seeing", ns_giudizio_fine: "Small pixels for this telescope: with {s}″ seeing {b}×{b} binning is better",
  ns_giudizio_grosso: "Large pixels for this telescope: stars may look blocky",
});
const NS_ANTEPRIME = ["M31", "M42", "M45", "M33", "NGC 7000", "M101", "M81", "M51", "M27", "M13", "IC 1396", "M8", "M16", "M57", "NGC 2244", "M1"];
let NS_APRI = false;
function percorsoSetup(dopo, aperto) {
  const carta = el("section", { class: "gas-card gas-ns" + (aperto ? " gas-ns--aperto" : "") });
  const s = { modo: CAMPO.modo === "visuale" ? "visuale" : "foto", tel: null, k: 1, cam: null, oc: null, bin: 1 };
  let passo = 0, salvatoNome = "";
  const bozza = ricorda("ns_bozza", null);
  if (bozza && bozza.s && bozza.s.tel) { Object.assign(s, bozza.s); passo = clamp(bozza.passo || 0, 0, 3); carta.classList.add("gas-ns--aperto"); }
  const salvaBozza = () => salva("ns_bozza", s.tel && !salvatoNome && carta.classList.contains("gas-ns--aperto") && !SETUP_ELENCO.some(x => stessoSetup(x, s)) ? { s, passo } : null);
  const passi = () => [["tel", t("ns_p_tel")], ["k", t("ns_p_k")], [s.modo === "visuale" ? "oc" : "cam", t(s.modo === "visuale" ? "ns_p_oc" : "ns_p_cam")], ["fine", t("ns_p_fine")]];
  const fatto = i => i === 0 ? !!s.tel : i === 1 ? !!s.tel : i === 2 ? (s.modo === "visuale" ? !!s.oc : !!s.cam) : !!salvatoNome;
  const fuocoDomanda = () => { const d = $(".gas-ns-domanda", carta) || $(".gas-ns-via", carta); if (d) d.focus({ preventScroll: true }); };
  const vaiPasso = i => {
    if (i === 1 && s.tel && s.tel.smart) i = passo > 1 ? 0 : 2;
    passo = clamp(i, 0, 3); disegna(); carta.scrollIntoView({ block: "start", behavior: "smooth" }); fuocoDomanda();
  };
  const regolaSmart = () => {
    if (!(s.tel && s.tel.smart)) return false;
    s.k = 1; s.kVoce = null; s.modo = "foto";
    const c = typeof camSmartPer === "function" ? camSmartPer(s.tel.nome, s.tel.h) : null;
    if (c) s.cam = camScelta(c);
    return !!c;
  };
  const prendiTel = x => { s.tel = x; regolaSmart(); disegna(); };
  const avanti = () => {
    if (passo === 0 && s.tel && s.tel.smart) { vaiPasso(regolaSmart() ? 3 : 2); return; }
    vaiPasso(passo + 1);
  };
  function disegnaChiusa() {
    svuota(carta).append(el("div", { class: "gas-ns-invito" },
      el("span", { class: "gas-ns-invito-ico" }, icona("attrezzatura")),
      el("div", { class: "gas-ns-invito-testo" }, el("b", null, t("ns_titolo")), el("span", null, t("ns_apri_n"))),
      el("button", { type: "button", class: "gas-btn gas-ns-via", onclick: () => { carta.classList.add("gas-ns--aperto"); passo = 0; disegna(); fuocoDomanda(); } }, "+ ", t("ns_apri"))));
  }
  function barraPassi() {
    return el("ol", { class: "gas-ns-passi" }, passi().map(([, nome], i) => el("li", { class: i === passo ? "on" : i < passo ? "ok" : "" },
      el("button", { type: "button", "aria-current": i === passo ? "step" : null, onclick: () => vaiPasso(i),
        disabled: (i === 1 && !!(s.tel && s.tel.smart)) || (i > passo && !(i <= 3 && [0, 1, 2].slice(0, i).every(fatto))) },
        el("i", null, i < passo ? "✓" : String(i + 1)), el("span", null, nome)))));
  }
  const scelto = (tipo, x, cambia) => el("div", { class: "gas-ns-scelto" }, fotoAttrezzo(tipo, x),
    el("div", { class: "gas-att-testo" }, el("b", null, TIPI_ATT[tipo].nome(x)), TIPI_ATT[tipo].sotto(x) ? el("small", null, TIPI_ATT[tipo].sotto(x)) : null),
    el("button", { type: "button", class: "gas-btn gas-btn--chiaro gas-btn--mini", onclick: cambia }, t("ns_cambia")));
  const tuoi = (tipo, prendi) => ATTREZZI && ATTREZZI[tipo].length ? el("div", { class: "gas-ns-tuoi" }, el("small", { class: "gas-setup-etich" }, t("ns_tuoi")),
    el("div", { class: "gas-rapida-riga" }, ATTREZZI[tipo].map(x => el("button", { type: "button", class: "gas-rapida-btn", onclick: () => prendi(copiaProfonda(x)) },
      nomeCorto(TIPI_ATT[tipo].nome(x)))))) : null;
  function ricercaConMano(o) {
    const valori = {}, campi = o.campi.map(([k, e, u, p]) => campoNumero(e, null, v => { valori[k] = v; }, { unita: u, min: 0, passo: p }));
    const nome = el("input", { type: "text", class: "gas-input", maxlength: 60, placeholder: t("att_nome"), "aria-label": t("att_nome") });
    const mano = el("details", { class: "gas-dettagli gas-ns-mano" }, el("summary", null, t("ns_mano")),
      el("div", { class: campi.length > 2 ? "gas-tre" : "gas-due" }, campi), o.nota ? el("small", { class: "gas-muto" }, o.nota) : null,
      el("div", { class: "gas-riga-bottoni" }, nome, el("button", { type: "button", class: "gas-btn gas-btn--mini", onclick: () => {
        const x = o.daMano(valori, nome.value.trim());
        if (x) o.prendi(x); else avvisaMancanti(mano);
      } }, t("ns_usa"))));
    const daRicerca = new Set();
    nome.addEventListener("input", () => daRicerca.delete(nome));
    campi.forEach(c => $$("input", c).forEach(i => i.addEventListener("input", () => daRicerca.delete(i))));
    const riempi = q => {
      mano.open = true;
      if (!nome.value.trim() || daRicerca.has(nome)) { nome.value = q.slice(0, 60); daRicerca.add(nome); }
      const v = o.indovina ? o.indovina(q) : null;
      o.campi.forEach(([k], i) => {
        const inp = $("input", campi[i]);
        if (!inp || (inp.value && !daRicerca.has(inp))) return;
        if (v && v[k] != null) { inp.value = String(v[k]); valori[k] = v[k]; daRicerca.add(inp); }
        else if (daRicerca.has(inp)) { inp.value = ""; delete valori[k]; daRicerca.delete(inp); }
      });
    };
    const cerca = creaCerca({ segnaposto: o.segnaposto, cerca: o.cerca, riga: o.riga, scegli: x => o.prendi(o.daVoce(x)),
      senza: { testo: t("att_non_trovato"), apri: riempi, tocca: () => { mano.open = true; mano.scrollIntoView({ block: "center", behavior: "smooth" }); } } });
    setTimeout(() => { if (cerca.input.isConnected && window.innerWidth >= 768) cerca.input.focus({ preventScroll: true }); }, 60);
    return [cerca.box, mano];
  }
  function passoTel() {
    if (s.tel) return [scelto("tel", s.tel, () => { if (s.tel.smart) s.cam = null; s.tel = null; disegna(); }), configurazioniDi(), bottoniDiaframma(s.tel, () => disegna())];
    return [tuoi("tel", prendiTel), ...ricercaConMano({
      segnaposto: t("cerca_telescopio"), cerca: q => cercaTelescopi(q, 40), daVoce: telDaVoce,
      riga: x => ({ titolo: titoloTelescopio(x), sotto: rigaTelescopio(x), foto: x.foto }),
      prendi: prendiTel,
      campi: [["D", t("diametro"), "mm", "1"], ["F", t("focale"), "mm", "1"], ["N", t("att_fn"), "", "0.1"]], nota: t("att_fn_n"),
      indovina: indovinaTelescopio,
      daMano: (v, n) => {
        const D = v.D > 0 ? v.D : v.F > 0 && v.N > 0 ? Math.round(v.F / v.N * 10) / 10 : null, F = v.F > 0 ? v.F : v.D > 0 && v.N > 0 ? Math.round(v.D * v.N) : null;
        if (!(D > 0 && F > 0)) return null;
        const lente = !(v.D > 0) && v.N > 0;
        return Object.assign({ nome: n || (lente ? `${num(F)} mm f/${num(v.N, 1)}` : `${num(D)}/${num(F)} mm`), D, F }, lente ? { lente: true } : {});
      },
    })];
  }
  function configurazioniDi() {
    const conf = s.tel && s.tel.h ? configurazioni(s.tel.h) : [];
    if (!conf.length) return null;
    return el("div", { class: "gas-seg gas-seg--config", role: "group", "aria-label": t("configurazione") }, conf.map(x => {
      const on = x.D === s.tel.D && x.F === s.tel.F;
      return el("button", { type: "button", class: on ? "on" : "", "aria-pressed": String(on), onclick: () => { s.tel = telDaVoce(x); disegna(); } },
        el("b", null, nomeConfigurazione(x)), el("small", null, `${num(x.D)}/${num(x.F)} mm · f/${num(x.F / x.D, 1)}`));
    }));
  }
  function passoK() {
    const chip = (k, testo, sotto) => el("button", { type: "button", class: "gas-ns-chip" + (s.k === k ? " on" : ""), "aria-pressed": String(s.k === k),
      onclick: () => { s.k = k; s.kVoce = null; disegna(); } }, el("b", null, testo), sotto ? el("small", null, sotto) : null);
    const miei = ATTREZZI ? ATTREZZI.k.filter((x, i, a) => a.findIndex(y => y.k === x.k) === i) : [];
    const F = s.tel ? s.tel.F : 0;
    const comuni = (s.tel && F / s.tel.D >= 9 ? [0.63, 0.7, 0.8, 2] : [0.7, 0.8, 0.85, 2]).filter(k => !miei.some(x => x.k === k));
    const altro = selezione([["", t("ns_altro_k")], ...FATTORI.filter(f => f !== 1).map(f => [f, nomeFattore(f) + (F ? ` · ${num(F * f)} mm` : "")])], FATTORI.includes(s.k) && s.k !== 1 && ![...miei.map(x => x.k), ...comuni].includes(s.k) ? s.k : "",
      v => { if (v) { s.k = parseFloat(v); s.kVoce = null; disegna(); } }, { "aria-label": t("ns_altro_k") });
    const numero = el("input", { type: "text", inputmode: "decimal", class: "gas-input", placeholder: num(0.72, 2), "aria-label": t("ns_k_numero") });
    const avviso = el("p", { class: "gas-nota gas-att-manca", role: "alert", hidden: true }, t("ns_k_fuori"));
    const usaNumero = () => {
      const v = parseFloat(String(numero.value).replace(",", "."));
      if (!(v >= 0.3 && v <= 6) || fattoreVicino(v) === 1) { avviso.textContent = t(v >= 0.3 && v <= 6 ? "ns_k_uno" : "ns_k_fuori"); avviso.hidden = false; numero.setAttribute("aria-invalid", "true"); numero.focus(); return; }
      s.k = fattoreVicino(v); s.kVoce = null; disegna();
    };
    numero.addEventListener("keydown", e => { if (e.key === "Enter") { e.preventDefault(); usaNumero(); } });
    numero.addEventListener("input", () => { avviso.hidden = true; numero.removeAttribute("aria-invalid"); });
    const vaiNumero = () => { numero.scrollIntoView({ block: "center", behavior: "smooth" }); setTimeout(() => numero.focus({ preventScroll: true }), 300); };
    const cerca = creaCerca({ segnaposto: t("att_cerca_k"), cerca: q => cercaOttiche(q, 30),
      riga: x => ({ titolo: x.t, sotto: nomeFattore(x.k) + (F ? ` · ${num(F * x.k)} mm` : "") + (x.per ? " · " + x.per : ""), foto: x.foto }),
      scegli: x => { const k = fattoreVicino(x.k); s.k = k; s.kVoce = { nome: x.t, k, h: x.h || null }; disegna(); },
      senza: { testo: t("ns_k_non_trovato"), altro: t("ns_k_non_qui"), apri: () => {}, tocca: vaiNumero } });
    return [el("div", { class: "gas-ns-chips" }, chip(1, t("ns_nessun_k"), F ? `${num(F)} mm` : ""),
      ...miei.map(x => chip(x.k, nomeFattore(x.k), x.nome ? nomeCorto(x.nome) : F ? `${num(F * x.k)} mm` : "")),
      ...comuni.map(k => chip(k, nomeFattore(k), F ? `${num(F * k)} mm` : ""))),
    s.kVoce && s.kVoce.k === s.k ? el("p", { class: "gas-setup-ok" }, "✓ ", s.kVoce.nome, " · ", s.k === 1 ? t("ns_k_uguale") : nomeFattore(s.kVoce.k)) : null,
    el("div", { class: "gas-ns-altro" }, altro),
    el("div", { class: "gas-ns-k-cerca" }, el("small", { class: "gas-setup-etich" }, t("ns_k_nome")), cerca.box),
    el("label", { class: "gas-campo gas-ns-k-numero" }, el("span", null, t("ns_k_numero")),
      el("span", { class: "gas-riga-bottoni" }, numero, el("button", { type: "button", class: "gas-btn gas-btn--mini", onclick: usaNumero }, t("ns_k_usa")))),
    avviso];
  }
  function passoFine3() {
    const seg = el("div", { class: "gas-seg gas-ns-modo", role: "group" }, ["foto", "visuale"].map(m => el("button", { type: "button", class: s.modo === m ? "on" : "",
      "aria-pressed": String(s.modo === m), onclick: () => { s.modo = m; disegna(); } }, t(m === "foto" ? "ns_foto" : "ns_visuale"))));
    if (s.tel && s.tel.smart && s.cam) return [el("p", { class: "gas-nota" }, t("ns_smart")), scelto("cam", s.cam, () => { s.cam = null; disegna(); })];
    if (s.modo === "visuale") {
      if (s.oc) return [seg, scelto("oc", s.oc, () => { s.oc = null; disegna(); })];
      return [seg, tuoi("oc", x => { s.oc = x; disegna(); }), ...ricercaConMano({
        segnaposto: t("cerca_oculare"), cerca: q => cercaOculari(q, 40), daVoce: x => ({ nome: x.t, f: x.f, afov: x.afov, h: x.h, foto: x.foto }),
        riga: x => ({ titolo: x.t, sotto: `${num(x.f, x.f % 1 ? 1 : 0)} mm · ${num(x.afov)}°`, foto: x.foto }),
        prendi: x => { s.oc = x; disegna(); },
        campi: [["f", t("focale_oculare"), "mm", "0.1"], ["afov", t("campo_apparente"), "°", "1"]], indovina: indovinaOculare,
        daMano: (v, n) => v.f > 0 && v.afov > 0 ? { nome: n || `${num(v.f, v.f % 1 ? 1 : 0)} mm ${num(v.afov)}°`, f: v.f, afov: v.afov } : null,
      })];
    }
    if (s.cam) return [seg, scelto("cam", s.cam, () => { s.cam = null; disegna(); })];
    return [seg, tuoi("cam", x => { s.cam = x; disegna(); }), ...ricercaConMano({
      segnaposto: t("cerca_camera"), cerca: q => cercaCamere(q, 40), daVoce: camScelta,
      riga: c => ({ titolo: c.nome, sotto: rigaCamera(c), extra: c.h_negozio ? t("in_vendita") : "", foto: c.foto }),
      prendi: x => { s.cam = x; disegna(); },
      campi: [["w", t("larghezza_px"), "px", "1"], ["h", t("altezza_px"), "px", "1"], ["px", t("pixel"), "µm", "0.01"]],
      daMano: (v, n) => v.w > 0 && v.h > 0 && v.px > 0 ? { nome: n || `${num(v.w)}×${num(v.h)} · ${num(v.px, 2)} µm`, w: v.w, h: v.h, px: v.px } : null,
    })];
  }
  function passoFine() {
    const r = calcoloCampo(s) || {};
    const numeri = el("div", { class: "gas-ns-numeri" });
    const n = (etich, val, sotto) => numeri.appendChild(el("div", { class: "gas-ns-num" }, el("small", null, etich), el("b", null, val), sotto ? el("span", null, sotto) : null));
    n(t("ns_focale"), `${num(r.F)} mm`, `f/${num(r.N, 1)}`);
    let campo = null, giudizio = null;
    if (s.modo === "foto" && r.fovW) {
      n(t("ns_scala"), `${num(r.scala, 2)}″/px`);
      n(t("ns_campo_t"), angoli(r.fovW, r.fovH));
      campo = { w: r.fovW, h: r.fovH };
      const sg = CAMPO.seeing || 2.5, ppf = sg / r.scala;
      giudizio = el("p", { class: "gas-ns-giudizio " + (ppf > 4 ? "medio" : ppf < 1.3 ? "medio" : "ok") },
        t(ppf > 4 ? "ns_giudizio_fine" : ppf < 1.3 ? "ns_giudizio_grosso" : "ns_giudizio_ok", { s: num(sg, 1), b: Math.max(2, Math.round(ppf / 2.5)) }));
    } else if (r.M) {
      n(t("ns_ingr"), `${num(r.M)}×`);
      n(t("ns_campo_t"), angolo(r.campo), `${t("ns_pupilla")} ${num(r.pupilla, 1)} mm`);
      campo = { w: r.campo, h: r.campo };
    }
    let anteprima = null;
    if (campo) {
      const o = NS_ANTEPRIME.map(trovaOggetto).filter(Boolean).sort((a, b) => Math.abs(Math.log(riempimento(a, campo) / 55)) - Math.abs(Math.log(riempimento(b, campo) / 55)))[0];
      if (o) {
        const tela = el("canvas", { class: "gas-anteprima-tela", role: "img", "aria-label": titoloOggetto(o) });
        const img = FOTO_DSS ? el("img", { class: "gas-anteprima-foto", alt: "", decoding: "async" }) : null;
        anteprima = el("figure", { class: "gas-ns-anteprima" }, el("div", { class: "gas-anteprima" }, img, tela), el("figcaption", null, t("ns_anteprima", { o: titoloOggetto(o) })));
        requestAnimationFrame(() => {
          const prima = { cam: CAMPO.cam, modo: CAMPO.modo };
          CAMPO.cam = s.cam; CAMPO.modo = s.modo;
          try { Mappa.anteprima(tela, o, campo, img).catch(e => console.error("strumenti, anteprima setup:", e)); } finally { Object.assign(CAMPO, prima); }
        });
      }
    }
    const gia = SETUP_ELENCO.find(x => stessoSetup(x, s));
    const fine = el("div", { class: "gas-ns-salva" });
    if (salvatoNome) {
      fine.append(el("p", { class: "gas-setup-ok" }, "✓ ", t("ns_salvato", { n: salvatoNome })),
        el("div", { class: "gas-riga-bottoni" },
          el("button", { type: "button", class: "gas-btn", onclick: () => vai("campo") }, icona("campo"), " ", t("ns_campo")),
          el("button", { type: "button", class: "gas-btn gas-btn--chiaro", onclick: () => vai("stanotte") }, icona("stella"), " ", t("ns_stanotte")),
          el("button", { type: "button", class: "gas-btn gas-btn--chiaro", onclick: () => ricomincia() }, "+ ", t("ns_altro"))));
    } else if (gia) {
      fine.append(el("p", { class: "gas-setup-ok" }, "✓ ", t("ns_gia", { n: gia.nome })),
        el("div", { class: "gas-riga-bottoni" }, el("button", { type: "button", class: "gas-btn", onclick: () => { usaSetup(gia); vai("campo"); } }, icona("campo"), " ", t("ns_campo"))));
    } else if (SETUP_ELENCO.length >= SETUP_MAX) fine.append(el("p", { class: "gas-muto" }, t("ns_pieni", { n: SETUP_MAX })));
    else {
      const nome = el("input", { type: "text", class: "gas-input gas-setup-nome", maxlength: 60, value: s.nomeScritto || nomeSetupAuto(s), "aria-label": t("ns_nome"),
        onfocus: e => e.target.select(), oninput: e => { s.nomeScritto = e.target.value; salvaBozza(); } });
      const salvaOra = () => {
        if (!puoSalvare()) return invitoAccount();
        const pezzo = copiaProfonda(s), kVoce = pezzo.kVoce;
        delete pezzo.kVoce; delete pezzo.nomeScritto;
        metti("tel", pezzo.tel);
        if (pezzo.k && pezzo.k !== 1 && !ATTREZZI.k.some(y => y.k === pezzo.k)) metti("k", kVoce && kVoce.k === pezzo.k ? kVoce : { k: pezzo.k });
        if (pezzo.modo === "visuale") metti("oc", pezzo.oc); else if (!(pezzo.tel && pezzo.tel.smart)) metti("cam", pezzo.cam);
        salvaAttrezzi();
        if (!salvaSetup(nome.value, pezzo)) return;
        salvatoNome = SETUP_ELENCO[SETUP_ELENCO.length - 1].nome;
        usaSetup(pezzo);
        aggiornaSetupUI();
        disegna();
        if (dopo) dopo();
      };
      nome.addEventListener("keydown", e => { if (e.key === "Enter") { e.preventDefault(); salvaOra(); } });
      fine.append(el("label", { class: "gas-campo" }, el("span", null, t("ns_nome")),
        el("div", { class: "gas-setup-salva" }, nome, el("button", { type: "button", class: "gas-btn", onclick: salvaOra }, t("ns_salva")))),
        el("small", { class: "gas-muto" }, t("nome_foto_n")));
    }
    return [el("div", { class: "gas-ns-riep" }, el("div", null, numeri, giudizio, fine), anteprima)];
  }
  function ricomincia() { Object.assign(s, { tel: null, k: 1, kVoce: null, cam: null, oc: null, nomeScritto: null }); salvatoNome = ""; passo = 0; disegna(); }
  carta.salvaSeServe = () => {
    if (!s.tel || salvatoNome || !puoSalvare() || !carta.classList.contains("gas-ns--aperto")) return false;
    const pezzo = copiaProfonda(s), completo = pezzo.modo === "visuale" ? !!pezzo.oc : !!pezzo.cam, kVoce = pezzo.kVoce, scritto = pezzo.nomeScritto;
    delete pezzo.kVoce; delete pezzo.nomeScritto;
    metti("tel", pezzo.tel);
    if (pezzo.k && pezzo.k !== 1 && !ATTREZZI.k.some(y => y.k === pezzo.k)) metti("k", kVoce && kVoce.k === pezzo.k ? kVoce : { k: pezzo.k });
    if (completo && (pezzo.modo === "visuale" || !(pezzo.tel && pezzo.tel.smart))) metti(pezzo.modo === "visuale" ? "oc" : "cam", pezzo.modo === "visuale" ? pezzo.oc : pezzo.cam);
    salvaAttrezzi();
    if (completo) {
      const campoNome = $(".gas-setup-nome", carta);
      if (salvaSetup(campoNome ? campoNome.value : scritto || "", pezzo)) salvatoNome = SETUP_ELENCO[SETUP_ELENCO.length - 1].nome;
      usaSetup(pezzo);
    }
    else usaSetup(Object.assign({}, pezzo, { cam: null, oc: null }));
    salva("ns_bozza", null);
    return true;
  };
  carta.apri = () => {
    if (salvatoNome) { carta.classList.add("gas-ns--aperto"); ricomincia(); }
    else if (!carta.classList.contains("gas-ns--aperto")) { carta.classList.add("gas-ns--aperto"); passo = 0; disegna(); }
    carta.scrollIntoView({ block: "start", behavior: "smooth" });
    fuocoDomanda();
  };
  function disegna() {
    const fuoco = carta.contains(document.activeElement);
    salvaBozza();
    if (!carta.classList.contains("gas-ns--aperto")) { disegnaChiusa(); if (fuoco) fuocoDomanda(); return; }
    const domande = [t("ns_q_tel"), t("ns_q_k"), t(s.modo === "visuale" ? "ns_q_oc" : "ns_q_cam"), t("ns_q_fine")];
    const corpo = passo === 0 ? passoTel() : passo === 1 ? passoK() : passo === 2 ? passoFine3() : passoFine();
    const puoAvanti = passo < 3 && (passo === 1 || fatto(passo));
    svuota(carta).append(
      el("div", { class: "gas-ns-testa" }, el("h3", null, t("ns_titolo")),
        el("button", { type: "button", class: "gas-ns-chiudi", "aria-label": t("ns_chiudi"), title: t("ns_chiudi"),
          onclick: () => { carta.classList.remove("gas-ns--aperto"); if (salvatoNome) ricomincia(); else disegna(); } }, icona("chiudi"))),
      barraPassi(),
      el("p", { class: "gas-ns-domanda", tabindex: "-1" }, domande[passo]),
      el("div", { class: "gas-ns-corpo" }, corpo),
      passo < 3 ? el("div", { class: "gas-ns-piede" },
        passo ? el("button", { type: "button", class: "gas-btn gas-btn--chiaro", onclick: () => vaiPasso(passo - 1) }, "← ", t("ns_indietro")) : el("span"),
        el("button", { type: "button", class: "gas-btn gas-ns-avanti", disabled: !puoAvanti, onclick: avanti },
          passo === 1 && s.k === 1 ? t("ns_salta") : t("ns_avanti"), " →")) : el("div", { class: "gas-ns-piede" },
        el("button", { type: "button", class: "gas-btn gas-btn--chiaro", onclick: () => vaiPasso(2) }, "← ", t("ns_indietro")), el("span")));
    if (fuoco && !carta.contains(document.activeElement)) fuocoDomanda();
  }
  disegna();
  return carta;
}
function bottoneNuovoSetup(cl) {
  return el("button", { type: "button", class: "gas-btn gas-btn--chiaro gas-btn--mini gas-ns-link " + (cl || ""),
    onclick: () => { NS_APRI = true; vai("attrezzatura"); } }, "+ ", t("ns_apri"));
}
const NOTTE = Object.assign({
  luogo: { nome: LUOGO_PREDEFINITO[0], lat: LUOGO_PREDEFINITO[1], lon: LUOGO_PREDEFINITO[2] },
  data: "", hmin: 30, tipo: "tutti", cost: "", magmax: "", famosi: true, campo: false, ordine: "migliori", bortle: 5,
}, ricorda("notte", {}));
function salvaNotte() { salva("notte", Object.assign({}, NOTTE, { data: "" })); }
const ATLANTE_STATO = "eyJiYXNlbWFwIjoiTGF5ZXJCaW5nUm9hZCIsIm92ZXJsYXkiOiJ3YV8yMDE1Iiwib3ZlcmxheWNvbG9yIjpmYWxzZSwib3ZlcmxheW9wYWNpdHkiOjYwLCJmZWF0dXJlc29wYWNpdHkiOjg1fQ==";
const GRUPPI_TIPO = {
  galassie: ["gx", "gxg", "gxcl"], emissione: ["en", "cn"], riflessione: ["rn"], oscure: ["dn"], planetarie: ["pn"],
  supernova: ["snr"], aperti: ["oc", "sc"], globulari: ["gc"], altre: ["neb", "reg", "gxp", "ds"],
};
const SCELTE_TIPO = { galassie: ["galassie"], nebulose: ["emissione", "riflessione"], oscure: ["oscure"], planetarie: ["planetarie"],
  supernova: ["supernova"], aperti: ["aperti"], globulari: ["globulari"], altre: ["altre"] };
Object.assign(TESTI.it, { nr_nebulose: "Nebulose" });
Object.assign(TESTI.de, { nr_nebulose: "Nebel" });
Object.assign(TESTI.es, { nr_nebulose: "Nebulosas" });
Object.assign(TESTI.en, { nr_nebulose: "Nebulae" });
const nomeSceltaTipo = k => (k === "nebulose" ? t("nr_nebulose") : t("gruppo_" + k));
function tipiNotte() {
  if (!Array.isArray(NOTTE.tipi)) NOTTE.tipi = NOTTE.tipo && NOTTE.tipo !== "tutti" ? [["emissione", "riflessione"].includes(NOTTE.tipo) ? "nebulose" : NOTTE.tipo] : [];
  return NOTTE.tipi.filter(k => SCELTE_TIPO[k]);
}
function codiciTipiNotte() {
  const l = tipiNotte();
  return l.length ? new Set(l.flatMap(k => SCELTE_TIPO[k].flatMap(g => GRUPPI_TIPO[g]))) : null;
}
const DIFFUSI = new Set(["gx", "gxg", "gxcl", "gxp", "en", "cn", "rn", "dn", "snr", "neb", "reg", "pn"]);
const PIANETI = ["mercurio", "venere", "marte", "giove", "saturno", "urano", "nettuno"];
function dataNotte() {
  if (NOTTE.data) {
    const [y, m, d] = NOTTE.data.split("-").map(Number);
    if (y && m && d) return new Date(y, m - 1, d, 12);
  }
  const ora = new Date();
  if (ora.getHours() < 12) {
    const ieri = new Date(ora.getFullYear(), ora.getMonth(), ora.getDate() - 1, 12);
    if (!(fineNotte(ieri) < ora)) return ieri;
  }
  return new Date(ora.getFullYear(), ora.getMonth(), ora.getDate(), 12);
}
let _fineNotte = null;
function fineNotte(d) {
  const { lat, lon } = NOTTE.luogo || {}, chiave = `${isoData(d)}|${lat}|${lon}`;
  if (_fineNotte && _fineNotte.chiave === chiave) return _fineNotte.fine;
  let fine = null;
  try { const ev = Astro.notte(d, lat, lon, 20).ev; fine = ev.astroInizio || ev.nauticoInizio || null; } catch (e) {   }
  _fineNotte = { chiave, fine };
  return fine;
}
function isoData(d) { return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`; }
let _cacheNotte = null;
function calcolaNotte() {
  const d = dataNotte(), { lat, lon } = NOTTE.luogo;
  const chiave = `${isoData(d)}|${lat}|${lon}`;
  if (_cacheNotte && _cacheNotte.chiave === chiave) return _cacheNotte;
  const nt = Astro.notte(d, lat, lon, 10);
  const buio = nt.buio;
  const meta = buio.length ? buio[Math.floor(buio.length / 2)] : Math.floor(nt.n / 2);
  const lunaM = nt.lune[meta];
  const lunaSu = buio.length ? buio.filter(i => nt.hLuna[i] > 0).length / buio.length : 0;
  const righe = DATI.oggetti.filter(o => !o.soloCerca).map(o => rigaCalcolata(o, nt, lunaM));
  _cacheNotte = { chiave, nt, righe, meta, lunaSu, lunaM, giorno: d };
  return _cacheNotte;
}
function rigaCalcolata(o, nt, lunaM) {
  const c = Astro.curvaOggetto(nt, o.ra, o.dec);
  let hMax = -90, iMax = -1, n = 0;
  for (const i of nt.buio) { if (c.h[i] > hMax) { hMax = c.h[i]; iMax = i; } }
  return { o, h: c.h, ra: c.ra, dec: c.dec, hMax, iMax, sep: Astro.separazione(lunaM.ra, lunaM.dec, c.ra, c.dec), n };
}
function rigaDi(c, o) {
  const r = c.righe.find(x => x.o === o);
  if (r || !o.soloCerca) return r;
  const altre = c.cercati || (c.cercati = new Map());
  if (!altre.has(o)) altre.set(o, rigaCalcolata(o, c.nt, c.lunaM));
  return altre.get(o);
}
function oreSopra(r, nt, hmin) {
  let n = 0;
  for (const i of nt.buio) if (r.h[i] >= hmin) n++;
  return n * nt.passo / 60;
}
Object.assign(TESTI.it, { vs_titolo: "La mia vista: balcone, finestra, giardino", vs_on: "Mostra solo gli oggetti nella parte di cielo che vedo",
  vs_da: "Da (azimut)", vs_a: "A (azimut)", vs_hmax: "Altezza massima", vs_nessun_limite: "Nessun limite",
  vs_n: "In senso orario: 0° = nord, 90° = est, 180° = sud, 270° = ovest. Per esempio, da sud a ovest è da 180 a 270. L'altezza massima serve se sopra di te c'è un tetto o il balcone del piano di sopra.",
  vs_rapidi: "Verso:", vs_nord: "Nord", vs_est: "Est", vs_sud: "Sud", vs_ovest: "Ovest", vs_card: "N,E,S,O",
  vs_nota: "nella tua vista da {a}° a {b}°{h}", vs_fino: ", fino a {h}° di altezza", vs_pill_on: "Attiva", vs_pill_off: "Spenta",
  vs_stato_off: "Hai un balcone o una finestra? Dicci dove vedi il cielo: restano solo gli oggetti che puoi inquadrare davvero.",
  vs_stato_on: "Vedi da {a} a {b}{h}: nell'elenco restano solo gli oggetti che passano lì." });
Object.assign(TESTI.de, { vs_titolo: "Mein Himmelsausschnitt: Balkon, Fenster, Garten", vs_on: "Nur Objekte im Himmelsausschnitt zeigen, den ich sehe",
  vs_da: "Von (Azimut)", vs_a: "Bis (Azimut)", vs_hmax: "Maximale Höhe", vs_nessun_limite: "Keine Grenze",
  vs_n: "Im Uhrzeigersinn: 0° = Nord, 90° = Ost, 180° = Süd, 270° = West. Von Süd bis West ist zum Beispiel 180 bis 270. Die maximale Höhe brauchen Sie, wenn über Ihnen ein Dach oder der Balkon des oberen Stockwerks ist.",
  vs_rapidi: "Richtung:", vs_nord: "Nord", vs_est: "Ost", vs_sud: "Süd", vs_ovest: "West", vs_card: "N,O,S,W",
  vs_nota: "in Ihrem Ausschnitt von {a}° bis {b}°{h}", vs_fino: ", bis {h}° Höhe", vs_pill_on: "Aktiv", vs_pill_off: "Aus",
  vs_stato_off: "Balkon oder Fenster? Sagen Sie uns, wo Sie den Himmel sehen: Es bleiben nur die Objekte, die Sie von dort wirklich sehen können.",
  vs_stato_on: "Sie sehen von {a} bis {b}{h}: In der Liste bleiben nur Objekte, die dort vorbeiziehen." });
Object.assign(TESTI.es, { vs_titolo: "Mi vista: balcón, ventana, jardín", vs_on: "Mostrar solo los objetos en la parte del cielo que veo",
  vs_da: "Desde (acimut)", vs_a: "Hasta (acimut)", vs_hmax: "Altura máxima", vs_nessun_limite: "Sin límite",
  vs_n: "En sentido horario: 0° = norte, 90° = este, 180° = sur, 270° = oeste. Por ejemplo, de sur a oeste es de 180 a 270. La altura máxima sirve si encima tienes un tejado o el balcón del piso de arriba.",
  vs_rapidi: "Hacia:", vs_nord: "Norte", vs_est: "Este", vs_sud: "Sur", vs_ovest: "Oeste", vs_card: "N,E,S,O",
  vs_nota: "en tu vista de {a}° a {b}°{h}", vs_fino: ", hasta {h}° de altura", vs_pill_on: "Activa", vs_pill_off: "Desactivada",
  vs_stato_off: "¿Tienes un balcón o una ventana? Dinos dónde ves el cielo: quedan solo los objetos que puedes encuadrar de verdad.",
  vs_stato_on: "Ves de {a} a {b}{h}: en la lista quedan solo los objetos que pasan por ahí." });
Object.assign(TESTI.en, { vs_titolo: "My view: balcony, window, garden", vs_on: "Show only objects in the part of the sky I can see",
  vs_da: "From (azimuth)", vs_a: "To (azimuth)", vs_hmax: "Maximum altitude", vs_nessun_limite: "No limit",
  vs_n: "Clockwise: 0° = north, 90° = east, 180° = south, 270° = west. For example, south to west is 180 to 270. The maximum altitude is for when there's a roof or the balcony upstairs above you.",
  vs_rapidi: "Facing:", vs_nord: "North", vs_est: "East", vs_sud: "South", vs_ovest: "West", vs_card: "N,E,S,W",
  vs_nota: "in your view from {a}° to {b}°{h}", vs_fino: ", up to {h}° altitude", vs_pill_on: "On", vs_pill_off: "Off",
  vs_stato_off: "Got a balcony or a window? Tell us where you can see the sky and the list will keep only the objects you can actually frame.",
  vs_stato_on: "You see from {a} to {b}{h}: the list keeps only objects passing there." });
const vistaAttiva = () => !!(NOTTE.vista && NOTTE.vista.on);
const dentroAz = (az, a1, a2) => a1 === a2 || (a1 < a2 ? az >= a1 && az <= a2 : az >= a1 || az <= a2);
function aziOggetto(r, nt) {
  if (r.az) return r.az;
  const az = new Float32Array(nt.n), sl = Math.sin(nt.lat * RAD), cl = Math.cos(nt.lat * RAD), sd = Math.sin(r.dec * RAD), cd = Math.cos(r.dec * RAD);
  for (let i = 0; i < nt.n; i++) {
    const H = (nt.lst[i] - r.ra) * RAD;
    az[i] = (Math.atan2(-cd * Math.sin(H), sd * cl - cd * sl * Math.cos(H)) * DEG + 360) % 360;
  }
  return (r.az = az);
}
function inVista(r, nt, hmin, v) {
  const az = aziOggetto(r, nt);
  let n = 0, hMax = -90, iMax = -1;
  for (const i of nt.buio) {
    const h = r.h[i];
    if (h < hmin || (v && (h > v.hmax || !dentroAz(az[i], v.az1, v.az2))) || dietroMontagne(h, az[i])) continue;
    n++;
    if (h > hMax) { hMax = h; iMax = i; }
  }
  return { ore: n * nt.passo / 60, hMax, iMax };
}
Object.assign(TESTI.it, { ns_filtri: "Filtri" });
Object.assign(TESTI.de, { ns_filtri: "Filter" });
Object.assign(TESTI.es, { ns_filtri: "Filtros" });
Object.assign(TESTI.en, { ns_filtri: "Filters" });
Object.assign(TESTI.it, { ns_dir: "Direzione", ns_card16: "N,NNE,NE,ENE,E,ESE,SE,SSE,S,SSO,SO,OSO,O,ONO,NO,NNO",
  ns_dir_det: "Dove guardare: dalle {a} verso {da}, più alto alle {m} verso {dm}, fino alle {b} verso {db} (azimut da nord, in senso orario)." });
Object.assign(TESTI.de, { ns_dir: "Richtung", ns_card16: "N,NNO,NO,ONO,O,OSO,SO,SSO,S,SSW,SW,WSW,W,WNW,NW,NNW",
  ns_dir_det: "Wohin schauen: ab {a} Richtung {da}, am höchsten um {m} Richtung {dm}, bis {b} Richtung {db} (Azimut ab Nord, im Uhrzeigersinn)." });
Object.assign(TESTI.es, { ns_dir: "Dirección", ns_card16: "N,NNE,NE,ENE,E,ESE,SE,SSE,S,SSO,SO,OSO,O,ONO,NO,NNO",
  ns_dir_det: "Hacia dónde mirar: desde las {a} hacia {da}, más alto a las {m} hacia {dm}, hasta las {b} hacia {db} (acimut desde el norte, en sentido horario)." });
Object.assign(TESTI.en, { ns_dir: "Direction", ns_card16: "N,NNE,NE,ENE,E,ESE,SE,SSE,S,SSW,SW,WSW,W,WNW,NW,NNW",
  ns_dir_det: "Where to look: from {a} towards {da}, highest at {m} towards {dm}, until {b} towards {db} (azimuth from north, clockwise)." });
const cardinale = az => t("ns_card16").split(",")[Math.round(((az % 360) + 360) % 360 / 22.5) % 16];
function percorso(r, nt, hmin, v) {
  const az = aziOggetto(r, nt);
  let i0 = -1, i1 = -1, iM = -1;
  for (const i of nt.buio) {
    const h = r.h[i];
    if (h < hmin || (v && (h > v.hmax || !dentroAz(az[i], v.az1, v.az2))) || dietroMontagne(h, az[i])) continue;
    if (i0 < 0) i0 = i;
    i1 = i;
    if (iM < 0 || h > r.h[iM]) iM = i;
  }
  return i0 < 0 ? null : { i0, iM, i1, az };
}
function bussolaVista(v, lato) {
  const R = 40, p = a => [Math.sin(a * RAD) * R, -Math.cos(a * RAD) * R];
  const svg = sv("svg", { viewBox: "-50 -50 100 100", width: lato || 92, height: lato || 92, class: "gas-vista-bussola", "aria-hidden": "true" });
  svg.appendChild(sv("circle", { cx: 0, cy: 0, r: R, class: "gas-vista-cerchio" }));
  const giro = ((v.az2 - v.az1) % 360 + 360) % 360;
  if (giro === 0) svg.appendChild(sv("circle", { cx: 0, cy: 0, r: R, class: "gas-vista-spicchio" }));
  else {
    const [x1, y1] = p(v.az1), [x2, y2] = p(v.az2);
    svg.appendChild(sv("path", { d: `M0 0 L${x1.toFixed(1)} ${y1.toFixed(1)} A${R} ${R} 0 ${giro > 180 ? 1 : 0} 1 ${x2.toFixed(1)} ${y2.toFixed(1)} Z`, class: "gas-vista-spicchio" }));
  }
  t("vs_card").split(",").forEach((c, k) => {
    const [x, y] = [[0, -47], [47, 0], [0, 47], [-47, 0]][k];
    const tx = sv("text", { x, y, "text-anchor": "middle", "dominant-baseline": "central", class: "gas-vista-card" });
    tx.textContent = c;
    svg.appendChild(tx);
  });
  return svg;
}
function riempimento(o, campo) {
  const L = Math.max(campo.w, campo.h) * 60, S = Math.min(campo.w, campo.h) * 60;
  const a = misuraOggetto(o), b = o.b || a;
  return Math.max(a / L, b / S) * 100;
}
function adattoAlCampo(o, campo) {
  if (!campo) return 1;
  const f = riempimento(o, campo) / 100;
  if (f > 1.15) return 0.55;
  if (f < 0.04) return 0.5;
  if (f < 0.12) return 0.8;
  return 1.15;
}
function tabellaPianeti(c) {
  const { nt } = c;
  const notte = [];
  for (let i = 0; i < nt.n; i++) if (nt.hSole[i] < -6) notte.push(i);
  const righe = PIANETI.map(p => {
    const meta = notte.length ? notte[Math.floor(notte.length / 2)] : Math.floor(nt.n / 2);
    const pos = Astro.pianeta(p, nt.tempi[meta]);
    let hMax = -90, iMax = -1;
    for (const i of notte) {
      const h = Astro.altezza(pos.ra, pos.dec, nt.lat, nt.lst[i]);
      if (h > hMax) { hMax = h; iMax = i; }
    }
    return { p, pos, hMax, quando: iMax >= 0 ? Astro.data(nt.tempi[iMax]) : null };
  });
  return [el("h3", null, t("pianeti_stanotte")),
    el("div", { class: "gas-tab-scorre" }, el("table", { class: "gas-tab" },
      el("thead", null, el("tr", null, [t("pianeta"), t("alt_max"), t("quando"), t("mag"), t("diametro_app"), t("fase")].map(h => el("th", null, h)))),
      el("tbody", null, righe.map(r => el("tr", { class: r.hMax < 10 ? "gas-spento" : "" },
        el("td", null, el("b", null, t("pianeta_" + r.p)), " ", el("button", { type: "button", class: "gas-btn gas-btn--chiaro gas-btn--mini",
          onclick: () => { CAMPO.ogg = "@" + r.p; CENTRO = null; SPOSTA = [0, 0]; ZOOM = 1; salvaCampo(); vai("campo"); } }, t("inquadra_breve"))),
        el("td", null, r.hMax > 0 ? `${num(r.hMax)}°` : notte.length ? t("sotto_orizzonte") : "–"),
        el("td", null, r.hMax > 0 ? ora(r.quando) : "–"),
        el("td", null, num(r.pos.mag, 1)),
        el("td", null, `${num(r.pos.diam, 1)}″`),
        el("td", null, `${num(r.pos.k * 100)} %`))))))];
}
Object.assign(TESTI.it, { nr_aria: "Le scelte della notte", nr_dove: "Dove", nr_quando: "Quando", nr_setup: "Setup", nr_esempio: "Solo un esempio", nr_filtri: "Oggetti",
  nr_quali: "Quali oggetti mostrare", nr_mostra: "Mostra {n} oggetti", nr_mostra_1: "Mostra 1 oggetto", nr_nessuno: "Nessun oggetto: togli qualche scelta",
  nr_filtri_ottici: "I tuoi filtri ottici (Hα, dual band, UHC…)" });
Object.assign(TESTI.de, { nr_aria: "Auswahl für die Nacht", nr_dove: "Wo", nr_quando: "Wann", nr_setup: "Setup", nr_esempio: "Nur ein Beispiel", nr_filtri: "Objekte",
  nr_quali: "Welche Objekte angezeigt werden", nr_mostra: "{n} Objekte zeigen", nr_mostra_1: "1 Objekt zeigen", nr_nessuno: "Keine Objekte: Auswahl erweitern",
  nr_filtri_ottici: "Ihre optischen Filter (Hα, Dualband, UHC…)" });
Object.assign(TESTI.es, { nr_aria: "Opciones de la noche", nr_dove: "Dónde", nr_quando: "Cuándo", nr_setup: "Equipo", nr_esempio: "Solo un ejemplo", nr_filtri: "Objetos",
  nr_quali: "Qué objetos mostrar", nr_mostra: "Mostrar {n} objetos", nr_mostra_1: "Mostrar 1 objeto", nr_nessuno: "Ningún objeto: amplía la selección",
  nr_filtri_ottici: "Tus filtros ópticos (Hα, dual band, UHC…)" });
Object.assign(TESTI.en, { nr_aria: "Choices for the night", nr_dove: "Where", nr_quando: "When", nr_setup: "Setup", nr_esempio: "Just an example", nr_filtri: "Objects",
  nr_quali: "Which objects to show", nr_mostra: "Show {n} objects", nr_mostra_1: "Show 1 object", nr_nessuno: "No objects: widen your choices",
  nr_filtri_ottici: "Your optical filters (Hα, dual-band, UHC…)" });
function vistaNotte(pannello) {
  svuota(pannello);
  const riepilogo = el("div", { class: "gas-notte-riepilogo" });
  const cieloCifra = el("div", { class: "gas-cifra gas-cifra--cielo", title: t("cn_lpi_n") });
  let stimaNo = false;
  function disegnaCieloCifra() {
    const mis = NOTTE.sqmMisurato, scelto = NOTTE.bortleAuto === false && !mis, s = mis || NOTTE.sqmStima;
    const fonte = mis ? t("cn_misurato") : scelto ? t("cn_scelto") : NOTTE.fonteStima === "satellite" ? t("cn_lorenz") : t("cn_citta");
    if (!scelto && !s) { svuota(cieloCifra).append(el("small", null, t("cn_titolo")), el("b", null, stimaNo ? `Bortle ${NOTTE.bortle || 5}` : "…"), el("span", null, t(stimaNo ? "cn_no_stima" : "stima_in_corso"))); return; }
    if (scelto) { svuota(cieloCifra).append(el("small", null, t("cn_titolo")), el("b", null, `Bortle ${NOTTE.bortle || 5}`), el("span", null, fonte)); return; }
    const lpi = mis ? lpiDaSqm(mis) : NOTTE.lpiStima ?? lpiDaSqm(s);
    svuota(cieloCifra).append(el("small", null, t("cn_titolo")), el("b", null, `SQM ${num(s, 1)}`),
      el("span", null, `LPI ${numLpi(lpi)} · Bortle ${NOTTE.bortle || bortleDaSqm(s)}`), el("span", { class: "gas-cifra-fonte" }, fonte));
  }
  const pianeti = el("div", { class: "gas-pianeti" });
  const filtri = el("div", { class: "gas-filtri" });
  const elenco = el("div", { class: "gas-elenco" });
  const pianoCont = el("div", { class: "gas-pn-cont" });
  const cieloExtra = el("div", { class: "gas-notte-extra" });
  let ultimaNotte = null;
  const disegnaPiano = () => {
    if (!pianoCont.isConnected && pianoCont._mostrato) { PIANO_UI.delete(disegnaPiano); return; }
    pianoCont._mostrato = true;
    if (ultimaNotte) svuota(pianoCont).appendChild(boxPiano(ultimaNotte.nt));
  };
  PIANO_UI.add(disegnaPiano);
  const sintesi = el("div", { class: "gas-ns-rq", role: "group", "aria-label": t("nr_aria") });
  const posti = el("div", { class: "gas-notte-posti" });
  const oggettiBox = el("div", { class: "gas-notte-oggetti" }, el("h3", { class: "gas-titolo-elenco" }, t("migliori_stanotte")),
    NAV4 ? rigaPianoNotte() : null, avvisoInseguimentoNotte(), filtri, elenco);
  const sotto = el("div", { class: "gas-cx-gruppi gas-notte-sotto", role: "group", "aria-label": t("ns_aria") });
  const PARTI = [["oggetti", oggettiBox, "stella"], ["pianeti", pianeti, "pianeta"], ["cielo", cieloExtra, "meteora"], ["piano", pianoCont, "calendario"], ["posti", posti, "luogo"]];
  let vista = NAV4 ? "oggetti" : PARTI.some(([k]) => k === ricorda("notte_vista", "oggetti")) ? ricorda("notte_vista", "oggetti") : "oggetti";
  const etichettaParte = k => k === "oggetti" ? t(CAMPO.modo === "visuale" ? "ns_oggetti_v" : "ns_oggetti")
    : k === "piano" && (NOTTE.piano || []).length ? `${t("ns_piano")} (${NOTTE.piano.length})` : t("ns_" + k);
  function vaiParte(k, scorri) {
    vista = k;
    if (!NAV4) salva("notte_vista", k);
    for (const [kk, nodo] of PARTI) nodo.hidden = kk !== k;
    svuota(sotto);
    for (const [kk, , ico] of PARTI) sotto.appendChild(el("button", { type: "button", class: "gas-cx-chip" + (kk === k ? " on" : ""), "aria-pressed": String(kk === k),
      onclick: () => vaiParte(kk) }, icona(ico), el("span", null, etichettaParte(kk))));
    if (scorri) sotto.scrollIntoView({ behavior: "smooth", block: "start" });
  }
  PIANO_UI.add(() => { if (sotto.isConnected) vaiParte(vista); });
  let rqPronti = false, conteggioNotte = 0;
  const confermaOggetti = () => (conteggioNotte === 1 ? t("nr_mostra_1") : conteggioNotte ? t("nr_mostra", { n: num(conteggioNotte) }) : t("nr_nessuno"));
  function disegnaSintesi() {
    if (!rqPronti) return;
    const quando = NOTTE.data ? giorno(dataNotte()) : t("stanotte");
    const nomeT = CAMPO.tel && (CAMPO.tel.nome === t("personalizzato") ? `${num(CAMPO.tel.D)}/${num(CAMPO.tel.F)}` : nomeTelCorto(nomeTel(CAMPO.tel)));
    const attrezzi = CAMPO.tel ? nomeT + (CAMPO.modo === "foto" ? (CAMPO.cam && !CAMPO.tel.smart ? " + " + nomeCorto(CAMPO.cam.nome) : "") : (CAMPO.oc ? " + " + nomeCorto(CAMPO.oc.nome) : "")) : t("ns_senza_attrezzi");
    const cielo = NOTTE.sqmMisurato ? `SQM ${num(NOTTE.sqmMisurato, 1)}` : `Bortle ${NOTTE.bortle || 5}`;
    const ap601 = x => !!x && /GIO-APO601/i.test(x.nome || "");
    const esempio = ap601(CAMPO.tel) && !ho("tel", CAMPO.tel) && !SETUP_ELENCO.some(s => ap601(s.tel));
    const voce = (ico, nome, valore, sotto, titolo, pezzo, conferma) => el("button", { type: "button", class: "gas-ns-rq-v", "aria-haspopup": "dialog", "aria-label": `${nome}: ${valore}`,
      onclick: () => apriFoglioCampo(titolo, [pezzo], { dopo: () => disegnaSintesi(), conferma }) },
      icona(ico), el("span", { class: "gas-ns-rq-t" }, el("small", null, nome), el("b", null, valore), sotto ? el("span", null, sotto) : null));
    svuota(sintesi).append(
      voce("luogo", t("nr_dove"), NOTTE.luogo.nome, cielo, t("luogo"), cartaLuogo),
      voce("calendario", t("nr_quando"), quando, NOTTE.data ? "" : giorno(dataNotte()), t("data_notte"), cartaData),
      voce("campo", t("nr_setup"), attrezzi, esempio ? t("nr_esempio") : "", t("mio_setup"), cartaSetup),
      voce("cx_fil", t("nr_filtri"), riassFiltri.textContent || t("tutti"), "", t("nr_quali"), filtriVeri, confermaOggetti));
  }
  aggiungi(pannello, [sintesi, riepilogo, NAV4 ? null : sotto, PARTI.map(([, nodo]) => nodo)]);
  vaiParte(vista);
  const stLuogo = el("div", { class: "gas-scelto" });
  const nuovoLuogo = l => {
    Object.assign(NOTTE, { luogo: l, bortleAuto: true, sqmMisurato: null, sqmStima: null, lpiStima: null, fonteStima: null });
    ricalcola(true); stimaQui(); provaFatta(2);
    try { riempiChip(); } catch (e) {   }
  };
  const lat = campoNumero(t("latitudine"), NOTTE.luogo.lat, debounce(v => { if (v != null && Math.abs(v) <= 90) nuovoLuogo({ nome: t("posizione_mano"), lat: v, lon: NOTTE.luogo.lon }); }, 500), { unita: "°", passo: "0.01" });
  const lon = campoNumero(t("longitudine"), NOTTE.luogo.lon, debounce(v => { if (v != null && Math.abs(v) <= 180) nuovoLuogo({ nome: t("posizione_mano"), lat: NOTTE.luogo.lat, lon: v }); }, 500), { unita: "°", passo: "0.01" });
  const cercaCitta = creaCerca({
    segnaposto: t("cerca_citta"),
    cerca: q => Luoghi.cerca(q, 25).catch(() => {
      const k = normParole(q);
      return CITTA.filter(c => normParole(c[0]).includes(k)).slice(0, 20).map(c => ({ nome: c[0], lat: c[1], lon: c[2], zona: "" }));
    }),
    riga: c => ({ titolo: c.nome, sotto: [c.zona, `${num(c.lat, 2)}°, ${num(c.lon, 2)}°`].filter(Boolean).join(" · ") }),
    scegli: c => { cercaCitta.imposta(""); nuovoLuogo({ nome: c.zona && c.zona.length <= 3 ? `${c.nome} (${c.zona})` : c.nome, lat: c.lat, lon: c.lon }); chiudiFoglioCampo(); },
  });
  const gps = el("button", { type: "button", class: "gas-btn gas-btn--chiaro", onclick: () => {
    if (!navigator.geolocation) return;
    gps.disabled = true; gps.textContent = t("cerco_posizione");
    navigator.geolocation.getCurrentPosition(p => {
      gps.disabled = false; gps.textContent = t("usa_posizione");
      nuovoLuogo({ nome: t("mia_posizione"), gps: true, lat: Math.round(p.coords.latitude * 100) / 100, lon: Math.round(p.coords.longitude * 100) / 100 });
      chiudiFoglioCampo();
    }, () => { gps.disabled = false; gps.textContent = t("posizione_negata"); }, { timeout: 15000, maximumAge: 600000 });
  } }, t("usa_posizione"));
  const selBortle = selezione([1, 2, 3, 4, 5, 6, 7, 8, 9].map(b => [b, t("bortle_" + b)]), NOTTE.bortle || 5, v => {
    giroStima++;
    NOTTE.bortle = +v; NOTTE.bortleAuto = false; NOTTE.sqmMisurato = null; salvaNotte(); aggiornaCielo(); mostraElenco();
  });
  const sqmIn = campoNumero(t("sqm_misurato"), NOTTE.sqmMisurato, debounce(v => {
    if (v == null) {
      const qIn = $("input", sqmIn);
      if (!NOTTE.sqmMisurato || (qIn && qIn.validity && qIn.validity.badInput)) return;
      NOTTE.sqmMisurato = null; NOTTE.bortleAuto = true;
      if (NOTTE.sqmStima != null && NOTTE.fonteStima && NOTTE.mappaBuio === MAPPA_BUIO) { NOTTE.bortle = bortleDaSqm(NOTTE.sqmStima); salvaNotte(); aggiornaCielo(); mostraElenco(); }
      else { salvaNotte(); stimaQui(); }
      return;
    }
    if (v < 15 || v > 22.5) return;
    giroStima++;
    NOTTE.sqmMisurato = v; NOTTE.bortle = bortleDaSqm(v); NOTTE.bortleAuto = false; salvaNotte(); aggiornaCielo(); mostraElenco();
  }, 400), { unita: "mag", passo: "0.01", segnaposto: t("sqm_vuoto") });
  const scriviSqmIn = () => { const i = $("input", sqmIn); if (i && document.activeElement !== i) i.value = NOTTE.sqmMisurato ?? ""; };
  const statoCielo = el("p", { class: "gas-nota gas-cielo-stima" });
  const boxCielo = el("div", { class: "gas-cielo-luogo" }, etichetta(t("cielo_luogo"), selBortle), statoCielo,
    el("details", { class: "gas-dettagli" }, el("summary", null, t("coordinate_sqm")), el("div", { class: "gas-due" }, lat, lon), sqmIn),
    el("details", { class: "gas-dettagli" }, el("summary", null, t("come_stimiamo")), el("p", { class: "gas-nota" }, t("come_stimiamo_testo"))));
  function aggiornaCielo() {
    disegnaCieloCifra();
    selBortle.value = String(NOTTE.bortle || 5);
    scriviSqmIn();
    svuota(statoCielo);
    if (NOTTE.sqmMisurato) statoCielo.append(...tNodi("cielo_misurato", { s: num(NOTTE.sqmMisurato, 2) }));
    else if (NOTTE.bortleAuto !== false && NOTTE.sqmStima) statoCielo.append(...tNodi(NOTTE.fonteStima === "satellite" ? "cielo_satellite" : "cielo_stimato",
      { s: num(NOTTE.sqmStima, 1), b: NOTTE.bortle, l: numLpi(NOTTE.lpiStima ?? lpiDaSqm(NOTTE.sqmStima)) }));
    else if (NOTTE.bortleAuto !== false && stimaNo) statoCielo.append(t("cn_no_stima_n", { b: NOTTE.bortle || 5 }), " ",
      el("a", { href: "#", onclick: e => { e.preventDefault(); stimaQui(); } }, t("cn_riprova")));
    else statoCielo.append(t("cielo_scelto"), " ", el("a", { href: "#", onclick: e => { e.preventDefault(); NOTTE.bortleAuto = true; stimaQui(); } }, t("usa_stima")));
    const { lat: la, lon: lo } = NOTTE.luogo;
    statoCielo.append(" ", el("a", { href: "https://djlorenz.github.io/astronomy/lp/overlay/dark.html", target: "_blank", rel: "noopener", class: "gas-atlante" }, t("vedi_lorenz")),
      " · ", el("a", { href: `https://www.lightpollutionmap.info/#zoom=11.00&lat=${la.toFixed(4)}&lon=${lo.toFixed(4)}&state=${ATLANTE_STATO}`,
        target: "_blank", rel: "noopener nofollow", class: "gas-atlante" }, t("vedi_atlante")));
  }
  let giroStima = 0;
  function stimaQui() {
    if (NOTTE.bortleAuto === false) { aggiornaCielo(); return; }
    const mio = ++giroStima, { lat: la, lon: lo } = NOTTE.luogo;
    stimaNo = false; disegnaCieloCifra(); scriviSqmIn();
    statoCielo.textContent = t("stima_in_corso");
    Luoghi.stimaCielo(la, lo).then(s => {
      if (mio !== giroStima) return;
      NOTTE.sqmStima = Math.round(s.sqm * 1000) / 1000; NOTTE.lpiStima = s.lpi;
      NOTTE.bortle = s.bortle; NOTTE.bortleAuto = true; NOTTE.fonteStima = s.fonte; NOTTE.mappaBuio = MAPPA_BUIO;
      salvaNotte(); aggiornaCielo(); mostraElenco();
    }).catch(() => { if (mio === giroStima) { stimaNo = true; aggiornaCielo(); } });
  }
  const dataIn = el("input", { type: "date", class: "gas-input", value: isoData(dataNotte()), "aria-label": t("data_notte") });
  dataIn.addEventListener("change", () => { NOTTE.data = dataIn.value; ricalcola(); });
  const oggi = el("button", { type: "button", class: "gas-btn gas-btn--chiaro", onclick: () => { NOTTE.data = ""; dataIn.value = isoData(dataNotte()); ricalcola(); } }, t("stanotte"));
  const setupInfo = el("div", { class: "gas-setup-info" });
  const cercaTelN = creaCerca({
    segnaposto: t("cerca_telescopio"),
    cerca: q => cercaTelescopi(q, 40),
    riga: x => ({ titolo: titoloTelescopio(x), sotto: rigaTelescopio(x), foto: x.foto }),
    scegli: x => { scegliTelescopio(x); cercaTelN.imposta(""); aggiornaSetup(); mostraElenco(); },
  });
  const cercaCamN = creaCerca({
    segnaposto: t("cerca_camera"),
    cerca: q => cercaCamere(q, 40),
    riga: c => ({ titolo: c.nome, sotto: rigaCamera(c), extra: c.h_negozio ? t("in_vendita") : "", foto: c.foto }),
    scegli: c => { scegliCamera(c); cercaCamN.imposta(""); aggiornaSetup(); mostraElenco(); },
  });
  const camp = el("input", { type: "checkbox", checked: NOTTE.campo });
  camp.addEventListener("change", () => { NOTTE.campo = camp.checked; mostraElenco(); });
  const setupBoxN = boxSetup(() => { aggiornaSetup(); mostraElenco(); }, true);
  function aggiornaSetup() {
    setupBoxN.aggiorna();
    rifaiRapide();
    aggiornaSetupUI();
    const campo = campoAttuale();
    svuota(setupInfo).append(
      el("div", null, el("small", null, t("telescopio") + ": "), CAMPO.tel ? el("b", null, nomeTel(CAMPO.tel)) : "–",
        CAMPO.tel ? ` · ${num(CAMPO.tel.D)}/${num(CAMPO.tel.F * (CAMPO.tel.smart ? 1 : CAMPO.k))} mm` : ""),
      bottoniConfigurazione(() => { aggiornaSetup(); mostraElenco(); }) || "",
      el("div", null, el("small", null, (CAMPO.modo === "foto" ? t("camera") : t("oculare")) + ": "),
        CAMPO.modo === "foto" ? (CAMPO.cam ? el("b", null, CAMPO.cam.nome) : "–") : (CAMPO.oc ? el("b", null, CAMPO.oc.nome) : "–")),
      campo ? el("div", { class: "gas-setup-campo" }, t("campo_tuo"), " ", el("b", null, angoli(campo.w, campo.h)))
        : el("div", { class: "gas-muto" }, t("nessun_setup")),
      el("a", { href: "#campo", class: "gas-setup-link", onclick: e => { e.preventDefault(); vai("campo"); } }, t("modifica_campo")));
    camp.disabled = !campo;
    if (!campo && NOTTE.campo) { NOTTE.campo = false; camp.checked = false; }
    disegnaSintesi();
  }
  const cartaLuogo = scheda(titoloVoce(t("luogo"), "g_luogo"), cercaCitta.box, el("div", { class: "gas-riga-bottoni" }, gps), stLuogo, boxCielo);
  const cartaData = scheda(titoloVoce(t("data_notte"), "g_data"), el("div", { class: "gas-riga-bottoni" }, dataIn, oggi), el("p", { class: "gas-nota" }, t("nota_orari")));
  const dopoRapida = () => { aggiornaSetup(); mostraElenco(); };
  const rapide = { tel: sceltaRapida("tel", dopoRapida), cam: sceltaRapida("cam", dopoRapida) };
  function rifaiRapide() { for (const k of ["tel", "cam"]) { const n = sceltaRapida(k, dopoRapida); rapide[k].replaceWith(n); rapide[k] = n; } }
  const cartaSetup = el("section", { class: "gas-card gas-card--setup" }, el("h3", null, titoloVoce(t("mio_setup"), "g_mio_setup")), el("p", { class: "gas-nota" }, t("mio_setup_n")),
    setupBoxN, rapide.tel, cercaTelN.box, el("div", { class: "gas-spazio" }),
    rapide.cam, cercaCamN.box, setupInfo,
    el("div", { class: "gas-riga-bottoni gas-setup-azioni" },
      el("a", { href: urlScheda("attrezzatura") + "#attrezzatura", class: "gas-setup-link", onclick: e => { e.preventDefault(); chiudiFoglioCampo(); vai("attrezzatura"); } }, t("att_modifica")), bottoneAssistente()));
  if (!NAV4) posti.appendChild(cartaCieliBui(l => { nuovoLuogo(l); vaiParte("oggetti"); sintesi.scrollIntoView({ behavior: "smooth", block: "start" }); }));
  aggiornaSetup();
  if (NOTTE.bortleAuto !== false && (NOTTE.sqmStima == null || !NOTTE.fonteStima || NOTTE.mappaBuio !== MAPPA_BUIO)) stimaQui(); else aggiornaCielo();
  const hmin = selezione([10, 20, 30, 40, 50].map(v => [v, v + "°"]), NOTTE.hmin, v => { NOTTE.hmin = +v; mostraElenco(); });
  const chipTipi = el("div", { class: "gas-tipi-chip", role: "group", "aria-label": t("tipo") });
  function disegnaTipi() {
    const scelti = tipiNotte(), cambia = l => { NOTTE.tipi = l; disegnaTipi(); mostraElenco(); scriviRiass(); };
    svuota(chipTipi).append(
      el("button", { type: "button", class: "gas-filtro-scelta" + (scelti.length ? "" : " on"), "aria-pressed": String(!scelti.length), onclick: () => cambia([]) }, t("tutti")),
      ...Object.keys(SCELTE_TIPO).map(k => {
        const on = scelti.includes(k);
        return el("button", { type: "button", class: "gas-filtro-scelta" + (on ? " on" : ""), "aria-pressed": String(on),
          onclick: () => cambia(on ? scelti.filter(x => x !== k) : [...scelti, k]) }, nomeSceltaTipo(k));
      }));
  }
  const cost = selezione([["", t("tutte")], ...COSTELLAZIONI.map(c => [c, nomeCostellazione(c)]).sort((a, b) => a[1].localeCompare(b[1], LOCALE))],
    NOTTE.cost, v => { NOTTE.cost = v; mostraElenco(); });
  const mag = selezione([["", t("qualsiasi")], ...[6, 8, 10, 11, 12, 13].map(m => [m, "≤ " + m])], NOTTE.magmax, v => { NOTTE.magmax = v; mostraElenco(); });
  const ord = selezione(["migliori", "ore", "altezza", "grandezza", "luminosi", "nome"].map(k => [k, t("ord_" + k)]), NOTTE.ordine, v => { NOTTE.ordine = v; mostraElenco(); });
  const fam = el("input", { type: "checkbox", checked: NOTTE.famosi });
  fam.addEventListener("change", () => { NOTTE.famosi = fam.checked; mostraElenco(); });
  const bin = selezione([["", t("bi_tutti")], ...BINOCOLI.map(b => [b[0], t("bi_bino", { b: nomeBinocolo(b) })])], NOTTE.bino || "", v => { NOTTE.bino = v; mostraElenco(); });
  const cercaIn = el("input", { type: "search", class: "gas-input", placeholder: t("ns_cerca_ph"), "aria-label": t("ns_cerca"),
    autocomplete: "off", spellcheck: "false", enterkeyhint: "search" });
  cercaIn.addEventListener("input", debounce(() => { mostrati = 40; mostraElenco(); }, 150));
  cercaIn.addEventListener("keydown", e => {
    if (e.key === "Enter") { e.preventDefault(); cercaIn.blur(); apriPrimo(true); }
    else if (e.key === "Escape" && cercaIn.value) { e.preventDefault(); togliRicerca(); }
  });
  const togliRicerca = () => { cercaIn.value = ""; mostrati = 40; mostraElenco(); };
  const apriPrimo = scorri => {
    const testa = elenco.querySelector(".gas-ogg-testa");
    if (testa && testa.getAttribute("aria-expanded") !== "true") testa.click();
    if (testa && scorri) testa.scrollIntoView({ behavior: "smooth", block: "start" });
  };
  const filtriVeri = el("div", { class: "gas-notte-filtri-veri" },
    el("div", { class: "gas-tipi" }, el("small", { class: "gas-setup-etich" }, t("tipo")), chipTipi),
    el("div", { class: "gas-filtri-griglia" },
      etichetta(t("bi_strumento"), bin),
      etichetta(t("altezza_minima"), hmin), etichetta(t("costellazione"), cost),
      etichetta(t("magnitudine_max"), mag), etichetta(t("ordina"), ord)),
    el("div", { class: "gas-spunte" },
      el("label", { class: "gas-spunta" }, fam, t("solo_famosi")),
      el("label", { class: "gas-spunta" }, camp, el("span", null, t("solo_campo")))),
    boxVista(),
    el("details", { class: "gas-dettagli gas-notte-miei-filtri" }, el("summary", null, t("nr_filtri_ottici")),
      el("p", { class: "gas-nota" }, t("miei_filtri_n")), boxFiltri(() => { aggiornaSetup(); mostraElenco(); })));
  const riassFiltri = el("span");
  const scriviRiass = () => {
    const testo = x => (x && x.options && x.options[x.selectedIndex] ? x.options[x.selectedIndex].textContent : "");
    const tipiTesto = tipiNotte().map(nomeSceltaTipo).join(" + ") || t("tutti");
    riassFiltri.textContent = [NOTTE.bino ? testo(bin) : "", tipiTesto, cost.value ? testo(cost) : "", mag.value ? "mag " + testo(mag) : "",
      "≥ " + testo(hmin), NOTTE.ordine !== "migliori" ? testo(ord) : ""].filter(x => x && x !== "≥ ").join(" · ");
    disegnaSintesi();
    if (FOGLIO_CAMPO && FOGLIO_CAMPO.aggiorna) FOGLIO_CAMPO.aggiorna();
  };
  filtriVeri.addEventListener("change", scriviRiass);
  disegnaTipi();
  scriviRiass();
  filtri.append(el("div", { class: "gas-filtri-cerca gas-notte-cerca" }, icona("cerca"), cercaIn));
  function boxVista() {
    const v = NOTTE.vista = Object.assign({ on: false, az1: 90, az2: 270, hmax: 90 }, NOTTE.vista || {});
    let aperta = false;
    const posto = el("span", { class: "gas-vista-disegno" }), mini = el("span", { class: "gas-vista-mini" });
    const stato = el("small", null), pill = el("span", { class: "gas-vista-pill" });
    const dove = az => `${cardinale(az)} ${num(az)}°`;
    const disegna = () => {
      svuota(posto).appendChild(bussolaVista(v));
      svuota(mini).appendChild(bussolaVista(v, 46));
      stato.textContent = v.on ? t("vs_stato_on", { a: dove(v.az1), b: dove(v.az2), h: v.hmax < 90 ? t("vs_fino", { h: num(v.hmax) }) : "" }) : t("vs_stato_off");
      pill.textContent = t(v.on ? "vs_pill_on" : "vs_pill_off");
      box.classList.toggle("on", v.on);
    };
    const aggiorna = debounce(() => mostraElenco(), 250);
    const cambia = accendi => { if (accendi && !v.on) v.on = on.checked = true; disegna(); aggiorna(); };
    const gradi = x => ((Math.round(x) % 360) + 360) % 360;
    const on = el("input", { type: "checkbox", checked: v.on });
    on.addEventListener("change", () => { v.on = on.checked; cambia(false); });
    const da = campoNumero(t("vs_da"), v.az1, x => { if (x != null) { v.az1 = gradi(x); cambia(true); } }, { unita: "°", min: 0, max: 359, passo: "1" });
    const a = campoNumero(t("vs_a"), v.az2, x => { if (x != null) { v.az2 = gradi(x); cambia(true); } }, { unita: "°", min: 0, max: 359, passo: "1" });
    const hmax = selezione([[90, t("vs_nessun_limite")], ...[80, 70, 60, 50, 40, 30].map(x => [x, x + "°"])], v.hmax, x => { v.hmax = +x; cambia(true); });
    const rapido = (k, a1, a2) => el("button", { type: "button", class: "gas-filtro-scelta", onclick: () => {
      v.az1 = a1; v.az2 = a2;
      $("input", da).value = a1; $("input", a).value = a2;
      cambia(true);
    } }, t(k));
    const dentro = el("div", { class: "gas-vista-dentro", hidden: true },
      el("label", { class: "gas-spunta gas-vista-on" }, on, el("span", null, t("vs_on"))),
      el("div", { class: "gas-vista-corpo" }, posto,
        el("div", { class: "gas-vista-campi" },
          el("div", { class: "gas-tre" }, da, a, etichetta(t("vs_hmax"), hmax)),
          el("div", { class: "gas-setup-chip-riga gas-vista-rapidi" }, el("small", { class: "gas-setup-etich" }, t("vs_rapidi")),
            rapido("vs_nord", 270, 90), rapido("vs_est", 0, 180), rapido("vs_sud", 90, 270), rapido("vs_ovest", 180, 0)))),
      el("p", { class: "gas-nota" }, t("vs_n")),
      boxTerreno(() => { disegna(); mostraElenco(); }));
    const testa = el("button", { type: "button", class: "gas-vista-testa", "aria-expanded": "false", onclick: () => {
      aperta = !aperta;
      dentro.hidden = !aperta;
      testa.setAttribute("aria-expanded", String(aperta));
      box.classList.toggle("aperta", aperta);
    } }, mini, el("span", { class: "gas-vista-tit" }, el("b", null, t("vs_titolo")), stato), pill,
      el("span", { class: "gas-vista-freccia", "aria-hidden": "true" }, "▾"));
    const box = el("section", { class: "gas-vista" }, testa, dentro);
    disegna();
    return box;
  }
  let mostrati = 40;
  function ricalcola(salvaPosto) {
    salvaNotte();
    disegnaSintesi();
    stLuogo.textContent = `${NOTTE.luogo.nome} · ${num(NOTTE.luogo.lat, 2)}°, ${num(NOTTE.luogo.lon, 2)}°`;
    $$("input", lat).forEach(i => { if (document.activeElement !== i) i.value = NOTTE.luogo.lat; });
    $$("input", lon).forEach(i => { if (document.activeElement !== i) i.value = NOTTE.luogo.lon; });
    riepilogo.textContent = t("calcolo");
    setTimeout(() => {
      const c = calcolaNotte(); ultimaNotte = c; mostraRiepilogo(c);
      if (!NAV4) mostraPianeti(c);
      if (!NAV4) try { aggiungi(svuota(cieloExtra), [cartaMeteore(c), cartaComete(c), cartaSatelliti(c), cartaTransiti(), cartaAurora(c), cartaAvvisi()]); } catch (e) { console.error("strumenti, meteore e comete:", e); }
      disegnaPiano(); mostrati = 40; mostraElenco();
    }, 10);
  }
  function mostraRiepilogo(c) {
    const { nt } = c, ev = nt.ev;
    svuota(riepilogo);
    const fase = nt.fase;
    const oreBuio = nt.buio.length * nt.passo / 60;
    const prossNuova = Astro.prossimaFase(nt.tempi[0], 0), prossPiena = Astro.prossimaFase(nt.tempi[0], 180);
    riepilogo.append(
      el("div", { class: "gas-numeri gas-numeri--notte" },
        cifra(t("tramonto"), ora(ev.tramonto), ""),
        cifra(t("buio_da"), ora(ev.astroFine), t("crep_astronomico")),
        cifra(t("buio_a"), ora(ev.astroInizio), t("crep_astronomico")),
        cifra(t("alba"), ora(ev.alba), ""),
        cifra(t("ore_buio"), durata(oreBuio), nt.tipoBuio === "astro" ? "" : t("solo_nautico")),
        el("div", { class: "gas-cifra gas-cifra--luna" }, el("small", null, t("luna")), iconaLuna(fase), el("b", null, `${num(fase.k * 100)} %`),
          el("span", null, `${fase.crescente ? t("crescente") : t("calante")} · ↑ ${ora(ev.lunaSorge)} ↓ ${ora(ev.lunaTramonta)}`)), cieloCifra),
      lineaTempo(nt),
      el("p", { class: "gas-nota" },
        `${t("luna_nuova")}: ${prossNuova ? giorno(Astro.data(prossNuova)) : "–"} · ${t("luna_piena")}: ${prossPiena ? giorno(Astro.data(prossPiena)) : "–"}`,
        nt.tipoBuio !== "astro" ? " · " + t(nt.tipoBuio === "nautico" ? "avviso_nautico" : "avviso_nessuno") : ""));
  }
  function mostraPianeti(c) { aggiungi(svuota(pianeti), tabellaPianeti(c)); }
  function mostraElenco() {
    salvaNotte();
    const c = calcolaNotte(), nt = c.nt;
    aggiornaSetup();
    const bino = binocolo(NOTTE.bino), lmB = bino ? limiteBinocolo(bino) : 0;
    const campo = bino ? { w: bino[3], h: bino[3] } : campoAttuale();
    const q = cercaIn.value.trim();
    if (q) { mostraTrovati(q, c, nt, campo, bino, lmB); return; }
    const tipi = codiciTipiNotte();
    const magmax = NOTTE.magmax === "" ? null : +NOTTE.magmax;
    const fase = nt.fase.k;
    const lista = [];
    const miei = new Set(CAMPO.filtri || []), bandaStretta = !bino && ["dual", "sho", "ha", "oiii"].some(f => miei.has(f));
    const bortle = NOTTE.bortle || 5;
    const vista = vistaAttiva() ? NOTTE.vista : null, ter = terrenoAttivo();
    for (const r of c.righe) {
      const o = r.o;
      if (tipi && !tipi.has(o.t)) continue;
      const vb = bino ? votoBinocolo(o, bino, lmB) : 0;
      if (bino && !vb) continue;
      if (NOTTE.cost && o.c !== NOTTE.cost) continue;
      if (magmax != null && (o.mag == null || o.mag > magmax)) continue;
      if (NOTTE.famosi && !(o.top || o.messier || o.caldwell || o.nomi)) continue;
      if (r.hMax < NOTTE.hmin) continue;
      const vis = vista || ter ? inVista(r, nt, NOTTE.hmin, vista) : null;
      const ore = vis ? vis.ore : oreSopra(r, nt, NOTTE.hmin);
      if (ore <= 0) continue;
      const fit = adattoAlCampo(o, campo);
      if (NOTTE.campo && campo && fit < 1) continue;
      const pop = o.top ? 2 : (o.messier || o.caldwell) ? 1.5 : o.nomi ? 1.2 : 1;
      const magF = o.mag != null ? clamp((15 - o.mag) / 8, 0.4, 1.3) : 0.9;
      const em = nebEmissione(o) || o.t === "pn";
      const lunaF = 1 - (em && bandaStretta ? 0.2 : DIFFUSI.has(o.t) ? 0.7 : 0.25) * fase * Math.exp(-r.sep / 50) * (0.2 + 0.8 * c.lunaSu);
      const cieloF = !em && DIFFUSI.has(o.t) && bortle > 5 ? 1 - 0.08 * (bortle - 5) : 1;
      const punti = ore * pop * magF * lunaF * cieloF * (NOTTE.campo ? 1 : fit) * (0.6 + 0.4 * Math.sin((vis ? vis.hMax : r.hMax) * RAD)) * (bino ? (vb === 2 ? 1.3 : 1) : 1);
      lista.push({ r, ore, punti, vb, vis });
    }
    const chiave = {
      migliori: (a, b) => b.punti - a.punti, ore: (a, b) => b.ore - a.ore || b.r.hMax - a.r.hMax,
      altezza: (a, b) => b.r.hMax - a.r.hMax, grandezza: (a, b) => misuraOggetto(b.r.o) - misuraOggetto(a.r.o),
      luminosi: (a, b) => (a.r.o.mag ?? 99) - (b.r.o.mag ?? 99),
      nome: (a, b) => a.r.o.id.localeCompare(b.r.o.id, undefined, { numeric: true }),
    }[NOTTE.ordine];
    lista.sort(chiave);
    svuota(elenco);
    conteggioNotte = lista.length;
    if (FOGLIO_CAMPO && FOGLIO_CAMPO.aggiorna) FOGLIO_CAMPO.aggiorna();
    if (!lista.length) { elenco.appendChild(el("p", { class: "gas-muto" }, t("nessun_oggetto"))); return; }
    elenco.appendChild(el("p", { class: "gas-nota" }, t("trovati", { n: num(lista.length) }),
      vista ? " " + t("vs_nota", { a: num(vista.az1), b: num(vista.az2), h: vista.hmax < 90 ? t("vs_fino", { h: num(vista.hmax) }) : "" }) : "",
      ter ? " · " + t("ter_nota") : "",
      bino ? " · " + t("bi_nota", { b: nomeBinocolo(bino), c: num(bino[3], 1), m: num(lmB, 1) }) : ""));
    const tab = el("div", { class: "gas-righe-oggetti" });
    for (const x of lista.slice(0, mostrati)) tab.appendChild(rigaNotte(x, nt, campo, c));
    elenco.appendChild(tab);
    if (lista.length > mostrati) elenco.appendChild(el("button", { type: "button", class: "gas-btn gas-btn--chiaro gas-btn--largo",
      onclick: () => { mostrati += 40; mostraElenco(); } }, t("mostra_altri")));
    elenco.appendChild(el("p", { class: "gas-nota gas-og-crediti" }, t("og_crediti_lista")));
  }
  function mostraTrovati(q, c, nt, campo, bino, lmB) {
    const per = c.perOgg || (c.perOgg = new Map(c.righe.map(r => [r.o, r])));
    const trovati = cercaOggetti(q, 41);
    const corpi = trovati.filter(o => o.corpo).slice(0, 3);
    const lista = trovati.filter(o => per.has(o) || o.soloCerca).slice(0, 40).map(o => {
      const r = per.get(o) || rigaDi(c, o);
      return { r, ore: oreSopra(r, nt, NOTTE.hmin), vb: bino ? votoBinocolo(o, bino, lmB) : 0, cercato: true, sigla: siglaCercata(o, q) };
    });
    svuota(elenco);
    const togli = el("button", { type: "button", class: "gas-btn gas-btn--chiaro gas-btn--mini", onclick: () => { togliRicerca(); cercaIn.focus(); } }, "× ", t("ns_cerca_togli"));
    elenco.appendChild(el("div", { class: "gas-notte-trovati" },
      el("p", { class: "gas-nota" }, lista.length ? t(lista.length === 1 ? "ns_cerca_uno" : "ns_cerca_n", { n: num(lista.length), q }) : t("ns_cerca_vuoto", { q }),
        lista.length ? " " + t("ns_cerca_filtri") : ""), togli));
    for (const b of corpi) {
      const ls = b.id === "@luna" || b.id === "@sole";
      elenco.appendChild(el("p", { class: "gas-nota gas-notte-corpo" }, el("b", null, titoloOggetto(b)), " · ",
        el("button", { type: "button", class: "gas-btn gas-btn--chiaro gas-btn--mini",
          onclick: () => NAV4 ? apriLunaSole(!ls) : ls ? vai("lunasole") : vaiParte("pianeti", true) },
          icona(ls ? "lunasole" : "pianeta"), " ", t(NAV4 ? "ns_cerca_vai_lsp" : ls ? "ns_cerca_vai_ls" : "ns_cerca_vai_pianeti"))));
    }
    if (!lista.length) return;
    const tab = el("div", { class: "gas-righe-oggetti" });
    for (const x of lista) tab.appendChild(rigaNotte(x, nt, campo, c));
    elenco.appendChild(tab);
    if (trovati.filter(o => per.has(o)).length > 40) elenco.appendChild(el("p", { class: "gas-nota" }, t("ns_cerca_tanti")));
    if (lista.length === 1 && !corpi.length) apriPrimo();
  }
  function rigaNotte(x, nt, campo, c) {
    const { r, ore } = x, o = r.o;
    const ctx = contestoFiltro(o, lunaOggetto(nt, r.h, r.sep));
    if (binocolo(NOTTE.bino)) ctx.modo = "visuale";
    const cf = consiglioFiltro(o, ctx);
    const iM = x.vis && x.vis.iMax >= 0 ? x.vis.iMax : r.iMax, hM = x.vis && x.vis.iMax >= 0 ? x.vis.hMax : r.hMax;
    const quando = iM >= 0 ? Astro.data(nt.tempi[iM]) : null;
    const pc = nt.buio.length ? percorso(r, nt, NOTTE.hmin, vistaAttiva() ? NOTTE.vista : null) : null;
    let adatto = null;
    if (campo) {
      const p = riempimento(o, campo);
      const k = p > 115 ? "grande" : p < 12 ? "piccolo" : "ok";
      adatto = el("span", { class: "gas-fit gas-fit--" + k }, `▭ ${t("occupa", { p: num(p, p < 10 ? 1 : 0) })} · ${t("fit_" + k)}`);
    }
    const dett = el("div", { class: "gas-dett", hidden: true });
    const testa = el("button", { type: "button", class: "gas-ogg-testa", "aria-expanded": "false", onclick: () => {
      const aperto = dett.hidden;
      if (aperto) provaFatta(2);
      dett.hidden = !aperto; testa.setAttribute("aria-expanded", String(aperto));
      if (aperto && !dett.firstChild) riempiDettaglio(dett, r, nt, cf);
    } },
    miniaturaOggetto(o, 56),
    el("span", { class: "gas-ogg-nome" }, el("b", null, o.id, x.sigla ? " · " + x.sigla : ""), nomeOggetto(o) ? el("span", null, nomeOggetto(o)) : null,
      el("small", null, rigaOggetto(o)), el("span", { class: "gas-ogg-badge" },
        x.cercato && nt.buio.length && r.hMax < NOTTE.hmin ? el("span", { class: "gas-fit " + (r.hMax <= 0 ? "gas-fit--grande" : "gas-fit--piccolo") },
          r.hMax <= 0 ? t("ns_cerca_sotto") : t("ns_cerca_basso", { h: NOTTE.hmin })) : null,
        adatto, badgeFiltro(cf), segnoPiano(o.id), segnoDiario(o.id),
        x.vb ? el("span", { class: "gas-bi-badge" + (x.vb === 2 ? " on" : "") }, t(x.vb === 2 ? "bi_facile" : "bi_visibile")) : null)),
    el("span", { class: "gas-ogg-dati" },
      el("span", null, el("small", null, t("ore_utili")), el("b", null, durata(ore))),
      el("span", null, el("small", null, t("alt_max")), el("b", null, `${num(hM)}°`), el("small", null, ora(quando))),
      el("span", null, el("small", null, t("dist_luna")), el("b", null, `${num(r.sep)}°`)),
      pc ? el("span", { class: "gas-ogg-dir" }, el("small", null, t("ns_dir")),
        el("b", null, [pc.i0, pc.iM, pc.i1].map(i => cardinale(pc.az[i])).join(" → "))) : null),
    miniCurva(r.h, nt));
    return el("div", { class: "gas-ogg" }, testa, dett);
  }
  function rigaDirezione(r, nt) {
    const pc = nt.buio.length ? percorso(r, nt, NOTTE.hmin, vistaAttiva() ? NOTTE.vista : null) : null;
    if (!pc) return null;
    const dove = i => `${cardinale(pc.az[i])} ${num(pc.az[i])}°`, alle = i => ora(Astro.data(nt.tempi[i]));
    return el("p", { class: "gas-nota gas-ogg-dir-det" }, t("ns_dir_det", { a: alle(pc.i0), da: dove(pc.i0), m: alle(pc.iM), dm: dove(pc.iM), b: alle(pc.i1), db: dove(pc.i1) }));
  }
  function riempiDettaglio(dett, r, nt, cf) {
    const o = r.o;
    const ev = Astro.eventiOggetto(nt, r.h, r.ra);
    const tela = el("canvas", { class: "gas-anteprima-tela", role: "img", "aria-label": titoloOggetto(o) });
    const fotoVera = FOTO_DSS ? el("img", { class: "gas-anteprima-foto", alt: "", decoding: "async" }) : null;
    const foto = el("div", { class: "gas-anteprima" }, fotoVera, tela);
    const sempre = r.h.every(h => h > 0);
    const posa = CAMPO.modo === "foto" && cf && !binocolo(NOTTE.bino) ? boxTempoPosa(o, cf.luna) : null;
    const filtro = cf ? spiegaFiltro(cf) : null;
    dett.append(
      el("div", { class: "gas-dett-griglia" },
        el("div", null, graficoAltezza(r, nt), el("p", { class: "gas-nota" },
          sempre ? t("sempre_sopra") : `${t("sorge")} ${ora(ev.sorge)} · ${t("culmina")} ${ora(ev.culm)} (${num(ev.hMax)}°) · ${t("tramonta")} ${ora(ev.tramonta)}`,
          ` · RA ${raHms(o.ra)} · Dec ${decDms(o.dec)}`), rigaDirezione(r, nt), panoramaCielo(r, nt), bottoneVistaLuogo(o.id), posa ? null : filtro, posa),
        el("div", null, foto,
          azioniOggetto(o, [bottoneScheda(o), bottoneInquadra(o), bottoneVista(o), bottoneServe(o)]), posa ? filtro : null)));
    Mappa.anteprima(tela, o, campoAttuale(), fotoVera).catch(e => console.error("strumenti, anteprima:", e));
  }
  rqPronti = true;
  ricalcola();
}
function iconaLuna(fase) {
  const r = 11, k = fase.k, x = (1 - 2 * k) * r;
  const chiaro = "#f3ead2", scuro = "#2b3443";
  const lato = fase.crescente ? 1 : -1;
  return sv("svg", { viewBox: "-12 -12 24 24", width: 26, height: 26, class: "gas-luna" },
    sv("circle", { r, fill: scuro }),
    sv("path", { fill: chiaro, d: `M0,${-r} A${r},${r} 0 0 ${lato > 0 ? 1 : 0} 0,${r} A${Math.abs(x)},${r} 0 0 ${(x > 0) === (lato > 0) ? 0 : 1} 0,${-r} Z` }));
}
function lineaTempo(nt) {
  const n = nt.n, pc = i => i / (n - 1) * 100;
  const coloreCielo = h => h > -0.833 ? "#3a6694" : h > -6 ? "#294d78" : h > -12 ? "#1a3458" : h > -18 ? "#0f213d" : "#03070f";
  const pezzi = colore => {
    const out = [];
    for (let i = 0; i < n - 1; i++) {
      const c = colore(i), ultimo = out[out.length - 1];
      if (ultimo && ultimo[0] === c) ultimo[2] = pc(i + 1); else out.push([c, pc(i), pc(i + 1)]);
    }
    return out;
  };
  const sfumatura = pz => `linear-gradient(90deg, ${pz.map(([c, da, a]) => `${c} ${da.toFixed(2)}% ${a.toFixed(2)}%`).join(", ")})`;
  const oro = `rgba(244, 213, 139, ${(0.3 + 0.6 * nt.fase.k).toFixed(2)})`;
  const cielo = sfumatura(pezzi(i => coloreCielo((nt.hSole[i] + nt.hSole[i + 1]) / 2)));
  const luna = sfumatura(pezzi(i => (nt.hLuna[i] > 0 ? oro : "transparent")));
  const ore = el("div", { class: "gas-linea-ore", "aria-hidden": "true" });
  const t0 = Astro.data(nt.tempi[0]).getTime(), t1 = Astro.data(nt.tempi[n - 1]).getTime(), primo = new Date(t0 + 59999);
  primo.setMinutes(0, 0, 0);
  if (primo.getTime() < t0 - 1000) primo.setTime(primo.getTime() + 3600e3);
  for (let ms = primo.getTime(); ms <= t1 + 1000; ms += 3600e3) {
    const d = new Date(ms), x = (ms - t0) / (t1 - t0) * 100;
    if (d.getHours() % 2 !== 0) continue;
    const bordo = x < 3 ? "gas-sx" : x > 97 ? "gas-dx" : "";
    ore.appendChild(el("span", { class: [d.getHours() % 4 ? "gas-dispari" : "", bordo].join(" ").trim() || null,
      style: { left: x + "%", transform: `translateX(${bordo === "gas-sx" ? "0" : bordo === "gas-dx" ? "-100%" : "-50%"})` } }, String(d.getHours()).padStart(2, "0")));
  }
  const g = el("div", { class: "gas-linea", style: { backgroundImage: cielo } }, el("i", { class: "gas-linea-luna", style: { backgroundImage: luna } }));
  return el("div", { class: "gas-linea-box" }, g, ore, el("div", { class: "gas-legenda" },
    el("span", null, el("i", { style: { background: "#3a6694" } }), t("giorno")), el("span", null, el("i", { style: { background: "#1a3458" } }), t("crepuscolo")),
    el("span", null, el("i", { style: { background: "#03070f", outline: "1px solid rgba(255,255,255,.25)" } }), t("notte_astro")), el("span", null, el("i", { style: { background: "#f4d58b" } }), t("luna_sopra"))));
}
function miniCurva(h, nt) {
  const W = 120, H = 34;
  const i0 = Math.max(0, (nt.buio[0] || 0) - 12), i1 = Math.min(nt.n - 1, (nt.buio[nt.buio.length - 1] || nt.n - 1) + 12);
  const pts = [];
  for (let i = i0; i <= i1; i++) pts.push(`${((i - i0) / (i1 - i0) * W).toFixed(1)},${(H - Math.max(0, h[i]) / 90 * H).toFixed(1)}`);
  const b0 = ((nt.buio[0] || 0) - i0) / (i1 - i0) * W, b1 = ((nt.buio[nt.buio.length - 1] || 0) - i0) / (i1 - i0) * W;
  return sv("svg", { viewBox: `0 0 ${W} ${H}`, class: "gas-minicurva", "aria-hidden": "true" },
    sv("rect", { x: b0, y: 0, width: Math.max(0, b1 - b0), height: H, class: "gas-mc-buio" }),
    sv("polyline", { points: pts.join(" "), class: "gas-mc-linea" }));
}
function graficoAltezza(r, nt) {
  const W = 640, H = 240, sx = 34, sy = 12, gw = W - sx - 10, gh = H - sy - 28;
  const i0 = Math.max(0, (nt.buio[0] || 0) - 15), i1 = Math.min(nt.n - 1, (nt.buio[nt.buio.length - 1] || nt.n - 1) + 15);
  const X = i => sx + (i - i0) / (i1 - i0) * gw, Y = h => sy + gh - clamp(h, 0, 90) / 90 * gh;
  const g = sv("svg", { viewBox: `0 0 ${W} ${H}`, class: "gas-grafico", role: "img", "aria-label": t("grafico_altezza") });
  for (let i = i0; i < i1; i++) {
    const hs = (nt.hSole[i] + nt.hSole[i + 1]) / 2;
    const o = hs > -0.833 ? 0 : hs > -6 ? 0.25 : hs > -12 ? 0.5 : hs > -18 ? 0.75 : 1;
    g.appendChild(sv("rect", { x: X(i), y: sy, width: X(i + 1) - X(i) + 0.5, height: gh, class: "gas-gr-notte", opacity: o }));
  }
  for (const h of [0, 30, 60, 90]) {
    g.appendChild(sv("line", { x1: sx, y1: Y(h), x2: sx + gw, y2: Y(h), class: "gas-gr-griglia" }));
    g.appendChild(sv("text", { x: sx - 6, y: Y(h) + 4, "text-anchor": "end", class: "gas-gr-testo", text: h + "°" }));
  }
  g.appendChild(sv("line", { x1: sx, y1: Y(NOTTE.hmin), x2: sx + gw, y2: Y(NOTTE.hmin), class: "gas-gr-min" }));
  if (terrenoAttivo()) {
    const az = aziOggetto(r, nt);
    let d = `M${X(i0).toFixed(1)},${Y(0)}`;
    for (let i = i0; i <= i1; i++) d += `L${X(i).toFixed(1)},${Y(altTerreno(az[i])).toFixed(1)}`;
    g.appendChild(sv("path", { d: d + `L${X(i1).toFixed(1)},${Y(0)}Z`, class: "gas-pano-terra" }));
  }
  const linea = (arr, classe) => {
    let d = "", su = false;
    for (let i = i0; i <= i1; i++) {
      const h = arr[i];
      if (h > 0) { d += `${su ? "L" : "M"}${X(i).toFixed(1)},${Y(h).toFixed(1)}`; su = true; } else su = false;
    }
    return sv("path", { d, class: classe });
  };
  g.appendChild(linea(nt.hLuna, "gas-gr-luna"));
  g.appendChild(linea(r.h, "gas-gr-ogg"));
  for (let i = i0; i <= i1; i++) {
    const d = Astro.data(nt.tempi[i]);
    if (d.getMinutes() === 0 && d.getHours() % 2 === 0)
      g.appendChild(sv("text", { x: X(i), y: H - 8, "text-anchor": "middle", class: "gas-gr-testo", text: String(d.getHours()).padStart(2, "0") + ":00" }));
  }
  return el("div", { class: "gas-grafico-box" }, g, el("div", { class: "gas-legenda" },
    el("span", null, el("i", { class: "gas-leg-ogg" }), t("altezza_oggetto")), el("span", null, el("i", { class: "gas-leg-luna" }), t("altezza_luna")),
    el("span", null, el("i", { class: "gas-leg-min" }), t("altezza_minima"))));
}
Object.assign(ICONE_SVG, { luogo: '<path d="M12 21.2s-6.6-6.2-6.6-11.2a6.6 6.6 0 0 1 13.2 0c0 5-6.6 11.2-6.6 11.2z"/><circle cx="12" cy="10" r="2.4"/>' });
Object.assign(TESTI.it, { cn_titolo: "Cielo del luogo", cn_lorenz: "atlante di David Lorenz (2025)", cn_citta: "stima dalle città vicine",
  cn_misurato: "misurato da te", cn_scelto: "scelto da te", cn_lpi_n: "LPI: quante volte la luce artificiale supera quella naturale del cielo" });
Object.assign(TESTI.de, { cn_titolo: "Himmel am Ort", cn_lorenz: "Atlas von David Lorenz (2025)", cn_citta: "aus den Orten in der Nähe geschätzt",
  cn_misurato: "von Ihnen gemessen", cn_scelto: "von Ihnen gewählt", cn_lpi_n: "LPI: Verhältnis von künstlichem zu natürlichem Himmelslicht" });
Object.assign(TESTI.es, { cn_titolo: "Cielo del lugar", cn_lorenz: "atlas de David Lorenz (2025)", cn_citta: "estimado a partir de las poblaciones cercanas",
  cn_misurato: "medido por ti", cn_scelto: "elegido por ti", cn_lpi_n: "LPI: cuántas veces la luz artificial supera la natural del cielo" });
Object.assign(TESTI.en, { cn_titolo: "Local sky", cn_lorenz: "David Lorenz's atlas (2025)", cn_citta: "estimated from nearby towns",
  cn_misurato: "measured by you", cn_scelto: "chosen by you", cn_lpi_n: "LPI: how many times artificial light exceeds the natural light of the sky" });
Object.assign(TESTI.it, { cn_no_stima: "stima non arrivata", cn_riprova: "Riprova",
  cn_no_stima_n: "La stima del buio di questo luogo non è arrivata: serve la rete. Per ora usiamo Bortle {b} (scala del buio del cielo: da 1, buio pieno, a 9, centro città)." });
Object.assign(TESTI.de, { cn_no_stima: "Schätzung nicht angekommen", cn_riprova: "Erneut versuchen",
  cn_no_stima_n: "Die Schätzung der Dunkelheit für diesen Ort ist nicht angekommen: dafür braucht es eine Internetverbindung. Vorerst rechnen wir mit Bortle {b}." });
Object.assign(TESTI.es, { cn_no_stima: "estimación no recibida", cn_riprova: "Reintentar",
  cn_no_stima_n: "La estimación de la oscuridad de este lugar no ha llegado: hace falta conexión. Por ahora usamos Bortle {b}." });
Object.assign(TESTI.en, { cn_no_stima: "estimate not received", cn_riprova: "Try again",
  cn_no_stima_n: "The darkness estimate for this place didn't arrive: it needs a connection. For now we're using Bortle {b}." });
Object.assign(TESTI.it, { ns_aria: "Cosa vuoi vedere stanotte", ns_oggetti: "Cosa fotografare", ns_oggetti_v: "Cosa osservare", ns_pianeti: "Pianeti",
  ns_cielo: "Meteore, comete e ISS", ns_piano: "Il mio piano", ns_posti: "Posti bui", ns_cambia: "Cambia", ns_chiudi: "Chiudi", ns_senza_attrezzi: "Nessuna attrezzatura" });
Object.assign(TESTI.de, { ns_aria: "Was möchten Sie heute Nacht sehen", ns_oggetti: "Objekte zum Fotografieren", ns_oggetti_v: "Objekte zum Beobachten", ns_pianeti: "Planeten",
  ns_cielo: "Meteore, Kometen und ISS", ns_piano: "Mein Plan", ns_posti: "Dunkle Orte", ns_cambia: "Ändern", ns_chiudi: "Schließen", ns_senza_attrezzi: "Keine Ausrüstung" });
Object.assign(TESTI.es, { ns_aria: "Qué quieres ver esta noche", ns_oggetti: "Qué fotografiar", ns_oggetti_v: "Qué observar", ns_pianeti: "Planetas",
  ns_cielo: "Meteoros, cometas e ISS", ns_piano: "Mi plan", ns_posti: "Lugares oscuros", ns_cambia: "Cambiar", ns_chiudi: "Cerrar", ns_senza_attrezzi: "Sin equipo" });
Object.assign(TESTI.en, { ns_aria: "What to see tonight", ns_oggetti: "What to image", ns_oggetti_v: "What to observe", ns_pianeti: "Planets",
  ns_cielo: "Meteors, comets & ISS", ns_piano: "My plan", ns_posti: "Dark sites", ns_cambia: "Change", ns_chiudi: "Close", ns_senza_attrezzi: "No equipment" });
Object.assign(ICONE_SVG, { cerca: '<circle cx="10.6" cy="10.6" r="6.3"/><path d="M15.3 15.3 20.2 20.2"/>' });
Object.assign(TESTI.it, { ns_cerca: "Cerca un oggetto", ns_cerca_ph: "Cerca un oggetto: M42, Orione, NGC 7000…",
  ns_cerca_uno: "1 oggetto trovato con «{q}».", ns_cerca_n: "{n} oggetti trovati con «{q}».", ns_cerca_filtri: "Mentre cerchi, le scelte del riquadro Oggetti non contano.",
  ns_cerca_vuoto: "Nessun oggetto trovato con «{q}». Prova con la sigla (M42, NGC 7000) o con il nome (Orione, Andromeda).",
  ns_cerca_togli: "Togli la ricerca", ns_cerca_tanti: "Ne mostriamo 40: scrivi qualcosa in più per trovare quello che cerchi.",
  ns_cerca_sotto: "stanotte sotto l'orizzonte", ns_cerca_basso: "stanotte sotto i {h}°", ns_cerca_vai_ls: "Apri Luna e Sole", ns_cerca_vai_pianeti: "Apri Pianeti" });
Object.assign(TESTI.de, { ns_cerca: "Objekt suchen", ns_cerca_ph: "Objekt suchen: M42, Orion, NGC 7000…",
  ns_cerca_uno: "1 Objekt gefunden für „{q}“.", ns_cerca_n: "{n} Objekte gefunden für „{q}“.", ns_cerca_filtri: "Während der Suche zählt die Auswahl unter „Objekte“ nicht.",
  ns_cerca_vuoto: "Kein Objekt gefunden für „{q}“. Versuchen Sie es mit der Katalognummer (M42, NGC 7000) oder dem Namen (Orion, Andromeda).",
  ns_cerca_togli: "Suche löschen", ns_cerca_tanti: "Wir zeigen nur 40: Geben Sie etwas mehr ein, um das gesuchte Objekt zu finden.",
  ns_cerca_sotto: "heute Nacht unter dem Horizont", ns_cerca_basso: "heute Nacht unter {h}°", ns_cerca_vai_ls: "Mond und Sonne öffnen", ns_cerca_vai_pianeti: "Planeten öffnen" });
Object.assign(TESTI.es, { ns_cerca: "Buscar un objeto", ns_cerca_ph: "Buscar un objeto: M42, Orión, NGC 7000…",
  ns_cerca_uno: "1 objeto encontrado con «{q}».", ns_cerca_n: "{n} objetos encontrados con «{q}».", ns_cerca_filtri: "Mientras buscas, lo que elegiste en el recuadro Objetos no cuenta.",
  ns_cerca_vuoto: "Ningún objeto encontrado con «{q}». Prueba con la sigla (M42, NGC 7000) o con el nombre (Orión, Andrómeda).",
  ns_cerca_togli: "Borrar la búsqueda", ns_cerca_tanti: "Mostramos 40: escribe algo más para encontrar el que buscas.",
  ns_cerca_sotto: "esta noche bajo el horizonte", ns_cerca_basso: "esta noche por debajo de {h}°", ns_cerca_vai_ls: "Abrir Luna y Sol", ns_cerca_vai_pianeti: "Abrir Planetas" });
Object.assign(TESTI.en, { ns_cerca: "Find an object", ns_cerca_ph: "Find an object: M42, Orion, NGC 7000…",
  ns_cerca_uno: "1 object found for “{q}”.", ns_cerca_n: "{n} objects found for “{q}”.", ns_cerca_filtri: "While you search, the choices in the Objects box don't apply.",
  ns_cerca_vuoto: "No object found for “{q}”. Try the catalogue number (M42, NGC 7000) or the name (Orion, Andromeda).",
  ns_cerca_togli: "Clear search", ns_cerca_tanti: "Showing 40: type a little more to find the one you want.",
  ns_cerca_sotto: "below the horizon tonight", ns_cerca_basso: "below {h}° tonight", ns_cerca_vai_ls: "Open Moon & Sun", ns_cerca_vai_pianeti: "Open Planets" });
Object.assign(TESTI.it, {
  cb_titolo: "Dove andare stanotte per un cielo più buio", cb_n: "I punti più bui sulla terraferma entro la distanza che scegli, dall'atlante dell'inquinamento luminoso di David Lorenz (2025), con le nuvole previste stanotte.",
  cb_raggio: "Entro", cb_cerca: "Trova i cieli bui", cb_carico: "Cerco i posti più bui…", cb_nessuno: "Entro questa distanza non c'è un cielo più buio del tuo.",
  cb_fuori: "La mappa del buio copre l'Italia e i dintorni: qui non c'è.", cb_vicino: "vicino a {p}", cb_dir: "{km} km a {d}", cb_nuvole: "stanotte nuvole {p} %",
  cb_meteo_no: "meteo non disponibile", cb_usa: "Usa questo luogo", cb_mappa: "Mappa", cb_qui: "sei qui",
  cb_avviso: "Controlla su una mappa che ci si arrivi in sicurezza e che sia permesso starci di notte. Il buio è quello dell'atlante di David Lorenz (2025), dalle luci viste dal satellite, che vede poco i LED bianchi: vicino ai paesi può essere un po' più chiaro.",
  cb_nome: "Cielo buio vicino a {p}", cb_nome_senza: "Cielo buio a {km} km", cb_ora_sqm: "Dove sei: SQM {s} · LPI {l}",
});
Object.assign(TESTI.de, {
  cb_titolo: "Wo Sie heute Nacht einen dunkleren Himmel finden", cb_n: "Die dunkelsten Orte an Land im gewählten Umkreis, aus dem Lichtverschmutzungsatlas von David Lorenz (2025), mit der Bewölkung für heute Nacht.",
  cb_raggio: "Bis", cb_cerca: "Dunkle Orte finden", cb_carico: "Die dunkelsten Orte werden gesucht…", cb_nessuno: "In dieser Entfernung gibt es keinen dunkleren Himmel als bei Ihnen.",
  cb_fuori: "Die Dunkelkarte deckt nur Italien und Umgebung ab: Ihr Ort liegt außerhalb.", cb_vicino: "bei {p}", cb_dir: "{km} km Richtung {d}", cb_nuvole: "heute Nacht Wolken {p} %",
  cb_meteo_no: "Wetter nicht verfügbar", cb_usa: "Diesen Ort verwenden", cb_mappa: "Karte", cb_qui: "Sie sind hier",
  cb_avviso: "Prüfen Sie auf einer Karte, ob der Ort sicher erreichbar ist und ob man sich nachts dort aufhalten darf. Die Dunkelheitswerte stammen aus dem Atlas von David Lorenz (2025) und beruhen auf Satellitenaufnahmen der Lichter; weiße LEDs erfasst der Satellit kaum, daher kann es in Ortsnähe etwas heller sein.",
  cb_nome: "Dunkler Himmel bei {p}", cb_nome_senza: "Dunkler Himmel in {km} km Entfernung", cb_ora_sqm: "Bei Ihnen: SQM {s} · LPI {l}",
});
Object.assign(TESTI.es, {
  cb_titolo: "Adónde ir esta noche para un cielo más oscuro", cb_n: "Los puntos más oscuros en tierra firme dentro de la distancia que elijas, según el atlas de contaminación lumínica de David Lorenz (2025), con las nubes previstas esta noche.",
  cb_raggio: "Hasta", cb_cerca: "Buscar cielos oscuros", cb_carico: "Buscando los lugares más oscuros…", cb_nessuno: "Dentro de esta distancia no hay un cielo más oscuro que el tuyo.",
  cb_fuori: "El mapa de oscuridad cubre Italia y alrededores: aquí no.", cb_vicino: "cerca de {p}", cb_dir: "{km} km al {d}", cb_nuvole: "esta noche nubes {p} %",
  cb_meteo_no: "previsión no disponible", cb_usa: "Usar este lugar", cb_mappa: "Mapa", cb_qui: "estás aquí",
  cb_avviso: "Comprueba en un mapa que se pueda llegar con seguridad y que esté permitido estar allí de noche. La oscuridad es la del atlas de David Lorenz (2025), a partir de las luces vistas por satélite, que apenas ve los LED blancos: cerca de los pueblos puede ser algo más claro.",
  cb_nome: "Cielo oscuro cerca de {p}", cb_nome_senza: "Cielo oscuro a {km} km", cb_ora_sqm: "Donde estás: SQM {s} · LPI {l}",
});
Object.assign(TESTI.it, { cb_errore: "La mappa del buio non è arrivata: controlla la connessione e tocca di nuovo «{b}»." });
Object.assign(TESTI.de, { cb_errore: "Die Dunkelkarte ist nicht angekommen: Prüfen Sie die Verbindung und tippen Sie noch einmal auf „{b}“." });
Object.assign(TESTI.es, { cb_errore: "El mapa de oscuridad no ha llegado: revisa la conexión y toca otra vez «{b}»." });
Object.assign(TESTI.en, { cb_errore: "The darkness map didn't arrive: check your connection and tap “{b}” again." });
const DIREZIONI = {
  it: ["nord", "nord-est", "est", "sud-est", "sud", "sud-ovest", "ovest", "nord-ovest"],
  de: ["Norden", "Nordosten", "Osten", "Südosten", "Süden", "Südwesten", "Westen", "Nordwesten"],
  es: ["norte", "noreste", "este", "sureste", "sur", "suroeste", "oeste", "noroeste"],
  en: ["north", "north-east", "east", "south-east", "south", "south-west", "west", "north-west"],
}[LINGUA];
const direzione = az => DIREZIONI[Math.round(az / 45) % 8];
const SCALA_BUIO = [[21.8, [10, 14, 34]], [21.5, [20, 44, 88]], [21.2, [31, 79, 143]], [20.9, [47, 125, 63]], [20.5, [111, 168, 58]],
  [20.0, [200, 200, 58]], [19.5, [224, 165, 58]], [19.0, [217, 86, 46]], [18.5, [192, 48, 108]], [17.8, [240, 230, 240]]];
function coloreBuio(s) {
  if (s >= SCALA_BUIO[0][0]) return SCALA_BUIO[0][1];
  for (let i = 1; i < SCALA_BUIO.length; i++) {
    const [a, ca] = SCALA_BUIO[i - 1], [b, cb] = SCALA_BUIO[i];
    if (s >= b) { const f = (a - s) / (a - b); return ca.map((v, k) => Math.round(v + (cb[k] - v) * f)); }
  }
  return SCALA_BUIO[SCALA_BUIO.length - 1][1];
}
function cartaCieliBui(usa) {
  const raggio = selezione([30, 50, 80, 120].map(k => [k, `${k} km`]), ricorda("cieli_bui_r", 50), v => { salva("cieli_bui_r", +v); }, { "aria-label": t("cb_raggio") });
  const esito = el("div", { class: "gas-cb-esito" });
  const cerca = el("button", { type: "button", class: "gas-btn", onclick: () => trova() }, t("cb_cerca"));
  const box = scheda(t("cb_titolo"), el("p", { class: "gas-nota" }, t("cb_n")),
    el("div", { class: "gas-riga-bottoni gas-cb-comandi" }, etichetta(t("cb_raggio"), raggio), cerca), esito);
  box.classList.add("gas-cb");
  async function trova() {
    const { lat, lon } = NOTTE.luogo, R = +raggio.value, mio = (trova.giro = (trova.giro || 0) + 1);
    cerca.disabled = true;
    svuota(esito).append(el("p", { class: "gas-muto" }, t("cb_carico")));
    let r;
    try { r = await Luoghi.cieliBui(lat, lon, R); } catch (e) { r = null; }
    cerca.disabled = false;
    if (mio !== trova.giro) return;
    if (!r) { svuota(esito).append(el("p", { class: "gas-muto", role: "alert" }, t("cb_errore", { b: t("cb_cerca") }))); return; }
    if (!r.punti.some(p => p.sqm != null)) { svuota(esito).append(el("p", { class: "gas-muto" }, t("cb_fuori"))); return; }
    aggiungi(svuota(esito), [mappaBuio(r, lat, lon, R), r.qui != null ? el("p", { class: "gas-nota" }, t("cb_ora_sqm", { s: num(r.qui, 1), l: numLpi(lpiDaSqm(r.qui)) })) : null]);
    if (!r.migliori.length) { esito.append(el("p", { class: "gas-muto" }, t("cb_nessuno"))); return; }
    const nt = Astro.notte(dataNotte(), lat, lon, 10), a = nt.ev.astroFine || nt.ev.nauticoFine, b = nt.ev.astroInizio || nt.ev.nauticoInizio;
    const lista = el("ol", { class: "gas-cb-lista" });
    r.migliori.forEach((p, i) => {
      const nuvole = el("small", { class: "gas-cb-nuvole" }, "…");
      const nome = p.vicino ? t("cb_nome", { p: p.vicino }) : t("cb_nome_senza", { km: num(p.km) });
      lista.appendChild(el("li", { class: "gas-cb-voce" },
        el("span", { class: "gas-cb-num" }, String(i + 1)),
        el("div", { class: "gas-cb-testo" },
          el("b", null, `SQM ${num(p.sqm, 1)} · LPI ${numLpi(lpiDaSqm(p.sqm))} · Bortle ${bortleDaSqm(p.sqm)}`),
          el("span", null, [t("cb_dir", { km: num(p.km), d: direzione(p.az) }), p.vicino ? t("cb_vicino", { p: p.vicino }) : ""].filter(Boolean).join(" · ")),
          nuvole),
        el("div", { class: "gas-cb-bottoni" },
          el("button", { type: "button", class: "gas-btn gas-btn--mini", onclick: () => usa({ nome, lat: Math.round(p.lat * 1e4) / 1e4, lon: Math.round(p.lon * 1e4) / 1e4 }) }, t("cb_usa")),
          el("a", { class: "gas-btn gas-btn--chiaro gas-btn--mini", href: `https://www.google.com/maps/search/?api=1&query=${p.lat.toFixed(4)},${p.lon.toFixed(4)}`,
            target: "_blank", rel: "noopener" }, t("cb_mappa"), " ↗"))));
      if (!a || !b) { nuvole.textContent = ""; return; }
      previsione(p.lat, p.lon).then(dati => {
        const ore = dati.filter(x => x.oraria && x.t >= new Date(a.getTime() - 1800e3) && x.t <= b);
        if (!ore.length) { nuvole.textContent = t("cb_meteo_no"); return; }
        const m = ore.reduce((s, x) => s + (x.nuv ?? 0), 0) / ore.length;
        svuota(nuvole).append(el("i", { class: "gas-me-semaforo gas-me-semaforo--" + classeVoto(100 - m) }), " ", t("cb_nuvole", { p: num(m) }));
      }).catch(() => { nuvole.textContent = t("cb_meteo_no"); });
    });
    esito.append(lista, el("p", { class: "gas-nota" }, t("cb_avviso")));
  }
  return box;
}
function mappaBuio(r, lat, lon, R) {
  const W = 480, H = 480, tela = el("canvas", { class: "gas-cb-mappa", width: W, height: H, role: "img", "aria-label": t("cb_titolo") });
  const g = tela.getContext("2d"), kx = 111.2 * Math.cos(lat * RAD), ky = 111.2;
  const xy = (la, lo) => [W / 2 + (lo - lon) * kx / R * (W / 2 - 8), H / 2 - (la - lat) * ky / R * (H / 2 - 8)];
  g.fillStyle = "#070d1a"; g.fillRect(0, 0, W, H);
  const lato = r.passoKm / R * (W / 2 - 8) + 1;
  for (const p of r.punti) {
    const [x, y] = xy(p.lat, p.lon);
    g.fillStyle = p.sqm == null ? (p.terra ? "#1b2333" : "#0b1730") : `rgb(${coloreBuio(p.sqm).join(",")})`;
    g.fillRect(x - lato / 2, y - lato / 2, lato, lato);
  }
  g.strokeStyle = "rgba(255,255,255,.25)"; g.setLineDash([6, 6]); g.beginPath(); g.arc(W / 2, H / 2, W / 2 - 8, 0, 2 * Math.PI); g.stroke(); g.setLineDash([]);
  g.font = "700 15px system-ui, sans-serif"; g.textAlign = "center"; g.textBaseline = "middle";
  r.migliori.forEach((p, i) => {
    const [x, y] = xy(p.lat, p.lon);
    g.fillStyle = "#f4d58b"; g.strokeStyle = "#0a1320"; g.lineWidth = 2;
    g.beginPath(); g.arc(x, y, 11, 0, 2 * Math.PI); g.fill(); g.stroke();
    g.fillStyle = "#1b1404"; g.fillText(String(i + 1), x, y + 1);
  });
  g.fillStyle = "#fff"; g.strokeStyle = "#0a1320"; g.lineWidth = 3;
  g.beginPath(); g.arc(W / 2, H / 2, 6, 0, 2 * Math.PI); g.fill(); g.stroke();
  g.font = "600 13px system-ui, sans-serif"; g.lineWidth = 4; g.strokeStyle = "rgba(0,0,0,.75)";
  g.strokeText(t("cb_qui"), W / 2, H / 2 - 16); g.fillText(t("cb_qui"), W / 2, H / 2 - 16);
  const legenda = el("div", { class: "gas-cb-legenda" }, SCALA_BUIO.slice().reverse().map(([s, c]) => el("span", { style: { background: `rgb(${c.join(",")})` }, title: `SQM ${num(s, 1)}` })));
  const scala = el("div", { class: "gas-cb-scala" }, el("small", null, "SQM " + num(SCALA_BUIO[SCALA_BUIO.length - 1][0], 1)), legenda, el("small", null, num(SCALA_BUIO[0][0], 1)));
  return el("div", { class: "gas-cb-mappa-box" }, tela, scala);
}
Object.assign(TESTI.it, {
  pn_titolo: "Il piano della notte", pn_vuoto: "In «Cosa vedere» tocca «+ Piano» sugli oggetti: qui li mettiamo in fila nelle ore di buio, con gli orari.",
  pn_aggiungi: "+ Piano", pn_nel_piano: "✓ Nel piano", pn_basso: "non sale sopra {h}° nel buio", pn_stampa: "Stampa", pn_copia: "Copia", pn_nina: "Scarica il piano per N.I.N.A.",
  pn_svuota: "Svuota", pn_n: "Ordine: prima gli oggetti che tramontano prima. Orari nel fuso orario del tuo dispositivo.", pn_alt: "alto {h}°",
  pn_testa: "Piano della notte di {d} · {l}", pn_tot: "{n} oggetti · {t} di buio",
});
Object.assign(TESTI.de, {
  pn_titolo: "Plan für die Nacht", pn_vuoto: "Tippen Sie unter „Was sehen“ bei den Objekten auf „+ Plan“: Hier ordnen wir sie mit Uhrzeiten in die dunklen Stunden ein.",
  pn_aggiungi: "+ Plan", pn_nel_piano: "✓ Im Plan", pn_basso: "steigt im Dunkeln nicht über {h}°", pn_stampa: "Drucken", pn_copia: "Kopieren", pn_nina: "Für N.I.N.A. herunterladen",
  pn_svuota: "Leeren", pn_n: "Reihenfolge: zuerst die Objekte, die früher untergehen. Uhrzeiten in der Zeitzone Ihres Geräts.", pn_alt: "Höhe {h}°",
  pn_testa: "Plan der Nacht vom {d} · {l}", pn_tot: "{n} Objekte · {t} Dunkelheit",
});
Object.assign(TESTI.es, {
  pn_titolo: "El plan de la noche", pn_vuoto: "En «Qué ver» toca «+ Plan» en los objetos: aquí los ponemos en orden en las horas de oscuridad, con los horarios.",
  pn_aggiungi: "+ Plan", pn_nel_piano: "✓ En el plan", pn_basso: "no sube por encima de {h}° en las horas de oscuridad", pn_stampa: "Imprimir", pn_copia: "Copiar", pn_nina: "Descargar para N.I.N.A.",
  pn_svuota: "Vaciar", pn_n: "Orden: primero los objetos que se ponen antes. Horarios en la zona horaria de tu dispositivo.", pn_alt: "altura {h}°",
  pn_testa: "Plan de la noche del {d} · {l}", pn_tot: "{n} objetos · {t} de oscuridad",
});
Object.assign(TESTI.it, { pn_togli: "Togli {id} dal piano", pn_svuota_sicuro: "Sicuro? Tocca di nuovo per svuotare il piano", pn_orario: "Orario" });
Object.assign(TESTI.de, { pn_togli: "{id} aus dem Plan entfernen", pn_svuota_sicuro: "Sicher? Zum Leeren noch einmal tippen", pn_orario: "Uhrzeit" });
Object.assign(TESTI.es, { pn_togli: "Quitar {id} del plan", pn_svuota_sicuro: "¿Seguro? Toca otra vez para vaciar el plan", pn_orario: "Horario" });
Object.assign(TESTI.en, { pn_togli: "Remove {id} from the plan", pn_svuota_sicuro: "Sure? Tap again to clear the plan", pn_orario: "Time" });
if (!Array.isArray(NOTTE.piano)) NOTTE.piano = [];
function pianoNotte(nt) {
  const hmin = NOTTE.hmin || 30, buio = nt.buio;
  if (!buio.length) return [];
  const voci = NOTTE.piano.map(id => trovaOggetto(id)).filter(Boolean).map(o => {
    const h = Astro.curvaOggetto(nt, o.ra, o.dec).h, su = buio.filter(i => h[i] >= hmin);
    return { o, h, i0: su.length ? su[0] : null, i1: su.length ? su[su.length - 1] : null };
  });
  const ok = voci.filter(v => v.i0 != null).sort((a, b) => a.i1 - b.i1 || a.i0 - b.i0);
  let cur = buio[0];
  ok.forEach((v, k) => {
    const resto = ok.slice(k), limite = Math.max(...resto.map(x => x.i1)), dopo = ok[k + 1];
    const da = Math.max(cur, v.i0), quota = Math.max(1, Math.floor((limite - da) / resto.length));
    const a = Math.min(v.i1, Math.max(da + quota, dopo ? dopo.i0 : 0));
    Object.assign(v, { da, a: Math.max(a, da) });
    let hMax = -90;
    for (let i = da; i <= v.a; i++) hMax = Math.max(hMax, v.h[i]);
    v.hMax = hMax;
    cur = v.a;
  });
  return ok.concat(voci.filter(v => v.i0 == null));
}
function csvNina(voci) {
  const pa = CAMPO.modo === "foto" ? (CAMPO.rot || 0).toFixed(2) : "";
  const pulisci = s => String(s || "").replace(/[,"\n]/g, " ").trim();
  return ["Catalogue Entry,Familiar Name,Right Ascension (J2000),Declination (J2000),Position Angle (East)"]
    .concat(voci.filter(v => v.da != null).map(v => [pulisci(v.o.id), pulisci(nomeOggetto(v.o) || v.o.id), raTelescopius(v.o.ra), decTelescopius(v.o.dec), pa].join(",")))
    .join("\r\n") + "\r\n";
}
function boxPiano(nt) {
  const box = el("section", { class: "gas-card gas-pn" });
  const voci = pianoNotte(nt), hmin = NOTTE.hmin || 30;
  box.appendChild(el("h3", null, t("pn_titolo")));
  if (!NOTTE.piano.length) { box.appendChild(el("p", { class: "gas-nota" }, t("pn_vuoto"))); return box; }
  const t0 = nt.tempi[nt.buio[0]], t1 = nt.tempi[nt.buio[nt.buio.length - 1]], ora_ = i => ora(Astro.data(nt.tempi[i]));
  const barra = el("div", { class: "gas-pn-barra" });
  voci.filter(v => v.da != null).forEach((v, k) => barra.appendChild(el("span", { class: "gas-pn-seg gas-pn-seg--" + (k % 4),
    style: { left: ((nt.tempi[v.da] - t0) / (t1 - t0) * 100) + "%", width: Math.max(1.5, (nt.tempi[v.a] - nt.tempi[v.da]) / (t1 - t0) * 100) + "%" }, title: v.o.id }, v.o.id)));
  const lista = el("ol", { class: "gas-pn-lista" }, voci.map(v => el("li", { class: v.da == null ? "gas-spento" : "" },
    el("span", { class: "gas-pn-ore" }, v.da != null ? `${ora_(v.da)} – ${ora_(v.a)}` : "–"),
    el("span", { class: "gas-pn-ogg" }, el("b", null, v.o.id), nomeOggetto(v.o) ? ` ${nomeOggetto(v.o)}` : ""),
    el("small", null, v.da != null ? `${durata((nt.tempi[v.a] - nt.tempi[v.da]) * 24)} · ${t("pn_alt", { h: num(v.hMax) })}` : t("pn_basso", { h: hmin })),
    el("button", { type: "button", class: "gas-pn-togli", "aria-label": t("pn_togli", { id: v.o.id }), onclick: () => { cambiaPiano(v.o.id); } }, "×"))));
  const testo = () => [t("pn_testa", { d: giorno(dataNotte(), true), l: NOTTE.luogo.nome })]
    .concat(voci.map(v => `${v.da != null ? `${ora_(v.da)}-${ora_(v.a)}` : "  –  "}  ${v.o.id}${nomeOggetto(v.o) ? " " + nomeOggetto(v.o) : ""}  RA ${raHms(v.o.ra)}  Dec ${decDms(v.o.dec)}`)).join("\n");
  const stampa = () => {
    const w = window.open("", "_blank");
    if (!w) { window.print(); return; }
    const righe = voci.map(v => `<tr><td>${v.da != null ? `${ora_(v.da)} – ${ora_(v.a)}` : "–"}</td><td><b>${v.o.id}</b> ${nomeOggetto(v.o) || ""}</td><td>${raHms(v.o.ra)}</td><td>${decDms(v.o.dec)}</td><td>${v.da != null ? num(v.hMax) + "°" : ""}</td></tr>`).join("");
    w.document.write(`<!doctype html><meta charset="utf-8"><title>${t("pn_titolo")}</title><style>body{font:14px system-ui,sans-serif;margin:24px}h1{font-size:20px}table{border-collapse:collapse;width:100%}td,th{border-bottom:1px solid #ccc;padding:6px 8px;text-align:left}</style>
      <h1>${t("pn_testa", { d: giorno(dataNotte(), true), l: NOTTE.luogo.nome })}</h1><table><tr><th>${t("pn_orario")}</th><th>${t("oggetto")}</th><th>RA (J2000)</th><th>Dec (J2000)</th><th>${t("alt_max")}</th></tr>${righe}</table>
      <p style="color:#666">giordanoastronomia.it</p>`);
    w.document.close(); w.focus(); setTimeout(() => w.print(), 300);
  };
  let attesa = null;
  const svuotaB = el("button", { type: "button", class: "gas-btn gas-btn--chiaro gas-btn--mini gas-att-svuota", onclick: () => {
    if (!attesa) {
      svuotaB.classList.add("pronto"); svuotaB.textContent = t("pn_svuota_sicuro");
      attesa = setTimeout(() => { attesa = null; svuotaB.classList.remove("pronto"); svuotaB.textContent = t("pn_svuota"); }, 5000);
      return;
    }
    clearTimeout(attesa); attesa = null;
    NOTTE.piano = []; salvaNotte(); aggiornaPiani();
  } }, t("pn_svuota"));
  box.append(el("p", { class: "gas-nota" }, t("pn_tot", { n: voci.length, t: durata((t1 - t0) * 24) })), barra,
    el("div", { class: "gas-pn-scala" }, el("span", null, ora(Astro.data(t0))), el("span", null, ora(Astro.data(t1)))), lista,
    el("div", { class: "gas-riga-bottoni" },
      el("button", { type: "button", class: "gas-btn gas-btn--mini", onclick: () => scaricaTesto(csvNina(voci), `piano-${isoData(dataNotte())}.csv`, "text/csv;charset=utf-8") }, icona("esporta"), " ", t("pn_nina")),
      el("button", { type: "button", class: "gas-btn gas-btn--chiaro gas-btn--mini", onclick: e => copia(testo(), e.currentTarget) }, t("pn_copia")),
      el("button", { type: "button", class: "gas-btn gas-btn--chiaro gas-btn--mini", onclick: stampa }, t("pn_stampa")),
      svuotaB),
    el("p", { class: "gas-nota" }, t("pn_n")));
  return box;
}
const PIANO_UI = new Set();
function aggiornaPiani() { for (const f of [...PIANO_UI]) f(); }
function cambiaPiano(id) {
  const i = NOTTE.piano.indexOf(id);
  if (i >= 0) NOTTE.piano.splice(i, 1); else NOTTE.piano.push(id);
  salvaNotte(); aggiornaPiani();
}
function bottonePiano(id) {
  const b = el("button", { type: "button", class: "gas-btn gas-btn--chiaro gas-btn--mini gas-pn-btn" });
  const disegna = () => {
    if (!b.isConnected && b._mostrato) { PIANO_UI.delete(disegna); return; }
    b._mostrato = true;
    const dentro = NOTTE.piano.includes(id);
    b.classList.toggle("on", dentro); b.setAttribute("aria-pressed", String(dentro));
    b.textContent = dentro ? t("pn_nel_piano") : t("pn_aggiungi");
  };
  b.addEventListener("click", e => { e.stopPropagation(); cambiaPiano(id); });
  PIANO_UI.add(disegna);
  disegna();
  return b;
}
function segnoPiano(id) {
  const s = el("span", { class: "gas-pn-badge", hidden: !NOTTE.piano.includes(id) }, t("pn_nel_piano"));
  const disegna = () => { if (!s.isConnected && s._mostrato) { PIANO_UI.delete(disegna); return; } s._mostrato = true; s.hidden = !NOTTE.piano.includes(id); };
  PIANO_UI.add(disegna);
  return s;
}
Object.assign(TESTI.it, {
  tab_diario: "Il mio diario", home_diario: "Gli oggetti che hai visto e fotografato, e la sfida dei 110 di Messier.",
  dr_titolo: "Il mio diario del cielo", dr_n: "Segna gli oggetti che hai visto all'oculare o fotografato: li ritrovi qui con la data.",
  dr_visto: "Visto", dr_foto: "Fotografato", dr_vuoto: "Ancora niente: tocca «Visto» o «Fotografato» su un oggetto in «Cosa vedere», o le caselle di Messier qui sotto.",
  dr_conta: "Visti: {v} · fotografati: {f}", dr_togli: "Togli dal diario", dr_apri: "Apri", dr_esporta: "Scarica il diario (CSV)",
  dr_messier: "La sfida di Messier", dr_messier_n: "I 110 oggetti del catalogo di Charles Messier (1781). Un tocco = visto, due = anche fotografato, tre = togli. In una notte di primavera si possono vedere quasi tutti: è la «maratona Messier».",
  dr_progresso: "Visti: {n} su 110 · fotografati: {f}", dr_legenda_v: "visto", dr_legenda_f: "fotografato",
  dr_traguardo: "Traguardo: {n} oggetti di Messier!", dr_prossimo: "Prossimo traguardo: {n}", dr_finito: "Tutti e 110: complimenti, sfida completata!",
  dr_vista_t: "visto: {d}", dr_foto_t: "fotografato: {d}", dr_vai_stanotte: "Cerca cosa vedere stanotte →",
});
Object.assign(TESTI.de, {
  tab_diario: "Mein Tagebuch", home_diario: "Die Objekte, die Sie gesehen und fotografiert haben, und die Messier-Challenge mit 110 Objekten.",
  dr_titolo: "Mein Himmelstagebuch", dr_n: "Markieren Sie die Objekte, die Sie im Okular gesehen oder fotografiert haben: Sie finden sie hier mit Datum.",
  dr_visto: "Gesehen", dr_foto: "Fotografiert", dr_vuoto: "Noch nichts: Tippen Sie bei einem Objekt unter „Was sehen“ auf „Gesehen“ oder „Fotografiert“ oder auf die Messier-Felder unten.",
  dr_conta: "Gesehen: {v} · fotografiert: {f}", dr_togli: "Aus dem Tagebuch entfernen", dr_apri: "Öffnen", dr_esporta: "Tagebuch herunterladen (CSV)",
  dr_messier: "Die Messier-Challenge", dr_messier_n: "Die 110 Objekte aus Charles Messiers Katalog von 1781. Einmal tippen = gesehen, zweimal = auch fotografiert, dreimal = entfernen. In einer Frühlingsnacht sieht man fast alle: der «Messier-Marathon».",
  dr_progresso: "Gesehen: {n} von 110 · fotografiert: {f}", dr_legenda_v: "gesehen", dr_legenda_f: "fotografiert",
  dr_traguardo: "Meilenstein: {n} Messier-Objekte!", dr_prossimo: "Nächster Meilenstein: {n}", dr_finito: "Alle 110: Glückwunsch, Challenge geschafft!",
  dr_vista_t: "gesehen: {d}", dr_foto_t: "fotografiert: {d}", dr_vai_stanotte: "Was heute Nacht zu sehen ist →",
});
Object.assign(TESTI.es, {
  tab_diario: "Mi diario", home_diario: "Los objetos que has visto y fotografiado, y el reto de los 110 de Messier.",
  dr_titolo: "Mi diario del cielo", dr_n: "Marca los objetos que has visto en el ocular o fotografiado: los encuentras aquí con la fecha.",
  dr_visto: "Visto", dr_foto: "Fotografiado", dr_vuoto: "Todavía nada: toca «Visto» o «Fotografiado» en un objeto de «Qué ver», o las casillas de Messier de abajo.",
  dr_conta: "Vistos: {v} · fotografiados: {f}", dr_togli: "Quitar del diario", dr_apri: "Abrir", dr_esporta: "Descargar el diario (CSV)",
  dr_messier: "El reto de Messier", dr_messier_n: "Los 110 objetos del catálogo de Charles Messier (1781). Un toque = visto, dos = también fotografiado, tres = quitar. En una noche de primavera se pueden ver casi todos: es el «maratón Messier».",
  dr_progresso: "Vistos: {n} de 110 · fotografiados: {f}", dr_legenda_v: "visto", dr_legenda_f: "fotografiado",
  dr_traguardo: "¡Meta alcanzada: {n} objetos de Messier!", dr_prossimo: "Próxima meta: {n}", dr_finito: "Los 110: ¡enhorabuena, reto completado!",
  dr_vista_t: "visto el {d}", dr_foto_t: "fotografiado el {d}", dr_vai_stanotte: "Qué ver esta noche →",
});
Object.assign(GUIDA.it, { g_diario: "Il tuo diario del cielo: segna gli oggetti che hai visto o fotografato e li ritrovi qui con la data. Sotto c'è la sfida di Messier: centodieci caselle da riempire, una per ogni oggetto del catalogo." });
Object.assign(GUIDA.de, { g_diario: "Ihr Himmelstagebuch: markieren Sie die Objekte, die Sie gesehen oder fotografiert haben, und Sie finden sie hier mit Datum. Darunter die Messier-Challenge: hundertzehn Felder, eines für jedes Objekt des Katalogs." });
Object.assign(GUIDA.es, { g_diario: "Tu diario del cielo: marca los objetos que has visto o fotografiado y los encuentras aquí con la fecha. Debajo está el reto de Messier: ciento diez casillas, una por cada objeto del catálogo." });
Object.assign(TESTI.it, { dr_csv_testa: "oggetto;nome;visto;fotografato", dr_csv_nome: "diario-cielo.csv" });
Object.assign(TESTI.de, { dr_csv_testa: "Objekt;Name;gesehen;fotografiert", dr_csv_nome: "himmelstagebuch.csv" });
Object.assign(TESTI.es, { dr_csv_testa: "objeto;nombre;visto;fotografiado", dr_csv_nome: "diario-del-cielo.csv" });
Object.assign(TESTI.en, { dr_csv_testa: "object;name;observed;imaged", dr_csv_nome: "observing-log.csv" });
const DIARIO = (() => { const d = ricorda("diario", {}); return d && typeof d === "object" && !Array.isArray(d) ? d : {}; })();
const DIARIO_UI = new Set();
const TRAGUARDI = [10, 25, 50, 75, 110];
function salvaDiario() { salva("diario", DIARIO); for (const f of [...DIARIO_UI]) f(); }
function idMessier(i) { const o = trovaOggetto("M" + i); return o ? o.id : "M" + i; }
function messierVisti() { let v = 0, f = 0; for (let i = 1; i <= 110; i++) { const r = DIARIO[idMessier(i)]; if (r && r.v) v++; if (r && r.f) f++; } return { v, f }; }
function segnaDiario(id, tipo) {
  if (!puoSalvare()) return invitoAccount();
  const r = Object.assign({}, DIARIO[id]), oggi = isoData(new Date()), primaM = messierVisti().v;
  if (r[tipo]) { delete r[tipo]; if (tipo === "v") delete r.f; } else { r[tipo] = oggi; if (tipo === "f" && !r.v) r.v = oggi; }
  if (!r.v && !r.f) delete DIARIO[id]; else DIARIO[id] = r;
  salvaDiario();
  const dopoM = messierVisti().v, t0 = TRAGUARDI.find(n => primaM < n && dopoM >= n);
  if (t0) avvisoDiario(t(t0 === 110 ? "dr_finito" : "dr_traguardo", { n: t0 }));
}
function avvisoDiario(testo) {
  const a = el("div", { class: "gas-dr-avviso", role: "status" }, "★ ", testo);
  const sopra = typeof PAGINA_OGG !== "undefined" && PAGINA_OGG ? PAGINA_OGG : null;
  (sopra || document.getElementById("gas-sfondo") || document.body).appendChild(a);
  if (sopra && sopra.scrollTop) {
    const su = sopra.getBoundingClientRect().bottom - a.getBoundingClientRect().bottom - (parseFloat(getComputedStyle(a).bottom) || 0);
    if (su > 1) a.style.marginBottom = -su + "px";
  }
  setTimeout(() => a.classList.add("via"), 3200); setTimeout(() => a.remove(), 4000);
}
function bottoniDiario(id) {
  const box = el("div", { class: "gas-dr-bottoni" });
  const disegna = () => {
    if (!box.isConnected && box._mostrato) { DIARIO_UI.delete(disegna); return; }
    box._mostrato = true;
    const r = DIARIO[id] || {};
    svuota(box).append(
      el("button", { type: "button", class: "gas-btn gas-btn--chiaro gas-btn--mini gas-dr-v" + (r.v ? " on" : ""), "aria-pressed": String(!!r.v),
        onclick: e => { e.stopPropagation(); segnaDiario(id, "v"); } }, r.v ? "✓ " : "", t("dr_visto")),
      el("button", { type: "button", class: "gas-btn gas-btn--chiaro gas-btn--mini gas-dr-f" + (r.f ? " on" : ""), "aria-pressed": String(!!r.f),
        onclick: e => { e.stopPropagation(); segnaDiario(id, "f"); } }, r.f ? "✓ " : "", t("dr_foto")));
  };
  DIARIO_UI.add(disegna);
  disegna();
  return box;
}
function segnoDiario(id) {
  const s = el("span", { class: "gas-dr-segno" });
  const disegna = () => {
    if (!s.isConnected && s._mostrato) { DIARIO_UI.delete(disegna); return; }
    s._mostrato = true;
    const r = DIARIO[id];
    s.hidden = !r;
    s.textContent = r ? (r.f ? "📷 " + t("dr_legenda_f") : "✓ " + t("dr_legenda_v")) : "";
  };
  DIARIO_UI.add(disegna);
  disegna();
  return s;
}
const dataBreve = iso => { const [y, m, d] = String(iso).split("-").map(Number); return new Date(y, m - 1, d).toLocaleDateString(LOCALE, { day: "numeric", month: "short", year: "numeric" }); };
let _disegnaDiario = null;
function vistaDiario(pannello) {
  svuota(pannello);
  if (schedaSoloAccount(pannello, "diario")) { aggiornaHash("diario"); return; }
  if (_disegnaDiario) DIARIO_UI.delete(_disegnaDiario);
  const lista = el("div", { class: "gas-dr-lista" }), conta = el("p", { class: "gas-nota gas-dr-conta" });
  const griglia = el("div", { class: "gas-dr-messier", role: "group", "aria-label": t("dr_messier") });
  const progresso = el("div", { class: "gas-dr-barra" }, el("i")), progTesto = el("p", { class: "gas-dr-prog" });
  const disegna = () => {
    if (!pannello.isConnected) { DIARIO_UI.delete(disegna); return; }
    const voci = Object.entries(DIARIO).map(([id, r]) => ({ id, r, o: trovaOggetto(id), d: r.f && r.f > (r.v || "") ? r.f : r.v || r.f || "" }))
      .filter(x => x.o).sort((a, b) => b.d.localeCompare(a.d));
    const v = voci.filter(x => x.r.v).length, f = voci.filter(x => x.r.f).length;
    conta.textContent = t("dr_conta", { v, f });
    svuota(lista);
    if (!voci.length) lista.append(el("p", { class: "gas-muto" }, t("dr_vuoto")),
      el("a", { class: "gas-btn gas-btn--chiaro gas-btn--mini", href: urlScheda("stanotte"), onclick: e => { e.preventDefault(); vai("stanotte"); } }, t("dr_vai_stanotte")));
    for (const x of voci.slice(0, 200)) {
      lista.appendChild(el("div", { class: "gas-dr-voce" + (x.r.f ? " gas-dr-voce--f" : "") },
        x.o.corpo ? el("span", { class: "gas-dr-ico" }, x.r.f ? "📷" : "✓") : miniaturaOggetto(x.o, 48),
        el("span", { class: "gas-dr-testo" }, el("b", null, x.o.corpo ? nomeCorpo(x.o.corpo) : x.o.id, nomeOggetto(x.o) && !x.o.corpo ? el("span", null, " " + nomeOggetto(x.o)) : null),
          el("small", null, [x.r.v ? t("dr_vista_t", { d: dataBreve(x.r.v) }) : null, x.r.f ? t("dr_foto_t", { d: dataBreve(x.r.f) }) : null].filter(Boolean).join(" · "))),
        el("button", { type: "button", class: "gas-btn gas-btn--chiaro gas-btn--mini", onclick: () => {
          if (!x.o.corpo) { apriOggetto(x.o.id); return; }
          CAMPO.ogg = x.o.id; CENTRO = null; SPOSTA = [0, 0]; ZOOM = 1; salvaCampo(); vai("campo");
        } }, t("dr_apri")),
        el("button", { type: "button", class: "gas-dr-togli", "aria-label": `${t("dr_togli")}: ${x.o.id}`, title: t("dr_togli"), onclick: () => { delete DIARIO[x.id]; salvaDiario(); } }, "×")));
    }
    const m = messierVisti(), prossimo = TRAGUARDI.find(n => m.v < n);
    progresso.firstChild.style.width = (m.v / 110 * 100) + "%";
    progTesto.textContent = t("dr_progresso", { n: m.v, f: m.f }) + (prossimo ? ` · ${t("dr_prossimo", { n: prossimo })}` : ` · ${t("dr_finito")}`);
    for (const b of griglia.children) {
      const r = DIARIO[b.dataset.id] || {};
      b.className = "gas-dr-cella" + (r.f ? " f" : r.v ? " v" : "");
      b.setAttribute("aria-pressed", String(!!r.v));
      b.setAttribute("aria-label", b._nome + (r.f ? " – " + t("dr_legenda_f") : r.v ? " – " + t("dr_legenda_v") : ""));
    }
  };
  for (let i = 1; i <= 110; i++) {
    const id = idMessier(i), o = trovaOggetto(id), b = el("button", { type: "button", class: "gas-dr-cella", dataset: { id }, title: o ? titoloOggetto(o) : id, "aria-label": o ? titoloOggetto(o) : id,
      onclick: () => {
        const r = DIARIO[id] || {};
        if (!r.v) segnaDiario(id, "v"); else if (!r.f) segnaDiario(id, "f"); else { delete DIARIO[id]; salvaDiario(); }
      } }, String(i));
    b._nome = o ? titoloOggetto(o) : id;
    griglia.appendChild(b);
  }
  const esporta = el("button", { type: "button", class: "gas-btn gas-btn--chiaro gas-btn--mini", onclick: () => {
    const righe = [t("dr_csv_testa")].concat(Object.entries(DIARIO).map(([id, r]) => { const o = trovaOggetto(id); return [id, (o && nomeOggetto(o)) || "", r.v || "", r.f || ""].map(x => String(x).replace(/;/g, ",")).join(";"); }));
    scaricaTesto("﻿" + righe.join("\r\n") + "\r\n", t("dr_csv_nome"), "text/csv;charset=utf-8");
  } }, icona("esporta"), " ", t("dr_esporta"));
  pannello.append(
    scheda(t("dr_titolo"), el("p", { class: "gas-nota" }, t("dr_n")), boxAccount("diario", true), conta, lista, el("div", { class: "gas-riga-bottoni" }, esporta)),
    scheda(t("dr_messier"), el("p", { class: "gas-nota" }, t("dr_messier_n")), progresso, progTesto,
      el("p", { class: "gas-dr-legenda" }, el("i", { class: "v" }), " ", t("dr_legenda_v"), "  ", el("i", { class: "f" }), " ", t("dr_legenda_f")), griglia));
  _disegnaDiario = disegna;
  DIARIO_UI.add(disegna);
  disegna();
}
Object.assign(TESTI.it, {
  og_scheda: "Scheda completa", og_chiudi: "Chiudi", og_foto: "Foto", og_licenza: "licenza", og_commons: "Wikimedia Commons",
  og_dss: "Foto: Digitized Sky Survey (DSS2, STScI/NASA) tramite hips2fits (CDS)",
  og_opacita: "Opacità di Lynds", og_opacita_n: "da 1 a 6: più è alta, più è scura",
  og_tipo: "Tipo", og_cost: "Costellazione", og_mag: "Magnitudine", og_dim: "Dimensioni", og_dist: "Distanza", og_coord: "Coordinate (J2000)",
  og_sb: "Luminosità superficiale", og_migliore: "Periodo migliore", og_luna_x: "{x} volte la Luna piena", og_al: "anni luce", og_mil_al: "milioni di anni luce",
  og_mld_al: "miliardi di anni luce", og_stanotte: "Stanotte {l_da}", og_alto: "Più alto alle {o}, a {h}°", og_sopra: "sopra {h}° per {d}",
  og_mai: "Stanotte resta sotto {h}°: guarda il periodo migliore qui sotto.", og_anno: "Durante l'anno",
  og_anno_n: "Ore di buio con l'oggetto sopra {h}° {l_da}, a metà di ogni mese.", og_migliore_n: "Il giorno in cui è più alto a mezzanotte: {d} circa.",
  og_wiki: "Da Wikipedia", og_wiki_lic: "testo con licenza CC BY-SA", og_wiki_leggi: "Leggi tutto su Wikipedia ↗", og_wiki_carica: "Carico la descrizione…",
  og_telescopio: "Nel tuo telescopio", og_vicini: "Vicini nel cielo", og_approfondisci: "Approfondisci", og_inquadra: "Apri nel Campo inquadrato",
  og_link: "Copia il link della scheda", og_consigli: "Filtri e tempo di posa per stanotte",
  og_crediti_lista: "Foto degli oggetti: Wikimedia Commons (autore e licenza nella scheda di ogni oggetto) e Digitized Sky Survey (STScI/NASA, CDS).",
});
Object.assign(TESTI.de, {
  og_scheda: "Vollständiger Steckbrief", og_chiudi: "Schließen", og_foto: "Foto", og_licenza: "Lizenz", og_commons: "Wikimedia Commons",
  og_dss: "Foto: Digitized Sky Survey (DSS2, STScI/NASA) über hips2fits (CDS)",
  og_opacita: "Lynds-Opazität", og_opacita_n: "von 1 bis 6: je höher, desto dunkler",
  og_tipo: "Typ", og_cost: "Sternbild", og_mag: "Helligkeit", og_dim: "Ausdehnung", og_dist: "Entfernung", og_coord: "Koordinaten (J2000)",
  og_sb: "Flächenhelligkeit", og_migliore: "Beste Zeit", og_luna_x: "{x}-mal so groß wie der Vollmond", og_al: "Lichtjahre", og_mil_al: "Millionen Lichtjahre",
  og_mld_al: "Milliarden Lichtjahre", og_stanotte: "Heute Nacht {l_a}", og_alto: "Am höchsten um {o} Uhr, {h}°", og_sopra: "über {h}° für {d}",
  og_mai: "Bleibt heute Nacht unter {h}°: Die beste Zeit finden Sie unten.", og_anno: "Im Laufe des Jahres",
  og_anno_n: "Dunkle Stunden mit dem Objekt über {h}° {l_a}, jeweils zur Monatsmitte.", og_migliore_n: "Der Tag, an dem es um Mitternacht am höchsten steht: etwa {d}.",
  og_wiki: "Aus Wikipedia", og_wiki_lic: "Text unter der Lizenz CC BY-SA", og_wiki_leggi: "Weiterlesen auf Wikipedia ↗", og_wiki_carica: "Beschreibung wird geladen…",
  og_telescopio: "In Ihrem Teleskop", og_vicini: "In der Nähe am Himmel", og_approfondisci: "Mehr erfahren", og_inquadra: "Im Bildfeld öffnen",
  og_link: "Link zum Steckbrief kopieren", og_consigli: "Filter und Belichtungszeit für heute Nacht",
  og_crediti_lista: "Fotos der Objekte: Wikimedia Commons (Autor und Lizenz im Steckbrief jedes Objekts) und Digitized Sky Survey (STScI/NASA, CDS).",
});
Object.assign(TESTI.es, {
  og_scheda: "Ficha completa", og_chiudi: "Cerrar", og_foto: "Foto", og_licenza: "licencia", og_commons: "Wikimedia Commons",
  og_dss: "Foto: Digitized Sky Survey (DSS2, STScI/NASA) mediante hips2fits (CDS)",
  og_opacita: "Opacidad de Lynds", og_opacita_n: "de 1 a 6: cuanto más alta, más oscura",
  og_tipo: "Tipo", og_cost: "Constelación", og_mag: "Magnitud", og_dim: "Tamaño", og_dist: "Distancia", og_coord: "Coordenadas (J2000)",
  og_sb: "Brillo superficial", og_migliore: "Mejor época", og_luna_x: "{x} veces la Luna llena", og_al: "años luz", og_mil_al: "millones de años luz",
  og_mld_al: "miles de millones de años luz", og_stanotte: "Esta noche {l_da}", og_alto: "Más alto a las {o}, a {h}°", og_sopra: "por encima de {h}° durante {d}",
  og_mai: "Esta noche se queda por debajo de {h}°: mira abajo la mejor época.", og_anno: "A lo largo del año",
  og_anno_n: "Horas de oscuridad con el objeto por encima de {h}° {l_da}, a mitad de cada mes.", og_migliore_n: "Día en que está más alto a medianoche: hacia el {d}.",
  og_wiki: "De Wikipedia", og_wiki_lic: "texto con licencia CC BY-SA", og_wiki_leggi: "Leer más en Wikipedia ↗", og_wiki_carica: "Cargando la descripción…",
  og_telescopio: "En tu telescopio", og_vicini: "Cerca en el cielo", og_approfondisci: "Saber más", og_inquadra: "Abrir en Campo de visión",
  og_link: "Copiar el enlace de la ficha", og_consigli: "Filtros y tiempo de exposición para esta noche",
  og_crediti_lista: "Fotos de los objetos: Wikimedia Commons (autor y licencia en la ficha de cada objeto) y Digitized Sky Survey (STScI/NASA, CDS).",
});
Object.assign(TESTI.en, {
  og_scheda: "Full profile", og_chiudi: "Close", og_foto: "Photo", og_licenza: "licence", og_commons: "Wikimedia Commons",
  og_dss: "Photo: Digitized Sky Survey (DSS2, STScI/NASA) via hips2fits (CDS)",
  og_opacita: "Lynds opacity", og_opacita_n: "1 to 6: the higher, the darker",
  og_tipo: "Type", og_cost: "Constellation", og_mag: "Magnitude", og_dim: "Size", og_dist: "Distance", og_coord: "Coordinates (J2000)",
  og_sb: "Surface brightness", og_migliore: "Best time", og_luna_x: "{x} times the full Moon", og_al: "light years", og_mil_al: "million light years",
  og_mld_al: "billion light years", og_stanotte: "Tonight {l_da}", og_alto: "Highest at {o} ({h}°)", og_sopra: "above {h}° for {d}",
  og_mai: "Tonight it stays below {h}°: see the best time below.", og_anno: "Through the year",
  og_anno_n: "Dark hours with the object above {h}° as seen {l_da}, in the middle of each month.", og_migliore_n: "The day it's highest at midnight: around {d}.",
  og_wiki: "From Wikipedia", og_wiki_lic: "text licensed CC BY-SA", og_wiki_leggi: "Read more on Wikipedia ↗", og_wiki_carica: "Loading the description…",
  og_telescopio: "In your telescope", og_vicini: "Nearby in the sky", og_approfondisci: "Learn more", og_inquadra: "Open in Field of view",
  og_link: "Copy the link to this profile", og_consigli: "Filters and exposure time for tonight",
  og_crediti_lista: "Object photos: Wikimedia Commons (author and licence in each object's profile) and Digitized Sky Survey (STScI/NASA, CDS).",
});
let _fotoOggetti = null;
function caricaFotoOggetti() {
  const url = RADICE && RADICE.dataset.fotoOggetti;
  if (!_fotoOggetti) _fotoOggetti = (url ? fetch(url).then(r => r.ok ? r.json() : {}).then(j => j.o || {}) : Promise.resolve({})).catch(() => ({}));
  return _fotoOggetti;
}
const COMMONS = "https://upload.wikimedia.org/wikipedia/commons/";
const MISURE_COMMONS = [120, 250, 330, 500, 960, 1280, 1920];
function urlFotoCommons(e, larga) {
  const n = encodeURIComponent(e.f.slice(5)), w = MISURE_COMMONS.find(x => x >= larga) || 1920;
  return w >= e.w ? COMMONS + e.f.slice(0, 5) + n : `${COMMONS}thumb/${e.f.slice(0, 5)}${n}/${w}px-${n}`;
}
const paginaCommons = e => "https://commons.wikimedia.org/wiki/File:" + encodeURIComponent(e.f.slice(5));
function urlLicenza(l) {
  const m = /^CC BY(-SA)? (\d\.\d)(?: (\w+))?$/i.exec(l || "");
  if (m) return `https://creativecommons.org/licenses/${m[1] ? "by-sa" : "by"}/${m[2]}/${m[3] ? m[3].toLowerCase() + "/" : ""}`;
  return /^CC0/i.test(l || "") ? "https://creativecommons.org/publicdomain/zero/1.0/" : null;
}
const lattoDss = o => clamp(misuraOggetto(o) / 60 * 1.8, 0.1, 4);
function miniaturaOggetto(o, px) {
  const ico = icona(DIFFUSI.has(o.t) ? "campo" : "stanotte");
  const box = el("span", { class: "gas-ogg-mini", "aria-hidden": "true" }, ico);
  caricaFotoOggetti().then(F => {
    const e = F[o.id];
    let src = null, titolo = "";
    if (e && e.f) { src = urlFotoCommons(e, px * 2); titolo = `${t("og_foto")}: ${e.a} · ${e.l}`; }
    else if (FOTO_DSS && o.ra != null && !cdsGiu()) { src = urlCielo(o.ra, o.dec, lattoDss(o), px * 2, px * 2); titolo = "DSS2 (STScI/NASA, CDS)"; }
    if (!src) return;
    const img = el("img", { src, alt: "", loading: "lazy", decoding: "async", width: px, height: px, title: titolo });
    img.addEventListener("error", () => { if (!(e && e.f)) segnaCdsGiu(); img.remove(); });
    img.addEventListener("load", () => { box.classList.add("ok"); ico.remove(); });
    box.appendChild(img);
  });
  return box;
}
function distanzaTesto(al) {
  if (al >= 1e9) return `${num(al / 1e9, 1)} ${t("og_mld_al")}`;
  if (al >= 1e6) return `${num(al / 1e6, al >= 1e7 ? 0 : 1)} ${t("og_mil_al")}`;
  return `${num(al >= 1000 ? Math.round(al / 10) * 10 : Math.round(al))} ${t("og_al")}`;
}
function luminositaSuperficiale(o) {
  if (o.mag == null || !o.a || !DIFFUSI.has(o.t)) return null;
  return o.mag + 2.5 * Math.log10(Math.PI / 4 * (o.a * 60) * ((o.b || o.a) * 60));
}
function dataMigliore(o) {
  const anno = new Date().getFullYear();
  let meglio = null;
  for (let g = 0; g < 366; g += 2) {
    const d = new Date(anno, 0, 1 + g), s = Astro.sole(Astro.jd(d));
    const diff = Math.abs(((s.ra + 180 - o.ra) % 360 + 540) % 360 - 180);
    if (!meglio || diff < meglio.diff) meglio = { diff, d };
  }
  return meglio.d;
}
const _anno = new Map();
function oreAnno(o, lat, lon, hmin) {
  const k = `${o.id}|${lat}|${lon}|${hmin}`;
  if (_anno.has(k)) return _anno.get(k);
  const anno = new Date().getFullYear(), ore = [];
  for (let m = 0; m < 12; m++) {
    const nt = Astro.notte(new Date(anno, m, 15, 12), lat, lon, 20), c = Astro.curvaOggetto(nt, o.ra, o.dec);
    let n = 0;
    for (const i of nt.buio) if (c.h[i] >= hmin) n++;
    ore.push(n * nt.passo / 60);
  }
  _anno.set(k, ore);
  return ore;
}
function graficoAnno(ore, migliore) {
  const W = 640, H = 200, sx = 30, sy = 10, gw = W - sx - 6, gh = H - sy - 30, max = Math.max(8, ...ore);
  const g = sv("svg", { viewBox: `0 0 ${W} ${H}`, class: "gas-og-anno", role: "img", "aria-label": t("og_anno") });
  for (const h of [0, 4, 8, 12].filter(h => h <= max)) {
    const y = sy + gh - h / max * gh;
    g.appendChild(sv("line", { x1: sx, y1: y, x2: sx + gw, y2: y, class: "gas-gr-griglia" }));
    g.appendChild(sv("text", { x: sx - 6, y: y + 4, "text-anchor": "end", class: "gas-gr-testo", text: h + "h" }));
  }
  const bw = gw / 12;
  ore.forEach((h, m) => {
    const alto = h / max * gh, x = sx + m * bw + bw * 0.16;
    g.appendChild(sv("rect", { x, y: sy + gh - alto, width: bw * 0.68, height: Math.max(alto, 1.5), rx: 4, class: "gas-og-barra" + (m === migliore ? " on" : "") }));
    g.appendChild(sv("text", { x: x + bw * 0.34, y: H - 10, "text-anchor": "middle", class: "gas-gr-testo" + (m === migliore ? " on" : ""),
      text: new Date(2026, m, 1).toLocaleDateString(LOCALE, { month: "short" }).replace(".", "") }));
  });
  return g;
}
const _wiki = new Map();
function riassuntoWiki(e) {
  const wp = e && e.wp;
  if (!wp) return Promise.resolve(null);
  const titolo = l => (wp[l] === "=" ? wp.en : wp[l]);
  const chiave = JSON.stringify(wp);
  if (_wiki.has(chiave)) return _wiki.get(chiave);
  const p = (async () => {
    for (const l of [...new Set([LINGUA, "en"])]) {
      const tt = titolo(l);
      if (!tt) continue;
      try {
        const r = await fetch(`https://${l}.wikipedia.org/api/rest_v1/page/summary/${encodeURIComponent(tt.replace(/ /g, "_"))}`);
        if (!r.ok) continue;
        const j = await r.json();
        if (j.type === "disambiguation" || !j.extract) continue;
        return { testo: j.extract, url: (j.content_urls && j.content_urls.desktop && j.content_urls.desktop.page) || `https://${l}.wikipedia.org/wiki/${encodeURIComponent(tt)}`, lingua: l };
      } catch (err) {   }
    }
    return null;
  })();
  _wiki.set(chiave, p);
  return p;
}
let PAGINA_OGG = null;
function chiudiOggetto(soloTogli) {
  if (!PAGINA_OGG) return;
  const spinta = PAGINA_OGG._spinta, da = PAGINA_OGG._da;
  PAGINA_OGG.remove(); PAGINA_OGG = null;
  document.documentElement.classList.remove("gas-og-su");
  if (da && da.isConnected && !/^(INPUT|TEXTAREA|SELECT)$/.test(da.tagName)) try { da.focus({ preventScroll: true }); } catch (e) {   }
  if (soloTogli) return;
  if (spinta) history.back();
  else try { history.replaceState(null, "", location.pathname + location.search + (schedaAttiva && schedaAttiva !== "home" ? "#" + schedaAttiva : "")); } catch (e) {   }
}
function apriOggetto(id, daHash) {
  const o = trovaOggetto(id);
  if (!o || o.corpo) return;
  let spinta = false;
  const att = document.activeElement;
  const da = PAGINA_OGG ? PAGINA_OGG._da : (att && att !== document.body ? att : null);
  if (!daHash) try {
    if (PAGINA_OGG) { history.replaceState({ gasOgg: o.id }, "", "#oggetto?" + encodeURIComponent(o.id)); spinta = !!PAGINA_OGG._spinta; }
    else { history.pushState({ gasOgg: o.id }, "", "#oggetto?" + encodeURIComponent(o.id)); spinta = true; }
  } catch (e) {   }
  if (PAGINA_OGG) { spinta = spinta || PAGINA_OGG._spinta; PAGINA_OGG.remove(); }
  const box = el("div", { class: "gas-og-box gas", tabindex: "-1" });
  const fondo = el("div", { class: "gas-og", role: "dialog", "aria-modal": "true", "aria-label": titoloOggetto(o) }, box);
  fondo._spinta = spinta; fondo._da = da;
  fondo.addEventListener("click", e => { if (e.target === fondo) chiudiOggetto(); });
  const sf = document.getElementById("gas-sfondo");
  if (sf && sf.classList.contains("gas-rosso")) fondo.classList.add("gas-og--rosso");
  if (sf && sf.classList.contains("gas-chiaro")) fondo.classList.add("gas-chiaro");
  if (sf && sf.classList.contains("gas-grande")) fondo.classList.add("gas-grande");
  document.body.appendChild(fondo);
  document.documentElement.classList.add("gas-og-su");
  PAGINA_OGG = fondo;
  disegnaOggetto(box, o);
  box.focus({ preventScroll: true });
  fondo.scrollTop = 0;
}
document.addEventListener("keydown", e => { if (e.key === "Escape" && PAGINA_OGG) chiudiOggetto(); });
function disegnaOggetto(box, o) {
  const nome = nomeOggetto(o), sigle = [o.id, ...o.alias.filter(a => a !== o.id)].slice(0, 6);
  const foto = el("div", { class: "gas-og-foto" }), credito = el("p", { class: "gas-og-credito" });
  const eroe = el("header", { class: "gas-og-eroe" }, foto,
    el("div", { class: "gas-og-titolo" },
      el("small", null, [t("tipo_" + o.t), o.c ? nomeCostellazione(o.c) : null].filter(Boolean).join(" · ")),
      el("h2", null, nome || o.id),
      el("p", { class: "gas-og-sigle" }, sigle.map(s => el("span", null, s)))));
  const chiudi = el("button", { type: "button", class: "gas-og-chiudi", "aria-label": t("og_chiudi"), title: t("og_chiudi"), onclick: () => chiudiOggetto() }, icona("chiudi"));
  const c = calcolaNotte(), nt = c.nt, r = rigaDi(c, o), { lat, lon } = NOTTE.luogo;
  const dati = el("div", { class: "gas-og-dati" });
  const dato = (etich, valore, nota) => dati.appendChild(el("div", { class: "gas-og-dato" }, el("small", null, etich), el("b", null, valore), nota ? el("span", null, nota) : null));
  if (o.mag != null) dato(t("og_mag"), num(o.mag, 1));
  if (o.op) dato(t("og_opacita"), `${num(o.op)} / 6`, t("og_opacita_n"));
  const primi = x => `${num(x, x >= 10 ? 0 : 1)}′`;
  if (o.a) dato(t("og_dim"), o.b ? `${primi(o.a)} × ${primi(o.b)}` : primi(o.a), o.a >= 12 ? t("og_luna_x", { x: num(o.a / 31, o.a >= 62 ? 0 : 1) }) : null);
  const sb = luminositaSuperficiale(o);
  if (sb) dato(t("og_sb"), `${num(sb, 1)} mag/″²`);
  const migliore = dataMigliore(o);
  dato(t("og_migliore"), migliore.toLocaleDateString(LOCALE, { day: "numeric", month: "long" }));
  const bino = binocolo(NOTTE.bino) || binocolo("10x50"), vb = votoBinocolo(o, bino, limiteBinocolo(bino));
  dato(t("og_binocolo", { b: nomeBinocolo(bino) }), t("bi_v" + vb));
  if (o.c) dato(t("og_cost"), nomeCostellazione(o.c));
  dato(t("og_coord"), `${raHms(o.ra)}`, decDms(o.dec));
  const stanotte = el("section", { class: "gas-og-sez" }, el("h3", null, t("og_stanotte", luogoFrasi())));
  if (r) {
    const ore = oreSopra(r, nt, NOTTE.hmin), quando = r.iMax >= 0 ? Astro.data(nt.tempi[r.iMax]) : null;
    stanotte.append(el("p", { class: "gas-og-riga" }, r.hMax >= NOTTE.hmin
      ? [t("og_alto", { o: ora(quando), h: num(r.hMax) }), " · ", t("og_sopra", { h: NOTTE.hmin, d: durata(ore) })] : t("og_mai", { h: NOTTE.hmin })),
    graficoAltezza(r, nt), bottoneVistaLuogo(o.id, "gas-vl-apri--og"));
  }
  const annoBox = el("div", { class: "gas-og-anno-box" });
  const anno = el("section", { class: "gas-og-sez" }, el("h3", null, t("og_anno")),
    el("p", { class: "gas-nota" }, t("og_anno_n", Object.assign({ h: NOTTE.hmin }, luogoFrasi()))), annoBox,
    el("p", { class: "gas-og-riga" }, t("og_migliore_n", { d: migliore.toLocaleDateString(LOCALE, { day: "numeric", month: "long" }) })));
  setTimeout(() => { if (box.isConnected) annoBox.appendChild(graficoAnno(oreAnno(o, lat, lon, NOTTE.hmin), migliore.getMonth())); }, 30);
  const wiki = el("section", { class: "gas-og-sez gas-og-wiki" }, el("p", { class: "gas-muto" }, t("og_wiki_carica")));
  let consigli = null;
  if (r) {
    const cf = consiglioFiltro(o, contestoFiltro(o, lunaOggetto(nt, r.h, r.sep)));
    if (cf) consigli = el("section", { class: "gas-og-sez" }, el("h3", null, t("og_consigli")), spiegaFiltro(cf), CAMPO.modo === "foto" ? boxTempoPosa(o, cf.luna) : null);
  }
  const tela = el("canvas", { class: "gas-anteprima-tela", role: "img", "aria-label": titoloOggetto(o) });
  const fotoVera = FOTO_DSS ? el("img", { class: "gas-anteprima-foto", alt: "", decoding: "async" }) : null;
  const telescopio = el("section", { class: "gas-og-sez" }, el("h3", null, t("og_telescopio")),
    el("div", { class: "gas-anteprima" }, fotoVera, tela),
    azioniOggetto(o, [bottoneInquadra(o, true), typeof bottoneVista === "function" ? bottoneVista(o) : null, bottoneServe(o)]));
  const vicini = el("div", { class: "gas-og-vicini" });
  const viciniSez = el("section", { class: "gas-og-sez", hidden: true }, el("h3", null, t("og_vicini")), vicini);
  const link = el("div", { class: "gas-og-link" });
  const approfondisci = el("section", { class: "gas-og-sez" }, el("h3", null, t("og_approfondisci")), link,
    el("button", { type: "button", class: "gas-btn gas-btn--chiaro gas-btn--mini", onclick: e => copia((SR_IN_CAMPO ? location.origin + srBase() + "pages/" + srHandle() : location.origin + location.pathname) + "#oggetto?" + encodeURIComponent(o.id), e.currentTarget) },
      icona("link"), " ", t("og_link")));
  const esterno = (testo, href) => link.appendChild(el("a", { class: "gas-og-chip", href, target: "_blank", rel: "noopener" }, testo, " ↗"));
  esterno("SIMBAD", "https://simbad.cds.unistra.fr/simbad/sim-id?Ident=" + encodeURIComponent(o.id));
  esterno("Aladin Lite", `https://aladin.cds.unistra.fr/AladinLite/?target=${encodeURIComponent(o.id)}&fov=${num(lattoDss(o), 2).replace(",", ".")}&survey=CDS%2FP%2FDSS2%2Fcolor`);
  esterno("Stellarium Web", "https://stellarium-web.org/skysource/" + encodeURIComponent(o.id.replace(/\s+/g, "")));
  esterno("AstroBin", "https://www.astrobin.com/search/?q=" + encodeURIComponent(o.id));
  box.append(chiudi, eroe, credito,
    el("div", { class: "gas-og-corpo" },
      el("div", { class: "gas-og-principale" }, wiki, stanotte, anno, consigli, viciniSez),
      el("aside", { class: "gas-og-lato" }, dati, telescopio, approfondisci)));
  Mappa.anteprima(tela, o, campoAttuale(), fotoVera).catch(e => console.error("strumenti, anteprima:", e));
  caricaFotoOggetti().then(F => {
    if (!box.isConnected) return;
    const e = F[o.id];
    if (e && e.f) {
      const img = el("img", { src: urlFotoCommons(e, 960), alt: titoloOggetto(o), decoding: "async",
        srcset: [500, 960, 1280, 1920].filter(w => w <= Math.max(e.w, 500)).map(w => `${urlFotoCommons(e, w)} ${Math.min(w, e.w)}w`).join(", "), sizes: "(min-width: 1100px) 1100px, 100vw" });
      img.addEventListener("load", () => foto.classList.add("ok"));
      foto.appendChild(img);
      const lu = urlLicenza(e.l);
      credito.append(`${t("og_foto")}: `, el("a", { href: paginaCommons(e), target: "_blank", rel: "noopener" }, e.a), " · ",
        lu ? el("a", { href: lu, target: "_blank", rel: "noopener" }, e.l) : e.l, " · ", t("og_commons"));
    } else if (FOTO_DSS) {
      const img = el("img", { alt: titoloOggetto(o), decoding: "async" });
      foto.appendChild(img);
      fotoCielo(img, { ra: o.ra, dec: o.dec, fov: lattoDss(o) * 1.4, W: 1280, H: 720 }, () => foto.classList.add("ok"));
      credito.append(t("og_dss"));
    }
    if (e && e.d) { dato(t("og_dist"), distanzaTesto(e.d)); dati.insertBefore(dati.lastChild, dati.children[Math.min(2, dati.children.length - 1)]); }
    riassuntoWiki(e).then(w => {
      svuota(wiki);
      if (!w) { wiki.remove(); return; }
      wiki.append(el("h3", null, t("og_wiki")), el("p", { class: "gas-og-estratto", lang: w.lingua }, w.testo),
        el("p", { class: "gas-og-fonte" }, el("a", { href: w.url, target: "_blank", rel: "noopener" }, t("og_wiki_leggi")), " · ", t("og_wiki_lic")));
      esterno("Wikipedia", w.url);
      link.prepend(link.lastChild);
    });
    const cand = [];
    for (const x of DATI.oggetti) {
      if (x === o || !F[x.id] || !F[x.id].f || x.ra == null) continue;
      const s = Astro.separazione(o.ra, o.dec, x.ra, x.dec);
      if (s > 7 || s < 0.05) continue;
      cand.push({ x, s, p: (x.top ? 3 : 0) + (x.messier || x.caldwell ? 2 : 0) + (x.nomi ? 1 : 0) - s / 7 });
    }
    cand.sort((a, b) => b.p - a.p);
    for (const { x } of cand.slice(0, 10)) {
      vicini.appendChild(el("button", { type: "button", class: "gas-og-vicino", onclick: () => apriOggetto(x.id) },
        miniaturaOggetto(x, 120), el("b", null, x.id), el("small", null, nomeOggetto(x) || t("tipo_" + x.t))));
    }
    viciniSez.hidden = !vicini.children.length;
  });
}
function bottoneScheda(o, chiaro) {
  return el("button", { type: "button", class: "gas-btn gas-btn--mini" + (chiaro ? " gas-btn--chiaro" : "") + " gas-og-apri", onclick: e => { e.stopPropagation(); apriOggetto(o.id); } },
    "★ ", t("og_scheda"));
}
function bottoneInquadra(o, primario) {
  return el("button", { type: "button", class: "gas-btn" + (primario ? "" : " gas-btn--chiaro"), onclick: e => {
    e.stopPropagation();
    CAMPO.ogg = o.id; CENTRO = null; SPOSTA = [0, 0]; ZOOM = 1; salvaCampo();
    if (PAGINA_OGG) chiudiOggetto(true);
    vai("campo");
  } }, icona("campo"), " ", t("inquadra"));
}
function bottoneServe(o) {
  return el("button", { type: "button", class: "gas-btn gas-btn--chiaro", onclick: e => {
    e.stopPropagation();
    CAMPO.ogg = o.id; CENTRO = null; SPOSTA = [0, 0]; ZOOM = 1; CAMPO.modo = "foto"; salvaCampo();
    if (PAGINA_OGG) chiudiOggetto(true);
    vai("campo");
    setTimeout(() => { const c = $(".gas-consigli"); if (c) c.scrollIntoView({ behavior: "smooth", block: "start" }); }, 400);
  } }, icona("carrello"), " ", t("cm_cosa_serve"));
}
function azioniOggetto(o, grandi) {
  return el("div", { class: "gas-az" },
    el("div", { class: "gas-az-grandi" }, grandi.filter(Boolean)),
    el("div", { class: "gas-az-segni" },
      typeof bottonePiano === "function" ? bottonePiano(o.id) : null,
      typeof bottoniDiario === "function" ? bottoniDiario(o.id) : null));
}
Object.assign(TESTI.it, {
  bi_strumento: "Strumento", bi_tutti: "Telescopio (tutti gli oggetti)", bi_bino: "Binocolo {b}",
  bi_nota: "Col binocolo {b}: campo di {c}°, stelle fino alla magnitudine {m} dal tuo cielo. Restano solo gli oggetti che si vedono.",
  bi_facile: "facile col binocolo", bi_visibile: "visibile col binocolo", bi_no: "troppo debole per il binocolo", og_binocolo: "Col binocolo {b}", bi_v2: "Facile", bi_v1: "Si vede", bi_v0: "Troppo debole",
});
Object.assign(TESTI.de, {
  bi_strumento: "Instrument", bi_tutti: "Teleskop (alle Objekte)", bi_bino: "Fernglas {b}",
  bi_nota: "Mit dem Fernglas {b}: Gesichtsfeld {c}°, Sterne bis Größe {m} unter Ihrem Himmel. Es bleiben nur die sichtbaren Objekte.",
  bi_facile: "leicht im Fernglas", bi_visibile: "im Fernglas sichtbar", bi_no: "zu schwach für das Fernglas", og_binocolo: "Mit dem Fernglas {b}", bi_v2: "Leicht", bi_v1: "Sichtbar", bi_v0: "Zu schwach",
});
Object.assign(TESTI.es, {
  bi_strumento: "Instrumento", bi_tutti: "Telescopio (todos los objetos)", bi_bino: "Prismáticos {b}",
  bi_nota: "Con prismáticos {b}: campo de {c}°, estrellas hasta la magnitud {m} con tu cielo. Quedan solo los objetos que se ven.",
  bi_facile: "fácil con prismáticos", bi_visibile: "visible con prismáticos", bi_no: "demasiado débil para prismáticos", og_binocolo: "Con prismáticos {b}", bi_v2: "Fácil", bi_v1: "Se ve", bi_v0: "Demasiado débil",
});
Object.assign(TESTI.en, {
  bi_strumento: "Instrument", bi_tutti: "Telescope (all objects)", bi_bino: "Binoculars {b}",
  bi_nota: "With {b} binoculars: {c}° field, stars down to magnitude {m} under your sky. Only the objects you can see are left.",
  bi_facile: "easy in binoculars", bi_visibile: "visible in binoculars", bi_no: "too faint for binoculars", og_binocolo: "With {b} binoculars", bi_v2: "Easy", bi_v1: "Visible", bi_v0: "Too faint",
});
const BINOCOLI = [["7x50", 7, 50, 7.3], ["10x50", 10, 50, 6.5], ["12x60", 12, 60, 5.2], ["15x70", 15, 70, 4.4], ["20x80", 20, 80, 3.2], ["25x100", 25, 100, 2.7]];
const binocolo = k => BINOCOLI.find(b => b[0] === k) || null;
const nomeBinocolo = b => b[0].replace("x", "×");
const limiteBinocolo = b => limiteOcchio() + 5 * Math.log10(b[2] / 7) - 0.5;
function votoBinocolo(o, b, lm) {
  if (!o || o.mag == null) return 0;
  const tipo = o.t, misura = misuraOggetto(o);
  let margine;
  if (tipo === "dn") return misura >= 30 && sqmLuogo() >= 20.8 ? 1 : 0;
  if (["oc", "sc", "gc"].includes(tipo)) margine = lm - 1 - o.mag;
  else if (tipo === "pn") margine = lm - (misura >= 1 ? 2 : 1.2) - o.mag;
  else if (tipo === "ds") margine = lm - o.mag;
  else {
    const sb = typeof luminositaSuperficiale === "function" ? luminositaSuperficiale(o) : null;
    margine = lm - 2.2 - o.mag - (sb ? Math.max(0, sb - 22) * 0.6 : 0);
  }
  if (misura > b[3] * 60 * 1.3) margine -= 0.5;
  return margine >= 1.5 ? 2 : margine >= 0 ? 1 : 0;
}
Object.assign(GUIDA.it, { g_stanotte: "Questa è la scheda Cosa vedere. In alto, nei riquadri Dove, Quando, Setup e Oggetti, scegli il luogo, la notte, la tua attrezzatura e quali oggetti mostrare. Sotto ci sono gli orari del buio e la Luna, poi gli oggetti migliori della notte in classifica: toccando + Piano li aggiungi al tuo piano della notte. Per un oggetto preciso scrivilo in Cerca un oggetto, per esempio M42 o Andromeda. Tocca un oggetto per vedere il grafico dell'altezza e l'anteprima, e premi Inquadralo nel campo per aprirlo nel Campo inquadrato. Nella riga sotto i riquadri scegli anche Pianeti; Meteore, comete e ISS; Il mio piano; e Posti bui, per trovare un cielo più buio vicino a te." });
Object.assign(GUIDA.de, { g_stanotte: "Das ist der Bereich Was sehen. Oben, in den Kacheln Wo, Wann, Setup und Objekte, wählen Sie den Ort, die Nacht, Ihre Ausrüstung und welche Objekte angezeigt werden. Darunter stehen die Zeiten der Dunkelheit und der Mond, dann die besten Objekte der Nacht in einer Rangliste: Mit Plus Plan fügen Sie sie Ihrem Plan der Nacht hinzu. Ein bestimmtes Objekt schreiben Sie in Objekt suchen, zum Beispiel M42 oder Andromeda. Tippen Sie auf ein Objekt für das Höhendiagramm und die Vorschau, und drücken Sie Im Bildfeld zeigen, um es im Bildfeld zu öffnen. In der Zeile unter den Kacheln wählen Sie außerdem Planeten; Meteore, Kometen und ISS; Mein Plan; und Dunkle Orte, um einen dunkleren Himmel in Ihrer Nähe zu finden." });
Object.assign(GUIDA.es, { g_stanotte: "Esta es la sección Qué ver. Arriba, en los recuadros Dónde, Cuándo, Equipo y Objetos, eliges el lugar, la noche, tu equipo y qué objetos mostrar. Debajo están los horarios de la oscuridad y la Luna, y luego los mejores objetos de la noche en clasificación: tocando Más Plan los añades a tu plan de la noche. Para un objeto concreto escríbelo en Buscar un objeto, por ejemplo M42 o Andrómeda. Toca un objeto para ver la gráfica de altura y la vista previa, y pulsa Encuádralo en el campo para abrirlo en el Campo de visión. En la fila bajo los recuadros eliges también Planetas; Meteoros, cometas e ISS; Mi plan; y Lugares oscuros, para encontrar un cielo más oscuro cerca de ti." });
Object.assign(GUIDA.en, { g_stanotte: "This is the What to see tab. At the top, in the Where, When, Setup and Objects boxes, you choose the location, the night, your equipment and which objects to show. Below are the hours of darkness and the Moon, then the night's best objects, ranked: tap Plus Plan to add them to your night plan. For a specific object, type it in Find an object, for example M42 or Andromeda. Tap an object to see its altitude chart and preview, and press Frame it to open it in Field of view. In the row under the boxes you can also pick Planets; Meteors, comets & ISS; My plan; and Dark sites, to find a darker sky near you." });
if (NAV4) {
  Object.assign(GUIDA.it, { g_stanotte: "Questa è la pagina Cosa vedere. In alto ci sono quattro riquadri: Dove, Quando, Setup e Oggetti. Toccane uno per cambiare il luogo, la notte, il telescopio e la camera, oppure quali oggetti mostrare, per esempio solo le galassie, col binocolo o solo la parte di cielo che vedi dal balcone; il bottone in fondo conferma e chiude. Sotto trovi gli orari della notte: il tramonto, l'inizio e la fine del buio, l'alba, la Luna e il buio del cielo del tuo luogo. Poi c'è la classifica degli oggetti migliori della notte. Per un oggetto preciso scrivilo in Cerca un oggetto, per esempio M42 o Andromeda. Tocca un oggetto per vedere il grafico dell'altezza, dove guardare e l'anteprima, e premi Inquadralo nel campo per aprirlo nel Campo inquadrato; con il bottone col segno più e la scritta Piano lo aggiungi al tuo piano della notte. La Luna e i pianeti, le meteore e le comete e il meteo hanno il loro strumento nella riga degli strumenti di Stanotte." });
  Object.assign(GUIDA.de, { g_stanotte: "Das ist die Seite Was sehen. Oben gibt es vier Kästen: Wo, Wann, Setup und Objekte. Tippen Sie auf einen Kasten, um den Ort, die Nacht, Teleskop und Kamera oder die angezeigten Objekte zu ändern, zum Beispiel nur Galaxien, mit dem Fernglas oder nur den Himmelsausschnitt, den Sie vom Balkon sehen; der Knopf unten bestätigt und schließt. Darunter stehen die Zeiten der Nacht: Sonnenuntergang, Beginn und Ende der Dunkelheit, Sonnenaufgang, der Mond und die Dunkelheit des Himmels an Ihrem Ort. Dann folgt die Rangliste der besten Objekte der Nacht. Ein bestimmtes Objekt schreiben Sie in Objekt suchen, zum Beispiel M42 oder Andromeda. Tippen Sie auf ein Objekt für das Höhendiagramm, die Blickrichtung und die Vorschau, und drücken Sie Im Bildfeld zeigen, um es im Bildfeld zu öffnen; mit plus Plan nehmen Sie es in Ihren Plan der Nacht auf. Mond und Planeten, Meteore und Kometen und das Wetter haben jeweils ein eigenes Werkzeug in der Werkzeugleiste von Heute Nacht." });
  Object.assign(GUIDA.es, { g_stanotte: "Esta es la página Qué ver. Arriba hay cuatro recuadros: Dónde, Cuándo, Equipo y Objetos. Toca uno para cambiar el lugar, la noche, el telescopio y la cámara, o qué objetos mostrar, por ejemplo solo galaxias, con prismáticos o solo la parte del cielo que ves desde el balcón; el botón de abajo confirma y cierra. Debajo están los horarios de la noche: la puesta de sol, el comienzo y el final de la oscuridad, la salida del sol, la Luna y la oscuridad del cielo de tu lugar. Luego viene la clasificación de los mejores objetos de la noche. Para un objeto concreto escríbelo en Buscar un objeto, por ejemplo M42 o Andrómeda. Toca un objeto para ver la gráfica de altura, hacia dónde mirar y la vista previa, y pulsa Encuádralo en el campo para abrirlo en el Campo de visión; con más Plan lo añades a tu plan de la noche. La Luna y los planetas, los meteoros y los cometas y el tiempo tienen su propia herramienta en la fila de herramientas de Esta noche." });
  Object.assign(GUIDA.en, { g_stanotte: "This is the What to see page. At the top there are four boxes: Where, When, Setup and Objects. Tap one to change the place, the night, the telescope and camera, or which objects to show, for example only galaxies, with binoculars or only the part of the sky you can see from your balcony; the button at the bottom confirms and closes. Below are the times of the night: sunset, the start and end of darkness, sunrise, the Moon and how dark the sky is where you are. Then comes the ranking of the night's best objects. For a specific object, type it in Find an object, for example M42 or Andromeda. Tap an object to see its altitude chart, where to look and the preview, and press Frame it to open it in the Field of view; with plus Plan you add it to your plan for the night. The Moon and planets, meteors and comets, and the weather each have their own tool in the Tonight tools row." });
}
Object.assign(TESTI.it, {
  ter_titolo: "Montagne e colline: l'orizzonte vero", ter_on: "Togli gli oggetti nascosti dietro montagne e colline",
  ter_sopra: "Altezza sopra il terreno (balcone, terrazza)", ter_calcola: "Calcola l'orizzonte del luogo", ter_ricalcola: "Ricalcola",
  ter_attendi: "Leggo le mappe di elevazione dei satelliti: ci vuole qualche secondo…", ter_errore: "Le mappe di elevazione non sono arrivate: riprova tra poco.",
  ter_pronto: "Orizzonte del luogo pronto: quota {q} m, più {s} m sopra il terreno. Le montagne arrivano fino a {m}° di altezza.",
  ter_altro_luogo: "L'orizzonte calcolato è di un altro luogo: ricalcolalo per questo.",
  ter_n: "Dal luogo scelto calcoliamo quanto sono alte montagne e colline in ogni direzione, dalle mappe di elevazione dei satelliti: nell'elenco restano gli oggetti che le superano.",
  ter_crediti: "Elevazione: Terrain Tiles (Mapzen, AWS Open Data) da SRTM, Copernicus EU-DEM, ETOPO1 e altre fonti.",
  ter_nota: "tolti quelli dietro le montagne",
  pano_titolo: "Dove sarà nel cielo stanotte", pano_utile: "visibile col buio", pano_nascosto: "nascosto o troppo basso", pano_luce: "cielo chiaro",
  pano_terreno: "montagne e colline", pano_limite: "altezza minima", pano_n: "Azimut (la direzione: 0° nord, 90° est, 180° sud, 270° ovest); ogni punto è un'ora.",
});
Object.assign(TESTI.de, {
  ter_titolo: "Berge und Hügel: der echte Horizont", ter_on: "Objekte hinter Bergen und Hügeln ausblenden",
  ter_sopra: "Höhe über dem Boden (Balkon, Terrasse)", ter_calcola: "Horizont des Ortes berechnen", ter_ricalcola: "Neu berechnen",
  ter_attendi: "Die Höhenkarten der Satelliten werden gelesen: Das dauert einige Sekunden…", ter_errore: "Die Höhenkarten konnten nicht geladen werden: Bitte gleich noch einmal versuchen.",
  ter_pronto: "Horizont des Ortes berechnet: Meereshöhe {q} m, plus {s} m über dem Boden. Die Berge reichen bis {m}° Höhe.",
  ter_altro_luogo: "Der berechnete Horizont gehört zu einem anderen Ort: für diesen neu berechnen.",
  ter_n: "Für den gewählten Ort berechnen wir aus den Höhenkarten der Satelliten, wie hoch Berge und Hügel in jeder Richtung sind: In der Liste bleiben die Objekte, die höher stehen.",
  ter_crediti: "Höhendaten: Terrain Tiles (Mapzen, AWS Open Data) aus SRTM, Copernicus EU-DEM, ETOPO1 und weiteren Quellen.",
  ter_nota: "ohne Objekte hinter den Bergen",
  pano_titolo: "Wo es heute Nacht am Himmel steht", pano_utile: "sichtbar bei Dunkelheit", pano_nascosto: "verdeckt oder zu tief", pano_luce: "heller Himmel",
  pano_terreno: "Berge und Hügel", pano_limite: "Mindesthöhe", pano_n: "Azimut ab Nord im Uhrzeigersinn; jeder Punkt ist eine Stunde.",
});
Object.assign(TESTI.es, {
  ter_titolo: "Montañas y colinas: el horizonte real", ter_on: "Quitar los objetos ocultos tras montañas y colinas",
  ter_sopra: "Altura sobre el suelo (balcón, terraza)", ter_calcola: "Calcular el horizonte del lugar", ter_ricalcola: "Recalcular",
  ter_attendi: "Leyendo los mapas de elevación de los satélites: tarda unos segundos…", ter_errore: "Los mapas de elevación no han llegado: inténtalo de nuevo en un momento.",
  ter_pronto: "Horizonte del lugar listo: altitud {q} m, más {s} m sobre el suelo. Las montañas llegan hasta {m}° de altura.",
  ter_altro_luogo: "El horizonte calculado es de otro lugar: recalcúlalo para este.",
  ter_n: "Desde el lugar elegido calculamos la altura de montañas y colinas en cada dirección con los mapas de elevación de los satélites: en la lista quedan los objetos que las superan.",
  ter_crediti: "Elevación: Terrain Tiles (Mapzen, AWS Open Data) de SRTM, Copernicus EU-DEM, ETOPO1 y otras fuentes.",
  ter_nota: "sin los que están tras las montañas",
  pano_titolo: "Dónde estará en el cielo esta noche", pano_utile: "visible con cielo oscuro", pano_nascosto: "oculto o demasiado bajo", pano_luce: "cielo claro",
  pano_terreno: "montañas y colinas", pano_limite: "altura mínima", pano_n: "Acimut desde el norte en sentido horario; cada punto es una hora.",
});
Object.assign(TESTI.en, {
  ter_titolo: "Mountains and hills: the real horizon", ter_on: "Hide objects behind mountains and hills",
  ter_sopra: "Height above ground (balcony, terrace)", ter_calcola: "Work out this place's horizon", ter_ricalcola: "Recalculate",
  ter_attendi: "Reading satellite elevation maps: this takes a few seconds…", ter_errore: "The elevation maps didn't arrive: try again in a moment.",
  ter_pronto: "Horizon ready: elevation {q} m, plus {s} m above ground. The mountains reach {m}° high.",
  ter_altro_luogo: "The horizon was worked out for another place: recalculate it for this one.",
  ter_n: "From the chosen place we work out how high mountains and hills are in every direction, from satellite elevation maps: the list keeps the objects that rise above them.",
  ter_crediti: "Elevation: Terrain Tiles (Mapzen, AWS Open Data) from SRTM, Copernicus EU-DEM, ETOPO1 and other sources.",
  ter_nota: "excluding those hidden by mountains",
  pano_titolo: "Where it will be in the sky tonight", pano_utile: "visible after dark", pano_nascosto: "hidden or too low", pano_luce: "bright sky",
  pano_terreno: "mountains and hills", pano_limite: "minimum altitude", pano_n: "Azimuth from north, clockwise; each dot is one hour.",
});
const _tasselliDem = new Map();
function tasselloDem(z, x, y) {
  const k = `${z}/${x}/${y}`;
  if (!_tasselliDem.has(k)) _tasselliDem.set(k, new Promise(ok => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => {
      try {
        const c = document.createElement("canvas");
        c.width = c.height = 256;
        const g = c.getContext("2d", { willReadFrequently: true });
        g.drawImage(img, 0, 0);
        ok(g.getImageData(0, 0, 256, 256).data);
      } catch (e) { ok(null); }
    };
    img.onerror = () => { _tasselliDem.delete(k); ok(null); };
    img.src = `https://s3.amazonaws.com/elevation-tiles-prod/terrarium/${z}/${x}/${y}.png`;
  }));
  return _tasselliDem.get(k);
}
function pxDem(lat, lon, z) {
  const n = 256 * 2 ** z, la = clamp(lat, -85, 85) * RAD;
  return [(lon + 180) / 360 * n, (1 - Math.log(Math.tan(la) + 1 / Math.cos(la)) / Math.PI) / 2 * n];
}
async function calcolaOrizzonte(lat, lon, sopra) {
  const R = 6371000, VICINO = 40000, LONTANO = 150000, Z_VICINO = 10, Z_LONTANO = 8;
  const dist = [];
  for (let d = 250; d <= LONTANO; d *= 1.03) dist.push(d);
  const cl = Math.cos(lat * RAD);
  const punto = (az, d) => [lat + d * Math.cos(az * RAD) / R * DEG, lon + d * Math.sin(az * RAD) / (R * cl) * DEG];
  const zoom = d => (d <= VICINO ? Z_VICINO : Z_LONTANO);
  const chiavi = new Set();
  const chiave = (la, lo, z) => { const [px, py] = pxDem(la, lo, z); return `${z}/${Math.floor(px / 256)}/${Math.floor(py / 256)}`; };
  chiavi.add(chiave(lat, lon, Z_VICINO));
  for (let az = 0; az < 360; az += 2) for (const d of dist) { const [la, lo] = punto(az, d); chiavi.add(chiave(la, lo, zoom(d))); }
  const T = new Map();
  await Promise.all([...chiavi].map(k => { const [z, x, y] = k.split("/").map(Number); return tasselloDem(z, x, y).then(v => T.set(k, v)); }));
  const pixel = (X, Y, z) => {
    const x = Math.floor(X / 256), y = Math.floor(Y / 256), d = T.get(`${z}/${x}/${y}`);
    if (!d) return null;
    const i = ((Y - y * 256) * 256 + (X - x * 256)) * 4;
    return d[i] * 256 + d[i + 1] + d[i + 2] / 256 - 32768;
  };
  const quota = (la, lo, z) => {
    const [px, py] = pxDem(la, lo, z), X = Math.floor(px - 0.5), Y = Math.floor(py - 0.5), fx = px - 0.5 - X, fy = py - 0.5 - Y;
    const a = pixel(X, Y, z), b = pixel(X + 1, Y, z), c = pixel(X, Y + 1, z), d = pixel(X + 1, Y + 1, z);
    if (a == null || b == null || c == null || d == null) return pixel(Math.floor(px), Math.floor(py), z);
    return (a * (1 - fx) + b * fx) * (1 - fy) + (c * (1 - fx) + d * fx) * fy;
  };
  const q0 = quota(lat, lon, Z_VICINO);
  if (q0 == null) throw new Error("mappe di elevazione assenti");
  const h0 = Math.max(q0, 0) + (sopra || 0) + 1.5;
  const p = [];
  for (let az = 0; az < 360; az++) {
    let m = -3;
    for (const d of dist) {
      const [la, lo] = punto(az, d), q = quota(la, lo, zoom(d));
      if (q == null) continue;
      const a = Math.atan2(Math.max(q, 0) - d * d / (2 * R) * (1 - 0.13) - h0, d) * DEG;
      if (a > m) m = a;
    }
    p.push(Math.round(m * 10));
  }
  return { quota: Math.round(q0), p, v: VERSIONE_TERRENO };
}
const VERSIONE_TERRENO = 2;
let _rifaTerreno = null;
function rifaiTerrenoVecchio() {
  const T = NOTTE.terreno;
  if (_rifaTerreno || !T || !Array.isArray(T.p) || T.v === VERSIONE_TERRENO || T.lat == null) return;
  _rifaTerreno = calcolaOrizzonte(T.lat, T.lon, T.sopra || 0).then(r => {
    if (NOTTE.terreno !== T) return;
    Object.assign(T, { quota: r.quota, p: r.p, v: r.v });
    salvaNotte();
  }).catch(e => { console.error("strumenti, orizzonte:", e); });
}
function terrenoAttivo() {
  const T = NOTTE.terreno, L = NOTTE.luogo;
  return !!(T && T.on && Array.isArray(T.p) && T.p.length === 360 && L && Math.abs(T.lat - L.lat) < 0.005 && Math.abs(T.lon - L.lon) < 0.005);
}
const terrenoDelLuogo = () => {
  const T = NOTTE.terreno, L = NOTTE.luogo, ok = !!(T && Array.isArray(T.p) && L && Math.abs(T.lat - L.lat) < 0.005 && Math.abs(T.lon - L.lon) < 0.005);
  if (ok && T.v !== VERSIONE_TERRENO) rifaiTerrenoVecchio();
  return ok;
};
const altTerreno = az => NOTTE.terreno.p[Math.round(((az % 360) + 360) % 360) % 360] / 10;
const dietroMontagne = (h, az) => terrenoAttivo() && h < altTerreno(az) + 0.5;
function boxTerreno(dopo) {
  const T = NOTTE.terreno || (NOTTE.terreno = { on: false, sopra: 0 });
  const stato = el("p", { class: "gas-nota gas-ter-stato" }), pano = el("div", { class: "gas-ter-pano" });
  const on = el("input", { type: "checkbox", checked: !!T.on });
  const sopra = campoNumero(t("ter_sopra"), T.sopra || 0, v => { if (v != null) T.sopra = clamp(v, 0, 500); }, { unita: "m", min: 0, passo: "1" });
  const bott = el("button", { type: "button", class: "gas-btn gas-btn--mini", onclick: () => calcola() });
  const disegna = () => {
    const valido = terrenoDelLuogo();
    stato.textContent = valido ? t("ter_pronto", { q: num(T.quota), s: num(T.sopra || 0), m: num(Math.max(...T.p) / 10, 1) }) : T.p ? t("ter_altro_luogo") : t("ter_n");
    svuota(pano);
    if (valido) pano.appendChild(panoramaCielo(null));
    bott.textContent = t(valido ? "ter_ricalcola" : "ter_calcola");
  };
  async function calcola() {
    bott.disabled = true;
    stato.textContent = t("ter_attendi");
    try {
      const { lat, lon } = NOTTE.luogo, r = await calcolaOrizzonte(lat, lon, T.sopra || 0);
      Object.assign(T, { on: true, lat, lon, quota: r.quota, p: r.p, v: r.v });
      on.checked = true;
      salvaNotte();
      disegna();
      if (dopo) dopo();
    } catch (e) {
      console.error("strumenti, orizzonte:", e);
      stato.textContent = t("ter_errore");
    }
    bott.disabled = false;
  }
  on.addEventListener("change", () => {
    T.on = on.checked;
    salvaNotte();
    if (on.checked && !terrenoDelLuogo()) { calcola(); return; }
    disegna();
    if (dopo) dopo();
  });
  disegna();
  return el("div", { class: "gas-ter" }, el("h4", { class: "gas-ter-tit" }, t("ter_titolo")),
    el("label", { class: "gas-spunta" }, on, el("span", null, t("ter_on"))),
    el("div", { class: "gas-ter-riga" }, sopra, bott), stato, pano, el("small", { class: "gas-muto gas-ter-crediti" }, t("ter_crediti")));
}
function panoramaCielo(r, nt) {
  const W = 720, H = 240, sx = 30, sy = 8, gw = W - sx - 8, gh = H - sy - 26;
  let centro = 180;
  const az = r && nt ? aziOggetto(r, nt) : null;
  if (az && r.iMax >= 0) centro = Math.round(az[r.iMax] / 15) * 15;
  const ter = terrenoDelLuogo() ? NOTTE.terreno.p : null;
  let hTop = 40;
  if (ter) hTop = Math.max(hTop, Math.max(...ter) / 10 + 10);
  if (r) hTop = Math.max(hTop, Math.min(90, (r.hMax || 0) + 8));
  hTop = Math.max(hTop, (NOTTE.hmin || 0) + 10);
  hTop = Math.min(90, Math.ceil(hTop / 10) * 10);
  const X = a => sx + ((((a - centro + 540) % 360) - 180) + 180) / 360 * gw, Y = h => sy + gh - clamp(h, 0, hTop) / hTop * gh;
  const g = sv("svg", { viewBox: `0 0 ${W} ${H}`, class: "gas-pano", role: "img", "aria-label": t("pano_titolo") });
  const id = "gp" + (panoramaCielo._n = (panoramaCielo._n || 0) + 1);
  g.appendChild(sv("defs", null,
    sv("linearGradient", { id: id + "c", x1: 0, y1: 0, x2: 0, y2: 1 }, sv("stop", { offset: "0", "stop-color": "#020714" }), sv("stop", { offset: "0.7", "stop-color": "#081a35" }),
      sv("stop", { offset: "1", "stop-color": "#173a63" })),
    sv("linearGradient", { id: id + "t", x1: 0, y1: 0, x2: 0, y2: 1 }, sv("stop", { offset: "0", "stop-color": "#1d1a17" }), sv("stop", { offset: "1", "stop-color": "#07080a" })),
    sv("filter", { id: id + "g", x: "-20%", y: "-20%", width: "140%", height: "140%" }, sv("feGaussianBlur", { stdDeviation: "2.2", result: "b" }),
      sv("feMerge", null, sv("feMergeNode", { in: "b" }), sv("feMergeNode", { in: "SourceGraphic" })))));
  g.appendChild(sv("rect", { x: sx, y: sy, width: gw, height: gh, rx: 6, fill: `url(#${id}c)` }));
  let seme = 7;
  const caso = () => (seme = (seme * 16807) % 2147483647) / 2147483647;
  for (let k = 0; k < 140; k++) {
    const x = sx + caso() * gw, y = sy + caso() * gh * 0.92, m = caso();
    g.appendChild(sv("circle", { cx: x.toFixed(1), cy: y.toFixed(1), r: (0.35 + m * m * 1.2).toFixed(2), fill: "#dfe8ff", "fill-opacity": (0.25 + 0.6 * (1 - (y - sy) / gh) * (0.4 + m)).toFixed(2) }));
  }
  for (let h = 0; h <= hTop; h += hTop > 50 ? 30 : 10) {
    g.appendChild(sv("line", { x1: sx, y1: Y(h), x2: sx + gw, y2: Y(h), class: "gas-pano-griglia" }));
    if (h && h < hTop) g.appendChild(sv("text", { x: sx + 4, y: Y(h) - 3, class: "gas-pano-testo", text: h + "°" }));
  }
  const card = t("ns_card16").split(",");
  for (let a = 0; a < 360; a += 45) {
    const x = X(a);
    g.appendChild(sv("line", { x1: x, y1: sy, x2: x, y2: sy + gh, class: "gas-pano-griglia" }));
    g.appendChild(sv("text", { x, y: H - 7, "text-anchor": "middle", class: "gas-pano-card", text: card[a / 22.5] }));
  }
  if (vistaAttiva()) {
    const v = NOTTE.vista;
    for (let a = 0; a < 360; a++) if (!dentroAz(a + 0.5, v.az1, v.az2)) g.appendChild(sv("rect", { x: X(a), y: sy, width: gw / 360 + 0.4, height: gh, class: "gas-pano-fuori" }));
    if (v.hmax < 90) g.appendChild(sv("rect", { x: sx, y: sy, width: gw, height: Y(v.hmax) - sy, class: "gas-pano-fuori" }));
  }
  if (ter) {
    let d = `M${sx},${Y(0)}`;
    for (let k = 0; k <= 360; k++) { const a = (centro - 180 + k + 360) % 360; d += `L${(sx + k / 360 * gw).toFixed(1)},${Y(ter[Math.round(a) % 360] / 10).toFixed(1)}`; }
    g.appendChild(sv("path", { d: d + `L${sx + gw},${Y(0)}Z`, fill: `url(#${id}t)` }));
    g.appendChild(sv("path", { d: d.replace(/^M[^L]*L/, "M"), class: "gas-pano-cresta" }));
  }
  g.appendChild(sv("line", { x1: sx, y1: Y(0), x2: sx + gw, y2: Y(0), class: "gas-pano-orizz" }));
  g.appendChild(sv("line", { x1: sx, y1: Y(NOTTE.hmin), x2: sx + gw, y2: Y(NOTTE.hmin), class: "gas-pano-min" }));
  if (r && nt && az) {
    const v = vistaAttiva() ? NOTTE.vista : null;
    const stato = i => {
      if (nt.hSole[i] > -12) return "luce";
      const h = r.h[i];
      const libero = h >= NOTTE.hmin && !dietroMontagne(h, az[i]) && (!v || (h <= v.hmax && dentroAz(az[i], v.az1, v.az2)));
      return libero ? "ok" : "no";
    };
    let seg = null, prec = null;
    const chiudi = () => { if (seg && seg.p.length > 1) g.appendChild(sv("polyline", { points: seg.p.join(" "), class: "gas-pano-traccia gas-pano-traccia--" + seg.s,
      filter: seg.s === "ok" ? `url(#${id}g)` : null })); seg = null; };
    for (let i = 0; i < nt.n; i++) {
      const h = r.h[i];
      if (h < -1) { chiudi(); prec = null; continue; }
      const x = X(az[i]), y = Y(h), s = stato(i);
      if (prec && Math.abs(x - prec[0]) > gw / 2) { chiudi(); }
      if (!seg || seg.s !== s) { const p0 = seg && prec ? [`${prec[0].toFixed(1)},${prec[1].toFixed(1)}`] : []; chiudi(); seg = { s, p: p0 }; }
      seg.p.push(`${x.toFixed(1)},${y.toFixed(1)}`);
      prec = [x, y];
    }
    chiudi();
    for (let i = 0; i < nt.n; i++) {
      const d = Astro.data(nt.tempi[i]);
      if (d.getMinutes() !== 0 || r.h[i] < 0) continue;
      const x = X(az[i]), y = Y(r.h[i]);
      g.appendChild(sv("circle", { cx: x, cy: y, r: 3.2, class: "gas-pano-ora gas-pano-ora--" + stato(i) }));
      if (d.getHours() % 2 === 0 && nt.hSole[i] < -6) g.appendChild(sv("text", { x, y: y - 7, "text-anchor": "middle", class: "gas-pano-ora-t", text: String(d.getHours()).padStart(2, "0") + ":00" }));
    }
  }
  const leg = [];
  if (r) leg.push(el("span", null, el("i", { class: "gas-pano-leg gas-pano-leg--ok" }), t("pano_utile")), el("span", null, el("i", { class: "gas-pano-leg gas-pano-leg--no" }), t("pano_nascosto")),
    el("span", null, el("i", { class: "gas-pano-leg gas-pano-leg--luce" }), t("pano_luce")));
  if (ter) leg.push(el("span", null, el("i", { class: "gas-pano-leg gas-pano-leg--terra" }), t("pano_terreno")));
  leg.push(el("span", null, el("i", { class: "gas-pano-leg gas-pano-leg--min" }), t("pano_limite")));
  return el("div", { class: "gas-pano-box" }, r ? el("p", { class: "gas-pano-tit" }, t("pano_titolo")) : null, g,
    el("div", { class: "gas-pano-legenda" }, leg), r ? el("small", { class: "gas-pano-n" }, t("pano_n")) : null);
}
Object.assign(TESTI.it, {
  tab_lunasole: "Luna, Sole e pianeti", oggi: "Oggi", bl_cielo: "cielo SQM {s} · LPI {l} (Bortle {b})", bl_cielo_mis: "SQM misurato {s} (Bortle {b})", ls_luna: "La Luna", ls_sole: "Il Sole",
  fase_nuova: "Luna nuova", fase_crescente: "Falce crescente", fase_primo: "Primo quarto", fase_gibbosa_cresc: "Gibbosa crescente",
  fase_piena: "Luna piena", fase_gibbosa_cal: "Gibbosa calante", fase_ultimo: "Ultimo quarto", fase_calante: "Falce calante",
  ls_illuminata: "illuminata", ls_eta: "Età", ls_giorni: "giorni", ls_distanza: "Distanza", ls_diametro: "Diametro apparente",
  ls_sorge: "Sorge", ls_culmina: "Punto più alto", ls_tramonta: "Tramonta", ls_nessuno: "non oggi", ls_az: "az. {a}°", ls_alta: "altezza {h}°",
  ls_perigeo: "Vicina alla Terra (perigeo): più grande e luminosa del solito.", ls_apogeo: "Lontana dalla Terra (apogeo): più piccola del solito.",
  ls_foto_nasa: "Immagine NASA per le {o}: fase, grandezza e librazione (la lieve oscillazione del disco) vere, nord in alto.", ls_disegno: "Disegno della fase per le {o}, nord in alto.",
  ls_inquadra_luna: "Inquadra la Luna", ls_inquadra_sole: "Inquadra il Sole", ls_mezzogiorno: "Mezzogiorno vero", ls_durata_giorno: "Durata del giorno",
  ls_alt_mezzogiorno: "Altezza a mezzogiorno", ls_grafico: "Sole e Luna nelle 24 ore",
  ls_grafico_n: "Altezza sull'orizzonte di Sole e Luna; lo sfondo mostra il giorno, l'ora d'oro, l'ora blu, i crepuscoli e la notte.",
  ls_fasi: "Prossime fasi", ls_crepuscoli: "Crepuscoli, ora d'oro e ora blu", ls_mattina: "Mattina", ls_sera: "Sera",
  ls_crep_astro: "Crepuscolo astronomico", ls_crep_nautico: "Crepuscolo nautico", ls_crep_civile: "Crepuscolo civile", ls_ora_blu: "Ora blu", ls_ora_oro: "Ora d'oro",
  ls_crep_n: "È notte vera solo con il Sole oltre 18° sotto l'orizzonte. Ora blu: Sole tra −6° e −4°; ora d'oro: tra −4° e +6°, la luce preferita per i paesaggi.",
  ls_calendario: "Calendario della Luna", ls_calendario_n: "Ogni notte: la fase e le ore di buio senza Luna. In verde le notti migliori per galassie e nebulose. Tocca un giorno per portare tutta la pagina su quella data.",
  ls_senza_luna: "{h} di buio senza Luna", ls_mese_prec: "Mese precedente", ls_mese_succ: "Mese successivo", ls_giorno: "Giorno", ls_notte: "Notte",
  ls_sole_adesso: "Il Sole adesso, dal satellite SDO (NASA)",
  ls_sole_adesso_n: "Immagini aggiornate circa ogni 15 minuti. Per guardare o fotografare il Sole serve sempre un filtro solare certificato davanti al telescopio.",
  ls_sdo_macchie: "Macchie solari (luce visibile)", ls_sdo_304: "Cromosfera e protuberanze (304 Å, simile all'H-alfa)",
  ls_negozio_solare: "Telescopi H-alfa e filtri solari nel negozio →", ls_crediti: "Immagini: Luna NASA Scientific Visualization Studio · Sole NASA/SDO e i team scientifici AIA e HMI.",
  ls_legenda_sole: "Sole", ls_legenda_luna: "Luna",
});
Object.assign(TESTI.de, {
  tab_lunasole: "Mond, Sonne und Planeten", oggi: "Heute", bl_cielo: "Himmel SQM {s} · LPI {l} (Bortle {b})", bl_cielo_mis: "gemessener SQM {s} (Bortle {b})", ls_luna: "Der Mond", ls_sole: "Die Sonne",
  fase_nuova: "Neumond", fase_crescente: "Zunehmende Sichel", fase_primo: "Erstes Viertel", fase_gibbosa_cresc: "Zunehmender Mond",
  fase_piena: "Vollmond", fase_gibbosa_cal: "Abnehmender Mond", fase_ultimo: "Letztes Viertel", fase_calante: "Abnehmende Sichel",
  ls_illuminata: "beleuchtet", ls_eta: "Alter", ls_giorni: "Tage", ls_distanza: "Entfernung", ls_diametro: "Scheinbarer Durchmesser",
  ls_sorge: "Aufgang", ls_culmina: "Höchststand", ls_tramonta: "Untergang", ls_nessuno: "heute nicht", ls_az: "Az. {a}°", ls_alta: "Höhe {h}°",
  ls_perigeo: "Nah an der Erde (Perigäum): größer und heller als sonst.", ls_apogeo: "Fern von der Erde (Apogäum): kleiner als sonst.",
  ls_foto_nasa: "NASA-Bild für {o} Uhr: echte Phase, Libration und Größe, Norden oben.", ls_disegno: "Zeichnung der Phase für {o} Uhr, Norden oben.",
  ls_inquadra_luna: "Mond im Bildfeld", ls_inquadra_sole: "Sonne im Bildfeld", ls_mezzogiorno: "Wahrer Mittag", ls_durata_giorno: "Tageslänge",
  ls_alt_mezzogiorno: "Höhe am Mittag", ls_grafico: "Sonne und Mond in 24 Stunden",
  ls_grafico_n: "Höhe über dem Horizont von Sonne und Mond; der Hintergrund zeigt Tag, goldene und blaue Stunde, Dämmerungen und Nacht.",
  ls_fasi: "Nächste Mondphasen", ls_crepuscoli: "Dämmerungen, goldene und blaue Stunde", ls_mattina: "Morgen", ls_sera: "Abend",
  ls_crep_astro: "Astronomische Dämmerung", ls_crep_nautico: "Nautische Dämmerung", ls_crep_civile: "Bürgerliche Dämmerung", ls_ora_blu: "Blaue Stunde", ls_ora_oro: "Goldene Stunde",
  ls_crep_n: "Echte Nacht erst, wenn die Sonne mehr als 18° unter dem Horizont steht. Blaue Stunde: Sonne zwischen −6° und −4°; goldene Stunde: zwischen −4° und +6°, das beliebteste Licht für Landschaften.",
  ls_calendario: "Mondkalender", ls_calendario_n: "Jede Nacht: Phase und Stunden Dunkelheit ohne Mond. Grün markiert: die besten Nächte für Galaxien und Nebel. Tippen Sie auf einen Tag, um ihn zu wählen.",
  ls_senza_luna: "{h} Dunkelheit ohne Mond", ls_mese_prec: "Voriger Monat", ls_mese_succ: "Nächster Monat", ls_giorno: "Tag", ls_notte: "Nacht",
  ls_sole_adesso: "Die Sonne jetzt, vom Satelliten SDO (NASA)",
  ls_sole_adesso_n: "Bilder etwa alle 15 Minuten aktualisiert. Zum Beobachten oder Fotografieren der Sonne immer einen zertifizierten Sonnenfilter vor dem Teleskop verwenden.",
  ls_sdo_macchie: "Sonnenflecken (sichtbares Licht)", ls_sdo_304: "Chromosphäre und Protuberanzen (304 Å, ähnlich H-Alpha)",
  ls_negozio_solare: "H-Alpha-Teleskope und Sonnenfilter im Shop →", ls_crediti: "Bilder: Mond NASA Scientific Visualization Studio · Sonne NASA/SDO und die Teams von AIA und HMI.",
  ls_legenda_sole: "Sonne", ls_legenda_luna: "Mond",
});
Object.assign(TESTI.es, {
  tab_lunasole: "Luna, Sol y planetas", oggi: "Hoy", bl_cielo: "cielo SQM {s} · LPI {l} (Bortle {b})", bl_cielo_mis: "SQM medido {s} (Bortle {b})", ls_luna: "La Luna", ls_sole: "El Sol",
  fase_nuova: "Luna nueva", fase_crescente: "Creciente", fase_primo: "Cuarto creciente", fase_gibbosa_cresc: "Gibosa creciente",
  fase_piena: "Luna llena", fase_gibbosa_cal: "Gibosa menguante", fase_ultimo: "Cuarto menguante", fase_calante: "Menguante",
  ls_illuminata: "iluminada", ls_eta: "Edad", ls_giorni: "días", ls_distanza: "Distancia", ls_diametro: "Diámetro aparente",
  ls_sorge: "Sale", ls_culmina: "Punto más alto", ls_tramonta: "Se pone", ls_nessuno: "hoy no", ls_az: "az. {a}°", ls_alta: "altura {h}°",
  ls_perigeo: "Cerca de la Tierra (perigeo): más grande y brillante de lo normal.", ls_apogeo: "Lejos de la Tierra (apogeo): más pequeña de lo normal.",
  ls_foto_nasa: "Imagen NASA para las {o}: fase, libración y tamaño reales, norte arriba.", ls_disegno: "Dibujo de la fase para las {o}, norte arriba.",
  ls_inquadra_luna: "Encuadrar la Luna", ls_inquadra_sole: "Encuadrar el Sol", ls_mezzogiorno: "Mediodía verdadero", ls_durata_giorno: "Duración del día",
  ls_alt_mezzogiorno: "Altura al mediodía", ls_grafico: "Sol y Luna en 24 horas",
  ls_grafico_n: "Altura sobre el horizonte del Sol y la Luna; el fondo muestra el día, la hora dorada, la hora azul, los crepúsculos y la noche.",
  ls_fasi: "Próximas fases", ls_crepuscoli: "Crepúsculos, hora dorada y hora azul", ls_mattina: "Mañana", ls_sera: "Tarde",
  ls_crep_astro: "Crepúsculo astronómico", ls_crep_nautico: "Crepúsculo náutico", ls_crep_civile: "Crepúsculo civil", ls_ora_blu: "Hora azul", ls_ora_oro: "Hora dorada",
  ls_crep_n: "Es noche cerrada solo con el Sol a más de 18° bajo el horizonte. Hora azul: Sol entre −6° y −4°; hora dorada: entre −4° y +6°, la luz preferida para los paisajes.",
  ls_calendario: "Calendario lunar", ls_calendario_n: "Cada noche: la fase y las horas de oscuridad sin Luna. En verde las mejores noches para galaxias y nebulosas. Toca un día para elegirlo.",
  ls_senza_luna: "{h} de oscuridad sin Luna", ls_mese_prec: "Mes anterior", ls_mese_succ: "Mes siguiente", ls_giorno: "Día", ls_notte: "Noche",
  ls_sole_adesso: "El Sol ahora, desde el satélite SDO (NASA)",
  ls_sole_adesso_n: "Imágenes actualizadas cada 15 minutos aprox. Para observar o fotografiar el Sol usa siempre un filtro solar certificado delante del telescopio.",
  ls_sdo_macchie: "Manchas solares (luz visible)", ls_sdo_304: "Cromosfera y protuberancias (304 Å, parecido al H-alfa)",
  ls_negozio_solare: "Telescopios H-alfa y filtros solares en la tienda →", ls_crediti: "Imágenes: Luna NASA Scientific Visualization Studio · Sol NASA/SDO y los equipos científicos de AIA y HMI.",
  ls_legenda_sole: "Sol", ls_legenda_luna: "Luna",
});
Object.assign(GUIDA.it, { g_lunasole: "Questa è la pagina Luna, Sole e pianeti. In alto scegli il luogo e il giorno: sono gli stessi di Cosa vedere. Vedi la Luna com'è davvero quel giorno, con la fase, l'età, la distanza e gli orari in cui sorge, è più alta in cielo e tramonta. Accanto c'è il Sole con alba, mezzogiorno e tramonto; sotto i suoi orari trovi il Sole di adesso, fotografato dal satellite SDO della NASA. Poi ci sono la tabella dei pianeti della notte, il grafico delle altezze di Sole e Luna nelle 24 ore, le prossime fasi e i crepuscoli con l'ora d'oro e l'ora blu. In fondo il calendario mostra per ogni notte del mese quante ore di buio restano senza Luna: in verde le notti migliori per galassie e nebulose." });
Object.assign(GUIDA.de, { g_lunasole: "Das ist die Seite Mond, Sonne und Planeten. Oben wählen Sie Ort und Tag, dieselben wie bei Was sehen. Sie sehen den Mond so, wie er an diesem Tag wirklich aussieht, mit Phase, Alter, Entfernung und den Zeiten von Aufgang, Kulmination und Untergang. Daneben steht die Sonne mit Aufgang, Mittag und Untergang; unter ihren Zeiten sehen Sie die Sonne von jetzt, aufgenommen vom NASA-Satelliten SDO. Dann folgen die Tabelle der Planeten der Nacht, das Diagramm der Höhen von Sonne und Mond über 24 Stunden, die nächsten Mondphasen und die Dämmerungen mit goldener und blauer Stunde. Ganz unten zeigt der Kalender für jede Nacht des Monats die Stunden Dunkelheit ohne Mond: Grün sind die besten Nächte für Galaxien und Nebel." });
Object.assign(GUIDA.es, { g_lunasole: "Esta es la página Luna, Sol y planetas. Arriba eliges el lugar y el día, los mismos de Qué ver. Ves la Luna tal como es ese día, con la fase, la edad, la distancia y las horas de salida, culminación y puesta. Al lado está el Sol con amanecer, mediodía y puesta; debajo de sus horarios ves el Sol de ahora, fotografiado por el satélite SDO de la NASA. Luego vienen la tabla de los planetas de la noche, el gráfico de las alturas del Sol y la Luna en 24 horas, las próximas fases y los crepúsculos con la hora dorada y la hora azul. Al final, el calendario muestra para cada noche del mes cuántas horas de oscuridad quedan sin Luna: en verde, las mejores noches para galaxias y nebulosas." });
function giornoScelto() {
  if (NOTTE.data) {
    const [y, m, d] = NOTTE.data.split("-").map(Number);
    if (y && m && d) return new Date(y, m - 1, d, 12);
  }
  const o = new Date();
  return new Date(o.getFullYear(), o.getMonth(), o.getDate(), 12);
}
function urlCollezione(h) { return `${RADICE_URL.replace(/\/?$/, "/")}collections/${h}`; }
Object.assign(TESTI.it, { bl_cambia: "Cambia", bl_chiudi: "Chiudi" });
Object.assign(TESTI.de, { bl_cambia: "Ändern", bl_chiudi: "Schließen" });
Object.assign(TESTI.es, { bl_cambia: "Cambiar", bl_chiudi: "Cerrar" });
Object.assign(TESTI.en, { bl_cambia: "Change", bl_chiudi: "Close" });
const CIELO_UI = new Set();
function barraLuogo(dopo, conData) {
  const testo = el("span", { class: "gas-bl-luogo" }), cielo = el("span", { class: "gas-bl-cielo" });
  const scrivi = () => { svuota(testo).append("◎ ", el("b", null, NOTTE.luogo.nome), ` · ${num(NOTTE.luogo.lat, 2)}°, ${num(NOTTE.luogo.lon, 2)}°`); };
  const scriviCielo = () => {
    svuota(cielo);
    if (NOTTE.sqmMisurato) cielo.append(" · ", ...tNodi("bl_cielo_mis", { s: num(NOTTE.sqmMisurato, 2), b: NOTTE.bortle }));
    else if (NOTTE.sqmStima) cielo.append(" · ", ...tNodi("bl_cielo", { s: num(NOTTE.sqmStima, 1), b: NOTTE.bortle, l: numLpi(NOTTE.lpiStima ?? lpiDaSqm(NOTTE.sqmStima)) }));
  };
  let giro = 0;
  const stima = () => {
    if (NOTTE.bortleAuto === false) { scriviCielo(); return Promise.resolve(); }
    const { lat, lon } = NOTTE.luogo, mio = ++giro;
    cielo.textContent = " · " + t("stima_in_corso");
    return Luoghi.stimaCielo(lat, lon).then(s => {
      if (mio !== giro) return;
      const prima = sqmLuogo();
      Object.assign(NOTTE, { sqmStima: Math.round(s.sqm * 1000) / 1000, lpiStima: s.lpi, bortle: s.bortle, bortleAuto: true, fonteStima: s.fonte, mappaBuio: MAPPA_BUIO });
      salvaNotte(); scriviCielo();
      if (sqmLuogo() !== prima) for (const f of [...CIELO_UI]) try { f(); } catch (e) { console.error("strumenti, cielo:", e); }
    }).catch(() => { if (mio === giro) scriviCielo(); });
  };
  const cambia = l => {
    Object.assign(NOTTE, { luogo: l, bortleAuto: true, sqmMisurato: null, sqmStima: null, lpiStima: null, fonteStima: null });
    salvaNotte(); scrivi(); dopo(); stima();
    provaFatta(2);
    if (barra.classList.contains("gas-bl-aperta")) cambiaBtn.click();
    try { riempiChip(); } catch (e) {   }
  };
  const cerca = creaCerca({
    segnaposto: t("cerca_citta"),
    cerca: q => Luoghi.cerca(q, 25).catch(() => {
      const k = normParole(q);
      return CITTA.filter(c => normParole(c[0]).includes(k)).slice(0, 20).map(c => ({ nome: c[0], lat: c[1], lon: c[2], zona: "" }));
    }),
    riga: c => ({ titolo: c.nome, sotto: [c.zona, `${num(c.lat, 2)}°, ${num(c.lon, 2)}°`].filter(Boolean).join(" · ") }),
    scegli: c => { cerca.imposta(""); cambia({ nome: c.zona && c.zona.length <= 3 ? `${c.nome} (${c.zona})` : c.nome, lat: c.lat, lon: c.lon }); },
  });
  const gps = el("button", { type: "button", class: "gas-btn gas-btn--chiaro", onclick: () => {
    if (!navigator.geolocation) return;
    gps.disabled = true; gps.textContent = t("cerco_posizione");
    navigator.geolocation.getCurrentPosition(p => {
      gps.disabled = false; gps.textContent = t("usa_posizione");
      cambia({ nome: t("mia_posizione"), gps: true, lat: Math.round(p.coords.latitude * 100) / 100, lon: Math.round(p.coords.longitude * 100) / 100 });
    }, () => { gps.disabled = false; gps.textContent = t("posizione_negata"); }, { timeout: 15000, maximumAge: 600000 });
  } }, t("usa_posizione"));
  const comandi = el("div", { class: "gas-bl-comandi" }, cerca.box, gps);
  const cambiaBtn = el("button", { type: "button", class: "gas-btn gas-btn--mini gas-bl-cambia", "aria-expanded": "false", onclick: () => {
    const aperta = barra.classList.toggle("gas-bl-aperta");
    cambiaBtn.setAttribute("aria-expanded", String(aperta));
    cambiaBtn.textContent = t(aperta ? "bl_chiudi" : "bl_cambia");
    if (aperta) setTimeout(() => cerca.input.focus({ preventScroll: true }), 50);
  } }, t("bl_cambia"));
  const dataTesto = el("span", { class: "gas-bl-data" });
  const barra = el("section", { class: "gas-card gas-barra-luogo" + (ricorda("notte", null) ? "" : " gas-bl-aperta") }, el("div", { class: "gas-bl-testa" }, testo, cielo, infoBtn("cielo"), dataTesto, cambiaBtn), comandi);
  if (barra.classList.contains("gas-bl-aperta")) { cambiaBtn.textContent = t("bl_chiudi"); cambiaBtn.setAttribute("aria-expanded", "true"); }
  if (conData) {
    const quando = conData === "giorno" ? giornoScelto : dataNotte;
    const dataIn = el("input", { type: "date", class: "gas-input", value: isoData(quando()), "aria-label": t("data_notte") });
    const scriviData = () => { dataTesto.textContent = " · " + giorno(quando()); };
    scriviData();
    dataIn.addEventListener("change", () => { NOTTE.data = dataIn.value; salvaNotte(); scriviData(); dopo(); });
    const oggi = el("button", { type: "button", class: "gas-btn gas-btn--chiaro", onclick: () => {
      NOTTE.data = ""; dataIn.value = isoData(quando()); salvaNotte(); scriviData(); dopo(); } }, t(conData === "giorno" ? "oggi" : "stanotte"));
    comandi.append(el("div", { class: "gas-riga-bottoni" }, dataIn, oggi));
    barra.aggiornaData = () => { dataIn.value = isoData(quando()); scriviData(); };
  }
  scrivi();
  if (NOTTE.sqmMisurato || (NOTTE.sqmStima && NOTTE.fonteStima && NOTTE.mappaBuio === MAPPA_BUIO)) scriviCielo(); else stima();
  return barra;
}
function curvaGiorno(giornoD, lat, lon) {
  const t0 = new Date(giornoD.getFullYear(), giornoD.getMonth(), giornoD.getDate(), 0, 0, 0);
  const t1 = new Date(giornoD.getFullYear(), giornoD.getMonth(), giornoD.getDate() + 1, 0, 0, 0);
  const j0 = Astro.jd(t0), passo = 2, n = Math.round((t1 - t0) / 60000 / passo) + 1;
  const tempi = new Float64Array(n), hS = new Float32Array(n), hL = new Float32Array(n);
  for (let i = 0; i < n; i++) {
    const j = j0 + i * passo / 1440;
    tempi[i] = j;
    const lst = Astro.n360(Astro.gmst(j) + lon), s = Astro.sole(j), l = Astro.luna(j);
    hS[i] = Astro.altezza(s.ra, s.dec, lat, lst);
    hL[i] = Astro.altezzaLuna(l, lat, lst);
  }
  return { j0, passo, n, tempi, hS, hL, lat, lon, giorno: t0 };
}
function passaggi(c, h, soglia) {
  const su = [], giu = [];
  for (let i = 1; i < c.n; i++) {
    const a = h[i - 1] - soglia, b = h[i] - soglia;
    if (a < 0 && b >= 0) su.push(c.tempi[i - 1] + a / (a - b) * (c.tempi[i] - c.tempi[i - 1]));
    else if (a >= 0 && b < 0) giu.push(c.tempi[i - 1] + a / (a - b) * (c.tempi[i] - c.tempi[i - 1]));
  }
  return { su: su[0] || null, giu: giu[giu.length - 1] || null, suTutti: su, giuTutti: giu };
}
function culmine(c, h) {
  let im = 0;
  for (let i = 1; i < c.n; i++) if (h[i] > h[im]) im = i;
  if (im === 0 || im === c.n - 1) return { j: c.tempi[im], h: h[im], bordo: true };
  const a = h[im - 1], b = h[im], d = h[im + 1], den = a - 2 * b + d, f = den ? 0.5 * (a - d) / den : 0;
  return { j: c.tempi[im] + f * c.passo / 1440, h: b - 0.25 * (a - d) * f };
}
function azimut(corpo, j, lat, lon) {
  const p = corpo === "sole" ? Astro.sole(j) : Astro.luna(j);
  return Astro.altAz(p.ra, p.dec, lat, Astro.n360(Astro.gmst(j) + lon))[1];
}
const dataJ = j => (j == null ? null : new Date(Math.round((j - 2440587.5) * 86400000)));
function nomeFase(f) {
  const d = f.diff, vicino = a => Math.abs(((d - a + 540) % 360) - 180) < 12;
  if (vicino(0)) return t("fase_nuova");
  if (vicino(90)) return t("fase_primo");
  if (vicino(180)) return t("fase_piena");
  if (vicino(270)) return t("fase_ultimo");
  return t(d < 90 ? "fase_crescente" : d < 180 ? "fase_gibbosa_cresc" : d < 270 ? "fase_gibbosa_cal" : "fase_calante");
}
const SVS_LUNA = { 2026: "a000000/a005500/a005587" };
function caricaImmagine(attr, ms) {
  return new Promise((ok, no) => {
    const img = el("img", Object.assign({ decoding: "async" }, attr));
    const via = setTimeout(() => { img.onload = img.onerror = null; img.removeAttribute("src"); no(new Error("tempo scaduto")); }, ms || 20000);
    img.onload = () => { clearTimeout(via); if (img.naturalWidth) ok(img); else no(new Error("vuota")); };
    img.onerror = () => { clearTimeout(via); no(new Error("non arriva")); };
  });
}
function caricaPrima(urls, attr, ms) {
  return urls.reduce((prima, src, i) => prima.catch(() => caricaImmagine(Object.assign({}, attr, { src }), ms).then(img => ({ img, i }))),
    Promise.reject(new Error("inizio")));
}
function fotoLuna(d) {
  const y = d.getUTCFullYear(), base = SVS_LUNA[y];
  if (!base) return null;
  const fr = Math.round((d.getTime() - Date.UTC(y, 0, 1)) / 3600000) + 1;
  const max = (Date.UTC(y + 1, 0, 1) - Date.UTC(y, 0, 1)) / 3600000;
  if (fr < 1 || fr > max) return null;
  return `https://svs.gsfc.nasa.gov/vis/${base}/frames/730x730_1x1_30p/moon.${String(fr).padStart(4, "0")}.jpg`;
}
function lunaDisegnata(f, lato) {
  const r = 100, k = f.k, x = (1 - 2 * k) * r, dx = f.crescente ? 1 : -1;
  const id = "gasL" + Math.random().toString(36).slice(2, 7);
  return sv("svg", { viewBox: "-110 -110 220 220", width: lato, height: lato, class: "gas-ls-luna-svg", role: "img", "aria-label": nomeFase(f) },
    sv("defs", null, sv("radialGradient", { id, cx: "38%", cy: "35%", r: "75%" },
      sv("stop", { offset: "0", "stop-color": "#f6f1e3" }), sv("stop", { offset: "1", "stop-color": "#b9b2a0" }))),
    sv("circle", { r, fill: "#232a36" }),
    sv("path", { fill: `url(#${id})`, d: `M0,${-r} A${r},${r} 0 0 ${dx > 0 ? 1 : 0} 0,${r} A${Math.abs(x)},${r} 0 0 ${(x > 0) === (dx > 0) ? 0 : 1} 0,${-r} Z` }));
}
function coloreCielo(h) {
  return h > 6 ? "#35618f" : h > -4 ? "#7c6440" : h > -6 ? "#2b4f8a" : h > -12 ? "#1a3458" : h > -18 ? "#0f213d" : "#050b17";
}
function vistaLunaSole(pannello) {
  svuota(pannello);
  const corpo = el("div", { class: "gas-ls" });
  pannello.append(barraLuogo(() => disegna(), "giorno"), corpo);
  function disegna() {
    svuota(corpo);
    const g = giornoScelto(), { lat, lon } = NOTTE.luogo;
    const c = curvaGiorno(g, lat, lon);
    const pianeti = NAV4 ? cartaPianetiNotte() : null;
    aggiungi(corpo, [
      el("div", { class: "gas-ls-due" }, cartaLuna(c), cartaSole(c)),
      pianeti,
      cartaGrafico(c),
      el("div", { class: "gas-ls-due" }, cartaFasi(g), cartaCrepuscoli(c)),
      cartaCalendario(g, lat, lon, iso => { NOTTE.data = iso; salvaNotte(); vistaLunaSole(pannello); }),
      NAV4 ? null : cartaEventi(lat, lon, iso => { NOTTE.data = iso; salvaNotte(); vistaLunaSole(pannello); pannello.scrollIntoView({ behavior: "smooth", block: "start" }); })]);
    if (pianeti && LS_AI_PIANETI) { LS_AI_PIANETI = false; setTimeout(() => { if (pianeti.isConnected) pianeti.scrollIntoView({ behavior: "smooth", block: "start" }); }, 80); }
  }
  disegna();
}
function cartaPianetiNotte() {
  const box = el("section", { class: "gas-card gas-pianeti gas-ls-pianeti" });
  try { aggiungi(box, tabellaPianeti(calcolaNotte())); } catch (e) { console.error("strumenti, pianeti:", e); return null; }
  return box;
}
let LS_AI_PIANETI = false;
function apriLunaSole(aiPianeti) {
  LS_AI_PIANETI = !!aiPianeti;
  vai("lunasole", false, !!aiPianeti);
}
function cartaLuna(c) {
  const { lat, lon } = c;
  const p = passaggi(c, c.hL, -0.833), cu = culmine(c, c.hL);
  const jFoto = cu.h > 0 ? cu.j : c.j0 + 21 / 24;
  const quando = Astro.data(jFoto), f = Astro.faseLuna(jFoto), l = Astro.luna(jFoto);
  const diam = 2 * Math.asin(1737.4 / l.dist) * DEG * 60;
  const url = fotoLuna(quando);
  const img = lunaDisegnata(f, 260), didascalia = el("figcaption", null, t("ls_disegno", { o: ora(quando) }));
  if (url) caricaImmagine({ class: "gas-ls-luna-img", src: url, alt: nomeFase(f), width: 365, height: 365 }).then(foto => {
    if (!img.isConnected) return;
    img.replaceWith(foto); didascalia.textContent = t("ls_foto_nasa", { o: ora(quando) });
  }).catch(() => {});
  const evento = (testo, j, corpo) => cifra(testo, j ? ora(dataJ(j)) : t("ls_nessuno"), j ? t("ls_az", { a: num(azimut(corpo, j, lat, lon)) }) : "");
  return scheda(t("ls_luna"),
    el("div", { class: "gas-ls-astro" },
      el("figure", { class: "gas-ls-figura" }, img, didascalia),
      el("div", { class: "gas-ls-dati" },
        el("p", { class: "gas-ls-nome" }, nomeFase(f)),
        el("p", { class: "gas-ls-cifra" }, el("b", null, `${num(f.k * 100)} %`), " ", t("ls_illuminata")),
        riga(t("ls_eta"), `${num(f.eta, 1)} ${t("ls_giorni")}`),
        riga(t("ls_distanza"), `${num(l.dist)} km`),
        riga(t("ls_diametro"), `${num(diam, 1)}′`),
        l.dist < 362000 ? el("p", { class: "gas-nota gas-ok" }, t("ls_perigeo")) : l.dist > 404000 ? el("p", { class: "gas-nota" }, t("ls_apogeo")) : null)),
    el("div", { class: "gas-numeri gas-numeri--tre" },
      evento(t("ls_sorge"), p.su, "luna"),
      cifra(t("ls_culmina"), cu.h > -0.833 && !cu.bordo ? ora(dataJ(cu.j)) : "–", cu.h > -0.833 && !cu.bordo ? t("ls_alta", { h: num(cu.h) }) : ""),
      evento(t("ls_tramonta"), p.giu, "luna")),
    el("div", { class: "gas-riga-bottoni" }, el("button", { type: "button", class: "gas-btn gas-btn--chiaro", onclick: () => {
      CAMPO.ogg = "@luna"; CENTRO = null; SPOSTA = [0, 0]; ZOOM = 1; salvaCampo(); vai("campo"); } }, t("ls_inquadra_luna"))));
}
function cartaSole(c) {
  const { lat, lon } = c;
  const p = passaggi(c, c.hS, -0.833), cu = culmine(c, c.hS);
  const evento = (testo, j) => cifra(testo, j ? ora(dataJ(j)) : t("ls_nessuno"), j ? t("ls_az", { a: num(azimut("sole", j, lat, lon)) }) : "");
  const ore = p.su && p.giu ? (p.giu - p.su) * 24 : cu.h > 0 ? 24 : 0;
  return scheda(t("ls_sole"),
    el("div", { class: "gas-numeri" },
      evento(t("alba"), p.su),
      cifra(t("ls_mezzogiorno"), ora(dataJ(cu.j)), t("ls_alta", { h: num(cu.h) })),
      evento(t("tramonto"), p.giu),
      cifra(t("ls_durata_giorno"), durata(ore), "")),
    sdoAdesso(),
    el("div", { class: "gas-riga-bottoni" },
      el("button", { type: "button", class: "gas-btn gas-btn--chiaro", onclick: () => {
        CAMPO.ogg = "@sole"; CENTRO = null; SPOSTA = [0, 0]; ZOOM = 1; salvaCampo(); vai("campo"); } }, t("ls_inquadra_sole")),
      el("a", { class: "gas-btn gas-btn--chiaro", href: urlCollezione("telescopi-solari"), target: "_blank", rel: "noopener" }, t("ls_negozio_solare"))));
}
function cartaGrafico(c) {
  const W = clamp(Math.round((window.innerWidth || 1000) - 40), 320, 1000), H = W < 600 ? 196 : 236, top = 8, bot = H - 30;
  const y = h => top + (90 - clamp(h, -24, 90)) / 114 * (bot - top);
  const x = i => i / (c.n - 1) * W;
  const s = sv("svg", { viewBox: `0 0 ${W} ${H}`, class: "gas-ls-grafico", role: "img", "aria-label": t("ls_grafico") });
  for (let i = 0; i < c.n - 1; i += 5) {
    const i1 = Math.min(c.n - 1, i + 5);
    s.appendChild(sv("rect", { x: x(i).toFixed(1), y: top, width: (x(i1) - x(i) + 0.6).toFixed(1), height: bot - top, fill: coloreCielo(c.hS[Math.min(c.n - 1, i + 2)]) }));
  }
  for (const a of [30, 60]) s.appendChild(sv("line", { x1: 0, x2: W, y1: y(a), y2: y(a), class: "gas-ls-linea" }));
  s.appendChild(sv("line", { x1: 0, x2: W, y1: y(0), y2: y(0), class: "gas-ls-orizzonte" }));
  for (const a of [0, 30, 60]) s.appendChild(sv("text", { x: 6, y: y(a) - 4, class: "gas-ls-asse", text: a + "°" }));
  const g = c.giorno, lungo = c.tempi[c.n - 1] - c.j0;
  for (let hh = 0; hh <= 24; hh += 3) {
    const xx = (Astro.jd(new Date(g.getFullYear(), g.getMonth(), g.getDate(), hh)) - c.j0) / lungo * W;
    if (xx > W + 1) break;
    s.appendChild(sv("line", { x1: xx, x2: xx, y1: bot, y2: bot + 5, class: "gas-ls-linea" }));
    s.appendChild(sv("text", { x: clamp(xx, 14, W - 14), y: H - 10, "text-anchor": "middle", class: "gas-ls-asse", text: String(hh % 24).padStart(2, "0") }));
  }
  const percorso = arr => {
    let d = "", giu = true;
    for (let i = 0; i < c.n; i += 2) {
      if (arr[i] < -24) { giu = true; continue; }
      d += (giu ? "M" : "L") + x(i).toFixed(1) + "," + y(arr[i]).toFixed(1); giu = false;
    }
    return d;
  };
  s.appendChild(sv("path", { d: percorso(c.hL), class: "gas-ls-curva gas-ls-curva--luna" }));
  s.appendChild(sv("path", { d: percorso(c.hS), class: "gas-ls-curva gas-ls-curva--sole" }));
  const adesso = (Astro.jd(new Date()) - c.j0) * 1440 / c.passo;
  if (adesso >= 0 && adesso <= c.n - 1) {
    s.appendChild(sv("line", { x1: x(adesso), x2: x(adesso), y1: top, y2: bot, class: "gas-ls-adesso" }));
    const fine = x(adesso) > W - 56;
    s.appendChild(sv("text", { x: x(adesso) + (fine ? -5 : 5), y: top + 14, "text-anchor": fine ? "end" : "start", class: "gas-ls-asse", text: ora(new Date()) }));
  }
  const voce = (cl, testo) => el("span", { class: "gas-ls-leg" }, el("i", { class: cl }), testo);
  return scheda(t("ls_grafico"), el("p", { class: "gas-nota" }, t("ls_grafico_n")), el("div", { class: "gas-ls-grafico-box" }, s),
    el("div", { class: "gas-ls-legenda" }, voce("gas-ls-leg--sole", t("ls_legenda_sole")), voce("gas-ls-leg--luna", t("ls_legenda_luna")),
      voce("gas-ls-leg--oro", t("ls_ora_oro")), voce("gas-ls-leg--blu", t("ls_ora_blu")), voce("gas-ls-leg--crep", t("ls_crep_nautico")), voce("gas-ls-leg--notte", t("ls_notte"))));
}
function cartaFasi(g) {
  const oggi = new Date(), stesso = isoData(oggi) === isoData(g);
  const j = Astro.jd(stesso ? oggi : new Date(g.getFullYear(), g.getMonth(), g.getDate(), 0, 0));
  const fasi = [[0, "fase_nuova"], [90, "fase_primo"], [180, "fase_piena"], [270, "fase_ultimo"]]
    .map(([a, nome]) => ({ j: Astro.prossimaFase(j, a), a, nome })).filter(x => x.j).sort((p, q) => p.j - q.j);
  return scheda(t("ls_fasi"), el("ul", { class: "gas-ls-fasi" }, fasi.map(x => {
    const d = Astro.data(x.j), f = Astro.faseLuna(x.j);
    return el("li", null, iconaLuna(f), el("span", null, el("b", null, t(x.nome)), el("small", null, `${giorno(d)} · ${ora(d)}`)));
  })));
}
function cartaCrepuscoli(c) {
  const v = soglia => passaggi(c, c.hS, soglia);
  const a18 = v(-18), a12 = v(-12), a6 = v(-6), a4 = v(-4), p6 = v(6), a0 = v(-0.833);
  const o = j => (j ? ora(dataJ(j)) : "–");
  const fascia = (da, a) => (da || a ? `${o(da)} – ${o(a)}` : "–");
  const tab = (titolo, righe) => el("div", { class: "gas-ls-crep" }, el("h4", null, titolo), righe.map(([e, v2]) => riga(e, v2)));
  return scheda(t("ls_crepuscoli"),
    el("div", { class: "gas-ls-due gas-ls-due--stretto" },
      tab(t("ls_mattina"), [[t("ls_crep_astro"), fascia(a18.su, a12.su)], [t("ls_crep_nautico"), fascia(a12.su, a6.su)],
        [t("ls_ora_blu"), fascia(a6.su, a4.su)], [t("ls_ora_oro"), fascia(a4.su, p6.su)], [t("alba"), o(a0.su)]]),
      tab(t("ls_sera"), [[t("tramonto"), o(a0.giu)], [t("ls_ora_oro"), fascia(p6.giu, a4.giu)], [t("ls_ora_blu"), fascia(a4.giu, a6.giu)],
        [t("ls_crep_nautico"), fascia(a6.giu, a12.giu)], [t("ls_crep_astro"), fascia(a12.giu, a18.giu)]])),
    el("p", { class: "gas-nota" }, t("ls_crep_n")));
}
const _calendari = new Map();
function cartaCalendario(g, lat, lon, scegli, mostra) {
  const anno = (mostra || g).getFullYear(), mese = (mostra || g).getMonth(), chiave = `${anno}-${mese}|${lat}|${lon}`;
  if (!_calendari.has(chiave)) {
    const n = new Date(anno, mese + 1, 0).getDate(), giorni = [];
    for (let d = 1; d <= n; d++) {
      const gg = new Date(anno, mese, d, 12), nt = Astro.notte(gg, lat, lon, 15);
      let senza = 0;
      for (const i of nt.buio) if (nt.hLuna[i] < 0) senza++;
      giorni.push({ d, iso: isoData(gg), fase: nt.fase, ore: nt.buio.length * nt.passo / 60, senza: senza * nt.passo / 60 });
    }
    _calendari.set(chiave, giorni);
    if (_calendari.size > 24) _calendari.delete(_calendari.keys().next().value);
  }
  const giorni = _calendari.get(chiave), scelto = isoData(g), oggi = isoData(new Date());
  const primo = (new Date(anno, mese, 1).getDay() + 6) % 7;
  const nomiG = [...Array(7)].map((_, i) => new Date(2024, 0, 1 + i).toLocaleDateString(LOCALE, { weekday: "short" }));
  const cambiaMese = dm => {
    const nuova = cartaCalendario(g, lat, lon, scegli, new Date(anno, mese + dm, 1, 12));
    carta.replaceWith(nuova);
    const b = nuova.querySelector(dm < 0 ? ".gas-cal-prec" : ".gas-cal-succ");
    if (b) b.focus({ preventScroll: true });
  };
  const griglia = el("div", { class: "gas-cal" }, nomiG.map(n => el("span", { class: "gas-cal-nome" }, n)),
    [...Array(primo)].map(() => el("span", { class: "gas-cal-vuoto" })),
    giorni.map(x => {
      const q = x.ore ? x.senza / x.ore : 0, cl = q >= 0.75 ? "buia" : q >= 0.3 ? "mezza" : "luna";
      return el("button", { type: "button", class: `gas-cal-g gas-cal-g--${cl}${x.iso === scelto ? " on" : ""}${x.iso === oggi ? " oggi" : ""}`,
        title: `${nomeFase(x.fase)} · ${num(x.fase.k * 100)} % · ${t("ls_senza_luna", { h: durata(x.senza) })}`, onclick: () => scegli(x.iso) },
        el("span", { class: "gas-cal-n" }, String(x.d)), iconaLuna(x.fase), el("small", null, `${num(Math.round(x.senza * 2) / 2, x.senza % 1 >= 0.25 && x.senza % 1 < 0.75 ? 1 : 0)} h`));
    }));
  const titolo = new Date(anno, mese, 1).toLocaleDateString(LOCALE, { month: "long", year: "numeric" });
  const carta = scheda(t("ls_calendario"),
    el("div", { class: "gas-cal-testa" },
      el("button", { type: "button", class: "gas-btn gas-btn--chiaro gas-btn--mini gas-cal-prec", "aria-label": t("ls_mese_prec"), onclick: () => cambiaMese(-1) }, "‹"),
      el("b", null, titolo.charAt(0).toUpperCase() + titolo.slice(1)),
      el("button", { type: "button", class: "gas-btn gas-btn--chiaro gas-btn--mini gas-cal-succ", "aria-label": t("ls_mese_succ"), onclick: () => cambiaMese(1) }, "›")),
    el("p", { class: "gas-nota" }, t("ls_calendario_n")), griglia);
  return carta;
}
function sdoAdesso() {
  const o = new Date(), v = `${o.getUTCFullYear()}${o.getUTCMonth() + 1}${o.getUTCDate()}${o.getUTCHours()}${Math.floor(o.getUTCMinutes() / 15)}`;
  const stato = el("p", { class: "gas-nota gas-sdo-stato" }, t("ls_sdo_carico"));
  let arrivate = 0, finite = 0;
  const fatta = ok => { arrivate += ok ? 1 : 0; if (++finite < 2) return; if (arrivate) stato.remove(); else stato.textContent = t("ls_sdo_no"); };
  const foto = (urls, testo, altra) => {
    const fig = el("figure", { class: "gas-sdo-f", hidden: true }, el("figcaption", null, testo));
    caricaPrima(urls.map(u => `${u}?v=${v}`), { alt: testo, width: 512, height: 512 }, 9000)
      .then(({ img, i }) => { fig.prepend(img); if (i && altra) fig.lastChild.append(" · ", altra); fig.hidden = false; fatta(true); }, () => fatta(false));
    return fig;
  };
  const SDO = "https://sdo.gsfc.nasa.gov/assets/img/latest/", SOHO = "https://soho.nascom.nasa.gov/data/realtime/";
  return el("div", { class: "gas-sdo-box" }, el("h4", null, t("ls_sole_adesso")),
    el("div", { class: "gas-sdo" }, foto([SDO + "latest_512_HMIIC.jpg", SOHO + "hmi_igr/512/latest.jpg"], t("ls_sdo_macchie")),
      foto([SDO + "latest_512_0304.jpg", SOHO + "eit_304/512/latest.jpg"], t("ls_sdo_304"), "SOHO/EIT (ESA & NASA)")), stato,
    el("p", { class: "gas-nota" }, t("ls_sole_adesso_n")), el("p", { class: "gas-credits-mini" }, t("ls_crediti")));
}
Object.assign(TESTI.it, { ls_sdo_carico: "Carico le immagini del Sole dalla NASA…",
  ls_sdo_no: "Le immagini del Sole dalla NASA ora non arrivano: i loro server non rispondono. Riprova più tardi." });
Object.assign(TESTI.de, { ls_sdo_carico: "Die Sonnenbilder der NASA werden geladen…",
  ls_sdo_no: "Die Sonnenbilder der NASA kommen gerade nicht an: Die NASA-Server antworten nicht. Bitte später erneut versuchen." });
Object.assign(TESTI.es, { ls_sdo_carico: "Cargando las imágenes del Sol de la NASA…",
  ls_sdo_no: "Las imágenes del Sol de la NASA no llegan ahora: sus servidores no responden. Vuelve a intentarlo más tarde." });
Object.assign(TESTI.en, { ls_sdo_carico: "Loading the NASA images of the Sun…",
  ls_sdo_no: "The NASA images of the Sun aren't coming through right now: their servers aren't responding. Please try again later." });
Object.assign(TESTI.it, {
  ev_titolo: "Prossimi eventi del cielo", ev_n: "Per il tuo luogo, nei prossimi 12 mesi. Tocca un evento per portare tutta la pagina su quel giorno.",
  ev_meteore: "fino a {z} meteore all'ora al picco", ev_luna_ok: "Luna {p} %: notte ottima", ev_luna_media: "Luna {p} %: notte discreta", ev_luna_no: "Luna {p} %: disturba",
  ev_opposizione: "Opposizione di {p}", ev_opposizione_n: "diametro {d}″: il momento migliore per osservarlo e fotografarlo",
  ev_equ_prim: "Equinozio di primavera", ev_sol_est: "Solstizio d'estate", ev_equ_aut: "Equinozio d'autunno", ev_sol_inv: "Solstizio d'inverno",
  ev_stagione: "alle {o}", ev_superluna: "Superluna", ev_superluna_n: "Luna piena a {km} km: più grande e luminosa",
  ev_ecl_tot: "Eclissi totale di Luna", ev_ecl_parz: "Eclissi parziale di Luna", ev_ecl_pen: "Eclissi penombrale di Luna",
  ev_ecl_n: "massimo alle {o} · {v}", ev_visibile: "visibile da qui (Luna alta {h}°)", ev_non_visibile: "da qui la Luna è sotto l'orizzonte",
  ev_ecl_pen_n: "si nota appena: un bordo della Luna si scurisce", ev_tutti: "Mostra tutti ({n})",
  ev_ecl_sole: "Eclissi di Sole", ev_ecl_sole_n: "Parziale dall'Italia verso le 11: dal 55 % al Nord fino a quasi il 100 % a Lampedusa; totale nel sud della Spagna e in Nord Africa. Serve un filtro solare certificato.",
  sciame_QUA: "Quadrantidi", sciame_LYR: "Liridi", sciame_ETA: "Eta Aquaridi", sciame_SDA: "Delta Aquaridi", sciame_PER: "Perseidi", sciame_DRA: "Draconidi",
  sciame_ORI: "Orionidi", sciame_LEO: "Leonidi", sciame_GEM: "Geminidi", sciame_URS: "Ursidi",
});
Object.assign(TESTI.de, {
  ev_titolo: "Nächste Himmelsereignisse", ev_n: "Für Ihren Ort, in den nächsten 12 Monaten. Tippen Sie auf ein Ereignis, um den Tag zu wählen.",
  ev_meteore: "bis zu {z} Meteore pro Stunde im Maximum", ev_luna_ok: "Mond {p} %: sehr gute Nacht", ev_luna_media: "Mond {p} %: ordentliche Nacht", ev_luna_no: "Mond {p} %: stört",
  ev_opposizione: "Opposition von {p}", ev_opposizione_n: "Durchmesser {d}″: die beste Zeit zum Beobachten und Fotografieren",
  ev_equ_prim: "Frühlingsanfang", ev_sol_est: "Sommersonnenwende", ev_equ_aut: "Herbstanfang", ev_sol_inv: "Wintersonnenwende",
  ev_stagione: "um {o} Uhr", ev_superluna: "Supermond", ev_superluna_n: "Vollmond in {km} km Entfernung: größer und heller",
  ev_ecl_tot: "Totale Mondfinsternis", ev_ecl_parz: "Partielle Mondfinsternis", ev_ecl_pen: "Halbschatten-Mondfinsternis",
  ev_ecl_n: "Maximum um {o} · {v}", ev_visibile: "von hier sichtbar (Mondhöhe {h}°)", ev_non_visibile: "hier steht der Mond unter dem Horizont",
  ev_ecl_pen_n: "kaum zu sehen: Ein Mondrand wird etwas dunkler", ev_tutti: "Alle anzeigen ({n})",
  ev_ecl_sole: "Sonnenfinsternis", ev_ecl_sole_n: "In Italien partiell gegen 11 Uhr: von 55 % im Norden bis fast 100 % auf Lampedusa; total im Süden Spaniens und in Nordafrika. Nur mit zertifiziertem Sonnenfilter beobachten.",
  sciame_QUA: "Quadrantiden", sciame_LYR: "Lyriden", sciame_ETA: "Eta-Aquariiden", sciame_SDA: "Delta-Aquariiden", sciame_PER: "Perseiden", sciame_DRA: "Draconiden",
  sciame_ORI: "Orioniden", sciame_LEO: "Leoniden", sciame_GEM: "Geminiden", sciame_URS: "Ursiden",
});
Object.assign(TESTI.es, {
  ev_titolo: "Próximos eventos del cielo", ev_n: "Para tu lugar, en los próximos 12 meses. Toca un evento para elegir su día.",
  ev_meteore: "hasta {z} meteoros por hora en el máximo", ev_luna_ok: "Luna al {p} %: noche excelente", ev_luna_media: "Luna al {p} %: noche regular", ev_luna_no: "Luna al {p} %: molesta",
  ev_opposizione: "Oposición de {p}", ev_opposizione_n: "diámetro {d}″: el mejor momento para observarlo y fotografiarlo",
  ev_equ_prim: "Equinoccio de primavera", ev_sol_est: "Solsticio de verano", ev_equ_aut: "Equinoccio de otoño", ev_sol_inv: "Solsticio de invierno",
  ev_stagione: "a las {o}", ev_superluna: "Superluna", ev_superluna_n: "Luna llena a {km} km: más grande y brillante",
  ev_ecl_tot: "Eclipse total de Luna", ev_ecl_parz: "Eclipse parcial de Luna", ev_ecl_pen: "Eclipse penumbral de Luna",
  ev_ecl_n: "máximo a las {o} · {v}", ev_visibile: "visible desde aquí (Luna a {h}°)", ev_non_visibile: "desde aquí la Luna está bajo el horizonte",
  ev_ecl_pen_n: "apenas se nota: un borde de la Luna se oscurece", ev_tutti: "Mostrar todos ({n})",
  ev_ecl_sole: "Eclipse de Sol", ev_ecl_sole_n: "Parcial desde Italia hacia las 11: del 55 % en el norte a casi el 100 % en Lampedusa; total en el sur de España y en el norte de África. Hace falta un filtro solar certificado.",
  sciame_QUA: "Cuadrántidas", sciame_LYR: "Líridas", sciame_ETA: "Eta Acuáridas", sciame_SDA: "Delta Acuáridas", sciame_PER: "Perseidas", sciame_DRA: "Dracónidas",
  sciame_ORI: "Oriónidas", sciame_LEO: "Leónidas", sciame_GEM: "Gemínidas", sciame_URS: "Úrsidas",
});
const SCIAMI = [["QUA", 1, 3], ["LYR", 4, 22], ["ETA", 5, 5], ["SDA", 7, 30], ["PER", 8, 12], ["DRA", 10, 8],
  ["ORI", 10, 21], ["LEO", 11, 17], ["GEM", 12, 13], ["URS", 12, 22]];
function solePunto(j, lon) {
  const d = x => ((Astro.sole(x).lon - lon + 540) % 360) - 180;
  let da = d(j);
  for (let x = j + 1; x < j + 370; x += 1) {
    const dx = d(x);
    if (da < 0 && dx >= 0) { let p = x - 1, q = x; for (let i = 0; i < 30; i++) { const m = (p + q) / 2; if (d(m) < 0) p = m; else q = m; } return (p + q) / 2; }
    da = dx;
  }
  return null;
}
function eclissiLuna(jPiena) {
  let meglio = null;
  for (let k = -36; k <= 36; k++) {
    const j = jPiena + k * 5 / 1440, l = Astro.luna(j), s = Astro.sole(j);
    const sep = Astro.separazione(l.ra, l.dec, Astro.n360(s.ra + 180), -s.dec);
    if (!meglio || sep < meglio.sep) meglio = { j, sep, l, s };
  }
  const { sep, l, s } = meglio;
  const pm = l.par, ss = 0.2666 / s.dist, ps = 0.00244 / s.dist, sm = Math.asin(1737.4 / l.dist) * DEG;
  const ru = 1.02 * (0.99834 * pm - ss + ps), rp = 1.02 * (0.99834 * pm + ss + ps);
  const gu = (ru + sm - sep) / (2 * sm), gp = (rp + sm - sep) / (2 * sm);
  if (gp <= 0) return null;
  return { j: meglio.j, tipo: gu >= 1 ? "tot" : gu > 0 ? "parz" : "pen", grandezza: gu > 0 ? gu : gp };
}
function eclissiSoleQui(jA, jB, lat, lon) {
  let a = null, b = null, m = null, min = Infinity;
  for (let k = Math.ceil(jA * 1440); k <= jB * 1440; k++) {
    const j = k / 1440, lst = Astro.n360(Astro.gmst(j) + lon), s = Astro.sole(j);
    if (Astro.altezza(s.ra, s.dec, lat, lst) < 0) continue;
    const l = Astro.luna(j), q = lunaDaQui(l, lat, lst), sep = Astro.separazione(q.ra, q.dec, s.ra, s.dec);
    if (sep >= 0.2666 / s.dist + Math.asin(1737.4 / l.dist) * DEG) continue;
    if (a == null) a = j;
    b = j;
    if (sep < min) { min = sep; m = j; }
  }
  return a == null ? null : { a, m, b };
}
Object.assign(TESTI.it, {
  ev_cg_luna: "La Luna vicino {o}", ev_cg_copre: "La Luna copre {o}", ev_cg_pianeti: "{a} e {b} vicini",
  cg_mercurio: "a Mercurio", cg_venere: "a Venere", cg_marte: "a Marte", cg_giove: "a Giove", cg_saturno: "a Saturno", cg_regolo: "a Regolo",
  cg_spica: "a Spica", cg_antares: "ad Antares", cg_aldebaran: "ad Aldebaran", cg_pleiadi: "alle Pleiadi",
  ev_cg_n: "distanti {d}° alle {h}, a {dir} ({alt}° di altezza)", ev_cg_copre_n: "verso le {h}, a {dir} ({alt}° di altezza): col binocolo vedi la Luna passarci davanti",
  stella_regolo: "Regolo", stella_spica: "Spica", stella_antares: "Antares", stella_aldebaran: "Aldebaran", stella_pleiadi: "le Pleiadi",
});
Object.assign(TESTI.de, {
  ev_cg_luna: "Der Mond nahe {o}", ev_cg_copre: "Der Mond bedeckt {o}", ev_cg_pianeti: "{a} und {b} nah beieinander",
  cg_mercurio: "Merkur", cg_venere: "Venus", cg_marte: "Mars", cg_giove: "Jupiter", cg_saturno: "Saturn", cg_regolo: "Regulus",
  cg_spica: "Spica", cg_antares: "Antares", cg_aldebaran: "Aldebaran", cg_pleiadi: "den Plejaden",
  ev_cg_n: "{d}° voneinander entfernt um {h} Uhr, im {dir} ({alt}° hoch)", ev_cg_copre_n: "gegen {h} Uhr, im {dir} ({alt}° hoch): Mit dem Fernglas sehen Sie, wie der Mond davor vorbeizieht",
  stella_regolo: "Regulus", stella_spica: "Spica", stella_antares: "Antares", stella_aldebaran: "Aldebaran", stella_pleiadi: "die Plejaden",
});
Object.assign(TESTI.es, {
  ev_cg_luna: "La Luna cerca de {o}", ev_cg_copre: "La Luna oculta {o}", ev_cg_pianeti: "{a} y {b}, juntos",
  cg_mercurio: "Mercurio", cg_venere: "Venus", cg_marte: "Marte", cg_giove: "Júpiter", cg_saturno: "Saturno", cg_regolo: "Régulo",
  cg_spica: "Espiga", cg_antares: "Antares", cg_aldebaran: "Aldebarán", cg_pleiadi: "las Pléyades",
  ev_cg_n: "separados {d}° a las {h}, hacia el {dir} ({alt}° de altura)", ev_cg_copre_n: "hacia las {h}, al {dir} ({alt}° de altura): con prismáticos ves cómo la Luna pasa por delante",
  stella_regolo: "Régulo", stella_spica: "Espiga", stella_antares: "Antares", stella_aldebaran: "Aldebarán", stella_pleiadi: "las Pléyades",
});
Object.assign(TESTI.en, {
  ev_cg_luna: "The Moon near {o}", ev_cg_copre: "The Moon covers {o}", ev_cg_pianeti: "{a} and {b} close together",
  cg_mercurio: "Mercury", cg_venere: "Venus", cg_marte: "Mars", cg_giove: "Jupiter", cg_saturno: "Saturn", cg_regolo: "Regulus",
  cg_spica: "Spica", cg_antares: "Antares", cg_aldebaran: "Aldebaran", cg_pleiadi: "the Pleiades",
  ev_cg_n: "{d}° apart at {h}, in the {dir} ({alt}° high)", ev_cg_copre_n: "around {h}, in the {dir} ({alt}° high): with binoculars you'll see the Moon pass in front of it",
  stella_regolo: "Regulus", stella_spica: "Spica", stella_antares: "Antares", stella_aldebaran: "Aldebaran", stella_pleiadi: "the Pleiades",
});
Object.assign(ICONE_SVG, { congiunzione: '<circle cx="9.2" cy="13.6" r="5.4"/><circle class="pieno" cx="17.6" cy="7.4" r="2.4"/>' });
const CG_PIANETI = ["mercurio", "venere", "marte", "giove", "saturno"];
const CG_STELLE = [["regolo", 152.0930, 11.9672], ["spica", 201.2983, -11.1613], ["antares", 247.3519, -26.4320], ["aldebaran", 68.9802, 16.5093],
  ["pleiadi", 56.8712, 24.1051]];
function lunaDaQui(l, lat, lst) {
  const u = Math.atan(0.99664719 * Math.tan(lat * RAD)), rs = 0.99664719 * Math.sin(u), rc = Math.cos(u), sp = Math.sin(l.par * RAD);
  const H = (lst - l.ra) * RAD, d = l.dec * RAD;
  const da = Math.atan2(-rc * sp * Math.sin(H), Math.cos(d) - rc * sp * Math.cos(H));
  const dec = Math.atan2((Math.sin(d) - rs * sp) * Math.cos(da), Math.cos(d) - rc * sp * Math.cos(H));
  return { ra: Astro.n360(l.ra + da * DEG), dec: dec * DEG };
}
function vediCoppia(jm, posA, posB, lat, lon) {
  let meglio = null;
  for (let k = Math.ceil((jm - 0.5) * 48); k <= (jm + 0.5) * 48; k++) {
    const j = k / 48, lst = Astro.n360(Astro.gmst(j) + lon), s = Astro.sole(j);
    if (Astro.altezza(s.ra, s.dec, lat, lst) > -6) continue;
    const a = posA(j, lst), b = posB(j, lst);
    const [ha] = Astro.altAz(a.ra, a.dec, lat, lst), [hb, az] = Astro.altAz(b.ra, b.dec, lat, lst);
    if (Math.min(ha, hb) < 8) continue;
    const d = Astro.separazione(a.ra, a.dec, b.ra, b.dec);
    if (!meglio || d < meglio.d) meglio = { j, d, alt: Math.min(ha, hb), az };
  }
  return meglio;
}
function congiunzioni(j0, j1, lat, lon) {
  const jp = Math.floor(j0 - 0.5) + 0.5, fuori = [], giorni = Math.ceil(j1 - jp) + 2;
  const P = {};
  for (const p of CG_PIANETI) { P[p] = []; for (let g = 0; g <= giorni; g++) P[p].push(Astro.pianeta(p, jp + g)); }
  const posP = (p, j) => {
    const x = clamp(j - jp, 0, giorni - 1e-6), i = Math.floor(x), f = x - i, a = P[p][i], b = P[p][i + 1];
    return { ra: Astro.n360(a.ra + (((b.ra - a.ra + 540) % 360) - 180) * f), dec: a.dec + (b.dec - a.dec) * f };
  };
  const vicinoAlSole = (j, ra, dec) => { const s = Astro.sole(j); return Astro.separazione(ra, dec, s.ra, s.dec) < 15; };
  const quando = (j, d, alt, az) => ({ h: ora(dataJ(j)), d: num(d, d < 1 ? 1 : 1), alt: num(alt), dir: direzione(az) });
  const L = [];
  for (let k = Math.ceil(j0 * 12); k / 12 <= j1; k++) L.push([k / 12, Astro.luna(k / 12)]);
  const corpi = [...CG_PIANETI.map(p => ({ k: p, pos: j => posP(p, j), max: 2.5 })),
    ...CG_STELLE.map(([k, ra, dec]) => { const [r, d] = Astro.precessa(ra, dec, (j0 + j1) / 2); return { k, pos: () => ({ ra: r, dec: d }), max: 1.2 }; })];
  for (const c of corpi) {
    const s = L.map(([j, l]) => { const p = c.pos(j); return Astro.separazione(l.ra, l.dec, p.ra, p.dec); });
    for (let i = 1; i < s.length - 1; i++) {
      if (!(s[i] <= s[i - 1] && s[i] < s[i + 1] && s[i] < c.max + 1.1)) continue;
      const jm = L[i][0];
      if (c.max > 2 && vicinoAlSole(jm, c.pos(jm).ra, c.pos(jm).dec)) continue;
      const v = vediCoppia(jm, (j, lst) => lunaDaQui(Astro.luna(j), lat, lst), j => c.pos(j), lat, lon);
      if (!v || v.d > c.max) continue;
      const copre = v.d < 0.26 && c.max < 2;
      fuori.push({ j: v.j, giorno: dataJ(v.j), tipo: "congiunzione", chiave: c.k, titolo: copre ? t("ev_cg_copre", { o: t("stella_" + c.k) }) : t("ev_cg_luna", { o: t("cg_" + c.k) }),
        testo: t(copre ? "ev_cg_copre_n" : "ev_cg_n", quando(v.j, v.d, v.alt, v.az)) });
    }
  }
  for (let a = 0; a < CG_PIANETI.length; a++) for (let b = a + 1; b < CG_PIANETI.length; b++) {
    const pa = CG_PIANETI[a], pb = CG_PIANETI[b];
    const s = P[pa].map((x, g) => Astro.separazione(x.ra, x.dec, P[pb][g].ra, P[pb][g].dec));
    for (let g = 1; g < s.length - 1; g++) {
      if (!(s[g] <= s[g - 1] && s[g] < s[g + 1] && s[g] < 2) || jp + g > j1) continue;
      const jm = jp + g;
      if (vicinoAlSole(jm, P[pa][g].ra, P[pa][g].dec)) continue;
      const v = vediCoppia(jm, j => posP(pa, j), j => posP(pb, j), lat, lon);
      if (!v || v.d > 1.5) continue;
      fuori.push({ j: v.j, giorno: dataJ(v.j), tipo: "congiunzione", chiave: pa + "-" + pb, titolo: t("ev_cg_pianeti", { a: t("pianeta_" + pa), b: t("pianeta_" + pb) }),
        testo: t("ev_cg_n", quando(v.j, v.d, v.alt, v.az)) });
    }
  }
  return fuori;
}
const _eventi = new Map();
function eventiCielo(lat, lon) {
  const oggi = new Date(), j0 = Astro.jd(oggi), j1 = j0 + 366, s0 = Astro.sole(j0);
  const ieri = oggi.getHours() < 12 && Astro.altezza(s0.ra, s0.dec, lat, Astro.n360(Astro.gmst(j0) + lon)) < -6;
  const chiave = `${isoData(oggi)}${ieri ? "n" : ""}|${lat}|${lon}`;
  if (_eventi.has(chiave)) return _eventi.get(chiave);
  const ev = [], inizioNotte = new Date(oggi.getFullYear(), oggi.getMonth(), oggi.getDate() - (ieri ? 1 : 0), 0);
  for (const [sigla, m, g] of SCIAMI) {
    const zhr = SCIAMI_IMO.find(s => s[0] === sigla)[2];
    let d = new Date(oggi.getFullYear(), m - 1, g, 12);
    if (d < inizioNotte) d = new Date(oggi.getFullYear() + 1, m - 1, g, 12);
    const nt = Astro.notte(d, lat, lon, 20);
    let su = 0;
    for (const i of nt.buio) if (nt.hLuna[i] > 0) su++;
    const disturbo = nt.buio.length ? su / nt.buio.length * nt.fase.k : nt.fase.k;
    ev.push({ j: Astro.jd(d), giorno: d, tipo: "meteore", titolo: t("sciame_" + sigla),
      testo: `${t("ev_meteore", { z: zhr })} · ${t(disturbo < 0.15 ? "ev_luna_ok" : disturbo < 0.4 ? "ev_luna_media" : "ev_luna_no", { p: num(nt.fase.k * 100) })}` });
  }
  for (const p of ["marte", "giove", "saturno", "urano", "nettuno"]) {
    const o = prossimaOpposizione(p, j0);
    if (o && o.j < j1) ev.push({ j: o.j, giorno: Astro.data(o.j), tipo: "pianeta", titolo: t("ev_opposizione", { p: t("pianeta_" + p) }),
      testo: t("ev_opposizione_n", { d: num(o.diam, 1) }) });
  }
  try { ev.push(...congiunzioni(j0, j1, lat, lon)); } catch (e) { console.error("strumenti, congiunzioni:", e); }
  for (const [lonS, nome] of [[0, "ev_equ_prim"], [90, "ev_sol_est"], [180, "ev_equ_aut"], [270, "ev_sol_inv"]]) {
    const j = solePunto(j0, lonS);
    if (j && j < j1) ev.push({ j, giorno: Astro.data(j), tipo: "sole", titolo: t(nome), testo: t("ev_stagione", { o: ora(Astro.data(j)) }) });
  }
  let j = j0;
  for (let n = 0; n < 14; n++) {
    const jp = Astro.prossimaFase(j, 180);
    if (!jp || jp > j1) break;
    const l = Astro.luna(jp);
    if (l.dist < 360000) ev.push({ j: jp, giorno: Astro.data(jp), tipo: "luna", titolo: t("ev_superluna"), testo: t("ev_superluna_n", { km: num(l.dist) }) });
    const e = eclissiLuna(jp);
    if (e && (e.tipo !== "pen" || e.grandezza >= 0.6)) {
      const lm = Astro.luna(e.j), h = Astro.altezzaLuna(lm, lat, Astro.n360(Astro.gmst(e.j) + lon));
      ev.push({ j: e.j, giorno: Astro.data(e.j), tipo: "eclissi", titolo: t(e.tipo === "tot" ? "ev_ecl_tot" : e.tipo === "parz" ? "ev_ecl_parz" : "ev_ecl_pen"),
        testo: t("ev_ecl_n", { o: ora(Astro.data(e.j)), v: h > 0 ? t("ev_visibile", { h: num(h) }) : t("ev_non_visibile") })
          + (e.tipo === "pen" ? " · " + t("ev_ecl_pen_n") : ""), visibile: h > 0 });
    }
    j = jp + 1;
  }
  const jIt = Astro.jd(new Date(Date.UTC(2027, 7, 2, 9, 15)));
  if (jIt > j0 && jIt < j1) {
    const es = eclissiSoleQui(jIt - 3.25 / 24, jIt + 4.75 / 24, lat, lon), jsol = es ? es.m : jIt;
    ev.push(Object.assign({ j: jsol, giorno: dataJ(jsol), tipo: "eclissi", chiave: "sole", titolo: t("ev_ecl_sole"), testo: t("ev_ecl_sole_n"), visibile: !!es },
      es ? { inizio: dataJ(es.a), fine: dataJ(es.b) } : null));
  }
  ev.sort((a, b) => a.j - b.j);
  _eventi.set(chiave, ev);
  return ev;
}
Object.assign(TESTI.it, { ev_cal: "Aggiungi al calendario", ev_cal_tutti: "Aggiungi tutti al calendario", ev_cal_da: "Dagli strumenti di Giordano Astronomia" });
Object.assign(TESTI.de, { ev_cal: "Zum Kalender hinzufügen", ev_cal_tutti: "Alle zum Kalender hinzufügen", ev_cal_da: "Aus den Werkzeugen von Giordano Astronomia" });
Object.assign(TESTI.es, { ev_cal: "Añadir al calendario", ev_cal_tutti: "Añadir todos al calendario", ev_cal_da: "De las herramientas de Giordano Astronomia" });
const icsTesto = s => String(s || "").replace(/\\/g, "\\\\").replace(/;/g, "\\;").replace(/,/g, "\\,").replace(/\r?\n/g, "\\n");
const icsData = d => d.toISOString().replace(/[-:]/g, "").replace(/\.\d{3}/, "");
const icsGiorno = d => `${d.getFullYear()}${String(d.getMonth() + 1).padStart(2, "0")}${String(d.getDate()).padStart(2, "0")}`;
const ICS_UTF8 = new TextEncoder();
const icsPiega = r => {
  if (ICS_UTF8.encode(r).length <= 75) return r;
  const parti = [];
  let cur = "", n = 0, max = 75;
  for (const ch of r) {
    const b = ICS_UTF8.encode(ch).length;
    if (n + b > max) { parti.push(cur); cur = ""; n = 0; max = 74; }
    cur += ch; n += b;
  }
  parti.push(cur);
  return parti.join("\r\n ");
};
function icsEventi(lista, nome) {
  const url = urlEventi(), adesso = icsData(new Date());
  const righe = ["BEGIN:VCALENDAR", "VERSION:2.0", "PRODID:-//Giordano Astronomia//Strumenti//" + String(LINGUA).toUpperCase(), "CALSCALE:GREGORIAN", "METHOD:PUBLISH"];
  if (nome) righe.push("X-WR-CALNAME:" + icsTesto(`${nome} · Giordano Astronomia`));
  for (const e of lista) {
    const { conOra, a, b } = tempiEvento(e);
    righe.push("BEGIN:VEVENT", `UID:${e.chiave ? chiaveEvento(e) : `${e.tipo}-${icsData(e.giorno)}`}@giordanoastronomia.it`, "DTSTAMP:" + adesso,
      ...(conOra ? ["DTSTART:" + icsData(a), "DTEND:" + icsData(b)] : ["DTSTART;VALUE=DATE:" + icsGiorno(a), "DTEND;VALUE=DATE:" + icsGiorno(b)]),
      "SUMMARY:" + icsTesto(e.titolo), "DESCRIPTION:" + icsTesto(`${e.testo || ""}\n${t("ev_cal_da")}: ${url}`), "URL:" + url,
      "BEGIN:VALARM", "ACTION:DISPLAY", "DESCRIPTION:" + icsTesto(e.titolo), "TRIGGER:" + (conOra ? "-PT2H" : "-PT10H"), "END:VALARM", "END:VEVENT");
  }
  righe.push("END:VCALENDAR");
  return righe.map(icsPiega).join("\r\n") + "\r\n";
}
Object.assign(TESTI.it, { ev_cal_apple: "Calendario del dispositivo (iPhone, Android, Mac)", ev_cal_google: "Google Calendar", ev_cal_outlook: "Outlook" });
Object.assign(TESTI.de, { ev_cal_apple: "Gerätekalender (iPhone, Android, Mac)", ev_cal_google: "Google Kalender", ev_cal_outlook: "Outlook" });
Object.assign(TESTI.es, { ev_cal_apple: "Calendario del dispositivo (iPhone, Android, Mac)", ev_cal_google: "Google Calendar", ev_cal_outlook: "Outlook" });
const IOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
const IOS_SAFARI = IOS && !/CriOS|FxiOS|EdgiOS|OPiOS|GSA\//.test(navigator.userAgent);
const ICS_NEGOZIO = "/apps/strumenti/ics";
async function urlIcs(lista, nome, webcal) {
  const byte = new TextEncoder().encode(icsEventi(lista, nome));
  let dati = byte, z = false;
  if (typeof CompressionStream === "function") {
    try { dati = new Uint8Array(await new Response(new Blob([byte]).stream().pipeThrough(new CompressionStream("deflate-raw"))).arrayBuffer()); z = true; } catch (e) { dati = byte; z = false; }
  }
  let bin = "";
  for (let i = 0; i < dati.length; i += 0x8000) bin += String.fromCharCode.apply(null, dati.subarray(i, i + 0x8000));
  const base = (webcal ? "webcal://" + location.host : location.origin) + ICS_NEGOZIO;
  return `${base}?d=${btoa(bin).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "")}${z ? "&z=1" : ""}&n=${encodeURIComponent(String(nome).slice(0, 60))}`;
}
function scaricaIcs(lista, nome, avviso, chiave) {
  if (IOS) {
    if (!ICS_NEGOZIO) return;
    if (avviso) avviso.hidden = false;
    if (SOLO_SAFARI) { urlIcs(lista, nome).then(u => { location.href = "x-safari-" + u; }).catch(() => { location.href = linkSafari(chiave); }); return; }
    if (chiave) { _icsMio = chiave; try { history.replaceState(history.state, "", "#" + SCHEDA_ICS() + "?ics=" + encodeURIComponent(chiave)); } catch (e) {   } }
    urlIcs(lista, nome).then(u => { location.href = u; });
    return;
  }
  scaricaTesto(icsEventi(lista, nome), `${String(nome).replace(/[^\w\u00C0-\u017F]+/g, "-").replace(/^-|-$/g, "") || "eventi"}.ics`, "text/calendar;charset=utf-8");
}
Object.assign(TESTI.it, { ev_cal_no: "Il Calendario non si \u00E8 aperto?", ev_cal_iscriviti: "Iscriviti al calendario", ev_cal_iscriviti_n: "Funziona da qualsiasi app: tocca «Iscriviti», poi «Aggiungi»." });
Object.assign(TESTI.de, { ev_cal_no: "Der Kalender hat sich nicht ge\u00F6ffnet?", ev_cal_iscriviti: "Kalender abonnieren", ev_cal_iscriviti_n: "Geht aus jeder App: auf \u00ABAbonnieren\u00BB und dann \u00ABHinzuf\u00FCgen\u00BB tippen." });
Object.assign(TESTI.es, { ev_cal_no: "\u00BFNo se ha abierto el Calendario?", ev_cal_iscriviti: "Suscribirse al calendario", ev_cal_iscriviti_n: "Funciona desde cualquier app: toca \u00ABSuscribirse\u00BB y luego \u00ABA\u00F1adir\u00BB." });
function avvisoIcs(lista, nome) {
  if (!IOS || !ICS_NEGOZIO) return null;
  const a = el("a", { class: "gas-btn gas-btn--chiaro gas-btn--mini" }, icona("calendario"), " ", t("ev_cal_iscriviti"));
  urlIcs(lista, nome, true).then(u => { a.href = u; });
  return el("div", { class: "gas-ev-avviso", hidden: true }, el("b", null, t("ev_cal_no")), a, el("small", null, t("ev_cal_iscriviti_n")));
}
const tempiEvento = e => {
  if (e.inizio && e.fine) return { conOra: true, a: e.inizio, b: e.fine };
  const conOra = ["eclissi", "sole", "congiunzione"].includes(e.tipo), mezzo = e.tipo === "eclissi" ? 90 : e.tipo === "congiunzione" ? 45 : 15;
  return conOra ? { conOra, a: new Date(e.giorno.getTime() - mezzo * 60000), b: new Date(e.giorno.getTime() + mezzo * 60000) }
    : { conOra, a: e.giorno, b: new Date(e.giorno.getTime() + 86400000) };
};
function linkGoogle(e) {
  const { conOra, a, b } = tempiEvento(e), f = d => conOra ? icsData(d) : icsGiorno(d);
  return "https://calendar.google.com/calendar/render?action=TEMPLATE&text=" + encodeURIComponent(e.titolo) + "&dates=" + f(a) + "/" + f(b) +
    "&details=" + encodeURIComponent(`${e.testo || ""}\n${t("ev_cal_da")}: ${urlEventi()}`);
}
function linkOutlook(e) {
  const { conOra, a, b } = tempiEvento(e), f = d => conOra ? d.toISOString().replace(/\.\d{3}Z$/, "Z") : isoData(d);
  return "https://outlook.live.com/calendar/0/deeplink/compose?path=%2Fcalendar%2Faction%2Fcompose&rru=addevent&subject=" + encodeURIComponent(e.titolo) +
    "&startdt=" + encodeURIComponent(f(a)) + "&enddt=" + encodeURIComponent(f(b)) + "&allday=" + (conOra ? "false" : "true") + "&body=" + encodeURIComponent(e.testo || "");
}
Object.assign(TESTI.it, { ev_cal_safari: "Apri in Safari e aggiungi al Calendario", ev_cal_tutti_safari: "Aggiungi tutti (si apre Safari)",
  ev_cal_qui: "Aggiungi al Calendario dell'iPhone", ev_cal_tutti_n: "Tutti i prossimi eventi del cielo" });
Object.assign(TESTI.de, { ev_cal_safari: "In Safari öffnen und zum Kalender hinzufügen", ev_cal_tutti_safari: "Alle hinzufügen (öffnet Safari)",
  ev_cal_qui: "Zum iPhone-Kalender hinzufügen", ev_cal_tutti_n: "Alle nächsten Himmelsereignisse" });
Object.assign(TESTI.es, { ev_cal_safari: "Abrir en Safari y añadir al Calendario", ev_cal_tutti_safari: "Añadir todos (se abre Safari)",
  ev_cal_qui: "Añadir al Calendario del iPhone", ev_cal_tutti_n: "Todos los próximos eventos del cielo" });
const chiaveEvento = e => `${e.tipo}-${icsData(e.giorno).slice(0, 8)}${e.chiave ? "-" + e.chiave : ""}`;
const SCHEDA_ICS = () => NAV4 ? "eventi" : "lunasole";
const urlEventi = () => location.origin + urlScheda(SCHEDA_ICS()) + "#" + SCHEDA_ICS();
const linkSafari = k => "x-safari-" + urlEventi() + "?ics=" + encodeURIComponent(k);
let _icsMio = "", _icsScorso = "";
const SOLO_SAFARI = IOS && !IOS_SAFARI;
function menuCalendario(e) {
  const avviso = avvisoIcs([e], e.titolo);
  return el("div", { class: "gas-ev-menu" },
    !IOS || ICS_NEGOZIO ? el("button", { type: "button", class: "gas-btn gas-btn--mini" + (IOS ? "" : " gas-btn--chiaro"), onclick: () => scaricaIcs([e], e.titolo, avviso, chiaveEvento(e)) },
      icona("calendario"), " ", t(!IOS ? "ev_cal_apple" : SOLO_SAFARI ? "ev_cal_safari" : "ev_cal_qui")) : null,
    el("a", { class: "gas-btn gas-btn--chiaro gas-btn--mini", href: linkGoogle(e), target: "_blank", rel: "noopener" }, t("ev_cal_google")),
    el("a", { class: "gas-btn gas-btn--chiaro gas-btn--mini", href: linkOutlook(e), target: "_blank", rel: "noopener" }, t("ev_cal_outlook")),
    avviso);
}
const PRIMI_EVENTI = 8;
function cartaEventi(lat, lon, scegli) {
  const ev = eventiCielo(lat, lon);
  const ico = e => e.tipo === "meteore" ? icona("meteora") : e.tipo === "pianeta" ? icona("pianeta") : e.tipo === "sole" ? icona("sole")
    : e.tipo === "eclissi" ? icona("eclissi") : e.tipo === "congiunzione" ? icona("congiunzione") : iconaLuna({ k: 1, crescente: true });
  const notteDi = e => {
    const d = e.giorno, j = Astro.jd(d), s = Astro.sole(j);
    const buio = Astro.altezza(s.ra, s.dec, lat, Astro.n360(Astro.gmst(j) + lon)) < -0.833;
    return NAV4 && d.getHours() < 12 && buio ? new Date(d.getFullYear(), d.getMonth(), d.getDate() - 1, 12) : d;
  };
  const lista = el("ul", { class: "gas-ev" }, ev.map((e, i) => el("li", { class: "gas-ev-voce gas-ev--" + e.tipo + (e.visibile === false ? " gas-ev--no" : ""),
    hidden: i >= PRIMI_EVENTI },
    el("button", { type: "button", class: "gas-ev-apri", onclick: () => scegli(isoData(notteDi(e))) },
      el("span", { class: "gas-ev-ico" }, ico(e)),
      el("span", { class: "gas-ev-data" }, el("b", null, e.giorno.toLocaleDateString(LOCALE, { day: "numeric" })),
        el("small", null, e.giorno.toLocaleDateString(LOCALE, { month: "short", year: "2-digit" }))),
      el("span", { class: "gas-ev-testo" }, el("b", null, e.titolo), el("small", null, e.testo))),
    el("button", { type: "button", class: "gas-ev-cal", title: t("ev_cal"), "aria-label": `${t("ev_cal")}: ${e.titolo}`, "aria-expanded": "false",
      onclick: ev2 => {
        ev2.stopPropagation();
        const li = ev2.currentTarget.closest("li"), aperto = li.querySelector(".gas-ev-menu");
        lista.querySelectorAll(".gas-ev-menu").forEach(m => m.remove());
        lista.querySelectorAll(".gas-ev-cal").forEach(b => b.setAttribute("aria-expanded", "false"));
        if (!aperto) { li.appendChild(menuCalendario(e)); ev2.currentTarget.setAttribute("aria-expanded", "true"); }
      } }, icona("calendario")))));
  const tutti = ev.length > PRIMI_EVENTI ? el("button", { type: "button", class: "gas-btn gas-btn--chiaro gas-ev-tutti",
    onclick: b => { lista.querySelectorAll("li[hidden]").forEach(x => { x.hidden = false; }); b.currentTarget.remove(); } }, t("ev_tutti", { n: ev.length })) : null;
  const avvisoTutti = avvisoIcs(ev, t("ev_titolo"));
  const tuttiCal = !IOS || ICS_NEGOZIO ? el("button", { type: "button", class: "gas-btn gas-btn--chiaro gas-ev-tutti", onclick: () => scaricaIcs(ev, t("ev_titolo"), avvisoTutti, "tutti") },
    icona("calendario"), " ", t(SOLO_SAFARI ? "ev_cal_tutti_safari" : "ev_cal_tutti")) : null;
  const chiaveHash = new URLSearchParams((location.hash.split("?")[1] || "")).get("ics");
  const chiave = chiaveHash && chiaveHash !== _icsMio ? chiaveHash : null;
  const daAggiungere = !IOS || ICS_NEGOZIO ? (chiave === "tutti" ? ev : chiave ? ev.filter(e => chiaveEvento(e) === chiave) : []) : [];
  const nomeArrivo = daAggiungere.length > 1 ? t("ev_titolo") : daAggiungere.length ? daAggiungere[0].titolo : "";
  const avvisoArrivo = daAggiungere.length ? avvisoIcs(daAggiungere, nomeArrivo) : null;
  if (avvisoArrivo) avvisoArrivo.hidden = false;
  const arrivo = daAggiungere.length ? el("div", { class: "gas-ev-arrivo" },
    el("b", null, chiave === "tutti" ? t("ev_cal_tutti_n") : daAggiungere[0].titolo),
    el("button", { type: "button", class: "gas-btn", onclick: () => scaricaIcs(daAggiungere, nomeArrivo, null, chiave) },
      icona("calendario"), " ", t(IOS ? "ev_cal_qui" : "ev_cal_apple")), avvisoArrivo) : null;
  const carta = scheda(t("ev_titolo"), arrivo, el("p", { class: "gas-nota" }, t("ev_n")), lista, tutti, tuttiCal, avvisoTutti);
  if (arrivo && _icsScorso !== chiave) setTimeout(() => {
    if (carta.isConnected && _icsScorso !== chiave) { _icsScorso = chiave; carta.scrollIntoView({ behavior: "smooth", block: "start" }); }
  }, 400);
  return carta;
}
Object.assign(TESTI.it, {
  mtr_titolo: "Meteore di stanotte", mtr_n: "Quante meteore all'ora puoi vedere {l_da}, ora per ora, tenendo conto del tuo cielo e della Luna (calendario dell'International Meteor Organization).",
  mtr_max: "fino a {n} all'ora verso le {o}", mtr_poche: "meno di una all'ora da qui", mtr_info: "Radiante alto {h}° · {v} km/s · lo sciame nasce da {p}",
  mtr_nessuno: "Stanotte nessuno sciame importante.", mtr_prossimo: "Il prossimo: {n}, con il picco il {d} (fino a {z} meteore all'ora).",
  mtr_sporadiche: "In più ci sono le meteore sporadiche: circa {n} all'ora dopo mezzanotte, da qualsiasi direzione.", mtr_luna: "La Luna ({p} %) nasconde le più deboli.",
  mtr_consiglio: "Guarda a 40–50° dal radiante (il punto da cui sembrano partire le meteore), sdraiato, dopo 20 minuti al buio per abituare gli occhi.",
  sciame_CAP: "Alfa Capricornidi", sciame_STA: "Tauridi del Sud", sciame_NTA: "Tauridi del Nord",
});
Object.assign(TESTI.de, {
  mtr_titolo: "Meteore heute Nacht", mtr_n: "Wie viele Meteore pro Stunde Sie {l_da} sehen können, Stunde für Stunde, unter Berücksichtigung Ihres Himmels und des Mondes (IMO-Kalender).",
  mtr_max: "bis zu {n} pro Stunde gegen {o} Uhr", mtr_poche: "von hier weniger als eine pro Stunde", mtr_info: "Radiant {h}° hoch · {v} km/s · stammt von {p}",
  mtr_nessuno: "Heute Nacht kein wichtiger Meteorstrom.", mtr_prossimo: "Der nächste: {n}, Maximum am {d} (ZHR {z}).",
  mtr_sporadiche: "Dazu die sporadischen Meteore: etwa {n} pro Stunde nach Mitternacht, aus allen Richtungen.", mtr_luna: "Der Mond ({p} %) verbirgt die schwächsten.",
  mtr_consiglio: "Schauen Sie 40–50° vom Radianten entfernt, liegend, nach 20 Minuten im Dunkeln.",
  sciame_CAP: "Alpha-Capricorniden", sciame_STA: "Südliche Tauriden", sciame_NTA: "Nördliche Tauriden",
});
Object.assign(TESTI.es, {
  mtr_titolo: "Meteoros de esta noche", mtr_n: "Cuántos meteoros por hora puedes ver {l_da}, hora a hora, teniendo en cuenta tu cielo y la Luna (calendario IMO).",
  mtr_max: "hasta {n} por hora hacia las {o}", mtr_poche: "menos de uno por hora desde aquí", mtr_info: "Radiante a {h}° · {v} km/s · procede de {p}",
  mtr_nessuno: "Esta noche ninguna lluvia importante.", mtr_prossimo: "La próxima: {n}, con su máximo el {d} (hasta {z} meteoros por hora).",
  mtr_sporadiche: "A esto se suman los meteoros esporádicos: unos {n} por hora después de medianoche, desde cualquier dirección.", mtr_luna: "La Luna ({p} %) oculta los más débiles.",
  mtr_consiglio: "Mira a 40–50° del radiante, tumbado, tras 20 minutos a oscuras.",
  sciame_CAP: "Alfa Capricórnidas", sciame_STA: "Táuridas del Sur", sciame_NTA: "Táuridas del Norte",
});
Object.assign(TESTI.en, {
  mtr_titolo: "Meteors tonight", mtr_n: "How many meteors per hour you can see {l_da}, hour by hour, allowing for your sky and the Moon (IMO calendar).",
  mtr_max: "up to {n} an hour around {o}", mtr_poche: "fewer than one an hour from here", mtr_info: "Radiant {h}° high · {v} km/s · from {p}",
  mtr_nessuno: "No major shower tonight.", mtr_prossimo: "Next: {n}, peaking on {d} (up to {z} meteors an hour).",
  mtr_sporadiche: "Plus sporadic meteors: about {n} an hour after midnight, from any direction.", mtr_luna: "The Moon ({p}%) hides the faintest ones.",
  mtr_consiglio: "Look 40–50° away from the radiant, lying down, after 20 minutes in the dark.",
  sciame_CAP: "Alpha Capricornids", sciame_STA: "Southern Taurids", sciame_NTA: "Northern Taurids",
});
const SCIAMI_IMO = [
  ["QUA", 283.15, 80, 2.5, 2.1, 230, 49, 41, "2003 EH1"],
  ["LYR", 32.32, 18, 0.3, 2.1, 271, 34, 49, "C/1861 G1 (Thatcher)"],
  ["ETA", 45.5, 50, 0.08, 2.4, 338, -1, 66, "1P/Halley"],
  ["SDA", 127, 25, 0.08, 3.2, 340, -16, 41, "96P/Machholz"],
  ["CAP", 127, 5, 0.06, 2.5, 307, -10, 23, "169P/NEAT"],
  ["PER", 140.0, 100, 0.2, 2.2, 48, 58, 59, "109P/Swift-Tuttle"],
  ["DRA", 195.4, 10, 1.0, 2.6, 262, 54, 20, "21P/Giacobini-Zinner"],
  ["STA", 197, 5, 0.03, 2.3, 32, 9, 27, "2P/Encke"],
  ["ORI", 208, 20, 0.12, 2.5, 95, 16, 66, "1P/Halley"],
  ["NTA", 230, 5, 0.03, 2.3, 58, 22, 29, "2P/Encke"],
  ["LEO", 235.27, 15, 0.4, 2.5, 152, 22, 71, "55P/Tempel-Tuttle"],
  ["GEM", 262.2, 150, 0.45, 2.6, 112, 33, 35, "3200 Phaethon"],
  ["URS", 270.7, 10, 0.9, 3.0, 217, 76, 33, "8P/Tuttle"],
];
const lambdaSole = jd => Astro.n360(Astro.sole(jd).lon - 1.39697 * (jd - 2451545) / 36525);
const zhrSciame = (s, jd) => s[2] * Math.pow(10, -s[3] * Math.abs(((lambdaSole(jd) - s[1]) % 360 + 540) % 360 - 180));
const limiteOcchio = () => 7.93 - 5 * Math.log10(Math.pow(10, 4.316 - sqmLuogo() / 5) + 1);
function meteoreNotte(s, nt) {
  const curva = Astro.curvaOggetto(nt, s[5], s[6]), lm0 = limiteOcchio(), k = nt.fase.k, ore = [];
  for (const i of nt.buio.length ? nt.buio : []) {
    const d = dataJ(nt.tempi[i]);
    if (d.getMinutes() > 9) continue;
    const lm = Math.min(6.5, lm0 - (nt.hLuna[i] > 0 ? 0.3 + 2.2 * k : 0));
    const h = curva.h[i], hr = h > 0 ? zhrSciame(s, nt.tempi[i]) * Math.sin(h * RAD) / Math.pow(s[4], 6.5 - lm) : 0;
    ore.push({ d, h, hr });
  }
  return ore;
}
function graficoMeteore(ore) {
  const W = 300, H = 64, max = Math.max(1, ...ore.map(o => o.hr)), bw = W / Math.max(ore.length, 1);
  return sv("svg", { viewBox: `0 0 ${W} ${H + 14}`, class: "gas-mt-ore", role: "img", "aria-hidden": "true" },
    ...ore.map((o, i) => sv("rect", { x: i * bw + bw * 0.15, y: H - o.hr / max * H, width: bw * 0.7, height: Math.max(o.hr / max * H, o.hr > 0 ? 2 : 0), rx: 2, class: "gas-mt-barra" })),
    ...ore.filter((o, i) => i % 2 === 0).map(o => sv("text", { x: ore.indexOf(o) * bw + bw / 2, y: H + 12, "text-anchor": "middle", class: "gas-gr-testo", text: String(o.d.getHours()).padStart(2, "0") })));
}
function cartaMeteore(cn) {
  const nt = cn.nt, meta = nt.buio.length ? nt.tempi[nt.buio[Math.floor(nt.buio.length / 2)]] : nt.tempi[Math.floor(nt.n / 2)];
  const box = el("section", { class: "gas-card gas-mt" }, el("h3", null, icona("meteora"), " ", t("mtr_titolo")), el("p", { class: "gas-nota" }, t("mtr_n", luogoFrasi())));
  const attivi = SCIAMI_IMO.map(s => ({ s, z: zhrSciame(s, meta) })).filter(x => x.z >= 2).map(x => {
    const ore = meteoreNotte(x.s, nt), top = ore.reduce((a, b) => (b.hr > a.hr ? b : a), { hr: 0 });
    return Object.assign(x, { ore, top });
  }).sort((a, b) => b.top.hr - a.top.hr);
  for (const x of attivi) {
    const s = x.s;
    box.appendChild(el("div", { class: "gas-mt-sciame" },
      el("div", { class: "gas-mt-testa" }, el("b", null, t("sciame_" + s[0])),
        el("span", null, x.top.hr >= 1 ? t("mtr_max", { n: num(x.top.hr), o: ora(x.top.d) }) : t("mtr_poche"))),
      x.ore.length ? graficoMeteore(x.ore) : null,
      el("small", null, t("mtr_info", { h: num(Math.max(...x.ore.map(o => o.h), 0)), v: s[7], p: s[8] }))));
  }
  if (!attivi.length) {
    box.appendChild(el("p", null, t("mtr_nessuno")));
    let prossimo = null;
    for (let g = 1; g <= 366 && !prossimo; g++) {
      const jd = meta + g;
      for (const s of SCIAMI_IMO) if (s[2] >= 15 && Math.abs(((lambdaSole(jd) - s[1]) % 360 + 540) % 360 - 180) < 0.5) { prossimo = { s, jd }; break; }
    }
    if (prossimo) {
      const sera = dataJ(prossimo.jd - 0.5), r = SCIAMI.find(x => x[0] === prossimo.s[0]);
      const d = r ? [-1, 0, 1].map(k => new Date(sera.getFullYear() + k, r[1] - 1, r[2], 12)).reduce((a, b) => (Math.abs(b - sera) < Math.abs(a - sera) ? b : a)) : sera;
      box.appendChild(el("p", { class: "gas-nota" }, t("mtr_prossimo", { n: t("sciame_" + prossimo.s[0]), z: prossimo.s[2],
        d: d.toLocaleDateString(LOCALE, { day: "numeric", month: "long" }) })));
    }
  }
  const lm = Math.min(6.5, limiteOcchio()), spor = 10 / Math.pow(3, 6.5 - lm);
  box.appendChild(el("p", { class: "gas-nota" }, t("mtr_sporadiche", { n: num(Math.max(1, spor)) }),
    nt.fase.k > 0.35 ? " " + t("mtr_luna", { p: num(nt.fase.k * 100) }) : "", attivi.length ? " " + t("mtr_consiglio") : ""));
  for (const f of [...CIELO_UI]) if (!f.box.isConnected) CIELO_UI.delete(f);
  const rifai = () => { CIELO_UI.delete(rifai); if (box.isConnected) box.replaceWith(cartaMeteore({ nt })); };
  rifai.box = box; CIELO_UI.add(rifai);
  return box;
}
Object.assign(TESTI.it, {
  tab_planetario: "Carta del cielo", pl_cielo_sopra: "Il cielo {l_sopra}", pl_adesso: "Adesso", pl_meno: "−1 h", pl_piu: "+1 h", pl_avvia: "Fai scorrere le ore",
  pl_ferma: "Ferma", pl_gira: "Gira la carta", pl_in_basso: "in basso: {d}", pl_nomi: "Nomi", pl_linee: "Costellazioni", pl_messier: "Oggetti Messier",
  pl_istruzioni: "Il centro è il punto sopra la tua testa (zenit), il bordo è l'orizzonte. Tieni la carta sopra la testa con in basso la direzione verso cui guardi. Tocca una stella, un pianeta o un oggetto per vederne il nome.",
  pl_giorno: "È giorno: le stelle non si vedono, ma ecco dove sono.", pl_crepuscolo: "Crepuscolo: si vedono solo le stelle più luminose.", pl_notte: "Notte",
  pl_alt_az: "alt. {h}° · az. {a}°", pl_mag: "mag {m}", pl_inquadra: "Inquadra →", pl_visibili: "Pianeti e Luna sopra l'orizzonte", pl_nessuno: "Nessun pianeta sopra l'orizzonte a quest'ora.",
  pl_scelto: "Oggetto scelto nel Campo inquadrato", pl_card: "N|E|S|O", pl_dir: "nord|est|sud|ovest", pl_sole: "Sole",
});
Object.assign(TESTI.de, {
  tab_planetario: "Sternkarte", pl_cielo_sopra: "Der Himmel {l_sopra}", pl_adesso: "Jetzt", pl_meno: "−1 h", pl_piu: "+1 h", pl_avvia: "Stunden ablaufen lassen",
  pl_ferma: "Stopp", pl_gira: "Karte drehen", pl_in_basso: "unten: {d}", pl_nomi: "Namen", pl_linee: "Sternbilder", pl_messier: "Messier-Objekte",
  pl_istruzioni: "Die Mitte ist der Punkt über Ihrem Kopf (Zenit), der Rand der Horizont. Halten Sie die Karte über den Kopf, mit der Blickrichtung unten. Tippen Sie auf einen Stern, Planeten oder ein Objekt, um den Namen zu sehen.",
  pl_giorno: "Es ist Tag: Die Sterne sind nicht sichtbar, aber hier stehen sie.", pl_crepuscolo: "Dämmerung: nur die hellsten Sterne sind sichtbar.", pl_notte: "Nacht",
  pl_alt_az: "Höhe {h}° · Az. {a}°", pl_mag: "mag {m}", pl_inquadra: "Ins Bildfeld →", pl_visibili: "Planeten und Mond über dem Horizont", pl_nessuno: "Zu dieser Zeit kein Planet über dem Horizont.",
  pl_scelto: "Im Bildfeld gewähltes Objekt", pl_card: "N|O|S|W", pl_dir: "Norden|Osten|Süden|Westen", pl_sole: "Sonne",
});
Object.assign(TESTI.es, {
  tab_planetario: "Carta celeste", pl_cielo_sopra: "El cielo {l_sopra}", pl_adesso: "Ahora", pl_meno: "−1 h", pl_piu: "+1 h", pl_avvia: "Hacer correr las horas",
  pl_ferma: "Parar", pl_gira: "Girar la carta", pl_in_basso: "abajo: {d}", pl_nomi: "Nombres", pl_linee: "Constelaciones", pl_messier: "Objetos Messier",
  pl_istruzioni: "El centro es el punto sobre tu cabeza (cénit) y el borde el horizonte. Sostén la carta sobre la cabeza, con la dirección hacia la que miras en la parte de abajo. Toca una estrella, un planeta o un objeto para ver su nombre.",
  pl_giorno: "Es de día: las estrellas no se ven, pero aquí están.", pl_crepuscolo: "Crepúsculo: solo se ven las estrellas más brillantes.", pl_notte: "Noche",
  pl_alt_az: "alt. {h}° · az. {a}°", pl_mag: "mag {m}", pl_inquadra: "Encuadrar →", pl_visibili: "Planetas y Luna sobre el horizonte", pl_nessuno: "Ningún planeta sobre el horizonte a esta hora.",
  pl_scelto: "Objeto elegido en el campo de visión", pl_card: "N|E|S|O", pl_dir: "norte|este|sur|oeste", pl_sole: "Sol",
});
Object.assign(GUIDA.it, { g_planetario: "Questa è la Carta del cielo: tutto il cielo sopra il luogo scelto. Il centro della carta è il punto sopra la tua testa, il bordo è l'orizzonte, con i punti cardinali. Il cursore sotto la carta fa scorrere le ore della notte, e il bottone Adesso torna all'ora attuale. Vedi le stelle, le costellazioni, la Via Lattea, la Luna con la sua fase, i pianeti e gli oggetti di Messier. Tocca un astro per sapere come si chiama e quanto è alto; per i pianeti e gli oggetti c'è il bottone per inquadrarli con il tuo telescopio." });
Object.assign(GUIDA.de, { g_planetario: "Das ist die Sternkarte: der ganze Himmel über dem gewählten Ort. Die Mitte der Karte ist der Punkt über Ihrem Kopf, der Rand ist der Horizont mit den Himmelsrichtungen. Der Schieberegler lässt die Stunden der Nacht ablaufen, Jetzt springt zur aktuellen Zeit. Sie sehen Sterne, Sternbilder, Milchstraße, Mond mit Phase, Planeten und Messier-Objekte. Tippen Sie auf ein Objekt für Namen und Höhe; bei Planeten und Objekten gibt es einen Knopf, um sie mit Ihrem Teleskop ins Bildfeld zu holen." });
Object.assign(GUIDA.es, { g_planetario: "Esta es la Carta celeste: todo el cielo sobre el lugar elegido. El centro del mapa es el punto sobre tu cabeza y el borde el horizonte, con los puntos cardinales. El control deslizante hace pasar las horas de la noche y Ahora vuelve a la hora actual. Ves las estrellas, las constelaciones, la Vía Láctea, la Luna con su fase, los planetas y los objetos Messier. Toca un astro para saber cómo se llama y su altura; en los planetas y los objetos tienes el botón para encuadrarlos con tu telescopio." });
Object.assign(TESTI.it, { pl_scegli_ora: "Scegli l'ora" });
Object.assign(TESTI.de, { pl_scegli_ora: "Uhrzeit wählen" });
Object.assign(TESTI.es, { pl_scegli_ora: "Elige la hora" });
Object.assign(TESTI.en, { pl_scegli_ora: "Choose the time" });
const PLANETARIO = Object.assign({ nomi: true, linee: true, messier: true, giro: 0 }, ricorda("planetario", {}));
function salvaPlanetario() { salva("planetario", { nomi: PLANETARIO.nomi, linee: PLANETARIO.linee, messier: PLANETARIO.messier, giro: PLANETARIO.giro }); }
const COLORI_PIANETI = { mercurio: "#c9bfae", venere: "#fff3c8", marte: "#ff8a5c", giove: "#f1d9a8", saturno: "#f3dc94", urano: "#a8e6ea", nettuno: "#7f9cff" };
function vistaPlanetario(pannello) {
  svuota(pannello);
  const tela = el("canvas", { class: "gas-pl-tela", role: "img", "aria-label": t("tab_planetario") });
  const fumetto = el("div", { class: "gas-pl-fumetto", hidden: true });
  const titolo = el("p", { class: "gas-pl-titolo" }), stato = el("p", { class: "gas-nota gas-pl-stato" });
  const oraB = el("b", { class: "gas-pl-ora" });
  const cursore = el("input", { type: "range", class: "gas-pl-cursore", min: 0, max: 1000, step: 1, "aria-label": t("pl_scegli_ora") });
  const elenco = el("div", { class: "gas-pl-elenco" });
  let j = null, j0 = 0, j1 = 0, gioco = null;
  function finestra(suAdesso) {
    const { lat, lon } = NOTTE.luogo, adesso = Astro.jd(new Date()), g = dataNotte();
    const sole = Astro.sole(adesso), hs = Astro.altezza(sole.ra, sole.dec, lat, Astro.n360(Astro.gmst(adesso) + lon));
    const limiti = d => { const nt = Astro.notte(d, lat, lon, 10), e = nt.ev;
      return [e.tramonto ? Astro.jd(e.tramonto) - 1 / 24 : nt.j0 + 5 / 24, e.alba ? Astro.jd(e.alba) + 1 / 24 : nt.j0 + 19 / 24, e]; };
    let [a, b, ev] = limiti(g);
    if (!NOTTE.data && adesso < a && (suAdesso || hs < -6)) {
      const ieri = limiti(new Date(g.getFullYear(), g.getMonth(), g.getDate() - 1, 12));
      if (adesso <= ieri[1]) [a, b, ev] = ieri;
    }
    if (suAdesso) { a = Math.min(a, adesso); b = Math.max(b, adesso); j = adesso; }
    j0 = a; j1 = b;
    if (j == null || j < j0 || j > j1) {
      const dieci = Astro.jd(new Date(g.getFullYear(), g.getMonth(), g.getDate(), 22, 0));
      j = adesso >= j0 && adesso <= j1 && hs < -6 ? adesso : clamp(Math.max(dieci, ev.astroFine ? Astro.jd(ev.astroFine) : dieci), j0, j1);
    }
    cursore.value = String(Math.round((j - j0) / (j1 - j0) * 1000));
  }
  const vaiA = nuovo => { j = clamp(nuovo, j0, j1); cursore.value = String(Math.round((j - j0) / (j1 - j0) * 1000)); fumetto.hidden = true; ridisegna(); };
  cursore.addEventListener("input", () => { j = j0 + (+cursore.value / 1000) * (j1 - j0); fermaGioco(); fumetto.hidden = true; ridisegna(); });
  const bottone = (testo, fn, cl) => el("button", { type: "button", class: "gas-btn gas-btn--chiaro gas-btn--mini" + (cl ? " " + cl : ""), onclick: fn }, testo);
  const bGioco = bottone("▶ " + t("pl_avvia"), () => (gioco ? fermaGioco() : avviaGioco()));
  function avviaGioco() {
    if (j >= j1 - 1e-4) j = j0;
    bGioco.textContent = "❚❚ " + t("pl_ferma");
    let prima = performance.now();
    const passo = ora => {
      if (!tela.isConnected) { gioco = null; return; }
      const dt = Math.min(100, ora - prima); prima = ora;
      j += dt / 1000 / 24;
      if (j >= j1) { j = j1; vaiA(j); fermaGioco(); return; }
      vaiA(j);
      gioco = requestAnimationFrame(passo);
    };
    gioco = requestAnimationFrame(passo);
  }
  function fermaGioco() { if (gioco) cancelAnimationFrame(gioco); gioco = null; bGioco.textContent = "▶ " + t("pl_avvia"); }
  const dirTesto = el("span", { class: "gas-pl-dir" });
  const interruttore = (chiave, testo) => {
    const b = el("button", { type: "button", class: "gas-btn gas-btn--chiaro gas-btn--mini gas-pl-int" + (PLANETARIO[chiave] ? " on" : ""), "aria-pressed": String(!!PLANETARIO[chiave]),
      onclick: () => { PLANETARIO[chiave] = !PLANETARIO[chiave]; b.classList.toggle("on", PLANETARIO[chiave]); b.setAttribute("aria-pressed", String(PLANETARIO[chiave])); salvaPlanetario(); ridisegna(); } }, testo);
    return b;
  };
  const barraLuogoPl = barraLuogo(() => { j = null; finestra(); fumetto.hidden = true; ridisegna(); }, true);
  pannello.append(barraLuogoPl,
    el("section", { class: "gas-card gas-pl" },
      el("div", { class: "gas-pl-testa" }, titolo, Voce.bottone("g_planetario")),
      stato,
      el("div", { class: "gas-pl-box" }, tela, fumetto),
      el("div", { class: "gas-pl-tempo" }, oraB, cursore),
      el("div", { class: "gas-riga-bottoni gas-pl-comandi" },
        bottone(t("pl_meno"), () => { fermaGioco(); vaiA(j - 1 / 24); }), bottone(t("pl_adesso"), () => {
          fermaGioco(); NOTTE.data = ""; salvaNotte(); if (barraLuogoPl.aggiornaData) barraLuogoPl.aggiornaData(); finestra(true); vaiA(j); }),
        bottone(t("pl_piu"), () => { fermaGioco(); vaiA(j + 1 / 24); }), bGioco),
      el("div", { class: "gas-riga-bottoni gas-pl-comandi" },
        interruttore("linee", t("pl_linee")), interruttore("nomi", t("pl_nomi")), interruttore("messier", t("pl_messier")),
        bottone("↻ " + t("pl_gira"), () => { PLANETARIO.giro = (PLANETARIO.giro + 90) % 360; salvaPlanetario(); fumetto.hidden = true; ridisegna(); }), dirTesto),
      el("p", { class: "gas-nota" }, t("pl_istruzioni"))),
    el("section", { class: "gas-card" }, el("h3", null, t("pl_visibili")), elenco));
  let punti = [], geo = null, fotogramma = 0, riserva = 0;
  function ridisegna() {
    if (fotogramma) return;
    const vai = () => { cancelAnimationFrame(fotogramma); clearTimeout(riserva); fotogramma = 0; disegna(); };
    fotogramma = requestAnimationFrame(vai);
    riserva = setTimeout(vai, 120);
  }
  async function disegna() {
    const base = await Mappa.caricaBase().catch(() => null);
    if (!tela.isConnected) return;
    const { lat, lon } = NOTTE.luogo;
    const dpr = Math.min(window.devicePixelRatio || 1, 2), css = Math.min(tela.parentElement.clientWidth || 600, 760);
    const W = Math.round(css * dpr), k = dpr, cx = W / 2, cy = W / 2, R = W / 2 - 24 * k;
    if (tela.width !== W) { tela.width = W; tela.height = W; }
    tela.style.width = tela.style.height = css + "px";
    const c = tela.getContext("2d");
    c.clearRect(0, 0, W, W);
    const lst = Astro.n360(Astro.gmst(j) + lon), lstR = lst * RAD, sf = Math.sin(lat * RAD), cf = Math.cos(lat * RAD);
    const giro = PLANETARIO.giro * RAD;
    geo = { W, k, cx, cy, R, css };
    const proietta = (alt, az, out) => {
      if (alt < -2) return false;
      const r = R * Math.tan((90 - alt) * RAD / 2), a = az * RAD + giro;
      out[0] = cx - r * Math.sin(a); out[1] = cy - r * Math.cos(a);
      return true;
    };
    const altaz = (ra, dec) => Astro.altAz(ra, dec, lat, lst);
    const sole = Astro.sole(j), [hSole, azSole] = altaz(sole.ra, sole.dec);
    const fondo = hSole > 0 ? ["#4f86c0", "#9cc4e8"] : hSole > -6 ? ["#1f3f70", "#c9875a"] : hSole > -12 ? ["#0d2042", "#2c4d7c"] : hSole > -18 ? ["#081429", "#16304f"] : ["#03070f", "#0b1729"];
    c.save();
    c.beginPath(); c.arc(cx, cy, R, 0, 2 * Math.PI); c.closePath();
    const gr = c.createRadialGradient(cx, cy, 0, cx, cy, R);
    gr.addColorStop(0, fondo[0]); gr.addColorStop(0.75, fondo[0]); gr.addColorStop(1, fondo[1]);
    c.fillStyle = gr; c.fill();
    c.clip();
    const notteVera = hSole < -12, visib = hSole > -4 ? 0.22 : hSole > -10 ? 0.55 : 1;
    if (base && notteVera && base.viaDati) viaLatteaCupola(c, base, geo, lat, lst, giro);
    c.strokeStyle = "rgba(160,190,230,0.13)"; c.lineWidth = 1 * k;
    for (const h of [30, 60]) { c.beginPath(); c.arc(cx, cy, R * Math.tan((90 - h) * RAD / 2), 0, 2 * Math.PI); c.stroke(); }
    c.beginPath();
    for (let a = 0; a < 360; a += 90) { const p = [0, 0]; proietta(0, a, p); c.moveTo(cx, cy); c.lineTo(p[0], p[1]); }
    c.stroke();
    punti = [];
    const p = [0, 0], q = [0, 0];
    const famiglia = getComputedStyle(RADICE).fontFamily, piccola = css < 520;
    const scritte = [];
    const scrivi = (testo, x, y, colore, px, peso, prio, centro) => scritte.push({ testo, x, y, colore, px, peso, prio, centro });
    if (base) {
      if (PLANETARIO.linee) {
        c.strokeStyle = `rgba(143,208,255,${0.34 * Math.max(visib, 0.5)})`; c.lineWidth = 1.1 * k; c.beginPath();
        for (const [r1, d1, r2, d2] of base.linee) {
          const [h1, a1] = altaz(r1, d1), [h2, a2] = altaz(r2, d2);
          if (h1 < -2 && h2 < -2) continue;
          if (!proietta(Math.max(h1, -2), a1, p) || !proietta(Math.max(h2, -2), a2, q)) continue;
          c.moveTo(p[0], p[1]); c.lineTo(q[0], q[1]);
        }
        c.stroke();
      }
      const st = base.stelle;
      for (let i = 0; i < st.n; i++) {
        const m = st.m[i];
        if (m > 6.5) continue;
        const H = lstR - st.ra[i], ch = Math.cos(H);
        const sa = sf * st.sd[i] + cf * st.cd[i] * ch;
        if (sa < -0.02) continue;
        const alt = Math.asin(sa) * DEG, az = Math.atan2(-st.cd[i] * Math.sin(H), st.sd[i] * cf - st.cd[i] * sf * ch) * DEG;
        if (visib < 1 && m > (visib < 0.3 ? 1.2 : 3.2)) continue;
        if (!proietta(alt, az, p)) continue;
        const estinz = alt < 12 ? 0.35 + 0.65 * alt / 12 : 1;
        const r = Math.max(0.55, (6.8 - m) * 0.52) * k, col = Mappa.colore(st.c[i]);
        c.fillStyle = `rgba(${col[0]},${col[1]},${col[2]},${clamp((0.35 + (6.5 - m) * 0.16) * estinz * Math.max(visib, 0.6), 0.15, 1)})`;
        c.beginPath(); c.arc(p[0], p[1], r, 0, 2 * Math.PI); c.fill();
      }
      c.font = `500 ${11 * k}px ${getComputedStyle(RADICE).fontFamily}`;
      for (const s of base.nomi) {
        if (s.m > 3) continue;
        const [alt, az] = altaz(s.ra, s.dec);
        if (alt < 0 || !proietta(alt, az, p)) continue;
        const nome = s[LINGUA] || s.en;
        punti.push({ x: p[0], y: p[1], r: 9 * k, nome, riga: t("pl_mag", { m: num(s.m, 1) }), alt, az });
        if (PLANETARIO.nomi && s.m <= (piccola ? 1.2 : 1.8) && visib >= 0.5) scrivi(nome, p[0] + 6 * k, p[1] - 5 * k, "rgba(226,234,248,0.82)", 11, 500, 3 + s.m);
      }
      if (PLANETARIO.nomi && PLANETARIO.linee && visib >= 0.5) {
        for (const [sigla, [ra, dec]] of Object.entries(base.etichette)) {
          const [alt, az] = altaz(ra, dec);
          if (alt < 8 || !proietta(alt, az, p)) continue;
          scrivi(nomeCostellazione(sigla).toUpperCase(), p[0], p[1], "rgba(143,208,255,0.5)", piccola ? 9 : 10.5, 600, 8, true);
        }
      }
    }
    const scelto = trovaOggetto(CAMPO.ogg);
    if (PLANETARIO.messier || scelto) {
      for (const o of scelto && scelto.cometa ? DATI.oggetti.concat([scelto]) : DATI.oggetti) {
        const eScelto = scelto && o === scelto;
        if (!eScelto && !(PLANETARIO.messier && o.messier)) continue;
        const [alt, az] = altaz(o.ra, o.dec);
        if (alt < 0 || !proietta(alt, az, p)) continue;
        const nome = titoloOggetto(o), colore = /^(gx|gxp|gxg|gxcl)$/.test(o.t) ? "255,214,140" : /^(en|cn|neb|reg|snr|pn)$/.test(o.t) ? "255,140,170" : /^(rn)$/.test(o.t) ? "140,180,255" : "255,230,160";
        c.strokeStyle = `rgba(${colore},${eScelto ? 1 : 0.75 * Math.max(visib, 0.6)})`; c.lineWidth = (eScelto ? 2 : 1.2) * k;
        c.beginPath(); c.arc(p[0], p[1], (eScelto ? 7 : piccola ? 2.6 : 3.4) * k, 0, 2 * Math.PI); c.stroke();
        if (eScelto) scrivi(nome, p[0] + 10 * k, p[1] + 4 * k, `rgba(${colore},1)`, 11.5, 700, 1);
        else if (PLANETARIO.nomi && visib >= 0.5) scrivi(o.id, p[0] + 5 * k, p[1] + 3.5 * k, `rgba(${colore},0.72)`, piccola ? 9 : 10, 600, 9);
        punti.push({ x: p[0], y: p[1], r: 9 * k, nome, riga: rigaOggetto(o), alt, az, ogg: o.cometa ? CAMPO.ogg : o.id });
      }
    }
    const corpi = [];
    for (const nome of PIANETI) {
      const pl = Astro.pianeta(nome, j), [alt, az] = altaz(pl.ra, pl.dec);
      corpi.push({ nome, alt, az, mag: pl.mag });
      if (alt < -1 || !proietta(alt, az, p)) continue;
      const r = clamp(4.6 - pl.mag * 0.55, 2.2, 6) * k;
      c.fillStyle = COLORI_PIANETI[nome]; c.beginPath(); c.arc(p[0], p[1], r, 0, 2 * Math.PI); c.fill();
      c.strokeStyle = "rgba(0,0,0,0.5)"; c.lineWidth = 1 * k; c.stroke();
      scrivi(t("pianeta_" + nome), p[0] + r + 4 * k, p[1] + 4 * k, COLORI_PIANETI[nome], 11, 700, 0);
      punti.push({ x: p[0], y: p[1], r: 11 * k, nome: t("pianeta_" + nome), riga: t("pl_mag", { m: num(pl.mag, 1) }), alt, az, ogg: "@" + nome });
    }
    const luna = Astro.luna(j), fase = Astro.faseLuna(j), [hL0, azL] = altaz(luna.ra, luna.dec), hL = hL0 - luna.par * Math.cos(hL0 * RAD);
    corpi.push({ nome: "luna", alt: hL, az: azL, fase });
    if (proietta(hL, azL, p) && hL > -1) {
      const da = (azSole - azL) * RAD, f1 = hL * RAD, f2 = hSole * RAD;
      const vs = Math.atan2(Math.sin(da) * Math.cos(f2), Math.cos(f1) * Math.sin(f2) - Math.sin(f1) * Math.cos(f2) * Math.cos(da));
      lunaSuTela(c, p[0], p[1], 8 * k, fase, Math.PI / 2 - azL * RAD - giro + vs);
      scrivi(`${t("luna")} ${num(fase.k * 100)} %`, p[0] + 11 * k, p[1] + 4 * k, "#e9e4d4", 11, 700, 0);
      punti.push({ x: p[0], y: p[1], r: 12 * k, nome: t("luna"), riga: `${num(fase.k * 100)} % ${t("ls_illuminata")}`, alt: hL, az: azL, ogg: "@luna" });
    }
    if (proietta(hSole, azSole, p) && hSole > -1) {
      const g2 = c.createRadialGradient(p[0], p[1], 0, p[0], p[1], 18 * k);
      g2.addColorStop(0, "rgba(255,245,210,1)"); g2.addColorStop(0.35, "rgba(255,225,150,0.9)"); g2.addColorStop(1, "rgba(255,200,120,0)");
      c.fillStyle = g2; c.beginPath(); c.arc(p[0], p[1], 18 * k, 0, 2 * Math.PI); c.fill();
      punti.push({ x: p[0], y: p[1], r: 14 * k, nome: t("pl_sole"), riga: t("filtro_solare"), alt: hSole, az: azSole, ogg: "@sole" });
    }
    if (typeof terrenoDelLuogo === "function" && terrenoDelLuogo()) {
      const pr = NOTTE.terreno.p;
      c.beginPath();
      for (let a = 0; a <= 360; a++) { proietta(Math.max(pr[a % 360] / 10, 0), a, p); if (a) c.lineTo(p[0], p[1]); else c.moveTo(p[0], p[1]); }
      for (let a = 360; a >= 0; a--) { proietta(-2, a, p); c.lineTo(p[0], p[1]); }
      c.closePath();
      c.fillStyle = "rgba(38,30,20,0.86)"; c.fill();
      c.strokeStyle = "rgba(226,184,79,0.6)"; c.lineWidth = 1.2 * k;
      c.beginPath();
      for (let a = 0; a <= 360; a++) { proietta(Math.max(pr[a % 360] / 10, 0), a, p); if (a) c.lineTo(p[0], p[1]); else c.moveTo(p[0], p[1]); }
      c.stroke();
    }
    const occupati = [];
    scritte.sort((a, b) => a.prio - b.prio);
    for (const s of scritte) {
      c.font = `${s.peso} ${s.px * k}px ${famiglia}`;
      const w = c.measureText(s.testo).width, h = s.px * k, x = s.centro ? s.x - w / 2 : s.x;
      const box = [x - 2 * k, s.y - h, w + 4 * k, h + 3 * k];
      if (occupati.some(o => box[0] < o[0] + o[2] && o[0] < box[0] + box[2] && box[1] < o[1] + o[3] && o[1] < box[1] + box[3])) continue;
      occupati.push(box);
      c.fillStyle = s.colore; c.fillText(s.testo, x, s.y);
    }
    c.restore();
    c.strokeStyle = "rgba(226,184,79,0.55)"; c.lineWidth = 1.5 * k;
    c.beginPath(); c.arc(cx, cy, R, 0, 2 * Math.PI); c.stroke();
    const card = t("pl_card").split("|");
    c.font = `800 ${13 * k}px ${getComputedStyle(RADICE).fontFamily}`; c.textAlign = "center"; c.textBaseline = "middle"; c.fillStyle = "#f4d58b";
    for (let i = 0; i < 4; i++) {
      const a = i * 90 * RAD + giro, rr = R + 12 * k;
      c.fillText(card[i], cx - rr * Math.sin(a), cy - rr * Math.cos(a));
    }
    c.textAlign = "left"; c.textBaseline = "alphabetic";
    const quando = Astro.data(j);
    titolo.textContent = `${t("pl_cielo_sopra", luogoFrasi())} · ${giorno(quando)} · ${ora(quando)}`;
    oraB.textContent = ora(quando);
    cursore.setAttribute("aria-valuetext", `${giorno(quando)} ${ora(quando)}`);
    stato.textContent = hSole > -0.833 ? t("pl_giorno") : hSole > -12 ? t("pl_crepuscolo") : "";
    stato.hidden = !stato.textContent;
    const giu = (((180 + PLANETARIO.giro) % 360) / 90) | 0;
    dirTesto.textContent = t("pl_in_basso", { d: t("pl_dir").split("|")[(4 - (PLANETARIO.giro / 90 | 0) + 2) % 4] });
    void giu;
    const su = corpi.filter(x => x.alt > 0).sort((a, b) => b.alt - a.alt);
    aggiungi(svuota(elenco), [su.length ? el("ul", { class: "gas-pl-lista" }, su.map(x => el("li", null,
      x.nome === "luna" ? iconaLuna(x.fase) : el("i", { class: "gas-pl-pallino", style: { background: COLORI_PIANETI[x.nome] } }),
      el("b", null, x.nome === "luna" ? t("luna") : t("pianeta_" + x.nome)),
      el("span", null, t("pl_alt_az", { h: num(x.alt), a: num(x.az) }) + (x.mag != null ? " · " + t("pl_mag", { m: num(x.mag, 1) }) : "")),
      el("button", { type: "button", class: "gas-btn gas-btn--chiaro gas-btn--mini", onclick: () => inquadra("@" + x.nome) }, t("pl_inquadra")))))
      : el("p", { class: "gas-muto" }, t("pl_nessuno")),
      scelto ? el("p", { class: "gas-nota" }, `${t("pl_scelto")}: `, el("b", null, titoloOggetto(scelto)), " · ",
        (() => {
          const cs = scelto.corpo === "sole" ? { alt: hSole, az: azSole } : scelto.corpo ? corpi.find(x => x.nome === scelto.corpo) : null;
          const [alt, az] = cs ? [cs.alt, cs.az] : altaz(scelto.ra, scelto.dec);
          return alt > 0 ? t("pl_alt_az", { h: num(alt), a: num(az) }) : t("sotto_orizzonte"); })()) : null]);
  }
  function inquadra(id) { CAMPO.ogg = id; CENTRO = null; SPOSTA = [0, 0]; ZOOM = 1; salvaCampo(); vai("campo"); }
  let attesa = 0;
  const chiudiDopo = () => { if (!attesa) attesa = setTimeout(() => { attesa = 0; if (!fumetto.matches(":hover")) fumetto.hidden = true; }, 600); };
  function mostra(ev, tocco) {
    if (!geo || (!tocco && gioco)) return;
    const box = tela.getBoundingClientRect(), s = geo.W / box.width;
    const x = (ev.clientX - box.left) * s, y = (ev.clientY - box.top) * s;
    let best = null, dmin = Infinity;
    for (const p of punti) { const d = Math.hypot(p.x - x, p.y - y); if (d < p.r * (tocco ? 1.6 : 1) && d < dmin) { dmin = d; best = p; } }
    if (!best) { if (tocco) fumetto.hidden = true; else chiudiDopo(); return; }
    clearTimeout(attesa); attesa = 0;
    aggiungi(svuota(fumetto), [el("b", null, best.nome), el("span", null, best.riga), el("small", null, t("pl_alt_az", { h: num(best.alt), a: num(best.az) })),
      best.ogg ? el("button", { type: "button", class: "gas-btn gas-btn--mini", onclick: () => inquadra(best.ogg) }, t("pl_inquadra")) : null]);
    fumetto.hidden = false;
    const pb = tela.parentElement.getBoundingClientRect(), fx = best.x / s, fy = best.y / s;
    fumetto.style.left = `${box.left - pb.left + clamp(fx + 12, 4, box.width - fumetto.offsetWidth - 4)}px`;
    fumetto.style.top = `${box.top - pb.top + clamp(fy - 10, 4, box.height - fumetto.offsetHeight - 4)}px`;
  }
  tela.addEventListener("pointermove", e => { if (e.pointerType === "mouse") mostra(e, false); });
  tela.addEventListener("click", e => mostra(e, true));
  tela.addEventListener("pointerleave", e => { if (e.pointerType === "mouse") chiudiDopo(); });
  fumetto.addEventListener("pointerleave", e => { if (e.pointerType === "mouse") chiudiDopo(); });
  const alRidimensiona = debounce(() => { if (tela.isConnected) ridisegna(); }, 200);
  window.addEventListener("resize", alRidimensiona);
  finestra();
  ridisegna();
}
function viaLatteaCupola(c, base, g, lat, lst, giro) {
  const V = base.viaDati, nx = base.via.w, ny = base.via.h, passo = Math.max(4, Math.round(g.W / 150));
  const n = Math.ceil(g.W / passo), off = document.createElement("canvas");
  off.width = n; off.height = n;
  const oc = off.getContext("2d"), im = oc.createImageData(n, n), sf = Math.sin(lat * RAD), cf = Math.cos(lat * RAD);
  for (let yy = 0; yy < n; yy++) for (let xx = 0; xx < n; xx++) {
    const dx = (xx + 0.5) * passo - g.cx, dy = (yy + 0.5) * passo - g.cy, r = Math.hypot(dx, dy) / g.R;
    if (r > 1.02) continue;
    const alt = 90 - 2 * Math.atan(r) * DEG, az = Math.atan2(-dx, -dy) - giro;
    const sa = Math.sin(alt * RAD), ca = Math.cos(alt * RAD);
    const sd = sf * sa + cf * ca * Math.cos(az), dec = Math.asin(clamp(sd, -1, 1)) * DEG;
    const H = Math.atan2(-Math.sin(az) * ca, cf * sa - sf * ca * Math.cos(az)) * DEG;
    const ra = Astro.n360(lst - H);
    const fx = ra / 360 * nx - 0.5, fy = clamp((dec + 90) / 180 * ny - 0.5, 0, ny - 1);
    const x0 = Math.floor(fx), y0 = Math.floor(fy), y1 = Math.min(ny - 1, y0 + 1), tx = fx - x0, ty = fy - y0;
    const a = ((x0 % nx) + nx) % nx, b = (a + 1) % nx;
    const v = ((V[y0 * nx + a] * (1 - tx) + V[y0 * nx + b] * tx) * (1 - ty) + (V[y1 * nx + a] * (1 - tx) + V[y1 * nx + b] * tx) * ty) / 255;
    const f = clamp((v - 0.42) / 0.58, 0, 1), q = (yy * n + xx) * 4;
    const est = alt < 15 ? Math.max(0, alt / 15) : 1;
    im.data[q] = 175; im.data[q + 1] = 192; im.data[q + 2] = 238; im.data[q + 3] = Math.round(Math.pow(f, 1.4) * 0.34 * est * 255);
  }
  oc.putImageData(im, 0, 0);
  c.imageSmoothingEnabled = true;
  c.drawImage(off, 0, 0, n * passo, n * passo);
}
function lunaSuTela(c, x, y, r, f, ang) {
  c.save();
  c.fillStyle = "#2a313d"; c.beginPath(); c.arc(x, y, r, 0, 2 * Math.PI); c.fill();
  const e = r * (1 - 2 * f.k), dx = f.crescente ? 1 : -1;
  c.translate(x, y);
  if (ang == null) c.scale(dx, 1); else c.rotate(ang);
  c.fillStyle = "#f1ead6"; c.beginPath();
  c.arc(0, 0, r, -Math.PI / 2, Math.PI / 2, false);
  c.ellipse(0, 0, Math.abs(e), r, 0, Math.PI / 2, -Math.PI / 2, e > 0);
  c.fill();
  c.restore();
}
Object.assign(TESTI.it, {
  co_titolo: "Comete di stanotte", co_carico: "Calcolo le comete…", co_errore: "Le orbite delle comete adesso non arrivano: riprova più tardi.",
  co_n: "Le orbite di tutte le comete note, dal Minor Planet Center (IAU). La luminosità di una cometa è una stima: può essere diversa di una o due magnitudini.",
  co_nessuna: "Stanotte nessuna cometa più luminosa della magnitudine {m} sale sopra l'orizzonte {l_da}.",
  co_prossima: "La prossima da tenere d'occhio: {n} ({d} circa, mag {m}).",
  co_occhio: "a occhio nudo", co_bino: "col binocolo", co_tele: "col telescopio", co_foto: "in foto",
  co_riga: "mag {m} · {s} · più alta alle {o}, a {h}°", co_dist: "a {d} UA dalla Terra e {r} UA dal Sole", co_inquadra: "Inquadra",
  tipo_cometa: "Cometa", co_incerta: "stima incerta", co_fonte: "Orbite: Minor Planet Center (IAU); luminosità: JPL Small-Body Database (NASA).",
});
Object.assign(TESTI.de, {
  co_titolo: "Kometen heute Nacht", co_carico: "Kometen werden berechnet…", co_errore: "Die Kometenbahnen kommen gerade nicht an: später erneut versuchen.",
  co_n: "Die Bahnen aller bekannten Kometen, vom Minor Planet Center (IAU). Die Helligkeit eines Kometen ist eine Schätzung: sie kann ein bis zwei Größenklassen abweichen.",
  co_nessuna: "Heute Nacht steigt kein Komet heller als Größe {m} {l_da} über den Horizont.",
  co_prossima: "Als Nächstes im Auge behalten: {n} (etwa {d}, Größe {m}).",
  co_occhio: "mit bloßem Auge", co_bino: "mit dem Fernglas", co_tele: "mit dem Teleskop", co_foto: "fotografisch",
  co_riga: "Größe {m} · {s} · am höchsten um {o} Uhr, {h}°", co_dist: "{d} AE von der Erde, {r} AE von der Sonne", co_inquadra: "Ins Bildfeld",
  tipo_cometa: "Komet", co_incerta: "unsichere Schätzung", co_fonte: "Bahnen: Minor Planet Center (IAU); Helligkeit: JPL Small-Body Database (NASA).",
});
Object.assign(TESTI.es, {
  co_titolo: "Cometas de esta noche", co_carico: "Calculando los cometas…", co_errore: "Ahora no llegan las órbitas de los cometas: vuelve a intentarlo más tarde.",
  co_n: "Las órbitas de todos los cometas conocidos, del Minor Planet Center (IAU). El brillo de un cometa es una estimación: puede variar una o dos magnitudes.",
  co_nessuna: "Esta noche ningún cometa más brillante que la magnitud {m} sube sobre el horizonte {l_da}.",
  co_prossima: "El próximo a vigilar: {n} (hacia el {d}, mag {m}).",
  co_occhio: "a simple vista", co_bino: "con prismáticos", co_tele: "con telescopio", co_foto: "en foto",
  co_riga: "mag {m} · {s} · más alto a las {o}, a {h}°", co_dist: "a {d} UA de la Tierra y {r} UA del Sol", co_inquadra: "Encuadrar",
  tipo_cometa: "Cometa", co_incerta: "estimación incierta", co_fonte: "Órbitas: Minor Planet Center (IAU); brillo: JPL Small-Body Database (NASA).",
});
Object.assign(TESTI.en, {
  co_titolo: "Comets tonight", co_carico: "Calculating comet positions…", co_errore: "The comet orbits aren't coming through right now: try again later.",
  co_n: "The orbits of all known comets, from the Minor Planet Center (IAU). A comet's brightness is an estimate: it can be one or two magnitudes off.",
  co_nessuna: "Tonight no comet brighter than magnitude {m} rises above the horizon {l_da}.",
  co_prossima: "Next one to watch: {n} (around {d}, mag {m}).",
  co_occhio: "naked eye", co_bino: "binoculars", co_tele: "telescope", co_foto: "imaging",
  co_riga: "mag {m} · {s} · highest at {o}, at {h}°", co_dist: "{d} AU from Earth, {r} AU from the Sun", co_inquadra: "Frame it",
  tipo_cometa: "Comet", co_incerta: "rough estimate", co_fonte: "Orbits: Minor Planet Center (IAU); brightness: JPL Small-Body Database (NASA).",
});
const URL_MPC = "https://www.minorplanetcenter.net/iau/MPCORB/CometEls.txt";
const CO_MAG_MAX = 13;
const K_GAUSS = 0.01720209895;
let _comete = null, COMETE = null;
const jdCalendario = (a, m, g) => {
  if (m <= 2) { a -= 1; m += 12; }
  const A = Math.floor(a / 100), B = 2 - A + Math.floor(A / 4);
  return Math.floor(365.25 * (a + 4716)) + Math.floor(30.6001 * (m + 1)) + g + B - 1524.5;
};
function leggiCometeMpc(testo) {
  const oggi = Astro.jd(new Date()), fuori = [];
  for (const r of testo.split(/\r?\n/)) {
    if (r.length < 100) continue;
    const n = (a, b) => parseFloat(r.slice(a - 1, b));
    const T = jdCalendario(n(15, 18), n(20, 21), n(23, 29)), q = n(31, 39), e = n(42, 49), H = n(92, 95), G = n(97, 100), nome = r.slice(102, 158).trim();
    if (![T, q, e, H].every(Number.isFinite) || !nome || q > 6 || Math.abs(T - oggi) > 3 * 365.25) continue;
    fuori.push([nome, T, q, e, n(52, 59), n(62, 69), n(72, 79), H, Number.isFinite(G) ? G : 4]);
  }
  return fuori;
}
function chiaveCometa(nome) {
  const m = /^(\d+[PDI])\b/.exec(nome) || /^([CPDXAI]\/\d{4} [A-Z]{1,2}\d*(?:-[A-Z]+)?)/.exec(nome);
  return m ? m[1] : null;
}
function orbiteMpc() {
  const vecchie = ricorda("comete", null);
  if (vecchie && Array.isArray(vecchie.c) && Date.now() - vecchie.t < 12 * 3600e3) return Promise.resolve(vecchie.c);
  return fetch(URL_MPC).then(r => { if (!r.ok) throw new Error("MPC " + r.status); return r.text(); })
    .then(tx => { const c = leggiCometeMpc(tx); salva("comete", { t: Date.now(), c }); return c; })
    .catch(e => { if (vecchie && Array.isArray(vecchie.c)) return vecchie.c; throw e; });
}
function caricaComete() {
  if (_comete) return _comete;
  const url = RADICE && RADICE.dataset.cometeMag;
  const mag = url ? fetch(url).then(r => (r.ok ? r.json() : {})).then(j => j.m || {}).catch(() => ({})) : Promise.resolve({});
  _comete = Promise.all([orbiteMpc(), mag]).then(([lista, M]) => {
    COMETE = lista.map(c => { const k = chiaveCometa(c[0]), m = k && M[k]; return c.slice(0, 9).concat(m ? m : [null, null]); });
    return COMETE;
  }).catch(e => { _comete = null; throw e; });
  return _comete;
}
function posizioneCometa(c, jd) {
  const [, T, q, e, w, N, inc, H, G] = c, dt = jd - T;
  let nu, r;
  if (Math.abs(e - 1) < 1e-5) {
    const W = 3 * K_GAUSS / Math.sqrt(2 * q * q * q) * dt, Y = Math.cbrt(W / 2 + Math.sqrt(W * W / 4 + 1)), s = Y - 1 / Y;
    nu = 2 * Math.atan(s); r = q * (1 + s * s);
  } else if (e < 1) {
    const a = q / (1 - e), M0 = K_GAUSS / Math.pow(a, 1.5) * dt, M = Math.atan2(Math.sin(M0), Math.cos(M0));
    let E = M + 0.85 * e * Math.sign(Math.sin(M) || 1);
    for (let i = 0; i < 100; i++) { const dE = (E - e * Math.sin(E) - M) / (1 - e * Math.cos(E)); E -= dE; if (Math.abs(dE) < 1e-12) break; }
    nu = 2 * Math.atan2(Math.sqrt(1 + e) * Math.sin(E / 2), Math.sqrt(1 - e) * Math.cos(E / 2));
    r = a * (1 - e * Math.cos(E));
  } else {
    const a = q / (e - 1), M = K_GAUSS / Math.pow(a, 1.5) * dt;
    let F = Math.asinh(M / e);
    for (let i = 0; i < 100; i++) { const dF = (e * Math.sinh(F) - F - M) / (e * Math.cosh(F) - 1); F -= dF; if (Math.abs(dF) < 1e-12) break; }
    nu = 2 * Math.atan(Math.sqrt((e + 1) / (e - 1)) * Math.tanh(F / 2));
    r = a * (e * Math.cosh(F) - 1);
  }
  const u = (w * RAD) + nu, Nr = N * RAD, ir = inc * RAD;
  const x = r * (Math.cos(Nr) * Math.cos(u) - Math.sin(Nr) * Math.sin(u) * Math.cos(ir));
  const y = r * (Math.sin(Nr) * Math.cos(u) + Math.cos(Nr) * Math.sin(u) * Math.cos(ir));
  const z = r * Math.sin(u) * Math.sin(ir);
  const s = Astro.sole(jd), lam = (s.lon - 1.39697 * (jd - 2451545) / 36525) * RAD, R = s.dist;
  const dx = x + R * Math.cos(lam), dy = y + R * Math.sin(lam), dz = z;
  const eps = 23.4392911 * RAD, xe = dx, ye = dy * Math.cos(eps) - dz * Math.sin(eps), ze = dy * Math.sin(eps) + dz * Math.cos(eps);
  const d = Math.hypot(xe, ye, ze);
  const elong = Math.acos(clamp((Math.cos(lam) * dx + Math.sin(lam) * dy) / d, -1, 1)) * DEG;
  const jpl = c[9] != null;
  const mag = jpl ? c[9] + 5 * Math.log10(d) + c[10] * Math.log10(r) : H + 5 * Math.log10(d) + 2.5 * G * Math.log10(r) + 1.5;
  return { ra: Astro.n360(Math.atan2(ye, xe) * DEG), dec: Math.asin(ze / d) * DEG, r, d, mag, el: elong, incerta: !jpl };
}
function oggettoCometa(nome) {
  const c = COMETE && COMETE.find(x => x[0] === nome);
  if (!c) return null;
  const g = dataNotte(), p = posizioneCometa(c, Astro.jd(new Date(g.getFullYear(), g.getMonth(), g.getDate(), 23, 0)));
  return { id: nome, alias: [], ra: p.ra, dec: p.dec, t: "cometa", mag: Math.round(p.mag * 10) / 10, a: 8, b: 8, nomi: null, cometa: true, cerca: [], cercaParole: "" };
}
if (String(CAMPO.ogg || "").startsWith("@cometa:")) caricaComete().then(() => { if (schedaAttiva === "campo") vai("campo", true); }).catch(() => {});
const livelloCometa = m => (m < 5.5 ? "co_occhio" : m < 9 ? "co_bino" : m < 12 ? "co_tele" : "co_foto");
function cartaComete(cn) {
  const titolo = () => el("h3", null, icona("cometa"), " ", t("co_titolo"));
  const box = el("section", { class: "gas-card gas-co" }, titolo(), el("p", { class: "gas-muto" }, t("co_carico")));
  caricaComete().then(lista => {
    const nt = cn.nt, ore = nt.buio.length ? nt.buio : nt.tempi.map((_, i) => i).filter(i => nt.hSole[i] < -6);
    const jd = nt.tempi[ore.length ? ore[Math.floor(ore.length / 2)] : Math.floor(nt.n / 2)];
    const viste = [];
    for (const c of lista) {
      const p = posizioneCometa(c, jd);
      if (!(p.mag <= CO_MAG_MAX)) continue;
      const curva = Astro.curvaOggetto(nt, p.ra, p.dec);
      let hMax = -90, iMax = -1;
      for (const i of ore) if (curva.h[i] > hMax) { hMax = curva.h[i]; iMax = i; }
      if (hMax >= 10) viste.push({ c, p, hMax, quando: iMax >= 0 ? dataJ(nt.tempi[iMax]) : null });
    }
    viste.sort((a, b) => a.p.mag - b.p.mag);
    svuota(box).append(titolo(), el("p", { class: "gas-nota" }, t("co_n")));
    if (!viste.length) box.append(el("p", null, t("co_nessuna", Object.assign({ m: CO_MAG_MAX }, luogoFrasi()))));
    const elenco = el("div", { class: "gas-co-lista" });
    for (const v of viste.slice(0, 8)) {
      elenco.appendChild(el("div", { class: "gas-co-riga gas-co--" + livelloCometa(v.p.mag) },
        el("span", { class: "gas-co-ico", "aria-hidden": "true" }, icona("cometa")),
        el("div", { class: "gas-co-testo" }, el("b", null, v.c[0]),
          el("small", null, t("co_riga", { m: num(v.p.mag, 1) + (v.p.incerta ? " (" + t("co_incerta") + ")" : ""), s: t(livelloCometa(v.p.mag)), o: ora(v.quando), h: num(v.hMax) })),
          el("small", null, t("co_dist", { d: num(v.p.d, 2), r: num(v.p.r, 2) }))),
        el("button", { type: "button", class: "gas-btn gas-btn--chiaro gas-btn--mini", onclick: () => {
          CAMPO.ogg = "@cometa:" + v.c[0]; CENTRO = null; SPOSTA = [0, 0]; ZOOM = 1; salvaCampo(); vai("campo");
        } }, t("co_inquadra"))));
    }
    if (elenco.children.length) box.appendChild(elenco);
    let prossima = null;
    for (const c of lista) {
      if ((c[9] != null ? c[9] : c[7]) > 14) continue;
      for (let g = 7; g <= 365; g += 7) {
        const p = posizioneCometa(c, jd + g);
        if (p.mag < 9 && p.el > 30 && (!prossima || p.mag < prossima.m - 0.3)) { prossima = { n: c[0], m: p.mag, g }; break; }
      }
    }
    const quandoC = prossima && Astro.data(jd + prossima.g), stessoAnno = quandoC && quandoC.getFullYear() === Astro.data(jd).getFullYear();
    if (prossima && !viste.some(v => v.c[0] === prossima.n && v.p.mag < 9)) box.append(el("p", { class: "gas-nota" },
      t("co_prossima", { n: prossima.n, m: num(prossima.m, 1), d: quandoC.toLocaleDateString(LOCALE, stessoAnno ? { day: "numeric", month: "long" } : { day: "numeric", month: "long", year: "numeric" }) })));
    box.append(el("p", { class: "gas-co-fonte" }, t("co_fonte")));
  }).catch(() => { svuota(box).append(titolo(), el("p", { class: "gas-muto" }, t("co_errore"))); });
  return box;
}
Object.assign(TESTI.it, {
  sa_titolo: "Passaggi della ISS e di Tiangong", sa_carico: "Calcolo i passaggi delle stazioni spaziali…",
  sa_errore: "I dati delle stazioni spaziali adesso non arrivano: riprova più tardi.",
  sa_n: "Si vedono a occhio nudo: un punto luminoso che attraversa il cielo in pochi minuti, senza lampeggiare. Orari calcolati {l_da}, a partire da 10° sopra l'orizzonte.",
  sa_stanotte: "Stanotte", sa_nessuno: "Stanotte nessun passaggio visibile {l_da}.", sa_prossimi: "Nei prossimi giorni",
  sa_nessuno_prossimi: "Nei prossimi 6 giorni nessun passaggio visibile.",
  sa_da_a: "da {da} a {a}", sa_verso: "verso {d}", sa_alta: "alta {h}° alle {o}", sa_mag: "magnitudine ≈ {m}",
  sa_ombra: "sparisce nell'ombra della Terra alle {o}", sa_esce: "compare uscendo dall'ombra della Terra",
  sa_molto: "molto luminosa", sa_luminosa: "luminosa", sa_debole: "visibile",
  sa_iss: "ISS", sa_iss_n: "Stazione Spaziale Internazionale", sa_css: "Tiangong", sa_css_n: "stazione spaziale cinese",
  sa_fonte: "Orbite: CelesTrak (dati NORAD), calcolo SGP4. Orari ±1 minuto: le stazioni a volte correggono l'orbita, ricontrolla il giorno stesso.",
  sa_vecchi: "Dati orbitali di {g} giorni fa: gli orari possono spostarsi di qualche minuto.",
  sa_lontano: "I passaggi delle stazioni si possono calcolare solo per i prossimi 10 giorni.",
  sa_cielo: "Il percorso nel cielo: al centro sopra la testa, sul bordo l'orizzonte", sa_punti: "N E S O",
});
Object.assign(TESTI.de, {
  sa_titolo: "Überflüge der ISS und von Tiangong", sa_carico: "Die Überflüge der Raumstationen werden berechnet…",
  sa_errore: "Die Daten der Raumstationen kommen gerade nicht an: später erneut versuchen.",
  sa_n: "Mit bloßem Auge sichtbar: ein heller Punkt, der in wenigen Minuten über den Himmel zieht, ohne zu blinken. Zeiten {l_da}, ab 10° über dem Horizont.",
  sa_stanotte: "Heute Nacht", sa_nessuno: "Heute Nacht kein sichtbarer Überflug {l_da}.", sa_prossimi: "In den nächsten Tagen",
  sa_nessuno_prossimi: "In den nächsten 6 Tagen kein sichtbarer Überflug.",
  sa_da_a: "von {da} nach {a}", sa_verso: "in Richtung {d}", sa_alta: "{h}° hoch um {o} Uhr", sa_mag: "Magnitude ≈ {m}",
  sa_ombra: "verschwindet um {o} Uhr im Erdschatten", sa_esce: "taucht aus dem Erdschatten auf",
  sa_molto: "sehr hell", sa_luminosa: "hell", sa_debole: "sichtbar",
  sa_iss: "ISS", sa_iss_n: "Internationale Raumstation", sa_css: "Tiangong", sa_css_n: "chinesische Raumstation",
  sa_fonte: "Bahnen: CelesTrak (NORAD-Daten), SGP4-Berechnung. Zeiten ±1 Minute: Raumstationen korrigieren manchmal ihre Bahn, am selben Tag nochmals prüfen.",
  sa_vecchi: "Bahndaten von vor {g} Tagen: die Zeiten können sich um einige Minuten verschieben.",
  sa_lontano: "Die Überflüge der Raumstationen lassen sich nur für die nächsten 10 Tage berechnen.",
  sa_cielo: "Der Weg am Himmel: in der Mitte über dem Kopf, am Rand der Horizont", sa_punti: "N O S W",
});
Object.assign(TESTI.es, {
  sa_titolo: "Pasos de la ISS y de Tiangong", sa_carico: "Calculando los pasos de las estaciones espaciales…",
  sa_errore: "Ahora no llegan los datos de las estaciones espaciales: vuelve a intentarlo más tarde.",
  sa_n: "Se ven a simple vista: un punto brillante que cruza el cielo en pocos minutos, sin parpadear. Horarios calculados {l_da}, a partir de 10° sobre el horizonte.",
  sa_stanotte: "Esta noche", sa_nessuno: "Esta noche ningún paso visible {l_da}.", sa_prossimi: "En los próximos días",
  sa_nessuno_prossimi: "En los próximos 6 días ningún paso visible.",
  sa_da_a: "del {da} al {a}", sa_verso: "hacia el {d}", sa_alta: "a {h}° de altura a las {o}", sa_mag: "magnitud ≈ {m}",
  sa_ombra: "desaparece en la sombra de la Tierra a las {o}", sa_esce: "aparece al salir de la sombra de la Tierra",
  sa_molto: "muy brillante", sa_luminosa: "brillante", sa_debole: "visible",
  sa_iss: "ISS", sa_iss_n: "Estación Espacial Internacional", sa_css: "Tiangong", sa_css_n: "estación espacial china",
  sa_fonte: "Órbitas: CelesTrak (datos NORAD), cálculo SGP4. Horarios ±1 minuto: las estaciones a veces corrigen su órbita, vuelve a comprobarlo el mismo día.",
  sa_vecchi: "Datos orbitales de hace {g} días: los horarios pueden variar unos minutos.",
  sa_lontano: "Los pasos de las estaciones solo se pueden calcular para los próximos 10 días.",
  sa_cielo: "El recorrido en el cielo: en el centro sobre tu cabeza, en el borde el horizonte", sa_punti: "N E S O",
});
Object.assign(TESTI.en, {
  sa_titolo: "ISS and Tiangong passes", sa_carico: "Working out the space station passes…",
  sa_errore: "The space station data isn't coming through right now: try again later.",
  sa_n: "Visible to the naked eye: a bright dot crossing the sky in a few minutes, without blinking. Times as seen {l_da}, starting from 10° above the horizon.",
  sa_stanotte: "Tonight", sa_nessuno: "No visible pass tonight {l_da}.", sa_prossimi: "Over the next few days",
  sa_nessuno_prossimi: "No visible pass over the next 6 days.",
  sa_da_a: "from {da} to {a}", sa_verso: "towards the {d}", sa_alta: "{h}° high at {o}", sa_mag: "magnitude ≈ {m}",
  sa_ombra: "fades into the Earth's shadow at {o}", sa_esce: "appears out of the Earth's shadow",
  sa_molto: "very bright", sa_luminosa: "bright", sa_debole: "visible",
  sa_iss: "ISS", sa_iss_n: "International Space Station", sa_css: "Tiangong", sa_css_n: "Chinese space station",
  sa_fonte: "Orbits: CelesTrak (NORAD data), SGP4 model. Times ±1 minute: stations sometimes adjust their orbit, check again on the day.",
  sa_vecchi: "Orbital data from {g} days ago: times may shift by a few minutes.",
  sa_lontano: "Space station passes can only be worked out for the next 10 days.",
  sa_cielo: "The path across the sky: overhead in the centre, the horizon at the edge", sa_punti: "N E S W",
});
Object.assign(ICONE_SVG, { satellite: '<path d="M9.2 14.8 6.4 17.6M14.6 9.4l3-3"/><rect x="9.6" y="9.6" width="4.8" height="4.8" rx=".8" transform="rotate(45 12 12)"/><path d="m3.4 14.4 3.2-3.2 3 3-3.2 3.2zM14.4 3.4l3.2 3.2-3 3-3.2-3.2zM16.4 20.6a4.2 4.2 0 0 0 4.2-4.2"/>' });
const Sgp4 = (() => {
  const mu = 398600.8, re = 6378.135, xke = 60 / Math.sqrt(re * re * re / mu), j2 = 0.001082616, j3 = -0.00000253881, j4 = -0.00000165597;
  const j3oj2 = j3 / j2, x2o3 = 2 / 3, due = 2 * Math.PI;
  function inizia(el) {
    const ecco = el.e, inclo = el.i, argpo = el.argp, nodeo = el.nodo, mo = el.M, bstar = el.bstar;
    const eccsq = ecco * ecco, omeosq = 1 - eccsq, rteosq = Math.sqrt(omeosq);
    const cosio = Math.cos(inclo), cosio2 = cosio * cosio;
    const ak = Math.pow(xke / el.no, x2o3);
    const d1 = 0.75 * j2 * (3 * cosio2 - 1) / (rteosq * omeosq);
    let del = d1 / (ak * ak);
    const adel = ak * (1 - del * del - del * (1 / 3 + 134 * del * del / 81));
    del = d1 / (adel * adel);
    const no = el.no / (1 + del), ao = Math.pow(xke / no, x2o3);
    if (2 * Math.PI / no >= 225) return null;
    const sinio = Math.sin(inclo), po = ao * omeosq, con42 = 1 - 5 * cosio2, con41 = -con42 - cosio2 - cosio2;
    const posq = po * po, rp = ao * (1 - ecco), isimp = rp < 220 / re + 1;
    let sfour = 78 / re + 1, qzms24 = Math.pow((120 - 78) / re, 4);
    const perige = (rp - 1) * re;
    if (perige < 156) {
      sfour = perige < 98 ? 20 : perige - 78;
      qzms24 = Math.pow((120 - sfour) / re, 4);
      sfour = sfour / re + 1;
    }
    const pinvsq = 1 / posq, tsi = 1 / (ao - sfour), eta = ao * ecco * tsi, etasq = eta * eta, eeta = ecco * eta;
    const psisq = Math.abs(1 - etasq), coef = qzms24 * Math.pow(tsi, 4), coef1 = coef / Math.pow(psisq, 3.5);
    const cc2 = coef1 * no * (ao * (1 + 1.5 * etasq + eeta * (4 + etasq)) + 0.375 * j2 * tsi / psisq * con41 * (8 + 3 * etasq * (8 + etasq)));
    const cc1 = bstar * cc2;
    const cc3 = ecco > 1e-4 ? -2 * coef * tsi * j3oj2 * no * sinio / ecco : 0;
    const x1mth2 = 1 - cosio2;
    const cc4 = 2 * no * coef1 * ao * omeosq * (eta * (2 + 0.5 * etasq) + ecco * (0.5 + 2 * etasq) - j2 * tsi / (ao * psisq) *
      (-3 * con41 * (1 - 2 * eeta + etasq * (1.5 - 0.5 * eeta)) + 0.75 * x1mth2 * (2 * etasq - eeta * (1 + etasq)) * Math.cos(2 * argpo)));
    const cc5 = 2 * coef1 * ao * omeosq * (1 + 2.75 * (etasq + eeta) + eeta * etasq);
    const cosio4 = cosio2 * cosio2;
    const temp1 = 1.5 * j2 * pinvsq * no, temp2 = 0.5 * temp1 * j2 * pinvsq, temp3 = -0.46875 * j4 * pinvsq * pinvsq * no;
    const mdot = no + 0.5 * temp1 * rteosq * con41 + 0.0625 * temp2 * rteosq * (13 - 78 * cosio2 + 137 * cosio4);
    const argpdot = -0.5 * temp1 * con42 + 0.0625 * temp2 * (7 - 114 * cosio2 + 395 * cosio4) + temp3 * (3 - 36 * cosio2 + 49 * cosio4);
    const xhdot1 = -temp1 * cosio;
    const nodedot = xhdot1 + (0.5 * temp2 * (4 - 19 * cosio2) + 2 * temp3 * (3 - 7 * cosio2)) * cosio;
    const omgcof = bstar * cc3 * Math.cos(argpo), xmcof = ecco > 1e-4 ? -x2o3 * coef * bstar / eeta : 0;
    const nodecf = 3.5 * omeosq * xhdot1 * cc1, t2cof = 1.5 * cc1;
    const xlcof = -0.25 * j3oj2 * sinio * (3 + 5 * cosio) / (Math.abs(cosio + 1) > 1.5e-12 ? 1 + cosio : 1.5e-12);
    const aycof = -0.5 * j3oj2 * sinio, delmo = Math.pow(1 + eta * Math.cos(mo), 3), sinmao = Math.sin(mo), x7thm1 = 7 * cosio2 - 1;
    let d2 = 0, d3 = 0, d4 = 0, t3cof = 0, t4cof = 0, t5cof = 0;
    if (!isimp) {
      const cc1sq = cc1 * cc1;
      d2 = 4 * ao * tsi * cc1sq;
      const temp = d2 * tsi * cc1 / 3;
      d3 = (17 * ao + sfour) * temp;
      d4 = 0.5 * temp * ao * tsi * (221 * ao + 31 * sfour) * cc1;
      t3cof = d2 + 2 * cc1sq;
      t4cof = 0.25 * (3 * d3 + cc1 * (12 * d2 + 10 * cc1sq));
      t5cof = 0.2 * (3 * d4 + 12 * cc1 * d3 + 6 * d2 * d2 + 15 * cc1sq * (2 * d2 + cc1sq));
    }
    return { epoca: el.epoca, ecco, inclo, argpo, nodeo, mo, bstar, no, isimp, eta, con41, x1mth2, x7thm1, cc1, cc4, cc5, d2, d3, d4,
      delmo, sinmao, mdot, argpdot, nodedot, omgcof, xmcof, nodecf, t2cof, t3cof, t4cof, t5cof, xlcof, aycof };
  }
  function posizione(s, t) {
    const xmdf = s.mo + s.mdot * t, argpdf = s.argpo + s.argpdot * t, nodedf = s.nodeo + s.nodedot * t, t2 = t * t;
    let argpm = argpdf, mm = xmdf, nodem = nodedf + s.nodecf * t2;
    let tempa = 1 - s.cc1 * t, tempe = s.bstar * s.cc4 * t, templ = s.t2cof * t2;
    if (!s.isimp) {
      const delomg = s.omgcof * t, dm = 1 + s.eta * Math.cos(xmdf), delm = s.xmcof * (dm * dm * dm - s.delmo), temp = delomg + delm;
      mm = xmdf + temp; argpm = argpdf - temp;
      const t3 = t2 * t, t4 = t3 * t;
      tempa = tempa - s.d2 * t2 - s.d3 * t3 - s.d4 * t4;
      tempe = tempe + s.bstar * s.cc5 * (Math.sin(mm) - s.sinmao);
      templ = templ + s.t3cof * t3 + t4 * (s.t4cof + t * s.t5cof);
    }
    if (s.no <= 0) return null;
    const am = Math.pow(xke / s.no, x2o3) * tempa * tempa, nm = xke / Math.pow(am, 1.5);
    let em = s.ecco - tempe;
    if (em >= 1 || em < -0.001) return null;
    if (em < 1e-6) em = 1e-6;
    mm = mm + s.no * templ;
    let xlm = mm + argpm + nodem;
    nodem %= due; argpm %= due; xlm %= due;
    mm = (xlm - argpm - nodem) % due;
    const sinip = Math.sin(s.inclo), cosip = Math.cos(s.inclo);
    const axnl = em * Math.cos(argpm);
    let temp = 1 / (am * (1 - em * em));
    const aynl = em * Math.sin(argpm) + temp * s.aycof, xl = mm + argpm + nodem + temp * s.xlcof * axnl;
    const u = (xl - nodem) % due;
    let eo1 = u, tem5 = 9999.9, ktr = 1, sineo1 = 0, coseo1 = 0;
    while (Math.abs(tem5) >= 1e-12 && ktr <= 10) {
      sineo1 = Math.sin(eo1); coseo1 = Math.cos(eo1);
      tem5 = (u - aynl * coseo1 + axnl * sineo1 - eo1) / (1 - coseo1 * axnl - sineo1 * aynl);
      if (Math.abs(tem5) >= 0.95) tem5 = tem5 > 0 ? 0.95 : -0.95;
      eo1 += tem5; ktr++;
    }
    const ecose = axnl * coseo1 + aynl * sineo1, esine = axnl * sineo1 - aynl * coseo1, el2 = axnl * axnl + aynl * aynl, pl = am * (1 - el2);
    if (pl < 0) return null;
    const rl = am * (1 - ecose), rdotl = Math.sqrt(am) * esine / rl, rvdotl = Math.sqrt(pl) / rl, betal = Math.sqrt(1 - el2);
    temp = esine / (1 + betal);
    const sinu = am / rl * (sineo1 - aynl - axnl * temp), cosu = am / rl * (coseo1 - axnl + aynl * temp);
    let su = Math.atan2(sinu, cosu);
    const sin2u = (cosu + cosu) * sinu, cos2u = 1 - 2 * sinu * sinu;
    temp = 1 / pl;
    const temp1 = 0.5 * j2 * temp, temp2 = temp1 * temp;
    const mrt = rl * (1 - 1.5 * temp2 * betal * s.con41) + 0.5 * temp1 * s.x1mth2 * cos2u;
    if (mrt < 1) return null;
    su -= 0.25 * temp2 * s.x7thm1 * sin2u;
    const xnode = nodem + 1.5 * temp2 * cosip * sin2u, xinc = s.inclo + 1.5 * temp2 * cosip * sinip * cos2u;
    const mvt = rdotl - nm * temp1 * s.x1mth2 * sin2u / xke, rvdot = rvdotl + nm * temp1 * (s.x1mth2 * cos2u + 1.5 * s.con41) / xke;
    const sinsu = Math.sin(su), cossu = Math.cos(su), snod = Math.sin(xnode), cnod = Math.cos(xnode), sini = Math.sin(xinc), cosi = Math.cos(xinc);
    const xmx = -snod * cosi, xmy = cnod * cosi;
    const ux = xmx * sinsu + cnod * cossu, uy = xmy * sinsu + snod * cossu, uz = sini * sinsu;
    const vx = xmx * cossu - cnod * sinsu, vy = xmy * cossu - snod * sinsu, vz = sini * cossu, vk = re * xke / 60;
    return { r: [mrt * ux * re, mrt * uy * re, mrt * uz * re],
      v: [(mvt * ux + rvdot * vx) * vk, (mvt * uy + rvdot * vy) * vk, (mvt * uz + rvdot * vz) * vk] };
  }
  return { inizia, posizione };
})();
function elementiOmm(x) {
  const m = /^(\d{4})-(\d\d)-(\d\d)T(\d\d):(\d\d):(\d\d(?:\.\d+)?)/.exec(x.EPOCH || "");
  if (!m) return null;
  const ms = Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5]) + parseFloat(m[6]) * 1000;
  return { epoca: ms / 86400000 + 2440587.5, no: x.MEAN_MOTION * 2 * Math.PI / 1440, e: x.ECCENTRICITY, i: x.INCLINATION * RAD,
    nodo: x.RA_OF_ASC_NODE * RAD, argp: x.ARG_OF_PERICENTER * RAD, M: x.MEAN_ANOMALY * RAD, bstar: x.BSTAR };
}
const SA_STAZIONI = [[25544, "iss", -2.0], [48274, "css", -0.4]];
const URL_STAZIONI = "https://celestrak.org/NORAD/elements/gp.php?GROUP=stations&FORMAT=JSON", URL_STAZIONI_NOSTRE = "/apps/strumenti/stazioni";
let _stazioni = null;
function caricaStazioni() {
  if (_stazioni) return _stazioni;
  const vecchie = ricorda("stazioni", null), buone = v => v && Array.isArray(v.e) && v.e.length;
  const scarica = (url, leggi) => fetch(url).then(r => { if (!r.ok) throw new Error("orbite " + r.status); return r.json(); }).then(leggi);
  const dati = buone(vecchie) && Date.now() - vecchie.t < 2 * 3600e3 ? Promise.resolve(vecchie)
    : scarica(URL_STAZIONI_NOSTRE, j => j.e).catch(() => scarica(URL_STAZIONI, j => j)).then(j => {
      const e = (Array.isArray(j) ? j : []).filter(x => SA_STAZIONI.some(s => s[0] === x.NORAD_CAT_ID));
      if (!e.length) throw new Error("CelesTrak vuoto");
      const v = { t: Date.now(), e };
      salva("stazioni", v);
      return v;
    }).catch(err => { if (buone(vecchie)) return vecchie; throw err; });
  _stazioni = dati.then(v => v.e.map(x => {
    const s = SA_STAZIONI.find(y => y[0] === x.NORAD_CAT_ID), el = elementiOmm(x), rec = el && Sgp4.inizia(el);
    return rec ? { k: s[1], m0: s[2], rec } : null;
  }).filter(Boolean)).catch(e => { _stazioni = null; throw e; });
  return _stazioni;
}
const SA_A = 6378.137, SA_E2 = (2 - 1 / 298.257223563) / 298.257223563;
function vistaStazione(st, j, lat, lon) {
  const p = Sgp4.posizione(st.rec, (j - st.rec.epoca) * 1440);
  if (!p) return null;
  const th = (Astro.gmst(j) + lon) * RAD, fi = lat * RAD, sf = Math.sin(fi), cf = Math.cos(fi), sth = Math.sin(th), cth = Math.cos(th);
  const N = SA_A / Math.sqrt(1 - SA_E2 * sf * sf);
  const rx = p.r[0] - N * cf * cth, ry = p.r[1] - N * cf * sth, rz = p.r[2] - N * (1 - SA_E2) * sf, d = Math.hypot(rx, ry, rz);
  const su = cf * cth * rx + cf * sth * ry + sf * rz, est = -sth * rx + cth * ry, nord = -sf * cth * rx - sf * sth * ry + cf * rz;
  return { el: Math.asin(su / d) * DEG, az: Astro.n360(Math.atan2(est, nord) * DEG), d, r: p.r, rho: [rx / d, ry / d, rz / d] };
}
function soleStazione(j, lat, lon) {
  const s = Astro.sole(j), cd = Math.cos(s.dec * RAD);
  return { u: [cd * Math.cos(s.ra * RAD), cd * Math.sin(s.ra * RAD), Math.sin(s.dec * RAD)], h: Astro.altezza(s.ra, s.dec, lat, Astro.n360(Astro.gmst(j) + lon)) };
}
function stazioneAlSole(r, u) {
  const k = r[0] * u[0] + r[1] * u[1] + r[2] * u[2];
  return k > 0 || Math.hypot(r[0] - k * u[0], r[1] - k * u[1], r[2] - k * u[2]) > SA_A;
}
function passaggiStazione(st, lat, lon, j0, j1) {
  const fuori = [], grosso = 60 / 86400, fine = 5 / 86400;
  for (let j = j0; j < j1; j += grosso) {
    const v = vistaStazione(st, j, lat, lon);
    if (!v) return fuori;
    if (v.el < 0) continue;
    const punti = [];
    let k = j - grosso;
    for (; k < j1 + 1 / 48; k += fine) {
      const w = vistaStazione(st, k, lat, lon);
      if (!w) break;
      if (w.el >= 0) punti.push([k, w]); else if (punti.length) break;
    }
    j = k;
    const p = analizzaPassaggio(st, punti, lat, lon);
    if (p) fuori.push(p);
  }
  return fuori;
}
function analizzaPassaggio(st, punti, lat, lon) {
  const segni = punti.map(([j, w]) => {
    if (w.el < 10) return null;
    const s = soleStazione(j, lat, lon), alSole = stazioneAlSole(w.r, s.u);
    if (s.h > -6 || !alSole) return { j, el: w.el, buio: true, ombra: !alSole };
    const cf = -(s.u[0] * w.rho[0] + s.u[1] * w.rho[1] + s.u[2] * w.rho[2]);
    return { j, el: w.el, az: w.az, mag: st.m0 - 15.75 + 2.5 * Math.log10(w.d * w.d / Math.max((1 + cf) / 2, 0.01)) };
  });
  let meglio = [], ora_ = [];
  for (const x of segni) {
    if (x && !x.buio) { ora_.push(x); if (ora_.length > meglio.length) meglio = ora_; } else ora_ = [];
  }
  if (meglio.length < 3) return null;
  const a = meglio[0], b = meglio[meglio.length - 1], iA = segni.indexOf(a), iB = segni.indexOf(b);
  const max = meglio.reduce((x, y) => (y.el > x.el ? y : x));
  return { st, inizio: a.j, fine: b.j, da: a.az, a: b.az, max, mag: Math.min(...meglio.map(x => x.mag)),
    ombra: !!(segni[iB + 1] && segni[iB + 1].ombra && segni[iB + 1].el >= 10), esce: !!(segni[iA - 1] && segni[iA - 1].ombra && segni[iA - 1].el >= 10),
    traccia: meglio.filter((x, i) => i % 3 === 0 || i === meglio.length - 1).map(x => [x.az, x.el]) };
}
function cieloPassaggio(p) {
  const R = 44, c = 60, xy = ([az, el]) => { const r = R * (90 - el) / 90; return [c - r * Math.sin(az * RAD), c - r * Math.cos(az * RAD)]; };
  const pt = p.traccia.map(xy), [x0, y0] = pt[0], [x1, y1] = pt[pt.length - 1], [xp, yp] = pt[Math.max(0, pt.length - 2)];
  const ang = Math.atan2(y1 - yp, x1 - xp), fr = (da, l) => `${x1 + l * Math.cos(ang + da)},${y1 + l * Math.sin(ang + da)}`;
  const P = t("sa_punti").split(" ");
  return sv("svg", { viewBox: "0 0 120 120", class: "gas-sa-cielo", role: "img", "aria-label": t("sa_cielo") },
    sv("circle", { cx: c, cy: c, r: R + 12, fill: "#0b1d33" }),
    sv("circle", { cx: c, cy: c, r: R, fill: "none", stroke: "#5f7a99", "stroke-width": 1 }),
    sv("circle", { cx: c, cy: c, r: R / 2, fill: "none", stroke: "#3a5170", "stroke-width": 0.8, "stroke-dasharray": "2 3" }),
    sv("path", { d: `M${c} ${c - R}V${c + R}M${c - R} ${c}H${c + R}`, stroke: "#3a5170", "stroke-width": 0.8 }),
    [[P[0], c, c - R - 3.4], [P[1], c - R - 6.4, c + 4], [P[2], c, c + R + 11], [P[3], c + R + 6.4, c + 4]].map(([s, x, y]) =>
      sv("text", { x, y, "text-anchor": "middle", "font-size": 11, "font-weight": 700, fill: "#c8d2de", text: s })),
    sv("polyline", { points: pt.map(q => q.join(",")).join(" "), fill: "none", stroke: "#f4d58b", "stroke-width": 2.6, "stroke-linecap": "round", "stroke-linejoin": "round" }),
    sv("circle", { cx: x0, cy: y0, r: 2.6, fill: "#0b1d33", stroke: "#f4d58b", "stroke-width": 1.6 }),
    sv("path", { d: `M${fr(Math.PI * 0.82, 7)}L${x1},${y1}L${fr(-Math.PI * 0.82, 7)}`, fill: "none", stroke: "#f4d58b", "stroke-width": 2.4, "stroke-linecap": "round", "stroke-linejoin": "round" }),
    sv("circle", { cx: xy([p.max.az, p.max.el])[0], cy: xy([p.max.az, p.max.el])[1], r: 3.2, fill: "#fff" }));
}
const luceStazione = m => (m <= -2.5 ? "sa_molto" : m <= -1 ? "sa_luminosa" : "sa_debole");
function cartaSatelliti(cn) {
  const titolo = () => el("h3", null, icona("satellite"), " ", t("sa_titolo"));
  const box = el("section", { class: "gas-card gas-sa" }, titolo(), el("p", { class: "gas-muto" }, t("sa_carico")));
  caricaStazioni().then(stazioni => new Promise(ok => setTimeout(() => ok(stazioni), 20))).then(stazioni => {
    const nt = cn.nt, { lat, lon } = NOTTE.luogo, j0 = nt.tempi[0], j1 = nt.tempi[nt.n - 1], adesso = Astro.jd(new Date());
    svuota(box).append(titolo(), el("p", { class: "gas-nota" }, t("sa_n", luogoFrasi())));
    const epoca = Math.max(...stazioni.map(s => s.rec.epoca));
    if (j0 - epoca > 10 || epoca - j1 > 3) { box.append(el("p", null, t("sa_lontano"))); return; }
    const tutti = stazioni.flatMap(st => passaggiStazione(st, lat, lon, j0, j1 + 6)).sort((a, b) => a.inizio - b.inizio);
    const stanotte = tutti.filter(p => p.inizio < j1), dopo = tutti.filter(p => p.inizio >= j1);
    const nome = p => el("b", null, t("sa_" + p.st.k), " ", el("small", null, t("sa_" + p.st.k + "_n")));
    const strada = p => direzione(p.da) === direzione(p.a) ? t("sa_verso", { d: direzione(p.a) }) : t("sa_da_a", { da: direzione(p.da), a: direzione(p.a) });
    const mag = m => num(m, 1).replace("-", "−");
    const sx = el("div", { class: "gas-sa-col" }, el("h4", null, t("sa_stanotte")));
    if (!stanotte.length) sx.append(el("p", null, t("sa_nessuno", luogoFrasi())));
    else sx.append(el("div", { class: "gas-sa-lista" }, stanotte.map(p => el("div", { class: "gas-sa-pass" + (p.fine < adesso ? " gas-sa-passato" : "") },
      cieloPassaggio(p),
      el("div", { class: "gas-sa-testo" }, nome(p),
        el("span", { class: "gas-sa-ora" }, `${ora(Astro.data(p.inizio))} – ${ora(Astro.data(p.fine))}`),
        el("small", null, strada(p), " · ", t("sa_alta", { h: num(p.max.el), o: ora(Astro.data(p.max.j)) })),
        el("small", null, t("sa_mag", { m: mag(p.mag) }), " · ", t(luceStazione(p.mag))),
        p.esce ? el("small", null, t("sa_esce")) : null,
        p.ombra ? el("small", null, t("sa_ombra", { o: ora(Astro.data(p.fine)) })) : null)))));
    const dx = el("div", { class: "gas-sa-col" }, el("h4", null, t("sa_prossimi")));
    if (!dopo.length) dx.append(el("p", { class: "gas-nota" }, t("sa_nessuno_prossimi")));
    else dx.append(el("ul", { class: "gas-sa-prossimi" }, dopo.slice(0, 10).map(p => el("li", null,
      el("b", null, Astro.data(p.inizio).toLocaleDateString(LOCALE, { weekday: "short", day: "numeric", month: "short" }), " · ", ora(Astro.data(p.inizio))),
      " · ", t("sa_" + p.st.k), " · ", strada(p), " · ", t("sa_alta", { h: num(p.max.el), o: ora(Astro.data(p.max.j)) }), " · ≈ ", mag(p.mag)))));
    box.append(el("div", { class: "gas-sa-corpo" }, sx, dx));
    const giorni = Math.floor(adesso - epoca);
    if (giorni >= 3) box.append(el("p", { class: "gas-nota" }, t("sa_vecchi", { g: giorni })));
    box.append(el("p", { class: "gas-co-fonte" }, t("sa_fonte")));
  }).catch(e => { console.error("strumenti, stazioni spaziali:", e); svuota(box).append(titolo(), el("p", { class: "gas-muto" }, t("sa_errore"))); });
  return box;
}
Object.assign(TESTI.it, {
  au_titolo: "Aurora boreale", au_carico: "Controllo l'attività del Sole…", au_errore: "Le previsioni dell'aurora adesso non arrivano: riprova più tardi.",
  au_no: "Stanotte niente aurora {l_da}: l'indice Kp (forza delle tempeste geomagnetiche, da 0 a 9) è previsto fino a {k}, qui serve almeno {s}.",
  au_forse: "Attività geomagnetica alta stanotte (indice Kp fino a {k}), ma per vedere l'aurora {l_da} serve Kp {s}. Tieni d'occhio gli aggiornamenti.",
  au_foto: "Aurora possibile stanotte {l_da}, ma solo in foto: bassa sull'orizzonte nord (Kp previsto {k}). Grandangolo, pose di 5–15 secondi, lontano dalle luci.",
  au_occhio: "Tempesta geomagnetica forte stanotte (Kp previsto {k}): aurora possibile anche a occhio nudo {l_da}, bassa verso nord. In foto si vede di più.",
  au_quando: "Il momento più forte: verso le {o}.", au_lontano: "L'aurora si può prevedere solo per i prossimi 3 giorni.",
  au_fonte: "Previsioni dell'indice Kp: NOAA Space Weather Prediction Center. Le tempeste si prevedono solo 1–3 giorni prima e possono arrivare in anticipo o in ritardo.",
});
Object.assign(TESTI.de, {
  au_titolo: "Polarlicht", au_carico: "Die Sonnenaktivität wird geprüft…", au_errore: "Die Polarlicht-Vorhersage kommt gerade nicht an: später erneut versuchen.",
  au_no: "Heute Nacht kein Polarlicht {l_da}: vorhergesagter Kp-Index bis {k}, hier braucht es mindestens Kp {s}.",
  au_forse: "Hohe geomagnetische Aktivität heute Nacht (Kp bis {k}): {l_da} braucht es Kp {s}. Behalten Sie die Aktualisierungen im Auge.",
  au_foto: "Polarlicht heute Nacht {l_da} möglich, aber nur fotografisch: tief am Nordhorizont (vorhergesagter Kp {k}). Weitwinkel, 5–15 Sekunden belichten, weg von Lichtern.",
  au_occhio: "Starker geomagnetischer Sturm heute Nacht (vorhergesagter Kp {k}): Polarlicht {l_da} auch mit bloßem Auge möglich, tief im Norden. Auf Fotos sieht man mehr.",
  au_quando: "Am stärksten: gegen {o} Uhr.", au_lontano: "Polarlicht lässt sich nur für die nächsten 3 Tage vorhersagen.",
  au_fonte: "Kp-Vorhersage: NOAA Space Weather Prediction Center. Stürme werden nur 1–3 Tage im Voraus vorhergesagt und können früher oder später kommen.",
});
Object.assign(TESTI.es, {
  au_titolo: "Aurora boreal", au_carico: "Comprobando la actividad del Sol…", au_errore: "Ahora no llega la previsión de auroras: vuelve a intentarlo más tarde.",
  au_no: "Esta noche no hay aurora {l_da}: índice Kp previsto hasta {k}, aquí hace falta al menos Kp {s}.",
  au_forse: "Actividad geomagnética alta esta noche (Kp hasta {k}): {l_da} hace falta Kp {s}. Sigue las actualizaciones.",
  au_foto: "Posible aurora esta noche {l_da}, pero solo en foto: baja sobre el horizonte norte (Kp previsto {k}). Gran angular, exposiciones de 5–15 segundos, lejos de las luces.",
  au_occhio: "Fuerte tormenta geomagnética esta noche (Kp previsto {k}): posible aurora incluso a simple vista {l_da}, baja hacia el norte. En foto se ve más.",
  au_quando: "El momento de mayor actividad: hacia las {o}.", au_lontano: "La aurora solo se puede prever para los próximos 3 días.",
  au_fonte: "Previsión del índice Kp: NOAA Space Weather Prediction Center. Las tormentas solo se prevén 1–3 días antes y pueden llegar antes o después.",
});
Object.assign(TESTI.en, {
  au_titolo: "Northern lights", au_carico: "Checking the Sun's activity…", au_errore: "The aurora forecast isn't coming through right now: try again later.",
  au_no: "No aurora tonight {l_da}: forecast Kp index up to {k}, here you need at least Kp {s}.",
  au_forse: "High geomagnetic activity tonight (Kp up to {k}): {l_da} you need Kp {s}. Keep an eye on the updates.",
  au_foto: "Aurora possible tonight {l_da}, but only in photos: low on the northern horizon (forecast Kp {k}). Wide-angle lens, 5–15 second exposures, away from lights.",
  au_occhio: "Strong geomagnetic storm tonight (forecast Kp {k}): aurora possible even to the naked eye {l_da}, low towards the north. Photos show more.",
  au_quando: "Strongest around {o}.", au_lontano: "Aurora can only be forecast for the next 3 days.",
  au_fonte: "Kp index forecast: NOAA Space Weather Prediction Center. Storms can only be forecast 1–3 days ahead and may arrive earlier or later.",
});
Object.assign(TESTI.it, { au_passato: "Per le notti passate non ci sono previsioni dell'aurora: si prevede solo per i prossimi 3 giorni." });
Object.assign(TESTI.de, { au_passato: "Für vergangene Nächte gibt es keine Polarlicht-Vorhersage: sie reicht nur für die nächsten 3 Tage." });
Object.assign(TESTI.es, { au_passato: "Para las noches pasadas no hay previsión de auroras: solo se prevé para los próximos 3 días." });
Object.assign(TESTI.en, { au_passato: "There's no aurora forecast for past nights: it only covers the next 3 days." });
Object.assign(ICONE_SVG, { aurora:'<path d="M3.4 17.6c2.4-6.8 4.6-10.2 6.6-10.2s2.2 4.6 4 4.6 3-3.8 6.6-6.4"/><path d="M3.4 20.6c2.8-3.4 5-5 6.8-5s2.8 2 4.6 2 3.4-1.6 5.8-4"/>' });
const URL_KP = "https://services.swpc.noaa.gov/products/noaa-planetary-k-index-forecast.json";
let _kp = null;
function caricaKp() {
  if (_kp) return _kp;
  const vecchi = ricorda("kp", null), buoni = v => v && Array.isArray(v.b) && v.b.length;
  _kp = (buoni(vecchi) && Date.now() - vecchi.t < 3600e3 ? Promise.resolve(vecchi.b)
    : fetch(URL_KP).then(r => { if (!r.ok) throw new Error("NOAA " + r.status); return r.json(); }).then(j => {
      const righe = Array.isArray(j) ? j.map(x => Array.isArray(x) ? { time_tag: x[0], kp: parseFloat(x[1]) } : x) : [];
      const b = righe.map(x => ({ j: Date.parse(String(x.time_tag).replace(" ", "T") + "Z") / 86400000 + 2440587.5, kp: +x.kp }))
        .filter(x => Number.isFinite(x.j) && Number.isFinite(x.kp));
      if (!b.length) throw new Error("NOAA vuoto");
      salva("kp", { t: Date.now(), b });
      return b;
    }).catch(e => { if (buoni(vecchi)) return vecchi.b; throw e; })).catch(e => { _kp = null; throw e; });
  return _kp;
}
function latGeomagnetica(lat, lon) {
  const fp = 80.8 * RAD, lp = -72.7 * RAD, f = lat * RAD, l = lon * RAD;
  return Math.asin(Math.sin(f) * Math.sin(fp) + Math.cos(f) * Math.cos(fp) * Math.cos(l - lp)) * DEG;
}
const sogliaKp = (lat, lon) => clamp(Math.round(8 - (latGeomagnetica(lat, lon) - 42) / 4.3), 3, 9);
function cartaAurora(cn) {
  const titolo = () => el("h3", null, icona("aurora"), " ", t("au_titolo"));
  const box = el("section", { class: "gas-card gas-au" }, titolo(), el("p", { class: "gas-muto" }, t("au_carico")));
  caricaKp().then(blocchi => {
    const nt = cn.nt, ore = nt.buio.length ? nt.buio : nt.tempi.map((_, i) => i).filter(i => nt.hSole[i] < -6);
    const a = nt.tempi[ore.length ? ore[0] : 0], b = nt.tempi[ore.length ? ore[ore.length - 1] : nt.n - 1];
    const dentro = blocchi.filter(x => x.j < b && x.j + 0.125 > a);
    svuota(box).append(titolo());
    if (!dentro.length) {
      const js = blocchi.map(x => x.j);
      box.append(el("p", { class: "gas-muto" }, t(a > Math.max(...js) ? "au_lontano" : b < Math.min(...js) ? "au_passato" : "au_errore"))); return;
    }
    const forte = dentro.reduce((x, y) => (y.kp > x.kp ? y : x)), k = forte.kp, { lat, lon } = NOTTE.luogo, s = sogliaKp(lat, lon);
    const livello = k >= s + 1 ? "occhio" : k >= s ? "foto" : k >= s - 1 ? "forse" : "no";
    box.classList.add("gas-au--" + livello);
    const v = Object.assign({ k: num(k, 1), s: num(s) }, luogoFrasi());
    box.append(el("p", { class: "gas-au-testo" }, t("au_" + livello, v)));
    if (livello !== "no") box.append(el("p", { class: "gas-nota" }, t("au_quando", { o: ora(Astro.data(Math.max(a, forte.j) + 0.0625)) })));
    box.append(el("p", { class: "gas-co-fonte" }, t("au_fonte")));
  }).catch(e => { console.error("strumenti, aurora:", e); svuota(box).append(titolo(), el("p", { class: "gas-muto" }, t("au_errore"))); });
  return box;
}
Object.assign(TESTI.it, {
  tr_paese: "vicino a {p}", tr_in_mare: "entro {r} km passa solo sul mare", tr_mare_n: "Entro {r} km da casa la linea centrale passa solo sul mare: il punto verde è in mare. Allarga la distanza per trovare un punto sulla terraferma.",
  tr_titolo: "Transiti della ISS davanti al Sole e alla Luna",
  tr_n: "La stazione attraversa il disco in un attimo, da mezzo secondo a qualche secondo, e si vede solo da una striscia di terra larga pochi chilometri. Qui trovi i transiti dei prossimi giorni entro {r} km {l_da}, con il punto dove andare.",
  tr_entro: "Entro", tr_giorni: "Giorni", tr_cerca: "Cerca", tr_calcolo: "Cerco i transiti… {p} %",
  tr_nessuno: "Nessun transito entro {r} km nei prossimi {g} giorni. Prova ad allargare la distanza o ad aumentare i giorni.",
  tr_sole: "Sole", tr_luna: "Luna", tr_davanti_sole: "davanti al Sole", tr_davanti_luna: "davanti alla Luna", tr_da_casa: "Si vede anche da casa!",
  tr_dove: "a {km} km verso {d}", tr_durata: "{s} s sul disco", tr_alto: "altezza {h}°",
  tr_mappa: "La striscia verde è la zona da cui si vede il transito: sulla linea al centro la stazione passa nel mezzo del disco, verso i bordi della striscia lo sfiora appena. Il punto verde è dove andare: il punto della linea, sulla terraferma, più vicino a casa tua (il punto giallo).",
  tr_maps: "Apri il punto in Maps", tr_punto: "Coordinate: {lat}, {lon}",
  tr_c_alt: "Altezza", tr_c_dur: "Durata sul disco", tr_c_dist: "Distanza della stazione", tr_c_gr: "Grandezza della stazione",
  tr_c_fascia: "Larghezza della striscia", tr_c_casa: "Da casa: distanza minima dal centro",
  tr_meteo: "Nuvole previste lì a quell'ora: {n} %", tr_meteo_no: "Previsione delle nuvole: disponibile solo da 9 giorni prima del transito.",
  tr_filtro: "Il Sole si guarda e si fotografa SOLO con un filtro solare a tutta apertura davanti all'obiettivo o al telescopio.",
  tr_filtri: "Filtri solari", tr_fase: "Luna illuminata: {k} %.", tr_sottile: "Luna sottile: la stazione si vede solo sulla parte illuminata.",
  tr_lontano: "Oltre 3 giorni gli orari possono spostarsi di qualche secondo e la striscia di qualche chilometro: ricontrolla il giorno prima.",
  tr_fonte: "Orbite: CelesTrak (dati NORAD), calcolo SGP4 · Mappa © OpenStreetMap",
  tr_errore: "I dati delle stazioni spaziali adesso non arrivano: riprova più tardi.",
});
Object.assign(TESTI.de, {
  tr_paese: "bei {p}", tr_in_mare: "im Umkreis von {r} km nur über dem Meer", tr_mare_n: "Im Umkreis von {r} km verläuft die Mittellinie nur über dem Meer: der grüne Punkt liegt im Meer. Vergrößern Sie die Entfernung, um einen Punkt an Land zu finden.",
  tr_titolo: "Transite der ISS vor Sonne und Mond",
  tr_n: "Die Station zieht in einem Augenblick vor der Scheibe vorbei, eine halbe bis einige Sekunden lang, und ist nur von einem wenige Kilometer breiten Streifen aus sichtbar. Hier finden Sie die Transite der nächsten Tage im Umkreis von {r} km {l_da}, mit dem Ort, an den man fahren muss.",
  tr_entro: "Umkreis", tr_giorni: "Tage", tr_cerca: "Suchen", tr_calcolo: "Transite werden gesucht… {p} %",
  tr_nessuno: "Kein Transit im Umkreis von {r} km in den nächsten {g} Tagen. Umkreis oder Tage vergrößern.",
  tr_sole: "Sonne", tr_luna: "Mond", tr_davanti_sole: "vor der Sonne", tr_davanti_luna: "vor dem Mond", tr_da_casa: "Auch von zu Hause sichtbar!",
  tr_dove: "{km} km Richtung {d}", tr_durata: "{s} s auf der Scheibe", tr_alto: "Höhe {h}°",
  tr_mappa: "Der grüne Streifen ist das Gebiet, von dem aus man den Transit sieht: Auf der Mittellinie zieht die Station durch die Mitte der Scheibe, zu den Rändern des Streifens hin streift sie sie nur. Der grüne Punkt ist das Ziel: der Punkt der Linie an Land, der Ihrem Zuhause (gelber Punkt) am nächsten liegt.",
  tr_maps: "Punkt in Maps öffnen", tr_punto: "Koordinaten: {lat}, {lon}",
  tr_c_alt: "Höhe", tr_c_dur: "Dauer auf der Scheibe", tr_c_dist: "Entfernung der Station", tr_c_gr: "Größe der Station",
  tr_c_fascia: "Breite des Streifens", tr_c_casa: "Von zu Hause: geringster Abstand zur Mitte",
  tr_meteo: "Vorhergesagte Wolken dort zu dieser Zeit: {n} %", tr_meteo_no: "Wolkenvorhersage: erst ab 9 Tagen vor dem Transit verfügbar.",
  tr_filtro: "Die Sonne NUR mit einem Sonnenfilter über die volle Öffnung vor Objektiv oder Teleskop beobachten und fotografieren.",
  tr_filtri: "Sonnenfilter", tr_fase: "Mond beleuchtet: {k} %.", tr_sottile: "Schmaler Mond: die Station ist nur vor dem beleuchteten Teil sichtbar.",
  tr_lontano: "Nach mehr als 3 Tagen können sich die Zeiten um einige Sekunden und der Streifen um einige Kilometer verschieben: am Vortag nochmals prüfen.",
  tr_fonte: "Bahnen: CelesTrak (NORAD-Daten), SGP4-Berechnung · Karte © OpenStreetMap",
  tr_errore: "Die Daten der Raumstationen kommen gerade nicht an: später erneut versuchen.",
});
Object.assign(TESTI.es, {
  tr_paese: "cerca de {p}", tr_in_mare: "a menos de {r} km solo pasa sobre el mar", tr_mare_n: "A menos de {r} km de casa la línea central solo pasa sobre el mar: el punto verde está en el mar. Amplía la distancia para encontrar un punto en tierra firme.",
  tr_titolo: "Tránsitos de la ISS por delante del Sol y de la Luna",
  tr_n: "La estación cruza el disco en un instante, de medio segundo a unos pocos segundos, y solo se ve desde una franja de tierra de pocos kilómetros de ancho. Aquí tienes los tránsitos de los próximos días a menos de {r} km {l_di}, con el punto adonde ir.",
  tr_entro: "A menos de", tr_giorni: "Días", tr_cerca: "Buscar", tr_calcolo: "Buscando tránsitos… {p} %",
  tr_nessuno: "Ningún tránsito a menos de {r} km en los próximos {g} días. Prueba a ampliar la distancia o a aumentar los días.",
  tr_sole: "Sol", tr_luna: "Luna", tr_davanti_sole: "delante del Sol", tr_davanti_luna: "delante de la Luna", tr_da_casa: "¡Se ve también desde casa!",
  tr_dove: "a {km} km hacia el {d}", tr_durata: "{s} s en el disco", tr_alto: "a {h}° de altura",
  tr_mappa: "La franja verde es la zona desde donde se ve el tránsito: en la línea central la estación pasa por el centro del disco, hacia los bordes de la franja apenas lo roza. El punto verde es adonde ir: el punto de la línea, en tierra firme, más cercano a tu casa (el punto amarillo).",
  tr_maps: "Abrir el punto en Maps", tr_punto: "Coordenadas: {lat}, {lon}",
  tr_c_alt: "Altura", tr_c_dur: "Duración en el disco", tr_c_dist: "Distancia de la estación", tr_c_gr: "Tamaño de la estación",
  tr_c_fascia: "Anchura de la franja", tr_c_casa: "Desde casa: distancia mínima al centro",
  tr_meteo: "Nubes previstas allí a esa hora: {n} %", tr_meteo_no: "Previsión de nubes: disponible solo desde 9 días antes del tránsito.",
  tr_filtro: "El Sol se observa y se fotografía SOLO con un filtro solar de apertura completa delante del objetivo o del telescopio.",
  tr_filtri: "Filtros solares", tr_fase: "Luna iluminada: {k} %.", tr_sottile: "Luna fina: la estación solo se ve sobre la parte iluminada.",
  tr_lontano: "Más allá de 3 días los horarios pueden variar unos segundos y la franja desplazarse unos kilómetros: vuelve a comprobarlo el día antes.",
  tr_fonte: "Órbitas: CelesTrak (datos NORAD), cálculo SGP4 · Mapa © OpenStreetMap",
  tr_errore: "Ahora no llegan los datos de las estaciones espaciales: vuelve a intentarlo más tarde.",
});
Object.assign(TESTI.en, {
  tr_paese: "near {p}", tr_in_mare: "within {r} km it only crosses the sea", tr_mare_n: "Within {r} km of home the centre line only crosses the sea: the green dot is at sea. Increase the distance to find a spot on land.",
  tr_titolo: "ISS transits across the Sun and the Moon",
  tr_n: "The station crosses the disc in a flash, from half a second to a few seconds, and is visible only from a strip of land a few kilometres wide. Here are the transits over the coming days within {r} km {l_di}, with the spot to go to.",
  tr_entro: "Within", tr_giorni: "Days", tr_cerca: "Search", tr_calcolo: "Searching for transits… {p}%",
  tr_nessuno: "No transit within {r} km in the next {g} days. Try a larger distance or more days.",
  tr_sole: "Sun", tr_luna: "Moon", tr_davanti_sole: "across the Sun", tr_davanti_luna: "across the Moon", tr_da_casa: "Visible from home too!",
  tr_dove: "{km} km to the {d}", tr_durata: "{s} s on the disc", tr_alto: "altitude {h}°",
  tr_mappa: "The green strip is the area the transit is visible from: on the centre line the station crosses the middle of the disc, towards the edges of the strip it only grazes it. The green dot is where to go: the spot on the line, on land, closest to your home (the yellow dot).",
  tr_maps: "Open the spot in Maps", tr_punto: "Coordinates: {lat}, {lon}",
  tr_c_alt: "Altitude", tr_c_dur: "Time on the disc", tr_c_dist: "Distance of the station", tr_c_gr: "Size of the station",
  tr_c_fascia: "Width of the strip", tr_c_casa: "From home: shortest distance from the centre",
  tr_meteo: "Clouds forecast there at that time: {n}%", tr_meteo_no: "Cloud forecast: only available from 9 days before the transit.",
  tr_filtro: "Look at and photograph the Sun ONLY with a full-aperture solar filter in front of the lens or telescope.",
  tr_filtri: "Solar filters", tr_fase: "Moon {k}% lit.", tr_sottile: "Thin crescent: the station only shows up against the lit part.",
  tr_lontano: "Beyond 3 days times can shift by a few seconds and the strip by a few kilometres: check again the day before.",
  tr_fonte: "Orbits: CelesTrak (NORAD data), SGP4 model · Map © OpenStreetMap",
  tr_errore: "The space station data isn't coming through right now: try again later.",
});
Object.assign(TESTI.it, { tr_apri: "Apri i transiti", tr_prossimo: "Il prossimo vicino a te: {q} · {s} {c}{p}.", tr_cerco_breve: "Cerco il prossimo vicino a te…" });
Object.assign(TESTI.de, { tr_apri: "Transite öffnen", tr_prossimo: "Der nächste in Ihrer Nähe: {q} · {s} {c}{p}.", tr_cerco_breve: "Ich suche den nächsten in Ihrer Nähe…" });
Object.assign(TESTI.es, { tr_apri: "Abrir los tránsitos", tr_prossimo: "El próximo cerca de ti: {q} · {s} {c}{p}.", tr_cerco_breve: "Buscando el próximo cerca de ti…" });
Object.assign(TESTI.en, { tr_apri: "Open ISS transits", tr_prossimo: "The next one near you: {q} · {s} {c}{p}.", tr_cerco_breve: "Looking for the next one near you…" });
ICONE_SVG.satellite = '<path d="M2 9h6v6H2zM16 9h6v6h-6zM8 12h8M10 10h4v4h-4z"/>';
Object.assign(TESTI.it, { tr_casa_fuori: "da casa non passa davanti" });
Object.assign(TESTI.de, { tr_casa_fuori: "von zu Hause zieht sie nicht davor vorbei" });
Object.assign(TESTI.es, { tr_casa_fuori: "desde casa no pasa por delante" });
Object.assign(TESTI.en, { tr_casa_fuori: "from home it doesn't cross the disc" });
Object.assign(TESTI.it, {
  tr_giorno: "Transito di giorno: la Luna è a {d}° dal Sole. Cercala senza mai far passare il telescopio o il cercatore sul Sole.",
  tr_vecchi: "Le orbite sono di {g} giorni fa: l'ora e la striscia possono essere sbagliate di molto. Ricontrolla con la rete prima di partire.",
});
Object.assign(TESTI.de, {
  tr_giorno: "Transit am Tag: Der Mond steht {d}° von der Sonne entfernt. Suchen Sie ihn, ohne Teleskop oder Sucher je über die Sonne zu schwenken.",
  tr_vecchi: "Die Bahndaten sind {g} Tage alt: Zeit und Streifen können deutlich abweichen. Prüfen Sie vor der Abfahrt noch einmal mit Netz.",
});
Object.assign(TESTI.es, {
  tr_giorno: "Tránsito de día: la Luna está a {d}° del Sol. Búscala sin pasar nunca el telescopio ni el buscador por el Sol.",
  tr_vecchi: "Las órbitas son de hace {g} días: la hora y la franja pueden estar muy equivocadas. Vuelve a comprobarlo con conexión antes de salir.",
});
Object.assign(TESTI.en, {
  tr_giorno: "Daytime transit: the Moon is {d}° from the Sun. Find it without ever sweeping the telescope or finder across the Sun.",
  tr_vecchi: "The orbits are {g} days old: the time and the strip may be well off. Check again online before you set off.",
});
const angoloTr =g => (g < 1 ? `${num(g * 60, 1)}′` : `${num(g, 1)}°`);
const TR_B = 6356.752314;
const TR_LUNGHEZZA = { iss: 0.109, css: 0.055 };
const TR_ROT = 7.2921159e-5;
function trCorpo(k, j) {
  const c = k === "sole" ? Astro.sole(j) : Astro.luna(j), d = k === "sole" ? c.dist * 149597870.7 : c.dist, cd = Math.cos(c.dec * RAD);
  return [d * cd * Math.cos(c.ra * RAD), d * cd * Math.sin(c.ra * RAD), d * Math.sin(c.dec * RAD)];
}
function trCorpoVeloce(k, j, cache) {
  const m = Math.floor(j * 1440), f = j * 1440 - m;
  const a = cache.get(k + m) || (cache.set(k + m, trCorpo(k, m / 1440)), cache.get(k + m));
  const b = cache.get(k + (m + 1)) || (cache.set(k + (m + 1), trCorpo(k, (m + 1) / 1440)), cache.get(k + (m + 1)));
  if (cache.size > 400) cache.clear();
  return [a[0] + (b[0] - a[0]) * f, a[1] + (b[1] - a[1]) * f, a[2] + (b[2] - a[2]) * f];
}
function trPuntoCentrale(p, c, j) {
  let ux = p.r[0] - c[0], uy = p.r[1] - c[1], uz = p.r[2] - c[2];
  const nu = Math.hypot(ux, uy, uz);
  ux /= nu; uy /= nu; uz /= nu;
  const f = SA_A / TR_B, Pz = p.r[2] * f, Uz = uz * f;
  const A = ux * ux + uy * uy + Uz * Uz, B = 2 * (p.r[0] * ux + p.r[1] * uy + Pz * Uz), C = p.r[0] * p.r[0] + p.r[1] * p.r[1] + Pz * Pz - SA_A * SA_A;
  const disc = B * B - 4 * A * C;
  if (disc < 0) return null;
  const s = (-B - Math.sqrt(disc)) / (2 * A);
  if (!(s > 0)) return null;
  const g = [p.r[0] + s * ux, p.r[1] + s * uy, p.r[2] + s * uz];
  const lon = Astro.n360(Math.atan2(g[1], g[0]) * DEG - Astro.gmst(j) + 180) - 180;
  const lat = Math.atan2(g[2], (1 - SA_E2) * Math.hypot(g[0], g[1])) * DEG;
  const th = (Astro.gmst(j) + lon) * RAD, fi = lat * RAD, sf = Math.sin(fi), cf = Math.cos(fi), sth = Math.sin(th), cth = Math.cos(th);
  const su = -(cf * cth * ux + cf * sth * uy + sf * uz), est = -(-sth * ux + cth * uy), nord = -(-sf * cth * ux - sf * sth * uy + cf * uz);
  return { lat, lon, g, s, u: [ux, uy, uz], h: Math.asin(su) * DEG, az: Astro.n360(Math.atan2(est, nord) * DEG) };
}
function trKm(la1, lo1, la2, lo2) {
  const a = Math.sin((la2 - la1) * RAD / 2) ** 2 + Math.cos(la1 * RAD) * Math.cos(la2 * RAD) * Math.sin((lo2 - lo1) * RAD / 2) ** 2;
  return 2 * 6371.0088 * Math.asin(Math.min(1, Math.sqrt(a)));
}
function trAz(la1, lo1, la2, lo2) {
  const y = Math.sin((lo2 - lo1) * RAD) * Math.cos(la2 * RAD), x = Math.cos(la1 * RAD) * Math.sin(la2 * RAD) - Math.sin(la1 * RAD) * Math.cos(la2 * RAD) * Math.cos((lo2 - lo1) * RAD);
  return Astro.n360(Math.atan2(y, x) * DEG);
}
const trDiametro = (k, d) => k === "sole" ? 2 * Math.atan(696000 / d) * DEG : 2 * Math.asin(1737.4 / d) * DEG;
async function cercaTransiti(st, lat, lon, j0, j1, raggio, corpi, hmin, avanza) {
  const fuori = [], passo = 8 / 86400, cache = new Map();
  const kmx = Math.cos(lat * RAD) * 111.32, kmy = 110.57;
  const xy = g => [(g.lon - lon) * kmx, (g.lat - lat) * kmy];
  const prec = {};
  let n = 0;
  for (let j = j0; j < j1; j += passo) {
    if (++n % 3000 === 0) { if (avanza) avanza((j - j0) / (j1 - j0)); await new Promise(ok => setTimeout(ok, 0)); }
    const p = Sgp4.posizione(st.rec, (j - st.rec.epoca) * 1440);
    if (!p) break;
    for (const k of corpi) {
      const g = trPuntoCentrale(p, trCorpoVeloce(k, j, cache), j);
      const a = prec[k];
      prec[k] = g && g.h > hmin - 5 ? { j, g } : null;
      if (!g || !a || g.h < hmin - 5) continue;
      const [x1, y1] = xy(a.g), [x2, y2] = xy(g), dx = x2 - x1, dy = y2 - y1, l2 = dx * dx + dy * dy;
      if (l2 > 2500 * 2500) continue;
      const tq = l2 ? Math.max(0, Math.min(1, -(x1 * dx + y1 * dy) / l2)) : 0;
      if (Math.hypot(x1 + tq * dx, y1 + tq * dy) > raggio + 15) continue;
      const dist = jj => {
        const q = Sgp4.posizione(st.rec, (jj - st.rec.epoca) * 1440), gg = q && trPuntoCentrale(q, trCorpo(k, jj), jj);
        return gg && gg.h > 0 ? trKm(lat, lon, gg.lat, gg.lon) : 1e9;
      };
      if (fuori.some(e => e.corpo === k && Math.abs(e.j - j) < 150 / 86400)) continue;
      let jMeglio = a.j, dMeglio = 1e9;
      for (let s = -30; s <= 90; s++) {
        const jj = a.j + s / 86400, d = dist(jj);
        if (d < dMeglio) { dMeglio = d; jMeglio = jj; }
      }
      let lo = jMeglio - 1.5 / 86400, hi = jMeglio + 1.5 / 86400;
      for (let i = 0; i < 40; i++) {
        const m1 = lo + (hi - lo) / 3, m2 = hi - (hi - lo) / 3;
        if (dist(m1) < dist(m2)) hi = m2; else lo = m1;
      }
      const jt = (lo + hi) / 2, dmin = dist(jt);
      if (dmin > raggio || fuori.some(e => e.corpo === k && Math.abs(e.j - jt) < 60 / 86400)) continue;
      const ev = dettaglioTransito(st, k, jt, lat, lon);
      if (ev && ev.h >= hmin) fuori.push(ev);
    }
  }
  if (avanza) avanza(1);
  return fuori.filter(e => !(e.corpo === "luna" && e.hSole > -6 && e.fase < 0.1));
}
function dettaglioTransito(st, k, jt, lat, lon) {
  const p = Sgp4.posizione(st.rec, (jt - st.rec.epoca) * 1440), c = trCorpo(k, jt), g = p && trPuntoCentrale(p, c, jt);
  if (!g) return null;
  const vo = [-TR_ROT * g.g[1], TR_ROT * g.g[0], 0];
  const rv = [p.v[0] - vo[0], p.v[1] - vo[1], p.v[2] - vo[2]], rho = [-g.u[0], -g.u[1], -g.u[2]];
  const lungo = rv[0] * rho[0] + rv[1] * rho[1] + rv[2] * rho[2];
  const traverso = Math.hypot(rv[0] - lungo * rho[0], rv[1] - lungo * rho[1], rv[2] - lungo * rho[2]);
  const omega = traverso / g.s * DEG;
  const dCorpo = Math.hypot(c[0] - g.g[0], c[1] - g.g[1], c[2] - g.g[2]), diam = trDiametro(k, dCorpo);
  const g2 = (() => { const jj = jt + 0.5 / 86400, q = Sgp4.posizione(st.rec, (jj - st.rec.epoca) * 1440); return q && trPuntoCentrale(q, trCorpo(k, jj), jj); })();
  const velKm = g2 ? trKm(g.lat, g.lon, g2.lat, g2.lon) * 2 : 8;
  const dLuogo = trKm(lat, lon, g.lat, g.lon), mezzo = (dLuogo + 60) / Math.max(velKm, 1), linea = [];
  for (let i = -24; i <= 24; i++) {
    const jj = jt + mezzo * i / 24 / 86400, q = Sgp4.posizione(st.rec, (jj - st.rec.epoca) * 1440), gg = q && trPuntoCentrale(q, trCorpo(k, jj), jj);
    if (gg && gg.h > 0) linea.push([gg.lat, gg.lon]);
  }
  const r0 = g.s * Math.tan(diam / 2 * RAD), aB = r0 / Math.max(Math.sin(g.h * RAD), 0.05);
  const dirLinea = g2 ? trAz(g.lat, g.lon, g2.lat, g2.lon) : 0, traversoAz = (dirLinea + 90) * RAD, azC = g.az * RAD;
  const cosA = Math.cos(traversoAz - azC), sinA = Math.sin(traversoAz - azC);
  const larghezza = 2 * Math.hypot(aB * cosA, r0 * sinA);
  const daCasa = minimoDaCasa(st, k, jt, lat, lon);
  const ve = traverso > 0 ? direzioneNelCielo(st, k, jt, g) : 0;
  const so = k === "luna" ? Astro.sole(jt) : null, lu = so && Astro.luna(jt);
  return { st, corpo: k, j: jt, lat: g.lat, lon: g.lon, h: g.h, az: g.az, dist: g.s, diam, omega, durata: diam / omega,
    grandezza: TR_LUNGHEZZA[st.k] / g.s * 206265, larghezza, vel: velKm, km: dLuogo, verso: trAz(lat, lon, g.lat, g.lon), linea, daCasa, angolo: ve,
    fase: k === "luna" ? Astro.faseLuna(jt).k : null,
    hSole: so ? Astro.altezza(so.ra, so.dec, g.lat, Astro.n360(Astro.gmst(jt) + g.lon)) : g.h, elong: so ? Astro.separazione(so.ra, so.dec, lu.ra, lu.dec) : 0 };
}
async function suTerraferma(e, lat, lon, raggio) {
  const cache = new Map(), passi = [], tMax = Math.sqrt(Math.max(0, raggio * raggio - e.km * e.km)) / Math.max(e.vel || 8, 1) + 1;
  for (let s = -tMax; s <= tMax + 1e-9; s += 0.05) {
    const jj = e.j + s / 86400, q = Sgp4.posizione(e.st.rec, (jj - e.st.rec.epoca) * 1440), g = q && trPuntoCentrale(q, trCorpoVeloce(e.corpo, jj, cache), jj);
    if (g && g.h > 0) passi.push({ s, lat: g.lat, lon: g.lon, km: trKm(lat, lon, g.lat, g.lon) });
  }
  if (!passi.length) return e;
  let info;
  try { info = await Luoghi.terraferma(passi.map(x => [x.lat, x.lon])); } catch (err) { return e; }
  const i0 = passi.reduce((m, x, i) => (Math.abs(x.s) < Math.abs(passi[m].s) ? i : m), 0);
  const cand = passi.map((x, i) => i).filter(i => info[i].terra !== false && (i === i0 || passi[i].km <= raggio)).sort((a, b) => passi[a].km - passi[b].km);
  let scelto = -1;
  for (const i of cand.slice(0, 200)) {
    let ok = true;
    try { ok = await terraOsm(passi[i].lat, passi[i].lon); } catch (err) {   }
    if (ok) { scelto = i; break; }
  }
  if (scelto < 0) return Object.assign(e, { inMare: true, mareEntro: raggio, paese: "" });
  if (scelto === i0) return Object.assign(e, { paese: info[i0].vicino });
  const e2 = dettaglioTransito(e.st, e.corpo, e.j + passi[scelto].s / 86400, lat, lon);
  return e2 && e2.h >= 10 ? Object.assign(e2, { paese: info[scelto].vicino, mare: { lat: e.lat, lon: e.lon, km: e.km } }) : e;
}
const TR_TASSELLI = new Map();
function pixelOsm(z, x, y) {
  const k = `${z}/${x}/${y}`;
  if (!TR_TASSELLI.has(k)) {
    const p = new Promise((ok, no) => {
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => {
        try { const c = document.createElement("canvas"); c.width = c.height = 256; const g = c.getContext("2d"); g.drawImage(img, 0, 0); ok(g.getImageData(0, 0, 256, 256).data); }
        catch (err) { no(err); }
      };
      img.onerror = () => no(new Error("tassello " + k));
      img.src = `https://tile.openstreetmap.org/${k}.png`;
    });
    p.catch(() => TR_TASSELLI.delete(k));
    TR_TASSELLI.set(k, p);
    if (TR_TASSELLI.size > 80) TR_TASSELLI.delete(TR_TASSELLI.keys().next().value);
  }
  return TR_TASSELLI.get(k);
}
async function terraOsm(la, lo) {
  const z = 11, n = 2 ** z, fx = (lo + 180) / 360 * n * 256, fy = (1 - Math.log(Math.tan(Math.PI / 4 + la * RAD / 2)) / Math.PI) / 2 * n * 256;
  for (let dy = -2; dy <= 2; dy++) for (let dx = -2; dx <= 2; dx++) {
    const gx = Math.floor(fx) + dx, gy = Math.floor(fy) + dy, x = Math.floor(gx / 256), y = Math.floor(gy / 256);
    const d = await pixelOsm(z, x, y), i = ((gy - y * 256) * 256 + (gx - x * 256)) * 4;
    if (Math.abs(d[i] - 170) + Math.abs(d[i + 1] - 211) + Math.abs(d[i + 2] - 223) < 24) return false;
  }
  return true;
}
function minimoDaCasa(st, k, jt, lat, lon) {
  let meglio = { sep: 99, j: jt };
  for (let i = -60; i <= 60; i++) {
    const jj = jt + i * 0.05 / 86400, v = vistaStazione(st, jj, lat, lon);
    if (!v) continue;
    const c = trCorpo(k, jj), th = (Astro.gmst(jj) + lon) * RAD, fi = lat * RAD, sf = Math.sin(fi), cf = Math.cos(fi);
    const N = SA_A / Math.sqrt(1 - SA_E2 * sf * sf), o = [N * cf * Math.cos(th), N * cf * Math.sin(th), N * (1 - SA_E2) * sf];
    const cx = c[0] - o[0], cy = c[1] - o[1], cz = c[2] - o[2], cd = Math.hypot(cx, cy, cz);
    const sep = Math.acos(Math.max(-1, Math.min(1, (cx * v.rho[0] + cy * v.rho[1] + cz * v.rho[2]) / cd))) * DEG;
    if (sep < meglio.sep) meglio = { sep, j: jj, raggio: trDiametro(k, cd) / 2 };
  }
  return meglio;
}
function direzioneNelCielo(st, k, jt, g) {
  const lat = g.lat, lon = g.lon, dt = 0.3 / 86400;
  const v1 = vistaStazione(st, jt - dt, lat, lon), v2 = vistaStazione(st, jt + dt, lat, lon);
  if (!v1 || !v2) return 0;
  let daz = v2.az - v1.az;
  if (daz > 180) daz -= 360; if (daz < -180) daz += 360;
  return Math.atan2(v2.el - v1.el, daz * Math.cos(g.h * RAD)) * DEG;
}
const trOraSec = j => Astro.data(j).toLocaleTimeString(LOCALE, { hour: "2-digit", minute: "2-digit", second: "2-digit" });
const trGiorno = j => Astro.data(j).toLocaleDateString(LOCALE, { weekday: "short", day: "numeric", month: "short" });
function mappaTransito(e, lat, lon) {
  const span = e.km + 40, mLat = (lat + e.lat) / 2, mLon = (lon + e.lon) / 2, cosL = Math.cos(mLat * RAD);
  const z = Math.max(5, Math.min(13, Math.floor(Math.log2(40075 * cosL * 3 / (span * 1.35)))));
  const n = 256 * 2 ** z, px = (la, lo) => [(lo + 180) / 360 * n, (1 - Math.log(Math.tan(Math.PI / 4 + la * RAD / 2)) / Math.PI) / 2 * n];
  const [cx, cy] = px(mLat, mLon), ox = cx - 384, oy = cy - 384, P = (la, lo) => { const [x, y] = px(la, lo); return [x - ox, y - oy]; };
  const kmPx = n / (40075 * cosL);
  const tasselli = [];
  for (let ty = Math.floor(oy / 256); ty <= Math.floor((oy + 768) / 256); ty++) for (let tx = Math.floor(ox / 256); tx <= Math.floor((ox + 768) / 256); tx++) {
    const nt = 2 ** z, x = ((tx % nt) + nt) % nt;
    tasselli.push(sv("image", { href: `https://tile.openstreetmap.org/${z}/${x}/${ty}.png`, x: tx * 256 - ox, y: ty * 256 - oy, width: 256, height: 256 }));
  }
  const linea = e.linea.map(([la, lo]) => P(la, lo).map(v => v.toFixed(1)).join(",")).join(" ");
  const [hx, hy] = P(lat, lon), [gx, gy] = P(e.lat, e.lon);
  return sv("svg", { viewBox: "0 0 768 768", class: "gas-tr-mappa", role: "img", "aria-label": t("tr_mappa") }, tasselli,
    sv("polyline", { points: linea, fill: "none", stroke: "rgba(46, 157, 87, .38)", "stroke-width": Math.max(6, e.larghezza * kmPx), "stroke-linecap": "round", "stroke-linejoin": "round" }),
    sv("polyline", { points: linea, fill: "none", stroke: "#1f8a4c", "stroke-width": 2.5 }),
    sv("line", { x1: hx, y1: hy, x2: gx, y2: gy, stroke: "#0b1d33", "stroke-width": 2.5, "stroke-dasharray": "8 6" }),
    sv("circle", { cx: gx, cy: gy, r: 11, fill: "#2fbf6a", stroke: "#fff", "stroke-width": 3 }),
    sv("circle", { cx: hx, cy: hy, r: 11, fill: "#e2b84f", stroke: "#0b1d33", "stroke-width": 3 }),
    sv("rect", { x: 768 - 214, y: 768 - 30, width: 214, height: 30, fill: "rgba(255,255,255,.85)" }),
    sv("text", { x: 768 - 8, y: 768 - 10, "text-anchor": "end", "font-size": 17, fill: "#333", text: "© OpenStreetMap" }));
}
Object.assign(TESTI.it, {
  pls_titolo: "Prova lo scatto",
  pls_n: "Il transito nel fotogramma della tua camera, alla grandezza vera e con lo zenit in alto: scegli setup, fotogrammi al secondo e tempo di posa, poi premi ▶.",
  pls_setup: "Setup", pls_campo: "Quello del Campo inquadrato", pls_fps: "Fotogrammi al secondo", pls_posa: "Tempo di posa",
  pls_lento: "Al rallentatore", pls_reale: "Tempo reale", pls_dove: "Visto da", pls_verde: "il punto verde", pls_casa: "casa tua",
  pls_esempio: "Esempio (non è il tuo): {n}", pls_esempio_n: "È solo un esempio: aggiungi i tuoi telescopi e le tue camere in Attrezzatura e lo vedi col tuo setup.", pls_vai_att: "Apri la tua attrezzatura",
  pls_fotogramma: "fotogramma {i} di {n}", pls_tutti: "tutti i fotogrammi insieme ({n})", pls_rallentato: "rallentato {x} volte",
  pls_c_n: "Fotogrammi sul disco", pls_c_passo: "Fra un fotogramma e l'altro", pls_c_mosso: "Mosso durante la posa",
  pls_c_staz: "La stazione sul sensore", pls_c_disco: "Il disco nel fotogramma",
  pls_nitida: "nitida", pls_appena: "appena mossa", pls_mossa: "mossa: prova {t}", pls_entra: "entra tutto", pls_non_entra: "non entra tutto",
  pls_vista: "Vista", pls_intero: "Fotogramma intero", pls_ritaglio: "Ritaglio sul disco", pls_ritaglio_n: "ritaglio",
  pls_lente: "La stazione con i pixel del tuo sensore", pls_lente_n: "La stazione con i pixel del tuo sensore, ingrandita: così verrà nella tua foto.",
  pls_v_nitida_t: "Nitida.", pls_v_nitida: "Con {p} la stazione si sposta di {x} px mentre scatti.", pls_v_appena_t: "Quasi nitida.", pls_v_appena: "Con {p} si sposta di {x} px mentre scatti: per averla nitida usa {n}.", pls_v_mossa_t: "Mossa.", pls_v_mossa: "Con {p} si sposta di {x} px mentre scatti: per averla nitida usa {n} o più veloce.",
  pls_oculare: "Con l'oculare la vedi attraversare il disco in {s} s: tieni l'occhio fermo e non sbattere le palpebre!",
});
Object.assign(TESTI.de, {
  pls_titolo: "Probeaufnahme",
  pls_n: "Der Transit im Bild Ihrer Kamera, in echter Größe und mit dem Zenit oben: Setup, Bilder pro Sekunde und Belichtungszeit wählen, dann ▶ drücken.",
  pls_setup: "Setup", pls_campo: "Das aus dem Bildfeld", pls_fps: "Bilder pro Sekunde", pls_posa: "Belichtungszeit",
  pls_lento: "Zeitlupe", pls_reale: "Echtzeit", pls_dove: "Gesehen von", pls_verde: "dem grünen Punkt", pls_casa: "zu Hause",
  pls_esempio: "Beispiel (nicht Ihres): {n}", pls_esempio_n: "Nur ein Beispiel: Fügen Sie Ihre Teleskope und Kameras unter Ausrüstung hinzu, dann sehen Sie es mit Ihrem Setup.", pls_vai_att: "Ausrüstung öffnen",
  pls_fotogramma: "Bild {i} von {n}", pls_tutti: "alle Bilder zusammen ({n})", pls_rallentato: "{x}-fach verlangsamt",
  pls_c_n: "Bilder vor der Scheibe", pls_c_passo: "Von Bild zu Bild", pls_c_mosso: "Bewegungsunschärfe",
  pls_c_staz: "Die Station auf dem Sensor", pls_c_disco: "Die Scheibe im Bild",
  pls_nitida: "scharf", pls_appena: "leicht verwischt", pls_mossa: "verwischt: versuchen Sie {t}", pls_entra: "passt ganz hinein", pls_non_entra: "passt nicht ganz hinein",
  pls_vista: "Ansicht", pls_intero: "Ganzes Bild", pls_ritaglio: "Ausschnitt um die Scheibe", pls_ritaglio_n: "Ausschnitt",
  pls_lente: "Die Station mit den Pixeln Ihres Sensors", pls_lente_n: "Die Station mit den Pixeln Ihres Sensors, vergrößert: so wird sie auf Ihrem Foto aussehen.",
  pls_v_nitida_t: "Scharf.", pls_v_nitida: "Mit {p} bewegt sich die Station während der Aufnahme um {x} px.", pls_v_appena_t: "Fast scharf.", pls_v_appena: "Mit {p} bewegt sie sich während der Aufnahme um {x} px: für ein scharfes Bild {n} verwenden.", pls_v_mossa_t: "Verwischt.", pls_v_mossa: "Mit {p} bewegt sie sich während der Aufnahme um {x} px: für ein scharfes Bild {n} oder kürzer verwenden.",
  pls_oculare: "Im Okular sehen Sie sie in {s} s über die Scheibe ziehen: Auge ruhig halten und nicht blinzeln!",
});
Object.assign(TESTI.es, {
  pls_titolo: "Prueba la toma",
  pls_n: "El tránsito en el fotograma de tu cámara, a tamaño real y con el cénit arriba: elige equipo, fotogramas por segundo y tiempo de exposición, y pulsa ▶.",
  pls_setup: "Equipo", pls_campo: "El del Campo de visión", pls_fps: "Fotogramas por segundo", pls_posa: "Tiempo de exposición",
  pls_lento: "A cámara lenta", pls_reale: "Tiempo real", pls_dove: "Visto desde", pls_verde: "el punto verde", pls_casa: "tu casa",
  pls_esempio: "Ejemplo (no es el tuyo): {n}", pls_esempio_n: "Es solo un ejemplo: añade tus telescopios y tus cámaras en Equipo y lo ves con tu equipo.", pls_vai_att: "Abrir tu equipo",
  pls_fotogramma: "fotograma {i} de {n}", pls_tutti: "todos los fotogramas juntos ({n})", pls_rallentato: "{x} veces más lento",
  pls_c_n: "Fotogramas sobre el disco", pls_c_passo: "De un fotograma al siguiente", pls_c_mosso: "Desplazamiento durante la exposición",
  pls_c_staz: "La estación en el sensor", pls_c_disco: "El disco en el fotograma",
  pls_nitida: "nítida", pls_appena: "algo movida", pls_mossa: "movida: prueba {t}", pls_entra: "cabe entero", pls_non_entra: "no cabe entero",
  pls_vista: "Vista", pls_intero: "Fotograma entero", pls_ritaglio: "Recorte del disco", pls_ritaglio_n: "recorte",
  pls_lente: "La estación con los píxeles de tu sensor", pls_lente_n: "La estación con los píxeles de tu sensor, ampliada: así saldrá en tu foto.",
  pls_v_nitida_t: "Nítida.", pls_v_nitida: "Con {p} la estación se desplaza {x} px mientras disparas.", pls_v_appena_t: "Casi nítida.", pls_v_appena: "Con {p} se desplaza {x} px mientras disparas: para tenerla nítida usa {n}.", pls_v_mossa_t: "Movida.", pls_v_mossa: "Con {p} se desplaza {x} px mientras disparas: para tenerla nítida usa {n} o más rápido.",
  pls_oculare: "Con el ocular la ves cruzar el disco en {s} s: ¡ojo quieto y no parpadees!",
});
Object.assign(TESTI.en, {
  pls_titolo: "Try the shot",
  pls_n: "The transit in your camera's frame, at true size with the zenith up: choose setup, frames per second and exposure, then press ▶.",
  pls_setup: "Setup", pls_campo: "The one in Field of view", pls_fps: "Frames per second", pls_posa: "Exposure",
  pls_lento: "Slow motion", pls_reale: "Real time", pls_dove: "Seen from", pls_verde: "the green dot", pls_casa: "your home",
  pls_esempio: "Example (not yours): {n}", pls_esempio_n: "Just an example: add your telescopes and cameras in Equipment and you'll see it with your setup.", pls_vai_att: "Open your equipment",
  pls_fotogramma: "frame {i} of {n}", pls_tutti: "all frames together ({n})", pls_rallentato: "{x}× slower",
  pls_c_n: "Frames on the disc", pls_c_passo: "From one frame to the next", pls_c_mosso: "Motion blur in the exposure",
  pls_c_staz: "The station on the sensor", pls_c_disco: "The disc in the frame",
  pls_nitida: "sharp", pls_appena: "slightly blurred", pls_mossa: "blurred: try {t}", pls_entra: "fits entirely", pls_non_entra: "doesn't fit entirely",
  pls_vista: "View", pls_intero: "Whole frame", pls_ritaglio: "Crop on the disc", pls_ritaglio_n: "crop",
  pls_lente: "The station with your sensor's pixels", pls_lente_n: "The station with your sensor's pixels, enlarged: this is how it will look in your photo.",
  pls_v_nitida_t: "Sharp.", pls_v_nitida: "At {p} the station moves {x} px while you shoot.", pls_v_appena_t: "Almost sharp.", pls_v_appena: "At {p} it moves {x} px while you shoot: for a sharp shot use {n}.", pls_v_mossa_t: "Blurred.", pls_v_mossa: "At {p} it moves {x} px while you shoot: for a sharp shot use {n} or faster.",
  pls_oculare: "In the eyepiece you see it cross the disc in {s} s: keep your eye still and don't blink!",
});
Object.assign(TESTI.it, {
  pls_foto_sole: "Il Sole vero: la foto di oggi del satellite NASA SDO, con le macchie, girata come lo vedrai.",
  pls_foto_giorni: "Il Sole ruota su se stesso in 27 giorni: il giorno del transito ({g}) le macchie saranno spostate.",
  pls_foto_luna: "La Luna vera di quell'ora: fase, librazione (la lieve oscillazione del disco) e inclinazione come la vedrai.",
  pls_cred_sole: "Foto NASA/SDO e team scientifico HMI.", pls_cred_luna: "Foto NASA Scientific Visualization Studio.",
});
Object.assign(TESTI.de, {
  pls_foto_sole: "Die echte Sonne: das heutige Foto des NASA-Satelliten SDO, mit den Flecken, so gedreht, wie Sie sie sehen werden.",
  pls_foto_giorni: "Die Sonne dreht sich in 27 Tagen einmal um sich selbst: am Tag des Transits ({g}) sind die Flecken verschoben.",
  pls_foto_luna: "Der echte Mond zu dieser Stunde: Phase, Libration und Neigung, wie Sie ihn sehen werden.",
  pls_cred_sole: "Foto NASA/SDO und HMI-Wissenschaftsteam.", pls_cred_luna: "Foto NASA Scientific Visualization Studio.",
});
Object.assign(TESTI.es, {
  pls_foto_sole: "El Sol real: la foto de hoy del satélite SDO de la NASA, con las manchas, girada como lo verás.",
  pls_foto_giorni: "El Sol gira sobre sí mismo en 27 días: el día del tránsito ({g}) las manchas estarán desplazadas.",
  pls_foto_luna: "La Luna real de esa hora: fase, libración e inclinación como la verás.",
  pls_cred_sole: "Foto NASA/SDO y equipo científico HMI.", pls_cred_luna: "Foto NASA Scientific Visualization Studio.",
});
Object.assign(TESTI.en, {
  pls_foto_sole: "The real Sun: today's photo from NASA's SDO satellite, with its sunspots, turned the way you'll see it.",
  pls_foto_giorni: "The Sun rotates once every 27 days: on the day of the transit ({g}) the sunspots will have moved.",
  pls_foto_luna: "The real Moon at that hour: phase, libration and tilt the way you'll see it.",
  pls_cred_sole: "Photo: NASA/SDO and the HMI science team.", pls_cred_luna: "Photo: NASA Scientific Visualization Studio.",
});
const PS_FPS = [25, 30, 60, 120, 240], PS_POSE = [250, 500, 1000, 2000, 4000, 8000];
const PS_FOTO = new Map();
function fotoDelTransito(e) {
  const lst = Astro.n360(Astro.gmst(e.j) + e.lon);
  if (e.corpo === "sole") {
    const o = new Date(), v = `${o.getUTCFullYear()}${o.getUTCMonth() + 1}${o.getUTCDate()}${o.getUTCHours()}${Math.floor(o.getUTCMinutes() / 15)}`;
    const s = Astro.sole(e.j), [ra, dec] = aJ2000(s.ra, s.dec, e.j);
    return { url: `https://sdo.gsfc.nasa.gov/assets/img/latest/latest_1024_HMIIC.jpg?v=${v}`, lato: 1024,
      riserve: [`https://jsoc1.stanford.edu/data/hmi/images/latest/HMI_latest_colInt_1024x1024.jpg?v=${v}`, `https://soho.nascom.nasa.gov/data/realtime/hmi_igr/1024/latest.jpg?v=${v}`],
      raggio: 475.13 / Astro.sole(Astro.jd(o)).dist, giro: angoloPosizione(s.ra, s.dec, lst, e.lat) - angoloPosizione(ra, dec, 286.13, 63.87) };
  }
  const d = Astro.data(e.j), url = fotoLuna(d);
  if (!url) return null;
  const lf = Astro.luna(Astro.jd(new Date(Math.round(d.getTime() / 3600000) * 3600000))), l = Astro.luna(e.j);
  return { url, lato: 730, raggio: 0.34966 * Math.asin(1737.4 / lf.dist) * DEG * 3600, giro: angoloPosizione(l.ra, l.dec, lst, e.lat) };
}
function caricaFotoTransito(url, riserve) {
  if (!PS_FOTO.has(url)) {
    const p = riserve && riserve.length ? caricaPrima([url, ...riserve], { alt: "" }, 9000).then(x => x.img) : caricaImmagine({ src: url, alt: "" });
    p.catch(() => PS_FOTO.delete(url));
    PS_FOTO.set(url, p);
  }
  return PS_FOTO.get(url);
}
function sagomaStazione(c, k, L) {
  if (L < 4) { c.beginPath(); c.arc(0, 0, Math.max(1.2, L / 2), 0, 2 * Math.PI); c.fill(); return; }
  const r = (x, y, w, h) => c.fillRect(x * L, y * L, w * L, h * L);
  if (k === "iss") {
    r(-0.025, -0.5, 0.05, 1);
    for (const y of [-0.46, -0.33, 0.33, 0.46]) { r(-0.35, y - 0.055, 0.32, 0.11); r(0.03, y - 0.055, 0.32, 0.11); }
    r(-0.33, -0.03, 0.66, 0.06);
    r(-0.09, -0.13, 0.05, 0.26); r(0.12, -0.08, 0.05, 0.16);
  } else {
    r(-0.03, -0.5, 0.06, 1);
    for (const y of [-0.42, 0.42]) r(-0.3, y - 0.07, 0.6, 0.14);
    r(-0.03, -0.035, 0.36, 0.07);
  }
}
function numeriScatto(e, r, fps, posa, corda, seeing) {
  const durata = e.durata * (corda == null ? 1 : corda), n = Math.max(1, Math.round(durata * fps));
  if (!r || !r.scala) return { durata, n };
  const pxGrado = 3600 / r.scala, passo = e.omega / fps * pxGrado, mosso = e.omega / posa * pxGrado, tol = Math.max(1, (seeing || 2) / r.scala);
  const posaNitida = PS_POSE.find(p => e.omega / p * pxGrado <= tol) || PS_POSE[PS_POSE.length - 1];
  return { durata, n, passo, mosso, tol, posaNitida, stazione: e.grandezza / r.scala, disco: e.diam / Math.min(r.fovW, r.fovH) };
}
function provaScatto(e) {
  const sole = e.corpo === "sole", fase = sole ? null : Astro.faseLuna(e.j);
  const luce = (() => {
    if (sole) return 0;
    const lst = Astro.n360(Astro.gmst(e.j) + e.lon), l = Astro.luna(e.j), s = Astro.sole(e.j);
    const [hl, al] = Astro.altAz(l.ra, l.dec, e.lat, lst), [hs, as] = Astro.altAz(s.ra, s.dec, e.lat, lst);
    const da = (as - al) * RAD, f1 = hl * RAD, f2 = hs * RAD;
    const b = Math.atan2(Math.sin(da) * Math.cos(f2), Math.cos(f1) * Math.sin(f2) - Math.sin(f1) * Math.cos(f2) * Math.cos(da));
    return Math.atan2(Math.cos(b), Math.sin(b)) * DEG;
  })();
  const casaOk = !!(e.daCasa && e.daCasa.sep < e.daCasa.raggio);
  const scelte = [], aggiungiScelta = (nome, s) => { if (!scelte.some(x => stessoSetup(x[2], s))) scelte.push([String(scelte.length), nome, s]); };
  const sCampo = setupAttuale();
  if (CAMPO.tel && ho("tel", CAMPO.tel) && (CAMPO.modo === "visuale" ? ho("oc", CAMPO.oc) : ho("cam", CAMPO.cam)))
    aggiungiScelta(`${t("pls_campo")}: ${etichettaSetup(SETUP_ELENCO.find(s => stessoSetup(s, sCampo))) || nomeSetupAuto(sCampo)}`, sCampo);
  for (const s of SETUP_ELENCO) aggiungiScelta(etichettaSetup(s) || nomeSetupAuto(s), s);
  for (const tel of ATTREZZI.tel) {
    for (const cam of ATTREZZI.cam) { const s = { modo: "foto", tel, k: 1, cam, bin: 1 }; aggiungiScelta(nomeSetupAuto(s), s); }
    for (const oc of ATTREZZI.oc) { const s = { modo: "visuale", tel, k: 1, oc }; aggiungiScelta(nomeSetupAuto(s), s); }
  }
  const esempio = !scelte.length;
  if (esempio && calcoloCampo(sCampo)) scelte.push(["0", t("pls_esempio", { n: nomeSetupAuto(sCampo) }), sCampo]);
  let scelta = scelte.length ? scelte[0][0] : "", vista = null, lente = null, fps = ricorda("pls_fps", 30), posa = ricorda("pls_posa", 1000), daCasa = false, gira = null, fondo = null, chiave = "";
  let foto = null;
  const tela = el("canvas", { class: "gas-ps-tela", role: "img", "aria-label": t("pls_titolo") });
  const lenteTela = el("canvas", { class: "gas-ps-lente-tela", width: 192, height: 192, role: "img", "aria-label": t("pls_lente") });
  const verdetto = el("p", { class: "gas-ps-verdetto" });
  const lenteBox = el("div", { class: "gas-ps-lente", hidden: true }, lenteTela, el("div", null, el("p", { class: "gas-nota" }, t("pls_lente_n")), verdetto));
  const numeri = el("div", { class: "gas-numeri gas-ps-numeri" }), nota = el("p", { class: "gas-nota", hidden: true });
  const setupDi = () => { const x = scelte.find(([k]) => k === scelta); return x ? x[2] : null; };
  const selSetup = selezione(scelte.map(([k, nome]) => [k, nome]), scelta, v => { scelta = v; aggiorna(); });
  const campoSetup = etichetta(t("pls_setup"), selSetup);
  campoSetup.hidden = !scelte.length;
  const selFps = selezione(PS_FPS.map(n => [n, String(n)]), fps, v => { fps = +v; salva("pls_fps", fps); aggiorna(); });
  const selPosa = selezione(PS_POSE.map(n => [n, `1/${n} s`]), posa, v => { posa = +v; salva("pls_posa", posa); aggiorna(); });
  const campoFps = etichetta(t("pls_fps"), selFps), campoPosa = etichetta(t("pls_posa"), selPosa);
  const selVista = selezione([["intero", t("pls_intero")], ["disco", t("pls_ritaglio")]], "intero", v => { vista = v; aggiorna(); });
  const campoVista = etichetta(t("pls_vista"), selVista);
  const selDove = casaOk ? selezione([["verde", t("pls_verde")], ["casa", t("pls_casa")]], "verde", v => { daCasa = v === "casa"; aggiorna(); }) : null;
  const geo = () => {
    const su = setupDi(), r = su ? calcoloCampo(su) : null, foto = !!(r && r.fovW), oc = !foto && r && r.campo ? r.campo : 0;
    const fw = foto ? r.fovW : oc || e.diam * 1.9, fh = foto ? r.fovH : oc || e.diam * 1.9 * 2 / 3;
    const corda = daCasa ? Math.sqrt(Math.max(0, 1 - (e.daCasa.sep / e.daCasa.raggio) ** 2)) : 1;
    const ns = numeriScatto(e, foto ? r : null, fps, posa, corda, CAMPO.seeing);
    const v = foto ? vista || (ns.disco < 0.4 ? "disco" : "intero") : "intero", z = v === "disco" ? Math.min(1, e.diam / 0.6 / Math.min(fw, fh)) : 1;
    return { r, foto, oc, fw: fw * z, fh: fh * z, vista: v, ritaglio: z < 1, corda, ns };
  };
  const preparaFondo = g => {
    const css = tela.clientWidth || 600, dpr = Math.min(window.devicePixelRatio || 1, 2), W = Math.round(css * dpr);
    const H = Math.round(W * Math.min(1.25, g.fh / g.fw)), k = [W, H, scelta, g.vista].join("|");
    if (tela.width !== W || tela.height !== H) { tela.width = W; tela.height = H; }
    if (fondo && k === chiave) return;
    chiave = k; fondo = document.createElement("canvas"); fondo.width = W; fondo.height = H;
    const c = fondo.getContext("2d"), ppd = W / g.fw, R = e.diam / 2 * ppd;
    c.fillStyle = "#03060d"; c.fillRect(0, 0, W, H);
    if (foto) {
      const im = foto.img, k = R / (foto.raggio * im.naturalWidth / foto.lato);
      c.save(); c.beginPath(); c.arc(W / 2, H / 2, R, 0, 2 * Math.PI); c.clip();
      c.translate(W / 2, H / 2); c.rotate(foto.giro * RAD);
      c.drawImage(im, -im.naturalWidth / 2 * k, -im.naturalHeight / 2 * k, im.naturalWidth * k, im.naturalHeight * k);
      c.restore();
    } else if (sole) {
      const gr = c.createRadialGradient(W / 2, H / 2, 0, W / 2, H / 2, R);
      gr.addColorStop(0, "#fff7d1"); gr.addColorStop(0.7, "#ffd27a"); gr.addColorStop(1, "#e8892c");
      c.fillStyle = gr; c.beginPath(); c.arc(W / 2, H / 2, R, 0, 2 * Math.PI); c.fill();
    } else {
      c.save(); c.translate(W / 2, H / 2); c.rotate(-(luce - (fase.crescente ? 0 : 180)) * RAD); disegnaDiscoLuna(c, 0, 0, R, fase); c.restore();
    }
    if (g.oc) {
      c.save(); c.fillStyle = "#000"; c.beginPath(); c.rect(0, 0, W, H); c.arc(W / 2, H / 2, Math.min(W, H) / 2 - 1, 0, 2 * Math.PI, true); c.fill("evenodd"); c.restore();
    }
  };
  const disegna = (g, istanti, sotto, sopra) => {
    preparaFondo(g);
    const W = tela.width, H = tela.height, c = tela.getContext("2d"), ppd = W / g.fw, cx = W / 2, cy = H / 2, R = e.diam / 2 * ppd;
    c.drawImage(fondo, 0, 0);
    const a = e.angolo * RAD, ux = Math.cos(a), uy = -Math.sin(a), off = daCasa ? e.daCasa.sep * ppd : 0;
    const L = Math.max(2.5, e.grandezza / 3600 * ppd), passiMosso = g.foto ? Math.max(1, Math.min(16, Math.ceil(e.omega / posa * ppd))) : 1;
    c.save(); c.beginPath(); c.arc(cx, cy, R, 0, 2 * Math.PI); c.clip();
    c.fillStyle = "#000";
    for (const s0 of istanti) {
      c.globalAlpha = Math.min(1, 1.6 / passiMosso);
      for (let i = 0; i < passiMosso; i++) {
        const s = s0 + (passiMosso > 1 ? i / (passiMosso - 1) - 0.5 : 0) / posa, d = e.omega * s * ppd;
        c.save(); c.translate(cx + ux * d - uy * off, cy + uy * d + ux * off); c.rotate(-a); sagomaStazione(c, e.st.k, L); c.restore();
      }
    }
    c.restore();
    const s0 = istanti.length === 1 ? istanti[0] : 0, d0 = e.omega * s0 * ppd, x0 = cx + ux * d0 - uy * off, y0 = cy + uy * d0 + ux * off;
    if (g.foto && istanti.length && Math.hypot(x0 - cx, y0 - cy) < R - 2) {
      const pxSens = 3600 / g.r.scala, Lp = e.grandezza / g.r.scala, N = Math.max(24, Math.min(96, Math.ceil(Lp * 2.4))), lato = N / pxSens * ppd;
      if (!lente) lente = document.createElement("canvas");
      lente.width = lente.height = N;
      const lc = lente.getContext("2d"), passi = Math.max(1, Math.min(16, Math.ceil(e.omega / posa * pxSens)));
      lc.drawImage(fondo, x0 - lato / 2, y0 - lato / 2, lato, lato, 0, 0, N, N);
      lc.fillStyle = "#000"; lc.globalAlpha = Math.min(1, 1.6 / passi);
      for (let i = 0; i < passi; i++) {
        const dd = (passi > 1 ? i / (passi - 1) - 0.5 : 0) / posa * e.omega * pxSens;
        lc.save(); lc.translate(N / 2 + ux * dd, N / 2 + uy * dd); lc.rotate(-a); sagomaStazione(lc, e.st.k, Lp); lc.restore();
      }
      const tc = lenteTela.getContext("2d");
      tc.imageSmoothingEnabled = false; tc.clearRect(0, 0, 192, 192); tc.drawImage(lente, 0, 0, 192, 192);
    }
    const fs = Math.max(11, Math.round(W * 0.03));
    c.font = `600 ${fs}px system-ui, sans-serif`; c.textBaseline = "alphabetic";
    const scritta = (testo, x, y, al) => { if (!testo) return; c.textAlign = al; c.fillStyle = "rgba(0,0,0,.55)"; c.fillText(testo, x + 1, y + 1); c.fillStyle = "#f4d58b"; c.fillText(testo, x, y); };
    scritta(sotto, fs * 0.7, H - fs * 0.7, "left");
    scritta(sopra, W - fs * 0.7, fs * 1.4, "right");
  };
  const istantiSulDisco = g => (g.foto ? Array.from({ length: g.ns.n }, (_, i) => (i + 0.5 - g.ns.n / 2) / fps) : [-0.3, -0.15, 0, 0.15, 0.3].map(f => f * g.ns.durata));
  const tutti = g => disegna(g, istantiSulDisco(g), g.foto ? t("pls_tutti", { n: g.ns.n }) + (g.ritaglio ? " · " + t("pls_ritaglio_n") : "") : "", `${e.st.k === "iss" ? "ISS" : "Tiangong"} · ${trOraSec(daCasa ? e.daCasa.j : e.j)}`);
  const ferma = () => { if (gira) cancelAnimationFrame(gira); gira = null; };
  const play = lento => {
    ferma();
    const g = geo(), dur = g.ns.durata, x = lento ? Math.max(2, Math.min(40, Math.round(8 / Math.max(dur, 0.05)))) : 1;
    const margine = Math.max(0.1, dur * 0.15), inizio = -dur / 2 - margine, fine = dur / 2 + margine, t0 = performance.now();
    const passo = ora0 => {
      if (!tela.isConnected) return ferma();
      const s = inizio + (ora0 - t0) / 1000 / x;
      if (s > fine) { gira = null; tutti(g); return; }
      const sopra = x > 1 ? t("pls_rallentato", { x }) : t("pls_reale");
      if (g.foto) {
        const k = Math.floor((s + dur / 2) * fps), dentro = k >= 0 && k < g.ns.n, sk = (k + 0.5) / fps - dur / 2;
        disegna(g, dentro || Math.abs(sk) < dur / 2 + 0.5 / fps ? [sk] : [], dentro ? t("pls_fotogramma", { i: k + 1, n: g.ns.n }) : "", sopra);
      } else disegna(g, [s], "", sopra);
      gira = requestAnimationFrame(passo);
    };
    gira = requestAnimationFrame(passo);
  };
  const aggiorna = () => {
    ferma();
    const g = geo();
    campoFps.hidden = campoPosa.hidden = campoVista.hidden = lenteBox.hidden = !g.foto;
    selVista.value = g.vista;
    svuota(numeri);
    nota.hidden = g.foto && !esempio;
    if (g.foto) {
      const ns = g.ns, giudizio = ns.mosso <= ns.tol ? t("pls_nitida") : ns.mosso <= 2 * ns.tol ? t("pls_appena") : t("pls_mossa", { t: `1/${ns.posaNitida} s` });
      const [cl, kv] = ns.mosso <= ns.tol ? ["ok", "pls_v_nitida"] : ns.mosso <= 2 * ns.tol ? ["medio", "pls_v_appena"] : ["male", "pls_v_mossa"];
      verdetto.className = "gas-ps-verdetto gas-ps-verdetto--" + cl;
      aggiungi(svuota(verdetto), [el("b", null, t(kv + "_t")), " ", t(kv, { p: `1/${posa} s`, x: num(ns.mosso, ns.mosso < 10 ? 1 : 0), n: `1/${ns.posaNitida} s` })]);
      aggiungi(numeri, [cifra(t("pls_c_n"), String(ns.n), `${fps} fps`), cifra(t("pls_c_passo"), `${num(ns.passo)} px`, ""),
        cifra(t("pls_c_mosso"), `${num(ns.mosso, ns.mosso < 10 ? 1 : 0)} px`, giudizio), cifra(t("pls_c_staz"), `${num(ns.stazione)} px`, ""),
        cifra(t("pls_c_disco"), `${num(ns.disco * 100)} %`, t(ns.disco <= 1 ? "pls_entra" : "pls_non_entra"))]);
    }
    if (esempio || !g.r) aggiungi(svuota(nota), [t("pls_esempio_n"), " ", el("a", { href: urlScheda("attrezzatura") + "#attrezzatura", onclick: ev => { ev.preventDefault(); vai("attrezzatura"); } }, t("pls_vai_att"), " →")]);
    else if (g.oc) nota.textContent = t("pls_oculare", { s: num(g.ns.durata, 1) });
    tutti(g);
  };
  const fotoNota = el("p", { class: "gas-nota gas-ps-foto", hidden: true });
  const fx = fotoDelTransito(e);
  if (fx) caricaFotoTransito(fx.url, fx.riserve).then(img => {
    foto = Object.assign({}, fx, { img }); fondo = null;
    const giorni = sole && isoData(Astro.data(e.j)) !== isoData(new Date()) ? " " + t("pls_foto_giorni", { g: trGiorno(e.j) }) : "";
    fotoNota.textContent = (sole ? t("pls_foto_sole") + giorni + " " + t("pls_cred_sole") : t("pls_foto_luna") + " " + t("pls_cred_luna"));
    fotoNota.hidden = false;
    if (!gira && tela.isConnected) tutti(geo());
  }).catch(() => {});
  const box = el("section", { class: "gas-ps" },
    el("h4", null, icona("campo"), " ", t("pls_titolo")), el("p", { class: "gas-nota" }, t("pls_n")),
    el("div", { class: "gas-ps-comandi" }, campoSetup, campoVista, campoFps, campoPosa, selDove ? etichetta(t("pls_dove"), selDove) : null),
    tela, fotoNota, lenteBox,
    el("div", { class: "gas-ps-play" },
      el("button", { type: "button", class: "gas-btn", onclick: () => play(true) }, "▶ ", t("pls_lento")),
      el("button", { type: "button", class: "gas-btn gas-btn--chiaro", onclick: () => play(false) }, "▶ ", t("pls_reale"))),
    nota, numeri);
  setTimeout(aggiorna, 0);
  if (window.ResizeObserver) {
    let w0 = 0;
    const ro = new ResizeObserver(() => { if (!tela.isConnected) return ro.disconnect(); const w = tela.clientWidth; if (w && w !== w0) { w0 = w; if (!gira) tutti(geo()); } });
    ro.observe(tela);
  }
  return box;
}
const TR_RICERCHE = new Map();
function transitiVicini(lat, lon, r, g, corpi, avanza) {
  const k = [lat.toFixed(3), lon.toFixed(3), r, g, corpi.join("+"), Math.floor(Date.now() / 3600000)].join("|");
  if (!TR_RICERCHE.has(k)) {
    const nuova = { f: 0, chi: new Set() };
    nuova.p = (async () => {
      const stazioni = await caricaStazioni(), j0 = Astro.jd(new Date()), tutti = [];
      for (let i = 0; i < stazioni.length; i++)
        tutti.push(...await cercaTransiti(stazioni[i], lat, lon, j0, j0 + g, r, corpi, 10, f => { nuova.f = (i + f) / stazioni.length; nuova.chi.forEach(a => a(nuova.f)); }));
      const pronti = [];
      for (const e of tutti) pronti.push(await suTerraferma(e, lat, lon, r));
      return pronti.sort((a, b) => a.j - b.j);
    })();
    nuova.p.then(() => { nuova.finita = true; nuova.chi.clear(); }, () => TR_RICERCHE.delete(k));
    TR_RICERCHE.set(k, nuova);
  }
  const voce = TR_RICERCHE.get(k);
  if (avanza) { if (!voce.finita) voce.chi.add(avanza); avanza(voce.f); }
  return voce.p;
}
function transitiScelti() {
  const r = ricorda("tr_raggio", 100), g = ricorda("tr_giorni", 7), corpi = ["sole", "luna"].filter(k => ricorda("tr_" + k, true));
  const { lat, lon } = NOTTE.luogo;
  return { r, g, lista: corpi.length ? transitiVicini(lat, lon, r, g, corpi) : Promise.resolve([]) };
}
const fraseProssimo = e => t("tr_prossimo", { q: `${trGiorno(e.j)} · ${trOraSec(e.j)}`, s: t("sa_" + e.st.k), c: t("tr_davanti_" + e.corpo), p: e.paese ? ", " + t("tr_paese", { p: e.paese }) : "" });
function cartaProssimoTransito() {
  const riga = el("p", { class: "gas-nota" }, t("tr_cerco_breve"));
  const { r, g, lista } = transitiScelti();
  lista.then(l => {
    const adesso = Astro.jd(new Date()), e = l.find(x => x.j > adesso), vecchi = e ? Math.floor(adesso - e.st.rec.epoca) : 0;
    svuota(riga).append(e ? fraseProssimo(e) : t("tr_nessuno", { r, g }));
    if (vecchi >= 2) riga.append(" ", t("tr_vecchi", { g: vecchi }));
  }).catch(() => { svuota(riga).append(t("tr_errore")); });
  return el("section", { class: "gas-card gas-tr-avviso" }, el("h3", null, icona("satellite"), " ", t("tr_titolo")), riga,
    el("a", { class: "gas-btn", href: linkStrumento("transiti"), onclick: e => { if (!clicSemplice(e)) return; e.preventDefault(); vai("transiti"); } }, t("tr_apri"), " →"));
}
function vistaTransiti(pannello) {
  svuota(pannello);
  const corpo = el("div");
  const disegna = () => { svuota(corpo).append(cartaTransiti()); };
  pannello.append(barraLuogo(() => disegna(), false), corpo);
  disegna();
}
function cartaTransiti() {
  const titolo = el("h3", null, icona("satellite"), " ", t("tr_titolo"));
  const nota = el("p", { class: "gas-nota" }), stato = el("p", { class: "gas-muto", role: "status" });
  const lista = el("div", { class: "gas-tr-lista" }), dettaglio = el("div", { class: "gas-tr-dett" });
  const raggio = selezione([25, 50, 100, 150, 250].map(n => [n, n + " km"]), ricorda("tr_raggio", 100), v => { salva("tr_raggio", +v); cerca(); });
  const giorni = selezione([3, 7, 10, 14].map(n => [n, String(n)]), ricorda("tr_giorni", 7), v => { salva("tr_giorni", +v); cerca(); });
  const spunta = (k, testo) => {
    const i = el("input", { type: "checkbox" });
    i.checked = ricorda("tr_" + k, true);
    i.addEventListener("change", () => { salva("tr_" + k, i.checked); cerca(); });
    return el("label", { class: "gas-tr-spunta" }, i, " ", testo);
  };
  const conSole = spunta("sole", t("tr_sole")), conLuna = spunta("luna", t("tr_luna"));
  const box = el("section", { class: "gas-card gas-tr" }, titolo, nota,
    el("div", { class: "gas-tr-comandi" }, etichetta(t("tr_entro"), raggio), etichetta(t("tr_giorni"), giorni), conSole, conLuna),
    stato, lista, dettaglio, el("p", { class: "gas-co-fonte" }, t("tr_fonte")));
  let giro = 0;
  const mostra = (e, bottone, tocco) => {
    $$(".gas-tr-voce", lista).forEach(b => { b.classList.toggle("on", b === bottone); b.setAttribute("aria-pressed", String(b === bottone)); });
    const { lat, lon } = NOTTE.luogo, adesso = Astro.jd(new Date()), vecchi = Math.floor(adesso - e.st.rec.epoca);
    const nomeC = t(e.corpo === "sole" ? "tr_sole" : "tr_luna"), nomeSt = t("sa_" + e.st.k);
    const meteo = el("p", { class: "gas-nota", hidden: true });
    const cifre = [cifra(t("tr_c_alt"), `${num(e.h)}°`, nomeC), cifra(t("tr_c_dur"), `${num(e.durata, 2)} s`, ""),
      cifra(t("tr_c_dist"), `${num(e.dist)} km`, nomeSt), cifra(t("tr_c_gr"), `${num(e.grandezza, 1)}″`, ""),
      cifra(t("tr_c_fascia"), `${num(e.larghezza, 1)} km`, ""),
      e.daCasa ? (e.daCasa.sep < e.daCasa.raggio ? cifra(t("tr_c_casa"), t("tr_da_casa"), "") : cifra(t("tr_c_casa"), angoloTr(e.daCasa.sep), t("tr_casa_fuori"))) : null];
    aggiungi(svuota(dettaglio), [
      el("h4", null, `${trGiorno(e.j)} · ${trOraSec(e.j)} · ${nomeSt} ${t("tr_davanti_" + e.corpo)}`),
      el("div", { class: "gas-tr-vista" },
        el("figure", { class: "gas-tr-fig" }, mappaTransito(e, lat, lon), el("figcaption", null, t("tr_mappa"), " ",
          el("a", { href: `https://www.google.com/maps/search/?api=1&query=${e.lat.toFixed(5)},${e.lon.toFixed(5)}`, target: "_blank", rel: "noopener" }, t("tr_maps"), " ↗"),
          el("br"), el("small", null, t("tr_punto", { lat: e.lat.toFixed(5), lon: e.lon.toFixed(5) }), e.paese ? " · " + t("tr_paese", { p: e.paese }) : ""),
          e.inMare ? [el("br"), el("b", null, t("tr_mare_n", { r: e.mareEntro }))] : null)),
        provaScatto(e)),
      el("div", { class: "gas-numeri gas-tr-numeri" }, cifre),
      meteo,
      e.corpo === "sole" ? el("p", { class: "gas-giudizio gas-giudizio--poco_sotto" }, el("b", null, t("tr_filtro")), " ",
        el("a", { href: urlCollezione("filtri-solari"), target: "_blank", rel: "noopener" }, t("tr_filtri"), " →")) : null,
      e.corpo === "luna" ? el("p", { class: "gas-nota" }, t("tr_fase", { k: num(e.fase * 100) }), e.fase < 0.25 ? [" ", t("tr_sottile")] : null) : null,
      e.corpo === "luna" && e.hSole > -0.833 ? el("p", { class: "gas-giudizio gas-giudizio--poco_sotto" }, el("b", null, t("tr_giorno", { d: num(e.elong) }))) : null,
      vecchi >= 2 ? el("p", { class: "gas-giudizio gas-giudizio--poco_sotto" }, el("b", null, t("tr_vecchi", { g: vecchi }))) : null,
      e.j - adesso > 3 ? el("p", { class: "gas-nota" }, t("tr_lontano")) : null]);
    if (tocco && dettaglio.getBoundingClientRect().top > window.innerHeight * 0.5) dettaglio.scrollIntoView({ behavior: "smooth", block: "start" });
    if (e.j - adesso < 9) previsione(e.lat, e.lon).then(p => {
      const d = Astro.data(e.j).getTime(), x = p.reduce((a, b) => Math.abs(b.t - d) < Math.abs(a.t - d) ? b : a);
      if (Math.abs(x.t - d) <= 3 * 3.6e6 && x.nuv != null) { meteo.textContent = t("tr_meteo", { n: num(x.nuv) }); meteo.hidden = false; }
    }).catch(() => {});
    else { meteo.textContent = t("tr_meteo_no"); meteo.hidden = false; }
  };
  async function cerca() {
    const mio = ++giro, r = +raggio.value, g = +giorni.value;
    const corpi = [conSole.querySelector("input").checked ? "sole" : null, conLuna.querySelector("input").checked ? "luna" : null].filter(Boolean);
    nota.textContent = t("tr_n", Object.assign({ r }, luogoFrasi()));
    svuota(lista); svuota(dettaglio);
    if (!corpi.length) { stato.textContent = ""; return; }
    stato.hidden = false; stato.textContent = t("tr_calcolo", { p: 0 });
    const { lat, lon } = NOTTE.luogo;
    let pronti;
    try { pronti = await transitiVicini(lat, lon, r, g, corpi, f => { if (mio === giro) stato.textContent = t("tr_calcolo", { p: Math.round(f * 100) }); }); }
    catch (e) { if (mio === giro) stato.textContent = t("tr_errore"); return; }
    if (mio !== giro) return;
    const ora0 = Astro.jd(new Date());
    pronti = pronti.filter(e => e.j > ora0);
    if (!pronti.length) { stato.textContent = t("tr_nessuno", { r, g }); return; }
    stato.hidden = true;
    const bottoni = pronti.map(e => {
      const casa = e.daCasa && e.daCasa.sep < e.daCasa.raggio;
      const b = el("button", { type: "button", class: "gas-tr-voce" + (casa ? " gas-tr-casa" : ""), onclick: () => mostra(e, b, true) },
        el("span", { class: "gas-tr-ico gas-tr-ico--" + e.corpo, "aria-hidden": "true" }),
        el("span", { class: "gas-tr-testo" },
          el("b", null, `${trGiorno(e.j)} · ${trOraSec(e.j)}`),
          el("small", null, `${t("sa_" + e.st.k)} ${t("tr_davanti_" + e.corpo)} · ${t("tr_dove", { km: num(e.km), d: direzione(e.verso) })}${e.paese ? ", " + t("tr_paese", { p: e.paese }) : ""}${e.inMare ? " · " + t("tr_in_mare", { r }) : ""} · ${t("tr_alto", { h: num(e.h) })} · ${t("tr_durata", { s: num(e.durata, 2) })}`),
          casa ? el("em", null, t("tr_da_casa")) : null));
      return b;
    });
    lista.append(...bottoni);
    mostra(pronti[0], bottoni[0]);
  }
  setTimeout(cerca, 60);
  return box;
}
Object.assign(TESTI.it, {
  vl_titolo: "Dal tuo posto", vl_apri: "Dal tuo posto", vl_apri_n: "Guarda il cielo come lo vedi dal luogo scelto, con le montagne vere",
  vl_chiudi: "Chiudi", vl_adesso: "Adesso", vl_meno: "−1 h", vl_piu: "+1 h", vl_avvia: "Fai scorrere la notte", vl_ferma: "Ferma",
  vl_centra: "Torna sull'oggetto", vl_allarga: "Allarga", vl_stringi: "Stringi", vl_linee: "Costellazioni", vl_foto: "Foto del cielo",
  vl_sopra: "sopra le montagne", vl_dietro: "dietro le montagne", vl_sotto: "sotto l'orizzonte", vl_basso: "più basso di {h}°",
  vl_giorno: "Giorno", vl_crep: "Crepuscolo", vl_buio: "Buio", vl_luna_su: "Luna {k} %",
  vl_ter_no: "Le montagne non sono ancora calcolate: l'orizzonte è piatto.", vl_ter_calcola: "Aggiungi le montagne vere", vl_ter_attendi: "Leggo le mappe di elevazione…",
  vl_trascina: "Trascina per girarti · rotella o due dita per allargare o stringere · tocca un astro per il nome",
  vl_crediti: "Foto: DSS2 (STScI/NASA, CDS) · stelle: Hipparcos e Tycho-2 (ESA)", vl_crediti_ter: " · elevazione: Terrain Tiles (Mapzen, AWS Open Data)",
  vl_finestra: "Col buio e sopra {h}°: dalle {a} alle {b}", vl_mai: "Stanotte, col buio, non è mai sopra {h}° senza montagne davanti",
});
Object.assign(TESTI.de, {
  vl_titolo: "Von Ihrem Ort", vl_apri: "Von Ihrem Ort", vl_apri_n: "Den Himmel so sehen, wie er vom gewählten Ort aussieht, mit den echten Bergen",
  vl_chiudi: "Schließen", vl_adesso: "Jetzt", vl_meno: "−1 h", vl_piu: "+1 h", vl_avvia: "Die Nacht ablaufen lassen", vl_ferma: "Stopp",
  vl_centra: "Zurück zum Objekt", vl_allarga: "Herauszoomen", vl_stringi: "Hineinzoomen", vl_linee: "Sternbilder", vl_foto: "Himmelsfoto",
  vl_sopra: "über den Bergen", vl_dietro: "hinter den Bergen", vl_sotto: "unter dem Horizont", vl_basso: "tiefer als {h}°",
  vl_giorno: "Tag", vl_crep: "Dämmerung", vl_buio: "Dunkel", vl_luna_su: "Mond {k} %",
  vl_ter_no: "Die Berge sind noch nicht berechnet: der Horizont ist flach.", vl_ter_calcola: "Echte Berge hinzufügen", vl_ter_attendi: "Höhenkarten werden gelesen…",
  vl_trascina: "Ziehen zum Drehen · Mausrad oder zwei Finger zum Vergrößern oder Verkleinern · auf ein Objekt tippen für den Namen",
  vl_crediti: "Foto: DSS2 (STScI/NASA, CDS) · Sterne: Hipparcos und Tycho-2 (ESA)", vl_crediti_ter: " · Höhendaten: Terrain Tiles (Mapzen, AWS Open Data)",
  vl_finestra: "Bei Dunkelheit und über {h}°: von {a} bis {b}", vl_mai: "Heute Nacht steigt es bei Dunkelheit nicht frei über {h}°",
});
Object.assign(TESTI.es, {
  vl_titolo: "Desde tu lugar", vl_apri: "Desde tu lugar", vl_apri_n: "Mira el cielo como se ve desde el lugar elegido, con las montañas reales",
  vl_chiudi: "Cerrar", vl_adesso: "Ahora", vl_meno: "−1 h", vl_piu: "+1 h", vl_avvia: "Hacer correr la noche", vl_ferma: "Parar",
  vl_centra: "Volver al objeto", vl_allarga: "Alejar", vl_stringi: "Acercar", vl_linee: "Constelaciones", vl_foto: "Foto del cielo",
  vl_sopra: "sobre las montañas", vl_dietro: "tras las montañas", vl_sotto: "bajo el horizonte", vl_basso: "por debajo de {h}°",
  vl_giorno: "Día", vl_crep: "Crepúsculo", vl_buio: "Oscuridad", vl_luna_su: "Luna al {k} %",
  vl_ter_no: "Las montañas aún no están calculadas: el horizonte es plano.", vl_ter_calcola: "Añadir las montañas reales", vl_ter_attendi: "Leyendo los mapas de elevación…",
  vl_trascina: "Arrastra para girar · rueda o dos dedos para acercar o alejar · toca un astro para ver su nombre",
  vl_crediti: "Foto: DSS2 (STScI/NASA, CDS) · estrellas: Hipparcos y Tycho-2 (ESA)", vl_crediti_ter: " · elevación: Terrain Tiles (Mapzen, AWS Open Data)",
  vl_finestra: "Con oscuridad y sobre {h}°: de {a} a {b}", vl_mai: "Esta noche, con oscuridad, nunca está por encima de {h}° sin montañas delante",
});
Object.assign(TESTI.en, {
  vl_titolo: "From your spot", vl_apri: "From your spot", vl_apri_n: "See the sky as it looks from the chosen place, with the real mountains",
  vl_chiudi: "Close", vl_adesso: "Now", vl_meno: "−1 h", vl_piu: "+1 h", vl_avvia: "Play the night", vl_ferma: "Stop",
  vl_centra: "Back to the object", vl_allarga: "Zoom out", vl_stringi: "Zoom in", vl_linee: "Constellations", vl_foto: "Sky photo",
  vl_sopra: "above the mountains", vl_dietro: "behind the mountains", vl_sotto: "below the horizon", vl_basso: "lower than {h}°",
  vl_giorno: "Day", vl_crep: "Twilight", vl_buio: "Dark", vl_luna_su: "Moon {k}%",
  vl_ter_no: "The mountains haven't been calculated yet: the horizon is flat.", vl_ter_calcola: "Add the real mountains", vl_ter_attendi: "Reading the elevation maps…",
  vl_trascina: "Drag to turn · wheel or two fingers to zoom in or out · tap a star for its name",
  vl_crediti: "Photo: DSS2 (STScI/NASA, CDS) · stars: Hipparcos and Tycho-2 (ESA)", vl_crediti_ter: " · elevation: Terrain Tiles (Mapzen, AWS Open Data)",
  vl_finestra: "In the dark and above {h}°: from {a} to {b}", vl_mai: "Tonight, in the dark, it never gets above {h}° clear of the mountains",
});
ICONE_SVG.orizzonte = '<path d="M2.8 19.4l5.6-8.2 3.6 5.1 2.6-3.3 6.6 6.4z"/><path class="pieno" d="M16.6 3.4l.6 1.35 1.35.6-1.35.6-.6 1.35-.6-1.35-1.35-.6 1.35-.6z"/><circle class="pieno" cx="7.4" cy="5.6" r="1"/>';
const VLUOGO = Object.assign({ linee: true, foto: true }, ricorda("vluogo", {}));
let VL_APERTA = null;
function bottoneVistaLuogo(id, cl) {
  return el("button", { type: "button", class: "gas-vl-apri " + (cl || ""), title: t("vl_apri_n"),
    onclick: () => apriVistaLuogo(typeof id === "function" ? id() : id) }, icona("orizzonte"), el("span", null, t("vl_apri")));
}
function chiudiVistaLuogo(soloTogli) {
  if (!VL_APERTA) return;
  const v = VL_APERTA; VL_APERTA = null;
  v.fine();
  v.fondo.remove();
  document.documentElement.classList.remove("gas-og-su");
  if (PAGINA_OGG) document.documentElement.classList.add("gas-og-su");
  if (!soloTogli && v.spinta && history.state && history.state.gasVl) history.back();
  if (v.prima && v.prima.isConnected && v.prima.focus) try { v.prima.focus({ preventScroll: true }); } catch (e) {   }
}
document.addEventListener("keydown", e => { if (e.key === "Escape" && VL_APERTA) { e.stopImmediatePropagation(); chiudiVistaLuogo(); } }, true);
function apriVistaLuogo(id) {
  const prima = VL_APERTA ? VL_APERTA.prima : document.activeElement, giaSpinta = !!(VL_APERTA && VL_APERTA.spinta);
  chiudiVistaLuogo(true);
  const o = trovaOggetto(id || CAMPO.ogg) || trovaOggetto("M31");
  const { lat, lon } = NOTTE.luogo;
  const fotoPossibile = FOTO_DSS || DEBUG;
  const glTela = el("canvas", { class: "gas-vl-gl", "aria-hidden": "true" });
  const tela = el("canvas", { class: "gas-vl-tela", role: "img", "aria-label": t("vl_titolo") });
  const info = el("div", { class: "gas-vl-info" }), fumetto = el("div", { class: "gas-vl-fumetto", hidden: true });
  const avviso = el("div", { class: "gas-vl-avviso", hidden: true });
  const scena = el("div", { class: "gas-vl-scena" }, glTela, tela, info, fumetto, avviso);
  const oraB = el("b", { class: "gas-vl-ora" }), statoCielo = el("span", { class: "gas-vl-stato" });
  const curva = sv("svg", { class: "gas-vl-curva", viewBox: "0 0 1000 60", preserveAspectRatio: "none", "aria-hidden": "true" });
  const cursore = el("input", { type: "range", class: "gas-vl-cursore", min: 0, max: 1000, step: 1, "aria-label": t("pl_scegli_ora") });
  const finestraTesto = el("p", { class: "gas-vl-finestra" });
  const bott = (contenuto, titolo, fn, cl) => el("button", { type: "button", class: "gas-vl-btn " + (cl || ""), title: titolo, "aria-label": titolo, onclick: fn }, contenuto);
  const bGioco = bott("▶", t("vl_avvia"), () => (gioco ? fermaGioco() : avviaGioco()), "gas-vl-gioco");
  const interr = (chiave, testo) => {
    const b = bott(testo, testo, () => { VLUOGO[chiave] = !VLUOGO[chiave]; b.setAttribute("aria-pressed", String(VLUOGO[chiave])); salva("vluogo", VLUOGO); ridisegna(); }, "gas-vl-int");
    b.setAttribute("aria-pressed", String(!!VLUOGO[chiave]));
    return b;
  };
  const strumenti = el("div", { class: "gas-vl-strumenti" },
    bott(icona("piu"), t("vl_stringi"), () => { fov = clamp(fov / 1.3, 12, 150); ridisegna(); }),
    bott(icona("meno"), t("vl_allarga"), () => { fov = clamp(fov * 1.3, 12, 150); ridisegna(); }),
    bott(icona("centro"), t("vl_centra"), () => { centraSuOggetto(); ridisegna(); }));
  scena.appendChild(strumenti);
  const terBtn = el("button", { type: "button", class: "gas-btn gas-btn--mini gas-vl-ter", onclick: () => calcolaTerreno() }, icona("orizzonte"), " ", t("vl_ter_calcola"));
  const crediti = el("small", { class: "gas-vl-crediti" });
  const titolo = el("div", { class: "gas-vl-tit" }, el("b", null, titoloOggetto(o)), el("span", null, luogoFrasi().l_da));
  const testa = el("div", { class: "gas-vl-testa" }, titolo,
    el("div", { class: "gas-vl-opz" }, fotoPossibile ? interr("foto", t("vl_foto")) : null, interr("linee", t("vl_linee"))),
    el("button", { type: "button", class: "gas-vl-chiudi", "aria-label": t("vl_chiudi"), title: t("vl_chiudi"), onclick: () => chiudiVistaLuogo() }, icona("chiudi")));
  const piede = el("div", { class: "gas-vl-piede" },
    el("div", { class: "gas-vl-tempo" }, el("div", { class: "gas-vl-orario" }, oraB, statoCielo),
      el("div", { class: "gas-vl-pista" }, curva, cursore),
      el("div", { class: "gas-vl-comandi" }, bott(t("vl_meno"), t("vl_meno"), () => { fermaGioco(); vaiA(j - 1 / 24); }),
        bott(t("vl_adesso"), t("vl_adesso"), () => { fermaGioco(); notteDiAdesso(); vaiA(Astro.jd(new Date())); }),
        bott(t("vl_piu"), t("vl_piu"), () => { fermaGioco(); vaiA(j + 1 / 24); }), bGioco)),
    el("div", { class: "gas-vl-sotto" }, finestraTesto, terBtn, el("small", { class: "gas-vl-aiuto" }, t("vl_trascina")), crediti));
  const box = el("div", { class: "gas-vl-box gas", tabindex: "-1" }, testa, scena, piede);
  const fondo = el("div", { class: "gas-vl", role: "dialog", "aria-modal": "true", "aria-label": `${t("vl_titolo")} · ${titoloOggetto(o)}` }, box);
  const sf = document.getElementById("gas-sfondo");
  if (sf && sf.classList.contains("gas-rosso")) fondo.classList.add("gas-vl--rosso");
  if (sf && sf.classList.contains("gas-grande")) fondo.classList.add("gas-grande");
  document.body.appendChild(fondo);
  document.documentElement.classList.add("gas-og-su");
  let spinta = giaSpinta;
  if (!spinta) try { history.pushState({ gasVl: 1 }, ""); spinta = true; } catch (e) {   }
  const indietro = () => { if (VL_APERTA && VL_APERTA.fondo === fondo) chiudiVistaLuogo(true); };
  window.addEventListener("popstate", indietro);
  let hips = null;
  if (fotoPossibile) try { hips = Hips.crea(glTela, { pronto: () => { glTela.hidden = false; }, errore: () => { glTela.hidden = true; } }); } catch (e) { hips = null; }
  if (!hips) glTela.hidden = true;
  const limiti = n => [n.ev.tramonto ? Astro.jd(n.ev.tramonto) - 1 / 24 : n.j0 + 5 / 24, n.ev.alba ? Astro.jd(n.ev.alba) + 1 / 24 : n.j0 + 19 / 24];
  const nt = Astro.notte(dataNotte(), lat, lon, 10);
  let [j0, j1] = limiti(nt);
  const corpo = o.corpo && !String(o.corpo).startsWith("cometa") ? o.corpo : null;
  const [raD, decD] = o.ra != null ? Astro.precessa(o.ra, o.dec, nt.tempi[Math.floor(nt.n / 2)]) : [0, 0];
  const posData = jj => { if (corpo) { const p = posizioneCorpo(corpo, jj); return [p.ra, p.dec]; } return [raD, decD]; };
  const altAzA = jj => {
    const [ra, dec] = posData(jj), r = Astro.altAz(ra, dec, lat, Astro.n360(Astro.gmst(jj) + lon));
    if (corpo === "luna") r[0] -= Astro.luna(jj).par * Math.cos(r[0] * RAD);
    return r;
  };
  let traccia = [];
  const calcolaTraccia = () => {
    const PASSI = Math.max(2, Math.round((j1 - j0) * 144));
    traccia = [];
    for (let i = 0; i <= PASSI; i++) {
      const jj = j0 + (j1 - j0) * i / PASSI, [h, az] = altAzA(jj), s = Astro.sole(jj);
      traccia.push({ j: jj, h, az, hs: Astro.altezza(s.ra, s.dec, lat, Astro.n360(Astro.gmst(jj) + lon)) });
    }
  };
  calcolaTraccia();
  const terAlt = az => { const P = NOTTE.terreno.p, a = ((az % 360) + 360) % 360, i = Math.floor(a), f = a - i; return (P[i % 360] * (1 - f) + P[(i + 1) % 360] * f) / 10; };
  const libero = p => p.h >= Math.max(NOTTE.hmin || 0, 0) && !(terrenoDelLuogo() && p.h < terAlt(p.az) + 0.5);
  let j = Astro.jd(new Date());
  {
    const adesso = traccia.find(p => Math.abs(p.j - j) < 0.007);
    if (!(j >= j0 && j <= j1 && adesso && adesso.hs < -12 && libero(adesso))) {
      let best = null;
      for (const p of traccia) if (p.hs < -12 && (!best || p.h > best.h)) best = p;
      j = best ? best.j : clamp(j, j0, j1);
    }
  }
  let az0 = 180, alt0 = 25, fov = 100;
  function centraSuOggetto() {
    const [h, az] = altAzA(j), w = scena.clientWidth || 800, hh = scena.clientHeight || 500;
    const base0 = w < 640 ? 80 : 100, alto = clamp(h, 0, 88);
    fov = clamp(Math.max(base0, (alto + 14) * w / hh), base0, 140);
    const fovV = fov * hh / w;
    az0 = az;
    alt0 = fovV / 2 - 5;
    if (alto > alt0 + fovV / 2 - 7) alt0 = alto - fovV / 2 + 9;
  }
  const vettore = (alt, az) => { const ca = Math.cos(alt * RAD); return [ca * Math.sin(az * RAD), ca * Math.cos(az * RAD), Math.sin(alt * RAD)]; };
  const croce = (a, b) => [a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0]];
  const punto = (a, b) => a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
  const versore = a => { const l = Math.hypot(a[0], a[1], a[2]) || 1; return [a[0] / l, a[1] / l, a[2] / l]; };
  const eqV = (ra, dec) => { const cd = Math.cos(dec * RAD); return [cd * Math.cos(ra * RAD), cd * Math.sin(ra * RAD), Math.sin(dec * RAD)]; };
  const P = (() => {
    const jm = nt.tempi[Math.floor(nt.n / 2)];
    return [eqV(...Astro.precessa(0, 0, jm)), eqV(...Astro.precessa(90, 0, jm)), eqV(...Astro.precessa(0, 90, jm))];
  })();
  const aJ2000 = v => [punto(P[0], v), punto(P[1], v), punto(P[2], v)];
  let B = null;
  function basi(W, H) {
    const lst = Astro.n360(Astro.gmst(j) + lon), fi = lat * RAD, ls = lst * RAD;
    const C = vettore(alt0, az0), Z = [0, 0, 1];
    let U = versore([Z[0] - punto(Z, C) * C[0], Z[1] - punto(Z, C) * C[1], Z[2] - punto(Z, C) * C[2]]);
    if (alt0 > 89.5) U = vettore(0, az0);
    const L = croce(U, C);
    const Ev = [-Math.sin(ls), Math.cos(ls), 0], Nv = [-Math.sin(fi) * Math.cos(ls), -Math.sin(fi) * Math.sin(ls), Math.cos(fi)],
      Zv = [Math.cos(fi) * Math.cos(ls), Math.cos(fi) * Math.sin(ls), Math.sin(fi)];
    const aData = v => [v[0] * Ev[0] + v[1] * Nv[0] + v[2] * Zv[0], v[0] * Ev[1] + v[1] * Nv[1] + v[2] * Zv[1], v[0] * Ev[2] + v[1] * Nv[2] + v[2] * Zv[2]];
    const dL = aData(L), dU = aData(U), dC = aData(C);
    const cdr = fov * RAD / W;
    B = { loc: [L, U, C], data: [dL, dU, dC], j2000: [aJ2000(dL), aJ2000(dU), aJ2000(dC)], zData: Zv, z2000: aJ2000(Zv), W, H, f: 1 / cdr, cdr, lst };
  }
  function proietta(v, base, out) {
    const d = punto(v, base[2]);
    if (d < -0.25) return false;
    const s = 2 / (1 + d) * B.f;
    out[0] = B.W / 2 - punto(v, base[0]) * s; out[1] = B.H / 2 - punto(v, base[1]) * s;
    return true;
  }
  const dentro = (p, m) => p[0] > -m && p[0] < B.W + m && p[1] > -m && p[1] < B.H + m;
  function versoSole(m, s, pm) {
    const d = punto(s, m), u = versore([s[0] - d * m[0], s[1] - d * m[1], s[2] - d * m[2]]), q = [0, 0];
    const v = [m[0] * 0.99985 + u[0] * 0.01745, m[1] * 0.99985 + u[1] * 0.01745, m[2] * 0.99985 + u[2] * 0.01745];
    return proietta(v, B.loc, q) ? Math.atan2(q[1] - pm[1], q[0] - pm[0]) : null;
  }
  let fotogramma = 0, riserva = 0, punti = [];
  function ridisegna() {
    fumetto.hidden = true;
    if (fotogramma) return;
    const vai = () => { cancelAnimationFrame(fotogramma); clearTimeout(riserva); fotogramma = 0; disegna(); };
    fotogramma = requestAnimationFrame(vai);
    riserva = setTimeout(vai, 120);
  }
  let base = null;
  Mappa.caricaBase().then(b => { base = b; ridisegna(); }).catch(() => {});
  const famiglia = getComputedStyle(RADICE || document.body).fontFamily;
  function disegna() {
    if (!fondo.isConnected) return;
    const dpr = Math.min(window.devicePixelRatio || 1, 2), cw = scena.clientWidth, ch = scena.clientHeight;
    if (!cw || !ch) return;
    const W = Math.round(cw * dpr), H = Math.round(ch * dpr), k = dpr;
    if (tela.width !== W || tela.height !== H) { tela.width = W; tela.height = H; }
    basi(W, H);
    const c = tela.getContext("2d");
    c.clearRect(0, 0, W, H);
    const sole = Astro.sole(j), lst = B.lst, [hSole, azSole] = Astro.altAz(sole.ra, sole.dec, lat, lst);
    const notte = hSole < -12, visib = hSole > -4 ? 0.2 : hSole > -10 ? 0.55 : hSole > -15 ? 0.85 : 1;
    const conFoto = !!(hips && VLUOGO.foto && hSole < -9);
    glTela.style.opacity = conFoto ? String(clamp((-9 - hSole) / 6, 0, 1)) : "0";
    if (conFoto) hips.disegna({ W, H, cdelt: fov / W, assi: B.j2000, stereo: true, grezzo: true, livelli: [0.045, 2] }, ["dss"]);
    const pO = [0, 0], pZ = [0, 0];
    proietta(vettore(0, az0), B.loc, pO);
    const yOr = clamp(pO[1], -H, 2 * H);
    const cieloCol = hSole > 0 ? ["rgba(70,122,186,0.97)", "rgba(166,203,236,0.97)"] : hSole > -6 ? ["rgba(26,52,96,0.9)", "rgba(222,140,86,0.9)"]
      : hSole > -12 ? ["rgba(10,26,56,0.72)", "rgba(52,84,130,0.8)"] : hSole > -18 ? ["rgba(4,12,28,0.25)", "rgba(24,48,82,0.55)"] : ["rgba(2,6,16,0)", "rgba(16,32,58,0.45)"];
    const gc = c.createLinearGradient(0, Math.min(0, yOr - H), 0, yOr);
    gc.addColorStop(0, cieloCol[0]); gc.addColorStop(1, cieloCol[1]);
    c.fillStyle = gc; c.fillRect(0, 0, W, H);
    if (!conFoto && notte) { c.fillStyle = "rgba(3,7,16,0.55)"; c.fillRect(0, 0, W, H); }
    const bort = clamp(NOTTE.bortle || 5, 1, 9);
    if (hSole < -6) {
      const alto = 18 * B.f * RAD, ga = c.createLinearGradient(0, yOr - alto, 0, yOr);
      ga.addColorStop(0, "rgba(255,170,90,0)"); ga.addColorStop(1, `rgba(255,${150 + bort * 4},${90 + bort * 6},${0.03 + bort * 0.022})`);
      c.fillStyle = ga; c.fillRect(0, yOr - alto, W, alto);
    }
    if (hSole > -14) {
      const ps = [0, 0];
      if (proietta(vettore(hSole, azSole), B.loc, ps)) {
        const r = (hSole > 0 ? 90 : 260) * k, g2 = c.createRadialGradient(ps[0], ps[1], 0, ps[0], ps[1], r);
        const forza = hSole > 0 ? 1 : clamp((hSole + 14) / 14, 0, 1) * 0.55;
        g2.addColorStop(0, `rgba(255,236,190,${forza})`); g2.addColorStop(0.3, `rgba(255,190,120,${forza * 0.5})`); g2.addColorStop(1, "rgba(255,170,100,0)");
        c.fillStyle = g2; c.beginPath(); c.arc(ps[0], ps[1], r, 0, 2 * Math.PI); c.fill();
        if (hSole > 0) { c.fillStyle = "#fff8e0"; c.beginPath(); c.arc(ps[0], ps[1], 9 * k, 0, 2 * Math.PI); c.fill(); }
      }
    }
    punti = [];
    const scritte = [];
    const scrivi = (testo, x, y, colore, px, peso, prio, centro, ombra) => scritte.push({ testo, x, y, colore, px, peso, prio, centro, ombra });
    const p = [0, 0], q = [0, 0];
    c.lineWidth = 1 * k; c.strokeStyle = "rgba(170,200,240,0.12)"; c.setLineDash([3 * k, 5 * k]);
    for (const h of [10, 30, 60]) {
      c.beginPath(); let su = false;
      for (let a = -180; a <= 180; a += 2) {
        if (!proietta(vettore(h, az0 + a), B.loc, p) || !dentro(p, 400 * k)) { su = false; continue; }
        if (su) c.lineTo(p[0], p[1]); else c.moveTo(p[0], p[1]);
        su = true;
      }
      c.stroke();
      if (proietta(vettore(h, az0), B.loc, p) && dentro(p, 0)) scrivi(h + "°", p[0] + 6 * k, p[1] - 4 * k, "rgba(170,200,240,0.45)", 10, 600, 20);
    }
    c.setLineDash([]);
    if (base) {
      const lin = base.linee, j2 = B.j2000;
      if (VLUOGO.linee && visib >= 0.5) {
        c.strokeStyle = "rgba(143,208,255,0.3)"; c.lineWidth = 1.1 * k; c.beginPath();
        for (const [r1, d1, r2, d2] of lin) {
          if (!proietta(eqV(r1, d1), j2, p) || !proietta(eqV(r2, d2), j2, q)) continue;
          if (!dentro(p, 200 * k) && !dentro(q, 200 * k)) continue;
          c.moveTo(p[0], p[1]); c.lineTo(q[0], q[1]);
        }
        c.stroke();
      }
      const st = base.stelle, z2 = B.z2000, magMax = (fov > 90 ? 5.6 : fov > 50 ? 6.2 : 6.5) - (1 - visib) * 3.5, v = [0, 0, 0];
      for (let i = 0; i < st.n; i++) {
        const m = st.m[i];
        if (m > magMax) continue;
        v[0] = st.cd[i] * Math.cos(st.ra[i]); v[1] = st.cd[i] * Math.sin(st.ra[i]); v[2] = st.sd[i];
        const sa = punto(v, z2);
        if (sa < -0.01 || !proietta(v, j2, p) || !dentro(p, 4)) continue;
        const alt = Math.asin(clamp(sa, -1, 1)) * DEG, estinz = alt < 15 ? 0.3 + 0.7 * alt / 15 : 1;
        const r = Math.max(0.6, (6.9 - m) * 0.55) * k * (fov < 40 ? 1.2 : 1), col = Mappa.colore(st.c[i]);
        const a = clamp((0.4 + (6.5 - m) * 0.17) * estinz * Math.max(visib, 0.5), 0.12, 1);
        if (m < 2.2) {
          const g3 = c.createRadialGradient(p[0], p[1], 0, p[0], p[1], r * 3.2);
          g3.addColorStop(0, `rgba(${col[0]},${col[1]},${col[2]},${a * 0.55})`); g3.addColorStop(1, `rgba(${col[0]},${col[1]},${col[2]},0)`);
          c.fillStyle = g3; c.beginPath(); c.arc(p[0], p[1], r * 3.2, 0, 2 * Math.PI); c.fill();
        }
        c.fillStyle = `rgba(${col[0]},${col[1]},${col[2]},${a})`;
        c.beginPath(); c.arc(p[0], p[1], r, 0, 2 * Math.PI); c.fill();
      }
      for (const s of base.nomi) {
        if (s.m > 2.6) continue;
        const vv = eqV(s.ra, s.dec), sa = punto(vv, z2);
        if (sa < 0 || !proietta(vv, j2, p) || !dentro(p, 0)) continue;
        const nome = s[LINGUA] || s.en, alt = Math.asin(sa) * DEG;
        punti.push({ x: p[0], y: p[1], r: 10 * k, nome, riga: t("pl_mag", { m: num(s.m, 1) }), alt });
        if (s.m <= (fov > 90 ? 1.3 : 2) && visib >= 0.5) scrivi(nome, p[0] + 7 * k, p[1] - 6 * k, "rgba(226,234,248,0.78)", 11, 500, 6 + s.m);
      }
      if (VLUOGO.linee && visib >= 0.5 && fov <= 120) for (const [sigla, [ra, dec]] of Object.entries(base.etichette)) {
        const vv = eqV(ra, dec);
        if (punto(vv, z2) < 0.12 || !proietta(vv, j2, p) || !dentro(p, -20 * k)) continue;
        scrivi(nomeCostellazione(sigla).toUpperCase(), p[0], p[1], "rgba(143,208,255,0.45)", 10, 600, 12, true);
      }
    }
    const dat = B.data, zD = B.zData;
    for (const nome of PIANETI) {
      if (corpo === nome) continue;
      const pl = Astro.pianeta(nome, j), vv = eqV(pl.ra, pl.dec);
      if (punto(vv, zD) < -0.01 || !proietta(vv, dat, p) || !dentro(p, 0)) continue;
      const r = clamp(4.8 - pl.mag * 0.6, 2.4, 6.5) * k;
      const g4 = c.createRadialGradient(p[0], p[1], 0, p[0], p[1], r * 3);
      g4.addColorStop(0, COLORI_PIANETI[nome] + "88"); g4.addColorStop(1, COLORI_PIANETI[nome] + "00");
      c.fillStyle = g4; c.beginPath(); c.arc(p[0], p[1], r * 3, 0, 2 * Math.PI); c.fill();
      c.fillStyle = COLORI_PIANETI[nome]; c.beginPath(); c.arc(p[0], p[1], r, 0, 2 * Math.PI); c.fill();
      scrivi(t("pianeta_" + nome), p[0] + r + 5 * k, p[1] + 4 * k, COLORI_PIANETI[nome], 11.5, 700, 2);
      punti.push({ x: p[0], y: p[1], r: 12 * k, nome: t("pianeta_" + nome), riga: t("pl_mag", { m: num(pl.mag, 1) }), alt: Math.asin(punto(vv, zD)) * DEG });
    }
    const luna = Astro.luna(j), fase = Astro.faseLuna(j), [hL0, azL] = Astro.altAz(luna.ra, luna.dec, lat, lst);
    const hL = hL0 - luna.par * Math.cos(hL0 * RAD), vl = vettore(hL, azL), vSole = vettore(hSole, azSole);
    if (corpo !== "luna" && vl[2] > -0.01 && proietta(vl, B.loc, p) && dentro(p, 20)) {
      const r = Math.max(8 * k, 0.26 * RAD * B.f);
      const g5 = c.createRadialGradient(p[0], p[1], r, p[0], p[1], r * 5);
      g5.addColorStop(0, `rgba(240,234,214,${0.25 * fase.k})`); g5.addColorStop(1, "rgba(240,234,214,0)");
      c.fillStyle = g5; c.beginPath(); c.arc(p[0], p[1], r * 5, 0, 2 * Math.PI); c.fill();
      lunaSuTela(c, p[0], p[1], r, fase, versoSole(vl, vSole, p));
      scrivi(t("vl_luna_su", { k: num(fase.k * 100) }), p[0] + r + 6 * k, p[1] + 4 * k, "#efe8d2", 11.5, 700, 2);
      punti.push({ x: p[0], y: p[1], r: r + 6 * k, nome: t("luna"), riga: `${num(fase.k * 100)} % ${t("ls_illuminata")}`, alt: hL });
    }
    const loc = B.loc;
    const statoP = x => x.hs > -12 ? "luce" : libero(x) ? "ok" : "no";
    const COL = { ok: "rgba(244,206,110,0.95)", no: "rgba(255,110,110,0.7)", luce: "rgba(190,200,220,0.45)" };
    c.lineCap = "round"; c.lineWidth = 2.6 * k;
    let prec = null;
    for (const x of traccia) {
      const ok = proietta(vettore(x.h, x.az), loc, p);
      if (ok && prec) {
        c.strokeStyle = COL[statoP(x)];
        c.shadowColor = statoP(x) === "ok" ? "rgba(244,206,110,0.8)" : "transparent"; c.shadowBlur = 8 * k;
        c.beginPath(); c.moveTo(prec[0], prec[1]); c.lineTo(p[0], p[1]); c.stroke();
      }
      prec = ok ? [p[0], p[1]] : null;
    }
    c.shadowBlur = 0; c.shadowColor = "transparent";
    const d0 = Astro.data(j0);
    d0.setMinutes(60, 0, 0);
    for (let jj = Astro.jd(d0); jj <= j1; jj += 1 / 24) {
      const [h, az] = altAzA(jj);
      if (h < (terrenoDelLuogo() ? terAlt(az) : 0) - 0.5 || !proietta(vettore(h, az), loc, p) || !dentro(p, 0)) continue;
      c.fillStyle = "#0b1426"; c.strokeStyle = "rgba(244,206,110,0.95)"; c.lineWidth = 1.6 * k;
      c.beginPath(); c.arc(p[0], p[1], 3.6 * k, 0, 2 * Math.PI); c.fill(); c.stroke();
      scrivi(ora(new Date(Math.round(Astro.data(jj).getTime() / 60000) * 60000)), p[0] + 7 * k, p[1] + 13 * k, "rgba(244,222,160,0.9)", 10.5, 700, 4, false, true);
    }
    const [hO, azO] = altAzA(j), pO2 = [0, 0];
    const vO = vettore(hO, azO);
    let posO = null;
    if (proietta(vO, loc, pO2)) {
      posO = [pO2[0], pO2[1]];
      const camp = campoAttuale();
      if (camp && !corpo) {
        const [raJ, decJ] = [o.ra, o.dec];
        const a = (CAMPO.rot || 0) * RAD, angoli = [[-1, -1], [1, -1], [1, 1], [-1, 1]];
        c.beginPath();
        angoli.forEach(([sx, sy], i) => {
          const x = sx * camp.w / 2, y = sy * camp.h / 2;
          const xr = x * Math.cos(a) + y * Math.sin(a), yr = -x * Math.sin(a) + y * Math.cos(a);
          const [ra, dec] = daGnomonica(raJ, decJ, -xr, -yr);
          if (proietta(eqV(ra, dec), B.j2000, q)) { if (i) c.lineTo(q[0], q[1]); else c.moveTo(q[0], q[1]); }
        });
        c.closePath();
        c.fillStyle = "rgba(244,206,110,0.12)"; c.fill();
        c.strokeStyle = "rgba(244,206,110,1)"; c.lineWidth = 1.8 * k; c.stroke();
      }
      const g6 = c.createRadialGradient(posO[0], posO[1], 0, posO[0], posO[1], 22 * k);
      g6.addColorStop(0, "rgba(255,226,150,0.55)"); g6.addColorStop(1, "rgba(255,226,150,0)");
      c.fillStyle = g6; c.beginPath(); c.arc(posO[0], posO[1], 22 * k, 0, 2 * Math.PI); c.fill();
      c.strokeStyle = "#ffe29a"; c.lineWidth = 2 * k;
      c.beginPath(); c.arc(posO[0], posO[1], 7 * k, 0, 2 * Math.PI); c.stroke();
      for (const [dx, dy] of [[1, 0], [-1, 0], [0, 1], [0, -1]]) { c.beginPath(); c.moveTo(posO[0] + dx * 10 * k, posO[1] + dy * 10 * k); c.lineTo(posO[0] + dx * 15 * k, posO[1] + dy * 15 * k); c.stroke(); }
      if (corpo === "luna") lunaSuTela(c, posO[0], posO[1], Math.max(8 * k, 0.26 * RAD * B.f), fase, versoSole(vO, vSole, posO));
      scrivi(titoloOggetto(o), posO[0] + 18 * k, posO[1] - 12 * k, "#ffe29a", 13, 800, 0, false, true);
      punti.push({ x: posO[0], y: posO[1], r: 16 * k, nome: titoloOggetto(o), riga: o.corpo ? "" : rigaOggetto(o), alt: hO });
    }
    const ter = terrenoDelLuogo(), cresta = [];
    for (let a = -120; a <= 120; a += 0.5) {
      const az = az0 + a, h = ter ? terAlt(az) : 0;
      if (proietta(vettore(h, az), loc, p)) cresta.push([p[0], p[1]]);
    }
    if (cresta.length > 1) {
      const fine = cresta[cresta.length - 1], primo = cresta[0], basso = H + 400 * k;
      const yMin = Math.min(...cresta.map(x => x[1]));
      c.beginPath(); c.moveTo(primo[0], basso);
      for (const x of cresta) c.lineTo(x[0], x[1]);
      c.lineTo(fine[0], basso); c.closePath();
      const gt = c.createLinearGradient(0, yMin, 0, Math.min(H, yMin + 260 * k));
      const giorno = hSole > -6;
      gt.addColorStop(0, giorno ? "#3c4034" : "#1a1e29"); gt.addColorStop(0.35, giorno ? "#262a21" : "#0b0d13"); gt.addColorStop(1, giorno ? "#15170f" : "#040507");
      c.fillStyle = gt; c.fill();
      c.beginPath(); cresta.forEach((x, i) => (i ? c.lineTo(x[0], x[1]) : c.moveTo(x[0], x[1])));
      c.strokeStyle = "rgba(226,184,79,0.85)"; c.lineWidth = 1.6 * k; c.shadowColor = "rgba(226,184,79,0.6)"; c.shadowBlur = 6 * k; c.stroke();
      c.shadowBlur = 0; c.shadowColor = "transparent";
    }
    const card = t("ns_card16").split(",");
    for (let i = 0; i < 16; i++) {
      const az = i * 22.5, d = ((az - az0 + 540) % 360) - 180;
      if (Math.abs(d) > 115) continue;
      if (!proietta(vettore(-3.2, az), loc, p) || !dentro(p, 0)) continue;
      const grande = i % 4 === 0;
      scrivi(card[i], p[0], Math.min(p[1], H - 10 * k), grande ? "#f4d58b" : "rgba(244,213,139,0.55)", grande ? 15 : 11, 800, grande ? 1 : 10, true);
      c.strokeStyle = grande ? "rgba(244,213,139,0.6)" : "rgba(244,213,139,0.3)"; c.lineWidth = 1 * k;
      if (proietta(vettore(ter ? terAlt(az) : 0, az), loc, q)) { c.beginPath(); c.moveTo(q[0], q[1]); c.lineTo(q[0], q[1] + (grande ? 9 : 5) * k); c.stroke(); }
    }
    const occupati = [];
    scritte.sort((a, b) => a.prio - b.prio);
    c.textBaseline = "alphabetic";
    for (const s of scritte) {
      c.font = `${s.peso} ${s.px * k}px ${famiglia}`;
      const w = c.measureText(s.testo).width, h = s.px * k, x = s.centro ? s.x - w / 2 : s.x;
      const box2 = [x - 2 * k, s.y - h, w + 4 * k, h + 4 * k];
      if (occupati.some(o2 => box2[0] < o2[0] + o2[2] && o2[0] < box2[0] + box2[2] && box2[1] < o2[1] + o2[3] && o2[1] < box2[1] + box2[3])) continue;
      occupati.push(box2);
      if (s.ombra) { c.fillStyle = "rgba(0,0,0,0.65)"; c.fillText(s.testo, x + 1 * k, s.y + 1 * k); }
      c.fillStyle = s.colore; c.fillText(s.testo, x, s.y);
    }
    const quando = Astro.data(j);
    oraB.textContent = ora(quando);
    cursore.setAttribute("aria-valuetext", `${giorno(quando)} ${ora(quando)}`);
    statoCielo.textContent = `${giorno(quando)} · ${hSole > -0.833 ? t("vl_giorno") : hSole > -12 ? t("vl_crep") : t("vl_buio")}`;
    const dir = card[Math.round(Astro.n360(azO) / 22.5) % 16];
    const dove = hO < 0 ? t("vl_sotto") : ter && hO < terAlt(azO) + 0.5 ? t("vl_dietro") : hO < (NOTTE.hmin || 0) ? t("vl_basso", { h: NOTTE.hmin }) : ter ? t("vl_sopra") : "";
    aggiungi(svuota(info), [el("b", null, titoloOggetto(o)), el("span", null, `${num(hO)}° · ${dir} (${num(Astro.n360(azO))}°)`),
      dove ? el("em", { class: hO < 0 || (ter && hO < terAlt(azO) + 0.5) ? "no" : hO < (NOTTE.hmin || 0) ? "basso" : "ok" }, dove) : null]);
    const fuori = !posO || !dentro(posO, -10 * k);
    avviso.hidden = !fuori;
    if (fuori) avviso.textContent = `${titoloOggetto(o)} ${((azO - az0 + 540) % 360) - 180 > 0 ? "→" : "←"}`;
    crediti.textContent = (conFoto ? t("vl_crediti") : t("vl_crediti").replace(/^[^·]*·\s*/, "")) + (ter ? t("vl_crediti_ter") : "");
    terBtn.hidden = !!ter;
    void pZ;
  }
  function disegnaCurva() {
    svuota(curva);
    const X = jj => (jj - j0) / (j1 - j0) * 1000, Y = h => 58 - clamp(h, 0, 90) / 90 * 54;
    const idG = "vlg" + (disegnaCurva._n = (disegnaCurva._n || 0) + 1);
    const colore = hs => hs > -0.833 ? "#4c79ad" : hs > -6 ? "#7a5a7c" : hs > -12 ? "#2b3c66" : hs > -18 ? "#16233f" : "#0a1122";
    curva.appendChild(sv("defs", null, sv("linearGradient", { id: idG, x1: 0, y1: 0, x2: 1, y2: 0 },
      traccia.filter((x, i) => i % 2 === 0 || i === traccia.length - 1).map(x => sv("stop", { offset: ((x.j - j0) / (j1 - j0)).toFixed(4), "stop-color": colore(x.hs) })))));
    curva.appendChild(sv("rect", { x: 0, y: 0, width: 1000, height: 60, fill: `url(#${idG})` }));
    let d = "", d2 = "";
    traccia.forEach((x, i) => { d += `${i ? "L" : "M"}${X(x.j).toFixed(1)},${Y(x.h).toFixed(1)}`; });
    d2 = d + `L1000,60L0,60Z`;
    curva.appendChild(sv("path", { d: d2, fill: "rgba(244,206,110,0.16)" }));
    curva.appendChild(sv("path", { d, fill: "none", stroke: "rgba(244,206,110,0.95)", "stroke-width": 2, "vector-effect": "non-scaling-stroke" }));
    if (terrenoDelLuogo() || NOTTE.hmin) {
      for (let i = 1; i < traccia.length; i++) if (traccia[i].hs < -12 && libero(traccia[i]))
        curva.appendChild(sv("rect", { x: X(traccia[i - 1].j), y: 56, width: X(traccia[i].j) - X(traccia[i - 1].j) + 0.6, height: 4, fill: "#5fd08a" }));
    }
    const buoni = traccia.filter(x => x.hs < -12 && libero(x));
    finestraTesto.textContent = buoni.length ? t("vl_finestra", { h: num(Math.max(NOTTE.hmin || 0, 0)), a: ora(Astro.data(buoni[0].j)), b: ora(Astro.data(buoni[buoni.length - 1].j)) })
      : t("vl_mai", { h: num(Math.max(NOTTE.hmin || 0, 0)) });
  }
  const posCursore = () => { cursore.value = String(Math.round((j - j0) / (j1 - j0) * 1000)); };
  const vaiA = nuovo => { j = clamp(nuovo, j0, j1); posCursore(); ridisegna(); };
  function notteDiAdesso() {
    const adesso = Astro.jd(new Date()), oggi = new Date();
    if (adesso >= j0 && adesso <= j1) return;
    const g = new Date(oggi.getFullYear(), oggi.getMonth(), oggi.getDate() - (oggi.getHours() < 12 ? 1 : 0), 12);
    let [a, b] = limiti(Astro.notte(g, lat, lon, 10));
    if (adesso > b) [a, b] = limiti(Astro.notte(new Date(g.getFullYear(), g.getMonth(), g.getDate() + 1, 12), lat, lon, 10));
    j0 = Math.min(a, adesso); j1 = Math.max(b, adesso);
    calcolaTraccia(); disegnaCurva();
  }
  cursore.addEventListener("input", () => { j = j0 + (+cursore.value / 1000) * (j1 - j0); fermaGioco(); ridisegna(); });
  let gioco = null;
  function avviaGioco() {
    if (j >= j1 - 1e-4) j = j0;
    bGioco.textContent = "❚❚"; bGioco.setAttribute("aria-label", t("vl_ferma"));
    let prima = performance.now();
    const passo = adesso => {
      if (!fondo.isConnected) { gioco = null; return; }
      const dt = Math.min(100, adesso - prima); prima = adesso;
      j += dt / 1000 / 24 * 1.5;
      if (j >= j1) { vaiA(j1); fermaGioco(); return; }
      vaiA(j);
      gioco = requestAnimationFrame(passo);
    };
    gioco = requestAnimationFrame(passo);
  }
  function fermaGioco() { if (gioco) cancelAnimationFrame(gioco); gioco = null; bGioco.textContent = "▶"; bGioco.setAttribute("aria-label", t("vl_avvia")); }
  async function calcolaTerreno() {
    terBtn.disabled = true; terBtn.lastChild.textContent = " " + t("vl_ter_attendi");
    try {
      const T = NOTTE.terreno || (NOTTE.terreno = { on: false, sopra: 0 });
      const r = await calcolaOrizzonte(lat, lon, T.sopra || 0);
      Object.assign(T, { lat, lon, quota: r.quota, p: r.p, v: r.v });
      salvaNotte();
      disegnaCurva(); ridisegna();
    } catch (e) { console.error("strumenti, orizzonte:", e); terBtn.lastChild.textContent = " " + t("ter_errore"); terBtn.disabled = false; return; }
    terBtn.disabled = false; terBtn.lastChild.textContent = " " + t("vl_ter_calcola");
  }
  const tocchi = new Map();
  let mosso = 0, distIniz = 0, fovIniz = 0;
  tela.addEventListener("pointerdown", e => {
    tela.setPointerCapture(e.pointerId);
    tocchi.set(e.pointerId, [e.clientX, e.clientY]);
    mosso = 0;
    if (tocchi.size === 2) { const [a, b] = [...tocchi.values()]; distIniz = Math.hypot(a[0] - b[0], a[1] - b[1]); fovIniz = fov; }
  });
  tela.addEventListener("pointermove", e => {
    if (!tocchi.has(e.pointerId)) { if (e.pointerType === "mouse") mostra(e, false); return; }
    const prima = tocchi.get(e.pointerId), dx = e.clientX - prima[0], dy = e.clientY - prima[1];
    tocchi.set(e.pointerId, [e.clientX, e.clientY]);
    if (tocchi.size === 2) {
      const [a, b] = [...tocchi.values()], d = Math.hypot(a[0] - b[0], a[1] - b[1]);
      if (distIniz > 10) { fov = clamp(fovIniz * distIniz / d, 12, 150); ridisegna(); }
      mosso += 10;
      return;
    }
    mosso += Math.abs(dx) + Math.abs(dy);
    const gradiPx = fov / (scena.clientWidth || 800);
    az0 = Astro.n360(az0 - dx * gradiPx);
    alt0 = clamp(alt0 + dy * gradiPx, -20, 89);
    fumetto.hidden = true;
    ridisegna();
  });
  const lascia = e => {
    if (tocchi.has(e.pointerId) && tocchi.size === 1 && mosso < 6 && e.type === "pointerup") mostra(e, true);
    tocchi.delete(e.pointerId);
  };
  tela.addEventListener("pointerup", lascia);
  tela.addEventListener("pointercancel", lascia);
  tela.addEventListener("wheel", e => { e.preventDefault(); fov = clamp(fov * (e.deltaY > 0 ? 1.12 : 1 / 1.12), 12, 150); ridisegna(); }, { passive: false });
  function mostra(ev, tocco) {
    if (!tocco && gioco) return;
    const r = tela.getBoundingClientRect(), s = tela.width / (r.width || 1);
    const x = (ev.clientX - r.left) * s, y = (ev.clientY - r.top) * s;
    let best = null, dmin = Infinity;
    for (const pt of punti) { const d = Math.hypot(pt.x - x, pt.y - y); if (d < pt.r * (tocco ? 1.7 : 1) && d < dmin) { dmin = d; best = pt; } }
    if (!best) { fumetto.hidden = true; return; }
    aggiungi(svuota(fumetto), [el("b", null, best.nome), best.riga ? el("span", null, best.riga) : null, el("small", null, `${num(best.alt)}°`)]);
    fumetto.hidden = false;
    fumetto.style.left = `${clamp(best.x / s + 14, 6, r.width - 200)}px`; fumetto.style.top = `${clamp(best.y / s - 12, 6, r.height - 90)}px`;
  }
  box.addEventListener("keydown", e => {
    if (e.target === cursore || (e.target.closest && e.target.closest("input, select, textarea"))) return;
    const passo = fov / 12;
    if (e.key === "ArrowLeft") az0 = Astro.n360(az0 - passo); else if (e.key === "ArrowRight") az0 = Astro.n360(az0 + passo);
    else if (e.key === "ArrowUp") alt0 = clamp(alt0 + passo, -20, 89); else if (e.key === "ArrowDown") alt0 = clamp(alt0 - passo, -20, 89);
    else return;
    e.preventDefault(); ridisegna();
  });
  const alRidimensiona = debounce(() => ridisegna(), 120);
  window.addEventListener("resize", alRidimensiona);
  fondo.addEventListener("click", e => { if (e.target === fondo) chiudiVistaLuogo(); });
  VL_APERTA = {
    fondo, prima, spinta,
    fine: () => {
      fermaGioco();
      window.removeEventListener("resize", alRidimensiona);
      window.removeEventListener("popstate", indietro);
      try { const g = glTela.getContext("webgl"); const x = g && g.getExtension("WEBGL_lose_context"); if (x) x.loseContext(); } catch (e) {   }
    },
  };
  posCursore();
  disegnaCurva();
  requestAnimationFrame(() => { centraSuOggetto(); ridisegna(); box.focus({ preventScroll: true }); });
}
Object.assign(TESTI.it, {
  tab_meteo: "Meteo", me_titolo: "Previsione per astrofili", me_carico: "Carico la previsione…", me_errore: "La previsione non è arrivata: riprova tra poco.",
  me_stanotte: "Stanotte", me_buio_da_a: "buio dalle {a} alle {b}", me_ore_buone: "{n} ore buone", me_finestra: "dalle {a} alle {b}", me_nessuna: "nessuna ora buona",
  me_nuvole_medie: "nuvole in media {p} %", me_condensa: "Rischio condensa dalle {o}: tieni accese le fasce anticondensa.", me_vento: "Vento forte dalle {o}: occhio alle pose lunghe.",
  me_luna_su: "Luna ({p} %) in cielo fino alle {o}", me_luna_sorge: "Luna ({p} %) sorge alle {o}", me_luna_no: "Luna sotto l'orizzonte per tutto il buio",
  me_ora: "Ora", me_giudizio: "Cielo", me_nuvole: "Nuvole", me_basse: "basse", me_medie: "medie", me_alte: "alte", me_nebbia: "Nebbia", me_pioggia: "Pioggia",
  me_umidita: "Umidità", me_rugiada: "T − rugiada", me_temp: "Temperatura", me_vento_r: "Vento", me_buio: "Buio", me_luna: "Luna",
  me_legenda: "Cielo: verde ✓ = ottimo per osservare, giallo ~ = discreto, rosso ✕ = no. Nuvole in %: le basse e le medie coprono, le alte (velature) tolgono trasparenza. «T − rugiada» è la temperatura meno il punto di rugiada: sotto i 2 °C c'è rischio di condensa sulle ottiche.",
  me_notti: "Le prossime notti", me_notti_n: "Per ogni notte: la nuvolosità media nelle ore di buio vero e la Luna.", me_sereno: "serena", me_poco: "poco nuvolosa", me_nuvoloso: "nuvolosa", me_coperto: "coperta",
  me_cielo_ora: "Nuvole e pioggia adesso", me_cielo_ora_n: "Satellite all'infrarosso (le nuvole si vedono anche di notte: più chiare = più alte e fredde) e radar della pioggia. Il punto oro è il tuo luogo.",
  me_satellite: "Satellite", me_radar: "Radar", me_coste: "Coste", me_radar_solo_it: "Il radar copre solo l'Italia.",
  me_seeing: "Seeing e trasparenza", me_seeing_n: "Per il seeing (turbolenza) non c'è una fonte libera affidabile per l'Italia: guarda i siti specializzati, con i link già impostati sulle tue coordinate.",
  me_buio_sqm: "Buio del cielo del luogo: SQM {s} (Bortle {b}), senza Luna.", me_crediti: "Previsioni: MET Norway (CC BY 4.0) · Satellite: © EUMETSAT 2026, Meteosat MTG (EUMETView) · Radar: Radar-DPC, Dipartimento della Protezione Civile (CC BY-SA 4.0) · Coste: Natural Earth.",
  me_anticondensa: "Fasce anticondensa e alimentatori nel negozio →", me_agg: "aggiornata alle {o}",
});
Object.assign(TESTI.de, {
  tab_meteo: "Wetter", me_titolo: "Vorhersage für Sternfreunde", me_carico: "Vorhersage wird geladen…", me_errore: "Die Vorhersage ist nicht angekommen: bitte gleich noch einmal versuchen.",
  me_stanotte: "Heute Nacht", me_buio_da_a: "dunkel von {a} bis {b}", me_ore_buone: "{n} gute Stunden", me_finestra: "von {a} bis {b}", me_nessuna: "keine gute Stunde",
  me_nuvole_medie: "Wolken im Mittel {p} %", me_condensa: "Taugefahr ab {o}: Taukappenheizung einschalten.", me_vento: "Starker Wind ab {o}: Vorsicht bei Langzeitbelichtungen.",
  me_luna_su: "Mond ({p} %) am Himmel bis {o}", me_luna_sorge: "Mond ({p} %) geht um {o} auf", me_luna_no: "Mond während der ganzen Dunkelheit unter dem Horizont",
  me_ora: "Uhrzeit", me_giudizio: "Himmel", me_nuvole: "Wolken", me_basse: "tief", me_medie: "mittel", me_alte: "hoch", me_nebbia: "Nebel", me_pioggia: "Regen",
  me_umidita: "Feuchte", me_rugiada: "T − Taupunkt", me_temp: "Temperatur", me_vento_r: "Wind", me_buio: "Dunkel", me_luna: "Mond",
  me_legenda: "Himmel: grün ✓ = sehr gut, gelb ~ = mittel, rot ✕ = nein. Wolken in %: tiefe und mittlere decken ab, hohe (Schleier) nehmen Transparenz. «T − Taupunkt» unter 2 °C = Tau auf der Optik.",
  me_notti: "Die nächsten Nächte", me_notti_n: "Für jede Nacht: mittlere Bewölkung in den Stunden echter Dunkelheit und der Mond.", me_sereno: "klar", me_poco: "leicht bewölkt", me_nuvoloso: "bewölkt", me_coperto: "bedeckt",
  me_cielo_ora: "Wolken und Regen jetzt", me_cielo_ora_n: "Infrarot-Satellitenbild (Wolken auch nachts sichtbar: heller = höher und kälter) und Regenradar. Der goldene Punkt ist Ihr Ort.",
  me_satellite: "Satellit", me_radar: "Radar", me_coste: "Küsten", me_radar_solo_it: "Das Radar deckt nur Italien ab.",
  me_seeing: "Seeing und Transparenz", me_seeing_n: "Für das Seeing gibt es keine freie, zuverlässige Quelle für Italien: Siehe die Fachseiten, mit Links, die schon auf Ihre Koordinaten eingestellt sind.",
  me_buio_sqm: "Himmelsdunkelheit am Ort: SQM {s} (Bortle {b}), ohne Mond.", me_crediti: "Vorhersage: MET Norway (CC BY 4.0) · Satellit: © EUMETSAT 2026, Meteosat MTG (EUMETView) · Radar: Radar-DPC, Dipartimento della Protezione Civile (CC BY-SA 4.0) · Küsten: Natural Earth.",
  me_anticondensa: "Taukappenheizungen und Netzteile im Shop →", me_agg: "aktualisiert um {o}",
});
Object.assign(TESTI.es, {
  tab_meteo: "Tiempo", me_titolo: "Previsión para astrónomos aficionados", me_carico: "Cargando la previsión…", me_errore: "La previsión no ha llegado: inténtalo de nuevo en un momento.",
  me_stanotte: "Esta noche", me_buio_da_a: "oscuridad de {a} a {b}", me_ore_buone: "{n} horas buenas", me_finestra: "de {a} a {b}", me_nessuna: "ninguna hora buena",
  me_nuvole_medie: "nubosidad media {p} %", me_condensa: "Riesgo de rocío desde las {o}: enciende las bandas antirrocío.", me_vento: "Viento fuerte desde las {o}: cuidado con las exposiciones largas.",
  me_luna_su: "Luna ({p} %) en el cielo hasta las {o}", me_luna_sorge: "Luna ({p} %) sale a las {o}", me_luna_no: "Luna bajo el horizonte durante toda la oscuridad",
  me_ora: "Hora", me_giudizio: "Cielo", me_nuvole: "Nubes", me_basse: "bajas", me_medie: "medias", me_alte: "altas", me_nebbia: "Niebla", me_pioggia: "Lluvia",
  me_umidita: "Humedad", me_rugiada: "T − rocío", me_temp: "Temperatura", me_vento_r: "Viento", me_buio: "Oscuridad", me_luna: "Luna",
  me_legenda: "Cielo: verde ✓ = muy bueno, amarillo ~ = regular, rojo ✕ = no. Nubes en %: las bajas y medias tapan, las altas (velos) quitan transparencia. «T − rocío» por debajo de 2 °C = rocío en la óptica.",
  me_notti: "Las próximas noches", me_notti_n: "Para cada noche: la nubosidad media en las horas de oscuridad real y la Luna.", me_sereno: "despejada", me_poco: "poco nubosa", me_nuvoloso: "nubosa", me_coperto: "cubierta",
  me_cielo_ora: "Nubes y lluvia ahora", me_cielo_ora_n: "Satélite infrarrojo (las nubes se ven también de noche: más claras = más altas y frías) y radar de lluvia. El punto dorado es tu lugar.",
  me_satellite: "Satélite", me_radar: "Radar", me_coste: "Costas", me_radar_solo_it: "El radar cubre solo Italia.",
  me_seeing: "Seeing y transparencia", me_seeing_n: "Para el seeing (turbulencia) no hay una fuente libre fiable para Italia: consulta los sitios especializados (los enlaces ya llevan tus coordenadas).",
  me_buio_sqm: "Oscuridad del cielo del lugar: SQM {s} (Bortle {b}), sin Luna.", me_crediti: "Previsión: MET Norway (CC BY 4.0) · Satélite: © EUMETSAT 2026, Meteosat MTG (EUMETView) · Radar: Radar-DPC, Dipartimento della Protezione Civile (CC BY-SA 4.0) · Costas: Natural Earth.",
  me_anticondensa: "Bandas antirrocío y alimentadores en la tienda →", me_agg: "actualizada a las {o}",
});
Object.assign(GUIDA.it, { g_meteo: "Questa è la scheda Meteo, pensata per chi osserva il cielo. In alto c'è il riassunto di stanotte: quante ore buone, a che ora, le nuvole, la Luna e il rischio di condensa sulle ottiche. Sotto, la previsione ora per ora: per ogni ora un giudizio verde, giallo o rosso, le nuvole divise in basse, medie e alte, la nebbia, la pioggia, l'umidità, la differenza tra temperatura e punto di rugiada, il vento, il buio e la Luna. Poi le prossime notti e il satellite all'infrarosso con il radar della pioggia sul tuo luogo, nelle ultime 3 ore: tocca Riproduci per vedere come si muovono nuvole e temporali. In fondo trovi i siti per controllare il seeing, cioè quanto trema l'aria, e la trasparenza e dove andare stanotte per un cielo più buio. Le previsioni sono dell'Istituto meteorologico norvegese, il satellite è di EUMETSAT e il radar della Protezione Civile." });
Object.assign(GUIDA.de, { g_meteo: "Das ist der Wetterbereich für Himmelsbeobachter. Oben die Zusammenfassung für heute Nacht: wie viele gute Stunden, wann, Wolken, Mond und Taugefahr auf der Optik. Darunter die stündliche Vorhersage mit einer Bewertung in Grün, Gelb oder Rot, den Wolken in tief, mittel und hoch, Nebel, Regen, Feuchte, Abstand zum Taupunkt, Wind, Dunkelheit und Mond. Dann die nächsten Nächte und das Infrarot-Satellitenbild mit dem Regenradar für Ihren Ort, über die letzten 3 Stunden: Tippen Sie auf Abspielen, um zu sehen, wie Wolken und Gewitter ziehen. Ganz unten finden Sie die Fachseiten für Seeing und Transparenz und Orte mit dunklerem Himmel für heute Nacht. Die Vorhersagen stammen vom Norwegischen Meteorologischen Institut, das Satellitenbild von EUMETSAT und das Radar vom italienischen Zivilschutz." });
Object.assign(GUIDA.es, { g_meteo: "Esta es la sección del tiempo pensada para quien observa el cielo. Arriba el resumen de esta noche: cuántas horas buenas, a qué hora, las nubes, la Luna y el riesgo de rocío. Debajo, la previsión hora a hora con una valoración verde, amarilla o roja, las nubes bajas, medias y altas, la niebla, la lluvia, la humedad, la diferencia entre la temperatura y el punto de rocío, el viento, la oscuridad y la Luna. Luego las próximas noches y el satélite infrarrojo con el radar de lluvia sobre tu lugar, en las últimas 3 horas: toca Reproducir para ver cómo se mueven las nubes y las tormentas. Al final encuentras los sitios para el seeing y la transparencia, y adónde ir esta noche para tener un cielo más oscuro. Las previsiones son del Instituto Meteorológico Noruego, el satélite es de EUMETSAT y el radar, de la Protección Civil italiana." });
const _previsioni = new Map();
function previsione(lat, lon) {
  const la = Math.round(lat * 100) / 100, lo = Math.round(lon * 100) / 100, chiave = `${la},${lo}`;
  const c = _previsioni.get(chiave);
  if (c && Date.now() - c.quando < 30 * 60000) return c.p;
  const p = fetch(`https://api.met.no/weatherapi/locationforecast/2.0/complete?lat=${la}&lon=${lo}`, { credentials: "omit" })
    .then(r => { if (!r.ok) throw new Error("MET " + r.status); return r.json(); })
    .then(j => Object.assign(j.properties.timeseries.map(x => {
      const d = x.data.instant.details, n1 = x.data.next_1_hours, n6 = x.data.next_6_hours;
      const sim = (n1 && n1.summary && n1.summary.symbol_code) || (n6 && n6.summary && n6.summary.symbol_code) || "";
      return { t: new Date(x.time), nuv: d.cloud_area_fraction, basse: d.cloud_area_fraction_low, medie: d.cloud_area_fraction_medium, alte: d.cloud_area_fraction_high,
        nebbia: d.fog_area_fraction, um: d.relative_humidity, temp: d.air_temperature, rug: d.dew_point_temperature, vento: d.wind_speed * 3.6, dir: d.wind_from_direction,
        pioggia: n1 ? n1.details.precipitation_amount : n6 ? n6.details.precipitation_amount / 6 : null, oraria: !!n1,
        temporale: /thunder/.test(sim), neve: /snow|sleet/.test(sim) };
    }), { agg: new Date((j.properties.meta && j.properties.meta.updated_at) || NaN) }));
  p.catch(() => _previsioni.delete(chiave));
  _previsioni.set(chiave, { p, quando: Date.now() });
  return p;
}
function votoOra(x) {
  let v = 100 - (x.nuv ?? 100);
  if ((x.nebbia ?? 0) > 5) v = Math.min(v, 15);
  if ((x.pioggia ?? 0) > 0.1 || x.temporale) v = 0;
  if ((x.um ?? 0) > 95) v -= 15;
  if ((x.vento ?? 0) > 40) v -= 25; else if ((x.vento ?? 0) > 28) v -= 10;
  return clamp(v, 0, 100);
}
const classeVoto = v => (v >= 75 ? "si" : v >= 50 ? "forse" : "no");
function cieloA(d, lat, lon) {
  const j = Astro.jd(d), lst = Astro.n360(Astro.gmst(j) + lon), s = Astro.sole(j), l = Astro.luna(j);
  return { hs: Astro.altezza(s.ra, s.dec, lat, lst), hl: Astro.altezzaLuna(l, lat, lst), k: Astro.faseLuna(j).k };
}
function vistaMeteo(pannello) {
  svuota(pannello);
  const corpo = el("div", { class: "gas-me" });
  const posti = NAV4 ? el("div", { class: "gas-me-posti" }) : null;
  const usaPosto = l => {
    Object.assign(NOTTE, { luogo: Object.assign({}, l, { punto: true }), bortleAuto: true, sqmMisurato: null, sqmStima: null, lpiStima: null, fonteStima: null });
    salvaNotte();
    try { riempiChip(); } catch (e) {   }
    vistaMeteo(pannello);
    pannello.scrollIntoView({ behavior: "smooth", block: "start" });
  };
  const disegnaPosti = () => { if (posti) svuota(posti).appendChild(cartaCieliBui(usaPosto)); };
  aggiungi(pannello, [barraLuogo(() => { disegna(); disegnaPosti(); }, false), corpo, posti]);
  disegnaPosti();
  async function disegna() {
    const { lat, lon } = NOTTE.luogo, mio = (disegna.giro = (disegna.giro || 0) + 1);
    svuota(corpo).append(el("p", { class: "gas-carico" }, t("me_carico")));
    let dati;
    try { dati = await previsione(lat, lon); } catch (e) {
      if (mio === disegna.giro) svuota(corpo).append(el("p", { class: "gas-errore" }, t("me_errore"), el("br"),
        el("button", { type: "button", class: "gas-btn gas-btn--chiaro", style: { marginTop: "1.2rem" }, onclick: () => disegna() }, t("me_riprova"))));
      return;
    }
    if (mio !== disegna.giro || !corpo.isConnected) return;
    const ora0 = Date.now() - 3600e3;
    const ore = dati.filter(x => x.oraria && x.t.getTime() >= ora0).map(x => Object.assign({}, x, cieloA(new Date(x.t.getTime() + 1800e3), lat, lon)));
    for (const x of ore) x.voto = x.hs > -12 ? null : votoOra(x);
    const vecchia = Date.now() - dati.agg > 12 * 3600e3;
    aggiungi(svuota(corpo), [vecchia ? el("p", { class: "gas-me-avviso gas-me-avviso--forte" }, "⚠ ", t("me_vecchia", { g: giorno(dati.agg), o: ora(dati.agg) })) : null,
      cartaStanotte(ore, lat, lon), cartaOraria(ore, dati.agg), cartaNotti(dati, lat, lon), cartaCieloOra(lat, lon, ore), cartaAltriSiti(lat, lon),
      el("p", { class: "gas-credits-mini" }, t("me_crediti"))]);
  }
  disegna();
}
function dataNotteMeteo(lat, lon, stanotte) {
  if (NOTTE.data && !stanotte) return dataNotte();
  const o = new Date(), oggi = new Date(o.getFullYear(), o.getMonth(), o.getDate(), 12), ieri = new Date(o.getFullYear(), o.getMonth(), o.getDate() - 1, 12);
  if (o.getHours() >= 12) return oggi;
  const ev = Astro.notte(ieri, lat, lon, 10).ev, fine = ev.astroInizio || ev.nauticoInizio;
  return fine && fine > o ? ieri : oggi;
}
function cartaStanotte(ore, lat, lon) {
  const d = dataNotteMeteo(lat, lon), nt = Astro.notte(d, lat, lon, 10), ev = nt.ev;
  const a = ev.astroFine || ev.nauticoFine, b = ev.astroInizio || ev.nauticoInizio;
  const g = giorno(d), nome = isoData(d) === isoData(dataNotteMeteo(lat, lon, true)) ? t("me_stanotte") : g.charAt(0).toUpperCase() + g.slice(1);
  const dentro = a && b ? ore.filter(x => x.t >= new Date(a.getTime() - 1800e3) && x.t <= b) : [];
  const scoperta = !!(a && b) && !(dentro.length && ore[ore.length - 1].t >= new Date(b.getTime() - 3600e3));
  let meglio = [], corr = [];
  for (const x of dentro) { if (x.voto != null && x.voto >= 75) { corr.push(x); if (corr.length > meglio.length) meglio = corr.slice(); } else corr = []; }
  const buone = dentro.filter(x => x.voto != null && x.voto >= 75).length;
  const media = dentro.length ? dentro.reduce((s, x) => s + (x.nuv ?? 0), 0) / dentro.length : null;
  const umido = dentro.find(x => x.temp != null && x.rug != null && x.temp - x.rug < 2), ventoso = dentro.find(x => x.vento > 28);
  const da = a ? new Date(a.getTime() - 3 * 3600e3) : new Date(0), fino = b || new Date(Date.now() + 12 * 3600e3);
  const prossime = ore.filter(x => x.t >= da && x.t <= fino);
  const tuono = prossime.find(x => x.temporale), bagnato = prossime.find(x => (x.pioggia ?? 0) > 0.1);
  const fase = nt.fase, sulle = [];
  if (a && b) {
    const H0 = -0.833, hL = nt.hLuna, p = num(fase.k * 100), i0 = clamp(Math.floor((Astro.jd(a) - nt.j0) * 1440 / nt.passo), 0, nt.n - 1);
    const passa = su => {
      for (let i = i0 + 1; i < nt.n; i++) {
        const x = hL[i - 1] - H0, y = hL[i] - H0;
        if (su ? x < 0 && y >= 0 : x >= 0 && y < 0) return Astro.data(nt.tempi[i - 1] + x / (x - y) * (nt.tempi[i] - nt.tempi[i - 1]));
      }
      return null;
    };
    if (cieloA(a, lat, lon).hl >= H0) sulle.push(t("me_luna_su", { p, o: ora(passa(false) || b) }));
    else { const s = passa(true); sulle.push(s && s < b ? t("me_luna_sorge", { p, o: ora(s) }) : t("me_luna_no")); }
  }
  const voto = scoperta ? "" : buone >= 4 ? "si" : buone >= 1 ? "forse" : "no";
  const fin = meglio.length ? { a: ora(new Date(Math.max(meglio[0].t, a))), b: ora(new Date(Math.min(meglio[meglio.length - 1].t.getTime() + 3600e3, b))) } : null;
  return scheda(titoloVoce(t("me_titolo"), "g_meteo"),
    el("div", { class: "gas-me-sintesi" + (voto ? " gas-me-sintesi--" + voto : "") },
      el("i", { class: "gas-me-semaforo", style: voto ? null : { background: "var(--gas-muto)", boxShadow: "none" } }),
      el("div", null,
        el("p", { class: "gas-me-riga1" }, el("b", null, nome), a && b ? ` · ${t("me_buio_da_a", { a: ora(a), b: ora(b) })}` : ""),
        el("p", { class: "gas-me-riga2" }, scoperta ? t("me_non_copre") : buone ? [el("b", null, t("me_ore_buone", { n: buone })),
          !fin ? "" : meglio.length === buone ? " " + t("me_finestra", fin) : meglio.length > 1 ? ", " + t("me_di_fila", Object.assign({ n: meglio.length }, fin)) : ""]
          : el("b", null, t("me_nessuna")), !scoperta && media != null ? ` · ${t("me_nuvole_medie", { p: num(media) })}` : ""),
        sulle.length ? el("p", { class: "gas-me-riga3" }, iconaLuna(fase), " ", sulle.join(" · ")) : null)),
    tuono ? el("p", { class: "gas-me-avviso gas-me-avviso--forte" }, "⚡ ", t("me_temporali", { o: ora(tuono.t) })) : null,
    bagnato && !tuono ? el("p", { class: "gas-me-avviso" }, bagnato.neve ? "❄ " : "🌧 ", t(bagnato.neve ? "me_neve_da" : "me_pioggia_da", { o: ora(bagnato.t) })) : null,
    umido ? el("p", { class: "gas-me-avviso" }, "💧 ", t("me_condensa", { o: ora(umido.t) }), " ",
      el("a", { href: urlCollezione("alimentatori-e-batterie"), target: "_blank", rel: "noopener" }, t("me_anticondensa"))) : null,
    ventoso ? el("p", { class: "gas-me-avviso" }, "💨 ", t("me_vento", { o: ora(ventoso.t) })) : null);
}
function cartaOraria(ore, agg) {
  const lista = ore.slice(0, 60);
  const rgbNuv = p => { const f = clamp((p ?? 0) / 100, 0, 1); return [Math.round(18 + f * 190), Math.round(48 + f * 160), Math.round(92 + f * 125)]; };
  const colNuv = p => `rgb(${rgbNuv(p).join(",")})`;
  const lin = v => { v /= 255; return v <= 0.03928 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4; };
  const testoNuv = p => { const [r, g, b] = rgbNuv(p); return 0.2126 * lin(r) + 0.7152 * lin(g) + 0.0722 * lin(b) > 0.179 ? "#000" : "#fff"; };
  const cella = (testo, stile, cl) => el("td", { class: cl || "", style: stile || null }, testo);
  const SEGNO = { si: "✓", forse: "~", no: "✕" };
  const giudizio = c => el("td", { class: "gas-me-v gas-me-forte gas-me-v--" + c, style: { color: "#000" }, title: t("me_v_" + c), "aria-label": t("me_v_" + c) },
    el("span", { "aria-hidden": "true" }, SEGNO[c]));
  const righe = [
    [t("me_giudizio"), x => x.voto == null ? cella("", null, "gas-me-v gas-me-v--giorno") : giudizio(classeVoto(x.voto))],
    [t("me_nuvole"), x => cella(num(x.nuv), { background: colNuv(x.nuv), color: testoNuv(x.nuv) }, "gas-me-forte")],
    [`· ${t("me_basse")}`, x => cella(num(x.basse), { background: colNuv(x.basse), color: testoNuv(x.basse) })],
    [`· ${t("me_medie")}`, x => cella(num(x.medie), { background: colNuv(x.medie), color: testoNuv(x.medie) })],
    [`· ${t("me_alte")}`, x => cella(num(x.alte), { background: colNuv(x.alte), color: testoNuv(x.alte) })],
    [t("me_nebbia"), x => cella(x.nebbia > 0.5 ? num(x.nebbia) : "", x.nebbia > 5 ? { background: "#8d98a8", color: "#14223a" } : null)],
    [`${t("me_pioggia")} mm`, x => cella(x.pioggia > 0.05 ? num(x.pioggia, 1) : "", x.pioggia > 0.05 ? { background: `rgba(70,140,255,${clamp(0.25 + x.pioggia / 4, 0.25, 0.7)})` } : null)],
    [t("me_temporale"), x => cella(x.temporale ? "⚡" : "", x.temporale ? { background: "#f2c14e", color: "#14223a" } : null, x.temporale ? "gas-me-forte" : "")],
    [`${t("me_umidita")} %`, x => cella(num(x.um), null, x.um > 92 ? "gas-me-attento" : "")],
    [`${t("me_rugiada")} °`, x => { const d = x.temp - x.rug; return cella(num(d, 1), null, d < 2 ? "gas-me-male" : d < 4 ? "gas-me-attento" : ""); }],
    [`${t("me_temp")} °C`, x => cella(num(x.temp))],
    [`${t("me_vento_r")} km/h`, x => cella(num(x.vento), null, x.vento > 40 ? "gas-me-male" : x.vento > 25 ? "gas-me-attento" : "")],
    [t("me_buio"), x => cella("", { background: coloreCielo(x.hs) })],
    [t("me_luna"), x => cella(x.hl > 0 ? `${num(x.k * 100)}` : "", x.hl > 0 ? { color: "#f1ead6" } : null, x.hl > 0 ? "gas-me-luna" : "")],
  ];
  const giorni = [];
  for (const x of lista) { const g = giorno(x.t); if (!giorni.length || giorni[giorni.length - 1].g !== g) giorni.push({ g, n: 0 }); giorni[giorni.length - 1].n++; }
  const tab = el("table", { class: "gas-me-tab" },
    el("thead", null,
      el("tr", null, el("th", { class: "gas-me-fissa" }, ""), giorni.map(g => el("th", { colspan: g.n, class: "gas-me-giorno" }, g.n >= 3 ? g.g : ""))),
      el("tr", null, el("th", { class: "gas-me-fissa" }, t("me_ora")), lista.map(x => el("th", { class: x.hs < -12 ? "gas-me-notte" : "" }, String(x.t.getHours()).padStart(2, "0"))))),
    el("tbody", null, righe.map(([nome, f]) => el("tr", null, el("th", { class: "gas-me-fissa" }, nome), lista.map(f)))));
  const quando = !agg || isNaN(agg) ? "" : isoData(agg) === isoData(new Date()) ? t("me_agg", { o: ora(agg) }) : t("me_agg_giorno", { g: giorno(agg), o: ora(agg) });
  return scheda(null, el("div", { class: "gas-me-scorre" }, tab), el("p", { class: "gas-nota" }, t("me_legenda"), " ", t("me_legenda_tuoni"),
    quando ? [" ", el("small", null, `(${quando})`)] : null));
}
function cartaNotti(dati, lat, lon) {
  const oggi = dataNotteMeteo(lat, lon, true), righe = [];
  const quante = clamp(Math.round((dataNotteMeteo(lat, lon) - oggi) / 864e5) + 1, 7, 10);
  for (let d = 0; d < quante; d++) {
    const g = new Date(oggi.getFullYear(), oggi.getMonth(), oggi.getDate() + d, 12), nt = Astro.notte(g, lat, lon, 20), ev = nt.ev;
    const a = ev.astroFine || ev.nauticoFine, b = ev.astroInizio || ev.nauticoInizio;
    if (!a || !b) continue;
    let dentro = dati.filter(x => x.t >= a && x.t <= b);
    if (!dentro.length) {
      const mezzo = new Date((a.getTime() + b.getTime()) / 2);
      const vicino = dati.reduce((m, x) => (!m || Math.abs(x.t - mezzo) < Math.abs(m.t - mezzo) ? x : m), null);
      if (vicino && Math.abs(vicino.t - mezzo) < 4 * 3600e3) dentro = [vicino];
    }
    if (!dentro.length) continue;
    const media = dentro.reduce((s, x) => s + (x.nuv ?? 0), 0) / dentro.length;
    const pioggia = dentro.some(x => (x.pioggia ?? 0) > 0.1), tuoni = dentro.some(x => x.temporale);
    const cl = tuoni ? ["no", "me_temporali_notte"] : pioggia ? ["no", "me_piovosa"]
      : [classeVoto(100 - media), media > 75 ? "me_coperto" : media > 50 ? "me_nuvoloso" : media > 25 ? "me_poco" : "me_sereno"];
    righe.push(el("li", { class: "gas-me-notte-riga" },
      el("i", { class: "gas-me-semaforo gas-me-semaforo--" + cl[0] }),
      el("b", null, giorno(g)),
      el("span", { class: "gas-me-barra" }, el("i", { style: { width: `${clamp(media, 2, 100)}%` } })),
      el("span", null, `${num(media)} % · ${tuoni ? "⚡ " : pioggia ? "🌧 " : ""}${t(cl[1])}`),
      el("span", { class: "gas-me-lunina" }, iconaLuna(nt.fase), ` ${num(nt.fase.k * 100)} %`)));
  }
  return scheda(t("me_notti"), el("p", { class: "gas-nota" }, t("me_notti_n")), el("ul", { class: "gas-me-notti" }, righe));
}
Object.assign(TESTI.it, { me_cielo_ora: "Nuvole e pioggia", me_cielo_ora_n: "Le ultime 3 ore, ogni 10 minuti: il satellite all'infrarosso (le nuvole si vedono anche di notte: più chiare = più alte e fredde) con il radar della pioggia e i temporali. Poi la previsione ora per ora. Tocca ▶ Riproduci per vedere come si muovono. Il punto oro è il tuo luogo.",
  me_t_sat: "Satellite delle {o}", me_t_radar: "radar degli ultimi minuti", me_t_prev: "Previsione per {g} alle {o}", me_adesso: "Adesso", me_play: "Riproduci", me_pausa: "Pausa",
  me_prev_carico: "Carico la previsione di nuvole e pioggia…", me_prev_errore: "La previsione delle nuvole non è arrivata.", me_sat_errore: "L'immagine del satellite adesso non arriva: riprova tra qualche minuto.",
  me_prev_n: "Dopo «Adesso» è una previsione: la pioggia dal modello ICON-EU del servizio meteo tedesco (un punto ogni 7 km), le nuvole e i temporali da MET Norway (un punto ogni 100 km circa: le nuvole piccole non si vedono).",
  me_badge_prev: "Previsione",
  me_prev_qui: "Sul tuo luogo: nuvole {p} % (basse {b} · medie {m} · alte {a}) · pioggia {r} mm", me_indietro: "Un passo indietro", me_avanti: "Un passo avanti" });
Object.assign(TESTI.de, { me_cielo_ora: "Wolken und Regen", me_cielo_ora_n: "Die letzten 3 Stunden alle 10 Minuten: das Infrarot-Satellitenbild (Wolken auch nachts sichtbar: heller = höher und kälter) mit Regenradar und Gewittern. Dann die Vorhersage Stunde für Stunde. Tippen Sie auf ▶ Abspielen, um zu sehen, wie sie ziehen. Der goldene Punkt ist Ihr Ort.",
  me_t_sat: "Satellitenbild von {o} Uhr", me_t_radar: "Radar der letzten Minuten", me_t_prev: "Vorhersage für {g}, {o} Uhr", me_adesso: "Jetzt", me_play: "Abspielen", me_pausa: "Pause",
  me_prev_carico: "Vorhersage für Wolken und Regen wird geladen…", me_prev_errore: "Die Wolkenvorhersage ist nicht angekommen.", me_sat_errore: "Das Satellitenbild kommt gerade nicht an: in ein paar Minuten erneut versuchen.",
  me_prev_n: "Nach „Jetzt“ ist es eine Vorhersage: der Regen aus dem Modell ICON-EU des Deutschen Wetterdienstes (alle 7 km), Wolken und Gewitter von MET Norway (etwa alle 100 km: kleine Wolken fehlen).",
  me_badge_prev: "Vorhersage",
  me_prev_qui: "An Ihrem Ort: Wolken {p} % (tief {b} · mittel {m} · hoch {a}) · Regen {r} mm", me_indietro: "Einen Schritt zurück", me_avanti: "Einen Schritt vor" });
Object.assign(TESTI.es, { me_cielo_ora: "Nubes y lluvia", me_cielo_ora_n: "Las últimas 3 horas, cada 10 minutos: el satélite infrarrojo (las nubes se ven también de noche: más claras = más altas y frías) con el radar de lluvia y las tormentas. Luego la previsión hora a hora. Toca ▶ Reproducir para ver cómo se mueven. El punto dorado es tu lugar.",
  me_t_sat: "Satélite de las {o}", me_t_radar: "radar de los últimos minutos", me_t_prev: "Previsión para el {g} a las {o}", me_adesso: "Ahora", me_play: "Reproducir", me_pausa: "Pausa",
  me_prev_carico: "Cargando la previsión de nubes y lluvia…", me_prev_errore: "La previsión de nubes no ha llegado.", me_sat_errore: "La imagen del satélite no llega ahora: vuelve a intentarlo en unos minutos.",
  me_prev_n: "Lo que viene después de «Ahora» es una previsión: la lluvia del modelo ICON-EU del servicio meteorológico alemán (un punto cada 7 km), las nubes y las tormentas de MET Norway (un punto cada 100 km aprox.: las nubes pequeñas no se ven).",
  me_badge_prev: "Previsión",
  me_prev_qui: "En tu lugar: nubes {p} % (bajas {b} · medias {m} · altas {a}) · lluvia {r} mm", me_indietro: "Un paso atrás", me_avanti: "Un paso adelante" });
let _ultimoSat = null;
function ultimoSatellite() {
  if (_ultimoSat && Date.now() - _ultimoSat.quando < 10 * 60000) return _ultimoSat.p;
  const p = fetch("https://view.eumetsat.int/geoserver/mtg_fd/ir105_hrfi/ows?service=WMS&request=GetCapabilities&version=1.3.0", { credentials: "omit" })
    .then(r => r.text()).then(s => { const m = /<Dimension name="time"[^>]*default="([^"]+)"/.exec(s); if (!m) throw new Error("time"); return new Date(m[1]); })
    .catch(() => { const d = new Date(Date.now() - 20 * 60000); d.setUTCMinutes(Math.floor(d.getUTCMinutes() / 10) * 10, 0, 0); return d; });
  _ultimoSat = { p, quando: Date.now() };
  return p;
}
const RADAR_ARCHIVIO = "/apps/strumenti/radar/";
let _elencoRadar = null;
function elencoRadar() {
  if (_elencoRadar && Date.now() - _elencoRadar.quando < 2 * 60000) return _elencoRadar.p;
  const p = fetch(RADAR_ARCHIVIO + "elenco", { credentials: "same-origin" })
    .then(r => (r.ok ? r.json() : { momenti: [] }))
    .then(j => new Map((j.momenti || []).filter(x => x.vmi > 0).map(x => [x.t, x])))
    .catch(() => new Map());
  _elencoRadar = { p, quando: Date.now() };
  return p;
}
const momentoRadar = d => d.toISOString().slice(0, 16).replace(/[-T:]/g, "");
const _pacchettiRadar = new Map();
function pacchettoRadar(d, tx, ty) {
  const t = momentoRadar(d), k = `${t}/${tx}/${ty}`;
  if (!_pacchettiRadar.has(k)) {
    const p = elencoRadar().then(lista => {
      if (!lista.has(t)) { _pacchettiRadar.delete(k); return null; }
      return fetch(RADAR_ARCHIVIO + k, { credentials: "same-origin" }).then(r => { if (!r.ok) throw new Error("radar " + r.status); return r.json(); });
    });
    p.catch(() => _pacchettiRadar.delete(k));
    _pacchettiRadar.set(k, p);
    if (_pacchettiRadar.size > 60) _pacchettiRadar.delete(_pacchettiRadar.keys().next().value);
  }
  return _pacchettiRadar.get(k).catch(() => null);
}
const _griglie = new Map();
const GRIGLIA_PASSO = 1;
function grigliaNuvole(lat0, lat1, lon0, lon1) {
  const P = GRIGLIA_PASSO, lats = [], lons = [];
  for (let a = Math.floor(lat0 / P) * P; a <= Math.ceil(lat1 / P) * P; a += P) lats.push(a);
  for (let o = Math.floor(lon0 / P) * P; o <= Math.ceil(lon1 / P) * P; o += P) lons.push(o);
  const chiave = `${lats[0]},${lons[0]},${lats.length}x${lons.length}`, c = _griglie.get(chiave);
  if (c && Date.now() - c.quando < 30 * 60000) return c.p;
  const punti = [];
  lats.forEach((a, i) => lons.forEach((o, j) => punti.push({ a, o, i, j })));
  const val = new Map();
  let prossimo = 0, persi = 0;
  const chiedi = async pt => {
    for (let prova = 0; prova < 2; prova++) {
      try {
        const r = await fetch(`https://api.met.no/weatherapi/locationforecast/2.0/compact?lat=${pt.a}&lon=${pt.o}`, { credentials: "omit" });
        if (r.ok) return await r.json();
      } catch (e) {   }
      await new Promise(ok => setTimeout(ok, 800));
    }
    return null;
  };
  const lavora = async () => {
    while (prossimo < punti.length) {
      const pt = punti[prossimo++], j = await chiedi(pt);
      if (!j) { persi++; continue; }
      for (const x of j.properties.timeseries) {
        if (!x.data.next_1_hours) continue;
        const k = x.time.slice(0, 13);
        if (!val.has(k)) val.set(k, lats.map(() => lons.map(() => null)));
        const d1 = x.data.next_1_hours;
        val.get(k)[pt.i][pt.j] = { c: x.data.instant.details.cloud_area_fraction, p: (d1.details && d1.details.precipitation_amount) || 0,
          t: /thunder/.test((d1.summary && d1.summary.symbol_code) || "") };
      }
    }
  };
  const p = Promise.all([...Array(Math.min(4, punti.length))].map(lavora)).then(() => {
    if (persi > punti.length * 0.3) throw new Error("MET: mancano " + persi + " punti");
    return { lats, lons, passo: P, val };
  });
  p.catch(() => _griglie.delete(chiave));
  _griglie.set(chiave, { p, quando: Date.now() });
  return p;
}
const _pioggiaDwd = new Map();
function pioggiaDwd(d, lat0, lat1, lon0, lon1) {
  const fine = new Date(Math.floor(d.getTime() / 3600e3) * 3600e3 + 3600e3).toISOString().replace(/\.\d+Z$/, ".000Z");
  const b = [lat0 - 0.1, lat1 + 0.1, lon0 - 0.1, lon1 + 0.1].map(x => x.toFixed(2)), k = fine + "|" + b.join(",");
  if (!_pioggiaDwd.has(k)) {
    const u = "https://maps.dwd.de/geoserver/dwd/wcs?service=WCS&request=GetCoverage&version=2.0.1&coverageId=dwd__Icon-eu_reg00625_fd_sl_TOTPREC01H" +
      `&subset=Lat(${b[0]},${b[1]})&subset=Long(${b[2]},${b[3]})&subset=time("${fine}")&format=text/plain`;
    const p = fetch(u, { credentials: "omit" }).then(r => { if (!r.ok) throw new Error("DWD " + r.status); return r.text(); }).then(leggiGrigliaDwd);
    p.catch(() => _pioggiaDwd.delete(k));
    _pioggiaDwd.set(k, p);
    if (_pioggiaDwd.size > 48) _pioggiaDwd.delete(_pioggiaDwd.keys().next().value);
  }
  return _pioggiaDwd.get(k);
}
function leggiGrigliaDwd(s) {
  const m = /GeneralBounds\[\(([-\d.]+),\s*([-\d.]+)\),\s*\(([-\d.]+),\s*([-\d.]+)\)\]/.exec(s), i = s.indexOf("Band 0:");
  if (!m || i < 0) throw new Error("DWD: formato");
  const v = s.slice(i + 7).trim().split("\n").map(r => r.trim().split(/\s+/).map(Number)).filter(r => r.length > 1);
  const ny = v.length, nx = ny ? v[0].length : 0;
  if (!ny || nx < 2 || v.some(r => r.length !== nx)) throw new Error("DWD: righe");
  return { lonW: +m[1], latS: +m[2], lonE: +m[3], latN: +m[4], nx, ny, v };
}
function cartaCieloOra(lat, lon, ore) {
  const R = 6378137, PI = Math.PI, z = 7, m = 2 * PI * R / (1 << z);
  const mx = lon * RAD * R, my = R * Math.log(Math.tan(PI / 4 + lat * RAD / 2));
  const tx = Math.floor((mx + PI * R) / m), ty = Math.floor((PI * R - my) / m);
  const x0 = (tx - 1) * m - PI * R, x1 = (tx + 2) * m - PI * R, y1 = PI * R - (ty - 1) * m, y0 = PI * R - (ty + 2) * m;
  const lonDi = x => x / R * DEG, latDi = y => (2 * Math.atan(Math.exp(y / R)) - PI / 2) * DEG;
  const bbox = `&bbox=${x0.toFixed(1)},${y0.toFixed(1)},${x1.toFixed(1)},${y1.toFixed(1)}`;
  const wms = (layer, extra) => `https://view.eumetsat.int/geoserver/ows?service=WMS&request=GetMap&version=1.3.0&layers=${layer}&styles=&crs=EPSG:3857${bbox}&width=768&height=768${extra}`;
  const urlSat = (d, riserva) => wms(riserva ? "msg_fes:ir108" : "mtg_fd:ir105_hrfi",
    `&format=image/jpeg&time=${(riserva ? new Date(Math.floor(d.getTime() / 900000) * 900000) : d).toISOString().replace(".000", "")}`);
  const sat = el("img", { class: "gas-me-strato", alt: "", width: 768, height: 768,
    onload: e => { e.target.style.visibility = ""; if (stato.dataset.sat) { stato.hidden = true; delete stato.dataset.sat; } },
    onerror: e => {
      if (!e.target.dataset.riserva && e.target.dataset.quando) { e.target.dataset.riserva = "1"; e.target.src = urlSat(new Date(e.target.dataset.quando), true); return; }
      e.target.style.visibility = "hidden";
      if (!sat.hidden) { stato.textContent = t("me_sat_errore"); stato.dataset.sat = "1"; stato.hidden = false; }
    } });
  const coste = el("img", { class: "gas-me-strato", src: wms("backgrounds:ne_10m_coastline,backgrounds:ne_boundary_lines_land", "&format=image/png&transparent=true"), alt: "", width: 768, height: 768, loading: "lazy",
    onerror: e => { e.target.style.visibility = "hidden"; } });
  const inItalia = lat > 35 && lat < 48 && lon > 5.5 && lon < 19.5;
  const o0 = new Date(), v = `${o0.getUTCFullYear()}${o0.getUTCMonth() + 1}${o0.getUTCDate()}${o0.getUTCHours()}${Math.floor(o0.getUTCMinutes() / 10)}`;
  const tasselli = (div, strato) => {
    if (inItalia) for (let j = -1; j <= 1; j++) for (let i = -1; i <= 1; i++) {
      const a = (tx + i) * m - PI * R, b = PI * R - (ty + j + 1) * m;
      const vivo = `https://radar-geowebcache.protezionecivile.it/service/wms?service=WMS&request=GetMap&layers=radar:${strato}&styles=&format=image/png&transparent=true` +
        `&version=1.1.1&tiled=true&width=256&height=256&srs=EPSG:3857&bbox=${a},${b},${a + m},${b + m}&v=${v}`;
      div.appendChild(el("img", { src: vivo, alt: "", width: 256, height: 256, loading: "lazy", dataset: { vivo, k: `${tx + i}_${ty + j}` },
        onerror: e => { e.target.style.visibility = "hidden"; } }));
    }
    return div;
  };
  const radar = tasselli(el("div", { class: "gas-me-strato gas-me-radar" }), "vmi");
  const temporali = tasselli(el("div", { class: "gas-me-strato gas-me-radar" }), "hrd");
  const TRASPARENTE = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
  const mettiTasselli = (div, dati) => {
    for (const im of div.children) {
      const b = dati && dati[im.dataset.k], src = !dati ? im.dataset.vivo : b ? "data:image/png;base64," + b : TRASPARENTE;
      if (im.src !== src) { im.style.visibility = ""; im.src = src; }
    }
  };
  const urlFulmini = d => `https://view.eumetsat.int/geoserver/ows?service=WMS&request=GetMap&version=1.3.0&layers=mtg_fd:li_afa&styles=mtg_li_afa&crs=EPSG:3857${bbox}` +
    `&width=768&height=768&format=image/png&transparent=true&time=${d.toISOString().replace(".000", "")}`;
  const fulmini = el("img", { class: "gas-me-strato gas-me-fulmini", alt: "", width: 768, height: 768,
    onload: e => { e.target.style.visibility = ""; }, onerror: e => { e.target.style.visibility = "hidden"; } });
  const nuvole = el("canvas", { class: "gas-me-strato gas-me-nuvole", width: 128, height: 128, hidden: true });
  const pioggiaPrev = el("canvas", { class: "gas-me-strato gas-me-pioggia", width: 288, height: 288, hidden: true });
  const tuoni = el("div", { class: "gas-me-strato gas-me-tuoni", hidden: true });
  const etichetta = el("span", { class: "gas-me-badge", hidden: true }, t("me_badge_prev"));
  const px = (mx - x0) / (x1 - x0) * 100, py = (y1 - my) / (y1 - y0) * 100;
  const punto = el("i", { class: "gas-me-punto", style: { left: px + "%", top: py + "%" } });
  const stato = el("div", { class: "gas-me-stato", hidden: true });
  const scatola = el("div", { class: "gas-me-mappa" }, sat, radar, temporali, nuvole, pioggiaPrev, coste, fulmini, tuoni, punto, etichetta, stato);
  const quando = el("p", { class: "gas-me-quando" }), qui = el("p", { class: "gas-me-qui" });
  const PASSI = 18;
  const futuro = (ore || []).filter(x => x.t.getTime() > Date.now()).slice(0, 36);
  let pos = [], i0 = PASSI, giro = 0;
  const cursore = el("input", { type: "range", class: "gas-range gas-me-cursore", min: 0, max: PASSI + futuro.length, step: 1, value: PASSI, "aria-label": t("me_cielo_ora") });
  const giornoBreve = d => d.toLocaleDateString(LOCALE, { weekday: "short" });
  const mostra = async k => {
    const p = pos[k], mio = ++giro;
    if (!p) return;
    cursore.value = k;
    scatola.classList.toggle("gas-me-mappa--prev", !p.sat);
    etichetta.hidden = !!p.sat;
    if (p.sat) {
      nuvole.hidden = true; stato.hidden = true; delete stato.dataset.sat; sat.hidden = !interruttori.sat.on; qui.hidden = true;
      pioggiaPrev.hidden = true; tuoni.hidden = true;
      sat.dataset.quando = p.t.toISOString(); delete sat.dataset.riserva;
      sat.src = urlSat(p.t);
      fulmini.hidden = !interruttori.fulmini.on;
      if (!fulmini.hidden) fulmini.src = urlFulmini(p.t);
      const acceso = nome => !!(interruttori[nome] && interruttori[nome].on);
      if (!inItalia) { radar.hidden = true; temporali.hidden = true; quando.textContent = t("me_t_sat", { o: ora(p.t) }); return; }
      if (k === i0) {
        mettiTasselli(radar, null); mettiTasselli(temporali, null);
        radar.hidden = !acceso("radar"); temporali.hidden = !acceso("temporali");
        quando.textContent = t("me_t_sat", { o: ora(p.t) }) + " · " + t("me_t_radar");
        return;
      }
      radar.hidden = true; temporali.hidden = true;
      quando.textContent = t("me_t_sat", { o: ora(p.t) }) + " · " + t("me_t_radar_carico");
      const pk = await pacchettoRadar(p.t, tx, ty);
      if (mio !== giro) return;
      if (!pk) { quando.textContent = t("me_t_sat", { o: ora(p.t) }) + " · " + t("me_t_senza_radar"); return; }
      mettiTasselli(radar, pk.vmi || {}); mettiTasselli(temporali, pk.hrd || {});
      radar.hidden = !acceso("radar"); temporali.hidden = !acceso("temporali");
      quando.textContent = t("me_t_sat_radar", { o: ora(p.t) });
      return;
    }
    sat.hidden = true; radar.hidden = true; temporali.hidden = true; fulmini.hidden = true; delete stato.dataset.sat;
    pioggiaPrev.hidden = true; tuoni.hidden = true;
    quando.textContent = t("me_t_prev", { g: giornoBreve(p.t), o: ora(p.t) });
    const x = p.x;
    qui.hidden = false;
    svuota(qui).append(el("i", { class: "gas-me-semaforo gas-me-semaforo--" + classeVoto(x.voto == null ? votoOra(x) : x.voto) }), " ",
      t("me_prev_qui", { p: num(x.nuv ?? 0), b: num(x.basse ?? 0), m: num(x.medie ?? 0), a: num(x.alte ?? 0), r: num(x.pioggia ?? 0, 1) }));
    stato.textContent = t("me_prev_carico"); stato.hidden = false;
    const [g, gr] = await Promise.all([grigliaNuvole(latDi(y0), latDi(y1), lonDi(x0), lonDi(x1)).catch(() => null), pioggiaDelle(p.t).catch(() => null)]);
    if (mio !== giro) return;
    const campo = g && g.val.get(p.t.toISOString().slice(0, 13));
    if (!campo && !gr) { stato.textContent = t("me_prev_errore"); return; }
    stato.hidden = true;
    if (campo) { disegnaNuvole(campo, g); disegnaTuoni(campo, g); }
    nuvole.hidden = !campo;
    if (gr) disegnaPioggiaDwd(gr); else disegnaPioggia(campo, g);
    pioggiaPrev.hidden = !(!interruttori.radar || interruttori.radar.on);
    tuoni.hidden = !campo || !(!interruttori.temporali || interruttori.temporali.on);
  };
  const pioggiaDelle = d => pioggiaDwd(d, latDi(y0), latDi(y1), lonDi(x0), lonDi(x1));
  const valGriglia = (campo, g, chiave) => (i, j) => {
    const a = clamp(i, 0, g.lats.length - 1), b = clamp(j, 0, g.lons.length - 1), v0 = campo[a] && campo[a][b];
    if (v0) return v0[chiave] || 0;
    let somma = 0, n = 0;
    for (let di = -1; di <= 1; di++) for (let dj = -1; dj <= 1; dj++) { const w = campo[a + di] && campo[a + di][b + dj]; if (w) { somma += w[chiave] || 0; n++; } }
    return n ? somma / n : 0;
  };
  const disegnaNuvole = (campo, g) => {
    const c = nuvole.getContext("2d"), W = nuvole.width, H = nuvole.height, img = c.createImageData(W, H), val = valGriglia(campo, g, "c");
    for (let yy = 0; yy < H; yy++) {
      const la = latDi(y1 - (yy + 0.5) / H * (y1 - y0)), fi = (la - g.lats[0]) / g.passo, i = Math.floor(fi), di = fi - i;
      for (let xx = 0; xx < W; xx++) {
        const lo = lonDi(x0 + (xx + 0.5) / W * (x1 - x0)), fj = (lo - g.lons[0]) / g.passo, j = Math.floor(fj), dj = fj - j;
        const v1 = val(i, j) * (1 - dj) + val(i, j + 1) * dj, v2 = val(i + 1, j) * (1 - dj) + val(i + 1, j + 1) * dj;
        const cop = (v1 * (1 - di) + v2 * di) / 100, q = (yy * W + xx) * 4;
        img.data[q] = 226; img.data[q + 1] = 228; img.data[q + 2] = 231; img.data[q + 3] = Math.round(255 * Math.pow(cop, 1.2) * 0.9);
      }
    }
    c.putImageData(img, 0, 0);
  };
  const SCALA_PIOGGIA = [[0.1, [0, 250, 250]], [0.6, [0, 250, 125]], [1.5, [0, 250, 0]], [3, [250, 250, 0]], [8, [250, 125, 0]], [15, [250, 0, 0]], [30, [250, 0, 250]]];
  const colorePioggia = mm => {
    if (mm < 0.05) return null;
    if (mm < SCALA_PIOGGIA[0][0]) return SCALA_PIOGGIA[0][1];
    for (let k = 1; k < SCALA_PIOGGIA.length; k++) {
      const [a, ca] = SCALA_PIOGGIA[k - 1], [b, cb] = SCALA_PIOGGIA[k];
      if (mm <= b) { const f = (mm - a) / (b - a); return ca.map((v, z) => Math.round(v + (cb[z] - v) * f)); }
    }
    return SCALA_PIOGGIA[SCALA_PIOGGIA.length - 1][1];
  };
  const alfaPioggia = mm => Math.min(0.85, 0.3 + mm / 10) * clamp((mm - 0.05) / 0.35, 0, 1);
  const mettiPunto = (img, q, mm) => {
    const col = colorePioggia(mm);
    if (!col) return;
    img.data[q] = col[0]; img.data[q + 1] = col[1]; img.data[q + 2] = col[2]; img.data[q + 3] = Math.round(255 * alfaPioggia(mm));
  };
  const disegnaPioggiaDwd = gr => {
    const c = pioggiaPrev.getContext("2d"), W = pioggiaPrev.width, H = pioggiaPrev.height, img = c.createImageData(W, H);
    const dlon = (gr.lonE - gr.lonW) / gr.nx, dlat = (gr.latN - gr.latS) / gr.ny;
    const val = (j, i) => { const r = gr.v[clamp(j, 0, gr.ny - 1)], x = r[clamp(i, 0, gr.nx - 1)]; return x > 0 && x < 1e4 ? x : 0; };
    for (let yy = 0; yy < H; yy++) {
      const fj = (gr.latN - latDi(y1 - (yy + 0.5) / H * (y1 - y0))) / dlat - 0.5, j = Math.floor(fj), dj = fj - j;
      for (let xx = 0; xx < W; xx++) {
        const fi = (lonDi(x0 + (xx + 0.5) / W * (x1 - x0)) - gr.lonW) / dlon - 0.5, i = Math.floor(fi), di = fi - i;
        const mm = (val(j, i) * (1 - di) + val(j, i + 1) * di) * (1 - dj) + (val(j + 1, i) * (1 - di) + val(j + 1, i + 1) * di) * dj;
        mettiPunto(img, (yy * W + xx) * 4, mm);
      }
    }
    c.putImageData(img, 0, 0);
  };
  const disegnaPioggia = (campo, g) => {
    const c = pioggiaPrev.getContext("2d"), W = pioggiaPrev.width, H = pioggiaPrev.height, img = c.createImageData(W, H);
    if (campo) {
      const val = valGriglia(campo, g, "p");
      for (let yy = 0; yy < H; yy++) {
        const la = latDi(y1 - (yy + 0.5) / H * (y1 - y0)), fi = (la - g.lats[0]) / g.passo, i = Math.floor(fi), di = fi - i;
        for (let xx = 0; xx < W; xx++) {
          const lo = lonDi(x0 + (xx + 0.5) / W * (x1 - x0)), fj = (lo - g.lons[0]) / g.passo, j = Math.floor(fj), dj = fj - j;
          const v1 = val(i, j) * (1 - dj) + val(i, j + 1) * dj, v2 = val(i + 1, j) * (1 - dj) + val(i + 1, j + 1) * dj;
          mettiPunto(img, (yy * W + xx) * 4, v1 * (1 - di) + v2 * di);
        }
      }
    }
    c.putImageData(img, 0, 0);
  };
  const disegnaTuoni = (campo, g) => {
    svuota(tuoni);
    g.lats.forEach((la, i) => g.lons.forEach((lo, j) => {
      const v0 = campo[i] && campo[i][j];
      if (!v0 || !v0.t) return;
      const mxp = lo * RAD * R, myp = R * Math.log(Math.tan(PI / 4 + la * RAD / 2));
      const xp = (mxp - x0) / (x1 - x0) * 100, yp = (y1 - myp) / (y1 - y0) * 100;
      if (xp >= 0 && xp <= 100 && yp >= 0 && yp <= 100) tuoni.appendChild(el("span", { class: "gas-me-tuono", style: { left: xp + "%", top: yp + "%" }, "aria-hidden": "true" }, "⚡"));
    }));
  };
  let gioca = null;
  const pausa = ms => new Promise(ok => setTimeout(ok, ms));
  const caricaImg = src => new Promise(ok => { const im = new Image(); im.onload = im.onerror = () => ok(); im.src = src; });
  const pronti = new Map();
  const prepara = k => {
    const p = pos[k];
    if (!p) return Promise.resolve();
    if (!p.sat) {
      if (!pronti.has(k)) pronti.set(k, Promise.all([grigliaNuvole(latDi(y0), latDi(y1), lonDi(x0), lonDi(x1)).catch(() => 0), pioggiaDelle(p.t).catch(() => 0)]));
      return pronti.get(k);
    }
    if (!pronti.has(k)) pronti.set(k, Promise.all([interruttori.sat.on ? caricaImg(urlSat(p.t)) : 0,
      interruttori.fulmini.on ? caricaImg(urlFulmini(p.t)) : 0, inItalia && k !== i0 ? pacchettoRadar(p.t, tx, ty) : 0]));
    return pronti.get(k);
  };
  const ferma = () => { if (gioca) { gioca = null; play.textContent = "▶ " + t("me_play"); } };
  const avvia = async () => {
    const mio = gioca = {};
    play.textContent = "⏸ " + t("me_pausa");
    let k = +cursore.value;
    if (k === i0 || k >= pos.length - 1) {
      k = 0;
      await Promise.race([prepara(0), pausa(5000)]);
      if (gioca !== mio) return;
      mostra(0);
    }
    while (gioca === mio && k < pos.length - 1 && scatola.isConnected) {
      for (let q = k + 1; q <= Math.min(k + (k < i0 ? 6 : 3), pos.length - 1); q++) prepara(q);
      if (k === i0 - 3 && futuro.length) grigliaNuvole(latDi(y0), latDi(y1), lonDi(x0), lonDi(x1)).catch(() => {});
      await Promise.all([Promise.race([prepara(k + 1), pausa(5000)]), pausa(k === i0 ? 1500 : k < i0 ? 450 : 700)]);
      if (gioca !== mio) return;
      mostra(++k);
    }
    if (gioca === mio) ferma();
  };
  const play = el("button", { type: "button", class: "gas-btn gas-btn--chiaro gas-btn--mini", onclick: () => (gioca ? ferma() : avvia()) }, "▶ " + t("me_play"));
  cursore.addEventListener("input", () => { ferma(); mostra(+cursore.value); });
  const passo = d => el("button", { type: "button", class: "gas-btn gas-btn--chiaro gas-btn--mini gas-me-passo", title: t(d < 0 ? "me_indietro" : "me_avanti"),
    "aria-label": t(d < 0 ? "me_indietro" : "me_avanti"), onclick: () => { ferma(); mostra(clamp(+cursore.value + d, 0, pos.length - 1)); } }, d < 0 ? "‹" : "›");
  const adesso = el("button", { type: "button", class: "gas-btn gas-btn--chiaro gas-btn--mini", onclick: () => { ferma(); mostra(i0); } }, t("me_adesso"));
  const interruttori = {};
  const interr = (nome, testo, strato) => {
    const st = interruttori[nome] = { on: true };
    const b = el("button", { type: "button", class: "gas-btn gas-btn--chiaro gas-btn--mini gas-pl-int on", "aria-pressed": "true", onclick: () => {
      st.on = !st.on; b.classList.toggle("on", st.on); b.setAttribute("aria-pressed", String(st.on)); pronti.clear(); mostra(+cursore.value);
      if (nome === "coste") coste.hidden = !st.on;
    } }, testo);
    return b;
  };
  const tacche = el("div", { class: "gas-me-tacche" });
  ultimoSatellite().then(d => {
    pos = [...Array(PASSI + 1)].map((_, k) => ({ sat: true, t: new Date(d.getTime() - (PASSI - k) * 10 * 60000) })).concat(futuro.map(x => ({ t: x.t, x })));
    aggiungi(svuota(tacche), [el("span", null, ora(pos[0].t)), el("span", { class: "gas-me-tacca-ora" }, t("me_adesso")),
      futuro.length ? el("span", null, `${giornoBreve(futuro[futuro.length - 1].t)} ${ora(futuro[futuro.length - 1].t)}`) : null]);
    tacche.style.setProperty("--ora", (i0 / Math.max(1, pos.length - 1)).toFixed(3));
    mostra(i0);
    if (inItalia) elencoRadar();
  });
  return scheda(t("me_cielo_ora"), el("p", { class: "gas-nota" }, t("me_cielo_ora_n")), quando, scatola, qui,
    el("div", { class: "gas-me-tempo" }, passo(-1), cursore, passo(1)), tacche,
    el("div", { class: "gas-riga-bottoni gas-pl-comandi" }, play, adesso, interr("sat", t("me_satellite"), sat), inItalia ? interr("radar", t("me_radar"), radar) : null,
      inItalia ? interr("temporali", t("me_strato_temporali"), temporali) : null, interr("fulmini", t("me_fulmini"), fulmini),
      interr("coste", t("me_coste"), coste), inItalia ? null : el("small", { class: "gas-muto" }, t("me_radar_solo_it"))),
    el("div", { class: "gas-me-leg" },
      inItalia ? el("span", null, el("i", { class: "gas-me-leg-pioggia" }), t("me_leg_pioggia")) : null,
      inItalia ? el("span", null, el("i", { class: "gas-me-leg-temporali" }), t("me_leg_temporali")) : null,
      el("span", null, el("i", { class: "gas-me-leg-fulmini" }), t("me_leg_fulmini")),
      el("span", null, el("b", { class: "gas-me-leg-tuono", "aria-hidden": "true" }, "⚡"), t("me_leg_prev"))),
    el("p", { class: "gas-credits-mini" }, t("me_prev_n")),
    el("p", { class: "gas-credits-mini" }, t("me_fonti_mappa", { a: new Date().getFullYear() })));
}
function cartaAltriSiti(lat, lon) {
  const la = lat.toFixed(2), lo = lon.toFixed(2);
  const ns = `${Math.abs(lat).toFixed(3)}${lat >= 0 ? "N" : "S"}${Math.abs(lon).toFixed(3)}${lon >= 0 ? "E" : "W"}`;
  const link = (testo, url) => el("a", { class: "gas-btn gas-btn--chiaro gas-btn--mini", href: url, target: "_blank", rel: "noopener nofollow" }, testo + " ↗");
  return scheda([t("me_seeing"), " ", infoBtn("seeing")], el("p", { class: "gas-nota" }, t("me_seeing_n")),
    el("div", { class: "gas-riga-bottoni gas-pl-comandi" },
      link("Meteoblue · seeing", `https://www.meteoblue.com/${{ it: "it/tempo", de: "de/wetter", es: "es/tiempo", en: "en/weather" }[LINGUA] || "en/weather"}/outdoorsports/seeing/${ns}`),
      link("Clear Outside", `https://clearoutside.com/forecast/${la}/${lo}`),
      link(`Windy · ${t("me_nuvole")}`, `https://www.windy.com/?clouds,${la},${lo},8`),
      link("7Timer · astro", `https://www.7timer.info/bin/astro.php?lon=${lo}&lat=${la}&ac=0&lang=en&unit=metric&output=internal&tzshift=0`)));
}
Object.assign(TESTI.it, { me_temporali: "Temporali possibili dalle {o}: non lasciare fuori l'attrezzatura e stacca i cavi.", me_pioggia_da: "Pioggia prevista dalle {o}.",
  me_neve_da: "Neve prevista dalle {o}.", me_temporale: "Temporale", me_temporali_notte: "temporali", me_piovosa: "pioggia", me_legenda_tuoni: "⚡ = temporale." });
Object.assign(TESTI.de, { me_temporali: "Gewitter möglich ab {o}: Ausrüstung nicht draußen lassen und Kabel abziehen.", me_pioggia_da: "Regen erwartet ab {o}.",
  me_neve_da: "Schnee erwartet ab {o}.", me_temporale: "Gewitter", me_temporali_notte: "Gewitter", me_piovosa: "Regen", me_legenda_tuoni: "⚡ = Gewitter." });
Object.assign(TESTI.es, { me_temporali: "Posibles tormentas desde las {o}: no dejes el equipo fuera y desconecta los cables.", me_pioggia_da: "Lluvia prevista desde las {o}.",
  me_neve_da: "Nieve prevista desde las {o}.", me_temporale: "Tormenta", me_temporali_notte: "tormentas", me_piovosa: "lluvia", me_legenda_tuoni: "⚡ = tormenta." });
Object.assign(TESTI.en, { me_temporali: "Thunderstorms possible from {o}: don't leave your equipment outside and unplug the cables.", me_pioggia_da: "Rain expected from {o}.",
  me_neve_da: "Snow expected from {o}.", me_temporale: "Thunderstorm", me_temporali_notte: "thunderstorms", me_piovosa: "rain", me_legenda_tuoni: "⚡ = thunderstorm." });
Object.assign(TESTI.en, { me_sat_errore: "The satellite image isn't coming through right now: try again in a few minutes." });
Object.assign(TESTI.it, { me_fonti_mappa: "Satellite e fulmini: © EUMETSAT {a}, Meteosat MTG (EUMETView) · Radar della pioggia e temporali: Dipartimento della Protezione Civile (Radar-DPC, CC BY-SA 4.0) · Coste: Natural Earth · Nuvole previste: MET Norway (CC BY 4.0) · Pioggia prevista: Deutscher Wetterdienst, modello ICON-EU (CC BY 4.0, colori rielaborati)",
  me_fulmini: "Fulmini", me_strato_temporali: "Temporali", me_leg_pioggia: "Pioggia: celeste debole, verde e giallo moderata, arancio e rosso forte, viola fortissima (spesso grandine)",
  me_leg_temporali: "Temporali: le celle temporalesche segnalate dalla Protezione Civile (pioggia forte, grandine, raffiche)",
  me_leg_fulmini: "Fulmini visti dal satellite nei 5 minuti dell'ora mostrata: rosa pochi, viola tanti",
  me_t_sat_radar: "Satellite e radar delle {o}", me_t_radar_carico: "carico il radar…", me_t_senza_radar: "radar non disponibile per quest'ora",
  me_leg_prev: "Dopo «Adesso»: la pioggia prevista con gli stessi colori e ⚡ dove sono previsti temporali (indicativo)" });
Object.assign(TESTI.de, { me_fonti_mappa: "Satellit und Blitze: © EUMETSAT {a}, Meteosat MTG (EUMETView) · Regenradar und Gewitter: Italienischer Zivilschutz (Radar-DPC, CC BY-SA 4.0) · Küsten: Natural Earth · Wolkenvorhersage: MET Norway (CC BY 4.0) · Regenvorhersage: Deutscher Wetterdienst, Modell ICON-EU (CC BY 4.0, Farben bearbeitet)",
  me_fulmini: "Blitze", me_strato_temporali: "Gewitter", me_leg_pioggia: "Regen: hellblau schwach, grün und gelb mäßig, orange und rot stark, violett sehr stark (oft Hagel)",
  me_leg_temporali: "Gewitter: die vom italienischen Zivilschutz gemeldeten Gewitterzellen (Starkregen, Hagel, Böen)",
  me_leg_fulmini: "Blitze vom Satelliten in den 5 Minuten der gezeigten Zeit: rosa wenige, violett viele",
  me_t_sat_radar: "Satellit und Radar von {o} Uhr", me_t_radar_carico: "Radar wird geladen…", me_t_senza_radar: "kein Radar für diese Uhrzeit",
  me_leg_prev: "Nach „Jetzt“: der vorhergesagte Regen in denselben Farben und ⚡ wo Gewitter erwartet werden (ungefähr)" });
Object.assign(TESTI.es, { me_fonti_mappa: "Satélite y rayos: © EUMETSAT {a}, Meteosat MTG (EUMETView) · Radar de lluvia y tormentas: Protección Civil italiana (Radar-DPC, CC BY-SA 4.0) · Costas: Natural Earth · Nubes previstas: MET Norway (CC BY 4.0) · Lluvia prevista: Deutscher Wetterdienst, modelo ICON-EU (CC BY 4.0, colores reelaborados)",
  me_fulmini: "Rayos", me_strato_temporali: "Tormentas", me_leg_pioggia: "Lluvia: celeste débil, verde y amarillo moderada, naranja y rojo fuerte, violeta muy fuerte (a menudo granizo)",
  me_leg_temporali: "Tormentas: las células tormentosas señaladas por la Protección Civil italiana (lluvia fuerte, granizo, rachas)",
  me_leg_fulmini: "Rayos vistos desde el satélite en los 5 minutos de la hora mostrada: rosa pocos, violeta muchos",
  me_t_sat_radar: "Satélite y radar de las {o}", me_t_radar_carico: "cargando el radar…", me_t_senza_radar: "radar no disponible para esta hora",
  me_leg_prev: "Después de «Ahora»: la lluvia prevista con los mismos colores y ⚡ donde se prevén tormentas (orientativo)" });
Object.assign(TESTI.en, { me_fonti_mappa: "Satellite and lightning: © EUMETSAT {a}, Meteosat MTG (EUMETView) · Rain radar and storms: Italian Civil Protection Department (Radar-DPC, CC BY-SA 4.0) · Coastlines: Natural Earth · Cloud forecast: MET Norway (CC BY 4.0) · Rain forecast: Deutscher Wetterdienst, ICON-EU model (CC BY 4.0, colours adapted)",
  me_fulmini: "Lightning", me_strato_temporali: "Storms", me_leg_pioggia: "Rain: light blue = light, green and yellow = moderate, orange and red = heavy, purple = very heavy (often hail)",
  me_leg_temporali: "Storms: thunderstorm cells flagged by the Italian Civil Protection (heavy rain, hail, gusts)",
  me_leg_fulmini: "Lightning seen from the satellite in the 5 minutes of the time shown: pink = few, purple = many",
  me_t_sat_radar: "Satellite and radar at {o}", me_t_radar_carico: "loading the radar…", me_t_senza_radar: "no radar for this time",
  me_cielo_ora_n: "The last 3 hours, every 10 minutes: the infrared satellite (clouds show up even at night: brighter = higher and colder) with the rain radar and storms. Then the hour-by-hour forecast. Tap ▶ Play to see how they move. The gold dot is your location.",
  me_leg_prev: "After “Now”: forecast rain in the same colours and ⚡ where storms are expected (approximate)",
  me_prev_n: "After “Now” it's a forecast: rain from the German Weather Service's ICON-EU model (one point every 7 km), clouds and storms from MET Norway (one point every 100 km or so: small clouds don't show).",
  me_badge_prev: "Forecast", me_prev_carico: "Loading the cloud and rain forecast…" });
Object.assign(TESTI.it, { me_non_copre: "La previsione ora per ora non copre tutta questa notte: guarda «Le prossime notti» qui sotto.",
  me_di_fila: "{n} di fila dalle {a} alle {b}", me_agg_giorno: "aggiornata il {g} alle {o}", me_riprova: "Riprova",
  me_vecchia: "Questa previsione è del {g} alle {o}, non di adesso: quando hai la rete, riapri il Meteo per aggiornarla.",
  me_v_si: "ottimo per osservare", me_v_forse: "discreto", me_v_no: "non adatto" });
Object.assign(TESTI.de, { me_non_copre: "Die stündliche Vorhersage deckt diese Nacht nicht ganz ab: Sehen Sie unten bei „Die nächsten Nächte“ nach.",
  me_di_fila: "{n} am Stück von {a} bis {b}", me_agg_giorno: "aktualisiert am {g} um {o}", me_riprova: "Erneut versuchen",
  me_vecchia: "Diese Vorhersage ist vom {g}, {o} Uhr, nicht von jetzt: Öffnen Sie das Wetter erneut, sobald Sie Netz haben, um sie zu aktualisieren.",
  me_v_si: "sehr gut zum Beobachten", me_v_forse: "mittel", me_v_no: "nicht geeignet" });
Object.assign(TESTI.es, { me_non_copre: "La previsión hora a hora no cubre toda esta noche: mira «Las próximas noches» más abajo.",
  me_di_fila: "{n} seguidas de {a} a {b}", me_agg_giorno: "actualizada el {g} a las {o}", me_riprova: "Reintentar",
  me_vecchia: "Esta previsión es del {g} a las {o}, no de ahora: cuando tengas conexión, vuelve a abrir el Tiempo para actualizarla.",
  me_v_si: "muy bueno para observar", me_v_forse: "regular", me_v_no: "no apto" });
Object.assign(TESTI.en, { me_non_copre: "The hour-by-hour forecast doesn't cover all of this night: see “The next nights” below.",
  me_di_fila: "{n} in a row from {a} to {b}", me_agg_giorno: "updated {g} at {o}", me_riprova: "Try again",
  me_vecchia: "This forecast is from {g} at {o}, not from now: when you have a connection, open the Weather again to update it.",
  me_v_si: "excellent for observing", me_v_forse: "fair", me_v_no: "not suitable" });
Object.assign(TESTI.it, {
  tab_home: "Tutti gli strumenti", home_strumenti: "Strumenti", home_titolo: "Cosa vuoi fare?",
  home_campo: "Scegli telescopio e camera e guarda cosa entra nel sensore, su una foto vera del cielo.",
  home_stanotte: "Gli oggetti migliori di stanotte dal tuo luogo, con la Luna e il buio.",
  home_meteo: "Nuvole ora per ora, condensa e vento, satellite e radar.",
  home_planetario: "Tutto il cielo sopra di te, ora per ora, con pianeti e Luna.",
  home_lunasole: "Fasi lunari, notti buie del mese, alba, tramonto e crepuscoli.",
  home_camere: "Camere astronomiche, reflex e mirrorless a confronto.",
  home_calcolatori: "Per osservare e fotografare, per montatura e guida, cielo e meteo: con la tua attrezzatura e i prodotti del negozio.",
  home_software: "I programmi per acquisire ed elaborare, con i link ufficiali.",
  home_vivo_setup: "Il tuo setup: {s}", home_vivo_buio: "Buio vero dalle {a} alle {b}", home_vivo_meteo: "Stanotte {n} ore buone · nuvole {p} %",
  home_vivo_meteo_no: "Stanotte nessuna ora buona · nuvole {p} %", home_vivo_pianeti: "Alle 22: {p}", home_vivo_nessuno: "Nessun pianeta alto alle 22",
  home_vivo_camere: "{n} camere nel database", home_vivo_software: "Acquisizione, guida, elaborazione, planetari", home_vivo_calc: "{n} calcolatori pronti",
  home_chiudi: "Chiudi",
});
Object.assign(TESTI.de, {
  tab_home: "Alle Werkzeuge", home_strumenti: "Werkzeuge", home_titolo: "Was möchten Sie tun?",
  home_campo: "Teleskop und Kamera wählen und sehen, was auf den Sensor passt, auf einer echten Himmelsaufnahme.",
  home_stanotte: "Die besten Objekte heute Nacht von Ihrem Ort aus, mit Mond und Dunkelheit.",
  home_meteo: "Wolken Stunde für Stunde, Tau und Wind, Satellit und Radar.",
  home_planetario: "Der ganze Himmel über Ihnen, Stunde für Stunde, mit Planeten und Mond.",
  home_lunasole: "Mondphasen, dunkle Nächte des Monats, Sonnenauf- und -untergang, Dämmerung.",
  home_camere: "Astrokameras, Spiegelreflex- und spiegellose Kameras im Vergleich.",
  home_calcolatori: "Beobachten, Fotografieren, Montierung und Guiding, Himmel und Wetter: mit Ihrer Ausrüstung und den Produkten des Shops.",
  home_software: "Programme für Aufnahme und Bearbeitung, mit den offiziellen Links.",
  home_vivo_setup: "Ihre Ausrüstung: {s}", home_vivo_buio: "Echte Dunkelheit von {a} bis {b}", home_vivo_meteo: "Heute Nacht {n} gute Stunden · Wolken {p} %",
  home_vivo_meteo_no: "Heute Nacht keine gute Stunde · Wolken {p} %", home_vivo_pianeti: "Um 22 Uhr: {p}", home_vivo_nessuno: "Um 22 Uhr kein Planet hoch",
  home_vivo_camere: "{n} Kameras in der Datenbank", home_vivo_software: "Aufnahme, Guiding, Bearbeitung, Planetarium", home_vivo_calc: "{n} Rechner",
  home_chiudi: "Schließen",
});
Object.assign(TESTI.es, {
  tab_home: "Todas las herramientas", home_strumenti: "Herramientas", home_titolo: "¿Qué quieres hacer?",
  home_campo: "Elige telescopio y cámara y mira qué entra en el sensor, sobre una foto real del cielo.",
  home_stanotte: "Los mejores objetos de esta noche desde tu lugar, con la Luna y la oscuridad.",
  home_meteo: "Nubes hora a hora, rocío y viento, satélite y radar.",
  home_planetario: "Todo el cielo sobre ti, hora a hora, con planetas y Luna.",
  home_lunasole: "Fases lunares, noches oscuras del mes, salida y puesta del Sol, crepúsculos.",
  home_camere: "Comparativa de cámaras astronómicas, réflex y sin espejo.",
  home_calcolatori: "Para observar y fotografiar, para montura y guiado, cielo y tiempo: con tu equipo y los productos de la tienda.",
  home_software: "Los programas para capturar y procesar, con los enlaces oficiales.",
  home_vivo_setup: "Tu equipo: {s}", home_vivo_buio: "Oscuridad real de {a} a {b}", home_vivo_meteo: "Esta noche {n} horas buenas · nubes {p} %",
  home_vivo_meteo_no: "Esta noche ninguna hora buena · nubes {p} %", home_vivo_pianeti: "A las 22: {p}", home_vivo_nessuno: "Ningún planeta alto a las 22",
  home_vivo_camere: "{n} cámaras en la base de datos", home_vivo_software: "Captura, guiado, procesado, planetarios", home_vivo_calc: "{n} calculadoras",
  home_chiudi: "Cerrar",
});
Object.assign(GUIDA.it, { g_home: "Questa è la pagina degli strumenti di Giordano Astronomia. Ogni riquadro apre uno strumento. Il Campo inquadrato mostra cosa entra nel sensore del tuo setup. La scheda Stanotte mostra gli oggetti migliori della notte. Poi ci sono il meteo per astrofili, la carta del cielo, la Luna e il Sole, il database delle camere, i calcolatori e il software. Trovi anche la tua attrezzatura, il tuo diario del cielo e il quiz per scegliere telescopio, camera o montatura. In ogni scheda il bottone Come funziona ti spiega la pagina." });
Object.assign(GUIDA.de, { g_home: "Das ist die Seite mit den Werkzeugen von Giordano Astronomia. Jede Kachel öffnet ein Werkzeug. Das Bildfeld zeigt, was auf den Sensor Ihrer Ausrüstung passt. Heute Nacht zeigt die besten Objekte der Nacht. Dazu kommen das Wetter für Sternfreunde, die Sternkarte, Mond und Sonne, die Kameradatenbank, die Rechner und die Software. Sie finden auch Ihre Ausrüstung, Ihr Himmelstagebuch und das Quiz zur Wahl von Teleskop, Kamera oder Montierung. In jedem Bereich erklärt die Schaltfläche „So funktioniert's“ die Seite." });
Object.assign(GUIDA.es, { g_home: "Esta es la página de herramientas de Giordano Astronomia. Cada recuadro abre una herramienta: el campo de visión de tu equipo, qué fotografiar esta noche, el tiempo para astrónomos, la carta celeste, la Luna y el Sol, la base de datos de cámaras, las calculadoras y el software. También encontrarás tu equipo, tu diario del cielo y el test para elegir telescopio, cámara o montura. En cada sección el botón Cómo funciona te explica la página." });
const PAGINE_SCHEDE = { campo: "calcolatore-campo-inquadrato", stanotte: "cosa-fotografare-stanotte", meteo: "meteo-astronomico",
  planetario: "carta-del-cielo", lunasole: "fasi-lunari-luna-e-sole", camere: "database-camere-astronomiche", calcolatori: "calcolatori-astronomia",
  software: "software-astrofotografia", transiti: "transiti-iss" };
const PAGINA_HUB = "strumenti-astronomia";
function urlScheda(nome) { return `${RADICE_URL.replace(/\/?$/, "/")}pages/${PAGINE_SCHEDE[nome] || PAGINA_HUB}`; }
function schedaDellaPagina() {
  const h = (RADICE && RADICE.dataset.pagina) || "";
  return Object.keys(PAGINE_SCHEDE).find(k => PAGINE_SCHEDE[k] === h) || null;
}
let BV_ATTESA = false;
const bvAspetta = () => SYNC.stato === "?" && !ricorda("sync_visto", null) && !ricorda("benvenuto_ok", false);
function vistaHome(pannello) {
  if (NAV4) { vistaHome4(pannello); return; }
  svuota(pannello);
  const griglia = el("div", { class: "gas-home" });
  for (const [nome] of SCHEDE) {
    if (nome === "home" || nome === "scegli") continue;
    const vivo = el("span", { class: "gas-home-vivo" });
    griglia.appendChild(el("a", { class: "gas-home-carta gas-home-carta--" + nome, href: urlScheda(nome),
      onclick: e => { if (e.metaKey || e.ctrlKey || e.shiftKey) return; e.preventDefault(); vai(nome); } },
      el("span", { class: "gas-home-ico" }, icona(nome)),
      el("span", { class: "gas-home-testo" }, el("b", null, t("tab_" + nome)), el("span", { class: "gas-home-desc" }, t("home_" + nome)), vivo),
      el("span", { class: "gas-home-freccia", "aria-hidden": "true" }, "→")));
    try { infoViva(nome, vivo); } catch (e) {   }
  }
  BV_ATTESA = bvAspetta();
  const bv = BV_ATTESA ? null : cartaBenvenuto(() => vistaHome(pannello));
  aggiungi(pannello, [bv, bv || BV_ATTESA || cartaBenvenuto._chiuso ? null : cartaAppHome(() => vistaHome(pannello)), cartaTester(() => vistaHome(pannello)), cartaStasera(), bannerQuiz(),
    el("div", { class: "gas-home-testa" }, el("h2", { class: "gas-home-titolo" }, t("home_titolo")), typeof bottoneTour === "function" ? bottoneTour() : null), griglia,
    cartaAvvisi(), cartaSenzaRete(), ]);
}
Object.assign(TESTI.it, { leggi_tutto: "Leggi tutto ▾", leggi_meno: "Chiudi ▴" });
Object.assign(TESTI.de, { leggi_tutto: "Weiterlesen ▾", leggi_meno: "Weniger ▴" });
Object.assign(TESTI.es, { leggi_tutto: "Leer más ▾", leggi_meno: "Leer menos ▴" });
function eroeLeggiTutto() {
  const testo = document.querySelector(".gas-eroe-testo");
  if (!testo || testo.dataset.altro) return;
  testo.dataset.altro = "1";
  const b = el("button", { type: "button", class: "gas-eroe-altro", "aria-expanded": "false" }, t("leggi_tutto"));
  b.addEventListener("click", () => {
    const aperto = testo.classList.toggle("gas-eroe-testo--aperto");
    b.setAttribute("aria-expanded", String(aperto)); b.textContent = t(aperto ? "leggi_meno" : "leggi_tutto");
  });
  testo.after(b);
  const controlla = () => { b.hidden = !testo.classList.contains("gas-eroe-testo--aperto") && testo.scrollHeight <= testo.clientHeight + 2; };
  controlla();
  window.addEventListener("resize", debounce(controlla, 150));
  if (window.ResizeObserver) new ResizeObserver(debounce(controlla, 60)).observe(testo);
}
function infoViva(nome, box) {
  const { lat, lon } = NOTTE.luogo;
  const scrivi = (...x) => { svuota(box).append(...x); };
  if (nome === "campo") {
    const ap601 = x => !!x && /GIO-APO601/i.test(x.nome || "");
    const esempio = ap601(CAMPO.tel) && !ho("tel", CAMPO.tel) && !SETUP_ELENCO.some(s => ap601(s.tel));
    if (CAMPO.tel && (CAMPO.cam || CAMPO.oc)) { const s = nomeSetupAuto(setupAttuale()); scrivi(esempio ? t("pls_esempio", { n: s }) : t("home_vivo_setup", { s })); }
  } else if (nome === "stanotte" || nome === "lunasole") {
    const nt = Astro.notte(dataNotte(), lat, lon, 10), ev = nt.ev;
    if (nome === "stanotte" && ev.astroFine && ev.astroInizio) scrivi(t("home_vivo_buio", { a: ora(ev.astroFine), b: ora(ev.astroInizio) }));
    if (nome === "lunasole") scrivi(iconaLuna(nt.fase), ` ${nomeFase(nt.fase)} · ${num(nt.fase.k * 100)} %`);
  } else if (nome === "meteo") {
    const g = dataNotteMeteo(lat, lon);
    return previsione(lat, lon).then(dati => {
      const nt = Astro.notte(g, lat, lon, 10), ev = nt.ev;
      const a = ev.astroFine || ev.nauticoFine, b = ev.astroInizio || ev.nauticoInizio;
      if (!a || !b) return false;
      const ore = dati.filter(x => x.oraria && x.t >= new Date(a.getTime() - 1800e3) && x.t <= b);
      if (!ore.length) return false;
      const buone = ore.filter(x => votoOra(x) >= 75).length, media = ore.reduce((s, x) => s + (x.nuv ?? 0), 0) / ore.length;
      scrivi(el("i", { class: "gas-me-semaforo gas-me-semaforo--" + (buone >= 4 ? "si" : buone ? "forse" : "no") }), " ",
        t(buone ? "home_vivo_meteo" : "home_vivo_meteo_no", { n: buone, p: num(media) }));
      return true;
    }).catch(() => false);
  } else if (nome === "planetario") {
    const g = dataNotte(), j = Astro.jd(new Date(g.getFullYear(), g.getMonth(), g.getDate(), 22, 0)), lst = Astro.n360(Astro.gmst(j) + lon);
    const su = PIANETI.map(p => ({ p, pos: Astro.pianeta(p, j) })).filter(x => Astro.altezza(x.pos.ra, x.pos.dec, lat, lst) > 10 && x.pos.mag < 6.5)
      .sort((a, b) => a.pos.mag - b.pos.mag).map(x => t("pianeta_" + x.p));
    scrivi(su.length ? t("home_vivo_pianeti", { p: su.slice(0, 3).join(", ") }) : t("home_vivo_nessuno"));
  } else if (nome === "attrezzatura") scrivi(riepilogoAttrezzi());
  else if (nome === "camere") scrivi(t("home_vivo_camere", { n: num(DATI.camere.length) }));
  else if (nome === "calcolatori") scrivi(t("home_vivo_calc", { n: CALC_ELENCO.length }));
  else if (nome === "diario") { const m = messierVisti(); scrivi(t("dr_progresso", { n: m.v, f: m.f })); }
  else if (nome === "software") scrivi(t("home_vivo_software"));
  else if (nome === "scegli") scrivi(t("home_vivo_scegli"));
  else if (nome === "piano") {
    const n = (NOTTE.piano || []).length;
    scrivi(n ? t("home_vivo_piano", { n }) : t("home_vivo_piano_0"));
  } else if (nome === "eventi") {
    setTimeout(() => {
      try {
        const e = eventiCielo(lat, lon).find(x => x.visibile !== false);
        if (e && box.isConnected) scrivi(icona("calendario"), " ", t("home_vivo_eventi", { e: `${e.titolo} · ${e.giorno.toLocaleDateString(LOCALE, { day: "numeric", month: "short" })}` }));
      } catch (er) {   }
    }, 60);
  }
}
function bottoneStrumenti() {
  if (NAV4) return;
  const foglio = el("div", { class: "gas-foglio", hidden: true, role: "dialog", "aria-modal": "true", "aria-label": t("tab_home") });
  const chiudi = () => { foglio.hidden = true; document.documentElement.classList.remove("gas-foglio-su"); };
  const apri = () => {
    svuota(foglio).append(el("div", { class: "gas-foglio-box" },
      el("div", { class: "gas-foglio-testa" }, el("b", null, t("tab_home")),
        el("button", { type: "button", class: "gas-foglio-chiudi", "aria-label": t("home_chiudi"), onclick: chiudi }, icona("chiudi"))),
      el("div", { class: "gas-foglio-griglia" }, SCHEDE.map(([n]) => el("a", { href: n === "home" ? urlScheda("home") : urlScheda(n),
        class: "gas-foglio-voce" + (n === schedaAttiva ? " on" : ""), onclick: e => { e.preventDefault(); chiudi(); vai(n); } },
        icona(n), el("span", null, n === "home" ? t("home_strumenti") : t("tab_" + n)))))));
    foglio.hidden = false;
    document.documentElement.classList.add("gas-foglio-su");
  };
  foglio.addEventListener("click", e => { if (e.target === foglio) chiudi(); });
  document.addEventListener("keydown", e => { if (e.key === "Escape" && !foglio.hidden) chiudi(); });
  const b = el("button", { type: "button", class: "gas-galleggia", hidden: true, onclick: apri }, icona("home"), el("span", null, t("home_strumenti")));
  const dove = document.getElementById("gas-sfondo") || document.body;
  dove.append(foglio, b);
  const barra = $(".gas-schede", RADICE);
  if (window.IntersectionObserver && barra) {
    new IntersectionObserver(([e]) => { b.hidden = e.isIntersecting || e.boundingClientRect.top > 0; }, { threshold: 0 }).observe(barra);
  }
}
Object.assign(TESTI.it, {
  nv_transiti: "Transiti ISS", tab_transiti: "Transiti ISS", home_transiti: "La ISS davanti al Sole e alla Luna: dove andare e come verrà la foto.",
  nd_transiti: "La ISS e Tiangong davanti al Sole e alla Luna: dove andare, l'ora esatta al secondo e come verrà la tua foto.",
  vc_inizio: "Inizio", vc_notte: "Stanotte", vc_attrezzi: "Attrezzatura", vc_scelta: "Scegli", vc_diario: "Diario",
  vc_notte_n: "Cosa c'è in cielo stanotte dal tuo luogo e che tempo fa.",
  vc_attrezzi_n: "La tua attrezzatura, cosa inquadra e tutti i calcoli.",
  vc_scelta_n: "Il telescopio, la camera o la montatura giusti per te, e i programmi.",
  vc_diario_n: "Cosa vuoi vedere stanotte e cosa hai già visto e fotografato.",
  vc_aria: "Sezioni degli strumenti", vc_aria_str: "Strumenti della sezione {v}",
  nv_stanotte: "Cosa vedere", nv_lunasole: "Luna, Sole e pianeti", nv_eventi: "Eventi del cielo", nv_meteo: "Meteo", nv_planetario: "Carta del cielo",
  nv_attrezzatura: "La mia attrezzatura", nv_campo: "Campo inquadrato", nv_calcolatori: "Calcolatori",
  nv_scegli: "Quale scegliere?", nv_camere: "Camere", nv_software: "Software", nv_diario: "Il mio diario", nv_piano: "Il mio piano",
  tab_eventi: "Eventi del cielo", tab_piano: "Il mio piano",
  nd_stanotte: "Gli oggetti migliori di stanotte dal tuo luogo: a occhio nudo, col binocolo, al telescopio o in foto.",
  nd_lunasole: "La Luna, il Sole e i pianeti: fasi, orari, notti buie del mese e crepuscoli.",
  nd_eventi: "Meteore, comete, passaggi della ISS, aurore, eclissi e congiunzioni, da mettere nel calendario.",
  nd_meteo: "Nuvole ora per ora, condensa e vento, satellite e radar, e dove andare per un cielo più buio.",
  nd_piano: "Gli oggetti che vuoi vedere stanotte, in fila negli orari giusti.",
  home_vivo_piano: "{n} oggetti nel piano", home_vivo_piano_1: "Un oggetto nel piano", home_vivo_piano_0: "Ancora vuoto: aggiungi gli oggetti da «Cosa vedere»",
  home_vivo_eventi: "Prossimo: {e}", home_vivo_scegli: "Telescopio, camera o montatura",
  vc_nel_piano: "Nel tuo piano: {n} oggetti", vc_nel_piano_1: "Nel tuo piano: un oggetto", vc_apri_piano: "Apri il piano →",
  ns_cerca_vai_lsp: "Apri Luna, Sole e pianeti",
});
Object.assign(TESTI.de, {
  nv_transiti: "ISS-Transite", tab_transiti: "ISS-Transite", home_transiti: "Die ISS vor Sonne und Mond: wohin fahren und wie das Foto wird.",
  nd_transiti: "ISS und Tiangong vor Sonne und Mond: wohin fahren, sekundengenau wann und wie Ihr Foto wird.",
  vc_inizio: "Start", vc_notte: "Heute Nacht", vc_attrezzi: "Ausrüstung", vc_scelta: "Wählen", vc_diario: "Tagebuch",
  vc_notte_n: "Was heute Nacht von Ihrem Ort aus am Himmel steht und wie das Wetter wird.",
  vc_attrezzi_n: "Ihre Ausrüstung, was sie erfasst und alle Berechnungen.",
  vc_scelta_n: "Das passende Teleskop, die Kamera oder die Montierung für Sie, und die Programme.",
  vc_diario_n: "Was Sie heute Nacht sehen möchten und was Sie schon gesehen und fotografiert haben.",
  vc_aria: "Bereiche der Werkzeuge", vc_aria_str: "Werkzeuge im Bereich {v}",
  nv_stanotte: "Was sehen", nv_lunasole: "Mond, Sonne und Planeten", nv_eventi: "Himmelsereignisse", nv_meteo: "Wetter", nv_planetario: "Sternkarte",
  nv_attrezzatura: "Meine Ausrüstung", nv_campo: "Bildfeld", nv_calcolatori: "Rechner",
  nv_scegli: "Was wählen?", nv_camere: "Kameras", nv_software: "Software", nv_diario: "Mein Tagebuch", nv_piano: "Mein Plan",
  tab_eventi: "Himmelsereignisse", tab_piano: "Mein Plan",
  nd_stanotte: "Die besten Objekte heute Nacht von Ihrem Ort aus: mit bloßem Auge, Fernglas, Teleskop oder Kamera.",
  nd_lunasole: "Mond, Sonne und Planeten: Phasen, Zeiten, dunkle Nächte des Monats und Dämmerung.",
  nd_eventi: "Meteore, Kometen, ISS-Überflüge, Polarlichter, Finsternisse und Konjunktionen, für Ihren Kalender.",
  nd_meteo: "Wolken Stunde für Stunde, Tau und Wind, Satellit und Radar, und wohin für einen dunkleren Himmel.",
  nd_piano: "Die Objekte, die Sie heute Nacht sehen möchten, zu den richtigen Zeiten geordnet.",
  home_vivo_piano: "{n} Objekte im Plan", home_vivo_piano_1: "Ein Objekt im Plan", home_vivo_piano_0: "Noch leer: Objekte über „Was sehen“ hinzufügen",
  home_vivo_eventi: "Als Nächstes: {e}", home_vivo_scegli: "Teleskop, Kamera oder Montierung",
  vc_nel_piano: "In Ihrem Plan: {n} Objekte", vc_nel_piano_1: "In Ihrem Plan: ein Objekt", vc_apri_piano: "Plan öffnen →",
  ns_cerca_vai_lsp: "Mond, Sonne und Planeten öffnen",
});
Object.assign(TESTI.es, {
  nv_transiti: "Tránsitos ISS", tab_transiti: "Tránsitos ISS", home_transiti: "La ISS delante del Sol y la Luna: adónde ir y cómo saldrá la foto.",
  nd_transiti: "La ISS y Tiangong delante del Sol y la Luna: adónde ir, la hora exacta al segundo y cómo saldrá tu foto.",
  vc_inizio: "Inicio", vc_notte: "Esta noche", vc_attrezzi: "Equipo", vc_scelta: "Elegir", vc_diario: "Diario",
  vc_notte_n: "Qué hay en el cielo esta noche desde tu lugar y qué tiempo hará.",
  vc_attrezzi_n: "Tu equipo, qué encuadra y todos los cálculos.",
  vc_scelta_n: "El telescopio, la cámara o la montura adecuados para ti, y los programas.",
  vc_diario_n: "Qué quieres ver esta noche y qué has visto y fotografiado ya.",
  vc_aria: "Secciones de las herramientas", vc_aria_str: "Herramientas de la sección {v}",
  nv_stanotte: "Qué ver", nv_lunasole: "Luna, Sol y planetas", nv_eventi: "Eventos del cielo", nv_meteo: "Tiempo", nv_planetario: "Carta celeste",
  nv_attrezzatura: "Mi equipo", nv_campo: "Campo de visión", nv_calcolatori: "Calculadoras",
  nv_scegli: "¿Cuál elegir?", nv_camere: "Cámaras", nv_software: "Software", nv_diario: "Mi diario", nv_piano: "Mi plan",
  tab_eventi: "Eventos del cielo", tab_piano: "Mi plan",
  nd_stanotte: "Los mejores objetos de esta noche desde tu lugar: a simple vista, con prismáticos, con telescopio o en foto.",
  nd_lunasole: "La Luna, el Sol y los planetas: fases, horarios, noches oscuras del mes y crepúsculos.",
  nd_eventi: "Meteoros, cometas, pasos de la ISS, auroras, eclipses y conjunciones, para añadir al calendario.",
  nd_meteo: "Nubes hora a hora, rocío y viento, satélite y radar, y adónde ir para un cielo más oscuro.",
  nd_piano: "Los objetos que quieres ver esta noche, en orden y a las horas adecuadas.",
  home_vivo_piano: "{n} objetos en el plan", home_vivo_piano_1: "Un objeto en el plan", home_vivo_piano_0: "Aún vacío: añade los objetos desde «Qué ver»",
  home_vivo_eventi: "Próximo: {e}", home_vivo_scegli: "Telescopio, cámara o montura",
  vc_nel_piano: "En tu plan: {n} objetos", vc_nel_piano_1: "En tu plan: un objeto", vc_apri_piano: "Abrir el plan →",
  ns_cerca_vai_lsp: "Abrir Luna, Sol y planetas",
});
Object.assign(TESTI.en, {
  nv_transiti: "ISS transits", tab_transiti: "ISS transits", home_transiti: "The ISS in front of the Sun and Moon: where to go and how the photo will look.",
  nd_transiti: "The ISS and Tiangong in front of the Sun and Moon: where to go, the exact second, and how your photo will look.",
  vc_inizio: "Home", vc_notte: "Tonight", vc_attrezzi: "Equipment", vc_scelta: "Choose", vc_diario: "Log",
  vc_notte_n: "What's in the sky tonight from where you are, and the weather.",
  vc_attrezzi_n: "Your equipment, what it frames and all the calculations.",
  vc_scelta_n: "The right telescope, camera or mount for you, and the software.",
  vc_diario_n: "What you want to see tonight and what you've already observed and imaged.",
  vc_aria: "Tool sections", vc_aria_str: "Tools in the {v} section",
  nv_stanotte: "What to see", nv_lunasole: "Moon, Sun & planets", nv_eventi: "Sky events", nv_meteo: "Weather", nv_planetario: "Sky chart",
  nv_attrezzatura: "My equipment", nv_campo: "Field of view", nv_calcolatori: "Calculators",
  nv_scegli: "Which to choose?", nv_camere: "Cameras", nv_software: "Software", nv_diario: "My log", nv_piano: "My plan",
  tab_eventi: "Sky events", tab_piano: "My plan",
  nd_stanotte: "Tonight's best targets from where you are: naked eye, binoculars, telescope or camera.",
  nd_lunasole: "The Moon, the Sun and the planets: phases, times, the month's dark nights and twilight.",
  nd_eventi: "Meteors, comets, ISS passes, auroras, eclipses and conjunctions, ready for your calendar.",
  nd_meteo: "Clouds hour by hour, dew and wind, satellite and radar, and where to go for a darker sky.",
  nd_piano: "The objects you want to see tonight, lined up at the right times.",
  home_vivo_piano: "{n} objects in the plan", home_vivo_piano_1: "One object in the plan", home_vivo_piano_0: "Still empty: add objects from “What to see”",
  home_vivo_eventi: "Next: {e}", home_vivo_scegli: "Telescope, camera or mount",
  vc_nel_piano: "In your plan: {n} objects", vc_nel_piano_1: "In your plan: one object", vc_apri_piano: "Open the plan →",
  ns_cerca_vai_lsp: "Open Moon, Sun & planets",
});
Object.assign(GUIDA.it, {
  g_transiti: "Questa è la scheda dei transiti della ISS. In alto scegli il luogo. Sotto scegli fino a quanti chilometri ti sposti e per quanti giorni: l'elenco mostra i transiti della Stazione spaziale e della stazione cinese davanti al Sole e alla Luna. Tocca un transito: la mappa mostra la striscia da cui si vede e il punto dove andare, con il paese e il bottone per aprirlo nel navigatore. Più sotto, Prova lo scatto: scegli il tuo setup e premi play per vedere il passaggio nel fotogramma della tua camera, con il consiglio sul tempo di posa. Il Sole si guarda solo con il filtro solare.",
  g_home4: "Questa è la pagina degli strumenti di Giordano Astronomia. Ci sono quattro sezioni. Stanotte: cosa vedere dal tuo luogo, la Luna, il Sole e i pianeti, gli eventi del cielo, i transiti della ISS, il meteo e la carta del cielo. Attrezzatura: la tua attrezzatura, il Campo inquadrato per vedere cosa entra nella camera e i calcolatori. Scegli: il quiz per trovare il telescopio, la camera o la montatura, il database delle camere e i programmi. Diario: il tuo diario del cielo e il piano della notte. Tocca una sezione per vedere i suoi strumenti. In ogni strumento il bottone Come funziona ti spiega la pagina.",
  g_home4_app: "Questa è la pagina degli strumenti di Giordano Astronomia. In basso, accanto a Inizio, ci sono quattro sezioni. Stanotte: cosa vedere dal tuo luogo, la Luna, il Sole e i pianeti, gli eventi del cielo, il meteo e la carta del cielo. Attrezzatura: la tua attrezzatura, il Campo inquadrato per vedere cosa entra nella camera e i calcolatori. Scegli: il quiz per trovare il telescopio, la camera o la montatura, il database delle camere e i programmi. Diario: il tuo diario del cielo e il piano della notte. Tocca una sezione: in alto compaiono i suoi strumenti. Il menu in alto a sinistra ha tutte le sezioni e le impostazioni, come il testo grande e la visione notturna. In ogni strumento il bottone Aiuto ti spiega la pagina.",
  g_eventi: "Questa è la scheda Eventi del cielo. In alto scegli il luogo e la notte. Trovi le piogge di meteore, le comete che si vedono, i passaggi della Stazione spaziale, la possibilità di aurora e, più sotto, i prossimi eventi del cielo, come eclissi e congiunzioni. Tocca l'icona del calendario per mettere un evento nel calendario del telefono; tocca invece l'evento per passare a quella notte.",
  g_piano: "Questo è il piano della notte. In Cosa vedere tocca il bottone col segno più e la scritta Piano sugli oggetti che ti interessano: qui li mettiamo in fila nelle ore di buio, prima quelli che tramontano prima, con gli orari. In alto puoi cambiare il luogo e la notte. Il piano si stampa, si copia o si scarica per il programma di ripresa N.I.N.A.",
});
Object.assign(GUIDA.de, {
  g_transiti: "Das ist der Bereich der ISS-Transite. Oben wählen Sie den Ort. Darunter, wie weit Sie fahren und für wie viele Tage: Die Liste zeigt die Transite der Raumstation und der chinesischen Station vor Sonne und Mond. Tippen Sie auf einen Transit: Die Karte zeigt den Streifen, von dem aus man ihn sieht, und den Ort, an den Sie fahren sollen, mit Ortsname und Knopf für das Navi. Weiter unten, Probeaufnahme: Setup wählen und Play drücken, um den Durchgang im Bild Ihrer Kamera zu sehen, mit dem Rat zur Belichtungszeit. Die Sonne nur mit Sonnenfilter beobachten.",
  g_home4: "Das ist die Seite mit den Werkzeugen von Giordano Astronomia. Es gibt vier Bereiche. Heute Nacht: was Sie von Ihrem Ort aus sehen, Mond, Sonne und Planeten, die Himmelsereignisse, die ISS-Transite, das Wetter und die Sternkarte. Ausrüstung: Ihre Ausrüstung, was sie im Bildfeld erfasst, und die Rechner. Wählen: das Quiz für Teleskop, Kamera oder Montierung, die Kameradatenbank und die Programme. Tagebuch: Ihr Himmelstagebuch und der Plan der Nacht. Tippen Sie auf einen Bereich, um seine Werkzeuge zu sehen. In jedem Werkzeug erklärt die Schaltfläche „So funktioniert's“ die Seite.",
  g_home4_app: "Das ist die Seite mit den Werkzeugen von Giordano Astronomia. Unten, neben Start, gibt es vier Bereiche. Heute Nacht: was Sie von Ihrem Ort aus sehen, Mond, Sonne und Planeten, die Himmelsereignisse, das Wetter und die Sternkarte. Ausrüstung: Ihre Ausrüstung, was sie im Bildfeld erfasst, und die Rechner. Wählen: das Quiz für Teleskop, Kamera oder Montierung, die Kameradatenbank und die Programme. Tagebuch: Ihr Himmelstagebuch und der Plan der Nacht. Tippen Sie auf einen Bereich: oben erscheinen seine Werkzeuge. Im Menü oben links finden Sie alle Bereiche und die Einstellungen, zum Beispiel große Schrift und Nachtsicht. In jedem Werkzeug erklärt die Schaltfläche Hilfe die Seite.",
  g_eventi: "Das ist der Bereich Himmelsereignisse. Oben wählen Sie Ort und Nacht. Sie finden die Meteorströme, die sichtbaren Kometen, die Überflüge der Raumstation, die Chance auf Polarlichter und weiter unten die nächsten Himmelsereignisse wie Finsternisse und Konjunktionen. Tippen Sie auf das Kalender-Symbol, um ein Ereignis in den Kalender Ihres Telefons zu übernehmen; tippen Sie dagegen auf das Ereignis, um zu dieser Nacht zu wechseln.",
  g_piano: "Das ist der Plan der Nacht. Tippen Sie unter Was sehen bei den Objekten, die Sie interessieren, auf „plus Plan“: hier ordnen wir sie in den dunklen Stunden, zuerst die, die früher untergehen, mit Uhrzeiten. Oben können Sie Ort und Nacht ändern. Den Plan können Sie drucken, kopieren oder für N.I.N.A. herunterladen.",
});
Object.assign(GUIDA.es, {
  g_transiti: "Esta es la sección de los tránsitos de la ISS. Arriba eliges el lugar. Debajo, hasta cuántos kilómetros te mueves y durante cuántos días: la lista muestra los tránsitos de la Estación espacial y de la estación china delante del Sol y de la Luna. Toca un tránsito: el mapa muestra la franja desde donde se ve y el punto adonde ir, con el pueblo y el botón para abrirlo en Maps. Más abajo, Prueba la toma: elige tu equipo y pulsa play para ver el paso en el fotograma de tu cámara, con el consejo sobre el tiempo de exposición. El Sol solo se mira con filtro solar.",
  g_home4: "Esta es la página de herramientas de Giordano Astronomia. Hay cuatro secciones. Esta noche: qué ver desde tu lugar, la Luna, el Sol y los planetas, los eventos del cielo, los tránsitos de la ISS, el tiempo y la carta celeste. Equipo: tu equipo, qué encuadra en el Campo de visión y las calculadoras. Elegir: el test para encontrar el telescopio, la cámara o la montura, la base de datos de cámaras y los programas. Diario: tu diario del cielo y el plan de la noche. Toca una sección para ver sus herramientas. En cada herramienta el botón Cómo funciona te explica la página.",
  g_home4_app: "Esta es la página de herramientas de Giordano Astronomia. Abajo, junto a Inicio, hay cuatro secciones. Esta noche: qué ver desde tu lugar, la Luna, el Sol y los planetas, los eventos del cielo, el tiempo y la carta celeste. Equipo: tu equipo, qué encuadra en el Campo de visión y las calculadoras. Elegir: el test para encontrar el telescopio, la cámara o la montura, la base de datos de cámaras y los programas. Diario: tu diario del cielo y el plan de la noche. Toca una sección: arriba aparecen sus herramientas. En el menú de arriba a la izquierda tienes todas las secciones y los ajustes, como el texto grande y la visión nocturna. En cada herramienta el botón Ayuda te explica la página.",
  g_eventi: "Esta es la sección Eventos del cielo. Arriba eliges el lugar y la noche. Encuentras las lluvias de meteoros, los cometas visibles, los pasos de la Estación espacial, la posibilidad de auroras y, más abajo, los próximos eventos del cielo, como eclipses y conjunciones. Toca el icono del calendario para añadir un evento al calendario del móvil; si tocas el evento, en cambio, pasas a esa noche.",
  g_piano: "Este es el plan de la noche. En Qué ver toca «más Plan» en los objetos que te interesan: aquí los ponemos en orden en las horas de oscuridad, primero los que se ponen antes, con los horarios. Arriba puedes cambiar el lugar y la noche. El plan se imprime, se copia o se descarga para N.I.N.A.",
});
Object.assign(GUIDA.en, {
  g_transiti: "This is the ISS transits tab. At the top, choose your location. Below, choose how far you're willing to travel and for how many days: the list shows the transits of the Space Station and of the Chinese station in front of the Sun and the Moon. Tap a transit: the map shows the strip it's visible from and the spot to go to, with the town and a button to open it in your navigation app. Further down, Try the shot: choose your setup and press play to see the pass in your camera's frame, with advice on the exposure. Only look at the Sun through a solar filter.",
  g_home4: "This is the Giordano Astronomia tools page. There are four sections. Tonight: what to see from where you are, the Moon, the Sun and the planets, sky events, ISS transits, the weather and the sky chart. Equipment: your equipment, what it frames in the Field of view, and the calculators. Choose: the quiz to find the right telescope, camera or mount, the camera database and the software. Log: your observing log and the plan for the night. Tap a section to see its tools. In every tool, the How it works button explains the page.",
  g_home4_app: "This is the Giordano Astronomia tools page. At the bottom, next to Home, there are four sections. Tonight: what to see from where you are, the Moon, the Sun and the planets, sky events, the weather and the sky chart. Equipment: your equipment, what it frames in the Field of view, and the calculators. Choose: the quiz to find the right telescope, camera or mount, the camera database and the software. Log: your observing log and the plan for the night. Tap a section and its tools appear at the top. The menu at the top left has every section and the settings, such as large text and night vision. In every tool, the Help button explains the page.",
  g_eventi: "This is the Sky events tab. At the top, choose the place and the night. You'll find meteor showers, the comets you can see, passes of the Space Station, the chance of an aurora and, further down, the next sky events, such as eclipses and conjunctions. Tap the calendar icon to put an event in your phone's calendar; tap the event itself instead to switch to that night.",
  g_piano: "This is the plan for the night. In What to see, tap “plus Plan” on the objects you like: here we line them up in the dark hours, the ones that set first at the top, with times. At the top you can change the place and the night. You can print the plan, copy it or download it for N.I.N.A.",
});
const VOCI = [
  { id: "notte", ico: "stanotte", strumenti: ["stanotte", "lunasole", "eventi", "transiti", "meteo", "planetario"] },
  { id: "attrezzi", ico: "attrezzatura", strumenti: ["attrezzatura", "campo", "calcolatori"] },
  { id: "scelta", ico: "scegli", strumenti: ["scegli", "camere", "software"] },
  { id: "diario", ico: "diario", strumenti: ["diario", "piano"] },
];
const ICO_STRUMENTO = { stanotte: "stella", eventi: "meteora", transiti: "satellite", piano: "calendario" };
const icoStrumento = n => ICO_STRUMENTO[n] || n;
const vocePer = n => VOCI.find(v => v.strumenti.includes(n)) || null;
const nomeStrumento = n => t("nv_" + n);
function descrStrumento(n) {
  if (["stanotte", "lunasole", "eventi", "transiti", "meteo", "piano"].includes(n)) return t("nd_" + n);
  return n === "scegli" ? t("tt_scegli") : t("home_" + n);
}
function linkStrumento(n) { return n === "home" ? urlScheda("home") : urlScheda(n) + (PAGINE_SCHEDE[n] ? "" : "#" + n); }
function chiaveGuida(n) {
  if (n === "attrezzatura" && attrezzaturaVuota()) return "g_attrezzatura_vuota";
  if (!(NAV4 && n === "home")) return "g_" + n;
  return /(^|\s)gas-barra-basso(\s|$)/.test(document.documentElement.className || "") ? "g_home4_app" : "g_home4";
}
const clicSemplice = e => !(e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0);
const NAV = { barra: null, voci: null, strumenti: null };
function creaNav() {
  const voce = (id, ico, dove) => el("a", { class: "gas-sez gas-sez--" + id, href: linkStrumento(dove), dataset: { voce: id },
    onclick: e => { if (!clicSemplice(e)) return; e.preventDefault(); apriVoce(id); } },
    el("span", { class: "gas-sez-ico" }, icona(ico)), el("span", { class: "gas-sez-nome" }, t("vc_" + id)));
  NAV.voci = el("nav", { class: "gas-nav-voci", "aria-label": t("vc_aria") }, voce("inizio", "home", "home"), VOCI.map(v => voce(v.id, v.ico, v.strumenti[0])));
  NAV.strumenti = el("nav", { class: "gas-nav-str", hidden: true });
  NAV.barra = el("div", { class: "gas-nav" }, NAV.voci);
  PIANO_UI.add(() => { const c = NAV.strumenti && NAV.strumenti.querySelector(".gas-str-conta"); if (c) c.textContent = contaPiano(); });
  return NAV.barra;
}
const contaPiano = () => (NOTTE.piano || []).length ? ` (${NOTTE.piano.length})` : "";
function sistemaNav() {
  if (!NAV.barra) return;
  const largo = window.matchMedia ? matchMedia("(min-width: 990px)") : null;
  const sposta = () => {
    if (largo && largo.matches) NAV.barra.appendChild(NAV.strumenti);
    else NAV.barra.after(NAV.strumenti);
    misuraNav();
  };
  sposta();
  if (largo && largo.addEventListener) largo.addEventListener("change", sposta);
  if (window.ResizeObserver) new ResizeObserver(() => misuraNav()).observe(NAV.barra);
  else addEventListener("resize", debounce(misuraNav, 150));
}
function misuraNav() {
  if (!NAV.barra || !RADICE) return;
  const inBasso = getComputedStyle(NAV.barra).position === "fixed";
  document.documentElement.classList.toggle("gas-barra-basso", inBasso);
  const h = Math.round(NAV.barra.getBoundingClientRect().height);
  const ab = document.querySelector(".gas-appbar"), hAb = ab && getComputedStyle(ab).display !== "none" ? Math.round(ab.getBoundingClientRect().height) : 0;
  RADICE.style.setProperty("--gas-ab-h", hAb + "px");
  if (inBasso) { RADICE.style.setProperty("--gas-nav-h", hAb + "px"); document.documentElement.style.setProperty("--gas-barra-h", h + "px"); }
  else if (h) RADICE.style.setProperty("--gas-nav-h", hAb + h + "px");
}
function apriVoce(id) {
  if (id === "inizio") { vai("home"); return; }
  const v = VOCI.find(x => x.id === id);
  if (!v) return;
  if (vocePer(schedaAttiva) === v) { tornaAllaNav(); return; }
  const ultimi = ricorda("voci_ultimi", {});
  vai(v.strumenti.includes(ultimi[id]) ? ultimi[id] : v.strumenti[0]);
}
function tornaAllaNav() {
  if (!RADICE) return;
  const top = RADICE.getBoundingClientRect().top + window.scrollY - 90;
  if (window.scrollY > top + 40) window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
}
function segnaVoce(nome) {
  if (!NAV.voci) return;
  const v = vocePer(nome);
  for (const a of NAV.voci.querySelectorAll(".gas-sez")) {
    const on = a.dataset.voce === (v ? v.id : "inizio");
    a.classList.toggle("on", on);
    if (on) a.setAttribute("aria-current", "page"); else a.removeAttribute("aria-current");
  }
  svuota(NAV.strumenti);
  NAV.strumenti.hidden = !v;
  if (v) {
    NAV.strumenti.setAttribute("aria-label", t("vc_aria_str", { v: t("vc_" + v.id) }));
    for (const n of v.strumenti) NAV.strumenti.appendChild(el("a", { class: "gas-str gas-str--" + n + (n === nome ? " on" : ""), href: linkStrumento(n),
      "aria-current": n === nome ? "page" : null, onclick: e => { if (!clicSemplice(e)) return; e.preventDefault(); if (n !== schedaAttiva) vai(n); } },
      el("span", { class: "gas-str-ico" }, icona(icoStrumento(n))), el("span", { class: "gas-str-nome" }, nomeStrumento(n),
        n === "piano" ? el("span", { class: "gas-str-conta" }, contaPiano()) : null)));
    const ultimi = ricorda("voci_ultimi", {});
    if (ultimi[v.id] !== nome) { ultimi[v.id] = nome; salva("voci_ultimi", ultimi); }
  }
  const acceso = NAV.strumenti.querySelector(".gas-str.on");
  if (acceso && NAV.strumenti.scrollWidth > NAV.strumenti.clientWidth + 2) NAV.strumenti.scrollLeft = Math.max(0, acceso.offsetLeft - NAV.strumenti.offsetLeft - 24);
  if (typeof titoloAppbar === "function") titoloAppbar(nome);
  misuraNav();
}
function vistaHome4(pannello) {
  svuota(pannello);
  const griglia = el("div", { class: "gas-hv-griglia" });
  for (const v of VOCI) {
    const lista = el("ul", { class: "gas-hv-lista" });
    for (const n of v.strumenti) {
      const vivo = el("span", { class: "gas-home-vivo gas-hv-vivo" });
      lista.appendChild(el("li", null, el("a", { class: "gas-hv-str", href: linkStrumento(n),
        onclick: e => { if (!clicSemplice(e)) return; e.preventDefault(); vai(n); } },
        el("span", { class: "gas-hv-str-ico" }, icona(icoStrumento(n))),
        el("span", { class: "gas-hv-str-testo" }, el("b", null, nomeStrumento(n)), vivo),
        el("span", { class: "gas-hv-freccia", "aria-hidden": "true" }, "→"))));
      try { infoViva(n, vivo); } catch (e) {   }
    }
    griglia.appendChild(el("section", { class: "gas-hv gas-hv--" + v.id },
      el("div", { class: "gas-hv-testa" }, el("span", { class: "gas-hv-ico" }, icona(v.ico)),
        el("div", { class: "gas-hv-testo" }, el("h3", { class: "gas-hv-nome" }, t("vc_" + v.id)), el("p", { class: "gas-hv-desc" }, t("vc_" + v.id + "_n")))),
      lista));
  }
  BV_ATTESA = bvAspetta();
  const bv = BV_ATTESA ? null : cartaBenvenuto(() => vistaHome(pannello));
  aggiungi(pannello, [bv, bv || BV_ATTESA || cartaBenvenuto._chiuso ? null : cartaAppHome(() => vistaHome(pannello)), cartaTester(() => vistaHome(pannello)), cartaStasera(), bannerQuiz(),
    el("div", { class: "gas-home-testa" }, el("h2", { class: "gas-home-titolo" }, t("home_titolo")), typeof bottoneTour === "function" ? bottoneTour() : null), griglia,
    cartaAvvisi(), cartaSenzaRete()]);
}
function vistaEventi(pannello) {
  svuota(pannello);
  const corpo = el("div", { class: "gas-eventi" });
  const disegna = () => {
    const c = calcolaNotte(), { lat, lon } = NOTTE.luogo;
    const scegli = iso => { NOTTE.data = iso; salvaNotte(); vistaEventi(pannello); pannello.scrollIntoView({ behavior: "smooth", block: "start" }); };
    try { aggiungi(svuota(corpo), [cartaMeteore(c), cartaComete(c), cartaSatelliti(c), cartaProssimoTransito(), cartaAurora(c), cartaEventi(lat, lon, scegli), cartaAvvisi()]); }
    catch (e) { console.error("strumenti, eventi:", e); }
  };
  pannello.append(barraLuogo(() => disegna(), true), corpo);
  disegna();
}
function vistaPiano(pannello) {
  svuota(pannello);
  const corpo = el("div", { class: "gas-pn-cont" });
  const disegna = () => {
    if (!corpo.isConnected && corpo._mostrato) { PIANO_UI.delete(disegna); return; }
    corpo._mostrato = true;
    try { svuota(corpo).appendChild(boxPiano(calcolaNotte().nt)); } catch (e) { console.error("strumenti, piano:", e); }
  };
  PIANO_UI.add(disegna);
  pannello.append(barraLuogo(() => disegna(), true), corpo,
    el("div", { class: "gas-riga-bottoni" }, el("a", { class: "gas-btn gas-btn--chiaro gas-btn--mini", href: linkStrumento("stanotte"),
      onclick: e => { if (!clicSemplice(e)) return; e.preventDefault(); vai("stanotte"); } }, icona("stella"), " ", t("nv_stanotte"), " →")));
  disegna();
}
function rigaPianoNotte() {
  const testo = el("span"), riga = el("p", { class: "gas-nota gas-notte-piano", hidden: true }, icona("calendario"), " ", testo, " ",
    el("a", { href: linkStrumento("piano"), onclick: e => { if (!clicSemplice(e)) return; e.preventDefault(); vai("piano"); } }, t("vc_apri_piano")));
  const disegna = () => {
    if (!riga.isConnected && riga._mostrato) { PIANO_UI.delete(disegna); return; }
    riga._mostrato = true;
    const n = (NOTTE.piano || []).length;
    riga.hidden = !n;
    testo.textContent = t("vc_nel_piano", { n });
  };
  PIANO_UI.add(disegna);
  disegna();
  return riga;
}
Object.assign(TESTI.it, {
  qz_titolo: "Quale telescopio fa per me?", qz_n: "Cinque domande e ti consigliamo tre telescopi del negozio, con il perché.", qz_via: "Inizia", qz_indietro: "Indietro",
  qz_ricomincia: "Rifai le domande", qz_passo: "Domanda {n} di 5",
  qz_d_uso: "Cosa vuoi fare?", qz_uso_visuale: "Guardare il cielo all'oculare", qz_uso_pianeti: "Guardare o fotografare pianeti e Luna", qz_uso_deep: "Fotografare nebulose e galassie",
  qz_uso_tutto: "Un po' di tutto", qz_uso_semplice: "La cosa più semplice: fotografare comandando tutto dal telefono",
  qz_d_budget: "Quanto vuoi spendere?", qz_b_300: "Fino a 300 €", qz_b_700: "300 – 700 €", qz_b_1500: "700 – 1.500 €", qz_b_3000: "1.500 – 3.000 €", qz_b_max: "Oltre 3.000 €",
  qz_d_esp: "Che esperienza hai?", qz_e_prima: "È il mio primo telescopio", qz_e_ho: "Ne ho già usato uno", qz_e_esperto: "Sono esperto",
  qz_d_luogo: "Da dove osservi?", qz_l_citta: "Dal balcone o dal giardino, in città", qz_l_auto: "Lo porto in auto sotto un cielo buio", qz_l_fisso: "Ho una postazione fissa",
  qz_d_peso: "Quanto conta il peso?", qz_p_leggero: "Leggero e facile da portare", qz_p_ok: "Va bene anche grande e pesante",
  qz_risultato: "I telescopi giusti per te", qz_nessuno: "Con queste risposte non troviamo un telescopio disponibile: prova ad alzare il budget.",
  qz_vedi: "Vedi nel negozio", qz_prova: "Prova nel Campo inquadrato", qz_solo_tubo: "Solo il tubo: servono anche la montatura e la camera.", qz_carico: "Trova la montatura adatta",
  qz_r_smart: "Smart telescope: telescopio, camera e montatura in uno, si comanda dal telefono e in pochi minuti hai la foto.",
  qz_r_dobson: "Dobson da {d} mm: tantissima luce per il prezzo, si monta in un minuto e mostra galassie, nebulose e pianeti.",
  qz_r_goto: "GoTo completo: trova da solo gli oggetti e li segue, comodo anche dal balcone.",
  qz_r_pianeti: "Focale lunga (f/{n}): immagini grandi e nitide di pianeti e Luna.", qz_r_apo: "Rifrattore apocromatico f/{n}: stelle nitide e colori giusti, il tubo più usato per le foto del cielo profondo.",
  qz_r_astro: "Astrografo f/{n}: tanta luce e campo largo per le nebulose.", qz_r_leggero: "Compatto e leggero.", qz_r_grande: "{d} mm di diametro: più dettagli e oggetti più deboli.",
  qz_e_entry: "Pensato per cominciare: completo di montatura e accessori.",
});
Object.assign(TESTI.de, {
  qz_titolo: "Welches Teleskop passt zu mir?", qz_n: "Fünf Fragen, und wir empfehlen Ihnen drei Teleskope aus dem Shop, mit Begründung.", qz_via: "Starten", qz_indietro: "Zurück",
  qz_ricomincia: "Fragen neu beantworten", qz_passo: "Frage {n} von 5",
  qz_d_uso: "Was möchten Sie tun?", qz_uso_visuale: "Den Himmel durchs Okular beobachten", qz_uso_pianeti: "Planeten und Mond", qz_uso_deep: "Nebel und Galaxien fotografieren",
  qz_uso_tutto: "Ein bisschen von allem", qz_uso_semplice: "Das Einfachste: fotografieren und alles vom Handy aus steuern",
  qz_d_budget: "Wie viel möchten Sie ausgeben?", qz_b_300: "Bis 300 €", qz_b_700: "300 – 700 €", qz_b_1500: "700 – 1.500 €", qz_b_3000: "1.500 – 3.000 €", qz_b_max: "Über 3.000 €",
  qz_d_esp: "Welche Erfahrung haben Sie?", qz_e_prima: "Es ist mein erstes Teleskop", qz_e_ho: "Ich hatte schon eins", qz_e_esperto: "Ich bin erfahren",
  qz_d_luogo: "Wo beobachten Sie?", qz_l_citta: "Vom Balkon oder Garten, in der Stadt", qz_l_auto: "Ich nehme es im Auto mit unter einen dunklen Himmel", qz_l_fisso: "Ich habe einen festen Standort",
  qz_d_peso: "Wie wichtig ist das Gewicht?", qz_p_leggero: "Leicht und gut zu tragen", qz_p_ok: "Darf auch groß und schwer sein",
  qz_risultato: "Die richtigen Teleskope für Sie", qz_nessuno: "Mit diesen Antworten finden wir kein verfügbares Teleskop: erhöhen Sie das Budget.",
  qz_vedi: "Im Shop ansehen", qz_prova: "Im Bildfeld ausprobieren", qz_solo_tubo: "Nur der Tubus: Montierung und Kamera braucht es auch.", qz_carico: "Passende Montierung finden",
  qz_r_smart: "Smart-Teleskop: Teleskop, Kamera und Montierung in einem, Steuerung per Handy, in wenigen Minuten ein Foto.",
  qz_r_dobson: "Dobson mit {d} mm: sehr viel Licht fürs Geld, in einer Minute aufgebaut, zeigt Galaxien, Nebel und Planeten.",
  qz_r_goto: "Komplettes GoTo: findet die Objekte selbst und führt nach, bequem auch vom Balkon.",
  qz_r_pianeti: "Lange Brennweite (f/{n}): große, scharfe Bilder von Planeten und Mond.", qz_r_apo: "Apochromatischer Refraktor f/{n}: scharfe Sterne und richtige Farben, der beliebteste Tubus für Deep-Sky-Fotos.",
  qz_r_astro: "Astrograph f/{n}: viel Licht und weites Feld für Nebel.", qz_r_leggero: "Kompakt und leicht.", qz_r_grande: "{d} mm Öffnung: mehr Details und schwächere Objekte.",
  qz_e_entry: "Zum Einstieg gedacht: komplett mit Montierung und Zubehör.",
});
Object.assign(TESTI.es, {
  qz_titolo: "¿Qué telescopio es para mí?", qz_n: "Cinco preguntas y te recomendamos tres telescopios de la tienda, con el porqué.", qz_via: "Empezar", qz_indietro: "Atrás",
  qz_ricomincia: "Repetir las preguntas", qz_passo: "Pregunta {n} de 5",
  qz_d_uso: "¿Qué quieres hacer?", qz_uso_visuale: "Mirar el cielo por el ocular", qz_uso_pianeti: "Planetas y Luna", qz_uso_deep: "Fotografiar nebulosas y galaxias",
  qz_uso_tutto: "Un poco de todo", qz_uso_semplice: "Lo más sencillo: fotografiar controlándolo todo desde el móvil",
  qz_d_budget: "¿Cuánto quieres gastar?", qz_b_300: "Hasta 300 €", qz_b_700: "300 – 700 €", qz_b_1500: "700 – 1500 €", qz_b_3000: "1500 – 3000 €", qz_b_max: "Más de 3000 €",
  qz_d_esp: "¿Qué experiencia tienes?", qz_e_prima: "Es mi primer telescopio", qz_e_ho: "Ya he usado uno", qz_e_esperto: "Soy experto",
  qz_d_luogo: "¿Desde dónde observas?", qz_l_citta: "Desde el balcón o el jardín, en la ciudad", qz_l_auto: "Lo llevo en coche a un cielo oscuro", qz_l_fisso: "Tengo un sitio fijo",
  qz_d_peso: "¿Cuánto importa el peso?", qz_p_leggero: "Ligero y fácil de llevar", qz_p_ok: "Puede ser grande y pesado",
  qz_risultato: "Los telescopios adecuados para ti", qz_nessuno: "Con estas respuestas no encontramos un telescopio disponible: prueba a subir el presupuesto.",
  qz_vedi: "Ver en la tienda", qz_prova: "Probar en Campo de visión", qz_solo_tubo: "Solo el tubo: también hacen falta la montura y la cámara.", qz_carico: "Encuentra la montura adecuada",
  qz_r_smart: "Smart telescope: telescopio, cámara y montura en uno, se maneja desde el móvil y en pocos minutos tienes la foto.",
  qz_r_dobson: "Dobson de {d} mm: muchísima luz por su precio, se monta en un minuto y muestra galaxias, nebulosas y planetas.",
  qz_r_goto: "GoTo completo: encuentra los objetos por sí solo y los sigue, cómodo también desde el balcón.",
  qz_r_pianeti: "Focal larga (f/{n}): imágenes grandes y nítidas de planetas y Luna.", qz_r_apo: "Refractor apocromático f/{n}: estrellas nítidas y colores correctos, el tubo más usado para fotos de cielo profundo.",
  qz_r_astro: "Astrógrafo f/{n}: mucha luz y campo amplio para las nebulosas.", qz_r_leggero: "Compacto y ligero.", qz_r_grande: "{d} mm de diámetro: más detalles y objetos más débiles.",
  qz_e_entry: "Pensado para empezar: incluye montura y accesorios.",
});
Object.assign(TESTI.it, {
  tab_scegli: "Quale scegliere?", qz_banner_t: "Non sai quale telescopio scegliere?", qz_banner_b: "Fai il quiz",
  qz_banner_d: "Rispondi a 5 domande facili: ti consigliamo 3 telescopi disponibili nel negozio e ti spieghiamo perché. C'è anche il quiz per la camera e per la montatura.",
  qz_intro: "Il modo più semplice per scegliere il telescopio, la camera o la montatura: rispondi a cinque domande e ti proponiamo i prodotti giusti fra quelli disponibili nel negozio, con il perché.",
  qz_p1: "5 domande, un minuto", qz_p2: "Solo prodotti disponibili", qz_p3: "Il perché di ogni consiglio",
  qz_le_tue: "Le tue risposte (tocca per cambiare)", qz_primo: "Prima scelta", qz_n_pos: "{n}°",
  qz_come: "Come scegliamo", qz_come_t: "Vuoi guardare il cielo e sei all'inizio: un Dobson, cioè un telescopio a specchio su una base che gira a mano. A parità di prezzo ha lo specchio più grande, quindi fa vedere più cose. Se osservi dal balcone è meglio un telescopio piccolo con il puntamento automatico (GoTo), che trova da solo gli oggetti.|Vuoi vedere bene pianeti e Luna: un telescopio con la focale lunga, che ingrandisce di più, e con il diametro più grande possibile, che mostra più dettagli.|Vuoi fotografare nebulose e galassie e sei all'inizio: uno smart telescope (come Seestar o Dwarf), cioè telescopio, camera e montatura in un pezzo solo, che si comanda dal telefono.|Vuoi fotografare e hai già esperienza: un rifrattore apocromatico, che dà stelle nitide e colori giusti, su una montatura motorizzata che segue il cielo.",
  qz_come_n: "Ti proponiamo solo telescopi disponibili adesso, con il prezzo di oggi.",
  qz_hai_gia: "Hai già un telescopio? Inseriscilo nella tua attrezzatura", qz_cosa_vedo: "Cosa vedo",
});
Object.assign(TESTI.de, {
  tab_scegli: "Was wählen?", qz_banner_t: "Sie wissen nicht, welches Teleskop Sie wählen sollen?", qz_banner_b: "Zum Quiz",
  qz_banner_d: "Beantworten Sie 5 einfache Fragen: wir empfehlen 3 lieferbare Teleskope aus dem Shop und erklären warum. Auch für Kamera und Montierung.",
  qz_intro: "Der einfachste Weg zu Teleskop, Kamera oder Montierung: beantworten Sie fünf Fragen, und wir schlagen die passenden lieferbaren Produkte aus dem Shop vor, mit Begründung.",
  qz_p1: "5 Fragen, eine Minute", qz_p2: "Nur lieferbare Produkte", qz_p3: "Die Begründung zu jeder Empfehlung",
  qz_le_tue: "Ihre Antworten (zum Ändern antippen)", qz_primo: "Erste Wahl", qz_n_pos: "{n}.",
  qz_come: "Wie wir auswählen", qz_come_t: "Sie möchten den Himmel beobachten und fangen gerade an: ein Dobson, also ein Spiegelteleskop auf einer Basis, die man von Hand dreht. Zum gleichen Preis hat er den größten Spiegel und zeigt deshalb mehr. Vom Balkon aus ist ein kleines Teleskop mit automatischer Ausrichtung (GoTo) besser, das die Objekte selbst findet.|Sie möchten Planeten und Mond gut sehen: ein Teleskop mit langer Brennweite, die stärker vergrößert, und möglichst großer Öffnung, die mehr Details zeigt.|Sie möchten Nebel und Galaxien fotografieren und fangen an: ein Smart-Teleskop (wie Seestar oder Dwarf), also Teleskop, Kamera und Montierung in einem Gerät, gesteuert vom Handy.|Sie möchten fotografieren und haben schon Erfahrung: ein apochromatischer Refraktor, der scharfe Sterne und richtige Farben liefert, auf einer motorisierten Montierung, die dem Himmel folgt.",
  qz_come_n: "Wir schlagen nur Teleskope vor, die jetzt lieferbar sind, mit dem heutigen Preis.",
  qz_hai_gia: "Sie haben schon ein Teleskop? Tragen Sie es in Ihre Ausrüstung ein", qz_cosa_vedo: "Was ich sehe",
});
Object.assign(TESTI.es, {
  tab_scegli: "¿Cuál elegir?", qz_banner_t: "¿No sabes qué telescopio elegir?", qz_banner_b: "Haz el test",
  qz_banner_d: "Responde a 5 preguntas sencillas: te recomendamos 3 telescopios disponibles en la tienda y te explicamos por qué. También para la cámara y la montura.",
  qz_intro: "La forma más sencilla de elegir telescopio, cámara o montura: responde a cinco preguntas y te proponemos los productos adecuados entre los disponibles en la tienda, con el porqué.",
  qz_p1: "5 preguntas, un minuto", qz_p2: "Solo productos disponibles", qz_p3: "El porqué de cada consejo",
  qz_le_tue: "Tus respuestas (toca para cambiar)", qz_primo: "Primera opción", qz_n_pos: "{n}.º",
  qz_come: "Cómo elegimos", qz_come_t: "Quieres mirar el cielo y estás empezando: un Dobson, es decir, un telescopio de espejo sobre una base que se gira a mano. Por el mismo precio tiene el espejo más grande, así que muestra más cosas. Si observas desde el balcón es mejor un telescopio pequeño con apuntado automático (GoTo), que encuentra solo los objetos.|Quieres ver bien planetas y Luna: un telescopio de focal larga, que aumenta más, y con el mayor diámetro posible, que muestra más detalles.|Quieres fotografiar nebulosas y galaxias y estás empezando: un smart telescope (como Seestar o Dwarf), es decir telescopio, cámara y montura en una sola pieza, que se maneja desde el móvil.|Quieres fotografiar y ya tienes experiencia: un refractor apocromático, que da estrellas nítidas y colores correctos, sobre una montura motorizada que sigue el cielo.",
  qz_come_n: "Solo te proponemos telescopios disponibles ahora, con el precio de hoy.",
  qz_hai_gia: "¿Ya tienes un telescopio? Añádelo a tu equipo", qz_cosa_vedo: "Qué veo",
});
Object.assign(GUIDA.it, { g_scegli: "Qui trovi il telescopio giusto in un minuto. Rispondi a cinque domande: cosa vuoi fare, quanto vuoi spendere, che esperienza hai, da dove osservi e quanto conta il peso. Ti proponiamo tre telescopi disponibili nel negozio e ti spieghiamo perché. Tocca una risposta per cambiarla. Sotto puoi confrontarli fianco a fianco e mettere nel carrello il kit completo. C'è anche il quiz per scegliere la camera o la montatura." });
Object.assign(GUIDA.de, { g_scegli: "Hier finden Sie in einer Minute das richtige Teleskop. Beantworten Sie fünf Fragen: was Sie tun möchten, wie viel Sie ausgeben wollen, Ihre Erfahrung, wo Sie beobachten und wie wichtig das Gewicht ist. Wir schlagen drei lieferbare Teleskope aus dem Shop vor und erklären warum. Tippen Sie auf eine Antwort, um sie zu ändern. Darunter können Sie sie direkt vergleichen und das komplette Set in den Warenkorb legen. Es gibt auch das Quiz für Kamera oder Montierung." });
Object.assign(GUIDA.es, { g_scegli: "Aquí encuentras el telescopio adecuado en un minuto. Responde a cinco preguntas: qué quieres hacer, cuánto quieres gastar, tu experiencia, desde dónde observas y cuánto importa el peso. Te proponemos tres telescopios disponibles en la tienda y te explicamos por qué. Toca una respuesta para cambiarla. Debajo puedes compararlos uno al lado del otro y añadir al carrito el kit completo. También hay un test para elegir la cámara o la montura." });
const QZ_DOMANDE = [["uso", ["visuale", "pianeti", "deep", "tutto", "semplice"]], ["budget", ["300", "700", "1500", "3000", "max"]],
  ["esp", ["prima", "ho", "esperto"]], ["luogo", ["citta", "auto", "fisso"]], ["peso", ["leggero", "ok"]]];
const QZ_BUDGET = { 300: [0, 300], 700: [250, 700], 1500: [600, 1500], 3000: [1200, 3000], max: [2500, 1e9] };
function consigliaTelescopi(r, margine) {
  const [min, max] = QZ_BUDGET[r.budget] || [0, 1e9], N = x => x.F / x.D, leggero = r.peso === "leggero", tetto = max * (margine || 1.05);
  const principiante = r.esp === "prima";
  const unici = new Map();
  for (const x of DATI.telescopi) if (x.h && x.prezzo && x.disp && !unici.has(x.h) && !["guida", "solare"].includes(x.tipo) && !/solar|sun.?tracking/i.test(x.t)) unici.set(x.h, x);
  const voti = [];
  for (const x of unici.values()) {
    if (x.prezzo > tetto || x.prezzo < min * 0.8) continue;
    const completo = !!x.completo, smart = x.tipo === "smart" || x.completo === "smart", perche = [];
    let s = 0;
    if (principiante && !completo && !(r.uso === "deep" && max >= 3000)) continue;
    if (r.uso === "semplice") { if (!smart) continue; s = 10; perche.push(t("qz_r_smart")); }
    else if (r.uso === "visuale" || r.uso === "tutto") {
      if (smart && r.uso === "visuale") continue;
      if (x.tipo === "dobson" && !(leggero && x.D > 150)) { s = r.uso === "tutto" ? 5 : 8; perche.push(t("qz_r_dobson", { d: num(x.D) })); }
      else if (x.completo === "goto") { s = r.luogo === "citta" || r.uso === "tutto" ? 8 : 6; perche.push(t("qz_r_goto")); }
      else if (completo) { s = 5; if (x.completo === "entry") perche.push(t("qz_e_entry")); }
      else s = r.esp === "esperto" ? 4 : 1;
      s += Math.min(4, x.D / 60);
      if (x.D >= 150) perche.push(t("qz_r_grande", { d: num(x.D) }));
    } else if (r.uso === "pianeti") {
      if (smart) continue;
      s = N(x) >= 10 ? 6 : N(x) >= 7 ? 4 : x.D >= 200 ? 4 : 1;
      if (N(x) >= 7) perche.push(t("qz_r_pianeti", { n: num(N(x), 0) }));
      if (completo) { s += 2; if (x.completo === "goto") perche.push(t("qz_r_goto")); else if (x.tipo === "dobson") perche.push(t("qz_r_dobson", { d: num(x.D) })); }
      s += Math.min(4, x.D / 70);
    } else if (r.uso === "deep") {
      if (smart) { s = principiante || max <= 1500 ? 10 : 5; perche.push(t("qz_r_smart")); }
      else if (x.tipo === "rifrattore_apo" && x.D >= 50 && x.D <= (r.esp === "esperto" ? 130 : 100) && N(x) <= 7.5) {
        s = r.esp === "prima" ? 4 : 8; perche.push(t("qz_r_apo", { n: num(N(x), 1) }));
        if (!completo && x.prezzo > max * 0.45) s -= 4;
      } else if (r.esp === "esperto" && r.luogo === "fisso" && !completo && /newton|rc/.test(x.tipo) && N(x) <= 5) {
        s = 7; perche.push(t("qz_r_astro", { n: num(N(x), 1) }));
      } else continue;
    }
    if (leggero) { if (x.D <= 110 || smart) { s += 1.5; perche.push(t("qz_r_leggero")); } else if (x.D >= 200) s -= 3; }
    if (r.luogo === "citta" && x.tipo === "dobson" && x.D > 250) s -= 2;
    const limite = leggero || r.luogo === "citta" ? 200 : principiante ? 300 : Infinity;
    if (!smart && x.D > limite) s -= (x.D - limite) / 30;
    const alto = max < 1e9 ? max : min * 2.4;
    s += 2 - Math.abs(x.prezzo - alto * 0.8) / Math.max(200, alto);
    voti.push({ x, s, perche, soloTubo: !completo && !smart });
  }
  if (margine === Infinity) voti.sort((a, b) => a.x.prezzo - b.x.prezzo); else voti.sort((a, b) => b.s - a.s);
  const scelti = [];
  for (const v of voti) {
    if (scelti.some(w => w.x.tipo === v.x.tipo && Math.abs(w.x.D - v.x.D) < 15 && Math.abs(w.x.prezzo - v.x.prezzo) < max * 0.15)) continue;
    scelti.push(v);
    if (scelti.length === 3) break;
  }
  if (scelti.length < 3 && !margine) return consigliaTelescopi(r, 1.3);
  if (scelti.length < 2 && margine === 1.3) return consigliaTelescopi(r, Infinity);
  for (const v of scelti) v.sopra = v.x.prezzo > max * 1.02;
  return scelti;
}
Object.assign(TESTI.it, { qz_da_zero: "Ricomincia da zero" });
Object.assign(TESTI.de, { qz_da_zero: "Von vorn beginnen" });
Object.assign(TESTI.es, { qz_da_zero: "Empezar de cero" });
Object.assign(TESTI.it, {
  qz_sopra: "Nel budget che hai scelto non c'è un telescopio adatto a queste risposte: ti mostriamo i più vicini, che costano di più.",
  qc_sopra: "Nel budget che hai scelto non c'è una camera adatta a queste risposte: ti mostriamo le più vicine, che costano di più.",
  qm_sopra: "Nel budget che hai scelto non c'è una montatura che regga questo carico: ti mostriamo le più vicine, che costano di più.",
  qc_meno: "Per questo uso non serve spendere così tanto: queste sono le migliori che abbiamo.",
  qm_meno: "Per questo carico non serve spendere così tanto: queste sono le più adatte che abbiamo.",
  qm_nessuno_carico: "Per questo carico adesso non abbiamo una montatura disponibile: scrivici e te la troviamo.",
  qz_sopra_uno: "Sopra il tuo budget",
});
Object.assign(TESTI.de, {
  qz_sopra: "In Ihrem Budget gibt es kein passendes Teleskop für diese Antworten: wir zeigen Ihnen die nächstliegenden, die mehr kosten.",
  qc_sopra: "In Ihrem Budget gibt es keine passende Kamera für diese Antworten: wir zeigen Ihnen die nächstliegenden, die mehr kosten.",
  qm_sopra: "In Ihrem Budget gibt es keine Montierung, die diese Last trägt: wir zeigen Ihnen die nächstliegenden, die mehr kosten.",
  qc_meno: "Für diesen Zweck müssen Sie nicht so viel ausgeben: das sind die besten, die wir haben.",
  qm_meno: "Für diese Last müssen Sie nicht so viel ausgeben: das sind die passendsten, die wir haben.",
  qm_nessuno_carico: "Für diese Last haben wir gerade keine lieferbare Montierung: schreiben Sie uns, wir finden eine für Sie.",
  qz_sopra_uno: "Über Ihrem Budget",
});
Object.assign(TESTI.es, {
  qz_sopra: "Con el presupuesto elegido no hay un telescopio adecuado para estas respuestas: te mostramos los más cercanos, que cuestan más.",
  qc_sopra: "Con el presupuesto elegido no hay una cámara adecuada para estas respuestas: te mostramos las más cercanas, que cuestan más.",
  qm_sopra: "Con el presupuesto elegido no hay una montura que aguante esta carga: te mostramos las más cercanas, que cuestan más.",
  qc_meno: "Para este uso no hace falta gastar tanto: estas son las mejores que tenemos.",
  qm_meno: "Para esta carga no hace falta gastar tanto: estas son las más adecuadas que tenemos.",
  qm_nessuno_carico: "Para esta carga ahora no tenemos una montura disponible: escríbenos y te la buscamos.",
  qz_sopra_uno: "Por encima de tu presupuesto",
});
Object.assign(TESTI.en, {
  qz_sopra: "There's no suitable telescope for these answers within the budget you chose: here are the closest ones, which cost more.",
  qc_sopra: "There's no suitable camera for these answers within the budget you chose: here are the closest ones, which cost more.",
  qm_sopra: "There's no mount that can carry this load within the budget you chose: here are the closest ones, which cost more.",
  qc_meno: "You don't need to spend that much for this: these are the best we have.",
  qm_meno: "You don't need to spend that much for this load: these are the best fits we have.",
  qm_nessuno_carico: "We don't have a mount in stock for this load right now: write to us and we'll find one for you.",
  qz_sopra_uno: "Over your budget",
});
Object.assign(TESTI.it, { qz_nodisp: "Non disponibile adesso", qz_solo_tubo_vis: "Solo il tubo: serve anche la montatura." });
Object.assign(TESTI.de, { qz_nodisp: "Gerade nicht lieferbar", qz_solo_tubo_vis: "Nur der Tubus: eine Montierung braucht es auch." });
Object.assign(TESTI.es, { qz_nodisp: "No disponible ahora", qz_solo_tubo_vis: "Solo el tubo: también hace falta la montura." });
Object.assign(TESTI.en, { qz_nodisp: "Not available right now", qz_solo_tubo_vis: "Tube only: you'll also need a mount." });
function fuocoQuiz(box) {
  const d = $(".gas-qz-domanda", box);
  if (d) { d.tabIndex = -1; d.focus({ preventScroll: true }); }
}
function titoloNegozio(nodo, p) { if (LINGUA !== "it" && p && p.title) nodo.textContent = p.title; }
function segnaNonDisponibile(testo, p) {
  if (p === false || (p && p.available === false)) testo.insertBefore(el("small", { class: "gas-qz-sopra" }, t("qz_nodisp")), testo.children[2] || null);
}
const QZ_PREF = { uso: "uso", budget: "b", esp: "e", luogo: "l", peso: "p" };
const rispostaQuiz = (k, v) => t(`qz_${QZ_PREF[k]}_${v}`);
function cartaQuiz() {
  const R = Object.assign({}, ricorda("quiz", {}));
  const box = scheda(null);
  box.classList.add("gas-qz");
  let passo = R.fatto ? 5 : -1;
  const vaiA = p => {
    passo = p; disegna(); fuocoQuiz(box);
    const r = box.getBoundingClientRect();
    if (r.top < 70 || r.top > window.innerHeight * 0.6) window.scrollTo({ top: r.top + window.scrollY - 80, behavior: "smooth" });
  };
  const tutte = () => QZ_DOMANDE.every(([k]) => R[k] != null);
  const ricomincia = () => { for (const k of Object.keys(R)) delete R[k]; salva("quiz", R); vaiA(0); };
  const riepilogo = (fino, conReset) => {
    const date = QZ_DOMANDE.slice(0, fino).map(([k], i) => [k, i]).filter(([k]) => R[k] != null);
    return date.length ? el("div", { class: "gas-qz-risposte" }, el("small", null, t("qz_le_tue")),
      el("div", { class: "gas-qz-risposte-voci" }, date.map(([k, i]) => el("button", { type: "button", class: "gas-cx-chip gas-cx-chip--mini", onclick: () => vaiA(i) },
        el("span", null, rispostaQuiz(k, R[k])), " ✎")),
        conReset ? el("button", { type: "button", class: "gas-cx-chip gas-cx-chip--mini gas-qz-reset", onclick: ricomincia }, icona("reimposta"), el("span", null, t("qz_da_zero"))) : null)) : null;
  };
  function disegna() {
    svuota(box);
    box.appendChild(el("h3", { class: "gas-qz-titolo" }, icona("scegli"), " ", t("qz_titolo")));
    if (passo < 0) {
      aggiungi(box, [el("p", { class: "gas-nota" }, t("qz_n")),
        el("ul", { class: "gas-qz-punti" }, ["qz_p1", "qz_p2", "qz_p3"].map(k => el("li", null, el("i", null, "✓"), " ", t(k)))),
        el("button", { type: "button", class: "gas-btn gas-qz-via", onclick: () => vaiA(0) }, t("qz_via"), " →")]);
      return;
    }
    if (passo < 5) {
      const [chiave, scelte] = QZ_DOMANDE[passo];
      aggiungi(box, [el("div", { class: "gas-qz-passi" }, QZ_DOMANDE.map((_, i) => el("i", { class: i < passo ? "fatto" : i === passo ? "ora" : "" }))),
        el("small", { class: "gas-setup-etich" }, t("qz_passo", { n: passo + 1 })),
        el("p", { class: "gas-qz-domanda" }, t("qz_d_" + chiave)),
        el("div", { class: "gas-qz-scelte" }, scelte.map(v => el("button", { type: "button", class: "gas-qz-scelta" + (R[chiave] === v ? " on" : ""), "aria-pressed": String(R[chiave] === v),
          onclick: () => {
            R[chiave] = v;
            if (passo === 4 || (R.fatto && tutte())) { R.fatto = true; salva("quiz", R); vaiA(5); } else { salva("quiz", R); vaiA(passo + 1); }
          } }, rispostaQuiz(chiave, v)))),
        passo > 0 ? el("button", { type: "button", class: "gas-btn gas-btn--chiaro gas-btn--mini", onclick: () => vaiA(passo - 1) }, "‹ ", t("qz_indietro")) : null,
        riepilogo(passo)]);
      return;
    }
    const scelti = consigliaTelescopi(R), lista = el("div", { class: "gas-qz-lista" });
    provaFatta(3);
    aggiungi(box, [el("p", { class: "gas-qz-domanda" }, t("qz_risultato")), riepilogo(5, true), lista,
      el("div", { class: "gas-riga-bottoni" }, el("button", { type: "button", class: "gas-btn gas-btn--chiaro gas-btn--mini",
        onclick: ricomincia }, icona("reimposta"), " ", t("qz_da_zero")))]);
    if (!scelti.length) { lista.appendChild(el("p", { class: "gas-muto" }, t("qz_nessuno"))); return; }
    const tuttiSopra = scelti.every(v => v.sopra);
    if (tuttiSopra) lista.appendChild(el("p", { class: "gas-nota gas-qz-avviso" }, t("qz_sopra")));
    scelti.forEach((v, i) => {
      const prezzo = el("span", { class: "gas-cm-prezzo" }, euro(Math.round(v.x.prezzo * 100)));
      const nome = el("b", null, v.x.t), vedi = el("a", { class: "gas-btn gas-btn--mini", href: urlProdotto(v.x.h), target: "_blank", rel: "noopener" }, t("qz_vedi"));
      const testo = el("div", { class: "gas-qz-testo" }, nome, prezzo,
        v.sopra && !tuttiSopra ? el("small", { class: "gas-qz-sopra" }, t("qz_sopra_uno")) : null,
        el("ul", { class: "gas-qz-perche" }, v.perche.slice(0, 3).map(p => el("li", null, p))),
        v.soloTubo ? el("small", { class: "gas-muto" }, t(R.uso === "deep" ? "qz_solo_tubo" : "qz_solo_tubo_vis")) : null,
        el("div", { class: "gas-riga-bottoni" }, vedi,
          el("button", { type: "button", class: "gas-btn gas-btn--chiaro gas-btn--mini", onclick: () => { scegliTelescopio(v.x); if (v.soloTubo) apriCalcolatore("carico"); else vai("campo"); } },
            v.soloTubo ? t("qz_carico") : t("qz_prova")),
          v.x.tipo !== "smart" && v.x.completo !== "smart" ? el("button", { type: "button", class: "gas-btn gas-btn--chiaro gas-btn--mini",
            onclick: () => { CALC.D = v.x.D; CALC.F = v.x.F; CALC.k = 1; CALC.scelte.tel = { nome: v.x.t, D: v.x.D, F: v.x.F, h: v.x.h }; salva("calc", CALC); apriCalcolatore("vista"); } }, t("qz_cosa_vedo")) : null,
          bottoneConfronto(v.x.h)));
      prodotto(v.x.h).then(p => {
        if (p && p.price) prezzo.textContent = euro(p.price);
        titoloNegozio(nome, p); segnaNonDisponibile(testo, p);
        if (p === false) vedi.remove();
      }).catch(() => {});
      lista.appendChild(el("div", { class: "gas-qz-voce" + (i === 0 ? " gas-qz-voce--primo" : "") },
        el("span", { class: "gas-qz-pos" }, i === 0 ? `★ ${t("qz_primo")}` : t("qz_n_pos", { n: i + 1 })),
        v.x.foto ? el("img", { src: v.x.foto + (v.x.foto.includes("?") ? "&" : "?") + "width=240", alt: "", width: 96, height: 96, loading: "lazy" }) : el("span", { class: "gas-cm-senza" }, icona("campo")),
        testo));
    });
    const dopo = [];
    if (scelti.length > 1) dopo.push(el("div", { class: "gas-riga-bottoni gas-qz-confronta" }, el("button", { type: "button", class: "gas-btn gas-btn--chiaro gas-btn--mini",
      onclick: () => { CONFRONTO_TEL = scelti.map(v => v.x.h).slice(0, 3); salvaConfronto(); const c = document.querySelector(".gas-tc"); if (c) c.scrollIntoView({ behavior: "smooth", block: "start" }); } }, icona("cx_tc"), " ", t(scelti.length === 2 ? "tc_due" : "tc_tutti"))));
    dopo.push(boxKit(scelti, R));
    lista.after(...dopo);
  }
  disegna();
  return box;
}
function vistaScegli(pannello) {
  svuota(pannello);
  const [n, q] = (location.hash || "").slice(1).split("?");
  let tipo = n === "scegli" && ["telescopio", "camera", "montatura"].includes(q) ? q : n === "scegli" && !schedaAttiva ? "telescopio" : ricorda("scegli_tipo", "telescopio");
  if (!["telescopio", "camera", "montatura"].includes(tipo)) tipo = "telescopio";
  salva("scegli_tipo", tipo);
  if (n === "scegli" && tipo !== "telescopio" && q !== tipo) try { history.replaceState(null, "", "#scegli?" + tipo); } catch (e) {   }
  const corpo = el("div");
  const chip = el("div", { class: "gas-cx-gruppi gas-qx-tipi", role: "group", "aria-label": t("qx_tipo") });
  const come = el("details", { class: "gas-qz-come" }, el("summary", null, t("qz_come")),
    el("ul", { class: "gas-qz-come-lista" }, t("qz_come_t").split("|").map(x => { const i = x.indexOf(": "); return el("li", null, i > 0 ? [el("b", null, x.slice(0, i + 1)), x.slice(i + 1)] : x); })),
    el("p", { class: "gas-nota" }, t("qz_come_n")));
  const disegna = () => {
    for (const b of chip.children) { const on = b.dataset.tipo === tipo; b.classList.toggle("on", on); b.setAttribute("aria-pressed", String(on)); }
    svuota(corpo);
    if (tipo === "camera") corpo.appendChild(cartaQuizCamera());
    else if (tipo === "montatura") corpo.appendChild(cartaQuizMontatura());
    else corpo.append(cartaQuiz(), cartaConfronto());
    come.hidden = tipo !== "telescopio";
  };
  for (const [k, ico] of [["telescopio", "scegli"], ["camera", "camere"], ["montatura", "attrezzatura"]]) {
    chip.appendChild(el("button", { type: "button", class: "gas-cx-chip", dataset: { tipo: k }, onclick: () => {
      tipo = k; salva("scegli_tipo", k);
      try { history.replaceState(null, "", "#scegli" + (k === "telescopio" ? "" : "?" + k)); } catch (e) {   }
      disegna();
    } }, icona(ico), el("span", null, t("qx_" + k))));
  }
  pannello.appendChild(el("div", { class: "gas-qz-pagina" },
    el("p", { class: "gas-nota gas-qz-intro" }, t("qz_intro")), chip, corpo,
    el("div", { class: "gas-qz-sotto" }, come,
      el("a", { class: "gas-btn gas-btn--chiaro gas-btn--mini", href: urlScheda("attrezzatura") + "#attrezzatura",
        onclick: e => { if (e.metaKey || e.ctrlKey || e.shiftKey) return; e.preventDefault(); ATT_APRI = "tel"; vai("attrezzatura", false, true);
          const r = $(".gas-att-acc--tel");
          if (r) { r.scrollIntoView({ block: "start", behavior: "smooth" }); const i = $("input", r); if (i) setTimeout(() => i.focus({ preventScroll: true }), 400); }
          else tornaAllaNav(); } }, icona("attrezzatura"), " ", t("qz_hai_gia")))));
  disegna();
}
function bannerQuiz() {
  return el("a", { class: "gas-qz-banner", href: urlScheda("scegli") + "#scegli", onclick: e => { if (e.metaKey || e.ctrlKey || e.shiftKey) return; e.preventDefault(); salva("scegli_tipo", "telescopio"); vai("scegli"); } },
    el("span", { class: "gas-qz-banner-ico" }, icona("scegli")),
    el("span", { class: "gas-qz-banner-testo" }, el("b", null, t("qz_banner_t")), el("span", null, t("qz_banner_d"))),
    el("span", { class: "gas-btn gas-qz-banner-btn" }, t("qz_banner_b"), " →"));
}
Object.assign(TESTI.it, {
  tc_titolo: "Confronta telescopi", tc_i: "Fino a tre telescopi del negozio fianco a fianco: cosa fanno vedere, quanto pesano e quanto costano. Il campo si calcola con la tua camera e il tuo oculare.",
  tc_cerca: "Aggiungi: Dobson 200, Seestar…", tc_vuoto: "Aggiungi due o tre telescopi da confrontare, oppure tocca «Confronta» nei risultati del quiz.",
  tc_tipo: "Tipo", tc_ottica: "Diametro e focale", tc_montatura: "Montatura", tc_luce: "Luce raccolta", tc_dettagli: "Dettagli più piccoli", tc_stelle: "Stelle più deboli",
  tc_ingr: "Ingrandimento massimo", tc_campo_cam: "Campo con {c}", tc_campo_sua: "camera integrata", tc_campo_oc: "Con {o}", tc_peso: "Peso", tc_prezzo: "Prezzo",
  tc_m_goto: "inclusa, GoTo", tc_m_entry: "inclusa, manuale", tc_m_dobson: "base Dobson inclusa", tc_m_smart: "tutto incluso", tc_m_tubo: "solo il tubo",
  tc_meglio: "In oro il migliore di ogni riga. Luce, dettagli e stelle dipendono dal diametro: più è grande, più vedi.",
  tc_disp: "disponibile", tc_nodisp: "non disponibile", tc_togli: "Togli dal confronto", tc_confronta: "Confronta", tc_nel: "✓ Nel confronto",
  tc_tutti: "Confronta questi tre", tc_oc_tipico: "un oculare da 25 mm", tc_prova: "Prova nel Campo inquadrato",
  tc_t_rifrattore_apo: "Rifrattore apocromatico", tc_t_rifrattore: "Rifrattore", tc_t_newton: "Newton", tc_t_dobson: "Dobson", tc_t_sc: "Schmidt-Cassegrain",
  tc_t_mak: "Maksutov", tc_t_rc: "Ritchey-Chrétien", tc_t_coassiale: "Catadiottrico", tc_t_smart: "Smart telescope", tc_t_solare: "Telescopio solare", tc_t_guida: "Cannocchiale guida", tc_t_altro: "Telescopio",
});
Object.assign(TESTI.de, {
  tc_titolo: "Teleskope vergleichen", tc_i: "Bis zu drei Teleskope aus dem Shop nebeneinander: was sie zeigen, wie viel sie wiegen und was sie kosten. Das Feld wird mit Ihrer Kamera und Ihrem Okular berechnet.",
  tc_cerca: "Hinzufügen: Dobson 200, Seestar…", tc_vuoto: "Fügen Sie zwei oder drei Teleskope hinzu oder tippen Sie in den Quiz-Ergebnissen auf „Vergleichen“.",
  tc_tipo: "Typ", tc_ottica: "Öffnung und Brennweite", tc_montatura: "Montierung", tc_luce: "Lichtsammelleistung", tc_dettagli: "Kleinste Details", tc_stelle: "Schwächste Sterne",
  tc_ingr: "Maximale Vergrößerung", tc_campo_cam: "Feld mit {c}", tc_campo_sua: "integrierte Kamera", tc_campo_oc: "Mit {o}", tc_peso: "Gewicht", tc_prezzo: "Preis",
  tc_m_goto: "dabei, GoTo", tc_m_entry: "dabei, manuell", tc_m_dobson: "Dobson-Basis dabei", tc_m_smart: "alles dabei", tc_m_tubo: "nur der Tubus",
  tc_meglio: "In Gold der beste Wert jeder Zeile. Licht, Details und Sterne hängen von der Öffnung ab: je größer, desto mehr sehen Sie.",
  tc_disp: "lieferbar", tc_nodisp: "nicht lieferbar", tc_togli: "Aus dem Vergleich entfernen", tc_confronta: "Vergleichen", tc_nel: "✓ Im Vergleich",
  tc_tutti: "Diese drei vergleichen", tc_oc_tipico: "einem 25-mm-Okular", tc_prova: "Im Bildfeld testen",
  tc_t_rifrattore_apo: "Apochromatischer Refraktor", tc_t_rifrattore: "Refraktor", tc_t_newton: "Newton", tc_t_dobson: "Dobson", tc_t_sc: "Schmidt-Cassegrain",
  tc_t_mak: "Maksutov", tc_t_rc: "Ritchey-Chrétien", tc_t_coassiale: "Katadioptrisch", tc_t_smart: "Smart-Teleskop", tc_t_solare: "Sonnenteleskop", tc_t_guida: "Leitrohr", tc_t_altro: "Teleskop",
});
Object.assign(TESTI.es, {
  tc_titolo: "Comparar telescopios", tc_i: "Hasta tres telescopios de la tienda lado a lado: qué muestran, cuánto pesan y cuánto cuestan. El campo se calcula con tu cámara y tu ocular.",
  tc_cerca: "Añadir: Dobson 200, Seestar…", tc_vuoto: "Añade dos o tres telescopios para comparar, o toca «Comparar» en los resultados del test.",
  tc_tipo: "Tipo", tc_ottica: "Diámetro y focal", tc_montatura: "Montura", tc_luce: "Luz recogida", tc_dettagli: "Detalles más pequeños", tc_stelle: "Estrellas más débiles",
  tc_ingr: "Aumento máximo", tc_campo_cam: "Campo con {c}", tc_campo_sua: "cámara integrada", tc_campo_oc: "Con {o}", tc_peso: "Peso", tc_prezzo: "Precio",
  tc_m_goto: "incluida, GoTo", tc_m_entry: "incluida, manual", tc_m_dobson: "base Dobson incluida", tc_m_smart: "todo incluido", tc_m_tubo: "solo el tubo",
  tc_meglio: "En oro el mejor de cada fila. Luz, detalles y estrellas dependen del diámetro: cuanto mayor, más ves.",
  tc_disp: "disponible", tc_nodisp: "no disponible", tc_togli: "Quitar de la comparación", tc_confronta: "Comparar", tc_nel: "✓ En la comparación",
  tc_tutti: "Comparar estos tres", tc_oc_tipico: "un ocular de 25 mm", tc_prova: "Probar en Campo de visión",
  tc_t_rifrattore_apo: "Refractor apocromático", tc_t_rifrattore: "Refractor", tc_t_newton: "Newton", tc_t_dobson: "Dobson", tc_t_sc: "Schmidt-Cassegrain",
  tc_t_mak: "Maksutov", tc_t_rc: "Ritchey-Chrétien", tc_t_coassiale: "Catadióptrico", tc_t_smart: "Telescopio inteligente", tc_t_solare: "Telescopio solar", tc_t_guida: "Telescopio guía", tc_t_altro: "Telescopio",
});
Object.assign(TESTI.it, { tc_due: "Confronta questi due" });
Object.assign(TESTI.de, { tc_due: "Diese zwei vergleichen" });
Object.assign(TESTI.es, { tc_due: "Comparar estos dos" });
Object.assign(TESTI.en, { tc_due: "Compare these two" });
function nomiDistinti(lista) {
  const doppi = nomi => nomi.map(n => nomi.filter(m => m === n).length > 1);
  let nomi = lista.map(x => nomeCorto(x.t));
  const d1 = doppi(nomi);
  nomi = nomi.map((n, i) => (d1[i] && String(lista[i].t || "").split(/\s[–—-]\s|,(?!\d)|\s\(/)[0].trim()) || n);
  const d2 = doppi(nomi);
  return nomi.map((n, i) => (d2[i] && lista[i].prezzo ? `${n} · ${euro(Math.round(lista[i].prezzo * 100))}` : n));
}
function nomiNegozio(lista, nodi) {
  if (LINGUA === "it") return;
  Promise.all(lista.map(x => (x.c ? null : prodotto(x.h)))).then(rr => {
    const nomi = nomiDistinti(lista.map((x, i) => ({ t: (rr[i] && rr[i].title) || x.t, prezzo: x.prezzo })));
    nodi.forEach((n, i) => { if (n && rr[i] && rr[i].title) n.textContent = nomi[i]; });
  }).catch(() => {});
}
let CONFRONTO_TEL = (() => { const v = ricorda("confronta_tel", []); return Array.isArray(v) ? v.filter(h => typeof h === "string").slice(0, 3) : []; })();
const CONFRONTO_UI = new Set();
function salvaConfronto() { salva("confronta_tel", CONFRONTO_TEL); for (const f of [...CONFRONTO_UI]) f(); }
function cambiaConfronto(h) {
  const i = CONFRONTO_TEL.indexOf(h);
  if (i >= 0) CONFRONTO_TEL.splice(i, 1);
  else { if (CONFRONTO_TEL.length >= 3) CONFRONTO_TEL.shift(); CONFRONTO_TEL.push(h); }
  salvaConfronto();
}
function bottoneConfronto(h) {
  const b = el("button", { type: "button", class: "gas-btn gas-btn--chiaro gas-btn--mini gas-tc-btn" });
  const disegna = () => {
    if (!b.isConnected && b._mostrato) { CONFRONTO_UI.delete(disegna); return; }
    b._mostrato = true;
    const on = CONFRONTO_TEL.includes(h);
    b.classList.toggle("on", on); b.setAttribute("aria-pressed", String(on));
    b.textContent = on ? t("tc_nel") : "+ " + t("tc_confronta");
  };
  b.addEventListener("click", e => { e.stopPropagation(); cambiaConfronto(h); });
  CONFRONTO_UI.add(disegna);
  disegna();
  return b;
}
function camConfronto() {
  const c = CAMPO.cam && !(CAMPO.tel && CAMPO.tel.smart) ? CAMPO.cam : (ATTREZZI.cam || [])[0];
  return c && (c.mm || (c.w && c.h && c.px)) ? c : null;
}
function ocConfronto() {
  const o = CAMPO.oc || (ATTREZZI.oc || [])[0];
  return o && o.f && o.afov ? { f: o.f, afov: o.afov, nome: nomeCorto(o.nome || `${num(o.f)} mm`) } : { f: 25, afov: 52, nome: t("tc_oc_tipico") };
}
const sensoreMm = c => c.mm || [c.w * c.px / 1000, c.h * c.px / 1000];
function campoTesto(F, c) {
  const [w, h] = sensoreMm(c), a = 2 * Math.atan(w / (2 * F)) * DEG, b = 2 * Math.atan(h / (2 * F)) * DEG;
  return `${angolo(a)} × ${angolo(b)}`;
}
function cartaConfronto() {
  const box = scheda(t("tc_titolo"), el("p", { class: "gas-nota" }, t("tc_i")));
  box.classList.add("gas-tc");
  const cerca = creaCerca({
    segnaposto: t("tc_cerca"),
    cerca: q => cercaTelescopi(q, 40).filter(x => x.h && x.tipo !== "obiettivo" && x.prezzo),
    riga: x => ({ titolo: titoloTelescopio(x), sotto: rigaTelescopio(x), foto: x.foto }),
    scegli: x => { cerca.imposta(""); if (!CONFRONTO_TEL.includes(x.h)) cambiaConfronto(x.h); },
  });
  const corpo = el("div", { class: "gas-tc-corpo" });
  box.append(cerca.box, corpo);
  const disegna = () => {
    if (!box.isConnected && box._mostrato) { CONFRONTO_UI.delete(disegna); return; }
    box._mostrato = true;
    svuota(corpo);
    const tel = CONFRONTO_TEL.map(h => DATI.telescopi.find(x => x.h === h)).filter(Boolean);
    if (!tel.length) { corpo.appendChild(el("p", { class: "gas-muto" }, t("tc_vuoto"))); return; }
    const cam = camConfronto(), oc = ocConfronto();
    const smart = x => x.tipo === "smart" || x.completo === "smart";
    const prezzi = new Map(tel.map(x => [x.h, x.prezzo]));
    const righe = [
      [t("tc_tipo"), x => t("tc_t_" + (TESTI.it["tc_t_" + x.tipo] ? x.tipo : "altro")), null],
      [t("tc_ottica"), x => `${num(x.D)}/${num(x.F)} mm · f/${num(x.F / x.D, 1)}`, null],
      [t("tc_montatura"), x => t("tc_m_" + (smart(x) ? "smart" : x.completo || "tubo")), null],
      [t("tc_luce"), x => `${num((x.D / 7) ** 2)}×`, x => x.D],
      [t("tc_dettagli"), x => `${num(116 / x.D, 2)}″`, x => x.D],
      [t("tc_stelle"), x => `mag ${num(2.7 + 5 * Math.log10(x.D), 1)}`, x => x.D],
      [t("tc_ingr"), x => `${num(Math.min(2 * x.D, 350))}×`, x => Math.min(2 * x.D, 350)],
      [cam ? t("tc_campo_cam", { c: nomeCorto(cam.nome) }) : t("tc_campo_cam", { c: t("tc_campo_sua") }), x => {
        if (smart(x)) { const c = camSmartPer(x.t, x.h); return c && (c.mm || c.px) ? `${campoTesto(c.F || x.F, c)} · ${t("tc_campo_sua")}` : "–"; }
        return cam ? campoTesto(x.F, cam) : "–";
      }, null],
      [t("tc_campo_oc", { o: oc.nome }), x => smart(x) ? "–" : `${num(x.F / oc.f)}× · ${angolo(oc.afov / (x.F / oc.f))}`, null],
      [t("tc_peso"), x => x.kg ? `${num(x.kg, 1)} kg` : "–", x => x.kg ? -x.kg : null],
      [t("tc_prezzo"), null, x => prezzi.get(x.h) ? -prezzi.get(x.h) : null],
    ];
    const celle = [];
    const nomi = nomiDistinti(tel), link = tel.map((x, i) => el("a", { href: urlProdotto(x.h), target: "_blank", rel: "noopener" }, nomi[i]));
    nomiNegozio(tel, link);
    const testa = el("tr", null, el("th", { scope: "col" }), tel.map((x, i) => el("th", { scope: "col" },
      el("div", { class: "gas-tc-testa" },
        x.foto ? el("img", { src: x.foto + (x.foto.includes("?") ? "&" : "?") + "width=200", alt: "", width: 72, height: 72, loading: "lazy" }) : null,
        link[i],
        el("button", { type: "button", class: "gas-tc-togli", "aria-label": `${t("tc_togli")}: ${x.t}`, title: t("tc_togli"), onclick: () => cambiaConfronto(x.h) }, "×")))));
    const corpoTab = el("tbody", null, righe.map(([nome, testo, valore]) => {
      const tr = el("tr", null, el("th", { scope: "row" }, nome));
      const td = tel.map(x => {
        const cella = el("td", null);
        if (testo) cella.textContent = testo(x);
        else {
          const p = el("b", null, x.prezzo ? euro(Math.round(x.prezzo * 100)) : "–"), d = el("small", null, "");
          cella.append(p, el("br"), d);
          prodotto(x.h).then(r => {
            if (!r) return;
            if (r.price) { p.textContent = euro(r.price); prezzi.set(x.h, r.price / 100); evidenzia(); }
            d.textContent = r.available ? t("tc_disp") : t("tc_nodisp");
            d.className = r.available ? "gas-tc-si" : "gas-tc-no";
          });
        }
        tr.appendChild(cella);
        return cella;
      });
      if (valore) celle.push([valore, td]);
      return tr;
    }));
    function evidenzia() {
      for (const [valore, td] of celle) {
        const v = tel.map(valore), validi = v.filter(x => x != null);
        const max = validi.length > 1 ? Math.max(...validi) : null, tutti = validi.every(x => x === max);
        td.forEach((c, i) => c.classList.toggle("gas-tc-meglio", max != null && !tutti && v[i] === max));
      }
    }
    evidenzia();
    const piede = el("tr", null, el("td"), tel.map(x => el("td", null, el("div", { class: "gas-tc-azioni" },
      el("a", { class: "gas-btn gas-btn--mini", href: urlProdotto(x.h), target: "_blank", rel: "noopener" }, t("qz_vedi")),
      el("button", { type: "button", class: "gas-btn gas-btn--chiaro gas-btn--mini", onclick: () => { scegliTelescopio(x); vai("campo"); } }, t("tc_prova"))))));
    corpo.append(el("div", { class: "gas-tc-scorri" }, el("table", { class: "gas-tc-tab gas-tc-tab--" + tel.length }, el("thead", null, testa), corpoTab, el("tfoot", null, piede))),
      el("p", { class: "gas-nota" }, t("tc_meglio")));
  };
  CONFRONTO_UI.add(disegna);
  disegna();
  return box;
}
Object.assign(TESTI.it, {
  kit_titolo: "Il kit completo", kit_i: "Quello che serve per cominciare, scelto fra i prodotti disponibili nel negozio. Togli la spunta a quello che hai già.",
  kit_per: "Kit per", kit_carico: "Preparo il kit…", kit_r_tel: "Il telescopio",
  kit_r_oc_medio: "Oculare per galassie, nebulose e ammassi ({m}×)", kit_r_oc_pianeti: "Oculare per pianeti e Luna ({m}×)",
  kit_r_barlow: "Barlow 2×: raddoppia gli ingrandimenti di ogni oculare", kit_r_luna: "Filtro lunare: la Luna piena non abbaglia",
  kit_r_neb: "Filtro nebulare: le nebulose risaltano anche con un po' di luce intorno", kit_r_mont: "Montatura motorizzata: regge tubo, camera e accessori ({p} kg di portata)",
  kit_r_cam: "Camera a colori: {s}″/px con questo tubo", kit_r_spian: "Spianatore o riduttore: stelle tonde fino agli angoli", kit_r_filtro: "Filtro dual band: nebulose anche dal cielo di città",
  kit_n_spian: "Molti apocromatici vogliono uno spianatore dedicato: chiedici quello giusto per questo tubo.",
  kit_n_pc: "Per comandare camera e montatura serve anche un computer o un ASIAIR (piccolo computer ZWO che si comanda dal telefono).", kit_n_smart: "Non serve altro: camera, montatura e filtri sono già dentro, e si comanda dal telefono.",
  kit_n_incluso: "Montatura e un oculare base sono già nella confezione.", kit_totale: "Totale", kit_pezzi: "{n} prodotti",
  kit_carrello: "Aggiungi tutto al carrello", kit_fatto: "✓ Nel carrello", kit_vai: "Vai al carrello →", kit_errore: "Non sono riuscito ad aggiungerli: riprova o aggiungili dalle loro schede.",
  kit_nessuno: "nessun prodotto adatto disponibile adesso",
});
Object.assign(TESTI.de, {
  kit_titolo: "Das komplette Set", kit_i: "Was Sie für den Start brauchen, ausgewählt aus lieferbaren Produkten des Shops. Entfernen Sie den Haken bei dem, was Sie schon haben.",
  kit_per: "Set für", kit_carico: "Set wird zusammengestellt…", kit_r_tel: "Das Teleskop",
  kit_r_oc_medio: "Okular für Galaxien, Nebel und Haufen ({m}×)", kit_r_oc_pianeti: "Okular für Planeten und Mond ({m}×)",
  kit_r_barlow: "Barlow 2×: verdoppelt die Vergrößerung jedes Okulars", kit_r_luna: "Mondfilter: der Vollmond blendet nicht",
  kit_r_neb: "Nebelfilter: Nebel treten auch bei etwas Umgebungslicht hervor", kit_r_mont: "Motorisierte Montierung: trägt Tubus, Kamera und Zubehör ({p} kg Tragkraft)",
  kit_r_cam: "Farbkamera: {s}″/px mit diesem Tubus", kit_r_spian: "Flattener oder Reducer: runde Sterne bis in die Ecken", kit_r_filtro: "Dualband-Filter: Nebel auch vom Stadthimmel",
  kit_n_spian: "Viele Apochromaten brauchen einen eigenen Flattener: fragen Sie uns nach dem richtigen für diesen Tubus.",
  kit_n_pc: "Zur Steuerung von Kamera und Montierung braucht es auch einen Computer oder ein ASIAIR.", kit_n_smart: "Mehr braucht es nicht: Kamera, Montierung und Filter sind schon drin, gesteuert vom Handy.",
  kit_n_incluso: "Montierung und ein einfaches Okular sind schon im Lieferumfang.", kit_totale: "Gesamt", kit_pezzi: "{n} Produkte",
  kit_carrello: "Alles in den Warenkorb", kit_fatto: "✓ Im Warenkorb", kit_vai: "Zum Warenkorb →", kit_errore: "Das hat nicht geklappt: versuchen Sie es erneut oder fügen Sie sie von den Produktseiten hinzu.",
  kit_nessuno: "gerade kein passendes Produkt lieferbar",
});
Object.assign(TESTI.es, {
  kit_titolo: "El kit completo", kit_i: "Lo que hace falta para empezar, elegido entre los productos disponibles en la tienda. Desmarca lo que ya tienes.",
  kit_per: "Kit para", kit_carico: "Preparando el kit…", kit_r_tel: "El telescopio",
  kit_r_oc_medio: "Ocular para galaxias, nebulosas y cúmulos ({m}×)", kit_r_oc_pianeti: "Ocular para planetas y Luna ({m}×)",
  kit_r_barlow: "Barlow 2×: duplica los aumentos de cada ocular", kit_r_luna: "Filtro lunar: la Luna llena no deslumbra",
  kit_r_neb: "Filtro nebular: las nebulosas destacan aunque haya algo de luz", kit_r_mont: "Montura motorizada: aguanta tubo, cámara y accesorios ({p} kg de capacidad)",
  kit_r_cam: "Cámara en color: {s}″/px con este tubo", kit_r_spian: "Aplanador o reductor: estrellas redondas hasta las esquinas", kit_r_filtro: "Filtro dual band: nebulosas también desde la ciudad",
  kit_n_spian: "Muchos apocromáticos necesitan un aplanador propio: pregúntanos el adecuado para este tubo.",
  kit_n_pc: "Para manejar cámara y montura también hace falta un ordenador o un ASIAIR.", kit_n_smart: "No hace falta nada más: cámara, montura y filtros ya están dentro, y se maneja desde el móvil.",
  kit_n_incluso: "La montura y un ocular básico ya vienen en la caja.", kit_totale: "Total", kit_pezzi: "{n} productos",
  kit_carrello: "Añadir todo al carrito", kit_fatto: "✓ En el carrito", kit_vai: "Ir al carrito →", kit_errore: "No he podido añadirlos: inténtalo de nuevo o añádelos desde sus fichas.",
  kit_nessuno: "ningún producto adecuado disponible ahora",
});
const misura125 = s => !/(^|[^\d])(2\s?("|''|”|pollici|inch)|50[,.]8)/i.test(String(s || ""));
const motorizzata = m => /goto|go-to|synscan|harmonic|armonica|\bam\d|\bcem\d|\bgem\d|\bcgx|\bcgem|\bavx|advanced vx|\beq6|\beq8|\bheq5|\beqm|\bwave|\bcq350|\beq-al55i/i.test(m.t);
const bundleConTelescopio = m => eBundle(m) && /rcn\d|telescop|newton|rifratt|\b\d{2,3}\/\d{3,4}\b/i.test(m.t);
Object.assign(TESTI.it, { kit_r_mont_vis: "Montatura: regge il tubo con oculari e accessori ({p} kg di portata)",
  kit_n_diagonale: "Per guardare comodamente con questo tubo serve anche un diagonale (il raccordo che piega la luce di 90° verso l'oculare), se non è nella confezione: chiedici quello giusto.",
  kit_rete: "Non riesco a leggere prezzi e disponibilità dal negozio: controlla la connessione e riprova.", kit_riprova: "Riprova" });
Object.assign(TESTI.de, { kit_r_mont_vis: "Montierung: trägt den Tubus mit Okularen und Zubehör ({p} kg Tragkraft)",
  kit_n_diagonale: "Für bequemes Beobachten mit diesem Tubus braucht es auch einen Zenitspiegel, falls keiner dabei ist: fragen Sie uns nach dem passenden.",
  kit_rete: "Preise und Verfügbarkeit des Shops lassen sich gerade nicht laden: prüfen Sie die Verbindung und versuchen Sie es erneut.", kit_riprova: "Erneut versuchen" });
Object.assign(TESTI.es, { kit_r_mont_vis: "Montura: aguanta el tubo con oculares y accesorios ({p} kg de capacidad)",
  kit_n_diagonale: "Para observar cómodo con este tubo también hace falta un diagonal, si no viene en la caja: pregúntanos el adecuado.",
  kit_rete: "No consigo leer los precios y la disponibilidad de la tienda: comprueba la conexión y vuelve a intentarlo.", kit_riprova: "Reintentar" });
Object.assign(TESTI.en, { kit_r_mont_vis: "Mount: carries the tube with eyepieces and accessories ({p} kg capacity)",
  kit_n_diagonale: "To observe comfortably with this tube you'll also need a star diagonal, if there isn't one in the box: ask us for the right one.",
  kit_rete: "I can't load prices and availability from the shop: check your connection and try again.", kit_riprova: "Try again" });
function pezziKit(x, R) {
  const N = x.F / x.D, prezzo = x.prezzo || 500, pezzi = [], note = [];
  const smart = x.tipo === "smart" || x.completo === "smart";
  if (smart) { note.push(t("kit_n_smart")); return { pezzi, note }; }
  const vicino = (f, lista) => lista.filter(o => o.f >= f * 0.78 && o.f <= f * 1.28 && o.bar !== "2" && misura125(o.t))
    .sort((a, b) => Math.abs(a.f - f) - Math.abs(b.f - f)).slice(0, 8);
  const tubo = () => x.kg || pesoTubo({ nome: x.t, D: x.D, h: x.h }).kg || 3;
  if (x.completo || R.uso !== "deep") {
    if (x.completo) note.push(t("kit_n_incluso"));
    else {
      const carico = tubo() + 1;
      const mont = DATI.montature.filter(m => m.kg_portata && !bundleConTelescopio(m) && !/testa equatoriale|wedge|cuneo/i.test(m.t) && carico <= m.kg_portata * 0.8)
        .sort((a, b) => a.kg_portata - b.kg_portata).slice(0, 8);
      pezzi.push({ ruolo: "mont", testo: t("kit_r_mont_vis", { p: mont[0] ? num(mont[0].kg_portata) : "–" }), candidati: mont, tetto: 2600, testoDi: m => t("kit_r_mont_vis", { p: num(m.kg_portata) }) });
      if (!/newton|dobson/.test(x.tipo)) note.push(t("kit_n_diagonale"));
    }
    const tettoOc = clamp(prezzo * 0.15, 45, 160);
    const fMedio = clamp(2 * N, 7, 30), fPianeti = Math.max(N, x.F / Math.min(2 * x.D, 250));
    pezzi.push({ ruolo: "oc_medio", testo: t("kit_r_oc_medio", { m: num(x.F / fMedio) }), candidati: vicino(fMedio, DATI.oculari), tetto: tettoOc });
    if (R.uso !== "deep") pezzi.push({ ruolo: "oc_pianeti", testo: t("kit_r_oc_pianeti", { m: num(x.F / fPianeti) }), candidati: vicino(fPianeti, DATI.oculari), tetto: tettoOc });
    if (R.uso === "pianeti" || R.uso === "tutto") pezzi.push({ ruolo: "barlow", testo: t("kit_r_barlow"),
      candidati: DATI.ottiche.filter(o => o.tipo === "barlow" && o.k >= 1.8 && o.k <= 2.6 && misura125(o.t)).slice(0, 8), tetto: 90 });
    const daOculare = f => misura125(f.misura + " " + f.t) && !/clip/i.test(f.misura + " " + f.t);
    pezzi.push({ ruolo: "luna", testo: t("kit_r_luna"), candidati: DATI.filtri.filter(f => f.tipo === "luna" && daOculare(f)), tetto: 50 });
    if (x.D >= 130 && R.uso !== "pianeti") pezzi.push({ ruolo: "neb", testo: t("kit_r_neb"),
      candidati: DATI.filtri.filter(f => (f.tipo === "uhc" || f.tipo === "oiii") && daOculare(f)).sort((a, b) => (a.tipo === "uhc" ? 0 : 1) - (b.tipo === "uhc" ? 0 : 1)), tetto: 170 });
    return { pezzi, note };
  }
  const carico = tubo() + 0.7 + 1.5;
  const mont = DATI.montature.filter(m => m.tipo !== "altaz" && motorizzata(m) && carico <= m.kg_portata * (m.tipo === "armonica" ? 0.7 : 0.5))
    .sort((a, b) => a.kg_portata - b.kg_portata).slice(0, 8);
  pezzi.push({ ruolo: "mont", testo: t("kit_r_mont", { p: mont[0] ? num(mont[0].kg_portata) : "–" }), candidati: mont, tetto: 2600, testoDi: m => t("kit_r_mont", { p: num(m.kg_portata) }) });
  const scala = c => 206.265 * c.px / x.F, tettoCam = clamp(prezzo * 1.3, 450, 2200), prezziCam = DATI.camerePrezzi || {};
  const camere = DATI.camere.filter(c => c.h_negozio && ["raffreddata", "non_raffreddata"].includes(c.cat) && c.col !== "mono" && c.px && scala(c) >= 1 && scala(c) <= 2.6 &&
      (!prezziCam[c.h_negozio] || (prezziCam[c.h_negozio][1] && prezziCam[c.h_negozio][0] <= tettoCam)))
    .sort((a, b) => (R.esp === "esperto" ? 0 : (a.cat === "non_raffreddata" ? 0 : 1) - (b.cat === "non_raffreddata" ? 0 : 1)) || Math.abs(scala(a) - 1.8) - Math.abs(scala(b) - 1.8))
    .slice(0, 8).map(c => ({ h: c.h_negozio, t: c.nome, foto: c.foto, scala: scala(c) }));
  pezzi.push({ ruolo: "cam", testo: t("kit_r_cam", { s: `${num(1)}–${num(2.6, 1)}` }), candidati: camere, tetto: tettoCam, testoDi: c => t("kit_r_cam", { s: num(c.scala, 1) }) });
  const numeri = (String(x.t).match(/\b\d{2,3}\b/g) || []).filter(n => +n >= 50 && +n <= 160);
  const spian = /spianat|flattener|quadrupl|petzval|redcat|\bfra\d|\bfma\d|esprit/i.test(x.t) ? [] :
    DATI.ottiche.filter(o => (o.tipo === "spianatore" || o.tipo === "riduttore") && o.v === x.v && numeri.some(n => new RegExp(`\\b${n}\\b`).test(o.t)));
  if (spian.length) pezzi.push({ ruolo: "spian", testo: t("kit_r_spian"), candidati: spian.slice(0, 6), tetto: 600 });
  else if (!/spianat|flattener|quadrupl|petzval|redcat|\bfra\d|\bfma\d|esprit/i.test(x.t)) note.push(t("kit_n_spian"));
  if (R.luogo === "citta") pezzi.push({ ruolo: "filtro", testo: t("kit_r_filtro"), candidati: DATI.filtri.filter(f => f.tipo === "dual" && !/clip/i.test(f.misura + f.t)), tetto: 380 });
  note.push(t("kit_n_pc"));
  return { pezzi, note };
}
async function risolviKit(pezzi) {
  return Promise.all(pezzi.map(async p => {
    const letti = await Promise.all(p.candidati.map(c => prodotto(c.h).then(r => ({ c, r }))));
    const ok = letti.filter(v => v.r && v.r.available && v.r.price);
    const scelto = ok.find(v => v.r.price / 100 <= p.tetto) || null;
    return scelto ? Object.assign({}, p, { c: scelto.c, r: scelto.r, testo: p.testoDi ? p.testoDi(scelto.c) : p.testo }) : Object.assign({}, p, { c: null });
  }));
}
function boxKit(scelti, R, opz) {
  opz = Object.assign({ pezzi: pezziKit, principale: t("kit_r_tel") }, opz || {});
  const box = el("section", { class: "gas-kit" });
  let quale = 0, giro = 0;
  const disegna = async () => {
    const mio = ++giro, v = scelti[quale], x = v.x;
    svuota(box).append(el("h4", { class: "gas-kit-titolo" }, "🧰 ", t("kit_titolo")), el("p", { class: "gas-nota" }, t("kit_i")));
    if (scelti.length > 1) {
      const nomi = nomiDistinti(scelti.map(s => s.x)), pillole = scelti.map((s, i) => el("button", { type: "button", class: "gas-cx-chip gas-cx-chip--mini" + (i === quale ? " on" : ""),
        "aria-pressed": String(i === quale), onclick: () => { quale = i; disegna(); } }, nomi[i]));
      box.appendChild(el("div", { class: "gas-kit-scegli", role: "group", "aria-label": t("kit_per") }, el("small", null, t("kit_per")), pillole));
      nomiNegozio(scelti.map(s => s.x), pillole);
    }
    const lista = el("div", { class: "gas-kit-lista" }, el("p", { class: "gas-muto" }, t("kit_carico")));
    box.appendChild(lista);
    const { pezzi, note } = opz.pezzi(x, R);
    const [tel, risolti] = await Promise.all([prodotto(x.h), risolviKit(pezzi)]);
    if (mio !== giro) return;
    svuota(lista);
    if (tel === null && risolti.every(p => !p.c)) {
      lista.append(el("p", { class: "gas-nota" }, t("kit_rete")), el("div", { class: "gas-riga-bottoni" }, el("button", { type: "button", class: "gas-btn gas-btn--chiaro gas-btn--mini",
        onclick: async () => { if (typeof _prezzi !== "undefined") for (const [h, q] of [..._prezzi]) if (await q === null) _prezzi.delete(h); disegna(); } }, icona("reimposta"), " ", t("kit_riprova"))));
      return;
    }
    const esaurito = tel === false || !!(tel && tel.available === false);
    const voci = [{ ruolo: "tel", testo: esaurito ? `${opz.principale} · ${t("qz_nodisp")}` : opz.principale, c: { h: x.h, t: x.t, foto: x.foto }, r: tel, fisso: true, on: !esaurito }, ...risolti];
    const totale = el("b", null, ""), conta = el("small", null, "");
    let messo = false, inVolo = false;
    const aggiorna = () => {
      const dentro = voci.filter(p => p.c && p.r && p.on !== false);
      totale.textContent = euro(dentro.reduce((s, p) => s + (p.r.price || 0), 0));
      conta.textContent = t("kit_pezzi", { n: dentro.length });
      if (!messo && !inVolo) carrello.disabled = !dentro.length;
    };
    for (const p of voci) {
      if (!p.c) { lista.appendChild(el("div", { class: "gas-kit-voce gas-kit-voce--vuota" }, el("span", { class: "gas-kit-ruolo" }, p.testo), el("small", { class: "gas-muto" }, t("kit_nessuno")))); continue; }
      const spunta = el("input", { type: "checkbox", checked: p.on !== false, disabled: !!p.fisso, "aria-label": p.c.t });
      spunta.addEventListener("change", () => { p.on = spunta.checked; riga.classList.toggle("gas-kit-voce--fuori", !spunta.checked); aggiorna(); });
      const foto = p.c.foto || (p.r && p.r.featured_image);
      const riga = el("label", { class: "gas-kit-voce" + (p.on === false ? " gas-kit-voce--fuori" : "") }, spunta,
        foto ? el("img", { src: foto + (foto.includes("?") ? "&" : "?") + "width=120", alt: "", width: 52, height: 52, loading: "lazy" }) : el("span", { class: "gas-kit-senza" }),
        el("span", { class: "gas-kit-testo" }, el("small", null, p.testo), el("a", { href: urlProdotto(p.c.h), target: "_blank", rel: "noopener" }, (p.r && p.r.title) || p.c.t)),
        el("b", { class: "gas-kit-prezzo" }, p.r && p.r.price ? euro(p.r.price) : "–"));
      lista.appendChild(riga);
    }
    const esito = el("p", { class: "gas-nota", hidden: true });
    const carrello = el("button", { type: "button", class: "gas-btn gas-kit-carrello", onclick: async () => {
      const scelti = voci.filter(p => p.c && p.r && p.on !== false);
      const items = scelti.map(p => { const va = (p.r.variants || []).find(z => z.available) || (p.r.variants || [])[0];
        return va ? { id: va.id, quantity: 1 } : null; }).filter(Boolean);
      if (!items.length || inVolo) return;
      inVolo = true; carrello.disabled = true;
      try {
        const r = await fetch(`${RADICE_URL.replace(/\/?$/, "/")}cart/add.js`, { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items }) });
        if (!r.ok) throw new Error(String(r.status));
        segnaDaStrumenti(...scelti.filter(p => p.r.handle).map(p => "kit:" + p.r.handle));
        messo = true; carrello.textContent = t("kit_fatto");
        svuota(esito).append(el("a", { href: `${RADICE_URL.replace(/\/?$/, "/")}cart` }, t("kit_vai")));
        esito.hidden = false;
        document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
      } catch (e) {
        carrello.disabled = false;
        esito.textContent = t("kit_errore"); esito.hidden = false;
      } finally { inVolo = false; }
    } }, icona("carrello"), " ", t("kit_carrello"));
    aggiorna();
    aggiungi(box, [el("div", { class: "gas-kit-totale" }, el("span", null, t("kit_totale"), " ", conta), totale),
      note.length ? el("ul", { class: "gas-kit-note" }, note.map(n => el("li", null, n))) : null, carrello, esito]);
  };
  disegna();
  return box;
}
Object.assign(TESTI.it, {
  qc_titolo: "Quale camera fa per me?", qc_n: "Cinque domande e ti consigliamo tre camere del negozio, scelte per il tuo telescopio e il tuo cielo.",
  qc_d_uso: "Cosa vuoi fotografare?", qc_uso_deep: "Nebulose e galassie", qc_uso_pianeti: "Pianeti, Luna e Sole", qc_uso_entrambi: "Un po' di tutto", qc_uso_guida: "Mi serve una camera per la guida",
  qc_d_tel: "Con quale telescopio?", qc_tel_mio: "Il mio: {n}", qc_tel_corto: "Obiettivo o telescopio corto (focale fino a 500 mm)", qc_tel_medio: "Telescopio medio (500–1200 mm)",
  qc_tel_lungo: "Focale lunga (oltre 1200 mm)", qc_tel_nonso: "Non lo so ancora",
  qc_d_col: "A colori o in bianco e nero?", qc_col_colore: "A colori: una ripresa sola, più semplice", qc_col_mono: "Monocromatica con i filtri: più dettaglio", qc_col_nonso: "Consigliami tu",
  qc_d_budget: "Quanto vuoi spendere per la camera?", qc_b_300: "Fino a 300 €", qc_b_800: "300 – 800 €", qc_b_1600: "800 – 1.600 €", qc_b_max: "Oltre 1.600 €",
  qc_d_esp: "Che esperienza hai?", qc_e_prima: "È la mia prima camera astronomica", qc_e_ho: "Ne ho già usata una", qc_e_esperto: "Sono esperto",
  qc_risultato: "Le camere giuste per te", qc_nessuno: "Con queste risposte non troviamo una camera disponibile: prova ad alzare il budget.",
  qc_r_sensore: "Sensore {s}: {mp} MP, pixel {px} µm", qc_r_scala: "{s}″/px con {t}: {g}", qc_r_raff: "Raffreddata: molto meno rumore nelle pose lunghe",
  qc_r_nonraff: "Non raffreddata: leggera e semplice, bene per pose brevi e per i pianeti", qc_r_planet: "Veloce e con pixel piccoli: tanti fotogrammi al secondo per i pianeti",
  qc_r_guida: "Sensibile e leggera: fatta per l'autoguida", qc_r_colore: "A colori: niente ruota portafiltri, una ripresa e hai la foto", qc_r_mono: "Monocromatica: più dettaglio e banda stretta, con i filtri",
  qc_g_ok: "campionamento giusto", qc_g_sovra: "un po' troppo fine: puoi usare il binning (unire i pixel a gruppi, dalle impostazioni della camera)", qc_g_sotto: "campo largo, stelle un po' quadrate",
  qc_principale: "La camera", qc_k_dual: "Filtro dual band: nebulose anche dal cielo di città", qc_k_ha: "Filtro Hα per le nebulose", qc_k_oiii: "Filtro OIII", qc_k_sii: "Filtro SII",
  qc_k_barlow: "Barlow per arrivare al rapporto focale giusto per i pianeti", qc_k_uvir: "Filtro UV/IR cut: colori giusti e stelle più nitide",
  qc_k_guida: "Cannocchiale guida da abbinare", qc_n_ruota: "Per i filtri della camera monocromatica serve anche una ruota portafiltri.",
  qc_n_pc: "Per comandarla serve un computer o un ASIAIR.", qc_vedi: "Vedi nel negozio", qc_prova: "Prova nel Campo inquadrato",
  qm_titolo: "Quale montatura fa per me?", qm_n: "Cinque domande e ti consigliamo tre montature del negozio che reggono davvero il tuo telescopio.",
  qm_d_carico: "Cosa ci metti sopra?", qm_c_mio: "Il mio: {n} (circa {kg} kg)", qm_c_smart: "Smart telescope o obiettivo (fino a 3 kg)", qm_c_piccolo: "Rifrattore piccolo (3–6 kg)",
  qm_c_medio: "Telescopio medio (6–12 kg)", qm_c_grande: "Telescopio grande (12–20 kg)", qm_c_molto: "Oltre 20 kg",
  qm_d_uso: "Per cosa la usi?", qm_uso_visuale: "Per osservare", qm_uso_foto: "Per fotografare nebulose e galassie", qm_uso_entrambi: "Per tutte e due",
  qm_d_dove: "Quanto la sposti?", qm_dove_fisso: "Postazione fissa o giardino", qm_dove_auto: "La porto in auto", qm_dove_viaggio: "In viaggio, anche in aereo",
  qm_d_budget: "Quanto vuoi spendere per la montatura?", qm_b_600: "Fino a 600 €", qm_b_1500: "600 – 1.500 €", qm_b_3000: "1.500 – 3.000 €", qm_b_max: "Oltre 3.000 €",
  qm_d_esp: "Che esperienza hai?", qm_e_prima: "È la mia prima montatura", qm_e_ho: "Ne ho già usata una", qm_e_esperto: "Sono esperto",
  qm_risultato: "Le montature giuste per te", qm_nessuno: "Con queste risposte non troviamo una montatura disponibile: prova a cambiare carico o budget.",
  qm_r_portata: "Porta {p} kg{cp} · il tuo carico di {c} kg: {u} % della portata", qm_r_cp: " ({p} kg con contrappeso)", qm_r_armonica: "Armonica: niente contrappesi, leggera da portare",
  qm_r_eq: "Equatoriale: robusta e precisa per le pose lunghe", qm_r_altaz: "Altazimutale: semplice e veloce per osservare (non per le pose lunghe)",
  qm_r_goto: "GoTo: trova da sola gli oggetti e li segue", qm_r_leggera: "Pesa {kg} kg: si porta bene", qm_principale: "La montatura",
  qm_k_guida: "Cannocchiale guida: stelle puntiformi nelle pose lunghe", qm_k_camguida: "Camera guida", qm_n_treppiede: "Si vende senza treppiede: serve anche un treppiede o una colonna.",
  qm_n_guida: "Per allineare la montatura al polo e per la guida automatica serve un computer con il programma PHD2 o un ASIAIR (piccolo computer ZWO che si comanda dal telefono).", qm_calcola: "Calcola il carico",
  qx_tipo: "Cosa vuoi scegliere?", qx_telescopio: "Telescopio", qx_camera: "Camera", qx_montatura: "Montatura",
});
Object.assign(TESTI.de, {
  qc_titolo: "Welche Kamera passt zu mir?", qc_n: "Fünf Fragen, und wir empfehlen drei Kameras aus dem Shop, passend zu Ihrem Teleskop und Ihrem Himmel.",
  qc_d_uso: "Was möchten Sie fotografieren?", qc_uso_deep: "Nebel und Galaxien", qc_uso_pianeti: "Planeten, Mond und Sonne", qc_uso_entrambi: "Ein bisschen von allem", qc_uso_guida: "Ich brauche eine Guidingkamera",
  qc_d_tel: "Mit welchem Teleskop?", qc_tel_mio: "Meins: {n}", qc_tel_corto: "Objektiv oder kurzes Teleskop (bis 500 mm)", qc_tel_medio: "Mittleres Teleskop (500–1200 mm)",
  qc_tel_lungo: "Lange Brennweite (über 1200 mm)", qc_tel_nonso: "Weiß ich noch nicht",
  qc_d_col: "Farbe oder Schwarzweiß?", qc_col_colore: "Farbe: eine Aufnahme, einfacher", qc_col_mono: "Monochrom mit Filtern: mehr Details", qc_col_nonso: "Empfehlen Sie mir etwas",
  qc_d_budget: "Wie viel möchten Sie für die Kamera ausgeben?", qc_b_300: "Bis 300 €", qc_b_800: "300 – 800 €", qc_b_1600: "800 – 1.600 €", qc_b_max: "Über 1.600 €",
  qc_d_esp: "Welche Erfahrung haben Sie?", qc_e_prima: "Meine erste Astrokamera", qc_e_ho: "Ich hatte schon eine", qc_e_esperto: "Ich bin erfahren",
  qc_risultato: "Die richtigen Kameras für Sie", qc_nessuno: "Mit diesen Antworten finden wir keine lieferbare Kamera: erhöhen Sie das Budget.",
  qc_r_sensore: "Sensor {s}: {mp} MP, Pixel {px} µm", qc_r_scala: "{s}″/px mit {t}: {g}", qc_r_raff: "Gekühlt: viel weniger Rauschen bei langen Belichtungen",
  qc_r_nonraff: "Ungekühlt: leicht und einfach, gut für kurze Belichtungen und Planeten", qc_r_planet: "Schnell und mit kleinen Pixeln: viele Bilder pro Sekunde für Planeten",
  qc_r_guida: "Empfindlich und leicht: für das Autoguiding gemacht", qc_r_colore: "Farbe: kein Filterrad, eine Aufnahme und das Foto ist fertig", qc_r_mono: "Monochrom: mehr Details und Schmalband, mit Filtern",
  qc_g_ok: "passende Abtastung", qc_g_sovra: "etwas zu fein, Binning möglich", qc_g_sotto: "weites Feld, Sterne etwas eckig",
  qc_principale: "Die Kamera", qc_k_dual: "Dualband-Filter: Nebel auch vom Stadthimmel", qc_k_ha: "Hα-Filter für Nebel", qc_k_oiii: "OIII-Filter", qc_k_sii: "SII-Filter",
  qc_k_barlow: "Barlow für das richtige Öffnungsverhältnis bei Planeten", qc_k_uvir: "UV/IR-Sperrfilter: richtige Farben und schärfere Sterne",
  qc_k_guida: "Passendes Leitrohr", qc_n_ruota: "Für die Filter der Monochromkamera braucht es auch ein Filterrad.",
  qc_n_pc: "Zur Steuerung braucht es einen Computer oder ein ASIAIR.", qc_vedi: "Im Shop ansehen", qc_prova: "Im Bildfeld testen",
  qm_titolo: "Welche Montierung passt zu mir?", qm_n: "Fünf Fragen, und wir empfehlen drei Montierungen aus dem Shop, die Ihr Teleskop wirklich tragen.",
  qm_d_carico: "Was setzen Sie darauf?", qm_c_mio: "Meins: {n} (etwa {kg} kg)", qm_c_smart: "Smart-Teleskop oder Objektiv (bis 3 kg)", qm_c_piccolo: "Kleiner Refraktor (3–6 kg)",
  qm_c_medio: "Mittleres Teleskop (6–12 kg)", qm_c_grande: "Großes Teleskop (12–20 kg)", qm_c_molto: "Über 20 kg",
  qm_d_uso: "Wofür nutzen Sie sie?", qm_uso_visuale: "Zum Beobachten", qm_uso_foto: "Für Deep-Sky-Fotos", qm_uso_entrambi: "Für beides",
  qm_d_dove: "Wie oft bewegen Sie sie?", qm_dove_fisso: "Fester Standort oder Garten", qm_dove_auto: "Ich nehme sie im Auto mit", qm_dove_viaggio: "Auf Reisen, auch im Flugzeug",
  qm_d_budget: "Wie viel möchten Sie für die Montierung ausgeben?", qm_b_600: "Bis 600 €", qm_b_1500: "600 – 1.500 €", qm_b_3000: "1.500 – 3.000 €", qm_b_max: "Über 3.000 €",
  qm_d_esp: "Welche Erfahrung haben Sie?", qm_e_prima: "Meine erste Montierung", qm_e_ho: "Ich hatte schon eine", qm_e_esperto: "Ich bin erfahren",
  qm_risultato: "Die richtigen Montierungen für Sie", qm_nessuno: "Mit diesen Antworten finden wir keine lieferbare Montierung: ändern Sie Last oder Budget.",
  qm_r_portata: "Trägt {p} kg{cp} · Ihre Last von {c} kg: {u} % der Tragfähigkeit", qm_r_cp: " ({p} kg mit Gegengewicht)", qm_r_armonica: "Harmonic: keine Gegengewichte, leicht zu tragen",
  qm_r_eq: "Äquatorial: robust und präzise für lange Belichtungen", qm_r_altaz: "Azimutal: einfach und schnell zum Beobachten (nicht für lange Belichtungen)",
  qm_r_goto: "GoTo: findet die Objekte selbst und führt nach", qm_r_leggera: "Wiegt {kg} kg: gut zu transportieren", qm_principale: "Die Montierung",
  qm_k_guida: "Leitrohr: punktförmige Sterne bei langen Belichtungen", qm_k_camguida: "Guidingkamera", qm_n_treppiede: "Wird ohne Stativ verkauft: es braucht auch ein Stativ oder eine Säule.",
  qm_n_guida: "Für Einnordung und Guiding braucht es einen Computer mit PHD2 oder ein ASIAIR.", qm_calcola: "Last berechnen",
  qx_tipo: "Was möchten Sie wählen?", qx_telescopio: "Teleskop", qx_camera: "Kamera", qx_montatura: "Montierung",
});
Object.assign(TESTI.es, {
  qc_titolo: "¿Qué cámara es para mí?", qc_n: "Cinco preguntas y te recomendamos tres cámaras de la tienda, elegidas para tu telescopio y tu cielo.",
  qc_d_uso: "¿Qué quieres fotografiar?", qc_uso_deep: "Nebulosas y galaxias", qc_uso_pianeti: "Planetas, Luna y Sol", qc_uso_entrambi: "Un poco de todo", qc_uso_guida: "Necesito una cámara de guiado",
  qc_d_tel: "¿Con qué telescopio?", qc_tel_mio: "El mío: {n}", qc_tel_corto: "Objetivo o telescopio corto (hasta 500 mm)", qc_tel_medio: "Telescopio medio (500–1200 mm)",
  qc_tel_lungo: "Focal larga (más de 1200 mm)", qc_tel_nonso: "Todavía no lo sé",
  qc_d_col: "¿En color o en blanco y negro?", qc_col_colore: "En color: una sola toma, más sencillo", qc_col_mono: "Monocromática con filtros: más detalle", qc_col_nonso: "Aconséjame tú",
  qc_d_budget: "¿Cuánto quieres gastar en la cámara?", qc_b_300: "Hasta 300 €", qc_b_800: "300 – 800 €", qc_b_1600: "800 – 1600 €", qc_b_max: "Más de 1600 €",
  qc_d_esp: "¿Qué experiencia tienes?", qc_e_prima: "Es mi primera cámara astronómica", qc_e_ho: "Ya he usado una", qc_e_esperto: "Soy experto",
  qc_risultato: "Las cámaras adecuadas para ti", qc_nessuno: "Con estas respuestas no encontramos una cámara disponible: prueba a subir el presupuesto.",
  qc_r_sensore: "Sensor {s}: {mp} MP, píxel {px} µm", qc_r_scala: "{s}″/px con {t}: {g}", qc_r_raff: "Refrigerada: mucho menos ruido en las exposiciones largas",
  qc_r_nonraff: "Sin refrigerar: ligera y sencilla, bien para exposiciones cortas y planetas", qc_r_planet: "Rápida y con píxeles pequeños: muchos fotogramas por segundo para planetas",
  qc_r_guida: "Sensible y ligera: hecha para el autoguiado", qc_r_colore: "En color: sin rueda portafiltros, una toma y tienes la foto", qc_r_mono: "Monocromática: más detalle y banda estrecha, con filtros",
  qc_g_ok: "muestreo adecuado", qc_g_sovra: "algo demasiado fino, puedes usar binning", qc_g_sotto: "campo amplio, estrellas algo cuadradas",
  qc_principale: "La cámara", qc_k_dual: "Filtro dual band: nebulosas también desde la ciudad", qc_k_ha: "Filtro Hα para nebulosas", qc_k_oiii: "Filtro OIII", qc_k_sii: "Filtro SII",
  qc_k_barlow: "Barlow para llegar a la relación focal adecuada para planetas", qc_k_uvir: "Filtro UV/IR cut: colores correctos y estrellas más nítidas",
  qc_k_guida: "Telescopio guía compatible", qc_n_ruota: "Para los filtros de la cámara monocromática también hace falta una rueda portafiltros.",
  qc_n_pc: "Para manejarla hace falta un ordenador o un ASIAIR.", qc_vedi: "Ver en la tienda", qc_prova: "Probar en el Campo",
  qm_titolo: "¿Qué montura es para mí?", qm_n: "Cinco preguntas y te recomendamos tres monturas de la tienda que de verdad aguantan tu telescopio.",
  qm_d_carico: "¿Qué vas a poner encima?", qm_c_mio: "El mío: {n} (unos {kg} kg)", qm_c_smart: "Smart telescope u objetivo (hasta 3 kg)", qm_c_piccolo: "Refractor pequeño (3–6 kg)",
  qm_c_medio: "Telescopio medio (6–12 kg)", qm_c_grande: "Telescopio grande (12–20 kg)", qm_c_molto: "Más de 20 kg",
  qm_d_uso: "¿Para qué la usas?", qm_uso_visuale: "Para observar", qm_uso_foto: "Para fotografiar cielo profundo", qm_uso_entrambi: "Para las dos cosas",
  qm_d_dove: "¿Cuánto la mueves?", qm_dove_fisso: "Sitio fijo o jardín", qm_dove_auto: "La llevo en coche", qm_dove_viaggio: "De viaje, también en avión",
  qm_d_budget: "¿Cuánto quieres gastar en la montura?", qm_b_600: "Hasta 600 €", qm_b_1500: "600 – 1500 €", qm_b_3000: "1500 – 3000 €", qm_b_max: "Más de 3000 €",
  qm_d_esp: "¿Qué experiencia tienes?", qm_e_prima: "Es mi primera montura", qm_e_ho: "Ya he usado una", qm_e_esperto: "Soy experto",
  qm_risultato: "Las monturas adecuadas para ti", qm_nessuno: "Con estas respuestas no encontramos una montura disponible: prueba a cambiar la carga o el presupuesto.",
  qm_r_portata: "Aguanta {p} kg{cp} · tu carga de {c} kg: {u} % de la capacidad", qm_r_cp: " ({p} kg con contrapeso)", qm_r_armonica: "Armónica: sin contrapesos, ligera de llevar",
  qm_r_eq: "Ecuatorial: robusta y precisa para exposiciones largas", qm_r_altaz: "Altacimutal: sencilla y rápida para observar (no para exposiciones largas)",
  qm_r_goto: "GoTo: encuentra los objetos por sí sola y los sigue", qm_r_leggera: "Pesa {kg} kg: se lleva bien", qm_principale: "La montura",
  qm_k_guida: "Telescopio guía: estrellas puntuales en las exposiciones largas", qm_k_camguida: "Cámara de guiado", qm_n_treppiede: "Se vende sin trípode: hace falta también un trípode o una columna.",
  qm_n_guida: "Para la puesta en estación y el guiado hace falta un ordenador con PHD2 o un ASIAIR.", qm_calcola: "Calcular la carga",
  qx_tipo: "¿Qué quieres elegir?", qx_telescopio: "Telescopio", qx_camera: "Cámara", qx_montatura: "Montura",
});
Object.assign(TESTI.it, { qc_p2: "Solo camere disponibili", qm_p2: "Solo montature disponibili", qx_primo: "La più adatta",
  qm_r_armonica_cp: "Armonica: leggera da portare, ma con questo carico serve il contrappeso" });
Object.assign(TESTI.de, { qc_p2: "Nur lieferbare Kameras", qm_p2: "Nur lieferbare Montierungen", qx_primo: "Am besten geeignet",
  qm_r_armonica_cp: "Harmonic: leicht zu tragen, aber bei dieser Last braucht es das Gegengewicht" });
Object.assign(TESTI.es, { qc_p2: "Solo cámaras disponibles", qm_p2: "Solo monturas disponibles", qx_primo: "La más adecuada",
  qm_r_armonica_cp: "Armónica: ligera de llevar, pero con esta carga hace falta el contrapeso" });
Object.assign(TESTI.en, { qc_p2: "In-stock cameras only", qm_p2: "In-stock mounts only", qx_primo: "Best match",
  qm_r_armonica_cp: "Harmonic drive: light to carry, but this load needs the counterweight" });
const telescopioMio = () => {
  const ok = x => !!x && !x.smart && x.F && x.D, miei = (ATTREZZI.tel || []).filter(ok);
  const ap601 = x => /GIO-APO601/i.test((x && x.nome) || "");
  const esempio = ap601(CAMPO.tel) && !SETUP_ELENCO.some(s => ap601(s.tel));
  if (ok(CAMPO.tel) && (ho("tel", CAMPO.tel) || (!miei.length && !esempio))) return CAMPO.tel;
  return miei[0] || null;
};
function cartaQuizGen(def) {
  const R = Object.assign({}, ricorda(def.id, {}));
  const box = scheda(null);
  box.classList.add("gas-qz");
  const D = def.domande(), N = D.length;
  let passo = R.fatto ? N : -1;
  const vaiA = p => {
    passo = p; disegna(); fuocoQuiz(box);
    const r = box.getBoundingClientRect();
    if (r.top < 70 || r.top > window.innerHeight * 0.6) window.scrollTo({ top: r.top + window.scrollY - 80, behavior: "smooth" });
  };
  const etichettaDi = (k, v) => { const d = D.find(x => x.k === k), s = d && d.scelte.find(([vv]) => vv === v); return s ? s[1] : v; };
  const tutte = () => D.every(d => R[d.k] != null && d.scelte.some(([v]) => v === R[d.k]));
  const ricomincia = () => { for (const k of Object.keys(R)) delete R[k]; salva(def.id, R); vaiA(0); };
  const riepilogo = (fino, conReset) => {
    const date = D.slice(0, fino).map((d, i) => [d.k, i]).filter(([k]) => R[k] != null);
    return date.length ? el("div", { class: "gas-qz-risposte" }, el("small", null, t("qz_le_tue")),
      el("div", { class: "gas-qz-risposte-voci" }, date.map(([k, i]) => el("button", { type: "button", class: "gas-cx-chip gas-cx-chip--mini", onclick: () => vaiA(i) },
        el("span", null, etichettaDi(k, R[k])), " ✎")),
        conReset ? el("button", { type: "button", class: "gas-cx-chip gas-cx-chip--mini gas-qz-reset", onclick: ricomincia }, icona("reimposta"), el("span", null, t("qz_da_zero"))) : null)) : null;
  };
  function disegna() {
    svuota(box);
    box.appendChild(el("h3", { class: "gas-qz-titolo" }, icona(def.icona), " ", def.titolo));
    if (passo < 0) {
      aggiungi(box, [el("p", { class: "gas-nota" }, def.n),
        el("ul", { class: "gas-qz-punti" }, ["qz_p1", def.p2 || "qz_p2", "qz_p3"].map(k => el("li", null, el("i", null, "✓"), " ", t(k)))),
        el("button", { type: "button", class: "gas-btn gas-qz-via", onclick: () => vaiA(0) }, t("qz_via"), " →")]);
      return;
    }
    if (passo < N) {
      const d = D[passo];
      aggiungi(box, [el("div", { class: "gas-qz-passi" }, D.map((_, i) => el("i", { class: i < passo ? "fatto" : i === passo ? "ora" : "" }))),
        el("small", { class: "gas-setup-etich" }, t("qz_passo", { n: passo + 1 })),
        el("p", { class: "gas-qz-domanda" }, def.domanda(d.k)),
        el("div", { class: "gas-qz-scelte" }, d.scelte.map(([v, etich]) => el("button", { type: "button", class: "gas-qz-scelta" + (R[d.k] === v ? " on" : ""), "aria-pressed": String(R[d.k] === v),
          onclick: () => { R[d.k] = v; if (passo === N - 1 || (R.fatto && tutte())) { R.fatto = true; salva(def.id, R); vaiA(N); } else { salva(def.id, R); vaiA(passo + 1); } } }, etich))),
        passo > 0 ? el("button", { type: "button", class: "gas-btn gas-btn--chiaro gas-btn--mini", onclick: () => vaiA(passo - 1) }, "‹ ", t("qz_indietro")) : null,
        riepilogo(passo)]);
      return;
    }
    if (!tutte()) { passo = 0; disegna(); return; }
    const scelti = def.consiglia(R), lista = el("div", { class: "gas-qz-lista" });
    provaFatta(3);
    aggiungi(box, [el("p", { class: "gas-qz-domanda" }, def.risultato), riepilogo(N, true), lista,
      el("div", { class: "gas-riga-bottoni" }, el("button", { type: "button", class: "gas-btn gas-btn--chiaro gas-btn--mini",
        onclick: ricomincia }, icona("reimposta"), " ", t("qz_da_zero")))]);
    if (!scelti.length) { lista.appendChild(el("p", { class: "gas-muto" }, def.vuoto)); return; }
    const tuttiSopra = scelti.every(v => v.sopra);
    if (tuttiSopra) lista.appendChild(el("p", { class: "gas-nota gas-qz-avviso" }, def.sopra));
    else if (scelti.every(v => v.meno)) lista.appendChild(el("p", { class: "gas-nota gas-qz-avviso" }, def.meno));
    scelti.forEach((v, i) => {
      const prezzo = el("span", { class: "gas-cm-prezzo" }, v.x.prezzo ? euro(Math.round(v.x.prezzo * 100)) : "");
      const img = el("img", { alt: "", width: 96, height: 96, loading: "lazy" });
      const metti = u => { if (u) img.src = (u.startsWith("//") ? "https:" + u : u) + (u.includes("?") ? "&" : "?") + "width=240"; };
      metti(v.x.foto);
      const nome = el("b", null, v.x.t), vedi = el("a", { class: "gas-btn gas-btn--mini", href: urlProdotto(v.x.h), target: "_blank", rel: "noopener" }, t("qz_vedi"));
      const testo = el("div", { class: "gas-qz-testo" }, nome, prezzo,
        v.sopra && !tuttiSopra ? el("small", { class: "gas-qz-sopra" }, t("qz_sopra_uno")) : null,
        el("ul", { class: "gas-qz-perche" }, v.perche.slice(0, 4).map(p => el("li", null, p))),
        el("div", { class: "gas-riga-bottoni" }, vedi, def.extra ? def.extra(v) : null));
      prodotto(v.x.h).then(p => {
        segnaNonDisponibile(testo, p);
        if (p === false) vedi.remove();
        if (!p) return;
        if (p.price) prezzo.textContent = euro(p.price);
        if (!v.x.foto) metti(p.featured_image);
        if (!v.x.c) titoloNegozio(nome, p);
      }).catch(() => {});
      lista.appendChild(el("div", { class: "gas-qz-voce" + (i === 0 ? " gas-qz-voce--primo" : "") },
        el("span", { class: "gas-qz-pos" }, i === 0 ? `★ ${t(def.primo || "qz_primo")}` : t("qz_n_pos", { n: i + 1 })),
        img, testo));
    });
    lista.after(def.kit(scelti, R));
  }
  disegna();
  return box;
}
const QC_BUDGET = { 300: [0, 300], 800: [250, 800], 1600: [700, 1600], max: [1400, 1e9] };
const QC_VELOCI = /IMX(662|678|585|462|224|290|715|664|676|482|485|464)/i;
const QC_TOP = /IMX(571|533|585|455|294|410|461|411|662|678)/i;
function focaleQuiz(R) {
  const mio = telescopioMio();
  return R.tel === "mio" && mio ? { F: mio.F * (CAMPO.tel === mio && CAMPO.k ? CAMPO.k : 1), nome: nomeCorto(nomeTel(mio)) }
    : { F: { corto: 400, medio: 800, lungo: 2000 }[R.tel] || null, nome: null };
}
function consigliaCamere(R, allarga) {
  const [min0, max] = QC_BUDGET[R.budget] || [0, 1e9], min = allarga ? 0 : min0, tetto = allarga === 2 ? Infinity : max * 1.05;
  const { F, nome } = focaleQuiz(R), prezzi = DATI.camerePrezzi || {};
  const voti = [];
  for (const c of DATI.camere) {
    const pr = c.h_negozio && prezzi[c.h_negozio];
    if (!pr || !pr[1] || !c.px) continue;
    const prezzo = pr[0];
    if (prezzo > tetto || prezzo < min * 0.75) continue;
    const mono = c.col === "mono", cat = c.cat, sens = String(c.sensore || ""), mp = c.w && c.h ? c.w * c.h / 1e6 : null, perche = [];
    if (R.uso === "guida") { if (cat !== "planetaria_guida") continue; }
    else if (R.uso === "pianeti") { if (!["planetaria_guida", "non_raffreddata"].includes(cat) || c.px > 4.1) continue; }
    else if (R.uso === "deep") { if (!["raffreddata", "non_raffreddata"].includes(cat)) continue; }
    else if (!["raffreddata", "non_raffreddata", "planetaria_guida"].includes(cat)) continue;
    if (R.col === "colore" && mono && R.uso !== "guida") continue;
    if (R.col === "mono" && !mono) continue;
    let s = 5;
    if (R.uso === "deep") {
      if (cat === "raffreddata") { s += max >= 800 ? 3 : 1; perche.push(t("qc_r_raff")); } else perche.push(t("qc_r_nonraff"));
      if (QC_TOP.test(sens)) s += 1.5;
      if (F && mp && F < 600 && mp >= 20) s += 1;
    } else if (R.uso === "pianeti") {
      if (QC_VELOCI.test(sens)) s += 2.5;
      if (c.px <= 3) s += 1.5;
      perche.push(t("qc_r_planet"));
    } else if (R.uso === "entrambi") {
      if (/IMX(585|533|662|678|571)/i.test(sens)) s += 3;
      if (cat === "raffreddata") { s += 1; perche.push(t("qc_r_raff")); } else perche.push(t("qc_r_nonraff"));
    } else {
      if (mono) s += 2;
      if (c.px >= 2.9 && c.px <= 4) s += 1;
      perche.push(t("qc_r_guida"));
    }
    if (R.uso !== "guida") {
      if (!mono) { s += R.esp === "prima" || R.col === "nonso" ? 1.5 : 0; perche.push(t("qc_r_colore")); }
      else { s += R.esp === "esperto" ? 1 : -1; perche.push(t("qc_r_mono")); }
    }
    if (F && R.uso !== "pianeti" && R.uso !== "guida") {
      const scala = 206.265 * c.px / F, g = scala < 0.8 ? "sovra" : scala > 2.6 ? "sotto" : "ok";
      s += g === "ok" ? 3 : 0.5;
      perche.unshift(t("qc_r_scala", { s: num(scala, 2), t: nome || `${num(F)} mm`, g: t("qc_g_" + g) }));
    }
    perche.unshift(t("qc_r_sensore", { s: sens.replace(/^Sony\s+/i, "") || "–", mp: mp ? num(mp, 1) : "–", px: num(c.px, 2) }));
    s += 2 - Math.abs(prezzo - max * 0.75) / Math.max(200, Math.min(max, 4000));
    voti.push({ x: { h: c.h_negozio, t: c.nome, foto: c.foto, prezzo, c }, s, perche });
  }
  if (allarga === 2) voti.sort((a, b) => a.x.prezzo - b.x.prezzo); else voti.sort((a, b) => b.s - a.s);
  const scelti = [];
  for (const v of voti) {
    if (scelti.some(w => (w.x.c.sensore || "") === (v.x.c.sensore || "") && w.x.c.col === v.x.c.col)) continue;
    scelti.push(v);
    if (scelti.length === 3) break;
  }
  if (!scelti.length && (allarga || 0) < 2) return consigliaCamere(R, (allarga || 0) + 1);
  for (const v of scelti) { v.sopra = v.x.prezzo > max * 1.05; v.meno = v.x.prezzo < min0 * 0.75; }
  return scelti;
}
function pezziKitCamera(x, R) {
  const c = x.c, pezzi = [], note = [], diag = c.mm ? Math.hypot(c.mm[0], c.mm[1]) : c.w && c.h ? Math.hypot(c.w, c.h) * c.px / 1000 : 15;
  const misuraGiusta = f => diag > 18 ? !/1[,.]25|31[,.]8/.test(f.misura + f.t) && !/clip/i.test(f.misura + f.t) : !/clip/i.test(f.misura + f.t);
  if (R.uso === "pianeti") {
    const { F } = focaleQuiz(R), mio = R.tel === "mio" ? telescopioMio() : null, N = F && mio ? F / mio.D : null, k = N ? 5 * c.px / N : 2.5;
    if (k > 1.3) pezzi.push({ ruolo: "barlow", testo: t("qc_k_barlow"), candidati: DATI.ottiche.filter(o => o.tipo === "barlow" && o.k >= Math.min(k, 3) * 0.75 && o.k <= Math.max(k, 2) * 1.3).slice(0, 8), tetto: 200 });
    if (c.col !== "mono") pezzi.push({ ruolo: "uvir", testo: t("qc_k_uvir"), candidati: DATI.filtri.filter(f => f.tipo === "uvir" && /uv.?ir/i.test(f.t) && !/clear/i.test(f.t) && misuraGiusta(f)), tetto: 120 });
  } else if (R.uso === "guida") {
    pezzi.push({ ruolo: "guida", testo: t("qc_k_guida"), candidati: DATI.telescopi.filter(z => z.tipo === "guida" && z.prezzo && z.disp).sort((a, b) => a.prezzo - b.prezzo).slice(0, 8), tetto: 260 });
  } else if (c.col === "mono") {
    for (const [tipo, ch] of [["ha", "qc_k_ha"], ["oiii", "qc_k_oiii"], ["sii", "qc_k_sii"]])
      pezzi.push({ ruolo: tipo, testo: t(ch), candidati: DATI.filtri.filter(f => f.tipo === tipo && misuraGiusta(f)), tetto: 420 });
    note.push(t("qc_n_ruota"));
  } else if ((NOTTE.bortle || 5) >= 5) {
    pezzi.push({ ruolo: "dual", testo: t("qc_k_dual"), candidati: DATI.filtri.filter(f => f.tipo === "dual" && misuraGiusta(f)), tetto: 380 });
  }
  if (R.uso !== "guida") note.push(t("qc_n_pc"));
  return { pezzi, note };
}
function cartaQuizCamera() {
  return cartaQuizGen({
    id: "quiz_cam", titolo: t("qc_titolo"), n: t("qc_n"), icona: "camere", risultato: t("qc_risultato"), vuoto: t("qc_nessuno"),
    sopra: t("qc_sopra"), meno: t("qc_meno"), p2: "qc_p2", primo: "qx_primo",
    domanda: k => t("qc_d_" + k),
    domande: () => {
      const mio = telescopioMio();
      return [{ k: "uso", scelte: ["deep", "pianeti", "entrambi", "guida"].map(v => [v, t("qc_uso_" + v)]) },
        { k: "tel", scelte: [...(mio ? [["mio", t("qc_tel_mio", { n: nomeCorto(nomeTel(mio)) })]] : []), ...["corto", "medio", "lungo", "nonso"].map(v => [v, t("qc_tel_" + v)])] },
        { k: "col", scelte: ["colore", "mono", "nonso"].map(v => [v, t("qc_col_" + v)]) },
        { k: "budget", scelte: ["300", "800", "1600", "max"].map(v => [v, t("qc_b_" + v)]) },
        { k: "esp", scelte: ["prima", "ho", "esperto"].map(v => [v, t("qc_e_" + v)]) }];
    },
    consiglia: consigliaCamere,
    kit: (scelti, R) => boxKit(scelti, R, { pezzi: pezziKitCamera, principale: t("qc_principale") }),
    extra: v => el("button", { type: "button", class: "gas-btn gas-btn--chiaro gas-btn--mini", onclick: () => { scegliCamera(v.x.c); vai("campo"); } }, t("qc_prova")),
  });
}
const QM_BUDGET = { 600: [0, 600], 1500: [500, 1500], 3000: [1300, 3000], max: [2600, 1e9] };
const QM_CARICO = { smart: 2.5, piccolo: 5, medio: 9, grande: 16, molto: 25 };
function caricoQuiz(R) {
  const mio = telescopioMio();
  if (R.carico === "mio" && mio) return Math.round(((pesoTubo(mio).kg || 4) + (R.uso === "visuale" ? 0.5 : 1.8)) * 10) / 10;
  return QM_CARICO[R.carico] || 6;
}
function consigliaMontature(R, allarga) {
  const [min0, max] = QM_BUDGET[R.budget] || [0, 1e9], min = allarga ? 0 : min0, tetto = allarga === 2 ? Infinity : max * 1.05;
  const carico = caricoQuiz(R), foto = R.uso !== "visuale", voti = [];
  for (const m of DATI.montature) {
    if (!m.prezzo || !m.disp || !m.kg_portata) continue;
    if (/testa equatoriale|wedge|cuneo/i.test(m.t)) continue;
    if (bundleConTelescopio(m)) continue;
    if (m.prezzo > tetto || m.prezzo < min * 0.75) continue;
    const armonica = m.tipo === "armonica", altaz = m.tipo === "altaz", goto = motorizzata(m);
    if (foto && (altaz || !goto)) continue;
    const viaggio = R.dove === "viaggio", portata = armonica && !viaggio && m.kg_portata_cp ? m.kg_portata_cp : m.kg_portata;
    const fattore = foto ? (armonica ? 0.7 : 0.5) : 0.8, uso = carico / (portata * fattore);
    if (uso > 1) continue;
    if (viaggio && m.kg && m.kg > 8) continue;
    let s = 5;
    s += uso >= 0.45 && uso <= 0.85 ? 2.5 : uso < 0.45 ? 1 : 0;
    if (viaggio) s += armonica ? 3 : -2;
    else if (R.dove === "auto") s += armonica ? 1.5 : (m.kg && m.kg > 18 ? -2 : 0);
    else s += armonica ? 0.5 : 1;
    if (R.esp === "prima") s += (goto ? 1.5 : -1) + (armonica ? 1 : 0);
    if (!foto && altaz) s += 1;
    s += 2 - Math.abs(m.prezzo - max * 0.75) / Math.max(300, Math.min(max, 5000));
    const conCp = armonica && portata !== m.kg_portata && carico > m.kg_portata * fattore;
    const perche = [t("qm_r_portata", { p: num(m.kg_portata), cp: m.kg_portata_cp ? t("qm_r_cp", { p: num(m.kg_portata_cp) }) : "", c: num(carico, 1), u: num(carico / portata * 100) }),
      t(armonica ? (conCp ? "qm_r_armonica_cp" : "qm_r_armonica") : altaz ? "qm_r_altaz" : "qm_r_eq")];
    if (goto) perche.push(t("qm_r_goto"));
    if (m.kg && m.kg <= (viaggio ? 8 : 12) && (viaggio || R.dove === "auto")) perche.push(t("qm_r_leggera", { kg: num(m.kg, 1) }));
    voti.push({ x: { h: m.h, t: m.t, foto: null, prezzo: m.prezzo, m }, s, perche });
  }
  if (allarga === 2) voti.sort((a, b) => a.x.prezzo - b.x.prezzo); else voti.sort((a, b) => b.s - a.s);
  const scelti = [];
  for (const v of voti) {
    if (scelti.some(w => w.x.m.v === v.x.m.v && w.x.m.tipo === v.x.m.tipo && Math.abs(w.x.m.kg_portata - v.x.m.kg_portata) < 3)) continue;
    scelti.push(v);
    if (scelti.length === 3) break;
  }
  if (!scelti.length && (allarga || 0) < 2) return consigliaMontature(R, (allarga || 0) + 1);
  for (const v of scelti) { v.sopra = v.x.prezzo > max * 1.05; v.meno = v.x.prezzo < min0 * 0.75; }
  return scelti;
}
function pezziKitMontatura(x, R) {
  const m = x.m, pezzi = [], note = [];
  if (!/treppied|tripod|colonna|pier|tri-pier|literoc/i.test(m.t) && m.tipo === "armonica") note.push(t("qm_n_treppiede"));
  if (R.uso !== "visuale") {
    pezzi.push({ ruolo: "guida", testo: t("qm_k_guida"), candidati: DATI.telescopi.filter(z => z.tipo === "guida" && z.prezzo && z.disp).sort((a, b) => a.prezzo - b.prezzo).slice(0, 8), tetto: 220 });
    const camGuida = DATI.camere.filter(c => c.cat === "planetaria_guida" && c.col === "mono" && c.h_negozio && (DATI.camerePrezzi[c.h_negozio] || [])[1])
      .sort((a, b) => (DATI.camerePrezzi[a.h_negozio][0] - DATI.camerePrezzi[b.h_negozio][0])).slice(0, 8).map(c => ({ h: c.h_negozio, t: c.nome, foto: c.foto }));
    pezzi.push({ ruolo: "camguida", testo: t("qm_k_camguida"), candidati: camGuida, tetto: 320 });
    note.push(t("qm_n_guida"));
  }
  return { pezzi, note };
}
function cartaQuizMontatura() {
  return cartaQuizGen({
    id: "quiz_mont", titolo: t("qm_titolo"), n: t("qm_n"), icona: "attrezzatura", risultato: t("qm_risultato"), vuoto: t("qm_nessuno_carico"),
    sopra: t("qm_sopra"), meno: t("qm_meno"), p2: "qm_p2", primo: "qx_primo",
    domanda: k => t("qm_d_" + k),
    domande: () => {
      const mio = telescopioMio();
      return [{ k: "carico", scelte: [...(mio ? [["mio", t("qm_c_mio", { n: nomeCorto(nomeTel(mio)), kg: num(pesoTubo(mio).kg || 4, 1) })]] : []),
        ...["smart", "piccolo", "medio", "grande", "molto"].map(v => [v, t("qm_c_" + v)])] },
        { k: "uso", scelte: ["visuale", "foto", "entrambi"].map(v => [v, t("qm_uso_" + v)]) },
        { k: "dove", scelte: ["fisso", "auto", "viaggio"].map(v => [v, t("qm_dove_" + v)]) },
        { k: "budget", scelte: ["600", "1500", "3000", "max"].map(v => [v, t("qm_b_" + v)]) },
        { k: "esp", scelte: ["prima", "ho", "esperto"].map(v => [v, t("qm_e_" + v)]) }];
    },
    consiglia: consigliaMontature,
    kit: (scelti, R) => boxKit(scelti, R, { pezzi: pezziKitMontatura, principale: t("qm_principale") }),
    extra: v => el("button", { type: "button", class: "gas-btn gas-btn--chiaro gas-btn--mini", onclick: () => {
      const S = Object.assign({}, ricorda("carico", {}), { mont: v.x.h }); salva("carico", S); apriCalcolatore("carico"); } }, t("qm_calcola")),
  });
}
Object.assign(TESTI.it, {
  hs_occhiello: "Stasera {l_da}", hs_buio: "Buio vero dalle {a} alle {b}", hs_nautico: "Niente buio vero: cielo scuro dalle {a} alle {b}",
  hs_niente: "Stanotte il cielo non diventa buio", hs_luna: "Luna {k} %", hs_luna_sorge: "sorge alle {o}", hs_luna_tramonta: "tramonta alle {o}",
  hs_migliori: "I migliori di stanotte", hs_cosa: "Cosa guardare stanotte", hs_alto: "più alto alle {o} · {h}°", hs_ore: "alto più di {h}° per {d}", hs_tutti: "Tutti gli oggetti di stanotte",
  hs_dal_posto: "Guarda il cielo dal tuo posto", hs_nessuno: "Stanotte nessun oggetto famoso sale abbastanza: prova un'altra data in «Cosa vedere».",
});
Object.assign(TESTI.de, {
  hs_occhiello: "Heute Abend {l_da}", hs_buio: "Echte Dunkelheit von {a} bis {b}", hs_nautico: "Keine echte Dunkelheit: dunkler Himmel von {a} bis {b}",
  hs_niente: "Heute Nacht wird der Himmel nicht dunkel", hs_luna: "Mond {k} %", hs_luna_sorge: "geht um {o} auf", hs_luna_tramonta: "geht um {o} unter",
  hs_migliori: "Die besten heute Nacht", hs_cosa: "Was heute Nacht beobachten", hs_alto: "am höchsten um {o} · {h}°", hs_ore: "{d} höher als {h}°", hs_tutti: "Alle Objekte heute Nacht",
  hs_dal_posto: "Den Himmel von Ihrem Ort ansehen", hs_nessuno: "Heute Nacht steigt kein bekanntes Objekt hoch genug: ein anderes Datum in „Was sehen“ versuchen.",
});
Object.assign(TESTI.es, {
  hs_occhiello: "Esta noche {l_da}", hs_buio: "Oscuridad real de {a} a {b}", hs_nautico: "Sin oscuridad real: cielo casi oscuro de {a} a {b}",
  hs_niente: "Esta noche el cielo no se oscurece", hs_luna: "Luna {k} %", hs_luna_sorge: "sale a las {o}", hs_luna_tramonta: "se pone a las {o}",
  hs_migliori: "Los mejores de esta noche", hs_cosa: "Qué mirar esta noche", hs_alto: "más alto a las {o} · {h}°", hs_ore: "más de {h}° de altura durante {d}", hs_tutti: "Todos los objetos de esta noche",
  hs_dal_posto: "Mira el cielo desde tu lugar", hs_nessuno: "Esta noche ningún objeto famoso sube lo suficiente: prueba otra fecha en «Qué ver».",
});
Object.assign(TESTI.en, {
  hs_occhiello: "Tonight {l_da}", hs_buio: "Truly dark from {a} to {b}", hs_nautico: "No true darkness: dark sky from {a} to {b}",
  hs_niente: "Tonight the sky doesn't get dark", hs_luna: "Moon {k}%", hs_luna_sorge: "rises at {o}", hs_luna_tramonta: "sets at {o}",
  hs_migliori: "Tonight's best", hs_cosa: "What to look at tonight", hs_alto: "highest at {o} · {h}°", hs_ore: "above {h}° for {d}", hs_tutti: "All of tonight's objects",
  hs_dal_posto: "See the sky from your spot", hs_nessuno: "Tonight no famous object rises high enough: try another date in “What to see”.",
});
Object.assign(TESTI.it, { hs_nessuno_tipo: "Stanotte nessun oggetto famoso del tipo che hai scelto sale abbastanza: cambia tipo o data in «Cosa vedere»." });
Object.assign(TESTI.de, { hs_nessuno_tipo: "Heute Nacht steigt kein bekanntes Objekt der gewählten Art hoch genug: eine andere Art oder ein anderes Datum in «Was sehen» versuchen." });
Object.assign(TESTI.es, { hs_nessuno_tipo: "Esta noche ningún objeto famoso del tipo que has elegido sube lo suficiente: prueba otro tipo u otra fecha en «Qué ver»." });
Object.assign(TESTI.en, { hs_nessuno_tipo: "Tonight no famous object of the type you chose rises high enough: try another type or date in «What to see»." });
function suStanotte(fn) {
  const d = NOTTE.data;
  if (!d) return fn();
  NOTTE.data = "";
  try { return fn(); } finally { NOTTE.data = d; }
}
function miglioriStasera(n) {
  const c = suStanotte(calcolaNotte), nt = c.nt, campo = campoAttuale(), fase = nt.fase.k;
  const vista = vistaAttiva() ? NOTTE.vista : null, ter = terrenoAttivo(), hmin = NOTTE.hmin || 0;
  const tipi = codiciTipiNotte();
  const lista = [];
  for (const r of c.righe) {
    const o = r.o;
    if (!(o.top || o.messier || o.caldwell) || r.hMax < hmin || (tipi && !tipi.has(o.t))) continue;
    const vis = vista || ter ? inVista(r, nt, hmin, vista) : null;
    const ore = vis ? vis.ore : oreSopra(r, nt, hmin);
    if (ore <= 0) continue;
    const pop = o.top ? 2 : 1.5, magF = o.mag != null ? clamp((15 - o.mag) / 8, 0.4, 1.3) : 0.9;
    const lunaF = 1 - (DIFFUSI.has(o.t) ? 0.7 : 0.25) * fase * Math.exp(-r.sep / 50) * (0.2 + 0.8 * c.lunaSu);
    lista.push({ r, ore, vis, punti: ore * pop * magF * lunaF * adattoAlCampo(o, campo) * (0.6 + 0.4 * Math.sin((vis ? vis.hMax : r.hMax) * RAD)) });
  }
  lista.sort((a, b) => b.punti - a.punti);
  const scelti = [], tipo = o => Object.keys(GRUPPI_TIPO).find(k => GRUPPI_TIPO[k].includes(o.t)) || o.t;
  for (const x of lista) {
    if (scelti.length >= n) break;
    const o = x.r.o;
    if (scelti.some(y => Astro.separazione(y.r.o.ra, y.r.o.dec, o.ra, o.dec) < 4 || (o.c && y.r.o.c === o.c))) continue;
    if (!tipi && scelti.filter(y => tipo(y.r.o) === tipo(o)).length >= 2) continue;
    scelti.push(x);
  }
  return { c, lista: scelti };
}
function cartaStasera() {
  let dati;
  try { dati = miglioriStasera(3); } catch (e) { console.error("strumenti, stasera:", e); return null; }
  const { c, lista } = dati, nt = c.nt, ev = nt.ev;
  const testo = ev.astroFine && ev.astroInizio ? t("hs_buio", { a: ora(ev.astroFine), b: ora(ev.astroInizio) })
    : ev.nauticoFine && ev.nauticoInizio ? t("hs_nautico", { a: ora(ev.nauticoFine), b: ora(ev.nauticoInizio) }) : t("hs_niente");
  const pill = (...x) => el("span", { class: "gas-hs-pill" }, ...x);
  const lunaOra = ev.lunaSorge && (!ev.lunaTramonta || ev.lunaSorge < ev.lunaTramonta) ? t("hs_luna_sorge", { o: ora(ev.lunaSorge) })
    : ev.lunaTramonta ? t("hs_luna_tramonta", { o: ora(ev.lunaTramonta) }) : "";
  const meteo = el("span", { class: "gas-home-vivo" }, "…"), pianeti = el("span", { class: "gas-home-vivo" });
  const pMeteo = pill(icona("meteo"), " ", meteo);
  let senzaMeteo = false;
  try {
    const attesa = suStanotte(() => infoViva("meteo", meteo));
    if (attesa && attesa.then) attesa.then(scritto => { if (!scritto) pMeteo.remove(); }); else senzaMeteo = true;
  } catch (e) { senzaMeteo = true; }
  try { suStanotte(() => infoViva("planetario", pianeti)); } catch (e) {   }
  const pillole = el("div", { class: "gas-hs-pillole" },
    pill(iconaLuna(nt.fase), ` ${t("hs_luna", { k: num(nt.fase.k * 100) })}${lunaOra ? " · " + lunaOra : ""}`),
    senzaMeteo ? null : pMeteo, pill(icona("pianeta"), " ", pianeti));
  const alle = i => ora(Astro.data(nt.tempi[i]));
  const stanotte = fn => { NOTTE.data = ""; fn(); };
  const carte = lista.map(({ r, ore, vis }) => {
    const o = r.o, iM = vis && vis.iMax >= 0 ? vis.iMax : r.iMax, hM = vis && vis.iMax >= 0 ? vis.hMax : r.hMax;
    const foto = miniaturaOggetto(o, 360);
    foto.classList.add("gas-hs-foto");
    const vaiScheda = e => { if (!clicSemplice(e)) return; e.preventDefault(); stanotte(() => apriOggetto(o.id)); };
    return el("article", { class: "gas-hs-ogg" },
      el("a", { class: "gas-hs-ogg-link", href: "#oggetto?" + encodeURIComponent(o.id), onclick: vaiScheda, "aria-label": titoloOggetto(o) }, foto,
        el("span", { class: "gas-hs-ogg-testo" },
          el("small", null, [t("tipo_" + o.t), o.c ? nomeCostellazione(o.c) : null].filter(Boolean).join(" · ")),
          el("b", null, titoloOggetto(o)),
          el("span", null, iM >= 0 ? t("hs_alto", { o: alle(iM), h: num(hM) }) : ""),
          el("span", { class: "gas-hs-ore" }, t("hs_ore", { d: durata(ore), h: num(NOTTE.hmin || 0) })))),
      el("button", { type: "button", class: "gas-hs-posto", title: t("vl_apri_n"), "aria-label": `${t("vl_apri")} · ${titoloOggetto(o)}`,
        onclick: () => stanotte(() => apriVistaLuogo(o.id)) }, icona("orizzonte")));
  });
  const W = 1200, H = 120, sagoma = sv("svg", { class: "gas-hs-monti", viewBox: `0 0 ${W} ${H}`, preserveAspectRatio: "none", "aria-hidden": "true" });
  let d = `M0,${H}`;
  if (terrenoDelLuogo()) {
    const P = NOTTE.terreno.p, top = Math.max(8, ...P.slice(90, 271).map(x => x / 10));
    for (let a = 90; a <= 270; a++) d += `L${((a - 90) / 180 * W).toFixed(1)},${(H - 6 - P[a] / 10 / top * (H - 30)).toFixed(1)}`;
  } else for (let x = 0; x <= W; x += 20) d += `L${x},${(H - 26 - 14 * Math.sin(x / 170) - 9 * Math.sin(x / 61 + 1)).toFixed(1)}`;
  sagoma.appendChild(sv("path", { d: d + `L${W},${H}Z` }));
  const primo = lista[0] && lista[0].r.o;
  return el("section", { class: "gas-hs", "aria-label": t("hs_occhiello", luogoFrasi()) },
    el("div", { class: "gas-hs-stelle", "aria-hidden": "true" }), sagoma,
    el("div", { class: "gas-hs-corpo" },
      el("div", { class: "gas-hs-testa" },
        el("small", { class: "gas-hs-occhiello" }, t("hs_occhiello", luogoFrasi())),
        el("h2", { class: "gas-hs-titolo" }, document.querySelector(".gas-plancia-ciao") ? t("hs_cosa") : testo), pillole),
      el("div", { class: "gas-hs-sez" }, el("h3", null, t("hs_migliori")),
        carte.length ? el("div", { class: "gas-hs-griglia" }, carte) : el("p", { class: "gas-hs-vuoto" }, t(codiciTipiNotte() ? "hs_nessuno_tipo" : "hs_nessuno"))),
      el("div", { class: "gas-hs-piede" },
        primo ? el("button", { type: "button", class: "gas-hs-cta", onclick: () => stanotte(() => apriVistaLuogo(primo.id)) }, icona("orizzonte"), " ", t("hs_dal_posto")) : null,
        el("a", { class: "gas-hs-tutti", href: typeof linkStrumento === "function" ? linkStrumento("stanotte") : "#stanotte",
          onclick: e => { if (!clicSemplice(e)) return; e.preventDefault(); stanotte(() => vai("stanotte")); } }, t("hs_tutti"), " →"))));
}
Object.assign(TESTI.it, {
  bv_titolo: "Benvenuto negli strumenti!", bv_sotto: "Tre domande e vedi il tuo cielo di stanotte.",
  bv_q1: "Da dove osservi?", bv_q1_n: "Scrivi la tua città o usa la tua posizione: così calcoliamo quando fa buio, che Luna c'è e cosa si vede nel tuo cielo.",
  bv_q2: "Cosa usi per guardare o fotografare il cielo?", bv_q2_n: "Scegli il tuo telescopio e poi la camera, o l'oculare se non fotografi: alla fine vedrai cosa inquadri su una foto vera del cielo.",
  bv_occhi: "Guardo a occhio nudo o col binocolo", bv_niente: "Non ho ancora un telescopio: aiutami a sceglierlo",
  bv_q3: "Cosa ti piace guardare?", bv_q3_n: "Ti mostreremo solo gli oggetti del tipo che scegli qui. Puoi cambiare scelta quando vuoi nel riquadro «Oggetti» di «Cosa vedere».",
  bv_tutto: "Un po' di tutto", bv_nebulose: "Nebulose", bv_galassie: "Galassie", bv_ammassi: "Ammassi aperti", bv_planetarie: "Nebulose planetarie",
  bv_avanti: "Avanti", bv_indietro: "Indietro", bv_salta: "Salta", bv_fine: "Fatto: mostrami il mio cielo", bv_chiudi: "Chiudi il riquadro di benvenuto",
  bv_prossima: "Prossima domanda", bv_precedente: "Domanda precedente",
  bv_passo: "Domanda {n} di 3",
});
Object.assign(TESTI.de, {
  bv_titolo: "Willkommen bei den Werkzeugen!", bv_sotto: "Drei Fragen und Sie sehen Ihren Himmel heute Nacht.",
  bv_q1: "Von wo beobachten Sie?", bv_q1_n: "Geben Sie Ihre Stadt ein oder verwenden Sie Ihren Standort: So berechnen wir, wann es dunkel wird, wie der Mond steht und was an Ihrem Himmel zu sehen ist.",
  bv_q2: "Womit beobachten oder fotografieren Sie den Himmel?", bv_q2_n: "Wählen Sie Ihr Teleskop und dann die Kamera oder, wenn Sie visuell beobachten, das Okular: Am Ende sehen Sie auf einem echten Himmelsfoto, was in Ihr Bildfeld passt.",
  bv_occhi: "Ich beobachte mit bloßem Auge oder mit dem Fernglas", bv_niente: "Ich habe noch kein Teleskop: Hilfe bei der Wahl",
  bv_q3: "Was beobachten Sie am liebsten?", bv_q3_n: "Wir zeigen Ihnen dann nur die Objektart, die Sie hier wählen. Ändern können Sie das jederzeit in der Kachel Objekte unter „Was sehen“.",
  bv_tutto: "Ein bisschen von allem", bv_nebulose: "Nebel", bv_galassie: "Galaxien", bv_ammassi: "Offene Sternhaufen", bv_planetarie: "Planetarische Nebel",
  bv_avanti: "Weiter", bv_indietro: "Zurück", bv_salta: "Überspringen", bv_fine: "Fertig: meinen Himmel anzeigen", bv_chiudi: "Willkommensfenster schließen",
  bv_prossima: "Nächste Frage", bv_precedente: "Vorherige Frage",
  bv_passo: "Frage {n} von 3",
});
Object.assign(TESTI.es, {
  bv_titolo: "¡Bienvenido a las herramientas!", bv_sotto: "Tres preguntas y ves tu cielo de esta noche.",
  bv_q1: "¿Desde dónde observas?", bv_q1_n: "Escribe tu ciudad o usa tu posición: así calculamos cuándo oscurece, cómo está la Luna y qué se ve en tu cielo.",
  bv_q2: "¿Con qué miras o fotografías el cielo?", bv_q2_n: "Elige tu telescopio y luego la cámara, o el ocular si no haces fotos: al final verás lo que encuadras sobre una foto real del cielo.",
  bv_occhi: "Miro a simple vista o con prismáticos", bv_niente: "Aún no tengo telescopio: ayúdame a elegirlo",
  bv_q3: "¿Qué te gusta observar?", bv_q3_n: "Te mostraremos solo los objetos del tipo que elijas aquí. Puedes cambiarlo cuando quieras en el recuadro «Objetos» de «Qué ver».",
  bv_tutto: "Un poco de todo", bv_nebulose: "Nebulosas", bv_galassie: "Galaxias", bv_ammassi: "Cúmulos abiertos", bv_planetarie: "Nebulosas planetarias",
  bv_avanti: "Siguiente", bv_indietro: "Atrás", bv_salta: "Saltar", bv_fine: "Hecho: muéstrame mi cielo", bv_chiudi: "Cerrar el recuadro de bienvenida",
  bv_prossima: "Siguiente pregunta", bv_precedente: "Pregunta anterior",
  bv_passo: "Pregunta {n} de 3",
});
Object.assign(TESTI.en, {
  bv_titolo: "Welcome to the tools!", bv_sotto: "Three questions and you'll see your sky tonight.",
  bv_q1: "Where do you observe from?", bv_q1_n: "Type your town or use your location: we'll work out when it gets dark, what the Moon is doing and what you can see in your sky.",
  bv_q2: "What do you use to observe or photograph the sky?", bv_q2_n: "Pick your telescope and then the camera, or the eyepiece if you don't take photos: at the end you'll see what you frame on a real photo of the sky.",
  bv_occhi: "I observe with the naked eye or binoculars", bv_niente: "I don't have a telescope yet: help me choose",
  bv_q3: "What do you like to look at?", bv_q3_n: "We'll only show you the kind of objects you pick here. You can change it any time from the Objects box in What to see.",
  bv_tutto: "A bit of everything", bv_nebulose: "Nebulae", bv_galassie: "Galaxies", bv_ammassi: "Open clusters", bv_planetarie: "Planetary nebulae",
  bv_avanti: "Next", bv_indietro: "Back", bv_salta: "Skip", bv_fine: "Done: show me my sky", bv_chiudi: "Close the welcome panel",
  bv_prossima: "Next question", bv_precedente: "Previous question",
  bv_passo: "Question {n} of 3",
});
let BV_PASSO = clamp(ricorda("bv_passo", 0) || 0, 0, 2);
function cartaBenvenuto(ridisegna) {
  const forza = /[?&]benvenuto\b/.test(location.search) && !cartaBenvenuto._chiuso;
  let nuovo = false, aspetta = false;
  try {
    nuovo = puoSalvare() && (attrezzaturaVuota() || BV_PASSO > 0);
    aspetta = nuovo && !BV_PASSO && SYNC.stato === "?";
  } catch (e) { nuovo = false; }
  if (!forza && (ricorda("benvenuto_ok", false) || !nuovo)) return null;
  if (!forza && aspetta) {
    const segnaposto = el("div", { hidden: true });
    const dopo = () => {
      if (SYNC.stato === "?") return;
      SYNC.ui.delete(dopo);
      if (segnaposto.isConnected && schedaAttiva === "home") try { ridisegna(); } catch (e) { console.error("strumenti, benvenuto:", e); }
    };
    SYNC.ui.add(dopo);
    return segnaposto;
  }
  const finito = vaiStanotte => {
    salva("benvenuto_ok", true); cartaBenvenuto._chiuso = true; BV_PASSO = 0; salva("bv_passo", 0);
    if (vaiStanotte) {
      vai("stanotte");
      setTimeout(() => { if (typeof avviaTour === "function" && schedaAttiva === "stanotte") avviaTour(TOUR_NOTTE, () => {}); }, 900);
    } else ridisegna();
  };
  const carta = el("section", { class: "gas-bv", "aria-label": t("bv_titolo") });
  const vaiPasso = i => {
    BV_PASSO = clamp(i, 0, 2); salva("bv_passo", BV_PASSO); disegna();
    const q = $(".gas-bv-q", carta);
    if (q) try { q.focus({ preventScroll: true }); } catch (e) {   }
    carta.scrollIntoView({ block: "start", behavior: "smooth" });
  };
  const togliBino = () => { if (NOTTE.bino) { NOTTE.bino = ""; salvaNotte(); } };
  const domanda = k => el("h3", { class: "gas-bv-q", tabindex: "-1" }, t(k));
  function disegna() {
    const n = BV_PASSO;
    const puntini = el("div", { class: "gas-bv-puntini", "aria-label": t("bv_passo", { n: n + 1 }) },
      [0, 1, 2].map(i => el("i", { class: i === n ? "on" : i < n ? "ok" : "" })), el("span", null, t("bv_passo", { n: n + 1 })));
    let corpo, ns = null;
    if (n === 0) corpo = [domanda("bv_q1"), el("p", { class: "gas-bv-n" }, t("bv_q1_n")), barraLuogo(() => {}, false)];
    else if (n === 1) corpo = [domanda("bv_q2"), el("p", { class: "gas-bv-n" }, t("bv_q2_n")),
      ns = percorsoSetup(() => { togliBino(); vaiPasso(2); }, true),
      el("div", { class: "gas-bv-alternative" },
        el("button", { type: "button", class: "gas-bv-alt", onclick: () => { CAMPO.modo = "visuale"; salvaCampo(); NOTTE.bino = "10x50"; salvaNotte(); vaiPasso(2); } }, "👀 ", t("bv_occhi")),
        el("button", { type: "button", class: "gas-bv-alt", onclick: () => { salva("benvenuto_ok", true); cartaBenvenuto._chiuso = true; BV_PASSO = 0; salva("bv_passo", 0);
          salva("scegli_tipo", "telescopio");
          vai("scegli"); } }, "🔭 ", t("bv_niente")))];
    else {
      const scelte = [["tutti", "bv_tutto", "✨"], ["emissione", "bv_nebulose", "🌸"], ["galassie", "bv_galassie", "🌀"], ["aperti", "bv_ammassi", "💫"], ["planetarie", "bv_planetarie", "🫧"]];
      const segna = () => {
        for (const b of gusti) {
          const kk = b.dataset.k, on = kk === "tutti" ? !tipiNotte().length : tipiNotte().length === 1 && tipiNotte()[0] === kk;
          b.classList.toggle("on", on); b.setAttribute("aria-pressed", String(on));
        }
      };
      const gusti = scelte.map(([k, tt, ico]) => { const kk = k === "emissione" ? "nebulose" : k;
        return el("button", { type: "button", class: "gas-bv-gusto", dataset: { k: kk },
          onclick: () => { NOTTE.tipi = kk === "tutti" ? [] : [kk]; salvaNotte(); segna(); } }, el("span", { class: "gas-bv-gusto-ico", "aria-hidden": "true" }, ico), t(tt)); });
      segna();
      corpo = [domanda("bv_q3"), el("p", { class: "gas-bv-n" }, t("bv_q3_n")), el("div", { class: "gas-bv-gusti" }, gusti)];
    }
    const prossimo = () => { if (ns && ns.salvaSeServe && ns.salvaSeServe()) togliBino(); vaiPasso(n + 1); };
    svuota(carta).append(
      el("div", { class: "gas-bv-testa" },
        el("div", null, el("small", { class: "gas-bv-occhiello" }, t("bv_titolo")), el("p", { class: "gas-bv-sotto" }, t("bv_sotto"))),
        el("button", { type: "button", class: "gas-ns-chiudi", "aria-label": t("bv_chiudi"), title: t("bv_chiudi"), onclick: () => finito(false) }, icona("chiudi"))),
      puntini, el("div", { class: "gas-bv-corpo" }, corpo),
      el("div", { class: "gas-bv-piede" },
        n ? el("button", { type: "button", class: "gas-btn gas-btn--chiaro gas-bv-indietro", onclick: () => vaiPasso(n - 1) }, "← ", t(n === 1 ? "bv_precedente" : "bv_indietro")) : null,
        n < 2 ? el("button", { type: "button", class: "gas-btn gas-bv-avanti" + (n === 1 ? " gas-btn--chiaro" : ""), onclick: prossimo }, t(n === 1 ? "bv_prossima" : "bv_avanti"), " →")
          : el("button", { type: "button", class: "gas-btn gas-bv-avanti", onclick: () => finito(true) }, t("bv_fine"), " →")));
  }
  disegna();
  return carta;
}
try { if (ricorda("notte", null)) { const sf = document.getElementById("gas-sfondo"); if (sf) sf.classList.add("gas-di-casa"); } } catch (e) {   }
Object.assign(TESTI.it, {
  pc_mattino: "Buongiorno", pc_pomeriggio: "Buon pomeriggio", pc_sera: "Buonasera", pc_notte: "Buona notte",
  pc_buio_ora: "È buio: il cielo è tuo fino alle {b}.", pc_buio_tra: "Stasera il buio arriva alle {a}.", pc_giorno: "Stanotte buio dalle {a} alle {b}.",
  pc_niente: "Stanotte il cielo non diventa del tutto buio.", pc_luna_su: "Luna {k} %", pc_pronto: "Il tuo osservatorio è pronto",
});
Object.assign(TESTI.de, {
  pc_mattino: "Guten Morgen", pc_pomeriggio: "Guten Tag", pc_sera: "Guten Abend", pc_notte: "Gute Nacht",
  pc_buio_ora: "Es ist dunkel: der Himmel gehört Ihnen bis {b}.", pc_buio_tra: "Heute Abend wird es um {a} dunkel.", pc_giorno: "Heute Nacht dunkel von {a} bis {b}.",
  pc_niente: "Heute Nacht wird der Himmel nicht ganz dunkel.", pc_luna_su: "Mond {k} %", pc_pronto: "Ihr Observatorium ist bereit",
});
Object.assign(TESTI.es, {
  pc_mattino: "Buenos días", pc_pomeriggio: "Buenas tardes", pc_sera: "Buenas tardes", pc_notte: "Buenas noches",
  pc_buio_ora: "Es de noche: el cielo es tuyo hasta las {b}.", pc_buio_tra: "Esta noche oscurece a las {a}.", pc_giorno: "Esta noche, oscuridad de {a} a {b}.",
  pc_niente: "Esta noche el cielo no se oscurece del todo.", pc_luna_su: "Luna al {k} %", pc_pronto: "Tu observatorio está listo",
});
Object.assign(TESTI.en, {
  pc_mattino: "Good morning", pc_pomeriggio: "Good afternoon", pc_sera: "Good evening", pc_notte: "Good evening",
  pc_buio_ora: "It's dark: the sky is yours until {b}.", pc_buio_tra: "Tonight it gets dark at {a}.", pc_giorno: "Tonight it's dark from {a} to {b}.",
  pc_niente: "Tonight the sky doesn't get fully dark.", pc_luna_su: "Moon {k}%", pc_pronto: "Your observatory is ready",
});
Object.assign(TESTI.it, { pc_cambia: "cambia", pc_luna_n: "La Luna di stasera, con la sua fase" });
Object.assign(TESTI.de, { pc_cambia: "ändern", pc_luna_n: "Der Mond heute Abend, mit seiner Phase" });
Object.assign(TESTI.es, { pc_cambia: "cambiar", pc_luna_n: "La Luna de esta noche, con su fase" });
Object.assign(TESTI.en, { pc_cambia: "change", pc_luna_n: "Tonight's Moon, with its phase" });
function disegnaLunaGrande(tela, fase) {
  const css = tela.clientWidth || 220, dpr = Math.min(window.devicePixelRatio || 1, 2), W = Math.round(css * dpr);
  if (tela.width !== W) { tela.width = W; tela.height = W; }
  const c = tela.getContext("2d"), m = W / 2, R = W * 0.3;
  c.clearRect(0, 0, W, W);
  const al = c.createRadialGradient(m, m, R * 0.9, m, m, R * 1.6);
  al.addColorStop(0, `rgba(255,240,205,${0.12 + 0.22 * fase.k})`); al.addColorStop(1, "rgba(255,240,205,0)");
  c.fillStyle = al; c.beginPath(); c.arc(m, m, R * 1.6, 0, 2 * Math.PI); c.fill();
  disegnaDiscoLuna(c, m, m, R, fase);
}
function disegnaDiscoLuna(c, x0, y0, R, fase) {
  c.save(); c.translate(x0, y0);
  c.save(); c.beginPath(); c.arc(0, 0, R, 0, 2 * Math.PI); c.clip();
  const sup = c.createRadialGradient(-R * 0.3, -R * 0.35, R * 0.1, 0, 0, R * 1.05);
  sup.addColorStop(0, "#fbf7ee"); sup.addColorStop(0.65, "#e7dfcd"); sup.addColorStop(1, "#bdb29c");
  c.fillStyle = sup; c.fillRect(-R, -R, 2 * R, 2 * R);
  const MARI = [[-0.55, -0.05, 0.27, 0.46, 0.2], [-0.28, -0.44, 0.27, 0.21, -0.2], [0.12, -0.38, 0.16, 0.15, 0], [0.28, -0.12, 0.21, 0.17, 0.3],
    [0.64, -0.3, 0.12, 0.1, 0], [0.52, 0.12, 0.12, 0.19, 0.2], [0.33, 0.27, 0.09, 0.09, 0], [-0.18, 0.36, 0.19, 0.13, 0.1], [-0.46, 0.36, 0.1, 0.09, 0],
    [-0.05, -0.73, 0.42, 0.06, 0], [0.0, -0.2, 0.08, 0.07, 0], [-0.22, 0.05, 0.12, 0.1, 0]];
  c.filter = `blur(${Math.max(1, R * 0.045)}px)`;
  for (const [x, y, a, b, r] of MARI) {
    c.fillStyle = "rgba(110,103,91,.36)"; c.beginPath(); c.ellipse(x * R, y * R, a * R, b * R, r, 0, 2 * Math.PI); c.fill();
  }
  c.filter = "none";
  let seme = 11;
  const caso = () => (seme = (seme * 16807) % 2147483647) / 2147483647;
  for (let i = 0; i < 34; i++) {
    const ang = caso() * 2 * Math.PI, d = Math.sqrt(caso()) * R * 0.95, r = (0.012 + caso() * 0.03) * R;
    const x = Math.cos(ang) * d, y = Math.sin(ang) * d;
    c.fillStyle = "rgba(95,88,78,.16)"; c.beginPath(); c.arc(x, y, r, 0, 2 * Math.PI); c.fill();
    c.strokeStyle = "rgba(255,255,255,.14)"; c.lineWidth = Math.max(1, r * 0.25); c.beginPath(); c.arc(x - r * 0.2, y - r * 0.2, r, Math.PI * 0.9, Math.PI * 1.6); c.stroke();
  }
  const tx = -0.12 * R, ty = 0.62 * R;
  c.strokeStyle = "rgba(255,255,255,.12)"; c.lineWidth = Math.max(1, R * 0.012);
  for (let i = 0; i < 9; i++) { const a = i / 9 * 2 * Math.PI + 0.3; c.beginPath(); c.moveTo(tx, ty); c.lineTo(tx + Math.cos(a) * R * 0.55, ty + Math.sin(a) * R * 0.55); c.stroke(); }
  c.fillStyle = "rgba(255,255,255,.75)"; c.beginPath(); c.arc(tx, ty, R * 0.03, 0, 2 * Math.PI); c.fill();
  c.restore();
  const S = Math.ceil(2 * R + 12), mo = S / 2, off = document.createElement("canvas");
  off.width = off.height = S;
  const o = off.getContext("2d");
  o.fillStyle = "rgba(6,12,24,.9)"; o.beginPath(); o.arc(mo, mo, R + 1, 0, 2 * Math.PI); o.fill();
  o.globalCompositeOperation = "destination-out";
  o.filter = `blur(${Math.max(1, R * 0.03)}px)`;
  o.save(); o.translate(mo, mo); o.scale(fase.crescente ? 1 : -1, 1);
  const e = R * (1 - 2 * fase.k);
  o.beginPath(); o.arc(0, 0, R + 2, -Math.PI / 2, Math.PI / 2, false); o.ellipse(0, 0, Math.abs(e), R + 2, 0, Math.PI / 2, -Math.PI / 2, e > 0); o.fill();
  o.restore();
  c.drawImage(off, -mo, -mo);
  c.restore();
}
let PLANCIA_AGGIORNA = null;
function plancia() {
  const eroe = document.querySelector(".gas-eroe");
  if (!eroe || eroe.querySelector(".gas-plancia-ciao")) return;
  eroe.classList.add("gas-eroe--app");
  const nome = ((RADICE && RADICE.dataset.nome) || "").trim().split(/\s+/)[0];
  const saluto = el("span", { class: "gas-plancia-saluto" });
  const scriviSaluto = () => {
    const h = new Date().getHours();
    const s = t(h >= 5 && h < 12 ? "pc_mattino" : h < 18 && h >= 12 ? "pc_pomeriggio" : h >= 18 && h < 23 ? "pc_sera" : "pc_notte");
    svuota(saluto).append(nome ? `${s}, ${nome}` : s, el("i", { "aria-hidden": "true" }, "\u00a0✦"));
  };
  scriviSaluto();
  const stato = el("span", { class: "gas-plancia-stato" });
  const notteDiOggi = () => suStanotte(dataNotte);
  const scriviStato = () => {
    try {
      const { lat, lon } = NOTTE.luogo, nt = Astro.notte(notteDiOggi(), lat, lon, 10), ev = nt.ev;
      const a = ev.astroFine || ev.nauticoFine, b = ev.astroInizio || ev.nauticoInizio, ora0 = new Date();
      const frase = !a || !b ? t("pc_niente") : ora0 >= a && ora0 <= b ? t("pc_buio_ora", { b: ora(b) }) : ora0 < a ? t("pc_buio_tra", { a: ora(a) }) : t("pc_giorno", { a: ora(a), b: ora(b) });
      svuota(stato).append(iconaLuna(nt.fase), " ", frase.replace(/\.\s*$/, ""), " · ", t("pc_luna_su", { k: num(nt.fase.k * 100) }));
    } catch (e) { stato.textContent = t("pc_pronto"); }
  };
  scriviStato();
  const luogo = el("button", { type: "button", class: "gas-plancia-luogo", onclick: () => vai("stanotte") });
  const scriviLuogo = () => { svuota(luogo).append(icona("luogo"), " ", el("b", null, NOTTE.luogo.nome), " · ", el("u", null, t("pc_cambia"))); };
  scriviLuogo();
  const luna = el("canvas", { class: "gas-plancia-luna", role: "img", "aria-label": t("pc_luna_n") });
  const disegnaLuna = () => { try { disegnaLunaGrande(luna, Astro.notte(notteDiOggi(), NOTTE.luogo.lat, NOTTE.luogo.lon, 10).fase); } catch (e) {   } };
  eroe.prepend(luna, el("div", { class: "gas-plancia-ciao" }, saluto, el("div", { class: "gas-plancia-righe" }, stato, luogo)));
  const sf = document.getElementById("gas-sfondo");
  if (sf) sf.classList.add("gas-con-plancia");
  requestAnimationFrame(disegnaLuna);
  window.addEventListener("resize", debounce(disegnaLuna, 200));
  const tutto = () => { scriviSaluto(); scriviStato(); scriviLuogo(); disegnaLuna(); };
  setInterval(tutto, 300000);
  document.addEventListener("visibilitychange", () => { if (!document.hidden) tutto(); });
  PLANCIA_AGGIORNA = tutto;
}
Object.assign(TESTI.it, { ab_menu: "Menu", ab_chiudi: "Chiudi il menu", ab_negozio: "Torna al negozio", ab_strumenti: "Strumenti", ab_impostazioni: "Impostazioni",
  ab_on: "Sì", ab_off: "No", ab_whatsapp: "Scrivici su WhatsApp", ab_aiuto: "Aiuto",
  ab_dentro: "Sei dentro come {n}", ab_dentro_n: "Attrezzatura, setup e diario sono nel tuo account: li ritrovi su ogni telefono e computer entrando con questa email.", ab_account: "Il mio account", ab_esci: "Esci dall'account" });
Object.assign(TESTI.de, { ab_menu: "Menü", ab_chiudi: "Menü schließen", ab_negozio: "Zurück zum Shop", ab_strumenti: "Werkzeuge", ab_impostazioni: "Einstellungen",
  ab_on: "An", ab_off: "Aus", ab_whatsapp: "Schreiben Sie uns auf WhatsApp", ab_aiuto: "Hilfe",
  ab_dentro: "Angemeldet als {n}", ab_dentro_n: "Ausrüstung, Setups und Tagebuch sind in Ihrem Konto: Sie finden sie auf jedem Handy und Computer wieder, wenn Sie sich mit dieser E-Mail anmelden.", ab_account: "Mein Konto", ab_esci: "Abmelden" });
Object.assign(TESTI.es, { ab_menu: "Menú", ab_chiudi: "Cerrar el menú", ab_negozio: "Volver a la tienda", ab_strumenti: "Herramientas", ab_impostazioni: "Ajustes",
  ab_on: "Sí", ab_off: "No", ab_whatsapp: "Escríbenos por WhatsApp", ab_aiuto: "Ayuda",
  ab_dentro: "Has entrado como {n}", ab_dentro_n: "Tu equipo, tus equipos guardados y tu diario están en tu cuenta: los tienes en cualquier móvil y ordenador entrando con este correo.", ab_account: "Mi cuenta", ab_esci: "Cerrar sesión" });
Object.assign(TESTI.en, { ab_menu: "Menu", ab_chiudi: "Close the menu", ab_negozio: "Back to the shop", ab_strumenti: "Tools", ab_impostazioni: "Settings",
  ab_on: "On", ab_off: "Off", ab_whatsapp: "Message us on WhatsApp", ab_aiuto: "Help",
  ab_dentro: "Signed in as {n}", ab_dentro_n: "Your equipment, setups and log are saved in your account: you'll find them on any phone or computer when you sign in with this email.", ab_account: "My account", ab_esci: "Sign out" });
ICONE_SVG.menu = '<path d="M4 7h16M4 12h16M4 17h16"/>';
ICONE_SVG.utente = '<circle cx="12" cy="8" r="4"/><path d="M4 21c0-4.4 3.6-8 8-8s8 3.6 8 8"/>';
ICONE_SVG.esci = '<path d="M14 4h5v16h-5M10 8l-4 4 4 4M6 12h10"/>';
const APP_TEL = window.matchMedia ? matchMedia("(max-width: 767px)") : null;
let APPBAR = null, MENU_APP = null;
const logoNegozio = () => RADICE.dataset.logo
  ? el("img", { src: RADICE.dataset.logo, alt: "Giordano Astronomia", width: 480, height: 105 })
  : [el("b", null, "GIORDANO"), el("small", null, "ASTRONOMIA")];
function creaAppbar() {
  if (!NAV4 || !RADICE || APPBAR) return;
  const pagina = RADICE.closest(".gas-pagina") || RADICE.parentNode;
  const titolo = el("b", { class: "gas-ab-tit" }, t("ab_strumenti"));
  const menu = el("button", { type: "button", class: "gas-ab-menu", "aria-label": t("ab_menu"), "aria-expanded": "false", onclick: () => apriMenuApp() }, icona("menu"));
  const logo = el("a", { class: "gas-ab-logo", href: RADICE_URL, title: t("ab_negozio") }, logoNegozio());
  APPBAR = el("div", { class: "gas-appbar" }, menu, titolo, logo);
  APPBAR.titolo = titolo;
  pagina.prepend(APPBAR);
  const applica = () => {
    document.documentElement.classList.toggle("gas-app", !!(APP_TEL && APP_TEL.matches));
    if (!(APP_TEL && APP_TEL.matches)) chiudiMenuApp();
    misuraNav();
  };
  applica();
  if (APP_TEL && APP_TEL.addEventListener) APP_TEL.addEventListener("change", applica);
}
function titoloAppbar(nome) {
  document.documentElement.classList.toggle("gas-in-home", !nome || nome === "home");
  if (APPBAR) APPBAR.titolo.textContent = !nome || nome === "home" ? t("ab_strumenti") : nomeStrumento(nome);
  if (MENU_APP) disegnaMenuApp();
}
function chiudiMenuApp() {
  if (!MENU_APP || MENU_APP.hidden) return;
  MENU_APP.hidden = true;
  document.documentElement.classList.remove("gas-menu-su");
  if (APPBAR) { const b = APPBAR.querySelector(".gas-ab-menu"); b.setAttribute("aria-expanded", "false"); b.focus({ preventScroll: true }); }
}
function apriMenuApp() {
  if (!MENU_APP) {
    MENU_APP = el("div", { class: "gas-menu-app", role: "dialog", "aria-modal": "true", "aria-label": t("ab_menu"), hidden: true });
    MENU_APP.addEventListener("click", e => { if (e.target === MENU_APP) chiudiMenuApp(); });
    document.addEventListener("keydown", e => { if (e.key === "Escape") chiudiMenuApp(); });
    document.body.appendChild(MENU_APP);
  }
  disegnaMenuApp();
  MENU_APP.classList.toggle("gas-ma--rosso", notturna);
  MENU_APP.classList.toggle("gas-grande", testoGrande);
  MENU_APP.hidden = false;
  document.documentElement.classList.add("gas-menu-su");
  if (APPBAR) APPBAR.querySelector(".gas-ab-menu").setAttribute("aria-expanded", "true");
  const primo = MENU_APP.querySelector(".gas-ma-voce.on") || MENU_APP.querySelector(".gas-ma-voce");
  if (primo) primo.focus({ preventScroll: true });
}
function disegnaMenuApp() {
  if (!MENU_APP) return;
  MENU_APP.classList.toggle("gas-ma--rosso", notturna);
  MENU_APP.classList.toggle("gas-grande", testoGrande);
  const voce = (n, ico, nome) => el("a", { class: "gas-ma-voce" + (n === schedaAttiva ? " on" : ""), href: linkStrumento(n), "aria-current": n === schedaAttiva ? "page" : null,
    onclick: e => { if (!clicSemplice(e)) return; e.preventDefault(); chiudiMenuApp(); if (n !== schedaAttiva) vai(n); } },
    el("span", { class: "gas-ma-ico" }, icona(ico)), el("span", null, nome));
  const interruttore = (ico, nome, acceso, fn) => el("button", { type: "button", class: "gas-ma-voce gas-ma-int", "aria-pressed": String(!!acceso), dataset: { ico },
    onclick: () => {
      const vecchio = MENU_APP.querySelector(".gas-ma-pannello"), y = vecchio ? vecchio.scrollTop : 0;
      fn(); disegnaMenuApp();
      const nuovo = MENU_APP.querySelector(".gas-ma-pannello");
      if (nuovo) { nuovo.style.animation = "none"; nuovo.scrollTop = y; }
      const b = MENU_APP.querySelector(`.gas-ma-int[data-ico="${ico}"]`);
      if (b) b.focus({ preventScroll: true });
    } },
    el("span", { class: "gas-ma-ico" }, icona(ico)), el("span", null, nome), el("em", { class: acceso ? "on" : "" }, t(acceso ? "ab_on" : "ab_off")));
  const pannello = el("nav", { class: "gas-ma-pannello", "aria-label": t("ab_menu") },
    el("div", { class: "gas-ma-testa" }, el("span", { class: "gas-ab-logo" }, logoNegozio()),
      el("button", { type: "button", class: "gas-ma-chiudi", "aria-label": t("ab_chiudi"), onclick: () => chiudiMenuApp() }, icona("chiudi"))),
    (() => {
      const d = RADICE.dataset, chi = d.nome || d.email || "";
      return chi ? el("div", { class: "gas-ma-gruppo gas-ma-conto" },
        el("p", { class: "gas-ma-conto-chi" }, "☁ ", t("ab_dentro", { n: chi })), d.nome && d.email ? el("small", { class: "gas-ma-conto-email" }, d.email) : null,
        el("p", { class: "gas-ma-conto-n" }, t("ab_dentro_n")),
        el("a", { class: "gas-ma-voce", href: d.account || "/account" }, el("span", { class: "gas-ma-ico" }, icona("utente")), el("span", null, t("ab_account"))),
        el("button", { type: "button", class: "gas-ma-voce gas-ma-esci", onclick: () => { chiudiMenuApp(); esciAccount(); } }, el("span", { class: "gas-ma-ico" }, icona("esci")), el("span", null, t("ab_esci"))))
        : el("div", { class: "gas-ma-gruppo gas-ma-conto" }, el("a", { class: "gas-btn", href: urlAccesso(schedaAttiva) }, t("sy_accedi"), " →"));
    })(),
    el("div", { class: "gas-ma-gruppo" }, voce("home", "home", t("vc_inizio"))),
    VOCI.map(v => el("div", { class: "gas-ma-gruppo" }, el("small", { class: "gas-ma-tit" }, t("vc_" + v.id)), v.strumenti.map(n => voce(n, icoStrumento(n), nomeStrumento(n))))),
    el("div", { class: "gas-ma-gruppo" }, el("small", { class: "gas-ma-tit" }, t("ab_impostazioni")),
      interruttore("stanotte", t("tema_scuro"), !TEMA_CHIARO, () => impostaTema(TEMA_CHIARO)),
      interruttore("testo", t("testo_grande"), testoGrande, () => impostaTesto(!testoGrande)),
      interruttore("rosso", t("rosso"), notturna, () => { impostaRosso(!notturna); if (notturna && typeof provaFatta === "function") provaFatta(4); }),
      el("button", { type: "button", class: "gas-ma-voce", onclick: e => { chiudiMenuApp(); Voce.parla(chiaveGuida(schedaAttiva), e.currentTarget); } },
        el("span", { class: "gas-ma-ico" }, icona("guida")), el("span", null, t("tt_guida"))),
      typeof APP_INSTALLATA !== "undefined" && !APP_INSTALLATA ? el("button", { type: "button", class: "gas-ma-voce", onclick: () => { chiudiMenuApp(); apriAppHome(); } },
        el("span", { class: "gas-ma-ico" }, icona("telefono")), el("span", null, t("ah_voce"))) : null),
    el("div", { class: "gas-ma-gruppo" }, el("small", { class: "gas-ma-tit" }, t("ab_aiuto")),
      el("a", { class: "gas-ma-voce", href: "https://wa.me/393284750874", target: "_blank", rel: "noopener" }, el("span", { class: "gas-ma-ico" }, icona("invia")), el("span", null, t("ab_whatsapp"))),
      el("a", { class: "gas-ma-voce gas-ma-negozio", href: RADICE_URL }, el("span", { class: "gas-ma-ico" }, icona("carrello")), el("span", null, t("ab_negozio")))));
  svuota(MENU_APP).appendChild(pannello);
}
Object.assign(TESTI.it, {
  ah_voce: "Aggiungi alla schermata Home", ah_tit: "Mettila sul telefono, come un'app",
  ah_n: "Un'icona sulla schermata Home: gli strumenti si aprono a schermo intero, senza le barre del browser.",
  ah_ios_1: "Tocca il bottone Condividi {i} (in basso in Safari, in alto a destra in Chrome).", ah_ios_2: "Scorri e tocca «Aggiungi alla schermata Home».",
  ah_ios_3: "Tocca «Aggiungi»: l'icona di Giordano Astronomia è sulla schermata Home.",
  ah_and_1: "Tocca il menu ⋮ del browser in alto a destra.", ah_and_2: "Tocca «Installa app» o «Aggiungi a schermata Home».", ah_and_3: "Conferma: l'icona di Giordano Astronomia è sulla schermata Home.",
  ah_installa: "Installa", ah_nota: "La prima volta che apri gli strumenti dall'icona devi rientrare col tuo account: per il telefono l'icona e il browser sono separati.",
  ah_fatto: "Fatto", ah_come: "Come si fa", ah_non_ora: "Non ora",
});
Object.assign(TESTI.de, {
  ah_voce: "Zum Home-Bildschirm hinzufügen", ah_tit: "Aufs Handy, wie eine App",
  ah_n: "Ein Symbol auf dem Home-Bildschirm: die Werkzeuge öffnen sich im Vollbild, ohne Browserleisten.",
  ah_ios_1: "Tippen Sie auf Teilen {i} (unten in Safari, oben rechts in Chrome).", ah_ios_2: "Nach unten scrollen und auf „Zum Home-Bildschirm“ tippen.",
  ah_ios_3: "Auf „Hinzufügen“ tippen: das Symbol von Giordano Astronomia ist auf dem Home-Bildschirm.",
  ah_and_1: "Tippen Sie oben rechts auf das Browsermenü ⋮.", ah_and_2: "Auf „App installieren“ oder „Zum Startbildschirm hinzufügen“ tippen.", ah_and_3: "Bestätigen: das Symbol von Giordano Astronomia ist auf dem Startbildschirm.",
  ah_installa: "Installieren", ah_nota: "Beim ersten Öffnen über das Symbol melden Sie sich mit Ihrem Konto an: das Handy hält es vom Browser getrennt.",
  ah_fatto: "Fertig", ah_come: "So geht's", ah_non_ora: "Nicht jetzt",
});
Object.assign(TESTI.es, {
  ah_voce: "Añadir a la pantalla de inicio", ah_tit: "Ponla en el móvil, como una app",
  ah_n: "Un icono en la pantalla de inicio: las herramientas se abren a pantalla completa, sin las barras del navegador.",
  ah_ios_1: "Toca el botón Compartir {i} (abajo en Safari, arriba a la derecha en Chrome).", ah_ios_2: "Desliza y toca «Añadir a pantalla de inicio».",
  ah_ios_3: "Toca «Añadir»: el icono de Giordano Astronomia está en la pantalla de inicio.",
  ah_and_1: "Toca el menú ⋮ del navegador arriba a la derecha.", ah_and_2: "Toca «Instalar aplicación» o «Añadir a pantalla de inicio».", ah_and_3: "Confirma: el icono de Giordano Astronomia está en la pantalla de inicio.",
  ah_installa: "Instalar", ah_nota: "La primera vez que la abras desde el icono, entra con tu cuenta: el móvil la guarda aparte del navegador.",
  ah_fatto: "Hecho", ah_come: "Cómo se hace", ah_non_ora: "Ahora no",
});
Object.assign(TESTI.en, {
  ah_voce: "Add to Home Screen", ah_tit: "Put it on your phone, like an app",
  ah_n: "An icon on your Home Screen: the tools open full screen, without the browser bars.",
  ah_ios_1: "Tap the Share button {i} (at the bottom in Safari, top right in Chrome).", ah_ios_2: "Scroll and tap “Add to Home Screen”.",
  ah_ios_3: "Tap “Add”: the Giordano Astronomia icon is on your Home Screen.",
  ah_and_1: "Tap the browser menu ⋮ at the top right.", ah_and_2: "Tap “Install app” or “Add to Home screen”.", ah_and_3: "Confirm: the Giordano Astronomia icon is on your Home screen.",
  ah_installa: "Install", ah_nota: "The first time you open it from the icon, sign in with your account: the phone keeps it separate from the browser.",
  ah_fatto: "Done", ah_come: "How to do it", ah_non_ora: "Not now",
});
ICONE_SVG.condividi_ios = '<path d="M12 3.5v11M8.2 7.2 12 3.5l3.8 3.7"/><path d="M8 10.5H6.4a1.4 1.4 0 0 0-1.4 1.4v7.2a1.4 1.4 0 0 0 1.4 1.4h11.2a1.4 1.4 0 0 0 1.4-1.4v-7.2a1.4 1.4 0 0 0-1.4-1.4H16"/>';
ICONE_SVG.telefono = '<rect x="6.5" y="2.8" width="11" height="18.4" rx="2.4"/><path d="M10.5 18h3"/>';
let APP_INSTALLATA = !!((window.matchMedia && matchMedia("(display-mode: standalone)").matches) || navigator.standalone);
const SU_IOS = /iPhone|iPad|iPod/i.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
let PROMPT_INSTALLA = null;
let AH_CARTA = null;
function appInstallata() {
  APP_INSTALLATA = true; PROMPT_INSTALLA = null;
  salva("app_home_no", true);
  if (AH_CARTA) { AH_CARTA.remove(); AH_CARTA = null; }
  if (MENU_APP && !MENU_APP.hidden) disegnaMenuApp();
}
if (typeof window.addEventListener === "function") {
  window.addEventListener("beforeinstallprompt", e => {
    e.preventDefault(); PROMPT_INSTALLA = e;
    const b = AH_CARTA && AH_CARTA.querySelector(".gas-ah-carta-bott .gas-btn");
    if (b) b.textContent = t("ah_installa");
  });
  window.addEventListener("appinstalled", appInstallata);
}
function prepariAppHome() {
  if (!RADICE) return;
  if (APP_INSTALLATA) document.documentElement.classList.add("gas-installata");
  const d = RADICE.dataset, prova = /anteprima/.test(d.pagina || "");
  const metti = (tag, attr) => {
    const sel = tag + Object.entries(attr).filter(([k]) => k === "rel" || k === "name").map(([k, v]) => `[${k}="${v}"]`).join("");
    if (document.head.querySelector(sel)) return;
    document.head.appendChild(Object.assign(document.createElement(tag), attr));
  };
  const man = prova ? d.appManifestProva : d.appManifest;
  if (man && !(typeof SR_IN_CAMPO !== "undefined" && SR_IN_CAMPO)) metti("link", { rel: "manifest", href: man });
  if (d.appIcona) metti("link", { rel: "apple-touch-icon", href: d.appIcona });
  metti("meta", { name: "apple-mobile-web-app-capable", content: "yes" });
  metti("meta", { name: "mobile-web-app-capable", content: "yes" });
  metti("meta", { name: "apple-mobile-web-app-title", content: t("ab_strumenti") });
  metti("meta", { name: "apple-mobile-web-app-status-bar-style", content: "black" });
  const tc = document.head.querySelector('meta[name="theme-color"]');
  if (tc) tc.setAttribute("content", "#050c18"); else metti("meta", { name: "theme-color", content: "#050c18" });
}
function apriAppHome() {
  if (PROMPT_INSTALLA) {
    const p = PROMPT_INSTALLA;
    p.prompt();
    p.userChoice.then(c => { if (c && c.outcome === "accepted") appInstallata(); }).catch(() => {}).finally(() => {
      PROMPT_INSTALLA = null;
      const b = AH_CARTA && AH_CARTA.querySelector(".gas-ah-carta-bott .gas-btn");
      if (b) b.textContent = t("ah_come");
    });
    return;
  }
  const passi = SU_IOS ? ["ah_ios_1", "ah_ios_2", "ah_ios_3"] : ["ah_and_1", "ah_and_2", "ah_and_3"];
  const chiudi = () => { fondo.remove(); document.documentElement.classList.remove("gas-menu-su"); };
  const ok = el("button", { type: "button", class: "gas-btn gas-ah-ok", onclick: chiudi }, t("ah_fatto"));
  const fondo = el("div", { class: "gas-ah" + (notturna ? " gas-ah--rosso" : "") + (testoGrande ? " gas-grande" : ""), role: "dialog", "aria-modal": "true", "aria-label": t("ah_voce"),
    onclick: e => { if (e.target === fondo) chiudi(); }, onkeydown: e => { if (e.key === "Escape") chiudi(); } },
    el("div", { class: "gas-ah-box" },
      el("img", { class: "gas-ah-icona", src: (RADICE.dataset.appIcona || ""), alt: "", width: 72, height: 72 }),
      el("h3", null, t("ah_tit")), el("p", { class: "gas-ah-n" }, t("ah_n")),
      el("ol", { class: "gas-ah-passi" }, passi.map(k => el("li", null, ...t(k).split("{i}").flatMap((p, n) => n ? [el("span", { class: "gas-ah-cond" }, icona("condividi_ios")), p] : [p])))),
      el("p", { class: "gas-ah-nota" }, t("ah_nota")), ok));
  document.body.appendChild(fondo);
  document.documentElement.classList.add("gas-menu-su");
  try { ok.focus({ preventScroll: true }); } catch (e) {   }
}
function cartaAppHome(ridisegna) {
  if (APP_INSTALLATA || ricorda("app_home_no", false) || !(APP_TEL && APP_TEL.matches)) return null;
  AH_CARTA = el("section", { class: "gas-ah-carta" },
    el("span", { class: "gas-ah-carta-ico" }, el("img", { src: (RADICE.dataset.appIcona || ""), alt: "", width: 52, height: 52 })),
    el("div", { class: "gas-ah-carta-testo" }, el("b", null, t("ah_tit")), el("span", null, t("ah_n"))),
    el("div", { class: "gas-ah-carta-bott" },
      el("button", { type: "button", class: "gas-btn gas-btn--mini", onclick: () => apriAppHome() }, PROMPT_INSTALLA ? t("ah_installa") : t("ah_come")),
      el("button", { type: "button", class: "gas-ah-no", onclick: () => { salva("app_home_no", true); ridisegna(); } }, t("ah_non_ora"))));
  return AH_CARTA;
}
Object.assign(TESTI.it, {
  sg_piede_t: "Un'idea o un problema?", sg_piede_n: "Dicci cosa aggiungeresti agli strumenti o cosa non funziona: leggiamo ogni messaggio.",
  sg_scrivi: "Scrivici", sg_titolo: "Suggerimenti e problemi",
  sg_intro: "Gli strumenti crescono con le idee di chi li usa. Scrivi cosa ti piacerebbe trovare o cosa non va: il messaggio arriva a chi li sviluppa.",
  sg_tipo: "Di cosa si tratta?", sg_idea: "Un'idea", sg_problema: "Un problema", sg_altro: "Altro", sg_msg: "Il tuo messaggio",
  sg_ph_idea: "Es. mi piacerebbe uno strumento per…", sg_ph_problema: "Cosa stavi facendo e cosa è successo? Es. la carta del cielo non si apre sul telefono",
  sg_ph_altro: "Scrivi qui", sg_email: "La tua email (facoltativa)", sg_email_n: "Solo se vuoi una risposta.",
  sg_email_ko: "L'indirizzo email non sembra valido (puoi anche lasciarlo vuoto).",
  sg_tecnico: "Con il messaggio inviamo anche lo strumento aperto ({s}), la lingua e il tipo di browser: servono a capire i problemi.",
  sg_privacy: "Informativa privacy", sg_invia: "Invia", sg_invio: "Invio…",
  sg_grazie: "Grazie! Il tuo messaggio è arrivato.", sg_grazie_n: "Lo leggiamo con attenzione. Se hai lasciato l'email, ti rispondiamo appena possibile.",
  sg_ancora: "Scrivi un altro messaggio", sg_errore: "Non sono riuscito a inviarlo: controlla la connessione e riprova.",
  sg_vuoto: "Scrivi qualche parola in più, così capiamo cosa intendi.", sg_robot: "Un attimo: verifico che tu non sia un robot…",
});
Object.assign(TESTI.de, {
  sg_piede_t: "Eine Idee oder ein Problem?", sg_piede_n: "Sagen Sie uns, was Sie den Werkzeugen hinzufügen würden oder was nicht funktioniert: Wir lesen jede Nachricht.",
  sg_scrivi: "Schreiben Sie uns", sg_titolo: "Vorschläge und Probleme",
  sg_intro: "Die Werkzeuge wachsen mit den Ideen ihrer Nutzer. Schreiben Sie, was Sie sich wünschen oder was nicht stimmt: Die Nachricht geht direkt an den Entwickler.",
  sg_tipo: "Worum geht es?", sg_idea: "Eine Idee", sg_problema: "Ein Problem", sg_altro: "Anderes", sg_msg: "Ihre Nachricht",
  sg_ph_idea: "Z. B. ich hätte gern ein Werkzeug für…", sg_ph_problema: "Was haben Sie gemacht und was ist passiert? Z. B. die Himmelskarte öffnet sich auf dem Handy nicht",
  sg_ph_altro: "Hier schreiben", sg_email: "Ihre E-Mail (freiwillig)", sg_email_n: "Nur wenn Sie eine Antwort möchten.",
  sg_email_ko: "Die E-Mail-Adresse scheint nicht gültig zu sein (Sie können sie auch leer lassen).",
  sg_tecnico: "Mit der Nachricht senden wir auch das geöffnete Werkzeug ({s}), die Sprache und den Browsertyp: Das hilft, Probleme zu verstehen.",
  sg_privacy: "Datenschutzerklärung", sg_invia: "Senden", sg_invio: "Wird gesendet…",
  sg_grazie: "Danke! Ihre Nachricht ist angekommen.", sg_grazie_n: "Wir lesen sie aufmerksam. Wenn Sie Ihre E-Mail angegeben haben, antworten wir so bald wie möglich.",
  sg_ancora: "Noch eine Nachricht schreiben", sg_errore: "Senden fehlgeschlagen: Bitte prüfen Sie die Verbindung und versuchen Sie es erneut.",
  sg_vuoto: "Schreiben Sie bitte ein paar Worte mehr, damit wir verstehen, was Sie meinen.", sg_robot: "Einen Moment: Wir prüfen, dass Sie kein Roboter sind…",
});
Object.assign(TESTI.es, {
  sg_piede_t: "¿Una idea o un problema?", sg_piede_n: "Dinos qué añadirías a las herramientas o qué no funciona: leemos cada mensaje.",
  sg_scrivi: "Escríbenos", sg_titolo: "Sugerencias y problemas",
  sg_intro: "Las herramientas crecen con las ideas de quien las usa. Escribe qué te gustaría encontrar o qué no va bien: el mensaje llega a quien las desarrolla.",
  sg_tipo: "¿De qué se trata?", sg_idea: "Una idea", sg_problema: "Un problema", sg_altro: "Otro", sg_msg: "Tu mensaje",
  sg_ph_idea: "P. ej. me gustaría una herramienta para…", sg_ph_problema: "¿Qué estabas haciendo y qué ha pasado? P. ej. la Carta celeste no se abre en el móvil",
  sg_ph_altro: "Escribe aquí", sg_email: "Tu correo (opcional)", sg_email_n: "Solo si quieres una respuesta.",
  sg_email_ko: "La dirección de correo no parece válida (también puedes dejarla vacía).",
  sg_tecnico: "Con el mensaje enviamos también la herramienta abierta ({s}), el idioma y el tipo de navegador: sirven para entender los problemas.",
  sg_privacy: "Política de privacidad", sg_invia: "Enviar", sg_invio: "Enviando…",
  sg_grazie: "¡Gracias! Tu mensaje ha llegado.", sg_grazie_n: "Lo leemos con atención. Si has dejado tu correo, te responderemos lo antes posible.",
  sg_ancora: "Escribir otro mensaje", sg_errore: "No he podido enviarlo: comprueba la conexión e inténtalo de nuevo.",
  sg_vuoto: "Escribe alguna palabra más, así entendemos lo que quieres decir.", sg_robot: "Un momento: compruebo que no eres un robot…",
});
Object.assign(TESTI.en, {
  sg_piede_t: "An idea or a problem?", sg_piede_n: "Tell us what you'd add to the tools or what isn't working: we read every message.",
  sg_scrivi: "Write to us", sg_titolo: "Suggestions and problems",
  sg_intro: "These tools grow with the ideas of the people who use them. Tell us what you'd like to find or what's wrong: your message goes straight to the person who builds them.",
  sg_tipo: "What is it about?", sg_idea: "An idea", sg_problema: "A problem", sg_altro: "Other", sg_msg: "Your message",
  sg_ph_idea: "E.g. I'd love a tool for…", sg_ph_problema: "What were you doing and what happened? E.g. the sky chart doesn't open on my phone",
  sg_ph_altro: "Write here", sg_email: "Your email (optional)", sg_email_n: "Only if you'd like a reply.",
  sg_email_ko: "The email address doesn't look valid (you can also leave it empty).",
  sg_tecnico: "Along with your message we send the open tool ({s}), the language and the browser type: they help us understand problems.",
  sg_privacy: "Privacy policy", sg_invia: "Send", sg_invio: "Sending…",
  sg_grazie: "Thank you! We've received your message.", sg_grazie_n: "We'll read it carefully. If you left your email, we'll reply as soon as we can.",
  sg_ancora: "Write another message", sg_errore: "I couldn't send it: check your connection and try again.",
  sg_vuoto: "Please write a few more words, so we understand what you mean.", sg_robot: "Just a moment: checking you're not a robot…",
});
ICONE_SVG.suggerimenti = '<path d="M5.4 4.2h13.2a1.8 1.8 0 0 1 1.8 1.8v8.6a1.8 1.8 0 0 1-1.8 1.8h-7.4l-4.6 3.8v-3.8H5.4a1.8 1.8 0 0 1-1.8-1.8V6a1.8 1.8 0 0 1 1.8-1.8z"/>'
  + '<path class="pieno" d="M12 6.9l.8 1.65 1.8.27-1.3 1.27.3 1.8-1.6-.85-1.6.85.3-1.8-1.3-1.27 1.8-.27z"/>';
const SG_URL = "/apps/strumenti/suggerimenti";
const SG_TURNSTILE = "0x4AAAAAAE-p2S2z4nZNZbMr";
const SG_TIPI = ["idea", "problema", "altro"];
let _sgTurnstile = null, _sgFoglio = null, _sgBozza = null;
function caricaTurnstile() {
  if (window.turnstile) return Promise.resolve(window.turnstile);
  if (!_sgTurnstile) _sgTurnstile = new Promise((ok, ko) => {
    const s = document.createElement("script");
    s.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
    s.async = true;
    s.onload = () => (window.turnstile ? ok(window.turnstile) : ko(new Error("turnstile")));
    s.onerror = () => { _sgTurnstile = null; ko(new Error("turnstile")); };
    document.head.appendChild(s);
  });
  return _sgTurnstile;
}
function apriSuggerimenti(tipo) {
  if (_sgFoglio) _sgFoglio.chiudi();
  const bozza = _sgBozza;
  const st = { tipo: bozza ? bozza.tipo : SG_TIPI.includes(tipo) ? tipo : "idea", gettone: "", widget: null, aperto: Date.now(), invio: false };
  const strumento = schedaAttiva || "home";
  const nomeAperto = strumento === "home" ? t("home_strumenti") : NAV4 ? nomeStrumento(strumento) : t("tab_" + strumento);
  const area = el("textarea", { class: "gas-input gas-sg-msg", id: "gas-sg-msg", rows: 5, maxlength: 4000 });
  const email = el("input", { class: "gas-input", id: "gas-sg-email", type: "email", autocomplete: "email", inputmode: "email", maxlength: 160 });
  if (bozza) { area.value = bozza.testo; email.value = bozza.email; }
  const ricordaBozza = () => { _sgBozza = area.value.trim() || email.value.trim() ? { tipo: st.tipo, testo: area.value, email: email.value } : null; };
  area.addEventListener("input", ricordaBozza); email.addEventListener("input", ricordaBozza);
  const esca = el("input", { class: "gas-sg-esca", type: "text", name: "azienda", tabindex: "-1", autocomplete: "off", "aria-hidden": "true" });
  const avviso = el("p", { class: "gas-sg-avviso", role: "alert", hidden: true });
  const robot = el("div", { class: "gas-sg-robot" });
  const invia = el("button", { type: "submit", class: "gas-btn" }, t("sg_invia"));
  const tipi = SG_TIPI.map(k => el("button", { type: "button", class: "gas-chip gas-sg-tipo", "aria-pressed": String(k === st.tipo), dataset: { tipo: k },
    onclick: () => { st.tipo = k; tipi.forEach(c => c.setAttribute("aria-pressed", String(c.dataset.tipo === k))); area.placeholder = t("sg_ph_" + k); ricordaBozza(); } }, t("sg_" + k)));
  area.placeholder = t("sg_ph_" + st.tipo);
  const mostra = (testo, campo) => { avviso.textContent = testo; avviso.hidden = !testo; if (campo) campo.focus(); };
  const modulo = el("form", { class: "gas-sg-modulo", novalidate: true },
    el("p", { class: "gas-sg-intro" }, t("sg_intro")),
    el("div", { class: "gas-sg-tipi", role: "group", "aria-label": t("sg_tipo") }, tipi),
    el("label", { class: "gas-campo", for: "gas-sg-msg" }, el("span", null, t("sg_msg"))), area,
    el("label", { class: "gas-campo gas-sg-email", for: "gas-sg-email" }, el("span", null, t("sg_email"))), email,
    el("p", { class: "gas-nota gas-sg-nota" }, t("sg_email_n")),
    esca, robot, avviso,
    el("div", { class: "gas-riga-bottoni" }, invia),
    el("p", { class: "gas-nota gas-sg-nota" }, t("sg_tecnico", { s: nomeAperto }), " ",
      el("a", { href: RADICE_URL.replace(/\/?$/, "/") + "pages/privacy-policy", target: "_blank", rel: "noopener" }, t("sg_privacy"))));
  const corpo = el("div", { class: "gas-sg-corpo" }, modulo);
  const foglio = el("div", { class: "gas-foglio gas-sg-foglio", role: "dialog", "aria-modal": "true", "aria-label": t("sg_titolo") },
    el("div", { class: "gas-foglio-box gas-sg-box" },
      el("div", { class: "gas-foglio-testa" }, el("b", null, t("sg_titolo")),
        el("button", { type: "button", class: "gas-foglio-chiudi", "aria-label": t("home_chiudi"), onclick: () => chiudi() }, icona("chiudi"))),
      corpo));
  const tasto = e => { if (e.key === "Escape") chiudi(); };
  function chiudi() {
    document.removeEventListener("keydown", tasto);
    if (st.widget != null && window.turnstile) { try { window.turnstile.remove(st.widget); } catch (e) {   } }
    foglio.remove();
    document.documentElement.classList.remove("gas-foglio-su");
    if (_sgFoglio && _sgFoglio.foglio === foglio) _sgFoglio = null;
  }
  foglio.addEventListener("click", e => { if (e.target === foglio) chiudi(); });
  document.addEventListener("keydown", tasto);
  (document.getElementById("gas-sfondo") || document.body).appendChild(foglio);
  document.documentElement.classList.add("gas-foglio-su");
  _sgFoglio = { foglio, chiudi };
  if (window.matchMedia && matchMedia("(pointer: fine)").matches) area.focus();
  const preparaRobot = () => caricaTurnstile().then(ts => {
    if (!foglio.isConnected || st.widget != null) return;
    st.widget = ts.render(robot, { sitekey: SG_TURNSTILE, theme: "dark", size: "flexible", appearance: "interaction-only", language: LINGUA,
      callback: g => { st.gettone = g; }, "expired-callback": () => { st.gettone = ""; }, "error-callback": () => { st.gettone = ""; } });
  }).catch(() => {   });
  preparaRobot();
  const aspettaGettone = ms => new Promise(ok => { const t0 = Date.now(); const giro = () => (st.gettone || Date.now() - t0 > ms ? ok() : setTimeout(giro, 200)); giro(); });
  modulo.addEventListener("submit", async e => {
    e.preventDefault();
    if (st.invio) return;
    const testo = area.value.trim(), mail = email.value.trim();
    if (testo.replace(/\s+/g, "").length < 5) return mostra(t("sg_vuoto"), area);
    if (mail && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(mail)) return mostra(t("sg_email_ko"), email);
    if (navigator.onLine === false) return mostra(t("sg_errore"));
    st.invio = true; invia.disabled = true; invia.textContent = t("sg_invio");
    try {
      if (!st.gettone) { mostra(t("sg_robot")); await aspettaGettone(10000); }
      mostra("");
      const r = await fetch(SG_URL, { method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ tipo: st.tipo, messaggio: testo, email: mail, lingua: LINGUA, strumento, pagina: location.pathname + location.hash,
          dispositivo: navigator.userAgent.slice(0, 220) + " · " + window.innerWidth + "×" + window.innerHeight, aperto_il: st.aperto, azienda: esca.value,
          turnstile: st.gettone }) });
      const j = await r.json().catch(() => null);
      if (r.ok && j && j.ok) {
        _sgBozza = null;
        svuota(corpo).append(el("div", { class: "gas-sg-fatto" },
          el("span", { class: "gas-sg-fatto-ico", "aria-hidden": "true" }, "✓"),
          el("b", null, t("sg_grazie")), el("p", null, t("sg_grazie_n")),
          el("div", { class: "gas-riga-bottoni" },
            el("button", { type: "button", class: "gas-btn gas-btn--mini", onclick: () => apriSuggerimenti(st.tipo) }, t("sg_ancora")),
            el("button", { type: "button", class: "gas-btn gas-btn--chiaro gas-btn--mini", onclick: () => chiudi() }, t("home_chiudi")))));
        return;
      }
      throw Object.assign(new Error(j && typeof j.errore === "string" && j.errore.includes(" ") ? j.errore : ""), { delServer: true });
    } catch (err) {
      mostra(err && err.delServer && err.message ? err.message : t("sg_errore"));
      if (st.widget != null && window.turnstile) { try { window.turnstile.reset(st.widget); } catch (x) {   } st.gettone = ""; }
    } finally {
      st.invio = false; invia.disabled = false; invia.textContent = t("sg_invia");
    }
  });
}
function piedeSuggerimenti() {
  return el("aside", { class: "gas-sg-piede" },
    el("span", { class: "gas-sg-ico", "aria-hidden": "true" }, icona("suggerimenti")),
    el("div", { class: "gas-sg-piede-testo" }, el("b", null, t("sg_piede_t")), el("span", null, t("sg_piede_n"))),
    el("button", { type: "button", class: "gas-btn gas-btn--mini gas-sg-piede-btn", onclick: () => apriSuggerimenti("idea") }, t("sg_scrivi"), " →"));
}
Object.assign(ICONE_SVG, {
  senzarete: '<rect x="6.5" y="2.8" width="11" height="18.4" rx="2.2"/><path d="M12 7.2v6.4M9.3 11 12 13.7 14.7 11"/><path d="M10.4 18.1h3.2"/>',
});
Object.assign(TESTI.it, {
  sr_titolo: "Sul campo senza rete",
  sr_n: "Per usare gli strumenti dove il telefono non prende (in montagna, in campagna): 1) a casa, con la rete, tocca «Prepara per il campo»; 2) apri la versione da campo e aggiungila alla schermata Home o ai Preferiti; 3) sul campo aprila da lì, anche senza rete.",
  sr_prepara: "Prepara per il campo", sr_aggiorna: "Aggiorna i dati salvati", sr_togli: "Cancella i dati salvati", sr_apri: "Apri la versione da campo",
  sr_lavoro: "Salvo gli strumenti su questo dispositivo… {p} %",
  sr_pronto: "Pronto: dati salvati il giorno {d} alle {o} per {l} ({mb} MB).",
  sr_cosa: "Senza rete funzionano: «Cosa vedere», il Campo inquadrato (le foto del cielo solo se già viste), la Carta del cielo, «Luna, Sole e pianeti», i calcolatori, la tua attrezzatura e il diario. Il meteo resta quello dell'ultima volta che c'era rete.",
  sr_iphone_chrome: "Su iPhone con Chrome: tocca il quadrato con la freccia in su accanto all'indirizzo (se non lo vedi: i tre puntini ⋯ e poi «Condividi»), poi «Aggiungi alla schermata Home». Chrome e l'icona salvano i dati ognuno per conto suo: tocca «Prepara per il campo» dall'icona se sul campo userai l'icona, da Chrome se userai Chrome. Se preferisci restare in Chrome, salvala nei Preferiti.",
  sr_iphone: "Su iPhone: in Safari tocca il quadrato con la freccia in su, poi «Aggiungi alla schermata Home». Safari e l'icona salvano i dati ognuno per conto suo: tocca «Prepara per il campo» dall'icona se sul campo userai l'icona, da Safari se userai Safari.", sr_android: "Su Android: in Chrome tocca i tre puntini in alto a destra, poi «Aggiungi a schermata Home».",
  sr_errore: "Non sono riuscito a salvare tutto: controlla la rete e riprova.",
  sr_no: "Questo browser non permette di salvare gli strumenti per usarli senza rete: apri questa pagina in Safari o in Chrome e riprova da lì.",
  sr_tolti: "Dati salvati tolti da questo dispositivo.",
  sr_in_campo: "Questa è la versione da campo: funziona anche senza rete. Dati salvati il giorno {d} alle {o}; quando torna la rete si aggiornano da soli.",
  sr_completa: "Torna alla versione normale",
  sr_offline: "Sei senza rete: stai usando gli strumenti salvati il giorno {d} alle {o}.",
  sr_offline_mai: "Sei senza rete: alcune parti degli strumenti potrebbero non funzionare.",
  sr_offline_vai: "Apri la versione da campo",
});
Object.assign(TESTI.de, {
  sr_titolo: "Im Feld ohne Netz",
  sr_n: "So nutzen Sie die Werkzeuge dort, wo das Handy keinen Empfang hat (in den Bergen, auf dem Land): 1) zu Hause, mit Netz, auf „Für das Feld vorbereiten“ tippen; 2) die Feldversion öffnen und zum Home-Bildschirm oder zu den Favoriten hinzufügen; 3) im Feld von dort öffnen, auch ohne Netz.",
  sr_prepara: "Für das Feld vorbereiten", sr_aggiorna: "Gespeicherte Daten aktualisieren", sr_togli: "Gespeicherte Daten löschen", sr_apri: "Feldversion öffnen",
  sr_lavoro: "Die Werkzeuge werden auf diesem Gerät gespeichert… {p} %",
  sr_pronto: "Fertig: Daten gespeichert am {d} um {o} für {l} ({mb} MB).",
  sr_cosa: "Ohne Netz funktionieren: „Was sehen“, das Bildfeld (Himmelsfotos nur, wenn schon angesehen), die Sternkarte, „Mond, Sonne und Planeten“, die Rechner, Ihre Ausrüstung und das Tagebuch. Das Wetter bleibt das vom letzten Mal mit Netz.",
  sr_iphone_chrome: "Auf dem iPhone mit Chrome: Tippen Sie auf das Quadrat mit dem Pfeil nach oben neben der Adresse (falls nicht sichtbar: die drei Punkte ⋯ und dann «Teilen»), dann «Zum Home-Bildschirm». Chrome und das Symbol speichern ihre Daten getrennt: Tippen Sie auf «Für das Feld vorbereiten» im Symbol, wenn Sie im Feld das Symbol nutzen, und in Chrome, wenn Sie Chrome nutzen. Wenn Sie lieber in Chrome bleiben, speichern Sie sie als Lesezeichen.",
  sr_iphone: "Auf dem iPhone: in Safari auf das Quadrat mit dem Pfeil nach oben tippen, dann «Zum Home-Bildschirm». Safari und das Symbol speichern ihre Daten getrennt: Tippen Sie auf «Für das Feld vorbereiten» im Symbol, wenn Sie im Feld das Symbol nutzen, und in Safari, wenn Sie Safari nutzen.", sr_android: "Auf Android: in Chrome auf die drei Punkte oben rechts tippen, dann auf „Zum Startbildschirm hinzufügen“.",
  sr_errore: "Nicht alles konnte gespeichert werden: prüfen Sie das Netz und versuchen Sie es erneut.",
  sr_no: "Dieser Browser erlaubt es nicht, die Werkzeuge für die Nutzung ohne Netz zu speichern: Öffnen Sie diese Seite in Safari oder Chrome und versuchen Sie es dort erneut.",
  sr_tolti: "Gespeicherte Daten von diesem Gerät entfernt.",
  sr_in_campo: "Das ist die Feldversion: sie funktioniert auch ohne Netz. Daten gespeichert am {d} um {o}; mit Netz aktualisieren sie sich von selbst.",
  sr_completa: "Zurück zur normalen Version",
  sr_offline: "Kein Netz: Sie nutzen die am {d} um {o} gespeicherten Werkzeuge.",
  sr_offline_mai: "Kein Netz: einige Teile der Werkzeuge funktionieren eventuell nicht.",
  sr_offline_vai: "Feldversion öffnen",
});
Object.assign(TESTI.es, {
  sr_titolo: "En el campo sin conexión",
  sr_n: "Para usar las herramientas donde el móvil no tiene cobertura (en la montaña, en el campo): 1) en casa, con conexión, toca «Preparar para el campo»; 2) abre la versión de campo y añádela a la pantalla de inicio o a Favoritos; 3) en el campo ábrela desde ahí, también sin conexión.",
  sr_prepara: "Preparar para el campo", sr_aggiorna: "Actualizar los datos guardados", sr_togli: "Borrar los datos guardados", sr_apri: "Abrir la versión de campo",
  sr_lavoro: "Guardando las herramientas en este dispositivo… {p} %",
  sr_pronto: "Listo: datos guardados el {d} a las {o} para {l} ({mb} MB).",
  sr_cosa: "Sin conexión funcionan: «Qué ver», el Campo de visión (las fotos del cielo solo si ya las has visto), la Carta celeste, «Luna, Sol y planetas», las calculadoras, tu equipo y el diario. La previsión del tiempo es la de la última vez que hubo conexión.",
  sr_iphone_chrome: "En iPhone con Chrome: toca el cuadrado con la flecha hacia arriba junto a la dirección (si no lo ves: los tres puntos ⋯ y luego «Compartir»), y después «Añadir a pantalla de inicio». Chrome y el icono guardan los datos cada uno por su lado: toca «Preparar para el campo» desde el icono si en el campo usarás el icono, desde Chrome si usarás Chrome. Si prefieres quedarte en Chrome, guárdala en Marcadores.",
  sr_iphone: "En iPhone: en Safari toca el cuadrado con la flecha hacia arriba y luego «Añadir a pantalla de inicio». Safari y el icono guardan los datos cada uno por su lado: toca «Preparar para el campo» desde el icono si en el campo usarás el icono, desde Safari si usarás Safari.", sr_android: "En Android: en Chrome toca los tres puntos arriba a la derecha y luego «Añadir a pantalla de inicio».",
  sr_errore: "No se ha podido guardar todo: comprueba la conexión y vuelve a intentarlo.",
  sr_no: "Este navegador no permite guardar las herramientas para usarlas sin conexión: abre esta página en Safari o en Chrome y vuelve a intentarlo desde ahí.",
  sr_tolti: "Se han borrado los datos guardados de este dispositivo.",
  sr_in_campo: "Esta es la versión de campo: funciona también sin conexión. Datos guardados el {d} a las {o}; cuando vuelve la conexión se actualizan solos.",
  sr_completa: "Volver a la versión normal",
  sr_offline: "Sin conexión: estás usando las herramientas guardadas el {d} a las {o}.",
  sr_offline_mai: "Sin conexión: algunas partes de las herramientas podrían no funcionar.",
  sr_offline_vai: "Abrir la versión de campo",
});
Object.assign(TESTI.en, {
  sr_titolo: "In the field without a connection",
  sr_n: "To use the tools where your phone has no signal (in the mountains, in the countryside): 1) at home, with a connection, tap “Get ready for the field”; 2) open the field version and add it to your Home screen or Favourites; 3) out in the field, open it from there, even with no connection.",
  sr_prepara: "Get ready for the field", sr_aggiorna: "Update saved data", sr_togli: "Delete the saved data", sr_apri: "Open the field version",
  sr_lavoro: "Saving the tools on this device… {p}%",
  sr_pronto: "Ready: data saved on {d} at {o} for {l} ({mb} MB).",
  sr_cosa: "These work without a connection: “What to see”, the Field of view (sky photos only if you've already seen them), the Sky chart, “Moon, Sun & planets”, the calculators, your equipment and your log. The weather stays as it was the last time you were online.",
  sr_iphone_chrome: "On iPhone with Chrome: tap the square with the up arrow next to the address (if you can't see it: the three dots ⋯ and then “Share”), then “Add to Home Screen”. Chrome and the icon each keep their own data: tap “Get ready for the field” from the icon if you'll use the icon in the field, from Chrome if you'll use Chrome. If you'd rather stay in Chrome, save it as a bookmark.",
  sr_iphone: "On iPhone: in Safari tap the square with the up arrow, then “Add to Home Screen”. Safari and the icon each keep their own data: tap “Get ready for the field” from the icon if you'll use the icon in the field, from Safari if you'll use Safari.", sr_android: "On Android: in Chrome tap the three dots at the top right, then “Add to Home screen”.",
  sr_errore: "Couldn't save everything: check your connection and try again.",
  sr_no: "This browser doesn't allow saving the tools for use without a connection: open this page in Safari or Chrome and try again from there.",
  sr_tolti: "Saved data removed from this device.",
  sr_in_campo: "This is the field version: it works even without a connection. Data saved on {d} at {o}; when you're back online it updates by itself.",
  sr_completa: "Back to the normal version",
  sr_offline: "No connection: you're using the tools saved on {d} at {o}.",
  sr_offline_mai: "No connection: some parts of the tools may not work.",
  sr_offline_vai: "Open the field version",
});
const SR_PAGINE = "gas-pagine-v1", SR_FILE = "gas-file-v1";
const srBase = () => RADICE_URL.replace(/\/?$/, "/");
const srHandle = () => (RADICE && RADICE.dataset.pagina) || PAGINA_HUB;
const srIndirizzo = () => location.origin + srBase() + "apps/strumenti/campo/" + srHandle();
const SR_IN_CAMPO = /\/apps\/strumenti\/campo\//.test(location.pathname);
const srPossibile = () => "serviceWorker" in navigator && "caches" in window && window.isSecureContext !== false;
const srQuando = t => ({ d: new Date(t).toLocaleDateString(LOCALE, { day: "numeric", month: "numeric" }), o: ora(new Date(t)) });
const srSalvato = () => { const s = ricorda("senza_rete", null); return s && s.t ? s : null; };
function srAttivo(reg) {
  return new Promise(ok => {
    if (reg.active) return ok();
    const w = reg.installing || reg.waiting;
    if (!w) return ok();
    const fine = setTimeout(ok, 10000);
    w.addEventListener("statechange", () => { if (w.state === "activated" || w.state === "redundant") { clearTimeout(fine); ok(); } });
  });
}
async function srPaginaVera() {
  const r = await fetch(srBase() + "pages/" + srHandle(), { credentials: "same-origin", cache: "no-store" });
  const html = r.ok ? await r.text() : "";
  return html.includes('id="ga-strumenti"') ? html : null;
}
const srCopia = html => new Response(html, { headers: { "content-type": "text/html; charset=utf-8" } });
function srFileDellaPagina(html) {
  const fuori = new Set(), nostro = u => { try { const x = new URL(u.replace(/&amp;/g, "&"), location.href); return x.origin === location.origin && x.pathname.startsWith("/cdn/") ? x.href : null; } catch (e) { return null; } };
  for (const m of html.matchAll(/(?:href|src|data-[a-z-]+)="((?:https?:)?\/\/[^"]+|\/cdn\/[^"]+)"/g)) {
    const u = nostro(m[1]);
    if (u && /\.(?:css|js|json|woff2?)(?:\?|$)/.test(u)) fuori.add(u);
  }
  return fuori;
}
async function srSfoltisci(file, nuovi) {
  try {
    const senzaV = u => { const x = new URL(u); x.searchParams.delete("v"); return x.href; };
    const chiavi = await file.keys(), dentro = new Set(chiavi.map(k => k.url));
    const basi = new Set([...nuovi].filter(u => dentro.has(u)).map(senzaV));
    for (const k of chiavi) if (!nuovi.has(k.url) && new URL(k.url).searchParams.has("v") && basi.has(senzaV(k.url))) await file.delete(k);
  } catch (e) {   }
}
async function preparaCampo(avanza) {
  const reg = await navigator.serviceWorker.register(srBase() + "apps/strumenti/sw.js", { scope: srBase() + "apps/strumenti/", updateViaCache: "none" });
  await srAttivo(reg);
  const html = await srPaginaVera();
  if (!html) throw new Error("pagina");
  const lista = srFileDellaPagina(html), assoluto = u => new URL(u, location.href).href;
  for (const e of performance.getEntriesByType("resource")) {
    try { const u = new URL(e.name); if (u.origin === location.origin && u.pathname.startsWith("/cdn/")) lista.add(u.href); } catch (err) {   }
  }
  const D = RADICE.dataset, nome = (base, n) => assoluto(base.replace(/ga-[a-z]+-0\.json/, n));
  if (D.stelle) {
    const j = await fetch(D.stelle, { credentials: "omit" }).then(r => r.json()).catch(() => null);
    if (j) {
      for (const b of Object.keys(j.medie || {})) lista.add(nome(D.stelle, `ga-stelle-m${b}.json`));
      for (const k of Object.keys(j.tasselli || {})) lista.add(nome(D.stelle, `ga-stelle-t${k}.json`));
    }
  }
  if (D.citta || D.buio) {
    const nomeBuio = n => D.buio ? assoluto(D.buio.replace("ga-buio.json", n)) : nome(D.citta, n);
    for (const n of ["ga-buio.json", "ga-buio-terra.json", "ga-buio-vicini.json"]) lista.add(nomeBuio(n));
    if (D.citta) lista.add(nome(D.citta, "ga-luci.json"));
    const ix = await fetch(nomeBuio("ga-buio.json"), { credentials: "omit" }).then(r => r.json()).catch(() => null);
    if (ix && ix.lato && Array.isArray(ix.tasselli)) {
      const la = NOTTE.luogo.lat, lo = NOTTE.luogo.lon, dLat = 150 / 111.2, dLon = 150 / (111.2 * Math.max(0.2, Math.cos(la * RAD)));
      for (let a = Math.floor((la - dLat) / ix.lato) * ix.lato; a <= la + dLat; a += ix.lato)
        for (let o = Math.floor((lo - dLon) / ix.lato) * ix.lato; o <= lo + dLon; o += ix.lato)
          if (ix.tasselli.includes(`${a}-${o}`)) lista.add(nomeBuio(`ga-buio-${a}-${o}.json`));
    }
  }
  const la = Math.round(NOTTE.luogo.lat * 100) / 100, lo = Math.round(NOTTE.luogo.lon * 100) / 100;
  lista.add(`https://api.met.no/weatherapi/locationforecast/2.0/complete?lat=${la}&lon=${lo}`);
  const file = await caches.open(SR_FILE), voci = [...lista];
  let fatti = 0, errori = 0, byte = 0;
  const uno = async u => {
    try {
      if (!/api\.met\.no/.test(u) && await file.match(u)) return;
      const r = await fetch(u, { credentials: "omit" });
      if (!r.ok) throw new Error(r.status);
      const b = await r.clone().blob();
      byte += b.size;
      await file.put(u, r);
    } catch (e) { errori++; }
    finally { avanza(Math.round(++fatti / (voci.length + 1) * 100)); }
  };
  for (let i = 0; i < voci.length; i += 6) await Promise.all(voci.slice(i, i + 6).map(uno));
  await (await caches.open(SR_PAGINE)).put(srIndirizzo(), srCopia(html));
  await srSfoltisci(file, lista);
  provaFatta(4);
  try { await caricaComete(); } catch (e) {   }
  avanza(100);
  let mb = byte / 1048576;
  try { const s = navigator.storage && navigator.storage.estimate ? await navigator.storage.estimate() : null; if (s && s.usage) mb = s.usage / 1048576; } catch (e) {   }
  salva("senza_rete", { t: Date.now(), mb: Math.round(mb * 10) / 10, luogo: NOTTE.luogo.nome || "", h: srHandle() });
  return { mb, errori };
}
async function togliCampo() {
  if ("serviceWorker" in navigator) for (const r of await navigator.serviceWorker.getRegistrations()) if (/\/apps\/strumenti\/$/.test(new URL(r.scope).pathname)) await r.unregister();
  if ("caches" in window) for (const k of await caches.keys()) if (k.startsWith("gas-")) await caches.delete(k);
  salva("senza_rete", null);
}
async function aggiornaCopia() {
  if (!SR_IN_CAMPO || navigator.onLine === false || !("caches" in window)) return;
  const html = await srPaginaVera().catch(() => null);
  if (!html) return;
  const file = await caches.open(SR_FILE), nuovi = srFileDellaPagina(html);
  for (const u of nuovi) {
    if (await file.match(u)) continue;
    try { const r = await fetch(u, { credentials: "omit" }); if (r.ok) await file.put(u, r); } catch (e) { return; }
  }
  await (await caches.open(SR_PAGINE)).put(location.origin + location.pathname, srCopia(html));
  await srSfoltisci(file, nuovi);
  const s = srSalvato();
  if (s) salva("senza_rete", Object.assign(s, { t: Date.now() }));
}
Object.assign(TESTI.it, { sr_intro: "Una copia degli strumenti salvata sul telefono, per usarli anche senza rete: in montagna, in campagna, al buio.",
  sr_p1: "A casa, con la rete, tocca «Prepara per il campo».", sr_p2: "Apri la versione da campo e aggiungila alla schermata Home (o ai Preferiti).",
  sr_p3: "Sul campo aprila da lì: funziona anche senza rete.", sr_cosa_t: "Cosa funziona senza rete" });
Object.assign(TESTI.de, { sr_intro: "Eine auf dem Handy gespeicherte Kopie der Werkzeuge, um sie auch ohne Netz zu nutzen: in den Bergen, auf dem Land, im Dunkeln.",
  sr_p1: "Zu Hause, mit Netz, auf „Für das Feld vorbereiten“ tippen.", sr_p2: "Die Feldversion öffnen und zum Home-Bildschirm (oder zu den Favoriten) hinzufügen.",
  sr_p3: "Im Feld von dort öffnen: sie funktioniert auch ohne Netz.", sr_cosa_t: "Was ohne Netz funktioniert" });
Object.assign(TESTI.es, { sr_intro: "Una copia de las herramientas guardada en el móvil, para usarlas también sin conexión: en la montaña, en el campo, a oscuras.",
  sr_p1: "En casa, con conexión, toca «Preparar para el campo».", sr_p2: "Abre la versión de campo y añádela a la pantalla de inicio (o a Favoritos).",
  sr_p3: "En el campo ábrela desde ahí: funciona también sin conexión.", sr_cosa_t: "Qué funciona sin conexión" });
Object.assign(TESTI.en, { sr_intro: "A copy of the tools saved on your phone, to use them even without a connection: in the mountains, in the countryside, in the dark.",
  sr_p1: "At home, with a connection, tap “Get ready for the field”.", sr_p2: "Open the field version and add it to your Home screen (or Favourites).",
  sr_p3: "Out in the field, open it from there: it works even with no connection.", sr_cosa_t: "What works without a connection" });
Object.assign(TESTI.it, { sr_offline_copia: "Sei senza rete: hai una copia degli strumenti salvata il {d} alle {o}." });
Object.assign(TESTI.de, { sr_offline_copia: "Kein Netz: Sie haben eine am {d} um {o} gespeicherte Kopie der Werkzeuge." });
Object.assign(TESTI.es, { sr_offline_copia: "Sin conexión: tienes una copia de las herramientas guardada el {d} a las {o}." });
Object.assign(TESTI.en, { sr_offline_copia: "No connection: you have a copy of the tools saved on {d} at {o}." });
function cartaSenzaRete() {
  const box = scheda(null);
  box.classList.add("gas-sr");
  box.id = "gas-sr";
  const stato = el("p", { class: "gas-nota gas-sr-stato", role: "status", "aria-live": "polite" });
  const bottoni = el("div", { class: "gas-riga-bottoni" });
  const disegna = (msg) => {
    svuota(bottoni);
    const s = srSalvato();
    if (msg) stato.textContent = msg;
    else if (s) { const q = srQuando(s.t); stato.textContent = SR_IN_CAMPO ? t("sr_in_campo", q) : t("sr_pronto", { mb: num(s.mb || 0, 1), d: q.d, o: q.o, l: s.luogo || NOTTE.luogo.nome || "" }); }
    else stato.textContent = "";
    stato.hidden = !stato.textContent;
    stato.classList.toggle("gas-sr-stato--ok", !!s && !msg);
    passi.hidden = SR_IN_CAMPO || !srPossibile();
    if (!srPossibile()) { stato.textContent = t("sr_no"); stato.hidden = false; return; }
    const prepara = el("button", { type: "button", class: "gas-btn" + (s ? " gas-btn--chiaro" : ""), onclick: async () => {
      prepara.disabled = true;
      stato.hidden = false; stato.textContent = t("sr_lavoro", { p: 0 });
      try {
        const esito = await preparaCampo(p => { stato.textContent = t("sr_lavoro", { p }); });
        disegna(esito.errori ? t("sr_errore") : null);
      } catch (e) { console.error("strumenti, senza rete:", e); disegna(t("sr_errore")); }
    } }, icona("senzarete"), " ", s ? t("sr_aggiorna") : t("sr_prepara"));
    if (s && !SR_IN_CAMPO) bottoni.append(el("a", { class: "gas-btn", href: srIndirizzo() }, t("sr_apri"), " →"));
    if (SR_IN_CAMPO) bottoni.append(el("a", { class: "gas-btn gas-btn--chiaro", href: srBase() + "pages/" + srHandle() }, t("sr_completa"), " →"));
    bottoni.append(prepara);
    if (s) bottoni.append(el("button", { type: "button", class: "gas-sr-togli", onclick: async () => {
      try { await togliCampo(); } catch (e) {   }
      disegna(t("sr_tolti"));
    } }, t("sr_togli")));
  };
  const telefono = IOS ? (/CriOS/i.test(navigator.userAgent) ? "sr_iphone_chrome" : "sr_iphone") : /Android/i.test(navigator.userAgent) ? "sr_android" : null;
  const passi = el("ol", { class: "gas-sr-passi" }, el("li", null, t("sr_p1")),
    el("li", null, t("sr_p2"), telefono ? el("small", null, t(telefono)) : null), el("li", null, t("sr_p3")));
  aggiungi(box, [el("h3", { class: "gas-sr-titolo" }, icona("senzarete"), " ", t("sr_titolo")), el("p", { class: "gas-sr-intro" }, t("sr_intro")),
    passi, stato, bottoni,
    el("details", { class: "gas-dettagli gas-sr-cosa" }, el("summary", null, t("sr_cosa_t")), el("p", { class: "gas-nota" }, t("sr_cosa")))]);
  disegna();
  return box;
}
function avvisoSenzaRete() {
  const riga = el("div", { class: "gas-sr-avviso", role: "status", hidden: true });
  const agg = () => {
    const s = srSalvato(), senza = navigator.onLine === false;
    svuota(riga);
    riga.hidden = !senza;
    if (!senza) return;
    riga.append(el("span", null, icona("senzarete"), " ", s ? t(SR_IN_CAMPO ? "sr_offline" : "sr_offline_copia", srQuando(s.t)) : t("sr_offline_mai")));
    if (s && !SR_IN_CAMPO) riga.append(el("a", { href: srIndirizzo() }, t("sr_offline_vai"), " →"));
  };
  window.addEventListener("online", agg);
  window.addEventListener("offline", agg);
  agg();
  return riga;
}
Object.assign(ICONE_SVG, {
  tester: '<path d="M12 3.2l2.3 1.6 2.8-.1.9 2.7 2.2 1.7-.9 2.7.9 2.7-2.2 1.7-.9 2.7-2.8-.1L12 20.8l-2.3-1.6-2.8.1-.9-2.7-2.2-1.7.9-2.7-.9-2.7 2.2-1.7.9-2.7 2.8.1z"/><path d="M8.8 12.2l2.2 2.2 4.2-4.4"/>',
});
Object.assign(TESTI.it, {
  bt_titolo: "Benvenuto nella prova degli strumenti!",
  bt_n: "Grazie per darci una mano. Per una settimana usali come faresti davvero e prova queste 5 cose. Se qualcosa non va, o ti viene un'idea, scrivicelo con «Un'idea o un problema?» in fondo alla pagina.",
  bt_1: "Inserisci la tua attrezzatura", bt_1n: "Telescopi, camere, oculari e filtri. Poi apri gli strumenti dall'altro dispositivo (telefono o computer) e controlla di ritrovare la stessa attrezzatura.",
  bt_2: "Guarda cosa inquadra il tuo setup", bt_2n: "Nel Campo inquadrato scegli un oggetto che vuoi fotografare o osservare.",
  bt_3: "Scopri cosa fotografare stanotte", bt_3n: "Metti il tuo luogo: gli oggetti migliori, il meteo, la Luna e il posto buio più vicino.",
  bt_4: "Fai un quiz", bt_4n: "Telescopio, camera o montatura: rispondi come se dovessi comprare davvero.",
  bt_5: "Provali sul campo", bt_5n: "La visione notturna, la guida a voce (bottone «Guida» in alto) e «Prepara per il campo» per usarli senza rete.",
  bt_vai: "Apri", bt_fatto: "Fatto", bt_da_fare: "Da fare", bt_nota: "Le spunte restano solo su questo dispositivo.", bt_nascondi: "Nascondi",
  bt_tutto: "Hai provato tutto: grazie! Raccontaci com'è andata con «Un'idea o un problema?».", bt_rivedi: "Le 5 prove del tester",
});
Object.assign(TESTI.de, {
  bt_titolo: "Willkommen beim Test der Werkzeuge!",
  bt_n: "Danke für Ihre Hilfe. Nutzen Sie die Werkzeuge eine Woche lang wie im Alltag und probieren Sie diese 5 Dinge aus. Wenn etwas nicht passt oder Sie eine Idee haben, schreiben Sie uns über „Eine Idee oder ein Problem?“ unten auf der Seite.",
  bt_1: "Tragen Sie Ihre Ausrüstung ein", bt_1n: "Teleskope, Kameras, Okulare und Filter. Öffnen Sie die Werkzeuge dann auf dem anderen Gerät (Handy oder Computer) und prüfen Sie, ob dieselbe Ausrüstung da ist.",
  bt_2: "Sehen Sie, was Ihr Setup erfasst", bt_2n: "Wählen Sie im Bildfeld ein Objekt, das Sie fotografieren oder beobachten möchten.",
  bt_3: "Entdecken Sie, was Sie heute Nacht fotografieren können", bt_3n: "Geben Sie Ihren Ort ein: die besten Objekte, das Wetter, den Mond und den nächsten dunklen Ort.",
  bt_4: "Machen Sie ein Quiz", bt_4n: "Teleskop, Kamera oder Montierung: antworten Sie, als ob Sie wirklich kaufen würden.",
  bt_5: "Im Feld ausprobieren", bt_5n: "Die Nachtsicht, die Sprachführung (Knopf „Hilfe“ oben) und „Für das Feld vorbereiten“, um die Werkzeuge ohne Netz zu nutzen.",
  bt_vai: "Öffnen", bt_fatto: "Erledigt", bt_da_fare: "Offen", bt_nota: "Die Häkchen bleiben nur auf diesem Gerät.", bt_nascondi: "Ausblenden",
  bt_tutto: "Sie haben alles ausprobiert: danke! Erzählen Sie uns über „Eine Idee oder ein Problem?“, wie es war.", bt_rivedi: "Die 5 Tests",
});
Object.assign(TESTI.es, {
  bt_titolo: "¡Bienvenido a la prueba de las herramientas!",
  bt_n: "Gracias por echarnos una mano. Durante una semana úsalas como lo harías de verdad y prueba estas 5 cosas. Si algo no va, o se te ocurre una idea, escríbenos con «¿Una idea o un problema?» al final de la página.",
  bt_1: "Añade tu equipo", bt_1n: "Telescopios, cámaras, oculares y filtros. Luego abre las herramientas desde el otro dispositivo (móvil u ordenador) y comprueba que aparezca el mismo equipo.",
  bt_2: "Mira qué encuadra tu equipo", bt_2n: "En Campo de visión elige un objeto que quieras fotografiar u observar.",
  bt_3: "Descubre qué fotografiar esta noche", bt_3n: "Pon tu lugar: los mejores objetos, el tiempo, la Luna y el sitio oscuro más cercano.",
  bt_4: "Haz un test", bt_4n: "Telescopio, cámara o montura: responde como si fueras a comprar de verdad.",
  bt_5: "Pruébalas en el campo", bt_5n: "La visión nocturna, la guía por voz (botón «Guía» arriba) y «Preparar para el campo» para usarlas sin conexión.",
  bt_vai: "Abrir", bt_fatto: "Hecho", bt_da_fare: "Pendiente", bt_nota: "Las marcas se quedan solo en este dispositivo.", bt_nascondi: "Ocultar",
  bt_tutto: "Lo has probado todo: ¡gracias! Cuéntanos qué tal con «¿Una idea o un problema?».", bt_rivedi: "Las 5 pruebas",
});
Object.assign(TESTI.en, {
  bt_titolo: "Welcome to the tools test!",
  bt_n: "Thanks for helping us. For a week, use them as you really would and try these 5 things. If something doesn't work, or you have an idea, tell us with “An idea or a problem?” at the bottom of the page.",
  bt_1: "Add your equipment", bt_1n: "Telescopes, cameras, eyepieces and filters. Then open the tools on your other device (phone or computer) and check the same equipment is there.",
  bt_2: "See what your setup frames", bt_2n: "In Field of view, pick an object you want to image or observe.",
  bt_3: "Find out what to image tonight", bt_3n: "Set your location: the best targets, the weather, the Moon and the nearest dark site.",
  bt_4: "Take a quiz", bt_4n: "Telescope, camera or mount: answer as if you were really buying.",
  bt_5: "Try them in the field", bt_5n: "Night vision, the voice guide (“Guide” button at the top) and “Get ready for the field” to use them without a connection.",
  bt_vai: "Open", bt_fatto: "Done", bt_da_fare: "To do", bt_nota: "The ticks stay on this device only.", bt_nascondi: "Hide",
  bt_tutto: "You've tried everything: thank you! Tell us how it went with “An idea or a problem?”.", bt_rivedi: "The 5 tester tasks",
});
Object.assign(TESTI.it, { bt_conta: "{n} di 5 prove fatte", bt_mostra: "Mostra le 5 prove", bt_riduci: "Riduci" });
Object.assign(TESTI.de, { bt_conta: "{n} von 5 Tests erledigt", bt_mostra: "Die 5 Tests zeigen", bt_riduci: "Verkleinern" });
Object.assign(TESTI.es, { bt_conta: "{n} de 5 pruebas hechas", bt_mostra: "Ver las 5 pruebas", bt_riduci: "Reducir" });
Object.assign(TESTI.en, { bt_conta: "{n} of 5 tasks done", bt_mostra: "Show the 5 tasks", bt_riduci: "Collapse" });
Object.assign(TESTI.it, { bt_5n_app: "La visione notturna e la guida a voce («Ascolta la guida»), tutte e due nel menu ☰ in alto, e «Prepara per il campo» per usarli senza rete." });
Object.assign(TESTI.de, { bt_5n_app: "Die Nachtsicht und die Sprachführung («Anleitung anhören»), beide im Menü ☰ oben, und «Für das Feld vorbereiten», um sie ohne Netz zu nutzen." });
Object.assign(TESTI.es, { bt_5n_app: "La visión nocturna y la guía por voz («Escuchar la guía»), las dos en el menú ☰ de arriba, y «Preparar para el campo» para usarlas sin conexión." });
Object.assign(TESTI.en, { bt_5n_app: "Night vision and the voice guide («Listen to the guide»), both in the ☰ menu at the top, and «Get ready for the field» to use them without a connection." });
const BT_PROVE = [["bt_1", "attrezzatura"], ["bt_2", "campo"], ["bt_3", "stanotte"], ["bt_4", "scegli"], ["bt_5", null]];
const eTester = () => !!(RADICE && RADICE.dataset.tester === "1");
function provaFatta(i) {
  try {
    if (!eTester()) return;
    const f = new Set(ricorda("tester_fatti", []));
    if (f.has(i)) return;
    f.add(i); salva("tester_fatti", [...f]);
  } catch (e) {   }
}
const attrezziPieni = () => !!ATTREZZI && ["tel", "cam", "oc", "k", "m"].some(k => (ATTREZZI[k] || []).length);
let BT_APERTO = null;
function cartaTester(ridisegna) {
  if (!eTester()) return null;
  const rifai = bt => {
    ridisegna();
    const b = document.querySelector(`[data-bt="${bt}"]`);
    if (b) try { b.focus({ preventScroll: true }); } catch (e) {   }
  };
  if (ricorda("tester_nascosto", false)) {
    return el("div", { class: "gas-riga-bottoni gas-bt-rivedi" }, el("button", { type: "button", class: "gas-cx-chip gas-cx-chip--mini", dataset: { bt: "rivedi" },
      onclick: () => { salva("tester_nascosto", false); rifai(BT_APERTO ? "riduci" : "mostra"); } }, icona("tester"), el("span", null, t("bt_rivedi"))));
  }
  if (attrezziPieni() && !ricorda("tester_auto0", false)) { provaFatta(0); salva("tester_auto0", true); }
  const fatti = new Set(ricorda("tester_fatti", []));
  if (BT_APERTO === null) { BT_APERTO = !ricorda("tester_visto", false); salva("tester_visto", true); }
  const app = !!(APPBAR && APP_TEL && APP_TEL.matches);
  const box = scheda(null);
  box.classList.add("gas-bt");
  const nascondi = el("button", { type: "button", class: "gas-btn gas-btn--chiaro gas-btn--mini", dataset: { bt: "nascondi" },
    onclick: () => { salva("tester_nascosto", true); rifai("rivedi"); } }, t("bt_nascondi"));
  if (!BT_APERTO) {
    aggiungi(box, [el("h3", { class: "gas-bt-titolo" }, icona("tester"), " ", t("bt_titolo")),
      el("div", { class: "gas-bt-piede gas-bt-piede--corto" }, el("span", { class: "gas-bt-conta" }, t("bt_conta", { n: fatti.size })),
        el("div", { class: "gas-riga-bottoni" }, el("button", { type: "button", class: "gas-btn gas-btn--mini", dataset: { bt: "mostra" },
          onclick: () => { BT_APERTO = true; rifai("riduci"); } }, t("bt_mostra")), nascondi))]);
    return box;
  }
  const lista = el("ol", { class: "gas-bt-lista" });
  BT_PROVE.forEach(([k, scheda_], i) => {
    const fatto = fatti.has(i);
    lista.appendChild(el("li", { class: "gas-bt-voce" + (fatto ? " fatto" : "") },
      el("button", { type: "button", class: "gas-bt-spunta", "aria-pressed": String(fatto), "aria-label": `${t(k)}: ${fatto ? t("bt_fatto") : t("bt_da_fare")}`, dataset: { bt: "spunta" + i },
        onclick: () => { if (fatti.has(i)) fatti.delete(i); else fatti.add(i); salva("tester_fatti", [...fatti]); rifai("spunta" + i); } }, fatto ? "✓" : String(i + 1)),
      el("div", { class: "gas-bt-testo" }, el("b", null, t(k)), el("span", null, t(k + "n" + (app && k === "bt_5" ? "_app" : "")))),
      el("button", { type: "button", class: "gas-btn gas-btn--chiaro gas-btn--mini", onclick: () => {
        if (scheda_) { vai(scheda_); return; }
        const sr = document.getElementById("gas-sr");
        if (sr) sr.scrollIntoView({ behavior: "smooth", block: "start" });
      } }, t("bt_vai"))));
  });
  aggiungi(box, [el("h3", { class: "gas-bt-titolo" }, icona("tester"), " ", t("bt_titolo")), el("p", { class: "gas-nota" }, t("bt_n")), lista,
    fatti.size === BT_PROVE.length ? el("p", { class: "gas-bt-grazie" }, t("bt_tutto")) : null,
    el("div", { class: "gas-bt-piede" }, el("small", { class: "gas-muto" }, t("bt_nota")),
      el("div", { class: "gas-riga-bottoni" }, el("button", { type: "button", class: "gas-btn gas-btn--chiaro gas-btn--mini", dataset: { bt: "riduci" },
        onclick: () => { BT_APERTO = false; rifai("mostra"); } }, t("bt_riduci")), nascondi))]);
  return box;
}
Object.assign(TESTI.it, {
  av_titolo: "Avvisi del cielo per email",
  av_n: "Ti scriviamo prima di eclissi, comete luminose e piogge di meteore, insieme alle novità degli strumenti, alle notizie e alle offerte del negozio. Ti cancelli quando vuoi con un clic.",
  av_si: "Iscrivimi", av_no: "Non ora", av_nota: "Usiamo l'email del tuo account.", av_privacy: "Informativa privacy",
  av_ok: "Fatto: sei iscritto agli avvisi del cielo. Grazie!",
  av_conferma: "Fatto! Se ti arriva un'email di conferma, aprila e tocca il link per completare l'iscrizione.", av_chiudi: "Chiudi",
  av_gia: "Avvisi attivi: ti scriviamo prima di eclissi, comete luminose e piogge di meteore. Ti cancelli quando vuoi dal link in fondo alle nostre email.",
  av_attiva: "Attiva gli avvisi", av_n_iscritto: "Ricevi già le nostre email: attiva anche gli avvisi del cielo, ti scriviamo prima di eclissi, comete luminose e piogge di meteore.",
});
Object.assign(TESTI.de, {
  av_titolo: "Himmels-Benachrichtigungen per E-Mail",
  av_n: "Wir schreiben Ihnen vor Finsternissen, hellen Kometen und Meteorströmen, zusammen mit den Neuigkeiten der Werkzeuge, Nachrichten und Angeboten des Shops. Abmelden jederzeit mit einem Klick.",
  av_si: "Anmelden", av_no: "Nicht jetzt", av_nota: "Wir verwenden die E-Mail Ihres Kontos.", av_privacy: "Datenschutzerklärung",
  av_ok: "Erledigt: Sie erhalten jetzt die Himmels-Benachrichtigungen. Danke!",
  av_conferma: "Erledigt! Wenn Sie eine Bestätigungs-E-Mail erhalten, öffnen Sie sie und tippen Sie auf den Link, um die Anmeldung abzuschließen.", av_chiudi: "Schließen",
  av_gia: "Benachrichtigungen aktiv: Wir schreiben Ihnen vor Finsternissen, hellen Kometen und Meteorströmen. Abmelden jederzeit über den Link am Ende unserer E-Mails.",
  av_attiva: "Benachrichtigungen aktivieren", av_n_iscritto: "Sie erhalten bereits unsere E-Mails: aktivieren Sie auch die Himmels-Benachrichtigungen, wir schreiben Ihnen vor Finsternissen, hellen Kometen und Meteorströmen.",
});
Object.assign(TESTI.es, {
  av_titolo: "Avisos del cielo por email",
  av_n: "Te escribimos antes de los eclipses, los cometas brillantes y las lluvias de meteoros, junto con las novedades de las herramientas, las noticias y las ofertas de la tienda. Te das de baja cuando quieras con un clic.",
  av_si: "Suscribirme", av_no: "Ahora no", av_nota: "Usamos el correo de tu cuenta.", av_privacy: "Política de privacidad",
  av_ok: "Hecho: estás suscrito a los avisos del cielo. ¡Gracias!",
  av_conferma: "¡Hecho! Si te llega un email de confirmación, ábrelo y toca el enlace para completar la suscripción.", av_chiudi: "Cerrar",
  av_gia: "Avisos activos: te escribimos antes de los eclipses, los cometas brillantes y las lluvias de meteoros. Te das de baja cuando quieras desde el enlace al final de nuestros emails.",
  av_attiva: "Activar los avisos", av_n_iscritto: "Ya recibes nuestros emails: activa también los avisos del cielo, te escribimos antes de eclipses, cometas brillantes y lluvias de meteoros.",
});
Object.assign(TESTI.en, {
  av_titolo: "Sky alerts by email",
  av_n: "We'll email you before eclipses, bright comets and meteor showers, together with what's new in the tools and the shop's news and offers. Unsubscribe anytime with one click.",
  av_si: "Sign me up", av_no: "Not now", av_nota: "We use your account email.", av_privacy: "Privacy policy",
  av_ok: "Done: you're signed up for sky alerts. Thank you!",
  av_conferma: "Done! If you get a confirmation email, open it and tap the link to finish signing up.", av_chiudi: "Close",
  av_gia: "Alerts on: we'll email you before eclipses, bright comets and meteor showers. Unsubscribe anytime from the link at the bottom of our emails.",
  av_attiva: "Turn on alerts", av_n_iscritto: "You already get our emails: turn on sky alerts too, and we'll email you before eclipses, bright comets and meteor showers.",
});
Object.assign(ICONE_SVG, {
  avvisi: '<path d="M4.6 6.6h14.8a1.4 1.4 0 0 1 1.4 1.4v9.6a1.4 1.4 0 0 1-1.4 1.4H4.6a1.4 1.4 0 0 1-1.4-1.4V8a1.4 1.4 0 0 1 1.4-1.4z"/><path d="M3.6 7.6 12 13.4l8.4-5.8"/><path class="pieno" d="M18.6 2.2l.5 1.1 1.1.5-1.1.5-.5 1.1-.5-1.1-1.1-.5 1.1-.5z"/>',
});
let AV_MODULO = null;
const avModulo = () => AV_MODULO || (AV_MODULO = document.getElementById("gas-avvisi-modulo"));
function cartaAvvisi() {
  if (RADICE && RADICE.dataset.avvisi === "1") {
    const gia = scheda(null);
    gia.classList.add("gas-av", "gas-av--gia");
    aggiungi(gia, [el("h3", { class: "gas-av-titolo" }, icona("avvisi"), " ", t("av_titolo")), el("p", { class: "gas-av-gia" }, "✓ ", t("av_gia"))]);
    return gia;
  }
  const giaIscritto = !!RADICE && RADICE.dataset.iscritto === "1";
  if (!RADICE || (RADICE.dataset.iscritto !== "0" && !giaIscritto) || !avModulo()) return null;
  if (SR_IN_CAMPO || navigator.onLine === false) return null;
  const no = ricorda("avvisi_no", 0);
  if (no && Date.now() - no < 30 * 864e5) return null;
  const box = scheda(null);
  box.classList.add("gas-av");
  const f = avModulo();
  for (const vecchio of f.querySelectorAll(".gas-av-invia")) vecchio.remove();
  const si = el("button", { type: "submit", class: "gas-btn gas-av-invia" }, t("av_si"));
  f.onsubmit = () => { salva("avvisi_chiesto", Date.now()); };
  si.addEventListener("click", () => {
    if (f.dataset.hcaptchaBound) return;
    try { f.dispatchEvent(new FocusEvent("focusin", { bubbles: true })); } catch (e) {   }
    si.classList.add("gas-av-attesa");
    const t0 = Date.now(), prova = () => {
      if (!f.isConnected) return;
      if (f.dataset.hcaptchaBound) { setTimeout(() => { try { f.requestSubmit(si); } catch (e) { si.click(); } }, 400); return; }
      if (Date.now() - t0 < 10000) setTimeout(prova, 250); else si.classList.remove("gas-av-attesa");
    };
    setTimeout(prova, 250);
  });
  f.classList.add("gas-av-modulo");
  f.appendChild(si);
  if (giaIscritto) si.textContent = t("av_attiva");
  aggiungi(box, [el("h3", { class: "gas-av-titolo" }, icona("avvisi"), " ", t("av_titolo")), el("p", { class: "gas-nota" }, t(giaIscritto ? "av_n_iscritto" : "av_n")),
    el("div", { class: "gas-riga-bottoni" }, f,
      el("button", { type: "button", class: "gas-btn gas-btn--chiaro gas-btn--mini", onclick: () => {
        salva("avvisi_no", Date.now());
        for (const c of document.querySelectorAll(".gas-av")) c.remove();
      } }, t("av_no"))),
    el("small", { class: "gas-muto gas-av-nota" }, t("av_nota"), " ",
      el("a", { href: RADICE_URL.replace(/\/?$/, "/") + "pages/privacy-policy", target: "_blank", rel: "noopener" }, t("av_privacy")))]);
  return box;
}
function esitoAvvisi() {
  const dalModulo = location.hash === "#gas-avvisi-modulo";
  if (!/[?&]customer_posted=true\b/.test(location.search) && !dalModulo) return null;
  if (dalModulo) {
    try { history.replaceState(history.state, "", location.pathname + location.search); } catch (e) {   }
    setTimeout(() => window.scrollTo(0, 0), 50);
  }
  const chiesto = ricorda("avvisi_chiesto", 0);
  if (!chiesto || Date.now() - chiesto > 15 * 60000) return null;
  salva("avvisi_chiesto", 0);
  try { history.replaceState(history.state, "", location.pathname + location.search.replace(/[?&]customer_posted=true\b/, "").replace(/^&/, "?") + location.hash); } catch (e) {   }
  const riga = el("div", { class: "gas-av-esito", role: "status" },
    el("span", null, icona("avvisi"), " ", RADICE.dataset.iscritto === "1" ? t("av_ok") : t("av_conferma")),
    el("button", { type: "button", class: "gas-btn gas-btn--chiaro gas-btn--mini", onclick: () => riga.remove() }, t("av_chiudi")));
  return riga;
}
Object.assign(TESTI.it, {
  nl_etichetta: "Gratis con la newsletter", nl_titolo: "Iscriviti alla newsletter e accedi agli strumenti",
  nl_testo: "Gli strumenti per l'astronomia sono gratuiti: per accedere basta iscriversi alla newsletter di Giordano Astronomia. Iscriviti con un tocco e accedi subito: riceverai le nostre email con novità e offerte.",
  nl_nota: "Usiamo l'email del tuo account. Puoi cancellarti quando vuoi dal link in fondo alle email e continuerai a usare gli strumenti.", nl_bottone: "Iscriviti e accedi", nl_privacy: "Informativa privacy",
});
Object.assign(TESTI.de, {
  nl_etichetta: "Kostenlos mit dem Newsletter", nl_titolo: "Newsletter abonnieren und die Werkzeuge nutzen",
  nl_testo: "Die Astronomie-Werkzeuge sind kostenlos: Für den Zugang genügt das Abonnement des Newsletters von Giordano Astronomia. Abonnieren Sie mit einem Tippen und legen Sie sofort los: Sie erhalten unsere E-Mails mit Neuigkeiten und Angeboten.",
  nl_nota: "Wir verwenden die E-Mail Ihres Kontos. Sie können sich jederzeit über den Link am Ende der E-Mails abmelden und die Werkzeuge weiter nutzen.", nl_bottone: "Abonnieren und loslegen", nl_privacy: "Datenschutzerklärung",
});
Object.assign(TESTI.es, {
  nl_etichetta: "Gratis con la newsletter", nl_titolo: "Suscríbete a la newsletter y accede a las herramientas",
  nl_testo: "Las herramientas de astronomía son gratuitas: para acceder basta suscribirse a la newsletter de Giordano Astronomia. Suscríbete con un toque y accede enseguida: recibirás nuestros emails con novedades y ofertas.",
  nl_nota: "Usamos el correo de tu cuenta. Puedes darte de baja cuando quieras desde el enlace al final de los emails y seguirás usando las herramientas.", nl_bottone: "Suscribirme y acceder", nl_privacy: "Política de privacidad",
});
Object.assign(TESTI.en, {
  nl_etichetta: "Free with the newsletter", nl_titolo: "Subscribe to the newsletter and access the tools",
  nl_testo: "The astronomy tools are free: to access them, just subscribe to the Giordano Astronomia newsletter. Subscribe with one tap and get straight in: you'll receive our emails with news and offers.",
  nl_nota: "We use your account email. You can unsubscribe anytime from the link at the bottom of the emails and you'll keep using the tools.", nl_bottone: "Subscribe and access", nl_privacy: "Privacy policy",
});
const ACCESSO_URL = "/apps/strumenti/accesso";
function segnaMovimento(voce) {
  try {
    if (!RADICE || RADICE.dataset.collaudo === "1" || (typeof SR_IN_CAMPO !== "undefined" && SR_IN_CAMPO)) return;
    const g = new Date().toISOString().slice(0, 10), m = ricorda("movimento", null);
    const fatte = m && m.g === g ? m.v : [];
    if (fatte.includes(voce)) return;
    salva("movimento", { g, v: fatte.concat(voce) });
    fetch("/apps/strumenti/movimento", { method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ voce }) }).catch(() => {});
  } catch (e) {   }
}
async function cancelloNewsletter() {
  const d = RADICE.dataset, prova = d.collaudo === "1" && /[?&]prova-newsletter\b/.test(location.search);
  if (!prova) {
    if (d.iscritto !== "0" && d.iscritto !== "1") return true;
    const dalModulo = /[?&]customer_posted=true/.test(location.search) || location.hash === "#gas-accesso-modulo";
    if (dalModulo) {
      segnaMovimento("iscrizione");
      if (location.hash === "#gas-accesso-modulo") history.replaceState(null, "", location.pathname + location.search);
    }
    if (dalModulo || d.iscritto === "1" || d.accesso === "1") {
      const chi = d.cliente || d.email || "si";
      if (ricorda("accesso_segnato", "") !== chi) fetch(ACCESSO_URL, { method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/json" }, body: "{}" })
        .then(r => { if (r.ok) salva("accesso_segnato", chi); }).catch(() => {});
      return true;
    }
    if (typeof SR_IN_CAMPO !== "undefined" && SR_IN_CAMPO) return true;
    try {
      const r = await fetch(ACCESSO_URL + "?t=" + Date.now(), { credentials: "same-origin" });
      if (!r.ok) return true;
      const j = await r.json();
      if (j.visto || j.accesso === false) return true;
    } catch (e) { return true; }
  }
  segnaMovimento("avviso");
  disegnaCancello(prova);
  return false;
}
function disegnaCancello(prova) {
  const f = document.getElementById("gas-accesso-modulo") || (prova ? el("form", { onsubmit: e => e.preventDefault() }) : null);
  if (!f) return;
  const si = el("button", { type: "submit", class: "gas-btn gas-nl-via" }, t("nl_bottone"), " →");
  si.addEventListener("click", () => {
    if (f.dataset.hcaptchaBound || prova) return;
    try { f.dispatchEvent(new FocusEvent("focusin", { bubbles: true })); } catch (e) {   }
    si.classList.add("gas-av-attesa");
    const t0 = Date.now(), attendi = () => {
      if (!f.isConnected) return;
      if (f.dataset.hcaptchaBound) { setTimeout(() => { try { f.requestSubmit(si); } catch (e) { si.click(); } }, 400); return; }
      if (Date.now() - t0 < 10000) setTimeout(attendi, 250); else si.classList.remove("gas-av-attesa");
    };
    setTimeout(attendi, 250);
  });
  f.appendChild(si);
  RADICE.appendChild(el("section", { class: "gas-card gas-nl" },
    el("span", { class: "gas-nl-etichetta" }, t("nl_etichetta")), el("h2", { class: "gas-nl-titolo" }, t("nl_titolo")), el("p", { class: "gas-nl-testo" }, t("nl_testo")),
    f, el("p", { class: "gas-nota gas-nl-nota" }, t("nl_nota"), " ", el("a", { href: RADICE_URL.replace(/\/?$/, "/") + "pages/privacy-policy", target: "_blank", rel: "noopener" }, t("nl_privacy")))));
}
Object.assign(TESTI.it, {
  tr_avanti: "Avanti", tr_indietro: "Indietro", tr_fine: "Fine", tr_salta: "Salta la guida", tr_conta: "{n} di {m}", tr_rifai: "Giro guidato",
  tr_1: "Benvenuto negli strumenti di Giordano Astronomia! Qui in alto ci sono tutte le schede: tocca un nome per aprirla. Ti faccio fare un giro di un minuto.",
  tr_2: "Non sai quale telescopio scegliere? Qui c'è il quiz: con cinque domande facili ti consigliamo tre telescopi del negozio e ti spieghiamo perché.",
  tr_3: "Qui metti la tua attrezzatura una volta sola: basta scrivere cosa hai, per esempio «Seestar S50» o «Newton 200/1000 e Canon 6D», e l'assistente compila tutto per te.",
  tr_4: "Nel Campo inquadrato vedi cosa entra nella tua camera o nel tuo oculare, su una foto vera del cielo. Finita la guida, trascina il cielo per spostarti; con «Risultato» vedi come uscirà la foto.",
  tr_5: "Stanotte: qui in alto il luogo, la notte e la tua attrezzatura. Tocca «Cambia» per modificarli.",
  tr_6: "Poi scegli cosa vedere: gli oggetti migliori della notte, i pianeti, meteore, comete e la ISS, il tuo piano e i posti bui vicino a te.",
  tr_7: "Ecco il Meteo: il pallino verde, giallo o rosso ti dice come sarà la notte e accanto vedi le ore buone. Più sotto, ora per ora, trovi nuvole basse, medie e alte, umidità e vento.",
  tr_8: "Questa è Guida: una voce ti spiega la pagina in cui sei. In ogni strumento c'è anche Come funziona, che ti mostra i punti importanti. Qui accanto trovi Testo grande, per ingrandire le scritte. Cieli sereni!",
});
Object.assign(TESTI.de, {
  tr_avanti: "Weiter", tr_indietro: "Zurück", tr_fine: "Fertig", tr_salta: "Rundgang überspringen", tr_conta: "{n} von {m}", tr_rifai: "Rundgang",
  tr_1: "Willkommen bei den Werkzeugen von Giordano Astronomia! Oben finden Sie alle Bereiche: tippen Sie auf einen Namen, um den Bereich zu öffnen. Ich zeige Ihnen in einer Minute alles.",
  tr_2: "Sie wissen nicht, welches Teleskop Sie wählen sollen? Hier ist das Quiz: Nach fünf einfachen Fragen empfehlen wir Ihnen drei Teleskope aus dem Shop und erklären, warum.",
  tr_3: "Hier tragen Sie Ihre Ausrüstung nur einmal ein: Sie schreiben einfach, was Sie haben, etwa „Seestar S50“ oder „Newton 200/1000 und Canon 6D“, und der Assistent füllt alles für Sie aus.",
  tr_4: "Im Bildfeld sehen Sie auf einem echten Himmelsfoto, was Ihre Kamera oder Ihr Okular erfasst. Ziehen Sie nach dem Rundgang den Himmel, um sich zu bewegen; mit «Ergebnis» sehen Sie, wie das Foto wird.",
  tr_5: "Heute Nacht: oben Ort, Nacht und Ausrüstung. Tippen Sie auf „Ändern“, um sie zu ändern.",
  tr_6: "Dann wählen Sie, was Sie sehen möchten: die besten Objekte der Nacht, die Planeten, Meteore, Kometen und die ISS, Ihren Plan und dunkle Orte in Ihrer Nähe.",
  tr_7: "Hier ist das Wetter: Der grüne, gelbe oder rote Punkt zeigt, wie die Nacht wird, daneben stehen die guten Stunden. Darunter finden Sie Stunde für Stunde tiefe, mittlere und hohe Wolken, Feuchte und Wind.",
  tr_8: "Das ist Hilfe: Eine Stimme erklärt Ihnen die Seite, auf der Sie sind. In jedem Werkzeug gibt es auch „So funktioniert's“, das Ihnen die wichtigsten Punkte zeigt. Gleich daneben finden Sie Große Schrift, um die Texte zu vergrößern. Klaren Himmel!",
});
Object.assign(TESTI.es, {
  tr_avanti: "Siguiente", tr_indietro: "Atrás", tr_fine: "Terminar", tr_salta: "Saltar la visita", tr_conta: "{n} de {m}", tr_rifai: "Visita guiada",
  tr_1: "¡Bienvenido a las herramientas de Giordano Astronomia! Arriba están todas las secciones: toca un nombre para abrirla. Te acompaño en una visita guiada de un minuto.",
  tr_2: "¿No sabes qué telescopio elegir? Aquí está el test: con cinco preguntas sencillas te recomendamos tres telescopios de la tienda y te explicamos por qué.",
  tr_3: "Aquí pones tu equipo una sola vez: basta con escribir lo que tienes, por ejemplo «Seestar S50» o «Newton 200/1000 y Canon 6D», y el asistente lo rellena todo por ti.",
  tr_4: "En el Campo de visión ves lo que entra en tu cámara o en tu ocular, sobre una foto real del cielo. Al terminar la visita, arrastra el cielo para moverte; con «Resultado» ves cómo saldrá la foto.",
  tr_5: "Esta noche: arriba el lugar, la noche y tu equipo. Toca «Cambiar» para modificarlos.",
  tr_6: "Luego eliges qué ver: los mejores objetos de la noche, los planetas, meteoros, cometas y la ISS, tu plan y los lugares oscuros cerca de ti.",
  tr_7: "Aquí tienes el Tiempo: el punto verde, amarillo o rojo te dice cómo será la noche, y al lado ves las horas buenas. Más abajo, hora a hora, están las nubes bajas, medias y altas, la humedad y el viento.",
  tr_8: "Esto es Guía: una voz te explica la página en la que estás. En cada herramienta tienes también Cómo funciona, que te enseña los puntos importantes. Aquí al lado tienes Texto grande, para agrandar las letras. ¡Cielos despejados!",
});
Object.assign(TESTI.en, {
  tr_avanti: "Next", tr_indietro: "Back", tr_fine: "Done", tr_salta: "Skip the tour", tr_conta: "{n} of {m}", tr_rifai: "Guided tour",
  tr_1: "Welcome to the Giordano Astronomia tools! All the tabs are up here: tap a name to open it. Let me give you a one-minute tour.",
  tr_2: "Not sure which telescope to choose? Here's the quiz: after five easy questions we suggest three telescopes from our shop and explain why.",
  tr_3: "This is where you add your equipment, just once: you simply type what you have, like “Seestar S50” or “Newton 200/1000 and Canon 6D”, and the assistant fills everything in for you.",
  tr_4: "The Field of view shows what fits in your camera or eyepiece, on a real photo of the sky. After the tour, drag the sky to move around; «Result» shows how the photo will look.",
  tr_5: "Tonight: your location, the night and your equipment are up here. Tap “Change” to edit them.",
  tr_6: "Then choose what to look at: the night's best targets, the planets, meteors, comets and the ISS, your plan and dark sites near you.",
  tr_7: "This is the Weather tool: the green, yellow or red dot tells you what the night will be like, with the good hours beside it. Further down, hour by hour, are low, mid and high clouds, humidity and wind.",
  tr_8: "This is Guide: a voice explains the page you're on. Every tool also has How it works, which shows you the key parts. Right next to it is Large text, to make the writing bigger. Clear skies!",
});
Object.assign(ICONE_SVG, { tour: '<path d="M12 3.6a8.4 8.4 0 1 0 0 16.8 8.4 8.4 0 0 0 0-16.8z"/><path class="pieno" d="m15.4 8.6-2 4.8-4.8 2 2-4.8z"/>' });
const TOUR_PASSI = NAV4
  ? [["home", ".gas-nav", "tr4_1"], ["home", ".gas-qz-banner", "tr_2"], ["attrezzatura", ".gas-as", "tr_3"],
    ["campo", ".gas-cielo-box", "tr_4"], ["stanotte", ".gas-ns-rq", "trn_1"], ["stanotte", ".gas-nav-str", "tr4_6"],
    ["meteo", "#gas-pan-meteo .gas-me-sintesi", "tr_7", ".gas-card", ".gas-testata"], [null, ".gas-guida-btn:not(.gas-testo-btn)", "tr_8"]]
  : [["home", ".gas-schede", "tr_1"], ["home", ".gas-qz-banner", "tr_2"], ["attrezzatura", ".gas-as", "tr_3"],
    ["campo", ".gas-cielo-box", "tr_4"], ["stanotte", ".gas-ns-rq", "trn_1"], ["stanotte", ".gas-notte-sotto", "tr_6"],
    ["meteo", "#gas-pan-meteo .gas-me-sintesi", "tr_7", ".gas-card", ".gas-testata"], [null, ".gas-guida-btn:not(.gas-testo-btn)", "tr_8"]];
Object.assign(TESTI.it, {
  tr4_1: "Benvenuto negli strumenti di Giordano Astronomia! Qui in alto ci sono le sezioni: dopo questo giro di un minuto, toccane una e sotto vedrai i suoi strumenti.",
  tr4_6: "In questa riga trovi gli altri strumenti di Stanotte: Luna, Sole e pianeti, Eventi del cielo, Transiti ISS, Meteo e Carta del cielo. Finita la guida, toccane uno per aprirlo." });
Object.assign(TESTI.de, {
  tr4_1: "Willkommen bei den Werkzeugen von Giordano Astronomia! Oben sind die Bereiche: Tippen Sie nach dem einminütigen Rundgang auf einen, darunter erscheinen seine Werkzeuge.",
  tr4_6: "In dieser Leiste finden Sie die anderen Werkzeuge unter Heute Nacht: Mond, Sonne und Planeten, Himmelsereignisse, ISS-Transite, Wetter und Sternkarte. Tippen Sie nach dem Rundgang auf eines, um es zu öffnen." });
Object.assign(TESTI.es, {
  tr4_1: "¡Bienvenido a las herramientas de Giordano Astronomia! Aquí arriba están las secciones: después de esta visita de un minuto, toca una y debajo verás sus herramientas.",
  tr4_6: "En esta fila tienes las otras herramientas de la sección Esta noche: Luna, Sol y planetas, Eventos del cielo, Tránsitos ISS, Tiempo y Carta celeste. Al terminar la visita, toca una para abrirla." });
Object.assign(TESTI.en, {
  tr4_1: "Welcome to the Giordano Astronomia tools! The sections are up here: after this one-minute tour, tap one and you'll see its tools below.",
  tr4_6: "This row has the other Tonight tools: Moon, Sun & planets, Sky events, ISS transits, Weather and Sky chart. After the tour, tap one to open it." });
Object.assign(TESTI.it, {
  tr4_1_app: "Benvenuto negli strumenti di Giordano Astronomia! Qui in basso ci sono le sezioni: dopo questo giro di un minuto, toccane una e in alto vedrai i suoi strumenti.",
  tr_8_app: "Nel menu ☰ in alto trovi tutte le sezioni, Testo grande e Tema scuro. In ogni strumento il bottone Aiuto ti mostra i punti importanti o ti spiega tutto a voce. Cieli sereni!" });
Object.assign(TESTI.de, {
  tr4_1_app: "Willkommen bei den Werkzeugen von Giordano Astronomia! Unten sind die Bereiche: Tippen Sie nach dem einminütigen Rundgang auf einen, oben erscheinen seine Werkzeuge.",
  tr_8_app: "Im Menü ☰ oben finden Sie alle Bereiche, Große Schrift und Dunkles Design. In jedem Werkzeug zeigt Ihnen die Schaltfläche Hilfe die wichtigsten Punkte oder erklärt alles per Stimme. Klaren Himmel!" });
Object.assign(TESTI.es, {
  tr4_1_app: "¡Bienvenido a las herramientas de Giordano Astronomia! Aquí abajo están las secciones: después de esta visita de un minuto, toca una y arriba verás sus herramientas.",
  tr_8_app: "En el menú ☰ de arriba tienes todas las secciones, Texto grande y Tema oscuro. En cada herramienta, el botón Ayuda te enseña los puntos importantes o te lo explica todo con voz. ¡Cielos despejados!" });
Object.assign(TESTI.en, {
  tr4_1_app: "Welcome to the Giordano Astronomia tools! The sections are down here: after this one-minute tour, tap one and you'll see its tools at the top.",
  tr_8_app: "The ☰ menu at the top has every section, Large text and Dark theme. In every tool, the Help button shows you the key parts or explains everything by voice. Clear skies!" });
const TOUR_NOTTE = [["stanotte", ".gas-ns-rq", "trn_1"], ["stanotte", ".gas-numeri--notte", "trn_2", ".gas-notte-riepilogo"],
  ["stanotte", ".gas-notte-oggetti", "trn_3"], ["stanotte", ".gas-nav-str", "trn_4"], [null, ".gas-nav-voci", "trn_5"]];
Object.assign(TESTI.it, {
  trn_1: "Ecco il tuo cielo di stanotte! Nei riquadri Dove, Quando, Setup e Oggetti cambi il luogo, la notte, con cosa guardi o scatti, e quali oggetti vedere.",
  trn_2: "Qui vedi le ore di stanotte. Nella barra, la parte nera è il buio vero e la striscia gialla ti dice quando c'è la Luna: le ore migliori sono quelle nere senza Luna.",
  trn_3: "Ecco gli oggetti di stanotte: in cima ci sono i migliori per te. Finita la guida, toccane uno: vedrai la foto, quando è più alto in cielo, il filtro giusto e come inquadrarlo.",
  trn_4: "In questa riga trovi gli altri strumenti di Stanotte: Luna, Sole e pianeti, Eventi del cielo, Transiti ISS, Meteo e Carta del cielo. Finita la guida, toccane uno per aprirlo.",
  trn_5: "Qui in alto trovi le altre sezioni: Inizio, Attrezzatura, Scegli e Diario. Quando ti serve aiuto, tocca Guida e una voce ti spiega la pagina. Cieli sereni!",
  trn_5_app: "Qui in basso trovi le altre sezioni: Inizio, Attrezzatura, Scegli e Diario. Nel menu ☰ in alto ci sono Testo grande e Tema scuro; in ogni strumento il bottone Aiuto ti spiega la pagina. Cieli sereni!",
  trn_4_app: "In questa riga trovi gli altri strumenti di Stanotte: Luna, Sole e pianeti, Eventi del cielo, Transiti ISS, Meteo e Carta del cielo. Finita la guida, falla scorrere col dito per vederli tutti.",
  trn_5_alto: "Qui in alto trovi le altre sezioni: Inizio, Attrezzatura, Scegli e Diario. Nel menu ☰ ci sono Testo grande e Tema scuro; in ogni strumento il bottone Aiuto ti spiega la pagina. Cieli sereni!" });
Object.assign(TESTI.de, {
  trn_1: "Hier ist Ihr Himmel heute Nacht! In den Kacheln Wo, Wann, Setup und Objekte ändern Sie Ort, Nacht, womit Sie beobachten oder fotografieren, und welche Objekte Sie sehen.",
  trn_2: "Hier sehen Sie die Stunden dieser Nacht. Im Balken ist der schwarze Teil die echte Dunkelheit, der gelbe Streifen zeigt, wann der Mond am Himmel steht: Am besten sind die schwarzen Stunden ohne Mond.",
  trn_3: "Hier sind die Objekte dieser Nacht, die besten für Sie ganz oben. Tippen Sie nach dem Rundgang auf eines: Sie sehen das Foto, wann es am höchsten steht, den richtigen Filter und wie Sie es ins Bild bekommen.",
  trn_4: "In dieser Leiste finden Sie die anderen Werkzeuge unter Heute Nacht: Mond, Sonne und Planeten, Himmelsereignisse, ISS-Transite, Wetter und Sternkarte. Tippen Sie nach dem Rundgang auf eines, um es zu öffnen.",
  trn_5: "Hier oben finden Sie die anderen Bereiche: Start, Ausrüstung, Wählen und Tagebuch. Wenn Sie nicht weiterwissen, tippen Sie auf Hilfe, und eine Stimme erklärt Ihnen die Seite. Klaren Himmel!",
  trn_5_app: "Hier unten finden Sie die anderen Bereiche: Start, Ausrüstung, Wählen und Tagebuch. Im Menü ☰ oben gibt es Große Schrift und Dunkles Design; in jedem Werkzeug erklärt Ihnen die Schaltfläche Hilfe die Seite. Klaren Himmel!",
  trn_4_app: "In dieser Leiste finden Sie die anderen Werkzeuge unter Heute Nacht: Mond, Sonne und Planeten, Himmelsereignisse, ISS-Transite, Wetter und Sternkarte. Wischen Sie nach dem Rundgang zur Seite, um alle zu sehen.",
  trn_5_alto: "Hier oben finden Sie die anderen Bereiche: Start, Ausrüstung, Wählen und Tagebuch. Im Menü ☰ gibt es Große Schrift und Dunkles Design; in jedem Werkzeug erklärt Ihnen die Schaltfläche Hilfe die Seite. Klaren Himmel!" });
Object.assign(TESTI.es, {
  trn_1: "¡Este es tu cielo de esta noche! En los recuadros Dónde, Cuándo, Equipo y Objetos cambias el lugar, la noche, con qué miras o fotografías, y qué objetos ver.",
  trn_2: "Aquí ves las horas de esta noche. En la barra, la parte negra es la oscuridad real y la franja amarilla te dice cuándo hay Luna: las mejores horas son las negras sin Luna.",
  trn_3: "Aquí tienes los objetos de esta noche: arriba están los mejores para ti. Al terminar la visita, toca uno: verás la foto, cuándo está más alto, el filtro adecuado y cómo encuadrarlo.",
  trn_4: "En esta fila tienes las otras herramientas de la sección Esta noche: Luna, Sol y planetas, Eventos del cielo, Tránsitos ISS, Tiempo y Carta celeste. Al terminar la visita, toca una para abrirla.",
  trn_5: "Aquí arriba tienes las otras secciones: Inicio, Equipo, Elegir y Diario. Cuando necesites ayuda, toca Guía y una voz te explica la página. ¡Cielos despejados!",
  trn_5_app: "Aquí abajo tienes las otras secciones: Inicio, Equipo, Elegir y Diario. En el menú ☰ de arriba están Texto grande y Tema oscuro; en cada herramienta el botón Ayuda te explica la página. ¡Cielos despejados!",
  trn_4_app: "En esta fila tienes las otras herramientas de la sección Esta noche: Luna, Sol y planetas, Eventos del cielo, Tránsitos ISS, Tiempo y Carta celeste. Al terminar la visita, deslízala de lado para verlas todas.",
  trn_5_alto: "Aquí arriba tienes las otras secciones: Inicio, Equipo, Elegir y Diario. En el menú ☰ están Texto grande y Tema oscuro; en cada herramienta el botón Ayuda te explica la página. ¡Cielos despejados!" });
Object.assign(TESTI.en, {
  trn_1: "Here's your sky tonight! In the Where, When, Setup and Objects boxes you can change your location, the night, what you observe or shoot with, and which objects to see.",
  trn_2: "Here you can see tonight's hours. In the bar, the black part is true darkness and the yellow strip shows when the Moon is up: the best hours are the black ones with no Moon.",
  trn_3: "Here are tonight's objects, with the best ones for you at the top. After the tour, tap one: you'll see its photo, when it's highest, the right filter and how to frame it.",
  trn_4: "This row has the other Tonight tools: Moon, Sun & planets, Sky events, ISS transits, Weather and Sky chart. After the tour, tap one to open it.",
  trn_5: "Up here are the other sections: Home, Equipment, Choose and Log. Whenever you need help, tap Guide and a voice will explain the page. Clear skies!",
  trn_5_app: "Down here are the other sections: Home, Equipment, Choose and Log. The ☰ menu at the top has Large text and Dark theme; in every tool the Help button explains the page. Clear skies!",
  trn_4_app: "This row has the other Tonight tools: Moon, Sun & planets, Sky events, ISS transits, Weather and Sky chart. After the tour, swipe it sideways to see them all.",
  trn_5_alto: "Up here are the other sections: Home, Equipment, Choose and Log. The ☰ menu has Large text and Dark theme; in every tool the Help button explains the page. Clear skies!" });
const TOUR_INIZIO = [[null, ".gas-nav-voci", "tri_1"], [null, ".gas-guida-btn:not(.gas-testo-btn)", "tri_2"], ["home", ".gas-bv-q", "tri_3"]];
Object.assign(TESTI.it, {
  tri_1: "Benvenuto! Ti mostro come funziona in tre passi. Qui in alto ci sono le sezioni: Inizio, Stanotte, Attrezzatura, Scegli e Diario. Finita la guida, toccane una per aprirla.",
  tri_1_app: "Benvenuto! Ti mostro come funziona in tre passi. Qui in basso ci sono le sezioni: Inizio, Stanotte, Attrezzatura, Scegli e Diario. Finita la guida, toccane una per aprirla.",
  tri_2: "Se non sai cosa fare, tocca Guida: una voce ti spiega la pagina in cui sei. Qui accanto c'è anche Testo grande, per ingrandire le scritte.",
  tri_2_app: "Nel menu ☰ trovi tutti gli strumenti, il Testo grande e la Visione notturna (schermo rosso, per non abbagliarti). In ogni strumento, il bottone Aiuto ti spiega come funziona.",
  tri_3: "Si parte da qui, con tre domande veloci su dove osservi, cosa usi e cosa ti piace guardare. Poi ti mostriamo il tuo cielo di stanotte e gli oggetti migliori per te.",
  tri_via: "Cominciamo →" });
Object.assign(TESTI.de, {
  tri_1: "Willkommen! Ich zeige Ihnen in drei Schritten, wie es funktioniert. Oben sind die Bereiche: Start, Heute Nacht, Ausrüstung, Wählen und Tagebuch. Tippen Sie nach dem Rundgang auf einen, um ihn zu öffnen.",
  tri_1_app: "Willkommen! Ich zeige Ihnen in drei Schritten, wie es funktioniert. Unten sind die Bereiche: Start, Heute Nacht, Ausrüstung, Wählen und Tagebuch. Tippen Sie nach dem Rundgang auf einen, um ihn zu öffnen.",
  tri_2: "Wenn Sie nicht weiterwissen, tippen Sie auf Hilfe: Eine Stimme erklärt Ihnen die Seite, auf der Sie sind. Gleich daneben finden Sie Große Schrift, um die Texte zu vergrößern.",
  tri_2_app: "Im Menü ☰ finden Sie alle Werkzeuge, Große Schrift und Nachtsicht (roter Bildschirm, damit er Sie nicht blendet). In jedem Werkzeug erklärt die Schaltfläche Hilfe, wie es funktioniert.",
  tri_3: "Hier beginnen wir mit drei kurzen Fragen: wo Sie beobachten, womit und was Sie am liebsten sehen. Danach zeigen wir Ihnen Ihren Himmel heute Nacht und die besten Objekte für Sie.",
  tri_via: "Los geht's →" });
Object.assign(TESTI.es, {
  tri_1: "¡Bienvenido! Te enseño cómo funciona en tres pasos. Aquí arriba están las secciones: Inicio, Esta noche, Equipo, Elegir y Diario. Al terminar la visita, toca una para abrirla.",
  tri_1_app: "¡Bienvenido! Te enseño cómo funciona en tres pasos. Aquí abajo están las secciones: Inicio, Esta noche, Equipo, Elegir y Diario. Al terminar la visita, toca una para abrirla.",
  tri_2: "Si no sabes qué hacer, toca Guía: una voz te explica la página en la que estás. Aquí al lado tienes también Texto grande, para agrandar las letras.",
  tri_2_app: "En el menú ☰ tienes todas las herramientas, Texto grande y Visión nocturna (pantalla roja, para no deslumbrarte). En cada herramienta, el botón Ayuda te explica cómo funciona.",
  tri_3: "Todo empieza aquí, con tres preguntas rápidas: desde dónde observas, con qué y qué te gusta mirar. Luego te mostramos tu cielo de esta noche y los mejores objetos para ti.",
  tri_via: "Empezamos →" });
Object.assign(TESTI.en, {
  tri_1: "Welcome! Let me show you how it works in three steps. The sections are up here: Home, Tonight, Equipment, Choose and Log. After the tour, tap one to open it.",
  tri_1_app: "Welcome! Let me show you how it works in three steps. The sections are down here: Home, Tonight, Equipment, Choose and Log. After the tour, tap one to open it.",
  tri_2: "If you're not sure what to do, tap Guide: a voice explains the page you're on. Right next to it is Large text, to make the writing bigger.",
  tri_2_app: "The ☰ menu has every tool, Large text and Night vision (a red screen, so it won't dazzle you). In every tool, the Help button explains how it works.",
  tri_3: "It all starts here, with three quick questions: where you observe from, what you use and what you like to look at. Then we'll show you your sky tonight and the best objects for you.",
  tri_via: "Let's start →" });
let TOUR = null;
function tourTrova(sel) {
  return [...document.querySelectorAll(sel)].find(x => x.getClientRects().length && x.offsetWidth > 0) || null;
}
function avviaTour(passi, dopo, fine, da) {
  if (TOUR || !RADICE) return;
  Voce.smetti();
  const luce = el("div", { class: "gas-tour-luce", "aria-hidden": "true" });
  const blocco = el("div", { class: "gas-tour-blocco" });
  const conta = el("small", { class: "gas-tour-conta" }), testo = el("p", { class: "gas-tour-testo", id: "gas-tour-testo" });
  const indietro = el("button", { type: "button", class: "gas-btn gas-btn--chiaro gas-btn--mini", onclick: () => vaiPasso(TOUR.i - 1, -1) }, t("tr_indietro"));
  const avanti = el("button", { type: "button", class: "gas-btn gas-btn--mini", onclick: () => vaiPasso(TOUR.i + 1, 1) });
  const salta = el("button", { type: "button", class: "gas-tour-salta", onclick: () => chiudiTour() }, t("tr_salta"));
  const freccia = el("span", { class: "gas-tour-freccia", "aria-hidden": "true" });
  const bolla = el("div", { class: "gas-tour-bolla", role: "dialog", "aria-modal": "true", "aria-label": t("tr_rifai"), "aria-describedby": "gas-tour-testo" },
    freccia, conta, testo, el("div", { class: "gas-tour-bottoni" }, salta, el("span", { class: "gas-tour-spazio" }), indietro, avanti));
  const sf = document.getElementById("gas-sfondo");
  const radice = el("div", { class: "gas gas-tour" + (sf && sf.classList.contains("gas-chiaro") ? " gas-chiaro" : "") + (testoGrande ? " gas-grande" : "") +
    (sf && sf.classList.contains("gas-rosso") ? " gas-tour--rosso" : "") }, blocco, luce, bolla);
  document.body.appendChild(radice);
  let rif = null;
  const posiziona = () => {
    const tg = TOUR && TOUR.bersaglio;
    if (!tg || !tg.isConnected) return;
    const vv = window.visualViewport, r = tg.getBoundingClientRect(), m = 8, vw = innerWidth, vh = vv ? Math.min(vv.height, innerHeight) : innerHeight;
    const giu = matchMedia("(pointer: coarse)").matches ? 90 : 8;
    const top = Math.max(r.top - m, 6), bot = Math.min(r.bottom + m, vh - 6), sx = Math.max(r.left - m, 6), dx = Math.min(r.right + m, vw - 6);
    Object.assign(luce.style, { left: sx + "px", top: top + "px", width: Math.max(0, dx - sx) + "px", height: Math.max(0, bot - top) + "px" });
    const bw = bolla.offsetWidth, bh = bolla.offsetHeight, spazio = 16;
    let y, sotto = true;
    let dentro = false;
    if (bot + spazio + bh <= vh - giu) y = bot + spazio;
    else if (top - spazio - bh >= 8) { y = top - spazio - bh; sotto = false; }
    else { y = clamp(top + 16, 8, vh - bh - giu); sotto = false; dentro = true; }
    const cx = (sx + dx) / 2, x = clamp(cx - bw / 2, 12, vw - bw - 12);
    bolla.style.left = x + "px"; bolla.style.top = y + "px";
    freccia.style.left = clamp(cx - x, 22, bw - 22) + "px";
    bolla.classList.toggle("sopra", !sotto);
    freccia.hidden = dentro;
  };
  const ridisegna = () => { if (rif) return; rif = requestAnimationFrame(() => { rif = null; posiziona(); }); };
  const tasti = e => {
    if (e.key === "Escape") { e.preventDefault(); chiudiTour(); }
    else if (e.key === "ArrowRight") { e.preventDefault(); vaiPasso(TOUR.i + 1, 1); }
    else if (e.key === "ArrowLeft") { e.preventDefault(); vaiPasso(TOUR.i - 1, -1); }
  };
  addEventListener("resize", ridisegna); addEventListener("scroll", ridisegna, true); document.addEventListener("keydown", tasti);
  if (window.visualViewport) visualViewport.addEventListener("resize", ridisegna);
  addEventListener("scrollend", ridisegna);
  TOUR = { i: -1, bersaglio: null, radice, luce, bolla, testo, conta, avanti, indietro, posiziona, giro: 0, passi: passi || TOUR_PASSI, dopo, fine, fuoco: document.activeElement,
    id: passi === TOUR_INIZIO ? "inizio" : passi === TOUR_NOTTE ? "notte" : passi && passi.id || "home",
    via: () => { removeEventListener("resize", ridisegna); removeEventListener("scroll", ridisegna, true); document.removeEventListener("keydown", tasti);
      if (window.visualViewport) visualViewport.removeEventListener("resize", ridisegna); removeEventListener("scrollend", ridisegna); } };
  vaiPasso(da || 0, 1);
}
async function vaiPasso(i, verso) {
  if (!TOUR) return;
  if (i >= TOUR.passi.length) { chiudiTour(true); return; }
  if (i < 0) return;
  let [scheda, sel, chiave, attorno, riserva] = TOUR.passi[i];
  if (scheda === "attrezzatura" && typeof puoSalvare === "function" && !puoSalvare()) { vaiPasso(i + (verso || 1), verso || 1); return; }
  const giro = ++TOUR.giro;
  const cl = document.documentElement.classList;
  if (cl.contains("gas-app")) {
    const basso = cl.contains("gas-barra-basso");
    if (chiave === "tr4_1" && basso) chiave = "tr4_1_app";
    if (chiave === "tr_8") { sel = ".gas-ab-menu"; chiave = "tr_8_app"; }
    if (chiave === "trn_5") chiave = basso ? "trn_5_app" : "trn_5_alto";
    if (chiave === "trn_4" || chiave === "tr4_6") chiave = "trn_4_app";
    if (chiave === "tri_1" && basso) chiave = "tri_1_app";
    if (chiave === "tri_2") { sel = ".gas-ab-menu"; chiave = "tri_2_app"; }
  }
  const trova = () => { const x = tourTrova(sel); return x && attorno ? x.closest(attorno) || x : x; };
  if (scheda === "attrezzatura") apriSezioneAtt("as");
  if (scheda && schedaAttiva !== scheda) vai(scheda, false, true);
  let tg = trova();
  for (let k = 0; !tg && k < (riserva ? 5 : 25); k++) { await new Promise(r => setTimeout(r, 100)); if (!TOUR || giro !== TOUR.giro) return; tg = trova(); }
  const daRiserva = !tg && riserva ? tourTrova(riserva) : null;
  if (!tg && !daRiserva) { vaiPasso(i + (verso || 1), verso || 1); return; }
  TOUR.i = i;
  salva("tour_in_corso", { id: TOUR.id, i, t: Date.now() });
  TOUR.conta.textContent = t("tr_conta", { n: i + 1, m: TOUR.passi.length });
  TOUR.testo.textContent = t(chiave);
  TOUR.indietro.hidden = i === 0;
  TOUR.avanti.textContent = i === TOUR.passi.length - 1 ? t(TOUR.fine || "tr_fine") : t("tr_avanti") + " →";
  const mostraPezzo = x => {
    TOUR.bersaglio = x;
    const vv = window.visualViewport, vh = vv ? Math.min(vv.height, innerHeight) : innerHeight, r = x.getBoundingClientRect();
    const grande = r.height > vh * 0.5;
    const nav = NAV4 && RADICE ? parseFloat(getComputedStyle(RADICE).getPropertyValue("--gas-nav-h")) || 0 : 0;
    const dove = Math.max(0, window.scrollY + r.top - (grande ? Math.max(90, nav + 24) : (vh - r.height) / 2));
    let fermo = false;
    const inVista = r.top >= 0 && r.bottom <= vh;
    for (let n = x; n && n.nodeType === 1 && !fermo; n = n.parentElement) {
      const pos = getComputedStyle(n).position;
      fermo = pos === "fixed" || (inVista && /sticky/.test(pos));
    }
    if (!fermo && Math.abs(dove - window.scrollY) > 4) window.scrollTo({ top: dove, behavior: "smooth" });
    TOUR.posiziona();
    for (const ms of [120, 450, 900, 1600]) setTimeout(() => { if (TOUR && giro === TOUR.giro) TOUR.posiziona(); }, ms);
  };
  mostraPezzo(tg || daRiserva);
  if (!tg) {
    const t0 = Date.now(), prova = () => {
      if (!TOUR || giro !== TOUR.giro) return;
      const v = trova();
      if (v) mostraPezzo(v); else if (Date.now() - t0 < 15000) setTimeout(prova, 300);
    };
    setTimeout(prova, 300);
  }
  try { TOUR.avanti.focus({ preventScroll: true }); } catch (e) { TOUR.avanti.focus(); }
}
function chiudiTour(finito) {
  if (!TOUR) return;
  const dopo = TOUR.dopo, f = TOUR.fuoco;
  TOUR.via(); TOUR.radice.remove(); TOUR = null;
  if (f && f.isConnected && f.matches && f.matches("button, a[href], summary")) try { f.focus({ preventScroll: true }); } catch (e) {   }
  salva("tour_visto", true); salva("tour_in_corso", null);
  if (dopo) dopo();
  else {
    if (finito) vai("home");
    let g = f;
    if (g && !g.isConnected && g.classList && g.classList.contains("gas-tour-rifai")) g = document.querySelector(".gas-tour-rifai");
    if (g && g !== f && g.isConnected) try { g.focus({ preventScroll: true }); } catch (e) {   }
  }
}
const dopoGiroInizio = () => {
  const c = document.querySelector(".gas-bv"), q = c && c.querySelector(".gas-bv-q");
  if (q) try { q.focus({ preventScroll: true }); } catch (e) {   }
  if (c) c.scrollIntoView({ block: "start", behavior: "smooth" });
};
function tourAlPrimoAccesso(attesa) {
  if (typeof SYNC !== "undefined" && SYNC.stato === "?" && (attesa || 0) < 10000) {
    setTimeout(() => { try { tourAlPrimoAccesso((attesa || 0) + 250); } catch (e) { console.error("strumenti, giro guidato:", e); } }, 250);
    return;
  }
  const sospeso = ricorda("tour_in_corso", null), giri = { inizio: [TOUR_INIZIO, dopoGiroInizio, "tri_via"], notte: [TOUR_NOTTE, () => {}], home: [TOUR_PASSI] };
  if (sospeso && giri[sospeso.id] && Date.now() - (sospeso.t || 0) < 6 * 3600e3 && !(typeof SR_IN_CAMPO !== "undefined" && SR_IN_CAMPO) && !PAGINA_OGG &&
    !location.hash.includes("?")) {
    const [passi, dopo, fine] = giri[sospeso.id], da = clamp(Number(sospeso.i) || 0, 0, passi.length - 1);
    let dove = "home";
    for (let k = da; k >= 0; k--) if (passi[k][0]) { dove = passi[k][0]; break; }
    if (schedaAttiva === "home" || schedaAttiva === dove) { avviaTour(passi, dopo, fine, da); return; }
  }
  if (sospeso) salva("tour_in_corso", null);
  if (ricorda("tour_visto", false) || (typeof SR_IN_CAMPO !== "undefined" && SR_IN_CAMPO) || schedaAttiva !== "home" || PAGINA_OGG) return;
  if (document.querySelector(".gas-bv")) {
    avviaTour(TOUR_INIZIO, dopoGiroInizio, "tri_via");
    return;
  }
  avviaTour();
}
function bottoneTour() {
  return el("button", { type: "button", class: "gas-btn gas-btn--chiaro gas-btn--mini gas-tour-rifai", onclick: () => avviaTour() }, icona("tour"), " ", t("tr_rifai"));
}
function segnaDaStrumenti(...voci) {
  const lista = [...voci, ...ricorda("acquisti_strumenti", []).filter(x => !voci.includes(x))].slice(0, 15);
  salva("acquisti_strumenti", lista);
  try {
    fetch(`${RADICE_URL.replace(/\/?$/, "/")}cart/update.js`, { method: "POST", keepalive: true, credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ attributes: { _strumenti: lista.join(", ") } }) })
      .catch(() => {});
  } catch (e) {   }
}
document.addEventListener("click", e => {
  const a = e.target && e.target.closest ? e.target.closest("a[href*='/products/']") : null;
  if (!a || !a.closest(".gas-sfondo, .gas-og, .gas-foglio, .gas-galleggia")) return;
  let u;
  try { u = new URL(a.href, location.href); } catch (x) { return; }
  const h = u.host === location.host && /\/products\/([^/?#.]+)/.exec(u.pathname);
  if (h) segnaDaStrumenti(`${schedaAttiva || "strumenti"}:${h[1]}`);
}, true);
const SCORRIMENTI = ".gas-schede, .gas-cx-gruppi, .gas-cx-recenti, .gas-cielo-barra, .gas-tab-scorre, .gas-me-scorre, .gas-tc-scorri, .gas-og-vicini, .gas-nav-str";
const _scorrimentiVisti = new WeakSet();
function aggiornaScorrimento(n) {
  const resto = n.scrollWidth - n.clientWidth;
  n.classList.toggle("gas-scorre-sx", resto > 2 && n.scrollLeft > 2);
  n.classList.toggle("gas-scorre-dx", resto > 2 && n.scrollLeft < resto - 2);
}
function segnaScorrimenti() {
  for (const n of document.querySelectorAll(SCORRIMENTI)) {
    if (!_scorrimentiVisti.has(n)) {
      _scorrimentiVisti.add(n);
      n.addEventListener("scroll", () => aggiornaScorrimento(n), { passive: true });
    }
    aggiornaScorrimento(n);
  }
}
let _scorrimentiAttesa = null;
function osservaScorrimenti() {
  const giro = () => { clearTimeout(_scorrimentiAttesa); _scorrimentiAttesa = setTimeout(segnaScorrimenti, 150); };
  if (window.MutationObserver) new MutationObserver(giro).observe(document.body, { childList: true, subtree: true });
  addEventListener("resize", giro);
  giro();
}
const TOUR_PAGINA = {
  scegli: [["scegli", ".gas-qx-tipi", "tp_scegli_1"], ["scegli", ".gas-qz", "tp_scegli_2"], ["scegli", ".gas-tc", "tp_scegli_3"],
    ["scegli", ".gas-qz-come", "tp_scegli_4"]],
  attrezzatura: [["attrezzatura", ".gas-ns", "tp_att_1"], ["attrezzatura", ".gas-as", "tp_att_2"], ["attrezzatura", ".gas-att", "tp_att_3"]],
  campo: [["campo", ".gas-cielo-rq", "tp_campo_1"], ["campo", ".gas-cielo", "tp_campo_2"], ["campo", ".gas-cielo-comandi", "tp_campo_3"],
    ["campo", ".gas-risultati .gas-numeri", "tp_campo_4"], ["campo", ".gas-consigli", "tp_campo_5"]],
  stanotte: TOUR_NOTTE.slice(0, 4),
  diario: [["diario", ".gas-dr-lista", "tp_diario_1", ".gas-card"], ["diario", ".gas-dr-messier", "tp_diario_2", ".gas-card"]],
  meteo: [["meteo", ".gas-me-sintesi", "tp_meteo_1", ".gas-card"], ["meteo", ".gas-me-scorre", "tp_meteo_2", ".gas-card"],
    ["meteo", ".gas-me-notti", "tp_meteo_3", ".gas-card"], ["meteo", ".gas-me-mappa", "tp_meteo_4", ".gas-card"], ["meteo", ".gas-cb", "tp_meteo_5"]],
  planetario: [["planetario", ".gas-pl-box", "tp_pl_1"], ["planetario", ".gas-pl-tempo", "tp_pl_2"],
    ["planetario", ".gas-pl-comandi + .gas-pl-comandi", "tp_pl_3"], ["planetario", ".gas-pl-elenco", "tp_pl_4"]],
  lunasole: [["lunasole", ".gas-ls-due > .gas-card", "tp_ls_1"], ["lunasole", ".gas-ls-due > .gas-card + .gas-card", "tp_ls_2"],
    ["lunasole", ".gas-ls-pianeti", "tp_ls_3"], ["lunasole", ".gas-cal", "tp_ls_4", ".gas-card"]],
  eventi: [["eventi", ".gas-mt", "tp_ev_1"], ["eventi", ".gas-co", "tp_ev_2"], ["eventi", ".gas-sa", "tp_ev_3"], ["eventi", ".gas-ev", "tp_ev_4", ".gas-card"]],
  transiti: [["transiti", ".gas-tr-comandi", "tp_tr_1"], ["transiti", ".gas-tr-lista", "tp_tr_2"], ["transiti", ".gas-tr-dett", "tp_tr_3"]],
  piano: [["piano", ".gas-pn-cont", "tp_piano_1"]],
  camere: [["camere", ".gas-filtri-cerca", "tp_cam_1"], ["camere", ".gas-filtri-apri", "tp_cam_2"], ["camere", ".gas-tab-camere", "tp_cam_3"]],
  calcolatori: [["calcolatori", ".gas-cx-comandi", "tp_cx_1"], ["calcolatori", ".gas-cx-gruppo", "tp_cx_2"]],
  software: [["software", ".gas-filtri", "tp_sw_1"], ["software", ".gas-sw-gruppo", "tp_sw_2"]],
};
for (const p of Object.values(TOUR_PAGINA)) p.id = "pagina";
Object.assign(TESTI.it, {
  cf_bottone: "Come funziona", cf_corto: "Aiuto", cf_mostrami: "Mostrami", cf_mostrami_n: "I punti importanti, con i fumetti · 30 secondi",
  cf_ascolta: "Ascolta", cf_ascolta_n: "Una voce ti spiega la pagina, col testo scritto",
  pv_testo: "Prima volta qui? Ti mostro come funziona · 30 secondi", pv_chiudi: "Non ora",
  tp_scegli_1: "Prima scegli cosa vuoi scegliere: un telescopio, una camera o una montatura.",
  tp_scegli_2: "Rispondi a poche domande facili: alla fine ti consigliamo tre prodotti del negozio e ti spieghiamo perché.",
  tp_scegli_3: "Qui metti fianco a fianco fino a tre telescopi: cosa fanno vedere, quanto pesano e quanto costano.",
  tp_scegli_4: "Qui trovi come scegliamo i consigli: fra i prodotti disponibili nel negozio, in base ai loro dati e alle tue risposte.",
  tp_att_1: "Il modo più semplice: «Crea un setup» ti fa scegliere telescopio e camera in quattro passi.",
  tp_att_2: "Oppure scrivi o di' a voce quello che hai, per esempio «Newton 200/1000 e Canon 6D»: l'assistente compila tutto.",
  tp_att_3: "Qui c'è tutta la tua attrezzatura: telescopi, camere, oculari, riduttori e filtri. La inserisci una volta e la ritrovi in tutti gli strumenti.",
  tp_campo_1: "In questi riquadri scegli il setup, il telescopio, la camera e l'oggetto da riprendere.",
  tp_campo_2: "Questa è una foto vera del cielo con il riquadro del sensore. Trascina per spostarti, allarga due dita per ingrandire, gira la camera con la maniglia ↻.",
  tp_campo_3: "Qui scegli foto o mappa, accendi i nomi e la griglia, e con «Risultato» vedi come uscirà la foto con la camera girata.",
  tp_campo_4: "Ecco i numeri del tuo setup: quanto cielo entra, la scala dell'immagine e il rapporto focale. Tocca ⓘ se una parola non ti è chiara.",
  tp_campo_5: "Qui sotto ti diciamo cosa ti serve per fotografare questo oggetto: tempo di posa, filtri e accessori.",
  tp_diario_1: "Qui finiscono gli oggetti che segni come «Visto» o «Fotografato» negli altri strumenti, con la data.",
  tp_diario_2: "La sfida di Messier: 110 oggetti da vedere e fotografare. Tocca un numero per segnarlo o per sapere cos'è.",
  tp_meteo_1: "La previsione della notte per chi osserva: il pallino verde, giallo o rosso e le ore buone.",
  tp_meteo_2: "Ora per ora: il cielo, le nuvole basse, medie e alte, l'umidità, il vento. Fai scorrere la tabella di lato.",
  tp_meteo_3: "Le prossime notti in breve, per scegliere la serata migliore della settimana.",
  tp_meteo_4: "Satellite e radar delle ultime ore e la previsione delle nuvole: tocca ▶ per vederle muoversi.",
  tp_meteo_5: "Qui trovi i posti più bui vicino a te, con le nuvole previste stanotte in ognuno.",
  tp_pl_1: "Tutto il cielo sopra di te: il centro è sopra la tua testa, il bordo è l'orizzonte. Tocca una stella o un pianeta per il suo nome.",
  tp_pl_2: "Fai scorrere le ore della notte e guarda il cielo girare; «Adesso» torna all'ora attuale.",
  tp_pl_3: "Accendi e spegni costellazioni, nomi e oggetti di Messier, e gira la carta verso la direzione in cui guardi.",
  tp_pl_4: "I pianeti e la Luna sopra l'orizzonte adesso, con la loro altezza.",
  tp_ls_1: "La Luna di stanotte: la fase vera, quando sorge e tramonta, quanto è lontana.",
  tp_ls_2: "Il Sole di oggi visto dal satellite della NASA, con macchie e protuberanze.",
  tp_ls_3: "I pianeti di stanotte: quando si vedono, quanto sono alti e quanto sono luminosi.",
  tp_ls_4: "Il calendario della Luna: per ogni notte la fase e le ore di buio senza Luna, le migliori per fotografare.",
  tp_ev_1: "Le meteore di stanotte: quante all'ora puoi vederne dal tuo posto, ora per ora.",
  tp_ev_2: "Le comete che si vedono stanotte, se ce ne sono di abbastanza luminose.",
  tp_ev_3: "Quando passano sopra di te la Stazione spaziale (ISS) e la stazione cinese Tiangong: si vedono a occhio nudo, come un punto luminoso che attraversa il cielo.",
  tp_ev_4: "Eclissi, avvicinamenti fra pianeti e piogge di meteore dei prossimi mesi, per il tuo luogo. Tocca un evento per passare a quella notte; col bottone del calendario lo salvi sul telefono.",
  tp_tr_1: "Scegli fino a quanti chilometri sei disposto a spostarti e per quanti giorni cercare.",
  tp_tr_2: "Ecco i transiti trovati: la ISS che passa davanti al Sole o alla Luna, con l'ora al secondo.",
  tp_tr_3: "Per ogni transito: la mappa con la striscia da cui si vede e quanto dura. Ricordati il filtro solare per il Sole!",
  tp_piano_1: "Il piano della notte: aggiungi gli oggetti da «Cosa vedere» e qui vedi l'ordine giusto per guardarli, ora per ora.",
  tp_cam_1: "Cerca una camera per nome: per esempio «ASI2600» o «EOS R6».",
  tp_cam_2: "Con i filtri scegli marca, tipo di sensore e dimensione dei pixel.",
  tp_cam_3: "Ecco le camere con i dati ufficiali. Spunta fino a quattro camere per confrontarle fianco a fianco.",
  tp_cx_1: "Cerca un calcolatore per nome oppure scegli un gruppo: osservare, fotografare, montatura e guida, cielo e meteo.",
  tp_cx_2: "Tocca un calcolatore per aprirlo: i valori partono dalla tua attrezzatura e dai prodotti del negozio.",
  tp_sw_1: "Scegli la categoria, il sistema (Windows, Mac, telefono…) o solo i programmi gratuiti.",
  tp_sw_2: "Ogni riquadro è un programma, con a cosa serve e il link al sito ufficiale.",
});
Object.assign(TESTI.de, {
  cf_bottone: "So funktioniert's", cf_corto: "Hilfe", cf_mostrami: "Zeig es mir", cf_mostrami_n: "Das Wichtigste mit Sprechblasen · 30 Sekunden",
  cf_ascolta: "Anhören", cf_ascolta_n: "Eine Stimme erklärt die Seite, mit dem Text dazu",
  pv_testo: "Zum ersten Mal hier? Ich zeige Ihnen, wie es geht · 30 Sekunden", pv_chiudi: "Nicht jetzt",
  tp_scegli_1: "Wählen Sie zuerst, was Sie suchen: ein Teleskop, eine Kamera oder eine Montierung.",
  tp_scegli_2: "Beantworten Sie ein paar einfache Fragen: Am Ende empfehlen wir drei Produkte aus dem Shop und erklären, warum.",
  tp_scegli_3: "Hier stellen Sie bis zu drei Teleskope nebeneinander: was sie zeigen, was sie wiegen und was sie kosten.",
  tp_scegli_4: "Hier steht, wie wir empfehlen: aus den verfügbaren Produkten des Shops, anhand ihrer Daten und Ihrer Antworten.",
  tp_att_1: "Am einfachsten: «Setup erstellen» führt Sie in vier Schritten durch Teleskop und Kamera.",
  tp_att_2: "Oder schreiben bzw. sagen Sie, was Sie haben, etwa „Newton 200/1000 und Canon 6D“: Der Assistent füllt alles aus.",
  tp_att_3: "Hier ist Ihre ganze Ausrüstung: Teleskope, Kameras, Okulare, Reducer und Filter. Einmal eingetragen, finden Sie sie in allen Werkzeugen wieder.",
  tp_campo_1: "In diesen Kacheln wählen Sie Setup, Teleskop, Kamera und das Objekt.",
  tp_campo_2: "Das ist ein echtes Himmelsfoto mit dem Rahmen des Sensors. Ziehen zum Verschieben, zwei Finger zum Vergrößern, die Kamera drehen Sie mit dem Griff ↻.",
  tp_campo_3: "Hier wählen Sie Foto oder Karte, schalten Namen und Gitter ein, und mit «Ergebnis» sehen Sie, wie das Foto mit gedrehter Kamera wird.",
  tp_campo_4: "Das sind die Werte Ihres Setups: wie viel Himmel ins Bild passt, der Abbildungsmaßstab und das Öffnungsverhältnis. Tippen Sie auf ⓘ, wenn ein Wort unklar ist.",
  tp_campo_5: "Darunter steht, was Sie für dieses Objekt brauchen: Belichtungszeit, Filter und Zubehör.",
  tp_diario_1: "Hier landen die Objekte, die Sie in den anderen Werkzeugen als «Gesehen» oder «Fotografiert» markieren, mit Datum.",
  tp_diario_2: "Die Messier-Challenge: 110 Objekte zum Sehen und Fotografieren. Tippen Sie auf eine Nummer, um sie zu markieren oder mehr zu erfahren.",
  tp_meteo_1: "Die Vorhersage der Nacht für Beobachter: der grüne, gelbe oder rote Punkt und die guten Stunden.",
  tp_meteo_2: "Stunde für Stunde: Himmel, tiefe, mittlere und hohe Wolken, Feuchte und Wind. Wischen Sie die Tabelle zur Seite.",
  tp_meteo_3: "Die nächsten Nächte im Überblick, um den besten Abend der Woche zu wählen.",
  tp_meteo_4: "Satellit und Radar der letzten Stunden und die Wolkenvorhersage: Tippen Sie auf ▶, um sie in Bewegung zu sehen.",
  tp_meteo_5: "Hier finden Sie die dunkelsten Orte in Ihrer Nähe, jeweils mit den Wolken heute Nacht.",
  tp_pl_1: "Der ganze Himmel über Ihnen: die Mitte ist über Ihrem Kopf, der Rand ist der Horizont. Tippen Sie auf einen Stern oder Planeten für seinen Namen.",
  tp_pl_2: "Lassen Sie die Stunden der Nacht laufen und sehen Sie den Himmel wandern; «Jetzt» springt zur aktuellen Uhrzeit.",
  tp_pl_3: "Schalten Sie Sternbilder, Namen und Messier-Objekte ein und aus und drehen Sie die Karte in Ihre Blickrichtung.",
  tp_pl_4: "Planeten und Mond, die gerade über dem Horizont stehen, mit ihrer Höhe.",
  tp_ls_1: "Der Mond heute Nacht: die echte Phase, Auf- und Untergang und seine Entfernung.",
  tp_ls_2: "Die Sonne von heute, vom NASA-Satelliten gesehen, mit Flecken und Protuberanzen.",
  tp_ls_3: "Die Planeten heute Nacht: wann sie zu sehen sind, wie hoch und wie hell.",
  tp_ls_4: "Der Mondkalender: für jede Nacht die Phase und die dunklen Stunden ohne Mond, die besten zum Fotografieren.",
  tp_ev_1: "Die Meteore heute Nacht: wie viele pro Stunde Sie von Ihrem Ort sehen können, Stunde für Stunde.",
  tp_ev_2: "Die Kometen, die heute Nacht zu sehen sind, wenn welche hell genug sind.",
  tp_ev_3: "Wann die Raumstation ISS und die chinesische Station Tiangong über Sie fliegen: Mit bloßem Auge sieht man einen hellen Punkt, der über den Himmel zieht.",
  tp_ev_4: "Finsternisse, Planetenbegegnungen und Meteorströme der nächsten Monate für Ihren Ort. Tippen Sie auf ein Ereignis, um zu dieser Nacht zu wechseln; mit der Kalender-Schaltfläche speichern Sie es auf dem Handy.",
  tp_tr_1: "Wählen Sie, wie viele Kilometer Sie fahren würden und für wie viele Tage gesucht wird.",
  tp_tr_2: "Die gefundenen Transite: die ISS vor Sonne oder Mond, sekundengenau.",
  tp_tr_3: "Für jeden Transit: die Karte mit dem Streifen, von dem aus man ihn sieht, und seine Dauer. Für die Sonne an den Sonnenfilter denken!",
  tp_piano_1: "Der Plan der Nacht: Fügen Sie Objekte aus «Was sehen» hinzu, hier sehen Sie die richtige Reihenfolge, Stunde für Stunde.",
  tp_cam_1: "Suchen Sie eine Kamera nach Namen, etwa „ASI2600“ oder „EOS R6“.",
  tp_cam_2: "Mit den Filtern wählen Sie Marke, Sensortyp und Pixelgröße.",
  tp_cam_3: "Hier sind die Kameras mit den offiziellen Daten. Haken Sie bis zu vier an, um sie nebeneinander zu vergleichen.",
  tp_cx_1: "Suchen Sie einen Rechner nach Namen oder wählen Sie eine Gruppe: Beobachten, Fotografieren, Montierung und Guiding, Himmel und Wetter.",
  tp_cx_2: "Tippen Sie auf einen Rechner, um ihn zu öffnen: Die Werte kommen aus Ihrer Ausrüstung und aus den Produkten des Shops.",
  tp_sw_1: "Wählen Sie Kategorie, System (Windows, Mac, Handy…) oder nur kostenlose Programme.",
  tp_sw_2: "Jede Kachel ist ein Programm, mit seinem Zweck und dem Link zur offiziellen Seite.",
});
Object.assign(TESTI.es, {
  cf_bottone: "Cómo funciona", cf_corto: "Ayuda", cf_mostrami: "Muéstramelo", cf_mostrami_n: "Lo importante, con bocadillos · 30 segundos",
  cf_ascolta: "Escuchar", cf_ascolta_n: "Una voz te explica la página, con el texto escrito",
  pv_testo: "¿Primera vez aquí? Te enseño cómo funciona · 30 segundos", pv_chiudi: "Ahora no",
  tp_scegli_1: "Primero elige qué quieres elegir: un telescopio, una cámara o una montura.",
  tp_scegli_2: "Responde a unas preguntas sencillas: al final te recomendamos tres productos de la tienda y te explicamos por qué.",
  tp_scegli_3: "Aquí pones lado a lado hasta tres telescopios: qué muestran, cuánto pesan y cuánto cuestan.",
  tp_scegli_4: "Aquí explicamos cómo elegimos: entre los productos disponibles en la tienda, según sus datos y tus respuestas.",
  tp_att_1: "Lo más sencillo: «Crear una configuración» te hace elegir telescopio y cámara en cuatro pasos.",
  tp_att_2: "O escribe o di en voz alta lo que tienes, por ejemplo «Newton 200/1000 y Canon 6D»: el asistente lo rellena todo.",
  tp_att_3: "Aquí está todo tu equipo: telescopios, cámaras, oculares, reductores y filtros. Lo pones una vez y lo encuentras en todas las herramientas.",
  tp_campo_1: "En estos recuadros eliges el equipo, el telescopio, la cámara y el objeto.",
  tp_campo_2: "Esta es una foto real del cielo con el recuadro del sensor. Arrastra para moverte, abre dos dedos para ampliar y gira la cámara con el asa ↻.",
  tp_campo_3: "Aquí eliges foto o mapa, enciendes nombres y cuadrícula, y con «Resultado» ves cómo saldrá la foto con la cámara girada.",
  tp_campo_4: "Estos son los números de tu equipo: cuánto cielo entra, la escala de la imagen y la relación focal. Toca ⓘ si una palabra no está clara.",
  tp_campo_5: "Aquí debajo te decimos qué necesitas para fotografiar este objeto: tiempo de exposición, filtros y accesorios.",
  tp_diario_1: "Aquí llegan los objetos que marcas como «Visto» o «Fotografiado» en las otras herramientas, con la fecha.",
  tp_diario_2: "El reto Messier: 110 objetos para ver y fotografiar. Toca un número para marcarlo o saber qué es.",
  tp_meteo_1: "La previsión de la noche para quien observa: el punto verde, amarillo o rojo y las horas buenas.",
  tp_meteo_2: "Hora a hora: el cielo, las nubes bajas, medias y altas, la humedad y el viento. Desliza la tabla de lado.",
  tp_meteo_3: "Las próximas noches en resumen, para elegir la mejor de la semana.",
  tp_meteo_4: "Satélite y radar de las últimas horas y la previsión de nubes: toca ▶ para verlas moverse.",
  tp_meteo_5: "Aquí están los lugares más oscuros cerca de ti, con las nubes previstas esta noche en cada uno.",
  tp_pl_1: "Todo el cielo sobre ti: el centro está sobre tu cabeza y el borde es el horizonte. Toca una estrella o un planeta para ver su nombre.",
  tp_pl_2: "Desliza las horas de la noche y mira cómo gira el cielo; «Ahora» vuelve a la hora actual.",
  tp_pl_3: "Enciende y apaga constelaciones, nombres y objetos Messier, y gira la carta hacia donde miras.",
  tp_pl_4: "Los planetas y la Luna sobre el horizonte ahora, con su altura.",
  tp_ls_1: "La Luna de esta noche: la fase real, cuándo sale y se pone, a qué distancia está.",
  tp_ls_2: "El Sol de hoy visto desde el satélite de la NASA, con manchas y protuberancias.",
  tp_ls_3: "Los planetas de esta noche: cuándo se ven, a qué altura y con qué brillo.",
  tp_ls_4: "El calendario lunar: para cada noche la fase y las horas oscuras sin Luna, las mejores para fotografiar.",
  tp_ev_1: "Los meteoros de esta noche: cuántos por hora puedes ver desde tu lugar, hora a hora.",
  tp_ev_2: "Los cometas que se ven esta noche, si hay alguno lo bastante brillante.",
  tp_ev_3: "Cuándo pasan sobre ti la Estación Espacial (ISS) y la estación china Tiangong: se ven a simple vista, como un punto brillante que cruza el cielo.",
  tp_ev_4: "Eclipses, encuentros de planetas y lluvias de meteoros de los próximos meses, para tu lugar. Toca un evento para pasar a esa noche; con el botón del calendario lo guardas en el móvil.",
  tp_tr_1: "Elige hasta cuántos kilómetros te moverías y durante cuántos días buscar.",
  tp_tr_2: "Estos son los tránsitos encontrados: la ISS delante del Sol o de la Luna, con la hora al segundo.",
  tp_tr_3: "Para cada tránsito: el mapa con la franja desde la que se ve y cuánto dura. ¡Para el Sol, recuerda el filtro solar!",
  tp_piano_1: "El plan de la noche: añade objetos desde «Qué ver» y aquí ves el orden adecuado para mirarlos, hora a hora.",
  tp_cam_1: "Busca una cámara por su nombre, por ejemplo «ASI2600» o «EOS R6».",
  tp_cam_2: "Con los filtros eliges marca, tipo de sensor y tamaño de píxel.",
  tp_cam_3: "Estas son las cámaras con los datos oficiales. Marca hasta cuatro para compararlas lado a lado.",
  tp_cx_1: "Busca una calculadora por su nombre o elige un grupo: observar, fotografiar, montura y guiado, cielo y tiempo.",
  tp_cx_2: "Toca una calculadora para abrirla: los valores salen de tu equipo y de los productos de la tienda.",
  tp_sw_1: "Elige la categoría, el sistema (Windows, Mac, móvil…) o solo los programas gratuitos.",
  tp_sw_2: "Cada recuadro es un programa, con para qué sirve y el enlace a su web oficial.",
});
Object.assign(TESTI.en, {
  cf_bottone: "How it works", cf_corto: "Help", cf_mostrami: "Show me", cf_mostrami_n: "The key parts, with speech bubbles · 30 seconds",
  cf_ascolta: "Listen", cf_ascolta_n: "A voice explains the page, with the text on screen",
  pv_testo: "First time here? Let me show you how it works · 30 seconds", pv_chiudi: "Not now",
  tp_scegli_1: "First choose what you're looking for: a telescope, a camera or a mount.",
  tp_scegli_2: "Answer a few easy questions: at the end we suggest three products from our shop and explain why.",
  tp_scegli_3: "Here you can put up to three telescopes side by side: what they show, what they weigh and what they cost.",
  tp_scegli_4: "This explains how we choose: from the products available in the shop, based on their data and your answers.",
  tp_att_1: "The easiest way: «Create a setup» walks you through telescope and camera in four steps.",
  tp_att_2: "Or type or say what you have, for example “Newton 200/1000 and Canon 6D”: the assistant fills everything in.",
  tp_att_3: "This is all your equipment: telescopes, cameras, eyepieces, reducers and filters. Add it once and you'll find it in every tool.",
  tp_campo_1: "In these boxes you choose the setup, telescope, camera and the target.",
  tp_campo_2: "This is a real photo of the sky with the sensor frame. Drag to move, spread two fingers to zoom, rotate the camera with the ↻ handle.",
  tp_campo_3: "Here you choose photo or map, turn on names and grid, and «Result» shows how the photo will look with the camera rotated.",
  tp_campo_4: "These are your setup's numbers: how much sky fits, the image scale and the focal ratio. Tap ⓘ if a word isn't clear.",
  tp_campo_5: "Below, we tell you what you need to photograph this target: exposure time, filters and accessories.",
  tp_diario_1: "Objects you mark as «Observed» or «Imaged» in the other tools end up here, with the date.",
  tp_diario_2: "The Messier challenge: 110 objects to see and photograph. Tap a number to tick it or learn what it is.",
  tp_meteo_1: "Tonight's forecast for stargazers: the green, yellow or red dot and the good hours.",
  tp_meteo_2: "Hour by hour: the sky, low, mid and high clouds, humidity and wind. Swipe the table sideways.",
  tp_meteo_3: "The next nights at a glance, to pick the best evening of the week.",
  tp_meteo_4: "Satellite and radar for the last few hours and the cloud forecast: tap ▶ to watch them move.",
  tp_meteo_5: "Here you'll find the darkest places near you, each with tonight's forecast clouds.",
  tp_pl_1: "The whole sky above you: the centre is overhead, the edge is the horizon. Tap a star or planet to see its name.",
  tp_pl_2: "Slide through the hours of the night and watch the sky turn; «Now» jumps back to the current time.",
  tp_pl_3: "Turn constellations, names and Messier objects on and off, and rotate the chart to face where you're looking.",
  tp_pl_4: "The planets and Moon above the horizon right now, with their altitude.",
  tp_ls_1: "Tonight's Moon: the real phase, when it rises and sets, and how far away it is.",
  tp_ls_2: "Today's Sun seen from NASA's satellite, with sunspots and prominences.",
  tp_ls_3: "Tonight's planets: when you can see them, how high and how bright.",
  tp_ls_4: "The Moon calendar: for every night the phase and the dark hours without the Moon, the best for photography.",
  tp_ev_1: "Tonight's meteors: how many per hour you can see from your spot, hour by hour.",
  tp_ev_2: "The comets visible tonight, if any are bright enough.",
  tp_ev_3: "When the Space Station (ISS) and China's Tiangong station pass over you: you can see them with the naked eye, as a bright dot crossing the sky.",
  tp_ev_4: "Eclipses, planet conjunctions and meteor showers in the coming months, for your location. Tap an event to jump to that night; the calendar button saves it to your phone.",
  tp_tr_1: "Choose how many kilometres you'd travel and how many days to search.",
  tp_tr_2: "These are the transits found: the ISS in front of the Sun or Moon, timed to the second.",
  tp_tr_3: "For each transit: the map with the strip it's visible from and how long it lasts. For the Sun, remember the solar filter!",
  tp_piano_1: "The night plan: add objects from «What to see» and here you'll get the right order to look at them, hour by hour.",
  tp_cam_1: "Search for a camera by name, for example “ASI2600” or “EOS R6”.",
  tp_cam_2: "Use the filters to choose brand, sensor type and pixel size.",
  tp_cam_3: "Here are the cameras with their official specs. Tick up to four to compare them side by side.",
  tp_cx_1: "Search for a calculator by name or pick a group: observing, photography, mount and guiding, sky and weather.",
  tp_cx_2: "Tap a calculator to open it: the values start from your equipment and the shop's products.",
  tp_sw_1: "Choose the category, the system (Windows, Mac, phone…) or only free programs.",
  tp_sw_2: "Each box is a program, with what it's for and a link to its official site.",
});
function avviaGiroPagina(nome) {
  const passi = TOUR_PAGINA[nome];
  if (!passi || TOUR) return;
  aiutoVisto(nome);
  avviaTour(passi, () => {});
}
function aiutoVisto(nome) {
  const v = ricorda("aiuto_visto", {}) || {};
  v[nome] = 9; salva("aiuto_visto", v);
}
function rigaPrimaVolta(nome) {
  if (!TOUR_PAGINA[nome] || TOUR || !ricorda("tour_visto", false)) return null;
  const v = ricorda("aiuto_visto", {}) || {};
  if ((v[nome] || 0) >= 3) return null;
  v[nome] = (v[nome] || 0) + 1; salva("aiuto_visto", v);
  const riga = el("div", { class: "gas-pv", role: "note" },
    el("span", { class: "gas-pv-ico", "aria-hidden": "true" }, icona("tour")),
    el("span", { class: "gas-pv-testo" }, t("pv_testo")),
    el("button", { type: "button", class: "gas-btn gas-btn--mini gas-pv-via", onclick: () => { riga.remove(); avviaGiroPagina(nome); } }, t("cf_mostrami"), " →"),
    el("button", { type: "button", class: "gas-pv-chiudi", title: t("pv_chiudi"), "aria-label": t("pv_chiudi"), onclick: () => { aiutoVisto(nome); riga.remove(); } }, "✕"));
  return riga;
}
let POP = null;
function chiudiPop() {
  if (!POP) return;
  POP.via(); POP.radice.remove();
  if (POP.bottone) POP.bottone.setAttribute("aria-expanded", "false");
  POP = null;
}
function apriPop(bottone, ...contenuto) {
  const stesso = POP && POP.bottone === bottone;
  chiudiPop();
  if (stesso) return;
  const sf = document.getElementById("gas-sfondo");
  const bolla = el("div", { class: "gas-pop-bolla", role: "dialog" }, ...contenuto);
  const radice = el("div", { class: "gas gas-pop" + (sf && sf.classList.contains("gas-chiaro") ? " gas-chiaro" : "") + (testoGrande ? " gas-grande" : "") +
    (sf && sf.classList.contains("gas-rosso") ? " gas-tour--rosso" : "") }, bolla);
  document.body.appendChild(radice);
  const posiziona = () => {
    if (!bottone.isConnected) { chiudiPop(); return; }
    const r = bottone.getBoundingClientRect(), bw = bolla.offsetWidth, bh = bolla.offsetHeight, vh = innerHeight;
    const x = clamp(r.left + r.width / 2 - bw / 2, 10, innerWidth - bw - 10);
    const y = r.bottom + 10 + bh < vh - 10 ? r.bottom + 10 : Math.max(10, r.top - 10 - bh);
    bolla.style.left = x + "px"; bolla.style.top = y + "px";
  };
  const fuori = e => { if (!bolla.contains(e.target) && !bottone.contains(e.target)) chiudiPop(); };
  const tasti = e => { if (e.key === "Escape") { chiudiPop(); try { bottone.focus(); } catch (x) {   } } };
  setTimeout(() => document.addEventListener("pointerdown", fuori, true), 0);
  document.addEventListener("keydown", tasti);
  addEventListener("scroll", posiziona, true); addEventListener("resize", posiziona);
  POP = { radice, bottone, via: () => { document.removeEventListener("pointerdown", fuori, true); document.removeEventListener("keydown", tasti);
    removeEventListener("scroll", posiziona, true); removeEventListener("resize", posiziona); } };
  bottone.setAttribute("aria-expanded", "true");
  posiziona();
  const primo = bolla.querySelector("button");
  if (primo) try { primo.focus({ preventScroll: true }); } catch (e) {   }
}
function bottoneComeFunziona(nome) {
  const voce = chiaveGuida(nome), giro = TOUR_PAGINA[nome];
  const b = el("button", { type: "button", class: "gas-btn gas-btn--chiaro gas-btn--mini gas-testata-guida", "aria-haspopup": "dialog", "aria-expanded": "false",
    "aria-label": t("cf_bottone"), title: t("cf_bottone"),
    onclick: () => {
      const scelta = (ico, titolo, sotto, fn) => el("button", { type: "button", class: "gas-pop-voce", onclick: () => { chiudiPop(); fn(); } },
        el("span", { class: "gas-pop-ico", "aria-hidden": "true" }, icona(ico)), el("span", null, el("b", null, titolo), el("small", null, sotto)));
      apriPop(b, giro ? scelta("tour", t("cf_mostrami"), t("cf_mostrami_n"), () => avviaGiroPagina(nome)) : null,
        scelta("guida", t("cf_ascolta"), t("cf_ascolta_n"), () => Voce.parla(voce, b)));
    } },
  icona("tour"), " ", NAV4 ? [el("span", { class: "gas-lungo" }, t("cf_bottone")), el("span", { class: "gas-corto" }, t("cf_corto"))] : t("cf_bottone"));
  return b;
}
Object.assign(TESTI.it, {
  info_aria: "Che cos'è?",
  gl_fov: "Quanto cielo entra nella foto, in gradi: la Luna piena è larga mezzo grado. Dipende dalla focale del telescopio e dalla grandezza del sensore.",
  gl_scala: "Quanti secondi d'arco di cielo finiscono in un pixel. Più è piccola, più dettagli vedi, ma servono un cielo stabile e una montatura precisa. Per il cielo profondo di solito va bene fra 1 e 2″/px.",
  gl_fnum: "Il rapporto focale (f/) è la focale divisa per il diametro. Più è basso (f/4, f/5) più il telescopio è «veloce»: raccoglie luce in fretta e bastano pose più brevi.",
  gl_campionamento: "Dice se i pixel sono della misura giusta per il tremolio dell'aria (seeing). Ideale: ogni stella copre 2-3 pixel. Con pixel troppo grandi le stelle vengono quadrate; troppo piccoli, l'immagine è morbida e meno luminosa.",
  gl_pupilla: "Il diametro del fascio di luce che esce dall'oculare. Fra 1 e 5 mm va bene; sotto 0,5 mm l'immagine diventa scura e sfocata, sopra 7 mm una parte della luce non entra nell'occhio.",
  gl_cielo: "SQM: quanto è buio il cielo, più è alto meglio è (22 è il cielo più buio possibile, 18 una città). LPI: quanta luce artificiale c'è rispetto al cielo naturale. Bortle: da 1 (cielo perfetto) a 9 (centro città).",
  gl_seeing: "Seeing: quanto l'aria trema e fa tremolare le stelle; conta per pianeti, Luna e dettagli fini. Trasparenza: quanto l'aria è limpida, senza foschia; conta per nebulose e galassie.",
});
Object.assign(TESTI.de, {
  info_aria: "Was ist das?",
  gl_fov: "Wie viel Himmel ins Bild passt, in Grad: Der Vollmond ist ein halbes Grad breit. Es hängt von der Brennweite und der Sensorgröße ab.",
  gl_scala: "Wie viele Bogensekunden Himmel auf ein Pixel fallen. Je kleiner, desto mehr Details, aber Sie brauchen ruhige Luft und eine genaue Montierung. Für Deep-Sky passen meist 1 bis 2″/px.",
  gl_fnum: "Das Öffnungsverhältnis (f/) ist die Brennweite geteilt durch den Durchmesser. Je kleiner (f/4, f/5), desto „schneller“ das Teleskop: Es sammelt rasch Licht und kürzere Belichtungen reichen.",
  gl_campionamento: "Sagt, ob die Pixel zur Luftunruhe (Seeing) passen. Ideal: Jeder Stern deckt 2-3 Pixel. Zu große Pixel machen eckige Sterne, zu kleine ein weiches, dunkleres Bild.",
  gl_pupilla: "Der Durchmesser des Lichtbündels, das aus dem Okular kommt. Zwischen 1 und 5 mm ist gut; unter 0,5 mm wird das Bild dunkel und unscharf, über 7 mm geht Licht am Auge vorbei.",
  gl_cielo: "SQM: wie dunkel der Himmel ist, je höher desto besser (22 ist der dunkelste mögliche Himmel, 18 eine Stadt). LPI: wie viel künstliches Licht im Verhältnis zum natürlichen Himmel. Bortle: von 1 (perfekt) bis 9 (Innenstadt).",
  gl_seeing: "Seeing: wie stark die Luft flimmert und die Sterne zittern lässt; wichtig für Planeten, Mond und feine Details. Transparenz: wie klar die Luft ist, ohne Dunst; wichtig für Nebel und Galaxien.",
});
Object.assign(TESTI.es, {
  info_aria: "¿Qué es?",
  gl_fov: "Cuánto cielo entra en la foto, en grados: la Luna llena mide medio grado. Depende de la focal del telescopio y del tamaño del sensor.",
  gl_scala: "Cuántos segundos de arco de cielo caen en un píxel. Cuanto más pequeña, más detalle, pero hacen falta un cielo estable y una montura precisa. Para cielo profundo suele ir bien entre 1 y 2″/px.",
  gl_fnum: "La relación focal (f/) es la focal dividida por el diámetro. Cuanto más baja (f/4, f/5), más «rápido» es el telescopio: recoge luz deprisa y bastan exposiciones más cortas.",
  gl_campionamento: "Dice si los píxeles tienen el tamaño adecuado para la turbulencia del aire (seeing). Ideal: cada estrella ocupa 2-3 píxeles. Con píxeles demasiado grandes las estrellas salen cuadradas; demasiado pequeños, la imagen sale blanda y menos luminosa.",
  gl_pupilla: "El diámetro del haz de luz que sale del ocular. Entre 1 y 5 mm va bien; por debajo de 0,5 mm la imagen se vuelve oscura y borrosa, por encima de 7 mm parte de la luz no entra en el ojo.",
  gl_cielo: "SQM: lo oscuro que es el cielo, cuanto más alto mejor (22 es el cielo más oscuro posible, 18 una ciudad). LPI: cuánta luz artificial hay respecto al cielo natural. Bortle: de 1 (cielo perfecto) a 9 (centro de la ciudad).",
  gl_seeing: "Seeing: cuánto tiembla el aire y hace titilar las estrellas; cuenta para planetas, Luna y detalles finos. Transparencia: lo limpio que está el aire, sin bruma; cuenta para nebulosas y galaxias.",
});
Object.assign(TESTI.en, {
  info_aria: "What is this?",
  gl_fov: "How much sky fits in the photo, in degrees: the full Moon is half a degree across. It depends on the telescope's focal length and the sensor size.",
  gl_scala: "How many arcseconds of sky land on one pixel. Smaller means more detail, but you need steady air and an accurate mount. For deep sky, 1 to 2″/px usually works well.",
  gl_fnum: "The focal ratio (f/) is the focal length divided by the aperture. The lower it is (f/4, f/5), the “faster” the telescope: it gathers light quickly and shorter exposures are enough.",
  gl_campionamento: "Tells you whether the pixels suit the air turbulence (seeing). Ideally each star covers 2-3 pixels. Pixels too big give square stars; too small, a soft and dimmer image.",
  gl_pupilla: "The width of the beam of light leaving the eyepiece. Between 1 and 5 mm is good; below 0.5 mm the image gets dark and blurry, above 7 mm some light misses your eye.",
  gl_cielo: "SQM: how dark the sky is, higher is better (22 is the darkest possible sky, 18 a city). LPI: how much artificial light there is compared with the natural sky. Bortle: from 1 (perfect sky) to 9 (city centre).",
  gl_seeing: "Seeing: how much the air shimmers and makes stars twinkle; it matters for planets, the Moon and fine detail. Transparency: how clear the air is, without haze; it matters for nebulae and galaxies.",
});
function infoBtn(chiave) {
  const b = el("button", { type: "button", class: "gas-info", "aria-haspopup": "dialog", "aria-expanded": "false", "aria-label": t("info_aria"), title: t("info_aria"),
    onclick: e => { e.stopPropagation(); e.preventDefault(); apriPop(b, el("p", { class: "gas-pop-testo" }, t("gl_" + chiave))); } }, "i");
  return b;
}
const FILTRO_CAM = Object.assign({ q: "", marca: "", cat: "", col: "", sens: "", pix: "", negozio: false, prod: false, ord: "nome" },
  ricorda("camere", {}));
const CATEGORIE_CAM = ["raffreddata", "non_raffreddata", "planetaria_guida", "smart", "mirrorless", "reflex", "medio_formato", "swir"];
const FASCE_PIXEL = [["", null, null], ["p1", 0, 2.4], ["p2", 2.4, 3.8], ["p3", 3.8, 5], ["p4", 5, 99]];
const RE_SENSORE = /(IMX|ICX|KAF|KAI|GSENSE|MN|SC|AR)-?0*(\d+)/i;
function codiceSensore(s) { const m = RE_SENSORE.exec(s || ""); return m ? m[1].toUpperCase() + m[2] : ""; }
Object.assign(TESTI.it, { confronta_max: "Al massimo 4 camere: togline una dal confronto per aggiungere questa.",
  dim_sensore: "Dimensioni" });
Object.assign(TESTI.de, { confronta_max: "Höchstens 4 Kameras: Entfernen Sie eine aus dem Vergleich, um diese hinzuzufügen.", dim_sensore: "Größe" });
Object.assign(TESTI.es, { confronta_max: "Como máximo 4 cámaras: quita una de la comparación para añadir esta.", dim_sensore: "Tamaño" });
Object.assign(TESTI.en, { confronta_max: "4 cameras at most: remove one from the comparison to add this one.", dim_sensore: "Size" });
function vistaCamere(pannello) {
  svuota(pannello);
  const marche = [...new Set(DATI.camere.map(c => c.marca))].sort((a, b) => a.localeCompare(b));
  const nomiSens = new Map();
  for (const c of DATI.camere) {
    const m = RE_SENSORE.exec(c.sensore || "");
    if (!m) continue;
    const k = m[1].toUpperCase() + m[2], e = c.sensore.slice(0, m.index) + m[0], v = nomiSens.get(k) || {};
    v[e] = (v[e] || 0) + 1; nomiSens.set(k, v);
  }
  const sensori = [...nomiSens].map(([k, v]) => [k, Object.keys(v).sort((a, b) => v[b] - v[a])[0]])
    .sort((a, b) => a[1].localeCompare(b[1], undefined, { numeric: true }));
  FILTRO_CAM.sens = codiceSensore(FILTRO_CAM.sens);
  const confronta = new Set();
  const cerca = el("input", { type: "search", class: "gas-input", placeholder: t("cerca_camera"), value: FILTRO_CAM.q });
  cerca.addEventListener("input", debounce(() => { FILTRO_CAM.q = cerca.value; mostra(); }, 120));
  const s = (k, voci) => selezione(voci, FILTRO_CAM[k], v => { FILTRO_CAM[k] = v; mostra(); });
  const spunta = (k, testo) => {
    const c = el("input", { type: "checkbox", checked: FILTRO_CAM[k] });
    c.addEventListener("change", () => { FILTRO_CAM[k] = c.checked; mostra(); });
    return el("label", { class: "gas-spunta" }, c, testo);
  };
  const conta = el("p", { class: "gas-nota" });
  const elenco = el("div", { class: "gas-camere" });
  const barraConfronto = el("div", { class: "gas-confronto-barra", hidden: true });
  const confronto = el("div", { class: "gas-confronto" });
  const veri = el("div", { class: "gas-filtri-veri gas-filtri-chiusi" });
  const riass = el("span", { class: "gas-filtri-riass" });
  const scriviRiass = () => {
    const scelti = [...veri.querySelectorAll("select")].filter(x => x.selectedIndex > 0).map(x => x.options[x.selectedIndex].textContent)
      .concat([...veri.querySelectorAll("input[type=checkbox]:checked")].map(x => x.parentNode.textContent.trim()));
    riass.textContent = scelti.length ? scelti.join(" · ") : t("tutte");
  };
  const apri = el("button", { type: "button", class: "gas-filtri-apri", "aria-expanded": "false", onclick: () => {
    const chiusi = veri.classList.toggle("gas-filtri-chiusi");
    apri.setAttribute("aria-expanded", String(!chiusi));
  } }, el("b", null, t("ns_filtri")), riass, el("span", { class: "gas-filtri-freccia", "aria-hidden": "true" }, "▾"));
  veri.addEventListener("change", scriviRiass);
  pannello.append(
    el("div", { class: "gas-filtri" },
      el("div", { class: "gas-filtri-cerca" }, cerca), apri,
      aggiungi(veri, [el("div", { class: "gas-filtri-griglia" },
        etichetta(t("marca"), s("marca", [["", t("tutte")], ...marche.map(m => [m, m])])),
        etichetta(t("tipo"), s("cat", [["", t("tutti")], ...CATEGORIE_CAM.filter(c => DATI.camere.some(x => x.cat === c)).map(c => [c, t("cat_" + c)])])),
        etichetta(t("colore_mono"), s("col", [["", t("tutte")], ["colore", t("colore")], ["mono", t("mono")]])),
        etichetta(t("sensore"), s("sens", [["", t("tutti")], ...sensori])),
        etichetta(t("pixel"), s("pix", FASCE_PIXEL.map(([k]) => [k, k ? t("pix_" + k) : t("tutti")]))),
        etichetta(t("ordina"), s("ord", [["nome", t("ord_nome")], ["mp", t("ord_mp")], ["pixel", t("ord_pixel")], ["sensore_mm", t("ord_formato")], ["anno", t("ord_recenti")]]))),
      el("div", { class: "gas-spunte" }, spunta("negozio", t("solo_negozio")), spunta("prod", t("solo_produzione")))]) || veri),
    conta, barraConfronto, confronto, elenco,
    el("p", { class: "gas-nota" }, t("nota_camere")));
  scriviRiass();
  let limite = 60;
  function filtrate() {
    const q = normParole(FILTRO_CAM.q).trim().split(/\s+/).filter(Boolean);
    const fascia = FASCE_PIXEL.find(f => f[0] === FILTRO_CAM.pix) || FASCE_PIXEL[0];
    const out = DATI.camere.filter(c =>
      (!q.length || q.every(w => c.cercaParole.includes(w) || c.cerca.includes(norm(w)))) &&
      (!FILTRO_CAM.marca || c.marca === FILTRO_CAM.marca) && (!FILTRO_CAM.cat || c.cat === FILTRO_CAM.cat) &&
      (!FILTRO_CAM.col || c.col === FILTRO_CAM.col) && (!FILTRO_CAM.sens || codiceSensore(c.sensore) === FILTRO_CAM.sens) &&
      (fascia[1] == null || (c.px > fascia[1] && c.px <= fascia[2])) &&
      (!FILTRO_CAM.negozio || c.h_negozio) && (!FILTRO_CAM.prod || c.prod !== false));
    const ord = {
      nome: (a, b) => a.nome.localeCompare(b.nome, undefined, { numeric: true }),
      mp: (a, b) => (b.mp || 0) - (a.mp || 0), pixel: (a, b) => (b.px || 0) - (a.px || 0),
      sensore_mm: (a, b) => (b.mm ? b.mm[0] * b.mm[1] : 0) - (a.mm ? a.mm[0] * a.mm[1] : 0),
      anno: (a, b) => (b.anno || 0) - (a.anno || 0) || a.nome.localeCompare(b.nome),
    }[FILTRO_CAM.ord] || (() => 0);
    return out.sort(ord);
  }
  function mostra() {
    salva("camere", Object.assign({}, FILTRO_CAM, { q: "" }));
    const lista = filtrate();
    conta.textContent = t("camere_trovate", { n: num(lista.length), tot: num(DATI.camere.length) });
    svuota(elenco);
    const tab = el("table", { class: "gas-tab gas-tab-camere" },
      el("thead", null, el("tr", null, el("th", { "aria-label": t("confronta") }), [t("camera"), t("sensore"), t("risoluzione"), t("pixel"), t("dim_sensore"), t("campo_col")].map(h => el("th", null, h)),
        el("th", { "aria-label": `${t("usa")} · ${t("acquista")}` }))),
      el("tbody", null, lista.slice(0, limite).map(rigaCam)));
    elenco.appendChild(el("div", { class: "gas-tab-scorre" }, tab));
    if (lista.length > limite) elenco.appendChild(el("button", { type: "button", class: "gas-btn gas-btn--chiaro gas-btn--largo",
      onclick: () => { limite += 60; mostra(); } }, t("mostra_altre", { n: num(lista.length - limite) })));
  }
  function rigaCam(c) {
    const r = calcoloCampo();
    let campo = "–";
    if (r && r.F && c.w && c.px) {
      const F = c.cat === "smart" && c.F ? c.F : r.F;
      campo = angoli(2 * Math.atan(c.w * c.px / 2000 / F) * DEG, 2 * Math.atan(c.h * c.px / 2000 / F) * DEG);
    } else if (c.cat === "smart" && c.F && c.w && c.px) {
      campo = angoli(2 * Math.atan(c.w * c.px / 2000 / c.F) * DEG, 2 * Math.atan(c.h * c.px / 2000 / c.F) * DEG);
    }
    const sp = el("input", { type: "checkbox", checked: confronta.has(c.id), "aria-label": `${t("confronta")}: ${c.nome}` });
    const nomeTd = el("td", null, el("b", null, c.nome), el("br"), el("small", null, [t("cat_" + c.cat), t(c.col), c.raff && c.cat !== "raffreddata" ? t("raffreddata_s") : null,
      c.prod === false ? t("fuori_produzione") : null, c.anno].filter(Boolean).join(" · ")));
    sp.addEventListener("change", () => {
      if (sp.checked && confronta.size >= 4) {
        sp.checked = false;
        if (!$(".gas-confronto-max", nomeTd)) { const a = el("small", { class: "gas-confronto-max", role: "alert" }, t("confronta_max")); nomeTd.appendChild(a); setTimeout(() => a.remove(), 6000); }
        return;
      }
      if (sp.checked) confronta.add(c.id); else confronta.delete(c.id);
      mostraConfronto();
      if (sp.checked && confronta.size === 2) barraConfronto.scrollIntoView({ block: "start", behavior: "smooth" });
    });
    return el("tr", null,
      el("td", null, el("label", { class: "gas-cam-spunta" }, sp)),
      nomeTd,
      el("td", null, c.sensore || "–", c.bit ? el("small", null, ` · ${c.bit} bit`) : null),
      el("td", null, c.w ? `${num(c.w)} × ${num(c.h)}` : "–", c.mp ? el("small", null, ` · ${num(c.mp, 1)} MP`) : null),
      el("td", null, c.px ? `${num(c.px, 2)} µm` : "–"),
      el("td", null, c.mm ? `${num(c.mm[0], 1)} × ${num(c.mm[1], 1)} mm` : "–"),
      el("td", null, campo),
      el("td", { class: "gas-azioni" },
        el("button", { type: "button", class: "gas-btn gas-btn--mini", "aria-label": `${t("usa")}: ${c.nome}`, onclick: () => usaCamera(c) }, t("usa")),
        c.h_negozio ? el("a", { class: "gas-btn gas-btn--mini gas-btn--oro", href: urlProdotto(c.h_negozio), target: "_blank", rel: "noopener",
          "aria-label": `${t("acquista")}: ${c.nome}` }, t("acquista")) : null));
  }
  function usaCamera(c) {
    CAMPO.modo = "foto";
    CAMPO.cam = camScelta(c);
    if (c.cat === "smart" && c.D && c.F) CAMPO.tel = { nome: c.nome, D: c.D, F: c.F, smart: true, h: c.h_negozio };
    salvaCampo();
    vai("campo");
  }
  function mostraConfronto() {
    svuota(confronto);
    barraConfronto.hidden = !confronta.size;
    svuota(barraConfronto).append(el("span", null, t("da_confrontare", { n: confronta.size })),
      el("button", { type: "button", class: "gas-btn gas-btn--mini", onclick: () => { confronta.clear(); mostra(); mostraConfronto(); } }, t("svuota")));
    if (confronta.size < 2) return;
    const cc = [...confronta].map(id => DATI.perCamera.get(id)).filter(Boolean);
    const r = calcoloCampo();
    const righe = [
      [t("sensore"), c => c.sensore || "–"], [t("risoluzione"), c => `${num(c.w)} × ${num(c.h)}`], [t("megapixel"), c => num(c.mp, 1)],
      [t("pixel"), c => `${num(c.px, 2)} µm`], [t("dim_sensore"), c => c.mm ? `${num(c.mm[0], 1)} × ${num(c.mm[1], 1)} mm` : "–"],
      [t("bit"), c => c.bit || "–"], [t("raffreddata"), c => c.raff ? t("si") : t("no")], [t("colore_mono"), c => t(c.col)],
    ];
    const Fc = c => c.cat === "smart" && c.F ? c.F : r && r.F;
    if (cc.some(Fc)) {
      righe.push([t("campo_col") + (r && r.F ? ` (${num(r.F)} mm)` : ""), c => Fc(c) && c.w && c.px ? angoli(2 * Math.atan(c.w * c.px / 2000 / Fc(c)) * DEG,
        2 * Math.atan(c.h * c.px / 2000 / Fc(c)) * DEG) + (Fc(c) !== (r && r.F) ? ` (${num(Fc(c))} mm)` : "") : "–"]);
      righe.push([t("scala"), c => Fc(c) && c.px ? `${num(206.265 * c.px / Fc(c), 2)}″/px` : "–"]);
    }
    confronto.appendChild(el("div", { class: "gas-tab-scorre" }, el("table", { class: "gas-tab gas-tab-confronto" },
      el("thead", null, el("tr", null, el("th", null, t("confronto")), cc.map(c => el("th", null, c.nome)))),
      el("tbody", null, righe.map(([e, f]) => el("tr", null, el("th", null, e), cc.map(c => el("td", null, f(c)))))))));
  }
  mostra();
}
const CALC = Object.assign({ D: 100, F: 550, k: 1, f: 25, afov: 68, px: 3.76, seeing: 2.5, pxp: 2.9, colp: "colore",
  lf: 14, ln: 2.8, lpx: 5.9, lcrop: 1, ldec: 0,
  T: 10, RH: 85, pose: 60, esp: 180, scelte: {} }, ricorda("calc", {}));
if (!CALC.scelte) CALC.scelte = {};
Object.assign(TESTI.it, {
  xi_intro: "{n} calcolatori per osservare e fotografare il cielo. Scegline uno: i valori partono dal tuo setup e dai prodotti del negozio.",
  xi_cerca: "Cerca: pupilla, ″/px, Bortle, polvere…", xi_tutti: "Tutti", xi_nessuno: "Nessun calcolatore con queste parole.",
  xi_indice: "Tutti i calcolatori", xi_altri: "Altri calcolatori · {g}", xi_recenti: "Usati di recente", riduttore_barlow: "Riduttore o Barlow",
  xg_osserva: "Osservare", xg_foto: "Fotografare", xg_montatura: "Montatura e guida", xg_cielo: "Cielo e meteo",
  xn_telescopio: "Cosa può fare il telescopio", xd_telescopio: "Luce raccolta, dettagli più piccoli, stelle più deboli e ingrandimenti utili.",
  xn_oculare: "Ingrandimento e campo", xd_oculare: "Con il tuo oculare: ingrandimento, campo reale e pupilla d'uscita.",
  xn_oculari: "Gli oculari giusti", xd_oculari: "Le focali che servono al tuo telescopio, con gli oculari del negozio.",
  xn_binocolo: "Binocolo", xd_binocolo: "Pupilla d'uscita, luminosità, fattore crepuscolare e campo a 1000 m.",
  xn_vista: "Cosa vedo all'oculare", xd_vista: "Saturno, la Luna, M13 o M42 come appaiono col tuo telescopio e il tuo oculare.",
  xn_confronta: "Confronta telescopi", xd_confronta: "Due o tre telescopi del negozio fianco a fianco: luce, dettagli, campo, peso e prezzo.",
  xn_campionamento: "Focale ideale e campionamento", xd_campionamento: "Quanti ″/px ottieni con telescopio e camera, e se vanno bene per il seeing del tuo cielo (anche con binning e Barlow).",
  xn_posa: "Durata della singola posa", xd_posa: "Quanto devono durare le pose col tuo cielo, la tua camera e il filtro.",
  xn_integrazione: "Integrazione e spazio su disco", xd_integrazione: "Ore totali di posa e quanti GB occupano i file.",
  xn_planetario: "Riprese planetarie", xd_planetario: "Il rapporto focale giusto per la camera, la Barlow che serve e quanto viene grande Giove.",
  xn_npf: "Paesaggi notturni", xd_npf: "Posa massima su treppiede senza stelle mosse: regole NPF e del 500.",
  xn_rotazione: "Rotazione di campo", xd_rotazione: "Posa massima su una montatura altazimutale o uno smart telescope.",
  xn_cfz: "Zona critica di fuoco", xd_cfz: "Quanto è stretto il fuoco e ogni quanti gradi di temperatura rifocheggiare.",
  xn_filtri: "Misura dei filtri", xd_filtri: "1,25″, 31 mm, 36 mm o 2″: il filtro più piccolo che non dà vignettatura.",
  xn_polvere: "Polvere sul sensore", xd_polvere: "Dalle ciambelle nei flat: su quale vetro sta la polvere.",
  xn_carico: "Carico della montatura", xd_carico: "Peso del setup e portata, con le montature del negozio adatte.",
  xn_guida: "Cannocchiale guida", xd_guida: "Cannocchiale guida o guida fuori asse: il rapporto fra le due scale.",
  xn_backfocus: "Catena del backfocus", xd_backfocus: "Quanti distanziali servono fra spianatore e camera.",
  xn_polare: "Polare nel cannocchiale", xd_polare: "Dove mettere la Polare adesso, per il tuo luogo.",
  xn_condensa: "Rischio condensa", xd_condensa: "Punto di rugiada e quanto rischi l'appannamento delle ottiche.",
  xn_cielo: "Qualità del cielo", xd_cielo: "SQM, Bortle, stelle visibili a occhio nudo e luminosità del fondo.",
});
Object.assign(TESTI.de, {
  xi_intro: "{n} Rechner zum Beobachten und Fotografieren. Wählen Sie einen: die Werte sind mit Ihrer Ausrüstung und den Produkten des Shops vorausgefüllt.",
  xi_cerca: "Suche: Pupille, ″/px, Bortle, Staub…", xi_tutti: "Alle", xi_nessuno: "Kein Rechner mit diesen Wörtern.",
  xi_indice: "Alle Rechner", xi_altri: "Weitere Rechner · {g}", xi_recenti: "Zuletzt benutzt", riduttore_barlow: "Reducer oder Barlow",
  xg_osserva: "Beobachten", xg_foto: "Fotografieren", xg_montatura: "Montierung und Guiding", xg_cielo: "Himmel und Wetter",
  xn_telescopio: "Was das Teleskop kann", xd_telescopio: "Lichtsammelleistung, kleinste Details, schwächste Sterne und sinnvolle Vergrößerungen.",
  xn_oculare: "Vergrößerung und Feld", xd_oculare: "Mit Ihrem Okular: Vergrößerung, wahres Feld und Austrittspupille.",
  xn_oculari: "Die richtigen Okulare", xd_oculari: "Die Brennweiten, die Ihr Teleskop braucht, mit den Okularen aus dem Shop.",
  xn_binocolo: "Fernglas", xd_binocolo: "Austrittspupille, Helligkeit, Dämmerungszahl und Sehfeld auf 1000 m.",
  xn_vista: "Was ich im Okular sehe", xd_vista: "Saturn, Mond, M13 oder M42 so, wie sie mit Ihrem Teleskop und Okular aussehen.",
  xn_confronta: "Teleskope vergleichen", xd_confronta: "Zwei oder drei Teleskope aus dem Shop nebeneinander: Licht, Details, Feld, Gewicht und Preis.",
  xn_campionamento: "Ideale Brennweite und Abtastung", xd_campionamento: "Wie viele ″/px Sie mit Teleskop und Kamera erreichen und ob das zum Seeing Ihres Himmels passt (auch mit Binning und Barlow).",
  xn_posa: "Länge der Einzelbelichtung", xd_posa: "Wie lang die Belichtungen bei Ihrem Himmel, Ihrer Kamera und Ihrem Filter sein sollten.",
  xn_integrazione: "Integration und Speicherplatz", xd_integrazione: "Gesamte Belichtungszeit und wie viele GB die Dateien belegen.",
  xn_planetario: "Planetenaufnahmen", xd_planetario: "Das richtige Öffnungsverhältnis für die Kamera, die nötige Barlow und wie groß Jupiter wird.",
  xn_npf: "Nachtlandschaften", xd_npf: "Maximale Belichtung auf dem Stativ ohne Strichspuren: NPF- und 500er-Regel.",
  xn_rotazione: "Bildfelddrehung", xd_rotazione: "Maximale Belichtung auf einer azimutalen Montierung oder einem Smart-Teleskop.",
  xn_cfz: "Kritische Fokuszone", xd_cfz: "Wie eng der Fokus ist und nach wie vielen Grad nachfokussiert werden muss.",
  xn_filtri: "Filtergröße", xd_filtri: "1,25″, 31 mm, 36 mm oder 2″: der kleinste Filter ohne Vignettierung.",
  xn_polvere: "Staub auf dem Sensor", xd_polvere: "Aus den Ringen in den Flats: auf welchem Glas der Staub liegt.",
  xn_carico: "Belastung der Montierung", xd_carico: "Gewicht der Ausrüstung und Tragkraft, mit passenden Montierungen aus dem Shop.",
  xn_guida: "Leitrohr", xd_guida: "Leitrohr oder Off-Axis-Guider: das Verhältnis der beiden Maßstäbe.",
  xn_backfocus: "Backfokus-Kette", xd_backfocus: "Wie viele Distanzringe zwischen Flattener und Kamera nötig sind.",
  xn_polare: "Polaris im Polsucher", xd_polare: "Wo Polaris jetzt stehen muss, für Ihren Ort.",
  xn_condensa: "Taurisiko", xd_condensa: "Taupunkt und wie stark die Optik beschlagen kann.",
  xn_cielo: "Himmelsqualität", xd_cielo: "SQM, Bortle, mit bloßem Auge sichtbare Sterne und Helligkeit des Hintergrunds.",
});
Object.assign(TESTI.es, {
  xi_intro: "{n} calculadoras para observar y fotografiar el cielo. Elige una: los valores parten de tu equipo y de los productos de la tienda.",
  xi_cerca: "Busca: pupila, ″/px, Bortle, polvo…", xi_tutti: "Todas", xi_nessuno: "Ninguna calculadora con estas palabras.",
  xi_indice: "Todas las calculadoras", xi_altri: "Otras calculadoras · {g}", xi_recenti: "Usadas hace poco", riduttore_barlow: "Reductor o Barlow",
  xg_osserva: "Observar", xg_foto: "Fotografiar", xg_montatura: "Montura y guiado", xg_cielo: "Cielo y tiempo",
  xn_telescopio: "Qué puede hacer el telescopio", xd_telescopio: "Luz recogida, detalles más pequeños, estrellas más débiles y aumentos útiles.",
  xn_oculare: "Aumento y campo", xd_oculare: "Con tu ocular: aumento, campo real y pupila de salida.",
  xn_oculari: "Los oculares adecuados", xd_oculari: "Las focales que necesita tu telescopio, con los oculares de la tienda.",
  xn_binocolo: "Prismáticos", xd_binocolo: "Pupila de salida, luminosidad, factor crepuscular y campo a 1000 m.",
  xn_vista: "Qué veo en el ocular", xd_vista: "Saturno, la Luna, M13 o M42 tal como se ven con tu telescopio y tu ocular.",
  xn_confronta: "Comparar telescopios", xd_confronta: "Dos o tres telescopios de la tienda lado a lado: luz, detalles, campo, peso y precio.",
  xn_campionamento: "Focal ideal y muestreo", xd_campionamento: "Cuántos ″/px obtienes con telescopio y cámara, y si van bien para el seeing de tu cielo (también con binning y Barlow).",
  xn_posa: "Duración de cada toma", xd_posa: "Cuánto deben durar las tomas con tu cielo, tu cámara y el filtro.",
  xn_integrazione: "Integración y espacio en disco", xd_integrazione: "Horas totales de exposición y cuántos GB ocupan los archivos.",
  xn_planetario: "Fotografía planetaria", xd_planetario: "La relación focal adecuada para la cámara, la Barlow necesaria y lo grande que sale Júpiter.",
  xn_npf: "Paisajes nocturnos", xd_npf: "Exposición máxima en trípode sin estrellas movidas: reglas NPF y del 500.",
  xn_rotazione: "Rotación de campo", xd_rotazione: "Exposición máxima en una montura altacimutal o un smart telescope.",
  xn_cfz: "Zona crítica de enfoque", xd_cfz: "Lo estrecho que es el enfoque y cada cuántos grados de temperatura reenfocar.",
  xn_filtri: "Tamaño de los filtros", xd_filtri: "1,25″, 31 mm, 36 mm o 2″: el filtro más pequeño que no viñetea.",
  xn_polvere: "Polvo en el sensor", xd_polvere: "Por los anillos de los flats: en qué cristal está el polvo.",
  xn_carico: "Carga de la montura", xd_carico: "Peso del equipo y capacidad, con las monturas adecuadas de la tienda.",
  xn_guida: "Telescopio guía", xd_guida: "Telescopio guía o guía fuera de eje: la relación entre las dos escalas.",
  xn_backfocus: "Cadena del backfocus", xd_backfocus: "Cuántos separadores hacen falta entre aplanador y cámara.",
  xn_polare: "Polar en el buscador polar", xd_polare: "Dónde poner la Polar ahora, para tu lugar.",
  xn_condensa: "Riesgo de rocío", xd_condensa: "Punto de rocío y cuánto riesgo hay de que se empañe la óptica.",
  xn_cielo: "Calidad del cielo", xd_cielo: "SQM, Bortle, estrellas visibles a simple vista y brillo del fondo.",
});
const CALC_GRUPPI = [["osserva", "rosso"], ["foto", "camere"], ["montatura", "attrezzatura"], ["cielo", "meteo"]];
const CALC_ELENCO = [
  ["telescopio", "osserva", "cx_tel", "dawes rayleigh risoluzione magnitudine limite luce diametro rapporto focale aufloesung resolucion"],
  ["oculare", "osserva", "cx_oc", "ingrandimento campo reale pupilla barlow vergroesserung aumento"],
  ["oculari", "osserva", "cx_ocset", "set oculari focali consigliati okulare oculares"],
  ["binocolo", "osserva", "cx_bino", "binocolo 10x50 7x50 crepuscolare fernglas prismaticos"],
  ["vista", "osserva", "cx_vista", "simulatore oculare cosa vedo saturno giove luna m13 m42 nebulosa galassia okular ocular"],
  ["confronta", "osserva", "cx_tc", "confronto paragone differenze telescopi vergleich comparar"],
  ["campionamento", "foto", "cx_camp", "campionamento seeing arcsec pixel scala binning riduttore ccd abtastung muestreo"],
  ["posa", "foto", "cx_posa", "sub esposizione rumore lettura gain fondo cielo belichtung exposicion"],
  ["integrazione", "foto", "cx_int", "integrazione ore pose spazio disco gb"],
  ["planetario", "foto", "pianeta", "planetaria pianeti giove saturno luna lucky imaging planeten planetas"],
  ["npf", "foto", "cx_npf", "npf 500 paesaggio via lattea treppiede obiettivo strisciate milchstrasse"],
  ["rotazione", "foto", "cx_rot", "rotazione campo altazimutale smart seestar dwarf dobson feldrotation"],
  ["cfz", "foto", "cx_cfz", "zona critica fuoco messa a fuoco temperatura focheggiatore fokus enfoque"],
  ["filtri", "foto", "cx_fil", "misura filtro vignettatura 1,25 31 36 2 pollici 50 mm filter"],
  ["polvere", "foto", "cx_pol", "polvere ciambelle flat dust donut staub polvo"],
  ["carico", "montatura", "cx_car", "carico portata peso montatura tragkraft carga"],
  ["guida", "montatura", "cx_gui", "guida autoguida cannocchiale oag fuori asse phd2 guiding"],
  ["backfocus", "montatura", "cx_bf", "backfocus distanziali spianatore riduttore 55 mm"],
  ["polare", "montatura", "stella", "polare stazionamento cannocchiale polare allineamento polaris"],
  ["condensa", "cielo", "cx_rug", "rugiada condensa umidita fasce anticondensa tau rocio"],
  ["cielo", "cielo", "cx_sqm", "sqm bortle inquinamento luminoso magnitudine occhio nudo nelm"],
].map(([id, g, ico, kw]) => ({ id, g, ico, kw }));
Object.assign(TESTI.it, { usa_attr_calc: "Riempi con la mia attrezzatura:" });
Object.assign(TESTI.de, { usa_attr_calc: "Mit meiner Ausrüstung ausfüllen:" });
Object.assign(TESTI.es, { usa_attr_calc: "Rellenar con mi equipo:" });
Object.assign(TESTI.en, { usa_attr_calc: "Fill in with my gear:" });
const CALC_CON_SETUP = { telescopio: "tel", oculare: "tel k oc", oculari: "tel", vista: "tel k oc", campionamento: "tel k cam", posa: "tel k cam",
  integrazione: "cam", planetario: "tel cam", cfz: "tel k", filtri: "tel k cam", polvere: "tel k cam", guida: "tel k cam" };
function cropCamera(c) {
  const mm = c.mm || (c.w && c.h && c.px ? [c.w * c.px / 1000, c.h * c.px / 1000] : null);
  return mm ? Math.round(43.27 / Math.hypot(mm[0], mm[1]) * 100) / 100 : null;
}
function barlowNegozio(k) {
  const vicine = DATI.ottiche.filter(x => x.tipo === "barlow" && x.k >= k * 0.7 && x.k <= k * 1.35)
    .sort((a, b) => Math.abs(a.k - k) - Math.abs(b.k - k)).slice(0, 3);
  return vicine.length ? el("p", { class: "gas-nota gas-calc-negozio" }, t("barlow_vicine"), " ",
    vicine.map((x, i) => [i ? " · " : "", el("a", { href: urlProdotto(x.h), target: "_blank", rel: "noopener" }, x.t)])) : null;
}
function calcAperto() {
  const [n, q] = (location.hash || "").slice(1).split("?");
  return n === "calcolatori" && q && CALC_ELENCO.some(c => c.id === q) ? q : null;
}
const urlCalcolatore = id => `${urlScheda("calcolatori")}#calcolatori${id ? "?" + id : ""}`;
function apriCalcolatore(id, daIndice) {
  try { history.pushState({ gasCalc: id || "", daIndice: !!(id && daIndice) }, "", "#calcolatori" + (id ? "?" + id : "")); } catch (e) {   }
  if (id) salva("calc_recenti", [id, ...ricorda("calc_recenti", []).filter(x => x !== id)].slice(0, 4));
  vai("calcolatori", true);
  const top = RADICE.getBoundingClientRect().top + window.scrollY - 90;
  if (Math.abs(window.scrollY - top) > 40) window.scrollTo({ top, behavior: "smooth" });
}
const normCalc = s => String(s || "").toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "").replace(/[^a-z0-9,.″]+/g, " ");
function indiceCalcolatori() {
  const box = el("div", { class: "gas-cx-indice" });
  let gruppo = ricorda("calc_gruppo", "tutti");
  if (gruppo !== "tutti" && !CALC_GRUPPI.some(([g]) => g === gruppo)) gruppo = "tutti";
  const voce = c => el("a", { class: "gas-cx-voce", href: urlCalcolatore(c.id), dataset: { id: c.id },
    onclick: e => { if (e.metaKey || e.ctrlKey || e.shiftKey) return; e.preventDefault(); apriCalcolatore(c.id, true); } },
    el("span", { class: "gas-cx-ico" }, icona(c.ico)),
    el("span", { class: "gas-cx-testo" }, el("b", null, t("xn_" + c.id)), el("small", null, t("xd_" + c.id))),
    el("span", { class: "gas-cx-freccia", "aria-hidden": "true" }, "→"));
  const cerca = el("input", { type: "search", class: "gas-input gas-cx-cerca", placeholder: t("xi_cerca"), autocomplete: "off", spellcheck: "false", "aria-label": t("xi_cerca") });
  const chip = el("div", { class: "gas-cx-gruppi", role: "group" });
  const sezioni = CALC_GRUPPI.map(([g, ico]) => {
    const lista = CALC_ELENCO.filter(c => c.g === g);
    return { g, nodo: el("section", { class: "gas-cx-gruppo", dataset: { g } },
      el("h3", { class: "gas-cx-gruppo-titolo" }, icona(ico), " ", t("xg_" + g), el("small", null, String(lista.length))),
      el("div", { class: "gas-cx-griglia" }, lista.map(voce))) };
  });
  const vuoto = el("p", { class: "gas-muto gas-cx-vuoto", hidden: true }, t("xi_nessuno"));
  const filtra = () => {
    const q = normCalc(cerca.value).trim().split(/\s+/).filter(Boolean);
    let tot = 0;
    for (const s of sezioni) {
      let n = 0;
      for (const a of s.nodo.querySelectorAll(".gas-cx-voce")) {
        const c = CALC_ELENCO.find(x => x.id === a.dataset.id), testo = normCalc(`${t("xn_" + c.id)} ${t("xd_" + c.id)} ${c.kw} ${t("xg_" + c.g)}`);
        const si = q.every(p => testo.includes(p));
        a.hidden = !si; if (si) n++;
      }
      s.nodo.hidden = !n || (!q.length && gruppo !== "tutti" && s.g !== gruppo);
      if (!s.nodo.hidden) tot += n;
    }
    vuoto.hidden = tot > 0;
    for (const b of chip.children) { const on = !q.length && b.dataset.g === gruppo; b.classList.toggle("on", on); b.setAttribute("aria-pressed", String(on)); }
  };
  for (const [g, ico] of [["tutti", "home"], ...CALC_GRUPPI]) {
    chip.appendChild(el("button", { type: "button", class: "gas-cx-chip", dataset: { g }, onclick: () => { gruppo = g; salva("calc_gruppo", g); cerca.value = ""; filtra(); } },
      icona(ico), el("span", null, g === "tutti" ? t("xi_tutti") : t("xg_" + g))));
  }
  cerca.addEventListener("input", debounce(filtra, 60));
  const recenti = ricorda("calc_recenti", []).map(id => CALC_ELENCO.find(c => c.id === id)).filter(Boolean);
  aggiungi(box, [el("p", { class: "gas-nota gas-cx-intro" }, t("xi_intro", { n: CALC_ELENCO.length })),
    el("div", { class: "gas-cx-comandi" }, cerca, chip),
    recenti.length ? el("div", { class: "gas-cx-recenti" }, el("small", null, t("xi_recenti")),
      recenti.map(c => el("a", { class: "gas-cx-chip gas-cx-chip--mini", href: urlCalcolatore(c.id),
        onclick: e => { if (e.metaKey || e.ctrlKey || e.shiftKey) return; e.preventDefault(); apriCalcolatore(c.id, true); } }, icona(c.ico), el("span", null, t("xn_" + c.id))))) : null,
    ...sezioni.map(s => s.nodo), vuoto]);
  filtra();
  return box;
}
function latoCalcolatori(id) {
  return el("nav", { class: "gas-cx-lato", "aria-label": t("xi_indice") },
    el("a", { class: "gas-cx-lato-tutti", href: urlCalcolatore(""), onclick: e => { e.preventDefault(); apriCalcolatore(""); } }, icona("home"), " ", t("xi_indice")),
    CALC_GRUPPI.map(([g, ico]) => el("div", { class: "gas-cx-lato-gruppo" },
      el("small", null, icona(ico), " ", t("xg_" + g)),
      CALC_ELENCO.filter(c => c.g === g).map(c => el("a", { class: "gas-cx-lato-voce" + (c.id === id ? " on" : ""), href: urlCalcolatore(c.id), "aria-current": c.id === id ? "page" : null,
        onclick: e => { if (e.metaKey || e.ctrlKey || e.shiftKey) return; e.preventDefault(); apriCalcolatore(c.id); } }, icona(c.ico), el("span", null, t("xn_" + c.id)))))));
}
function vistaCalcolatori(pannello) {
  svuota(pannello);
  clearInterval(vistaCalcolatori._t);
  if (!ricorda("calc", null)) {
    if (CAMPO.tel) { CALC.D = CAMPO.tel.D; CALC.F = CAMPO.tel.F; CALC.scelte.tel = { nome: nomeTel(CAMPO.tel), D: CAMPO.tel.D, F: CAMPO.tel.F, h: CAMPO.tel.h, smart: !!CAMPO.tel.smart }; }
    if (CAMPO.cam && CAMPO.cam.px) { CALC.px = CAMPO.cam.px; CALC.scelte.cam = { nome: CAMPO.cam.nome, px: CAMPO.cam.px, h: CAMPO.cam.h_negozio, id: CAMPO.cam.id }; }
  }
  const id = calcAperto();
  if (!id) { pannello.appendChild(el("div", { class: "gas-cx" }, indiceCalcolatori())); return; }
  const voce = CALC_ELENCO.find(c => c.id === id);
  const corpo = el("div", { class: "gas-cx-corpo" });
  pannello.appendChild(el("div", { class: "gas-cx gas-cx--uno" }, latoCalcolatori(id), corpo));
  corpo.appendChild(el("div", { class: "gas-cx-barra" },
    el("a", { class: "gas-btn gas-btn--chiaro gas-btn--mini gas-cx-indietro", href: urlCalcolatore(""),
      onclick: e => { e.preventDefault(); if (history.state && history.state.daIndice) history.back(); else apriCalcolatore(""); } }, icona("indietro"), " ", t("xi_indice")),
    el("span", { class: "gas-cx-dove" }, icona(CALC_GRUPPI.find(([g]) => g === voce.g)[1]), " ", t("xg_" + voce.g))));
  const usaPezzo = (tipo, x) => {
    if (!x) return;
    if (tipo === "tel") { CALC.D = x.D; CALC.F = x.F; CALC.scelte.tel = { nome: nomeTel(x), D: x.D, F: x.F, h: x.h, smart: !!x.smart }; if (x.smart) CALC.k = 1; }
    if (tipo === "k" && x.k) CALC.k = x.k;
    if (tipo === "cam" && x.px) {
      CALC.px = CALC.pxp = x.px;
      CALC.scelte.cam = { nome: x.nome, px: x.px, h: x.h_negozio, id: x.id };
      const d = (x.id && DATI.perCamera.get(x.id)) || x;
      if (d.col) CALC.colp = d.col === "mono" ? "mono" : "colore";
      CALC.scelte.camP = { nome: x.nome, px: x.px, h: x.h_negozio, w: x.w, sh: x.h };
      if (x.w && x.h) CALC.scelte.camI = { nome: x.nome, w: x.w, h: x.h };
      const diag = x.mm ? Math.hypot(x.mm[0], x.mm[1]) : x.w && x.h ? Math.hypot(x.w, x.h) * x.px / 1000 : null;
      if (diag) { CALC.fsDiag = Math.round(diag * 10) / 10; CALC.scelte.camF = { nome: x.nome, d: CALC.fsDiag, h: x.h_negozio }; }
    }
    if (tipo === "oc") { CALC.f = x.f; CALC.afov = x.afov; CALC.scelte.oc = { nome: x.nome, f: x.f, afov: x.afov, h: x.h }; }
  };
  const PEZZI_CALC = [["tel", x => nomeCorto(nomeTel(x))], ["k", x => x.nome ? nomeCorto(x.nome) : nomeFattore(x.k)], ["cam", x => nomeCorto(x.nome)],
    ["oc", x => nomeCorto(x.nome)]];
  const usati = (CALC_CON_SETUP[id] || "").split(" ");
  const pezzi = ATTREZZI ? PEZZI_CALC.filter(([tipo]) => usati.includes(tipo)).flatMap(([tipo, nome]) => (ATTREZZI[tipo] || []).map(x => ({ tipo, x, nome: nome(x) }))) : [];
  const fatto = () => { salva("calc", CALC); vistaCalcolatori(pannello); };
  if ((SETUP_ELENCO.length || pezzi.length) && CALC_CON_SETUP[id]) corpo.appendChild(el("div", { class: "gas-calc-setup" },
    el("span", null, t(pezzi.length ? "usa_attr_calc" : "usa_setup_calc")),
    SETUP_ELENCO.map(s => el("button", { type: "button", class: "gas-btn gas-btn--chiaro gas-btn--mini", title: nomeSetupAuto(s), onclick: () => {
      usaPezzo("tel", s.tel);
      CALC.k = s.tel && s.tel.smart ? 1 : (s.k || 1);
      usaPezzo("cam", s.cam);
      usaPezzo("oc", s.oc);
      fatto();
    } }, s.nome)),
    pezzi.map(p => el("button", { type: "button", class: "gas-btn gas-btn--chiaro gas-btn--mini", title: TIPI_ATT[p.tipo].sotto(p.x),
      onclick: () => { usaPezzo(p.tipo, p.x); fatto(); } }, icona(TIPI_ATT[p.tipo].ico), " ", p.nome))));
  const griglia = el("div", { class: "gas-calc gas-calc--uno" });
  corpo.appendChild(griglia);
  const carte = [], info = [];
  const ricalcola = () => { salva("calc", CALC); info.forEach(f => f()); carte.forEach(c => c.aggiorna()); };
  const ridisegna = () => { salva("calc", CALC); vistaCalcolatori(pannello); };
  const campo = (k, etich, o) => campoNumero(etich, CALC[k], v => { if (v != null || (o && o.facoltativo)) { CALC[k] = v; ricalcola(); } }, o);
  const scelta = (k, voci) => selezione(voci, CALC[k], v => { CALC[k] = isNaN(+v) ? v : +v; ricalcola(); });
  const carta = (titolo, intro, sopra, ingressi, calcola) => {
    const out = el("div", { class: "gas-calc-out" });
    const c = scheda(titolo, intro ? el("p", { class: "gas-nota" }, intro) : null,
      sopra && sopra.length ? el("div", { class: "gas-calc-scegli" }, sopra) : null, el("div", { class: "gas-due" }, ingressi), out);
    c.aggiorna = () => { svuota(out); aggiungi(out, [calcola()]); };
    carte.push(c); griglia.appendChild(c);
    return c;
  };
  const cercaTel = () => creaCerca({
    segnaposto: t("cerca_telescopio"),
    cerca: q => cercaTelescopi(q, 40),
    riga: x => ({ titolo: titoloTelescopio(x), sotto: rigaTelescopio(x), foto: x.foto }),
    scegli: x => { CALC.D = x.D; CALC.F = x.F; CALC.scelte.tel = { nome: titoloTelescopio(x), D: x.D, F: x.F, h: x.h, smart: x.tipo === "smart" }; ridisegna(); },
  }).box;
  const cercaOc = () => creaCerca({
    segnaposto: t("cerca_oculare"),
    cerca: q => cercaOculari(q, 40),
    riga: x => ({ titolo: x.t, sotto: `${num(x.f, x.f % 1 ? 1 : 0)} mm · ${num(x.afov)}°`, foto: x.foto }),
    scegli: x => { CALC.f = x.f; CALC.afov = x.afov; CALC.scelte.oc = { nome: x.t, f: x.f, afov: x.afov, h: x.h }; ridisegna(); },
  }).box;
  const cercaCam = (usa, segnaposto) => creaCerca({
    segnaposto: segnaposto || t("cerca_camera"),
    cerca: q => cercaCamere(q, 40),
    riga: c => ({ titolo: c.nome, sotto: rigaCamera(c), extra: c.h_negozio ? t("in_vendita") : "", foto: c.foto }),
    scegli: c => { usa(c); ridisegna(); },
  }).box;
  const scelto = (chiave, uguale, dettagli) => {
    const n = el("div", { class: "gas-calc-scelto" });
    const agg = () => {
      const s = CALC.scelte[chiave];
      svuota(n);
      if (s && uguale(s)) aggiungi(n, ["✓ ", el("b", null, s.nome), dettagli ? " · " + dettagli(s) : "",
        s.h && inNegozio(s.h) ? [" · ", el("a", { href: urlProdotto(s.h), target: "_blank", rel: "noopener" }, t("vedi_prodotto"), " →")] : null]);
      n.hidden = !n.firstChild;
    };
    info.push(agg);
    return n;
  };
  const telScelto = () => scelto("tel", s => s.D === CALC.D && s.F === CALC.F, s => `${num(s.D)}/${num(s.F)} mm`);
  const pxCam = c => `${num(c.px, 2)} µm`;
  const H = { campo, scelta, carta, cercaTel, cercaOc, cercaCam, scelto, telScelto, pxCam, ricalcola, ridisegna, griglia };
  const crop = [[1, t("full_frame")], [1.5, `APS-C ${num(1.5, 1)}×`], [1.6, `APS-C ${num(1.6, 1)}× (Canon)`], [2, `Micro 4/3 ${num(2)}×`]];
  if (!crop.some(([v]) => v === CALC.lcrop)) crop.push([CALC.lcrop, `${num(CALC.lcrop, 2)}×`]);
  const COSTRUISCI = {
    telescopio: () => carta(t("xn_telescopio"), t("c_tel_i"), [cercaTel(), telScelto()],
      [campo("D", t("diametro"), { unita: "mm" }), campo("F", t("focale"), { unita: "mm" })], () => {
      const { D, F } = CALC;
      if (!D || !F) return null;
      return [riga(t("rapporto_focale"), `f/${num(F / D, 1)}`),
        riga(t("luce_raccolta"), `${num((D / 7) ** 2)}×`, t("luce_raccolta_n")),
        riga(t("risoluzione_dawes"), `${num(116 / D, 2)}″`), riga(t("risoluzione_rayleigh"), `${num(138 / D, 2)}″`),
        riga(t("mag_limite"), num(2.7 + 5 * Math.log10(D), 1), t("mag_limite_n")),
        riga(t("ingr_max"), `${num(2 * D)}×`), riga(t("ingr_minimo"), `${num(D / 7)}×`, t("ingr_minimo_n"))];
    }),
    oculare: () => carta(t("xn_oculare"), t("c_oc_i"), [cercaOc(), scelto("oc", s => s.f === CALC.f && s.afov === CALC.afov, s => `${num(s.f, s.f % 1 ? 1 : 0)} mm · ${num(s.afov)}°`),
      cercaTel(), telScelto()],
    [campo("f", t("focale_oculare"), { unita: "mm" }), campo("afov", t("campo_apparente"), { unita: "°" }),
      campo("D", t("diametro"), { unita: "mm" }), campo("F", t("focale_telescopio"), { unita: "mm" }),
      etichetta(t("riduttore_barlow"), scelta("k", FATTORI.map(f => [f, f === 1 ? t("nessuno") : `${num(f, 2)}×`])))], () => {
      const { D, F, f, afov, k } = CALC;
      if (!D || !F || !f) return null;
      const M = F * k / f, campoR = afov ? afov / M : null;
      return [riga(t("ingrandimento"), `${num(M)}×`, M > 2 * D ? t("troppo_ingrandimento", { m: num(2 * D) }) : ""),
        riga(t("campo_reale"), angolo(campoR)), riga(t("pupilla"), `${num(D / M, 1)} mm`, D / M > 7 ? t("pupilla_grande") : D / M < 0.5 ? t("pupilla_piccola") : "")];
    }),
    oculari: () => cxOculari(H),
    binocolo: () => cxBinocolo(H),
    vista: () => cxVista(H),
    confronta: () => griglia.appendChild(cartaConfronto()),
    campionamento: () => carta(t("xn_campionamento"), t("c_camp_i"), [
      cercaCam(c => { CALC.px = c.px; CALC.scelte.cam = { nome: c.nome, px: c.px, h: c.h_negozio, id: c.id }; }),
      scelto("cam", s => s.px === CALC.px, pxCam), cercaTel(), telScelto()],
    [campo("px", t("pixel"), { unita: "µm", passo: "0.01" }),
      etichetta(t("seeing"), scelta("seeing", SEEING.map(s => [s, t("seeing_" + String(s).replace(".", "_"))]))), campo("F", t("focale_telescopio"), { unita: "mm" }),
      etichetta(t("riduttore_barlow"), scelta("k", FATTORI.map(f => [f, f === 1 ? t("nessuno") : `${num(f, 2)}×`])))], () => {
      const { px, seeing, F } = CALC, k = CALC.k || 1;
      if (!px || !seeing) return null;
      const scala = F ? 206.265 * px / (F * k) : null;
      const Fmin = 206.265 * px / (seeing / 2), Fmax = 206.265 * px / (seeing / 3);
      const out = [riga(t("focale_ideale"), `${num(Fmin)} – ${num(Fmax)} mm`, t("focale_ideale_n", { s: num(seeing, 1) }))];
      if (scala) {
        const [classe, giudizio] = giudizioCampionamento(scala, seeing);
        out.push(riga(t("scala"), `${num(scala, 2)}″/px`, giudizio, "gas-riga--" + classe));
        const kIdeale = (Fmin + Fmax) / 2 / F, netto = classe === "sovra" || classe === "sotto";
        if (netto && kIdeale < 0.9) out.push(riga(t("consiglio"), t("consiglio_rid", { k: num(Math.max(0.5, kIdeale), 2) })));
        if (netto && kIdeale >= 0.9 && kIdeale <= 1.1 && k !== 1) out.push(riga(t("consiglio"), `${t("riduttore_barlow")}: ${t("nessuno")}`));
        if (netto && kIdeale > 1.1) out.push(riga(t("consiglio"), t("consiglio_barlow", { k: num(kIdeale, 1) }), classe === "sotto" ? t("consiglio_barlow_n") : ""), barlowNegozio(kIdeale));
        for (const b of [2, 3]) if (classe === "sovra" || classe === "poco_sovra") out.push(riga(`bin ${b}×${b}`, `${num(scala * b, 2)}″/px`));
      }
      return out;
    }),
    posa: () => cxPosa(H),
    integrazione: () => carta(t("xn_integrazione"), t("c_int_i"), [
      cercaCam(c => { CALC.scelte.camI = { nome: c.nome, w: c.w, h: c.h }; }),
      scelto("camI", s => s.w && s.h, s => `${num(s.w)} × ${num(s.h)} px`)],
    [campo("pose", t("numero_pose")), campo("esp", t("posa_s"), { unita: "s" })], () => {
      const { pose, esp } = CALC;
      if (!pose || !esp) return null;
      const out = [riga(t("integrazione"), durata(pose * esp / 3600))];
      const c = CALC.scelte.camI || CAMPO.cam;
      if (c && c.w && c.h) {
        const mb = c.w * c.h * 2 / 1048576;
        out.push(riga(t("spazio_disco"), mb * pose < 1024 ? `${num(mb * pose)} MB` : `${num(mb * pose / 1024, mb * pose > 10240 ? 0 : 1)} GB`,
          t("spazio_disco_n", { c: c.nome, mb: num(mb, 1) })));
      }
      return out;
    }),
    planetario: () => carta(t("xn_planetario"), t("c_plan_i"), [
      cercaCam(c => { CALC.pxp = c.px; CALC.colp = c.col === "mono" ? "mono" : "colore"; CALC.scelte.camP = { nome: c.nome, px: c.px, h: c.h_negozio, w: c.w, sh: c.h }; }),
      scelto("camP", s => s.px === CALC.pxp, pxCam), cercaTel(), telScelto()],
    [campo("pxp", t("pixel"), { unita: "µm", passo: "0.01" }), etichetta(t("colore_mono"), scelta("colp", [["colore", t("colore")], ["mono", t("mono")]])),
      campo("D", t("diametro"), { unita: "mm" }), campo("F", t("focale"), { unita: "mm" })], () => {
      const { pxp, colp, D, F } = CALC;
      if (!pxp) return null;
      const N = (colp === "mono" ? 4 : 5) * pxp;
      const out = [riga(t("f_ideale"), `f/${num(N, 1)}`, t("f_ideale_n"))];
      if (D && F) {
        const st = CALC.scelte.tel, smart = !!st && st.D === D && st.F === F && (!!st.smart || tipoTelescopio(st) === "smart");
        const k = N / (F / D), barlow = k > 1.05 && !smart, Fp = barlow ? N * D : F, scala = 206.265 * pxp / Fp;
        out.push(riga(t("focale_planetaria"), `${num(Fp)} mm`, barlow ? t("barlow_serve", { k: num(k, 1) }) : k > 1.05 ? t("pp_smart") : t("barlow_non_serve")));
        if (barlow) out.push(barlowNegozio(k));
        out.push(riga(t("pl2_giove"), t("pl2_px", { n: num(45 / scala) })), riga(t("pl2_saturno"), t("pl2_px", { n: num(43 / scala) })));
        const s = CALC.scelte.camP;
        if (s && s.px === pxp && s.w && s.sh) {
          const luna = 1865 / scala, lato = Math.min(s.w, s.sh);
          out.push(riga(t("pl2_luna"), luna <= lato ? t("pl2_luna_si") : t("pl2_luna_no", { n: num(Math.ceil(luna / s.w * 1.2) * Math.ceil(luna / s.sh * 1.2)) })));
        }
      }
      return out;
    }),
    npf: () => carta(t("xn_npf"), t("c_npf_i"), [
      cercaCam(c => { CALC.lpx = c.px; CALC.lcrop = cropCamera(c) || CALC.lcrop; CALC.scelte.camN = { nome: c.nome, px: c.px, h: c.h_negozio }; },
        t("cerca_fotocamera")),
      scelto("camN", s => s.px === CALC.lpx, s => `${pxCam(s)} · crop ${num(CALC.lcrop, 2)}×`)],
    [campo("lf", t("focale_obiettivo"), { unita: "mm" }), campo("ln", t("diaframma"), { segnaposto: "2.8", unita: "f/" }),
      campo("lpx", t("pixel"), { unita: "µm", passo: "0.01" }), etichetta(t("sensore"), scelta("lcrop", crop)),
      campo("ldec", t("declinazione"), { unita: "°", min: -89, max: 89, facoltativo: true })], () => {
      const { lf, ln, lpx, lcrop, ldec } = CALC;
      if (!lf || !ln || !lpx) return null;
      const c = Math.max(0.15, Math.cos((ldec || 0) * RAD));
      const npf = (35 * ln + 30 * lpx) / lf / c;
      const r500 = 500 / (lf * lcrop) / c;
      return [riga(t("regola_npf"), `${num(npf, 1)} s`, t("regola_npf_n")), riga(t("regola_500"), `${num(r500, 1)} s`, t("regola_500_n"))];
    }),
    rotazione: () => cxRotazione(H),
    cfz: () => cxCfz(H),
    filtri: () => cxFiltri(H),
    polvere: () => cxPolvere(H),
    carico: () => griglia.appendChild(cartaCarico()),
    guida: () => cxGuida(H),
    backfocus: () => griglia.appendChild(cartaBackfocus()),
    polare: () => {
      const polare = scheda(t("xn_polare"), el("p", { class: "gas-nota" }, t("c_pol_i")));
      const polOut = el("div", { class: "gas-calc-out" });
      polare.appendChild(polOut);
      polare.aggiorna = () => mostraPolare(polOut);
      carte.push(polare); griglia.appendChild(polare);
      vistaCalcolatori._t = setInterval(() => { if (!pannello.hidden && polare.isConnected) polare.aggiorna(); }, 30000);
    },
    condensa: () => carta(t("xn_condensa"), t("c_rug_i"), null, [campo("T", t("temperatura"), { unita: "°C" }), campo("RH", t("umidita"), { unita: "%", min: 1, max: 100 })], () => {
      const { T, RH } = CALC;
      if (T == null || !RH) return null;
      const g = Math.log(clamp(RH, 1, 100) / 100) + 17.62 * T / (243.12 + T);
      const Td = 243.12 * g / (17.62 - g);
      const margine = T - Td;
      return [riga(t("punto_rugiada"), `${num(Td, 1)} °C`),
        riga(t("rischio"), margine < 2 ? t("rischio_alto") : margine < 5 ? t("rischio_medio") : t("rischio_basso"), t("rischio_n", { m: num(margine, 1) }),
          margine < 2 ? "gas-riga--sotto" : margine < 5 ? "gas-riga--poco_sotto" : "gas-riga--ok")];
    }),
    cielo: () => cxCielo(H),
  };
  COSTRUISCI[id]();
  ricalcola();
  corpo.appendChild(el("div", { class: "gas-cx-altri" }, el("small", null, t("xi_altri", { g: t("xg_" + voce.g) })),
    el("div", { class: "gas-cx-altri-voci" }, CALC_ELENCO.filter(c => c.g === voce.g && c.id !== id).map(c => el("a", { class: "gas-cx-chip gas-cx-chip--mini", href: urlCalcolatore(c.id),
      onclick: e => { if (e.metaKey || e.ctrlKey || e.shiftKey) return; e.preventDefault(); apriCalcolatore(c.id); } }, icona(c.ico), el("span", null, t("xn_" + c.id))))),
    el("a", { class: "gas-btn gas-btn--chiaro gas-btn--mini", href: urlCalcolatore(""), onclick: e => { e.preventDefault(); apriCalcolatore(""); } }, icona("home"), " ", t("xi_indice"))));
}
const POLARE_2000 = [37.95454, 89.26411];
function mostraPolare(out) {
  svuota(out);
  const { lat, lon, nome } = NOTTE.luogo;
  if (lat < 0) { out.appendChild(el("p", { class: "gas-muto" }, t("pol_sud"))); return; }
  const adesso = new Date(), j = Astro.jd(adesso);
  const [ra, dec] = Astro.precessa(POLARE_2000[0], POLARE_2000[1], j);
  const lst = Astro.n360(Astro.gmst(j) + lon);
  const H = Astro.n360(lst - ra);
  const oreH = H / 15;
  const orologio = x => { const tot = Math.round((((x % 12) + 12) % 12) * 60) % 720, h = Math.floor(tot / 60); return `${h === 0 ? 12 : h}:${String(tot % 60).padStart(2, "0")}`; };
  const minH = Math.round(oreH * 60) % 1440;
  const occhio = 12 - oreH / 2, cannocchiale = occhio + 6;
  const dist = 90 - dec;
  const disegno = vista => {
    const R = 46, ang = H * RAD * (vista === "c" ? 1 : 1);
    const x = vista === "c" ? Math.sin(ang) * R : -Math.sin(ang) * R, y = vista === "c" ? Math.cos(ang) * R : -Math.cos(ang) * R;
    const segni = [];
    for (let k = 0; k < 12; k++) {
      const a = k * 30 * RAD;
      segni.push(sv("line", { x1: Math.sin(a) * (R - 4), y1: -Math.cos(a) * (R - 4), x2: Math.sin(a) * (R + 4), y2: -Math.cos(a) * (R + 4), class: "gas-pol-segno" }));
      segni.push(sv("text", { x: Math.sin(a) * (R + 13), y: -Math.cos(a) * (R + 13) + 4, "text-anchor": "middle", class: "gas-pol-num", text: String(k === 0 ? 12 : k) }));
    }
    return sv("svg", { viewBox: "-66 -66 132 132", class: "gas-pol" },
      sv("circle", { r: 64, class: "gas-pol-fondo" }), sv("circle", { r: R, class: "gas-pol-cerchio" }), ...segni,
      sv("line", { x1: -8, y1: 0, x2: 8, y2: 0, class: "gas-pol-croce" }), sv("line", { x1: 0, y1: -8, x2: 0, y2: 8, class: "gas-pol-croce" }),
      sv("circle", { cx: x, cy: y, r: 4.5, class: "gas-pol-stella" }));
  };
  out.append(
    el("div", { class: "gas-pol-due" },
      el("figure", null, disegno("c"), el("figcaption", null, el("b", null, t("pol_cannocchiale")), el("br"), t("pol_ore", { o: orologio(cannocchiale) }))),
      el("figure", null, disegno("o"), el("figcaption", null, el("b", null, t("pol_occhio")), el("br"), t("pol_ore", { o: orologio(occhio) })))),
    riga(t("pol_angolo"), `${Math.floor(minH / 60)}h ${String(minH % 60).padStart(2, "0")}m`),
    riga(t("pol_distanza"), `${num(dist * 60, 1)}′`),
    el("p", { class: "gas-nota" }, t("pol_nota", { luogo: `${nome} (${num(lat, 2)}°, ${num(lon, 2)}°)`, ora: ora(adesso) })));
}
Object.assign(TESTI.it, {
  bf_titolo: "Catena del backfocus", bf_i: "Quanti distanziali servono fra lo spianatore (o il riduttore) e la camera, con la ruota portafiltri e la guida fuori asse.",
  bf_ottica: "Backfocus dell'ottica", bf_camera: "Camera", bf_pezzi: "Nella catena", bf_filtro: "Filtro nel percorso", bf_vetro: "Spessore del vetro",
  bf_altro: "Altro (scrivi tu)", bf_mm: "mm", bf_aggiungi: "+ Altro pezzo", bf_pezzo: "Pezzo", bf_spessore: "Spessore",
  bf_cam_zr: "ZWO raffreddata (17,5 mm, con la piastra di tilt)", bf_cam_zn: "ZWO non raffreddata o planetaria (12,5 mm)", bf_cam_t2: "Reflex o mirrorless con anello T2 (55 mm in tutto)",
  bf_cam_baionetta: "{n} senza anello ({m} mm)", bf_efw: "Ruota portafiltri ZWO EFW", bf_oag: "Guida fuori asse ZWO OAG-L", bf_fd54: "Cassetto portafiltri ZWO M54", bf_fd42: "Cassetto portafiltri ZWO M42",
  bf_r_ottica: "L'ottica vuole", bf_r_catena: "Camera e pezzi", bf_r_filtro: "Il filtro sposta il fuoco", bf_r_servono: "Distanziali da aggiungere", bf_r_lungo: "Troppo lunga di",
  bf_lungo_n: "Togli un pezzo, usa un cassetto al posto della ruota o una camera con meno backfocus.", bf_giusto: "Già giusto: niente distanziali.",
  bf_combo: "Per esempio: {c}", bf_spessori: "più spessori sottili da {s} mm", bf_tolleranza: "Con il tuo f/{n} la tolleranza è circa ±{t} mm: le stelle agli angoli restano tonde.",
  bf_negozio: "Prolunghe e distanziali nel negozio", bf_filtro_n: "il vetro allunga il fuoco di un terzo del suo spessore",
});
Object.assign(TESTI.de, {
  bf_titolo: "Backfokus-Kette", bf_i: "Wie viele Distanzringe zwischen Flattener (oder Reducer) und Kamera nötig sind, mit Filterrad und Off-Axis-Guider.",
  bf_ottica: "Backfokus der Optik", bf_camera: "Kamera", bf_pezzi: "In der Kette", bf_filtro: "Filter im Strahlengang", bf_vetro: "Glasdicke",
  bf_altro: "Andere (selbst eingeben)", bf_mm: "mm", bf_aggiungi: "+ Weiteres Teil", bf_pezzo: "Teil", bf_spessore: "Dicke",
  bf_cam_zr: "ZWO gekühlt (17,5 mm, mit Tilt-Platte)", bf_cam_zn: "ZWO ungekühlt oder Planetenkamera (12,5 mm)", bf_cam_t2: "DSLR oder spiegellos mit T2-Ring (insgesamt 55 mm)",
  bf_cam_baionetta: "{n} ohne Ring ({m} mm)", bf_efw: "Filterrad ZWO EFW", bf_oag: "Off-Axis-Guider ZWO OAG-L", bf_fd54: "Filterschublade ZWO M54", bf_fd42: "Filterschublade ZWO M42",
  bf_r_ottica: "Die Optik braucht", bf_r_catena: "Kamera und Teile", bf_r_filtro: "Der Filter verschiebt den Fokus", bf_r_servono: "Hinzuzufügende Distanzringe", bf_r_lungo: "Zu lang um",
  bf_lungo_n: "Entfernen Sie ein Teil, nehmen Sie eine Schublade statt des Rads oder eine Kamera mit weniger Backfokus.", bf_giusto: "Schon richtig: keine Distanzringe.",
  bf_combo: "Zum Beispiel: {c}", bf_spessori: "plus dünne Scheiben mit {s} mm", bf_tolleranza: "Bei Ihrem f/{n} beträgt die Toleranz etwa ±{t} mm: die Sterne in den Ecken bleiben rund.",
  bf_negozio: "Verlängerungen und Distanzringe im Shop", bf_filtro_n: "das Glas verlängert den Fokus um ein Drittel seiner Dicke",
});
Object.assign(TESTI.es, {
  bf_titolo: "Cadena del backfocus", bf_i: "Cuántos separadores hacen falta entre el aplanador (o el reductor) y la cámara, con la rueda portafiltros y la guía fuera de eje.",
  bf_ottica: "Backfocus de la óptica", bf_camera: "Cámara", bf_pezzi: "En la cadena", bf_filtro: "Filtro en el tren óptico", bf_vetro: "Espesor del vidrio",
  bf_altro: "Otro (escríbelo)", bf_mm: "mm", bf_aggiungi: "+ Otra pieza", bf_pezzo: "Pieza", bf_spessore: "Espesor",
  bf_cam_zr: "ZWO refrigerada (17,5 mm, con la placa de tilt)", bf_cam_zn: "ZWO no refrigerada o planetaria (12,5 mm)", bf_cam_t2: "Réflex o sin espejo con anillo T2 (55 mm en total)",
  bf_cam_baionetta: "{n} sin anillo ({m} mm)", bf_efw: "Rueda portafiltros ZWO EFW", bf_oag: "Guía fuera de eje ZWO OAG-L", bf_fd54: "Cajón portafiltros ZWO M54", bf_fd42: "Cajón portafiltros ZWO M42",
  bf_r_ottica: "La óptica necesita", bf_r_catena: "Cámara y piezas", bf_r_filtro: "El filtro desplaza el foco", bf_r_servono: "Separadores que añadir", bf_r_lungo: "Demasiado larga en",
  bf_lungo_n: "Quita una pieza, usa un cajón en lugar de la rueda o una cámara con menos backfocus.", bf_giusto: "Ya es correcto: no hacen falta separadores.",
  bf_combo: "Por ejemplo: {c}", bf_spessori: "más láminas finas de {s} mm", bf_tolleranza: "Con tu f/{n} la tolerancia es de unos ±{t} mm: las estrellas de las esquinas quedan redondas.",
  bf_negozio: "Extensiones y separadores en la tienda", bf_filtro_n: "el vidrio alarga el foco un tercio de su espesor",
});
const BF_CAMERE = [["zr", 17.5], ["zn", 12.5], ["t2", 55], ["Canon EF", 44], ["Nikon F", 46.5], ["Canon RF", 20], ["Sony E", 18], ["Nikon Z", 16], ["Fujifilm X", 17.7], ["Micro 4/3", 19.25]];
const BF_PEZZI = [["efw", 20], ["oag", 17.5], ["fd54", 20], ["fd42", 21]];
const BF_DISTANZIALI = [1, 2, 3, 5, 7.5, 10, 15, 20, 25, 30, 40];
function comboDistanziali(mm) {
  const n = Math.floor(mm * 2 + 1e-6), meglio = new Array(n + 1).fill(null);
  meglio[0] = [];
  for (let v = 1; v <= n; v++) for (const d of BF_DISTANZIALI) {
    const p = Math.round(d * 2);
    if (p <= v && meglio[v - p] && (!meglio[v] || meglio[v - p].length + 1 < meglio[v].length)) meglio[v] = meglio[v - p].concat(d);
  }
  let v = n;
  while (v > 0 && !meglio[v]) v--;
  return { pezzi: (meglio[v] || []).sort((a, b) => b - a), resto: Math.round((mm - v / 2) * 100) / 100 };
}
function cartaBackfocus() {
  const S = Object.assign({ ottica: 55, camera: null, camMm: 17.5, pezzi: { efw: true, oag: false, fd54: false, fd42: false }, filtro: true, vetro: 2, altri: [] }, ricorda("bf", {}));
  if (!S.camera) {
    const c = CAMPO.cam && CAMPO.cam.id ? DATI.perCamera.get(CAMPO.cam.id) : null;
    S.camera = c && /zwo/i.test(c.marca || "") ? (c.cat === "raffreddata" ? "zr" : "zn") : c && /reflex|mirrorless/.test(c.cat || "") ? "t2" : "zr";
  }
  const out = el("div", { class: "gas-calc-out" });
  const salvaBf = () => { salva("bf", S); disegna(); };
  const ottica = campoNumero(t("bf_ottica"), S.ottica, v => { if (v > 0) { S.ottica = v; salvaBf(); } }, { unita: t("bf_mm"), passo: "0.1", min: 10 });
  const nomeCam = ([k, mm]) => (k === "zr" || k === "zn" || k === "t2" ? t("bf_cam_" + k) : t("bf_cam_baionetta", { n: k, m: num(mm, mm % 1 ? 2 : 0) }));
  const camMm = campoNumero(t("bf_spessore"), S.camMm, v => { if (v > 0) { S.camMm = v; salvaBf(); } }, { unita: t("bf_mm"), passo: "0.1" });
  const camera = selezione([...BF_CAMERE.map(c => [c[0], nomeCam(c)]), ["altro", t("bf_altro")]], S.camera, v => { S.camera = v; salvaBf(); });
  const pezzi = el("div", { class: "gas-bf-pezzi" }, BF_PEZZI.map(([k, mm]) => {
    const b = el("button", { type: "button", class: "gas-filtro-scelta" + (S.pezzi[k] ? " on" : ""), "aria-pressed": String(!!S.pezzi[k]), onclick: () => {
      S.pezzi[k] = !S.pezzi[k];
      if (S.pezzi[k] && (k === "fd54" || k === "fd42")) S.pezzi[k === "fd54" ? "fd42" : "fd54"] = false;
      salva("bf", S); vistaPezzi();
    } }, `${S.pezzi[k] ? "✓ " : ""}${t("bf_" + k)} · ${num(mm, mm % 1 ? 1 : 0)} mm`);
    return b;
  }));
  const altri = el("div", { class: "gas-bf-altri" });
  const vistaPezzi = () => { const nuovo = cartaBackfocus(); box.replaceWith(nuovo); };
  const disegnaAltri = () => {
    svuota(altri);
    S.altri.forEach((p, i) => altri.appendChild(el("div", { class: "gas-due gas-bf-altro" },
      el("label", { class: "gas-campo" }, el("span", null, t("bf_pezzo")), el("input", { type: "text", class: "gas-input", value: p.nome || "", maxlength: 40,
        oninput: e => { p.nome = e.target.value; salvaBf(); } })),
      campoNumero(t("bf_spessore"), p.mm, v => { p.mm = v || 0; salvaBf(); }, { unita: t("bf_mm"), passo: "0.1" }),
      el("button", { type: "button", class: "gas-att-togli", title: t("att_togli"), "aria-label": `${t("att_togli")}: ${p.nome || t("bf_pezzo")}`,
        onclick: () => { S.altri.splice(i, 1); salvaBf(); disegnaAltri(); } }, icona("chiudi")))));
    altri.appendChild(el("button", { type: "button", class: "gas-btn gas-btn--chiaro gas-btn--mini", onclick: () => { S.altri.push({ nome: "", mm: 0 }); salva("bf", S); disegnaAltri(); } }, t("bf_aggiungi")));
  };
  const filtro = el("input", { type: "checkbox", checked: S.filtro });
  filtro.addEventListener("change", () => { S.filtro = filtro.checked; salvaBf(); });
  const vetro = campoNumero(t("bf_vetro"), S.vetro, v => { if (v >= 0) { S.vetro = v; salvaBf(); } }, { unita: t("bf_mm"), passo: "0.05" });
  function disegna() {
    svuota(out);
    camMm.hidden = S.camera !== "altro";
    const c = BF_CAMERE.find(x => x[0] === S.camera), mmCam = c ? c[1] : S.camMm || 0;
    const pz = BF_PEZZI.filter(([k]) => S.pezzi[k]).map(([k, mm]) => [t("bf_" + k), mm]).concat(S.altri.filter(p => p.mm > 0).map(p => [p.nome || t("bf_pezzo"), p.mm]));
    const catena = mmCam + pz.reduce((s, p) => s + p[1], 0), filtroMm = S.filtro ? S.vetro / 3 : 0, servono = S.ottica + filtroMm - catena;
    const tot = Math.max(S.ottica + filtroMm, catena), barra = el("div", { class: "gas-bf-barra" });
    const pezzo = (nome, mm, cl) => barra.appendChild(el("span", { class: "gas-bf-seg " + cl, style: { flexGrow: String(mm) }, title: `${nome} · ${num(mm, 1)} mm` },
      el("b", null, num(mm, mm % 1 ? 1 : 0)), el("small", null, nome)));
    pezzo(c && c[0].length > 2 ? c[0] : t("bf_camera"), mmCam, "gas-bf-cam");
    for (const [n, mm] of pz) pezzo(n, mm, "gas-bf-pz");
    if (servono > 0.05) pezzo(t("bf_r_servono"), servono, "gas-bf-dist");
    out.append(barra, el("div", { class: "gas-bf-righello" }, el("span", null, "0"), el("span", null, `${num(tot, 1)} mm`)));
    const righe = [riga(t("bf_r_ottica"), `${num(S.ottica, 1)} mm`), riga(t("bf_r_catena"), `${num(catena, 1)} mm`)];
    if (filtroMm) righe.push(riga(t("bf_r_filtro"), `+${num(filtroMm, 2)} mm`, t("bf_filtro_n")));
    if (servono > 0.05) {
      const co = comboDistanziali(servono);
      righe.push(riga(t("bf_r_servono"), `${num(servono, 1)} mm`, [co.pezzi.length ? t("bf_combo", { c: co.pezzi.map(d => num(d, d % 1 ? 1 : 0) + " mm").join(" + ") }) : "",
        co.resto >= 0.05 ? t("bf_spessori", { s: num(co.resto, 2) }) : ""].filter(Boolean).join(" "), "gas-riga--ok"));
    } else if (servono < -0.05) righe.push(riga(t("bf_r_lungo"), `${num(-servono, 1)} mm`, t("bf_lungo_n"), "gas-riga--sotto"));
    else righe.push(riga(t("bf_r_servono"), "0 mm", t("bf_giusto"), "gas-riga--ok"));
    out.appendChild(el("div", { class: "gas-righe" }, righe));
    const r = calcoloCampo();
    if (r && r.N) out.appendChild(el("p", { class: "gas-nota" }, t("bf_tolleranza", { n: num(r.N, 1), t: num(r.N <= 3 ? 0.1 : r.N <= 4.5 ? 0.25 : r.N <= 6 ? 0.5 : 0.8, 2) })));
    out.appendChild(el("p", { class: "gas-nota" }, el("a", { href: `${RADICE_URL.replace(/\/?$/, "/")}search?q=prolunga`, target: "_blank", rel: "noopener" }, t("bf_negozio"), " →")));
  }
  const box = scheda(t("bf_titolo"), el("p", { class: "gas-nota" }, t("bf_i")),
    el("div", { class: "gas-due" }, ottica, etichetta(t("bf_camera"), camera)), camMm,
    el("small", { class: "gas-setup-etich" }, t("bf_pezzi")), pezzi, altri,
    el("div", { class: "gas-due" }, el("label", { class: "gas-spunta" }, filtro, el("span", null, t("bf_filtro"))), vetro), out);
  box.classList.add("gas-bf");
  box.aggiorna = disegna;
  disegnaAltri();
  disegna();
  return box;
}
Object.assign(TESTI.it, { mc_del_negozio: "Del nostro negozio", mc_altre: "Altre montature" });
Object.assign(TESTI.de, { mc_del_negozio: "Aus unserem Shop", mc_altre: "Weitere Montierungen" });
Object.assign(TESTI.es, { mc_del_negozio: "De nuestra tienda", mc_altre: "Otras monturas" });
Object.assign(TESTI.en, { mc_del_negozio: "From our shop", mc_altre: "Other mounts" });
Object.assign(TESTI.it, {
  mc_titolo: "Carico della montatura", mc_i: "Telescopio, camera e accessori a confronto con la portata della montatura: quanto si può caricare per fotografare bene.",
  mc_tubo: "Tubo ottico", mc_camera: "Camera", mc_acc: "Accessori", mc_montatura: "Montatura", mc_portata: "Portata", mc_stima: "stima: correggi con il peso vero",
  mc_negozio: "dal negozio", mc_altra: "Altra montatura (scrivi la portata)", mc_scegli: "Scegli la montatura",
  mc_a_efw: "Ruota portafiltri", mc_a_oag: "Guida fuori asse", mc_a_guida: "Cannocchiale guida + camera", mc_a_rid: "Spianatore o riduttore", mc_a_foc: "Focheggiatore motorizzato",
  mc_a_anti: "Fasce anticondensa", mc_a_pc: "ASIAIR o mini PC", mc_a_barra: "Barra e anelli (se non inclusi)",
  mc_totale: "Carico totale", mc_uso: "{p} % della portata", mc_ok: "Ottimo per fotografare: la montatura lavora tranquilla.",
  mc_medio: "Va bene per fotografare se bilanci con cura e non c'è vento; con le pose lunghe serve un po' di cautela.",
  mc_visuale: "Al limite: va bene in visuale e per pose brevi; per la fotografia meglio una montatura più robusta.", mc_troppo: "Troppo carico: la montatura non regge questo peso.",
  mc_consigliate: "Montature del negozio adatte a questo carico per la fotografia", mc_cp: "{a} kg ({b} kg con contrappeso)", mc_vedi: "Vedi",
});
Object.assign(TESTI.de, {
  mc_titolo: "Belastung der Montierung", mc_i: "Teleskop, Kamera und Zubehör im Vergleich zur Tragkraft der Montierung: wie viel man für gute Fotos laden kann.",
  mc_tubo: "Optischer Tubus", mc_camera: "Kamera", mc_acc: "Zubehör", mc_montatura: "Montierung", mc_portata: "Tragkraft", mc_stima: "Schätzung: mit dem echten Gewicht korrigieren",
  mc_negozio: "aus dem Shop", mc_altra: "Andere Montierung (Tragkraft eingeben)", mc_scegli: "Montierung wählen",
  mc_a_efw: "Filterrad", mc_a_oag: "Off-Axis-Guider", mc_a_guida: "Leitrohr + Kamera", mc_a_rid: "Flattener oder Reducer", mc_a_foc: "Motorfokus",
  mc_a_anti: "Taukappenheizung", mc_a_pc: "ASIAIR oder Mini-PC", mc_a_barra: "Schiene und Rohrschellen (falls nicht dabei)",
  mc_totale: "Gesamtlast", mc_uso: "{p} % der Tragkraft", mc_ok: "Sehr gut für Fotos: die Montierung arbeitet entspannt.",
  mc_medio: "Gut für Fotos, wenn Sie sorgfältig ausbalancieren und kein Wind weht; bei langen Belichtungen ist etwas Vorsicht nötig.",
  mc_visuale: "Am Limit: gut visuell und für kurze Belichtungen, für Fotos besser eine stabilere Montierung.", mc_troppo: "Zu viel Last: die Montierung trägt dieses Gewicht nicht.",
  mc_consigliate: "Montierungen aus dem Shop für diese Last beim Fotografieren", mc_cp: "{a} kg ({b} kg mit Gegengewicht)", mc_vedi: "Ansehen",
});
Object.assign(TESTI.es, {
  mc_titolo: "Carga de la montura", mc_i: "Telescopio, cámara y accesorios comparados con la capacidad de la montura: cuánto se puede cargar para fotografiar bien.",
  mc_tubo: "Tubo óptico", mc_camera: "Cámara", mc_acc: "Accesorios", mc_montatura: "Montura", mc_portata: "Capacidad", mc_stima: "estimación: corrígela con el peso real",
  mc_negozio: "de la tienda", mc_altra: "Otra montura (escribe la capacidad)", mc_scegli: "Elige la montura",
  mc_a_efw: "Rueda portafiltros", mc_a_oag: "Guía fuera de eje", mc_a_guida: "Telescopio guía + cámara", mc_a_rid: "Aplanador o reductor", mc_a_foc: "Enfocador motorizado",
  mc_a_anti: "Bandas antirrocío", mc_a_pc: "ASIAIR o mini PC", mc_a_barra: "Barra y anillas (si no vienen incluidas)",
  mc_totale: "Carga total", mc_uso: "{p} % de la capacidad", mc_ok: "Muy bien para fotografiar: la montura trabaja con holgura.",
  mc_medio: "Vale para fotografiar si equilibras con cuidado y no hay viento; con exposiciones largas hace falta algo de cautela.",
  mc_visuale: "Al límite: va bien en visual y para exposiciones cortas; para la fotografía, mejor una montura más robusta.", mc_troppo: "Demasiada carga: la montura no aguanta este peso.",
  mc_consigliate: "Monturas de la tienda adecuadas a esta carga para fotografiar", mc_cp: "{a} kg ({b} kg con contrapeso)", mc_vedi: "Ver",
});
const MC_ACCESSORI = [["efw", 0.45], ["oag", 0.15], ["guida", 0.45], ["rid", 0.35], ["foc", 0.3], ["anti", 0.15], ["pc", 0.25], ["barra", 0.6]];
function pesoTubo(tel) {
  if (!tel) return { kg: null };
  const x = tel.h ? DATI.telescopi.find(z => z.h === tel.h) : null;
  const kgNegozio = x && (x.kgTubo || (!x.completo && x.tipo !== "smart" ? x.kg : null));
  if (kgNegozio) return { kg: kgNegozio, fonte: "negozio" };
  const D = tel.D || 0, n = String(tel.nome || "");
  if (eObiettivo(tel)) return { kg: 0.9, fonte: "stima" };
  if (tel.smart) return { kg: null };
  const tipo = tipoOttica(tel);
  const kg = (tipo ? tipo === "newton" || tipo === "dobson" : /newton|riflettore|dobson/i.test(n)) ? 0.00018 * D * D + 1.5
    : (tipo ? TIPI_SPECCHIO.includes(tipo) : /\brc\b|ritchey|schmidt|cassegrain|maksutov|\bmak\b|rasa|dall|\bsc\b|edge|rcn8/i.test(n)) ? 0.00014 * D * D + 0.3
      : 0.00042 * D * D + 0.3;
  return { kg: Math.round(kg * 10) / 10, fonte: "stima" };
}
function pesoCamera(cam) {
  const c = cam && cam.id ? DATI.perCamera.get(cam.id) : null, cat = (c && c.cat) || "";
  return { raffreddata: 0.7, non_raffreddata: 0.15, planetaria_guida: 0.12, mirrorless: 0.65, reflex: 0.75, medio_formato: 0.9 }[cat] || (cam ? 0.5 : 0);
}
function cartaCarico() {
  const tubo = pesoTubo(CAMPO.tel), camKg = Math.round(pesoCamera(CAMPO.cam) * 100) / 100;
  const S = Object.assign({ tubo: tubo.kg, cam: camKg, acc: { efw: false, oag: false, guida: true, rid: true, foc: false, anti: true, pc: true, barra: false },
    mont: "", portata: null }, ricorda("carico", {}));
  const chTel = CAMPO.tel ? [CAMPO.tel.h || "", CAMPO.tel.D, CAMPO.tel.F].join("|") : "";
  const chCam = CAMPO.cam ? [CAMPO.cam.id || "", CAMPO.cam.w, CAMPO.cam.h, CAMPO.cam.px].join("|") : "";
  const aMano = (k, ch) => { const m = ricorda(k, null); return m && m.k === ch && m.kg != null ? m.kg : null; };
  const tuboMano = aMano("carico_tubo_mano", chTel), camMano = aMano("carico_cam_mano", chCam);
  S.tubo = tuboMano != null ? tuboMano : tubo.kg;
  S.cam = camMano != null ? camMano : camKg;
  const mia = ((ATTREZZI && ATTREZZI.m) || [])[0], portataSalvata = S.portata;
  let montAuto = false;
  if (!S.mont && mia) {
    if (mia.h && (DATI.montature.some(x => x.h === mia.h) || montatureNote().some(x => x.h === mia.h))) { S.mont = mia.h; montAuto = true; }
    else if (mia.kg > 0) { S.mont = "altra"; S.portata = mia.kg; montAuto = true; }
  }
  const out = el("div", { class: "gas-calc-out" });
  const salvaC = () => { salva("carico", montAuto ? Object.assign({}, S, { mont: "", portata: portataSalvata }) : S); disegna(); };
  const nota = el("small", { class: "gas-muto", hidden: tuboMano != null }, tubo.fonte === "negozio" ? t("mc_negozio") : tubo.fonte === "stima" ? t("mc_stima") : "");
  const tuboIn = campoNumero(`${t("mc_tubo")}${CAMPO.tel ? " · " + nomeCorto(nomeTel(CAMPO.tel)) : ""}`, S.tubo, v => {
    S.tubo = v != null ? v : tubo.kg; nota.hidden = v != null; salva("carico_tubo_mano", v != null ? { k: chTel, kg: v } : null); salvaC();
  }, { unita: "kg", passo: "0.1", min: 0, segnaposto: tubo.kg != null ? num(tubo.kg, 1) : "" });
  const camIn = campoNumero(`${t("mc_camera")}${CAMPO.cam ? " · " + nomeCorto(CAMPO.cam.nome) : ""}`, S.cam, v => {
    S.cam = v != null ? v : camKg; salva("carico_cam_mano", v != null ? { k: chCam, kg: v } : null); salvaC();
  }, { unita: "kg", passo: "0.05", min: 0, segnaposto: num(camKg, 2) });
  const acc = el("div", { class: "gas-bf-pezzi" }, MC_ACCESSORI.map(([k, kg]) => {
    const b = el("button", { type: "button", class: "gas-filtro-scelta" + (S.acc[k] ? " on" : ""), "aria-pressed": String(!!S.acc[k]), onclick: () => {
      S.acc[k] = !S.acc[k]; b.classList.toggle("on", S.acc[k]); b.setAttribute("aria-pressed", String(S.acc[k]));
      b.textContent = `${S.acc[k] ? "✓ " : ""}${t("mc_a_" + k)} · ${num(kg, 2)} kg`; salvaC();
    } }, `${S.acc[k] ? "✓ " : ""}${t("mc_a_" + k)} · ${num(kg, 2)} kg`);
    return b;
  }));
  const mont = DATI.montature.filter(x => montatureSenzaPacchetti().includes(x) || x.h === S.mont).sort((a, b) => a.kg_portata - b.kg_portata);
  const etMont = m => `${m.t.replace(/^(Montatura|Skywatcher Montatura|iOptron Montatura|Celestron Montatura)\s+/i, "").slice(0, 60)} · ${num(m.kg_portata, m.kg_portata % 1 ? 1 : 0)} kg`;
  const nuove = montatureNoteNuove();
  const note = montatureNote().filter(x => nuove.includes(x) || x.h === S.mont).sort((a, b) => a.t.localeCompare(b.t, LOCALE));
  const opz = m => el("option", { value: m.h, selected: m.h === S.mont }, etMont(m));
  const montSel = el("select", { class: "gas-input", "aria-label": t("mc_montatura") },
    el("option", { value: "", selected: !S.mont }, t("mc_scegli")),
    el("optgroup", { label: t("mc_del_negozio") }, mont.map(opz)),
    note.length ? el("optgroup", { label: t("mc_altre") }, note.map(opz)) : null,
    el("option", { value: "altra", selected: S.mont === "altra" }, t("mc_altra")));
  montSel.addEventListener("change", () => { montAuto = false; S.mont = montSel.value; salvaC(); });
  const portataIn = campoNumero(t("mc_portata"), S.portata, v => { montAuto = false; S.portata = v; salvaC(); }, { unita: "kg", passo: "0.5", min: 1 });
  function disegna() {
    svuota(out);
    portataIn.hidden = S.mont !== "altra";
    const accKg = MC_ACCESSORI.filter(([k]) => S.acc[k]).reduce((s, [, kg]) => s + kg, 0);
    const totale = (S.tubo || 0) + (S.cam || 0) + accKg;
    const m = DATI.montature.find(x => x.h === S.mont) || montatureNote().find(x => x.h === S.mont), portata = m ? m.kg_portata : S.mont === "altra" ? S.portata : null;
    const armonica = m && m.tipo === "armonica";
    out.appendChild(el("div", { class: "gas-righe" }, riga(t("mc_totale"), `${num(totale, 1)} kg`,
      `${t("mc_tubo")} ${num(S.tubo || 0, 1)} · ${t("mc_camera")} ${num(S.cam || 0, 2)} · ${t("mc_acc")} ${num(accKg, 2)} kg`)));
    if (portata) {
      const uso = totale / portata, limOk = armonica ? 0.7 : 0.5, limMedio = armonica ? 0.85 : 0.65;
      const cl = uso <= limOk ? "ok" : uso <= limMedio ? "poco_sotto" : "sotto";
      out.appendChild(el("div", { class: "gas-mc-barra" }, el("span", { class: "gas-mc-uso gas-mc-uso--" + cl, style: { width: Math.min(100, uso * 100) + "%" } }),
        el("i", { class: "gas-mc-lim", style: { left: limOk * 100 + "%" } }), el("i", { class: "gas-mc-lim gas-mc-lim--2", style: { left: limMedio * 100 + "%" } })));
      out.appendChild(el("div", { class: "gas-giudizio gas-giudizio--" + cl }, el("b", null, t("mc_uso", { p: num(uso * 100) })), " ",
        t(uso <= limOk ? "mc_ok" : uso <= limMedio ? "mc_medio" : uso <= 1 ? "mc_visuale" : "mc_troppo"),
        m && m.kg_portata_cp ? el("small", null, " · ", t("mc_cp", { a: num(m.kg_portata), b: num(m.kg_portata_cp) })) : null));
    }
    if (totale > 0) {
      const motorizzata = x => /goto|go-to|synscan|harmonic|armonica|\bam\d|\bcem\d|\bgem\d|\bcgx|\bcgem|\bavx|advanced vx|\beq6|\beq8|\bheq5|\beqm|\bwave|\bcq350|\beq-al55i/i.test(x.t);
      const adatte = DATI.montature.filter(x => totale <= x.kg_portata * (x.tipo === "armonica" ? 0.7 : 0.5) && x.tipo !== "altaz" && motorizzata(x))
        .sort((a, b) => a.kg_portata - b.kg_portata).slice(0, 6);
      if (adatte.length) {
        const lista = el("div", { class: "gas-mc-lista" }), tit = el("p", { class: "gas-setup-etich", hidden: true }, t("mc_consigliate"));
        out.append(tit, lista);
        Promise.all(adatte.map(x => prodotto(x.h).then(p => ({ x, p })))).then(r => {
          if (!lista.isConnected) return;
          const ok = r.filter(v => v.p && v.p.available).slice(0, 3);
          for (const { x, p } of ok) lista.appendChild(el("a", { class: "gas-mc-voce", href: urlProdotto(x.h), target: "_blank", rel: "noopener" },
            el("b", null, p.title), el("span", null, `${num(x.kg_portata, x.kg_portata % 1 ? 1 : 0)} kg · ${euro(p.price)}`)));
          if (ok.length) tit.hidden = false; else { tit.remove(); lista.remove(); }
        });
      }
    }
  }
  const box = scheda(t("mc_titolo"), el("p", { class: "gas-nota" }, t("mc_i")),
    el("div", { class: "gas-due" }, el("div", null, tuboIn, nota), camIn),
    el("small", { class: "gas-setup-etich" }, t("mc_acc")), acc,
    el("div", { class: "gas-due" }, etichetta(t("mc_montatura"), montSel), portataIn), out);
  box.classList.add("gas-mc");
  disegna();
  return box;
}
Object.assign(TESTI.it, {
  ox_i: "Quattro focali coprono quasi tutto: una per cercare e per i campi larghi, una per galassie e nebulose, una per ammassi globulari e nebulose planetarie, una per pianeti e Luna. Si calcolano dalla pupilla d'uscita.",
  ox_barilotto: "Barilotto", ox_2: "2″ e 1,25″", ox_125: "Solo 1,25″",
  ox_largo: "Campo largo: cercare, grandi nebulose, ammassi aperti", ox_deep: "Galassie e nebulose", ox_medio: "Ammassi globulari e nebulose planetarie", ox_pianeti: "Pianeti, Luna e stelle doppie",
  ox_riga: "{m}× · pupilla {p} mm", ox_negozio: "Nel negozio:", ox_nessuno: "Nessun oculare del negozio con questa focale.",
  ox_max_125: "Col barilotto da 1,25″ la focale utile più lunga è circa 32 mm (24 mm se grandangolare): oltre, il campo non si allarga.",
  ox_pianeti_n: "Oltre {m}× l'immagine non migliora: la limitano il diametro (circa 2 ingrandimenti per mm) e la turbolenza dell'aria.",
  bn_i: "Scrivi i numeri del binocolo (10x50: 10 ingrandimenti, obiettivi da 50 mm) e il campo reale in gradi, che trovi inciso sul binocolo o sulla scheda.",
  bn_m: "Ingrandimenti", bn_d: "Obiettivi", bn_campo: "Campo reale", bn_pupilla: "Pupilla d'uscita", bn_luce: "Luminosità relativa", bn_crep: "Fattore crepuscolare",
  bn_1000: "Campo a 1000 m", bn_app: "Campo apparente",
  bn_notte: "Ottimo di notte: al buio la pupilla dell'occhio arriva a 6–7 mm sotto i 40 anni, a circa 5 mm dopo i 50.", bn_ok: "Buono anche di notte.",
  bn_giorno: "Pupilla piccola: più adatto di giorno o per la Luna.", bn_treppiede: "Da {m}× in su, a mano libera le stelle ballano: meglio un treppiede.",
  bn_crep_n: "più è alto, più dettagli vedi con poca luce", bn_luce_n: "il quadrato della pupilla: 25 per un 7x35, 49 per un 7x50",
  ps_i: "La singola posa deve durare abbastanza perché il fondo cielo copra il rumore di lettura della camera; più lunga non migliora la foto e rischi stelle sature e pose buttate. Dipende dal cielo, dal filtro, dal rapporto focale e dalla camera.",
  ps_rn: "Rumore di lettura", ps_qe: "Efficienza (QE)", ps_sqm: "Cielo (SQM)", ps_filtro: "Filtro", ps_col: "Sensore",
  ps_f_nessuno: "Nessun filtro", ps_f_larga: "Anti-inquinamento a banda larga", ps_f_dual: "Dual band 7 nm", ps_f_s7: "Banda stretta 7 nm", ps_f_s3: "Banda stretta 3 nm",
  ps_consigliata: "Posa singola consigliata", ps_consigliata_n: "il fondo cielo copre il rumore di lettura (10 × RN²)", ps_minima: "Sotto questa domina il rumore",
  ps_minima_n: "3 × RN²: le pose più corte si sprecano", ps_fondo: "Fondo cielo", ps_fondo_n: "elettroni al secondo per pixel", ps_altri: "Con gli altri filtri",
  ps_breve: "Il fondo è luminoso: bastano pochi secondi. Si usano comunque pose da 10–30 s con il guadagno basso, così hai meno file.",
  ps_lunga: "Oltre 10 minuti: conviene il binning, un rapporto focale più veloce o una camera più sensibile.", ps_luogo: "Usa il cielo {l_di} (SQM {s})",
  ps_n: "Stima per una notte senza Luna. Senza autoguida resta comunque entro la posa che la tua montatura regge (spesso 30–120 s).",
  rz_i: "Su una montatura altazimutale (Dobson motorizzati, smart telescope come Seestar e Dwarf) il campo ruota durante la posa e le stelle agli angoli diventano archi. Quanto può durare la posa dipende da dove punti e da quanto è grande il sensore.",
  rz_alt: "Altezza", rz_az: "Azimut (0 = nord, 180 = sud)", rz_lat: "Latitudine", rz_w: "Sensore, pixel in larghezza", rz_h: "Sensore, pixel in altezza",
  rz_oggetto: "Cerca: M31, Orione, Giove…", rz_ora: "{o} adesso {l_da}: altezza {h}°, azimut {a}°", rz_sotto: "{o} adesso è sotto l'orizzonte {l_di}.",
  rz_vel: "Rotazione del campo", rz_vel_n: "gradi al minuto", rz_max: "Posa massima", rz_max_n: "spostamento di 1 pixel all'angolo del sensore",
  rz_zenit: "Vicino allo zenit il campo gira velocissimo: evita i 10° attorno.", rz_est: "Verso est e ovest il campo quasi non ruota: lì le pose possono essere lunghe.",
  rz_smart: "Gli smart telescope girano le pose prima di sommarle: il limite vale per la singola posa.", rz_oltre: "oltre 10 min",
  fz_i: "La zona critica di fuoco è quanto si può spostare il sensore restando a fuoco: con i rapporti focali veloci è di pochi centesimi di millimetro. Il tubo si allunga e si accorcia con la temperatura, per questo durante la notte si rifocheggia.",
  fz_tubo: "Tubo", fz_al: "Alluminio", fz_acc: "Acciaio", fz_car: "Fibra di carbonio", fz_passo: "Passo del focheggiatore motorizzato",
  fz_zona: "Zona critica di fuoco", fz_zona_n: "4,88 × λ × N², con λ = 0,55 µm (luce verde)", fz_dil: "Il tubo cambia di", fz_dil_n: "per ogni grado di temperatura",
  fz_ogni: "Rifocheggia ogni", fz_ogni_n: "con questo cambio di temperatura si esce dalla zona di fuoco", fz_passi: "Passi dentro la zona di fuoco", fz_passi_n: "ne servono almeno 5–10 per mettere a fuoco bene",
  fs_i: "Più il filtro è lontano dal sensore e più il rapporto focale è veloce, più il filtro deve essere grande per non tagliare la luce agli angoli (vignettatura).",
  fs_diag: "Diagonale del sensore", fs_dist: "Distanza filtro–sensore", fs_min: "Diametro utile minimo", fs_min_n: "diagonale + distanza ÷ rapporto focale",
  fs_ok: "va bene", fs_no: "vignetta", fs_quasi: "al limite", fs_consiglio: "Il filtro più piccolo che va bene: {m}.", fs_nessuno: "Nessuna misura basta: avvicina il filtro al sensore.",
  fs_misure: "1,25″ montato (circa 27 mm utili)|31 mm non montato|36 mm non montato|2″ montato (circa 46 mm utili)|50 mm non montato",
  fs_ruota: "Nella ruota portafiltri il filtro sta a circa 15–20 mm dal sensore, nel cassetto davanti alla camera a 25–30 mm.",
  pv_i: "Le ciambelle scure nei flat sono l'ombra di granelli di polvere: più la ciambella è grande, più la polvere è lontana dal sensore. Misura il diametro in pixel con il programma di elaborazione e scopri quale vetro pulire.",
  pv_diam: "Diametro della ciambella", pv_dist: "Distanza dal sensore", pv_dove: "Dove pulire",
  pv_sensore: "Sul vetro del sensore: serve molta cautela, meglio un laboratorio.", pv_finestra: "Sulla finestra della camera, il vetro davanti al sensore.",
  pv_filtro: "Sul filtro: nella ruota, nel cassetto o avvitato alla camera.", pv_ottica: "Sullo spianatore o sul riduttore, o ancora più lontano dal sensore.",
  pv_n: "Distanze indicative: cambiano un po' con la camera e con la catena di pezzi.",
  gd_i: "L'autoguida corregge la montatura guardando una stella: la scala della camera guida (″/px) non deve essere molto più grande di quella della camera di ripresa, altrimenti la guida non vede gli errori che si vedono nella foto.",
  gd_fguida: "Focale del cannocchiale guida", gd_pxguida: "Pixel della camera guida", gd_cerca: "Camera guida: ASI120MM, ASI220MM…",
  gd_scala_r: "Scala di ripresa", gd_scala_g: "Scala di guida", gd_rapporto: "Rapporto guida / ripresa",
  gd_ottimo: "Ottimo: la guida vede anche gli errori piccoli.", gd_buono: "Va bene: con PHD2 e una buona calibrazione si guida senza problemi.",
  gd_limite: "Al limite: meglio un cannocchiale guida più lungo o la guida fuori asse.", gd_minima: "Focale guida per stare entro 1:4", gd_troppo: "Troppo alto: la guida non vede gli errori della foto. Serve un cannocchiale guida più lungo o la guida fuori asse.",
  gd_oag: "Con la guida fuori asse", gd_oag_n: "la camera guida usa il telescopio di ripresa: rapporto 1:{r} e niente flessioni",
  gd_lunga: "Oltre i 1000 mm di focale di ripresa si usa quasi sempre la guida fuori asse.",
  sq_i: "L'SQM misura quanto è buio il cielo, in magnitudini per secondo d'arco quadrato: più è alto, più è buio. La scala di Bortle lo racconta a parole, da 1 (cielo perfetto) a 9 (centro città).",
  sq_sqm: "SQM", sq_bortle: "Bortle", sq_luogo: "Usa il cielo {l_di} (SQM {s})", sq_classe: "Classe di Bortle",
  sq_nelm: "Stelle a occhio nudo fino a", sq_nelm_n: "magnitudine limite allo zenit, con l'occhio abituato al buio", sq_lum: "Luminosità del fondo",
  sq_lum_n: "millesimi di candela per m²: il cielo naturale è circa 0,2", sq_volte: "Rispetto a un cielo perfetto", sq_volte_n: "volte più luminoso (SQM 22)",
  sq_b: "|Cielo eccellente|Cielo veramente buio|Cielo rurale|Tra campagna e periferia|Cielo di periferia|Periferia luminosa|Tra periferia e città|Cielo di città|Centro città",
  sq_d: "|La Via Lattea proietta ombre, luce zodiacale ben visibile.|Via Lattea piena di dettagli, M33 a occhio nudo.|Via Lattea ancora ricca, qualche luce all'orizzonte.|Via Lattea visibile ma piatta, cupole di luce lontane.|Via Lattea debole, sparisce verso l'orizzonte.|Via Lattea appena visibile allo zenit, cielo grigio.|Via Lattea invisibile, cielo grigio-arancio.|Solo le stelle più brillanti, M31 a fatica.|Luna, pianeti e poche stelle.",
  pl2_giove: "Giove (45″) sul sensore", pl2_saturno: "Saturno con gli anelli (43″)", pl2_px: "{n} pixel", pl2_luna: "La Luna intera (31′)",
  pl2_luna_si: "entra nel sensore", pl2_luna_no: "non entra: serve un mosaico di circa {n} pannelli",
});
Object.assign(TESTI.de, {
  ox_i: "Vier Brennweiten decken fast alles ab: eine zum Suchen und für weite Felder, eine für Galaxien und Nebel, eine für Kugelsternhaufen und planetarische Nebel, eine für Planeten und Mond. Berechnet aus der Austrittspupille.",
  ox_barilotto: "Steckhülse", ox_2: "2″ und 1,25″", ox_125: "Nur 1,25″",
  ox_largo: "Weites Feld: Suchen, große Nebel, offene Haufen", ox_deep: "Galaxien und Nebel", ox_medio: "Kugelsternhaufen und planetarische Nebel", ox_pianeti: "Planeten, Mond und Doppelsterne",
  ox_riga: "{m}× · Pupille {p} mm", ox_negozio: "Im Shop:", ox_nessuno: "Kein Okular im Shop mit dieser Brennweite.",
  ox_max_125: "Mit 1,25″ ist die längste sinnvolle Brennweite etwa 32 mm (24 mm bei Weitwinkel): darüber wird das Feld nicht größer.",
  ox_pianeti_n: "Über {m}× wird das Bild nicht besser: Es begrenzen die Öffnung (etwa 2-fach pro mm) und die Luftunruhe.",
  bn_i: "Geben Sie die Zahlen des Fernglases ein (10x50: 10-fach, Objektive 50 mm) und das wahre Feld in Grad, das auf dem Glas oder im Datenblatt steht.",
  bn_m: "Vergrößerung", bn_d: "Objektive", bn_campo: "Wahres Feld", bn_pupilla: "Austrittspupille", bn_luce: "Relative Helligkeit", bn_crep: "Dämmerungszahl",
  bn_1000: "Sehfeld auf 1000 m", bn_app: "Scheinbares Feld",
  bn_notte: "Sehr gut nachts: im Dunkeln öffnet sich die Pupille unter 40 Jahren auf 6–7 mm, nach 50 auf etwa 5 mm.", bn_ok: "Auch nachts gut.",
  bn_giorno: "Kleine Pupille: eher für den Tag oder den Mond.", bn_treppiede: "Ab {m}× zittern die Sterne freihändig: besser ein Stativ.",
  bn_crep_n: "je höher, desto mehr Details bei wenig Licht", bn_luce_n: "das Quadrat der Pupille: 25 bei 7x35, 49 bei 7x50",
  ps_i: "Die Einzelbelichtung muss lang genug sein, damit der Himmelshintergrund das Ausleserauschen überdeckt; länger macht das Bild nicht besser und riskiert gesättigte Sterne und verlorene Aufnahmen. Es hängt von Himmel, Filter, Öffnungsverhältnis und Kamera ab.",
  ps_rn: "Ausleserauschen", ps_qe: "Quanteneffizienz (QE)", ps_sqm: "Himmel (SQM)", ps_filtro: "Filter", ps_col: "Sensor",
  ps_f_nessuno: "Kein Filter", ps_f_larga: "Breitband-Lichtverschmutzungsfilter", ps_f_dual: "Dualband 7 nm", ps_f_s7: "Schmalband 7 nm", ps_f_s3: "Schmalband 3 nm",
  ps_consigliata: "Empfohlene Einzelbelichtung", ps_consigliata_n: "der Himmel überdeckt das Ausleserauschen (10 × RN²)", ps_minima: "Darunter dominiert das Rauschen",
  ps_minima_n: "3 × RN²: kürzere Belichtungen sind verschenkt", ps_fondo: "Himmelshintergrund", ps_fondo_n: "Elektronen pro Sekunde und Pixel", ps_altri: "Mit den anderen Filtern",
  ps_breve: "Heller Hintergrund: wenige Sekunden reichen. Man nimmt trotzdem 10–30 s mit niedrigem Gain, so gibt es weniger Dateien.",
  ps_lunga: "Über 10 Minuten: Binning, ein schnelleres Öffnungsverhältnis oder eine empfindlichere Kamera helfen.", ps_luogo: "Himmel {l_di} verwenden (SQM {s})",
  ps_n: "Schätzung für eine Nacht ohne Mond. Ohne Guiding bleiben Sie im Limit, das die Montierung schafft (oft 30–120 s).",
  rz_i: "Auf einer azimutalen Montierung (motorisierte Dobsons, Smart-Teleskope wie Seestar und Dwarf) dreht sich das Feld während der Belichtung, und die Sterne in den Ecken werden zu Bögen. Wie lange belichtet werden kann, hängt von der Richtung und der Sensorgröße ab.",
  rz_alt: "Höhe", rz_az: "Azimut (0 = Nord, 180 = Süd)", rz_lat: "Breitengrad", rz_w: "Sensor, Pixel in der Breite", rz_h: "Sensor, Pixel in der Höhe",
  rz_oggetto: "Suche: M31, Orion, Jupiter…", rz_ora: "{o} jetzt {l_da}: Höhe {h}°, Azimut {a}°", rz_sotto: "{o} steht jetzt unter dem Horizont {l_di}.",
  rz_vel: "Bildfelddrehung", rz_vel_n: "Grad pro Minute", rz_max: "Maximale Belichtung", rz_max_n: "1 Pixel Versatz in der Sensorecke",
  rz_zenit: "Nahe dem Zenit dreht sich das Feld sehr schnell: meiden Sie die 10° darum.", rz_est: "Im Osten und Westen dreht sich das Feld kaum: dort sind lange Belichtungen möglich.",
  rz_smart: "Smart-Teleskope drehen die Aufnahmen vor dem Stacken: die Grenze gilt für die Einzelbelichtung.", rz_oltre: "über 10 min",
  fz_i: "Die kritische Fokuszone ist, wie weit sich der Sensor bewegen darf und trotzdem scharf bleibt: bei schnellen Öffnungsverhältnissen nur wenige Hundertstelmillimeter. Der Tubus dehnt sich mit der Temperatur, deshalb wird nachts nachfokussiert.",
  fz_tubo: "Tubus", fz_al: "Aluminium", fz_acc: "Stahl", fz_car: "Kohlefaser", fz_passo: "Schrittweite des Motorfokus",
  fz_zona: "Kritische Fokuszone", fz_zona_n: "4,88 × λ × N², mit λ = 0,55 µm (grünes Licht)", fz_dil: "Der Tubus ändert sich um", fz_dil_n: "pro Grad Temperatur",
  fz_ogni: "Nachfokussieren alle", fz_ogni_n: "bei dieser Temperaturänderung verlassen Sie die Fokuszone", fz_passi: "Schritte in der Fokuszone", fz_passi_n: "mindestens 5–10 für einen guten Fokus",
  fs_i: "Je weiter der Filter vom Sensor entfernt ist und je schneller das Öffnungsverhältnis, desto größer muss der Filter sein, damit die Ecken nicht abgeschattet werden (Vignettierung).",
  fs_diag: "Sensordiagonale", fs_dist: "Abstand Filter–Sensor", fs_min: "Minimaler freier Durchmesser", fs_min_n: "Diagonale + Abstand ÷ Öffnungsverhältnis",
  fs_ok: "passt", fs_no: "vignettiert", fs_quasi: "knapp", fs_consiglio: "Der kleinste passende Filter: {m}.", fs_nessuno: "Keine Größe reicht: bringen Sie den Filter näher an den Sensor.",
  fs_misure: "1,25″ gefasst (etwa 27 mm frei)|31 mm ungefasst|36 mm ungefasst|2″ gefasst (etwa 46 mm frei)|50 mm ungefasst",
  fs_ruota: "Im Filterrad sitzt der Filter etwa 15–20 mm vor dem Sensor, in der Schublade vor der Kamera 25–30 mm.",
  pv_i: "Die dunklen Ringe in den Flats sind Schatten von Staubkörnern: je größer der Ring, desto weiter ist der Staub vom Sensor entfernt. Messen Sie den Durchmesser in Pixeln im Bearbeitungsprogramm und finden Sie heraus, welches Glas zu reinigen ist.",
  pv_diam: "Durchmesser des Rings", pv_dist: "Abstand zum Sensor", pv_dove: "Wo reinigen",
  pv_sensore: "Auf dem Sensorglas: sehr vorsichtig, besser in einer Werkstatt.", pv_finestra: "Auf dem Kamerafenster, dem Glas vor dem Sensor.",
  pv_filtro: "Auf dem Filter: im Rad, in der Schublade oder an der Kamera.", pv_ottica: "Auf Flattener oder Reducer, oder noch weiter vom Sensor entfernt.",
  pv_n: "Richtwerte: sie ändern sich etwas mit Kamera und Aufbau.",
  gd_i: "Das Autoguiding korrigiert die Montierung anhand eines Sterns: der Abbildungsmaßstab der Guidingkamera (″/px) darf nicht viel größer sein als der der Aufnahmekamera, sonst sieht das Guiding die Fehler nicht, die im Foto sichtbar sind.",
  gd_fguida: "Brennweite des Leitrohrs", gd_pxguida: "Pixel der Guidingkamera", gd_cerca: "Guidingkamera: ASI120MM, ASI220MM…",
  gd_scala_r: "Aufnahmemaßstab", gd_scala_g: "Guidingmaßstab", gd_rapporto: "Verhältnis Guiding / Aufnahme",
  gd_ottimo: "Sehr gut: das Guiding sieht auch kleine Fehler.", gd_buono: "Passt: mit PHD2 und guter Kalibrierung guiden Sie problemlos.",
  gd_limite: "Am Limit: besser ein längeres Leitrohr oder ein Off-Axis-Guider.", gd_minima: "Leitrohr-Brennweite für höchstens 1:4", gd_troppo: "Zu hoch: Das Guiding sieht die Fehler im Foto nicht. Nötig ist ein längeres Leitrohr oder ein Off-Axis-Guider.",
  gd_oag: "Mit Off-Axis-Guider", gd_oag_n: "die Guidingkamera nutzt das Aufnahmeteleskop: Verhältnis 1:{r} und keine Durchbiegung",
  gd_lunga: "Ab 1000 mm Aufnahmebrennweite nimmt man fast immer einen Off-Axis-Guider.",
  sq_i: "Das SQM misst, wie dunkel der Himmel ist, in Magnituden pro Quadratbogensekunde: je höher, desto dunkler. Die Bortle-Skala beschreibt es in Worten, von 1 (perfekter Himmel) bis 9 (Stadtzentrum).",
  sq_sqm: "SQM", sq_bortle: "Bortle", sq_luogo: "Himmel {l_di} verwenden (SQM {s})", sq_classe: "Bortle-Klasse",
  sq_nelm: "Sterne mit bloßem Auge bis", sq_nelm_n: "Grenzgröße im Zenit, mit dunkeladaptiertem Auge", sq_lum: "Helligkeit des Hintergrunds",
  sq_lum_n: "Millicandela pro m²: der natürliche Himmel liegt bei etwa 0,2", sq_volte: "Im Vergleich zu einem perfekten Himmel", sq_volte_n: "mal heller (SQM 22)",
  sq_b: "|Exzellenter Himmel|Wirklich dunkler Himmel|Ländlicher Himmel|Zwischen Land und Vorort|Vorstadthimmel|Heller Vorstadthimmel|Zwischen Vorort und Stadt|Stadthimmel|Stadtzentrum",
  sq_d: "|Die Milchstraße wirft Schatten, Zodiakallicht gut sichtbar.|Milchstraße voller Details, M33 mit bloßem Auge.|Milchstraße noch reich, etwas Licht am Horizont.|Milchstraße sichtbar, aber flach, entfernte Lichtglocken.|Milchstraße schwach, verschwindet zum Horizont hin.|Milchstraße im Zenit gerade noch sichtbar, grauer Himmel.|Milchstraße unsichtbar, grau-oranger Himmel.|Nur die hellsten Sterne, M31 mit Mühe.|Mond, Planeten und wenige Sterne.",
  pl2_giove: "Jupiter (45″) auf dem Sensor", pl2_saturno: "Saturn mit Ringen (43″)", pl2_px: "{n} Pixel", pl2_luna: "Der ganze Mond (31′)",
  pl2_luna_si: "passt auf den Sensor", pl2_luna_no: "passt nicht: ein Mosaik aus etwa {n} Feldern nötig",
});
Object.assign(TESTI.es, {
  ox_i: "Cuatro focales cubren casi todo: una para buscar y campos amplios, una para galaxias y nebulosas, una para cúmulos globulares y nebulosas planetarias, una para planetas y Luna. Se calculan a partir de la pupila de salida.",
  ox_barilotto: "Barrilete", ox_2: "2″ y 1,25″", ox_125: "Solo 1,25″",
  ox_largo: "Campo amplio: buscar, grandes nebulosas, cúmulos abiertos", ox_deep: "Galaxias y nebulosas", ox_medio: "Cúmulos globulares y nebulosas planetarias", ox_pianeti: "Planetas, Luna y estrellas dobles",
  ox_riga: "{m}× · pupila {p} mm", ox_negozio: "En la tienda:", ox_nessuno: "Ningún ocular de la tienda con esta focal.",
  ox_max_125: "Con barrilete de 1,25″ la focal útil más larga es de unos 32 mm (24 mm si es gran angular): más allá el campo no crece.",
  ox_pianeti_n: "Por encima de {m}× la imagen no mejora: la limitan el diámetro (unos 2 aumentos por mm) y la turbulencia del aire.",
  bn_i: "Escribe los números de los prismáticos (10x50: 10 aumentos, objetivos de 50 mm) y el campo real en grados, que viene grabado en los prismáticos o en la ficha.",
  bn_m: "Aumentos", bn_d: "Objetivos", bn_campo: "Campo real", bn_pupilla: "Pupila de salida", bn_luce: "Luminosidad relativa", bn_crep: "Factor crepuscular",
  bn_1000: "Campo a 1000 m", bn_app: "Campo aparente",
  bn_notte: "Muy buenos de noche: en la oscuridad la pupila del ojo llega a 6–7 mm antes de los 40 años, a unos 5 mm después de los 50.", bn_ok: "Buenos también de noche.",
  bn_giorno: "Pupila pequeña: más adecuados para el día o para la Luna.", bn_treppiede: "Desde {m}× a pulso las estrellas tiemblan: mejor un trípode.",
  bn_crep_n: "cuanto más alto, más detalles con poca luz", bn_luce_n: "el cuadrado de la pupila: 25 para unos 7x35, 49 para unos 7x50",
  ps_i: "Cada toma debe durar lo suficiente para que el fondo del cielo cubra el ruido de lectura de la cámara; si es más larga, no mejora la foto y te arriesgas a tener estrellas saturadas y tomas perdidas. Depende del cielo, del filtro, de la relación focal y de la cámara.",
  ps_rn: "Ruido de lectura", ps_qe: "Eficiencia (QE)", ps_sqm: "Cielo (SQM)", ps_filtro: "Filtro", ps_col: "Sensor",
  ps_f_nessuno: "Sin filtro", ps_f_larga: "Antipolución de banda ancha", ps_f_dual: "Dual band 7 nm", ps_f_s7: "Banda estrecha 7 nm", ps_f_s3: "Banda estrecha 3 nm",
  ps_consigliata: "Toma individual recomendada", ps_consigliata_n: "el fondo del cielo cubre el ruido de lectura (10 × RN²)", ps_minima: "Por debajo domina el ruido",
  ps_minima_n: "3 × RN²: las tomas más cortas se desperdician", ps_fondo: "Fondo del cielo", ps_fondo_n: "electrones por segundo y píxel", ps_altri: "Con los otros filtros",
  ps_breve: "El fondo es brillante: bastan pocos segundos. Aun así se usan tomas de 10–30 s con ganancia baja, para tener menos archivos.",
  ps_lunga: "Más de 10 minutos: conviene el binning, una relación focal más rápida o una cámara más sensible.", ps_luogo: "Usar el cielo {l_di} (SQM {s})",
  ps_n: "Estimación para una noche sin Luna. Sin autoguiado, no superes la exposición que aguanta tu montura (a menudo 30–120 s).",
  rz_i: "En una montura altacimutal (Dobson motorizados, smart telescopes como Seestar y Dwarf) el campo gira durante la exposición y las estrellas de las esquinas se vuelven arcos. Cuánto puede durar la toma depende de hacia dónde apuntas y del tamaño del sensor.",
  rz_alt: "Altura", rz_az: "Acimut (0 = norte, 180 = sur)", rz_lat: "Latitud", rz_w: "Sensor, píxeles de ancho", rz_h: "Sensor, píxeles de alto",
  rz_oggetto: "Busca: M31, Orión, Júpiter…", rz_ora: "{o} ahora {l_da}: altura {h}°, acimut {a}°", rz_sotto: "{o} ahora está bajo el horizonte {l_di}.",
  rz_vel: "Rotación de campo", rz_vel_n: "grados por minuto", rz_max: "Exposición máxima", rz_max_n: "desplazamiento de 1 píxel en la esquina del sensor",
  rz_zenit: "Cerca del cénit el campo gira muy rápido: evita la zona de 10° a su alrededor.", rz_est: "Hacia el este y el oeste el campo casi no gira: ahí las tomas pueden ser largas.",
  rz_smart: "Los smart telescopes giran las tomas antes de apilarlas: el límite vale para cada toma.", rz_oltre: "más de 10 min",
  fz_i: "La zona crítica de enfoque es cuánto puede moverse el sensor sin desenfocar: con relaciones focales rápidas son pocas centésimas de milímetro. El tubo se alarga y se acorta con la temperatura, por eso se reenfoca durante la noche.",
  fz_tubo: "Tubo", fz_al: "Aluminio", fz_acc: "Acero", fz_car: "Fibra de carbono", fz_passo: "Paso del enfocador motorizado",
  fz_zona: "Zona crítica de enfoque", fz_zona_n: "4,88 × λ × N², con λ = 0,55 µm (luz verde)", fz_dil: "El tubo cambia", fz_dil_n: "por cada grado de temperatura",
  fz_ogni: "Reenfoca cada", fz_ogni_n: "con este cambio de temperatura sales de la zona de enfoque", fz_passi: "Pasos dentro de la zona de enfoque", fz_passi_n: "hacen falta al menos 5–10 para enfocar bien",
  fs_i: "Cuanto más lejos está el filtro del sensor y más rápida la relación focal, más grande debe ser el filtro para no recortar la luz de las esquinas (viñeteo).",
  fs_diag: "Diagonal del sensor", fs_dist: "Distancia filtro–sensor", fs_min: "Diámetro útil mínimo", fs_min_n: "diagonal + distancia ÷ relación focal",
  fs_ok: "vale", fs_no: "viñetea", fs_quasi: "justo", fs_consiglio: "El filtro más pequeño que vale: {m}.", fs_nessuno: "Ninguna medida basta: acerca el filtro al sensor.",
  fs_misure: "1,25″ montado (unos 27 mm útiles)|31 mm sin montar|36 mm sin montar|2″ montado (unos 46 mm útiles)|50 mm sin montar",
  fs_ruota: "En la rueda portafiltros el filtro queda a unos 15–20 mm del sensor, en el cajón delante de la cámara a 25–30 mm.",
  pv_i: "Los anillos oscuros de los flats son la sombra de motas de polvo: cuanto más grande el anillo, más lejos está el polvo del sensor. Mide el diámetro en píxeles con el programa de procesado y descubre qué cristal limpiar.",
  pv_diam: "Diámetro del anillo", pv_dist: "Distancia al sensor", pv_dove: "Dónde limpiar",
  pv_sensore: "En el cristal del sensor: con mucho cuidado, mejor en un taller.", pv_finestra: "En la ventana de la cámara, el cristal delante del sensor.",
  pv_filtro: "En el filtro: en la rueda, en el cajón o roscado a la cámara.", pv_ottica: "En el aplanador o el reductor, o aún más lejos del sensor.",
  pv_n: "Distancias orientativas: cambian algo con la cámara y la cadena de piezas.",
  gd_i: "El autoguiado corrige la montura mirando una estrella: la escala de la cámara guía (″/px) no debe ser mucho mayor que la de la cámara de captura, si no la guía no ve los errores que se ven en la foto.",
  gd_fguida: "Focal del telescopio guía", gd_pxguida: "Píxel de la cámara guía", gd_cerca: "Cámara guía: ASI120MM, ASI220MM…",
  gd_scala_r: "Escala de captura", gd_scala_g: "Escala de guiado", gd_rapporto: "Relación guía / captura",
  gd_ottimo: "Muy bien: la guía ve incluso los errores pequeños.", gd_buono: "Vale: con PHD2 y una buena calibración se guía sin problemas.",
  gd_limite: "Al límite: mejor un telescopio guía más largo o una guía fuera de eje.", gd_minima: "Focal guía para quedar dentro de 1:4", gd_troppo: "Demasiado alto: la guía no ve los errores de la foto. Hace falta un telescopio guía más largo o una guía fuera de eje.",
  gd_oag: "Con guía fuera de eje", gd_oag_n: "la cámara guía usa el telescopio de captura: relación 1:{r} y sin flexiones",
  gd_lunga: "Por encima de 1000 mm de focal de captura se usa casi siempre la guía fuera de eje.",
  sq_i: "El SQM mide lo oscuro que es el cielo, en magnitudes por segundo de arco cuadrado: cuanto más alto, más oscuro. La escala de Bortle lo describe con palabras, de 1 (cielo perfecto) a 9 (centro de la ciudad).",
  sq_sqm: "SQM", sq_bortle: "Bortle", sq_luogo: "Usar el cielo {l_di} (SQM {s})", sq_classe: "Clase de Bortle",
  sq_nelm: "Estrellas a simple vista hasta", sq_nelm_n: "magnitud límite en el cénit, con el ojo adaptado a la oscuridad", sq_lum: "Brillo del fondo",
  sq_lum_n: "milésimas de candela por m²: el cielo natural ronda 0,2", sq_volte: "Frente a un cielo perfecto", sq_volte_n: "veces más brillante (SQM 22)",
  sq_b: "|Cielo excelente|Cielo realmente oscuro|Cielo rural|Entre campo y periferia|Cielo de periferia|Periferia luminosa|Entre periferia y ciudad|Cielo de ciudad|Centro de la ciudad",
  sq_d: "|La Vía Láctea proyecta sombras, luz zodiacal bien visible.|Vía Láctea llena de detalles, M33 a simple vista.|Vía Láctea aún rica, algo de luz en el horizonte.|Vía Láctea visible pero plana, cúpulas de luz lejanas.|Vía Láctea débil, desaparece hacia el horizonte.|Vía Láctea apenas visible en el cénit, cielo gris.|Vía Láctea invisible, cielo gris anaranjado.|Solo las estrellas más brillantes, M31 con esfuerzo.|Luna, planetas y pocas estrellas.",
  pl2_giove: "Júpiter (45″) en el sensor", pl2_saturno: "Saturno con los anillos (43″)", pl2_px: "{n} píxeles", pl2_luna: "La Luna entera (31′)",
  pl2_luna_si: "cabe en el sensor", pl2_luna_no: "no cabe: hace falta un mosaico de unos {n} paneles",
});
for (const [k, v] of Object.entries({ ocMis: "2", bM: 10, bD: 50, bC: 6.5, psRn: 1.5, psQe: 0.8, psCol: "colore", psFil: "nessuno", psSqm: null,
  rAlt: 50, rAz: 180, rLat: null, rW: 1920, rH: 1080, fzTubo: "al", fzPasso: null, fsDiag: 28.3, fsDist: 18, pvD: 120, gdF: 120, gdPx: 3.75, sqSqm: null })) {
  if (CALC[k] === undefined) CALC[k] = v;
}
const sqmLuogo = () => NOTTE.sqmMisurato || (NOTTE.bortleAuto === false ? null : NOTTE.sqmStima) || SQM_DA_BORTLE[NOTTE.bortle || 5];
function secondiLeggibili(s) {
  if (!isFinite(s)) return "–";
  if (s < 59.5) return `${num(s, s < 9.95 ? 1 : 0)} s`;
  const tot = Math.round(s);
  if (tot < 3600) { const m = Math.floor(tot / 60), r = tot % 60; return r ? `${m} min ${String(r).padStart(2, "0")} s` : `${m} min`; }
  return durata(tot / 3600);
}
function cxOculari(H) {
  H.carta(t("xn_oculari"), t("ox_i"), [H.cercaTel(), H.telScelto()],
    [H.campo("D", t("diametro"), { unita: "mm" }), H.campo("F", t("focale"), { unita: "mm" }),
      etichetta(t("ox_barilotto"), H.scelta("ocMis", [["2", t("ox_2")], ["1.25", t("ox_125")]]))], () => {
    const { D, F } = CALC, solo125 = String(CALC.ocMis) === "1.25";
    if (!D || !F) return null;
    const N = F / D, Mmax = Math.min(2 * D, 350), out = [];
    for (const [ruolo, pupilla] of [["largo", 5.5], ["deep", 3], ["medio", 1.8], ["pianeti", 1]]) {
      let f = pupilla * N;
      if (ruolo === "largo") f = Math.min(f, solo125 ? 32 : 40);
      if (ruolo === "pianeti") f = Math.max(f, F / Mmax);
      const M = F / f;
      const simili = DATI.oculari.filter(x => x.f >= f * 0.8 && x.f <= f * 1.25 && !(solo125 && x.bar === "2"))
        .sort((a, b) => Math.abs(a.f - f) - Math.abs(b.f - f) || (b.afov || 0) - (a.afov || 0)).slice(0, 3);
      out.push(el("div", { class: "gas-ox" },
        el("div", { class: "gas-ox-testa" }, el("b", null, `${num(f, f < 10 ? 1 : 0)} mm`), el("span", null, t("ox_" + ruolo))),
        el("small", { class: "gas-muto" }, t("ox_riga", { m: num(M), p: num(D / M, 1) })),
        simili.length ? el("div", { class: "gas-ox-negozio" }, el("small", null, t("ox_negozio")),
          simili.map(x => el("a", { href: urlProdotto(x.h), target: "_blank", rel: "noopener" }, x.t, el("i", null, ` · ${num(x.f, x.f % 1 ? 1 : 0)} mm · ${num(x.afov)}°`))))
          : el("small", { class: "gas-muto" }, t("ox_nessuno"))));
    }
    out.push(el("p", { class: "gas-nota" }, t("ox_pianeti_n", { m: num(Mmax) })));
    if (solo125) out.push(el("p", { class: "gas-nota" }, t("ox_max_125")));
    return out;
  });
}
function cxBinocolo(H) {
  H.carta(t("xn_binocolo"), t("bn_i"), null,
    [H.campo("bM", t("bn_m"), { unita: "×" }), H.campo("bD", t("bn_d"), { unita: "mm" }), H.campo("bC", t("bn_campo"), { unita: "°", passo: "0.1" })], () => {
    const { bM: M, bD: D, bC: C } = CALC;
    if (!M || !D) return null;
    const p = D / M, out = [
      riga(t("bn_pupilla"), `${num(p, 1)} mm`, p >= 5 ? t("bn_notte") : p >= 3.5 ? t("bn_ok") : t("bn_giorno"), p >= 5 ? "gas-riga--ok" : p >= 3.5 ? "" : "gas-riga--poco_sotto"),
      riga(t("bn_luce"), num(p * p), t("bn_luce_n")),
      riga(t("bn_crep"), num(Math.sqrt(M * D), 1), t("bn_crep_n"))];
    if (C) {
      out.push(riga(t("bn_1000"), `${num(2000 * Math.tan(C / 2 * RAD))} m`));
      out.push(riga(t("bn_app"), `${num(2 * Math.atan(M * Math.tan(C / 2 * RAD)) * DEG)}°`));
    }
    if (M >= 12) out.push(el("p", { class: "gas-nota" }, t("bn_treppiede", { m: num(12) })));
    return out;
  });
}
const PS_FILTRI = [["nessuno", 1], ["larga", 0.6], ["dual", 14 / 300], ["s7", 7 / 300], ["s3", 3 / 300]];
function cxPosa(H) {
  if (CALC.psSqm == null) CALC.psSqm = Math.round(sqmLuogo() * 10) / 10;
  const camScelta = CALC.scelte.cam;
  if (camScelta && camScelta.id && camScelta.id !== CALC.psCamId) {
    const d = datiCameraPosa({ id: camScelta.id });
    CALC.psRn = d.rn; CALC.psQe = d.qe; CALC.psCol = d.colore ? "colore" : "mono"; CALC.psCamId = camScelta.id;
  }
  const usaCam = c => {
    const d = datiCameraPosa({ id: c.id });
    CALC.px = c.px; CALC.psRn = d.rn; CALC.psQe = d.qe; CALC.psCol = c.col === "mono" ? "mono" : "colore"; CALC.psCamId = c.id;
    CALC.scelte.cam = { nome: c.nome, px: c.px, h: c.h_negozio, id: c.id };
  };
  const luogo = el("button", { type: "button", class: "gas-btn gas-btn--chiaro gas-btn--mini", onclick: () => { CALC.psSqm = Math.round(sqmLuogo() * 10) / 10; H.ridisegna(); } },
    "◎ ", t("ps_luogo", Object.assign(luogoFrasi(), { s: num(sqmLuogo(), 1) })));
  H.carta(t("xn_posa"), t("ps_i"), [H.cercaTel(), H.telScelto(), H.cercaCam(usaCam), H.scelto("cam", s => s.px === CALC.px, H.pxCam), luogo],
    [H.campo("D", t("diametro"), { unita: "mm" }), H.campo("F", t("focale"), { unita: "mm" }),
      etichetta(t("riduttore_barlow"), H.scelta("k", FATTORI.map(f => [f, f === 1 ? t("nessuno") : `${num(f, 2)}×`]))),
      H.campo("px", t("pixel"), { unita: "µm", passo: "0.01" }), H.campo("psRn", t("ps_rn"), { unita: "e⁻", passo: "0.1" }),
      H.campo("psQe", t("ps_qe"), { passo: "0.05", min: 0.1, max: 1 }),
      etichetta(t("ps_col"), H.scelta("psCol", [["colore", t("colore")], ["mono", t("mono")]])),
      H.campo("psSqm", t("ps_sqm"), { passo: "0.1", min: 16, max: 22.5 }),
      etichetta(t("ps_filtro"), H.scelta("psFil", PS_FILTRI.map(([k]) => [k, t("ps_f_" + k)])))], () => {
    const { D, F, px, psRn: rn, psQe: qe, psCol, psSqm: sqm } = CALC, k = CALC.k || 1;
    if (!D || !F || !px || !rn || !qe || !sqm) return null;
    const scala = 206.265 * px / (F * k), A = areaUtile(CALC.scelte.tel || null, D), eff = qe * (psCol === "mono" ? 0.85 : 0.33);
    const fondo = r => FOTONI_0 * Math.pow(10, -0.4 * sqm) * A * scala * scala * eff * r;
    const r0 = (PS_FILTRI.find(([kk]) => kk === CALC.psFil) || PS_FILTRI[0])[1], B = fondo(r0);
    const tSub = 10 * rn * rn / B, tMin = 3 * rn * rn / B;
    const out = [riga(t("ps_consigliata"), `≈ ${secondiLeggibili(tSub)}`, t("ps_consigliata_n"), "gas-riga--ok"),
      riga(t("ps_minima"), secondiLeggibili(tMin), t("ps_minima_n")),
      riga(t("ps_fondo"), `${num(B, B < 1 ? 2 : 1)} e⁻/s`, t("ps_fondo_n")),
      riga(t("scala"), `${num(scala, 2)}″/px · f/${num(F * k / D, 1)}`)];
    if (tSub < 10) out.push(el("p", { class: "gas-nota" }, t("ps_breve")));
    if (tSub > 600) out.push(el("p", { class: "gas-nota" }, t("ps_lunga")));
    if (senzaInseguimento(CALC.scelte.tel)) out.unshift(el("p", { class: "gas-giudizio gas-giudizio--poco_sotto" }, t("dob_tp")));
    out.push(el("small", { class: "gas-setup-etich" }, t("ps_altri")),
      el("div", { class: "gas-righe" }, PS_FILTRI.filter(([kk]) => kk !== CALC.psFil).map(([kk, r]) => riga(t("ps_f_" + kk), `≈ ${secondiLeggibili(10 * rn * rn / fondo(r))}`))),
      el("p", { class: "gas-nota" }, t("ps_n")));
    return out;
  });
}
let RZ_NOTA = "";
function cxRotazione(H) {
  if (CALC.rLat == null) CALC.rLat = Math.round(NOTTE.luogo.lat * 10) / 10;
  const nota = el("p", { class: "gas-nota" });
  const cercaOgg = creaCerca({
    segnaposto: t("rz_oggetto"),
    cerca: q => cercaOggetti(q, 20).filter(o => isFinite(o.ra) && isFinite(o.dec)),
    riga: (o, q) => ({ titolo: titoloCercato(o, q), sotto: nomeOggetto(o) || "" }),
    scegli: o => {
      const { lat, lon, nome } = NOTTE.luogo, lst = Astro.n360(Astro.gmst(Astro.jd(new Date())) + lon), [h, a] = Astro.altAz(o.ra, o.dec, lat, lst);
      CALC.rLat = Math.round(lat * 10) / 10;
      RZ_NOTA = h > 0 ? t("rz_ora", Object.assign(luogoFrasi(), { o: titoloOggetto(o).split(" – ")[0], h: num(h), a: num(a) })) : t("rz_sotto", Object.assign(luogoFrasi(), { o: titoloOggetto(o).split(" – ")[0] }));
      if (h > 0) { CALC.rAlt = Math.round(h); CALC.rAz = Math.round(a); }
      H.ridisegna();
    },
  }).box;
  if (RZ_NOTA) nota.textContent = RZ_NOTA; else nota.hidden = true;
  const usaCam = c => { if (c.w && c.h) { CALC.rW = c.w; CALC.rH = c.h; CALC.scelte.camR = { nome: c.nome, w: c.w, sh: c.h, h: c.h_negozio }; } };
  H.carta(t("xn_rotazione"), t("rz_i"), [cercaOgg, nota, H.cercaCam(usaCam), H.scelto("camR", s => s.w === CALC.rW && s.sh === CALC.rH, s => `${num(s.w)} × ${num(s.sh)} px`)],
    [H.campo("rAlt", t("rz_alt"), { unita: "°", min: 0, max: 90 }), H.campo("rAz", t("rz_az"), { unita: "°", min: 0, max: 360 }),
      H.campo("rLat", t("rz_lat"), { unita: "°", min: -90, max: 90, passo: "0.1" }),
      H.campo("rW", t("rz_w"), { unita: "px" }), H.campo("rH", t("rz_h"), { unita: "px" })], () => {
    const { rAlt: h, rAz: a, rLat: lat, rW: w, rH: hh } = CALC;
    if (h == null || a == null || lat == null || !w || !hh) return null;
    const om = 0.0041781 * Math.cos(lat * RAD) * Math.cos(a * RAD) / Math.max(0.01, Math.cos(Math.min(h, 89.5) * RAD));
    const r = Math.hypot(w, hh) / 2, tMax = 1 / (r * Math.abs(om) * RAD);
    const out = [riga(t("rz_vel"), `${num(Math.abs(om) * 60, Math.abs(om) * 60 < 0.1 ? 3 : 2)}°/min`, t("rz_vel_n")),
      riga(t("rz_max"), tMax > 600 ? t("rz_oltre") : secondiLeggibili(tMax), t("rz_max_n"), tMax >= 30 ? "gas-riga--ok" : tMax >= 10 ? "gas-riga--poco_sotto" : "gas-riga--sotto")];
    if (h > 75) out.push(el("p", { class: "gas-nota" }, t("rz_zenit")));
    else if (Math.abs(Math.cos(a * RAD)) < 0.35) out.push(el("p", { class: "gas-nota" }, t("rz_est")));
    out.push(el("p", { class: "gas-nota" }, t("rz_smart")));
    return out;
  });
}
const FZ_ALFA = { al: 23.1, acc: 12, car: 0.5 };
function cxCfz(H) {
  H.carta(t("xn_cfz"), t("fz_i"), [H.cercaTel(), H.telScelto()],
    [H.campo("D", t("diametro"), { unita: "mm" }), H.campo("F", t("focale"), { unita: "mm" }),
      etichetta(t("riduttore_barlow"), H.scelta("k", FATTORI.map(f => [f, f === 1 ? t("nessuno") : `${num(f, 2)}×`]))),
      etichetta(t("fz_tubo"), H.scelta("fzTubo", [["al", t("fz_al")], ["acc", t("fz_acc")], ["car", t("fz_car")]])),
      H.campo("fzPasso", t("fz_passo"), { unita: "µm", passo: "0.1", facoltativo: true })], () => {
    const { D, F } = CALC, k = CALC.k || 1;
    if (!D || !F) return null;
    const N = F * k / D, zona = 4.88 * 0.55 * N * N, dil = FZ_ALFA[CALC.fzTubo || "al"] * F / 1000;
    const out = [riga(`${t("fz_zona")} · f/${num(N, 1)}`, `${num(zona)} µm (± ${num(zona / 2)} µm)`, t("fz_zona_n")),
      riga(t("fz_dil"), `${num(dil, 1)} µm`, t("fz_dil_n"))];
    const ogni = zona / 2 / Math.max(dil, 0.01);
    out.push(riga(t("fz_ogni"), ogni > 30 ? "> 30 °C" : `${num(ogni, ogni < 3 ? 1 : 0)} °C`, t("fz_ogni_n"), ogni >= 3 ? "gas-riga--ok" : ogni >= 1 ? "gas-riga--poco_sotto" : "gas-riga--sotto"));
    if (CALC.fzPasso) {
      const n = zona / CALC.fzPasso;
      out.push(riga(t("fz_passi"), num(n), t("fz_passi_n"), n >= 5 ? "gas-riga--ok" : "gas-riga--sotto"));
    }
    return out;
  });
}
const FS_MISURE = [27, 31, 36, 46, 50];
function cxFiltri(H) {
  const usaCam = c => {
    const mm = c.mm ? Math.hypot(c.mm[0], c.mm[1]) : c.w && c.h && c.px ? Math.hypot(c.w, c.h) * c.px / 1000 : null;
    if (mm) { CALC.fsDiag = Math.round(mm * 10) / 10; CALC.scelte.camF = { nome: c.nome, d: CALC.fsDiag, h: c.h_negozio }; }
  };
  H.carta(t("xn_filtri"), t("fs_i"), [H.cercaCam(usaCam), H.scelto("camF", s => s.d === CALC.fsDiag, s => `${num(s.d, 1)} mm`), H.cercaTel(), H.telScelto()],
    [H.campo("fsDiag", t("fs_diag"), { unita: "mm", passo: "0.1" }), H.campo("fsDist", t("fs_dist"), { unita: "mm" }),
      H.campo("D", t("diametro"), { unita: "mm" }), H.campo("F", t("focale"), { unita: "mm" }),
      etichetta(t("riduttore_barlow"), H.scelta("k", FATTORI.map(f => [f, f === 1 ? t("nessuno") : `${num(f, 2)}×`])))], () => {
    const { fsDiag, fsDist, D, F } = CALC, k = CALC.k || 1;
    if (!fsDiag || fsDist == null || !D || !F) return null;
    const N = F * k / D, min = fsDiag + fsDist / N, nomi = t("fs_misure").split("|");
    const ok = FS_MISURE.findIndex(m => m >= min);
    const out = [riga(`${t("fs_min")} · f/${num(N, 1)}`, `${num(min, 1)} mm`, t("fs_min_n")),
      el("div", { class: "gas-righe" }, FS_MISURE.map((m, i) => {
        const stato = m >= min ? "ok" : m >= min - 1.5 ? "quasi" : "no";
        return riga(nomi[i], t("fs_" + stato), null, stato === "ok" ? "gas-riga--ok gas-fs-ok" : stato === "quasi" ? "gas-riga--poco_sotto gas-fs-quasi" : "gas-riga--sotto gas-fs-no");
      })),
      el("p", { class: "gas-nota" }, ok >= 0 ? t("fs_consiglio", { m: nomi[ok] }) : t("fs_nessuno")),
      el("p", { class: "gas-nota" }, t("fs_ruota"))];
    return out;
  });
}
function cxPolvere(H) {
  const usaCam = c => { CALC.px = c.px; CALC.scelte.cam = { nome: c.nome, px: c.px, h: c.h_negozio, id: c.id }; };
  H.carta(t("xn_polvere"), t("pv_i"), [H.cercaCam(usaCam), H.scelto("cam", s => s.px === CALC.px, H.pxCam), H.cercaTel(), H.telScelto()],
    [H.campo("pvD", t("pv_diam"), { unita: "px" }), H.campo("px", t("pixel"), { unita: "µm", passo: "0.01" }),
      H.campo("D", t("diametro"), { unita: "mm" }), H.campo("F", t("focale"), { unita: "mm" }),
      etichetta(t("riduttore_barlow"), H.scelta("k", FATTORI.map(f => [f, f === 1 ? t("nessuno") : `${num(f, 2)}×`])))], () => {
    const { pvD, px, D, F } = CALC, k = CALC.k || 1;
    if (!pvD || !px || !D || !F) return null;
    const N = F * k / D, d = pvD * px / 1000 * N;
    const dove = d < 3 ? "sensore" : d < 12 ? "finestra" : d < 40 ? "filtro" : "ottica";
    return [riga(`${t("pv_dist")} · f/${num(N, 1)}`, `${num(d, d < 10 ? 1 : 0)} mm`),
      riga(t("pv_dove"), "", t("pv_" + dove), "gas-riga--ok"), el("p", { class: "gas-nota" }, t("pv_n"))];
  });
}
function cxGuida(H) {
  const usaGuida = c => { CALC.gdPx = c.px; CALC.scelte.camG = { nome: c.nome, px: c.px, h: c.h_negozio }; };
  const usaRipresa = c => { CALC.px = c.px; CALC.scelte.cam = { nome: c.nome, px: c.px, h: c.h_negozio, id: c.id }; };
  H.carta(t("xn_guida"), t("gd_i"), [H.cercaTel(), H.telScelto(), H.cercaCam(usaRipresa), H.scelto("cam", s => s.px === CALC.px, H.pxCam),
    H.cercaCam(usaGuida, t("gd_cerca")), H.scelto("camG", s => s.px === CALC.gdPx, H.pxCam)],
  [H.campo("F", t("focale_telescopio"), { unita: "mm" }), etichetta(t("riduttore_barlow"), H.scelta("k", FATTORI.map(f => [f, f === 1 ? t("nessuno") : `${num(f, 2)}×`]))),
    H.campo("px", t("pixel"), { unita: "µm", passo: "0.01" }), H.campo("gdF", t("gd_fguida"), { unita: "mm" }), H.campo("gdPx", t("gd_pxguida"), { unita: "µm", passo: "0.01" })], () => {
    const { F, px, gdF, gdPx } = CALC, k = CALC.k || 1;
    if (!F || !px || !gdF || !gdPx) return null;
    const sr = 206.265 * px / (F * k), sg = 206.265 * gdPx / gdF, r = sg / sr;
    const out = [riga(t("gd_scala_r"), `${num(sr, 2)}″/px`), riga(t("gd_scala_g"), `${num(sg, 2)}″/px`),
      riga(t("gd_rapporto"), `1 : ${num(r, 1)}`, r <= 3 ? t("gd_ottimo") : r <= 5 ? t("gd_buono") : r <= 8 ? t("gd_limite") : t("gd_troppo"),
        r <= 3 ? "gas-riga--ok" : r <= 5 ? "gas-riga--poco_sotto" : "gas-riga--sotto")];
    if (r > 4) out.push(riga(t("gd_minima"), `${num(206.265 * gdPx / (4 * sr))} mm`));
    out.push(riga(t("gd_oag"), `${num(206.265 * gdPx / (F * k), 2)}″/px`, t("gd_oag_n", { r: num(gdPx / px, 1) })));
    if (F * k > 1000) out.push(el("p", { class: "gas-nota" }, t("gd_lunga")));
    return out;
  });
}
function cxCielo(H) {
  if (CALC.sqSqm == null) CALC.sqSqm = Math.round(sqmLuogo() * 10) / 10;
  const bortle = selezione([["", "–"], ...[1, 2, 3, 4, 5, 6, 7, 8, 9].map(b => [b, `${b} · ${t("sq_b").split("|")[b]}`])], bortleDaSqm(CALC.sqSqm),
    v => { if (v) { CALC.sqSqm = SQM_DA_BORTLE[+v]; H.ridisegna(); } });
  const luogo = el("button", { type: "button", class: "gas-btn gas-btn--chiaro gas-btn--mini", onclick: () => { CALC.sqSqm = Math.round(sqmLuogo() * 10) / 10; H.ridisegna(); } },
    "◎ ", t("sq_luogo", Object.assign(luogoFrasi(), { s: num(sqmLuogo(), 1) })));
  H.carta(t("xn_cielo"), t("sq_i"), [luogo], [H.campo("sqSqm", t("sq_sqm"), { unita: "mag/″²", passo: "0.1", min: 15, max: 22.5 }), etichetta(t("sq_bortle"), bortle)], () => {
    const q = CALC.sqSqm;
    if (!q) return null;
    const b = bortleDaSqm(q), nelm = 7.93 - 5 * Math.log10(Math.pow(10, 4.316 - q / 5) + 1), lum = 10.8e4 * Math.pow(10, -0.4 * q) * 1000;
    bortle.value = String(b);
    return [riga(t("sq_classe"), `${b} · ${t("sq_b").split("|")[b]}`, t("sq_d").split("|")[b], b <= 3 ? "gas-riga--ok" : b <= 5 ? "gas-riga--poco_sotto" : "gas-riga--sotto"),
      riga(t("sq_nelm"), `mag ${num(nelm, 1)}`, t("sq_nelm_n")),
      riga(t("sq_lum"), `${num(lum, lum < 1 ? 2 : 1)} mcd/m²`, t("sq_lum_n")),
      riga(t("sq_volte"), `${num(Math.pow(10, 0.4 * (22 - q)), 1)}×`, t("sq_volte_n"))];
  });
}
Object.assign(TESTI.en, { gd_troppo: "Too high: the guiding can't see the errors in the photo. You need a longer guide scope or an off-axis guider." });
Object.assign(TESTI.it, {
  vo_i: "Come appare l'oggetto nell'oculare, col tuo telescopio e il tuo oculare: grandezza vera rispetto al campo, quanta luce e quali dettagli. Al telescopio i colori sono molto più tenui che nelle foto e le nebulose sono grigie.",
  vo_cerca: "Cerca: M13, Saturno, Orione…", vo_ingr: "Ingrandimento", vo_campo: "Campo reale", vo_pupilla: "Pupilla d'uscita", vo_grande: "Grande come",
  vo_grande_v: "{n} volte la Luna piena a occhio nudo", vo_stanotte: "Stanotte {l_da}", vo_alto: "altezza {h}° alle {o}", vo_sotto: "non sale sopra l'orizzonte",
  vo_noti: "Cosa noterai", vo_ingrandito: "ingrandito", vo_troppo: "È più grande del campo ({a} contro {b}): con un oculare a focale più lunga lo vedi intero.",
  vo_capovolto: "Nel telescopio l'immagine è capovolta (Newton, Dobson) o specchiata (col diagonale): qui è come nel cielo, col nord in alto.",
  vo_dss: "Foto DSS rielaborata per somigliare alla vista nell'oculare.", vo_nodss: "Per nebulose, galassie e ammassi serve la foto del cielo, che qui non è disponibile.",
  vo_n_luna: "Crateri, mari e montagne: i dettagli migliori lungo il confine fra luce e ombra. Con un filtro lunare abbaglia meno.",
  vo_n_luna_parte: "A questo ingrandimento ne vedi solo una parte: spostati lungo il confine fra luce e ombra.",
  vo_n_giove_piccolo: "Un dischetto chiaro: per le bande servono almeno 40 ingrandimenti.", vo_n_giove_bande: "Il disco schiacciato con le due bande scure principali.",
  vo_n_giove_lune: "Le 4 lune di Galileo come stelline in fila: cambiano posto da una notte all'altra.", vo_n_giove_grs: "Più bande sottili e la Grande Macchia Rossa, quando è rivolta verso di noi.",
  vo_n_saturno_anelli: "Gli anelli si vedono già a 30 ingrandimenti: lo spettacolo più bello per chi comincia.", vo_n_saturno_cassini: "La divisione di Cassini, la riga scura fra i due anelli principali.",
  vo_n_saturno_titano: "Titano, la luna più grande, come una stellina vicina.", vo_n_marte: "Un disco arancione piccolo: i dettagli si vedono solo vicino all'opposizione.",
  vo_n_marte_calotta: "La calotta polare bianca.", vo_n_marte_macchie: "Le macchie scure della superficie, come Syrtis Major.",
  vo_n_venere: "La fase, come una piccola Luna: la superficie no, è coperta di nubi.", vo_n_mercurio: "Un puntino con la fase, basso nel chiarore del tramonto o dell'alba.",
  vo_n_lontani: "Un dischetto minuscolo: Urano verde-azzurro, Nettuno azzurro.", vo_n_sole: "Non guardarlo MAI senza un filtro solare davanti al telescopio.",
  vo_n_gc_1: "Una macchia rotonda e nebbiosa, più luminosa al centro.", vo_n_gc_2: "I bordi si sgranano in tante stelline.", vo_n_gc_3: "Si risolvono le stelle fin quasi al centro: uno spettacolo.",
  vo_n_oc: "Tante stelle di luminosità diverse: rende al meglio con un campo largo.", vo_n_neb: "Una nebbiolina grigia, mai colorata come nelle foto.",
  vo_n_neb_filtro: "Con un filtro UHC o OIII il contrasto migliora molto.", vo_n_m42: "Al centro il Trapezio, quattro stelle vicine; intorno ali di nebbia grigio-verde.",
  vo_n_pn: "Un dischetto grigio-verde: con un filtro OIII si vede meglio.", vo_n_m57: "Un piccolo anello di fumo.", vo_n_gx: "Il nucleo luminoso e un alone ovale: i bracci si vedono nelle foto, all'oculare quasi mai.",
  vo_n_gx_bracci: "Con questo diametro e un cielo buio si intuiscono i bracci a spirale.", vo_n_ds: "Due stelline separate, a volte di colori diversi.",
  vo_n_citta: "Dal cielo di città le galassie e le nebulose quasi spariscono: meglio Luna, pianeti e ammassi.", vo_n_distolta: "Guarda appena di lato all'oggetto (visione distolta): l'occhio vede più luce.",
});
Object.assign(TESTI.de, {
  vo_i: "Wie das Objekt im Okular mit Ihrem Teleskop und Okular aussieht: echte Größe im Gesichtsfeld, wie viel Licht und welche Details. Im Teleskop sind die Farben viel blasser als auf Fotos, Nebel sind grau.",
  vo_cerca: "Suche: M13, Saturn, Orion…", vo_ingr: "Vergrößerung", vo_campo: "Wahres Feld", vo_pupilla: "Austrittspupille", vo_grande: "So groß wie",
  vo_grande_v: "{n}-mal der Vollmond mit bloßem Auge", vo_stanotte: "Heute Nacht {l_da}", vo_alto: "Höhe {h}° um {o} Uhr", vo_sotto: "steigt nicht über den Horizont",
  vo_noti: "Was Sie sehen", vo_ingrandito: "vergrößert", vo_troppo: "Größer als das Feld ({a} gegen {b}): mit einem Okular längerer Brennweite sehen Sie es ganz.",
  vo_capovolto: "Im Teleskop steht das Bild auf dem Kopf (Newton, Dobson) oder ist gespiegelt (mit Zenitspiegel): hier wie am Himmel, Norden oben.",
  vo_dss: "DSS-Foto, bearbeitet, damit es dem Blick ins Okular ähnelt.", vo_nodss: "Für Deep-Sky-Objekte braucht es das Himmelsfoto, hier nicht verfügbar.",
  vo_n_luna: "Krater, Meere und Gebirge: die besten Details entlang der Licht-Schatten-Grenze. Mit Mondfilter blendet er weniger.",
  vo_n_luna_parte: "Bei dieser Vergrößerung sehen Sie nur einen Teil: Fahren Sie die Licht-Schatten-Grenze entlang.",
  vo_n_giove_piccolo: "Ein helles Scheibchen: für die Bänder braucht es mindestens 40-fach.", vo_n_giove_bande: "Die abgeplattete Scheibe mit den zwei dunklen Hauptbändern.",
  vo_n_giove_lune: "Die 4 Galileischen Monde als Sternchen in einer Reihe: sie wechseln jede Nacht die Position.", vo_n_giove_grs: "Mehr feine Bänder und der Große Rote Fleck, wenn er uns zugewandt ist.",
  vo_n_saturno_anelli: "Die Ringe sieht man schon bei 30-fach: der schönste Anblick für Einsteiger.", vo_n_saturno_cassini: "Die Cassinische Teilung, die dunkle Linie zwischen den Hauptringen.",
  vo_n_saturno_titano: "Titan, der größte Mond, als Sternchen daneben.", vo_n_marte: "Ein kleines orangefarbenes Scheibchen: Details nur nahe der Opposition.",
  vo_n_marte_calotta: "Die weiße Polkappe.", vo_n_marte_macchie: "Die dunklen Flecken der Oberfläche, wie Syrtis Major.",
  vo_n_venere: "Die Phase, wie ein kleiner Mond: die Oberfläche nicht, sie ist von Wolken bedeckt.", vo_n_mercurio: "Ein Pünktchen mit Phase, tief in der Abend- oder Morgendämmerung.",
  vo_n_lontani: "Ein winziges Scheibchen: Uranus grünblau, Neptun blau.", vo_n_sole: "Schauen Sie NIE ohne Sonnenfilter vor dem Teleskop hindurch.",
  vo_n_gc_1: "Ein runder, nebliger Fleck, in der Mitte heller.", vo_n_gc_2: "Die Ränder lösen sich in viele Sternchen auf.", vo_n_gc_3: "Die Sterne lösen sich fast bis zur Mitte auf: ein Spektakel.",
  vo_n_oc: "Viele Sterne verschiedener Helligkeit: am schönsten mit weitem Feld.", vo_n_neb: "Ein grauer Nebelhauch, nie so farbig wie auf Fotos.",
  vo_n_neb_filtro: "Mit einem UHC- oder OIII-Filter steigt der Kontrast deutlich.", vo_n_m42: "In der Mitte das Trapez, vier enge Sterne; drumherum grau-grüne Nebelflügel.",
  vo_n_pn: "Ein grau-grünes Scheibchen: mit OIII-Filter besser.", vo_n_m57: "Ein kleiner Rauchring.", vo_n_gx: "Der helle Kern und ein ovaler Schein: die Arme auf Fotos, im Okular fast nie.",
  vo_n_gx_bracci: "Mit dieser Öffnung und dunklem Himmel ahnt man die Spiralarme.", vo_n_ds: "Zwei getrennte Sternchen, manchmal in verschiedenen Farben.",
  vo_n_citta: "Vom Stadthimmel verschwinden Galaxien und Nebel fast: besser Mond, Planeten und Sternhaufen.", vo_n_distolta: "Schauen Sie knapp neben das Objekt (indirektes Sehen): das Auge sieht mehr Licht.",
});
Object.assign(TESTI.es, {
  vo_i: "Cómo se ve el objeto en el ocular con tu telescopio y tu ocular: tamaño real respecto al campo, cuánta luz y qué detalles. En el telescopio los colores son mucho más tenues que en las fotos y las nebulosas son grises.",
  vo_cerca: "Busca: M13, Saturno, Orión…", vo_ingr: "Aumento", vo_campo: "Campo real", vo_pupilla: "Pupila de salida", vo_grande: "Tan grande como",
  vo_grande_v: "{n} veces la Luna llena a simple vista", vo_stanotte: "Esta noche {l_da}", vo_alto: "altura {h}° a las {o}", vo_sotto: "no sube por encima del horizonte",
  vo_noti: "Qué notarás", vo_ingrandito: "ampliado", vo_troppo: "Es más grande que el campo ({a} frente a {b}): con un ocular de focal más larga lo ves entero.",
  vo_capovolto: "En el telescopio la imagen sale invertida (Newton, Dobson) o espejada (con diagonal): aquí está como en el cielo, con el norte arriba.",
  vo_dss: "Foto DSS retocada para parecerse a la vista en el ocular.", vo_nodss: "Para los objetos de cielo profundo hace falta la foto del cielo, aquí no disponible.",
  vo_n_luna: "Cráteres, mares y montañas: los mejores detalles en el borde entre luz y sombra. Con un filtro lunar deslumbra menos.",
  vo_n_luna_parte: "A este aumento ves solo una parte: muévete a lo largo del límite entre luz y sombra.",
  vo_n_giove_piccolo: "Un pequeño disco claro: para las bandas hacen falta al menos 40 aumentos.", vo_n_giove_bande: "El disco achatado con las dos bandas oscuras principales.",
  vo_n_giove_lune: "Las 4 lunas de Galileo como estrellitas en fila: cambian de sitio de una noche a otra.", vo_n_giove_grs: "Más bandas finas y la Gran Mancha Roja, cuando mira hacia nosotros.",
  vo_n_saturno_anelli: "Los anillos se ven ya a 30 aumentos: el espectáculo más bonito para quien empieza.", vo_n_saturno_cassini: "La división de Cassini, la raya oscura entre los anillos principales.",
  vo_n_saturno_titano: "Titán, la luna más grande, como una estrellita cercana.", vo_n_marte: "Un disco naranja pequeño: los detalles solo se ven cerca de la oposición.",
  vo_n_marte_calotta: "El casquete polar blanco.", vo_n_marte_macchie: "Las manchas oscuras de la superficie, como Syrtis Major.",
  vo_n_venere: "La fase, como una pequeña Luna: la superficie no, está cubierta de nubes.", vo_n_mercurio: "Un puntito con fase, bajo en la claridad del atardecer o del alba.",
  vo_n_lontani: "Un disco minúsculo: Urano verde azulado, Neptuno azul.", vo_n_sole: "No lo mires NUNCA sin un filtro solar delante del telescopio.",
  vo_n_gc_1: "Una mancha redonda y nebulosa, más brillante en el centro.", vo_n_gc_2: "Los bordes se resuelven en muchas estrellitas.", vo_n_gc_3: "Se resuelven las estrellas casi hasta el centro: un espectáculo.",
  vo_n_oc: "Muchas estrellas de distinto brillo: luce más con un campo amplio.", vo_n_neb: "Una neblina gris, nunca con los colores de las fotos.",
  vo_n_neb_filtro: "Con un filtro UHC u OIII el contraste mejora mucho.", vo_n_m42: "En el centro el Trapecio, cuatro estrellas juntas; alrededor alas de niebla gris verdosa.",
  vo_n_pn: "Un pequeño disco gris verdoso: con un filtro OIII se ve mejor.", vo_n_m57: "Un pequeño anillo de humo.", vo_n_gx: "El núcleo brillante y un halo ovalado: los brazos se ven en las fotos, en el ocular casi nunca.",
  vo_n_gx_bracci: "Con este diámetro y un cielo oscuro se intuyen los brazos espirales.", vo_n_ds: "Dos estrellitas separadas, a veces de colores distintos.",
  vo_n_citta: "Bajo un cielo de ciudad las galaxias y nebulosas casi desaparecen: mejor Luna, planetas y cúmulos.", vo_n_distolta: "Mira justo al lado del objeto (visión lateral): el ojo capta más luz.",
});
Object.assign(TESTI.it, { vo_bottone: "Cosa vedo all'oculare" });
Object.assign(TESTI.de, { vo_bottone: "So sieht es im Okular aus" });
Object.assign(TESTI.es, { vo_bottone: "Qué veo en el ocular" });
function bottoneVista(o) {
  return el("button", { type: "button", class: "gas-btn gas-btn--chiaro", onclick: e => {
    e.stopPropagation();
    CALC.vOgg = o.id;
    const tel = CAMPO.tel && !CAMPO.tel.smart ? CAMPO.tel : (ATTREZZI.tel || []).find(x => !x.smart && x.D && x.F);
    if (tel && tel.D && tel.F) { CALC.D = tel.D; CALC.F = tel.F; CALC.scelte.tel = { nome: nomeTel(tel), D: tel.D, F: tel.F, h: tel.h }; }
    const oc = CAMPO.oc || (ATTREZZI.oc || [])[0];
    if (oc && oc.f && oc.afov) { CALC.f = oc.f; CALC.afov = oc.afov; CALC.scelte.oc = { nome: oc.nome, f: oc.f, afov: oc.afov, h: oc.h }; }
    CALC.k = CAMPO.tel && CAMPO.k ? CAMPO.k : 1;
    salva("calc", CALC);
    if (PAGINA_OGG) chiudiOggetto(true);
    apriCalcolatore("vista");
  } }, icona("cx_vista"), " ", t("vo_bottone"));
}
const VO_SCELTE = ["@luna", "@giove", "@saturno", "@marte", "@venere", "M42", "M31", "M13", "M57", "M45", "M51", "M27"];
const VO_NEBULOSE = new Set(["en", "rn", "neb", "snr", "cn", "reg"]);
const VO_GALASSIE = new Set(["gx", "gxg", "gxcl"]);
function notiVista(o, v, B) {
  const n = [], id = String(o.id || "").replace(/\s+/g, "").toUpperCase();
  if (o.corpo) {
    const c = o.corpo;
    if (c === "luna") { n.push(t("vo_n_luna")); if (v.campo < 0.52) n.push(t("vo_n_luna_parte")); }
    else if (c === "giove") { n.push(t(v.M >= 40 ? "vo_n_giove_bande" : "vo_n_giove_piccolo"), t("vo_n_giove_lune")); if (v.D >= 150 && v.M >= 120) n.push(t("vo_n_giove_grs")); }
    else if (c === "saturno") { n.push(t("vo_n_saturno_anelli")); if (v.D >= 90 && v.M >= 100) n.push(t("vo_n_saturno_cassini")); if (v.D >= 60) n.push(t("vo_n_saturno_titano")); }
    else if (c === "marte") { n.push(t("vo_n_marte")); if (v.D >= 80 && v.M >= 120 && o.diam >= 10) n.push(t("vo_n_marte_calotta")); if (v.D >= 150 && o.diam >= 12) n.push(t("vo_n_marte_macchie")); }
    else if (c === "venere") n.push(t("vo_n_venere"));
    else if (c === "mercurio") n.push(t("vo_n_mercurio"));
    else if (c === "sole") n.push(t("vo_n_sole"));
    else n.push(t("vo_n_lontani"));
    return n;
  }
  if (o.t === "gc") n.push(t(v.D < 100 ? "vo_n_gc_1" : v.D < 200 ? "vo_n_gc_2" : "vo_n_gc_3"));
  else if (o.t === "oc") n.push(t("vo_n_oc"));
  else if (o.t === "pn") { n.push(t(id === "M57" ? "vo_n_m57" : "vo_n_pn")); }
  else if (VO_NEBULOSE.has(o.t)) { n.push(t(id === "M42" ? "vo_n_m42" : "vo_n_neb")); n.push(t("vo_n_neb_filtro")); }
  else if (VO_GALASSIE.has(o.t)) { n.push(t("vo_n_gx")); if (v.D >= 200 && B <= 4) n.push(t("vo_n_gx_bracci")); }
  else if (o.t === "ds") n.push(t("vo_n_ds"));
  if (B >= 6 && (VO_NEBULOSE.has(o.t) || VO_GALASSIE.has(o.t))) n.push(t("vo_n_citta"));
  if (o.t !== "ds") n.push(t("vo_n_distolta"));
  return n;
}
function disegnaVista(o, v, B) {
  const box = el("div", { class: "gas-vo" });
  const campo = el("div", { class: "gas-vo-campo" });
  box.appendChild(campo);
  const g = clamp((B - 1) / 8, 0, 1) * clamp(v.pup / 5, 0.25, 1.3);
  campo.style.background = `rgb(${Math.round(3 + 34 * g)}, ${Math.round(5 + 38 * g)}, ${Math.round(9 + 46 * g)})`;
  const frazione = d => d / 3600 * v.M / v.afov;
  if (o.corpo === "luna") {
    const url = fotoLuna(new Date()), p = Math.min(6, frazione(o.diam)) * 100;
    const disegno = lunaDisegnata(Astro.faseLuna(Astro.jd(new Date())), 200);
    disegno.classList.add("gas-vo-luna");
    disegno.style.width = disegno.style.height = p + "%";
    campo.appendChild(disegno);
    if (url) caricaImmagine({ src: url, alt: "", class: "gas-vo-luna" }).then(img => {
      img.style.width = img.style.height = p * 1.1 + "%";
      if (disegno.isConnected) disegno.replaceWith(img);
    }).catch(() => {});
  } else if (o.corpo) {
    const tela = el("canvas", { class: "gas-vo-tela" });
    const dettaglio = el("canvas", { class: "gas-vo-dettaglio" });
    campo.appendChild(tela);
    const fr = frazione(o.diam), piccolo = fr < 0.12;
    const disegna = () => {
      const lato = campo.clientWidth || 320, dpr = Math.min(2, window.devicePixelRatio || 1);
      tela.width = tela.height = Math.round(lato * dpr);
      const c = tela.getContext("2d"), R = tela.width / 2;
      c.clearRect(0, 0, tela.width, tela.height);
      disegnaCorpo(c, o, R, R, Math.max(1.2 * dpr, fr * tela.width / 2), dpr);
      if (o.corpo === "giove" && o.quando) {
        c.fillStyle = "rgba(255,248,230,0.95)";
        for (const m of luneGiove(Astro.jd(o.quando), o.polo || 0, o.diam)) {
          if (m.sulDisco && !m.davanti) continue;
          const x = R - m.est * v.M / v.afov * tela.width, y = R - m.nord * v.M / v.afov * tela.width;
          if (Math.hypot(x - R, y - R) > R) continue;
          c.beginPath(); c.arc(x, y, Math.max(1.1 * dpr, fr * tela.width * 0.03), 0, 2 * Math.PI); c.fill();
        }
      }
      if (piccolo) {
        const l2 = Math.round(Math.min(150, lato * 0.42) * dpr);
        dettaglio.width = dettaglio.height = l2;
        const d = dettaglio.getContext("2d");
        d.fillStyle = "#04060a"; d.fillRect(0, 0, l2, l2);
        disegnaCorpo(d, o, l2 / 2, l2 / 2, l2 * (o.corpo === "saturno" ? 0.17 : 0.34), dpr);
      }
    };
    if (piccolo) box.appendChild(el("figure", { class: "gas-vo-zoom" }, dettaglio, el("figcaption", null, t("vo_ingrandito"))));
    let fatto = false;
    const una = () => { if (!fatto && campo.isConnected) { fatto = true; disegna(); } };
    requestAnimationFrame(una); setTimeout(una, 120); setTimeout(() => { fatto = false; una(); }, 600);
  } else if (FOTO_DSS || DEBUG) {
    const img = el("img", { alt: "", class: "gas-vo-dss", loading: "lazy" });
    const luce = clamp(0.3 + 0.13 * v.pup, 0.3, 1), contrasto = clamp((0.92 + 0.15 * Math.log2(v.D / 100)) * (1 - 0.05 * (B - 3)), 0.6, 1.3);
    img.style.filter = `grayscale(.88) brightness(${luce.toFixed(2)}) contrast(${contrasto.toFixed(2)}) blur(.3px)`;
    campo.append(img, el("i", { class: "gas-vo-bagliore", style: { opacity: String(clamp(0.05 * (B - 1) * Math.sqrt(v.pup / 5), 0, 0.5).toFixed(2)) } }));
    if (v.campo <= 30) setTimeout(() => { if (img.isConnected) fotoCielo(img, { ra: o.ra, dec: o.dec, fov: v.campo, W: 480, H: 480 }); }, 450);
  } else campo.appendChild(el("p", { class: "gas-vo-nodss" }, t("vo_nodss")));
  campo.appendChild(el("i", { class: "gas-vo-bordo" }));
  return box;
}
function cxVista(H) {
  if (!CALC.vOgg || !trovaOggetto(CALC.vOgg)) CALC.vOgg = "@saturno";
  const scelte = el("div", { class: "gas-vo-scelte" }, VO_SCELTE.map(id => {
    const o = trovaOggetto(id);
    if (!o) return null;
    return el("button", { type: "button", class: "gas-cx-chip gas-cx-chip--mini" + (norm(CALC.vOgg) === norm(id) ? " on" : ""), onclick: () => { CALC.vOgg = id; H.ridisegna(); } },
      o.corpo ? nomeCorpo(o.corpo) : `${o.id}${nomeOggetto(o) ? " · " + nomeCorto(nomeOggetto(o)) : ""}`);
  }));
  const cercaOgg = creaCerca({
    segnaposto: t("vo_cerca"),
    cerca: q => cercaOggetti(q, 20).filter(o => isFinite(o.ra) && isFinite(o.dec)),
    riga: (o, q) => ({ titolo: titoloCercato(o, q), sotto: rigaOggetto(o) }),
    scegli: o => { CALC.vOgg = o.id; H.ridisegna(); },
  }).box;
  H.carta(t("xn_vista"), t("vo_i"), [scelte, cercaOgg, H.cercaTel(), H.telScelto(), H.cercaOc(),
    H.scelto("oc", s => s.f === CALC.f && s.afov === CALC.afov, s => `${num(s.f, s.f % 1 ? 1 : 0)} mm · ${num(s.afov)}°`)],
  [H.campo("D", t("diametro"), { unita: "mm" }), H.campo("F", t("focale"), { unita: "mm" }),
    H.campo("f", t("focale_oculare"), { unita: "mm" }), H.campo("afov", t("campo_apparente"), { unita: "°" }),
    etichetta(t("riduttore_barlow"), H.scelta("k", FATTORI.map(f => [f, f === 1 ? t("nessuno") : `${num(f, 2)}×`])))], () => {
    const { D, F, f, afov } = CALC, k = CALC.k || 1;
    if (!D || !F || !f || !afov) return null;
    const o = trovaOggetto(CALC.vOgg);
    if (!o) return null;
    const M = F * k / f, v = { D, M, afov, campo: afov / M, pup: D / M }, B = NOTTE.bortle || bortleDaSqm(sqmLuogo());
    const righe = [riga(t("vo_ingr"), `${num(M)}×`, M > 2 * D ? t("troppo_ingrandimento", { m: num(2 * D) }) : ""),
      riga(t("vo_campo"), angolo(v.campo)), riga(t("vo_pupilla"), `${num(v.pup, 1)} mm`)];
    if (o.corpo && o.diam && o.corpo !== "luna") righe.push(riga(t("vo_grande"), t("vo_grande_v", { n: num(o.diam * M / 1865, o.diam * M / 1865 < 10 ? 1 : 0) })));
    let hMax = -90, quando = null;
    if (o.corpo) { hMax = o.hMax; quando = o.quando; }
    else {
      const nt = notteBase().nt, h = Astro.curvaOggetto(nt, o.ra, o.dec).h;
      for (let i = 0; i < nt.n; i++) if (nt.hSole[i] < -12 && h[i] > hMax) { hMax = h[i]; quando = Astro.data(nt.tempi[i]); }
    }
    righe.push(riga(t("vo_stanotte", luogoFrasi()), hMax > 0 && quando ? t("vo_alto", { h: num(hMax), o: ora(quando) }) : t("vo_sotto"), null, hMax > 25 ? "gas-riga--ok" : hMax > 0 ? "gas-riga--poco_sotto" : "gas-riga--sotto"));
    const grandezza = o.corpo ? null : (o.a || misuraOggetto(o)) / 60;
    const noti = notiVista(o, v, B);
    if (grandezza && grandezza > v.campo * 1.05) noti.unshift(t("vo_troppo", { a: angolo(grandezza), b: angolo(v.campo) }));
    return [disegnaVista(o, v, B), el("div", { class: "gas-righe" }, righe),
      el("small", { class: "gas-setup-etich" }, t("vo_noti")), el("ul", { class: "gas-vo-noti" }, noti.map(x => el("li", null, x))),
      el("p", { class: "gas-nota" }, t("vo_capovolto"), o.corpo ? "" : " " + t("vo_dss"))];
  });
}
const CAT_SW = ["acquisizione", "guida", "plate_solving", "driver", "stacking", "elaborazione", "planetario_solare", "planetari",
  "app_strumenti", "meteo_cielo"];
const FILTRO_SW = { cat: "", os: "", gratis: false, q: "" };
function vistaSoftware(pannello) {
  svuota(pannello);
  const sistemi = ["Windows", "macOS", "Linux", "iOS", "Android", "Web", "Raspberry Pi"];
  const cerca = el("input", { type: "search", class: "gas-input", placeholder: t("cerca_software"), value: FILTRO_SW.q });
  cerca.addEventListener("input", debounce(() => { FILTRO_SW.q = cerca.value; mostra(); }, 120));
  const cat = selezione([["", t("tutte")], ...CAT_SW.map(c => [c, t("sw_" + c)])], FILTRO_SW.cat, v => { FILTRO_SW.cat = v; mostra(); });
  const os = selezione([["", t("tutti")], ...sistemi.map(s => [s, s])], FILTRO_SW.os, v => { FILTRO_SW.os = v; mostra(); });
  const gr = el("input", { type: "checkbox", checked: FILTRO_SW.gratis });
  gr.addEventListener("change", () => { FILTRO_SW.gratis = gr.checked; mostra(); });
  const elenco = el("div", { class: "gas-sw" });
  pannello.append(el("div", { class: "gas-filtri" }, el("div", { class: "gas-filtri-cerca" }, cerca),
    el("div", { class: "gas-filtri-griglia" }, etichetta(t("categoria"), cat), etichetta(t("sistema"), os)),
    el("div", { class: "gas-spunte" }, el("label", { class: "gas-spunta" }, gr, t("solo_gratis")))), elenco,
  el("p", { class: "gas-nota" }, t("nota_software")));
  function mostra() {
    const q = normParole(FILTRO_SW.q).trim();
    const lista = DATI.software.filter(s => s.attivo !== false &&
      (!FILTRO_SW.cat || s.categoria === FILTRO_SW.cat) && (!FILTRO_SW.os || (s.piattaforme || []).includes(FILTRO_SW.os)) &&
      (!FILTRO_SW.gratis || ["gratuito", "open_source", "freemium"].includes(s.prezzo)) &&
      (!q || normParole(`${s.nome} ${s.produttore} ${s[LINGUA] || s.it}`).includes(q)));
    svuota(elenco);
    for (const c of CAT_SW) {
      const qui = lista.filter(s => s.categoria === c);
      if (!qui.length) continue;
      elenco.appendChild(el("section", { class: "gas-sw-gruppo" }, el("h3", null, t("sw_" + c)), el("div", { class: "gas-sw-griglia" },
        qui.map(s => el("a", { class: "gas-sw-voce", href: s.url, target: "_blank", rel: "noopener nofollow" },
          el("span", { class: "gas-sw-testa" }, el("b", null, s.nome), badge(t("prezzo_" + s.prezzo), s.prezzo === "a_pagamento" ? "pag" : "free")),
          el("span", { class: "gas-sw-desc" }, s[LINGUA] || s.it),
          el("span", { class: "gas-sw-piede" }, el("small", null, s.produttore || ""), el("span", { class: "gas-sw-os" }, (s.piattaforme || []).map(p => el("i", null, p)))))))));
    }
    if (!elenco.firstChild) elenco.appendChild(el("p", { class: "gas-muto" }, t("nessun_risultato")));
  }
  mostra();
}
TESTI.en = Object.assign({
"tab_campo": "Field of view",
"tab_stanotte": "Tonight",
"tab_camere": "Cameras",
"tab_calcolatori": "Calculators",
"tab_software": "Software",
"caricamento": "Loading the tools…",
"errore_dati": "Couldn't load the tools' data. Reload the page in a few seconds.",
"cerca": "Search…",
"nessun_risultato": "No results",
"nel_negozio": "At Giordano Astronomia",
"vedi_prodotto": "View",
"da": "from",
"non_disponibile": "out of stock",
"copiato": "Link copied!",
"modo_foto": "Astrophotography",
"modo_visuale": "Visual observing",
"telescopio": "Telescope",
"cerca_telescopio": "Search: Esprit 100, RCN8, Samyang…",
"diametro": "Aperture",
"focale": "Focal length",
"personalizzato": "Custom",
"personalizzata": "Custom",
"riduttore": "Reducer / Barlow",
"nessuno": "None (1×)",
"riduttore_b": "reducer",
"barlow_b": "Barlow",
"riduttori_negozio": "Reducers with this factor in our shop:",
"barlow_negozio": "Barlows with this factor in our shop:",
"camera": "Camera",
"cerca_camera": "Search: ASI2600, EOS R6, Seestar…",
"larghezza_px": "Width",
"altezza_px": "Height",
"pixel": "Pixel",
"binning": "Binning",
"seeing": "Seeing",
"seeing_1": "Excellent (1″)",
"seeing_1_5": "Very good (1.5″)",
"seeing_2": "Good (2″)",
"seeing_2_5": "Average (2.5″)",
"seeing_3": "Mediocre (3″)",
"seeing_4": "Poor (4″)",
"seeing_5": "Very poor (5″)",
"in_vendita": "in our shop",
"oculare": "Eyepiece",
"cerca_oculare": "Search: 25 mm, 82°, Plössl…",
"focale_oculare": "Eyepiece focal length",
"campo_apparente": "Apparent field",
"oggetto": "Object",
"cerca_oggetto": "Search: M31, NGC 7000, Flying Bat…",
"inquadratura": "Framing",
"rotazione": "Camera rotation",
"rotazione_n": "0° = long side horizontal (east-west) with north up; the angle increases anticlockwise.",
"mosaico_x": "Panels across",
"mosaico_y": "Panels down",
"sovrapposizione": "Overlap",
"mosaico": "Mosaic",
"rosso": "Night vision",
"rosso_n": "Red page so you keep your dark adaptation when you're outdoors",
"chip_luna": "Moon",
"chip_buio": "Darkness",
"chip_oggetti": "objects",
"chip_camere": "cameras",
"chip_telescopi": "telescopes",
"rotazione_b": "Rotation",
"ruota_90": "Rotate by 90°",
"carico_cielo": "Drawing the sky map…",
"cielo_errore": "The sky map can't load right now: the calculations are still valid.",
"allarga": "Zoom out",
"stringi": "Zoom in",
"centra_qui": "Centre here",
"reimposta": "Reset",
"copia_link": "Copy link",
"credito_cielo": "Sky map drawn by Giordano Astronomia: stars from ESA's Hipparcos and Tycho-2 catalogues down to magnitude 10.5, in their true colours; the Milky Way derived from star density; galaxies and nebulae from our catalogue with real sizes and orientations.",
"trascina": "Drag the sky to move around (the frame stays in the centre); double-tap (or double-click) to centre; two fingers or Ctrl + scroll wheel to zoom.",
"centri_pannelli": "Mosaic panel coordinates",
"centro_inquadratura": "Coordinates of the frame centre",
"scegli_telescopio": "Choose a telescope or enter aperture and focal length.",
"scegli_camera": "Choose a camera or enter resolution and pixel size.",
"scegli_oculare": "Choose an eyepiece or enter focal length and apparent field.",
"mancano_dati": "Choose a telescope and camera (or eyepiece) to see the field of view.",
"campo_inquadrato": "Field of view",
"diagonale": "diagonal",
"scala": "Image scale",
"focale_effettiva": "Effective focal length",
"immagine": "Image",
"campionamento": "Sampling",
"camp_sovra": "oversampled",
"camp_sovra_n": "Each star covers too many pixels: use {b}×{b} binning or a reducer.",
"camp_poco_sovra": "slightly oversampled",
"camp_poco_sovra_n": "Fine in better seeing; with the seeing you chose, 2×2 binning loses no detail.",
"camp_ok": "ideal",
"camp_ok_n": "Stars stay round and you use the full resolution.",
"camp_poco_sotto": "slightly undersampled",
"camp_poco_sotto_n": "Normal for wide fields: slightly squarer stars, detail close to the maximum.",
"camp_sotto": "undersampled",
"camp_sotto_n": "Stars turn into little squares: fine for very wide fields, but for detail you need more focal length.",
"camp_dettaglio": "With {s}″ seeing the ideal is between {a} and {b}″/px (2-3 pixels per star).",
"risoluzione_dawes": "Resolving power (Dawes)",
"risoluzione_nota": "theoretical limit of the optics: in practice the limit is almost always the seeing",
"mosaico_totale": "Mosaic, total area",
"pannelli": "panels",
"riempimento": "The object fills",
"non_entra": "doesn't fit entirely: try a reducer or a mosaic",
"molto_piccolo": "very small in the field: you need more focal length",
"ingrandimento": "Magnification",
"max_utile": "max useful",
"campo_reale": "True field",
"pupilla": "Exit pupil",
"pupilla_piccola": "very small: dim image",
"pupilla_grande": "Exit pupil over 7 mm: some of the light doesn't enter your eye.",
"troppo_ingrandimento": "Beyond the maximum useful magnification ({m}×): the image breaks down.",
"ingr_minimo": "Minimum magnification",
"ingr_minimo_n": "below this, the exit pupil exceeds 7 mm",
"il_telescopio": "The telescope at Giordano Astronomia",
"la_camera": "The camera at Giordano Astronomia",
"l_oculare": "The eyepiece at Giordano Astronomia",
"parte_di": "part of",
"migliori_stanotte": "Best objects of the night",
"latitudine": "Latitude",
"longitudine": "Longitude",
"posizione_mano": "Location entered manually",
"cerca_citta": "Search for a city…",
"cerco_posizione": "Finding your location…",
"mia_posizione": "My location",
"usa_posizione": "Use my location",
"posizione_negata": "Location unavailable: search for a city or type the coordinates.",
"stanotte": "Tonight",
"luogo": "Location",
"data_notte": "Night of",
"nota_orari": "Times are in your device's time zone.",
"altezza_minima": "Minimum altitude",
"tipo": "Type",
"tutti": "All",
"tutte": "All",
"costellazione": "Constellation",
"qualsiasi": "Any",
"magnitudine_max": "Magnitude",
"ordina": "Sort by",
"ord_migliori": "Best tonight",
"ord_ore": "Most usable hours",
"ord_altezza": "Highest in the sky",
"ord_grandezza": "Largest",
"ord_luminosi": "Brightest",
"ord_nome": "Name",
"ord_mp": "Most megapixels",
"ord_pixel": "Largest pixels",
"ord_formato": "Largest sensor",
"ord_recenti": "Newest",
"solo_famosi": "Only Messier, Caldwell and named objects",
"solo_campo": "Only show objects that suit my field of view",
"mio_setup": "Tonight's telescope and camera",
"mio_setup_n": "Choose a telescope and camera: the choice also applies to “Field of view”.",
"campo_tuo": "Your field of view:",
"nessun_setup": "Choose a telescope and camera to see which objects fit in your field of view.",
"modifica_campo": "View and edit in Field of view →",
"occupa": "{p}% of the field",
"fit_ok": "fits well",
"fit_grande": "larger than the field",
"fit_piccolo": "small in the field",
"prima_campo": "first choose a telescope and camera",
"calcolo": "Calculating the night…",
"tramonto": "Sunset",
"buio_da": "Darkness from",
"buio_a": "Darkness until",
"crep_astronomico": "astronomical twilight",
"alba": "Sunrise",
"ore_buio": "Dark hours",
"solo_nautico": "the sky doesn't get fully dark",
"luna": "Moon",
"crescente": "waxing",
"calante": "waning",
"luna_nuova": "Next new Moon",
"luna_piena": "Next full Moon",
"avviso_nautico": "On this date the sky doesn't get fully dark: the calculations use the darkest part available (nautical twilight).",
"avviso_nessuno": "On this date the Sun doesn't sink far enough below the horizon: no true night.",
"giorno": "Day",
"crepuscolo": "Twilight",
"notte_astro": "Astronomical night",
"luna_sopra": "Moon above the horizon",
"pianeti_stanotte": "Planets tonight",
"pianeta": "Planet",
"alt_max": "Max altitude",
"quando": "Time",
"mag": "Magnitude",
"diametro_app": "Diameter",
"fase": "Illuminated",
"sotto_orizzonte": "below the horizon",
"pianeta_mercurio": "Mercury",
"pianeta_venere": "Venus",
"pianeta_marte": "Mars",
"pianeta_giove": "Jupiter",
"pianeta_saturno": "Saturn",
"pianeta_urano": "Uranus",
"pianeta_nettuno": "Neptune",
"nessun_oggetto": "No objects match these choices: lower the minimum altitude or remove some limits in “Objects”.",
"trovati": "{n} visible objects",
"mostra_altri": "Show more",
"ore_utili": "Usable hours",
"dist_luna": "Distance from the Moon",
"sempre_sopra": "Always above the horizon",
"sorge": "Rises",
"culmina": "highest",
"tramonta": "sets",
"inquadra": "Frame it",
"grafico_altezza": "Altitude above the horizon during the night",
"altezza_oggetto": "Object",
"altezza_luna": "Moon",
"gruppo_galassie": "Galaxies",
"gruppo_emissione": "Emission nebulae",
"gruppo_riflessione": "Reflection nebulae",
"gruppo_oscure": "Dark nebulae",
"gruppo_planetarie": "Planetary nebulae",
"gruppo_supernova": "Supernova remnants",
"gruppo_aperti": "Open clusters",
"gruppo_globulari": "Globular clusters",
"gruppo_altre": "Other objects",
"tipo_gx": "Galaxy",
"tipo_gxg": "Galaxy group",
"tipo_gxcl": "Galaxy cluster",
"tipo_gxp": "Region of a galaxy",
"tipo_oc": "Open cluster",
"tipo_sc": "Star cloud",
"tipo_gc": "Globular cluster",
"tipo_pn": "Planetary nebula",
"tipo_en": "Emission nebula",
"tipo_rn": "Reflection nebula",
"tipo_dn": "Dark nebula",
"tipo_cn": "Cluster with nebula",
"tipo_snr": "Supernova remnant",
"tipo_neb": "Nebula",
"tipo_reg": "Region",
"tipo_ds": "Double star",
"marca": "Brand",
"colore_mono": "Colour or mono",
"colore": "Colour",
"mono": "Mono",
"sensore": "Sensor",
"pix_p1": "up to 2.4 µm",
"pix_p2": "2.4 – 3.8 µm",
"pix_p3": "3.8 – 5 µm",
"pix_p4": "over 5 µm",
"solo_negozio": "Only the ones we sell",
"solo_produzione": "Current models only",
"camere_trovate": "{n} of {tot} cameras",
"risoluzione": "Resolution",
"formato": "Size",
"campo_col": "Field with your telescope",
"confronta": "Compare",
"usa": "Use",
"acquista": "Buy",
"raffreddata_s": "cooled",
"fuori_produzione": "discontinued",
"mostra_altre": "Show more ({n})",
"da_confrontare": "{n} cameras to compare (up to 4)",
"svuota": "Clear",
"confronto": "Comparison",
"megapixel": "Megapixels",
"bit": "ADC",
"raffreddata": "Cooled",
"si": "Yes",
"no": "No",
"nota_camere": "Specifications from the manufacturers' official data sheets. The field of view is calculated with the telescope chosen in “Field of view”.",
"cat_raffreddata": "Cooled",
"cat_non_raffreddata": "Uncooled",
"cat_planetaria_guida": "Planetary and guiding",
"cat_smart": "Smart telescope",
"cat_mirrorless": "Mirrorless",
"cat_reflex": "DSLR",
"cat_medio_formato": "Medium format",
"cat_swir": "Infrared (SWIR)",
"c_tel": "Telescope",
"c_tel_i": "What a telescope can do, based on its aperture and focal length.",
"rapporto_focale": "Focal ratio",
"luce_raccolta": "Light-gathering power",
"luce_raccolta_n": "compared with the eye (7 mm pupil)",
"risoluzione_rayleigh": "Resolving power (Rayleigh)",
"mag_limite": "Visual limiting magnitude",
"mag_limite_n": "the faintest stars visible under a dark sky",
"ingr_max": "Maximum useful magnification",
"c_oc": "Eyepiece",
"c_oc_i": "Magnification, true field and exit pupil with an eyepiece.",
"focale_telescopio": "Telescope focal length",
"c_camp": "Ideal focal length for your camera",
"c_camp_i": "Which focal length makes the most of your camera's pixels with the seeing under your sky.",
"focale_ideale": "Ideal focal length",
"focale_ideale_n": "with {s}″ seeing (2-3 pixels per star)",
"consiglio": "Tip",
"consiglio_rid": "a reducer of about {k}×",
"consiglio_barlow": "a Barlow of about {k}×",
"consiglio_barlow_n": "only if you want maximum detail (or a telescope with a longer focal length): for wide fields it's fine as it is",
"c_plan": "Planetary imaging",
"c_plan_i": "For the Moon, Sun and planets, using the lucky imaging technique.",
"f_ideale": "Ideal focal ratio",
"f_ideale_n": "rule of thumb: 5 times the pixel size in µm for colour cameras, 4 times for mono",
"focale_planetaria": "Focal length to use",
"barlow_serve": "you need a Barlow of about {k}×",
"barlow_non_serve": "fine as it is",
"c_npf": "Nightscapes without tracking",
"c_npf_i": "The longest exposure before stars turn into trails, with the camera on a tripod.",
"focale_obiettivo": "Lens focal length",
"diaframma": "f-number",
"full_frame": "Full frame",
"declinazione": "Target declination",
"regola_npf": "NPF rule",
"regola_npf_n": "pinpoint stars even when zoomed in",
"regola_500": "500 rule",
"regola_500_n": "more forgiving, for full-screen viewing",
"c_bf": "Backfocus and spacers",
"c_bf_i": "How many millimetres of spacers you need between the corrector and the sensor.",
"bf_richiesto": "Required backfocus",
"bf_camera": "Camera",
"bf_ruota": "Filter wheel or drawer",
"bf_filtro": "Filter in the light path",
"bf_altro": "Other (type it in)",
"bf_distanziali": "Spacers to add",
"bf_troppo": "the imaging train is already too long",
"bf_correzione": "Filter correction",
"bf_correzione_n": "a glass filter pushes the focus back by about 1/3 of its thickness",
"c_pol": "Polaris in the polar scope",
"c_pol_i": "Where to put Polaris in the reticle to polar-align the mount, right now, at the location chosen in “Tonight”.",
"pol_cannocchiale": "In the polar scope",
"pol_occhio": "With the naked eye",
"pol_ore": "Polaris at {o} o'clock",
"pol_angolo": "Hour angle of Polaris",
"pol_distanza": "Distance of Polaris from the pole",
"pol_nota": "Calculated at {ora} for: {luogo}. The polar scope turns the image upside down: follow the “In the polar scope” drawing.",
"pol_sud": "Polaris can't be seen from the southern hemisphere: use Sigma Octantis.",
"c_rug": "Dew risk",
"c_rug_i": "The dew point tells you when the optics will fog up.",
"temperatura": "Temperature",
"umidita": "Humidity",
"punto_rugiada": "Dew point",
"rischio": "Dew risk",
"rischio_alto": "high: turn on the dew heaters",
"rischio_medio": "medium: have the dew heaters ready",
"rischio_basso": "low",
"rischio_n": "{m} °C above the dew point",
"c_int": "Integration time and disk space",
"c_int_i": "How many hours of data you collect and how much space they take up.",
"numero_pose": "Number of exposures",
"posa_s": "Sub-exposure length",
"integrazione": "Total integration",
"spazio_disco": "Disk space",
"spazio_disco_n": "{mb} MB per exposure (16-bit files, {c})",
"cerca_software": "Search for a program…",
"categoria": "Category",
"sistema": "System",
"solo_gratis": "Free only",
"nota_software": "Links to the programs' official websites. Giordano Astronomia is not responsible for the content of external websites.",
"prezzo_gratuito": "Free",
"prezzo_open_source": "Open source",
"prezzo_freemium": "Free + Pro",
"prezzo_a_pagamento": "Paid",
"sw_acquisizione": "Capture and control",
"sw_guida": "Autoguiding",
"sw_plate_solving": "Plate solving",
"sw_driver": "Drivers and connectivity",
"sw_stacking": "Calibration and stacking",
"sw_elaborazione": "Image processing",
"sw_planetario_solare": "Planetary, lunar and solar processing",
"sw_planetari": "Planetariums and planning",
"sw_app_strumenti": "Smart telescope and mount apps",
"sw_meteo_cielo": "Weather and sky",
"carico_foto": "Loading the sky photo…",
"foto_errore": "The sky photo isn't available right now: the calculations are still valid.",
"credito_foto": "Photo: Digitized Sky Survey (DSS2, STScI/NASA), colours by CDS, via hips2fits from CDS Strasbourg.",
"firma_mappa": "Giordano map · ESA Hipparcos/Tycho-2",
"mappa_cielo": "Sky map around the object, with the field-of-view frame",
"vista_mappa": "Map",
"vista_foto": "Photo",
"vista_confronto": "Compare",
"legenda_mappa": "On the map:",
"barlow_vicine": "Barlows in our shop:",
"cerca_fotocamera": "Search: EOS R6, Z6 II, A7 IV…",
"nomi": "Names",
"nomi_n": "Show or hide object names and outlines",
"foto_errore_mappa": "The sky photo isn't available right now: here's our map instead.",
"miei_setup": "My setups",
"setup": "Setup",
"salva_setup": "Save setup",
"nome_setup": "Setup name",
"salva": "Save",
"annulla": "Cancel",
"togli_setup": "Remove this setup",
"conferma_togli": "Remove the setup “{n}”?",
"nessun_setup_salvato": "No setups saved yet: choose a telescope and camera, then press “Save setup”.",
"setup_gia_salvato": "This equipment is already in your setups.",
"usa_setup_calc": "Fill in with one of my setups:",
"ferma": "Stop",
"ascolta_spiegazione": "Listen to the explanation",
"guida_voce": "Guide",
"torna_oggetto": "Back to the object",
"ctrl_rotella": "To zoom: Ctrl + scroll wheel (or two fingers)",
"richiama_setup": "Tap a setup to load it:",
"setup_salvato_come": "This equipment is saved as “{n}”.",
"passo_1": "Choose the telescope and camera (or eyepiece) below.",
"passo_1_notte": "Choose the telescope and camera below.",
"passo_2": "Then give it a name and press “Save setup”: next time you can load it with one tap.",
"setup_pieni": "You already have {n} setups: remove one to save another.",
"setup_scelto": "Selected equipment:",
"salva_come_setup": "Save this equipment to my setups",
"obiettivo": "Camera lens",
"diaframma_f": "f-number",
"miei_filtri": "My filters",
"miei_filtri_n": "Search for your filters by name (or tap the type): for each object we'll tell you which one to use.",
"filtro_dual": "Dual-band",
"filtro_sho": "Hα/OIII/SII set",
"filtro_ha": "Hα",
"filtro_oiii": "OIII",
"filtro_sii": "SII",
"filtro_hbeta": "Hβ",
"filtro_uhc": "UHC",
"filtro_lp": "Light-pollution filter",
"filtro_lrgb": "LRGB set",
"filtro_uvir": "UV/IR cut",
"filtro_irpass": "IR pass",
"filtro_luna": "Moon filter",
"filtro_nessuno": "No filter",
"filtro_rimanda": "Try another night",
"filtro_dual_n": "Hα + OIII in a single filter, for colour cameras (e.g. L-eXtreme, L-Ultimate, ALP-T)",
"filtro_sho_n": "Narrowband filters for mono cameras",
"filtro_ha_n": "Hydrogen-alpha narrowband",
"filtro_oiii_n": "Oxygen narrowband",
"filtro_sii_n": "Sulphur narrowband",
"filtro_hbeta_n": "Visual: Horsehead and California nebulae",
"filtro_uhc_n": "Nebula filter, mainly for visual use",
"filtro_lp_n": "Broadband filter against light pollution (e.g. L-Pro, CLS)",
"filtro_lrgb_n": "Luminance and colour for mono cameras",
"filtro_uvir_n": "Blocks ultraviolet and infrared",
"filtro_irpass_n": "For planets and the Moon in poor seeing",
"filtro_luna_n": "Dims the Moon's light for visual use",
"filtro_consigliato": "Recommended filter",
"filtro_alternativa": "Your {f} filter is better than none, but a dual-band filter is in another league.",
"filtro_non_usare": "Don't use: {f}.",
"filtri_negozio": "In our shop:",
"filtro_per_notte": "For tonight, observing {l_da} (Bortle {b} sky).",
"cambia_in_stanotte": "Change in “Tonight” →",
"cielo_luogo": "Local sky",
"cielo_luogo_n": "Used to recommend the filter: the brighter the sky, the more narrowband matters.",
"bortle_1": "1 · Excellent sky",
"bortle_2": "2 · Truly dark sky",
"bortle_3": "3 · Rural sky",
"bortle_4": "4 · Rural/suburban transition",
"bortle_5": "5 · Suburban sky",
"bortle_6": "6 · Bright suburbs",
"bortle_7": "7 · Suburban/urban transition",
"bortle_8": "8 · City sky",
"bortle_9": "9 · City centre",
"ff_mono_em": "emission nebula: Hα, then OIII and SII for the SHO palette. Works with the Moon and in the city too.",
"ff_mono_pn": "planetary nebula: OIII and Hα, even with the Moon up.",
"ff_colore_em_buio": "under a dark sky with no Moon you can also shoot without a filter, for natural star colours, but a dual-band filter gives more contrast.",
"ff_colore_em_luna": "with this Moon, a dual-band filter is almost essential: it blocks moonlight and lets only Hα and OIII through.",
"ff_colore_em_citta": "with the bright sky at your location, a dual-band filter cuts light pollution and lets only Hα and OIII through.",
"ff_colore_bl_buio": "for galaxies, clusters and reflection nebulae you don't need a filter (a UV/IR cut is enough if the camera doesn't have one).",
"ff_colore_bl_luce": "a broadband light-pollution filter helps a little in the suburbs, not much with the Moon or LED street lights. No dual-band filter: it would block the object's light.",
"ff_mono_bl_buio": "LRGB: luminance for detail, RGB for colour.",
"ff_mono_bl_luce": "more time on RGB than on luminance, because luminance suffers more from sky glow and moonlight. No narrowband on these objects.",
"ff_rimanda_luna": "with this Moon, galaxies and reflection nebulae lose almost all their contrast: better another night, or an emission nebula with a dual-band filter.",
"ff_rimanda_citta": "under this sky, galaxies and faint nebulae barely show even with filters: better a darker sky, or an emission nebula with a dual-band filter.",
"fv_uhc": "visually, a UHC filter darkens the sky background and makes the nebula stand out.",
"fv_oiii": "visually, the best for supernova remnants and planetary nebulae is the OIII (a UHC works too).",
"fv_hbeta": "visually, an Hβ filter is almost the only way to see it.",
"fv_nessuno": "visually, a filter would only take light away.",
"fv_nessuno_luce": "visually, no filter really helps with this much light: a darker sky is better.",
"scrivi_altre": "Type a few more letters…",
"sqm_misurato": "Measured SQM (if you have a meter)",
"coordinate_sqm": "Manual coordinates and measured SQM",
"sqm_vuoto": "Leave empty if not measured",
"configurazione": "Configuration",
"come_stimiamo": "How do we estimate sky darkness?",
"cielo_satellite": "From David Lorenz's Light Pollution Atlas (2025), at this spot: SQM about {s} · LPI {l} (Bortle {b}). If you observe outside town, enter the site's coordinates or use your location.",
"vedi_atlante": "The spot on lightpollutionmap.info ↗",
"vedi_lorenz": "David Lorenz's map ↗",
"come_stimiamo_testo": "In and around Italy (from Provence to Albania, down to Malta and Lampedusa) we use David Lorenz's Light Pollution Atlas, updated to 2025 from the lights seen by satellites (VIIRS): one value about every 900 metres. For each spot it gives two numbers. SQM is the sky brightness at the zenith in magnitudes per square arcsecond: the higher it is, the darker the sky (22 is the natural sky, with no lights). LPI, the Light Pollution Index, tells you how many times artificial light exceeds the natural light of the sky: 0.1 means a tenth, 1 the same amount, 50 fifty times as much. The Bortle class is our own conversion from SQM. Outside this area we estimate the darkness from nearby towns (typical error ±0.4–0.5 magnitudes). The map doesn't account for altitude or the evening's haze: if you measure the sky with an SQM, enter your value above, in “Manual coordinates and measured SQM”.",
"cielo_stimato": "Estimated from nearby towns: SQM about {s} · LPI {l} (Bortle {b}). If you're outside town, in the countryside or in the mountains, choose your sky above.",
"cielo_misurato": "From your SQM: {s} mag/arcsec².",
"cielo_scelto": "Chosen by you.",
"usa_stima": "Use the estimate",
"stima_in_corso": "Estimating sky darkness…",
"cerca_filtro": "Search: L-eXtreme, ALP-T, Hα…",
"togli_filtro": "Remove this filter",
"oppure_tipo": "…or tap the type of filter you have:",
"usa_il_tuo": "✓ Use your {f}.",
"luna_nuova_ok": "Nearly new Moon: no interference.",
"luna_non_in_cielo": "Moon {k}% lit, but not up while the object is high: no interference.",
"luna_info": "Moon {k}% lit, {sep}° from the object; usable hours with the Moon up: {su}%.",
"luna_lontana_ok": "It's far enough away: you can shoot without narrowband filters too.",
"luna_con_cautela": "Without narrowband filters it's possible, but the sky background will be brighter: the Moon-free hours are better.",
"luna_vicina_no": "Too close and too bright: without a narrowband filter it isn't worth shooting.",
"corpo_sole": "Sun",
"tipo_pianeta": "Planet",
"tipo_sole": "Star (the Sun)",
"tipo_luna": "Satellite",
"alle": "at",
"illuminato": "illuminated",
"inquadra_breve": "Frame it",
"filtro_solare": "Solar filter",
"filtro_solare_n": "Certified full-aperture solar filter, in front of the telescope",
"ff_sole": "it's mandatory: certified, full-aperture, fitted IN FRONT of the telescope (and the finder). Never look at or image the Sun without one: instant damage to eyes and camera.",
"ff_luna": "usually not needed; in poor seeing an IR pass gives steadier images.",
"fv_luna": "visually, a Moon filter or a polariser cuts the glare.",
"ff_pianeta": "colour camera: UV/IR cut; mono camera or poor seeing: IR pass for luminance. You'll find the ideal focal ratio in the “Planetary imaging” calculator.",
"fv_pianeta": "visually, a filter isn't essential; colour filters help bring out belts and spots.",
"ff_stelle_luce": "clusters and double stars are bright: they image well even under a bright sky, with short exposures (with a colour camera a broadband light-pollution filter helps a little). No narrowband: it would remove the star colours.",
"ff_stelle_buio": "under a dark sky you need nothing else: star colours stay natural (with a colour camera a UV/IR cut is enough, if it doesn't already have one).",
"ff_brillante_citta": "you can still image it under this sky because the object is bright, but it takes many hours of exposure; from a darker sky it looks much better.",
"luna_lontana_cielo": "It's far enough away: here the local sky is the problem, not the Moon.",
"fm_clip": "clip-in: only for {m} cameras",
"fm_usa": "✓ Use your {f}",
"fm_anche": "Also fine: {f}.",
"fm_no": "Don't use: {f}.",
"fm_sho": "Hubble palette (SHO): one set with {s} ({bs}) plus one with {h} ({bh}), then combine them.",
"fm_p_debole": "the most selective one you have; with this much light, an Hα+OIII of 7 nm or less would give more contrast",
"fm_a_largo": "wider: more natural stars, a bit less contrast",
"fm_a_stretto": "narrower: more contrast, less colourful stars",
"fm_p5": "the most selective one you have: with this much light (sky and Moon) you need it",
"fm_p4": "blocks moonlight and light pollution well",
"fm_p3": "good balance between contrast and star colours",
"fm_p2": "under a dark sky this is enough, and stars stay more natural",
"fm_pl": "removes some light pollution without removing the object's light",
"fm_pl_buio": "under a dark sky you can do without it",
"fm_pm": "one band at a time: for SHO or HOO",
"fm_plrgb": "for true colours with a mono camera",
"fm_puv": "only blocks UV and infrared",
"fm_n_larga": "narrowband: it would block this object's own light",
"fm_n_ha": "without Hα",
"fm_n_debole": "band too wide for this much light",
"fm_n_clip": "clip-in for {m}: it won't fit your camera",
"fm_n_solo_ha": "Hα only",
"fm_veloce": "at f/{n} the band shifts and loses signal (it's made for f/{m} or slower)",
"fm_lento": "it's the version for fast optics: at f/{n} it performs a little worse",
"fm_vignetta": "1.25″ filter: it vignettes on your camera's large sensor",
"fm_b_dual": "Hα+OIII {nm} nm",
"fm_b_dual0": "Hα+OIII",
"fm_b_sii": "SII+OIII {nm} nm",
"fm_b_quad": "4 lines: Hβ, OIII, Hα, SII",
"fm_b_tri": "Hα, Hβ and OIII",
"fm_b_uhc": "UHC: wide Hβ, OIII and Hα",
"fm_b_larga": "broadband, against light pollution",
"fm_b_f2": "for fast optics (f/{a}–f/{b})",
"fm_b_ha": "Hα {nm} nm",
"fm_b_oiii": "OIII {nm} nm",
"fm_b_sii1": "SII {nm} nm",
"fm_b_lrgb": "L, R, G, B",
"fm_b_uvir": "blocks UV and IR",
"fm_b_irpass": "passes only infrared",
"fm_guida": "When to use your filters",
"fm_g_dual": "emission nebulae and supernova remnants, even with the Moon up and in the city; not for galaxies and clusters.",
"fm_g_sii": "together with an Hα+OIII for the Hubble palette (SHO); on its own, only for OIII-rich nebulae.",
"fm_g_quad": "emission nebulae under an average sky: more star colour than a dual-band; not for galaxies.",
"fm_g_uhc": "emission and planetary nebulae, visually too; less selective than a dual-band.",
"fm_g_larga": "galaxies, reflection nebulae and clusters under a slightly light-polluted sky; not needed under a dark sky.",
"fm_g_mono": "mono camera: one band at a time (SHO, HOO); on a colour camera only the red or the green-blue channel works.",
"fm_g_lrgb": "mono camera: true colours of galaxies, clusters and reflection nebulae.",
"fm_g_uvir": "sharper stars with refractors and lenses, when the camera doesn't already have one.",
"fm_g_irpass": "planets and the Moon when the seeing is mediocre.",
"fm_g_solare": "mandatory for the Sun.",
"fm_g_luna": "dims the Moon's glare for visual observing.",
"fm_g_hbeta": "visually, for the Horsehead and California nebulae.",
"pp_titolo": "Planetary imaging",
"pp_disco": "{n}: {p} px on the sensor",
"pp_disco_n": "disc {d}",
"pp_anelli": "rings {p} px",
"pp_non_entra": "doesn't fit on the sensor: mosaic of {x} × {y} panels",
"pp_f_ideale": "Ideal focal ratio with {px} µm pixels",
"pp_f_range": "f/{a} in mediocre seeing · f/{b} in excellent seeing",
"pp_ora_f": "you're now at f/{n}",
"pp_ok": "that's fine",
"pp_barlow": "a Barlow of about {k}× takes you to f/{n}",
"pp_troppo": "too high: remove the Barlow or use a lower-power one",
"pp_roi": "Recommended ROI",
"pp_roi_n": "a {w} × {h} px window is enough: the camera runs much faster",
"pp_alto": "Highest tonight",
"pp_opposizione": "Next opposition",
"pp_opposizione_n": "diameter {s}: the largest of the year",
"luna_io": "Io",
"luna_europa": "Europa",
"luna_ganimede": "Ganymede",
"luna_callisto": "Callisto",
"pp_lune": "Jupiter's moons",
"pp_lune_campo": "{n} of 4 in the field",
"pp_lune_ora": "at {o}",
"pp_est": "E",
"pp_ovest": "W",
"pp_davanti": "in front of the disc",
"pp_dietro": "behind the disc",
"cm_titolo": "What you need to photograph {o}",
"cm_tel": "Telescopes in the shop that suit your camera",
"cm_tel_aps": "Telescopes in the shop that suit an APS-C camera",
"cm_cam": "Cameras in the shop that suit your telescope",
"cm_riempie": "{o}: {p}% of the field",
"cm_prova": "Try it",
"cm_vedi": "View",
"cm_nessuno": "No suitable product in stock right now.",
"cm_nota": "In green: the object fills 30 to 80% of the field, so it fits entirely, with some sky around it.",
"cm_carico": "Searching the shop…",
"cm_aps": "APS-C (23.5 × 15.6 mm)",
"cm_cosa_serve": "What do I need?",
"tp_titolo": "How much exposure time you need",
"tp_buona": "Good image",
"tp_ottima": "Excellent image",
"tp_sub": "Sub-exposure",
"tp_npose": "about {n} sub-exposures for a good image",
"tp_con": "with your {f}",
"tp_con_tipo": "with {f}",
"tp_senza": "Without a filter",
"tp_buio": "From a dark sky (SQM {s})",
"tp_oltre": "over 100 h",
"tp_n": "Estimate for the average brightness of {o} with your setup, the sky {l_a} (SQM {s}) and tonight's Moon: the core comes through first, the faint parts later. Accurate to ±50%: seeing, transparency and processing matter too.",
"tp_stelle": "Clusters and double stars: short exposures (10–60 s) are enough to avoid saturating the stars; after 30–60 minutes the background is already clean.",
"tp_manca": "Choose a telescope and camera to estimate the exposure time.",
"tp_scuro": "Dark nebula: it only shows as a shadow against the star field, and it needs a very dark sky and many hours.",
"cd_condividi": "Share",
"cd_titolo": "Share the framing",
"cd_preparo": "Preparing the image…",
"cd_errore": "I can't prepare the image with the photo, so I'm making it with the map.",
"cd_campo": "Field",
"cd_scala": "Scale",
"cd_fatto": "Made with Giordano Astronomia's free tools",
"cf_confronta": "Compare with",
"cf_togli": "Remove the comparison",
"cf_nessuno": "no setup",
"cf_attuale": "Current",
"cf_riga": "Comparison",
"cf_piu_grande": "The field of {n} is {x} times wider.",
"cf_piu_piccolo": "The field of {n} is {x} times narrower.",
"cf_uguale": "{n} has almost the same field.",
"esp_titolo": "For N.I.N.A. and ASIAIR",
"esp_scarica": "Download CSV",
"esp_copia": "Copy",
"esp_n": "Telescopius CSV format: J2000 coordinates and position angle (from north towards east). In N.I.N.A. open it with “Import” in the simple sequencer; in ASIAIR, from Plan.",
"tab_attrezzatura": "Equipment",
"home_attrezzatura": "The telescopes, cameras, eyepieces, reducers, filters and mounts you own: enter them once and find them in every tool.",
"att_titolo": "My equipment",
"att_intro": "Enter what you own once. In Field of view and Tonight your gear shows up first: one tap and it's selected. Your filters are used to suggest which one to fit.",
"att_tel": "Telescopes and lenses",
"att_cam": "Cameras",
"att_oc": "Eyepieces",
"att_k": "Reducers and Barlows",
"att_filtri": "Filters",
"att_vuoto_tel": "No telescopes yet: search for one below or enter it manually.",
"att_vuoto_cam": "No cameras yet: search for one below or enter it manually.",
"att_vuoto_oc": "No eyepieces.",
"att_vuoto_k": "No reducers or Barlows.",
"att_nessuno": "Still empty: start with the telescope.",
"att_a_mano": "Can't find it? Enter it manually",
"att_nome": "Name (optional)",
"att_aggiungi_btn": "Add",
"att_fattore": "Or just pick the number (e.g. 0.8× or 2×)",
"att_aggiungi": "Add to my equipment",
"att_aggiunto": "In your equipment",
"att_tua": "From your equipment:",
"att_togli": "Remove",
"att_cerca_k": "Search: 0.8×, Askar, Barlow 2×…",
"att_setup_n": "A setup is a ready-made combination of telescope, reducer and camera (or eyepiece): put it together below from your gear and save it with a name. Then you call it up with one tap in Field of view, Tonight and the calculators. The pencil ✎ lets you change the parts or the name.",
"att_prova": "Open Field of view",
"att_link": "Take it to another device",
"att_link_n": "Without an account it stays saved only in this browser: to have it on your phone (or computer) too, copy the link and open it there.",
"att_copia_link": "Copy the link",
"att_import": "This link contains equipment: {r}.",
"att_import_si": "Add it to mine",
"att_import_no": "No, thanks",
"att_importata": "Done: it's now in your equipment.",
"att_recuperati": "We found {n} filters that had been left inside your setups.",
"att_modifica": "Edit your equipment",
"att_svuota": "Clear all",
"att_svuota_n": "Deletes telescopes, cameras, eyepieces, reducers, mounts, filters and setups from this device",
"att_svuota_sicuro": "Sure? Tap again to delete everything",
"att_svuotata": "Done: equipment, filters and setups deleted. You're starting from scratch.",
"as_titolo": "Fill in with the assistant",
"as_apri": "Fill in with the assistant",
"as_ciao": "Hi! Tell me what you have: telescopes, reducers, cameras, eyepieces and filters. You can type it all at once, or tap the microphone and say it.",
"as_hai_gia": "You already have: {r}. Tell me what you'd like to add.",
"as_esempio": "For example: “Askar 71F with 0.8 reducer, ZWO ASI2600MC Pro, L-eXtreme and UHC filters”",
"as_segnaposto": "Type what you have here…",
"as_invia": "Send",
"as_voce": "Speak",
"as_ascolto": "Listening…",
"as_capito": "Here's what I understood. Untick anything that's wrong, or pick the right model:",
"as_non_capito": "I didn't recognise this: “{s}”. Try brand and model.",
"as_niente": "I didn't recognise anything. Type brand and model, for example “Sky-Watcher Evostar 80ED” or “Canon EOS 6D”.",
"as_aggiungi": "Add to my equipment",
"as_fatto": "✓ Done! Now you have: {r}.",
"as_va_bene": "All right.",
"as_chiedi_tel": "Which telescope (or camera lens) do you use?",
"as_chiedi_cam": "Which camera do you image with? If you only observe visually, tell me which eyepieces you have.",
"as_chiedi_filtri": "Do you have any filters? Type their names (or just the type, like “UHC” or “dual-band”), or “no”.",
"as_finito": "Perfect, your equipment is ready: in Field of view and in “What to see” you'll find your gear above the search boxes.",
"as_salva_setup": "Also save the setup “{n}”",
"as_setup_ok": "Setup “{n}” saved ✓",
"as_apri_campo": "Open Field of view",
"as_tipo_tel": "Telescope",
"as_tipo_cam": "Camera",
"as_tipo_oc": "Eyepiece",
"as_tipo_k": "Reducer/Barlow",
"as_tipo_f": "Filter",
"as_altri_modelli": "{n} other models…",
"as_altri_modelli_1": "One other model…",
"as_cambia_modello": "Change model",
"as_gia": "already in your equipment",
"as_a_mano": "entered manually",
"as_solo_tipo": "type only",
"as_ricomincia": "Start over",
"as_ricomincia_n": "Clear the conversation and start again (your equipment stays)",
"cb_titolo": "Where to go tonight for a darker sky",
"cb_n": "The darkest spots on land within the distance you choose, from David Lorenz's Light Pollution Atlas (2025), with tonight's forecast clouds.",
"cb_raggio": "Within",
"cb_cerca": "Find dark skies",
"cb_carico": "Looking for the darkest spots…",
"cb_nessuno": "Within this distance there's no sky darker than yours.",
"cb_fuori": "The darkness map covers Italy and its surroundings: there's no data here.",
"cb_vicino": "near {p}",
"cb_dir": "{km} km {d}",
"cb_nuvole": "clouds tonight {p}%",
"cb_meteo_no": "weather not available",
"cb_usa": "Use this location",
"cb_mappa": "Map",
"cb_qui": "you are here",
"cb_avviso": "Check on a map that you can get there safely and that you're allowed to be there at night. The darkness values come from David Lorenz's atlas (2025), based on night lights seen by satellite, and the satellite barely detects white LEDs: near towns the sky may be a little brighter.",
"cb_nome": "Dark sky near {p}",
"cb_nome_senza": "Dark sky {km} km away",
"cb_ora_sqm": "Where you are: SQM {s} · LPI {l}",
"pn_titolo": "Night plan",
"pn_vuoto": "In “What to see”, tap “+ Plan” on objects: we'll line them up here across the dark hours, with times.",
"pn_aggiungi": "+ Plan",
"pn_nel_piano": "✓ In the plan",
"pn_basso": "doesn't rise above {h}° during darkness",
"pn_stampa": "Print",
"pn_copia": "Copy",
"pn_nina": "Download for N.I.N.A.",
"pn_svuota": "Clear",
"pn_n": "Order: objects that set earliest come first. Times in your device's time zone.",
"pn_alt": "{h}° high",
"pn_testa": "Night plan for {d} · {l}",
"pn_tot": "{n} objects · {t} of darkness",
"tab_diario": "My log",
"home_diario": "The objects you've observed and imaged, and the 110-object Messier challenge.",
"dr_titolo": "My observing log",
"dr_n": "Mark the objects you've observed through the eyepiece or imaged: you'll find them here with the date.",
"dr_visto": "Observed",
"dr_foto": "Imaged",
"dr_vuoto": "Nothing yet: tap “Observed” or “Imaged” on an object in “What to see”, or the Messier boxes below.",
"dr_conta": "Observed: {v} · imaged: {f}",
"dr_togli": "Remove from log",
"dr_apri": "Open",
"dr_esporta": "Download the log (CSV)",
"dr_messier": "The Messier challenge",
"dr_messier_n": "The 110 objects in Charles Messier's catalogue (1781). One tap = observed, two = imaged too, three = remove. On a spring night you can see almost all of them: it's the “Messier marathon”.",
"dr_progresso": "Observed: {n} of 110 · imaged: {f}",
"dr_legenda_v": "observed",
"dr_legenda_f": "imaged",
"dr_traguardo": "Milestone: {n} Messier objects!",
"dr_prossimo": "Next milestone: {n}",
"dr_finito": "All 110: congratulations, challenge complete!",
"dr_vista_t": "observed on {d}",
"dr_foto_t": "imaged on {d}",
"dr_vai_stanotte": "Find what to see tonight →",
"tab_lunasole": "Moon, Sun & planets",
"oggi": "Today",
"bl_cielo": "sky SQM {s} · LPI {l} (Bortle {b})",
"bl_cielo_mis": "measured SQM {s} (Bortle {b})",
"ls_luna": "The Moon",
"ls_sole": "The Sun",
"fase_nuova": "New Moon",
"fase_crescente": "Waxing crescent",
"fase_primo": "First quarter",
"fase_gibbosa_cresc": "Waxing gibbous",
"fase_piena": "Full Moon",
"fase_gibbosa_cal": "Waning gibbous",
"fase_ultimo": "Last quarter",
"fase_calante": "Waning crescent",
"ls_illuminata": "illuminated",
"ls_eta": "Age",
"ls_giorni": "days",
"ls_distanza": "Distance",
"ls_diametro": "Apparent diameter",
"ls_sorge": "Rises",
"ls_culmina": "Highest point",
"ls_tramonta": "Sets",
"ls_nessuno": "not today",
"ls_az": "az. {a}°",
"ls_alta": "{h}° high",
"ls_perigeo": "Close to Earth (perigee): larger and brighter than usual.",
"ls_apogeo": "Far from Earth (apogee): smaller than usual.",
"ls_foto_nasa": "NASA image for {o}: true phase, libration and size, north up.",
"ls_disegno": "Drawing of the phase at {o}, north up.",
"ls_inquadra_luna": "Frame the Moon",
"ls_inquadra_sole": "Frame the Sun",
"ls_mezzogiorno": "Solar noon",
"ls_durata_giorno": "Day length",
"ls_alt_mezzogiorno": "Altitude at noon",
"ls_grafico": "Sun and Moon over 24 hours",
"ls_grafico_n": "Altitude of the Sun and Moon above the horizon; the background shows day, golden hour, blue hour, twilights and night.",
"ls_fasi": "Next phases",
"ls_crepuscoli": "Twilight, golden hour and blue hour",
"ls_mattina": "Morning",
"ls_sera": "Evening",
"ls_crep_astro": "Astronomical twilight",
"ls_crep_nautico": "Nautical twilight",
"ls_crep_civile": "Civil twilight",
"ls_ora_blu": "Blue hour",
"ls_ora_oro": "Golden hour",
"ls_crep_n": "True night only once the Sun is more than 18° below the horizon. Blue hour: Sun between −6° and −4°; golden hour: between −4° and +6°, the favourite light for landscapes.",
"ls_calendario": "Moon calendar",
"ls_calendario_n": "Every night: the phase and the dark hours without the Moon. In green, the best nights for galaxies and nebulae. Tap a day to select it.",
"ls_senza_luna": "{h} of moonless darkness",
"ls_mese_prec": "Previous month",
"ls_mese_succ": "Next month",
"ls_giorno": "Day",
"ls_notte": "Night",
"ls_sole_adesso": "The Sun now, from the SDO satellite (NASA)",
"ls_sole_adesso_n": "Images updated about every 15 minutes. To look at or photograph the Sun you always need a certified solar filter in front of the telescope.",
"ls_sdo_macchie": "Sunspots (visible light)",
"ls_sdo_304": "Chromosphere and prominences (304 Å, similar to H-alpha)",
"ls_negozio_solare": "H-alpha telescopes and solar filters in the shop →",
"ls_crediti": "Images: Moon NASA Scientific Visualization Studio · Sun NASA/SDO and the AIA and HMI science teams.",
"ls_legenda_sole": "Sun",
"ls_legenda_luna": "Moon",
"ev_titolo": "Upcoming sky events",
"ev_n": "For your location, over the next 12 months. Tap an event to select its day.",
"ev_meteore": "up to {z} meteors an hour at the peak",
"ev_luna_ok": "Moon {p}% lit: excellent night",
"ev_luna_media": "Moon {p}% lit: fair night",
"ev_luna_no": "Moon {p}% lit: interferes",
"ev_opposizione": "{p} at opposition",
"ev_opposizione_n": "diameter {d}″: the best time to observe and image it",
"ev_equ_prim": "Spring equinox",
"ev_sol_est": "Summer solstice",
"ev_equ_aut": "Autumn equinox",
"ev_sol_inv": "Winter solstice",
"ev_stagione": "at {o}",
"ev_superluna": "Supermoon",
"ev_superluna_n": "Full Moon at {km} km: larger and brighter",
"ev_ecl_tot": "Total lunar eclipse",
"ev_ecl_parz": "Partial lunar eclipse",
"ev_ecl_pen": "Penumbral lunar eclipse",
"ev_ecl_n": "maximum at {o} · {v}",
"ev_visibile": "visible from here (Moon {h}° high)",
"ev_non_visibile": "from here the Moon is below the horizon",
"ev_ecl_pen_n": "barely noticeable: one edge of the Moon darkens",
"ev_tutti": "Show all ({n})",
"ev_ecl_sole": "Solar eclipse",
"ev_ecl_sole_n": "Partial from Italy around 11 am: from 55% in the north to almost 100% on Lampedusa; total in southern Spain and North Africa. You need a certified solar filter.",
"sciame_QUA": "Quadrantids",
"sciame_LYR": "Lyrids",
"sciame_ETA": "Eta Aquariids",
"sciame_SDA": "Delta Aquariids",
"sciame_PER": "Perseids",
"sciame_DRA": "Draconids",
"sciame_ORI": "Orionids",
"sciame_LEO": "Leonids",
"sciame_GEM": "Geminids",
"sciame_URS": "Ursids",
"ev_cal": "Add to calendar",
"ev_cal_tutti": "Add all to calendar",
"ev_cal_da": "From the Giordano Astronomia tools",
"ev_cal_apple": "Device calendar (iPhone, Android, Mac)",
"ev_cal_google": "Google Calendar",
"ev_cal_outlook": "Outlook",
"ev_cal_no": "Calendar didn't open?",
"ev_cal_iscriviti": "Subscribe to the calendar",
"ev_cal_iscriviti_n": "Works from any app: tap “Subscribe”, then “Add”.",
"ev_cal_safari": "Open in Safari and add to Calendar",
"ev_cal_tutti_safari": "Add all (opens Safari)",
"ev_cal_qui": "Add to iPhone Calendar",
"ev_cal_tutti_n": "All upcoming sky events",
"tab_planetario": "Sky chart",
"pl_cielo_sopra": "The sky {l_sopra}",
"pl_adesso": "Now",
"pl_meno": "−1 h",
"pl_piu": "+1 h",
"pl_avvia": "Run through the hours",
"pl_ferma": "Stop",
"pl_gira": "Rotate the chart",
"pl_in_basso": "at the bottom: {d}",
"pl_nomi": "Names",
"pl_linee": "Constellations",
"pl_messier": "Messier objects",
"pl_istruzioni": "The centre is the point above your head (zenith), the edge is the horizon. Hold the chart above your head with the direction you're facing at the bottom. Tap a star, planet or object to see its name.",
"pl_giorno": "It's daytime: you can't see the stars, but here's where they are.",
"pl_crepuscolo": "Twilight: only the brightest stars are visible.",
"pl_notte": "Night",
"pl_alt_az": "alt. {h}° · az. {a}°",
"pl_mag": "mag {m}",
"pl_inquadra": "Frame it →",
"pl_visibili": "Planets and Moon above the horizon",
"pl_nessuno": "No planets above the horizon at this time.",
"pl_scelto": "Object chosen in Field of view",
"pl_card": "N|E|S|W",
"pl_dir": "north|east|south|west",
"pl_sole": "Sun",
"tab_meteo": "Weather",
"me_titolo": "Stargazing forecast",
"me_carico": "Loading the forecast…",
"me_errore": "The forecast didn't load: try again shortly.",
"me_stanotte": "Tonight",
"me_buio_da_a": "dark from {a} to {b}",
"me_ore_buone": "{n} good hours",
"me_finestra": "from {a} to {b}",
"me_nessuna": "no good hours",
"me_nuvole_medie": "average cloud cover {p}%",
"me_condensa": "Dew risk from {o}: keep your dew heaters on.",
"me_vento": "Strong wind from {o}: careful with long exposures.",
"me_luna_su": "Moon ({p}%) in the sky until {o}",
"me_luna_sorge": "Moon ({p}%) rises at {o}",
"me_luna_no": "Moon below the horizon for all the dark hours",
"me_ora": "Time",
"me_giudizio": "Sky",
"me_nuvole": "Clouds",
"me_basse": "low",
"me_medie": "mid",
"me_alte": "high",
"me_nebbia": "Fog",
"me_pioggia": "Rain",
"me_umidita": "Humidity",
"me_rugiada": "T − dew point",
"me_temp": "Temperature",
"me_vento_r": "Wind",
"me_buio": "Darkness",
"me_luna": "Moon",
"me_legenda": "Sky: green ✓ = excellent for observing, yellow ~ = fair, red ✕ = no. Clouds in %: low and mid clouds block the sky, high ones (thin veils) reduce transparency. “T − dew point” below 2 °C = dew on the optics.",
"me_notti": "The next few nights",
"me_notti_n": "For each night: average cloud during the hours of true darkness, and the Moon.",
"me_sereno": "clear",
"me_poco": "partly cloudy",
"me_nuvoloso": "cloudy",
"me_coperto": "overcast",
"me_cielo_ora": "Clouds and rain",
"me_cielo_ora_n": "The last 3 hours from the infrared satellite (clouds show up even at night: brighter = higher and colder) with the rain radar, then the hour-by-hour cloud forecast. The gold dot is your location.",
"me_satellite": "Satellite",
"me_radar": "Radar",
"me_coste": "Coastlines",
"me_radar_solo_it": "The radar only covers Italy.",
"me_seeing": "Seeing and transparency",
"me_seeing_n": "There's no reliable free source for seeing (turbulence) in Italy: check the specialist sites, with links already set to your coordinates.",
"me_buio_sqm": "Local sky darkness: SQM {s} (Bortle {b}), without the Moon.",
"me_crediti": "Forecast: MET Norway (CC BY 4.0) · Satellite: © EUMETSAT 2026, Meteosat MTG (EUMETView) · Radar: Radar-DPC, Italian Civil Protection Department (CC BY-SA 4.0) · Coastlines: Natural Earth.",
"me_anticondensa": "Dew heaters and power supplies in the shop →",
"me_agg": "updated at {o}",
"me_t_sat": "Satellite at {o}",
"me_t_radar": "radar from the last few minutes",
"me_t_prev": "Forecast for {g} at {o}",
"me_adesso": "Now",
"me_play": "Play",
"me_pausa": "Pause",
"me_prev_carico": "Loading the cloud forecast…",
"me_prev_errore": "The cloud forecast didn't load.",
"me_prev_n": "Forecast clouds (MET Norway, points every 2°: small clouds and isolated storms don't show).",
"me_prev_qui": "At your location: clouds {p}% (low {b} · mid {m} · high {a}) · rain {r} mm",
"me_indietro": "Step back",
"me_avanti": "Step forward",
"tab_home": "All tools",
"home_strumenti": "Tools",
"home_titolo": "What would you like to do?",
"home_campo": "Choose a telescope and camera and see what fits on the sensor, on a real photo of the sky.",
"home_stanotte": "Tonight's best objects from your location, with the Moon and the dark hours.",
"home_meteo": "Hour-by-hour clouds, dew and wind, satellite and radar.",
"home_planetario": "The whole sky above you, hour by hour, with the planets and the Moon.",
"home_lunasole": "Moon phases, the month's dark nights, sunrise, sunset and twilight.",
"home_camere": "Astronomy cameras, DSLRs and mirrorless cameras compared.",
"home_calcolatori": "For observing, imaging, mounts and guiding, sky and weather: with your equipment and the shop's products.",
"home_software": "Software for capture and processing, with the official links.",
"home_vivo_setup": "Your setup: {s}",
"home_vivo_buio": "True darkness from {a} to {b}",
"home_vivo_meteo": "{n} good hours tonight · clouds {p}%",
"home_vivo_meteo_no": "No good hours tonight · clouds {p}%",
"home_vivo_pianeti": "{p} up at 22:00",
"home_vivo_nessuno": "No planets up at 22:00",
"home_vivo_camere": "{n} cameras in the database",
"home_vivo_software": "Capture, guiding, processing, planetarium",
"home_vivo_calc": "{n} calculators ready to use",
"home_chiudi": "Close",
"leggi_tutto": "Read more ▾",
"leggi_meno": "Show less ▴",
"qz_titolo": "Which telescope is right for me?",
"qz_n": "Five questions and we'll recommend three telescopes from the shop, with the reasons why.",
"qz_via": "Start",
"qz_indietro": "Back",
"qz_ricomincia": "Retake the quiz",
"qz_passo": "Question {n} of 5",
"qz_d_uso": "What would you like to do?",
"qz_uso_visuale": "Look at the sky through an eyepiece",
"qz_uso_pianeti": "Planets and the Moon",
"qz_uso_deep": "Photograph nebulae and galaxies",
"qz_uso_tutto": "A bit of everything",
"qz_uso_semplice": "Keep it simple: take photos controlling everything from my phone",
"qz_d_budget": "How much do you want to spend?",
"qz_b_300": "Up to €300",
"qz_b_700": "€300–700",
"qz_b_1500": "€700–1,500",
"qz_b_3000": "€1,500–3,000",
"qz_b_max": "Over €3,000",
"qz_d_esp": "How much experience do you have?",
"qz_e_prima": "It's my first telescope",
"qz_e_ho": "I've used one before",
"qz_e_esperto": "I'm experienced",
"qz_d_luogo": "Where do you observe from?",
"qz_l_citta": "From a balcony or garden, in town",
"qz_l_auto": "I take it by car to a dark site",
"qz_l_fisso": "I have a permanent setup",
"qz_d_peso": "How much does weight matter?",
"qz_p_leggero": "Light and easy to carry",
"qz_p_ok": "Big and heavy is fine too",
"qz_risultato": "The right telescopes for you",
"qz_nessuno": "With these answers we can't find a telescope in stock: try raising your budget.",
"qz_vedi": "View in the shop",
"qz_prova": "Try it in Field of view",
"qz_solo_tubo": "Tube only: you'll also need a mount and a camera.",
"qz_carico": "Find the right mount",
"qz_r_smart": "Smart telescope: telescope, camera and mount in one, controlled from your phone, with a photo in a few minutes.",
"qz_r_dobson": "{d} mm Dobsonian: loads of light for the price, sets up in a minute and shows galaxies, nebulae and planets.",
"qz_r_goto": "Full GoTo: finds objects by itself and tracks them, handy even from a balcony.",
"qz_r_pianeti": "Long focal length (f/{n}): big, sharp images of the planets and the Moon.",
"qz_r_apo": "Apochromatic refractor f/{n}: sharp stars and true colours, the most popular tube for deep-sky photos.",
"qz_r_astro": "Astrograph f/{n}: lots of light and a wide field for nebulae.",
"qz_r_leggero": "Compact and light.",
"qz_r_grande": "{d} mm aperture: more detail and fainter objects.",
"qz_e_entry": "Designed for beginners: complete with mount and accessories.",
"tab_scegli": "Which to choose?",
"qz_banner_t": "Not sure which telescope to choose?",
"qz_banner_b": "Take the quiz",
"qz_banner_d": "Answer 5 easy questions: we'll suggest 3 in-stock telescopes from our shop and explain why. There's also a quiz for cameras and mounts.",
"qz_intro": "The easiest way to choose a telescope, camera or mount: answer five questions and we'll suggest the right in-stock products from our shop, and tell you why.",
"qz_p1": "5 questions, one minute",
"qz_p2": "In-stock products only",
"qz_p3": "The reason behind every pick",
"qz_le_tue": "Your answers (tap to change)",
"qz_primo": "Top pick",
"qz_n_pos": "#{n}",
"qz_come": "How we choose",
"qz_come_t": "You want to observe the sky and you're just starting out: a Dobsonian, a reflecting telescope on a base you turn by hand. For the same price it has the biggest mirror, so it shows more. If you observe from a balcony, a small telescope with automatic pointing (GoTo) is better, as it finds objects by itself.|You want good views of the planets and the Moon: a telescope with a long focal length, which magnifies more, and the largest aperture possible, which shows more detail.|You want to photograph nebulae and galaxies and you're just starting out: a smart telescope (like Seestar or Dwarf), with telescope, camera and mount in a single unit, controlled from your phone.|You want to take photos and already have experience: an apochromatic refractor, which gives sharp stars and true colours, on a motorised mount that tracks the sky.",
"qz_come_n": "We only suggest telescopes in stock right now, at today's price.",
"qz_hai_gia": "Already have a telescope? Add it to your equipment",
"qz_cosa_vedo": "What you'll see",
"qz_da_zero": "Start over",
"tc_titolo": "Compare telescopes",
"tc_i": "Up to three telescopes from our shop side by side: what they show, how much they weigh and what they cost. The field is calculated with your camera and your eyepiece.",
"tc_cerca": "Add: Dobson 200, Seestar…",
"tc_vuoto": "Add two or three telescopes to compare, or tap “Compare” in the quiz results.",
"tc_tipo": "Type",
"tc_ottica": "Aperture and focal length",
"tc_montatura": "Mount",
"tc_luce": "Light grasp",
"tc_dettagli": "Finest detail",
"tc_stelle": "Faintest stars",
"tc_ingr": "Maximum magnification",
"tc_campo_cam": "Field with {c}",
"tc_campo_sua": "built-in camera",
"tc_campo_oc": "With {o}",
"tc_peso": "Weight",
"tc_prezzo": "Price",
"tc_m_goto": "included, GoTo",
"tc_m_entry": "included, manual",
"tc_m_dobson": "Dobsonian base included",
"tc_m_smart": "all built in",
"tc_m_tubo": "tube only",
"tc_meglio": "The best in each row is in gold. Light, detail and stars depend on aperture: the bigger it is, the more you see.",
"tc_disp": "in stock",
"tc_nodisp": "out of stock",
"tc_togli": "Remove from comparison",
"tc_confronta": "Compare",
"tc_nel": "✓ Added to comparison",
"tc_tutti": "Compare these three",
"tc_oc_tipico": "a 25 mm eyepiece",
"tc_prova": "Try in Field of view",
"tc_t_rifrattore_apo": "Apochromatic refractor",
"tc_t_rifrattore": "Refractor",
"tc_t_newton": "Newtonian",
"tc_t_dobson": "Dobsonian",
"tc_t_sc": "Schmidt-Cassegrain",
"tc_t_mak": "Maksutov",
"tc_t_rc": "Ritchey-Chrétien",
"tc_t_coassiale": "Catadioptric",
"tc_t_smart": "Smart telescope",
"tc_t_solare": "Solar telescope",
"tc_t_guida": "Guide scope",
"tc_t_altro": "Telescope",
"kit_titolo": "The complete kit",
"kit_i": "What you need to get started, chosen from in-stock products in our shop. Untick anything you already have.",
"kit_per": "Kit for",
"kit_carico": "Building your kit…",
"kit_r_tel": "The telescope",
"kit_r_oc_medio": "Eyepiece for galaxies, nebulae and clusters ({m}×)",
"kit_r_oc_pianeti": "Eyepiece for planets and the Moon ({m}×)",
"kit_r_barlow": "2× Barlow: doubles the magnification of every eyepiece",
"kit_r_luna": "Moon filter: the full Moon won't dazzle you",
"kit_r_neb": "Nebula filter: nebulae stand out even with a little light around",
"kit_r_mont": "Motorised mount: carries tube, camera and accessories ({p} kg payload)",
"kit_r_cam": "Colour camera: {s}″/px with this tube",
"kit_r_spian": "Flattener or reducer: round stars right into the corners",
"kit_r_filtro": "Dual-band filter: nebulae even from city skies",
"kit_n_spian": "Many apochromats need a dedicated flattener: ask us for the right one for this tube.",
"kit_n_pc": "To control the camera and mount you'll also need a computer or an ASIAIR.",
"kit_n_smart": "Nothing else needed: camera, mount and filters are built in, and you control it from your phone.",
"kit_n_incluso": "The mount and a basic eyepiece are already in the box.",
"kit_totale": "Total",
"kit_pezzi": "{n} products",
"kit_carrello": "Add all to cart",
"kit_fatto": "✓ In your cart",
"kit_vai": "Go to cart →",
"kit_errore": "Couldn't add them: try again or add them from their product pages.",
"kit_nessuno": "no suitable product in stock right now",
"qc_titolo": "Which camera is right for me?",
"qc_n": "Five questions and we'll suggest three cameras from our shop, chosen for your telescope and your sky.",
"qc_d_uso": "What do you want to photograph?",
"qc_uso_deep": "Nebulae and galaxies",
"qc_uso_pianeti": "Planets, Moon and Sun",
"qc_uso_entrambi": "A bit of everything",
"qc_uso_guida": "I need a guide camera",
"qc_d_tel": "With which telescope?",
"qc_tel_mio": "Mine: {n}",
"qc_tel_corto": "Lens or short telescope (up to 500 mm)",
"qc_tel_medio": "Medium telescope (500–1200 mm)",
"qc_tel_lungo": "Long focal length (over 1200 mm)",
"qc_tel_nonso": "I don't know yet",
"qc_d_col": "Colour or black and white?",
"qc_col_colore": "Colour: a single shot, simpler",
"qc_col_mono": "Monochrome with filters: more detail",
"qc_col_nonso": "You choose for me",
"qc_d_budget": "How much do you want to spend on the camera?",
"qc_b_300": "Up to €300",
"qc_b_800": "€300–800",
"qc_b_1600": "€800–1,600",
"qc_b_max": "Over €1,600",
"qc_d_esp": "How experienced are you?",
"qc_e_prima": "It's my first astro camera",
"qc_e_ho": "I've used one before",
"qc_e_esperto": "I'm experienced",
"qc_risultato": "The right cameras for you",
"qc_nessuno": "With these answers we can't find a camera in stock: try raising your budget.",
"qc_r_sensore": "{s} sensor: {mp} MP, {px} µm pixels",
"qc_r_scala": "{s}″/px with {t}: {g}",
"qc_r_raff": "Cooled: much less noise in long exposures",
"qc_r_nonraff": "Uncooled: light and simple, good for short exposures and planets",
"qc_r_planet": "Fast with small pixels: lots of frames per second for the planets",
"qc_r_guida": "Sensitive and light: made for autoguiding",
"qc_r_colore": "Colour: no filter wheel, one shot and you have your photo",
"qc_r_mono": "Monochrome: more detail and narrowband, with filters",
"qc_g_ok": "good sampling",
"qc_g_sovra": "a bit too fine, you can use binning",
"qc_g_sotto": "wide field, slightly blocky stars",
"qc_principale": "The camera",
"qc_k_dual": "Dual-band filter: nebulae even from city skies",
"qc_k_ha": "Hα filter for nebulae",
"qc_k_oiii": "OIII filter",
"qc_k_sii": "SII filter",
"qc_k_barlow": "Barlow to reach the right focal ratio for the planets",
"qc_k_uvir": "UV/IR cut filter: true colours and sharper stars",
"qc_k_guida": "Matching guide scope",
"qc_n_ruota": "For the mono camera's filters you'll also need a filter wheel.",
"qc_n_pc": "To control it you need a computer or an ASIAIR.",
"qc_vedi": "View in the shop",
"qc_prova": "Try it in Field of view",
"qm_titolo": "Which mount is right for me?",
"qm_n": "Five questions and we'll suggest three mounts from our shop that can really carry your telescope.",
"qm_d_carico": "What will you put on it?",
"qm_c_mio": "Mine: {n} (about {kg} kg)",
"qm_c_smart": "Smart telescope or lens (up to 3 kg)",
"qm_c_piccolo": "Small refractor (3–6 kg)",
"qm_c_medio": "Medium telescope (6–12 kg)",
"qm_c_grande": "Large telescope (12–20 kg)",
"qm_c_molto": "Over 20 kg",
"qm_d_uso": "What will you use it for?",
"qm_uso_visuale": "For observing",
"qm_uso_foto": "For deep-sky imaging",
"qm_uso_entrambi": "For both",
"qm_d_dove": "How much will you move it around?",
"qm_dove_fisso": "Fixed spot or garden",
"qm_dove_auto": "I take it by car",
"qm_dove_viaggio": "Travelling, even by plane",
"qm_d_budget": "How much do you want to spend on the mount?",
"qm_b_600": "Up to €600",
"qm_b_1500": "€600–1,500",
"qm_b_3000": "€1,500–3,000",
"qm_b_max": "Over €3,000",
"qm_d_esp": "How experienced are you?",
"qm_e_prima": "It's my first mount",
"qm_e_ho": "I've used one before",
"qm_e_esperto": "I'm experienced",
"qm_risultato": "The right mounts for you",
"qm_nessuno": "With these answers we can't find a mount in stock: try changing the load or budget.",
"qm_r_portata": "Carries {p} kg{cp} · your {c} kg load: {u}% of capacity",
"qm_r_cp": " ({p} kg with counterweight)",
"qm_r_armonica": "Harmonic drive: no counterweights, light to carry",
"qm_r_eq": "Equatorial: sturdy and precise for long exposures",
"qm_r_altaz": "Alt-az: simple and quick for observing (not for long exposures)",
"qm_r_goto": "GoTo: finds objects by itself and tracks them",
"qm_r_leggera": "Weighs {kg} kg: easy to carry",
"qm_principale": "The mount",
"qm_k_guida": "Guide scope: pinpoint stars in long exposures",
"qm_k_camguida": "Guide camera",
"qm_n_treppiede": "Sold without a tripod: you also need a tripod or a pier.",
"qm_n_guida": "For polar alignment and guiding you need a computer with PHD2 or an ASIAIR.",
"qm_calcola": "Calculate the load",
"qx_tipo": "What do you want to choose?",
"qx_telescopio": "Telescope",
"qx_camera": "Camera",
"qx_montatura": "Mount",
"xi_intro": "{n} calculators for observing and imaging the sky. Pick one: the values are pre-filled from your setup and the products in our shop.",
"xi_cerca": "Search: pupil, ″/px, Bortle, dust…",
"xi_tutti": "All",
"xi_nessuno": "No calculators match these words.",
"xi_indice": "All calculators",
"xi_altri": "More calculators · {g}",
"xi_recenti": "Recently used",
"riduttore_barlow": "Reducer or Barlow",
"xg_osserva": "Observing",
"xg_foto": "Imaging",
"xg_montatura": "Mount and guiding",
"xg_cielo": "Sky and weather",
"xn_telescopio": "What your telescope can do",
"xd_telescopio": "Light grasp, finest detail, faintest stars and useful magnifications.",
"xn_oculare": "Magnification and field",
"xd_oculare": "With your eyepiece: magnification, true field and exit pupil.",
"xn_oculari": "The right eyepieces",
"xd_oculari": "The focal lengths your telescope needs, with eyepieces from our shop.",
"xn_binocolo": "Binoculars",
"xd_binocolo": "Exit pupil, brightness, twilight factor and field at 1000 m.",
"xn_vista": "What you'll see in the eyepiece",
"xd_vista": "Saturn, the Moon, M13 or M42 as they look with your telescope and eyepiece.",
"xn_confronta": "Compare telescopes",
"xd_confronta": "Two or three telescopes from our shop side by side: light, detail, field, weight and price.",
"xn_campionamento": "Ideal focal length and sampling",
"xd_campionamento": "How many ″/px you get with your telescope and camera, and whether that suits your sky's seeing (also with binning and a Barlow).",
"xn_posa": "Sub-exposure length",
"xd_posa": "How long your exposures should be with your sky, camera and filter.",
"xn_integrazione": "Integration and disk space",
"xd_integrazione": "Total exposure hours and how many GB the files take up.",
"xn_planetario": "Planetary imaging",
"xd_planetario": "The right focal ratio for the camera, the Barlow you need and how big Jupiter will be.",
"xn_npf": "Nightscapes",
"xd_npf": "Maximum exposure on a tripod without trailed stars: NPF and 500 rules.",
"xn_rotazione": "Field rotation",
"xd_rotazione": "Maximum exposure on an alt-az mount or a smart telescope.",
"xn_cfz": "Critical focus zone",
"xd_cfz": "How tight focus is and how many degrees of temperature change before you need to refocus.",
"xn_filtri": "Filter size",
"xd_filtri": "1.25″, 31 mm, 36 mm or 2″: the smallest filter that won't vignette.",
"xn_polvere": "Dust on the sensor",
"xd_polvere": "From the doughnuts in your flats: which glass the dust is on.",
"xn_carico": "Mount load",
"xd_carico": "Setup weight and payload, with suitable mounts from our shop.",
"xn_guida": "Guide scope",
"xd_guida": "Guide scope or off-axis guider: the ratio between the two image scales.",
"xn_backfocus": "Backfocus spacing",
"xd_backfocus": "How many spacers you need between flattener and camera.",
"xn_polare": "Polaris in the polar scope",
"xd_polare": "Where to put Polaris right now, for your location.",
"xn_condensa": "Dew risk",
"xd_condensa": "Dew point and how likely your optics are to fog up.",
"xn_cielo": "Sky quality",
"xd_cielo": "SQM, Bortle, naked-eye stars and background brightness.",
"bf_titolo": "Backfocus spacing",
"bf_i": "How many spacers you need between the flattener (or reducer) and the camera, with filter wheel and off-axis guider.",
"bf_ottica": "Backfocus of the optics",
"bf_pezzi": "In the imaging train",
"bf_vetro": "Glass thickness",
"bf_mm": "mm",
"bf_aggiungi": "+ Another part",
"bf_pezzo": "Part",
"bf_spessore": "Thickness",
"bf_cam_zr": "ZWO cooled (17.5 mm, with tilt plate)",
"bf_cam_zn": "ZWO uncooled or planetary (12.5 mm)",
"bf_cam_t2": "DSLR or mirrorless with T2 ring (55 mm in total)",
"bf_cam_baionetta": "{n} without ring ({m} mm)",
"bf_efw": "ZWO EFW filter wheel",
"bf_oag": "ZWO OAG-L off-axis guider",
"bf_fd54": "ZWO M54 filter drawer",
"bf_fd42": "ZWO M42 filter drawer",
"bf_r_ottica": "The optics need",
"bf_r_catena": "Camera and parts",
"bf_r_filtro": "The filter shifts focus",
"bf_r_servono": "Spacers to add",
"bf_r_lungo": "Too long by",
"bf_lungo_n": "Remove a part, use a drawer instead of the wheel, or a camera with less backfocus.",
"bf_giusto": "Already right: no spacers needed.",
"bf_combo": "For example: {c}",
"bf_spessori": "plus thin {s} mm shims",
"bf_tolleranza": "At your f/{n} the tolerance is about ±{t} mm: stars in the corners stay round.",
"bf_negozio": "Extension tubes and spacers in our shop",
"bf_filtro_n": "the glass pushes focus back by a third of its thickness",
"mc_titolo": "Mount load",
"mc_i": "Telescope, camera and accessories against the mount's payload: how much you can load and still image well.",
"mc_tubo": "Optical tube",
"mc_camera": "Camera",
"mc_acc": "Accessories",
"mc_montatura": "Mount",
"mc_portata": "Payload",
"mc_stima": "estimate: correct it with the real weight",
"mc_negozio": "from our shop",
"mc_altra": "Other mount (enter its payload)",
"mc_scegli": "Choose the mount",
"mc_a_efw": "Filter wheel",
"mc_a_oag": "Off-axis guider",
"mc_a_guida": "Guide scope + camera",
"mc_a_rid": "Flattener or reducer",
"mc_a_foc": "Motorised focuser",
"mc_a_anti": "Dew heater straps",
"mc_a_pc": "ASIAIR or mini PC",
"mc_a_barra": "Dovetail bar and rings (if not included)",
"mc_totale": "Total load",
"mc_uso": "{p}% of payload",
"mc_ok": "Great for imaging: the mount works comfortably.",
"mc_medio": "Fine for imaging if you balance carefully and there's no wind; take a little care with long exposures.",
"mc_visuale": "At the limit: fine for visual use and short exposures; for imaging, a sturdier mount is better.",
"mc_troppo": "Overloaded: the mount can't carry this weight.",
"mc_consigliate": "Mounts from our shop suited to this load for imaging",
"mc_cp": "{a} kg ({b} kg with counterweight)",
"mc_vedi": "View",
"ox_i": "Four focal lengths cover almost everything: one for finding and wide fields, one for galaxies and nebulae, one for globular clusters and planetary nebulae, one for the planets and the Moon. They're worked out from the exit pupil.",
"ox_barilotto": "Barrel",
"ox_2": "2″ and 1.25″",
"ox_125": "1.25″ only",
"ox_largo": "Wide field: finding, large nebulae, open clusters",
"ox_deep": "Galaxies and nebulae",
"ox_medio": "Globular clusters and planetary nebulae",
"ox_pianeti": "Planets, Moon and double stars",
"ox_riga": "{m}× · pupil {p} mm",
"ox_negozio": "In our shop:",
"ox_nessuno": "No eyepiece in our shop with this focal length.",
"ox_max_125": "With a 1.25″ barrel the longest useful focal length is about 32 mm (24 mm if wide-angle): beyond that, the field gets no wider.",
"ox_pianeti_n": "Beyond {m}× the image doesn't improve: it's limited by the aperture (about 2× per mm) and air turbulence.",
"bn_i": "Enter the binocular numbers (10x50: 10× magnification, 50 mm objectives) and the true field in degrees, which you'll find engraved on the binoculars or in the specs.",
"bn_m": "Magnification",
"bn_d": "Objectives",
"bn_campo": "True field",
"bn_pupilla": "Exit pupil",
"bn_luce": "Relative brightness",
"bn_crep": "Twilight factor",
"bn_1000": "Field at 1000 m",
"bn_app": "Apparent field",
"bn_notte": "Great at night: in the dark your pupil opens to 6–7 mm if you're under 40, about 5 mm after 50.",
"bn_ok": "Good at night too.",
"bn_giorno": "Small pupil: better for daytime or the Moon.",
"bn_treppiede": "From {m}× up, stars dance when hand-held: better use a tripod.",
"bn_crep_n": "the higher it is, the more detail you see in low light",
"bn_luce_n": "the square of the pupil: 25 for a 7x35, 49 for a 7x50",
"ps_i": "Each sub-exposure must be long enough for the sky background to swamp the camera's read noise; longer won't improve the photo and you risk saturated stars and wasted exposures. It depends on the sky, filter, focal ratio and camera.",
"ps_rn": "Read noise",
"ps_qe": "Efficiency (QE)",
"ps_sqm": "Sky (SQM)",
"ps_filtro": "Filter",
"ps_col": "Sensor",
"ps_f_nessuno": "No filter",
"ps_f_larga": "Broadband light-pollution filter",
"ps_f_dual": "Dual-band 7 nm",
"ps_f_s7": "Narrowband 7 nm",
"ps_f_s3": "Narrowband 3 nm",
"ps_consigliata": "Recommended sub-exposure",
"ps_consigliata_n": "the sky background swamps the read noise (10 × RN²)",
"ps_minima": "Below this, noise dominates",
"ps_minima_n": "3 × RN²: shorter exposures are wasted",
"ps_fondo": "Sky background",
"ps_fondo_n": "electrons per second per pixel",
"ps_altri": "With the other filters",
"ps_breve": "Bright background: a few seconds is enough. Still, use 10–30 s exposures at low gain, so you have fewer files.",
"ps_lunga": "Over 10 minutes: binning, a faster focal ratio or a more sensitive camera will help.",
"ps_luogo": "Use the sky {l_sopra} (SQM {s})",
"ps_n": "Estimate for a moonless night. On an unguided mount, stay within the limit it can handle (often 30–120 s).",
"rz_i": "On an alt-az mount (motorised Dobsonians, smart telescopes like Seestar and Dwarf) the field rotates during the exposure and stars in the corners turn into arcs. How long the exposure can be depends on where you point and how big the sensor is.",
"rz_alt": "Altitude",
"rz_az": "Azimuth (0 = north, 180 = south)",
"rz_lat": "Latitude",
"rz_w": "Sensor width in pixels",
"rz_h": "Sensor height in pixels",
"rz_oggetto": "Search: M31, Orion, Jupiter…",
"rz_ora": "{o} now {l_da}: altitude {h}°, azimuth {a}°",
"rz_sotto": "{o} is below the horizon {l_a} right now.",
"rz_vel": "Field rotation",
"rz_vel_n": "degrees per minute",
"rz_max": "Maximum exposure",
"rz_max_n": "1 pixel of drift at the sensor corner",
"rz_zenit": "Near the zenith the field spins very fast: avoid the 10° around it.",
"rz_est": "Towards the east and west the field barely rotates: exposures can be long there.",
"rz_smart": "Smart telescopes rotate the exposures before stacking them: the limit applies to each sub-exposure.",
"rz_oltre": "over 10 min",
"fz_i": "The critical focus zone is how far the sensor can move and stay in focus: at fast focal ratios it's only a few hundredths of a millimetre. The tube expands and contracts with temperature, which is why you refocus during the night.",
"fz_tubo": "Tube",
"fz_al": "Aluminium",
"fz_acc": "Steel",
"fz_car": "Carbon fibre",
"fz_passo": "Motorised focuser step size",
"fz_zona": "Critical focus zone",
"fz_zona_n": "4.88 × λ × N², with λ = 0.55 µm (green light)",
"fz_dil": "The tube changes by",
"fz_dil_n": "per degree of temperature",
"fz_ogni": "Refocus every",
"fz_ogni_n": "this temperature change takes you out of the focus zone",
"fz_passi": "Steps within the focus zone",
"fz_passi_n": "you need at least 5–10 for good focus",
"fs_i": "The further the filter is from the sensor and the faster the focal ratio, the bigger the filter must be to avoid cutting light at the corners (vignetting).",
"fs_diag": "Sensor diagonal",
"fs_dist": "Filter–sensor distance",
"fs_min": "Minimum clear aperture",
"fs_min_n": "diagonal + distance ÷ focal ratio",
"fs_ok": "fine",
"fs_no": "vignettes",
"fs_quasi": "borderline",
"fs_consiglio": "The smallest filter that works: {m}.",
"fs_nessuno": "No size is big enough: move the filter closer to the sensor.",
"fs_misure": "1.25″ mounted (about 27 mm clear)|31 mm unmounted|36 mm unmounted|2″ mounted (about 46 mm clear)|50 mm unmounted",
"fs_ruota": "In a filter wheel the filter sits about 15–20 mm from the sensor; in a drawer in front of the camera, 25–30 mm.",
"pv_i": "The dark doughnuts in your flats are shadows of dust specks: the bigger the doughnut, the further the dust is from the sensor. Measure its diameter in pixels in your processing software and find out which glass to clean.",
"pv_diam": "Doughnut diameter",
"pv_dist": "Distance from the sensor",
"pv_dove": "Where to clean",
"pv_sensore": "On the sensor glass: take great care, a service centre is better.",
"pv_finestra": "On the camera window, the glass in front of the sensor.",
"pv_filtro": "On the filter: in the wheel, in the drawer or screwed onto the camera.",
"pv_ottica": "On the flattener or reducer, or even further from the sensor.",
"pv_n": "Approximate distances: they vary a little with the camera and the imaging train.",
"gd_i": "Autoguiding corrects the mount by watching a star: the guide camera's image scale (″/px) mustn't be much larger than the imaging camera's, or the guiding won't see errors that show in the photo.",
"gd_fguida": "Guide scope focal length",
"gd_pxguida": "Guide camera pixel size",
"gd_cerca": "Guide camera: ASI120MM, ASI220MM…",
"gd_scala_r": "Imaging scale",
"gd_scala_g": "Guiding scale",
"gd_rapporto": "Guiding / imaging ratio",
"gd_ottimo": "Excellent: guiding sees even small errors.",
"gd_buono": "Fine: with PHD2 and a good calibration you'll guide without problems.",
"gd_limite": "Borderline: a longer guide scope or an off-axis guider is better.",
"gd_minima": "Guide focal length to stay within 1:4",
"gd_oag": "With an off-axis guider",
"gd_oag_n": "the guide camera uses the imaging telescope: ratio 1:{r} and no flexure",
"gd_lunga": "Beyond 1000 mm of imaging focal length, an off-axis guider is almost always used.",
"sq_i": "SQM measures how dark the sky is, in magnitudes per square arcsecond: the higher, the darker. The Bortle scale puts it into words, from 1 (perfect sky) to 9 (city centre).",
"sq_sqm": "SQM",
"sq_bortle": "Bortle",
"sq_luogo": "Use the sky {l_sopra} (SQM {s})",
"sq_classe": "Bortle class",
"sq_nelm": "Naked-eye stars down to",
"sq_nelm_n": "limiting magnitude at the zenith, with dark-adapted eyes",
"sq_lum": "Background brightness",
"sq_lum_n": "thousandths of a candela per m²: the natural sky is about 0.2",
"sq_volte": "Compared with a perfect sky",
"sq_volte_n": "times brighter (SQM 22)",
"sq_b": "|Excellent dark sky|Truly dark sky|Rural sky|Rural/suburban transition|Suburban sky|Bright suburban sky|Suburban/urban transition|City sky|Inner-city sky",
"sq_d": "|The Milky Way casts shadows, zodiacal light clearly visible.|Milky Way full of detail, M33 with the naked eye.|Milky Way still rich, some light on the horizon.|Milky Way visible but flat, distant light domes.|Milky Way faint, fading towards the horizon.|Milky Way barely visible at the zenith, grey sky.|Milky Way invisible, grey-orange sky.|Only the brightest stars, M31 with difficulty.|Moon, planets and a few stars.",
"pl2_giove": "Jupiter (45″) on the sensor",
"pl2_saturno": "Saturn with its rings (43″)",
"pl2_px": "{n} pixels",
"pl2_luna": "The whole Moon (31′)",
"pl2_luna_si": "fits on the sensor",
"pl2_luna_no": "doesn't fit: you need a mosaic of about {n} panels",
"vo_i": "How the object looks in the eyepiece with your telescope and eyepiece: true size within the field, how much light and what detail. At the telescope colours are much paler than in photos, and nebulae are grey.",
"vo_cerca": "Search: M13, Saturn, Orion…",
"vo_ingr": "Magnification",
"vo_campo": "True field",
"vo_pupilla": "Exit pupil",
"vo_grande": "As big as",
"vo_grande_v": "{n} times the full Moon to the naked eye",
"vo_stanotte": "Tonight {l_da}",
"vo_alto": "{h}° high at {o}",
"vo_sotto": "doesn't rise above the horizon",
"vo_noti": "What you'll notice",
"vo_ingrandito": "magnified",
"vo_troppo": "It's bigger than the field ({a} vs {b}): with a longer focal length eyepiece you'll see it whole.",
"vo_capovolto": "In the telescope the image is upside down (Newtonian, Dobsonian) or mirrored (with a diagonal): here it's as in the sky, with north up.",
"vo_dss": "DSS photo processed to look like the eyepiece view.",
"vo_nodss": "Deep-sky objects need the sky photo, which isn't available here.",
"vo_n_luna": "Craters, seas and mountains: the best detail is along the line between light and shadow. A Moon filter makes it less dazzling.",
"vo_n_luna_parte": "At this magnification you only see part of it: move along the line between light and shadow.",
"vo_n_giove_piccolo": "A small bright disc: you need at least 40× to see the belts.",
"vo_n_giove_bande": "The flattened disc with its two main dark belts.",
"vo_n_giove_lune": "The 4 Galilean moons like little stars in a row: they change position from one night to the next.",
"vo_n_giove_grs": "More thin belts and the Great Red Spot, when it's facing us.",
"vo_n_saturno_anelli": "The rings already show at 30×: the most beautiful sight for beginners.",
"vo_n_saturno_cassini": "The Cassini Division, the dark line between the two main rings.",
"vo_n_saturno_titano": "Titan, the largest moon, like a little star nearby.",
"vo_n_marte": "A small orange disc: details only show near opposition.",
"vo_n_marte_calotta": "The white polar cap.",
"vo_n_marte_macchie": "Dark surface markings, such as Syrtis Major.",
"vo_n_venere": "The phase, like a little Moon: not the surface, which is covered in cloud.",
"vo_n_mercurio": "A tiny dot with a phase, low in the glow of sunset or dawn.",
"vo_n_lontani": "A tiny disc: Uranus blue-green, Neptune blue.",
"vo_n_sole": "NEVER look at it without a solar filter in front of the telescope.",
"vo_n_gc_1": "A round, misty patch, brighter in the centre.",
"vo_n_gc_2": "The edges break up into lots of tiny stars.",
"vo_n_gc_3": "Stars resolve almost to the core: a spectacular sight.",
"vo_n_oc": "Lots of stars of different brightness: best in a wide field.",
"vo_n_neb": "A faint grey haze, never as colourful as in photos.",
"vo_n_neb_filtro": "A UHC or OIII filter greatly improves the contrast.",
"vo_n_m42": "In the centre the Trapezium, four close stars; around it, wings of grey-green haze.",
"vo_n_pn": "A small grey-green disc: an OIII filter shows it better.",
"vo_n_m57": "A little smoke ring.",
"vo_n_gx": "The bright core and an oval glow: the arms show in photos, almost never in the eyepiece.",
"vo_n_gx_bracci": "With this aperture and a dark sky you can glimpse the spiral arms.",
"vo_n_ds": "Two separate little stars, sometimes in different colours.",
"vo_n_citta": "From city skies galaxies and nebulae almost vanish: better stick to the Moon, planets and clusters.",
"vo_n_distolta": "Look just to the side of the object (averted vision): your eye picks up more light.",
"vo_bottone": "What you'll see in the eyepiece"
}, TESTI.en);
GUIDA.en = Object.assign({
"g_campo": "This is the Field of view tab. Choose your telescope and camera, or an eyepiece for visual observing, and then the object you want to image. The sensor frame appears on the sky: you can drag to move around, zoom in, rotate the camera and plan a mosaic. Below, you'll find the field of view, the image scale and whether the sampling is right for your sky.",
"g_stanotte": "This is the Tonight tab. Choose the place and the date: the page works out sunset, astronomical darkness and the Moon, then ranks the best objects of the night by how many hours they spend above the horizon, how high they get and how far they are from the Moon. If you enter your equipment, you can show only the objects that fit well in your field of view. Tap an object to see its altitude chart and preview, and press Frame it to open the object in the Field of view.",
"g_camere": "Here is the camera database: astronomy cameras, DSLRs, mirrorless cameras and smart telescopes, with data from the manufacturers' official spec sheets. You can filter by brand, sensor and pixel size, compare up to four cameras and, with the Use button, try them straight away in the Field of view.",
"g_calcolatori": "These are the calculators, split into four groups: observing, imaging, mount and guiding, sky and weather. Pick one from the list or search for it by name. In each calculator you can search for your telescope, camera or eyepiece, and the fields fill in by themselves. For example, you'll find magnification and exit pupil, the ideal focal length for your pixels, planetary imaging, nightscapes, backfocus spacing, Polaris in the polar scope and dew risk.",
"g_software": "Here you'll find the programs and apps most used by amateur astronomers, sorted by category: capture, autoguiding, stacking, processing, planetariums and weather. Each box takes you to the program's official website.",
"g_setup": "In My setups you can save your equipment combinations under a name. Next time, a single tap brings them back, with no need to search again for the telescope, reducer and camera. They stay in your account, so you have them on all your devices.",
"g_telescopio": "Search for your telescope among the ones in our shop, or type in the aperture and focal length yourself. If you choose a smart telescope, the camera is set automatically.",
"g_riduttore": "If you use a focal reducer or a Barlow lens, choose its factor: the effective focal length and the field of view update straight away.",
"g_camera": "Search for your camera in the database, or enter its resolution and pixel size. With the binning and the seeing of your sky, you can see whether the sampling is right.",
"g_oculare": "Search for your eyepiece among the ones in our shop, or enter its focal length and apparent field: you'll see the magnification, the true field and the exit pupil.",
"g_oggetto": "Search for the object you want to image by its catalogue code or its name, for example M31 or Andromeda. The sky view centres on the object.",
"g_mosaico": "If the object doesn't fit in a single shot, plan a mosaic: choose how many panels horizontally and vertically, and how much overlap. Below, you'll find the coordinates of the centre of each panel.",
"g_cielo": "This is the sky view. Drag the sky to move around: the camera frame stays in the centre. To zoom, use plus and minus, two fingers, or Control and the mouse wheel, and double-click to centre the view on that point. You can rotate the camera with the rotation slider or with two fingers. The Names button shows or hides the object names; the Grid button makes the coordinates clearly visible and adds the celestial equator and the ecliptic. The Result button shows how the photo will come out: only what lands on the sensor, straightened, with the camera rotated the way you set it. With the link you can share your framing.",
"g_luogo": "Choose a city or use your location: the times for the night, the Moon and the object ranking are all calculated for that spot.",
"g_data": "Choose the night you're interested in. Times are shown in your device's time zone.",
"g_attrezzatura": "This is your equipment. At the top are the boxes with the numbers: tap one and that part opens. Just below are your setups, that is telescope, reducer and camera saved together: tap a setup to use it in Field of view and Tonight; the pencil changes its parts or its name, and Create a setup makes a new one in four steps. Then there's a row for each type: telescopes, cameras, eyepieces, reducers, mounts and filters. Each row shows what's inside: tap it to open it, search for a piece by name or type it in. Tell the assistant what you own, by typing or speaking, and it fills everything in. At the bottom, under Account and link, you'll find your account, the link to send your equipment to a friend, and Clear all.",
"g_filtri": "Here you add the filters you own: search for them by name or tap their type. For each object, in What to see and here below the results, we tell you which one to use: it depends on the type of object, the Moon, the sky where you are and your camera, whether colour or monochrome.",
"g_mio_setup": "Set your telescope and camera here, or tap an item from your equipment or one of your setups. To see only the objects that fit well in your field of view, turn on Only show objects that suit my field of view in the Objects box.",
"g_diario": "Your observing log: mark the objects you've observed or imaged, and you'll find them here with the date. Below is the Messier challenge: one hundred and ten boxes to fill, one for each object in the catalogue.",
"g_lunasole": "This is the Moon, Sun & planets page. At the top, choose the place and the day: they're the same as in What to see. You see the Moon as it really looks on that day, with its phase, age, distance and the times of moonrise, culmination and moonset. Next to it is the Sun, with sunrise, solar noon and sunset; below its times you see the Sun right now, photographed by NASA's SDO satellite. Then come the table of tonight's planets, a chart of the Sun's and Moon's altitudes over the 24 hours, the next phases, and the twilights with golden hour and blue hour. At the bottom, the calendar shows for every night of the month how many hours of darkness are left without the Moon: green marks the best nights for galaxies and nebulae.",
"g_planetario": "This is the Sky chart: the whole sky above the place you've chosen. The centre of the chart is the point directly above your head, and the edge is the horizon, with the cardinal points. The slider below the chart moves through the hours of the night, and the Now button takes you back to the current time. You can see the stars, the constellations, the Milky Way, the Moon with its phase, the planets and the Messier objects. Tap a celestial object to find out its name and how high it is; for planets and deep-sky objects, there's a button to frame them with your telescope.",
"g_meteo": "This is the Weather tab, designed for stargazers. At the top is tonight's summary: how many good hours there are and when, the clouds, the Moon and the risk of dew on your optics. Below that is the hour-by-hour forecast: for each hour, a green, yellow or red rating, the clouds split into low, medium and high, fog, rain, humidity, the gap between temperature and dew point, wind, darkness and the Moon. Then come the next few nights and the infrared satellite image with the rain radar for your location, over the last 3 hours: tap Play to see how clouds and storms move. At the bottom you'll find the sites for seeing and transparency, and where to go tonight for a darker sky. The forecasts come from the Norwegian Meteorological Institute, the satellite images from EUMETSAT and the radar from the Italian Civil Protection Department.",
"g_home": "This is the Giordano Astronomia tools page. Each box opens a tool. Field of view shows what fits on the sensor of your setup. The Tonight tab shows the night's best objects. Then there are the weather for amateur astronomers, the sky chart, the Moon and the Sun, the camera database, the calculators and the software. You'll also find your equipment, your observing log and the quiz for choosing a telescope, camera or mount. Every tab has a How it works button that explains the page.",
"g_scegli": "Here you can find the right telescope in a minute. Answer five questions: what you want to do, how much you want to spend, how much experience you have, where you observe from and how much weight matters. We suggest three telescopes in stock in our shop and explain why. Tap an answer to change it. Below, you can compare them side by side and add the complete kit to your cart. There's also a quiz for choosing a camera or a mount."
}, GUIDA.en);
const SCHEDE = [
  ["home", vistaHome], ["scegli", vistaScegli], ["attrezzatura", vistaAttrezzatura], ["campo", vistaCampo], ["stanotte", vistaNotte], ["diario", vistaDiario], ["meteo", vistaMeteo], ["planetario", vistaPlanetario], ["lunasole", vistaLunaSole],
  ["camere", vistaCamere], ["calcolatori", vistaCalcolatori], ["software", vistaSoftware],
];
if (NAV4) SCHEDE.push(["eventi", vistaEventi], ["transiti", vistaTransiti], ["piano", vistaPiano]);
const PANNELLI = {};
let schedaAttiva = null, OGG_CAMPO_VISTO, LINK_CAMPO_LETTO = null;
function aggiornaHash(nome, nuova) {
  try { history[nuova ? "pushState" : "replaceState"](nome === "home" ? { gasHome: 1 } : null, "", nome === "home" ? location.pathname + location.search : "#" + nome); } catch (e) {   }
}
function vai(nome, daHash, fermo) {
  if (!DATI.pronto) return;
  if (!PANNELLI[nome]) nome = schedaDellaPagina() || "home";
  if (nome !== "campo") chiudiFoglioCampo();
  for (const [k, p] of Object.entries(PANNELLI)) {
    p.pannello.hidden = k !== nome;
    if (!p.bottone) continue;
    p.bottone.setAttribute("aria-selected", String(k === nome));
    p.bottone.classList.toggle("on", k === nome);
  }
  const p = PANNELLI[nome];
  const barra = p.bottone && p.bottone.parentElement;
  if (barra && barra.scrollWidth > barra.clientWidth) barra.scrollTo({ left: p.bottone.offsetLeft - (barra.clientWidth - p.bottone.offsetWidth) / 2, behavior: "smooth" });
  if (NAV4) segnaVoce(nome);
  Voce.smetti();
  if (!daHash) aggiornaHash(nome, !!schedaAttiva && nome !== schedaAttiva);
  p.vista(p.pannello);
  schedaAttiva = nome;
  if (nome === "campo") { if (OGG_CAMPO_VISTO !== undefined && CAMPO.ogg !== OGG_CAMPO_VISTO) provaFatta(1); OGG_CAMPO_VISTO = CAMPO.ogg; }
  try { aggiornaTestata(nome); } catch (e) { console.error("strumenti, testata:", e); }
  if (nome !== "home") segnaMovimento(nome);
  if (!daHash && !fermo) {
    const top = nome === "home" && document.documentElement.classList.contains("gas-app") ? 0 : RADICE.getBoundingClientRect().top + window.scrollY - 90;
    if (window.scrollY > top + 40) window.scrollTo({ top, behavior: "smooth" });
  }
}
Object.assign(TESTI.it, { tt_guida: "Ascolta la guida", tt_scegli: "Rispondi a poche domande: ti consigliamo il telescopio, la camera o la montatura giusti per te." });
Object.assign(TESTI.de, { tt_guida: "Anleitung anhören", tt_scegli: "Beantworten Sie ein paar Fragen: wir empfehlen Ihnen das passende Teleskop, die Kamera oder die Montierung." });
Object.assign(TESTI.es, { tt_guida: "Escuchar la guía", tt_scegli: "Responde a unas pocas preguntas: te recomendamos el telescopio, la cámara o la montura adecuados." });
Object.assign(TESTI.en, { tt_guida: "Listen to the guide", tt_scegli: "Answer a few questions: we'll recommend the right telescope, camera or mount for you." });
const TESTATA = el("div", { class: "gas-testata", hidden: true });
function aggiornaTestata(nome) {
  TESTATA.hidden = nome === "home";
  if (TESTATA.hidden) return;
  const guida = bottoneComeFunziona(nome);
  const titolo = NAV4 ? nomeStrumento(nome) : t("tab_" + nome), riga = NAV4 ? descrStrumento(nome) : nome === "scegli" ? t("tt_scegli") : t("home_" + nome);
  svuota(TESTATA).append(el("span", { class: "gas-testata-ico", "aria-hidden": "true" }, icona(NAV4 ? icoStrumento(nome) : nome)),
    el("div", { class: "gas-testata-testo" }, el("h2", null, titolo), el("p", null, riga)), guida);
  const primaVolta = rigaPrimaVolta(nome);
  if (primaVolta) TESTATA.append(primaVolta);
}
let notturna = false, bottoneRosso = null;
let TEMA_CHIARO = /[?&]tema=scuro\b/.test(location.search) ? false : /[?&]tema=chiaro\b/.test(location.search) ? true : ricorda("tema", "chiaro") !== "scuro";
let bottoneTema = null;
function impostaTema(scuro) {
  TEMA_CHIARO = !scuro;
  salva("tema", scuro ? "scuro" : "chiaro");
  impostaRosso(notturna);
  for (const n of document.querySelectorAll(".gas-og, .gas-tour")) n.classList.toggle("gas-chiaro", TEMA_CHIARO && !notturna);
  if (bottoneTema) { bottoneTema.setAttribute("aria-pressed", String(scuro)); bottoneTema.classList.toggle("on", scuro); }
}
function impostaRosso(si) {
  notturna = si;
  const s = document.getElementById("gas-sfondo");
  if (s) { s.classList.toggle("gas-rosso", si); s.classList.toggle("gas-chiaro", TEMA_CHIARO && !si); }
  document.documentElement.classList.toggle("gas-rosso-su", si);
  if (bottoneRosso) bottoneRosso.setAttribute("aria-pressed", String(si));
  salva("rosso", si);
  if (typeof misuraNav === "function") try { misuraNav(); } catch (e) {   }
}
Object.assign(ICONE_SVG, { testo: '<path d="M3.2 18.8 6.8 9.2l3.6 9.6M4.5 15.6h4.6"/><path d="M12 18.8l4.6-13.6 4.6 13.6M13.7 14.4h5.8"/>' });
Object.assign(TESTI.it, { testo_grande: "Testo grande", testo_grande_n: "Ingrandisce tutte le scritte degli strumenti", rosso_corto: "Notturna",
  tema_corto: "Scuro", testo_corto: "Grande", tema_scuro: "Tema scuro", tema_scuro_n: "Strumenti scuri come il cielo di notte (tocca di nuovo per tornare al tema chiaro)" });
Object.assign(TESTI.de, { tema_corto: "Dunkel", testo_corto: "Groß", tema_scuro: "Dunkles Design", tema_scuro_n: "Werkzeuge dunkel wie der Nachthimmel (noch einmal tippen für hell)" });
Object.assign(TESTI.es, { tema_corto: "Oscuro", testo_corto: "Grande", tema_scuro: "Tema oscuro", tema_scuro_n: "Herramientas oscuras como el cielo nocturno (toca otra vez para volver al tema claro)" });
Object.assign(TESTI.en, { tema_corto: "Dark", testo_corto: "Large", tema_scuro: "Dark theme", tema_scuro_n: "Makes the tools dark like the night sky (tap again to switch back to the light theme)" });
Object.assign(TESTI.de, { testo_grande: "Große Schrift", testo_grande_n: "Vergrößert alle Schriften der Werkzeuge", rosso_corto: "Nachtsicht" });
Object.assign(TESTI.es, { testo_grande: "Texto grande", testo_grande_n: "Agranda todos los textos de las herramientas", rosso_corto: "Nocturna" });
Object.assign(TESTI.en, { testo_grande: "Large text", testo_grande_n: "Makes all the text in the tools bigger", rosso_corto: "Night" });
let testoGrande = false, bottoneTesto = null;
function impostaTesto(si) {
  testoGrande = si;
  for (const n of document.querySelectorAll("#gas-sfondo, .gas-og")) n.classList.toggle("gas-grande", si);
  document.documentElement.classList.toggle("gas-grande-su", si);
  if (bottoneTesto) { bottoneTesto.setAttribute("aria-pressed", String(si)); bottoneTesto.classList.toggle("on", si); }
  salva("testo_grande", si);
}
function riempiChip() {
  if (typeof PLANCIA_AGGIORNA === "function") try { PLANCIA_AGGIORNA(); } catch (e) {   }
  const box = document.getElementById("gas-chip");
  if (!box) return;
  const nt = Astro.notte(dataNotte(), NOTTE.luogo.lat, NOTTE.luogo.lon, 10);
  const f = nt.fase, ev = nt.ev;
  const chip = (contenuto, dove) => el("button", { type: "button", class: "gas-chip", onclick: () => vai(dove) }, contenuto);
  svuota(box).append(
    chip([iconaLuna(f), t("chip_luna"), " ", el("b", null, `${num(f.k * 100)} %`), ` · ${f.crescente ? t("crescente") : t("calante")}`], "stanotte"),
    chip([t("chip_buio"), " ", el("b", null, `${ora(ev.astroFine)} → ${ora(ev.astroInizio)}`)], "stanotte"),
    chip(["◎ ", el("b", null, NOTTE.luogo.nome)], "stanotte"),
    chip([el("b", null, num(DATI.oggetti.length)), ` ${t("chip_oggetti")} · `, el("b", null, num(DATI.camere.length)), ` ${t("chip_camere")} · `,
      el("b", null, num(DATI.telescopi.length)), ` ${t("chip_telescopi")}`], "camere"));
}
Object.assign(TESTI.it, { dz_titolo: "Ripartire da zero?", dz_si: "Sì, riparti da zero", dz_no: "Annulla",
  dz_testo: "Cancelliamo dal tuo account e da questo dispositivo attrezzatura, setup, filtri, diario, luogo e preferenze: gli strumenti si riaprono come la prima volta. Sugli altri tuoi dispositivi si svuotano al prossimo accesso.",
  dz_errore: "Il tuo account adesso non risponde: non abbiamo cancellato niente. Riprova tra poco.", dz_attesa: "Sto cancellando…",
  dz_incerto: "Il tuo account adesso non risponde e non sappiamo se è già stato svuotato: quello che avevi è salvato su questo dispositivo. Riprova tra poco." });
Object.assign(TESTI.de, { dz_titolo: "Von vorne anfangen?", dz_si: "Ja, von vorne anfangen", dz_no: "Abbrechen",
  dz_testo: "Wir löschen aus Ihrem Konto und von diesem Gerät Ausrüstung, Setups, Filter, Tagebuch, Ort und Einstellungen: die Werkzeuge öffnen sich wie beim ersten Mal. Auf Ihren anderen Geräten werden sie beim nächsten Öffnen geleert.",
  dz_errore: "Ihr Konto antwortet gerade nicht: wir haben nichts gelöscht. Bitte gleich noch einmal versuchen.", dz_attesa: "Wird gelöscht…",
  dz_incerto: "Ihr Konto antwortet gerade nicht, und wir wissen nicht, ob es schon geleert wurde: Ihre Daten sind auf diesem Gerät gesichert. Bitte gleich noch einmal versuchen." });
Object.assign(TESTI.es, { dz_titolo: "¿Empezar de cero?", dz_si: "Sí, empezar de cero", dz_no: "Cancelar",
  dz_testo: "Borramos de tu cuenta y de este dispositivo equipo, equipos guardados, filtros, diario, lugar y preferencias: las herramientas se abren como la primera vez. En tus otros dispositivos se vacían la próxima vez que entres.",
  dz_errore: "Tu cuenta no responde ahora: no hemos borrado nada. Inténtalo de nuevo en un momento.", dz_attesa: "Borrando…",
  dz_incerto: "Tu cuenta no responde ahora y no sabemos si ya se ha vaciado: lo que tenías está guardado en este dispositivo. Inténtalo de nuevo en un momento." });
Object.assign(TESTI.en, { dz_titolo: "Start from scratch?", dz_si: "Yes, start from scratch", dz_no: "Cancel",
  dz_testo: "We'll delete your equipment, setups, filters, log, location and preferences from your account and from this device: the tools will open as if for the first time. On your other devices, they'll be cleared the next time you open the tools.",
  dz_errore: "We can't reach your account right now: nothing has been deleted. Please try again shortly.", dz_attesa: "Deleting…",
  dz_incerto: "We can't reach your account right now and can't tell whether it has already been cleared: what you had is still saved on this device. Please try again shortly." });
function ripartiDaZero() {
  const senza = () => { const u = new URL(location.href); u.searchParams.delete("da-zero"); return u.pathname + u.search + u.hash; };
  return new Promise(continua => {
    const COPIA = MEMORIA + "copia_da_zero";
    const errore = el("p", { class: "gas-nota gas-att-manca", role: "alert", hidden: true }, t("dz_errore"));
    const finisci = () => { for (const k of Object.keys(localStorage)) if (k.startsWith(MEMORIA) && k !== COPIA) localStorage.removeItem(k); location.replace(senza()); };
    const riprova = testo => { si.disabled = no.disabled = false; si.textContent = t("dz_si"); errore.textContent = testo; errore.hidden = false; };
    const si = el("button", { type: "button", class: "gas-btn", onclick: async () => {
      si.disabled = no.disabled = true; si.textContent = t("dz_attesa"); errore.hidden = true;
      let j;
      try { j = await chiamaSync(); } catch (e) { return riprova(t("dz_errore")); }
      const qui = JSON.parse(JSON.stringify(pacchettoSync()));
      const copia = j && j.dati && !pacchettoVuoto(j.dati) ? j.dati : qui, vecchia = ricorda("copia_da_zero", null);
      if (!pacchettoVuoto(copia) || !vecchia || pacchettoVuoto(vecchia.dati)) {
        try { localStorage.setItem(COPIA, JSON.stringify({ quando: new Date().toISOString(), dati: copia })); } catch (e) {   }
      }
      if (j && j.accesso) {
        const vuoto = { v: 1, attrezzatura: Object.fromEntries(Object.keys(TIPI_ATT).map(k => [k, []])), setup: [], filtri: [], filtriNomi: [], confronto: "", diario: {} };
        try {
          const r = await chiamaSync({ dati: vuoto });
          if (!r || !r.accesso) throw new Error("account");
        } catch (e) {
          const j2 = await chiamaSync().catch(() => null);
          if (!(j2 && j2.accesso && pacchettoVuoto(j2.dati))) {
            if (!j2) { try { localStorage.removeItem(MEMORIA + "sync_visto"); } catch (x) {   } return riprova(t("dz_incerto")); }
            return riprova(t("dz_errore"));
          }
        }
      }
      try { if (typeof togliCampo === "function") await togliCampo(); } catch (e) {   }
      finisci();
    } }, t("dz_si"));
    const no = el("button", { type: "button", class: "gas-btn gas-btn--chiaro", onclick: () => { try { history.replaceState(null, "", senza()); } catch (e) {   } continua(); } }, t("dz_no"));
    svuota(RADICE).append(el("section", { class: "gas-card gas-dz", role: "alertdialog", "aria-labelledby": "gas-dz-t" },
      el("h3", { id: "gas-dz-t" }, t("dz_titolo")), el("p", null, t("dz_testo")),
      el("div", { class: "gas-riga-bottoni" }, si, no),
      errore));
  });
}
Object.assign(TESTI.it, { ricarica_pagina: "Ricarica la pagina" });
Object.assign(TESTI.de, { ricarica_pagina: "Seite neu laden" });
Object.assign(TESTI.es, { ricarica_pagina: "Recargar la página" });
Object.assign(TESTI.en, { ricarica_pagina: "Reload the page" });
async function avvia() {
  if (!RADICE) return;
  const primaVolta = /[?&]prima-volta(=|&|$)/.test(location.search), chiVisti = RADICE.dataset.cliente || "";
  if (primaVolta || (chiVisti && ricorda("visti_di", "") !== chiVisti)) {
    for (const k of ["tour_visto", "tour_in_corso", "tester_visto", "tester_nascosto", "benvenuto_ok", "bv_passo", "app_home_no", "avvisi_no", "aiuto_visto", "ris_visto"]) { try { localStorage.removeItem(MEMORIA + k); } catch (e) {   } }
    BV_PASSO = 0;
    if (chiVisti) salva("visti_di", chiVisti);
    if (primaVolta) try { const u = new URL(location.href); u.searchParams.delete("prima-volta"); history.replaceState(null, "", u.pathname + u.search + u.hash); } catch (e) {   }
  }
  if (/[?&]da-zero(=|&|$)/.test(location.search)) await ripartiDaZero();
  svuota(RADICE);
  if (!(await cancelloNewsletter())) return;
  segnaMovimento("entrata");
  RADICE.classList.toggle("gas-nav4", NAV4);
  const barra = NAV4 ? null : el("div", { class: "gas-schede", role: "tablist" });
  bottoneRosso = el("button", { type: "button", class: "gas-rosso-btn", "aria-pressed": "false", title: t("rosso_n"),
    onclick: () => { impostaRosso(!notturna); if (notturna) provaFatta(4); } }, icona("rosso"), el("span", { class: "gas-lungo" }, t("rosso")), el("span", { class: "gas-corto" }, t("rosso_corto")));
  const corpo = el("div", { class: "gas-corpo" });
  const bottoneGuida = el("button", { type: "button", class: "gas-guida-btn", "aria-pressed": "false", title: t("ascolta_spiegazione"),
    onclick: () => Voce.parla(chiaveGuida(schedaAttiva), bottoneGuida) }, icona("guida"), el("span", null, t("guida_voce")));
  bottoneTesto = el("button", { type: "button", class: "gas-guida-btn gas-testo-btn", "aria-pressed": "false", title: t("testo_grande_n"),
    onclick: () => impostaTesto(!testoGrande) }, icona("testo"), el("span", { class: "gas-lungo" }, t("testo_grande")), el("span", { class: "gas-corto" }, t("testo_corto")));
  bottoneTema = el("button", { type: "button", class: "gas-guida-btn gas-testo-btn gas-tema-btn", "aria-pressed": String(!TEMA_CHIARO), title: t("tema_scuro_n"),
    onclick: () => impostaTema(TEMA_CHIARO) }, icona("stanotte"), el("span", { class: "gas-lungo" }, t("tema_scuro")), el("span", { class: "gas-corto" }, t("tema_corto")));
  if (!TEMA_CHIARO) bottoneTema.classList.add("on");
  const testa = NAV4 ? creaNav() : el("div", { class: "gas-testa-app" }, barra, bottoneTesto, bottoneGuida, bottoneRosso);
  RADICE.append(testa, corpo);
  impostaTesto(ricorda("testo_grande", false));
  const chip = document.getElementById("gas-chip");
  if (!NAV4) document.documentElement.classList.remove("gas-app", "gas-in-home");
  if (NAV4) {
    const riga = el("div", { class: "gas-chip-barra" }), utili = el("div", { class: "gas-utili" }, bottoneTema, bottoneTesto, bottoneGuida, bottoneRosso);
    RADICE.insertBefore(riga, testa);
    if (chip && chip.parentNode) riga.append(chip);
    riga.append(utili);
    sistemaNav();
    try { creaAppbar(); } catch (e) { console.error("strumenti, barra dell'app:", e); }
    try { prepariAppHome(); } catch (e) { console.error("strumenti, schermata Home:", e); }
  } else if (chip && chip.parentNode) {
    const riga = el("div", { class: "gas-chip-barra" }), utili = el("div", { class: "gas-utili" });
    RADICE.insertBefore(riga, testa);
    riga.append(chip, utili);
    const largo = window.matchMedia ? matchMedia("(min-width: 992px)") : null;
    const sposta = () => (largo && largo.matches ? utili : testa).append(bottoneTesto, bottoneGuida, bottoneRosso);
    if (largo) { sposta(); if (largo.addEventListener) largo.addEventListener("change", sposta); }
  }
  try { RADICE.insertBefore(avvisoSenzaRete(), corpo); } catch (e) { console.error("strumenti, senza rete:", e); }
  RADICE.insertBefore(TESTATA, corpo);
  try { const esito = esitoAvvisi(); if (esito) RADICE.insertBefore(esito, corpo); } catch (e) { console.error("strumenti, avvisi:", e); }
  try { RADICE.append(piedeSuggerimenti()); } catch (e) { console.error("strumenti, suggerimenti:", e); }
  impostaRosso(ricorda("rosso", false));
  for (const [nome, vista] of SCHEDE) {
    if (NAV4) {
      const pannello = el("div", { class: "gas-pannello", id: "gas-pan-" + nome, role: "region", "aria-label": nome === "home" ? t("tab_home") : nomeStrumento(nome), hidden: true });
      corpo.appendChild(pannello);
      PANNELLI[nome] = { bottone: null, pannello, vista };
      continue;
    }
    const bottone = el("a", { href: urlScheda(nome), role: "tab", class: "gas-scheda gas-scheda--" + nome, id: "gas-tab-" + nome, "aria-controls": "gas-pan-" + nome,
      title: nome === "home" ? t("tab_home") : null,
      onclick: e => { if (e.metaKey || e.ctrlKey || e.shiftKey) return; e.preventDefault(); vai(nome); } },
      el("span", { class: "gas-scheda-ico" }, icona(nome)), el("span", { class: "gas-scheda-nome" }, nome === "home" ? t("home_strumenti") : t("tab_" + nome)));
    const pannello = el("div", { class: "gas-pannello", id: "gas-pan-" + nome, role: "tabpanel", "aria-labelledby": "gas-tab-" + nome, hidden: true });
    barra.appendChild(bottone); corpo.appendChild(pannello);
    PANNELLI[nome] = { bottone, pannello, vista };
  }
  corpo.appendChild(el("div", { class: "gas-carico" }, t("caricamento")));
  try {
    await caricaDati();
  } catch (e) {
    svuota(corpo).appendChild(el("div", { class: "gas-errore", role: "alert" }, el("p", null, t("errore_dati")),
      el("button", { type: "button", class: "gas-btn", onclick: () => location.reload() }, t("ricarica_pagina"))));
    console.error("strumenti:", e);
    return;
  }
  $(".gas-carico", corpo).remove();
  if (!ricorda("campo", null)) {
    const tel = DATI.telescopi.find(x => /GIO-APO601/i.test(x.t));
    if (tel) CAMPO.tel = { nome: tel.t, D: tel.D, F: tel.F, h: tel.h, foto: tel.foto };
    const cam = DATI.perCamera.get("giordano-gio-571c");
    if (cam) CAMPO.cam = camScelta(cam);
  }
  const [nome0, q] = (location.hash || "").slice(1).split("?");
  const nome = NAV4 && nome0 === "lunasole" && /(^|&)ics=/.test(q || "") ? "eventi" : nome0;
  if (nome === "campo" && q) { leggiLinkCampo(q); LINK_CAMPO_LETTO = q; }
  const qAtt = nome === "attrezzatura" && q ? q : ricorda("att_link", null);
  if (qAtt) leggiLinkAttrezzatura(qAtt);
  try { plancia(); } catch (e) { console.error("strumenti, plancia:", e); }
  vai(PANNELLI[nome] ? nome : ATT_DA_LINK ? "attrezzatura" : schedaDellaPagina() || "home", true);
  if (nome === "oggetto" && q) setTimeout(() => { try { apriOggetto(decodeURIComponent(q), true); } catch (e) { console.error("strumenti, scheda:", e); } }, 0);
  const sinc = avviaSync().catch(e => console.error("strumenti, account:", e));
  try { riempiChip(); } catch (e) { console.error("strumenti, riquadri:", e); }
  try { eroeLeggiTutto(); } catch (e) { console.error("strumenti, testo in cima:", e); }
  try { bottoneStrumenti(); } catch (e) { console.error("strumenti, bottone:", e); }
  try { osservaScorrimenti(); } catch (e) { console.error("strumenti, file che scorrono:", e); }
  if (SR_IN_CAMPO) setTimeout(() => aggiornaCopia().catch(e => console.error("strumenti, copia per il campo:", e)), 8000);
  sinc.then(() => {
    if (BV_ATTESA && schedaAttiva === "home") try { vai("home", true); } catch (e) { console.error("strumenti, benvenuto:", e); }
    setTimeout(() => { try { tourAlPrimoAccesso(); } catch (e) { console.error("strumenti, giro guidato:", e); } }, 1500);
  });
  const dalIndirizzo = () => {
    const [n0, qq] = location.hash.slice(1).split("?");
    const n = (NAV4 && n0 === "lunasole" && /(^|&)ics=/.test(qq || "") ? "eventi" : n0) ||
      (history.state && history.state.gasHome ? "home" : location.href.includes("#") ? "" : schedaDellaPagina() || "home");
    if (n === "oggetto") { if (qq) apriOggetto(decodeURIComponent(qq), true); return; }
    if (PAGINA_OGG) chiudiOggetto(true);
    if (n === "attrezzatura" && qq) { leggiLinkAttrezzatura(qq); if (n === schedaAttiva) vai(n, true); }
    if (n === "campo" && qq && (schedaAttiva !== "campo" || qq !== LINK_CAMPO_LETTO)) { LINK_CAMPO_LETTO = qq; leggiLinkCampo(qq); vai(n, true); }
    else if (PANNELLI[n] && n !== schedaAttiva) vai(n, true);
    else if (n === "calcolatori" && n === schedaAttiva) vai(n, true);
  };
  window.addEventListener("hashchange", dalIndirizzo);
  window.addEventListener("popstate", () => { if (!location.href.includes("#")) dalIndirizzo(); });
}
if (DEBUG) window.GAS = { Astro, DATI, CAMPO, NOTTE, CALC, Mappa, Hips, visore: () => VISORE_FOTO, calcoloCampo, calcolaNotte, eventiCielo, eclissiLuna, prossimaOpposizione,
  consigliaTelescopi, CALC_ELENCO, apriCalcolatore, icsEventi, urlIcs, apriOggetto, caricaFotoOggetti, DIARIO, segnaDiario, messierVisti, idMessier,
  apriSuggerimenti, cercaOggetti, consigliaCamere, consigliaMontature, vai, preparaCampo, togliCampo, aggiornaCopia, nav4: NAV4, VOCI, apriVoce, Luoghi, lpiDaSqm, numLpi, calcolaOrizzonte, apriVistaLuogo };
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", avvia);
else avvia();
})();
